var Yc = Object.defineProperty;
var Wc = (j, f, D) => f in j ? Yc(j, f, { enumerable: !0, configurable: !0, writable: !0, value: D }) : j[f] = D;
var hr = (j, f, D) => (Wc(j, typeof f != "symbol" ? f + "" : f, D), D);
import { defineComponent as Ct, computed as Vt, openBlock as Ne, createElementBlock as We, normalizeClass as Ot, createElementVNode as he, renderSlot as nr, toDisplayString as ft, createCommentVNode as mt, createTextVNode as Ht, ref as lt, resolveComponent as Pt, createVNode as gt, normalizeStyle as Or, createBlock as Ft, onMounted as tr, onUpdated as Po, watch as er, nextTick as Rr, Fragment as or, renderList as _r, withDirectives as Cn, vModelCheckbox as Ro, onBeforeMount as bo, withModifiers as xo, withCtx as Rt, unref as ot, onBeforeUnmount as vi, onUnmounted as ta, Teleport as Du, vModelText as fo, Transition as oi, reactive as wo, onBeforeUpdate as Kc, resolveDynamicComponent as Uo, withKeys as Yr, useSlots as Nu, provide as ln, inject as cn, vModelRadio as Vc, createSlots as Cu, createApp as Gc, markRaw as Qc } from "vue";
import { useRouter as Er, useRoute as Kr, createRouter as Hc, createWebHistory as Xc } from "vue-router";
import $c from "primevue/calendar";
import { defineStore as Fa, createPinia as Zc } from "pinia";
import Jc from "axios";
import si from "primevue/button";
import qc from "primevue/overlaypanel";
import ef from "primevue/image";
import ga from "primevue/skeleton";
import ju from "primevue/message";
import Yn from "primevue/password";
import { useToast as Fo } from "primevue/usetoast";
import { useConfirm as Ou } from "primevue/useconfirm";
import tf from "primevue/card";
import rf from "primevue/toast";
import nf from "primevue/confirmdialog";
import af from "primevue/config";
import of from "primevue/confirmationservice";
import sf from "primevue/toastservice";
var Wn = /* @__PURE__ */ ((j) => (j.none = "", j.info = "info", j.success = "success", j.warning = "warning", j.danger = "danger", j))(Wn || {}), rn = /* @__PURE__ */ ((j) => (j.oneOne = "oneOne", j.twoOne = "twoOne", j.oneTwo = "oneTwo", j))(rn || {}), ha = /* @__PURE__ */ ((j) => (j[j.text = 0] = "text", j[j.email = 1] = "email", j))(ha || {}), _a = /* @__PURE__ */ ((j) => (j.xl = "xl", j.lg = "lg", j.sm = "sm", j))(_a || {});
const uf = /* @__PURE__ */ Ct({
  __name: "K2ColContainer",
  props: {
    rowClass: { default: "" },
    col1Class: { default: "" },
    col2Class: { default: "" },
    ratio: { default: rn.oneOne }
  },
  setup(j) {
    const f = j, D = Vt(
      () => {
        let U = "col-lg-6";
        switch (f.ratio) {
          case rn.oneOne:
            U = "col-lg-6";
            break;
          case rn.twoOne:
            U = "col-lg-9";
            break;
          case rn.oneTwo:
            U = "col-lg-3";
            break;
        }
        return U;
      }
    ), B = Vt(
      () => {
        let U = "col-lg-6";
        switch (f.ratio) {
          case rn.oneOne:
            U = "col-lg-6";
            break;
          case rn.twoOne:
            U = "col-lg-3";
            break;
          case rn.oneTwo:
            U = "col-lg-9";
            break;
        }
        return U;
      }
    );
    return (U, G) => (Ne(), We("div", {
      class: Ot(["row", U.rowClass])
    }, [
      he("div", {
        class: Ot(["col-12 col-md-12", [D.value, U.col1Class]]),
        style: { overflow: "auto" }
      }, [
        nr(U.$slots, "col1")
      ], 2),
      he("div", {
        class: Ot(["col-12 col-md-12", [B.value, U.col2Class]]),
        style: { overflow: "auto" }
      }, [
        nr(U.$slots, "col2")
      ], 2)
    ], 2));
  }
}), lf = /* @__PURE__ */ Ct({
  __name: "K3ColContainer",
  props: {
    rowClass: { default: "" },
    col1Class: { default: "" },
    col2Class: { default: "" },
    col3Class: { default: "" }
  },
  setup(j) {
    return (f, D) => (Ne(), We("div", {
      class: Ot(["row", f.rowClass])
    }, [
      he("div", {
        class: Ot(["col-12 col-md-12 col-lg-4", f.col1Class])
      }, [
        nr(f.$slots, "col1")
      ], 2),
      he("div", {
        class: Ot(["col-12 col-md-12 col-lg-4", f.col2Class])
      }, [
        nr(f.$slots, "col2")
      ], 2),
      he("div", {
        class: Ot(["col-12 col-md-12 col-lg-4", f.col3Class])
      }, [
        nr(f.$slots, "col3")
      ], 2)
    ], 2));
  }
}), cf = { class: "d-flex flex-column flex-md-row justify-content-between align-items-center" }, ff = {
  key: 0,
  class: "pr-2 fw-bold k-alert-badge"
}, df = {
  key: 1,
  class: "mr-2 fw-bold"
}, gf = { style: { display: "flex" } }, Bo = /* @__PURE__ */ Ct({
  __name: "KAlert",
  props: {
    badge: { default: "" },
    title: { default: "" },
    body: { default: "" },
    primaryButton: { default: null },
    secondaryButton: { default: null },
    singleRowText: { type: Boolean, default: !1 },
    level: { default: Wn.none }
  },
  setup(j) {
    const f = j, D = Vt(() => {
      const G = [];
      return f.level == Wn.none && G.push("alert-icon"), f.level != Wn.none ? G.push(`alert-${f.level.toString()}`) : G.push("alert-default"), G;
    }), B = Vt(() => f.primaryButton && f.primaryButton.length > 0), U = Vt(() => f.secondaryButton && f.secondaryButton.length > 0);
    return (G, R) => (Ne(), We("div", {
      class: Ot(["alert k-alert", D.value]),
      role: "alert"
    }, [
      he("div", cf, [
        he("div", {
          class: Ot(["", { "k-alert-single-row-text": f.singleRowText }])
        }, [
          f.badge && f.badge.length > 0 ? (Ne(), We("label", ff, ft(f.badge), 1)) : mt("", !0),
          f.title ? (Ne(), We("b", df, ft(f.title), 1)) : mt("", !0),
          Ht(" " + ft(f.body), 1)
        ], 2),
        he("div", gf, [
          U.value ? (Ne(), We("button", {
            key: 0,
            style: { "margin-left": "10px" },
            type: "button",
            class: "btn btn-outline-primary btn-xs px-5",
            onClick: R[0] || (R[0] = (m) => G.$emit("on-secondary-button-click"))
          }, [
            nr(G.$slots, "secondary-button-content", {}, () => [
              Ht(ft(G.secondaryButton), 1)
            ])
          ])) : mt("", !0),
          B.value ? (Ne(), We("button", {
            key: 1,
            style: { "margin-left": "10px" },
            type: "button",
            class: "btn btn-primary btn-xs px-5",
            onClick: R[1] || (R[1] = (m) => G.$emit("on-primary-button-click"))
          }, [
            nr(G.$slots, "primary-button-content", {}, () => [
              Ht(ft(G.primaryButton), 1)
            ])
          ])) : mt("", !0)
        ])
      ])
    ], 2));
  }
});
const mf = /* @__PURE__ */ Ct({
  __name: "KBackButton",
  setup(j) {
    const f = lt(null);
    Er();
    const D = () => {
      history.back();
    };
    return (B, U) => {
      const G = Pt("KIcon");
      return Ne(), We("a", {
        href: "#",
        ref_key: "kBackButton",
        ref: f,
        onClick: D,
        class: "go-back"
      }, [
        gt(G, {
          class: "icon-sm icon-primary me-2",
          icon: "it-arrow-left"
        }),
        Ht(" Torna indietro")
      ], 512);
    };
  }
}), Ef = {
  key: 0,
  class: "flag-icon",
  style: { "margin-left": "24px" }
}, Mf = {
  key: 1,
  class: "etichetta"
}, hf = { class: "card-body pt-0" }, _f = { class: "category fw-bold m-0" }, yf = {
  key: 3,
  class: "it-card-footer mt-4 d-flex justify-content-between"
}, vf = ["title"], pf = { class: "text text-uppercase" }, Tf = { class: "visually-hidden" }, Lf = ["title", "href"], If = { class: "text text-uppercase" }, Af = { class: "visually-hidden" }, Sf = ["title"], Df = { class: "visually-hidden" }, Pu = /* @__PURE__ */ Ct({
  __name: "KCard",
  props: {
    class: { default: "" },
    style: { default: "" },
    flat: { type: Boolean, default: !1 },
    shadow: { type: Boolean, default: !0 },
    title: { default: "" },
    titleClass: { default: "" },
    titleStyle: { default: "" },
    text: { default: "" },
    textClass: { default: "" },
    textStyle: { default: "" },
    topTitle: { default: "" },
    topTitleIcon: { default: "" },
    topTitleDate: { default: null },
    topTitleClass: { default: null },
    showDetailButton: { type: Boolean, default: !1 },
    labelDetailButton: { default: "" },
    detailButtonLinkUrl: { default: null },
    labelCmdButton: { default: "" },
    showCmdButton: { type: Boolean, default: !1 },
    showFlagIcon: { type: Boolean, default: !1 },
    tagIcon: { default: "" },
    tagTitle: { default: "" }
  },
  emits: ["cmd-button-click", "detail-button-click"],
  setup(j, { emit: f }) {
    const D = j, B = Vt(() => {
      const i = [];
      i.push("card"), D.flat !== !0 && (i.push("card-bg"), i.push("rounded"), D.shadow === !1 && i.push("k-card-mini-shadow"));
      let r = i.join(" ");
      return D.class && (r += " " + D.class), r;
    }), U = f, G = () => {
      U("detail-button-click");
    }, R = () => {
      U("cmd-button-click");
    }, m = Vt(() => !!(D.tagTitle || D.tagIcon)), e = Vt(() => !!(D.topTitle || D.topTitleIcon)), g = Vt(() => !!(D.showCmdButton || D.showDetailButton)), n = Vt(() => {
      let i = "";
      return D.topTitleIcon && (i = "categoryicon-top"), D.topTitleClass && (i += " " + D.topTitleClass), i;
    });
    return (i, r) => {
      const l = Pt("KIcon");
      return Ne(), We("div", {
        class: Ot(["card-wrapper", { "card-space": !i.flat }]),
        style: { height: "fit-content" }
      }, [
        he("div", {
          class: Ot(B.value),
          style: Or(i.style)
        }, [
          i.showFlagIcon ? (Ne(), We("div", Ef)) : mt("", !0),
          m.value ? (Ne(), We("div", Mf, [
            gt(l, { icon: i.tagIcon }, null, 8, ["icon"]),
            he("span", null, ft(i.tagTitle), 1)
          ])) : mt("", !0),
          he("div", hf, [
            e.value ? (Ne(), We("div", {
              key: 0,
              class: Ot(n.value)
            }, [
              i.topTitleIcon ? (Ne(), Ft(l, {
                key: 0,
                class: "icon-primary icon-xs",
                icon: i.topTitleIcon
              }, null, 8, ["icon"])) : mt("", !0),
              he("span", _f, ft(D.topTitle), 1)
            ], 2)) : mt("", !0),
            D.title ? (Ne(), We("h3", {
              key: 1,
              class: Ot(["card-title h5 text-truncate text-truncate-multiline", i.titleClass]),
              style: Or(i.titleStyle)
            }, ft(D.title), 7)) : mt("", !0),
            D.text ? (Ne(), We("p", {
              key: 2,
              class: Ot(["text-truncate text-truncate-multiline pt-0 mb-0", i.textClass]),
              style: Or(i.textStyle)
            }, ft(D.text), 7)) : mt("", !0),
            nr(i.$slots, "custom-content"),
            g.value ? (Ne(), We("div", yf, [
              he("span", null, [
                i.showDetailButton && i.detailButtonLinkUrl == null ? (Ne(), We("a", {
                  key: 0,
                  role: "button",
                  class: "read-more",
                  title: i.labelDetailButton,
                  onClick: G
                }, [
                  he("span", pf, [
                    Ht(ft(i.labelDetailButton), 1),
                    he("span", Tf, ft(D.title), 1)
                  ]),
                  gt(l, {
                    class: "icon-primary icon-xs",
                    icon: "it-arrow-right"
                  })
                ], 8, vf)) : i.showDetailButton && i.detailButtonLinkUrl != null ? (Ne(), We("a", {
                  key: 1,
                  role: "button",
                  class: "read-more",
                  title: i.labelDetailButton,
                  target: "_blank",
                  href: i.detailButtonLinkUrl
                }, [
                  he("span", If, [
                    Ht(ft(i.labelDetailButton), 1),
                    he("span", Af, ft(D.title), 1)
                  ]),
                  gt(l, {
                    class: "icon-primary icon-xs",
                    icon: "it-arrow-right"
                  })
                ], 8, Lf)) : mt("", !0)
              ]),
              he("span", null, [
                i.showCmdButton ? (Ne(), We("a", {
                  key: 0,
                  role: "button",
                  class: "btn btn-primary btn-sm text-uppercase float-end",
                  title: i.labelCmdButton,
                  onClick: R
                }, [
                  Ht(ft(i.labelCmdButton) + " ", 1),
                  he("span", Df, ft(i.labelCmdButton), 1)
                ], 8, Sf)) : mt("", !0)
              ])
            ])) : mt("", !0)
          ])
        ], 6)
      ], 2);
    };
  }
});
/*!
 * Splide.js
 * Version  : 3.6.12
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
const vr = "splide", zo = `data-${vr}`, Un = 1, Nf = 2, ui = 3, li = 4, ci = 5, Cf = {
  CREATED: Un,
  MOUNTED: Nf,
  IDLE: ui,
  MOVING: li,
  DESTROYED: ci
}, ko = 10, jf = 20;
function ra(j) {
  j.length = 0;
}
function Na(j) {
  return !Wo(j) && typeof j == "object";
}
function Ru(j) {
  return Array.isArray(j);
}
function Of(j) {
  return typeof j == "function";
}
function dn(j) {
  return typeof j == "string";
}
function Yo(j) {
  return typeof j > "u";
}
function Wo(j) {
  return j === null;
}
function Ko(j) {
  return j instanceof HTMLElement;
}
function Ba(j) {
  return Ru(j) ? j : [j];
}
function En(j, f) {
  Ba(j).forEach(f);
}
function pi(j, f) {
  return j.indexOf(f) > -1;
}
function pa(j, f) {
  return j.push(...Ba(f)), j;
}
const Pf = Array.prototype;
function na(j, f, D) {
  return Pf.slice.call(j, f, D);
}
function Rf(j, f) {
  return na(j).filter(f)[0];
}
function kn(j, f, D) {
  j && En(f, (B) => {
    B && j.classList[D ? "add" : "remove"](B);
  });
}
function gn(j, f) {
  kn(j, dn(f) ? f.split(" ") : f, !0);
}
function Ti(j, f) {
  En(f, j.appendChild.bind(j));
}
function Vo(j, f) {
  En(j, (D) => {
    const B = f.parentNode;
    B && B.insertBefore(D, f);
  });
}
function Go(j, f) {
  return Ko(j) && (j.msMatchesSelector || j.matches).call(j, f);
}
function bu(j, f) {
  return j ? na(j.children).filter((D) => Go(D, f)) : [];
}
function Xr(j, f) {
  return f ? bu(j, f)[0] : j.firstElementChild;
}
function Dn(j, f, D) {
  if (j) {
    let B = Object.keys(j);
    B = D ? B.reverse() : B;
    for (let U = 0; U < B.length; U++) {
      const G = B[U];
      if (G !== "__proto__" && f(j[G], G) === !1)
        break;
    }
  }
  return j;
}
function go(j) {
  return na(arguments, 1).forEach((f) => {
    Dn(f, (D, B) => {
      j[B] = f[B];
    });
  }), j;
}
function An(j, f) {
  return Dn(f, (D, B) => {
    Ru(D) ? j[B] = D.slice() : Na(D) ? j[B] = An(Na(j[B]) ? j[B] : {}, D) : j[B] = D;
  }), j;
}
function Wr(j, f) {
  j && En(f, (D) => {
    j.removeAttribute(D);
  });
}
function ur(j, f, D) {
  Na(f) ? Dn(f, (B, U) => {
    ur(j, U, B);
  }) : Wo(D) ? Wr(j, f) : j.setAttribute(f, String(D));
}
function Kn(j, f, D) {
  const B = document.createElement(j);
  return f && (dn(f) ? gn(B, f) : ur(B, f)), D && Ti(D, B), B;
}
function Cr(j, f, D) {
  if (Yo(D))
    return getComputedStyle(j)[f];
  if (!Wo(D)) {
    const { style: B } = j;
    D = `${D}`, B[f] !== D && (B[f] = D);
  }
}
function fi(j, f) {
  Cr(j, "display", f);
}
function bf(j) {
  j.setActive && j.setActive() || j.focus({ preventScroll: !0 });
}
function Ca(j, f) {
  return j.getAttribute(f);
}
function As(j, f) {
  return j && j.classList.contains(f);
}
function Sr(j) {
  return j.getBoundingClientRect();
}
function aa(j) {
  En(j, (f) => {
    f && f.parentNode && f.parentNode.removeChild(f);
  });
}
function xf(j, f) {
  if (dn(f)) {
    const D = Kn("div", { style: `width: ${f}; position: absolute;` }, j);
    f = Sr(D).width, aa(D);
  }
  return f;
}
function xu(j) {
  return Xr(new DOMParser().parseFromString(j, "text/html").body);
}
function an(j, f) {
  j.preventDefault(), f && (j.stopPropagation(), j.stopImmediatePropagation());
}
function Tn(j, f) {
  return j && j.querySelector(f);
}
function Qo(j, f) {
  return na(j.querySelectorAll(f));
}
function ja(j, f) {
  kn(j, f, !1);
}
function nn(j) {
  return dn(j) ? j : j ? `${j}px` : "";
}
function Oa(j, f = "") {
  if (!j)
    throw new Error(`[${vr}] ${f}`);
}
function mo(j) {
  setTimeout(j);
}
const Eo = () => {
};
function Ss(j) {
  return requestAnimationFrame(j);
}
const { min: Pa, max: Ra, floor: Mo, ceil: ba, abs: jr } = Math;
function wf(j, f, D) {
  return jr(j - f) < D;
}
function Ta(j, f, D, B) {
  const U = Pa(f, D), G = Ra(f, D);
  return B ? U < j && j < G : U <= j && j <= G;
}
function ya(j, f, D) {
  const B = Pa(f, D), U = Ra(f, D);
  return Pa(Ra(B, j), U);
}
function Ds(j) {
  return +(j > 0) - +(j < 0);
}
function wu(j, f) {
  return En(f, (D) => {
    j = j.replace("%s", `${D}`);
  }), j;
}
function Ho(j) {
  return j < 10 ? `0${j}` : `${j}`;
}
const Ns = {};
function Uf(j) {
  return `${j}${Ho(Ns[j] = (Ns[j] || 0) + 1)}`;
}
function Ff() {
  let j = {};
  function f(m, e, g, n = ko) {
    R(m, (i, r) => {
      j[i] = j[i] || [], pa(j[i], {
        _event: i,
        _callback: e,
        _namespace: r,
        _priority: n,
        _key: g
      }).sort((l, d) => l._priority - d._priority);
    });
  }
  function D(m, e) {
    R(m, (g, n) => {
      const i = j[g];
      j[g] = i && i.filter((r) => r._key ? r._key !== e : e || r._namespace !== n);
    });
  }
  function B(m) {
    Dn(j, (e, g) => {
      D(g, m);
    });
  }
  function U(m) {
    (j[m] || []).forEach((e) => {
      e._callback.apply(e, na(arguments, 1));
    });
  }
  function G() {
    j = {};
  }
  function R(m, e) {
    Ba(m).join(" ").split(" ").forEach((g) => {
      const n = g.split(".");
      e(n[0], n[1]);
    });
  }
  return {
    on: f,
    off: D,
    offBy: B,
    emit: U,
    destroy: G
  };
}
const Jr = "mounted", Cs = "ready", mn = "move", xa = "moved", Uu = "shifted", Fu = "click", Bf = "active", zf = "inactive", kf = "visible", Yf = "hidden", Bu = "slide:keydown", cr = "refresh", Lr = "updated", Hn = "resize", zu = "resized", ku = "repositioned", Wf = "drag", Kf = "dragging", Vf = "dragged", Yu = "scroll", za = "scrolled", Wu = "destroy", Gf = "arrows:mounted", Qf = "arrows:updated", Hf = "pagination:mounted", Xf = "pagination:updated", Ku = "navigation:mounted", $f = "autoplay:play", Zf = "autoplay:playing", Jf = "autoplay:pause", Vu = "lazyload:loaded";
function fr(j) {
  const { event: f } = j, D = {};
  let B = [];
  function U(n, i, r) {
    f.on(n, i, D, r);
  }
  function G(n) {
    f.off(n, D);
  }
  function R(n, i, r, l) {
    e(n, i, (d, t) => {
      B.push([d, t, r, l]), d.addEventListener(t, r, l);
    });
  }
  function m(n, i, r) {
    e(n, i, (l, d) => {
      B = B.filter((t) => t[0] === l && t[1] === d && (!r || t[2] === r) ? (l.removeEventListener(d, t[2], t[3]), !1) : !0);
    });
  }
  function e(n, i, r) {
    En(n, (l) => {
      l && i.split(" ").forEach(r.bind(null, l));
    });
  }
  function g() {
    B = B.filter((n) => m(n[0], n[1])), f.offBy(D);
  }
  return f.on(Wu, g, D), {
    on: U,
    off: G,
    emit: f.emit,
    bind: R,
    unbind: m,
    destroy: g
  };
}
function Xo(j, f, D, B) {
  const { now: U } = Date;
  let G, R = 0, m, e = !0, g = 0;
  function n() {
    if (!e) {
      const S = U() - G;
      if (S >= j ? (R = 1, G = U()) : R = S / j, D && D(R), R === 1 && (f(), B && ++g >= B))
        return r();
      Ss(n);
    }
  }
  function i(S) {
    !S && d(), G = U() - (S ? R * j : 0), e = !1, Ss(n);
  }
  function r() {
    e = !0;
  }
  function l() {
    G = U(), R = 0, D && D(R);
  }
  function d() {
    cancelAnimationFrame(m), R = 0, m = 0, e = !0;
  }
  function t(S) {
    j = S;
  }
  function T() {
    return e;
  }
  return {
    start: i,
    rewind: l,
    pause: r,
    cancel: d,
    set: t,
    isPaused: T
  };
}
function qf(j) {
  let f = j;
  function D(U) {
    f = U;
  }
  function B(U) {
    return pi(Ba(U), f);
  }
  return { set: D, is: B };
}
function Gu(j, f) {
  let D;
  function B() {
    D || (D = Xo(f || 0, () => {
      j.apply(this, arguments), D = null;
    }, null, 1), D.start());
  }
  return B;
}
function ed(j, f, D) {
  const B = Gu(n);
  let U, G, R;
  function m() {
    try {
      An(D, JSON.parse(Ca(j.root, zo)));
    } catch (l) {
      Oa(!1, l.message);
    }
    U = An({}, D);
    const { breakpoints: r } = D;
    if (r) {
      const l = D.mediaQuery === "min";
      G = Object.keys(r).sort((d, t) => l ? +t - +d : +d - +t).map((d) => [
        d,
        matchMedia(`(${l ? "min" : "max"}-width:${d}px)`)
      ]), n();
    }
  }
  function e() {
    G && addEventListener("resize", B);
  }
  function g(r) {
    r && removeEventListener("resize", B);
  }
  function n() {
    const r = Rf(G, (l) => l[1].matches) || [];
    r[0] !== R && i(R = r[0]);
  }
  function i(r) {
    const l = D.breakpoints[r] || U;
    l.destroy ? (j.options = U, j.destroy(l.destroy === "completely")) : (j.state.is(ci) && (g(!0), j.mount()), j.options = l);
  }
  return {
    setup: m,
    mount: e,
    destroy: g
  };
}
const js = "rtl", $o = "ttb", td = {
  marginRight: ["marginBottom", "marginLeft"],
  autoWidth: ["autoHeight"],
  fixedWidth: ["fixedHeight"],
  paddingLeft: ["paddingTop", "paddingRight"],
  paddingRight: ["paddingBottom", "paddingLeft"],
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: ["ArrowUp", "ArrowRight"],
  ArrowRight: ["ArrowDown", "ArrowLeft"]
};
function rd(j, f, D) {
  function B(G, R) {
    const { direction: m } = D, e = m === js && !R ? 1 : m === $o ? 0 : -1;
    return td[G][e] || G;
  }
  function U(G) {
    return G * (D.direction === js ? 1 : -1);
  }
  return {
    resolve: B,
    orient: U
  };
}
const $a = vr, nd = `${vr}__slider`, ad = `${vr}__track`, id = `${vr}__list`, Li = `${vr}__slide`, Qu = `${Li}--clone`, od = `${Li}__container`, Hu = `${vr}__arrows`, Zo = `${vr}__arrow`, Xu = `${Zo}--prev`, $u = `${Zo}--next`, Zu = `${vr}__pagination`, sd = `${Zu}__page`, Ju = `${vr}__progress`, ud = `${Ju}__bar`, ld = `${vr}__autoplay`, cd = `${vr}__play`, fd = `${vr}__pause`, dd = `${vr}__spinner`, gd = "is-initialized", Xn = "is-active", qu = "is-prev", el = "is-next", ho = "is-visible", _o = "is-loading", md = [Xn, ho, qu, el, _o], Ed = {
  slide: Li,
  clone: Qu,
  arrows: Hu,
  arrow: Zo,
  prev: Xu,
  next: $u,
  pagination: Zu,
  page: sd,
  spinner: dd
};
function Md(j, f, D) {
  const { on: B } = fr(j), { root: U } = j, G = {}, R = [];
  let m, e, g, n;
  function i() {
    T(), S(), gn(U, m = _());
  }
  function r() {
    B(cr, d, ko - 2), B(Lr, t);
  }
  function l() {
    [U, g, n].forEach((L) => {
      Wr(L, "style");
    }), ra(R), ja(U, m);
  }
  function d() {
    l(), i();
  }
  function t() {
    ja(U, m), gn(U, m = _());
  }
  function T() {
    e = Xr(U, `.${nd}`), g = Tn(U, `.${ad}`), n = Xr(g, `.${id}`), Oa(g && n, "A track/list element is missing."), pa(R, bu(n, `.${Li}:not(.${Qu})`));
    const L = h(`.${ld}`), v = h(`.${Hu}`);
    go(G, {
      root: U,
      slider: e,
      track: g,
      list: n,
      slides: R,
      arrows: v,
      autoplay: L,
      prev: Tn(v, `.${Xu}`),
      next: Tn(v, `.${$u}`),
      bar: Tn(h(`.${Ju}`), `.${ud}`),
      play: Tn(L, `.${cd}`),
      pause: Tn(L, `.${fd}`)
    });
  }
  function S() {
    const L = U.id || Uf(vr);
    U.id = L, g.id = g.id || `${L}-track`, n.id = n.id || `${L}-list`;
  }
  function h(L) {
    return Xr(U, L) || Xr(e, L);
  }
  function _() {
    return [
      `${$a}--${D.type}`,
      `${$a}--${D.direction}`,
      D.drag && `${$a}--draggable`,
      D.isNavigation && `${$a}--nav`,
      Xn
    ];
  }
  return go(G, {
    setup: i,
    mount: r,
    destroy: l
  });
}
const Ii = "role", $n = "aria-controls", di = "aria-current", Zn = "aria-label", tl = "aria-hidden", wa = "tabindex", hd = "disabled", rl = "aria-orientation", gi = [
  Ii,
  $n,
  di,
  Zn,
  tl,
  rl,
  wa,
  hd
], ka = "slide", ia = "loop", Ai = "fade";
function _d(j, f, D, B) {
  const { on: U, emit: G, bind: R, destroy: m } = fr(j), { Components: e, root: g, options: n } = j, { isNavigation: i, updateOnMove: r } = n, { resolve: l } = e.Direction, d = Ca(B, "style"), t = D > -1, T = Xr(B, `.${od}`), S = n.focusableNodes && Qo(B, n.focusableNodes);
  let h;
  function _() {
    t || (B.id = `${g.id}-slide${Ho(f + 1)}`), R(B, "click keydown", (C) => {
      G(C.type === "click" ? Fu : Bu, N, C);
    }), U([cr, ku, Uu, xa, za], o), U(Ku, v), r && U(mn, c);
  }
  function L() {
    h = !0, m(), ja(B, md), Wr(B, gi), ur(B, "style", d);
  }
  function v() {
    const C = t ? D : f, b = wu(n.i18n.slideX, C + 1), w = j.splides.map((V) => V.splide.root.id).join(" ");
    ur(B, Zn, b), ur(B, $n, w), ur(B, Ii, "menuitem"), y(I());
  }
  function c() {
    h || o();
  }
  function o() {
    if (!h) {
      const { index: C } = j;
      y(I()), u(M()), kn(B, qu, f === C - 1), kn(B, el, f === C + 1);
    }
  }
  function y(C) {
    C !== As(B, Xn) && (kn(B, Xn, C), i && ur(B, di, C || null), G(C ? Bf : zf, N));
  }
  function u(C) {
    const b = !C && (!I() || t);
    ur(B, tl, b || null), ur(B, wa, !b && n.slideFocus ? 0 : null), S && S.forEach((w) => {
      ur(w, wa, b ? -1 : null);
    }), C !== As(B, ho) && (kn(B, ho, C), G(C ? kf : Yf, N));
  }
  function A(C, b, w) {
    Cr(w && T || B, C, b);
  }
  function I() {
    const { index: C } = j;
    return C === f || n.cloneStatus && C === D;
  }
  function M() {
    if (j.is(Ai))
      return I();
    const C = Sr(e.Elements.track), b = Sr(B), w = l("left"), V = l("right");
    return Mo(C[w]) <= ba(b[w]) && Mo(b[V]) <= ba(C[V]);
  }
  function E(C, b) {
    let w = jr(C - f);
    return !t && (n.rewind || j.is(ia)) && (w = Pa(w, j.length - w)), w <= b;
  }
  const N = {
    index: f,
    slideIndex: D,
    slide: B,
    container: T,
    isClone: t,
    mount: _,
    destroy: L,
    update: o,
    style: A,
    isWithin: E
  };
  return N;
}
function yd(j, f, D) {
  const { on: B, emit: U, bind: G } = fr(j), { slides: R, list: m } = f.Elements, e = [];
  function g() {
    n(), B(cr, r), B([Jr, cr], () => {
      e.sort((A, I) => A.index - I.index);
    });
  }
  function n() {
    R.forEach((A, I) => {
      d(A, I, -1);
    });
  }
  function i() {
    L((A) => {
      A.destroy();
    }), ra(e);
  }
  function r() {
    i(), n();
  }
  function l() {
    L((A) => {
      A.update();
    });
  }
  function d(A, I, M) {
    const E = _d(j, I, M, A);
    E.mount(), e.push(E);
  }
  function t(A) {
    return A ? v((I) => !I.isClone) : e;
  }
  function T(A) {
    const { Controller: I } = f, M = I.toIndex(A), E = I.hasFocus() ? 1 : D.perPage;
    return v((N) => Ta(N.index, M, M + E - 1));
  }
  function S(A) {
    return v(A)[0];
  }
  function h(A, I) {
    En(A, (M) => {
      if (dn(M) && (M = xu(M)), Ko(M)) {
        const E = R[I];
        E ? Vo(M, E) : Ti(m, M), gn(M, D.classes.slide), o(M, U.bind(null, Hn));
      }
    }), U(cr);
  }
  function _(A) {
    aa(v(A).map((I) => I.slide)), U(cr);
  }
  function L(A, I) {
    t(I).forEach(A);
  }
  function v(A) {
    return e.filter(Of(A) ? A : (I) => dn(A) ? Go(I.slide, A) : pi(Ba(A), I.index));
  }
  function c(A, I, M) {
    L((E) => {
      E.style(A, I, M);
    });
  }
  function o(A, I) {
    const M = Qo(A, "img");
    let { length: E } = M;
    E ? M.forEach((N) => {
      G(N, "load error", () => {
        --E || I();
      });
    }) : I();
  }
  function y(A) {
    return A ? R.length : e.length;
  }
  function u() {
    return e.length > D.perPage;
  }
  return {
    mount: g,
    destroy: i,
    update: l,
    register: d,
    get: t,
    getIn: T,
    getAt: S,
    add: h,
    remove: _,
    forEach: L,
    filter: v,
    style: c,
    getLength: y,
    isEnough: u
  };
}
function vd(j, f, D) {
  const { on: B, bind: U, emit: G } = fr(j), { Slides: R } = f, { resolve: m } = f.Direction, { root: e, track: g, list: n } = f.Elements, { getAt: i } = R;
  let r, l;
  function d() {
    t(), U(window, "resize load", Gu(G.bind(this, Hn))), B([Lr, cr], t), B(Hn, T);
  }
  function t() {
    l = null, r = D.direction === $o, Cr(e, "maxWidth", nn(D.width)), Cr(g, m("paddingLeft"), h(!1)), Cr(g, m("paddingRight"), h(!0)), T();
  }
  function T() {
    const N = Sr(e);
    (!l || l.width !== N.width || l.height !== N.height) && (Cr(g, "height", _()), R.style(m("marginRight"), nn(D.gap)), R.style("width", v() || null), S(), l = N, G(zu));
  }
  function S() {
    R.style("height", c() || null, !0);
  }
  function h(N) {
    const { padding: C } = D, b = m(N ? "right" : "left");
    return C && nn(C[b] || (Na(C) ? 0 : C)) || "0px";
  }
  function _() {
    let N = "";
    return r && (N = L(), Oa(N, "height or heightRatio is missing."), N = `calc(${N} - ${h(!1)} - ${h(!0)})`), N;
  }
  function L() {
    return nn(D.height || Sr(n).width * D.heightRatio);
  }
  function v() {
    return D.autoWidth ? "" : nn(D.fixedWidth) || (r ? "" : o());
  }
  function c() {
    return nn(D.fixedHeight) || (r ? D.autoHeight ? "" : o() : L());
  }
  function o() {
    const N = nn(D.gap);
    return `calc((100%${N && ` + ${N}`})/${D.perPage || 1}${N && ` - ${N}`})`;
  }
  function y() {
    return Sr(n)[m("width")];
  }
  function u(N, C) {
    const b = i(N || 0);
    return b ? Sr(b.slide)[m("width")] + (C ? 0 : M()) : 0;
  }
  function A(N, C) {
    const b = i(N);
    if (b) {
      const w = Sr(b.slide)[m("right")], V = Sr(n)[m("left")];
      return jr(w - V) + (C ? 0 : M());
    }
    return 0;
  }
  function I() {
    return A(j.length - 1, !0) - A(-1, !0);
  }
  function M() {
    const N = i(0);
    return N && parseFloat(Cr(N.slide, m("marginRight"))) || 0;
  }
  function E(N) {
    return parseFloat(Cr(g, m(`padding${N ? "Right" : "Left"}`))) || 0;
  }
  return {
    mount: d,
    listSize: y,
    slideSize: u,
    sliderSize: I,
    totalSize: A,
    getPadding: E
  };
}
function pd(j, f, D) {
  const { on: B, emit: U } = fr(j), { Elements: G, Slides: R } = f, { resolve: m } = f.Direction, e = [];
  let g;
  function n() {
    i(), B(cr, l), B([Lr, Hn], d);
  }
  function i() {
    (g = S()) && (t(g), U(Hn));
  }
  function r() {
    aa(e), ra(e);
  }
  function l() {
    r(), i();
  }
  function d() {
    g < S() && U(cr);
  }
  function t(h) {
    const _ = R.get().slice(), { length: L } = _;
    if (L) {
      for (; _.length < h; )
        pa(_, _);
      pa(_.slice(-h), _.slice(0, h)).forEach((v, c) => {
        const o = c < h, y = T(v.slide, c);
        o ? Vo(y, _[0].slide) : Ti(G.list, y), pa(e, y), R.register(y, c - h + (o ? 0 : L), v.index);
      });
    }
  }
  function T(h, _) {
    const L = h.cloneNode(!0);
    return gn(L, D.classes.clone), L.id = `${j.root.id}-clone${Ho(_ + 1)}`, L;
  }
  function S() {
    let { clones: h } = D;
    if (!j.is(ia))
      h = 0;
    else if (!h) {
      const _ = xf(G.list, D[m("fixedWidth")]);
      h = (_ && ba(Sr(G.track)[m("width")] / _) || D[m("autoWidth")] && j.length || D.perPage) * (D.drag ? (D.flickMaxPages || 1) + 1 : 2);
    }
    return h;
  }
  return {
    mount: n,
    destroy: r
  };
}
function Td(j, f, D) {
  const { on: B, emit: U } = fr(j), { slideSize: G, getPadding: R, totalSize: m, listSize: e, sliderSize: g } = f.Layout, { resolve: n, orient: i } = f.Direction, { list: r, track: l } = f.Elements;
  let d;
  function t() {
    d = f.Transition, B([Jr, zu, Lr, cr], S);
  }
  function T() {
    Wr(r, "style");
  }
  function S() {
    N() || (f.Scroll.cancel(), _(j.index), U(ku));
  }
  function h(b, w, V, J) {
    if (!N()) {
      const { set: H } = j.state, z = A();
      b !== w && (d.cancel(), L(c(z, b > w), !0)), H(li), U(mn, w, V, b), d.start(w, () => {
        H(ui), U(xa, w, V, b), D.trimSpace === "move" && b !== V && z === A() ? f.Controller.go(b > V ? ">" : "<", !1, J) : J && J();
      });
    }
  }
  function _(b) {
    L(u(b, !0));
  }
  function L(b, w) {
    if (!j.is(Ai)) {
      const V = w ? b : v(b);
      r.style.transform = `translate${n("X")}(${V}px)`, b !== V && U(Uu);
    }
  }
  function v(b) {
    if (j.is(ia)) {
      const w = i(b - A()), V = C(!1, b) && w < 0, J = C(!0, b) && w > 0;
      (V || J) && (b = c(b, J));
    }
    return b;
  }
  function c(b, w) {
    const V = b - E(w), J = g();
    return b -= i(J * (ba(jr(V) / J) || 1)) * (w ? 1 : -1), b;
  }
  function o() {
    L(A()), d.cancel();
  }
  function y(b) {
    const w = f.Slides.get();
    let V = 0, J = 1 / 0;
    for (let H = 0; H < w.length; H++) {
      const z = w[H].index, Z = jr(u(z, !0) - b);
      if (Z <= J)
        J = Z, V = z;
      else
        break;
    }
    return V;
  }
  function u(b, w) {
    const V = i(m(b - 1) - M(b));
    return w ? I(V) : V;
  }
  function A() {
    const b = n("left");
    return Sr(r)[b] - Sr(l)[b] + i(R(!1));
  }
  function I(b) {
    return D.trimSpace && j.is(ka) && (b = ya(b, 0, i(g() - e()))), b;
  }
  function M(b) {
    const { focus: w } = D;
    return w === "center" ? (e() - G(b, !0)) / 2 : +w * G(b) || 0;
  }
  function E(b) {
    return u(b ? f.Controller.getEnd() : 0, !!D.trimSpace);
  }
  function N() {
    return j.state.is(li) && D.waitForTransition;
  }
  function C(b, w) {
    w = Yo(w) ? A() : w;
    const V = b !== !0 && i(w) < i(E(!1)), J = b !== !1 && i(w) > i(E(!0));
    return V || J;
  }
  return {
    mount: t,
    destroy: T,
    move: h,
    jump: _,
    translate: L,
    shift: c,
    cancel: o,
    toIndex: y,
    toPosition: u,
    getPosition: A,
    getLimit: E,
    isBusy: N,
    exceededLimit: C
  };
}
function Ld(j, f, D) {
  const { on: B } = fr(j), { Move: U } = f, { getPosition: G, getLimit: R } = U, { isEnough: m, getLength: e } = f.Slides, g = j.is(ia), n = j.is(ka);
  let i = D.start || 0, r = i, l, d, t;
  function T() {
    S(), B([Lr, cr], S, ko - 1);
  }
  function S() {
    l = e(!0), d = D.perMove, t = D.perPage, i = ya(i, 0, l - 1);
  }
  function h(w, V, J) {
    const H = L(w);
    if (D.useScroll)
      _(H, !0, !0, D.speed, J);
    else {
      const z = A(H);
      z > -1 && !U.isBusy() && (V || z !== i) && (N(z), U.move(H, z, r, J));
    }
  }
  function _(w, V, J, H, z) {
    const Z = V ? w : E(w);
    f.Scroll.scroll(V || J ? U.toPosition(Z, !0) : w, H, () => {
      N(U.toIndex(U.getPosition())), z && z();
    });
  }
  function L(w) {
    let V = i;
    if (dn(w)) {
      const [, J, H] = w.match(/([+\-<>])(\d+)?/) || [];
      J === "+" || J === "-" ? V = y(i + +`${J}${+H || 1}`, i, !0) : J === ">" ? V = H ? I(+H) : v(!0) : J === "<" && (V = c(!0));
    } else
      V = g ? w : ya(w, 0, u());
    return V;
  }
  function v(w) {
    return o(!1, w);
  }
  function c(w) {
    return o(!0, w);
  }
  function o(w, V) {
    const J = d || (b() ? 1 : t), H = y(i + J * (w ? -1 : 1), i);
    return H === -1 && n && !wf(G(), R(!w), 1) ? w ? 0 : u() : V ? H : A(H);
  }
  function y(w, V, J) {
    if (m()) {
      const H = u();
      w < 0 || w > H ? Ta(0, w, V, !0) || Ta(H, V, w, !0) ? w = I(M(w)) : g ? w = d || b() ? w : w < 0 ? -(l % t || t) : l : D.rewind ? w = w < 0 ? H : 0 : w = -1 : !J && w !== V && (w = d ? w : I(M(V) + (w < V ? -1 : 1)));
    } else
      w = -1;
    return w;
  }
  function u() {
    let w = l - t;
    return (b() || g && d) && (w = l - 1), Ra(w, 0);
  }
  function A(w) {
    return g ? m() ? w % l + (w < 0 ? l : 0) : -1 : w;
  }
  function I(w) {
    return ya(b() ? w : t * w, 0, u());
  }
  function M(w) {
    return b() || (w = Ta(w, l - t, l - 1) ? l - 1 : w, w = Mo(w / t)), w;
  }
  function E(w) {
    const V = U.toIndex(w);
    return n ? ya(V, 0, u()) : V;
  }
  function N(w) {
    w !== i && (r = i, i = w);
  }
  function C(w) {
    return w ? r : i;
  }
  function b() {
    return !Yo(D.focus) || D.isNavigation;
  }
  return {
    mount: T,
    go: h,
    scroll: _,
    getNext: v,
    getPrev: c,
    getAdjacent: o,
    getEnd: u,
    setIndex: N,
    getIndex: C,
    toIndex: I,
    toPage: M,
    toDest: E,
    hasFocus: b
  };
}
const Id = "http://www.w3.org/2000/svg", Ad = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z", Za = 40;
function Sd(j, f, D) {
  const { on: B, bind: U, emit: G } = fr(j), { classes: R, i18n: m } = D, { Elements: e, Controller: g } = f;
  let n = e.arrows, i = e.prev, r = e.next, l;
  const d = {};
  function t() {
    T(), B(Lr, T);
  }
  function T() {
    if (D.arrows && (!i || !r) && _(), i && r)
      if (d.prev)
        fi(n, D.arrows === !1 ? "none" : "");
      else {
        const { id: c } = e.track;
        ur(i, $n, c), ur(r, $n, c), d.prev = i, d.next = r, h(), G(Gf, i, r);
      }
  }
  function S() {
    l ? aa(n) : (Wr(i, gi), Wr(r, gi));
  }
  function h() {
    const { go: c } = g;
    B([Jr, xa, Lr, cr, za], v), U(r, "click", () => {
      c(">", !0);
    }), U(i, "click", () => {
      c("<", !0);
    });
  }
  function _() {
    n = Kn("div", R.arrows), i = L(!0), r = L(!1), l = !0, Ti(n, [i, r]), Vo(n, Xr(D.arrows === "slider" && e.slider || j.root));
  }
  function L(c) {
    const o = `<button class="${R.arrow} ${c ? R.prev : R.next}" type="button"><svg xmlns="${Id}" viewBox="0 0 ${Za} ${Za}" width="${Za}" height="${Za}"><path d="${D.arrowPath || Ad}" />`;
    return xu(o);
  }
  function v() {
    const c = j.index, o = g.getPrev(), y = g.getNext(), u = o > -1 && c < o ? m.last : m.prev, A = y > -1 && c > y ? m.first : m.next;
    i.disabled = o < 0, r.disabled = y < 0, ur(i, Zn, u), ur(r, Zn, A), G(Qf, i, r, o, y);
  }
  return {
    arrows: d,
    mount: t,
    destroy: S
  };
}
const Dd = `${zo}-interval`;
function Nd(j, f, D) {
  const { on: B, bind: U, emit: G } = fr(j), R = Xo(D.interval, j.go.bind(j, ">"), h), { isPaused: m } = R, { Elements: e } = f;
  let g, n, i;
  function r() {
    const { autoplay: L } = D;
    L && (l(!0), l(!1), d(), L !== "pause" && t());
  }
  function l(L) {
    const v = L ? "pause" : "play", c = e[v];
    c && (ur(c, $n, e.track.id), ur(c, Zn, D.i18n[v]), U(c, "click", L ? T : t));
  }
  function d() {
    const { root: L } = e;
    D.pauseOnHover && U(L, "mouseenter mouseleave", (v) => {
      g = v.type === "mouseenter", S();
    }), D.pauseOnFocus && U(L, "focusin focusout", (v) => {
      n = v.type === "focusin", S();
    }), B([mn, Yu, cr], R.rewind), B(mn, _);
  }
  function t() {
    m() && f.Slides.isEnough() && (R.start(!D.resetProgress), n = g = i = !1, G($f));
  }
  function T(L = !0) {
    m() || (R.pause(), G(Jf)), i = L;
  }
  function S() {
    i || (!g && !n ? t() : T(!1));
  }
  function h(L) {
    const { bar: v } = e;
    v && Cr(v, "width", `${L * 100}%`), G(Zf, L);
  }
  function _() {
    const L = f.Slides.getAt(j.index);
    R.set(L && +Ca(L.slide, Dd) || D.interval);
  }
  return {
    mount: r,
    destroy: R.cancel,
    play: t,
    pause: T,
    isPaused: m
  };
}
function Cd(j, f, D) {
  const { on: B } = fr(j);
  function U() {
    D.cover && (B(Vu, (e, g) => {
      m(!0, e, g);
    }), B([Jr, Lr, cr], R.bind(null, !0)));
  }
  function G() {
    R(!1);
  }
  function R(e) {
    f.Slides.forEach((g) => {
      const n = Xr(g.container || g.slide, "img");
      n && n.src && m(e, n, g);
    });
  }
  function m(e, g, n) {
    n.style("background", e ? `center/cover no-repeat url("${g.src}")` : "", !0), fi(g, e ? "none" : "");
  }
  return {
    mount: U,
    destroy: G
  };
}
const jd = 10, Od = 600, Pd = 0.6, Rd = 1.5, bd = 800;
function xd(j, f, D) {
  const { on: B, emit: U } = fr(j), { Move: G } = f, { getPosition: R, getLimit: m, exceededLimit: e } = G;
  let g, n;
  function i() {
    B(mn, T), B([Lr, cr], S);
  }
  function r(_, L, v, c) {
    const o = R();
    let y = 1;
    L = L || t(jr(_ - o)), n = v, T(), g = Xo(L, d, (u) => {
      const A = R(), M = (o + (_ - o) * h(u) - R()) * y;
      G.translate(A + M), j.is(ka) && !c && e() && (y *= Pd, jr(M) < jd && l(e(!1)));
    }, 1), U(Yu), g.start();
  }
  function l(_) {
    r(m(!_), Od, null, !0);
  }
  function d() {
    const _ = R(), L = G.toIndex(_);
    Ta(L, 0, j.length - 1) || G.translate(G.shift(_, L > 0), !0), n && n(), U(za);
  }
  function t(_) {
    return Ra(_ / Rd, bd);
  }
  function T() {
    g && g.cancel();
  }
  function S() {
    g && !g.isPaused() && (T(), d());
  }
  function h(_) {
    const { easingFunc: L } = D;
    return L ? L(_) : 1 - Math.pow(1 - _, 4);
  }
  return {
    mount: i,
    destroy: T,
    scroll: r,
    cancel: S
  };
}
const Fn = { passive: !1, capture: !0 }, wd = 5, Os = 200, Ud = "touchstart mousedown", Fi = "touchmove mousemove", Bi = "touchend touchcancel mouseup";
function Fd(j, f, D) {
  const { on: B, emit: U, bind: G, unbind: R } = fr(j), { Move: m, Scroll: e, Controller: g } = f, { track: n } = f.Elements, { resolve: i, orient: r } = f.Direction, { getPosition: l, exceededLimit: d } = m;
  let t, T, S, h, _, L, v = !1, c, o, y;
  function u() {
    G(n, Fi, Eo, Fn), G(n, Bi, Eo, Fn), G(n, Ud, I, Fn), G(n, "click", C, { capture: !0 }), G(n, "dragstart", an), B([Jr, Lr], A);
  }
  function A() {
    const { drag: Y } = D;
    K(!Y), _ = Y === "free";
  }
  function I(Y) {
    if (!o) {
      const { noDrag: ne } = D, ae = Z(Y), fe = !ne || !Go(Y.target, ne);
      c = !1, fe && (ae || !Y.button) && (m.isBusy() ? an(Y, !0) : (y = ae ? n : window, S = null, h = null, G(y, Fi, M, Fn), G(y, Bi, E, Fn), m.cancel(), e.cancel(), N(Y)));
    }
  }
  function M(Y) {
    if (h || U(Wf), h = Y, Y.cancelable) {
      const ne = J(Y) - J(T);
      if (L) {
        m.translate(t + z(ne));
        const ae = H(Y) - H(T) > Os, fe = v !== (v = d());
        (ae || fe) && N(Y), U(Kf), c = !0, an(Y);
      } else {
        let { dragMinThreshold: ae } = D;
        ae = Na(ae) ? ae : { mouse: 0, touch: +ae || 10 }, L = jr(ne) > (Z(Y) ? ae.touch : ae.mouse), b() && an(Y);
      }
    }
  }
  function E(Y) {
    R(y, Fi, M), R(y, Bi, E);
    const { index: ne } = j;
    if (h) {
      if (L || Y.cancelable && b()) {
        const ae = w(Y), fe = V(ae);
        _ ? g.scroll(fe) : j.is(Ai) ? g.go(ne + r(Ds(ae))) : g.go(g.toDest(fe), !0), an(Y);
      }
      U(Vf);
    } else
      !_ && l() !== m.toPosition(ne) && g.go(ne, !0);
    L = !1;
  }
  function N(Y) {
    S = T, T = Y, t = l();
  }
  function C(Y) {
    !o && c && an(Y, !0);
  }
  function b() {
    const Y = jr(J(h) - J(T)), ne = jr(J(h, !0) - J(T, !0));
    return Y > ne;
  }
  function w(Y) {
    if (j.is(ia) || !v) {
      const ne = T === h && S || T, ae = J(h) - J(ne), fe = H(Y) - H(ne), Q = H(Y) - H(h) < Os;
      if (fe && Q)
        return ae / fe;
    }
    return 0;
  }
  function V(Y) {
    return l() + Ds(Y) * Pa(jr(Y) * (D.flickPower || 600), _ ? 1 / 0 : f.Layout.listSize() * (D.flickMaxPages || 1));
  }
  function J(Y, ne) {
    return (Z(Y) ? Y.touches[0] : Y)[`page${i(ne ? "Y" : "X")}`];
  }
  function H(Y) {
    return Y.timeStamp;
  }
  function z(Y) {
    return Y / (v && j.is(ka) ? wd : 1);
  }
  function Z(Y) {
    return typeof TouchEvent < "u" && Y instanceof TouchEvent;
  }
  function ie() {
    return L;
  }
  function K(Y) {
    o = Y;
  }
  return {
    mount: u,
    disable: K,
    isDragging: ie
  };
}
const Bd = ["Left", "Right", "Up", "Down"], Ps = "keydown";
function zd(j, f, D) {
  const { on: B, bind: U, unbind: G } = fr(j), { root: R } = j, { resolve: m } = f.Direction;
  let e, g;
  function n() {
    i(), B(Lr, t), B(mn, d);
  }
  function i() {
    const { keyboard: S } = D;
    S && (S === "focused" ? (e = R, ur(R, wa, 0)) : e = window, U(e, Ps, T));
  }
  function r() {
    G(e, Ps), Ko(e) && Wr(e, wa);
  }
  function l(S) {
    g = S;
  }
  function d() {
    const S = g;
    g = !0, mo(() => {
      g = S;
    });
  }
  function t() {
    r(), i();
  }
  function T(S) {
    if (!g) {
      const { key: h } = S, _ = pi(Bd, h) ? `Arrow${h}` : h;
      _ === m("ArrowLeft") ? j.go("<") : _ === m("ArrowRight") && j.go(">");
    }
  }
  return {
    mount: n,
    destroy: r,
    disable: l
  };
}
const mi = `${zo}-lazy`, yo = `${mi}-srcset`, kd = `[${mi}], [${yo}]`;
function Yd(j, f, D) {
  const { on: B, off: U, bind: G, emit: R } = fr(j), m = D.lazyLoad === "sequential";
  let e = [], g = 0;
  function n() {
    D.lazyLoad && (r(), B(cr, i), m || B([Jr, cr, xa, za], d));
  }
  function i() {
    l(), r();
  }
  function r() {
    f.Slides.forEach((h) => {
      Qo(h.slide, kd).forEach((_) => {
        const L = Ca(_, mi), v = Ca(_, yo);
        if (L !== _.src || v !== _.srcset) {
          const c = D.classes.spinner, o = _.parentElement, y = Xr(o, `.${c}`) || Kn("span", c, o);
          ur(y, Ii, "presentation"), e.push({ _img: _, _Slide: h, src: L, srcset: v, _spinner: y }), !_.src && fi(_, "none");
        }
      });
    }), m && S();
  }
  function l() {
    g = 0, e = [];
  }
  function d() {
    e = e.filter((h) => {
      const _ = D.perPage * ((D.preloadPages || 1) + 1) - 1;
      return h._Slide.isWithin(j.index, _) ? t(h) : !0;
    }), e.length || U(xa);
  }
  function t(h) {
    const { _img: _ } = h;
    gn(h._Slide.slide, _o), G(_, "load error", (L) => {
      T(h, L.type === "error");
    }), ["srcset", "src"].forEach((L) => {
      h[L] && (ur(_, L, h[L]), Wr(_, L === "src" ? mi : yo));
    });
  }
  function T(h, _) {
    const { _Slide: L } = h;
    ja(L.slide, _o), _ || (aa(h._spinner), fi(h._img, ""), R(Vu, h._img, L), R(Hn)), m && S();
  }
  function S() {
    g < e.length && t(e[g++]);
  }
  return {
    mount: n,
    destroy: l
  };
}
function Wd(j, f, D) {
  const { on: B, emit: U, bind: G, unbind: R } = fr(j), { Slides: m, Elements: e, Controller: g } = f, { hasFocus: n, getIndex: i } = g, r = [];
  let l;
  function d() {
    t(), B([Lr, cr], t), B([mn, za], L);
  }
  function t() {
    T(), D.pagination && m.isEnough() && (S(), U(Hf, { list: l, items: r }, _(j.index)), L());
  }
  function T() {
    l && (aa(l), r.forEach((v) => {
      R(v.button, "click");
    }), ra(r), l = null);
  }
  function S() {
    const { length: v } = j, { classes: c, i18n: o, perPage: y } = D, u = D.pagination === "slider" && e.slider || e.root, A = n() ? v : ba(v / y);
    l = Kn("ul", c.pagination, u);
    for (let I = 0; I < A; I++) {
      const M = Kn("li", null, l), E = Kn("button", { class: c.page, type: "button" }, M), N = m.getIn(I).map((b) => b.slide.id), C = !n() && y > 1 ? o.pageX : o.slideX;
      G(E, "click", h.bind(null, I)), ur(E, $n, N.join(" ")), ur(E, Zn, wu(C, I + 1)), r.push({ li: M, button: E, page: I });
    }
  }
  function h(v) {
    g.go(`>${v}`, !0, () => {
      const c = m.getAt(g.toIndex(v));
      c && bf(c.slide);
    });
  }
  function _(v) {
    return r[g.toPage(v)];
  }
  function L() {
    const v = _(i(!0)), c = _(i());
    v && (ja(v.button, Xn), Wr(v.button, di)), c && (gn(c.button, Xn), ur(c.button, di, !0)), U(Xf, { list: l, items: r }, v, c);
  }
  return {
    items: r,
    mount: d,
    destroy: T,
    getAt: _,
    update: L
  };
}
const Kd = [" ", "Enter", "Spacebar"];
function Vd(j, f, D) {
  const { list: B } = f.Elements, U = [];
  function G() {
    j.splides.forEach((l) => {
      !l.isParent && e(l.splide);
    }), D.isNavigation && g();
  }
  function R() {
    Wr(B, gi), U.forEach((l) => {
      l.destroy();
    }), ra(U);
  }
  function m() {
    R(), G();
  }
  function e(l) {
    [j, l].forEach((d) => {
      const t = fr(d), T = d === j ? l : j;
      t.on(mn, (S, h, _) => {
        T.go(T.is(ia) ? _ : S);
      }), U.push(t);
    });
  }
  function g() {
    const l = fr(j), { on: d } = l;
    d(Fu, i), d(Bu, r), d([Jr, Lr], n), ur(B, Ii, "menu"), U.push(l), l.emit(Ku, j.splides);
  }
  function n() {
    ur(B, rl, D.direction !== $o ? "horizontal" : null);
  }
  function i(l) {
    j.go(l.index);
  }
  function r(l, d) {
    pi(Kd, d.key) && (i(l), an(d));
  }
  return {
    mount: G,
    destroy: R,
    remount: m
  };
}
function Gd(j, f, D) {
  const { bind: B } = fr(j);
  function U() {
    D.wheel && B(f.Elements.track, "wheel", G, Fn);
  }
  function G(m) {
    if (m.cancelable) {
      const { deltaY: e } = m;
      if (e) {
        const g = e < 0;
        j.go(g ? "<" : ">"), R(g) && an(m);
      }
    }
  }
  function R(m) {
    return !D.releaseWheel || j.state.is(li) || f.Controller.getAdjacent(m) !== -1;
  }
  return {
    mount: U
  };
}
var Qd = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Options: ed,
  Direction: rd,
  Elements: Md,
  Slides: yd,
  Layout: vd,
  Clones: pd,
  Move: Td,
  Controller: Ld,
  Arrows: Sd,
  Autoplay: Nd,
  Cover: Cd,
  Scroll: xd,
  Drag: Fd,
  Keyboard: zd,
  LazyLoad: Yd,
  Pagination: Wd,
  Sync: Vd,
  Wheel: Gd
});
const Hd = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay"
}, Rs = {
  type: "slide",
  speed: 400,
  waitForTransition: !0,
  perPage: 1,
  cloneStatus: !0,
  arrows: !0,
  pagination: !0,
  interval: 5e3,
  pauseOnHover: !0,
  pauseOnFocus: !0,
  resetProgress: !0,
  keyboard: !0,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: !0,
  direction: "ltr",
  slideFocus: !0,
  trimSpace: !0,
  focusableNodes: "a, button, textarea, input, select, iframe",
  classes: Ed,
  i18n: Hd
};
function Xd(j, f, D) {
  const { on: B } = fr(j);
  function U() {
    B([Jr, cr], () => {
      mo(() => {
        f.Slides.style("transition", `opacity ${D.speed}ms ${D.easing}`);
      });
    });
  }
  function G(R, m) {
    const { track: e } = f.Elements;
    Cr(e, "height", nn(Sr(e).height)), mo(() => {
      m(), Cr(e, "height", "");
    });
  }
  return {
    mount: U,
    start: G,
    cancel: Eo
  };
}
function $d(j, f, D) {
  const { bind: B } = fr(j), { Move: U, Controller: G } = f, { list: R } = f.Elements;
  let m;
  function e() {
    B(R, "transitionend", (l) => {
      l.target === R && m && (n(), m());
    });
  }
  function g(l, d) {
    const t = U.toPosition(l, !0), T = U.getPosition(), S = i(l);
    jr(t - T) >= 1 && S >= 1 ? (r(`transform ${S}ms ${D.easing}`), U.translate(t, !0), m = d) : (U.jump(l), d());
  }
  function n() {
    r("");
  }
  function i(l) {
    const { rewindSpeed: d } = D;
    if (j.is(ka) && d) {
      const t = G.getIndex(!0), T = G.getEnd();
      if (t === 0 && l >= T || t >= T && l === 0)
        return d;
    }
    return D.speed;
  }
  function r(l) {
    Cr(R, "transition", l);
  }
  return {
    mount: e,
    start: g,
    cancel: n
  };
}
const nl = class {
  constructor(j, f) {
    this.event = Ff(), this.Components = {}, this.state = qf(Un), this.splides = [], this._options = {}, this._Extensions = {};
    const D = dn(j) ? Tn(document, j) : j;
    Oa(D, `${D} is invalid.`), this.root = D, An(Rs, nl.defaults), An(An(this._options, Rs), f || {});
  }
  mount(j, f) {
    const { state: D, Components: B } = this;
    Oa(D.is([Un, ci]), "Already mounted!"), D.set(Un), this._Components = B, this._Transition = f || this._Transition || (this.is(Ai) ? Xd : $d), this._Extensions = j || this._Extensions;
    const U = go({}, Qd, this._Extensions, { Transition: this._Transition });
    return Dn(U, (G, R) => {
      const m = G(this, B, this._options);
      B[R] = m, m.setup && m.setup();
    }), Dn(B, (G) => {
      G.mount && G.mount();
    }), this.emit(Jr), gn(this.root, gd), D.set(ui), this.emit(Cs), this;
  }
  sync(j) {
    return this.splides.push({ splide: j }), j.splides.push({ splide: this, isParent: !0 }), this.state.is(ui) && (this._Components.Sync.remount(), j.Components.Sync.remount()), this;
  }
  go(j) {
    return this._Components.Controller.go(j), this;
  }
  on(j, f) {
    return this.event.on(j, f, null, jf), this;
  }
  off(j) {
    return this.event.off(j), this;
  }
  emit(j) {
    return this.event.emit(j, ...na(arguments, 1)), this;
  }
  add(j, f) {
    return this._Components.Slides.add(j, f), this;
  }
  remove(j) {
    return this._Components.Slides.remove(j), this;
  }
  is(j) {
    return this._options.type === j;
  }
  refresh() {
    return this.emit(cr), this;
  }
  destroy(j = !0) {
    const { event: f, state: D } = this;
    return D.is(Un) ? f.on(Cs, this.destroy.bind(this, j), this) : (Dn(this._Components, (B) => {
      B.destroy && B.destroy(j);
    }, !0), f.emit(Wu), f.destroy(), j && ra(this.splides), D.set(ci)), this;
  }
  get options() {
    return this._options;
  }
  set options(j) {
    const { _options: f } = this;
    An(f, j), this.state.is(Un) || this.emit(Lr, f);
  }
  get length() {
    return this._Components.Slides.getLength(!0);
  }
  get index() {
    return this._Components.Controller.getIndex();
  }
};
let Jo = nl;
Jo.defaults = {};
Jo.STATES = Cf;
const en = /* @__PURE__ */ new Map(), zi = {
  set(j, f, D) {
    en.has(j) || en.set(j, /* @__PURE__ */ new Map());
    const B = en.get(j);
    if (!B.has(f) && B.size !== 0) {
      console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(B.keys())[0]}.`);
      return;
    }
    B.set(f, D);
  },
  get(j, f) {
    return en.has(j) && en.get(j).get(f) || null;
  },
  remove(j, f) {
    if (!en.has(j))
      return;
    const D = en.get(j);
    D.delete(f), D.size === 0 && en.delete(j);
  }
}, Zd = 1e3, vo = "transitionend", Jd = (j) => j == null ? `${j}` : Object.prototype.toString.call(j).match(/\s([a-z]+)/i)[1].toLowerCase(), qd = (j) => {
  let f = j.getAttribute("data-bs-target");
  if (!f || f === "#") {
    let D = j.getAttribute("href");
    if (!D || !D.includes("#") && !D.startsWith("."))
      return null;
    D.includes("#") && !D.startsWith("#") && (D = `#${D.split("#")[1]}`), f = D && D !== "#" ? D.trim() : null;
  }
  return f;
}, La = (j) => {
  const f = qd(j);
  return f ? document.querySelector(f) : null;
}, eg = (j) => {
  if (!j)
    return 0;
  let { transitionDuration: f, transitionDelay: D } = window.getComputedStyle(j);
  const B = Number.parseFloat(f), U = Number.parseFloat(D);
  return !B && !U ? 0 : (f = f.split(",")[0], D = D.split(",")[0], (Number.parseFloat(f) + Number.parseFloat(D)) * Zd);
}, tg = (j) => {
  j.dispatchEvent(new Event(vo));
}, Vn = (j) => !j || typeof j != "object" ? !1 : (typeof j.jquery < "u" && (j = j[0]), typeof j.nodeType < "u"), po = (j) => Vn(j) ? j.jquery ? j[0] : j : typeof j == "string" && j.length > 0 ? document.querySelector(j) : null, al = (j) => {
  if (!Vn(j) || j.getClientRects().length === 0)
    return !1;
  const f = getComputedStyle(j).getPropertyValue("visibility") === "visible", D = j.closest("details:not([open])");
  if (!D)
    return f;
  if (D !== j) {
    const B = j.closest("summary");
    if (B && B.parentNode !== D || B === null)
      return !1;
  }
  return f;
}, oa = (j) => !j || j.nodeType !== Node.ELEMENT_NODE || j.classList.contains("disabled") ? !0 : typeof j.disabled < "u" ? j.disabled : j.hasAttribute("disabled") && j.getAttribute("disabled") !== "false", il = (j) => {
  j.offsetHeight;
}, ol = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, ki = [], rg = (j) => {
  document.readyState === "loading" ? (ki.length || document.addEventListener("DOMContentLoaded", () => {
    for (const f of ki)
      f();
  }), ki.push(j)) : j();
}, bs = () => document.documentElement.dir === "rtl", qo = (j) => {
  rg(() => {
    const f = ol();
    if (f) {
      const D = j.NAME, B = f.fn[D];
      f.fn[D] = j.jQueryInterface, f.fn[D].Constructor = j, f.fn[D].noConflict = () => (f.fn[D] = B, j.jQueryInterface);
    }
  });
}, Ln = (j) => {
  typeof j == "function" && j();
}, sl = (j, f, D = !0) => {
  if (!D) {
    Ln(j);
    return;
  }
  const B = 5, U = eg(f) + B;
  let G = !1;
  const R = ({ target: m }) => {
    m === f && (G = !0, f.removeEventListener(vo, R), Ln(j));
  };
  f.addEventListener(vo, R), setTimeout(() => {
    G || tg(f);
  }, U);
}, ul = (j, f, D, B) => {
  const U = j.length;
  let G = j.indexOf(f);
  return G === -1 ? !D && B ? j[U - 1] : j[0] : (G += D ? 1 : -1, B && (G = (G + U) % U), j[Math.max(0, Math.min(G, U - 1))]);
}, ng = /[^.]*(?=\..*)\.|.*/, ag = /\..*/, ig = /::\d+$/, Yi = {};
let xs = 1;
const ll = {
  mouseenter: "mouseover",
  mouseleave: "mouseout"
}, og = /* @__PURE__ */ new Set([
  "click",
  "dblclick",
  "mouseup",
  "mousedown",
  "contextmenu",
  "mousewheel",
  "DOMMouseScroll",
  "mouseover",
  "mouseout",
  "mousemove",
  "selectstart",
  "selectend",
  "keydown",
  "keypress",
  "keyup",
  "orientationchange",
  "touchstart",
  "touchmove",
  "touchend",
  "touchcancel",
  "pointerdown",
  "pointermove",
  "pointerup",
  "pointerleave",
  "pointercancel",
  "gesturestart",
  "gesturechange",
  "gestureend",
  "focus",
  "blur",
  "change",
  "reset",
  "select",
  "submit",
  "focusin",
  "focusout",
  "load",
  "unload",
  "beforeunload",
  "resize",
  "move",
  "DOMContentLoaded",
  "readystatechange",
  "error",
  "abort",
  "scroll"
]);
function cl(j, f) {
  return f && `${f}::${xs++}` || j.uidEvent || xs++;
}
function fl(j) {
  const f = cl(j);
  return j.uidEvent = f, Yi[f] = Yi[f] || {}, Yi[f];
}
function sg(j, f) {
  return function D(B) {
    return es(B, { delegateTarget: j }), D.oneOff && Wt.off(j, B.type, f), f.apply(j, [B]);
  };
}
function ug(j, f, D) {
  return function B(U) {
    const G = j.querySelectorAll(f);
    for (let { target: R } = U; R && R !== this; R = R.parentNode)
      for (const m of G)
        if (m === R)
          return es(U, { delegateTarget: R }), B.oneOff && Wt.off(j, U.type, f, D), D.apply(R, [U]);
  };
}
function dl(j, f, D = null) {
  return Object.values(j).find((B) => B.callable === f && B.delegationSelector === D);
}
function gl(j, f, D) {
  const B = typeof f == "string", U = B ? D : f || D;
  let G = ml(j);
  return og.has(G) || (G = j), [B, U, G];
}
function ws(j, f, D, B, U) {
  if (typeof f != "string" || !j)
    return;
  let [G, R, m] = gl(f, D, B);
  f in ll && (R = ((d) => function(t) {
    if (!t.relatedTarget || t.relatedTarget !== t.delegateTarget && !t.delegateTarget.contains(t.relatedTarget))
      return d.call(this, t);
  })(R));
  const e = fl(j), g = e[m] || (e[m] = {}), n = dl(g, R, G ? D : null);
  if (n) {
    n.oneOff = n.oneOff && U;
    return;
  }
  const i = cl(R, f.replace(ng, "")), r = G ? ug(j, D, R) : sg(j, R);
  r.delegationSelector = G ? D : null, r.callable = R, r.oneOff = U, r.uidEvent = i, g[i] = r, j.addEventListener(m, r, G);
}
function To(j, f, D, B, U) {
  const G = dl(f[D], B, U);
  G && (j.removeEventListener(D, G, !!U), delete f[D][G.uidEvent]);
}
function lg(j, f, D, B) {
  const U = f[D] || {};
  for (const G of Object.keys(U))
    if (G.includes(B)) {
      const R = U[G];
      To(j, f, D, R.callable, R.delegationSelector);
    }
}
function ml(j) {
  return j = j.replace(ag, ""), ll[j] || j;
}
const Wt = {
  on(j, f, D, B) {
    ws(j, f, D, B, !1);
  },
  one(j, f, D, B) {
    ws(j, f, D, B, !0);
  },
  off(j, f, D, B) {
    if (typeof f != "string" || !j)
      return;
    const [U, G, R] = gl(f, D, B), m = R !== f, e = fl(j), g = e[R] || {}, n = f.startsWith(".");
    if (typeof G < "u") {
      if (!Object.keys(g).length)
        return;
      To(j, e, R, G, U ? D : null);
      return;
    }
    if (n)
      for (const i of Object.keys(e))
        lg(j, e, i, f.slice(1));
    for (const i of Object.keys(g)) {
      const r = i.replace(ig, "");
      if (!m || f.includes(r)) {
        const l = g[i];
        To(j, e, R, l.callable, l.delegationSelector);
      }
    }
  },
  trigger(j, f, D) {
    if (typeof f != "string" || !j)
      return null;
    const B = ol(), U = ml(f), G = f !== U;
    let R = null, m = !0, e = !0, g = !1;
    G && B && (R = B.Event(f, D), B(j).trigger(R), m = !R.isPropagationStopped(), e = !R.isImmediatePropagationStopped(), g = R.isDefaultPrevented());
    let n = new Event(f, { bubbles: m, cancelable: !0 });
    return n = es(n, D), g && n.preventDefault(), e && j.dispatchEvent(n), n.defaultPrevented && R && R.preventDefault(), n;
  }
};
function es(j, f) {
  for (const [D, B] of Object.entries(f || {}))
    try {
      j[D] = B;
    } catch {
      Object.defineProperty(j, D, {
        configurable: !0,
        get() {
          return B;
        }
      });
    }
  return j;
}
function Us(j) {
  if (j === "true")
    return !0;
  if (j === "false")
    return !1;
  if (j === Number(j).toString())
    return Number(j);
  if (j === "" || j === "null")
    return null;
  if (typeof j != "string")
    return j;
  try {
    return JSON.parse(decodeURIComponent(j));
  } catch {
    return j;
  }
}
function Wi(j) {
  return j.replace(/[A-Z]/g, (f) => `-${f.toLowerCase()}`);
}
const Ia = {
  setDataAttribute(j, f, D) {
    j.setAttribute(`data-bs-${Wi(f)}`, D);
  },
  removeDataAttribute(j, f) {
    j.removeAttribute(`data-bs-${Wi(f)}`);
  },
  getDataAttributes(j) {
    if (!j)
      return {};
    const f = {}, D = Object.keys(j.dataset).filter((B) => B.startsWith("bs") && !B.startsWith("bsConfig"));
    for (const B of D) {
      let U = B.replace(/^bs/, "");
      U = U.charAt(0).toLowerCase() + U.slice(1, U.length), f[U] = Us(j.dataset[B]);
    }
    return f;
  },
  getDataAttribute(j, f) {
    return Us(j.getAttribute(`data-bs-${Wi(f)}`));
  }
};
class ts {
  // Getters
  static get Default() {
    return {};
  }
  static get DefaultType() {
    return {};
  }
  static get NAME() {
    throw new Error('You have to implement the static method "NAME", for each component!');
  }
  _getConfig(f) {
    return f = this._mergeConfigObj(f), f = this._configAfterMerge(f), this._typeCheckConfig(f), f;
  }
  _configAfterMerge(f) {
    return f;
  }
  _mergeConfigObj(f, D) {
    const B = Vn(D) ? Ia.getDataAttribute(D, "config") : {};
    return {
      ...this.constructor.Default,
      ...typeof B == "object" ? B : {},
      ...Vn(D) ? Ia.getDataAttributes(D) : {},
      ...typeof f == "object" ? f : {}
    };
  }
  _typeCheckConfig(f, D = this.constructor.DefaultType) {
    for (const B of Object.keys(D)) {
      const U = D[B], G = f[B], R = Vn(G) ? "element" : Jd(G);
      if (!new RegExp(U).test(R))
        throw new TypeError(
          `${this.constructor.NAME.toUpperCase()}: Option "${B}" provided type "${R}" but expected type "${U}".`
        );
    }
  }
}
const cg = "5.2.3";
class fg extends ts {
  constructor(f, D) {
    super(), f = po(f), f && (this._element = f, this._config = this._getConfig(D), zi.set(this._element, this.constructor.DATA_KEY, this));
  }
  // Public
  dispose() {
    zi.remove(this._element, this.constructor.DATA_KEY), Wt.off(this._element, this.constructor.EVENT_KEY);
    for (const f of Object.getOwnPropertyNames(this))
      this[f] = null;
  }
  _queueCallback(f, D, B = !0) {
    sl(f, D, B);
  }
  _getConfig(f) {
    return f = this._mergeConfigObj(f, this._element), f = this._configAfterMerge(f), this._typeCheckConfig(f), f;
  }
  // Static
  static getInstance(f) {
    return zi.get(po(f), this.DATA_KEY);
  }
  static getOrCreateInstance(f, D = {}) {
    return this.getInstance(f) || new this(f, typeof D == "object" ? D : null);
  }
  static get VERSION() {
    return cg;
  }
  static get DATA_KEY() {
    return `bs.${this.NAME}`;
  }
  static get EVENT_KEY() {
    return `.${this.DATA_KEY}`;
  }
  static eventName(f) {
    return `${f}${this.EVENT_KEY}`;
  }
}
const sa = fg, pr = {
  find(j, f = document.documentElement) {
    return [].concat(...Element.prototype.querySelectorAll.call(f, j));
  },
  findOne(j, f = document.documentElement) {
    return Element.prototype.querySelector.call(f, j);
  },
  children(j, f) {
    return [].concat(...j.children).filter((D) => D.matches(f));
  },
  parents(j, f) {
    const D = [];
    let B = j.parentNode.closest(f);
    for (; B; )
      D.push(B), B = B.parentNode.closest(f);
    return D;
  },
  prev(j, f) {
    let D = j.previousElementSibling;
    for (; D; ) {
      if (D.matches(f))
        return [D];
      D = D.previousElementSibling;
    }
    return [];
  },
  // TODO: this is now unused; remove later along with prev()
  next(j, f) {
    let D = j.nextElementSibling;
    for (; D; ) {
      if (D.matches(f))
        return [D];
      D = D.nextElementSibling;
    }
    return [];
  },
  focusableChildren(j) {
    const f = [
      "a",
      "button",
      "input",
      "textarea",
      "select",
      "details",
      "[tabindex]",
      '[contenteditable="true"]'
    ].map((D) => `${D}:not([tabindex^="-"])`).join(",");
    return this.find(f, j).filter((D) => !oa(D) && al(D));
  }
}, dg = "carousel", gg = "bs.carousel", mg = `.${gg}`, Eg = ".data-api", Mg = `load${mg}${Eg}`, hg = "[data-bs-carousel-splide]", _g = {
  slideFocus: !0,
  i18n: {
    prev: "Slide precedente",
    next: "Slide successiva",
    first: "Vai alla prima slide",
    last: "Vai all’ultima slide",
    slideX: "Vai alla slide %s",
    pageX: "Vai a pagina %s",
    play: "Attiva autoplay",
    pause: "Pausa autoplay"
  }
}, Fs = {
  "it-carousel-landscape-abstract-three-cols": {
    type: "slide",
    perPage: 3,
    gap: 24,
    padding: { left: 0, right: 0 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 0, right: 0 },
        arrows: !1
      },
      992: {
        perPage: 2,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !1
      }
    }
  },
  "it-carousel-landscape-abstract-three-cols-arrow-visible": {
    type: "slide",
    perPage: 3,
    gap: 24,
    padding: { left: 0, right: 0 },
    arrows: !0,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !0
      },
      992: {
        perPage: 2,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !0
      }
    }
  },
  "it-big-img": {
    type: "loop",
    perPage: 1,
    gap: 48,
    padding: { left: 320, right: 320 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 0,
        padding: { left: 0, right: 0 },
        arrows: !1
      },
      992: {
        perPage: 1,
        gap: 24,
        padding: { left: 160, right: 160 },
        arrows: !1
      }
    }
  },
  "it-standard-image": {
    type: "loop",
    perPage: 3,
    gap: 24,
    padding: { left: 48, right: 48 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !1
      },
      992: {
        perPage: 2,
        gap: 24,
        padding: { left: 48, right: 48 },
        arrows: !1
      }
    }
  },
  "it-carousel-landscape-abstract": {
    type: "slide",
    perPage: 1,
    gap: 24,
    padding: { left: 0, right: 0 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 0, right: 0 },
        arrows: !1
      },
      992: {
        perPage: 1,
        gap: 24,
        padding: { left: 24, right: 24 },
        arrows: !1
      }
    }
  },
  "it-calendar-wrapper": {
    type: "slide",
    perPage: 4,
    gap: 0,
    padding: { left: 0, right: 0 },
    arrows: !1,
    breakpoints: {
      560: {
        perPage: 1,
        gap: 0,
        padding: { left: 24, right: 24 },
        arrows: !1
      },
      768: {
        perPage: 2,
        gap: 0,
        padding: { left: 0, right: 0 },
        arrows: !1
      },
      992: {
        perPage: 3,
        gap: 0,
        padding: { left: 0, right: 0 },
        arrows: !1
      }
    }
  }
};
class El extends sa {
  constructor(f) {
    super(f), this._config = this._getConfig(), this._splide = new Jo(this._element, this._config), this._init();
  }
  dispose() {
    this._splide.destroy(), super.dispose();
  }
  // Getters
  static get NAME() {
    return dg;
  }
  // Public
  // Private
  _init() {
    this._splide.mount();
  }
  _getConfig() {
    let f = Object.assign({}, _g);
    return Object.keys(Fs).forEach((D) => {
      this._element.classList.contains(D) && (f = Object.assign({}, f, Fs[D]));
    }), f;
  }
}
Wt.on(window, Mg, () => {
  pr.find(hg).forEach((f) => {
    El.getOrCreateInstance(f);
  });
});
const yg = "inputlabel", vg = "bs.inputlabel", rs = `.${vg}`, pg = `focus${rs}`, Bs = `blur${rs}`, Tg = `change${rs}`, Ki = "active";
class jn {
  constructor(f) {
    this._element = f, this._init();
  }
  // Getters
  static get NAME() {
    return yg;
  }
  // Public
  // Private
  _init() {
    const f = this._getLabel();
    f && !f.classList.contains(Ki) && (this._labelOut(), this._labelOver()), this._bindEvents();
  }
  _bindEvents() {
    ["date", "time"].includes(this._element.getAttribute("type")) || (this._element.getAttribute("type") === "file" ? Wt.on(this._element, Bs, () => {
      this._labelOut();
    }) : (Wt.on(this._element, pg, () => {
      this._labelOut();
    }), Wt.on(this._element, Bs, () => {
      this._labelOver();
    }), Wt.on(this._element, Tg, () => {
      this._labelToggle();
    })));
  }
  _getLabel() {
    return pr.findOne('label[for="' + this._element.getAttribute("id") + '"]');
  }
  _isEmpty() {
    return !this._element.value && !this._element.getAttribute("placeholder");
  }
  _labelOut() {
    const f = this._getLabel();
    f && f.classList.add(Ki);
  }
  _labelOver() {
    if (this._isEmpty()) {
      const f = this._getLabel();
      f && f.classList.remove(Ki);
    }
  }
  _labelToggle() {
    this._isEmpty() ? this._labelOver() : this._labelOut();
  }
}
hr(jn, "getInputFromLabel", (f) => document.querySelector("#" + CSS.escape(f.getAttribute("for"))));
const Lg = "inputnumber", Ig = "bs.inputnumber", Ya = `.${Ig}`, ns = ".data-api", Ag = `click${Ya}`, zs = `change${Ya}`, Sg = `click${Ya}${ns}`, Dg = `mousedown${Ya}${ns}`, Ng = `keyup${Ya}${ns}`, Cg = "input-number-adaptive", jg = "input-number-percentage", Og = "input-number-currency", Pg = "input-number-sub", Ml = ".input-number", Si = 'input[data-bs-input][type="number"]', as = 'button[class^="input-number-"]';
class is extends sa {
  constructor(f) {
    super(f), this._wrapperElement = this._element.closest(Ml), this._label = new jn(f), this._init(), this._bindEvents();
  }
  // Getters
  static get NAME() {
    return Lg;
  }
  // Public
  // Private
  _init() {
    this._wrapperElement && this._inputResize();
  }
  _bindEvents() {
    this._wrapperElement && (pr.find(as, this._wrapperElement).forEach((f) => {
      Wt.on(f, Ag, (D) => {
        D.preventDefault(), this._incrDecr(f.classList.contains(Pg));
      });
    }), Wt.on(this._element, zs, () => this._checkLimit()));
  }
  _inputResize() {
    if (this._wrapperElement.classList.contains(Cg)) {
      let f = null;
      this._wrapperElement.classList.contains(jg) || (f = "calc(44px + " + this._element.value.length + "ch)"), this._wrapperElement.classList.contains(Og) && (f = "calc(40px + 44px + " + this._element.value.length + "ch)"), f && (this._element.style.width = f);
    }
  }
  _incrDecr(f) {
    const D = parseFloat(this._element.value);
    if (!isNaN(D)) {
      let B = parseFloat(this._element.getAttribute("step"));
      B || (B = 1), this._element.value = D + B * (f ? -1 : 1), Wt.trigger(this._element, zs);
    }
  }
  _checkLimit() {
    const f = parseFloat(this._element.value);
    if (!isNaN(f)) {
      let D = f;
      const B = parseFloat(this._element.getAttribute("max")), U = parseFloat(this._element.getAttribute("min"));
      U && f < U && (D = U), B && f > B && (D = B), this._element.value = D;
    }
    this._inputResize();
  }
}
const hl = (j) => j && j.matches(Si) && j.parentNode.querySelector(as) ? is.getOrCreateInstance(j) : null;
Wt.on(document, Dg, Si + ", label", function() {
  const j = jn.getInputFromLabel(this) || this;
  hl(j);
});
Wt.on(document, Ng, Si + ", label", function() {
  const j = jn.getInputFromLabel(this) || this, f = hl(j);
  f && f._label && f._label._labelOut();
});
Wt.on(document, Sg, as, function() {
  const j = this.closest(Ml);
  if (j) {
    const f = pr.findOne(Si, j);
    f && is.getOrCreateInstance(f);
  }
});
const Rg = (j, f = "hide") => {
  const D = `click.dismiss${j.EVENT_KEY}`, B = j.NAME;
  Wt.on(document, D, `[data-bs-dismiss="${B}"]`, function(U) {
    if (["A", "AREA"].includes(this.tagName) && U.preventDefault(), oa(this))
      return;
    const G = La(this) || this.closest(`.${B}`);
    j.getOrCreateInstance(G)[f]();
  });
}, bg = "input", xg = "bs.input", os = `.${xg}`, _l = ".data-api", wg = `mousedown${os}${_l}`, Ug = `keyup${os}${_l}`, Fg = `change${os}`;
class $r extends sa {
  constructor(f) {
    super(f), this._label = new jn(f), this._bindEvents();
  }
  // Getters
  static get NAME() {
    return bg;
  }
  // Public
  // Private
  _bindEvents() {
    this._element.getAttribute("type") === "file" && Wt.on(this._element, Fg, () => {
      this._handleFileDescription();
    });
  }
  _handleFileDescription() {
    const f = [];
    let D = "";
    Array.from(this._element.files).forEach((U) => {
      const G = Math.round(parseInt(U.size, 10) / 1024);
      f.push(U.name + " (" + G + "kb)");
    }), this._element.files.length > 1 && (D = this._element.files.length + " file da caricare: ");
    const B = pr.findOne('label[for="' + this._element.getAttribute("id") + '"] label.form-file-name', this._element);
    B && (B.innerText = D + f.join("; "));
  }
}
const Bg = [
  "select",
  //'input[data-bs-input][type="number"]',
  'input[data-bs-input][type="password"]',
  "input.input-password[data-bs-input]",
  'input[data-bs-autocomplete][type="search"]',
  'input[type="time"]'
], yl = (j) => {
  const f = !!Bg.find((B) => j.matches(B)), D = !!(j.getAttribute("type") === "number" && j.parentNode.querySelector('button[class^="input-number-"]'));
  return !f && !D ? $r.getOrCreateInstance(j) : null;
};
Wt.on(document, wg, "input, textarea, label", function() {
  const j = jn.getInputFromLabel(this) || this;
  yl(j);
});
Wt.on(document, Ug, "input, textarea, label", function() {
  const j = jn.getInputFromLabel(this) || this, f = yl(j);
  f && f._label && f._label._labelOut();
});
var ss = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Di(j) {
  return j && j.__esModule && Object.prototype.hasOwnProperty.call(j, "default") ? j.default : j;
}
function zg(j) {
  if (j.__esModule)
    return j;
  var f = j.default;
  if (typeof f == "function") {
    var D = function B() {
      return this instanceof B ? Reflect.construct(f, arguments, this.constructor) : f.apply(this, arguments);
    };
    D.prototype = f.prototype;
  } else
    D = {};
  return Object.defineProperty(D, "__esModule", { value: !0 }), Object.keys(j).forEach(function(B) {
    var U = Object.getOwnPropertyDescriptor(j, B);
    Object.defineProperty(D, B, U.get ? U : {
      enumerable: !0,
      get: function() {
        return j[B];
      }
    });
  }), D;
}
var vl = { exports: {} };
(function(j, f) {
  (function(B, U) {
    j.exports = U();
  })(window, function() {
    return function(D) {
      var B = {};
      function U(G) {
        if (B[G])
          return B[G].exports;
        var R = B[G] = { i: G, l: !1, exports: {} };
        return D[G].call(R.exports, R, R.exports, U), R.l = !0, R.exports;
      }
      return U.m = D, U.c = B, U.d = function(G, R, m) {
        U.o(G, R) || Object.defineProperty(G, R, { enumerable: !0, get: m });
      }, U.r = function(G) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(G, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(G, "__esModule", { value: !0 });
      }, U.t = function(G, R) {
        if (1 & R && (G = U(G)), 8 & R || 4 & R && typeof G == "object" && G && G.__esModule)
          return G;
        var m = /* @__PURE__ */ Object.create(null);
        if (U.r(m), Object.defineProperty(m, "default", { enumerable: !0, value: G }), 2 & R && typeof G != "string")
          for (var e in G)
            U.d(m, e, (function(g) {
              return G[g];
            }).bind(null, e));
        return m;
      }, U.n = function(G) {
        var R = G && G.__esModule ? function() {
          return G.default;
        } : function() {
          return G;
        };
        return U.d(R, "a", R), R;
      }, U.o = function(G, R) {
        return Object.prototype.hasOwnProperty.call(G, R);
      }, U.p = "/", U(U.s = 37);
    }([function(D, B, U) {
      var G = U(1), R = U(6), m = U(7), e = U(16), g = U(18), n = "prototype", i = function(r, l, d) {
        var t, T, S, h, _ = r & i.F, L = r & i.G, v = r & i.S, c = r & i.P, o = r & i.B, y = L ? G : v ? G[l] || (G[l] = {}) : (G[l] || {})[n], u = L ? R : R[l] || (R[l] = {}), A = u[n] || (u[n] = {});
        for (t in L && (d = l), d)
          S = ((T = !_ && y && y[t] !== void 0) ? y : d)[t], h = o && T ? g(S, G) : c && typeof S == "function" ? g(Function.call, S) : S, y && e(y, t, S, r & i.U), u[t] != S && m(u, t, h), c && A[t] != S && (A[t] = S);
      };
      G.core = R, i.F = 1, i.G = 2, i.S = 4, i.P = 8, i.B = 16, i.W = 32, i.U = 64, i.R = 128, D.exports = i;
    }, function(D, B) {
      var U = D.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
      typeof __g == "number" && (__g = U);
    }, function(D, B) {
      D.exports = function(U) {
        return typeof U == "object" ? U !== null : typeof U == "function";
      };
    }, function(D, B, U) {
      D.exports = !U(4)(function() {
        return Object.defineProperty({}, "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }, function(D, B) {
      D.exports = function(U) {
        try {
          return !!U();
        } catch {
          return !0;
        }
      };
    }, function(D, B, U) {
      U.r(B), U.d(B, "h", function() {
        return g;
      }), U.d(B, "createElement", function() {
        return g;
      }), U.d(B, "cloneElement", function() {
        return r;
      }), U.d(B, "Component", function() {
        return z;
      }), U.d(B, "render", function() {
        return Z;
      }), U.d(B, "rerender", function() {
        return T;
      }), U.d(B, "options", function() {
        return R;
      });
      var G = function() {
      }, R = {}, m = [], e = [];
      function g(K, Y) {
        var ne, ae, fe, Q, oe = e;
        for (Q = arguments.length; 2 < Q--; )
          m.push(arguments[Q]);
        for (Y && Y.children != null && (m.length || m.push(Y.children), delete Y.children); m.length; )
          if ((ae = m.pop()) && ae.pop !== void 0)
            for (Q = ae.length; Q--; )
              m.push(ae[Q]);
          else
            typeof ae == "boolean" && (ae = null), (fe = typeof K != "function") && (ae == null ? ae = "" : typeof ae == "number" ? ae = String(ae) : typeof ae != "string" && (fe = !1)), fe && ne ? oe[oe.length - 1] += ae : oe === e ? oe = [ae] : oe.push(ae), ne = fe;
        var de = new G();
        return de.nodeName = K, de.children = oe, de.attributes = Y ?? void 0, de.key = Y == null ? void 0 : Y.key, R.vnode !== void 0 && R.vnode(de), de;
      }
      function n(K, Y) {
        for (var ne in Y)
          K[ne] = Y[ne];
        return K;
      }
      var i = typeof Promise == "function" ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;
      function r(K, Y) {
        return g(K.nodeName, n(n({}, K.attributes), Y), 2 < arguments.length ? [].slice.call(arguments, 2) : K.children);
      }
      var l = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, d = [];
      function t(K) {
        !K._dirty && (K._dirty = !0) && d.push(K) == 1 && (R.debounceRendering || i)(T);
      }
      function T() {
        var K, Y = d;
        for (d = []; K = Y.pop(); )
          K._dirty && J(K);
      }
      function S(K, Y) {
        return K.normalizedNodeName === Y || K.nodeName.toLowerCase() === Y.toLowerCase();
      }
      function h(K) {
        var Y = n({}, K.attributes);
        Y.children = K.children;
        var ne = K.nodeName.defaultProps;
        if (ne !== void 0)
          for (var ae in ne)
            Y[ae] === void 0 && (Y[ae] = ne[ae]);
        return Y;
      }
      function _(K) {
        var Y = K.parentNode;
        Y && Y.removeChild(K);
      }
      function L(K, Y, ne, ae, fe) {
        if (Y === "className" && (Y = "class"), Y !== "key")
          if (Y === "ref")
            ne && ne(null), ae && ae(K);
          else if (Y !== "class" || fe)
            if (Y === "style") {
              if (ae && typeof ae != "string" && typeof ne != "string" || (K.style.cssText = ae || ""), ae && typeof ae == "object") {
                if (typeof ne != "string")
                  for (var Q in ne)
                    Q in ae || (K.style[Q] = "");
                for (var Q in ae)
                  K.style[Q] = typeof ae[Q] == "number" && l.test(Q) === !1 ? ae[Q] + "px" : ae[Q];
              }
            } else if (Y === "dangerouslySetInnerHTML")
              ae && (K.innerHTML = ae.__html || "");
            else if (Y[0] == "o" && Y[1] == "n") {
              var oe = Y !== (Y = Y.replace(/Capture$/, ""));
              Y = Y.toLowerCase().substring(2), ae ? ne || K.addEventListener(Y, v, oe) : K.removeEventListener(Y, v, oe), (K._listeners || (K._listeners = {}))[Y] = ae;
            } else if (Y !== "list" && Y !== "type" && !fe && Y in K) {
              try {
                K[Y] = ae ?? "";
              } catch {
              }
              ae != null && ae !== !1 || Y == "spellcheck" || K.removeAttribute(Y);
            } else {
              var de = fe && Y !== (Y = Y.replace(/^xlink:?/, ""));
              ae == null || ae === !1 ? de ? K.removeAttributeNS("http://www.w3.org/1999/xlink", Y.toLowerCase()) : K.removeAttribute(Y) : typeof ae != "function" && (de ? K.setAttributeNS("http://www.w3.org/1999/xlink", Y.toLowerCase(), ae) : K.setAttribute(Y, ae));
            }
          else
            K.className = ae || "";
      }
      function v(K) {
        return this._listeners[K.type](R.event && R.event(K) || K);
      }
      var c = [], o = 0, y = !1, u = !1;
      function A() {
        for (var K; K = c.pop(); )
          R.afterMount && R.afterMount(K), K.componentDidMount && K.componentDidMount();
      }
      function I(K, Y, ne, ae, fe, Q) {
        o++ || (y = fe != null && fe.ownerSVGElement !== void 0, u = K != null && !("__preactattr_" in K));
        var oe = M(K, Y, ne, ae, Q);
        return fe && oe.parentNode !== fe && fe.appendChild(oe), --o || (u = !1, Q || A()), oe;
      }
      function M(K, Y, ne, ae, fe) {
        var Q = K, oe = y;
        if (Y != null && typeof Y != "boolean" || (Y = ""), typeof Y == "string" || typeof Y == "number")
          return K && K.splitText !== void 0 && K.parentNode && (!K._component || fe) ? K.nodeValue != Y && (K.nodeValue = Y) : (Q = document.createTextNode(Y), K && (K.parentNode && K.parentNode.replaceChild(Q, K), E(K, !0))), Q.__preactattr_ = !0, Q;
        var de = Y.nodeName;
        if (typeof de == "function")
          return function(te, O, p, P) {
            for (var k = te && te._component, X = k, F = te, x = k && te._componentConstructor === O.nodeName, W = x, $ = h(O); k && !W && (k = k._parentComponent); )
              W = k.constructor === O.nodeName;
            return k && W && (!P || k._component) ? (V(k, $, 3, p, P), te = k.base) : (X && !x && (H(X), te = F = null), k = b(O.nodeName, $, p), te && !k.nextBase && (k.nextBase = te, F = null), V(k, $, 1, p, P), te = k.base, F && te !== F && (F._component = null, E(F, !1))), te;
          }(K, Y, ne, ae);
        if (y = de === "svg" || de !== "foreignObject" && y, de = String(de), (!K || !S(K, de)) && (Q = function(te, O) {
          var p = O ? document.createElementNS("http://www.w3.org/2000/svg", te) : document.createElement(te);
          return p.normalizedNodeName = te, p;
        }(de, y), K)) {
          for (; K.firstChild; )
            Q.appendChild(K.firstChild);
          K.parentNode && K.parentNode.replaceChild(Q, K), E(K, !0);
        }
        var Me = Q.firstChild, ge = Q.__preactattr_, se = Y.children;
        if (ge == null) {
          ge = Q.__preactattr_ = {};
          for (var ee = Q.attributes, re = ee.length; re--; )
            ge[ee[re].name] = ee[re].value;
        }
        return !u && se && se.length === 1 && typeof se[0] == "string" && Me != null && Me.splitText !== void 0 && Me.nextSibling == null ? Me.nodeValue != se[0] && (Me.nodeValue = se[0]) : (se && se.length || Me != null) && function(te, O, p, P, k) {
          var X, F, x, W, $, ce = te.childNodes, le = [], q = {}, _e = 0, Ee = 0, Te = ce.length, Ce = 0, xe = O ? O.length : 0;
          if (Te !== 0)
            for (var be = 0; be < Te; be++) {
              var Ge = ce[be], Pe = Ge.__preactattr_, Le = xe && Pe ? Ge._component ? Ge._component.__key : Pe.key : null;
              Le != null ? (_e++, q[Le] = Ge) : (Pe || (Ge.splitText !== void 0 ? !k || Ge.nodeValue.trim() : k)) && (le[Ce++] = Ge);
            }
          if (xe !== 0)
            for (var be = 0; be < xe; be++) {
              W = O[be], $ = null;
              var Le = W.key;
              if (Le != null)
                _e && q[Le] !== void 0 && ($ = q[Le], q[Le] = void 0, _e--);
              else if (Ee < Ce) {
                for (X = Ee; X < Ce; X++)
                  if (le[X] !== void 0 && (je = F = le[X], nt = k, typeof (Ze = W) == "string" || typeof Ze == "number" ? je.splitText !== void 0 : typeof Ze.nodeName == "string" ? !je._componentConstructor && S(je, Ze.nodeName) : nt || je._componentConstructor === Ze.nodeName)) {
                    $ = F, le[X] = void 0, X === Ce - 1 && Ce--, X === Ee && Ee++;
                    break;
                  }
              }
              $ = M($, W, p, P), x = ce[be], $ && $ !== te && $ !== x && (x == null ? te.appendChild($) : $ === x.nextSibling ? _(x) : te.insertBefore($, x));
            }
          var je, Ze, nt;
          if (_e)
            for (var be in q)
              q[be] !== void 0 && E(q[be], !1);
          for (; Ee <= Ce; )
            ($ = le[Ce--]) !== void 0 && E($, !1);
        }(Q, se, ne, ae, u || ge.dangerouslySetInnerHTML != null), function(te, O, p) {
          var P;
          for (P in p)
            O && O[P] != null || p[P] == null || L(te, P, p[P], p[P] = void 0, y);
          for (P in O)
            P === "children" || P === "innerHTML" || P in p && O[P] === (P === "value" || P === "checked" ? te[P] : p[P]) || L(te, P, p[P], p[P] = O[P], y);
        }(Q, Y.attributes, ge), y = oe, Q;
      }
      function E(K, Y) {
        var ne = K._component;
        ne ? H(ne) : (K.__preactattr_ != null && K.__preactattr_.ref && K.__preactattr_.ref(null), Y !== !1 && K.__preactattr_ != null || _(K), N(K));
      }
      function N(K) {
        for (K = K.lastChild; K; ) {
          var Y = K.previousSibling;
          E(K, !0), K = Y;
        }
      }
      var C = [];
      function b(K, Y, ne) {
        var ae, fe = C.length;
        for (K.prototype && K.prototype.render ? (ae = new K(Y, ne), z.call(ae, Y, ne)) : ((ae = new z(Y, ne)).constructor = K, ae.render = w); fe--; )
          if (C[fe].constructor === K)
            return ae.nextBase = C[fe].nextBase, C.splice(fe, 1), ae;
        return ae;
      }
      function w(K, Y, ne) {
        return this.constructor(K, ne);
      }
      function V(K, Y, ne, ae, fe) {
        K._disable || (K._disable = !0, K.__ref = Y.ref, K.__key = Y.key, delete Y.ref, delete Y.key, typeof K.constructor.getDerivedStateFromProps > "u" && (!K.base || fe ? K.componentWillMount && K.componentWillMount() : K.componentWillReceiveProps && K.componentWillReceiveProps(Y, ae)), ae && ae !== K.context && (K.prevContext || (K.prevContext = K.context), K.context = ae), K.prevProps || (K.prevProps = K.props), K.props = Y, K._disable = !1, ne !== 0 && (ne !== 1 && R.syncComponentUpdates === !1 && K.base ? t(K) : J(K, 1, fe)), K.__ref && K.__ref(K));
      }
      function J(K, Y, ne, ae) {
        if (!K._disable) {
          var fe, Q, oe, de = K.props, Me = K.state, ge = K.context, se = K.prevProps || de, ee = K.prevState || Me, re = K.prevContext || ge, ue = K.base, te = K.nextBase, O = ue || te, p = K._component, P = !1, k = re;
          if (K.constructor.getDerivedStateFromProps && (Me = n(n({}, Me), K.constructor.getDerivedStateFromProps(de, Me)), K.state = Me), ue && (K.props = se, K.state = ee, K.context = re, Y !== 2 && K.shouldComponentUpdate && K.shouldComponentUpdate(de, Me, ge) === !1 ? P = !0 : K.componentWillUpdate && K.componentWillUpdate(de, Me, ge), K.props = de, K.state = Me, K.context = ge), K.prevProps = K.prevState = K.prevContext = K.nextBase = null, K._dirty = !1, !P) {
            fe = K.render(de, Me, ge), K.getChildContext && (ge = n(n({}, ge), K.getChildContext())), ue && K.getSnapshotBeforeUpdate && (k = K.getSnapshotBeforeUpdate(se, ee));
            var X, F, x = fe && fe.nodeName;
            if (typeof x == "function") {
              var W = h(fe);
              (Q = p) && Q.constructor === x && W.key == Q.__key ? V(Q, W, 1, ge, !1) : (X = Q, K._component = Q = b(x, W, ge), Q.nextBase = Q.nextBase || te, Q._parentComponent = K, V(Q, W, 0, ge, !1), J(Q, 1, ne, !0)), F = Q.base;
            } else
              oe = O, (X = p) && (oe = K._component = null), (O || Y === 1) && (oe && (oe._component = null), F = function(_e, Ee, Te, Ce, xe, be) {
                o++ || (y = xe != null && xe.ownerSVGElement !== void 0, u = _e != null && !("__preactattr_" in _e));
                var Ge = M(_e, Ee, Te, Ce, be);
                return xe && Ge.parentNode !== xe && xe.appendChild(Ge), --o || (u = !1, be || A()), Ge;
              }(oe, fe, ge, ne || !ue, O && O.parentNode, !0));
            if (O && F !== O && Q !== p) {
              var $ = O.parentNode;
              $ && F !== $ && ($.replaceChild(F, O), X || (O._component = null, E(O, !1)));
            }
            if (X && H(X), (K.base = F) && !ae) {
              for (var ce = K, le = K; le = le._parentComponent; )
                (ce = le).base = F;
              F._component = ce, F._componentConstructor = ce.constructor;
            }
          }
          for (!ue || ne ? c.unshift(K) : P || (K.componentDidUpdate && K.componentDidUpdate(se, ee, k), R.afterUpdate && R.afterUpdate(K)); K._renderCallbacks.length; )
            K._renderCallbacks.pop().call(K);
          o || ae || A();
        }
      }
      function H(K) {
        R.beforeUnmount && R.beforeUnmount(K);
        var Y = K.base;
        K._disable = !0, K.componentWillUnmount && K.componentWillUnmount(), K.base = null;
        var ne = K._component;
        ne ? H(ne) : Y && (Y.__preactattr_ && Y.__preactattr_.ref && Y.__preactattr_.ref(null), _(K.nextBase = Y), C.push(K), N(Y)), K.__ref && K.__ref(null);
      }
      function z(K, Y) {
        this._dirty = !0, this.context = Y, this.props = K, this.state = this.state || {}, this._renderCallbacks = [];
      }
      function Z(K, Y, ne) {
        return I(ne, K, {}, !1, Y, !1);
      }
      n(z.prototype, { setState: function(K, Y) {
        this.prevState || (this.prevState = this.state), this.state = n(n({}, this.state), typeof K == "function" ? K(this.state, this.props) : K), Y && this._renderCallbacks.push(Y), t(this);
      }, forceUpdate: function(K) {
        K && this._renderCallbacks.push(K), J(this, 2);
      }, render: function() {
      } });
      var ie = { h: g, createElement: g, cloneElement: r, Component: z, render: Z, rerender: T, options: R };
      B.default = ie;
    }, function(D, B) {
      var U = D.exports = { version: "2.5.7" };
      typeof __e == "number" && (__e = U);
    }, function(D, B, U) {
      var G = U(8), R = U(40);
      D.exports = U(3) ? function(m, e, g) {
        return G.f(m, e, R(1, g));
      } : function(m, e, g) {
        return m[e] = g, m;
      };
    }, function(D, B, U) {
      var G = U(9), R = U(38), m = U(39), e = Object.defineProperty;
      B.f = U(3) ? Object.defineProperty : function(g, n, i) {
        if (G(g), n = m(n, !0), G(i), R)
          try {
            return e(g, n, i);
          } catch {
          }
        if ("get" in i || "set" in i)
          throw TypeError("Accessors not supported!");
        return "value" in i && (g[n] = i.value), g;
      };
    }, function(D, B, U) {
      var G = U(2);
      D.exports = function(R) {
        if (!G(R))
          throw TypeError(R + " is not an object!");
        return R;
      };
    }, function(D, B) {
      var U = 0, G = Math.random();
      D.exports = function(R) {
        return "Symbol(".concat(R === void 0 ? "" : R, ")_", (++U + G).toString(36));
      };
    }, function(D, B, U) {
      var G = U(22);
      D.exports = Object("z").propertyIsEnumerable(0) ? Object : function(R) {
        return G(R) == "String" ? R.split("") : Object(R);
      };
    }, function(D, B) {
      D.exports = function(U) {
        if (U == null)
          throw TypeError("Can't call method on  " + U);
        return U;
      };
    }, function(D, B, U) {
      var G = U(4);
      D.exports = function(R, m) {
        return !!R && G(function() {
          m ? R.call(null, function() {
          }, 1) : R.call(null);
        });
      };
    }, function(D, B, U) {
      var G = U(0);
      G(G.S + G.F, "Object", { assign: U(41) });
    }, function(D, B, U) {
      var G = U(2), R = U(1).document, m = G(R) && G(R.createElement);
      D.exports = function(e) {
        return m ? R.createElement(e) : {};
      };
    }, function(D, B, U) {
      var G = U(1), R = U(7), m = U(17), e = U(10)("src"), g = "toString", n = Function[g], i = ("" + n).split(g);
      U(6).inspectSource = function(r) {
        return n.call(r);
      }, (D.exports = function(r, l, d, t) {
        var T = typeof d == "function";
        T && (m(d, "name") || R(d, "name", l)), r[l] !== d && (T && (m(d, e) || R(d, e, r[l] ? "" + r[l] : i.join(String(l)))), r === G ? r[l] = d : t ? r[l] ? r[l] = d : R(r, l, d) : (delete r[l], R(r, l, d)));
      })(Function.prototype, g, function() {
        return typeof this == "function" && this[e] || n.call(this);
      });
    }, function(D, B) {
      var U = {}.hasOwnProperty;
      D.exports = function(G, R) {
        return U.call(G, R);
      };
    }, function(D, B, U) {
      var G = U(19);
      D.exports = function(R, m, e) {
        if (G(R), m === void 0)
          return R;
        switch (e) {
          case 1:
            return function(g) {
              return R.call(m, g);
            };
          case 2:
            return function(g, n) {
              return R.call(m, g, n);
            };
          case 3:
            return function(g, n, i) {
              return R.call(m, g, n, i);
            };
        }
        return function() {
          return R.apply(m, arguments);
        };
      };
    }, function(D, B) {
      D.exports = function(U) {
        if (typeof U != "function")
          throw TypeError(U + " is not a function!");
        return U;
      };
    }, function(D, B, U) {
      var G = U(42), R = U(28);
      D.exports = Object.keys || function(m) {
        return G(m, R);
      };
    }, function(D, B, U) {
      var G = U(11), R = U(12);
      D.exports = function(m) {
        return G(R(m));
      };
    }, function(D, B) {
      var U = {}.toString;
      D.exports = function(G) {
        return U.call(G).slice(8, -1);
      };
    }, function(D, B, U) {
      var G = U(21), R = U(24), m = U(43);
      D.exports = function(e) {
        return function(g, n, i) {
          var r, l = G(g), d = R(l.length), t = m(i, d);
          if (e && n != n) {
            for (; t < d; )
              if ((r = l[t++]) != r)
                return !0;
          } else
            for (; t < d; t++)
              if ((e || t in l) && l[t] === n)
                return e || t || 0;
          return !e && -1;
        };
      };
    }, function(D, B, U) {
      var G = U(25), R = Math.min;
      D.exports = function(m) {
        return 0 < m ? R(G(m), 9007199254740991) : 0;
      };
    }, function(D, B) {
      var U = Math.ceil, G = Math.floor;
      D.exports = function(R) {
        return isNaN(R = +R) ? 0 : (0 < R ? G : U)(R);
      };
    }, function(D, B, U) {
      var G = U(27)("keys"), R = U(10);
      D.exports = function(m) {
        return G[m] || (G[m] = R(m));
      };
    }, function(D, B, U) {
      var G = U(6), R = U(1), m = "__core-js_shared__", e = R[m] || (R[m] = {});
      (D.exports = function(g, n) {
        return e[g] || (e[g] = n !== void 0 ? n : {});
      })("versions", []).push({ version: G.version, mode: U(44) ? "pure" : "global", copyright: "© 2018 Denis Pushkarev (zloirock.ru)" });
    }, function(D, B) {
      D.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, function(D, B, U) {
      var G = U(12);
      D.exports = function(R) {
        return Object(G(R));
      };
    }, function(D, B, U) {
      var G = U(8).f, R = Function.prototype, m = /^\s*function ([^ (]*)/;
      "name" in R || U(3) && G(R, "name", { configurable: !0, get: function() {
        try {
          return ("" + this).match(m)[1];
        } catch {
          return "";
        }
      } });
    }, function(D, B, U) {
      var G = U(0), R = U(32)(1);
      G(G.P + G.F * !U(13)([].map, !0), "Array", { map: function(m) {
        return R(this, m, arguments[1]);
      } });
    }, function(D, B, U) {
      var G = U(18), R = U(11), m = U(29), e = U(24), g = U(47);
      D.exports = function(n, i) {
        var r = n == 1, l = n == 2, d = n == 3, t = n == 4, T = n == 6, S = n == 5 || T, h = i || g;
        return function(_, L, v) {
          for (var c, o, y = m(_), u = R(y), A = G(L, v, 3), I = e(u.length), M = 0, E = r ? h(_, I) : l ? h(_, 0) : void 0; M < I; M++)
            if ((S || M in u) && (o = A(c = u[M], M, y), n)) {
              if (r)
                E[M] = o;
              else if (o)
                switch (n) {
                  case 3:
                    return !0;
                  case 5:
                    return c;
                  case 6:
                    return M;
                  case 2:
                    E.push(c);
                }
              else if (t)
                return !1;
            }
          return T ? -1 : d || t ? t : E;
        };
      };
    }, function(D, B, U) {
      var G = U(22);
      D.exports = Array.isArray || function(R) {
        return G(R) == "Array";
      };
    }, function(D, B, U) {
      var G = U(27)("wks"), R = U(10), m = U(1).Symbol, e = typeof m == "function";
      (D.exports = function(g) {
        return G[g] || (G[g] = e && m[g] || (e ? m : R)("Symbol." + g));
      }).store = G;
    }, function(D, B, U) {
      var G = U(0), R = U(23)(!1), m = [].indexOf, e = !!m && 1 / [1].indexOf(1, -0) < 0;
      G(G.P + G.F * (e || !U(13)(m)), "Array", { indexOf: function(g) {
        return e ? m.apply(this, arguments) || 0 : R(this, g, arguments[1]);
      } });
    }, function(D, B, U) {
      var G = U(0);
      G(G.S, "Object", { create: U(52) });
    }, function(D, B, U) {
      B.__esModule = !0, B.default = void 0, U(14), U(30), U(31), U(35), U(49), U(50);
      var G = U(5), R = function(i) {
        return i && i.__esModule ? i : { default: i };
      }(U(51));
      function m(n) {
        if (!n.element)
          throw new Error("element is not defined");
        if (!n.id)
          throw new Error("id is not defined");
        if (!n.source)
          throw new Error("source is not defined");
        Array.isArray(n.source) && (n.source = e(n.source)), (0, G.render)((0, G.createElement)(R.default, n), n.element);
      }
      var e = function(i) {
        return function(r, l) {
          l(i.filter(function(d) {
            return d.toLowerCase().indexOf(r.toLowerCase()) !== -1;
          }));
        };
      };
      m.enhanceSelectElement = function(n) {
        if (!n.selectElement)
          throw new Error("selectElement is not defined");
        if (!n.source) {
          var i = [].filter.call(n.selectElement.options, function(d) {
            return d.value || n.preserveNullOptions;
          });
          n.source = i.map(function(d) {
            return d.textContent || d.innerText;
          });
        }
        if (n.onConfirm = n.onConfirm || function(d) {
          var t = [].filter.call(n.selectElement.options, function(T) {
            return (T.textContent || T.innerText) === d;
          })[0];
          t && (t.selected = !0);
        }, n.selectElement.value || n.defaultValue === void 0) {
          var r = n.selectElement.options[n.selectElement.options.selectedIndex];
          n.defaultValue = r.textContent || r.innerText;
        }
        n.name === void 0 && (n.name = ""), n.id === void 0 && (n.selectElement.id === void 0 ? n.id = "" : n.id = n.selectElement.id), n.autoselect === void 0 && (n.autoselect = !0);
        var l = document.createElement("div");
        n.selectElement.parentNode.insertBefore(l, n.selectElement), m(Object.assign({}, n, { element: l })), n.selectElement.style.display = "none", n.selectElement.id = n.selectElement.id + "-select";
      };
      var g = m;
      B.default = g;
    }, function(D, B, U) {
      D.exports = !U(3) && !U(4)(function() {
        return Object.defineProperty(U(15)("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }, function(D, B, U) {
      var G = U(2);
      D.exports = function(R, m) {
        if (!G(R))
          return R;
        var e, g;
        if (m && typeof (e = R.toString) == "function" && !G(g = e.call(R)) || typeof (e = R.valueOf) == "function" && !G(g = e.call(R)) || !m && typeof (e = R.toString) == "function" && !G(g = e.call(R)))
          return g;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function(D, B) {
      D.exports = function(U, G) {
        return { enumerable: !(1 & U), configurable: !(2 & U), writable: !(4 & U), value: G };
      };
    }, function(D, B, U) {
      var G = U(20), R = U(45), m = U(46), e = U(29), g = U(11), n = Object.assign;
      D.exports = !n || U(4)(function() {
        var i = {}, r = {}, l = Symbol(), d = "abcdefghijklmnopqrst";
        return i[l] = 7, d.split("").forEach(function(t) {
          r[t] = t;
        }), n({}, i)[l] != 7 || Object.keys(n({}, r)).join("") != d;
      }) ? function(i, r) {
        for (var l = e(i), d = arguments.length, t = 1, T = R.f, S = m.f; t < d; )
          for (var h, _ = g(arguments[t++]), L = T ? G(_).concat(T(_)) : G(_), v = L.length, c = 0; c < v; )
            S.call(_, h = L[c++]) && (l[h] = _[h]);
        return l;
      } : n;
    }, function(D, B, U) {
      var G = U(17), R = U(21), m = U(23)(!1), e = U(26)("IE_PROTO");
      D.exports = function(g, n) {
        var i, r = R(g), l = 0, d = [];
        for (i in r)
          i != e && G(r, i) && d.push(i);
        for (; n.length > l; )
          G(r, i = n[l++]) && (~m(d, i) || d.push(i));
        return d;
      };
    }, function(D, B, U) {
      var G = U(25), R = Math.max, m = Math.min;
      D.exports = function(e, g) {
        return (e = G(e)) < 0 ? R(e + g, 0) : m(e, g);
      };
    }, function(D, B) {
      D.exports = !1;
    }, function(D, B) {
      B.f = Object.getOwnPropertySymbols;
    }, function(D, B) {
      B.f = {}.propertyIsEnumerable;
    }, function(D, B, U) {
      var G = U(48);
      D.exports = function(R, m) {
        return new (G(R))(m);
      };
    }, function(D, B, U) {
      var G = U(2), R = U(33), m = U(34)("species");
      D.exports = function(e) {
        var g;
        return R(e) && (typeof (g = e.constructor) != "function" || g !== Array && !R(g.prototype) || (g = void 0), G(g) && (g = g[m]) === null && (g = void 0)), g === void 0 ? Array : g;
      };
    }, function(D, B, U) {
      var G = U(0), R = U(32)(2);
      G(G.P + G.F * !U(13)([].filter, !0), "Array", { filter: function(m) {
        return R(this, m, arguments[1]);
      } });
    }, function(D, B, U) {
      var G = U(0);
      G(G.S, "Array", { isArray: U(33) });
    }, function(D, B, U) {
      B.__esModule = !0, B.default = void 0, U(14), U(36), U(30), U(31), U(35), U(55), U(58);
      var G = U(5), R = e(U(60)), m = e(U(61));
      function e(d) {
        return d && d.__esModule ? d : { default: d };
      }
      function g() {
        return (g = Object.assign || function(d) {
          for (var t = 1; t < arguments.length; t++) {
            var T = arguments[t];
            for (var S in T)
              Object.prototype.hasOwnProperty.call(T, S) && (d[S] = T[S]);
          }
          return d;
        }).apply(this, arguments);
      }
      function n(d) {
        if (d === void 0)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return d;
      }
      var i = { 13: "enter", 27: "escape", 32: "space", 38: "up", 40: "down" };
      function r() {
        return typeof navigator < "u" && !(!navigator.userAgent.match(/(iPod|iPhone|iPad)/g) || !navigator.userAgent.match(/AppleWebKit/g));
      }
      var l = function(d) {
        function t(S) {
          var h;
          return (h = d.call(this, S) || this).elementReferences = {}, h.state = { focused: null, hovered: null, menuOpen: !1, options: S.defaultValue ? [S.defaultValue] : [], query: S.defaultValue, validChoiceMade: !1, selected: null, ariaHint: !0 }, h.handleComponentBlur = h.handleComponentBlur.bind(n(n(h))), h.handleKeyDown = h.handleKeyDown.bind(n(n(h))), h.handleUpArrow = h.handleUpArrow.bind(n(n(h))), h.handleDownArrow = h.handleDownArrow.bind(n(n(h))), h.handleEnter = h.handleEnter.bind(n(n(h))), h.handlePrintableKey = h.handlePrintableKey.bind(n(n(h))), h.handleListMouseLeave = h.handleListMouseLeave.bind(n(n(h))), h.handleOptionBlur = h.handleOptionBlur.bind(n(n(h))), h.handleOptionClick = h.handleOptionClick.bind(n(n(h))), h.handleOptionFocus = h.handleOptionFocus.bind(n(n(h))), h.handleOptionMouseDown = h.handleOptionMouseDown.bind(n(n(h))), h.handleOptionMouseEnter = h.handleOptionMouseEnter.bind(n(n(h))), h.handleInputBlur = h.handleInputBlur.bind(n(n(h))), h.handleInputChange = h.handleInputChange.bind(n(n(h))), h.handleInputFocus = h.handleInputFocus.bind(n(n(h))), h.pollInputElement = h.pollInputElement.bind(n(n(h))), h.getDirectInputChanges = h.getDirectInputChanges.bind(n(n(h))), h;
        }
        (function(h, _) {
          h.prototype = Object.create(_.prototype), (h.prototype.constructor = h).__proto__ = _;
        })(t, d);
        var T = t.prototype;
        return T.isQueryAnOption = function(S, h) {
          var _ = this;
          return h.map(function(L) {
            return _.templateInputValue(L).toLowerCase();
          }).indexOf(S.toLowerCase()) !== -1;
        }, T.componentDidMount = function() {
          this.pollInputElement();
        }, T.componentWillUnmount = function() {
          clearTimeout(this.$pollInput);
        }, T.pollInputElement = function() {
          var S = this;
          this.getDirectInputChanges(), this.$pollInput = setTimeout(function() {
            S.pollInputElement();
          }, 100);
        }, T.getDirectInputChanges = function() {
          var S = this.elementReferences[-1];
          S && S.value !== this.state.query && this.handleInputChange({ target: { value: S.value } });
        }, T.componentDidUpdate = function(S, h) {
          var _ = this.state.focused, L = _ === null, v = h.focused !== _;
          v && !L && this.elementReferences[_].focus();
          var c = _ === -1, o = v && h.focused === null;
          if (c && o) {
            var y = this.elementReferences[_];
            y.setSelectionRange(0, y.value.length);
          }
        }, T.hasAutoselect = function() {
          return !r() && this.props.autoselect;
        }, T.templateInputValue = function(S) {
          var h = this.props.templates && this.props.templates.inputValue;
          return h ? h(S) : S;
        }, T.templateSuggestion = function(S) {
          var h = this.props.templates && this.props.templates.suggestion;
          return h ? h(S) : S;
        }, T.handleComponentBlur = function(S) {
          var h, _ = this.state, L = _.options, v = _.query, c = _.selected;
          this.props.confirmOnBlur ? (h = S.query || v, this.props.onConfirm(L[c])) : h = v, this.setState({ focused: null, menuOpen: S.menuOpen || !1, query: h, selected: null, validChoiceMade: this.isQueryAnOption(h, L) });
        }, T.handleListMouseLeave = function(S) {
          this.setState({ hovered: null });
        }, T.handleOptionBlur = function(S, h) {
          var _ = this.state, L = _.focused, v = _.menuOpen, c = _.options, o = _.selected, y = S.relatedTarget === null, u = S.relatedTarget === this.elementReferences[-1], A = L !== h && L !== -1;
          if (!A && y || !(A || u)) {
            var I = v && r();
            this.handleComponentBlur({ menuOpen: I, query: this.templateInputValue(c[o]) });
          }
        }, T.handleInputBlur = function(S) {
          var h = this.state, _ = h.focused, L = h.menuOpen, v = h.options, c = h.query, o = h.selected;
          if (_ === -1) {
            var y = L && r(), u = r() ? c : this.templateInputValue(v[o]);
            this.handleComponentBlur({ menuOpen: y, query: u });
          }
        }, T.handleInputChange = function(S) {
          var h = this, _ = this.props, L = _.minLength, v = _.source, c = _.showAllValues, o = this.hasAutoselect(), y = S.target.value, u = y.length === 0, A = this.state.query.length !== y.length, I = y.length >= L;
          this.setState({ query: y, ariaHint: u }), c || !u && A && I ? v(y, function(M) {
            var E = 0 < M.length;
            h.setState({ menuOpen: E, options: M, selected: o && E ? 0 : -1, validChoiceMade: !1 });
          }) : !u && I || this.setState({ menuOpen: !1, options: [] });
        }, T.handleInputClick = function(S) {
          this.handleInputChange(S);
        }, T.handleInputFocus = function(S) {
          var h = this.state, _ = h.query, L = h.validChoiceMade, v = h.options, c = this.props.minLength, o = !L && _.length >= c && 0 < v.length;
          o ? this.setState(function(y) {
            var u = y.menuOpen;
            return { focused: -1, menuOpen: o || u, selected: -1 };
          }) : this.setState({ focused: -1 });
        }, T.handleOptionFocus = function(S) {
          this.setState({ focused: S, hovered: null, selected: S });
        }, T.handleOptionMouseEnter = function(S, h) {
          r() || this.setState({ hovered: h });
        }, T.handleOptionClick = function(S, h) {
          var _ = this.state.options[h], L = this.templateInputValue(_);
          this.props.onConfirm(_), this.setState({ focused: -1, hovered: null, menuOpen: !1, query: L, selected: -1, validChoiceMade: !0 }), this.forceUpdate();
        }, T.handleOptionMouseDown = function(S) {
          S.preventDefault();
        }, T.handleUpArrow = function(S) {
          S.preventDefault();
          var h = this.state, _ = h.menuOpen, L = h.selected;
          L !== -1 && _ && this.handleOptionFocus(L - 1);
        }, T.handleDownArrow = function(S) {
          var h = this;
          if (S.preventDefault(), this.props.showAllValues && this.state.menuOpen === !1)
            S.preventDefault(), this.props.source("", function(o) {
              h.setState({ menuOpen: !0, options: o, selected: 0, focused: 0, hovered: null });
            });
          else if (this.state.menuOpen === !0) {
            var _ = this.state, L = _.menuOpen, v = _.options, c = _.selected;
            c !== v.length - 1 && L && this.handleOptionFocus(c + 1);
          }
        }, T.handleSpace = function(S) {
          var h = this;
          this.props.showAllValues && this.state.menuOpen === !1 && this.state.query === "" && (S.preventDefault(), this.props.source("", function(_) {
            h.setState({ menuOpen: !0, options: _ });
          })), this.state.focused !== -1 && (S.preventDefault(), this.handleOptionClick(S, this.state.focused));
        }, T.handleEnter = function(S) {
          this.state.menuOpen && (S.preventDefault(), 0 <= this.state.selected && this.handleOptionClick(S, this.state.selected));
        }, T.handlePrintableKey = function(S) {
          var h = this.elementReferences[-1];
          S.target === h || h.focus();
        }, T.handleKeyDown = function(S) {
          switch (i[S.keyCode]) {
            case "up":
              this.handleUpArrow(S);
              break;
            case "down":
              this.handleDownArrow(S);
              break;
            case "space":
              this.handleSpace(S);
              break;
            case "enter":
              this.handleEnter(S);
              break;
            case "escape":
              this.handleComponentBlur({ query: this.state.query });
              break;
            default:
              (function(_) {
                return 47 < _ && _ < 58 || _ === 32 || _ === 8 || 64 < _ && _ < 91 || 95 < _ && _ < 112 || 185 < _ && _ < 193 || 218 < _ && _ < 223;
              })(S.keyCode) && this.handlePrintableKey(S);
          }
        }, T.render = function() {
          var S, h = this, _ = this.props, L = _.cssNamespace, v = _.displayMenu, c = _.id, o = _.minLength, y = _.name, u = _.placeholder, A = _.required, I = _.showAllValues, M = _.tNoResults, E = _.tStatusQueryTooShort, N = _.tStatusNoResults, C = _.tStatusSelectedOption, b = _.tStatusResults, w = _.tAssistiveHint, V = _.dropdownArrow, J = this.state, H = J.focused, z = J.hovered, Z = J.menuOpen, ie = J.options, K = J.query, Y = J.selected, ne = J.ariaHint, ae = J.validChoiceMade, fe = this.hasAutoselect(), Q = H === -1, oe = ie.length === 0, de = K.length !== 0, Me = K.length >= o, ge = this.props.showNoOptionsFound && Q && oe && de && Me, se = L + "__wrapper", ee = L + "__input", re = H !== null ? " " + ee + "--focused" : "", ue = this.props.showAllValues ? " " + ee + "--show-all-values" : " " + ee + "--default", te = L + "__dropdown-arrow-down", O = H !== -1 && H !== null, p = L + "__menu", P = p + "--" + v, k = p + "--" + (Z || ge ? "visible" : "hidden"), X = L + "__option", F = L + "__hint", x = this.templateInputValue(ie[Y]), W = x && x.toLowerCase().indexOf(K.toLowerCase()) === 0 && fe ? K + x.substr(K.length) : "", $ = c + "__assistiveHint", ce = ne ? { "aria-describedby": $ } : null;
          return I && typeof (S = V({ className: te })) == "string" && (S = (0, G.createElement)("div", { className: L + "__dropdown-arrow-down-wrapper", dangerouslySetInnerHTML: { __html: S } })), (0, G.createElement)("div", { className: se, onKeyDown: this.handleKeyDown }, (0, G.createElement)(R.default, { id: c, length: ie.length, queryLength: K.length, minQueryLength: o, selectedOption: this.templateInputValue(ie[Y]), selectedOptionIndex: Y, validChoiceMade: ae, isInFocus: this.state.focused !== null, tQueryTooShort: E, tNoResults: N, tSelectedOption: C, tResults: b }), W && (0, G.createElement)("span", null, (0, G.createElement)("input", { className: F, readonly: !0, tabIndex: "-1", value: W })), (0, G.createElement)("input", g({ "aria-expanded": Z ? "true" : "false", "aria-activedescendant": !!O && c + "__option--" + H, "aria-owns": c + "__listbox", "aria-autocomplete": this.hasAutoselect() ? "both" : "list" }, ce, { autoComplete: "off", className: "" + ee + re + ue, id: c, onClick: function(le) {
            return h.handleInputClick(le);
          }, onBlur: this.handleInputBlur }, function(q) {
            return { onInput: q };
          }(this.handleInputChange), { onFocus: this.handleInputFocus, name: y, placeholder: u, ref: function(le) {
            h.elementReferences[-1] = le;
          }, type: "text", role: "combobox", required: A, value: K })), S, (0, G.createElement)("ul", { className: p + " " + P + " " + k, onMouseLeave: function(le) {
            return h.handleListMouseLeave(le);
          }, id: c + "__listbox", role: "listbox" }, ie.map(function(le, q) {
            var _e = (H === -1 ? Y === q : H === q) && z === null ? " " + X + "--focused" : "", Ee = q % 2 ? " " + X + "--odd" : "", Te = r() ? "<span id=" + c + "__option-suffix--" + q + ' style="border:0;clip:rect(0 0 0 0);height:1px;marginBottom:-1px;marginRight:-1px;overflow:hidden;padding:0;position:absolute;whiteSpace:nowrap;width:1px"> ' + (q + 1) + " of " + ie.length + "</span>" : "";
            return (0, G.createElement)("li", { "aria-selected": H === q ? "true" : "false", className: "" + X + _e + Ee, dangerouslySetInnerHTML: { __html: h.templateSuggestion(le) + Te }, id: c + "__option--" + q, key: q, onBlur: function(Ce) {
              return h.handleOptionBlur(Ce, q);
            }, onClick: function(Ce) {
              return h.handleOptionClick(Ce, q);
            }, onMouseDown: h.handleOptionMouseDown, onMouseEnter: function(Ce) {
              return h.handleOptionMouseEnter(Ce, q);
            }, ref: function(Ce) {
              h.elementReferences[q] = Ce;
            }, role: "option", tabIndex: "-1", "aria-posinset": q + 1, "aria-setsize": ie.length });
          }), ge && (0, G.createElement)("li", { className: X + " " + X + "--no-results" }, M())), (0, G.createElement)("span", { id: $, style: { display: "none" } }, w()));
        }, t;
      }(G.Component);
      (B.default = l).defaultProps = { autoselect: !1, cssNamespace: "autocomplete", defaultValue: "", displayMenu: "inline", minLength: 0, name: "input-autocomplete", placeholder: "", onConfirm: function() {
      }, confirmOnBlur: !0, showNoOptionsFound: !0, showAllValues: !1, required: !1, tNoResults: function() {
        return "No results found";
      }, tAssistiveHint: function() {
        return "When autocomplete results are available use up and down arrows to review and enter to select.  Touch device users, explore by touch or with swipe gestures.";
      }, dropdownArrow: m.default };
    }, function(D, B, U) {
      var G = U(9), R = U(53), m = U(28), e = U(26)("IE_PROTO"), g = function() {
      }, n = "prototype", i = function() {
        var r, l = U(15)("iframe"), d = m.length;
        for (l.style.display = "none", U(54).appendChild(l), l.src = "javascript:", (r = l.contentWindow.document).open(), r.write("<script>document.F=Object<\/script>"), r.close(), i = r.F; d--; )
          delete i[n][m[d]];
        return i();
      };
      D.exports = Object.create || function(r, l) {
        var d;
        return r !== null ? (g[n] = G(r), d = new g(), g[n] = null, d[e] = r) : d = i(), l === void 0 ? d : R(d, l);
      };
    }, function(D, B, U) {
      var G = U(8), R = U(9), m = U(20);
      D.exports = U(3) ? Object.defineProperties : function(e, g) {
        R(e);
        for (var n, i = m(g), r = i.length, l = 0; l < r; )
          G.f(e, n = i[l++], g[n]);
        return e;
      };
    }, function(D, B, U) {
      var G = U(1).document;
      D.exports = G && G.documentElement;
    }, function(D, B, U) {
      var G = U(0);
      G(G.P, "Function", { bind: U(56) });
    }, function(D, B, U) {
      var G = U(19), R = U(2), m = U(57), e = [].slice, g = {};
      D.exports = Function.bind || function(n) {
        var i = G(this), r = e.call(arguments, 1), l = function() {
          var d = r.concat(e.call(arguments));
          return this instanceof l ? function(t, T, S) {
            if (!(T in g)) {
              for (var h = [], _ = 0; _ < T; _++)
                h[_] = "a[" + _ + "]";
              g[T] = Function("F,a", "return new F(" + h.join(",") + ")");
            }
            return g[T](t, S);
          }(i, d.length, d) : m(i, d, n);
        };
        return R(i.prototype) && (l.prototype = i.prototype), l;
      };
    }, function(D, B) {
      D.exports = function(U, G, R) {
        var m = R === void 0;
        switch (G.length) {
          case 0:
            return m ? U() : U.call(R);
          case 1:
            return m ? U(G[0]) : U.call(R, G[0]);
          case 2:
            return m ? U(G[0], G[1]) : U.call(R, G[0], G[1]);
          case 3:
            return m ? U(G[0], G[1], G[2]) : U.call(R, G[0], G[1], G[2]);
          case 4:
            return m ? U(G[0], G[1], G[2], G[3]) : U.call(R, G[0], G[1], G[2], G[3]);
        }
        return U.apply(R, G);
      };
    }, function(D, B, U) {
      U(59)("match", 1, function(G, R, m) {
        return [function(e) {
          var g = G(this), n = e == null ? void 0 : e[R];
          return n !== void 0 ? n.call(e, g) : new RegExp(e)[R](String(g));
        }, m];
      });
    }, function(D, B, U) {
      var G = U(7), R = U(16), m = U(4), e = U(12), g = U(34);
      D.exports = function(n, i, r) {
        var l = g(n), d = r(e, l, ""[n]), t = d[0], T = d[1];
        m(function() {
          var S = {};
          return S[l] = function() {
            return 7;
          }, ""[n](S) != 7;
        }) && (R(String.prototype, n, t), G(RegExp.prototype, l, i == 2 ? function(S, h) {
          return T.call(S, this, h);
        } : function(S) {
          return T.call(S, this);
        }));
      };
    }, function(D, B, U) {
      B.__esModule = !0, B.default = void 0, U(36);
      var G = U(5), R = function(g, n, i) {
        var r;
        return function() {
          var l = this, d = arguments, t = function() {
            r = null, i || g.apply(l, d);
          }, T = i && !r;
          clearTimeout(r), r = setTimeout(t, n), T && g.apply(l, d);
        };
      }, m = function(e) {
        function g() {
          for (var i, r = arguments.length, l = new Array(r), d = 0; d < r; d++)
            l[d] = arguments[d];
          return (i = e.call.apply(e, [this].concat(l)) || this).state = { bump: !1, debounced: !1 }, i;
        }
        (function(r, l) {
          r.prototype = Object.create(l.prototype), (r.prototype.constructor = r).__proto__ = l;
        })(g, e);
        var n = g.prototype;
        return n.componentWillMount = function() {
          var i = this;
          this.debounceStatusUpdate = R(function() {
            if (!i.state.debounced) {
              var r = !i.props.isInFocus || i.props.validChoiceMade;
              i.setState(function(l) {
                return { bump: !l.bump, debounced: !0, silenced: r };
              });
            }
          }, 1400);
        }, n.componentWillReceiveProps = function(i) {
          i.queryLength, this.setState({ debounced: !1 });
        }, n.render = function() {
          var i = this.props, r = i.id, l = i.length, d = i.queryLength, t = i.minQueryLength, T = i.selectedOption, S = i.selectedOptionIndex, h = i.tQueryTooShort, _ = i.tNoResults, L = i.tSelectedOption, v = i.tResults, c = this.state, o = c.bump, y = c.debounced, u = c.silenced, A = d < t, I = l === 0, M = T ? L(T, l, S) : "", E = null;
          return E = A ? h(t) : I ? _() : v(l, M), this.debounceStatusUpdate(), (0, G.createElement)("div", { style: { border: "0", clip: "rect(0 0 0 0)", height: "1px", marginBottom: "-1px", marginRight: "-1px", overflow: "hidden", padding: "0", position: "absolute", whiteSpace: "nowrap", width: "1px" } }, (0, G.createElement)("div", { id: r + "__status--A", role: "status", "aria-atomic": "true", "aria-live": "polite" }, !u && y && o ? E : ""), (0, G.createElement)("div", { id: r + "__status--B", role: "status", "aria-atomic": "true", "aria-live": "polite" }, u || !y || o ? "" : E));
        }, g;
      }(G.Component);
      (B.default = m).defaultProps = { tQueryTooShort: function(e) {
        return "Type in " + e + " or more characters for results";
      }, tNoResults: function() {
        return "No search results";
      }, tSelectedOption: function(e, g, n) {
        return e + " " + (n + 1) + " of " + g + " is highlighted";
      }, tResults: function(e, g) {
        return e + " " + (e === 1 ? "result" : "results") + " " + (e === 1 ? "is" : "are") + " available. " + g;
      } };
    }, function(D, B, U) {
      B.__esModule = !0, B.default = void 0;
      var G = U(5), R = function(e) {
        var g = e.className;
        return (0, G.createElement)("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", className: g, focusable: "false" }, (0, G.createElement)("g", { stroke: "none", fill: "none", "fill-rule": "evenodd" }, (0, G.createElement)("polygon", { fill: "#000000", points: "0 0 22 0 11 17" })));
      };
      B.default = R;
    }]).default;
  });
})(vl);
var kg = vl.exports;
const Yg = /* @__PURE__ */ Di(kg), Wg = "selectautocomplete";
class Kg extends sa {
  constructor(f, D) {
    super(f), this._config = D, this._enhance();
  }
  // Getters
  static get NAME() {
    return Wg;
  }
  // Public
  // Private
  _enhance() {
    Yg.enhanceSelectElement(Object.assign({}, { selectElement: this._element }, this._config));
  }
}
const ks = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", Ys = ".sticky-top", Ja = "padding-right", Ws = "margin-right";
class Vg {
  constructor() {
    this._element = document.body;
  }
  // Public
  getWidth() {
    const f = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - f);
  }
  hide() {
    const f = this.getWidth();
    this._disableOverFlow(), this._setElementAttributes(this._element, Ja, (D) => D + f), this._setElementAttributes(ks, Ja, (D) => D + f), this._setElementAttributes(Ys, Ws, (D) => D - f);
  }
  reset() {
    this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, Ja), this._resetElementAttributes(ks, Ja), this._resetElementAttributes(Ys, Ws);
  }
  isOverflowing() {
    return this.getWidth() > 0;
  }
  // Private
  _disableOverFlow() {
    this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
  }
  _setElementAttributes(f, D, B) {
    const U = this.getWidth(), G = (R) => {
      if (R !== this._element && window.innerWidth > R.clientWidth + U)
        return;
      this._saveInitialAttribute(R, D);
      const m = window.getComputedStyle(R).getPropertyValue(D);
      R.style.setProperty(D, `${B(Number.parseFloat(m))}px`);
    };
    this._applyManipulationCallback(f, G);
  }
  _saveInitialAttribute(f, D) {
    const B = f.style.getPropertyValue(D);
    B && Ia.setDataAttribute(f, D, B);
  }
  _resetElementAttributes(f, D) {
    const B = (U) => {
      const G = Ia.getDataAttribute(U, D);
      if (G === null) {
        U.style.removeProperty(D);
        return;
      }
      Ia.removeDataAttribute(U, D), U.style.setProperty(D, G);
    };
    this._applyManipulationCallback(f, B);
  }
  _applyManipulationCallback(f, D) {
    if (Vn(f)) {
      D(f);
      return;
    }
    for (const B of pr.find(f, this._element))
      D(B);
  }
}
const pl = "backdrop", Gg = "fade", Ks = "show", Vs = `mousedown.bs.${pl}`, Qg = {
  className: "modal-backdrop",
  clickCallback: null,
  isAnimated: !1,
  isVisible: !0,
  // if false, we use the backdrop helper without adding any element to the dom
  rootElement: "body"
  // give the choice to place backdrop under different elements
}, Hg = {
  className: "string",
  clickCallback: "(function|null)",
  isAnimated: "boolean",
  isVisible: "boolean",
  rootElement: "(element|string)"
};
class Xg extends ts {
  constructor(f) {
    super(), this._config = this._getConfig(f), this._isAppended = !1, this._element = null;
  }
  // Getters
  static get Default() {
    return Qg;
  }
  static get DefaultType() {
    return Hg;
  }
  static get NAME() {
    return pl;
  }
  // Public
  show(f) {
    if (!this._config.isVisible) {
      Ln(f);
      return;
    }
    this._append();
    const D = this._getElement();
    this._config.isAnimated && il(D), D.classList.add(Ks), this._emulateAnimation(() => {
      Ln(f);
    });
  }
  hide(f) {
    if (!this._config.isVisible) {
      Ln(f);
      return;
    }
    this._getElement().classList.remove(Ks), this._emulateAnimation(() => {
      this.dispose(), Ln(f);
    });
  }
  dispose() {
    this._isAppended && (Wt.off(this._element, Vs), this._element.remove(), this._isAppended = !1);
  }
  // Private
  _getElement() {
    if (!this._element) {
      const f = document.createElement("div");
      f.className = this._config.className, this._config.isAnimated && f.classList.add(Gg), this._element = f;
    }
    return this._element;
  }
  _configAfterMerge(f) {
    return f.rootElement = po(f.rootElement), f;
  }
  _append() {
    if (this._isAppended)
      return;
    const f = this._getElement();
    this._config.rootElement.append(f), Wt.on(f, Vs, () => {
      Ln(this._config.clickCallback);
    }), this._isAppended = !0;
  }
  _emulateAnimation(f) {
    sl(f, this._getElement(), this._config.isAnimated);
  }
}
const $g = "focustrap", Zg = "bs.focustrap", Ei = `.${Zg}`, Jg = `focusin${Ei}`, qg = `keydown.tab${Ei}`, em = "Tab", tm = "forward", Gs = "backward", rm = {
  autofocus: !0,
  trapElement: null
  // The element to trap focus inside of
}, nm = {
  autofocus: "boolean",
  trapElement: "element"
};
class am extends ts {
  constructor(f) {
    super(), this._config = this._getConfig(f), this._isActive = !1, this._lastTabNavDirection = null;
  }
  // Getters
  static get Default() {
    return rm;
  }
  static get DefaultType() {
    return nm;
  }
  static get NAME() {
    return $g;
  }
  // Public
  activate() {
    this._isActive || (this._config.autofocus && this._config.trapElement.focus(), Wt.off(document, Ei), Wt.on(document, Jg, (f) => this._handleFocusin(f)), Wt.on(document, qg, (f) => this._handleKeydown(f)), this._isActive = !0);
  }
  deactivate() {
    this._isActive && (this._isActive = !1, Wt.off(document, Ei));
  }
  // Private
  _handleFocusin(f) {
    const { trapElement: D } = this._config;
    if (f.target === document || f.target === D || D.contains(f.target))
      return;
    const B = pr.focusableChildren(D);
    B.length === 0 ? D.focus() : this._lastTabNavDirection === Gs ? B[B.length - 1].focus() : B[0].focus();
  }
  _handleKeydown(f) {
    f.key === em && (this._lastTabNavDirection = f.shiftKey ? Gs : tm);
  }
}
const im = "modal", om = "bs.modal", br = `.${om}`, sm = ".data-api", um = "Escape", lm = `hide${br}`, cm = `hidePrevented${br}`, Tl = `hidden${br}`, Ll = `show${br}`, fm = `shown${br}`, dm = `resize${br}`, gm = `click.dismiss${br}`, mm = `mousedown.dismiss${br}`, Em = `keydown.dismiss${br}`, Mm = `click${br}${sm}`, Qs = "modal-open", hm = "fade", Hs = "show", Vi = "modal-static", _m = ".modal.show", ym = ".modal-dialog", vm = ".modal-body", pm = '[data-bs-toggle="modal"]', Tm = {
  backdrop: !0,
  focus: !0,
  keyboard: !0
}, Lm = {
  backdrop: "(boolean|string)",
  focus: "boolean",
  keyboard: "boolean"
};
let Ua = class Il extends sa {
  constructor(f, D) {
    super(f, D), this._dialog = pr.findOne(ym, this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = !1, this._isTransitioning = !1, this._scrollBar = new Vg(), this._addEventListeners();
  }
  // Getters
  static get Default() {
    return Tm;
  }
  static get DefaultType() {
    return Lm;
  }
  static get NAME() {
    return im;
  }
  // Public
  toggle(f) {
    return this._isShown ? this.hide() : this.show(f);
  }
  show(f) {
    this._isShown || this._isTransitioning || Wt.trigger(this._element, Ll, {
      relatedTarget: f
    }).defaultPrevented || (this._isShown = !0, this._isTransitioning = !0, this._scrollBar.hide(), document.body.classList.add(Qs), this._adjustDialog(), this._backdrop.show(() => this._showElement(f)));
  }
  hide() {
    !this._isShown || this._isTransitioning || Wt.trigger(this._element, lm).defaultPrevented || (this._isShown = !1, this._isTransitioning = !0, this._focustrap.deactivate(), this._element.classList.remove(Hs), this._queueCallback(() => this._hideModal(), this._element, this._isAnimated()));
  }
  dispose() {
    for (const f of [window, this._dialog])
      Wt.off(f, br);
    this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
  }
  handleUpdate() {
    this._adjustDialog();
  }
  // Private
  _initializeBackDrop() {
    return new Xg({
      isVisible: !!this._config.backdrop,
      // 'static' option will be translated to true, and booleans will keep their value,
      isAnimated: this._isAnimated()
    });
  }
  _initializeFocusTrap() {
    return new am({
      trapElement: this._element
    });
  }
  _showElement(f) {
    document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
    const D = pr.findOne(vm, this._dialog);
    D && (D.scrollTop = 0), il(this._element), this._element.classList.add(Hs);
    const B = () => {
      this._config.focus && this._focustrap.activate(), this._isTransitioning = !1, Wt.trigger(this._element, fm, {
        relatedTarget: f
      });
    };
    this._queueCallback(B, this._dialog, this._isAnimated());
  }
  _addEventListeners() {
    Wt.on(this._element, Em, (f) => {
      if (f.key === um) {
        if (this._config.keyboard) {
          f.preventDefault(), this.hide();
          return;
        }
        this._triggerBackdropTransition();
      }
    }), Wt.on(window, dm, () => {
      this._isShown && !this._isTransitioning && this._adjustDialog();
    }), Wt.on(this._element, mm, (f) => {
      Wt.one(this._element, gm, (D) => {
        if (!(this._element !== f.target || this._element !== D.target)) {
          if (this._config.backdrop === "static") {
            this._triggerBackdropTransition();
            return;
          }
          this._config.backdrop && this.hide();
        }
      });
    });
  }
  _hideModal() {
    this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide(() => {
      document.body.classList.remove(Qs), this._resetAdjustments(), this._scrollBar.reset(), Wt.trigger(this._element, Tl);
    });
  }
  _isAnimated() {
    return this._element.classList.contains(hm);
  }
  _triggerBackdropTransition() {
    if (Wt.trigger(this._element, cm).defaultPrevented)
      return;
    const D = this._element.scrollHeight > document.documentElement.clientHeight, B = this._element.style.overflowY;
    B === "hidden" || this._element.classList.contains(Vi) || (D || (this._element.style.overflowY = "hidden"), this._element.classList.add(Vi), this._queueCallback(() => {
      this._element.classList.remove(Vi), this._queueCallback(() => {
        this._element.style.overflowY = B;
      }, this._dialog);
    }, this._dialog), this._element.focus());
  }
  /**
   * The following methods are used to handle overflowing modals
   */
  _adjustDialog() {
    const f = this._element.scrollHeight > document.documentElement.clientHeight, D = this._scrollBar.getWidth(), B = D > 0;
    if (B && !f) {
      const U = bs() ? "paddingLeft" : "paddingRight";
      this._element.style[U] = `${D}px`;
    }
    if (!B && f) {
      const U = bs() ? "paddingRight" : "paddingLeft";
      this._element.style[U] = `${D}px`;
    }
  }
  _resetAdjustments() {
    this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
  }
  // Static
  static jQueryInterface(f, D) {
    return this.each(function() {
      const B = Il.getOrCreateInstance(this, f);
      if (typeof f == "string") {
        if (typeof B[f] > "u")
          throw new TypeError(`No method named "${f}"`);
        B[f](D);
      }
    });
  }
};
Wt.on(document, Mm, pm, function(j) {
  const f = La(this);
  ["A", "AREA"].includes(this.tagName) && j.preventDefault(), Wt.one(f, Ll, (U) => {
    U.defaultPrevented || Wt.one(f, Tl, () => {
      al(this) && this.focus();
    });
  });
  const D = pr.findOne(_m);
  D && Ua.getInstance(D).hide(), Ua.getOrCreateInstance(f).toggle(this);
});
Rg(Ua);
qo(Ua);
const Im = Ua;
class us extends Im {
}
const Am = "tab", Sm = "bs.tab", On = `.${Sm}`, Dm = `hide${On}`, Nm = `hidden${On}`, Cm = `show${On}`, jm = `shown${On}`, Om = `click${On}`, Pm = `keydown${On}`, Rm = `load${On}`, bm = "ArrowLeft", Xs = "ArrowRight", xm = "ArrowUp", $s = "ArrowDown", Sn = "active", Zs = "fade", Gi = "show", wm = "dropdown", Um = ".dropdown-toggle", Fm = ".dropdown-menu", Qi = ":not(.dropdown-toggle)", Bm = '.list-group, .nav, [role="tablist"]', zm = ".nav-item, .list-group-item", km = `.nav-link${Qi}, .list-group-item${Qi}, [role="tab"]${Qi}`, Al = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', Hi = `${km}, ${Al}`, Ym = `.${Sn}[data-bs-toggle="tab"], .${Sn}[data-bs-toggle="pill"], .${Sn}[data-bs-toggle="list"]`;
let Ni = class Lo extends sa {
  constructor(f) {
    super(f), this._parent = this._element.closest(Bm), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), Wt.on(this._element, Pm, (D) => this._keydown(D)));
  }
  // Getters
  static get NAME() {
    return Am;
  }
  // Public
  show() {
    const f = this._element;
    if (this._elemIsActive(f))
      return;
    const D = this._getActiveElem(), B = D ? Wt.trigger(D, Dm, { relatedTarget: f }) : null;
    Wt.trigger(f, Cm, { relatedTarget: D }).defaultPrevented || B && B.defaultPrevented || (this._deactivate(D, f), this._activate(f, D));
  }
  // Private
  _activate(f, D) {
    if (!f)
      return;
    f.classList.add(Sn), this._activate(La(f));
    const B = () => {
      if (f.getAttribute("role") !== "tab") {
        f.classList.add(Gi);
        return;
      }
      f.removeAttribute("tabindex"), f.setAttribute("aria-selected", !0), this._toggleDropDown(f, !0), Wt.trigger(f, jm, {
        relatedTarget: D
      });
    };
    this._queueCallback(B, f, f.classList.contains(Zs));
  }
  _deactivate(f, D) {
    if (!f)
      return;
    f.classList.remove(Sn), f.blur(), this._deactivate(La(f));
    const B = () => {
      if (f.getAttribute("role") !== "tab") {
        f.classList.remove(Gi);
        return;
      }
      f.setAttribute("aria-selected", !1), f.setAttribute("tabindex", "-1"), this._toggleDropDown(f, !1), Wt.trigger(f, Nm, { relatedTarget: D });
    };
    this._queueCallback(B, f, f.classList.contains(Zs));
  }
  _keydown(f) {
    if (![bm, Xs, xm, $s].includes(f.key))
      return;
    f.stopPropagation(), f.preventDefault();
    const D = [Xs, $s].includes(f.key), B = ul(this._getChildren().filter((U) => !oa(U)), f.target, D, !0);
    B && (B.focus({ preventScroll: !0 }), Lo.getOrCreateInstance(B).show());
  }
  _getChildren() {
    return pr.find(Hi, this._parent);
  }
  _getActiveElem() {
    return this._getChildren().find((f) => this._elemIsActive(f)) || null;
  }
  _setInitialAttributes(f, D) {
    this._setAttributeIfNotExists(f, "role", "tablist");
    for (const B of D)
      this._setInitialAttributesOnChild(B);
  }
  _setInitialAttributesOnChild(f) {
    f = this._getInnerElement(f);
    const D = this._elemIsActive(f), B = this._getOuterElement(f);
    f.setAttribute("aria-selected", D), B !== f && this._setAttributeIfNotExists(B, "role", "presentation"), D || f.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(f, "role", "tab"), this._setInitialAttributesOnTargetPanel(f);
  }
  _setInitialAttributesOnTargetPanel(f) {
    const D = La(f);
    D && (this._setAttributeIfNotExists(D, "role", "tabpanel"), f.id && this._setAttributeIfNotExists(D, "aria-labelledby", `#${f.id}`));
  }
  _toggleDropDown(f, D) {
    const B = this._getOuterElement(f);
    if (!B.classList.contains(wm))
      return;
    const U = (G, R) => {
      const m = pr.findOne(G, B);
      m && m.classList.toggle(R, D);
    };
    U(Um, Sn), U(Fm, Gi), B.setAttribute("aria-expanded", D);
  }
  _setAttributeIfNotExists(f, D, B) {
    f.hasAttribute(D) || f.setAttribute(D, B);
  }
  _elemIsActive(f) {
    return f.classList.contains(Sn);
  }
  // Try to get the inner element (usually the .nav-link)
  _getInnerElement(f) {
    return f.matches(Hi) ? f : pr.findOne(Hi, f);
  }
  // Try to get the outer element (usually the .nav-item)
  _getOuterElement(f) {
    return f.closest(zm) || f;
  }
  // Static
  static jQueryInterface(f) {
    return this.each(function() {
      const D = Lo.getOrCreateInstance(this);
      if (typeof f == "string") {
        if (D[f] === void 0 || f.startsWith("_") || f === "constructor")
          throw new TypeError(`No method named "${f}"`);
        D[f]();
      }
    });
  }
};
Wt.on(document, Om, Al, function(j) {
  ["A", "AREA"].includes(this.tagName) && j.preventDefault(), !oa(this) && Ni.getOrCreateInstance(this).show();
});
Wt.on(window, Rm, () => {
  for (const j of pr.find(Ym))
    Ni.getOrCreateInstance(j);
});
qo(Ni);
const Wm = Ni, Km = "bs.tab", Sl = `.${Km}`, Vm = `click${Sl}`, Gm = `load${Sl}`, Qm = "ArrowLeft", Js = "ArrowRight", Hm = "ArrowUp", qs = "ArrowDown", eu = "Enter", tu = " ", Xi = "active", Xm = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', $m = `.${Xi}[data-bs-toggle="tab"], .${Xi}[data-bs-toggle="pill"], .${Xi}[data-bs-toggle="list"]`;
class Zr extends Wm {
  constructor(f) {
    super(f);
  }
  _keydown(f) {
    if (![Qm, Js, Hm, qs, eu, tu].includes(f.key))
      return;
    if (f.stopPropagation(), f.preventDefault(), f.key === eu || f.key === tu) {
      Zr.getOrCreateInstance(f.target).show();
      return;
    }
    const D = [Js, qs].includes(f.key), B = ul(
      this._getChildren().filter((U) => !oa(U)),
      f.target,
      D,
      !0
    );
    B && B.focus({ preventScroll: !0 });
  }
}
Wt.on(document, Vm, Xm, function(j) {
  if (["A", "AREA"].includes(this.tagName) && j.preventDefault(), oa(this))
    return;
  Zr.getOrCreateInstance(this).dispose(), Zr.getOrCreateInstance(this).show();
});
Wt.on(window, Gm, () => {
  for (const j of pr.find($m))
    Zr.getOrCreateInstance(j).dispose(), Zr.getOrCreateInstance(j);
});
qo(Zr);
const Zm = {}, Jm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zm
}, Symbol.toStringTag, { value: "Module" })), qm = /* @__PURE__ */ zg(Jm), ru = "data-focus-mouse", nu = "focus--mouse";
class Dl {
  constructor() {
    this._usingMouse = !1, this._bindEvents();
  }
  // Public
  // Private
  _bindEvents() {
    ["keydown", "mousedown"].forEach((D) => {
      document.addEventListener(D, (B) => {
        this._usingMouse = B.type === "mousedown";
      });
    }), document.addEventListener("focusin", (D) => {
      this._usingMouse && D.target && (D.target.classList.add(nu), D.target.setAttribute(ru, !0));
    }), document.addEventListener("focusout", (D) => {
      D.target && (D.target.classList.remove(nu), D.target.setAttribute(ru, !1));
    });
  }
}
new Dl();
const eE = "2.7.5", tE = () => {
  window.BOOTSTRAP_ITALIA_VERSION || (new Dl(), window.BOOTSTRAP_ITALIA_VERSION = eE);
};
tE();
const rE = { class: "splide__track" }, nE = { class: "splide__list" }, aE = { class: "it-single-slide-wrapper" }, iE = /* @__PURE__ */ Ct({
  __name: "KCarousel",
  props: {
    items: {}
  },
  setup(j) {
    const f = lt(null);
    let D = null;
    const B = j;
    return tr(() => {
    }), Po(() => {
    }), er(() => B.items, (U) => {
      !U || U.length <= 0 || Rr(() => {
        D != null && (D.dispose(), D = null), D = El.getOrCreateInstance(f.value);
      });
    }, { immediate: !0 }), (U, G) => (Ne(), We("div", {
      ref_key: "kCarousel",
      ref: f,
      class: "k-carousel it-carousel-wrapper it-carousel-landscape-abstract splide",
      "data-bs-carousel-splide": ""
    }, [
      he("div", rE, [
        he("ul", nE, [
          (Ne(!0), We(or, null, _r(U.items, (R, m) => (Ne(), We("li", {
            class: "splide__slide",
            key: m
          }, [
            he("div", aE, [
              nr(U.$slots, "template", { data: R })
            ])
          ]))), 128))
        ])
      ])
    ], 512));
  }
}), oE = ["disabled", "id"], sE = ["for"], uE = /* @__PURE__ */ Ct({
  __name: "KCheckbox",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { type: Boolean, default: !1 },
    labelText: { default: "" },
    class: { default: "" },
    disabled: { type: Boolean, default: !1 },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(j, { emit: f }) {
    const D = f, B = lt(), U = j;
    er(
      () => U.modelValue,
      async (m) => {
        B.value = m;
      },
      { immediate: !0 }
    );
    const G = (m) => {
      D("update:modelValue", m.target.checked);
    }, R = (m) => {
      D("change");
    };
    return (m, e) => (Ne(), We("div", {
      class: Ot(["form-check", m.formGroupClass])
    }, [
      Cn(he("input", {
        disabled: m.disabled,
        onInput: G,
        "onUpdate:modelValue": e[0] || (e[0] = (g) => B.value = g),
        onChange: R,
        class: Ot(m.class),
        id: m.id,
        type: "checkbox"
      }, null, 42, oE), [
        [Ro, B.value]
      ]),
      he("label", { for: m.id }, ft(m.labelText), 9, sE)
    ], 2));
  }
}), lE = { class: "d-flex align-items-center" }, cE = {
  key: 0,
  class: "text-primary",
  style: { "font-size": "14px" }
}, fE = { class: "d-flex flex-column" }, dE = { class: "d-flex align-items-center" }, gE = /* @__PURE__ */ he("span", { class: "text-primary" }, "Dettaglio", -1), mE = { class: "d-flex align-items-center" }, EE = /* @__PURE__ */ he("span", { class: "text-primary" }, "Scarica", -1), ME = { class: "d-flex align-items-center" }, hE = /* @__PURE__ */ he("span", { class: "text-primary" }, "Sposta in", -1), _E = { class: "d-flex align-items-center" }, yE = /* @__PURE__ */ he("span", { class: "text-primary" }, "Condividi", -1), vE = { class: "d-flex align-items-center" }, pE = /* @__PURE__ */ he("span", { class: "text-primary" }, "Copia link", -1), TE = { class: "d-flex align-items-center" }, LE = /* @__PURE__ */ he("span", { class: "text-primary" }, "Elimina", -1), IE = { class: "d-flex align-items-center" }, AE = /* @__PURE__ */ he("span", { class: "text-primary" }, "Rimuovi dallo spazio", -1), SE = { class: "d-flex align-items-center" }, DE = /* @__PURE__ */ he("span", { class: "text-primary" }, "Rinomina cartella", -1), NE = { class: "d-flex align-items-center" }, CE = /* @__PURE__ */ he("span", { class: "text-primary" }, "Sposta cartella in", -1), jE = { class: "d-flex align-items-center" }, OE = /* @__PURE__ */ he("span", { class: "text-primary" }, "Elimina cartella", -1), PE = { class: "d-flex align-items-center" }, RE = /* @__PURE__ */ he("span", { class: "text-primary" }, "Aggiungi a lista distribuzione", -1), bE = ["onClick"], xE = { class: "d-flex align-items-center" }, wE = { class: "text-primary" }, UE = /* @__PURE__ */ Ct({
  __name: "KDataTableActions",
  props: {
    showActionLabel: { type: Boolean, default: !1 },
    showIcons: { type: Boolean, default: !1 },
    showDetail: { type: Boolean, default: !1 },
    showDownload: { type: Boolean, default: !1 },
    showMove: { type: Boolean, default: !1 },
    showShare: { type: Boolean, default: !1 },
    showCopyLink: { type: Boolean, default: !1 },
    showDelete: { type: Boolean, default: !1 },
    showRemoveFromSpace: { type: Boolean, default: !1 },
    showRenameFolder: { type: Boolean, default: !1 },
    showMoveFolder: { type: Boolean, default: !1 },
    showDeleteFolder: { type: Boolean, default: !1 },
    showAddToDistList: { type: Boolean, default: !1 },
    overlayZIndex: { default: 0 },
    customActions: { default: [] }
  },
  emits: ["doc-detail", "doc-download", "doc-share", "doc-copylink", "doc-delete", "doc-move", "doc-remove-space", "doc-rename-folder", "doc-move-folder", "doc-delete-folder", "add-to-distribution-list"],
  setup(j, { emit: f }) {
    const D = lt(), B = lt(), U = lt(), G = lt(), R = lt(), m = lt(), e = lt(), g = lt(), n = lt(), i = lt(), r = lt(), l = lt(), d = lt([]), t = j, T = f, S = (b) => {
      var w;
      Array.from(document.getElementsByClassName("k-actions-menu-panel")).forEach((V) => {
        V.style.display = "none";
      }), D.value.toggle(b), (w = D.value) != null && w.visible && E();
    }, h = () => {
      T("doc-detail");
    }, _ = () => {
      T("doc-download");
    }, L = () => {
      T("doc-share");
    }, v = () => {
      T("doc-move");
    }, c = () => {
      T("doc-copylink");
    }, o = () => {
      T("doc-delete");
    }, y = () => {
      T("doc-remove-space");
    }, u = () => {
      T("doc-rename-folder");
    }, A = () => {
      T("doc-move-folder");
    }, I = () => {
      T("doc-delete-folder");
    }, M = () => {
      T("add-to-distribution-list");
    }, E = () => {
      Rr(() => {
        t.showDetail ? B.value.focus() : t.showDownload ? U.value.focus() : t.showDownload ? G.value.focus() : t.showShare ? R.value.focus() : t.showCopyLink ? m.value.focus() : t.showDelete ? e.value.focus() : t.showRemoveFromSpace ? g.value.focus() : t.showRenameFolder ? n.value.focus() : t.showMoveFolder ? i.value.focus() : t.showDeleteFolder ? r.value.focus() : t.showAddToDistList ? l.value.focus() : (d.value || []).length > 0 && d.value[0].value[0].focus();
      });
    }, N = Vt(() => t.showDetail || t.showDownload || t.showMove || t.showShare || t.showCopyLink || t.showDelete || t.showRemoveFromSpace || t.showRenameFolder || t.showMoveFolder || t.showDeleteFolder || t.showAddToDistList || (t.customActions || []).length > 0), C = Vt(() => t.overlayZIndex == null || t.overlayZIndex == null);
    return bo(() => {
      d.value = (t.customActions || []).map((b) => lt());
    }), Po(() => {
      d.value = (t.customActions || []).map((b) => lt());
    }), (b, w) => {
      const V = Pt("KIcon"), J = Pt("OverlayPanel");
      return Ne(), We(or, null, [
        N.value ? (Ne(), We("button", {
          key: 0,
          type: "button",
          class: "btn btn-icon k-btn-flat",
          onClick: w[0] || (w[0] = xo((H) => S(H), ["stop"]))
        }, [
          he("div", lE, [
            gt(V, {
              icon: "it-more-items",
              class: "icon-primary mr-2"
            }),
            b.showActionLabel ? (Ne(), We("span", cE, "Vedi azioni")) : mt("", !0)
          ])
        ])) : mt("", !0),
        gt(J, {
          ref_key: "btnOverlayPanel",
          ref: D,
          class: "k-actions-menu-panel",
          style: Or({ "z-index": b.overlayZIndex }),
          "auto-z-index": C.value
        }, {
          default: Rt(() => [
            he("div", fE, [
              b.showDetail ? (Ne(), We("a", {
                key: 0,
                ref_key: "detailButton",
                ref: B,
                href: "#",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: h
              }, [
                he("div", dE, [
                  b.showIcons ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-search"
                  })) : mt("", !0),
                  gE
                ])
              ], 512)) : mt("", !0),
              b.showDownload ? (Ne(), We("button", {
                key: 1,
                ref_key: "downloadButton",
                ref: U,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: _
              }, [
                he("div", mE, [
                  b.showIcons ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-download"
                  })) : mt("", !0),
                  EE
                ])
              ], 512)) : mt("", !0),
              b.showMove ? (Ne(), We("button", {
                key: 2,
                ref_key: "moveButton",
                ref: G,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: v
              }, [
                he("div", ME, [
                  b.showIcons ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-chevron-right"
                  })) : mt("", !0),
                  hE
                ])
              ], 512)) : mt("", !0),
              b.showShare ? (Ne(), We("button", {
                key: 3,
                ref_key: "shareButton",
                ref: R,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: L
              }, [
                he("div", _E, [
                  b.showIcons ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-share"
                  })) : mt("", !0),
                  yE
                ])
              ], 512)) : mt("", !0),
              b.showCopyLink ? (Ne(), We("button", {
                key: 4,
                ref_key: "copylinkButton",
                ref: m,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: c
              }, [
                he("div", vE, [
                  b.showIcons ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-link"
                  })) : mt("", !0),
                  pE
                ])
              ], 512)) : mt("", !0),
              b.showDelete ? (Ne(), We("button", {
                key: 5,
                ref_key: "deleteButton",
                ref: e,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: o
              }, [
                he("div", TE, [
                  b.showIcons ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-delete"
                  })) : mt("", !0),
                  LE
                ])
              ], 512)) : mt("", !0),
              b.showRemoveFromSpace ? (Ne(), We("button", {
                key: 6,
                ref_key: "removeFromSpaceButton",
                ref: g,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: y
              }, [
                he("div", IE, [
                  b.showIcons ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-close-circle"
                  })) : mt("", !0),
                  AE
                ])
              ], 512)) : mt("", !0),
              b.showRenameFolder ? (Ne(), We("button", {
                key: 7,
                ref_key: "renameFolderButton",
                ref: n,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: u
              }, [
                he("div", SE, [
                  b.showIcons ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-pencil"
                  })) : mt("", !0),
                  DE
                ])
              ], 512)) : mt("", !0),
              b.showMoveFolder ? (Ne(), We("button", {
                key: 8,
                ref_key: "moveFolderButton",
                ref: i,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: A
              }, [
                he("div", NE, [
                  b.showIcons ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-chevron-right"
                  })) : mt("", !0),
                  CE
                ])
              ], 512)) : mt("", !0),
              b.showDeleteFolder ? (Ne(), We("button", {
                key: 9,
                ref_key: "deleteFolderButton",
                ref: r,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: I
              }, [
                he("div", jE, [
                  b.showIcons ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-delete"
                  })) : mt("", !0),
                  OE
                ])
              ], 512)) : mt("", !0),
              b.showAddToDistList ? (Ne(), We("button", {
                key: 10,
                ref_key: "addToDistListButton",
                ref: l,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: M
              }, [
                he("div", PE, [
                  b.showIcons ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-list"
                  })) : mt("", !0),
                  RE
                ])
              ], 512)) : mt("", !0),
              (Ne(!0), We(or, null, _r(b.customActions, (H, z) => (Ne(), We("button", {
                ref_for: !0,
                ref: d.value[z],
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: H.handler
              }, [
                he("div", xE, [
                  b.showIcons && (H.icon || "") != "" ? (Ne(), Ft(V, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: H.icon
                  }, null, 8, ["icon"])) : mt("", !0),
                  he("span", wE, ft(H.label), 1)
                ])
              ], 8, bE))), 256))
            ])
          ]),
          _: 1
        }, 8, ["style", "auto-z-index"])
      ], 64);
    };
  }
});
var Nl = { exports: {} };
(function(j, f) {
  (function(D, B) {
    j.exports = B();
  })(ss, function() {
    var D = 1e3, B = 6e4, U = 36e5, G = "millisecond", R = "second", m = "minute", e = "hour", g = "day", n = "week", i = "month", r = "quarter", l = "year", d = "date", t = "Invalid Date", T = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, S = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, h = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, _ = function(E, N, C) {
      var b = String(E);
      return !b || b.length >= N ? E : "" + Array(N + 1 - b.length).join(C) + E;
    }, L = { s: _, z: function(E) {
      var N = -E.utcOffset(), C = Math.abs(N), b = Math.floor(C / 60), w = C % 60;
      return (N <= 0 ? "+" : "-") + _(b, 2, "0") + ":" + _(w, 2, "0");
    }, m: function E(N, C) {
      if (N.date() < C.date())
        return -E(C, N);
      var b = 12 * (C.year() - N.year()) + (C.month() - N.month()), w = N.clone().add(b, i), V = C - w < 0, J = N.clone().add(b + (V ? -1 : 1), i);
      return +(-(b + (C - w) / (V ? w - J : J - w)) || 0);
    }, a: function(E) {
      return E < 0 ? Math.ceil(E) || 0 : Math.floor(E);
    }, p: function(E) {
      return { M: i, y: l, w: n, d: g, D: d, h: e, m, s: R, ms: G, Q: r }[E] || String(E || "").toLowerCase().replace(/s$/, "");
    }, u: function(E) {
      return E === void 0;
    } }, v = "en", c = {};
    c[v] = h;
    var o = function(E) {
      return E instanceof I;
    }, y = function E(N, C, b) {
      var w;
      if (!N)
        return v;
      if (typeof N == "string") {
        var V = N.toLowerCase();
        c[V] && (w = V), C && (c[V] = C, w = V);
        var J = N.split("-");
        if (!w && J.length > 1)
          return E(J[0]);
      } else {
        var H = N.name;
        c[H] = N, w = H;
      }
      return !b && w && (v = w), w || !b && v;
    }, u = function(E, N) {
      if (o(E))
        return E.clone();
      var C = typeof N == "object" ? N : {};
      return C.date = E, C.args = arguments, new I(C);
    }, A = L;
    A.l = y, A.i = o, A.w = function(E, N) {
      return u(E, { locale: N.$L, utc: N.$u, x: N.$x, $offset: N.$offset });
    };
    var I = function() {
      function E(C) {
        this.$L = y(C.locale, null, !0), this.parse(C);
      }
      var N = E.prototype;
      return N.parse = function(C) {
        this.$d = function(b) {
          var w = b.date, V = b.utc;
          if (w === null)
            return /* @__PURE__ */ new Date(NaN);
          if (A.u(w))
            return /* @__PURE__ */ new Date();
          if (w instanceof Date)
            return new Date(w);
          if (typeof w == "string" && !/Z$/i.test(w)) {
            var J = w.match(T);
            if (J) {
              var H = J[2] - 1 || 0, z = (J[7] || "0").substring(0, 3);
              return V ? new Date(Date.UTC(J[1], H, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, z)) : new Date(J[1], H, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, z);
            }
          }
          return new Date(w);
        }(C), this.$x = C.x || {}, this.init();
      }, N.init = function() {
        var C = this.$d;
        this.$y = C.getFullYear(), this.$M = C.getMonth(), this.$D = C.getDate(), this.$W = C.getDay(), this.$H = C.getHours(), this.$m = C.getMinutes(), this.$s = C.getSeconds(), this.$ms = C.getMilliseconds();
      }, N.$utils = function() {
        return A;
      }, N.isValid = function() {
        return this.$d.toString() !== t;
      }, N.isSame = function(C, b) {
        var w = u(C);
        return this.startOf(b) <= w && w <= this.endOf(b);
      }, N.isAfter = function(C, b) {
        return u(C) < this.startOf(b);
      }, N.isBefore = function(C, b) {
        return this.endOf(b) < u(C);
      }, N.$g = function(C, b, w) {
        return A.u(C) ? this[b] : this.set(w, C);
      }, N.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, N.valueOf = function() {
        return this.$d.getTime();
      }, N.startOf = function(C, b) {
        var w = this, V = !!A.u(b) || b, J = A.p(C), H = function(fe, Q) {
          var oe = A.w(w.$u ? Date.UTC(w.$y, Q, fe) : new Date(w.$y, Q, fe), w);
          return V ? oe : oe.endOf(g);
        }, z = function(fe, Q) {
          return A.w(w.toDate()[fe].apply(w.toDate("s"), (V ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Q)), w);
        }, Z = this.$W, ie = this.$M, K = this.$D, Y = "set" + (this.$u ? "UTC" : "");
        switch (J) {
          case l:
            return V ? H(1, 0) : H(31, 11);
          case i:
            return V ? H(1, ie) : H(0, ie + 1);
          case n:
            var ne = this.$locale().weekStart || 0, ae = (Z < ne ? Z + 7 : Z) - ne;
            return H(V ? K - ae : K + (6 - ae), ie);
          case g:
          case d:
            return z(Y + "Hours", 0);
          case e:
            return z(Y + "Minutes", 1);
          case m:
            return z(Y + "Seconds", 2);
          case R:
            return z(Y + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, N.endOf = function(C) {
        return this.startOf(C, !1);
      }, N.$set = function(C, b) {
        var w, V = A.p(C), J = "set" + (this.$u ? "UTC" : ""), H = (w = {}, w[g] = J + "Date", w[d] = J + "Date", w[i] = J + "Month", w[l] = J + "FullYear", w[e] = J + "Hours", w[m] = J + "Minutes", w[R] = J + "Seconds", w[G] = J + "Milliseconds", w)[V], z = V === g ? this.$D + (b - this.$W) : b;
        if (V === i || V === l) {
          var Z = this.clone().set(d, 1);
          Z.$d[H](z), Z.init(), this.$d = Z.set(d, Math.min(this.$D, Z.daysInMonth())).$d;
        } else
          H && this.$d[H](z);
        return this.init(), this;
      }, N.set = function(C, b) {
        return this.clone().$set(C, b);
      }, N.get = function(C) {
        return this[A.p(C)]();
      }, N.add = function(C, b) {
        var w, V = this;
        C = Number(C);
        var J = A.p(b), H = function(ie) {
          var K = u(V);
          return A.w(K.date(K.date() + Math.round(ie * C)), V);
        };
        if (J === i)
          return this.set(i, this.$M + C);
        if (J === l)
          return this.set(l, this.$y + C);
        if (J === g)
          return H(1);
        if (J === n)
          return H(7);
        var z = (w = {}, w[m] = B, w[e] = U, w[R] = D, w)[J] || 1, Z = this.$d.getTime() + C * z;
        return A.w(Z, this);
      }, N.subtract = function(C, b) {
        return this.add(-1 * C, b);
      }, N.format = function(C) {
        var b = this, w = this.$locale();
        if (!this.isValid())
          return w.invalidDate || t;
        var V = C || "YYYY-MM-DDTHH:mm:ssZ", J = A.z(this), H = this.$H, z = this.$m, Z = this.$M, ie = w.weekdays, K = w.months, Y = function(Q, oe, de, Me) {
          return Q && (Q[oe] || Q(b, V)) || de[oe].slice(0, Me);
        }, ne = function(Q) {
          return A.s(H % 12 || 12, Q, "0");
        }, ae = w.meridiem || function(Q, oe, de) {
          var Me = Q < 12 ? "AM" : "PM";
          return de ? Me.toLowerCase() : Me;
        }, fe = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: Z + 1, MM: A.s(Z + 1, 2, "0"), MMM: Y(w.monthsShort, Z, K, 3), MMMM: Y(K, Z), D: this.$D, DD: A.s(this.$D, 2, "0"), d: String(this.$W), dd: Y(w.weekdaysMin, this.$W, ie, 2), ddd: Y(w.weekdaysShort, this.$W, ie, 3), dddd: ie[this.$W], H: String(H), HH: A.s(H, 2, "0"), h: ne(1), hh: ne(2), a: ae(H, z, !0), A: ae(H, z, !1), m: String(z), mm: A.s(z, 2, "0"), s: String(this.$s), ss: A.s(this.$s, 2, "0"), SSS: A.s(this.$ms, 3, "0"), Z: J };
        return V.replace(S, function(Q, oe) {
          return oe || fe[Q] || J.replace(":", "");
        });
      }, N.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, N.diff = function(C, b, w) {
        var V, J = A.p(b), H = u(C), z = (H.utcOffset() - this.utcOffset()) * B, Z = this - H, ie = A.m(this, H);
        return ie = (V = {}, V[l] = ie / 12, V[i] = ie, V[r] = ie / 3, V[n] = (Z - z) / 6048e5, V[g] = (Z - z) / 864e5, V[e] = Z / U, V[m] = Z / B, V[R] = Z / D, V)[J] || Z, w ? ie : A.a(ie);
      }, N.daysInMonth = function() {
        return this.endOf(i).$D;
      }, N.$locale = function() {
        return c[this.$L];
      }, N.locale = function(C, b) {
        if (!C)
          return this.$L;
        var w = this.clone(), V = y(C, b, !0);
        return V && (w.$L = V), w;
      }, N.clone = function() {
        return A.w(this.$d, this);
      }, N.toDate = function() {
        return new Date(this.valueOf());
      }, N.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, N.toISOString = function() {
        return this.$d.toISOString();
      }, N.toString = function() {
        return this.$d.toUTCString();
      }, E;
    }(), M = I.prototype;
    return u.prototype = M, [["$ms", G], ["$s", R], ["$m", m], ["$H", e], ["$W", g], ["$M", i], ["$y", l], ["$D", d]].forEach(function(E) {
      M[E[1]] = function(N) {
        return this.$g(N, E[0], E[1]);
      };
    }), u.extend = function(E, N) {
      return E.$i || (E(N, I, u), E.$i = !0), u;
    }, u.locale = y, u.isDayjs = o, u.unix = function(E) {
      return u(1e3 * E);
    }, u.en = c[v], u.Ls = c, u.p = {}, u;
  });
})(Nl);
var Cl = Nl.exports;
const sr = /* @__PURE__ */ Di(Cl), FE = { class: "input-group" }, BE = ["id", "for"], zE = /* @__PURE__ */ Ct({
  __name: "KDatePicker",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    inputId: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: null },
    labelText: { default: "" },
    class: { default: "" },
    disabled: { type: Boolean },
    dateFormat: { default: "dd/mm/yy" },
    useUTC: { type: Boolean, default: !0 },
    maxDate: { default: null },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(j, { emit: f }) {
    lt(null);
    const D = f, B = lt(), U = lt(Math.floor(Math.random() * 65536).toString(16)), G = j;
    er(
      () => G.modelValue,
      async (m) => {
        m ? B.value = G.useUTC ? sr.utc(m).local().toDate() : m : B.value = null, await Rr();
        var e = document.getElementById(G.inputId);
        if (new $r(e), !m) {
          var g = document.getElementById(U.value);
          g.classList.remove("active");
        }
      },
      { immediate: !0 }
    ), tr(() => {
      var m = document.getElementById(G.inputId);
      new $r(m);
    });
    const R = (m) => {
      if (m) {
        var e = G.useUTC ? sr(m).utc(!0).toDate() : m;
        D("update:modelValue", e);
      } else
        D("update:modelValue", null);
    };
    return (m, e) => {
      const g = Pt("Calendar");
      return Ne(), We("div", {
        class: Ot(["form-group", m.formGroupClass])
      }, [
        he("div", FE, [
          he("label", {
            id: U.value,
            for: m.inputId,
            class: "input-label-text"
          }, ft(m.labelText), 9, BE),
          gt(g, {
            ref: "kdInputText",
            id: m.id,
            hideOnDateTimeSelect: !0,
            modelValue: B.value,
            "onUpdate:modelValue": [
              e[0] || (e[0] = (n) => B.value = n),
              e[1] || (e[1] = (n) => R(n))
            ],
            class: Ot(["k-datepicker-input", m.class]),
            inputId: m.inputId,
            "append-to": "self",
            maxDate: m.maxDate,
            selectionMode: "single",
            dateFormat: m.dateFormat,
            showIcon: !0,
            disabled: m.disabled,
            manualInput: !1,
            "show-button-bar": !0
          }, null, 8, ["id", "modelValue", "class", "inputId", "maxDate", "dateFormat", "disabled"])
        ])
      ], 2);
    };
  }
}), kE = Fa("kappa-global-calendar-store", {
  state: () => ({
    calendarItems: []
  }),
  getters: {},
  actions: {
    addCalendarEventItems(j) {
      if (j && j.length > 0) {
        let f = [...this.calendarItems];
        j.forEach((D) => {
          const B = f.findIndex((U) => U.moduleKey === D.moduleKey && U.moduleId === D.moduleId);
          B < 0 ? f.push(D) : f.splice(B, 1, D);
        }), this.calendarItems = f;
      }
    }
  }
});
var YE = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var f = {}, D = Symbol("test"), B = Object(D);
  if (typeof D == "string" || Object.prototype.toString.call(D) !== "[object Symbol]" || Object.prototype.toString.call(B) !== "[object Symbol]")
    return !1;
  var U = 42;
  f[D] = U;
  for (D in f)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(f).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(f).length !== 0)
    return !1;
  var G = Object.getOwnPropertySymbols(f);
  if (G.length !== 1 || G[0] !== D || !Object.prototype.propertyIsEnumerable.call(f, D))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var R = Object.getOwnPropertyDescriptor(f, D);
    if (R.value !== U || R.enumerable !== !0)
      return !1;
  }
  return !0;
}, au = typeof Symbol < "u" && Symbol, WE = YE, KE = function() {
  return typeof au != "function" || typeof Symbol != "function" || typeof au("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : WE();
}, VE = "Function.prototype.bind called on incompatible ", $i = Array.prototype.slice, GE = Object.prototype.toString, QE = "[object Function]", HE = function(f) {
  var D = this;
  if (typeof D != "function" || GE.call(D) !== QE)
    throw new TypeError(VE + D);
  for (var B = $i.call(arguments, 1), U, G = function() {
    if (this instanceof U) {
      var n = D.apply(
        this,
        B.concat($i.call(arguments))
      );
      return Object(n) === n ? n : this;
    } else
      return D.apply(
        f,
        B.concat($i.call(arguments))
      );
  }, R = Math.max(0, D.length - B.length), m = [], e = 0; e < R; e++)
    m.push("$" + e);
  if (U = Function("binder", "return function (" + m.join(",") + "){ return binder.apply(this,arguments); }")(G), D.prototype) {
    var g = function() {
    };
    g.prototype = D.prototype, U.prototype = new g(), g.prototype = null;
  }
  return U;
}, XE = HE, ls = Function.prototype.bind || XE, $E = ls, ZE = $E.call(Function.call, Object.prototype.hasOwnProperty), qt, Jn = SyntaxError, jl = Function, Gn = TypeError, Zi = function(j) {
  try {
    return jl('"use strict"; return (' + j + ").constructor;")();
  } catch {
  }
}, Nn = Object.getOwnPropertyDescriptor;
if (Nn)
  try {
    Nn({}, "");
  } catch {
    Nn = null;
  }
var Ji = function() {
  throw new Gn();
}, JE = Nn ? function() {
  try {
    return arguments.callee, Ji;
  } catch {
    try {
      return Nn(arguments, "callee").get;
    } catch {
      return Ji;
    }
  }
}() : Ji, xn = KE(), on = Object.getPrototypeOf || function(j) {
  return j.__proto__;
}, Bn = {}, qE = typeof Uint8Array > "u" ? qt : on(Uint8Array), Qn = {
  "%AggregateError%": typeof AggregateError > "u" ? qt : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? qt : ArrayBuffer,
  "%ArrayIteratorPrototype%": xn ? on([][Symbol.iterator]()) : qt,
  "%AsyncFromSyncIteratorPrototype%": qt,
  "%AsyncFunction%": Bn,
  "%AsyncGenerator%": Bn,
  "%AsyncGeneratorFunction%": Bn,
  "%AsyncIteratorPrototype%": Bn,
  "%Atomics%": typeof Atomics > "u" ? qt : Atomics,
  "%BigInt%": typeof BigInt > "u" ? qt : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? qt : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? qt : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? qt : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? qt : FinalizationRegistry,
  "%Function%": jl,
  "%GeneratorFunction%": Bn,
  "%Int8Array%": typeof Int8Array > "u" ? qt : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? qt : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? qt : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": xn ? on(on([][Symbol.iterator]())) : qt,
  "%JSON%": typeof JSON == "object" ? JSON : qt,
  "%Map%": typeof Map > "u" ? qt : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !xn ? qt : on((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? qt : Promise,
  "%Proxy%": typeof Proxy > "u" ? qt : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? qt : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? qt : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !xn ? qt : on((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? qt : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": xn ? on(""[Symbol.iterator]()) : qt,
  "%Symbol%": xn ? Symbol : qt,
  "%SyntaxError%": Jn,
  "%ThrowTypeError%": JE,
  "%TypedArray%": qE,
  "%TypeError%": Gn,
  "%Uint8Array%": typeof Uint8Array > "u" ? qt : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? qt : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? qt : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? qt : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? qt : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? qt : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? qt : WeakSet
}, eM = function j(f) {
  var D;
  if (f === "%AsyncFunction%")
    D = Zi("async function () {}");
  else if (f === "%GeneratorFunction%")
    D = Zi("function* () {}");
  else if (f === "%AsyncGeneratorFunction%")
    D = Zi("async function* () {}");
  else if (f === "%AsyncGenerator%") {
    var B = j("%AsyncGeneratorFunction%");
    B && (D = B.prototype);
  } else if (f === "%AsyncIteratorPrototype%") {
    var U = j("%AsyncGenerator%");
    U && (D = on(U.prototype));
  }
  return Qn[f] = D, D;
}, iu = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Wa = ls, Mi = ZE, tM = Wa.call(Function.call, Array.prototype.concat), rM = Wa.call(Function.apply, Array.prototype.splice), ou = Wa.call(Function.call, String.prototype.replace), hi = Wa.call(Function.call, String.prototype.slice), nM = Wa.call(Function.call, RegExp.prototype.exec), aM = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, iM = /\\(\\)?/g, oM = function(f) {
  var D = hi(f, 0, 1), B = hi(f, -1);
  if (D === "%" && B !== "%")
    throw new Jn("invalid intrinsic syntax, expected closing `%`");
  if (B === "%" && D !== "%")
    throw new Jn("invalid intrinsic syntax, expected opening `%`");
  var U = [];
  return ou(f, aM, function(G, R, m, e) {
    U[U.length] = m ? ou(e, iM, "$1") : R || G;
  }), U;
}, sM = function(f, D) {
  var B = f, U;
  if (Mi(iu, B) && (U = iu[B], B = "%" + U[0] + "%"), Mi(Qn, B)) {
    var G = Qn[B];
    if (G === Bn && (G = eM(B)), typeof G > "u" && !D)
      throw new Gn("intrinsic " + f + " exists, but is not available. Please file an issue!");
    return {
      alias: U,
      name: B,
      value: G
    };
  }
  throw new Jn("intrinsic " + f + " does not exist!");
}, cs = function(f, D) {
  if (typeof f != "string" || f.length === 0)
    throw new Gn("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof D != "boolean")
    throw new Gn('"allowMissing" argument must be a boolean');
  if (nM(/^%?[^%]*%?$/, f) === null)
    throw new Jn("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var B = oM(f), U = B.length > 0 ? B[0] : "", G = sM("%" + U + "%", D), R = G.name, m = G.value, e = !1, g = G.alias;
  g && (U = g[0], rM(B, tM([0, 1], g)));
  for (var n = 1, i = !0; n < B.length; n += 1) {
    var r = B[n], l = hi(r, 0, 1), d = hi(r, -1);
    if ((l === '"' || l === "'" || l === "`" || d === '"' || d === "'" || d === "`") && l !== d)
      throw new Jn("property names with quotes must have matching quotes");
    if ((r === "constructor" || !i) && (e = !0), U += "." + r, R = "%" + U + "%", Mi(Qn, R))
      m = Qn[R];
    else if (m != null) {
      if (!(r in m)) {
        if (!D)
          throw new Gn("base intrinsic for " + f + " exists, but the property is not available.");
        return;
      }
      if (Nn && n + 1 >= B.length) {
        var t = Nn(m, r);
        i = !!t, i && "get" in t && !("originalValue" in t.get) ? m = t.get : m = m[r];
      } else
        i = Mi(m, r), m = m[r];
      i && !e && (Qn[R] = m);
    }
  }
  return m;
}, Ol = { exports: {} };
(function(j) {
  var f = ls, D = cs, B = D("%Function.prototype.apply%"), U = D("%Function.prototype.call%"), G = D("%Reflect.apply%", !0) || f.call(U, B), R = D("%Object.getOwnPropertyDescriptor%", !0), m = D("%Object.defineProperty%", !0), e = D("%Math.max%");
  if (m)
    try {
      m({}, "a", { value: 1 });
    } catch {
      m = null;
    }
  j.exports = function(i) {
    var r = G(f, U, arguments);
    if (R && m) {
      var l = R(r, "length");
      l.configurable && m(
        r,
        "length",
        { value: 1 + e(0, i.length - (arguments.length - 1)) }
      );
    }
    return r;
  };
  var g = function() {
    return G(f, B, arguments);
  };
  m ? m(j.exports, "apply", { value: g }) : j.exports.apply = g;
})(Ol);
var uM = Ol.exports, Pl = cs, Rl = uM, lM = Rl(Pl("String.prototype.indexOf")), cM = function(f, D) {
  var B = Pl(f, !!D);
  return typeof B == "function" && lM(f, ".prototype.") > -1 ? Rl(B) : B;
}, fs = typeof Map == "function" && Map.prototype, qi = Object.getOwnPropertyDescriptor && fs ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, _i = fs && qi && typeof qi.get == "function" ? qi.get : null, fM = fs && Map.prototype.forEach, ds = typeof Set == "function" && Set.prototype, eo = Object.getOwnPropertyDescriptor && ds ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, yi = ds && eo && typeof eo.get == "function" ? eo.get : null, dM = ds && Set.prototype.forEach, gM = typeof WeakMap == "function" && WeakMap.prototype, Aa = gM ? WeakMap.prototype.has : null, mM = typeof WeakSet == "function" && WeakSet.prototype, Sa = mM ? WeakSet.prototype.has : null, EM = typeof WeakRef == "function" && WeakRef.prototype, su = EM ? WeakRef.prototype.deref : null, MM = Boolean.prototype.valueOf, hM = Object.prototype.toString, _M = Function.prototype.toString, yM = String.prototype.match, gs = String.prototype.slice, fn = String.prototype.replace, vM = String.prototype.toUpperCase, uu = String.prototype.toLowerCase, bl = RegExp.prototype.test, lu = Array.prototype.concat, kr = Array.prototype.join, pM = Array.prototype.slice, cu = Math.floor, Io = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, to = Object.getOwnPropertySymbols, Ao = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, qn = typeof Symbol == "function" && typeof Symbol.iterator == "object", yr = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === qn || "symbol") ? Symbol.toStringTag : null, xl = Object.prototype.propertyIsEnumerable, fu = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(j) {
  return j.__proto__;
} : null);
function du(j, f) {
  if (j === 1 / 0 || j === -1 / 0 || j !== j || j && j > -1e3 && j < 1e3 || bl.call(/e/, f))
    return f;
  var D = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof j == "number") {
    var B = j < 0 ? -cu(-j) : cu(j);
    if (B !== j) {
      var U = String(B), G = gs.call(f, U.length + 1);
      return fn.call(U, D, "$&_") + "." + fn.call(fn.call(G, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return fn.call(f, D, "$&_");
}
var So = qm, gu = So.custom, mu = Ul(gu) ? gu : null, TM = function j(f, D, B, U) {
  var G = D || {};
  if (sn(G, "quoteStyle") && G.quoteStyle !== "single" && G.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (sn(G, "maxStringLength") && (typeof G.maxStringLength == "number" ? G.maxStringLength < 0 && G.maxStringLength !== 1 / 0 : G.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var R = sn(G, "customInspect") ? G.customInspect : !0;
  if (typeof R != "boolean" && R !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (sn(G, "indent") && G.indent !== null && G.indent !== "	" && !(parseInt(G.indent, 10) === G.indent && G.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (sn(G, "numericSeparator") && typeof G.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var m = G.numericSeparator;
  if (typeof f > "u")
    return "undefined";
  if (f === null)
    return "null";
  if (typeof f == "boolean")
    return f ? "true" : "false";
  if (typeof f == "string")
    return Bl(f, G);
  if (typeof f == "number") {
    if (f === 0)
      return 1 / 0 / f > 0 ? "0" : "-0";
    var e = String(f);
    return m ? du(f, e) : e;
  }
  if (typeof f == "bigint") {
    var g = String(f) + "n";
    return m ? du(f, g) : g;
  }
  var n = typeof G.depth > "u" ? 5 : G.depth;
  if (typeof B > "u" && (B = 0), B >= n && n > 0 && typeof f == "object")
    return Do(f) ? "[Array]" : "[Object]";
  var i = zM(G, B);
  if (typeof U > "u")
    U = [];
  else if (Fl(U, f) >= 0)
    return "[Circular]";
  function r(E, N, C) {
    if (N && (U = pM.call(U), U.push(N)), C) {
      var b = {
        depth: G.depth
      };
      return sn(G, "quoteStyle") && (b.quoteStyle = G.quoteStyle), j(E, b, B + 1, U);
    }
    return j(E, G, B + 1, U);
  }
  if (typeof f == "function" && !Eu(f)) {
    var l = OM(f), d = qa(f, r);
    return "[Function" + (l ? ": " + l : " (anonymous)") + "]" + (d.length > 0 ? " { " + kr.call(d, ", ") + " }" : "");
  }
  if (Ul(f)) {
    var t = qn ? fn.call(String(f), /^(Symbol\(.*\))_[^)]*$/, "$1") : Ao.call(f);
    return typeof f == "object" && !qn ? ma(t) : t;
  }
  if (UM(f)) {
    for (var T = "<" + uu.call(String(f.nodeName)), S = f.attributes || [], h = 0; h < S.length; h++)
      T += " " + S[h].name + "=" + wl(LM(S[h].value), "double", G);
    return T += ">", f.childNodes && f.childNodes.length && (T += "..."), T += "</" + uu.call(String(f.nodeName)) + ">", T;
  }
  if (Do(f)) {
    if (f.length === 0)
      return "[]";
    var _ = qa(f, r);
    return i && !BM(_) ? "[" + No(_, i) + "]" : "[ " + kr.call(_, ", ") + " ]";
  }
  if (AM(f)) {
    var L = qa(f, r);
    return !("cause" in Error.prototype) && "cause" in f && !xl.call(f, "cause") ? "{ [" + String(f) + "] " + kr.call(lu.call("[cause]: " + r(f.cause), L), ", ") + " }" : L.length === 0 ? "[" + String(f) + "]" : "{ [" + String(f) + "] " + kr.call(L, ", ") + " }";
  }
  if (typeof f == "object" && R) {
    if (mu && typeof f[mu] == "function" && So)
      return So(f, { depth: n - B });
    if (R !== "symbol" && typeof f.inspect == "function")
      return f.inspect();
  }
  if (PM(f)) {
    var v = [];
    return fM.call(f, function(E, N) {
      v.push(r(N, f, !0) + " => " + r(E, f));
    }), Mu("Map", _i.call(f), v, i);
  }
  if (xM(f)) {
    var c = [];
    return dM.call(f, function(E) {
      c.push(r(E, f));
    }), Mu("Set", yi.call(f), c, i);
  }
  if (RM(f))
    return ro("WeakMap");
  if (wM(f))
    return ro("WeakSet");
  if (bM(f))
    return ro("WeakRef");
  if (DM(f))
    return ma(r(Number(f)));
  if (CM(f))
    return ma(r(Io.call(f)));
  if (NM(f))
    return ma(MM.call(f));
  if (SM(f))
    return ma(r(String(f)));
  if (!IM(f) && !Eu(f)) {
    var o = qa(f, r), y = fu ? fu(f) === Object.prototype : f instanceof Object || f.constructor === Object, u = f instanceof Object ? "" : "null prototype", A = !y && yr && Object(f) === f && yr in f ? gs.call(Mn(f), 8, -1) : u ? "Object" : "", I = y || typeof f.constructor != "function" ? "" : f.constructor.name ? f.constructor.name + " " : "", M = I + (A || u ? "[" + kr.call(lu.call([], A || [], u || []), ": ") + "] " : "");
    return o.length === 0 ? M + "{}" : i ? M + "{" + No(o, i) + "}" : M + "{ " + kr.call(o, ", ") + " }";
  }
  return String(f);
};
function wl(j, f, D) {
  var B = (D.quoteStyle || f) === "double" ? '"' : "'";
  return B + j + B;
}
function LM(j) {
  return fn.call(String(j), /"/g, "&quot;");
}
function Do(j) {
  return Mn(j) === "[object Array]" && (!yr || !(typeof j == "object" && yr in j));
}
function IM(j) {
  return Mn(j) === "[object Date]" && (!yr || !(typeof j == "object" && yr in j));
}
function Eu(j) {
  return Mn(j) === "[object RegExp]" && (!yr || !(typeof j == "object" && yr in j));
}
function AM(j) {
  return Mn(j) === "[object Error]" && (!yr || !(typeof j == "object" && yr in j));
}
function SM(j) {
  return Mn(j) === "[object String]" && (!yr || !(typeof j == "object" && yr in j));
}
function DM(j) {
  return Mn(j) === "[object Number]" && (!yr || !(typeof j == "object" && yr in j));
}
function NM(j) {
  return Mn(j) === "[object Boolean]" && (!yr || !(typeof j == "object" && yr in j));
}
function Ul(j) {
  if (qn)
    return j && typeof j == "object" && j instanceof Symbol;
  if (typeof j == "symbol")
    return !0;
  if (!j || typeof j != "object" || !Ao)
    return !1;
  try {
    return Ao.call(j), !0;
  } catch {
  }
  return !1;
}
function CM(j) {
  if (!j || typeof j != "object" || !Io)
    return !1;
  try {
    return Io.call(j), !0;
  } catch {
  }
  return !1;
}
var jM = Object.prototype.hasOwnProperty || function(j) {
  return j in this;
};
function sn(j, f) {
  return jM.call(j, f);
}
function Mn(j) {
  return hM.call(j);
}
function OM(j) {
  if (j.name)
    return j.name;
  var f = yM.call(_M.call(j), /^function\s*([\w$]+)/);
  return f ? f[1] : null;
}
function Fl(j, f) {
  if (j.indexOf)
    return j.indexOf(f);
  for (var D = 0, B = j.length; D < B; D++)
    if (j[D] === f)
      return D;
  return -1;
}
function PM(j) {
  if (!_i || !j || typeof j != "object")
    return !1;
  try {
    _i.call(j);
    try {
      yi.call(j);
    } catch {
      return !0;
    }
    return j instanceof Map;
  } catch {
  }
  return !1;
}
function RM(j) {
  if (!Aa || !j || typeof j != "object")
    return !1;
  try {
    Aa.call(j, Aa);
    try {
      Sa.call(j, Sa);
    } catch {
      return !0;
    }
    return j instanceof WeakMap;
  } catch {
  }
  return !1;
}
function bM(j) {
  if (!su || !j || typeof j != "object")
    return !1;
  try {
    return su.call(j), !0;
  } catch {
  }
  return !1;
}
function xM(j) {
  if (!yi || !j || typeof j != "object")
    return !1;
  try {
    yi.call(j);
    try {
      _i.call(j);
    } catch {
      return !0;
    }
    return j instanceof Set;
  } catch {
  }
  return !1;
}
function wM(j) {
  if (!Sa || !j || typeof j != "object")
    return !1;
  try {
    Sa.call(j, Sa);
    try {
      Aa.call(j, Aa);
    } catch {
      return !0;
    }
    return j instanceof WeakSet;
  } catch {
  }
  return !1;
}
function UM(j) {
  return !j || typeof j != "object" ? !1 : typeof HTMLElement < "u" && j instanceof HTMLElement ? !0 : typeof j.nodeName == "string" && typeof j.getAttribute == "function";
}
function Bl(j, f) {
  if (j.length > f.maxStringLength) {
    var D = j.length - f.maxStringLength, B = "... " + D + " more character" + (D > 1 ? "s" : "");
    return Bl(gs.call(j, 0, f.maxStringLength), f) + B;
  }
  var U = fn.call(fn.call(j, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, FM);
  return wl(U, "single", f);
}
function FM(j) {
  var f = j.charCodeAt(0), D = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[f];
  return D ? "\\" + D : "\\x" + (f < 16 ? "0" : "") + vM.call(f.toString(16));
}
function ma(j) {
  return "Object(" + j + ")";
}
function ro(j) {
  return j + " { ? }";
}
function Mu(j, f, D, B) {
  var U = B ? No(D, B) : kr.call(D, ", ");
  return j + " (" + f + ") {" + U + "}";
}
function BM(j) {
  for (var f = 0; f < j.length; f++)
    if (Fl(j[f], `
`) >= 0)
      return !1;
  return !0;
}
function zM(j, f) {
  var D;
  if (j.indent === "	")
    D = "	";
  else if (typeof j.indent == "number" && j.indent > 0)
    D = kr.call(Array(j.indent + 1), " ");
  else
    return null;
  return {
    base: D,
    prev: kr.call(Array(f + 1), D)
  };
}
function No(j, f) {
  if (j.length === 0)
    return "";
  var D = `
` + f.prev + f.base;
  return D + kr.call(j, "," + D) + `
` + f.prev;
}
function qa(j, f) {
  var D = Do(j), B = [];
  if (D) {
    B.length = j.length;
    for (var U = 0; U < j.length; U++)
      B[U] = sn(j, U) ? f(j[U], j) : "";
  }
  var G = typeof to == "function" ? to(j) : [], R;
  if (qn) {
    R = {};
    for (var m = 0; m < G.length; m++)
      R["$" + G[m]] = G[m];
  }
  for (var e in j)
    sn(j, e) && (D && String(Number(e)) === e && e < j.length || qn && R["$" + e] instanceof Symbol || (bl.call(/[^\w$]/, e) ? B.push(f(e, j) + ": " + f(j[e], j)) : B.push(e + ": " + f(j[e], j))));
  if (typeof to == "function")
    for (var g = 0; g < G.length; g++)
      xl.call(j, G[g]) && B.push("[" + f(G[g]) + "]: " + f(j[G[g]], j));
  return B;
}
var ms = cs, ua = cM, kM = TM, YM = ms("%TypeError%"), ei = ms("%WeakMap%", !0), ti = ms("%Map%", !0), WM = ua("WeakMap.prototype.get", !0), KM = ua("WeakMap.prototype.set", !0), VM = ua("WeakMap.prototype.has", !0), GM = ua("Map.prototype.get", !0), QM = ua("Map.prototype.set", !0), HM = ua("Map.prototype.has", !0), Es = function(j, f) {
  for (var D = j, B; (B = D.next) !== null; D = B)
    if (B.key === f)
      return D.next = B.next, B.next = j.next, j.next = B, B;
}, XM = function(j, f) {
  var D = Es(j, f);
  return D && D.value;
}, $M = function(j, f, D) {
  var B = Es(j, f);
  B ? B.value = D : j.next = {
    // eslint-disable-line no-param-reassign
    key: f,
    next: j.next,
    value: D
  };
}, ZM = function(j, f) {
  return !!Es(j, f);
}, JM = function() {
  var f, D, B, U = {
    assert: function(G) {
      if (!U.has(G))
        throw new YM("Side channel does not contain " + kM(G));
    },
    get: function(G) {
      if (ei && G && (typeof G == "object" || typeof G == "function")) {
        if (f)
          return WM(f, G);
      } else if (ti) {
        if (D)
          return GM(D, G);
      } else if (B)
        return XM(B, G);
    },
    has: function(G) {
      if (ei && G && (typeof G == "object" || typeof G == "function")) {
        if (f)
          return VM(f, G);
      } else if (ti) {
        if (D)
          return HM(D, G);
      } else if (B)
        return ZM(B, G);
      return !1;
    },
    set: function(G, R) {
      ei && G && (typeof G == "object" || typeof G == "function") ? (f || (f = new ei()), KM(f, G, R)) : ti ? (D || (D = new ti()), QM(D, G, R)) : (B || (B = { key: {}, next: null }), $M(B, G, R));
    }
  };
  return U;
}, qM = String.prototype.replace, eh = /%20/g, no = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, Ms = {
  default: no.RFC3986,
  formatters: {
    RFC1738: function(j) {
      return qM.call(j, eh, "+");
    },
    RFC3986: function(j) {
      return String(j);
    }
  },
  RFC1738: no.RFC1738,
  RFC3986: no.RFC3986
}, th = Ms, ao = Object.prototype.hasOwnProperty, In = Array.isArray, Br = function() {
  for (var j = [], f = 0; f < 256; ++f)
    j.push("%" + ((f < 16 ? "0" : "") + f.toString(16)).toUpperCase());
  return j;
}(), rh = function(f) {
  for (; f.length > 1; ) {
    var D = f.pop(), B = D.obj[D.prop];
    if (In(B)) {
      for (var U = [], G = 0; G < B.length; ++G)
        typeof B[G] < "u" && U.push(B[G]);
      D.obj[D.prop] = U;
    }
  }
}, zl = function(f, D) {
  for (var B = D && D.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, U = 0; U < f.length; ++U)
    typeof f[U] < "u" && (B[U] = f[U]);
  return B;
}, nh = function j(f, D, B) {
  if (!D)
    return f;
  if (typeof D != "object") {
    if (In(f))
      f.push(D);
    else if (f && typeof f == "object")
      (B && (B.plainObjects || B.allowPrototypes) || !ao.call(Object.prototype, D)) && (f[D] = !0);
    else
      return [f, D];
    return f;
  }
  if (!f || typeof f != "object")
    return [f].concat(D);
  var U = f;
  return In(f) && !In(D) && (U = zl(f, B)), In(f) && In(D) ? (D.forEach(function(G, R) {
    if (ao.call(f, R)) {
      var m = f[R];
      m && typeof m == "object" && G && typeof G == "object" ? f[R] = j(m, G, B) : f.push(G);
    } else
      f[R] = G;
  }), f) : Object.keys(D).reduce(function(G, R) {
    var m = D[R];
    return ao.call(G, R) ? G[R] = j(G[R], m, B) : G[R] = m, G;
  }, U);
}, ah = function(f, D) {
  return Object.keys(D).reduce(function(B, U) {
    return B[U] = D[U], B;
  }, f);
}, ih = function(j, f, D) {
  var B = j.replace(/\+/g, " ");
  if (D === "iso-8859-1")
    return B.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(B);
  } catch {
    return B;
  }
}, oh = function(f, D, B, U, G) {
  if (f.length === 0)
    return f;
  var R = f;
  if (typeof f == "symbol" ? R = Symbol.prototype.toString.call(f) : typeof f != "string" && (R = String(f)), B === "iso-8859-1")
    return escape(R).replace(/%u[0-9a-f]{4}/gi, function(n) {
      return "%26%23" + parseInt(n.slice(2), 16) + "%3B";
    });
  for (var m = "", e = 0; e < R.length; ++e) {
    var g = R.charCodeAt(e);
    if (g === 45 || g === 46 || g === 95 || g === 126 || g >= 48 && g <= 57 || g >= 65 && g <= 90 || g >= 97 && g <= 122 || G === th.RFC1738 && (g === 40 || g === 41)) {
      m += R.charAt(e);
      continue;
    }
    if (g < 128) {
      m = m + Br[g];
      continue;
    }
    if (g < 2048) {
      m = m + (Br[192 | g >> 6] + Br[128 | g & 63]);
      continue;
    }
    if (g < 55296 || g >= 57344) {
      m = m + (Br[224 | g >> 12] + Br[128 | g >> 6 & 63] + Br[128 | g & 63]);
      continue;
    }
    e += 1, g = 65536 + ((g & 1023) << 10 | R.charCodeAt(e) & 1023), m += Br[240 | g >> 18] + Br[128 | g >> 12 & 63] + Br[128 | g >> 6 & 63] + Br[128 | g & 63];
  }
  return m;
}, sh = function(f) {
  for (var D = [{ obj: { o: f }, prop: "o" }], B = [], U = 0; U < D.length; ++U)
    for (var G = D[U], R = G.obj[G.prop], m = Object.keys(R), e = 0; e < m.length; ++e) {
      var g = m[e], n = R[g];
      typeof n == "object" && n !== null && B.indexOf(n) === -1 && (D.push({ obj: R, prop: g }), B.push(n));
    }
  return rh(D), f;
}, uh = function(f) {
  return Object.prototype.toString.call(f) === "[object RegExp]";
}, lh = function(f) {
  return !f || typeof f != "object" ? !1 : !!(f.constructor && f.constructor.isBuffer && f.constructor.isBuffer(f));
}, ch = function(f, D) {
  return [].concat(f, D);
}, fh = function(f, D) {
  if (In(f)) {
    for (var B = [], U = 0; U < f.length; U += 1)
      B.push(D(f[U]));
    return B;
  }
  return D(f);
}, kl = {
  arrayToObject: zl,
  assign: ah,
  combine: ch,
  compact: sh,
  decode: ih,
  encode: oh,
  isBuffer: lh,
  isRegExp: uh,
  maybeMap: fh,
  merge: nh
}, Yl = JM, Co = kl, Da = Ms, dh = Object.prototype.hasOwnProperty, hu = {
  brackets: function(f) {
    return f + "[]";
  },
  comma: "comma",
  indices: function(f, D) {
    return f + "[" + D + "]";
  },
  repeat: function(f) {
    return f;
  }
}, Hr = Array.isArray, gh = String.prototype.split, mh = Array.prototype.push, Wl = function(j, f) {
  mh.apply(j, Hr(f) ? f : [f]);
}, Eh = Date.prototype.toISOString, _u = Da.default, Mr = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: Co.encode,
  encodeValuesOnly: !1,
  format: _u,
  formatter: Da.formatters[_u],
  // deprecated
  indices: !1,
  serializeDate: function(f) {
    return Eh.call(f);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Mh = function(f) {
  return typeof f == "string" || typeof f == "number" || typeof f == "boolean" || typeof f == "symbol" || typeof f == "bigint";
}, io = {}, hh = function j(f, D, B, U, G, R, m, e, g, n, i, r, l, d, t, T) {
  for (var S = f, h = T, _ = 0, L = !1; (h = h.get(io)) !== void 0 && !L; ) {
    var v = h.get(f);
    if (_ += 1, typeof v < "u") {
      if (v === _)
        throw new RangeError("Cyclic object value");
      L = !0;
    }
    typeof h.get(io) > "u" && (_ = 0);
  }
  if (typeof e == "function" ? S = e(D, S) : S instanceof Date ? S = i(S) : B === "comma" && Hr(S) && (S = Co.maybeMap(S, function(J) {
    return J instanceof Date ? i(J) : J;
  })), S === null) {
    if (G)
      return m && !d ? m(D, Mr.encoder, t, "key", r) : D;
    S = "";
  }
  if (Mh(S) || Co.isBuffer(S)) {
    if (m) {
      var c = d ? D : m(D, Mr.encoder, t, "key", r);
      if (B === "comma" && d) {
        for (var o = gh.call(String(S), ","), y = "", u = 0; u < o.length; ++u)
          y += (u === 0 ? "" : ",") + l(m(o[u], Mr.encoder, t, "value", r));
        return [l(c) + (U && Hr(S) && o.length === 1 ? "[]" : "") + "=" + y];
      }
      return [l(c) + "=" + l(m(S, Mr.encoder, t, "value", r))];
    }
    return [l(D) + "=" + l(String(S))];
  }
  var A = [];
  if (typeof S > "u")
    return A;
  var I;
  if (B === "comma" && Hr(S))
    I = [{ value: S.length > 0 ? S.join(",") || null : void 0 }];
  else if (Hr(e))
    I = e;
  else {
    var M = Object.keys(S);
    I = g ? M.sort(g) : M;
  }
  for (var E = U && Hr(S) && S.length === 1 ? D + "[]" : D, N = 0; N < I.length; ++N) {
    var C = I[N], b = typeof C == "object" && typeof C.value < "u" ? C.value : S[C];
    if (!(R && b === null)) {
      var w = Hr(S) ? typeof B == "function" ? B(E, C) : E : E + (n ? "." + C : "[" + C + "]");
      T.set(f, _);
      var V = Yl();
      V.set(io, T), Wl(A, j(
        b,
        w,
        B,
        U,
        G,
        R,
        m,
        e,
        g,
        n,
        i,
        r,
        l,
        d,
        t,
        V
      ));
    }
  }
  return A;
}, _h = function(f) {
  if (!f)
    return Mr;
  if (f.encoder !== null && typeof f.encoder < "u" && typeof f.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var D = f.charset || Mr.charset;
  if (typeof f.charset < "u" && f.charset !== "utf-8" && f.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var B = Da.default;
  if (typeof f.format < "u") {
    if (!dh.call(Da.formatters, f.format))
      throw new TypeError("Unknown format option provided.");
    B = f.format;
  }
  var U = Da.formatters[B], G = Mr.filter;
  return (typeof f.filter == "function" || Hr(f.filter)) && (G = f.filter), {
    addQueryPrefix: typeof f.addQueryPrefix == "boolean" ? f.addQueryPrefix : Mr.addQueryPrefix,
    allowDots: typeof f.allowDots > "u" ? Mr.allowDots : !!f.allowDots,
    charset: D,
    charsetSentinel: typeof f.charsetSentinel == "boolean" ? f.charsetSentinel : Mr.charsetSentinel,
    delimiter: typeof f.delimiter > "u" ? Mr.delimiter : f.delimiter,
    encode: typeof f.encode == "boolean" ? f.encode : Mr.encode,
    encoder: typeof f.encoder == "function" ? f.encoder : Mr.encoder,
    encodeValuesOnly: typeof f.encodeValuesOnly == "boolean" ? f.encodeValuesOnly : Mr.encodeValuesOnly,
    filter: G,
    format: B,
    formatter: U,
    serializeDate: typeof f.serializeDate == "function" ? f.serializeDate : Mr.serializeDate,
    skipNulls: typeof f.skipNulls == "boolean" ? f.skipNulls : Mr.skipNulls,
    sort: typeof f.sort == "function" ? f.sort : null,
    strictNullHandling: typeof f.strictNullHandling == "boolean" ? f.strictNullHandling : Mr.strictNullHandling
  };
}, yh = function(j, f) {
  var D = j, B = _h(f), U, G;
  typeof B.filter == "function" ? (G = B.filter, D = G("", D)) : Hr(B.filter) && (G = B.filter, U = G);
  var R = [];
  if (typeof D != "object" || D === null)
    return "";
  var m;
  f && f.arrayFormat in hu ? m = f.arrayFormat : f && "indices" in f ? m = f.indices ? "indices" : "repeat" : m = "indices";
  var e = hu[m];
  if (f && "commaRoundTrip" in f && typeof f.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var g = e === "comma" && f && f.commaRoundTrip;
  U || (U = Object.keys(D)), B.sort && U.sort(B.sort);
  for (var n = Yl(), i = 0; i < U.length; ++i) {
    var r = U[i];
    B.skipNulls && D[r] === null || Wl(R, hh(
      D[r],
      r,
      e,
      g,
      B.strictNullHandling,
      B.skipNulls,
      B.encode ? B.encoder : null,
      B.filter,
      B.sort,
      B.allowDots,
      B.serializeDate,
      B.format,
      B.formatter,
      B.encodeValuesOnly,
      B.charset,
      n
    ));
  }
  var l = R.join(B.delimiter), d = B.addQueryPrefix === !0 ? "?" : "";
  return B.charsetSentinel && (B.charset === "iso-8859-1" ? d += "utf8=%26%2310003%3B&" : d += "utf8=%E2%9C%93&"), l.length > 0 ? d + l : "";
}, ea = kl, jo = Object.prototype.hasOwnProperty, vh = Array.isArray, mr = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: ea.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, ph = function(j) {
  return j.replace(/&#(\d+);/g, function(f, D) {
    return String.fromCharCode(parseInt(D, 10));
  });
}, Kl = function(j, f) {
  return j && typeof j == "string" && f.comma && j.indexOf(",") > -1 ? j.split(",") : j;
}, Th = "utf8=%26%2310003%3B", Lh = "utf8=%E2%9C%93", Ih = function(f, D) {
  var B = {}, U = D.ignoreQueryPrefix ? f.replace(/^\?/, "") : f, G = D.parameterLimit === 1 / 0 ? void 0 : D.parameterLimit, R = U.split(D.delimiter, G), m = -1, e, g = D.charset;
  if (D.charsetSentinel)
    for (e = 0; e < R.length; ++e)
      R[e].indexOf("utf8=") === 0 && (R[e] === Lh ? g = "utf-8" : R[e] === Th && (g = "iso-8859-1"), m = e, e = R.length);
  for (e = 0; e < R.length; ++e)
    if (e !== m) {
      var n = R[e], i = n.indexOf("]="), r = i === -1 ? n.indexOf("=") : i + 1, l, d;
      r === -1 ? (l = D.decoder(n, mr.decoder, g, "key"), d = D.strictNullHandling ? null : "") : (l = D.decoder(n.slice(0, r), mr.decoder, g, "key"), d = ea.maybeMap(
        Kl(n.slice(r + 1), D),
        function(t) {
          return D.decoder(t, mr.decoder, g, "value");
        }
      )), d && D.interpretNumericEntities && g === "iso-8859-1" && (d = ph(d)), n.indexOf("[]=") > -1 && (d = vh(d) ? [d] : d), jo.call(B, l) ? B[l] = ea.combine(B[l], d) : B[l] = d;
    }
  return B;
}, Ah = function(j, f, D, B) {
  for (var U = B ? f : Kl(f, D), G = j.length - 1; G >= 0; --G) {
    var R, m = j[G];
    if (m === "[]" && D.parseArrays)
      R = [].concat(U);
    else {
      R = D.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var e = m.charAt(0) === "[" && m.charAt(m.length - 1) === "]" ? m.slice(1, -1) : m, g = parseInt(e, 10);
      !D.parseArrays && e === "" ? R = { 0: U } : !isNaN(g) && m !== e && String(g) === e && g >= 0 && D.parseArrays && g <= D.arrayLimit ? (R = [], R[g] = U) : e !== "__proto__" && (R[e] = U);
    }
    U = R;
  }
  return U;
}, Sh = function(f, D, B, U) {
  if (f) {
    var G = B.allowDots ? f.replace(/\.([^.[]+)/g, "[$1]") : f, R = /(\[[^[\]]*])/, m = /(\[[^[\]]*])/g, e = B.depth > 0 && R.exec(G), g = e ? G.slice(0, e.index) : G, n = [];
    if (g) {
      if (!B.plainObjects && jo.call(Object.prototype, g) && !B.allowPrototypes)
        return;
      n.push(g);
    }
    for (var i = 0; B.depth > 0 && (e = m.exec(G)) !== null && i < B.depth; ) {
      if (i += 1, !B.plainObjects && jo.call(Object.prototype, e[1].slice(1, -1)) && !B.allowPrototypes)
        return;
      n.push(e[1]);
    }
    return e && n.push("[" + G.slice(e.index) + "]"), Ah(n, D, B, U);
  }
}, Dh = function(f) {
  if (!f)
    return mr;
  if (f.decoder !== null && f.decoder !== void 0 && typeof f.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof f.charset < "u" && f.charset !== "utf-8" && f.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var D = typeof f.charset > "u" ? mr.charset : f.charset;
  return {
    allowDots: typeof f.allowDots > "u" ? mr.allowDots : !!f.allowDots,
    allowPrototypes: typeof f.allowPrototypes == "boolean" ? f.allowPrototypes : mr.allowPrototypes,
    allowSparse: typeof f.allowSparse == "boolean" ? f.allowSparse : mr.allowSparse,
    arrayLimit: typeof f.arrayLimit == "number" ? f.arrayLimit : mr.arrayLimit,
    charset: D,
    charsetSentinel: typeof f.charsetSentinel == "boolean" ? f.charsetSentinel : mr.charsetSentinel,
    comma: typeof f.comma == "boolean" ? f.comma : mr.comma,
    decoder: typeof f.decoder == "function" ? f.decoder : mr.decoder,
    delimiter: typeof f.delimiter == "string" || ea.isRegExp(f.delimiter) ? f.delimiter : mr.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof f.depth == "number" || f.depth === !1 ? +f.depth : mr.depth,
    ignoreQueryPrefix: f.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof f.interpretNumericEntities == "boolean" ? f.interpretNumericEntities : mr.interpretNumericEntities,
    parameterLimit: typeof f.parameterLimit == "number" ? f.parameterLimit : mr.parameterLimit,
    parseArrays: f.parseArrays !== !1,
    plainObjects: typeof f.plainObjects == "boolean" ? f.plainObjects : mr.plainObjects,
    strictNullHandling: typeof f.strictNullHandling == "boolean" ? f.strictNullHandling : mr.strictNullHandling
  };
}, Nh = function(j, f) {
  var D = Dh(f);
  if (j === "" || j === null || typeof j > "u")
    return D.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var B = typeof j == "string" ? Ih(j, D) : j, U = D.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, G = Object.keys(B), R = 0; R < G.length; ++R) {
    var m = G[R], e = Sh(m, B[m], D, typeof j == "string");
    U = ea.merge(U, e, D);
  }
  return D.allowSparse === !0 ? U : ea.compact(U);
}, Ch = yh, jh = Nh, Oh = Ms, Ph = {
  formats: Oh,
  parse: jh,
  stringify: Ch
};
const Rh = /* @__PURE__ */ Di(Ph), ri = Jc.create({
  headers: { "Content-type": "application/json" },
  withCredentials: !0,
  paramsSerializer: (j) => Rh.stringify(j, { arrayFormat: "repeat" })
}), tn = {
  online: !1,
  name: "unknown",
  version: "?"
};
function xr() {
  return {
    api: ri,
    execApiCall: async (R, m = null) => {
      m && (m.value = !0);
      try {
        return await R;
      } catch (e) {
        return console.log("Error executing api call: " + e), null;
      } finally {
        m && (m.value = !1);
      }
    },
    configureApiUrl: (R) => {
      ri.defaults.baseURL = R;
    },
    initializePlatform: async (R) => {
      try {
        const m = await ri.get("platform/info/" + R);
        if (m && m.status === 200 && m.data) {
          const e = {
            //title: response.data.intranetTitle,
            modules: m.data.modules
          };
          return e == null, e;
        }
      } catch {
        console.error(`Failed call to DP365+ Api info for app type '${R}'!`);
      }
      return null;
    },
    getApiStatus: async () => {
      var R, m, e;
      try {
        const g = await ri.get("status/ping");
        g && g.status === 200 && g.data && (tn.online = ((R = g.data) == null ? void 0 : R.statusCode) == "OK", tn.lastCall = /* @__PURE__ */ new Date(), tn.name = (m = g.data) == null ? void 0 : m.name, tn.version = (e = g.data) == null ? void 0 : e.version, tn.online && (tn.lastSuccesfulCall = tn.lastCall));
      } catch {
        console.error("Failed call to DP365+ Api ping!");
      }
      return tn;
    },
    kToast: {
      showInfo: (R, m = null, e = 3e3) => {
        const { _toastQueue: g } = ir();
        g.value.push({ type: "info", message: R, detail: m, life: e });
      },
      showSuccess: (R, m = null, e = 3e3) => {
        const { _toastQueue: g } = ir();
        g.value.push({ type: "success", message: R, detail: m, life: e });
      },
      showWarning: (R, m = null, e = 3e3) => {
        const { _toastQueue: g } = ir();
        g.value.push({ type: "warn", message: R, detail: m, life: e });
      },
      showError: (R, m = null, e = 3e3) => {
        const { _toastQueue: g } = ir();
        g.value.push({ type: "error", message: R, detail: m, life: e });
      }
    },
    kConfirm: {
      requireConfirm: (R, m, e = null, g = null) => {
        const { _confirmQueue: n } = ir();
        g || (g = "Conferma richiesta"), n.value.push({ title: g, message: R, accept: m, reject: e });
      }
    }
  };
}
const { api: bh } = xr();
class la {
  constructor() {
    hr(this, "_lastResponseStatus", null);
    hr(this, "tryExecute", async (f) => {
      this._lastResponseStatus = null;
      try {
        return await f;
      } catch (D) {
        console.error("Server communication error.. " + D);
        const B = D;
        return B && B.isAxiosError && B.response && (console.warn("Error status " + B.response.status + " requesting endpoint " + B.config.url), this._lastResponseStatus = B.response.status, B.response.status == 400 && (console.error(B.response.data), B.response.data), B.response.status == 500 ? console.error(B.response.data) : B.response.status == 403 || B.response.status == 401), null;
      }
    });
  }
  get api() {
    return bh;
  }
  handleApiResponse(f) {
    if (f)
      return f.success || console.warn("Server response valid but request unsuccessful.." + JSON.stringify(f.messages)), f.data;
  }
  handleApiResultSuccess(f) {
    if (f)
      return f.success || console.warn("Server response valid but request unsuccessful.." + JSON.stringify(f.messages)), f.success;
  }
  parseDownloadedFileResponse(f, D) {
    if (f) {
      let B = D;
      try {
        B = f.headers["content-disposition"].split("filename=")[1].split(";")[0].replaceAll('"', "");
      } catch {
        console.error("Errore parsing filename dopo download. Uso nome default.");
      }
      return {
        contentType: f.headers["content-type"],
        fileName: `${B}`,
        fileStream: f.data
      };
    }
  }
}
class FA {
  constructor(f) {
    hr(this, "propertyName", "");
    hr(this, "code", "");
    hr(this, "text");
    hr(this, "type", "");
    this.text = f;
  }
}
class BA {
  constructor() {
    hr(this, "pageIndex");
    hr(this, "pageSize");
    hr(this, "sortField");
    hr(this, "sortOrder");
  }
}
var xh = /* @__PURE__ */ ((j) => (j[j.Descending = -1] = "Descending", j[j.Ascending = 1] = "Ascending", j))(xh || {}), va = /* @__PURE__ */ ((j) => (j.ModuleContainer = "ModuleContainer", j.WebLink = "WebLink", j.ExternalPage = "ExternalPage", j.DMS = "DMS", j.Act = "Act", j.Learning = "Learning", j.WebExpert = "WebExpert", j.WebTv = "WebTv", j.Employee = "Employee", j.DPRDI = "DPRDI", j.Vibes = "Vibes", j.KSoar = "KSoar", j.Custom = "Custom", j))(va || {});
class wh extends la {
  async getTreeFromNode(f, D) {
    let B = null;
    return D && D > 0 && (B = { maxNumOfChildren: D }), (await this.tryExecute(
      this.api.get("CMS/node-tree/" + f, { params: B })
    )).data;
  }
  async getNode(f, D) {
    return (await this.tryExecute(
      this.api.get("CMS/node/" + f, { params: D })
    )).data;
  }
}
const Vl = new wh();
class Uh extends la {
  async getLatestVideos(f = 3, D = 0) {
    const B = {
      skip: D,
      numOfVideos: f,
      excludeHomeVideos: !1
    };
    return (await this.tryExecute(
      this.api.get("webtv/latest", { params: B })
    )).data;
  }
  async getVideoDetails(f) {
    return (await this.tryExecute(
      this.api.get(`webtv/video/${f}`)
    )).data;
  }
  async getVideoSources(f) {
    return (await this.tryExecute(
      this.api.get(`webtv/video/${f}/sources`)
    )).data;
  }
  async getRelatedVideos(f) {
    return (await this.tryExecute(
      this.api.get(`webtv/video/${f}/related`)
    )).data;
  }
  async updateVideoWatchCounter(f) {
    await this.tryExecute(
      this.api.post(`webtv/video/${f}/watch`)
    );
  }
  async searchVideos(f, D = 15, B = 0) {
    const U = {
      searchText: f,
      skip: B,
      numOfVideos: D
    };
    return (await this.tryExecute(
      this.api.get("webtv/simple-search", { params: U })
    )).data;
  }
  buildVideoAssetUrl(f) {
    return `${this.api.defaults.baseURL}webtv/${f}`;
  }
}
const Qr = new Uh();
class Fh extends la {
  async getHomeLinks() {
    return (await this.tryExecute(
      this.api.get("platform/home-links")
    )).data;
  }
}
const zA = new Fh(), Bh = { class: "k-layout-centered-wrapper" }, zh = /* @__PURE__ */ Ct({
  __name: "SplashLayout",
  setup(j) {
    const { getAppTitle: f, getAppVersion: D } = ir();
    return D(), (B, U) => (Ne(), We("div", Bh, " Caricamento... "));
  }
}), kh = { class: "k-layout-centered-wrapper" }, Yh = { class: "k-layout-version-badge" }, Wh = /* @__PURE__ */ Ct({
  __name: "AnonymousLayout",
  setup(j) {
    const { getAppTitle: f, getAppVersion: D } = ir(), B = D();
    return (U, G) => {
      const R = Pt("router-view");
      return Ne(), We(or, null, [
        he("div", kh, [
          gt(R)
        ]),
        he("div", Yh, "v. " + ft(ot(B)), 1)
      ], 64);
    };
  }
});
class Kh extends la {
  async login(f, D) {
    const { getLoginEndpoint: B } = ir(), U = B(), G = await this.tryExecute(
      this.api.post(U, { username: f, password: D })
    );
    return this._lastResponseStatus == 422 ? {
      userName: f,
      lastLoginBeforeThis: null,
      passwordExpired: !0,
      defaultLanguageId: "",
      siteId: ""
    } : G.data;
  }
  async loginWithVerificationCode(f, D) {
    ir();
    const B = "account/mfa-verify-code", U = await this.tryExecute(
      this.api.post(B, { username: f, verificationCode: D })
    );
    return this._lastResponseStatus == 422 ? {
      userName: f,
      lastLoginBeforeThis: null,
      passwordExpired: !0,
      defaultLanguageId: "",
      siteId: ""
    } : U.data;
  }
  async requestNewVerificationCode(f, D) {
    const B = "account/mfa-resend-code";
    return (await this.tryExecute(
      this.api.post(B, { username: f, channel: D })
    )).data;
  }
  async loginWithSsoToken(f) {
    const { _appType: D } = ir();
    return (await this.tryExecute(
      this.api.get(`account/sso-login/${D.value}/${f}`)
    )).data;
  }
  async logout() {
    return (await this.tryExecute(
      this.api.get("account/logout")
    )).data;
  }
  async refresh() {
    return (await this.tryExecute(
      this.api.get("account/refresh")
    )).data;
  }
  async getLoggedUserInfo() {
    return (await this.tryExecute(
      this.api.get("account/me")
    )).data;
  }
  async getUserFavourites() {
    return (await this.tryExecute(this.api.get("account/favourites"))).data;
  }
  async changePassword(f, D, B) {
    return (await this.tryExecute(
      this.api.post("account/change-password", { currentpassword: f, newpassword: D, confirmnewpassword: B })
    )).data;
  }
  async changeExpiredPassword(f, D, B, U) {
    return (await this.tryExecute(
      this.api.post("account/change-expired-password", { username: f, currentpassword: D, newpassword: B, confirmnewpassword: U })
    )).data;
  }
  async generateVerificationCode(f) {
    return (await this.tryExecute(
      this.api.post("account/generate-verification-code", { email: f })
    )).data;
  }
  async verifyVerificationCode(f, D) {
    return (await this.tryExecute(
      this.api.post("account/verify-verification-code", { email: f, verificationCode: D })
    )).data;
  }
  async resetPasswordWithToken(f, D) {
    const B = await this.tryExecute(
      this.api.post("account/reset-password-by-token", { token: f, password: D })
    );
    return console.log(B.data), B.data;
  }
}
const Ar = new Kh();
class Vh extends la {
  async getProjects() {
    const f = {}, D = await this.tryExecute(
      this.api.get("dprdi/projects", { params: f })
    );
    return D && D.status == 200 ? D.data.items : null;
  }
}
const Gh = new Vh(), Qh = ["href"], Hh = /* @__PURE__ */ Ct({
  __name: "Projects",
  setup(j) {
    const f = lt(!1), D = lt([]), { toDateString: B } = qr();
    return tr(async () => {
      f.value = !0;
      try {
        D.value = await Gh.getProjects();
      } catch {
      } finally {
        f.value = !1;
      }
    }), (U, G) => {
      const R = Pt("PageHeader"), m = Pt("Column"), e = Pt("DataTable"), g = Pt("Page");
      return Ne(), Ft(g, { loading: f.value }, {
        default: Rt(() => [
          gt(R, { title: "Progetti" }),
          gt(e, {
            value: D.value,
            "table-class": "k-data-table"
          }, {
            default: Rt(() => [
              gt(m, { header: "Cliente" }, {
                body: Rt((n) => [
                  he("span", null, ft(n.data.clienteRagSociale), 1)
                ]),
                _: 1
              }),
              gt(m, { header: "Codice" }, {
                body: Rt((n) => [
                  he("span", null, ft(n.data.codice), 1)
                ]),
                _: 1
              }),
              gt(m, { header: "Titolo" }, {
                body: Rt((n) => [
                  he("span", null, ft(n.data.titolo), 1)
                ]),
                _: 1
              }),
              gt(m, { header: "Inizio" }, {
                body: Rt((n) => [
                  he("span", null, ft(ot(B)(n.data.dataInizio)), 1)
                ]),
                _: 1
              }),
              gt(m, { header: "Fine" }, {
                body: Rt((n) => [
                  he("span", null, ft(ot(B)(n.data.dataFine)), 1)
                ]),
                _: 1
              }),
              gt(m, { header: "Inizio" }, {
                body: Rt((n) => [
                  he("span", null, [
                    he("a", {
                      href: n.data.deepLinkProgetto,
                      target: "_blank"
                    }, "APRI", 8, Qh)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["loading"]);
    };
  }
}), Gl = [
  {
    name: "projects-list",
    path: "/projects",
    component: Hh,
    meta: {
      requiresAuth: !0,
      menu: {
        order: 4,
        label: "Progetti",
        iconAsset: "icons/ico-comunicazioni.svg"
      }
    }
  }
], Xh = { class: "external-iframe-container" }, $h = ["src"], Zh = /* @__PURE__ */ Ct({
  __name: "ExternalPage",
  setup(j) {
    const f = lt(!1);
    Er();
    const D = Kr(), B = Vt(() => D.meta.menu.pageTitle), U = Vt(() => D.meta.menu.pageContent), G = () => {
      f.value = !1, clearTimeout(R);
    };
    let R;
    return tr(async () => {
      R = setTimeout(() => {
        f.value === !0 && (f.value = !1, console.warn("External page loading timeout.."));
      }, 1e4);
    }), vi(() => clearTimeout(R)), (m, e) => {
      const g = Pt("PageHeader"), n = Pt("Page");
      return Ne(), Ft(n, { loading: f.value }, {
        default: Rt(() => [
          gt(g, { title: B.value }, null, 8, ["title"]),
          he("div", Xh, [
            he("iframe", {
              src: U.value,
              onLoad: G,
              class: "external-iframe"
            }, `\r
            `, 40, $h)
          ])
        ]),
        _: 1
      }, 8, ["loading"]);
    };
  }
});
const hs = (j, f) => {
  const D = j.__vccOpts || j;
  for (const [B, U] of f)
    D[B] = U;
  return D;
}, Ql = /* @__PURE__ */ hs(Zh, [["__scopeId", "data-v-6147e4de"]]), kA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ql
}, Symbol.toStringTag, { value: "Module" })), { execApiCall: zr } = xr(), Pr = Fa("kappa-user-store", {
  state: () => ({
    userAuthData: void 0,
    user: null,
    userInfo: null,
    userFavourites: [],
    systemFavourites: [],
    userRoutes: []
  }),
  getters: {
    isLogged(j) {
      if (j.userAuthData && j.userAuthData.userName) {
        const f = j.userAuthData.userName.length > 0 && j.userAuthData.passwordExpired === !0, D = j.userAuthData.userName.length > 0 && j.userAuthData.requireVerificationCode === !0;
        return !(f || D);
      }
      return !1;
    },
    userDisplayName(j) {
      return j.user && j.user.displayName && j.user.displayName.length > 0 ? (j.user.displayName.split(" ").length > 3, j.user.displayName) : "unknown";
    }
  },
  actions: {
    async changePassword(j, f, D) {
      return await zr(Ar.changePassword(j, f, D));
    },
    async changeExpiredPassword(j, f, D) {
      const B = await zr(Ar.changeExpiredPassword(this.userAuthData.userName, j, f, D));
      return B && B.success === !0 ? (await this.login(this.userAuthData.userName, f), !0) : !1;
    },
    async login(j, f) {
      const D = await zr(Ar.login(j.trim(), f.trim()));
      D && D.userName && (this.userAuthData = D, D.passwordExpired !== !0 ? await this.initUser() : console.warn("User valid but password expired."));
    },
    async loginWithVerificationCode(j) {
      var B, U;
      const f = (U = (B = this.userAuthData) == null ? void 0 : B.userName) == null ? void 0 : U.trim(), D = await zr(Ar.loginWithVerificationCode(f, j == null ? void 0 : j.trim()));
      D && D.userName && (this.userAuthData = D, D.passwordExpired !== !0 ? await this.initUser() : console.warn("User valid but password expired."));
    },
    async requestNewVerificationCode() {
      var D, B;
      const j = (B = (D = this.userAuthData) == null ? void 0 : D.userName) == null ? void 0 : B.trim();
      return await zr(Ar.requestNewVerificationCode(j, null));
    },
    async loginSso(j) {
      try {
        const f = await zr(Ar.loginWithSsoToken(j));
        if (f && f.userName)
          return this.userAuthData = f, await this.initUser(), !0;
      } catch (f) {
        console.error(f);
      }
      return !1;
    },
    async refreshToken() {
      const j = await zr(Ar.refresh());
      j && j.userName && (this.userAuthData = j);
    },
    async logout() {
      await zr(Ar.logout()) && this.$reset();
    },
    async initUser() {
      const j = await zr(Ar.getLoggedUserInfo());
      if (j && j.user) {
        const f = this.router;
        Jh(f, j), this.user = j, this.userInfo = j.user, this.userLastAccess = j.lastAccess;
        const D = await zr(Ar.getUserFavourites());
        D && (this.userFavourites = D.filter((B) => B.category.indexOf("SYSTEM.") > 0), this.systemFavourites = D.filter((B) => B.category.indexOf("SYSTEM.") == 0));
      }
    }
  }
}), Jh = (j, f) => {
  j.getRoutes().filter((m) => !m.meta || m.meta.static != !0).map((m) => m.name).filter((m) => m && m.toString().length > 0).forEach((m) => j.removeRoute(m));
  const B = j.getRoutes();
  let U = 0;
  const { getCustomModule: G } = ir(), R = f && f.userModules;
  R && R.length > 0 && R.forEach((m) => {
    if (m.moduleType != va.ModuleContainer) {
      if (B.find((g) => g.path == m.routePath))
        console.error("Tentativo di caricare un modulo aggiuntivo con route path già esistente per un modulo differente!");
      else if (m.moduleType == va.DPRDI)
        Gl.forEach((g) => {
          yu(g, U++), j.addRoute(g);
        });
      else if (m.moduleType == va.Custom) {
        const g = G(m.pageContent);
        g && g.length > 0 && g.forEach((n) => {
          yu(n, U++), j.addRoute(n);
        });
      }
    } else
      m.children && m.children.length > 0 && m.children.forEach((e) => {
        if (B.find((n) => n.path == e.routePath || e.routeName && e.routeName.length > 0 && n.name == e.routeName))
          console.error("Tentativo di caricare un modulo aggiuntivo con route path già esistente per un modulo differente!");
        else if (e.moduleType == va.ExternalPage) {
          const n = {
            path: e.routePath,
            component: Ql,
            meta: {
              requiresAuth: !0,
              menu: {
                isUserCustom: !0,
                order: e.menuOrder && e.menuOrder >= 0 ? e.menuLabel : 99,
                label: e.menuLabel,
                group: m.menuLabel,
                iconAsset: m.menuIconAsset,
                // specific to external page
                pageTitle: e.pageTitle,
                pageContent: e.pageContent
              }
            }
          };
          e.routeName && e.routeName.length > 0 ? n.name = e.routeName : n.name = "_dyn_route_" + U++, j.addRoute(n);
        }
      });
  });
}, yu = (j, f) => {
  (!j.name || j.name.toString().trim() == "") && (j.name = "_dyn_route_" + f);
}, qh = ["href", "xlink:href"], Dr = /* @__PURE__ */ Ct({
  __name: "KIcon",
  props: {
    class: { default: "" },
    svgStyle: { default: "" },
    icon: { default: "" }
  },
  setup(j) {
    const { getPathForAsset: f } = ir(), D = Vt(() => f("bi-sprites.svg#" + B.icon)), B = j;
    return (U, G) => (Ne(), We("svg", {
      class: Ot(["icon", U.class]),
      style: Or(U.svgStyle)
    }, [
      he("use", {
        href: D.value,
        "xlink:href": D.value
      }, null, 8, qh)
    ], 6));
  }
}), e_ = {
  key: 0,
  class: "d-flex justify-content-center",
  style: { "min-height": "72px" }
}, t_ = /* @__PURE__ */ he("div", { class: "progress-spinner-inner" }, null, -1), r_ = /* @__PURE__ */ he("div", { class: "progress-spinner-inner" }, null, -1), n_ = /* @__PURE__ */ he("span", { class: "visually-hidden" }, "Caricamento...", -1), a_ = [
  t_,
  r_,
  n_
], i_ = { key: 1 }, _s = /* @__PURE__ */ Ct({
  __name: "KSpinner",
  props: {
    spinnerClass: { default: "" },
    loading: { type: Boolean, default: !0 }
  },
  setup(j) {
    return (f, D) => f.loading ? (Ne(), We("div", e_, [
      he("div", {
        class: Ot(["progress-spinner progress-spinner-double progress-spinner-active", f.spinnerClass])
      }, a_, 2)
    ])) : (Ne(), We("div", i_, [
      nr(f.$slots, "default")
    ]));
  }
}), o_ = {
  class: "modal-dialog",
  role: "document"
}, s_ = { class: "modal-content perfect-scrollbar" }, u_ = {
  class: "modal-body",
  style: { "padding-bottom": "50px" }
}, l_ = { class: "container" }, c_ = { class: "row variable-gutters" }, f_ = { class: "col" }, d_ = { class: "modal-title" }, g_ = {
  class: "search-link d-md-none",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#search-modal",
  "aria-label": "Chiudi e torna alla pagina precedente",
  "data-focus-mouse": "false"
}, m_ = {
  class: "search-link d-none d-md-block",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#search-modal",
  "aria-label": "Chiudi e torna alla pagina precedente"
}, E_ = { class: "modal-body" }, Hl = /* @__PURE__ */ Ct({
  __name: "KModalFullPage",
  props: {
    modelValue: { type: Boolean },
    title: { default: "-" }
  },
  emits: ["closed", "update:modelValue"],
  setup(j, { emit: f }) {
    Ka();
    const D = j, B = f, U = "kmodal_" + Math.floor(Math.random() * 65536).toString(16);
    let G = null;
    tr(() => {
      const e = document.getElementById(U);
      G = us.getOrCreateInstance(e, {
        keyboard: !1,
        backdrop: "static",
        focus: !0
      }), G && G._element && G._element.addEventListener("hidden.bs.modal", function(g) {
        B("update:modelValue", !1), B("closed");
      });
    }), ta(() => {
      G && G.dispose();
    }), er(() => D.modelValue, (e) => {
      e === !0 ? R() : m();
    });
    const R = () => {
      G && G.show();
    }, m = () => {
      G && G.hide();
    };
    return (e, g) => (Ne(), Ft(Du, { to: "body" }, [
      he("div", {
        id: U,
        class: "modal fade search-modal",
        tabindex: "-1",
        "data-focus-mouse": "false",
        style: { display: "none" },
        "aria-hidden": "true"
      }, [
        he("div", o_, [
          he("div", s_, [
            he("div", u_, [
              he("div", l_, [
                he("div", c_, [
                  he("div", f_, [
                    he("div", d_, [
                      he("button", g_, [
                        gt(Dr, {
                          class: "icon-md",
                          icon: "it-arrow-left"
                        })
                      ]),
                      he("h2", null, ft(e.title), 1),
                      he("button", m_, [
                        gt(Dr, { icon: "it-close-big" })
                      ])
                    ]),
                    he("div", E_, [
                      nr(e.$slots, "default")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]));
  }
}), M_ = {
  key: 0,
  class: "container"
}, h_ = { class: "row justify-content-center" }, __ = { class: "col-lg-3 d-none d-lg-block scroll-filter-wrapper" }, y_ = /* @__PURE__ */ he("h2", {
  class: "visually-hidden",
  id: "filter"
}, "filtri da applicare", -1), v_ = { class: "categoy-list pb-4" }, p_ = /* @__PURE__ */ he("legend", { class: "h6 text-uppercase category-list__title" }, "Tipologie", -1), T_ = { class: "form-check" }, L_ = { class: "checkbox-body border-light py-3" }, I_ = ["id", "value"], A_ = ["for"], S_ = { class: "col-lg-8 offset-lg-1" }, D_ = { class: "d-flex justify-content-between align-items-center border-bottom border-light pb-3 mb-2" }, N_ = /* @__PURE__ */ he("h2", {
  class: "visually-hidden",
  id: "search-result"
}, "Risultati di ricerca", -1), C_ = { class: "search-results u-grey-light" }, j_ = { class: "numResult" }, O_ = {
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal-categories",
  class: "btn p-0 pe-2 d-lg-none"
}, P_ = { class: "rounded-icon" }, R_ = /* @__PURE__ */ he("span", { class: "t-primary title-xsmall-semi-bold ms-1" }, "Filtra", -1), b_ = ["disabled"], x_ = { class: "container p-0" }, w_ = { class: "row flex-column-reverse flex-lg-row" }, U_ = { class: "col-12 pt-3" }, F_ = { class: "card shadow-sm px-4 pt-4 pb-4 rounded" }, B_ = /* @__PURE__ */ he("span", { class: "visually-hidden" }, "Categoria:", -1), z_ = { class: "card-header border-0 p-0" }, k_ = { class: "text-decoration-none title-xsmall-bold mb-2 category text-uppercase" }, Y_ = { class: "card-body p-0 my-2" }, W_ = { class: "green-title-big t-primary" }, K_ = ["href"], V_ = ["innerHTML"], G_ = { class: "container p-0" }, Q_ = { class: "d-flex justify-content-center" }, H_ = ["disabled"], X_ = /* @__PURE__ */ he("span", { class: "" }, "Carica altri risultati", -1), $_ = [
  X_
], Z_ = /* @__PURE__ */ Ct({
  __name: "KModalSearchResults",
  setup(j) {
    const f = Ka();
    return (D, B) => {
      const U = Pt("router-link");
      return ot(f).lastSearchResultCount >= 0 && ot(f).results && ot(f).results.length >= 0 ? (Ne(), We("div", M_, [
        he("div", h_, [
          he("div", __, [
            y_,
            he("fieldset", null, [
              he("div", v_, [
                p_,
                he("ul", null, [
                  (Ne(!0), We(or, null, _r(ot(f).sourcesFilters, (G) => (Ne(), We("li", {
                    key: G.source
                  }, [
                    he("div", T_, [
                      he("div", L_, [
                        Cn(he("input", {
                          type: "checkbox",
                          id: G.source,
                          value: G,
                          "onUpdate:modelValue": B[0] || (B[0] = (R) => ot(f).resultSourceSelected = R),
                          class: "",
                          "data-focus-mouse": "false"
                        }, null, 8, I_), [
                          [Ro, ot(f).resultSourceSelected]
                        ]),
                        he("label", {
                          for: G.source,
                          class: "subtitle-small_semi-bold mb-0 category-list__list active"
                        }, ft(G.source) + " (" + ft(G.resultsCount) + ") ", 9, A_)
                      ])
                    ])
                  ]))), 128))
                ])
              ])
            ])
          ]),
          he("div", S_, [
            he("div", D_, [
              N_,
              he("span", C_, [
                he("span", j_, ft(ot(f).totalResultsCount), 1),
                Ht(" Risultati")
              ]),
              he("button", O_, [
                he("span", P_, [
                  gt(Dr, {
                    class: "icon-primary icon-xs",
                    "aria-hidden": "true",
                    icon: "it-funnel"
                  })
                ]),
                R_
              ]),
              he("button", {
                type: "button",
                class: "btn d-none d-lg-block btn-result",
                disabled: ot(f).lastSearchResultCount < 0,
                onClick: B[1] || (B[1] = //@ts-ignore
                (...G) => ot(f).resetSearch && ot(f).resetSearch(...G))
              }, " Rimuovi tutti i filtri ", 8, b_)
            ]),
            he("div", x_, [
              he("div", w_, [
                he("div", U_, [
                  gt(_s, {
                    loading: ot(f).searchingMore
                  }, {
                    default: Rt(() => [
                      (Ne(!0), We(or, null, _r(ot(f).filteredResults, (G, R) => (Ne(), We("div", {
                        key: R,
                        class: "cmp-card-latest-messages mb-3 mb-30",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#",
                        id: ""
                      }, [
                        he("div", F_, [
                          B_,
                          he("div", z_, [
                            he("span", k_, ft(G.source), 1)
                          ]),
                          he("div", Y_, [
                            he("h3", W_, [
                              G.urlExternal === !0 ? (Ne(), We("a", {
                                key: 0,
                                href: G.url,
                                target: "_blank",
                                class: "text-decoration-none",
                                "data-element": "service-link"
                              }, ft(G.title), 9, K_)) : (Ne(), Ft(U, {
                                key: 1,
                                to: { path: G.url },
                                class: "text-decoration-none",
                                "data-element": "service-link"
                              }, {
                                default: Rt(() => [
                                  Ht(ft(G.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            ]),
                            he("p", {
                              class: "text-paragraph",
                              innerHTML: G.description
                            }, null, 8, V_)
                          ])
                        ])
                      ]))), 128))
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]),
            he("div", G_, [
              he("div", Q_, [
                he("button", {
                  type: "button",
                  disabled: ot(f).searchingMore || ot(f).lastSearchResultCount == 0,
                  onClick: B[2] || (B[2] = (G) => ot(f).executeGlobalSearchMoreResult()),
                  class: "btn btn-outline-primary pt-15 pb-15 pl-90 pr-90 mb-30 mb-lg-50 full-mb text-button"
                }, $_, 8, H_)
              ])
            ])
          ])
        ])
      ])) : mt("", !0);
    };
  }
}), J_ = ["onSubmit"], q_ = { class: "container" }, ey = { class: "row variable-gutters" }, ty = { class: "col" }, ry = { class: "form-group autocomplete-wrapper" }, ny = {
  for: "kd-global-search-input",
  class: "visually-hidden"
}, ay = {
  class: "autocomplete-icon",
  "aria-hidden": "true",
  style: { left: "24px" }
}, iy = ["disabled"], oy = /* @__PURE__ */ Ct({
  __name: "KModalSearch",
  props: {
    title: { default: "Cerca" },
    searchTextHint: { default: "Cerca nel sito" },
    searchButtonText: { default: "Cerca" }
  },
  emits: ["closed", "startSearch"],
  setup(j, { emit: f }) {
    const D = Ka(), B = f, U = () => {
      B("closed");
    }, G = lt(!1), R = lt(null);
    er(() => D.isSearchGlobalModalOpened, (e, g) => {
      console.log(`${g} -> ${e}`), g != e && e === !0 && Rr(() => {
        Rr(() => {
          R.value && R.value.focus();
        });
      });
    });
    const m = async () => {
      B("startSearch", D.searchText), G.value = !0;
      try {
        await D.executeGlobalSearch(D.searchText);
      } finally {
        G.value = !1;
      }
    };
    return (e, g) => (Ne(), Ft(Hl, {
      title: e.title,
      modelValue: ot(D).isSearchGlobalModalOpened,
      "onUpdate:modelValue": g[1] || (g[1] = (n) => ot(D).isSearchGlobalModalOpened = n),
      onClosed: U
    }, {
      default: Rt(() => [
        he("form", {
          onSubmit: xo(m, ["prevent"])
        }, [
          he("div", q_, [
            he("div", ey, [
              he("div", ty, [
                he("div", ry, [
                  he("label", ny, ft(e.searchTextHint), 1),
                  Cn(he("input", {
                    type: "search",
                    "onUpdate:modelValue": g[0] || (g[0] = (n) => ot(D).searchText = n),
                    class: "ps-5",
                    placeholder: "Cerca nel sito",
                    id: "kd-global-search-input",
                    name: "kd-global-search-input",
                    ref_key: "kdglobalsearchinput",
                    ref: R
                  }, null, 512), [
                    [fo, ot(D).searchText]
                  ]),
                  he("span", ay, [
                    gt(Dr, { icon: "it-search" })
                  ]),
                  he("button", {
                    type: "submit",
                    disabled: ot(D).searching,
                    class: "btn btn-primary pt-15 pb-15 pl-90 pr-90 mb-30 mb-lg-50 full-mb text-button"
                  }, ft(e.searchButtonText), 9, iy)
                ])
              ])
            ])
          ])
        ], 40, J_),
        gt(_s, {
          loading: ot(D).searching
        }, {
          default: Rt(() => [
            gt(Z_)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]));
  }
}), sy = { class: "flex align-items-center layout-topbar" }, uy = /* @__PURE__ */ he("span", { class: "pi pi-bars" }, null, -1), ly = [
  uy
], cy = { class: "flex-grow-1 flex-shrink-1 flex align-items-center justify-content-start" }, fy = ["src"], dy = /* @__PURE__ */ he("div", { class: "flex-shrink-0 flex align-items-center justify-content-center" }, [
  /* @__PURE__ */ he("div", { class: "hidden md:inline-flex layout-topbar-icons" })
], -1), gy = { class: "flex-grow-1 flex-shrink-1 flex align-items-center justify-content-end" }, my = /* @__PURE__ */ he("span", { class: "visually-hidden" }, "Cerca", -1), Ey = /* @__PURE__ */ he("span", { class: "visually-hidden" }, "Notifiche", -1), My = {
  key: 0,
  class: "avatar-notificatoins-badge"
}, hy = { class: "visually-hidden" }, _y = {
  class: "avatar-wrapper avatar-extra-text",
  style: { "margin-bottom": "0" }
}, yy = ["title"], vy = { "aria-hidden": "true" }, py = { class: "visually-hidden" }, Ty = { class: "extra-text" }, Ly = ["title"], Iy = { style: { "font-size": "0.6em", "margin-top": "-5px" } }, Ay = { style: { width: "200px" } }, Sy = /* @__PURE__ */ he("hr", null, null, -1), Dy = { style: { "font-size": "x-small", padding: "0 20px" } }, Ny = { style: { "font-weight": "bold" } }, Cy = /* @__PURE__ */ he("br", null, null, -1), jy = /* @__PURE__ */ he("br", null, null, -1), Oy = /* @__PURE__ */ he("br", null, null, -1), Py = /* @__PURE__ */ Ct({
  __name: "AppTopbar",
  emits: ["menu-toggle"],
  setup(j, { emit: f }) {
    const { toDateTimeString: D } = qr(), B = f, U = Er(), G = (A) => {
      B("menu-toggle", A);
    }, R = lt(), m = async (A) => {
      R.value.toggle(A), A.preventDefault(), R.value.visible && h();
    }, { getAppTitle: e, getAppVersion: g, getPathForAsset: n, _appOptionsNotification: i } = ir(), { getApiStatus: r } = xr(), l = e(), d = g(), t = "0.8.2", T = lt(null), S = lt(!1), h = async () => {
      S.value = !0, (T.value == null || T.value.online == !1) && (T.value = await r()), S.value = !1;
    }, _ = Pr(), L = Vt(() => {
      var I = _.userDisplayName.match(/\b(\w)/g);
      return I.length > 3 && (I.length = 3), I.join("").toUpperCase();
    }), v = () => {
      _.logout();
    }, c = () => {
      U.push("/changepassword");
    }, o = Ka(), y = ys();
    let u = null;
    return tr(() => {
      y.loadUnreadNotificationsCount(), u = setInterval(
        () => {
          _.isLogged && y.loadUnreadNotificationsCount();
        },
        1e4
      );
    }), ta(() => {
      u && clearInterval(u);
    }), (A, I) => {
      var N;
      const M = Pt("router-link"), E = Pt("KIcon");
      return Ne(), We("div", sy, [
        he("div", { class: "flex-grow-0 flex-shrink-0 flex align-items-center justify-content-center layout-topbar-button-menu" }, [
          he("button", {
            class: "p-link layout-menu-button",
            onClick: G
          }, ly)
        ]),
        he("div", cy, [
          gt(M, {
            to: "/",
            class: "layout-topbar-logo"
          }, {
            default: Rt(() => [
              he("img", {
                alt: "logo",
                src: ot(n)("logo.png"),
                style: { height: "50px" }
              }, null, 8, fy)
            ]),
            _: 1
          })
        ]),
        dy,
        he("div", gy, [
          ot(o).isGlobalSearchEnabled ? (Ne(), We("a", {
            key: 0,
            class: "avatar size-lg",
            href: "#",
            onClick: I[0] || (I[0] = (C) => ot(o).isSearchGlobalModalOpened = !0)
          }, [
            gt(E, { icon: "it-search" }),
            my
          ])) : mt("", !0),
          (N = ot(i)) != null && N.hideNotificationsButton ? mt("", !0) : (Ne(), Ft(M, {
            key: 1,
            to: "/notifications",
            class: "avatar size-lg",
            "data-bs-toggle": "tooltip",
            "data-bs-html": "true",
            "data-bs-placement": "right",
            style: { margin: "0 16px", "text-decoration": "none", overflow: "visible" }
          }, {
            default: Rt(() => [
              gt(E, { icon: "it-mail" }),
              Ey,
              ot(y).totalUnreadCount > 0 ? (Ne(), We("div", My, [
                Ht(ft(ot(y).totalUnreadCount) + " ", 1),
                he("span", hy, "Unread messages: " + ft(ot(y).totalUnreadCount), 1)
              ])) : mt("", !0)
            ]),
            _: 1
          })),
          he("div", _y, [
            he("a", {
              class: "avatar avatar-primary size-lg",
              href: "#",
              onClick: m,
              role: "button",
              "data-bs-html": "true",
              "data-bs-placement": "top",
              title: ot(_).userDisplayName
            }, [
              he("p", vy, ft(L.value), 1),
              he("span", py, ft(ot(_).userDisplayName), 1)
            ], 8, yy),
            he("div", Ty, [
              he("div", {
                class: "k-user-label",
                title: ot(_).userDisplayName
              }, [
                he("a", {
                  href: "#",
                  role: "button",
                  onClick: m,
                  class: "text-primary"
                }, ft(ot(_).userDisplayName), 1)
              ], 8, Ly),
              he("div", Iy, " Ultimo accesso: " + ft(ot(D)(ot(_).userLastAccess)), 1)
            ])
          ]),
          gt(ot(qc), {
            ref_key: "opUser",
            ref: R,
            dismissable: !0,
            "append-to": ".layout-topbar",
            class: "k-usr-popup"
          }, {
            default: Rt(() => [
              he("div", Ay, [
                he("div", null, [
                  gt(ot(si), {
                    label: "Modifica password",
                    onClick: c,
                    class: "p-button-text text-primary"
                  }),
                  gt(ot(si), {
                    label: "Logout",
                    onClick: v,
                    class: "p-button-text text-primary"
                  })
                ]),
                Sy,
                he("div", Dy, [
                  he("span", Ny, ft(ot(l)), 1),
                  Cy,
                  Ht(" App version: " + ft(ot(d)) + " ", 1),
                  jy,
                  Ht(" k version: " + ft(ot(t)) + " ", 1),
                  Oy,
                  Ht(" Api version: " + ft(T.value && T.value.version), 1)
                ])
              ])
            ]),
            _: 1
          }, 512)
        ]),
        ot(o).isGlobalSearchEnabled ? (Ne(), Ft(oy, { key: 0 })) : mt("", !0)
      ]);
    };
  }
});
const Ry = { key: 0 }, by = ["onClick"], xy = ["alt", "title", "src"], wy = ["alt", "title", "src"], Uy = { key: 0 }, Fy = ["href"], By = ["alt", "title", "src"], zy = /* @__PURE__ */ Ct({
  __name: "AppSubmenu",
  props: {
    items: {},
    root: { type: Boolean, default: !1 },
    externalLinks: {}
  },
  emits: ["menuitem-click"],
  setup(j, { emit: f }) {
    const { getPathForAsset: D } = ir(), B = f, U = lt(null), G = (i, r, l) => {
      if (r.disabled) {
        i.preventDefault();
        return;
      }
      !r.to && !r.url && i.preventDefault(), r.command && r.command({ originalEvent: i, item: r }), U.value = l === U.value ? null : l, B("menuitem-click", {
        originalEvent: i,
        item: r
      });
    }, R = (i) => typeof i.visible == "function" ? i.visible() : i.visible !== !1, m = (i) => {
      i && i.isOpened && i.isOpened === !0 ? i.isOpened = !1 : i.isOpened = !0;
    }, e = Kr(), g = Er(), n = (i) => {
      var l, d;
      if (!i.to)
        return !1;
      const r = g.currentRoute.value;
      if (r && r.fullPath) {
        if (i.to == "/")
          return r.fullPath == i.to;
        const t = r.fullPath.indexOf(i.to) >= 0, T = ((l = r.fullPath.split("/")) == null ? void 0 : l.length) == ((d = i.to.split("/")) == null ? void 0 : d.length);
        return t && T;
      }
      return i.activeAliases && i.activeAliases.length > 0 ? i.activeAliases.some((t) => e.fullPath.indexOf(t) >= 0) : !1;
    };
    return (i, r) => {
      const l = Pt("router-link"), d = Pt("AppSubmenu", !0);
      return i.items ? (Ne(), We("ul", Ry, [
        (Ne(!0), We(or, null, _r(i.items, (t, T) => (Ne(), We(or, null, [
          R(t) && !t.separator ? (Ne(), We("li", {
            key: T,
            class: Ot([{ active: n(t) }]),
            role: "none"
          }, [
            t.items ? (Ne(), We("a", {
              key: 0,
              style: { opacity: "1" },
              onClick: (S) => m(t),
              class: "menu-item-group"
            }, [
              t.icon ? (Ne(), We("i", {
                key: 0,
                class: Ot(t.icon)
              }, null, 2)) : mt("", !0),
              t.iconAsset ? (Ne(), We("img", {
                key: 1,
                alt: t.label,
                title: t.label,
                src: ot(D)(t.iconAsset),
                class: "img-icon"
              }, null, 8, xy)) : mt("", !0),
              he("span", null, ft(t.label), 1),
              gt(ot(Dr), {
                icon: t.isOpened ? "it-collapse" : "it-expand",
                class: "ms-auto icon-white btn-menu-collapse"
              }, null, 8, ["icon"])
            ], 8, by)) : (Ne(), Ft(l, {
              key: 1,
              to: t.to,
              title: t.label,
              class: Ot([t.class, "p-ripple", { "active-route": n(t), "p-disabled": t.disabled }]),
              onClick: (S) => G(S, t, T),
              exact: ""
            }, {
              default: Rt(() => [
                t.icon && t.icon.length > 0 ? (Ne(), We("i", {
                  key: 0,
                  class: Ot(t.icon),
                  style: { margin: "0 5px" }
                }, null, 2)) : mt("", !0),
                t.iconAsset ? (Ne(), We("img", {
                  key: 1,
                  alt: t.label,
                  title: t.label,
                  src: ot(D)(t.iconAsset),
                  class: "img-icon"
                }, null, 8, wy)) : mt("", !0),
                he("span", {
                  class: Ot({ "menu-item-no-img": !t.icon || t.icon.length == 0 || !t.iconAsset })
                }, ft(t.label), 3)
              ]),
              _: 2
            }, 1032, ["to", "title", "class", "onClick"])),
            gt(oi, { name: "layout-submenu-wrapper" }, {
              default: Rt(() => [
                t.isOpened ? (Ne(), Ft(d, {
                  key: 0,
                  items: R(t) && t.items,
                  onMenuitemClick: r[0] || (r[0] = (S) => i.$emit("menuitem-click", S))
                }, null, 8, ["items"])) : mt("", !0)
              ]),
              _: 2
            }, 1024)
          ], 2)) : mt("", !0),
          R(t) && t.separator ? (Ne(), We("li", {
            class: "p-menu-separator",
            style: Or(t.style),
            key: "separator" + T,
            role: "separator"
          }, null, 4)) : mt("", !0)
        ], 64))), 256)),
        i.externalLinks && i.externalLinks.length > 0 ? (Ne(!0), We(or, { key: 0 }, _r(i.externalLinks, (t, T) => (Ne(), We(or, null, [
          i.root ? (Ne(), We("li", Uy, [
            he("a", {
              href: t.url,
              target: "_blank"
            }, [
              he("img", {
                alt: t.label,
                title: t.label,
                src: ot(D)(t.iconAsset),
                class: "img-icon"
              }, null, 8, By),
              he("span", null, ft(t.label), 1)
            ], 8, Fy)
          ])) : mt("", !0)
        ], 64))), 256)) : mt("", !0)
      ])) : mt("", !0);
    };
  }
});
const ky = { class: "layout-menu-container" }, Yy = /* @__PURE__ */ he("span", { class: "pi pi-bars" }, null, -1), Wy = [
  Yy
], Ky = /* @__PURE__ */ Ct({
  __name: "AppMenu",
  emits: ["menu-toggle", "menuitem-click"],
  setup(j, { emit: f }) {
    const D = Er(), B = Pr(), U = Vt(() => {
      if (!(B.user && B.isLogged))
        return [];
      const i = D.getRoutes().filter((d) => d.meta.menu).sort((d, t) => d.meta.menu.order - t.meta.menu.order);
      let r = {};
      const l = [];
      return i.forEach((d) => {
        if (d.meta.menu && d.meta.menu.group && d.meta.menu.group.length > 0) {
          const t = d.meta.menu.group;
          Object.keys(r).indexOf(t) < 0 && (r[t] = wo({
            label: t,
            //icon: 'ms-Icon ms-Icon--' + (route.meta.menu as any).icon, //'pi pi-fw pi-home',
            iconAsset: d.meta.menu.iconAsset,
            //to: route.path,
            items: [],
            isOpened: !1
          }), l.push(r[t]));
          let T = [];
          d.meta.menu.activationAliases && (T = d.meta.menu.activationAliases), r[t].items.push({
            label: R(d),
            to: G(d),
            activeAliases: T
          });
        } else {
          let t = d.meta.menu.icon;
          t && t.length > 0 && t.startsWith("pi") == !1 && (t = "ms-Icon ms-Icon--" + t);
          let T = {
            label: R(d),
            icon: t,
            iconAsset: d.meta.menu.iconAsset,
            visible: d.meta.menu.hidden !== !0,
            to: G(d),
            activeAliases: []
          };
          l.push(T);
        }
      }), l;
    }), G = (n) => {
      let i = n.path;
      const r = n.meta.menu.defaultParams;
      if (r)
        for (let l = 0; l < r.length; l++) {
          const t = r[l].split(":");
          i = i.replace(`:${t[0]}`, t[1]);
        }
      return i;
    }, R = (n) => n.meta.menu.label, m = f, e = (n) => {
      m("menu-toggle", n);
    }, g = (n) => {
      m("menuitem-click", n);
    };
    return (n, i) => (Ne(), We("div", ky, [
      he("div", { class: "layout-menu-button-container" }, [
        he("button", {
          class: "p-link layout-menu-button",
          onClick: e
        }, Wy)
      ]),
      gt(zy, {
        items: U.value,
        class: "layout-menu",
        root: !0,
        onMenuitemClick: g
      }, null, 8, ["items"])
    ]));
  }
}), Vy = /* @__PURE__ */ Ct({
  __name: "StandardLayout",
  setup(j) {
    const f = Kr();
    Er();
    const D = lt("static"), B = lt("light"), U = lt(!1), G = lt(!1), R = lt(!1), m = lt(!1), e = lt(!1);
    er(
      () => f,
      () => {
        m.value = !1;
      },
      { immediate: !0 }
    );
    const g = () => window.innerWidth > 1024, n = () => {
      e.value || (G.value = !1, R.value = !1), e.value = !1;
    }, i = () => {
      e.value = !0, g() ? D.value === "overlay" ? (R.value === !0 && (G.value = !0), G.value = !G.value, R.value = !1) : D.value === "static" && (U.value = !U.value) : R.value = !R.value;
    }, r = () => e.value = !0, l = (_) => {
      _.item && !_.item.items && (G.value = !1, R.value = !1);
    }, d = (_, L) => {
      _.classList ? _.classList.add(L) : _.className += " " + L;
    }, t = (_, L) => {
      _.classList ? _.classList.remove(L) : _.className = _.className.replace(new RegExp("(^|\\b)" + L.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }, T = () => g() ? D.value === "static" ? !U.value : D.value === "overlay" ? G.value : !0 : !0, S = Vt(() => ["layout-wrapper", {
      "layout-overlay": D.value === "overlay",
      "layout-static": D.value === "static",
      "layout-static-sidebar-inactive": U.value && D.value === "static",
      "layout-overlay-sidebar-active": G.value && D.value === "overlay",
      "layout-mobile-sidebar-active": R.value
      // 'p-input-filled': this.$appState.inputStyle === 'filled',
      // 'p-ripple-disabled': this.$primevue.ripple === false
    }]), h = Vt(() => ["layout-sidebar", {
      "layout-sidebar-dark": B.value === "dark",
      "layout-sidebar-light": B.value === "light",
      "layout-sidebar-compact": !T()
    }]);
    return Vt(() => B.value === "dark" ? "assets/layout/images/logo-white.svg" : "assets/layout/images/logo.svg"), Kc(() => {
      R.value ? d(document.body, "body-overflow-hidden") : t(document.body, "body-overflow-hidden");
    }), (_, L) => {
      const v = Pt("router-view");
      return Ne(), We("div", {
        class: Ot(S.value),
        onClick: n
      }, [
        gt(Py, { onMenuToggle: i }),
        gt(oi, { name: "layout-sidebar" }, {
          default: Rt(() => [
            he("div", {
              class: Ot(h.value),
              onClick: r
            }, [
              gt(Ky, {
                onMenuToggle: i,
                onMenuitemClick: l
              })
            ], 2)
          ]),
          _: 1
        }),
        he("div", {
          class: Ot(["layout-main", { "layout-main-compact": !T() }])
        }, [
          gt(v, null, {
            default: Rt(({ Component: c }) => [
              gt(oi, {
                name: "fade",
                mode: "out-in"
              }, {
                default: Rt(() => [
                  (Ne(), Ft(Uo(c)))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ], 2)
      ], 2);
    };
  }
});
function Gy() {
  const j = {
    splash: zh,
    default: Vy,
    anonymous: Wh
  };
  return {
    appStarting: lt(!1),
    layouts: j
    /*, layout*/
  };
}
var Qy = { exports: {} };
(function(j, f) {
  (function(D, B) {
    j.exports = B(Cl);
  })(ss, function(D) {
    function B(R) {
      return R && typeof R == "object" && "default" in R ? R : { default: R };
    }
    var U = B(D), G = { name: "it", weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"), weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"), weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"), months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"), weekStart: 1, monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"), formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "tra %s", past: "%s fa", s: "qualche secondo", m: "un minuto", mm: "%d minuti", h: "un' ora", hh: "%d ore", d: "un giorno", dd: "%d giorni", M: "un mese", MM: "%d mesi", y: "un anno", yy: "%d anni" }, ordinal: function(R) {
      return R + "º";
    } };
    return U.default.locale(G, null, !0), G;
  });
})(Qy);
sr.locale("it");
function qr() {
  return {
    capitalize: (r) => r == null ? "" : r.toUpperCase(),
    currency: (r) => isNaN(r) ? "-" : "€" + r.toFixed(2),
    toCurrencyString: (r, l = !1, d = "") => {
      if (r === 0 || r && !isNaN(r)) {
        let t = l ? "€ " : "";
        return t += r.toFixed(2), t;
      }
      return d;
    },
    fileIcon: (r) => {
      let l = "it-file";
      switch (r.split(".").pop()) {
        case "pdf":
          l = "it-file-pdf";
          break;
        case "xml":
          l = "it-file-xml";
          break;
        case "csv":
          l = "it-file-csv";
          break;
        case "xls":
        case "xlsx":
          l = "it-file-sheet";
          break;
        case "ppt":
        case "pptx":
          l = "it-file-slides";
          break;
        case "zip":
        case "rar":
        case "7z":
          l = " it-file-compressed";
          break;
      }
      return l;
    },
    toDateTimeString: (r) => r != null ? sr(r).format("DD/MM/YYYY HH:mm") : "",
    toDateString: (r) => r != null ? sr(r).format("DD/MM/YYYY") : "",
    toDateTimeLongString: (r) => r != null ? sr(r).locale("it").format("dddd, DD MMMM YYYY") : "",
    toTimeHMString: (r) => r != null ? sr(r).format("HH:mm") : "",
    toDDMMMMString: (r) => r != null ? sr(r).format("DD MMMM") : "",
    toStringDecimalNumber: (r) => r != null ? r.toFixed(2).replace(".", ",") : "",
    toDateTimeStringWithOptions: (r, l = !0) => r != null ? l ? sr.utc(r).local().format("DD/MM/YYYY HH:mm") : sr(r).format("DD/MM/YYYY HH:mm") : "",
    toTimeStringWithOptions: (r, l = !1, d = !0) => {
      if (r != null) {
        const t = d ? sr.utc(r).local() : sr(r).utc();
        return l ? t.format("HH:mm:ss") : t.format("HH:mm");
      }
      return "";
    }
  };
}
const ni = qr();
var Xl = /* @__PURE__ */ ((j) => (j.required = "required", j.email = "email", j.number = "number", j.integer = "integer", j.date = "date", j.minLength = "minLength", j.maxLength = "maxLength", j.minNumber = "minNumber", j.maxNumber = "maxNumber", j.minDate = "minDate", j.maxDate = "maxDate", j.numericRange = "numericRange", j.dateRange = "dateRange", j.cap = "cap", j.codiceFiscale = "codiceFiscale", j.partitaIva = "partitaIva", j.partitaIvaOCodiceFiscale = "partitaIvaOCodiceFiscale", j.regex = "regex", j))(Xl || {});
function YA() {
  const { kToast: j } = xr(), f = lt([]);
  let D = "Ci sono errori nella compilazione del form";
  const B = (_) => f.value ? f.value.find((L) => L.name == _) : null, U = (_) => {
    D = _;
  }, G = Vt(() => {
    if (!f.value)
      return !0;
    for (let _ = 0; _ < f.value.length; _++)
      if (!f.value[_].success)
        return !1;
    return !0;
  }), R = (_, L) => {
    const v = f.value.find((c) => c.name == _);
    v ? v.rules && v.rules instanceof Array && v.rules.length > 0 && v.rules.splice(0, v.rules.length) : f.value.push({
      name: _,
      fieldValue: null,
      success: null,
      rules: L,
      errors: [],
      customErrors: [],
      messages: [],
      validate: () => n(_),
      scrollToFieldToken: null
    });
  }, m = (_) => {
    er(_, () => {
      if (!(!_.value || !f.value))
        for (let L = 0; L < f.value.length; L++) {
          const v = f.value[L], c = _.value[v.name];
          (v.fieldValue != c || // aggiorno la validazione anche se il campo ha almeno regola
          // sottoposta ad abilitazione e precedentemente è risultato non valido
          !v.success && v.rules.find((o) => o.enabled && !o.enabled()) || // aggiorno la validazione se c'è una regola custom che può dipendere
          // da altri campi
          v.rules.find((o) => o.customValidationHandler)) && (v.fieldValue = c, r(v));
        }
    }, { deep: !0 });
  }, e = () => {
    for (let _ = 0; _ < f.value.length; _++) {
      const L = f.value[_];
      i(L);
    }
  }, g = (_, L) => {
    const v = h(L);
    R(_, v);
  }, n = (_, L = !1) => {
    if (!f.value)
      return;
    const v = f.value.find((c) => c.name == _);
    return r(v, L);
  }, i = (_) => {
    _.success = null, _.scrollToFieldToken = null, _.errors.length > 0 && _.errors.splice(0, _.errors.length), _.messages.length > 0 && _.messages.splice(0, _.messages.length), _.fieldValue = null;
  }, r = (_, L = !1) => {
    var c, o, y, u, A, I, M, E, N, C, b, w, V, J, H, z, Z;
    const v = (_ == null ? void 0 : _.rules) || [];
    _.success = !0, _.scrollToFieldToken = null, _.errors.length > 0 && _.errors.splice(0, _.errors.length), _.messages.length > 0 && _.messages.splice(0, _.messages.length);
    for (let ie = 0; ie < v.length; ie++) {
      const K = v[ie];
      let Y = !0, ne = "";
      if (!K.enabled || K.enabled())
        switch (K.rule) {
          case "required":
            (_.fieldValue == null || _.fieldValue == null || _.fieldValue.toString() == "" || _.fieldValue === !1) && (Y = !1, K.message || (ne = "Il campo è obbligatorio"));
            break;
          case "email":
            (((c = _.fieldValue) == null ? void 0 : c.toString()) || "") != "" && !/^[\w-\.]+@([\w-]+\.)+[\w-]{1,4}$/.test(_.fieldValue) && (Y = !1, ne = "Inserire un'e-mail corretta");
            break;
          case "minLength":
            (((o = _.fieldValue) == null ? void 0 : o.toString()) || "") != "" && _.fieldValue.toString().length < K.minNumber && (Y = !1, ne = `Inserire un testo di minimo ${K.minNumber} caratteri`);
            break;
          case "maxLength":
            (((y = _.fieldValue) == null ? void 0 : y.toString()) || "") != "" && _.fieldValue.toString().length > K.maxNumber && (Y = !1, ne = `Inserire un testo di massimo ${K.maxNumber} caratteri`);
            break;
          case "number":
            (((u = _.fieldValue) == null ? void 0 : u.toString()) || "") != "" && isNaN(_.fieldValue) && (Y = !1, ne = "Inserire un numero valido");
            break;
          case "integer":
            (((A = _.fieldValue) == null ? void 0 : A.toString()) || "") != "" && !/^[0-9]*$/.test(_.fieldValue) && (Y = !1, ne = "Inserire un numero intero");
            break;
          case "date":
            (((I = _.fieldValue) == null ? void 0 : I.toString()) || "") != "" && (l(_.fieldValue) || (Y = !1, ne = "Indicare una data valida"));
            break;
          case "minNumber":
            (((M = _.fieldValue) == null ? void 0 : M.toString()) || "") != "" && (isNaN(_.fieldValue) || Number(_.fieldValue) < K.minNumber) && (Y = !1, ne = `Inserire un numero a partire da ${K.minNumber}`);
            break;
          case "maxNumber":
            (((E = _.fieldValue) == null ? void 0 : E.toString()) || "") != "" && (isNaN(_.fieldValue) || Number(_.fieldValue) > K.maxNumber) && (Y = !1, ne = `Inserire un numero fino a ${K.maxNumber}`);
            break;
          case "minDate":
            (((N = _.fieldValue) == null ? void 0 : N.toString()) || "") != "" && l(_.fieldValue) && sr(_.fieldValue).toDate() < K.minDate && (Y = !1, ne = `Inserire una data a partire dal ${ni.toDateString(K.minDate)}`);
            break;
          case "maxDate":
            (((C = _.fieldValue) == null ? void 0 : C.toString()) || "") != "" && l(_.fieldValue) && sr(_.fieldValue).toDate() > K.maxDate && (Y = !1, ne = `Inserire un data fino al ${ni.toDateString(K.maxDate)}`);
            break;
          case "numericRange":
            (((b = _.fieldValue) == null ? void 0 : b.toString()) || "") != "" && (isNaN(_.fieldValue) || Number(_.fieldValue) < K.minNumber || Number(_.fieldValue) > K.maxNumber) && (Y = !1, ne = `Inserire un numero fra ${K.minNumber} e ${K.maxNumber}`);
            break;
          case "dateRange":
            (((w = _.fieldValue) == null ? void 0 : w.toString()) || "") != "" && (!l(_.fieldValue) || sr(_.fieldValue).toDate() < K.minDate || sr(_.fieldValue).toDate() > K.maxDate) && (Y = !1, ne = `Inserire una data fra ${ni.toDateString(K.minDate)} e ${ni.toDateString(K.maxDate)}`);
            break;
          case "regex":
            (((V = _.fieldValue) == null ? void 0 : V.toString()) || "") != "" && !K.regex.test(_.fieldValue) && (Y = !1, ne = "Inserire un valore nel formato previsto");
            break;
          case "cap":
            (((J = _.fieldValue) == null ? void 0 : J.toString()) || "") != "" && !/^[0-9]{5}$/.test(_.fieldValue) && (Y = !1, ne = "Inserire un CAP valido");
            break;
          case "codiceFiscale":
            (((H = _.fieldValue) == null ? void 0 : H.toString()) || "") != "" && (Y = t(_.fieldValue), Y || (ne = "Inserire un codice fiscale valido"));
            break;
          case "partitaIva":
            (((z = _.fieldValue) == null ? void 0 : z.toString()) || "") != "" && (Y = d(_.fieldValue), Y || (ne = "Inserire una partita IVA valida"));
            break;
          case "partitaIvaOCodiceFiscale":
            (((Z = _.fieldValue) == null ? void 0 : Z.toString()) || "") != "" && (Y = T(_.fieldValue), Y || (ne = "Inserire una partita IVA o un codice fiscale valido"));
            break;
          default:
            K.customValidationHandler ? Y = K.customValidationHandler(_.fieldValue) : Y = !1;
            break;
        }
      Y || (_.success = !1, _.errors.push(K.rule), (K.message || "") != "" ? _.messages.push(K.message) : _.messages.push(ne), L && (_.scrollToFieldToken = Date.now()));
    }
    return _;
  }, l = (_) => sr(_).isValid(), d = (_) => {
    if (!/^[0-9]{11}$/.test(_))
      return !1;
    for (var L = 0, v = 0; v < 11; v++) {
      var c = _.charCodeAt(v) - "0".charCodeAt(0);
      (v & 1) === 1 && (c *= 2, c > 9 && (c -= 9)), L += c;
    }
    return L % 10 === 0;
  }, t = (_) => {
    if (!/^[0-9A-Z]{16}$/.test(_))
      return !1;
    for (var L = 0, v = "BAFHJNPRTVCESULDGIMOQKWZYX", c = 0; c < 15; c++) {
      var o = _[c], y = 0;
      "0" <= o && o <= "9" ? y = o.charCodeAt(0) - "0".charCodeAt(0) : y = o.charCodeAt(0) - "A".charCodeAt(0), c & 1 || (y = v.charCodeAt(y) - "A".charCodeAt(0)), L += y;
    }
    return L % 26 + "A".charCodeAt(0) === _.charCodeAt(15);
  }, T = (_) => _ ? _.length == 16 ? t(_) : _.length == 11 ? d(_) : !1 : !1, S = (_ = !0) => {
    let L = !0, v = !1;
    if (f.value)
      for (let c = 0; c < f.value.length; c++) {
        const o = f.value[c];
        r(o, !v).success || (L = !1, v = !0);
      }
    return !L && _ && j.showError("Attenzione", D), L;
  }, h = (_) => {
    const L = [];
    for (let v = 0; v < _.length; v++) {
      const c = _[v];
      let o = null, y = null;
      typeof c == "string" ? o = c : c instanceof Object && (o = Object.keys(c)[0], y = c[o]);
      const u = {};
      switch (u.rule = o, y != null && y.enabled && (u.enabled = y == null ? void 0 : y.enabled), y != null && y.message && (u.message = y == null ? void 0 : y.message), u.rule) {
        case "numericRange":
          if (y && y.min && Number(y.min))
            u.minNumber = y.min;
          else
            throw "per il range, fornire sia min che max";
          if (y && y.max && Number(y.max))
            u.maxNumber = y.max;
          else
            throw "per il range, fornire sia min che max";
          break;
        case "dateRange":
          if (y && y.min && l(y.min))
            u.minDate = sr(y.min).toDate();
          else
            throw "per il range di date, fornire sia min che max";
          if (y && y.max && l(y.max))
            u.maxDate = sr(y.max).toDate();
          else
            throw "per il range di date, fornire sia min che max";
          break;
        case "minLength":
        case "minNumber":
          if (y && Number(y))
            u.minNumber = y;
          else if (y && y.min && Number(y.min))
            u.minNumber = y.min;
          else
            throw "indicare il valore minimo per la regola " + u.rule;
          break;
        case "maxLength":
        case "maxNumber":
          if (y && Number(y))
            u.maxNumber = y;
          else if (y && y.max && Number(y.max))
            u.maxNumber = y.max;
          else
            throw "indicare il valore massimo per la regola " + u.rule;
          break;
        case "minDate":
          if (y && l(y))
            u.minDate = sr(y).toDate();
          else if (y && y.min && l(y.min))
            u.minDate = sr(y.min).toDate();
          else
            throw "indicare la data minima per la regola " + u.rule;
          break;
        case "maxDate":
          if (y && l(y))
            u.minDate = sr(y).toDate();
          else if (y && y.max && l(y.max))
            u.minDate = sr(y.max).toDate();
          else
            throw "indicare la data massima per la regola " + u.rule;
          break;
        case "regex":
          if (y && y instanceof RegExp)
            u.regex = y;
          else if (y && typeof y == "string")
            u.regex = new RegExp(y);
          else if (y && y.regex)
            u.regex = y.regex;
          else
            throw "indicare la regula expression per regola regex";
          break;
        default:
          if (!Object.values(Xl).includes(o)) {
            if (y && y.rule)
              u.customValidationHandler = y.rule;
            else
              throw "indicare l'handler di validazione per regola custom";
            if ((u.message || "").trim() == "")
              throw "indicare il messaggio di errore per regola custom";
          }
          break;
      }
      L.push(u);
    }
    return L;
  };
  return {
    bindInstanceToValidate: m,
    clearValidationState: e,
    addField: g,
    getField: B,
    validateField: n,
    validate: S,
    setMainErrorMessage: U,
    success: G,
    validateTaxCode: t,
    validateVatCode: d,
    validateVatOrTaxCode: T
  };
}
const { execApiCall: ai } = xr(), Ci = Fa("kappa-web-tv-store", {
  state: () => ({
    latestVideos: [],
    searchedVideos: [],
    searching: !1,
    advancedSearchTerm: "",
    advancedSearchResults: []
  }),
  getters: {
    //
  },
  actions: {
    getSmallThumbnailUrl(j) {
      return Qr.buildVideoAssetUrl(j.smallThumbnailUrl);
    },
    getMediumThumbnailUrl(j) {
      return Qr.buildVideoAssetUrl(j.mediumThumbnailUrl);
    },
    getLargeThumbnailUrl(j) {
      return Qr.buildVideoAssetUrl(j.largeThumbnailUrl);
    },
    async getLatestVideos(j = 3, f = 0) {
      const D = await ai(Qr.getLatestVideos());
      return D && D.length >= 0 && (this.latestVideos = D), D;
    },
    async searchVideos(j, f = 12, D = 0) {
      const B = await ai(Qr.searchVideos(j, f, D));
      return B && B.length >= 0 && (this.searchedVideos = B), B;
    },
    async advancedSearch() {
      this.searching = !0;
      try {
        this.advancedSearchTerm && this.advancedSearchTerm.trim().length > 0 ? this.advancedSearchResults = await ai(Qr.searchVideos(this.advancedSearchTerm, 12)) : this.advancedSearchResults = await ai(Qr.getLatestVideos(12));
      } catch (j) {
        console.error(j);
      } finally {
        this.searching = !1;
      }
    }
  }
});
class Hy {
  constructor() {
    hr(this, "source", "web-tv");
    hr(this, "sourceDescription", "Web TV");
    hr(this, "_lastSearch", "");
    hr(this, "_lastSkip", 0);
  }
  async searchAsync(f) {
    return this._lastSearch = f, await this._searchVideos();
  }
  async loadMoreAsync() {
    return await this._searchVideos();
  }
  async _searchVideos() {
    const f = Ci(), D = await f.searchVideos(this._lastSearch, 5, this._lastSkip), B = D.map((U) => ({
      source: this.source,
      title: U.title,
      description: U.description,
      thumbnail: f.getSmallThumbnailUrl(U),
      url: "/video/" + U.id
    }));
    return this._lastSkip = this._lastSkip + D.length, B;
  }
}
const $l = new Hy();
let Ea = null, oo = null;
const so = lt("DP365+ Kappa Application"), ii = lt(null), vu = lt(!1), uo = lt("/"), wn = [], lo = [], pu = lt(null), co = lt(), Xy = lt([]), $y = lt([]);
function ir() {
  const j = (i) => {
    i.routingOptions || (i.routingOptions = {
      routeBasePath: i.routeBasePath
    }), i.routingOptions.routerBeforeNavigateGuard || (i.routingOptions.routerBeforeNavigateGuard = i.routerBeforeNavigateGuard), i.routingOptions.customUserSignupPath || (i.routingOptions.customUserSignupPath = i.customRegistrationPagePath), so.value = i.appName, ii.value = i.appType, vu.value = i.beta === !0, uo.value = i.routingOptions.routeBasePath, pu.value = i.routingOptions.customUserSignupPath, i.notificationOptions ? co.value = i.notificationOptions : co.value = {
      hideNotificationsButton: !1,
      disableNotificationReply: !1
    };
  }, f = (i) => {
    Ea = i, Ea && Ea.modules && Ea.modules.forEach((r) => {
      r.key == "webtv" && wn.push($l);
    });
  }, D = () => {
    let i = typeof APP_NAME < "u" ? APP_NAME : "DP365+ kappa app";
    const r = so.value;
    return r && r.trim().length > 0 && (i = r.trim()), i;
  }, B = () => typeof APP_VERSION < "u" ? APP_VERSION : "1.0.0", U = () => {
    let i = "account/login-custom";
    return ii.value == "intranet" ? i = "account/login-int" : ii.value == "extranet" && (i = "account/login-ext"), i;
  }, G = (i) => {
    let r = uo.value;
    r || (r = "/"), r.endsWith("/") || (r = r + "/");
    let l = "";
    if (i)
      for (l = i; l.startsWith("/") || l.startsWith("\\"); )
        l = l.substring(1);
    return r = r + l, r;
  }, R = (i) => {
    let r = null;
    if (oo) {
      const l = oo(i), d = l;
      d && d.initModule !== void 0 ? (console.log("caricato modulo custom: " + d.name), e(d.searchPlugins, d.notificationPlugins), d.initModule(), r = d.routes) : (console.log("caricato modulo custom solo come routes.."), r = l);
    }
    return r;
  }, m = (i) => {
    oo = i;
  }, e = (i, r) => {
    i && i.forEach((l) => {
      if (l == null || l.source == null || l.searchAsync == null || l.source.trim().length == 0)
        throw new Error(`Global search plugin not valid! => '${JSON.stringify(l)}'`);
      wn.findIndex((d) => d.source.trim().toLowerCase() == l.source.trim().toLowerCase()) < 0 && wn.push(l);
    }), r && r.forEach((l) => {
      if (l == null || l.handlingModule == null)
        throw new Error(`Custom notification handler plugin not valid! => '${JSON.stringify(l)}'`);
      g(l.handlingModule) == null && lo.push(l);
    });
  }, g = (i) => lo.find((r) => {
    var l;
    return ((l = r.handlingModule) == null ? void 0 : l.trim().toLowerCase()) == (i == null ? void 0 : i.trim().toLowerCase());
  });
  return {
    // INTERNAL SERVICES STRUCTURES
    _toastQueue: Xy,
    _confirmQueue: $y,
    // GENERAL APP SETTINGS
    _appName: so,
    _appType: ii,
    _appBeta: vu,
    _appRouteBasePath: uo,
    storeAppOptions: j,
    getPathForAsset: G,
    getAppTitle: D,
    getAppVersion: B,
    getLoginEndpoint: U,
    // INITIAL APPLICATION SETUP
    _config: Ea,
    storeConfig: f,
    storePlugins: e,
    // CUSTOM MODULE RESOLVER
    setCustomModuleResolver: m,
    getCustomModule: R,
    // GLOBAL SEARCH PLUGINS
    _searchPlugins: wn,
    isGlobalSearchEnabled: () => wn && wn.length > 0,
    // NOTIFICATION SETTINGS & HANDLERS
    _appOptionsNotification: co,
    _customNotificationHandlers: lo,
    getCustomNotificationHandlerForModule: g,
    // CUSTOM routes paths
    _customRegistrationPagePath: pu
  };
}
const Ka = Fa("kappa-global-search-store", {
  state: () => ({
    isSearchGlobalModalOpened: !1,
    results: [],
    searching: !1,
    searchingMore: !1,
    searchText: "",
    resultSourceSelected: [],
    lastSearchResultCount: -1
    // -1... ricerca in stato default da avviare
  }),
  getters: {
    isGlobalSearchEnabled(j) {
      const { isGlobalSearchEnabled: f } = ir();
      return f();
    },
    sourcesFilters(j) {
      let f = [];
      const { _searchPlugins: D } = ir();
      return D.forEach((B) => {
        const U = {
          source: B.source.trim().toUpperCase(),
          resultsCount: j.results.filter((G) => G.source == B.source).length
        };
        f.push(U);
      }), f;
    },
    filteredResults(j) {
      return j.results.filter((D) => j.resultSourceSelected && j.resultSourceSelected.length > 0 ? j.resultSourceSelected.findIndex((B) => B.source == D.source.trim().toUpperCase()) >= 0 : !0);
    },
    totalResultsCount(j) {
      return j.results.length;
    }
  },
  actions: {
    // addSearchPlugin(plugin: GlobalSearchPlugin) {
    //     if(plugin == null || plugin.source == null || plugin.searchAsync == null || plugin.source.trim().length == 0) {
    //         throw new Error(`Global plugin not valid! => '${JSON.stringify(plugin)}'`);
    //     }
    //     if(this.plugins.findIndex(p => p.source.trim().toLowerCase() == plugin.source.trim().toLowerCase()) > -1) {
    //         throw new Error(`Global plugin already registered for source '${plugin.source.trim()}'`);
    //     }
    //     this.plugins.push(plugin);
    // },
    async executeGlobalSearch(j) {
      let f = [];
      this.searching = !0;
      try {
        this.results = [], this.resultSourceSelected = [];
        let D = [];
        const { _searchPlugins: B } = ir();
        B.forEach((G) => D.push(G.searchAsync(j))), (await Promise.allSettled(D)).forEach((G) => {
          G.status === "fulfilled" && f.push(...G.value);
        }), this.lastSearchResultCount = f.length, this.results = f;
      } catch (D) {
        console.warn(D);
      } finally {
        this.searching = !1;
      }
      return f;
    },
    async executeGlobalSearchMoreResult() {
      let j = [];
      this.searchingMore = !0;
      try {
        let f = [];
        const { _searchPlugins: D } = ir();
        D.forEach((U) => f.push(U.loadMoreAsync())), (await Promise.allSettled(f)).forEach((U) => {
          U.status === "fulfilled" && j.push(...U.value);
        }), this.lastSearchResultCount = j.length, this.results.push(...j);
      } catch (f) {
        console.warn(f);
      } finally {
        this.searchingMore = !1;
      }
      return j;
    },
    resetSearch() {
      this.searchText = "", this.results = [], this.resultSourceSelected = [], this.lastSearchResultCount = -1;
    }
  }
});
class Zy extends la {
  async getInAppNotifications(f) {
    const D = {
      pageIndex: f.page,
      pageSize: f.size,
      search: f.search,
      readState: f.readState
    };
    return (await this.tryExecute(
      this.api.get("notifications", { params: D })
    )).data;
  }
  async getLatestInAppNotifications(f, D) {
    const B = {
      itemsNum: f,
      onlyUnread: D
    };
    return (await this.tryExecute(
      this.api.get("notifications/latest", { params: B })
    )).data;
  }
  async getInAppUnreadNotificationsCount() {
    return (await this.tryExecute(
      this.api.get("notifications/unread-count")
    )).data;
  }
  async setNotificationRead(f) {
    return (await this.tryExecute(
      this.api.post(`notifications/${f}/read`)
    )).data;
  }
  async setNotificationUnread(f) {
    return (await this.tryExecute(
      this.api.post(`notifications/${f}/unread`)
    )).data;
  }
  async sendInAppNotification(f, D, B) {
    const U = { targetId: f, subject: D, body: B };
    return (await this.tryExecute(
      this.api.post("notifications", U)
    )).data.success;
  }
}
const un = new Zy(), { execApiCall: Ma } = xr(), ys = Fa("kappa-notifications-store", {
  state: () => ({
    filter: {
      page: 0,
      search: "",
      size: 10,
      unreadOnly: null
    },
    totalUnreadCount: 0,
    searching: !1,
    notifications: [],
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
    selectedNotification: null
  }),
  getters: {
    optionsStates(j) {
      let f = [];
      return f.push({ name: "", value: "" }), f.push({ name: "Lette", value: "true" }), f.push({ name: "Da leggere", value: "false" }), f;
    },
    optionsDepartments(j) {
      return [];
    }
  },
  actions: {
    async loadUnreadNotificationsCount() {
      try {
        this.totalUnreadCount = await Ma(un.getInAppUnreadNotificationsCount());
      } catch {
        console.warn("Unread notifications count request failed!");
      }
    },
    async loadNotifications(j = !1) {
      try {
        this.searching = !0, j && (this.filter.page = 0, this.filter.search = "", this.filter.size = 10, this.filter.unreadOnly = null), this.filter.idNotification = null;
        const f = await Ma(un.getInAppNotifications(this.filter));
        this.notifications = f.items, this.currentPage = f.currentPage, this.totalCount = f.totalCount, this.totalPages = f.totalPages;
      } finally {
        this.searching = !1;
      }
    },
    async loadNotification(j) {
      try {
        this.searching = !0, this.filter.page = 0, this.filter.search = "", this.filter.size = 10, this.filter.unreadOnly = null, this.filter.idNotification = j;
        const f = await Ma(un.getInAppNotifications(this.filter));
        this.notifications = f.items, this.currentPage = f.currentPage, this.totalCount = f.totalCount, this.totalPages = f.totalPages;
      } finally {
        this.searching = !1;
      }
    },
    async setNotificationReadState(j, f) {
      try {
        let D;
        return f == !0 ? D = await Ma(un.setNotificationRead(j)) : D = await Ma(un.setNotificationUnread(j)), this.loadUnreadNotificationsCount(), D;
      } finally {
        this.searching = !1;
      }
    },
    async sendNotification(j) {
      await un.sendInAppNotification(1, "Ecco la seconda notifica di Martedì", "Prosegue la settimana"), j === !0 && await this.loadNotifications();
    }
  }
}), Jy = {
  key: 0,
  class: "dot-container"
}, qy = ["title"], ev = /* @__PURE__ */ he("br", null, null, -1), tv = /* @__PURE__ */ Ct({
  __name: "KGlobalCalendarCompact",
  setup(j) {
    const f = kE(), D = lt("auto"), B = new ResizeObserver((m) => {
      for (const e of m)
        D.value = `${e.contentRect.width}px`;
    });
    tr(() => {
      const m = document.getElementsByClassName("k-mini-calendar")[0];
      B.observe(m);
    });
    const U = (m) => f.calendarItems.filter(
      (e) => e.dateTimeStart.getDate() === m.day && e.dateTimeStart.getMonth() === m.month && e.dateTimeStart.getFullYear() === m.year
    ), G = lt(), R = Vt(() => {
      if (G.value) {
        const m = {
          day: G.value.getDate(),
          month: G.value.getMonth(),
          year: G.value.getFullYear()
        };
        return U(m);
      }
      return [];
    });
    return (m, e) => (Ne(), We(or, null, [
      gt(ot($c), {
        modelValue: G.value,
        "onUpdate:modelValue": e[0] || (e[0] = (g) => G.value = g),
        inline: "",
        class: "k-mini-calendar"
      }, {
        date: Rt((g) => {
          var n;
          return [
            Ht(ft(g.date.day) + " ", 1),
            ((n = U(g.date)) == null ? void 0 : n.length) > 0 ? (Ne(), We("span", Jy, [
              (Ne(!0), We(or, null, _r(U(g.date), (i) => (Ne(), We("span", {
                key: i.moduleKey + i.moduleId,
                title: i.title,
                class: Ot(["dot", { "bg-primary": i.isImportant === !0 }])
              }, null, 10, qy))), 128))
            ])) : mt("", !0)
          ];
        }),
        _: 1
      }, 8, ["modelValue"]),
      he("div", {
        style: Or({ width: D.value })
      }, [
        (Ne(!0), We(or, null, _r(R.value, (g) => (Ne(), We("div", {
          class: Ot(["k-mini-calendar-detail-item", [g.isImportant === !0 ? "primary-border-color" : "neutral-1-border-color-a2"]]),
          key: g.moduleKey + g.moduleId
        }, [
          he("em", null, ft(g.title), 1),
          ev,
          Ht(" " + ft(g.description), 1)
        ], 2))), 128))
      ], 4)
    ], 64));
  }
});
const rv = { class: "lightgrey-bg-c1 k-global-search" }, nv = /* @__PURE__ */ Ct({
  __name: "KGlobalSearchBar",
  setup(j) {
    const f = Ka(), D = async () => {
      f.isSearchGlobalModalOpened = !0, await f.executeGlobalSearch(f.searchText);
    };
    return (B, U) => {
      const G = Pt("KInputText");
      return Ne(), We("div", rv, [
        gt(G, {
          icon: "it-search",
          modelValue: ot(f).searchText,
          "onUpdate:modelValue": U[0] || (U[0] = (R) => ot(f).searchText = R),
          onEnterPressed: D,
          placeholder: "CERCA",
          autofocus: !0
        }, {
          "append-container": Rt(() => [
            he("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: D
            }, "Cerca")
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]);
    };
  }
});
const av = { class: "chip-label" }, iv = ["onClick"], ov = { class: "visually-hidden" }, sv = /* @__PURE__ */ Ct({
  __name: "KInputChips",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: {},
    type: { default: ha.text },
    labelText: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(j, { emit: f }) {
    const D = lt(""), B = lt([]), U = j, G = f;
    er(
      () => D.value,
      (r) => {
        r && r !== "" && U.type === ha.email && R();
      }
    ), er(
      () => U.modelValue,
      (r) => {
        B.value = JSON.parse(JSON.stringify(r));
      }
    );
    const R = () => {
      if (D.value.includes(";") || D.value.includes(",") || D.value.includes(" ")) {
        let r = D.value.split(";");
        r.length == 1 && (r = D.value.split(",")), r.length == 1 && (r = D.value.split(" "));
        let l = 0;
        for (; l <= r.length; )
          r.forEach((d) => {
            e(d), l++;
          });
      }
    }, m = () => {
      e(D.value);
    }, e = (r) => {
      r !== "" && (U.type === ha.email ? n(r) && (U.modelValue.push(r), D.value = "", g()) : (U.modelValue.push(r), D.value = "", g()));
    }, g = () => {
      G("update:modelValue", JSON.parse(JSON.stringify(U.modelValue)));
    }, n = (r) => !!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(r), i = (r) => {
      U.modelValue.splice(U.modelValue.indexOf(r), 1), g();
    };
    return (r, l) => {
      const d = Pt("KIcon"), t = Pt("KInputText");
      return Ne(), We(or, null, [
        (Ne(!0), We(or, null, _r(U.modelValue, (T, S) => (Ne(), We("div", {
          class: "chip chip-lg alert",
          key: S
        }, [
          U.type === ot(ha).email ? (Ne(), Ft(d, {
            key: 0,
            icon: "it-user"
          })) : mt("", !0),
          he("span", av, ft(T), 1),
          he("button", {
            onClick: (h) => i(T)
          }, [
            gt(d, { icon: "it-close" }),
            he("span", ov, "Elimina " + ft(T), 1)
          ], 8, iv)
        ]))), 128)),
        gt(t, {
          labelText: U.labelText,
          modelValue: D.value,
          "onUpdate:modelValue": l[0] || (l[0] = (T) => D.value = T),
          formGroupClass: U.labelText !== "" ? "mt-4 mb-0" : "mb-0",
          onEnterPressed: m
        }, null, 8, ["labelText", "modelValue", "formGroupClass"])
      ], 64);
    };
  }
}), uv = { class: "input-group" }, lv = {
  key: 0,
  class: "input-group-prepend"
}, cv = { class: "input-group-text" }, fv = ["for"], dv = ["id", "autofocus", "placeholder", "onKeyup", "value", "readonly"], gv = { class: "input-group-append" }, mv = /* @__PURE__ */ Ct({
  __name: "KInputDate",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    icon: {},
    labelText: { default: "" },
    class: { default: "" },
    readonly: { type: Boolean, default: !1 },
    formGroupClass: { default: "" },
    placeholder: { default: null },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "enter-pressed"],
  setup(j, { emit: f }) {
    const D = lt(null);
    lt(0);
    const B = j, U = f;
    er(
      () => B.modelValue,
      async () => {
        await Rr(), new $r(D.value);
      }
    ), tr(() => {
      new $r(D.value);
    });
    const G = (m) => {
      U("update:modelValue", m.target.value);
    }, R = () => {
      U("enter-pressed");
    };
    return (m, e) => {
      const g = Pt("KIcon");
      return Ne(), We("div", {
        class: Ot(["form-group", m.formGroupClass])
      }, [
        he("div", uv, [
          m.icon ? (Ne(), We("div", lv, [
            he("div", cv, [
              gt(g, {
                class: "icon-sm",
                icon: m.icon
              }, null, 8, ["icon"])
            ])
          ])) : mt("", !0),
          he("label", {
            for: m.id,
            class: "input-label-text active"
          }, ft(m.labelText), 9, fv),
          he("input", {
            type: "date",
            class: Ot(["form-control input-control-text", B.class]),
            id: m.id,
            ref_key: "kdInputDate",
            ref: D,
            autofocus: B.autofocus,
            placeholder: B.placeholder,
            onInput: G,
            onKeyup: Yr(R, ["enter"]),
            value: m.modelValue,
            readonly: B.readonly
          }, null, 42, dv),
          he("div", gv, [
            nr(m.$slots, "append-container")
          ])
        ])
      ], 2);
    };
  }
}), Ev = ["name", "id", "multiple", "accept", "capture"], Mv = ["for"], hv = {
  key: 0,
  class: "form-feedback just-validate-error-label"
}, _v = {
  key: 1,
  class: "upload-file-list"
}, yv = { key: 2 }, vv = /* @__PURE__ */ he("span", { class: "visually-hidden" }, "File caricato:", -1), pv = { class: "upload-file-weight" }, Tv = { disabled: "" }, Lv = /* @__PURE__ */ he("span", { class: "visually-hidden" }, "Caricamento ultimato", -1), Iv = ["onClick"], Av = /* @__PURE__ */ Ct({
  __name: "KInputFile",
  props: {
    modelValue: { default: () => [] },
    inputName: { default: "" },
    inputId: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    formGroupClass: { default: "" },
    multiple: { type: Boolean, default: !1 },
    buttonLabel: { default: "Carica file" },
    showFileName: { type: Boolean, default: !0 },
    previewSize: { default: "small" },
    fileTypes: {},
    accept: { default: "" },
    capture: { type: [Boolean, String], default: !1 },
    maxFileSize: { default: 1e7 }
  },
  emits: ["update:modelValue"],
  setup(j, { emit: f }) {
    const D = j, B = f, U = lt([]), G = lt(!1), R = lt(), m = Vt(() => {
      if ((D.accept || "") != "")
        return D.accept;
      if ((D.fileTypes || "") != "")
        switch (D.fileTypes) {
          case "images":
            return "image/*";
          case "videos":
            return "video/*";
        }
      return "";
    }), e = Vt({
      get() {
        return D.modelValue;
      },
      set(h) {
        g(h || []), B("update:modelValue", h);
      }
    }), g = (h) => {
      if (U.value && U.value.length > 0)
        for (let _ = 0; _ < U.value.length; _++) {
          const L = U.value[_];
          (L || "") != "" && URL.revokeObjectURL(L);
        }
      if (U.value.length > 0 && U.value.splice(0, U.value.length), h && h instanceof Array)
        for (let _ = 0; _ < h.length; _++) {
          const L = h[_];
          if (!n(L))
            U.value.push("");
          else {
            const v = URL.createObjectURL(L);
            U.value.push(v);
          }
        }
    };
    er(D.modelValue, () => {
      g(D.modelValue || []);
    }, { immediate: !0 });
    const n = (h) => h && h.type && h.type.startsWith("image/"), i = (h) => {
      const _ = [], L = Array.from(R.value.files);
      if (D.multiple)
        for (let o = 0; o < e.value.length; o++) {
          const y = e.value[o];
          _.push(y);
        }
      G.value = !1;
      const v = _.map((o) => r(o));
      let c = !1;
      for (let o = 0; o < L.length; o++) {
        const y = L[o], u = r(y);
        if (!(v.findIndex((A) => A == u) >= 0)) {
          if (D.maxFileSize && y.size > D.maxFileSize) {
            G.value = !0, c = !0;
            continue;
          }
          _.push(y);
        }
      }
      c && d(), e.value = _;
    }, r = (h) => `${h.name}|${h.size}|${h.lastModified}`, l = (h) => {
      const _ = [];
      for (let L = 0; L < e.value.length; L++) {
        const v = e.value[L];
        h != L && _.push(v);
      }
      d(), e.value = _;
    }, d = () => {
      R.value.files = new DataTransfer().files;
    }, t = (h) => U.value[h], T = (h, _ = 1) => {
      if (Math.abs(h) < 1e3)
        return h + " B";
      const v = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      let c = -1;
      const o = 10 ** _;
      do
        h /= 1e3, ++c;
      while (Math.round(Math.abs(h) * o) / o >= 1e3 && c < v.length - 1);
      return Number(h.toFixed(_)).toLocaleString() + " " + v[c];
    }, S = () => {
      document.querySelectorAll("button.p-image-preview-indicator").forEach((h) => {
        h.onclick = (_) => {
          _.stopPropagation(), _.preventDefault();
        };
      });
    };
    return tr(() => {
      S();
    }), Po(() => {
      S();
    }), (h, _) => (Ne(), We("div", {
      class: Ot(["", h.formGroupClass])
    }, [
      he("input", {
        type: "file",
        name: h.inputName,
        id: h.inputId,
        class: "upload",
        multiple: h.multiple,
        accept: m.value,
        capture: h.capture,
        onChange: i,
        ref_key: "refFileInput",
        ref: R
      }, null, 40, Ev),
      he("label", { for: h.inputId }, [
        gt(ot(Dr), {
          class: "icon-sm",
          icon: "it-upload"
        }),
        he("span", null, ft(h.buttonLabel), 1)
      ], 8, Mv),
      G.value ? (Ne(), We("div", hv, " Selezionare file di dimensione massima " + ft(T(h.maxFileSize)), 1)) : mt("", !0),
      e.value && e.value instanceof Array && e.value.length > 0 ? (Ne(), We("ul", _v, [
        (Ne(!0), We(or, null, _r(e.value, (L, v) => (Ne(), We("li", {
          class: Ot(["upload-file success", { "no-file-name": !h.showFileName }])
        }, [
          n(L) ? (Ne(), We("div", {
            key: 0,
            class: Ot(["upload-image", { sm: h.previewSize == "small", md: h.previewSize == "medium", lg: h.previewSize == "large", xl: h.previewSize == "xl" }])
          }, [
            gt(ot(ef), {
              src: t(v),
              preview: ""
            }, null, 8, ["src"])
          ], 2)) : (Ne(), Ft(ot(Dr), {
            key: 1,
            icon: "it-file"
          })),
          h.showFileName ? (Ne(), We("p", yv, [
            vv,
            Ht(" " + ft(L.name) + " ", 1),
            he("span", pv, ft(T(L.size)), 1)
          ])) : mt("", !0),
          he("button", Tv, [
            Lv,
            he("button", {
              class: "btn",
              type: "button",
              onClick: xo((c) => l(v), ["prevent"]),
              title: "Rimuovi file"
            }, [
              gt(ot(Dr), {
                class: "icon-sm",
                icon: "it-close"
              })
            ], 8, Iv)
          ])
        ], 2))), 256))
      ])) : mt("", !0)
    ], 2));
  }
});
const Sv = { class: "input-group" }, Dv = ["for"], Nv = ["id", "value"], Cv = {
  class: "password-icon",
  "aria-hidden": "true"
}, Zl = /* @__PURE__ */ Ct({
  __name: "KInputPassword",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    labelText: { default: "" },
    class: { default: "" },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(j, { emit: f }) {
    const D = lt(null), B = f;
    lt(0);
    const U = j;
    er(
      () => U.modelValue,
      async () => {
        await Rr(), D.value.dispatchEvent(new Event("change"));
      }
    );
    let G = null, R = null;
    tr(() => {
      const e = document.getElementById(U.id);
      G || (G = $r.getOrCreateInstance(e), R = e.parentElement.getElementsByClassName("password-icon")[0], R.addEventListener("click", (g) => {
        g.stopImmediatePropagation(), e.type == "password" ? (e.type = "text", R.children[0].classList.remove("d-none"), R.children[0].classList.add("d-none"), R.children[1].classList.remove("d-none")) : (e.type = "password", R.children[1].classList.remove("d-none"), R.children[1].classList.add("d-none"), R.children[0].classList.remove("d-none"));
      }));
    }), ta(() => {
      G && (G.dispose(), R = null);
    });
    const m = (e) => {
      B("update:modelValue", e.target.value);
    };
    return (e, g) => {
      const n = Pt("KIcon");
      return Ne(), We("div", {
        class: Ot(["form-group", e.formGroupClass])
      }, [
        he("div", Sv, [
          he("label", {
            for: e.id,
            class: "input-label-text"
          }, ft(e.labelText), 9, Dv),
          he("input", {
            type: "password",
            class: "form-control input-password",
            id: e.id,
            ref_key: "kdInputPassword",
            ref: D,
            value: e.modelValue,
            onChange: m,
            onBlur: m,
            onInput: m
          }, null, 40, Nv),
          he("span", Cv, [
            gt(n, {
              class: "password-icon-visible icon icon-sm",
              icon: "it-password-visible"
            }),
            gt(n, {
              class: "password-icon-invisible icon icon-sm d-none",
              icon: "it-password-invisible"
            })
          ])
        ])
      ], 2);
    };
  }
});
const jv = { class: "d-flex" }, Ov = { class: "input-group" }, Pv = ["onKeyup", "value", "placeholder"], Rv = { class: "input-group-append" }, bv = /* @__PURE__ */ he("span", { class: "visually-hidden" }, "Cerca", -1), xv = {
  key: 0,
  class: "form-group col-auto"
}, wv = {
  key: 1,
  class: "form-group col-auto"
}, Jl = /* @__PURE__ */ Ct({
  __name: "KInputSearch",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    placeholder: { default: "Cerca per nome, tag, parola chiave" },
    moreFilterButton: { type: Boolean, default: !1 },
    formGroupClass: { default: "" }
  },
  emits: ["search", "morefilterclick", "update:modelValue"],
  setup(j, { emit: f }) {
    const D = Nu(), B = Vt(() => {
      const e = D.default;
      if (e) {
        const g = e();
        if (g.length > 0)
          return g[0].children != "v-if";
      }
      return !1;
    }), U = lt(null), G = f, R = () => {
      G("search");
    };
    tr(() => {
      new $r(U.value);
    });
    const m = (e) => {
      G("update:modelValue", e.target.value);
    };
    return (e, g) => {
      const n = Pt("KIcon");
      return Ne(), We("div", jv, [
        he("div", {
          class: Ot(["form-group col", e.formGroupClass]),
          style: { "flex-grow": "2" }
        }, [
          he("div", Ov, [
            he("input", {
              type: "search",
              style: { "background-color": "#F4F4F4", color: "#757575" },
              class: "form-control",
              onInput: m,
              onKeyup: Yr(R, ["enter"]),
              value: e.modelValue,
              ref_key: "kdSearchText",
              ref: U,
              placeholder: e.placeholder
            }, null, 40, Pv),
            he("div", Rv, [
              he("button", {
                type: "button",
                class: "btn",
                style: { padding: "0" },
                onClick: R
              }, [
                gt(n, {
                  icon: "it-search",
                  class: "icon-white",
                  style: { "background-color": "#757575", padding: "8px", height: "2.4rem", width: "2.4rem" }
                }),
                bv
              ])
            ])
          ])
        ], 2),
        B.value ? (Ne(), We("div", xv, [
          nr(e.$slots, "default")
        ])) : mt("", !0),
        e.moreFilterButton ? (Ne(), We("div", wv, [
          he("button", {
            type: "button",
            class: "btn btn-outline-primary",
            style: { height: "100%", padding: "10px 20px", "margin-left": "20px" },
            onClick: g[0] || (g[0] = (i) => G("morefilterclick"))
          }, "...")
        ])) : mt("", !0)
      ]);
    };
  }
}), Uv = { class: "input-group" }, Fv = {
  key: 0,
  class: "input-group-prepend"
}, Bv = { class: "input-group-text" }, zv = ["for"], kv = ["id", "autofocus", "placeholder", "onKeyup", "value", "readonly"], Yv = { class: "input-group-append" }, ql = /* @__PURE__ */ Ct({
  __name: "KInputText",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    icon: {},
    labelText: { default: "" },
    class: { default: "" },
    readonly: { type: Boolean, default: !1 },
    formGroupClass: { default: "" },
    placeholder: { default: null },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "enter-pressed"],
  setup(j, { emit: f }) {
    const D = lt(null), B = f;
    lt(0);
    const U = j;
    er(
      () => U.modelValue,
      async () => {
        await Rr(), D.value.dispatchEvent(new Event("change"));
      }
    ), tr(() => {
      new $r(D.value);
    });
    const G = (m) => {
      B("update:modelValue", m.target.value);
    }, R = () => {
      B("enter-pressed");
    };
    return (m, e) => {
      const g = Pt("KIcon");
      return Ne(), We("div", {
        class: Ot(["form-group", m.formGroupClass])
      }, [
        he("div", Uv, [
          m.icon ? (Ne(), We("div", Fv, [
            he("div", Bv, [
              gt(g, {
                class: "icon-sm",
                icon: m.icon
              }, null, 8, ["icon"])
            ])
          ])) : mt("", !0),
          he("label", {
            for: m.id,
            class: "input-label-text"
          }, ft(m.labelText), 9, zv),
          he("input", {
            type: "text",
            class: Ot(["form-control input-control-text", U.class]),
            id: m.id,
            ref_key: "kdInputText",
            ref: D,
            autofocus: U.autofocus,
            placeholder: U.placeholder,
            onInput: G,
            onKeyup: Yr(R, ["enter"]),
            value: m.modelValue,
            readonly: U.readonly
          }, null, 42, kv),
          he("div", Yv, [
            nr(m.$slots, "append-container")
          ])
        ])
      ], 2);
    };
  }
}), Wv = { class: "input-group" }, Kv = ["for"], Vv = ["disabled"], Gv = ["id", "name", "autofocus", "placeholder", "min", "max", "step", "value", "readonly", "disabled", "onKeyup"], Qv = ["disabled"], Hv = { class: "visually-hidden" }, Xv = ["disabled"], $v = { class: "visually-hidden" }, Zv = /* @__PURE__ */ Ct({
  __name: "KInputNumber",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    step: { default: "any" },
    min: { default: "any" },
    max: { default: "any" },
    isCurrency: { type: Boolean, default: !1 },
    isPercentage: { type: Boolean, default: !1 },
    removeButton: { type: Boolean, default: !1 },
    labelText: { default: "" },
    labelBtnAdd: { default: "Aumenta valore" },
    labelBtnDecrement: { default: "Diminuisci valore" },
    class: { default: "" },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean },
    formGroupClass: { default: "" },
    placeholder: { default: null },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "enter-pressed"],
  setup(j, { emit: f }) {
    const D = lt(null), B = f, U = j;
    er(
      () => U.modelValue,
      async () => {
        await Rr(), D.value.dispatchEvent(new Event("change"));
      }
    );
    let G = null;
    tr(() => {
      G = new is(D.value);
      let n = document.getElementById(D.value.id), i = n.parentNode.querySelectorAll("button");
      for (let r = 0; r < i.length; r++)
        i[r].addEventListener("click", function() {
          n.dispatchEvent(new Event("change"));
        });
    }), ta(() => {
      G && G.dispose();
    });
    const R = (n) => {
      B("update:modelValue", n.target.value);
    }, m = (n) => {
      B("update:modelValue", n.target.value), B("enter-pressed");
    }, e = Vt(() => U.labelBtnAdd === "Aumenta valore" ? U.isPercentage || U.isCurrency ? U.labelBtnAdd + " di " + U.step + " €" : U.labelBtnAdd + " di " + U.step : U.labelBtnAdd), g = Vt(() => U.labelBtnDecrement === "Diminuisci valore" ? U.isPercentage || U.isCurrency ? U.labelBtnDecrement + " di " + U.step + " €" : U.labelBtnDecrement + " di " + U.step : U.labelBtnDecrement);
    return (n, i) => (Ne(), We("div", {
      class: Ot(["form-group", n.formGroupClass])
    }, [
      he("div", Wv, [
        he("label", {
          for: n.id,
          class: "input-label-text input-number-label"
        }, ft(n.labelText), 9, Kv),
        he("span", {
          class: Ot(["input-number", [n.isCurrency ? "input-number-currency" : "", n.isPercentage ? "input-number-percentage" : ""]]),
          disabled: n.disabled
        }, [
          he("input", {
            type: "number",
            class: Ot(["form-control k-input-number", U.class]),
            id: U.id,
            name: U.id,
            ref_key: "kdInputNumber",
            ref: D,
            autofocus: U.autofocus,
            placeholder: U.placeholder,
            min: n.min,
            max: n.max,
            step: n.step,
            value: U.modelValue,
            readonly: U.readonly,
            disabled: U.disabled,
            onChange: R,
            onBlur: R,
            onInput: R,
            onKeyup: Yr(m, ["enter"])
          }, null, 42, Gv),
          n.removeButton ? mt("", !0) : (Ne(), We("button", {
            key: 0,
            class: "input-number-add",
            disabled: U.disabled
          }, [
            he("span", Hv, ft(e.value), 1)
          ], 8, Qv)),
          n.removeButton ? mt("", !0) : (Ne(), We("button", {
            key: 1,
            class: "input-number-sub",
            disabled: U.disabled
          }, [
            he("span", $v, ft(g.value), 1)
          ], 8, Xv))
        ], 10, Vv)
      ])
    ], 2));
  }
});
const Jv = ["for"], qv = ["id", "value", "placeholder", "readonly"], ep = /* @__PURE__ */ Ct({
  __name: "KInputTextArea",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    textClass: { default: "" },
    class: { default: "" },
    placeholder: { default: "" },
    labelText: { default: "" },
    labelClass: { default: "" },
    labelStyle: { default: "" },
    readonly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(j, { emit: f }) {
    const D = lt(null), B = f, U = j;
    tr(() => {
      new $r(D.value);
    });
    const G = (R) => {
      B("update:modelValue", R.target.value);
    };
    return (R, m) => (Ne(), We("div", {
      class: Ot(["form-group", U.class])
    }, [
      he("label", {
        for: R.id,
        class: Ot(["input-label-text", U.labelClass]),
        style: Or(R.labelStyle)
      }, ft(R.labelText), 15, Jv),
      he("textarea", {
        class: Ot(U.textClass),
        id: R.id,
        ref_key: "kdInputTextArea",
        ref: D,
        onInput: G,
        value: R.modelValue,
        placeholder: R.placeholder,
        readonly: U.readonly
      }, null, 42, qv)
    ], 2));
  }
});
const ec = /* @__PURE__ */ hs(ep, [["__scopeId", "data-v-ee14e828"]]), tp = ["title"], rp = { class: "d-flex justify-content-center" }, np = { class: "d-flex justify-content-center" }, ap = { class: "text-center fw-bold text-white k-link-carousel-text" }, Tu = /* @__PURE__ */ Ct({
  __name: "KLinkCarouselContent",
  props: {
    item: {},
    compact: { type: Boolean, default: !1 }
  },
  setup(j) {
    const f = j, D = Vt(() => {
      let B = "icon-white pb-2";
      return f.compact || (B += " icon-lg"), B;
    });
    return (B, U) => {
      var G;
      return Ne(), We("div", {
        class: Ot(["card-body", { "k-link-carousel-compact": f.compact }]),
        title: B.item.text,
        role: "button"
      }, [
        he("div", rp, [
          gt(ot(Dr), {
            icon: (G = B.item) == null ? void 0 : G.icon,
            class: Ot(D.value)
          }, null, 8, ["icon", "class"])
        ]),
        he("div", np, [
          he("div", ap, ft(B.item.text), 1)
        ])
      ], 10, tp);
    };
  }
}), ip = { class: "d-flex justify-content-center" }, op = ["href"], sp = /* @__PURE__ */ Ct({
  __name: "KLinkCarousel",
  props: {
    items: {},
    numVisible: { default: 3 },
    numScroll: { default: 3 },
    title: { default: "" },
    compact: { type: Boolean, default: !1 }
  },
  setup(j) {
    const f = j;
    return (D, B) => {
      const U = Pt("router-link"), G = Pt("Carousel");
      return Ne(), Ft(G, {
        value: D.items,
        numVisible: D.numVisible,
        numScroll: D.numScroll,
        showIndicators: !1,
        class: Ot("mb-2")
      }, {
        header: Rt(() => [
          D.title ? (Ne(), Ft(ot(vs), {
            key: 0,
            title: D.title
          }, null, 8, ["title"])) : mt("", !0)
        ]),
        item: Rt((R) => [
          he("div", ip, [
            he("div", {
              class: Ot(["card rounded mb-0 k-link-carousel", { "bg-primary": !f.compact, "bg-secondary": f.compact, "mr-4": !f.compact, "mr-2": f.compact }])
            }, [
              R.data.openExternal ? (Ne(), We("a", {
                key: 0,
                href: R.data.link,
                target: "_blank",
                rel: "noreferrer noopener"
              }, [
                gt(Tu, {
                  item: R.data,
                  compact: D.compact
                }, null, 8, ["item", "compact"])
              ], 8, op)) : (Ne(), Ft(U, {
                key: 1,
                to: R.data.link
              }, {
                default: Rt(() => [
                  gt(Tu, {
                    item: R.data,
                    compact: D.compact
                  }, null, 8, ["item", "compact"])
                ]),
                _: 2
              }, 1032, ["to"]))
            ], 2)
          ])
        ]),
        _: 1
      }, 8, ["value", "numVisible", "numScroll"]);
    };
  }
});
const up = { class: "modal-dialog" }, lp = { class: "modal-content" }, cp = { class: "modal-header" }, fp = {
  class: "modal-title h5 no_toc",
  id: "modalCenterTitle"
}, dp = {
  key: 0,
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, gp = { class: "modal-body" }, mp = { class: "modal-footer" }, Ep = /* @__PURE__ */ Ct({
  __name: "KModalCenter",
  props: {
    title: { default: "" },
    closeButton: { type: Boolean, default: !0 },
    modelValue: { type: Boolean }
  },
  emits: ["closed", "update:modelValue"],
  setup(j, { emit: f }) {
    const D = j, B = f, U = lt(null);
    let G = null;
    tr(() => {
      G = us.getOrCreateInstance(U.value, {
        keyboard: !1,
        backdrop: "static"
      }), G && G._element && G._element.addEventListener("hidden.bs.modal", function(e) {
        B("update:modelValue", !1), B("closed");
      });
    }), ta(() => {
      G && G.dispose();
    }), er(() => D.modelValue, (e) => {
      e === !0 ? R() : m();
    });
    const R = () => {
      G && G.show();
    }, m = () => {
      G && G.hide();
    };
    return (e, g) => {
      const n = Pt("KIcon");
      return Ne(), We("div", {
        ref_key: "modalCenter",
        ref: U,
        class: "modal it-dialog-scrollable fade",
        tabindex: "-1",
        role: "dialog",
        id: "modalcenter",
        "aria-labelledby": "modalCenterTitle",
        "aria-hidden": "true"
      }, [
        he("div", up, [
          he("div", lp, [
            he("div", cp, [
              he("h2", fp, ft(e.title), 1),
              e.closeButton ? (Ne(), We("button", dp, [
                gt(n, { icon: "it-close" })
              ])) : mt("", !0)
            ]),
            he("div", gp, [
              nr(e.$slots, "default")
            ]),
            he("div", mp, [
              nr(e.$slots, "actions")
            ])
          ])
        ])
      ], 512);
    };
  }
}), Mp = { class: "modal-content" }, hp = {
  key: 0,
  class: "modal-header"
}, _p = {
  class: "modal-title h5 no_toc",
  id: "modalrightTitle"
}, yp = {
  key: 0,
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, vp = { class: "modal-footer" }, pp = /* @__PURE__ */ Ct({
  __name: "KModalSlide",
  props: {
    title: {},
    modelValue: { type: Boolean },
    showHeader: { type: Boolean, default: !0 },
    closeButton: { type: Boolean, default: !0 },
    bodyStyle: { default: null },
    dimension: { default: _a.lg }
  },
  emits: ["closed", "update:modelValue"],
  setup(j, { emit: f }) {
    const D = j, B = f, U = lt(null);
    let G = null;
    tr(() => {
      G = us.getOrCreateInstance(U.value, {
        keyboard: !1
      }), G && G._element && G._element.addEventListener("hidden.bs.modal", function(g) {
        B("update:modelValue", !1), B("closed");
      });
    }), ta(() => {
      G && G.dispose();
    }), er(() => D.modelValue, (g) => {
      g === !0 ? R() : m();
    });
    const R = () => {
      G && G.show();
    }, m = () => {
      G && G.hide();
    }, e = Vt(
      () => {
        let g = "k-modal-slide-xl";
        switch (D.dimension) {
          case _a.sm:
            g = "k-modal-slide-sm";
            break;
          case _a.lg:
            g = "k-modal-slide-lg";
            break;
          case _a.xl:
            g = "k-modal-slide-xl";
            break;
        }
        return g;
      }
    );
    return (g, n) => {
      const i = Pt("KIcon");
      return Ne(), Ft(Du, { to: "body" }, [
        he("div", {
          ref_key: "modal",
          ref: U,
          class: "modal it-dialog-scrollable fade",
          tabindex: "-1",
          role: "dialog",
          id: "modalright",
          "aria-labelledby": "modalrightTitle"
        }, [
          he("div", {
            class: Ot(["modal-dialog modal-dialog-right", e.value]),
            role: "document"
          }, [
            he("div", Mp, [
              g.showHeader ? (Ne(), We("div", hp, [
                he("h2", _p, ft(g.title), 1),
                g.closeButton ? (Ne(), We("button", yp, [
                  gt(i, { icon: "it-close" })
                ])) : mt("", !0)
              ])) : mt("", !0),
              he("div", {
                style: Or(g.bodyStyle),
                class: "modal-body"
              }, [
                nr(g.$slots, "default")
              ], 4),
              he("div", vp, [
                nr(g.$slots, "actions")
              ])
            ])
          ], 2)
        ], 512)
      ]);
    };
  }
}), Tp = ["aria-label"], Lp = { class: "pagination justify-content-center" }, Ip = {
  class: "page-link",
  href: "#"
}, Ap = /* @__PURE__ */ he("span", { class: "visually-hidden" }, "Pagina precedente", -1), Sp = /* @__PURE__ */ he("span", { class: "d-inline-block d-sm-none" }, "Pagina ", -1), Dp = {
  key: 2,
  class: "page-item"
}, Np = /* @__PURE__ */ he("span", { class: "page-link" }, "...", -1), Cp = [
  Np
], jp = {
  key: 0,
  class: "page-link",
  href: "#",
  "aria-current": "page"
}, Op = /* @__PURE__ */ he("span", { class: "d-inline-block d-sm-none" }, "Pagina ", -1), Pp = ["onClick"], Rp = {
  key: 3,
  class: "page-item"
}, bp = /* @__PURE__ */ he("span", { class: "page-link" }, "...", -1), xp = [
  bp
], wp = {
  key: 4,
  class: "page-item"
}, Up = /* @__PURE__ */ he("span", { class: "d-inline-block d-sm-none" }, "Pagina ", -1), Fp = {
  key: 5,
  class: "page-item"
}, Bp = /* @__PURE__ */ he("span", { class: "visually-hidden" }, "Pagina successiva", -1), zp = { key: 0 }, kp = /* @__PURE__ */ Ct({
  __name: "KPaginator",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    arialabel: { default: "Paginatore tabella" },
    class: { default: "" },
    currentPage: { default: 1 },
    totalPages: { default: 0 },
    totalCount: { default: 0 },
    nearPages: { default: 2 },
    showTotalCount: { type: Boolean, default: !1 }
  },
  emits: ["page-selected"],
  setup(j, { emit: f }) {
    lt(0);
    const D = j, B = f, U = () => {
      B("page-selected", D.currentPage + 1);
    }, G = () => {
      B("page-selected", D.currentPage - 1);
    }, R = (l) => {
      B("page-selected", l);
    }, m = Vt(() => {
      var l = D.class;
      return D.showTotalCount && (l = l + " pagination-total"), l;
    }), e = Vt(() => D.currentPage - D.nearPages > 2), g = Vt(() => D.currentPage + D.nearPages < D.totalPages - 1), n = Vt(() => D.currentPage < D.totalPages), i = Vt(() => D.currentPage > 1), r = Vt(() => {
      var l = D.currentPage - D.nearPages, d = D.currentPage + D.nearPages, t = [];
      for (let T = l; T <= d; T++)
        T > 1 && T < D.totalPages && t.push(T);
      return t;
    });
    return (l, d) => (Ne(), We("nav", {
      class: Ot(["pagination-wrapper justify-content-center d-flex", m.value]),
      "aria-label": l.arialabel
    }, [
      he("ul", Lp, [
        i.value ? (Ne(), We("li", {
          key: 0,
          class: "page-item",
          onClick: G
        }, [
          he("a", Ip, [
            gt(ot(Dr), { icon: "it-chevron-left" }),
            Ap
          ])
        ])) : mt("", !0),
        l.totalCount > 0 ? (Ne(), We("li", {
          key: 1,
          class: Ot(["page-item", [{ active: l.currentPage === 1 }]])
        }, [
          l.currentPage === 1 ? (Ne(), We("a", {
            key: 0,
            class: "page-link",
            href: "#",
            "aria-current": "page",
            onClick: d[0] || (d[0] = (t) => R(1))
          }, [
            Sp,
            Ht(ft(1))
          ])) : (Ne(), We("a", {
            key: 1,
            class: "page-link",
            href: "#",
            onClick: d[1] || (d[1] = (t) => R(1))
          }, ft(1)))
        ], 2)) : mt("", !0),
        e.value ? (Ne(), We("li", Dp, Cp)) : mt("", !0),
        (Ne(!0), We(or, null, _r(r.value, (t) => (Ne(), We("li", {
          key: t,
          class: Ot(["page-item", [{ active: l.currentPage === t }]])
        }, [
          l.currentPage === t ? (Ne(), We("a", jp, [
            Op,
            Ht(ft(t), 1)
          ])) : (Ne(), We("a", {
            key: 1,
            class: "page-link",
            href: "#",
            onClick: (T) => R(t)
          }, ft(t), 9, Pp))
        ], 2))), 128)),
        g.value ? (Ne(), We("li", Rp, xp)) : mt("", !0),
        l.totalPages > 1 ? (Ne(), We("li", wp, [
          l.currentPage === l.totalPages ? (Ne(), We("a", {
            key: 0,
            class: "page-link",
            href: "#",
            "aria-current": "page",
            onClick: d[2] || (d[2] = (t) => R(l.totalPages))
          }, [
            Up,
            Ht(ft(l.totalPages), 1)
          ])) : (Ne(), We("a", {
            key: 1,
            class: "page-link",
            href: "#",
            onClick: d[3] || (d[3] = (t) => R(l.totalPages))
          }, ft(l.totalPages), 1))
        ])) : mt("", !0),
        n.value ? (Ne(), We("li", Fp, [
          he("a", {
            class: "page-link",
            href: "#",
            onClick: U
          }, [
            Bp,
            gt(ot(Dr), { icon: "it-chevron-right" })
          ])
        ])) : mt("", !0)
      ]),
      l.showTotalCount ? (Ne(), We("p", zp, "Totale " + ft(l.totalCount) + " elementi ", 1)) : mt("", !0)
    ], 10, Tp));
  }
}), Yp = { class: "row" }, Wp = { class: "col-12 col-lg-4" }, Kp = {
  "data-bs-toggle": "sticky",
  "data-bs-stackable": "false",
  "data-bs-padding-top": "120"
}, Vp = {
  class: "navbar it-navscroll-wrapper navbar-expand-lg it-bottom-navscroll it-right-side",
  "data-bs-navscroll": ""
}, Gp = /* @__PURE__ */ he("button", {
  class: "custom-navbar-toggler",
  type: "button",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation",
  "data-bs-toggle": "navbarcollapsible",
  "data-bs-target": "#navbarNav",
  "data-focus-mouse": "false"
}, [
  /* @__PURE__ */ he("span", { class: "it-list" }),
  /* @__PURE__ */ Ht(" 1. Introduzione ")
], -1), Qp = /* @__PURE__ */ he("div", { class: "progress custom-navbar-progressbar" }, [
  /* @__PURE__ */ he("div", {
    class: "progress-bar it-navscroll-progressbar",
    role: "progressbar",
    "aria-valuenow": "0",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    style: { width: "0%" }
  })
], -1), Hp = {
  class: "navbar-collapsable",
  id: "navbarNav",
  style: { display: "none" },
  "aria-hidden": "true"
}, Xp = /* @__PURE__ */ he("div", {
  class: "overlay fade",
  style: { display: "none" }
}, null, -1), $p = {
  class: "it-back-button",
  href: "#",
  role: "button"
}, Zp = /* @__PURE__ */ he("span", null, "Indietro", -1), Jp = { class: "menu-wrapper" }, qp = { class: "link-list-wrapper" }, eT = /* @__PURE__ */ he("div", { class: "progress" }, [
  /* @__PURE__ */ he("div", {
    class: "progress-bar it-navscroll-progressbar",
    role: "progressbar",
    "aria-valuenow": "0",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    style: { width: "0%" }
  })
], -1), tT = { class: "link-list" }, rT = ["href"], nT = { class: "col-12 col-lg-8 it-page-sections-container" }, aT = /* @__PURE__ */ Ct({
  __name: "KNavScroll",
  props: {
    headerText: { default: "Header" }
  },
  setup(j) {
    const f = wo({
      items: []
    });
    return ln("navScrollProvider", f), ln("addItem", (D) => {
      f.items.push(D);
    }), ln("updateItem", (D, B) => {
      let U = f.items.findIndex((G) => G.computedId === D);
      B.isActive = f.items[U].isActive, f.items[U] = B;
    }), ln("deleteItem", (D) => {
      let B = f.items.findIndex((U) => U.computedId === D);
      f.items.splice(B, 1);
    }), (D, B) => {
      const U = Pt("KIcon");
      return Ne(), We("div", Yp, [
        he("div", Wp, [
          he("div", Kp, [
            he("nav", Vp, [
              Gp,
              Qp,
              he("div", Hp, [
                Xp,
                he("a", $p, [
                  gt(U, {
                    icon: "it-chevron-left",
                    class: "icon-sm icon-primary align-top"
                  }),
                  Zp
                ]),
                he("div", Jp, [
                  he("div", qp, [
                    he("h3", null, ft(D.headerText), 1),
                    eT,
                    he("ul", tT, [
                      (Ne(!0), We(or, null, _r(f.items, (G, R) => (Ne(), We("li", {
                        key: R,
                        class: "nav-item"
                      }, [
                        he("a", {
                          class: "nav-link",
                          href: G.hash,
                          "data-focus-mouse": "false"
                        }, [
                          he("span", null, ft(G.header), 1)
                        ], 8, rT)
                      ]))), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        he("div", nT, [
          nr(D.$slots, "default")
        ])
      ]);
    };
  }
}), iT = ["id"], oT = /* @__PURE__ */ Ct({
  __name: "KNavScrollItem",
  props: {
    id: {},
    name: {}
  },
  setup(j) {
    const f = j, D = cn("navScrollProvider"), B = cn("addItem"), U = cn("updateItem"), G = cn("deleteItem"), R = f.name, m = f.id ? f.id : f.name.toLowerCase().replace(/ /g, "-"), e = "#" + m;
    return er(() => Object.assign({}, f), () => {
      U(m, {
        name: f.name,
        header: f.name,
        hash: e,
        index: D.items.length,
        computedId: m
      });
    }), bo(() => {
      B({
        name: f.name,
        header: R,
        hash: e,
        index: D.items.length,
        computedId: m
      });
    }), vi(() => {
      G(m);
    }), (g, n) => (Ne(), We(or, null, [
      he("h2", {
        class: "it-page-section",
        id: ot(m)
      }, ft(g.name), 9, iT),
      nr(g.$slots, "default")
    ], 64));
  }
}), sT = { class: "form-check" }, uT = ["name", "value", "disabled", "id"], lT = ["for"], cT = /* @__PURE__ */ Ct({
  __name: "KRadioButton",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: !1 },
    value: {},
    labelText: { default: "" },
    groupName: {},
    class: { default: "" },
    disabled: { type: Boolean, default: !1 },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(j, { emit: f }) {
    const D = f, B = lt(), U = j;
    er(
      () => U.modelValue,
      async (m) => {
        B.value = m;
      },
      { immediate: !0 }
    );
    const G = (m) => {
      D("update:modelValue", m.target.value);
    }, R = (m) => {
      D("change");
    };
    return (m, e) => (Ne(), We("div", sT, [
      Cn(he("input", {
        name: m.groupName,
        value: m.value,
        disabled: m.disabled,
        onInput: G,
        "onUpdate:modelValue": e[0] || (e[0] = (g) => B.value = g),
        onChange: R,
        class: Ot(m.class),
        id: m.id,
        type: "radio"
      }, null, 42, uT), [
        [Vc, B.value]
      ]),
      he("label", { for: m.id }, ft(m.labelText), 9, lT)
    ]));
  }
}), fT = { class: "fw-bold" }, vs = /* @__PURE__ */ Ct({
  __name: "KSectionHeader",
  props: {
    title: { default: "" },
    rowClass: { default: "" },
    startClass: { default: "" },
    endClass: { default: "" },
    separator: { type: Boolean, default: !1 }
  },
  setup(j) {
    const f = j, D = Vt(() => {
      let B = "";
      return f.separator && (B = "k-section-header-separator "), f.rowClass && (B += f.rowClass), B;
    });
    return (B, U) => (Ne(), We("div", {
      class: Ot(["d-flex align-items-center mb-2", D.value])
    }, [
      he("div", {
        class: Ot(B.startClass)
      }, [
        he("h4", fT, ft(B.title), 1)
      ], 2),
      he("div", {
        class: Ot(["ms-auto", B.endClass])
      }, [
        nr(B.$slots, "end")
      ], 2)
    ], 2));
  }
});
const dT = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxzeW1ib2wgaWQ9Iml0LWFuZHJvaWQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE1LjY4MiAxMy43MzVhLjY2Ny42NjcgMCAxIDEgLjAwMi0xLjMzNC42NjcuNjY3IDAgMCAxLS4wMDIgMS4zMzRabS03LjM2NCAwQS42NjcuNjY3IDAgMSAxIDguMzIgMTIuNGEuNjY3LjY2NyAwIDAgMS0uMDAyIDEuMzM0Wm03LjYwMy00LjAxMyAxLjMzMi0yLjMwN2EuMjc3LjI3NyAwIDAgMC0uNDgtLjI3N2wtMS4zNDggMi4zMzZBOC4yMiA4LjIyIDAgMCAwIDEyIDguNzRhOC4yMiA4LjIyIDAgMCAwLTMuNDI1LjczM0w3LjIyOCA3LjEzOGEuMjc3LjI3NyAwIDAgMC0uNDguMjc3TDguMDggOS43MjJDNS43OTMgMTAuOTY1IDQuMjI5IDEzLjI4IDQgMTYuMDE1aDE2Yy0uMjI5LTIuNzM1LTEuNzkzLTUuMDUtNC4wNzktNi4yOTNaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtYW5kcm9pZC1zcXVhcmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjU2NyAxLjMzM2gxNi43NjJhMi4yODYgMi4yODYgMCAwIDEgMi4yODYgMi4yODZ2MTYuNzYyYTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2IDIuMjg2SDMuNTY3YTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2LTIuMjg2VjMuNjE5YTIuMjg2IDIuMjg2IDAgMCAxIDIuMjg2LTIuMjg2Wk0xNS4wMTYgMTMuMDdhLjY2Ny42NjcgMCAxIDAgMS4zMzQtLjAwMi42NjcuNjY3IDAgMCAwLTEuMzM0LjAwMlptLTcuMzY0IDBhLjY2Ny42NjcgMCAxIDAgMS4zMzQtLjAwMi42NjcuNjY3IDAgMCAwLTEuMzM0LjAwMlptOS42LTUuNjU0LTEuMzMxIDIuMzA3YzIuMjg2IDEuMjQzIDMuODUgMy41NTggNC4wNzkgNi4yOTNINGMuMjI5LTIuNzM1IDEuNzkzLTUuMDUgNC4wNzktNi4yOTNMNi43NDcgNy40MTVhLjI3Ny4yNzcgMCAwIDEgLjQ4LS4yNzdsMS4zNDggMi4zMzZBOC4yMiA4LjIyIDAgMCAxIDEyIDguNzRhOC4yMiA4LjIyIDAgMCAxIDMuNDI1LjczM2wxLjM0OC0yLjMzNmEuMjc3LjI3NyAwIDAgMSAuNDguMjc3WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWFwcGxlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xNC41MjggNS43NThjLjU5My0uNzQzLjk5Ni0xLjc0Ljg5LTIuNzU4LS44NjkuMDQzLTEuOTMuNTczLTIuNTQzIDEuMzE2LS41NTEuNjM2LTEuMDQgMS42NzUtLjkxMiAyLjY1Ljk3NS4wODUgMS45NS0uNDg3IDIuNTY1LTEuMjA4Wk0xNS40MDcgNy4xNTdjLTEuNDE3LS4wODQtMi42Mi44MDQtMy4yOTcuODA0cy0xLjcxMy0uNzYxLTIuODMzLS43NGMtMS40NTguMDItMi44MTEuODQ1LTMuNTUxIDIuMTU2LTEuNTIyIDIuNjI0LS40MDIgNi41MTUgMS4wNzggOC42NS43MTkgMS4wNTggMS41ODUgMi4yMjIgMi43MjYgMi4xOCAxLjA3OS0uMDQzIDEuNTAxLS42OTggMi44MTItLjY5OCAxLjMxIDAgMS42OS42OTggMi44MzIuNjc3IDEuMTg0LS4wMjEgMS45MjQtMS4wNTggMi42NDMtMi4xMTYuODI0LTEuMjA1IDEuMTYyLTIuMzY4IDEuMTgzLTIuNDMyLS4wMjEtLjAyMS0yLjI4My0uODg5LTIuMzA0LTMuNDktLjAyMS0yLjE3OCAxLjc3Ni0zLjIxNCAxLjg2LTMuMjc4LTEuMDE0LTEuNS0yLjYtMS42Ny0zLjE1LTEuNzEzWiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWFwcGxlLXNxdWFyZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuNTY3IDEuMzMzaDE2Ljc2MmEyLjI4NiAyLjI4NiAwIDAgMSAyLjI4NiAyLjI4NnYxNi43NjJhMi4yODYgMi4yODYgMCAwIDEtMi4yODYgMi4yODZIMy41NjdhMi4yODYgMi4yODYgMCAwIDEtMi4yODYtMi4yODZWMy42MTlhMi4yODYgMi4yODYgMCAwIDEgMi4yODYtMi4yODZaTTE1LjQxNyAzYy4xMDcgMS4wMTktLjI5NiAyLjAxNS0uODkgMi43NTgtLjYxNC43MjEtMS41ODkgMS4yOTMtMi41NjQgMS4yMDktLjEyNy0uOTc2LjM2LTIuMDE1LjkxMi0yLjY1LjYxNC0uNzQ0IDEuNjc0LTEuMjc0IDIuNTQzLTEuMzE3Wk0xMy4xMyA3LjY2NGMuNjMzLS4yNSAxLjQxNi0uNTU4IDIuMjc4LS41MDcuNTUuMDQzIDIuMTM1LjIxMiAzLjE1IDEuNzEzYS44MzYuODM2IDAgMCAxLS4wMzQuMDIyYy0uMjYuMTctMS44NDcgMS4yMDktMS44MjcgMy4yNTYuMDIgMi40NCAyLjAxIDMuMzU0IDIuMjc1IDMuNDc2YS4yNDUuMjQ1IDAgMCAxIC4wMjkuMDE0bC0uMDA2LjAxOWE5LjQxNiA5LjQxNiAwIDAgMS0xLjE3NyAyLjQxM2MtLjcxOSAxLjA1OC0xLjQ1OSAyLjA5NS0yLjY0MyAyLjExNi0uNTU3LjAxLS45MzMtLjE1MS0xLjMyNC0uMzE5LS40MS0uMTc1LS44MzctLjM1OC0xLjUwOC0uMzU4LS43MDMgMC0xLjE1LjE4OC0xLjU4MS4zNy0uMzcyLjE1Ny0uNzMuMzA4LTEuMjMuMzI4LTEuMTQyLjA0Mi0yLjAwOC0xLjEyMi0yLjcyNy0yLjE4LTEuNDgtMi4xMzUtMi42LTYuMDI2LTEuMDc4LTguNjUuNzQtMS4zMSAyLjA5My0yLjEzNSAzLjU1LTIuMTU3LjYzNy0uMDExIDEuMjQ3LjIzIDEuNzc4LjQ0LjQwNC4xNi43NjQuMzAxIDEuMDU2LjMwMS4yNjUgMCAuNjEtLjEzNiAxLjAxOS0uMjk3WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWFycm93LWRvd24iIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0ibTE3LjkgMTMuMi01LjQgNS4zVjNoLTF2MTUuNWwtNS40LTUuMy0uNy43IDYuNiA2LjUgNi42LTYuNS0uNy0uN3oiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1hcnJvdy1kb3duLWNpcmNsZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJtMTUuNiAxMy4yLjcuNy00LjMgNC4zLTQuMy00LjMuNy0uNyAzLjEgMy4xVjdoMXY5LjJsMy4xLTN6TTIyIDEyYzAgNS41LTQuNSAxMC0xMCAxMFMyIDE3LjUgMiAxMiA2LjUgMiAxMiAyczEwIDQuNSAxMCAxMHptLTEgMGMwLTUtNC05LTktOXMtOSA0LTkgOSA0IDkgOSA5IDktNCA5LTl6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtYXJyb3ctZG93bi10cmlhbmdsZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNOS4yIDEyaDUuNmMuNiAwIDEgLjUgMSAxIDAgLjMtLjEuNS0uMy43TDEyIDE3LjNsLTMuNS0zLjZjLS40LS40LS40LTEgMC0xLjQuMi0uMi40LS4zLjctLjN6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtYXJyb3ctbGVmdCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjEgMTEuNUg1LjVsNS4zLTUuNC0uNy0uN0wzLjYgMTJsNi41IDYuNi43LS43LTUuMy01LjRIMjF2LTF6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtYXJyb3ctbGVmdC1jaXJjbGUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTcuNyAxMS41SDE3djFINy44bDMgMy4xLS43LjdMNS44IDEybDQuMy00LjMuNy43LTMuMSAzLjF6TTIyIDEyYzAgNS41LTQuNSAxMC0xMCAxMFMyIDE3LjUgMiAxMiA2LjUgMiAxMiAyczEwIDQuNSAxMCAxMHptLTEgMGMwLTUtNC05LTktOXMtOSA0LTkgOSA0IDkgOSA5IDktNCA5LTl6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtYXJyb3ctbGVmdC10cmlhbmdsZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgOS4ydjUuNmMwIC42LS41IDEtMSAxLS4zIDAtLjUtLjEtLjctLjNMNi44IDEybDMuNS0zLjVjLjQtLjQgMS0uNCAxLjQgMCAuMi4yLjMuNC4zLjd6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtYXJyb3ctcmlnaHQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0ibTEzLjkgNS40LS43LjcgNS4zIDUuNEgzdjFoMTUuNWwtNS4zIDUuNC43LjcgNi42LTYuNi02LjYtNi42eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWFycm93LXJpZ2h0LWNpcmNsZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJtMTMuOSA3LjcgNC4zIDQuMy00LjMgNC4zLS43LS43IDMuMS0zLjFIN3YtMWg5LjJsLTMtMy4xLjctLjd6TTIyIDEyYzAgNS41LTQuNSAxMC0xMCAxMFMyIDE3LjUgMiAxMiA2LjUgMiAxMiAyczEwIDQuNSAxMCAxMHptLTEgMGMwLTUtNC05LTktOXMtOSA0LTkgOSA0IDkgOSA5IDktNCA5LTl6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtYXJyb3ctcmlnaHQtdHJpYW5nbGUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyIDE0LjhWOS4yYzAtLjYuNS0xIDEtMSAuMyAwIC41LjEuNy4zbDMuNSAzLjUtMy41IDMuNWMtLjQuNC0xIC40LTEuNCAwLS4yLS4yLS4zLS40LS4zLS43eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWFycm93LXVwIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xOC42IDEwLjEgMTIgMy41bC02LjYgNi42LjcuNyA1LjQtNS4zVjIxaDFWNS41bDUuNCA1LjMuNy0uN3oiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1hcnJvdy11cC1jaXJjbGUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0ibTEyIDUuOCA0LjMgNC4zLS43LjctMy4xLTMuMVYxN2gtMVY3LjhsLTMuMSAzLS43LS43TDEyIDUuOHpNMjIgMTJjMCA1LjUtNC41IDEwLTEwIDEwUzIgMTcuNSAyIDEyIDYuNSAyIDEyIDJzMTAgNC41IDEwIDEwem0tMSAwYzAtNS00LTktOS05cy05IDQtOSA5IDQgOSA5IDkgOS00IDktOXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1hcnJvdy11cC10cmlhbmdsZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTQuOCAxMkg5LjJjLS42IDAtMS0uNS0xLTEgMC0uMy4xLS41LjMtLjdMMTIgNi44bDMuNSAzLjVjLjQuNC40IDEgMCAxLjQtLjIuMi0uNC4zLS43LjN6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtYmFuIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMiAyQzYuNSAyIDIgNi41IDIgMTJzNC41IDEwIDEwIDEwIDEwLTQuNSAxMC0xMFMxNy41IDIgMTIgMnpNNS4yIDE3LjZDMy44IDE2IDMuMSAxNCAzLjEgMTEuOXMuNy00LjEgMi4xLTUuN2wxMi43IDEyLjdDMTQgMjIgOC4zIDIxLjQgNS4yIDE3LjZ6bTEzLjQuNUw1LjkgNS40YzMuNy0zLjMgOS40LTMgMTIuNy43IDMuMSAzLjQgMy4xIDguNiAwIDEyeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWJlaGFuY2UiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTcuOCA1LjhjLjUgMCAxLjEgMCAxLjYuMi40LjEuOS4zIDEuMi41LjQuMS43LjUuOS44LjIuNS4zIDEgLjMgMS40IDAgLjUtLjEgMS4xLS40IDEuNS0uMy40LS44LjgtMS4zIDEgLjcuMiAxLjMuNiAxLjcgMS4xLjQuNi42IDEuMy42IDIgMCAuNS0uMSAxLjEtLjMgMS42LS4yLjQtLjYuOC0xIDEuMS0uNC4zLS45LjUtMS40LjYtLjYuNC0xLjIuNC0xLjcuNEgyVjUuOGg1Ljh6bS0uMyA1Yy40IDAgLjgtLjEgMS4yLS40LjMtLjMuNS0uNy40LTEuMSAwLS4zIDAtLjUtLjEtLjgtLjEtLjEtLjItLjMtLjQtLjQtLjItLjEtLjQtLjItLjYtLjItLjIgMC0uNS0uMS0uNy0uMUg0Ljd2Mi45bDIuOC4xem0uMSA1LjJjLjMgMCAuNSAwIC44LS4xbC42LS4zYy4yLS4xLjMtLjMuNC0uNS4xLS4zLjItLjUuMi0uOCAwLS41LS4yLTEtLjUtMS4zLS40LS4zLS45LS40LTEuNC0uNGgtM1YxNmgyLjl6bTguNi0uMWMuNC40IDEgLjYgMS42LjUuNCAwIC45LS4xIDEuMy0uNC4zLS4yLjUtLjUuNi0uOGgyLjFjLS4yLjktLjggMS43LTEuNiAyLjMtLjguNS0xLjcuNy0yLjYuNy0uNiAwLTEuMy0uMS0xLjktLjMtMS4xLS40LTItMS4zLTIuMy0yLjQtLjItLjYtLjMtMS4yLS4zLTEuOSAwLS42LjEtMS4zLjMtMS45LjItLjYuNS0xLjEuOS0xLjUuNC0uNC45LS44IDEuNC0xIC43LS4yIDEuMy0uMyAxLjktLjMuNyAwIDEuNC4xIDIgLjQuNS4zIDEgLjcgMS40IDEuMi40LjUuNiAxLjEuOCAxLjcuMi43LjIgMS4zLjIgMmgtNi40YzAgLjYuMiAxLjIuNiAxLjd6bTIuOC00LjdjLS40LS4zLS45LS41LTEuNC0uNS0uMyAwLS43IDAtMSAuMi0uMi4xLS41LjMtLjYuNS0uMi4yLS4zLjQtLjMuNi0uMS4yLS4xLjQtLjEuNmg0Yy0uMS0uNS0uMy0xLS42LTEuNHptLTMuOS00LjZoNXYxLjJoLTVWNi42eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWJvb2ttYXJrIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Im0xOCAyMi43LTYtNi02IDZWMmgxMnYyMC43em0tNi03LjQgNSA1VjNIN3YxNy4zbDUtNXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1ib3giIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIxIDJIM3Y0aDF2MTZoMTZWNmgxVjJ6bS0yIDE5SDVWNmgxNHYxNXptMS0xNkg0VjNoMTZ2MnoiLz48cGF0aCBkPSJNOCA4aDh2MUg4eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWJ1cmdlciIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjIgNXYxSDJWNWgyMHpNMiAxMi41aDIwdi0xSDJ2MXpNMiAxOWgyMHYtMUgydjF6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtY2FsZW5kYXIiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIwLjUgNEgxN1YzaC0xdjFIOFYzSDd2MUgzLjVDMi43IDQgMiA0LjcgMiA1LjV2MTNjMCAuOC43IDEuNSAxLjUgMS41aDE3Yy44IDAgMS41LS43IDEuNS0xLjV2LTEzYzAtLjgtLjctMS41LTEuNS0xLjV6bS41IDE0LjVjMCAuMy0uMi41LS41LjVoLTE3Yy0uMyAwLS41LS4yLS41LS41di0xM2MwLS4zLjItLjUuNS0uNUg3djFoMVY1aDh2MWgxVjVoMy41Yy4zIDAgLjUuMi41LjV2MTN6TTQgOGgxNnYxSDRWOHoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1jYW1lcmEiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIwLjUgMjBoLTE3Yy0uOCAwLTEuNS0uNy0xLjUtMS41di0xMEMyIDcuNyAyLjcgNyAzLjUgN2g0LjNsMS41LTIuM2MuMy0uNC43LS43IDEuMi0uN2gzYy41IDAgLjkuMyAxLjIuN0wxNi4yIDdoNC4zYy44IDAgMS41LjcgMS41IDEuNXYxMGMwIC44LS43IDEuNS0xLjUgMS41ek0zLjUgOGMtLjMgMC0uNS4yLS41LjV2MTBjMCAuMy4yLjUuNS41aDE3Yy4zIDAgLjUtLjIuNS0uNXYtMTBjMC0uMy0uMi0uNS0uNS0uNWgtNC44bC0xLjgtMi44LS40LS4yaC0zbC0uNC4yTDguMyA4SDMuNXpNMTIgMThjLTIuOCAwLTUtMi4yLTUtNXMyLjItNSA1LTUgNSAyLjIgNSA1LTIuMiA1LTUgNXptMC05Yy0yLjIgMC00IDEuOC00IDRzMS44IDQgNCA0IDQtMS44IDQtNC0xLjgtNC00LTR6TTcgNUg0djFoM1Y1eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWNhcmQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIwLjUgNWgtMTdDMi43IDUgMiA1LjcgMiA2LjV2MTFjMCAuOC43IDEuNSAxLjUgMS41aDE3Yy44IDAgMS41LS43IDEuNS0xLjV2LTExYzAtLjgtLjctMS41LTEuNS0xLjV6TTMgOWgxOHYzSDNWOXptMTggOC41YzAgLjMtLjIuNS0uNS41aC0xN2MtLjMgMC0uNS0uMi0uNS0uNVYxM2gxOHY0LjV6TTMgOFY2LjVjMC0uMy4yLS41LjUtLjVoMTdjLjMgMCAuNS4yLjUuNVY4SDN6bTUgN0g0di0xaDR2MXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1jaGFydC1saW5lIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0yMSAyMHYxSDNWM2gxdjE3eiIvPjxwYXRoIGQ9Im0xMC41IDkuMiAyLjUgMi41IDYtNnYzLjhoMVY0aC01LjV2MWgzLjhMMTMgMTAuM2wtMi41LTIuNS00LjMgNC4zLjYuOHoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1jaGVjayIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNOS42IDE2LjkgNCAxMS40bC44LS43IDQuOCA0LjggOC41LTguNC43LjctOS4yIDkuMXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1jaGVjay1jaXJjbGUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0ibTE3LjEgNy45LjcuNy03LjggNy42LTQuNy00LjYuNy0uNyA0IDMuOSA3LjEtNi45ek0yMiAxMmMwIDUuNS00LjUgMTAtMTAgMTBTMiAxNy41IDIgMTIgNi41IDIgMTIgMnMxMCA0LjUgMTAgMTB6bS0xIDBjMC01LTQtOS05LTlzLTkgNC05IDkgNCA5IDkgOSA5LTQgOS05eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWNoZXZyb24tbGVmdCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTQuNiAxNy4yIDkgMTEuNiAxNC42IDZsLjguNy00LjkgNC45IDQuOSA0Ljl6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtY2hldnJvbi1yaWdodCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJtOS44IDE3LjItLjgtLjcgNC45LTQuOUw5IDYuN2wuOC0uNyA1LjYgNS42eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWNsaXAiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTExIDIyYy0xLjYuMS0yLjktMS4yLTMtMi44VjZjMC0yLjIgMS44LTQgNC00czQgMS44IDQgNHYxMGgtMVY2YzAtMS43LTEuMy0zLTMtM1M5IDQuMyA5IDZ2MTNjMCAxLjEuOSAyIDIgMnMyLS45IDItMlY4YzAtLjYtLjQtMS0xLTFzLTEgLjQtMSAxdjhoLTFWOGMwLTEuMS45LTIgMi0yczIgLjkgMiAydjExYy4xIDEuNi0xLjIgMi45LTIuOCAzSDExeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWNsb2NrIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMS41IDVoMXY3LjVIN3YtMWg0LjVWNXpNMjIgMTJjMCA1LjUtNC41IDEwLTEwIDEwUzIgMTcuNSAyIDEyIDYuNSAyIDEyIDJzMTAgNC41IDEwIDEwem0tMSAwYzAtNS00LTktOS05cy05IDQtOSA5IDQgOSA5IDkgOS00IDktOXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1jbG9zZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJtMTIuNyAxMiAzLjcgMy42LS44LjgtMy42LTMuNy0zLjYgMy43LS44LS44IDMuNy0zLjYtMy43LTMuNi44LS44IDMuNiAzLjcgMy42LTMuNy44LjgtMy43IDMuNnoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1jbG9zZS1iaWciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0ibTEyLjcgMTIgNi43IDYuNi0uOC44LTYuNi02LjctNi42IDYuNy0uOC0uOCA2LjctNi42LTYuNy02LjYuOC0uOCA2LjYgNi43IDYuNi02LjcuOC44LTYuNyA2LjZ6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtY2xvc2UtY2lyY2xlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xNi4zIDguMyAxMi42IDEybDMuNyAzLjYtLjcuNy0zLjctMy42LTMuNiAzLjYtLjctLjcgMy42LTMuNi0zLjYtMy43LjctLjcgMy42IDMuNyAzLjctMy43LjcuN3pNMjIgMTJjMCA1LjUtNC41IDEwLTEwIDEwUzIgMTcuNSAyIDEyIDYuNSAyIDEyIDJzMTAgNC41IDEwIDEwem0tMSAwYzAtNS00LTktOS05cy05IDQtOSA5IDQgOSA5IDkgOS00IDktOXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1jb2RlLWNpcmNsZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJtMTkgMTItMi45IDIuOS0uNy0uOCAyLjEtMi4xLTIuMS0yLjEuNy0uOEwxOSAxMnpNNy45IDkuMSA1IDEybDIuOSAyLjkuNy0uOEw2LjUgMTJsMi4xLTIuMS0uNy0uOHpNMjIgMTJjMCA1LjUtNC41IDEwLTEwIDEwUzIgMTcuNSAyIDEyIDYuNSAyIDEyIDJzMTAgNC41IDEwIDEwem0tMSAwYzAtNS00LTktOS05cy05IDQtOSA5IDQgOSA5IDkgOS00IDktOXpNOS42IDE2LjVsMSAuMyAzLjctOS4zLS45LS4zLTMuOCA5LjN6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtY29sbGFwc2UiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0ibTE2LjUgMTUuNC00LjktNC45LTQuOSA0LjktLjctLjhMMTEuNiA5bDUuNiA1LjZ6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtY29tbWVudCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM0g1Yy0xLjEgMC0yIC45LTIgMnYxMGMwIDEuMS45IDIgMiAyaDJ2NS40bDEuNy0xLjcgMy43LTMuN0gxOWMxLjEgMCAyLS45IDItMlY1YzAtMS4xLS45LTItMi0yem0xIDEyYy4xLjUtLjMuOS0uOCAxSDEybC00IDR2LTRINWMtLjUuMS0uOS0uMy0xLS44VjVjLS4xLS41LjMtLjkuOC0xSDE5Yy41LS4xLjkuMyAxIC44VjE1ek05IDEwYy4xLjUtLjMuOS0uOCAxSDhjLS41LjEtLjktLjMtMS0uOFYxMGMtLjEtLjUuMy0uOS44LTFIOGMuNS0uMS45LjMgMSAuOHYuMnptNCAwYzAgLjYtLjQgMS0xIDFzLTEtLjQtMS0xIC40LTEgMS0xIDEgLjQgMSAxem00IDBjMCAuNi0uNCAxLTEgMXMtMS0uNC0xLTEgLjQtMSAxLTEgMSAuNCAxIDF6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtY29weSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkuNSA0SDE4di0uNmMtLjEtLjgtLjctMS40LTEuNS0xLjRoLTExYy0uOCAwLTEuNC42LTEuNSAxLjR2MTUuMmMuMS44LjcgMS40IDEuNSAxLjRIN3YuNmMuMS44LjcgMS40IDEuNSAxLjRoMTFjLjggMCAxLjQtLjYgMS41LTEuNFY1LjRjLS4xLS44LS43LTEuNC0xLjUtMS40ek01IDE4LjZWMy40YzAtLjIuMy0uNC41LS40aDExYy4yIDAgLjUuMi41LjR2MTUuMmMwIC4yLS4zLjQtLjUuNGgtMTFjLS4yIDAtLjUtLjItLjUtLjR6bTE1IDJjMCAuMi0uMy40LS41LjRoLTExYy0uMiAwLS41LS4yLS41LS40VjIwaDguNWMuOCAwIDEuNC0uNiAxLjUtMS40VjVoMS41Yy4yIDAgLjUuMi41LjR2MTUuMnoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1kZWxldGUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE1LjUgNHYtLjVjMC0uOC0uNy0xLjUtMS41LTEuNWgtNGMtLjggMC0xLjUuNy0xLjUgMS41VjRIM3YxaDJ2MTUuNWMwIC44LjcgMS41IDEuNSAxLjVoMTFjLjggMCAxLjUtLjcgMS41LTEuNVY1aDJWNGgtNS41em0tNi0uNWMwLS4zLjItLjUuNS0uNWg0Yy4zIDAgLjUuMi41LjVWNGgtNXYtLjV6bTguNSAxN2MwIC4zLS4yLjUtLjUuNWgtMTFjLS4zIDAtLjUtLjItLjUtLjVWNWgxMnYxNS41eiIvPjxwYXRoIGQ9Ik0xMS41IDhoMXYxMGgtMXpNOCA4aDF2MTBIOHpNMTUgOGgxdjEwaC0xeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWRlc2lnbmVycy1pdGFsaWEiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTguNyAyMC4ydi0xM2gzLjZ2MTMuMWwtMy42LS4xek0yMyAxMC4xaC0zLjN2Ni41YzAgLjIuMS40LjMuNnMuNC4yLjguMmgyLjFsLjIgMi44Yy0xLjIuMy0yLjEuNC0yLjguNC0xLjYgMC0yLjctLjMtMy4zLTEuMS0uNi0uNy0uOS0yLS45LTMuOXYtMTJoMy42djMuNkgyM3YyLjl6bS0xOS44IDFjLS42IDAtMS4yLS4yLTEuNi0uNi0uNC0uNC0uNi0uOS0uNi0xLjVzLjItMS4xLjYtMS41Yy40LS41LjktLjcgMS42LS43czEuMS4yIDEuNS42Yy40LjUuNiAxIC42IDEuNnMtLjIgMS4xLS42IDEuNS0uOS42LTEuNS42eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWRvd25sb2FkIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMiAxNC4yIDcuNyA5LjlsLjctLjcgMy4xIDMuMVYzaDF2OS4ybDMuMS0zIC43LjctNC4zIDQuM3ptNy0yLjJ2Ny41YzAgLjMtLjIuNS0uNS41aC0xM2MtLjMgMC0uNS0uMi0uNS0uNVYxMkg0djcuNWMwIC44LjcgMS41IDEuNSAxLjVoMTNjLjggMCAxLjUtLjcgMS41LTEuNVYxMmgtMXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1lcnJvciIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTEuNSAxNC4yVjUuN2gxLjJ2OC41aC0xLjJ6bS0uMSA0LjFoMS4ydi0xLjhoLTEuMnYxLjh6TTIyIDcuOXY4LjNMMTYuMSAyMkg3LjlMMiAxNi4yVjcuOUw3LjkgMmg4LjJMMjIgNy45em0tMSAuNEwxNS43IDNIOC4zTDMgOC4zdjcuNUw4LjMgMjFoNy40bDUuMy01LjJWOC4zeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWV4Y2hhbmdlLWNpcmNsZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgMkM2LjUgMiAyIDYuNSAyIDEyczQuNSAxMCAxMCAxMCAxMC00LjUgMTAtMTBTMTcuNSAyIDEyIDJ6bTAgMTljLTUgMC05LTQtOS05czQtOSA5LTkgOSA0IDkgOS00IDktOSA5em01LjEtOC45LjguOC00LjMgNC4zYy0uMy4zLS43LjQtMS4xLjQtLjQgMC0uOC0uMS0xLjEtLjRMOSAxNC43VjE3SDh2LTRoNHYxSDkuN2wyLjQgMi41aC44bDQuMi00LjR6bS02LTQuNi00LjIgNC40LS44LS44IDQuMy00LjNjLjMtLjMuNy0uNCAxLjEtLjQuNCAwIC44LjEgMS4xLjRMMTUgOS4zVjdoMXY0aC00di0xaDIuM2wtMi40LTIuNWgtLjh6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZXhwYW5kIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMS42IDE1LjQgNiA5LjhsLjctLjggNC45IDQuOUwxNi41IDlsLjcuOHoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1leHRlcm5hbC1saW5rIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0yMSAzdjZoLTFWNC43bC03LjYgNy43LS44LS44TDE5LjMgNEgxNVYzaDZ6bS00IDE2LjVjMCAuMy0uMi41LS41LjVoLTEyYy0uMyAwLS41LS4yLS41LS41di0xMmMwLS4zLjItLjUuNS0uNUgxMlY2SDQuNUMzLjcgNiAzIDYuNyAzIDcuNXYxMmMwIC44LjcgMS41IDEuNSAxLjVoMTJjLjggMCAxLjUtLjcgMS41LTEuNVYxMmgtMXY3LjV6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZmFjZWJvb2siIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEzLjYgMjJ2LTkuMWgzLjFsLjUtMy42aC0zLjVWNy4xYzAtMSAuMy0xLjcgMS44LTEuN2gxLjlWMi4xYy0xLjEtLjEtMi0uMS0zLS4xLTIuNyAwLTQuNiAxLjctNC42IDQuN3YyLjZoLTN2My42aDMuMVYyMmgzLjd6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZmFjZWJvb2stc3F1YXJlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xNyAwSDFDLjQgMCAwIC40IDAgMXYxNmMwIC42LjQgMSAxIDFoOC42di02LjlINy4zVjguM2gyLjN2LTJjLS4xLTEgLjItMS45LjktMi42czEuNi0xLjEgMi42LTFjLjcgMCAxLjQgMCAyLjEuMXYyLjRoLTEuNGMtMS4xIDAtMS4zLjUtMS4zIDEuM3YxLjdoMi43bC0uNCAyLjdoLTIuM3Y3SDE3Yy42IDAgMS0uNCAxLTFWMWMwLS42LS40LTEtMS0xeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZpZ21hIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS41IDZBMy41IDMuNSAwIDAgMSA5IDIuNWgzLjV2N0g5QTMuNSAzLjUgMCAwIDEgNS41IDZaTTkgMy41YTIuNSAyLjUgMCAwIDAgMCA1aDIuNXYtNUg5WiIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguNSA2QTMuNSAzLjUgMCAwIDAgMTUgMi41aC0zLjV2N0gxNUEzLjUgMy41IDAgMCAwIDE4LjUgNlpNMTUgMy41YTIuNSAyLjUgMCAwIDEgMCA1aC0yLjV2LTVIMTVaIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC41IDEyYTMuNSAzLjUgMCAxIDAtNyAwIDMuNSAzLjUgMCAwIDAgNyAwWk0xNSA5LjVhMi41IDIuNSAwIDEgMSAwIDUgMi41IDIuNSAwIDAgMSAwLTVaIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjUgMTJBMy41IDMuNSAwIDAgMSA5IDguNWgzLjV2N0g5QTMuNSAzLjUgMCAwIDEgNS41IDEyWk05IDkuNWEyLjUgMi41IDAgMCAwIDAgNWgyLjV2LTVIOVoiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuNSAxOEEzLjUgMy41IDAgMCAxIDkgMTQuNWgzLjVWMThhMy41IDMuNSAwIDEgMS03IDBaTTkgMTUuNWEyLjUgMi41IDAgMSAwIDIuNSAyLjV2LTIuNUg5WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZpZ21hLXNxdWFyZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuNTY3IDEuMzMzaDE2Ljc2MmEyLjI4NiAyLjI4NiAwIDAgMSAyLjI4NiAyLjI4NnYxNi43NjJhMi4yODYgMi4yODYgMCAwIDEtMi4yODYgMi4yODZIMy41NjdhMi4yODYgMi4yODYgMCAwIDEtMi4yODYtMi4yODZWMy42MTlhMi4yODYgMi4yODYgMCAwIDEgMi4yODYtMi4yODZaTTYuNSA2LjY2N0EzLjE2NyAzLjE2NyAwIDAgMSA5LjY2NyAzLjVIMTVhMy4xNjcgMy4xNjcgMCAwIDEgMS43MDkgNS44MzMgMy4xNjcgMy4xNjcgMCAxIDEtMy44NzYgNC45NzZ2My4wMjRhMy4xNjcgMy4xNjcgMCAxIDEtNC44NzUtMi42NjZBMy4xNjQgMy4xNjQgMCAwIDEgNi41IDEyYzAtMS4xMi41ODEtMi4xMDQgMS40NTgtMi42NjdBMy4xNjQgMy4xNjQgMCAwIDEgNi41IDYuNjY3Wm0zLjE2NyAzLjE2NmgtLjAwNGEyLjE2NyAyLjE2NyAwIDAgMCAuMDA0IDQuMzM0aDIuMTY2VjkuODMzSDkuNjY3Wk0xMS44MzMgNC41djQuMzMzaC0yLjE3QTIuMTY3IDIuMTY3IDAgMCAxIDkuNjY3IDQuNWgyLjE2NlpNMTUgOC44MzNoLTIuMTY2VjQuNUgxNWEyLjE2NyAyLjE2NyAwIDAgMSAuMDA0IDQuMzMzSDE1Wm0tLjAwNCAxYTIuMTY3IDIuMTY3IDAgMSAwIC4wMDQgMGgtLjAwNFptLTcuNDk2IDcuNWMwLTEuMTk2Ljk3LTIuMTY2IDIuMTY3LTIuMTY2aDIuMTY2djIuMTY2YTIuMTY3IDIuMTY3IDAgMSAxLTQuMzMzIDBaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZmlsZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTQuNyAySDYuNUM1LjcgMiA1IDIuNyA1IDMuNXYxN2MwIC44LjcgMS41IDEuNSAxLjVoMTFjLjggMCAxLjUtLjcgMS41LTEuNVY2LjNMMTQuNyAyem0uMyAxLjdMMTcuMyA2aC0xLjhjLS4zIDAtLjUtLjItLjUtLjVWMy43ek0xNy41IDIxaC0xMWMtLjMgMC0uNS0uMi0uNS0uNXYtMTdjMC0uMy4yLS41LjUtLjVIMTR2Mi41YzAgLjguNyAxLjUgMS41IDEuNUgxOHYxMy41YzAgLjMtLjIuNS0uNS41ek04IDloOHYxSDhWOXptMCAyaDh2MUg4di0xem0wIDJoNHYxSDh2LTF6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZmlsZS1hdWRpbyIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMl8yNTkxKSI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjUgMmg4LjJMMTkgNi4zdjE0LjJhMS41IDEuNSAwIDAgMS0xLjUgMS41aC0xMUExLjUgMS41IDAgMCAxIDUgMjAuNXYtMTdBMS41IDEuNSAwIDAgMSA2LjUgMlptMTAuOCA0TDE1IDMuN3YxLjhhLjUuNSAwIDAgMCAuNS41aDEuOFptLjIgMTVoLTExYS41LjUgMCAwIDEtLjUtLjV2LTE3YS41LjUgMCAwIDEgLjUtLjVIMTR2Mi41QTEuNSAxLjUgMCAwIDAgMTUuNSA3SDE4djEzLjVhLjUuNSAwIDAgMS0uNS41Wk0xMiA5LjcyNyAxNSA5djIuNzVsLTIgLjV2My42MWMwIC40OTUtLjMwMS44ODMtLjY2MiAxLjEyMy0uMzY0LjI0My0uODM5LjM3Ny0xLjMzOC4zNzctLjUgMC0uOTc0LS4xMzQtMS4zMzgtLjM3Ny0uMzYtLjI0LS42NjItLjYyOC0uNjYyLTEuMTIzcy4zMDEtLjg4My42NjItMS4xMjNjLjM2NC0uMjQzLjgzOS0uMzc3IDEuMzM4LS4zNzcuMzU2IDAgLjcuMDY4IDEgLjE5NnYtNC44M1oiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJjbGlwMF8yXzI1OTEiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1maWxlLWNvbXByZXNzZWQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzJfMjYwMykiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi41IDJoOC4yTDE5IDYuM3YxNC4yYTEuNSAxLjUgMCAwIDEtMS41IDEuNWgtMTFBMS41IDEuNSAwIDAgMSA1IDIwLjV2LTE3QTEuNSAxLjUgMCAwIDEgNi41IDJabTEwLjggNEwxNSAzLjd2MS44YS41LjUgMCAwIDAgLjUuNWgxLjhabS4yIDE1aC0xMWEuNS41IDAgMCAxLS41LS41di0xN2EuNS41IDAgMCAxIC41LS41aDIuNjEydi45MThoLS43Nzh2LjkxN2guNzc4di45MThoLS43Nzh2LjkxN2guNzc4di45MThoMS4xNjZWNi42N0g5LjV2LS45MTdoLjc3OHYtLjkxOEg5LjV2LS45MTdoLjc3OFYzSDE0djIuNUExLjUgMS41IDAgMCAwIDE1LjUgN0gxOHYxMy41YS41LjUgMCAwIDEtLjUuNVpNOS4xMTEgOC4wNDZjLS40MjkgMC0uNzc3LjQxMS0uNzc3LjkxOHYuODZsLS4zMSAxLjQ2N2MtLjA4LjM3Ny4wNDkuNzcxLjMyMi45ODZsLjcyMy41NjlhLjY4LjY4IDAgMCAwIC44NjIgMGwuNzIzLS41NjljLjI3My0uMjE1LjQwMi0uNjEuMzIzLS45ODZsLS4zMS0xLjQ2NnYtLjg2MWMwLS41MDctLjM0OS0uOTE4LS43NzgtLjkxOEg5LjExWm0wIC45MThoLjc3OHYuODZjMCAuMDc2LjAwNy4xNS4wMjMuMjIzbC4zMSAxLjQ2Ny0uNzIyLjU2OS0uNzIzLS41NjkuMzExLTEuNDY3Yy4wMTYtLjA3Mi4wMjMtLjE0Ny4wMjMtLjIyMnYtLjg2MVoiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJjbGlwMF8yXzI2MDMiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1maWxlLWNzdiIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMl8yNTU1KSI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC43IDJINi41QTEuNSAxLjUgMCAwIDAgNSAzLjVWMTZoMVYzLjVhLjUuNSAwIDAgMSAuNS0uNUgxNHYyLjVBMS41IDEuNSAwIDAgMCAxNS41IDdIMTh2MTMuNWEuNS41IDAgMCAxLS41LjVIMTZ2MWgxLjVhMS41IDEuNSAwIDAgMCAxLjUtMS41VjYuM0wxNC43IDJabS4zIDEuN0wxNy4zIDZoLTEuOGEuNS41IDAgMCAxLS41LS41VjMuN1pNNS4wMDIgMTdjLjMzOCAwIC43MzcuMDQ1IDEuMTk3LjEzNGwuMjQuMDQ4LS4wMzkuODI0YTEyLjM0NCAxMi4zNDQgMCAwIDAtMS4xMi0uMDc3Yy0uNDg2IDAtLjgxMS4xMDktLjk3Ny4zMjYtLjE2Ni4yMTctLjI1LjYyNi0uMjUgMS4yMjZzLjA4IDEuMDE1LjI0IDEuMjQ1Yy4xNi4yMy40OTIuMzQ1Ljk5Ni4zNDVsMS4xMjEtLjA3Ny4wMjkuODM0Yy0uNjQ1LjExNC0xLjEzLjE3Mi0xLjQ1Ni4xNzItLjcyOCAwLTEuMjQyLS4xOTUtMS41NDItLjU4NEMzLjE0NyAyMS4wMiAzIDIwLjM3NSAzIDE5LjQ4YzAtLjg5NC4xNTYtMS41My40Ny0xLjkwNi4zMTItLjM4My44MjMtLjU3NSAxLjUzMi0uNTc1Wm01Ljc3IDEuMDkyYy0uNzU0LS4xMDItMS4zLS4xNTMtMS42MzgtLjE1My0uMzM5IDAtLjU3NS4wNDEtLjcwOS4xMjQtLjEyOC4wNzctLjE5MS4yMDEtLjE5MS4zNzQgMCAuMTcyLjA3LjI5My4yMS4zNjQuMTQ3LjA3LjQ4Ni4xNTMgMS4wMTYuMjQ5LjUzNi4wOS45MTYuMjMzIDEuMTQuNDMuMjIzLjE5OS4zMzUuNTUuMzM1IDEuMDU1IDAgLjUwNC0uMTYzLjg3NC0uNDg5IDEuMTEtLjMyLjIzNy0uNzg4LjM1NS0xLjQwOC4zNTUtLjM5IDAtLjg4MS0uMDU0LTEuNDc1LS4xNjNsLS4yOTctLjA0OC4wMzgtLjg3MWMuNzY3LjEwMiAxLjMyLjE1MyAxLjY1OC4xNTMuMzM4IDAgLjU3Ny0uMDQyLjcxOC0uMTI1LjE0Ny0uMDgzLjIyLS4yMi4yMi0uNDEyIDAtLjE5MS0uMDctLjMyMi0uMjEtLjM5Mi0uMTM1LS4wNzctLjQ2My0uMTU3LS45ODctLjI0LS41MTctLjA5LS44OTctLjIyNi0xLjE0LS40MTItLjI0My0uMTg1LS4zNjQtLjUyMy0uMzY0LTEuMDE1IDAtLjQ5Mi4xNjYtLjg1OS40OTgtMS4xMDEuMzM5LS4yNDMuNzctLjM2NCAxLjI5My0uMzY0LjQwOSAwIC45MS4wNSAxLjUwNC4xNTNsLjI5Ny4wNTctLjAyLjg3MlptMS43NTItLjk4N2gtMS4wOTJsMS4yMzUgNC43OWgxLjg1OWwxLjI0NS00Ljc5aC0xLjA2M2wtLjk1OCAzLjg5OWgtLjMwN2wtLjkyLTMuODk5WiIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImNsaXAwXzJfMjU1NSI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZpbGUtanNvbiIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuNSAyaDguMkwxOSA2LjNWMTZoLTFWN2gtMi41QTEuNSAxLjUgMCAwIDEgMTQgNS41VjNINi41YS41LjUgMCAwIDAtLjUuNVYxNkg1VjMuNUExLjUgMS41IDAgMCAxIDYuNSAyWm0xMC44IDRMMTUgMy43djEuOGEuNS41IDAgMCAwIC41LjVoMS44WiIvPjxwYXRoIGQ9Ik00LjM1IDIyLjR2LS44NWMuMTkgMCAuMzI2LS4wMzYuNDExLS4xMDcuMDg1LS4wNy4xMjgtLjIwMy4xMjgtLjM5NnYtMy45NjJoLjk3bC4wMDggNC4wMDRjMCAuNTE1LS4xMTYuODYyLS4zNDggMS4wNDItLjIyNi4xOC0uNjE2LjI2OS0xLjE2OS4yNjlaTTguMzYgMTcuODVjLS41MTYgMC0uNzczLjE3LS43NzMuNTEgMCAuMTUyLjA2NC4yNjguMTkxLjM0OC4xMjguMDguNDI2LjE5Ni44OTMuMzQ3LjQ3My4xNTEuODAzLjMyNC45OTIuNTE3LjE5LjE5LjI4NC40ODIuMjg0Ljg4IDAgLjUwNS0uMTU0Ljg4Ny0uNDYgMS4xNDctLjMwOC4yNi0uNzEuMzktMS4yMDYuMzktLjM2OCAwLS44Mi0uMDU3LTEuMzUzLS4xN2wtLjI1NS0uMDUuMDk5LS43NThjLjYzMy4wODUgMS4xMTcuMTI4IDEuNDUzLjEyOC41IDAgLjc1LS4yMDguNzUtLjYyNGEuNDEyLjQxMiAwIDAgMC0uMTc2LS4zNTRjLS4xMTQtLjA4NS0uMzQzLS4xNzgtLjY4OC0uMjc3LS41NDgtLjE1Ni0uOTM1LS4zNC0xLjE2Mi0uNTUzLS4yMjItLjIxNy0uMzMzLS41MTctLjMzMy0uOSAwLS40ODEuMTQ3LS44NC40NC0xLjA3Ny4yOTItLjIzNi42OTQtLjM1NCAxLjIwNC0uMzU0LjM1IDAgLjc5NC4wNDcgMS4zMzIuMTQybC4yNTYuMDUtLjA3OC43NzJjLS42NjYtLjA3Ni0xLjEzNy0uMTE0LTEuNDEtLjExNFpNMTEuNzMyIDIwLjc3Yy4xNDIuMjQ2LjQwNC4zNjkuNzg3LjM2OXMuNjQyLS4xMjMuNzgtLjM2OWMuMTQxLS4yNS4yMTItLjY2Ni4yMTItMS4yNDcgMC0uNTg2LS4wNy0xLjAxMS0uMjEzLTEuMjc2LS4xNDEtLjI2NC0uNDAxLS4zOTctLjc4LS4zOTctLjM3NyAwLS42MzcuMTMzLS43NzkuMzk3LS4xNDEuMjY1LS4yMTIuNjktLjIxMiAxLjI3NiAwIC41OC4wNjguOTk3LjIwNSAxLjI0N1ptMi4zMzIuNjI0Yy0uMjk4LjM5Ny0uODEzLjU5NS0xLjU0NS41OTVzLTEuMjUtLjE5OC0xLjU1Mi0uNTk1Yy0uMjk4LS40MDItLjQ0Ny0xLjAyOC0uNDQ3LTEuODc4IDAtLjg1LjE1LTEuNDgxLjQ0Ny0xLjg5Mi4zMDItLjQxNi44Mi0uNjI0IDEuNTUyLS42MjQuNzMyIDAgMS4yNDcuMjA4IDEuNTQ1LjYyNC4zMDIuNDEuNDUzIDEuMDQxLjQ1MyAxLjg5MiAwIC44NS0uMTUgMS40NzYtLjQ1MyAxLjg3OFpNMTUuMzU2IDIxLjkwNHYtNC44MTloMS42NTFsMS4xNjIgMy45NjhoLjA3MXYtMy45NjhoLjk3OHY0LjgxOUgxNy42MWwtMS4yMDUtMy45NjloLS4wNzF2My45NjloLS45NzhaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZmlsZS1vZHAiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjUgMmg4LjJMMTkgNi4zdjE0LjJhMS41IDEuNSAwIDAgMS0xLjUgMS41SDE2di0xaDEuNWEuNS41IDAgMCAwIC41LS41VjdoLTIuNUExLjUgMS41IDAgMCAxIDE0IDUuNVYzSDYuNWEuNS41IDAgMCAwLS41LjVWMTZINVYzLjVBMS41IDEuNSAwIDAgMSA2LjUgMlptMTAuOCA0TDE1IDMuN3YxLjhhLjUuNSAwIDAgMCAuNS41aDEuOFoiLz48cGF0aCBkPSJNNC4yMTQgMjAuNzc4Yy4xNDMuMjQ3LjQwNS4zNy43ODkuMzcuMzgzIDAgLjY0NC0uMTIzLjc4MS0uMzcuMTQyLS4yNS4yMTMtLjY2Ny4yMTMtMS4yNSAwLS41ODctLjA3LTEuMDEzLS4yMTMtMS4yNzgtLjE0Mi0uMjY1LS40MDItLjM5OC0uNzgxLS4zOThzLS42NC4xMzMtLjc4MS4zOThjLS4xNDIuMjY1LS4yMTMuNjkxLS4yMTMgMS4yNzggMCAuNTgzLjA2OCAxIC4yMDUgMS4yNVptMi4zMzcuNjI1Yy0uMjk4LjM5OC0uODE0LjU5Ny0xLjU0OC41OTctLjczNCAwLTEuMjUzLS4xOTktMS41NTYtLjU5N0MzLjE1IDIxLjAwMSAzIDIwLjM3MyAzIDE5LjUyMWMwLS44NTIuMTUtMS40ODQuNDQ3LTEuODk2LjMwMy0uNDE3LjgyMi0uNjI1IDEuNTU2LS42MjUuNzM0IDAgMS4yNS4yMDggMS41NDguNjI1LjMwMy40MTIuNDU1IDEuMDQ0LjQ1NSAxLjg5NiAwIC44NTMtLjE1MiAxLjQ4LS40NTUgMS44ODJaTTkuNDczIDIxLjkxNUg3Ljg0NnYtNC44M2gxLjYyN2MuNDE2IDAgLjc2LjA0NSAxLjAzLjEzNS4yNy4wODUuNDc4LjIzLjYyNC40MzMuMTUyLjIuMjU2LjQzNi4zMTMuNzEuMDU3LjI3LjA4NS42MjMuMDg1IDEuMDU5IDAgLjQzNi0uMDI2Ljc5OC0uMDc4IDEuMDg3LS4wNTIuMjg0LS4xNTEuNTQtLjI5OC43NjctLjE0Mi4yMjItLjM1LjM4Ni0uNjI1LjQ5LS4yNzUuMS0uNjI1LjE0OS0xLjA1MS4xNDlabTEuMDMtMS45MThjLjAwOS0uMTUxLjAxNC0uMzYuMDE0LS42MjUgMC0uMjctLjAxLS40ODUtLjAyOS0uNjQ2YTEuMjI3IDEuMjI3IDAgMCAwLS4xMzUtLjQ0LjU0Ny41NDcgMCAwIDAtLjMyLS4yNyAxLjYyNyAxLjYyNyAwIDAgMC0uNTYtLjA3OGgtLjY0N3YzLjEyNWguNjQ3Yy4zNTUgMCAuNjEzLS4wOS43NzQtLjI3LjEzNy0uMTQ3LjIyMi0uNDEyLjI1NS0uNzk2Wk0xNC4xNSAyMC41MDloLS43OTV2MS40MDZoLS45OHYtNC44M2gxLjc3NmMxLjE0NiAwIDEuNzE5LjU1OSAxLjcxOSAxLjY3NiAwIC41NjQtLjE0Ny45OTctLjQ0IDEuMy0uMjkuMjk4LS43MTYuNDQ4LTEuMjguNDQ4Wm0tLjc5NS0uODM4aC43ODljLjQ4NyAwIC43MzEtLjMwNC43MzEtLjkxIDAtLjI5OC0uMDU5LS41MTEtLjE3Ny0uNjM5LS4xMTktLjEzMi0uMzAzLS4xOTktLjU1NC0uMTk5aC0uNzg5djEuNzQ4WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZpbGUtb2RzIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi41IDJoOC4yTDE5IDYuM3YxNC4yYTEuNSAxLjUgMCAwIDEtMS41IDEuNUgxNnYtMWgxLjVhLjUuNSAwIDAgMCAuNS0uNVY3aC0yLjVBMS41IDEuNSAwIDAgMSAxNCA1LjVWM0g2LjVhLjUuNSAwIDAgMC0uNS41VjE2SDVWMy41QTEuNSAxLjUgMCAwIDEgNi41IDJabTEwLjggNEwxNSAzLjd2MS44YS41LjUgMCAwIDAgLjUuNWgxLjhaIi8+PHBhdGggZD0iTTQuMjE0IDIwLjc3OGMuMTQzLjI0Ny40MDUuMzcuNzg5LjM3LjM4MyAwIC42NDQtLjEyMy43ODEtLjM3LjE0Mi0uMjUuMjEzLS42NjcuMjEzLTEuMjUgMC0uNTg3LS4wNy0xLjAxMy0uMjEzLTEuMjc4LS4xNDItLjI2NS0uNDAyLS4zOTgtLjc4MS0uMzk4cy0uNjQuMTMzLS43ODEuMzk4Yy0uMTQyLjI2NS0uMjEzLjY5MS0uMjEzIDEuMjc4IDAgLjU4My4wNjggMSAuMjA1IDEuMjVabTIuMzM3LjYyNWMtLjI5OC4zOTgtLjgxNC41OTctMS41NDguNTk3LS43MzQgMC0xLjI1My0uMTk5LTEuNTU2LS41OTdDMy4xNSAyMS4wMDEgMyAyMC4zNzMgMyAxOS41MjFjMC0uODUyLjE1LTEuNDg0LjQ0Ny0xLjg5Ni4zMDMtLjQxNy44MjItLjYyNSAxLjU1Ni0uNjI1LjczNCAwIDEuMjUuMjA4IDEuNTQ4LjYyNS4zMDMuNDEyLjQ1NSAxLjA0NC40NTUgMS44OTYgMCAuODUzLS4xNTIgMS40OC0uNDU1IDEuODgyWk05LjQ3MyAyMS45MTVINy44NDZ2LTQuODNoMS42MjdjLjQxNiAwIC43Ni4wNDUgMS4wMy4xMzUuMjcuMDg1LjQ3OC4yMy42MjQuNDMzLjE1Mi4yLjI1Ni40MzYuMzEzLjcxLjA1Ny4yNy4wODUuNjIzLjA4NSAxLjA1OSAwIC40MzYtLjAyNi43OTgtLjA3OCAxLjA4Ny0uMDUyLjI4NC0uMTUxLjU0LS4yOTguNzY3LS4xNDIuMjIyLS4zNS4zODYtLjYyNS40OS0uMjc1LjEtLjYyNS4xNDktMS4wNTEuMTQ5Wm0xLjAzLTEuOTE4Yy4wMDktLjE1MS4wMTQtLjM2LjAxNC0uNjI1IDAtLjI3LS4wMS0uNDg1LS4wMjktLjY0NmExLjIyNyAxLjIyNyAwIDAgMC0uMTM1LS40NC41NDcuNTQ3IDAgMCAwLS4zMi0uMjcgMS42MjcgMS42MjcgMCAwIDAtLjU2LS4wNzhoLS42NDd2My4xMjVoLjY0N2MuMzU1IDAgLjYxMy0uMDkuNzc0LS4yNy4xMzctLjE0Ny4yMjItLjQxMi4yNTUtLjc5NlpNMTMuODYgMTcuODUyYy0uNTE2IDAtLjc3NC4xNy0uNzc0LjUxMiAwIC4xNTEuMDYzLjI2Ny4xOTEuMzQ4LjEyOC4wOC40MjYuMTk2Ljg5NS4zNDguNDc0LjE1MS44MDUuMzI0Ljk5NC41MTguMTkuMTkuMjg1LjQ4My4yODUuODggMCAuNTA3LS4xNTQuODkxLS40NjIgMS4xNTEtLjMwOC4yNi0uNzEuMzkxLTEuMjA4LjM5MS0uMzY5IDAtLjgyMS0uMDU3LTEuMzU2LS4xN2wtLjI1Ni0uMDUuMS0uNzZjLjYzNC4wODUgMS4xMi4xMjggMS40NTYuMTI4LjUwMiAwIC43NTItLjIwOS43NTItLjYyNSAwLS4xNTItLjA1OS0uMjctLjE3Ny0uMzU1LS4xMTQtLjA4Ni0uMzQzLS4xNzgtLjY4OS0uMjc3LS41NS0uMTU3LS45MzctLjM0MS0xLjE2NS0uNTU0LS4yMjItLjIxOC0uMzMzLS41MTktLjMzMy0uOTAyIDAtLjQ4My4xNDYtLjg0My40NC0xLjA4LjI5My0uMjM3LjY5Ni0uMzU1IDEuMjA3LS4zNTUuMzUgMCAuNzk2LjA0NyAxLjMzNS4xNDJsLjI1Ni4wNS0uMDc4Ljc3NGMtLjY2OC0uMDc2LTEuMTM5LS4xMTQtMS40MTMtLjExNFoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1maWxlLW9kdCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuNSAyaDguMkwxOSA2LjN2MTQuMmExLjUgMS41IDAgMCAxLTEuNSAxLjVIMTZ2LTFoMS41YS41LjUgMCAwIDAgLjUtLjVWN2gtMi41QTEuNSAxLjUgMCAwIDEgMTQgNS41VjNINi41YS41LjUgMCAwIDAtLjUuNVYxNkg1VjMuNUExLjUgMS41IDAgMCAxIDYuNSAyWm0xMC44IDRMMTUgMy43djEuOGEuNS41IDAgMCAwIC41LjVoMS44WiIvPjxwYXRoIGQ9Ik00LjIxNCAyMC43NzhjLjE0My4yNDcuNDA1LjM3Ljc4OS4zNy4zODMgMCAuNjQ0LS4xMjMuNzgxLS4zNy4xNDItLjI1LjIxMy0uNjY3LjIxMy0xLjI1IDAtLjU4Ny0uMDctMS4wMTMtLjIxMy0xLjI3OC0uMTQyLS4yNjUtLjQwMi0uMzk4LS43ODEtLjM5OHMtLjY0LjEzMy0uNzgxLjM5OGMtLjE0Mi4yNjUtLjIxMy42OTEtLjIxMyAxLjI3OCAwIC41ODMuMDY4IDEgLjIwNSAxLjI1Wm0yLjMzNy42MjVjLS4yOTguMzk4LS44MTQuNTk3LTEuNTQ4LjU5Ny0uNzM0IDAtMS4yNTMtLjE5OS0xLjU1Ni0uNTk3QzMuMTUgMjEuMDAxIDMgMjAuMzczIDMgMTkuNTIxYzAtLjg1Mi4xNS0xLjQ4NC40NDctMS44OTYuMzAzLS40MTcuODIyLS42MjUgMS41NTYtLjYyNS43MzQgMCAxLjI1LjIwOCAxLjU0OC42MjUuMzAzLjQxMi40NTUgMS4wNDQuNDU1IDEuODk2IDAgLjg1My0uMTUyIDEuNDgtLjQ1NSAxLjg4MlpNOS40NzMgMjEuOTE1SDcuODQ2di00LjgzaDEuNjI3Yy40MTYgMCAuNzYuMDQ1IDEuMDMuMTM1LjI3LjA4NS40NzguMjMuNjI0LjQzMy4xNTIuMi4yNTYuNDM2LjMxMy43MS4wNTcuMjcuMDg1LjYyMy4wODUgMS4wNTkgMCAuNDM2LS4wMjYuNzk4LS4wNzggMS4wODctLjA1Mi4yODQtLjE1MS41NC0uMjk4Ljc2Ny0uMTQyLjIyMi0uMzUuMzg2LS42MjUuNDktLjI3NS4xLS42MjUuMTQ5LTEuMDUxLjE0OVptMS4wMy0xLjkxOGMuMDA5LS4xNTEuMDE0LS4zNi4wMTQtLjYyNSAwLS4yNy0uMDEtLjQ4NS0uMDI5LS42NDZhMS4yMjcgMS4yMjcgMCAwIDAtLjEzNS0uNDQuNTQ3LjU0NyAwIDAgMC0uMzItLjI3IDEuNjI3IDEuNjI3IDAgMCAwLS41Ni0uMDc4aC0uNjQ3djMuMTI1aC42NDdjLjM1NSAwIC42MTMtLjA5Ljc3NC0uMjcuMTM3LS4xNDcuMjIyLS40MTIuMjU1LS43OTZaTTExLjkwNyAxNy45NTJ2LS44NjdoMy41NTJ2Ljg2N0gxNC4xOHYzLjk2M2gtLjk4di0zLjk2M2gtMS4yOTNaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZmlsZS1wZGYiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzJfMjU3NykiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi41IDJoOC4yTDE5IDYuM3YxNC4yYTEuNSAxLjUgMCAwIDEtMS41IDEuNWgtMTFBMS41IDEuNSAwIDAgMSA1IDIwLjV2LTE3QTEuNSAxLjUgMCAwIDEgNi41IDJabTEwLjggNEwxNSAzLjd2MS44YS41LjUgMCAwIDAgLjUuNWgxLjhabS4yIDE1aC0xMWEuNS41IDAgMCAxLS41LS41di0xN2EuNS41IDAgMCAxIC41LS41SDE0djIuNUExLjUgMS41IDAgMCAwIDE1LjUgN0gxOHYxMy41YS41LjUgMCAwIDEtLjUuNVptLTkuMzg0LTMuODljLjA5LjE4LjIzLjM0My40MzkuNDE5LjIwNy4wNzYuNDExLjA0LjU4LS4wMjkuMzE4LS4xMzEuNjM1LS40MzYuOTI2LS43ODdhMTEuMzEgMTEuMzEgMCAwIDAgMS4wMi0xLjUxIDExLjY0OCAxMS42NDggMCAwIDEgMS45OTgtLjQwNWMuMy4zODIuNjEuNzEyLjkxLjk1LjI4LjIyLjYwMy40MDMuOTM0LjQxNmEuODU0Ljg1NCAwIDAgMCAuNTEtLjEzOGMuMTU0LS4xLjI3LS4yNDcuMzU0LS40MTYuMDktLjE4LjE0NS0uMzcuMTM4LS41NjJhLjg0NS44NDUgMCAwIDAtLjItLjUxOWMtLjIyNi0uMjctLjU5Ni0uNC0uOTYtLjQ2NS0uMzgtLjA2OC0uODQtLjA4LTEuMzM1LS4wNWExMC45NSAxMC45NSAwIDAgMS0uOTgtMS42ODZjLjI1LS42Ni40MzctMS4yODQuNTItMS43OTQuMDM2LS4yMTguMDU0LS40MjYuMDQ3LS42MTNhMS4yMzggMS4yMzggMCAwIDAtLjEyNi0uNTM5LjcuNyAwIDAgMC0uNDc3LS4zNjVjLS4yMDItLjA0My0uNDEgMC0uNjAyLjA3Ny0uMzc3LjE1MS0uNTc1LjQ3LS42NS44MjMtLjA3My4zNC0uMDQuNzM2LjA0NiAxLjEzNy4wODguNDA1LjIzOC44NDcuNDMgMS4yOTVhMTkuNzEgMTkuNzEgMCAwIDEtMS4wNjIgMi4yMjcgNy42NTYgNy42NTYgMCAwIDAtMS40ODMuNjQ1Yy0uMzcuMjE5LS42OTguNDgtLjg5Ni43ODYtLjIxLjMyNi0uMjc1LjcxNC0uMDggMS4xMDNabTEuMzU5LTEuMjQzYy4xMzktLjA4My4yOTMtLjE2Mi40NTgtLjIzOWE3Ljg1OSA3Ljg1OSAwIDAgMS0uNDUuNjA2Yy0uMjguMzM3LS40OTcuNTE2LS42MzQuNTczYS4yNjYuMjY2IDAgMCAxLS4wMzYuMDEyLjI4NS4yODUgMCAwIDEtLjAyNi0uMDQ0Yy0uMDU1LS4xMTEtLjA1My0uMjE3LjA0LS4zNjIuMTA2LS4xNjQuMzItLjM1My42NDgtLjU0NlptMi40NTUtMS42NDdjLS4xMTkuMDI0LS4yMzguMDUtLjM1Ni4wNzdhMjEuMTU1IDIxLjE1NSAwIDAgMCAuNDk5LTEuMDUgMTEuNzE4IDExLjcxOCAwIDAgMCAuNTEuODU4Yy0uMjE3LjAzMi0uNDM2LjA3LS42NTMuMTE1Wm0yLjUyNC45MzlhMy44OTIgMy44OTIgMCAwIDEtLjQzNC0uNDFjLjIyOC4wMDQuNDM0LjAyMS42MTIuMDUzLjMxNy4wNTguNDY2LjE0Ny41MTguMjA5YS4wOTYuMDk2IDAgMCAxIC4wMjUuMDY0LjQzNi40MzYgMCAwIDEtLjA1OS4yLjMwNy4zMDcgMCAwIDEtLjA5NC4xMjQuMTA3LjEwNyAwIDAgMS0uMDY5LjAxNmMtLjA5MS0uMDA0LS4yNTgtLjA2Ni0uNDk5LS4yNTZabS0yLjIyNC00Ljc0NmE2LjY3IDYuNjcgMCAwIDEtLjIuODI4IDQuODQyIDQuODQyIDAgMCAxLS4wODktLjM0NmMtLjA3Ni0uMzUzLS4wODctLjYzLS4wNDYtLjgyMS4wMzctLjE3OC4xMDktLjI0OS4xOTYtLjI4M2EuNTE4LjUxOCAwIDAgMSAuMTQ1LS4wNGMuMDEyLjAzLjAyOC4wOTEuMDMyLjE5Ny4wMDUuMTIyLS4wMDcuMjc3LS4wMzguNDY1WiIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImNsaXAwXzJfMjU3NyI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZpbGUtcGRmLWV4dCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuNSAyaDguMkwxOSA2LjN2MTQuMmExLjUgMS41IDAgMCAxLTEuNSAxLjVIMTZ2LTFoMS41YS41LjUgMCAwIDAgLjUtLjVWN2gtMi41QTEuNSAxLjUgMCAwIDEgMTQgNS41VjNINi41YS41LjUgMCAwIDAtLjUuNVYxNkg1VjMuNUExLjUgMS41IDAgMCAxIDYuNSAyWm0xMC44IDRMMTUgMy43djEuOGEuNS41IDAgMCAwIC41LjVoMS44WiIvPjxwYXRoIGQ9Ik00Ljk1NyAyMC41NDRINC4wOFYyMkgzdi01aDEuOTU3YzEuMjYzIDAgMS44OTUuNTc4IDEuODk1IDEuNzM1IDAgLjU4NC0uMTYyIDEuMDMyLS40ODYgMS4zNDYtLjMxOC4zMDktLjc4OC40NjMtMS40MDkuNDYzWm0tLjg3Ny0uODY3aC44N2MuNTM3IDAgLjgwNi0uMzE0LjgwNi0uOTQyIDAtLjMwOC0uMDY2LS41My0uMTk2LS42NjItLjEzLS4xMzctLjMzNC0uMjA1LS42MS0uMjA1aC0uODd2MS44MDlaTTkuNDAzIDIySDcuNjF2LTVoMS43OTNjLjQ2IDAgLjgzOC4wNDcgMS4xMzUuMTQuMjk3LjA4OC41MjcuMjM4LjY4OS40NDguMTY3LjIwNi4yODIuNDUxLjM0NC43MzUuMDYzLjI4LjA5NC42NDUuMDk0IDEuMDk2IDAgLjQ1MS0uMDI4LjgyNi0uMDg2IDEuMTI1YTIuMDkyIDIuMDkyIDAgMCAxLS4zMjkuNzk0Yy0uMTU2LjIzLS4zODYuNC0uNjg4LjUwOC0uMzAzLjEwMi0uNjkuMTU0LTEuMTYuMTU0Wm0xLjEzNS0xLjk4NWMuMDEtLjE1Ny4wMTYtLjM3My4wMTYtLjY0NyAwLS4yOC0uMDEtLjUwMy0uMDMyLS42N2ExLjIxNiAxLjIxNiAwIDAgMC0uMTQ4LS40NTUuNTk1LjU5NSAwIDAgMC0uMzUzLS4yOCAxLjkwMiAxLjkwMiAwIDAgMC0uNjE4LS4wOEg4LjY5djMuMjM1aC43MTNjLjM5MSAwIC42NzYtLjA5My44NTMtLjI4LjE1Mi0uMTUyLjI0NS0uNDI2LjI4Mi0uODIzWk0xMi42MDIgMjJ2LTVIMTZ2Ljg4MmgtMi4zMTd2MS40N2gxLjg5NHYuODgzaC0xLjg5NFYyMmgtMS4wOFoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1maWxlLXBwdCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjcgMkg2LjVBMS41IDEuNSAwIDAgMCA1IDMuNVYxNmgxVjMuNWEuNS41IDAgMCAxIC41LS41SDE0djIuNUExLjUgMS41IDAgMCAwIDE1LjUgN0gxOHYxMy41YS41LjUgMCAwIDEtLjUuNUgxNXYxaDIuNWExLjUgMS41IDAgMCAwIDEuNS0xLjVWNi4zTDE0LjcgMlptLjMgMS43TDE3LjMgNmgtMS44YS41LjUgMCAwIDEtLjUtLjVWMy43WiIvPjxwYXRoIGQ9Ik00LjgyNSAyMC41MTloLS44MTh2MS40NDVIM1YxN2gxLjgyNWMxLjE3OCAwIDEuNzY3LjU3NCAxLjc2NyAxLjcyMyAwIC41NzktLjE1MSAxLjAyNC0uNDUzIDEuMzM2LS4yOTcuMzA2LS43MzUuNDYtMS4zMTQuNDZabS0uODE4LS44NjJoLjgxYy41MDIgMCAuNzUzLS4zMTEuNzUzLS45MzQgMC0uMzA3LS4wNjEtLjUyNi0uMTgzLS42NTctLjEyMi0uMTM2LS4zMTEtLjIwNS0uNTctLjIwNWgtLjgxdjEuNzk2Wk05LjEyNCAyMC41MTloLS44MTh2MS40NDVINy4zVjE3aDEuODI1YzEuMTc4IDAgMS43NjYuNTc0IDEuNzY2IDEuNzIzIDAgLjU3OS0uMTUgMS4wMjQtLjQ1MiAxLjMzNi0uMjk3LjMwNi0uNzM1LjQ2LTEuMzE0LjQ2Wm0tLjgxOC0uODYyaC44MWMuNTAyIDAgLjc1Mi0uMzExLjc1Mi0uOTM0IDAtLjMwNy0uMDYtLjUyNi0uMTgyLS42NTctLjEyMi0uMTM2LS4zMTItLjIwNS0uNTctLjIwNWgtLjgxdjEuNzk2Wk0xMS4xNTIgMTcuODlWMTdoMy42NXYuODloLTEuMzE0djQuMDc0aC0xLjAwN3YtNC4wNzNoLTEuMzI5WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZpbGUtc2hlZXQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzJfMjU3MCkiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi41IDJoOC4yTDE5IDYuM3YxNC4yYTEuNSAxLjUgMCAwIDEtMS41IDEuNWgtMTFBMS41IDEuNSAwIDAgMSA1IDIwLjV2LTE3QTEuNSAxLjUgMCAwIDEgNi41IDJabTEwLjggNEwxNSAzLjd2MS44YS41LjUgMCAwIDAgLjUuNWgxLjhabS4yIDE1aC0xMWEuNS41IDAgMCAxLS41LS41di0xN2EuNS41IDAgMCAxIC41LS41SDE0djIuNUExLjUgMS41IDAgMCAwIDE1LjUgN0gxOHYxMy41YS41LjUgMCAwIDEtLjUuNVpNMTQgMTB2N2gydi03aC0yWm0tMyA3di01aDJ2NWgtMlptLTMtM3YzaDJ2LTNIOFoiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJjbGlwMF8yXzI1NzAiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1maWxlLXNsaWRlcyIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuNSAyaDguMkwxOSA2LjN2MTQuMmExLjUgMS41IDAgMCAxLTEuNSAxLjVoLTExQTEuNSAxLjUgMCAwIDEgNSAyMC41di0xN0ExLjUgMS41IDAgMCAxIDYuNSAyWm0xMC44IDRMMTUgMy43djEuOGEuNS41IDAgMCAwIC41LjVoMS44Wm0uMiAxNWgtMTFhLjUuNSAwIDAgMS0uNS0uNXYtMTdhLjUuNSAwIDAgMSAuNS0uNUgxNHYyLjVBMS41IDEuNSAwIDAgMCAxNS41IDdIMTh2MTMuNWEuNS41IDAgMCAxLS41LjVaTTguNTA0IDkuNDM4QS41LjUgMCAwIDEgOSA5aDZhLjUuNSAwIDAgMSAuNDk2LjQzOGwuNSA0QS41LjUgMCAwIDEgMTUuNSAxNGgtM3YySDE0djFoLTR2LTFoMS41di0yaC0zYS41LjUgMCAwIDEtLjQ5Ni0uNTYybC41LTRabTIuNDk2Ljc4M3YyLjU1OGMwIC4wOTcuMTA2LjE1Ny4xOS4xMDdsMi4xMzEtMS4yNzlhLjEyNS4xMjUgMCAwIDAgMC0uMjE0bC0yLjEzMi0xLjI4YS4xMjUuMTI1IDAgMCAwLS4xODkuMTA4WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZpbGUtdHh0IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi41IDJoOC4yTDE5IDYuM3YxNC4yYTEuNSAxLjUgMCAwIDEtMS41IDEuNUgxNHYtMWgzLjVhLjUuNSAwIDAgMCAuNS0uNVY3aC0yLjVBMS41IDEuNSAwIDAgMSAxNCA1LjVWM0g2LjVhLjUuNSAwIDAgMC0uNS41VjE2SDVWMy41QTEuNSAxLjUgMCAwIDEgNi41IDJabTEwLjggNEwxNSAzLjd2MS44YS41LjUgMCAwIDAgLjUuNWgxLjhaIi8+PHBhdGggZD0iTTMgMTcuODk3VjE3aDMuNTI1di44OTdINS4yNTZWMjJoLS45NzN2LTQuMTAzSDNaTTcuNzYxIDE3bC44ODkgMS44MzhMOS41NiAxN2gxLjAwN2wtMS4zODEgMi41NTJMMTAuNTY3IDIySDkuNDlMOC42IDIwLjI3MiA3LjY5MSAyMkg2LjY4M2wxLjM4Mi0yLjM5N0w2LjY4MyAxN0g3Ljc2Wk0xMC43MjUgMTcuODk3VjE3aDMuNTI1di44OTdoLTEuMjY5VjIyaC0uOTczdi00LjEwM2gtMS4yODNaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZmlsZS12aWRlbyIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMl8yNTg0KSI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjUgMmg4LjJMMTkgNi4zdjE0LjJhMS41IDEuNSAwIDAgMS0xLjUgMS41aC0xMUExLjUgMS41IDAgMCAxIDUgMjAuNXYtMTdBMS41IDEuNSAwIDAgMSA2LjUgMlptMTAuOCA0TDE1IDMuN3YxLjhhLjUuNSAwIDAgMCAuNS41aDEuOFptLjIgMTVoLTExYS41LjUgMCAwIDEtLjUtLjV2LTE3YS41LjUgMCAwIDEgLjUtLjVIMTR2Mi41QTEuNSAxLjUgMCAwIDAgMTUuNSA3SDE4djEzLjVhLjUuNSAwIDAgMS0uNS41Wk0xMCAxNS40MjZ2LTQuODUyYzAtLjQ0NS40NjgtLjcyLjgzNi0uNDkybDMuODk2IDIuNDI3YS41ODUuNTg1IDAgMCAxIDAgLjk4MmwtMy44OTYgMi40MjdjLS4zNjguMjI5LS44MzYtLjA0Ni0uODM2LS40OTJaIi8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iY2xpcDBfMl8yNTg0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZmlsZS14bWwiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjUgMmg4LjJMMTkgNi4zdjE0LjJhMS41IDEuNSAwIDAgMS0xLjUgMS41SDE3di0xaC41YS41LjUgMCAwIDAgLjUtLjVWN2gtMi41QTEuNSAxLjUgMCAwIDEgMTQgNS41VjNINi41YS41LjUgMCAwIDAtLjUuNVYxNkg1VjMuNUExLjUgMS41IDAgMCAxIDYuNSAyWm0xMC44IDRMMTUgMy43djEuOGEuNS41IDAgMCAwIC41LjVoMS44WiIvPjxwYXRoIGQ9Im0zLjEyIDE3IC45MiAxLjgzOEw0Ljk4NSAxN0g2LjAzbC0xLjQzMyAyLjU1Mkw2LjAzIDIySDQuOTExbC0uOTIxLTEuNzI4TDMuMDQ2IDIySDJsMS40MzQtMi4zOTdMMiAxN2gxLjEyWk02LjY0IDIydi01aDEuNzJsLjg3NyAzLjY0Ny44NzgtMy42NDdoMS43MTl2NWgtMS4wMXYtMy44NjhoLS4xMWwtLjk3MiAzLjY0N2gtMS4wMWwtLjk3My0zLjY0N2gtLjExVjIySDYuNjRaTTE1Ljc1IDIyaC0yLjgzdi01aDEuMDA5djQuMTAzaDEuODIxVjIyWiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZpbGVzIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xNS43IDJINy41QzYuNyAyIDYgMi43IDYgMy41VjRoLS41QzQuNyA0IDQgNC43IDQgNS41djE1YzAgLjguNyAxLjUgMS41IDEuNWgxMWMuOCAwIDEuNS0uNyAxLjUtMS41VjIwaC41Yy44IDAgMS41LS43IDEuNS0xLjVWNi4zTDE1LjcgMnptLjMgMS43TDE4LjMgNmgtMS44Yy0uMyAwLS41LS4yLS41LS41VjMuN3ptMSAxNi44YzAgLjMtLjIuNS0uNS41aC0xMWMtLjMgMC0uNS0uMi0uNS0uNXYtMTVjMC0uMy4yLS41LjUtLjVINnYxMy41YzAgLjguNyAxLjUgMS41IDEuNUgxN3YuNXptMS41LTEuNWgtMTFjLS4zIDAtLjUtLjItLjUtLjV2LTE1YzAtLjMuMi0uNS41LS41SDE1djIuNWMwIC44LjcgMS41IDEuNSAxLjVIMTl2MTEuNWMwIC4zLS4yLjUtLjUuNXpNOSA5aDh2MUg5Vjl6bTAgMmg4djFIOXYtMXptMCAyaDR2MUg5di0xeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZsYWciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0ibTE3LjEgOCAzLjMtNUg1VjJINHYyMGgxdi05aDE1LjRsLTMuMy01ek01IDRoMTMuNmwtMi43IDQgMi43IDRINVY0eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZsaWNrciIgdmlld0JveD0iMCAwIDI0IDI0Ij48Y2lyY2xlIGN4PSI2LjciIGN5PSIxMiIgcj0iNC43Ii8+PGNpcmNsZSBjeD0iMTcuMyIgY3k9IjEyIiByPSI0LjciLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1mbGlja3Itc3F1YXJlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0yMCA0Yy0uNi0uNi0xLjUtMS0yLjQtMUg2LjRjLS45IDAtMS44LjQtMi40IDEtLjYuNi0xIDEuNS0xIDIuNHYxMS4zYzAgLjkuNCAxLjggMSAyLjQuNi42IDEuNSAxIDIuNCAxaDExLjJjMS45IDAgMy40LTEuNSAzLjQtMy40VjYuNGMwLS45LS40LTEuOC0xLTIuNHptLTkuNiA5LjhjLTEgMS0yLjUgMS0zLjUgMHMtMS0yLjUgMC0zLjUgMi41LTEgMy41IDBjMSAuOSAxIDIuNSAwIDMuNXptNi42IDBjLS43LjctMS44LjktMi43LjUtLjktLjQtMS41LTEuMy0xLjUtMi4zIDAtMSAuNi0xLjkgMS41LTIuMy45LS40IDItLjIgMi43LjUgMSAxIDEgMi42IDAgMy42eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZvbGRlciIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjAgNmgtOGwtMi0ySDRjLTEuMSAwLTIgLjktMiAydjEyYzAgMS4xLjkgMiAyIDJoMTZjMS4xIDAgMi0uOSAyLTJWOGMwLTEuMS0uOS0yLTItMnptMSAxMmMuMS41LS4zLjktLjggMUg0Yy0uNS4xLS45LS4zLTEtLjhWNmMtLjEtLjUuMy0uOS44LTFoNS44bDEuNyAxLjcuMy4zSDIwYy41LS4xLjkuMyAxIC44VjE4ek00IDhoMTZ2MUg0Vjh6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZnVsbHNjcmVlbiIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNCAyMGg0LjV2MUgzdi01LjVoMXpNMyA4LjVoMVY0aDQuNVYzSDN6TTIwIDIwaC00LjV2MUgyMXYtNS41aC0xek0xNS41IDN2MUgyMHY0LjVoMVYzeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWZ1bm5lbCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTQgMjJoLTF2LTguNkwyMCAzSDRsNyAxMC40VjIyaC0xdi04LjRMMiAyaDIwbC04IDExLjZWMjJ6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZ2l0aHViIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMiAyYy00LjkgMC05LjEgMy42LTkuOSA4LjRzMi4xIDkuNSA2LjcgMTEuMWMuNS4xLjctLjIuNy0uNXYtMS43Yy0yLjguNi0zLjQtMS4zLTMuNC0xLjMtLjEtLjYtLjYtMS4yLTEuMS0xLjUtLjktLjYuMS0uNi4xLS42LjYuMSAxLjIuNSAxLjUgMSAuNiAxIDEuOSAxLjQgMi45LjggMC0uNS4zLTEgLjYtMS4zLTIuMS0uMi00LjUtMS4xLTQuNS00LjkgMC0xIC4zLTIgMS0yLjctLjMtLjktLjItMS44LjEtMi42IDAgMCAuOC0uMyAyLjggMSAxLjYtLjQgMy40LS40IDUgMCAxLjktMS4zIDIuNy0xIDIuNy0xIC40LjguNCAxLjguMSAyLjYuNy43IDEgMS43IDEgMi43IDAgMy44LTIuMyA0LjctNC42IDQuOS41LjUuNyAxLjIuNyAxLjl2Mi44YzAgLjQuMi42LjcuNSA0LjctMS41IDcuNS02LjIgNi43LTExLjFTMTYuOSAyIDEyIDJ6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtZ29vZ2xlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMi41NDUgMTAuMjM5djMuODIxaDUuNDQ1Yy0uNzEyIDIuMzE1LTIuNjQ3IDMuOTcyLTUuNDQ1IDMuOTcyYTYuMDMzIDYuMDMzIDAgMSAxIDAtMTIuMDY0YzEuNDk4IDAgMi44NjYuNTQ5IDMuOTIxIDEuNDUzbDIuODE0LTIuODE0QTkuOTY5IDkuOTY5IDAgMCAwIDEyLjU0NSAyQzcuMDIxIDIgMi41NDMgNi40NzcgMi41NDMgMTJzNC40NzggMTAgMTAuMDAyIDEwYzguMzk2IDAgMTAuMjQ5LTcuODUgOS40MjYtMTEuNzQ4bC05LjQyNi0uMDEzeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWhlYXJpbmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIwIDljMCAyLjUtMS4zIDQuOC0zLjUgNmwtMiAxLjFjLS45LjYtMS41IDEuNi0xLjUgMi43IDAgMS44LTEuNCAzLjItMy4yIDMuMmgtLjZjLTEuMy0uMS0yLjUtLjktMy0yLjFsLjktLjVjLjMuOSAxLjEgMS42IDIuMSAxLjZoLjZjLjYgMCAxLjItLjIgMS42LS43LjQtLjQuNi0uOS42LTEuNSAwLTEuNC44LTIuOCAyLTMuNWwyLTEuMmMxLjgtMSAzLTMgMy01LjEgMC0zLjMtMi43LTYtNi02LTEuOSAwLTMuNy45LTQuOCAyLjRsLS44LS42QzguNyAzIDEwLjggMiAxMyAyYzMuOSAwIDcgMy4xIDcgN3pNNy41IDEyQzcuNSA5IDUgNi41IDIgNi41djFjMi41IDAgNC41IDIgNC41IDQuNXMtMiA0LjUtNC41IDQuNXYxYzMgMCA1LjUtMi41IDUuNS01LjV6TTUgMTJjLjEtMS42LTEuMi0yLjktMi44LTNIMnYxYzEuMSAwIDIgLjkgMiAycy0uOSAyLTIgMnYxYzEuNi4xIDIuOS0xLjIgMy0yLjhWMTJ6bTUgMGMwLTQuNC0zLjYtOC04LTh2MWMzLjkgMCA3IDMuMSA3IDdzLTMuMSA3LTcgN3YxYzQuNCAwIDgtMy42IDgtOHptNS45LjNjLjgtLjkgMS4yLTIgMS4yLTMuMiAwLTEuMi0uNC0yLjMtMS4yLTMuMi0uOC0uOS0yLTEuNC0zLjItMS40LTEuMi4xLTIuNC42LTMuMiAxLjVsLS4zLjMuMi4zYy42LjkgMS4xIDEuOSAxLjMgM3YuNGguNGMuOCAwIDEuNS43IDEuNSAxLjVzLS43IDEuNS0xLjUgMS41djFjMS40IDAgMi41LTEuMSAyLjUtMi41IDAtMS4yLS44LTIuMi0yLTIuNS0uMi0uOS0uNi0xLjgtMS4xLTIuNi42LS41IDEuNC0uOCAyLjItLjkuOSAwIDEuOC40IDIuNCAxIC43LjcgMSAxLjYgMSAyLjZzLS4zIDEuOS0xIDIuNmwuOC42eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWhlbHAiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyLjggMjJoLTEuNHYtMi4xaDEuNFYyMnptLS4xLTQuOWgtMS4yYy0uMS0uNi0uMS0xLjEtLjEtMS43IDAtLjQuMS0uOC4zLTEuMi4yLS41LjQtLjkuNy0xLjNsMi4zLTIuMWMuNy0uNiAxLjMtMS4zIDEuOC0yLjEuNC0uNy41LTEuNS41LTIuMy4xLTEtLjMtMi0xLjEtMi42LTEtLjYtMi4yLS44LTMuNC0uNy0xLjIuMS0yLjQuMi0zLjYuNWwtMSAuMy0uMi0xLjJoLjFjMS41LS41IDMuMS0uNyA0LjctLjggMS41LS4xIDMgLjIgNC4zIDEgMSAuOSAxLjUgMi4yIDEuNCAzLjUuMS45LS4xIDEuOS0uNSAyLjctLjUuOC0xLjEgMS42LTEuOSAyLjItLjYuNS0xLjIgMS0xLjggMS42bC0uOSAxLjJjLS4zLjQtLjQuOS0uNCAxLjR2MS42eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWhlbHAtY2lyY2xlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMiAyQzYuNSAyIDIgNi41IDIgMTJzNC41IDEwIDEwIDEwIDEwLTQuNSAxMC0xMFMxNy41IDIgMTIgMnptMCAxOWMtNSAwLTktNC05LTlzNC05IDktOSA5IDQgOSA5LTQgOS05IDl6bS0xLjItNC41SDEydjEuOGgtMS4ydi0xLjh6bTQuNS04YzAgLjYtLjEgMS4yLS4zIDEuOC0uMy41LS44IDEtMS4zIDEuNEwxMi4zIDEzYy0uMi40LS40LjgtLjQgMS4ydi42SDExYy0uMS0uMy0uMi0uNy0uMi0xIDAtLjQuMi0uOS41LTEuMi40LS41LjktMSAxLjQtMS40LjUtLjQuOS0uOCAxLjItMS4zLjItLjQuMy0uOS4zLTEuNCAwLS41LS4yLTEuMS0uNi0xLjQtLjYtLjMtMS4zLS41LTItLjRMOS4zIDdoLS41di0uOGMxLS4zIDItLjUgMy0uNS45LS4xIDEuOS4xIDIuNy42LjYuNi45IDEuNC44IDIuMnoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1ob3JuIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik01IDljLTEuNyAwLTMgMS4zLTMgM3MxLjMgMyAzIDNoLjVMNyAxOS4zYy4zIDEgMS4zIDEuNyAyLjMgMS43aC4yYy41IDAgLjktLjIgMS4yLS42LjMtLjQuNC0uOS4yLTEuNGwtMS4zLTRoMS44bDguNiAzLjhWNC43TDExLjQgOUg1em01IDEwLjNjMCAuMiAwIC40LS4xLjVsLS40LjJoLS4yYy0uNiAwLTEuMi0uNC0xLjQtMWwtMS4zLTRoMS45bDEuNSA0LjN6TTUgMTRjLTEuMSAwLTItLjktMi0ycy45LTIgMi0yaDZ2NEg1em0xNCAzLjItNy0zVjkuOGw3LTMuNXYxMC45ek0yMiA5djZoLTFWOWgxeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWluYm94IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik00IDJ2MTRoMy43bDEgMmg2LjZsMS0ySDIwVjJINHptMTUgMTNoLTMuM2wtMSAySDkuM2wtMS0ySDVWM2gxNHYxMnoiLz48cGF0aCBkPSJNMTkgMTdoMXY1SDR2LTVoMXY0aDE0ek03IDVoMTB2MUg3ek03IDhoMTB2MUg3ek03IDExaDEwdjFIN3oiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1pbmZvLWNpcmNsZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgMkM2LjUgMiAyIDYuNSAyIDEyczQuNSAxMCAxMCAxMCAxMC00LjUgMTAtMTBTMTcuNSAyIDEyIDJ6bTAgMTljLTUgMC05LTQtOS05czQtOSA5LTkgOSA0IDkgOS00IDktOSA5em0tLjctMTVoMS41djJoLTEuNVY2em0wIDNoMS41djloLTEuNVY5eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWluc3RhZ3JhbSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgNC42Yy0yLjQuMS0yLjYuMS0zLjYuMS0uNiAwLTEuMi4xLTEuNy4zLS40LjItLjcuNC0xIC43LS4zLjMtLjUuNi0uNyAxLS4yLjUtLjMgMS4xLS4zIDEuN3Y3LjJjMCAuNi4xIDEuMS4zIDEuNy4yLjQuNC43LjcgMSAuMy4zLjYuNSAxIC43LjUuMiAxLjEuMyAxLjcuMyAxIC4xIDEuMi4xIDMuNi4xczIuNi0uMSAzLjYtLjFjLjYgMCAxLjEtLjEgMS43LS4zLjgtLjMgMS40LS45IDEuNy0xLjcuMi0uNS4zLTEuMS4zLTEuNy4xLS45LjEtMS4yLjEtMy42cy0uMS0yLjYtLjEtMy42YzAtLjYtLjEtMS4xLS4zLTEuNy0uMi0uNC0uNC0uNy0uNy0xLS4zLS4zLS42LS41LTEtLjctLjUtLjItMS4xLS4zLTEuNy0uNEgxMnpNMTIgM2gzLjdjLjcgMCAxLjUuMiAyLjIuNCAxLjIuNSAyLjIgMS40IDIuNyAyLjYuMi44LjQgMS41LjQgMi4zdjcuNGMwIC44LS4yIDEuNS0uNSAyLjItLjUgMS4yLTEuNCAyLjItMi42IDIuNi0uNy4zLTEuNC40LTIuMi40SDguM2MtLjggMC0xLjUtLjItMi4yLS41LTEuMi0uNS0yLjItMS40LTIuNi0yLjYtLjMtLjctLjQtMS40LS40LTIuMlY4LjJjMC0uNy4yLTEuNS40LTIuMi41LTEuMiAxLjQtMi4yIDIuNi0yLjcuNy0uMSAxLjQtLjMgMi4yLS4zSDEyem0wIDQuNGMxLjIgMCAyLjQuNSAzLjMgMS40czEuNCAyIDEuNCAzLjNjMCAyLjYtMi4xIDQuNi00LjYgNC42UzcuNCAxNC42IDcuNCAxMnMyLTQuNiA0LjYtNC42em0wIDcuNmMuOCAwIDEuNi0uMyAyLjEtLjkuNi0uNi45LTEuMy45LTIuMSAwLTEuNy0xLjMtMy0zLTNzLTMgMS4zLTMgMyAxLjMgMyAzIDN6bTQuOC02LjdjLS42IDAtMS4xLS41LTEuMS0xLjFzLjUtMS4xIDEuMS0xLjFjLjYgMCAxLjEuNSAxLjEgMS4xcy0uNSAxLjEtMS4xIDEuMXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1rZXkiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE4IDEwYy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMnptMCAzYy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xIDEgLjQgMSAxYy4xLjUtLjMuOS0uOCAxSDE4em0tMS02Yy0yIDAtMy44IDEuMi00LjYgM0gzLjNsLTIgMiAzIDNIN3YtMWguM2wxIDFIMTF2LTFoMS40Yy44IDEuOCAyLjYgMyA0LjYgMyAyLjggMCA1LTIuMiA1LTVzLTIuMi01LTUtNXptMCA5Yy0xLjcgMC0zLjItMS4xLTMuOC0yLjdWMTNIMTB2MUg4LjdsLTEtMUg2djFINC43bC0yLTIgMS0xaDkuNHYtLjNDMTMuNyA5LjEgMTUuMyA4IDE3IDhjMi4yIDAgNCAxLjggNCA0cy0xLjggNC00IDR6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtbGVzcy1jaXJjbGUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyIDNjNSAwIDkgNCA5IDkgMCAyLjQtLjkgNC43LTIuNiA2LjQtMy41IDMuNS05LjIgMy41LTEyLjcgMHMtMy41LTkuMiAwLTEyLjdDNy4zIDMuOSA5LjYgMyAxMiAzbTAtMUM2LjUgMiAyIDYuNSAyIDEyczQuNSAxMCAxMCAxMCAxMC00LjUgMTAtMTBjMC0yLjctMS4xLTUuMi0yLjktNy4xQzE3LjIgMyAxNC43IDIgMTIgMnoiLz48cGF0aCBkPSJNNy44IDExLjNoOC41Yy40IDAgLjguMy44LjggMCAuNC0uMy44LS44LjhINy44Yy0uNS0uMS0uOC0uNS0uOC0uOXMuMy0uNy44LS43eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWxpbmsiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0ibTEzLjQgMTMuNC0uNy0uN2MuNi0uNS45LTEuMy45LTIuMXMtLjMtMS42LS45LTIuMUw5LjIgNC45QzggMy44IDYuMSAzLjggNC45IDQuOSAzLjggNi4xIDMuOCA4IDQuOSA5LjJMNy44IDEybC0uNy43LTIuOS0yLjhjLTEuNS0xLjYtMS41LTQuMSAwLTUuNyAxLjYtMS41IDQuMS0xLjUgNS43IDBsMy41IDMuNmMuOC43IDEuMiAxLjcgMS4yIDIuOCAwIDEuMS0uNCAyLjEtMS4yIDIuOHptNi40IDYuNGMxLjUtMS42IDEuNS00LjEgMC01LjdsLTIuOS0yLjgtLjcuNyAyLjkgMi44YzEuMSAxLjIgMS4xIDMuMSAwIDQuMy0xLjIgMS4xLTMuMSAxLjEtNC4zIDBsLTMuNS0zLjZjLS42LS41LS45LTEuMy0uOS0yLjFzLjMtMS42LjktMi4xbC0uNy0uN2MtLjguNy0xLjIgMS43LTEuMiAyLjggMCAxLjEuNCAyLjEgMS4yIDIuOGwzLjUgMy42Yy43LjcgMS44IDEuMSAyLjggMS4xIDEuMS4xIDIuMS0uMyAyLjktMS4xeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWxpbmtlZGluIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xNi41IDguN2MtMS40IDAtMi44LjctMy41IDEuOVY5SDkuNHYxMmgzLjd2LTUuOWMwLTEuNi4zLTMuMSAyLjItMy4xczEuOSAxLjggMS45IDMuMlYyMUgyMXYtNi42YzAtMy4yLS43LTUuNy00LjUtNS43ek01LjIgM0M0IDMgMyA0IDMgNS4yYzAgMS4yIDEgMi4yIDIuMiAyLjJzMi4yLTEgMi4yLTIuMmMwLS42LS4yLTEuMS0uNi0xLjUtLjUtLjUtMS4xLS43LTEuNi0uN3pNMy4zIDl2MTJIN1Y5SDMuM3ptMTMuMi0uM2MtMS40LS4xLTIuOC43LTMuNSAxLjlWOUg5LjR2MTJoMy43di01LjljMC0xLjYuMy0zLjEgMi4yLTMuMXMxLjkgMS44IDEuOSAzLjJWMjFIMjF2LTYuNmMwLTMuMi0uNy01LjctNC41LTUuN3pNMy4zIDIxSDdWOUgzLjN2MTJ6TTUuMiAzQzQgMyAzIDQgMyA1LjJjMCAxLjIgMSAyLjIgMi4yIDIuMnMyLjItMSAyLjItMi4yYzAtLjYtLjItMS4xLS42LTEuNS0uNS0uNS0xLjEtLjctMS42LS43eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWxpbmtlZGluLXNxdWFyZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkuNyAzSDQuM0MzLjYgMyAzIDMuNiAzIDQuM3YxNS40YzAgLjcuNiAxLjMgMS4zIDEuM2gxNS4zYy43IDAgMS4zLS42IDEuMy0xLjNWNC4zYy4xLS43LS41LTEuMy0xLjItMS4zek04LjMgMTguM0g1LjdWOS44aDIuN3Y4LjV6TTcgOC42Yy0uOSAwLTEuNS0uNy0xLjUtMS42IDAtLjkuNy0xLjUgMS41LTEuNnMxLjUuNyAxLjYgMS42YzAgLjQtLjIuOC0uNCAxLjEtLjQuMy0uOC41LTEuMi41em0xMS4zIDkuN2gtMi43di00LjJjMC0xIDAtMi4zLTEuNC0yLjNzLTEuNiAxLjEtMS42IDIuMnY0LjNIMTBWOS44aDIuNlYxMWMuNS0uOSAxLjUtMS40IDIuNS0xLjQgMi43IDAgMy4yIDEuOCAzLjIgNC4xdjQuNnoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1saXN0IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik00IDEyYy4xLjUtLjMuOS0uOCAxSDNjLS42IDAtMS0uNC0xLTFzLjQtMSAxLTFjLjUtLjEuOS4zIDEgLjh2LjJ6TTMgNC41Yy0uNS0uMS0uOS4zLTEgLjh2LjJjLS4xLjUuMy45LjggMUgzYy41LjEuOS0uMyAxLS44di0uMmMuMS0uNS0uMy0uOS0uOC0xSDN6bTAgMTNjLS42IDAtMSAuNC0xIDFzLjQgMSAxIDEgMS0uNCAxLTEtLjQtMS0xLTF6TTYgNXYxaDE2VjVINnptMCA3LjVoMTZ2LTFINnYxek02IDE5aDE2di0xSDZ2MXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1sb2NrIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xOC41IDguNUgxN1Y4YzAtMi44LTIuMi01LTUtNVM3IDUuMiA3IDh2LjVINS41QzQuNyA4LjUgNCA5LjIgNCAxMHY4LjVjMCAuOC43IDEuNSAxLjUgMS41aDEzYy44IDAgMS41LS43IDEuNS0xLjVWMTBjMC0uOC0uNy0xLjUtMS41LTEuNXpNOCA4YzAtMi4yIDEuOC00IDQtNHM0IDEuOCA0IDR2LjVIOFY4em0xMSAxMC41YzAgLjMtLjIuNS0uNS41aC0xM2MtLjMgMC0uNS0uMi0uNS0uNVYxMGMwLS4zLjItLjUuNS0uNWgxM2MuMyAwIC41LjIuNS41djguNXoiLz48cGF0aCBkPSJNMTIgMTMuM2MuNiAwIDEgLjQgMSAxcy0uNCAxLTEgMS0xLS40LTEtMSAuNC0xIDEtMW0wLTFjLTEuMSAwLTIgLjktMiAycy45IDIgMiAyIDItLjkgMi0yLS45LTItMi0yeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWxvY2tlZCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTYuNSAxMkgxNlY3YzAtMi4yLTEuOC00LTQtNFM4IDQuOCA4IDd2NWgtLjVjLS42IDAtMS4xLjUtMS4xIDEuMXY2LjhjMCAuNi41IDEuMSAxLjEgMS4xaDljLjYgMCAxLjEtLjUgMS4xLTEuMXYtNi44YzAtLjYtLjUtMS4xLTEuMS0xLjF6TTkgN2MwLTEuNyAxLjMtMyAzLTNzMyAxLjMgMyAzdjVIOVY3em03LjYgMTIuOWMwIC4xIDAgLjEtLjEuMWgtOWMtLjEgMC0uMSAwLS4xLS4xdi02LjhoOS4ydjYuOHpNMTMgMTUuNWMwIC4zLS4yLjctLjUuOHYxLjVoLTF2LTEuNWMtLjMtLjEtLjUtLjUtLjUtLjggMC0uNi40LTEgMS0xczEgLjQgMSAxeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LWxvZ291dCIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMl8yNTk4KSI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi43IDcuNyAyMSAxMmwtNC4zIDQuMy0uNy0uNyAzLTMuMUg5Ljh2LTFoOS4zTDE2IDguNGwuNy0uN1pNNC41IDIwSDEydjFINC41QTEuNSAxLjUgMCAwIDEgMyAxOS41di0xNUExLjUgMS41IDAgMCAxIDQuNSAzSDEydjFINC41YS41LjUgMCAwIDAtLjUuNXYxNWEuNS41IDAgMCAwIC41LjVaIi8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iY2xpcDBfMl8yNTk4Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtbWFpbCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjAuNSA1aC0xN0MyLjcgNSAyIDUuNyAyIDYuNXYxMWMwIC44LjcgMS41IDEuNSAxLjVoMTdjLjggMCAxLjUtLjcgMS41LTEuNXYtMTFjMC0uOC0uNy0xLjUtMS41LTEuNXptLS4zIDEtNy4xIDcuMmMtLjYuNi0xLjYuNi0yLjIgMEwzLjggNmgxNi40ek0zIDE3LjNWNi42TDguMyAxMiAzIDE3LjN6bS43LjdMOSAxMi43bDEuMiAxLjJjMSAuOSAyLjYuOSAzLjYgMGwxLjItMS4yIDUuMyA1LjNIMy43em0xMi02TDIxIDYuNnYxMC43TDE1LjcgMTJ6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtbWFpbC1vcGVuIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjEgMTkuODU4VjIwYTEgMSAwIDAgMS0xIDFINGExIDEgMCAwIDEtMS0xdi0uMTQybDktNS40IDkgNS40Wm0wLTEuMTY2di03Ljc1OWwtNi40NjYgMy44OEwyMSAxOC42OTJabTAtOC45MjV2LTEuNTNhMSAxIDAgMCAwLS41NTMtLjg5NWwtOC00YTEgMSAwIDAgMC0uODk0IDBsLTggNEExIDEgMCAwIDAgMyA4LjIzNnYxLjUzbDcuNDM3IDQuNDYzTDEyIDEzLjI5MmwxLjU2Mi45MzdMMjEgOS43NjdaTTMgMTAuOTMzdjcuNzU5bDYuNDY2LTMuODhMMyAxMC45MzRaTTIgOC4yMzZhMiAyIDAgMCAxIDEuMTA2LTEuNzg5bDgtNGEyIDIgMCAwIDEgMS43ODggMGw4IDRBMiAyIDAgMCAxIDIyIDguMjM3VjIwYTIgMiAwIDAgMS0yIDJINGEyIDIgMCAwIDEtMi0yVjguMjM2WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LW1hcC1tYXJrZXIiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyIDIyIDYuMyAxMS42Yy0xLjctMy4xLS42LTcgMi42LTguOHM3LjEtLjYgOC44IDIuNWMuNSAxIC44IDIgLjggMy4xcy0uMyAyLjItLjggMy4xTDEyIDIyem0wLTE5QzkgMyA2LjUgNS41IDYuNSA4LjVjMCAuOS4yIDEuOS43IDIuN0wxMiAyMGw0LjgtOC44YzEuNS0yLjYuNS02LTIuMS03LjUtLjgtLjUtMS44LS43LTIuNy0uN3oiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1tYXAtbWFya2VyLWNpcmNsZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTcuNyA1LjNDMTYgMi4yIDEyIDEuMSA4LjkgMi44cy00LjMgNS43LTIuNSA4LjhMMTIgMjJsNS43LTEwLjRjLjUtMSAuOC0yIC44LTMuMXMtLjMtMi4yLS44LTMuMnptLS45IDUuOEwxMiAxOS45bC00LjgtOC44Yy0uNS0uOC0uNy0xLjctLjctMi43QzYuNSA1LjQgOSAzIDEyIDNzNS41IDIuNSA1LjUgNS41YzAgLjktLjIgMS44LS43IDIuNnoiLz48cGF0aCBkPSJNMTIgNWMtMS45IDAtMy41IDEuNi0zLjUgMy41UzEwLjEgMTIgMTIgMTJzMy41LTEuNiAzLjUtMy41UzEzLjkgNSAxMiA1em0wIDZjLTEuNCAwLTIuNS0xLjEtMi41LTIuNVMxMC42IDYgMTIgNnMyLjUgMS4xIDIuNSAyLjVTMTMuNCAxMSAxMiAxMXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1tYXAtbWFya2VyLW1pbnVzIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xNy43IDUuM0MxNiAyLjIgMTIgMS4xIDguOSAyLjhzLTQuMyA1LjctMi41IDguOEwxMiAyMmw1LjctMTAuNGMuNS0xIC44LTIgLjgtMy4xcy0uMy0yLjItLjgtMy4yem0tLjkgNS44TDEyIDE5LjlsLTQuOC04LjhjLS41LS44LS43LTEuNy0uNy0yLjdDNi41IDUuNCA5IDMgMTIgM3M1LjUgMi41IDUuNSA1LjVjMCAuOS0uMiAxLjgtLjcgMi42eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LW1hcC1tYXJrZXItcGx1cyIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTUuMSAyLjhjLTEtLjUtMi0uOC0zLjEtLjgtMy42IDAtNi41IDIuOS02LjUgNi41IDAgMS4xLjMgMi4yLjggMy4xTDEyIDIybDUuNy0xMC40YzEuNy0zLjIuNS03LjEtMi42LTguOHptMS43IDguM0wxMiAxOS45bC00LjgtOC44Yy0xLjUtMi43LS41LTYgMi4xLTcuNSAyLjctMS41IDYtLjUgNy41IDIuMS41LjguNyAxLjcuNyAyLjdzLS4yIDEuOS0uNyAyLjd6Ii8+PHBhdGggZD0iTTEyLjUgOGgzdjFoLTN2M2gtMVY5aC0zVjhoM1Y1aDF6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtbWFzdG9kb24iIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE1LjUyNyAxNi43MmMyLjI2Ny0uMjcgNC4yNC0xLjY2IDQuNDg5LTIuOTMuMzktMiAuMzU4LTQuODguMzU4LTQuODggMC0zLjkwNS0yLjU3LTUuMDUtMi41Ny01LjA1LTEuMjk3LS41OTItMy41MjMtLjg0MS01LjgzNi0uODZoLS4wNTdjLTIuMzEzLjAxOS00LjUzOC4yNjgtNS44MzQuODYgMCAwLTIuNTcyIDEuMTQ1LTIuNTcyIDUuMDUgMCAuMjM2IDAgLjQ4NS0uMDAyLjc0NWE3Ny4yNiA3Ny4yNiAwIDAgMCAuMDEzIDIuMzUyYy4wOTQgMy44MTguNzA0IDcuNTgyIDQuMjUyIDguNTE2IDEuNjM2LjQzMSAzLjA0MS41MjEgNC4xNzMuNDYgMi4wNTEtLjExNCAzLjIwMy0uNzI5IDMuMjAzLS43MjlsLS4wNjgtMS40ODFzLTEuNDY2LjQ2LTMuMTEzLjQwNGMtMS42My0uMDU2LTMuMzUzLS4xNzUtMy42MTctMi4xNjhhNC4wNjcgNC4wNjcgMCAwIDEtLjAzNi0uNTU5czEuNjAxLjM5IDMuNjMuNDgyYzEuMjQyLjA1NyAyLjQwNS0uMDcyIDMuNTg3LS4yMTJabTEuODE0LTIuNzhIMTUuNDZWOS4zNTNjMC0uOTY4LS40MS0xLjQ1OS0xLjIyOC0xLjQ1OS0uOTA0IDAtMS4zNTguNTgzLTEuMzU4IDEuNzM0djIuNTEyaC0xLjg3MVY5LjYyN2MwLTEuMTUxLS40NTQtMS43MzQtMS4zNTgtMS43MzQtLjgxOSAwLTEuMjI4LjQ5MS0xLjIyOCAxLjQ1OXY0LjU4OUg2LjUzNFY5LjIxM2MwLS45NjcuMjQ3LTEuNzM1Ljc0NC0yLjMwMy41MTItLjU2OCAxLjE4My0uODU5IDIuMDE1LS44NTkuOTY0IDAgMS42OTMuMzY4IDIuMTc2IDEuMTA1bC40NjkuNzgzLjQ2OC0uNzgzYy40ODMtLjczNyAxLjIxMi0xLjEwNSAyLjE3Ni0xLjEwNS44MzIgMCAxLjUwMy4yOTEgMi4wMTUuODYuNDk3LjU2Ny43NDQgMS4zMzUuNzQ0IDIuMzAydjQuNzI4WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LW1hc3RvZG9uLXNxdWFyZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuNTY3IDEuMzMzaDE2Ljc2MmEyLjI4NiAyLjI4NiAwIDAgMSAyLjI4NiAyLjI4NnYxNi43NjJhMi4yODYgMi4yODYgMCAwIDEtMi4yODYgMi4yODZIMy41NjdhMi4yODYgMi4yODYgMCAwIDEtMi4yODYtMi4yODZWMy42MTlhMi4yODYgMi4yODYgMCAwIDEgMi4yODYtMi4yODZabTE1LjYxNCAxMi4yNTljLS4yMiAxLjEyOC0xLjk3NSAyLjM2NC0zLjk5IDIuNjAzLTEuMDUuMTI1LTIuMDg1LjI0LTMuMTg4LjE5YTE4LjgxNSAxOC44MTUgMCAwIDEtMy4yMjgtLjQzYzAgLjE3NS4wMTEuMzQyLjAzMy40OTcuMjM0IDEuNzcyIDEuNzY1IDEuODc4IDMuMjE1IDEuOTI3YTkuMzMgOS4zMyAwIDAgMCAyLjc2Ny0uMzU5bC4wNiAxLjMxN3MtMS4wMjQuNTQ3LTIuODQ3LjY0N2MtMS4wMDYuMDU1LTIuMjU1LS4wMjUtMy43MDktLjQwOC0zLjE1NC0uODMtMy42OTctNC4xNzYtMy43OC03LjU3YTY4LjcwNyA2OC43MDcgMCAwIDEtLjAxMS0yLjA5bC4wMDItLjY2M2MwLTMuNDcgMi4yODUtNC40ODggMi4yODUtNC40ODggMS4xNTMtLjUyNyAzLjEzLS43NDggNS4xODYtLjc2NWguMDVjMi4wNTcuMDE3IDQuMDM1LjIzOCA1LjE4OC43NjUgMCAwIDIuMjg1IDEuMDE3IDIuMjg1IDQuNDg4IDAgMCAuMDMgMi41Ni0uMzE4IDQuMzM5Wm0tNC4wNTEuMTMzaDEuNjczVjkuNTIyYzAtLjg1OS0uMjItMS41NDEtLjY2LTIuMDQ2LS40NTYtLjUwNS0xLjA1Mi0uNzY0LTEuNzkzLS43NjQtLjg1NiAwLTEuNTA0LjMyOC0xLjkzMy45ODNMMTIgOC4zOWwtLjQxNy0uNjk1Yy0uNDI5LS42NTUtMS4wNzctLjk4My0xLjkzMy0uOTgzLS43NCAwLTEuMzM3LjI1OS0xLjc5Mi43NjQtLjQ0Mi41MDUtLjY2MSAxLjE4Ny0uNjYxIDIuMDQ2djQuMjAzSDguODd2LTQuMDhjMC0uODU5LjM2NC0xLjI5NSAxLjA5LTEuMjk1LjgwNSAwIDEuMjA4LjUxNyAxLjIwOCAxLjU0MXYyLjIzM2gxLjY2NFY5Ljg5YzAtMS4wMjQuNDAzLTEuNTQxIDEuMjA3LTEuNTQxLjcyNyAwIDEuMDkxLjQzNiAxLjA5MSAxLjI5NnY0LjA3OVoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1tYXhpbWl6ZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJtNC43IDQgNi43IDYuNi0uNy43TDQgNC43djMuOEgzVjNoNS41djF6TTIwIDE5LjNsLTYuNi02LjctLjcuNyA2LjYgNi43aC0zLjh2MUgyMXYtNS41aC0xek0xNS41IDN2MWgzLjhsLTYuNiA2LjYuNy43TDIwIDQuN3YzLjhoMVYzek0xMC42IDEyLjYgNCAxOS4zdi0zLjhIM1YyMWg1LjV2LTFINC43bDYuNy02Ljd6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtbWF4aW1pemUtYWx0IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Im0xNS4xIDE4LjEuNy43LTMuOCAzLjktMy45LTMuOS43LS43IDIuNyAyLjd2LTcuM2gxdjcuM3pNMTguOSA4LjFsLS44LjcgMi43IDIuN2gtNy4zdjFoNy4zbC0yLjYgMi42LjcuNyAzLjgtMy44ek0xMS41IDMuMnY3LjNoMVYzLjJsMi42IDIuNi43LS43TDEyIDEuMyA4LjEgNS4xbC43Ljd6TTEwLjUgMTIuNXYtMUgzLjJsMi42LTIuNy0uNi0uN0wxLjMgMTJsMy44IDMuOC43LS43LTIuNi0yLjZ6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtbWVkaXVtIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMy4yODEgMTIuNjI1YzAgMy4xMDctMi41MjUgNS42MjUtNS42NCA1LjYyNUM0LjUyNCAxOC4yNSAyIDE1LjczMiAyIDEyLjYyNVM0LjUyNSA3IDcuNjQgN2MzLjExNiAwIDUuNjQxIDIuNTE4IDUuNjQxIDUuNjI1Wm02LjE4OCAwYzAgMi45MjQtMS4yNjMgNS4yOTUtMi44MiA1LjI5NS0xLjU1OCAwLTIuODItMi4zNzEtMi44Mi01LjI5NXMxLjI2Mi01LjI5NSAyLjgyLTUuMjk1YzEuNTU3IDAgMi44MiAyLjM3MSAyLjgyIDUuMjk1Wm0yLjUzMSAwYzAgMi42Mi0uNDQ0IDQuNzQ0LS45OTIgNC43NDRzLS45OTItMi4xMjUtLjk5Mi00Ljc0NGMwLTIuNjIuNDQ0LTQuNzQ0Ljk5Mi00Ljc0NFMyMiAxMC4wMDUgMjIgMTIuNjI1WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LW1lZGl1bS1zcXVhcmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjU2NyAxLjMzM2gxNi43NjJhMi4yODYgMi4yODYgMCAwIDEgMi4yODYgMi4yODZ2MTYuNzYyYTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2IDIuMjg2SDMuNTY3YTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2LTIuMjg2VjMuNjE5YTIuMjg2IDIuMjg2IDAgMCAxIDIuMjg2LTIuMjg2Wk04LjUxMiAxNi41YTQuNTA2IDQuNTA2IDAgMCAwIDQuNTEzLTQuNWMwLTIuNDg1LTIuMDItNC41LTQuNTEzLTQuNUE0LjUwNiA0LjUwNiAwIDAgMCA0IDEyYzAgMi40ODYgMi4wMiA0LjUgNC41MTIgNC41Wm03LjIwNy0uMjY0YzEuMjQ2IDAgMi4yNTYtMS44OTcgMi4yNTYtNC4yMzYgMC0yLjM0LTEuMDEtNC4yMzYtMi4yNTYtNC4yMzYtMS4yNDYgMC0yLjI1NiAxLjg5Ny0yLjI1NiA0LjIzNiAwIDIuMzM5IDEuMDEgNC4yMzYgMi4yNTYgNC4yMzZabTMuNDg3LS40NGMuNDM5IDAgLjc5NC0xLjcuNzk0LTMuNzk2cy0uMzU1LTMuNzk1LS43OTMtMy43OTVjLS40MzkgMC0uNzk0IDEuNy0uNzk0IDMuNzk1IDAgMi4wOTUuMzU1IDMuNzk1Ljc5MyAzLjc5NVoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1taW5pbWl6ZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMyAxNS41aDUuNVYyMWgtMXYtNC41SDN6TTcuNSA3LjVIM3YxaDUuNVYzaC0xek0xNS41IDIxaDF2LTQuNUgyMXYtMWgtNS41ek0xNi41IDcuNVYzaC0xdjUuNUgyMXYtMXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1taW51cyIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjAgMTIuNUg0di0xaDE2djF6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtbWludXMtY2lyY2xlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik02LjkgMTEuNWgxMHYxaC0xMHYtMXpNMjIgMTJjMCA1LjUtNC41IDEwLTEwIDEwUzIgMTcuNSAyIDEyIDYuNSAyIDEyIDJzMTAgNC41IDEwIDEwem0tMSAwYzAtNS00LTktOS05cy05IDQtOSA5IDQgOSA5IDkgOS00IDktOXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1tb29kbGUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0xNC41NTYgNi02LjIyMy40NDRMMyA5LjU1NmgxLjMzM3Y0LjA5NWMtLjI1OC4yMTQtLjQ0NC43ODQtLjQ0NCAxLjQ2IDAgLjg2LjI5OSAxLjU1Ni42NjcgMS41NTYuMzY4IDAgLjY2Ni0uNDc1LjY2Ni0xLjMzNCAwLS42NzYtLjE4Ni0xLjM4Mi0uNDQ0LTEuNjU1VjkuNTU2aDQuODg5TDE0LjU1NiA2Wk0xMi4xMSA4LjIyMiA5Ljg5IDEwSDYuMzMzYy0uMDQzLjIxNi0uMDU1LjIwOC0uMDU1LjQzNiAwIC4yMy4wMjMuNDU3LjA2OC42NzQuMTI0LS4wMDQgMi42NTQtLjIyMSAzLjk5Ni44OS4yNi0uNzg4Ljk4Mi0xLjggMi4wMDctMi43Mi4wOTQtLjA4NS4xMTItLjA5LjIwNy0uMTY5IDAtLjQ0NC0uMjA1LS42MzItLjQ0NS0uODg5Wm0zLjc3OC40NDVhMy45NzcgMy45NzcgMCAwIDAtMi42NjcgMS4wM2MtLjEzNC0uMTItLjI4LS4yMjgtLjQzLS4zMy0uMDU1LjA0Ny0uMTEuMDk0LS4xNjUuMTQzLS43MjMuNjQ4LTEuMjkgMS4zNDItMS42NTYgMS45NzIuNTM5LjI0NC45MTguNzguOTE4IDEuNDA3VjE4aDIuNjY3di01LjExMWMwLS44NTYuNy0xLjU1NiAxLjU1NS0xLjU1Ni44NTYgMCAxLjU1Ni43IDEuNTU2IDEuNTU2VjE4aDIuNjY2di01LjMzM2MwLTIuMi0xLjgtNC00LTRoLS40NDRaTTYuMzQ2IDExLjM0YTMuOTM4IDMuOTM4IDAgMCAwLS4yMzUgMS4zMjdWMThoMi42Njd2LTUuMTExYzAtLjM4NS4xNDgtLjczMi4zODMtMS4wMDMtLjY4NS0uMzE1LTEuNjg2LS41Mi0yLjgxNS0uNTQ2WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LW1vb2RsZS1zcXVhcmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGgyNHYyNEgweiIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy41NjYgMS4zM2gxNi43NjFhMi4yODYgMi4yODYgMCAwIDEgMi4yODYgMi4yODZ2MTYuNzYyYTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2IDIuMjg1SDMuNTY1YTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg1LTIuMjg1VjMuNjE2QTIuMjg2IDIuMjg2IDAgMCAxIDMuNTY1IDEuMzNabTQuNzY3IDUuNDQ0IDYuMjIyLS40NDQtNC44ODkgMy41NTZINC43Nzh2NC4xMjJjLjI1OC4yNzMuNDQ0Ljk3OS40NDQgMS42NTUgMCAuODYtLjI5OSAxLjMzNC0uNjY3IDEuMzM0LS4zNjggMC0uNjY2LS42OTctLjY2Ni0xLjU1NiAwLS42NzYuMTg2LTEuMjQ2LjQ0NC0xLjQ2VjkuODg2SDNsNS4zMzMtMy4xMTJaTTkuODkgMTAuMzNsMi4yMjItMS43NzguMDQ1LjA0OWMuMjIuMjMzLjQuNDI0LjQuODRsLS4wOS4wNzJjLS4wMzQuMDI1LS4wNjMuMDQ3LS4xMTcuMDk3LTEuMDI1LjkyLTEuNzQ3IDEuOTMyLTIuMDA3IDIuNzItMS4yNzctMS4wNTctMy42MjctLjkxMi0zLjk2LS44OTJsLS4wMzYuMDAyYTMuMzM3IDMuMzM3IDAgMCAxLS4wNjgtLjY3NGMwLS4xOC4wMDctLjIxMy4wMzEtLjMyM2wuMDI0LS4xMTNIOS44OVptMy4zMzMtLjMwMmEzLjk3NyAzLjk3NyAwIDAgMSAyLjY2Ny0xLjAzMWguNDQ0YzIuMiAwIDQgMS44IDQgNHY1LjMzM2gtMi42NjZ2LTUuMTExYzAtLjg1Ni0uNy0xLjU1Ni0xLjU1Ni0xLjU1Ni0uODU2IDAtMS41NTYuNy0xLjU1NiAxLjU1NnY1LjExMUgxMS44OXYtNS4xMTFjMC0uNjI3LS4zOC0xLjE2My0uOTE4LTEuNDA3LjM2Ni0uNjMuOTMzLTEuMzI0IDEuNjU1LTEuOTcybC4xMTMtLjA5OC4wNTItLjA0NWMuMTUuMTAyLjI5Ni4yMS40MzEuMzNabS03LjExMSAyLjk2OWMwLS40NjYuMDg3LS45MS4yMzUtMS4zMjcgMS4xMjkuMDI2IDIuMTMuMjMgMi44MTQuNTQ2LS4yMzQuMjcxLS4zODIuNjE4LS4zODIgMS4wMDN2NS4xMTFINi4xMXYtNS4zMzNaIiBmaWxsPSIjMUUxRTFFIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtbW9yZS1hY3Rpb25zIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik02IDEwYy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMnptMCAzYy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xIDEgLjQgMSAxLS40IDEtMSAxem02LTNjLTEuMSAwLTIgLjktMiAycy45IDIgMiAyIDItLjkgMi0yLS45LTItMi0yem0wIDNjLS42IDAtMS0uNC0xLTFzLjQtMSAxLTEgMSAuNCAxIDFjLjEuNS0uMy45LS44IDFIMTJ6bTYtM2MtMS4xIDAtMiAuOS0yIDJzLjkgMiAyIDIgMi0uOSAyLTItLjktMi0yLTJ6bTAgM2MtLjYgMC0xLS40LTEtMXMuNC0xIDEtMSAxIC40IDEgMWMuMS41LS4zLjktLjggMUgxOHoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1tb3JlLWl0ZW1zIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMiAxOGMuNiAwIDEgLjQgMSAxcy0uNCAxLTEgMS0xLS40LTEtMWMtLjEtLjUuMy0uOS44LTFoLjJtMC0xYy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMnptMC02Yy42IDAgMSAuNCAxIDFzLS40IDEtMSAxLTEtLjQtMS0xYy0uMS0uNS4zLS45LjgtMWguMm0wLTFjLTEuMSAwLTIgLjktMiAycy45IDIgMiAyIDItLjkgMi0yLS45LTItMi0yem0wLTZjLjUtLjEuOS4zIDEgLjhWNWMwIC42LS40IDEtMSAxcy0xLS40LTEtMWMtLjEtLjUuMy0uOS44LTFoLjJtMC0xYy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMnoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1ub3RlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xOC41IDRoLTEzQzQuNyA0IDQgNC43IDQgNS41djEzYzAgLjguNyAxLjUgMS41IDEuNWgxMC4ybDQuMy00LjNWNS41YzAtLjgtLjctMS41LTEuNS0xLjV6TTUgMTguNXYtMTNjMC0uMy4yLS41LjUtLjVoMTNjLjMgMCAuNS4yLjUuNVYxNWgtMi41Yy0uOCAwLTEuNS43LTEuNSAxLjVWMTlINS41Yy0uMyAwLS41LS4yLS41LS41ek0xOC4zIDE2IDE2IDE4LjN2LTEuOGMwLS4zLjItLjUuNS0uNWgxLjh6TTE2IDlIOFY4aDh2MXptMCAySDh2LTFoOHYxem0tMiAxdjFIOHYtMWg2eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LW9wZW4tc291cmNlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMCAwQzQuNSAwIDAgNC41IDAgMTBjMCA0LjMgMi43IDguMSA2LjggOS41bDEuNy01LjguMy0xQzcuNyAxMi4zIDcgMTEuMiA3IDEwYzAtMS43IDEuMy0zIDMtM3MzIDEuMyAzIDNjMCAxLjItLjcgMi4zLTEuOSAyLjhsLjMgMSAxLjggNS44YzUuMy0xLjcgOC4xLTcuMyA2LjQtMTIuNi0xLjMtNC4yLTUuMi03LTkuNi03em0zLjggMTguMS0xLjUtNC45Yy4xLS4xLjItLjEuMi0uMi4xLS4xLjItLjEuMi0uMmwuMi0uMmMuMy0uMy42LS43LjctMS4xbC4xLS4zYzAtLjEuMS0uMi4xLS4zIDAtLjIuMS0uMy4xLS41VjEwYzAtMi4yLTEuOC00LTQtNHMtNCAxLjgtNCA0di41YzAgLjIuMS4zLjEuNCAwIC4yLjEuMy4xLjQuMS4zLjMuNi40LjguMS4xLjIuMy4zLjRsLjMuM2MuMS4xLjIuMi40LjNMNiAxOEMxLjUgMTUuOS0uNCAxMC41IDEuNyA2czcuNS02LjQgMTItNC4zIDYuNCA3LjUgNC4zIDEyYy0uNyAyLTIuMyAzLjYtNC4yIDQuNHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1wYSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMyAyMWgxOHYxSDN2LTF6bTAtMWgxOHYtMUgzdjF6TTIyIDlIMmwxMC03IDEwIDd6TTUuMiA4aDEzLjZMMTIgMy4yIDUuMiA4ek02IDE4di04SDV2OGgxem00IDB2LThIOXY4aDF6bTUgMHYtOGgtMXY4aDF6bTQgMHYtOGgtMXY4aDF6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtcGFzc3dvcmQtaW52aXNpYmxlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xNSAxMmMwLS43LS4zLTEuNC0uNy0xLjlsLjQtMS4xYy44LjggMS4zIDEuOSAxLjMgMyAwIDIuMi0xLjcgMy45LTMuOSA0bC40LTEuMWMxLjQtLjIgMi41LTEuNCAyLjUtMi45ek0zLjEgMTJDNC44IDguNiA4LjIgNi41IDEyIDYuNWguNGwuNC0uOUgxMmMtNC4xIDAtNy45IDIuMy05LjggNkwyIDEybC4yLjVjMS4zIDIuNSAzLjUgNC40IDYuMSA1LjNsLjMtLjlDNi4yIDE2IDQuMiAxNC4zIDMuMSAxMnptMTguNy0uNWMtMS4zLTIuNS0zLjUtNC40LTYuMS01LjNsLS4zLjljMi40LjkgNC40IDIuNiA1LjUgNC45YTkuODggOS44OCAwIDAgMS04LjkgNS41aC0uNGwtLjQuOWguOGM0LjEgMCA3LjktMi4zIDkuOC02bC4yLS40LS4yLS41ek0xMS41IDkuMWwuNC0xLjFDOS43IDguMSA4IDkuOCA4IDEyYzAgMS4xLjUgMi4yIDEuMyAzbC40LTEuMWMtLjQtLjUtLjctMS4yLS43LTEuOSAwLTEuNSAxLjEtMi43IDIuNS0yLjl6bTMuMS01LjdMOC41IDIwLjNsLjkuMyA2LjEtMTYuOS0uOS0uM3oiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1wYXNzd29yZC12aXNpYmxlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0yMS44IDExLjVDMTkgNi4xIDEyLjQgMy45IDcgNi43Yy0yLjEgMS4xLTMuNyAyLjctNC44IDQuOEwyIDEybC4yLjVjMi44IDUuNCA5LjQgNy42IDE0LjggNC44IDIuMS0xLjEgMy43LTIuNyA0LjgtNC44bC4yLS41LS4yLS41em0tOS44IDZjLTMuOCAwLTcuMi0yLjEtOC45LTUuNUM0LjggOC42IDguMiA2LjUgMTIgNi41YzMuOCAwIDcuMiAyLjEgOC45IDUuNWE5Ljg4IDkuODggMCAwIDEtOC45IDUuNXpNMTIgOGMtMi4yIDAtNCAxLjgtNCA0czEuOCA0IDQgNCA0LTEuOCA0LTQtMS44LTQtNC00em0wIDdjLTEuNyAwLTMtMS4zLTMtM3MxLjMtMyAzLTMgMyAxLjMgMyAzYy4xIDEuNi0xLjIgMi45LTIuOCAzSDEyeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXBlbmNpbCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjAuNSAzLjVjLS41LS42LTEuMy0uOS0yLjEtLjlzLTEuNi4zLTIuMi45TDQuNiAxNS4ybC0xIDUuMiA1LjItMUwyMC41IDcuOGMxLjItMS4yIDEuMi0zLjEgMC00LjN6bS01LjcgMi44LjctLjcgMi45IDIuOS0uNy43LTIuOS0yLjl6bS0uNy44IDEuMSAxLTguNCA4LjQtMS4xLTEuMSA4LjQtOC4zek01LjcgMTguM2MtLjEtLjItLjQtLjMtLjYtLjNsLjMtMS41IDIuMSAyLjEtMS41LjNjMC0uMi0uMS0uNS0uMy0uNnptMi45IDAtMS4xLTEuMSA4LjQtOC40IDEgMS4xLTguMyA4LjR6TTE5LjggNy4xbC0uNy43LTIuOS0yLjkuNy0uN2MuNC0uNC45LS42IDEuNS0uNi41IDAgMSAuMiAxLjQuNi44LjguOCAyLjEgMCAyLjl6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtcGlhdHRhZm9ybWUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTkgMS4xIDE1LjkgNSA5IDguOSAyLjEgNSA5IDEuMU05IDAgMCA1bDkgNSA5LTUtOS01ek0xOCAxMS43bC05IDUtOS01IDEtLjUgOCA0LjQgOC00LjV6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDMpIi8+PHBhdGggZD0ibTE4IDguNS05IDUtOS01TDEgOGw4IDQuNCA4LTQuNXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1waW4iIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE4LjEgMTQgMTUgMTAuM1Y0LjZMMTYuMyAySDcuN0w5IDQuNnY1LjdMNS45IDE0aDUuNnY4aDF2LThoNS42ek0xMCA1aDR2NWgtNFY1em00LjctMi0uNSAxSDkuOGwtLjUtMWg1LjR6bS01IDhoNC42bDEuNiAySDguMWwxLjYtMnoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1waW50ZXJlc3QiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyIDNhOSA5IDAgMCAwLTMuMjggMTcuMzg0Yy0uMDc5LS43MTItLjE1LTEuODA4LjAzMS0yLjU4NS4xNjQtLjcwMiAxLjA1Ni00LjQ3MyAxLjA1Ni00LjQ3M3MtLjI3LS41NC0uMjctMS4zMzdjMC0xLjI1MS43MjYtMi4xODUgMS42MjktMi4xODUuNzY4IDAgMS4xMzkuNTc2IDEuMTM5IDEuMjY3IDAgLjc3My0uNDkyIDEuOTI3LS43NDYgMi45OTctLjIxMi44OTYuNDUgMS42MjYgMS4zMzMgMS42MjYgMS42IDAgMi44My0xLjY4NiAyLjgzLTQuMTIxIDAtMi4xNTUtMS41NS0zLjY2Mi0zLjc2LTMuNjYyLTIuNTYgMC00LjA2NCAxLjkyMS00LjA2NCAzLjkwNiAwIC43NzQuMjk4IDEuNjAzLjY3IDIuMDU0LjA3My4wOS4wODQuMTY3LjA2Mi4yNTgtLjA2OC4yODQtLjIyLjg5Ni0uMjUgMS4wMi0uMDM5LjE2Ni0uMTMuMi0uMy4xMjEtMS4xMjUtLjUyMy0xLjgyNy0yLjE2Ni0xLjgyNy0zLjQ4NiAwLTIuODQgMi4wNjItNS40NDcgNS45NDYtNS40NDcgMy4xMjIgMCA1LjU0OCAyLjIyNSA1LjU0OCA1LjE5OCAwIDMuMTAyLTEuOTU1IDUuNTk4LTQuNjcgNS41OTgtLjkxMiAwLTEuNzY5LS40NzQtMi4wNjMtMS4wMzNsLS41NiAyLjE0Yy0uMjAzLjc4MS0uNzUyIDEuNzYtMS4xMTkgMi4zNTkuODQyLjI2IDEuNzM3LjQwMSAyLjY2NS40MDFhOSA5IDAgMSAwIDAtMThaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtcGludGVyZXN0LXNxdWFyZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuNTY3IDEuMzMzaDE2Ljc2MmEyLjI4NiAyLjI4NiAwIDAgMSAyLjI4NiAyLjI4NnYxNi43NjJhMi4yODYgMi4yODYgMCAwIDEtMi4yODYgMi4yODZIMy41NjdhMi4yODYgMi4yODYgMCAwIDEtMi4yODYtMi4yODZWMy42MTlhMi4yODYgMi4yODYgMCAwIDEgMi4yODYtMi4yODZaTTQgMTJhOCA4IDAgMSAxIDUuNjMxIDcuNjQzYy4zMjYtLjUzMS44MTQtMS40MDIuOTk1LTIuMDk3bC40OTgtMS45MDJjLjI2LjQ5OCAxLjAyMy45MTkgMS44MzQuOTE5IDIuNDEyIDAgNC4xNS0yLjIxOSA0LjE1LTQuOTc2IDAtMi42NDMtMi4xNTYtNC42Mi00LjkzLTQuNjItMy40NTMgMC01LjI4NyAyLjMxNy01LjI4NyA0Ljg0IDAgMS4xNzQuNjI1IDIuNjM1IDEuNjI0IDMuMS4xNTIuMDcuMjMzLjA0LjI2OC0uMTA3bC4wODEtLjMzMi4xNC0uNTc1YS4yNC4yNCAwIDAgMC0uMDU1LS4yM2MtLjMzLS40LS41OTUtMS4xMzgtLjU5NS0xLjgyNiAwLTEuNzY0IDEuMzM2LTMuNDcxIDMuNjEyLTMuNDcxIDEuOTY2IDAgMy4zNDIgMS4zMzkgMy4zNDIgMy4yNTQgMCAyLjE2NS0xLjA5MyAzLjY2NC0yLjUxNSAzLjY2NC0uNzg1IDAtMS4zNzMtLjY1LTEuMTg1LTEuNDQ2LjA4Mi0uMzQ0LjE5MS0uNjk4LjI5Ny0xLjA0Mi4xODgtLjYwNy4zNjYtMS4xODMuMzY2LTEuNjIxIDAtLjYxNS0uMzMtMS4xMjctMS4wMTItMS4xMjctLjgwMyAwLTEuNDQ4LjgzLTEuNDQ4IDEuOTQzIDAgLjcwOC4yNCAxLjE4Ny4yNCAxLjE4N3MtLjc5MyAzLjM1Mi0uOTM5IDMuOTc3Yy0uMTYuNjktLjA5NyAxLjY2NC0uMDI3IDIuMjk3QTguMDA1IDguMDA1IDAgMCAxIDQgMTJaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtcGx1ZyIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJtOC41IDkuOS0yLjggMi44LTEuMSAxLjFjLS42LjYtLjYgMS41IDAgMi4xTDYgMTcuM2wtMy44IDMuOS43LjdMNi43IDE4bDEuNCAxLjRjLjMuMy43LjQgMS4xLjQuNCAwIC44LS4yIDEuMS0uNGwxLjEtMS4xIDIuOC0yLjgtNS43LTUuNnptMSA4LjhjLS4yLjItLjUuMi0uNyAwbC0zLjUtMy41Yy0uMi0uMi0uMi0uNSAwLS43bC40LS40IDQuMiA0LjItLjQuNHptLTMuMi01LjMgMi4xLTIuMSA0LjIgNC4yLTIuMSAyLjEtNC4yLTQuMnptOS42LTguOGMtLjYtLjYtMS41LS42LTIuMSAwTDExLjMgN2wxLjQgMS40LTIuMSAyLjEuNy43IDIuMS0yLjEgMS40IDEuNC0yLjEgMi4xLjcuNyAyLjEtMi4xIDEuNSAxLjQgMi41LTIuNWMuNi0uNi42LTEuNSAwLTIuMWwtMy42LTMuNHptMi44IDQuOUwxNyAxMS4zIDEyLjcgN2wxLjgtMS44Yy4yLS4yLjUtLjIuNyAwbDMuNSAzLjVjLjIuMy4yLjYgMCAuOHpNOC41IDEyLjdsLjcuNy0uNy43LS43LS43LjctLjd6bTIuOCAyLjgtLjcuNy0uNy0uNy43LS43LjcuN3pNMTggNi43bC0uNy0uNyAzLjktMy44LjcuN0wxOCA2Ljd6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtcGx1cyIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjAgMTIuNWgtNy41VjIwaC0xdi03LjVINHYtMWg3LjVWNGgxdjcuNUgyMHYxeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXBsdXMtY2lyY2xlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMi40IDExLjVoNC41djFoLTQuNVYxN2gtMXYtNC41SDYuOXYtMWg0LjVWN2gxdjQuNXptOS42LjVjMCA1LjUtNC41IDEwLTEwIDEwUzIgMTcuNSAyIDEyIDYuNSAyIDEyIDJzMTAgNC41IDEwIDEwem0tMSAwYzAtNS00LTktOS05cy05IDQtOSA5IDQgOSA5IDkgOS00IDktOXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1wcmVzZW50YXRpb24iIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTQgNXYxMC42QzQgMTYuOSA1LjEgMTggNi40IDE4aDMuMWwtMS4xIDRoMWwxLjEtNGgyLjdsMS4yIDRoMWwtMS4yLTRoMy41YzEuMyAwIDIuMy0xIDIuMy0yLjNWNUg0em0xNSAxMC43YzAgLjctLjYgMS4zLTEuMyAxLjNINi40Yy0uOCAwLTEuNC0uNi0xLjQtMS40VjZoMTR2OS43ek0yMSAzdjFIM1YzaDE4em0tOSAxM2MyLjUgMCA0LjUtMiA0LjUtNC41UzE0LjUgNyAxMiA3cy00LjUgMi00LjUgNC41UzkuNSAxNiAxMiAxNnptLS41LTcuOVYxMUg4LjZjLjItMS41IDEuNC0yLjcgMi45LTIuOXptMSAzLjlWOGMxLjkuMSAzLjQgMS44IDMuMyAzLjhTMTMuOSAxNS4xIDEyIDE1Yy0xLjcgMC0zLjItMS4zLTMuNC0zaDMuOXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1wcmludCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjEgOS41YzAtLjgtLjctMS41LTEuNS0xLjVIMTdWM0g3djVINC41QzMuNyA4IDMgOC43IDMgOS41VjE2aDJ2M2gydjJoMTB2LTJoMnYtM2gyVjkuNXpNOCA0aDh2NEg4VjR6TTYgMTh2LTRoMXY0SDZ6bTEwIDJIOHYtNmg4djZ6bTItMmgtMXYtNGgxdjR6bTItM2gtMXYtMkg1djJINFY5LjVjMC0uMy4yLS41LjUtLjVoMTVjLjMgMCAuNS4yLjUuNVYxNXpNNiAxMWg0djFINnYtMXoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1xdW9yYSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIuNzMgMTYuNDc2Yy0uNTU0LTEuMDkxLTEuMjA0LTIuMTkzLTIuNDczLTIuMTkzLS4yNDIgMC0uNDg0LjA0LS43MDcuMTQybC0uNDMtLjg2M2MuNTI1LS40NSAxLjM3My0uODA4IDIuNDY0LS44MDggMS42OTcgMCAyLjU2OC44MTggMy4yNiAxLjg2LjQxLS44OS42MDUtMi4wOTMuNjA1LTMuNTg0IDAtMy43MjQtMS4xNjUtNS42MzYtMy44ODUtNS42MzYtMi42OCAwLTMuODM5IDEuOTEyLTMuODM5IDUuNjM2IDAgMy43MDQgMS4xNTkgNS41OTYgMy44NCA1LjU5Ni40MjUgMCAuODExLS4wNDcgMS4xNjYtLjE1Wm0uNjY1IDEuM2E3LjEyOCA3LjEyOCAwIDAgMS0xLjgzLjI0NGMtMy41NyAwLTcuMDY1LTIuODQ4LTcuMDY1LTYuOTlDNC41IDYuODQ5IDcuOTk1IDQgMTEuNTY0IDRjMy42MyAwIDcuMDkgMi44MjggNy4wOSA3LjAzIDAgMi4zMzctMS4wOSA0LjIzNi0yLjY3NSA1LjQ2NC41MTIuNzY3IDEuMDQgMS4yNzcgMS43NzMgMS4yNzcuODAyIDAgMS4xMjUtLjYyIDEuMTc5LTEuMTA1aDEuMDQzYy4wNjEuNjQ3LS4yNjIgMy4zMzQtMy4xNzggMy4zMzQtMS43NjcgMC0yLjctMS4wMjQtMy40LTIuMjI0WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXF1b3JhLXNxdWFyZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuNTY3IDEuMzMzaDE2Ljc2MmEyLjI4NiAyLjI4NiAwIDAgMSAyLjI4NiAyLjI4NnYxNi43NjJhMi4yODYgMi4yODYgMCAwIDEtMi4yODYgMi4yODZIMy41NjdhMi4yODYgMi4yODYgMCAwIDEtMi4yODYtMi4yODZWMy42MTlhMi4yODYgMi4yODYgMCAwIDEgMi4yODYtMi4yODZabTYuMTkgMTIuOTVjMS4yNjkgMCAxLjkyIDEuMTAyIDIuNDc0IDIuMTkzLS4zNTUuMTA0LS43NC4xNS0xLjE2Ny4xNS0yLjY4IDAtMy44MzktMS44OTItMy44MzktNS41OTYgMC0zLjcyNCAxLjE1OS01LjYzNiAzLjg0LTUuNjM2IDIuNzIgMCAzLjg4NCAxLjkxMiAzLjg4NCA1LjYzNiAwIDEuNDkxLS4xOTUgMi42OTQtLjYwNiAzLjU4NS0uNjkxLTEuMDQzLTEuNTYyLTEuODYtMy4yNTktMS44Ni0xLjA5IDAtMS45NC4zNTYtMi40NjUuODA3bC40MzEuODYzYy4yMjMtLjEwMi40NjUtLjE0Mi43MDctLjE0MlptMS4zMDcgMy43MzdjLjYyIDAgMS4yNDMtLjA4NyAxLjgzMS0uMjQ0LjcgMS4yIDEuNjM0IDIuMjI0IDMuNCAyLjIyNCAyLjkxNyAwIDMuMjQtMi42ODcgMy4xOC0zLjMzNEgxOC40M2MtLjA1NC40ODYtLjM3NyAxLjEwNS0xLjE3OSAxLjEwNS0uNzM0IDAtMS4yNjEtLjUxLTEuNzczLTEuMjc3IDEuNTg1LTEuMjI4IDIuNjc1LTMuMTI3IDIuNjc1LTUuNDY0IDAtNC4yMDItMy40Ni03LjAzLTcuMDktNy4wM0M3LjQ5NCA0IDQgNi44NDkgNCAxMS4wM2MwIDQuMTQyIDMuNDk1IDYuOTkgNy4wNjQgNi45OVoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1yZWRkaXQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEwLjE2NyAxMmEuODMxLjgzMSAwIDAgMC0uODMuODNjMCAuNDU5LjM3Mi44NC44My44MzFhLjgzMS44MzEgMCAwIDAgMC0xLjY2MVpNMTIuMDEgMTUuNjQ3Yy4zMTUgMCAxLjQwMy0uMDM4IDEuOTc2LS42MTFhLjIzMi4yMzIgMCAwIDAgMC0uMzA2LjIxMy4yMTMgMCAwIDAtLjMwNiAwYy0uMzUzLjM2My0xLjEyNi40ODctMS42Ny40ODctLjU0NSAwLTEuMzA4LS4xMjQtMS42NzEtLjQ4N2EuMjEzLjIxMyAwIDAgMC0uMzA2IDAgLjIxMy4yMTMgMCAwIDAgMCAuMzA2Yy41NjQuNTYzIDEuNjUyLjYxIDEuOTc3LjYxWk0xMy4wMDIgMTIuODRjMCAuNDU4LjM3My44My44MzEuODMuNDU4IDAgLjgzLS4zODEuODMtLjgzYS44MzEuODMxIDAgMCAwLTEuNjYgMFoiLz48cGF0aCBkPSJNMjAgMTJhOCA4IDAgMSAxLTE2IDAgOCA4IDAgMCAxIDE2IDBabS0zLjgyOC0xLjE2NWMtLjMxNSAwLS42MDIuMTI0LS44MTIuMzI1LS44MDEtLjU3My0xLjktLjk0NS0zLjEyMS0uOTkzbC41MzQtMi41MDEgMS43MzguMzcyYS44My44MyAwIDEgMCAuODMtLjg2OS44My44MyAwIDAgMC0uNzQ0LjQ2OGwtMS45MzgtLjQxYS4yMDMuMjAzIDAgMCAwLS4xNTMuMDI4LjE4Ni4xODYgMCAwIDAtLjA4Ni4xMzRsLS41OTIgMi43ODhjLTEuMjQuMDM4LTIuMzU4LjQxLTMuMTcuOTkyLS4yMS0uMi0uNDk2LS4zMjQtLjgxLS4zMjRhMS4xNjMgMS4xNjMgMCAwIDAtLjQ3OCAyLjIyNGMtLjAyLjExNS0uMDI5LjIzLS4wMjkuMzUzIDAgMS43OTUgMi4wOTEgMy4yNTYgNC42NjkgMy4yNTYgMi41NzcgMCA0LjY2OC0xLjQ1MSA0LjY2OC0zLjI1NiAwLS4xMTQtLjAxLS4yMzgtLjAyOS0uMzUzLjQwMS0uMTgxLjY4OC0uNTkyLjY4OC0xLjA2OSAwLS42NS0uNTI2LTEuMTY1LTEuMTY1LTEuMTY1WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXJlZGRpdC1zcXVhcmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjU2NyAxLjMzM2gxNi43NjJhMi4yODYgMi4yODYgMCAwIDEgMi4yODYgMi4yODZ2MTYuNzYyYTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2IDIuMjg2SDMuNTY3YTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2LTIuMjg2VjMuNjE5YTIuMjg2IDIuMjg2IDAgMCAxIDIuMjg2LTIuMjg2Wk0xMiAyMGE4IDggMCAxIDAgMC0xNiA4IDggMCAwIDAgMCAxNlptMy4zNi04Ljg0Yy4yMS0uMi40OTctLjMyNS44MTItLjMyNS42NCAwIDEuMTY1LjUxNiAxLjE2NSAxLjE2NSAwIC40NzctLjI4Ny44ODgtLjY4OCAxLjA3LjAyLjExNC4wMjkuMjM4LjAyOS4zNTIgMCAxLjgwNS0yLjA5IDMuMjU2LTQuNjY4IDMuMjU2LTIuNTc4IDAtNC42NjktMS40Ni00LjY2OS0zLjI1NiAwLS4xMjQuMDEtLjIzOC4wMjktLjM1M2ExLjE2MiAxLjE2MiAwIDAgMSAuNDc3LTIuMjI0Yy4zMTUgMCAuNjAyLjEyNC44MTIuMzI0LjgxMS0uNTgyIDEuOTI4LS45NTQgMy4xNy0uOTkybC41OTEtMi43ODhhLjE4Ni4xODYgMCAwIDEgLjA4Ni0uMTM0Yy4wMzgtLjAyOC4wOTUtLjAzOC4xNTMtLjAyOGwxLjkzOC40MWEuODMuODMgMCAxIDEgLjc0NCAxLjE5NC44My44MyAwIDAgMS0uODMtLjc5M2wtMS43MzgtLjM3Mi0uNTM0IDIuNTAxYzEuMjIyLjA0OCAyLjMyLjQyIDMuMTIxLjk5M1ptLTYuMDIzIDEuNjdhLjgzMS44MzEgMCAxIDEgLjgzLjgzMS44MjUuODI1IDAgMCAxLS44My0uODNabTQuNjQ5IDIuMjA2Yy0uNTczLjU3My0xLjY2MS42MS0xLjk3Ni42MS0uMzI1IDAtMS40MTMtLjA0Ny0xLjk3Ni0uNjFhLjIxMy4yMTMgMCAwIDEgMC0uMzA2LjIxMy4yMTMgMCAwIDEgLjMwNSAwYy4zNjMuMzYzIDEuMTI2LjQ4NyAxLjY3LjQ4Ny41NDUgMCAxLjMxOC0uMTI0IDEuNjcxLS40ODdhLjIxMy4yMTMgMCAwIDEgLjMwNiAwIC4yMzIuMjMyIDAgMCAxIDAgLjMwNlptLS45ODQtMi4xOTZjMCAuNDU4LjM3My44My44MzEuODMuNDU4IDAgLjgzLS4zODEuODMtLjgzYS44MzEuODMxIDAgMCAwLTEuNjYgMFoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1yZWZyZXNoIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0yMSAxMmMwIDUtNCA5LTkgOXMtOS00LTktOSA0LTkgOS05YzIuNCAwIDQuNy45IDYuNCAyLjYuNC40LjguOSAxLjEgMS40aC00djFIMjFWMi41aC0xVjZjLS4zLS40LS42LS43LS45LTEuMUMxNS4yIDEgOC44IDEgNC45IDQuOVMxIDE1LjIgNC45IDE5LjFzMTAuMiAzLjkgMTQuMSAwYzEuOS0xLjkgMi45LTQuNCAyLjktNy4xSDIxeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXJlc3RvcmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyIDJDOS4zIDIgNi44IDMgNC45IDQuOWMtLjMuNC0uNi43LS45IDEuMVYyLjVIM1Y4aDUuNVY3aC00Yy4zLS41LjctLjkgMS4xLTEuNCAzLjUtMy41IDkuMi0zLjYgMTIuNy0uMXMzLjYgOS4yLjEgMTIuNy05LjIgMy42LTEyLjcuMUM0IDE2LjcgMyAxNC40IDMgMTJIMmMwIDUuNSA0LjUgMTAgMTAgMTBzMTAtNC41IDEwLTEwUzE3LjUgMiAxMiAyeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXJzcyIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMi43IDEyLjdjLTEuNSAwLTIuNyAxLjItMi43IDIuN1MxLjIgMTggMi43IDE4czIuNy0xLjIgMi43LTIuN2MtLjEtMS40LTEuMy0yLjYtMi43LTIuNnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiLz48cGF0aCBkPSJNLjMgNS45Yy0uMiAwLS4zLjEtLjMuM3YzLjRjMCAuMi4xLjMuMy4zIDQuNCAwIDcuOSAzLjUgNy45IDcuOSAwIC4yLjEuMy4zLjNoMy40Yy4yIDAgLjMtLjEuMy0uM0MxMi4xIDExLjIgNi44IDUuOS4zIDUuOXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiLz48cGF0aCBkPSJNMTggMTcuN0MxNy45IDggMTAgLjEuMyAwIC4xIDAgMCAuMSAwIC4zdjMuNWMwIC4xLjEuMi4zLjJDNy44IDQgMTQgMTAuMSAxNCAxNy43di4xYzAgLjIuMS4zLjMuM2gzLjVjLjEtLjEuMy0uMi4yLS40eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXJzcy1zcXVhcmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE0LjYgMEgzLjRDMS41IDAgMCAxLjUgMCAzLjR2MTEuMkMwIDE2LjUgMS41IDE4IDMuNCAxOGgxMS4zYzEuOSAwIDMuNC0xLjUgMy40LTMuNFYzLjRDMTggMS41IDE2LjUgMCAxNC42IDB6TTQuNSAxNS44Yy0xLjIgMC0yLjMtMS0yLjMtMi4zczEtMi4zIDIuMy0yLjMgMi4zIDEgMi4zIDIuMy0xLjEgMi4zLTIuMyAyLjN6bTQuNSAwQzkgMTIgNiA5IDIuMyA5VjYuOGM1IDAgOSA0IDkgOUg5em00LjUgMGMwLTYuMi01LTExLjMtMTEuMy0xMS4zVjIuM2M3LjUgMCAxMy41IDYgMTMuNSAxMy41aC0yLjJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDMpIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtc2VhcmNoIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0yMS45IDIxLjEgMTYgMTUuM2MxLjMtMS41IDItMy40IDItNS4zIDAtNC40LTMuNi04LTgtOHMtOCAzLjYtOCA4IDMuNiA4IDggOGMxLjkgMCAzLjgtLjcgNS4zLTJsNS44IDUuOS44LS44ek0xMCAxN2MtMy45IDAtNy0zLjEtNy03czMuMS03IDctNyA3IDMuMSA3IDctMy4xIDctNyA3eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXNldHRpbmdzIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMiA3LjVjLTIuNSAwLTQuNSAyLTQuNSA0LjVzMiA0LjUgNC41IDQuNSA0LjUtMiA0LjUtNC41LTItNC41LTQuNS00LjV6bTAgOGMtMS45IDAtMy41LTEuNi0zLjUtMy41czEuNi0zLjUgMy41LTMuNSAzLjUgMS42IDMuNSAzLjUtMS42IDMuNS0zLjUgMy41em05LjgtMS42Yy4xLS42LjItMS4zLjItMS45IDAtLjYtLjEtMS4zLS4yLTEuOWwtMi4xLS4zYy0uMi0uNi0uNC0xLjItLjctMS43bDEuMy0xLjdjLS43LTEuMS0xLjYtMi0yLjctMi43TDE1LjkgNWwtMS43LS43LS4zLTIuMUwxMiAybC0xLjkuMi0uMyAyLjEtMS43LjctMS43LTEuM2MtMS4xLjctMiAxLjYtMi43IDIuN0w1IDguMWMtLjMuNS0uNSAxLjEtLjcgMS43bC0yLjEuM2MtLjEuNi0uMiAxLjMtLjIgMS45IDAgLjYuMSAxLjMuMiAxLjlsMi4xLjNjLjIuNi40IDEuMi43IDEuN2wtMS4zIDEuN2MuNyAxLjEgMS42IDIgMi43IDIuN0w4LjEgMTlsMS43LjcuMyAyLjEgMS45LjIgMS45LS4yLjMtMi4xIDEuNy0uNyAxLjcgMS4zYzEuMS0uNyAyLTEuNiAyLjctMi43TDE5IDE1LjljLjMtLjUuNS0xLjEuNy0xLjdsMi4xLS4zem0tMi45LS43LS4yLjdjLS4xLjUtLjMgMS0uNiAxLjVsLS4zLjYuNC41LjggMS4xYy0uNC41LS45IDEtMS40IDEuNGwtMS4xLS44LS41LS40LS42LjNjLS41LjMtMSAuNS0xLjUuNmwtLjcuMnYuN2wtLjIgMS4zaC0ybC0uMi0xLjN2LS43bC0uNy0uMmMtLjUtLjEtMS0uMy0xLjUtLjZsLS42LS4zLS41LjQtMS4xLjhjLS41LS40LTEtLjktMS40LTEuNGwuOC0xLjEuNC0uNS0uMy0uNmMtLjMtLjUtLjUtMS0uNi0xLjVsLS4yLS43aC0uN0wzLjEgMTNjLS4xLS4zLS4xLS43LS4xLTEgMC0uMyAwLS43LjEtMWwxLjMtLjJoLjdsLjItLjdjLjEtLjUuMy0xIC42LTEuNWwuMy0uNi0uNC0uNUw1IDYuNCA2LjQgNWwxLjEuOC41LjQuNi0uM2MuNS0uMyAxLS41IDEuNS0uNmwuNy0uMnYtLjdsLjItMS4zaDJsLjIgMS4zdi43bC43LjJjLjUuMSAxIC4zIDEuNS42bC42LjMuNS0uNCAxLjEtLjhjLjUuNCAxIC45IDEuNCAxLjRsLS44IDEuMS0uNC41LjMuNmMuMy41LjUgMSAuNiAxLjVsLjIuN2guN2wxLjMuMmMuMS4zLjEuNy4xIDEgMCAuMyAwIC43LS4xIDFsLTEuMy4yaC0uN3oiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1zaGFyZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTcuNSAxNWMtLjggMC0xLjUuNC0yIDFsLTcuNi0zLjRjLjEtLjIuMS0uNC4xLS42IDAtLjIgMC0uNC0uMS0uNkwxNS41IDhjLjggMS4xIDIuNCAxLjMgMy41LjVzMS4zLTIuNC41LTMuNS0yLjQtMS4zLTMuNS0uNWMtLjYuNS0xIDEuMi0xIDIgMCAuMiAwIC40LjEuNmwtNy42IDMuNEM2LjcgOS40IDUuMSA5LjIgNCAxMHMtMS4zIDIuNC0uNSAzLjUgMi40IDEuMyAzLjUuNWMuMi0uMS40LS4zLjUtLjVsNy42IDMuNGMtLjEuMi0uMS40LS4xLjYgMCAxLjQgMS4xIDIuNSAyLjUgMi41czIuNS0xLjEgMi41LTIuNS0xLjEtMi41LTIuNS0yLjV6bTAtMTBjLjggMCAxLjUuNyAxLjUgMS41UzE4LjMgOCAxNy41IDggMTYgNy4zIDE2IDYuNSAxNi43IDUgMTcuNSA1em0tMTIgOC41Yy0uOCAwLTEuNS0uNy0xLjUtMS41cy43LTEuNSAxLjUtMS41UzcgMTEuMiA3IDEycy0uNyAxLjUtMS41IDEuNXptMTIgNS41Yy0uOCAwLTEuNS0uNy0xLjUtMS41cy43LTEuNSAxLjUtMS41IDEuNS43IDEuNSAxLjUtLjcgMS41LTEuNSAxLjV6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtc2xhY2siIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTYuNzgyIDE0LjM3NWMwIDEuMDQtLjg1IDEuODktMS44OTEgMS44OS0xLjA0IDAtMS44OTEtLjg1LTEuODkxLTEuODkgMC0xLjA0MS44NS0xLjg5MSAxLjg5LTEuODkxaDEuODkydjEuODlaTTcuNzM1IDE0LjM3NWMwLTEuMDQxLjg1LTEuODkxIDEuODktMS44OTEgMS4wNDEgMCAxLjg5MS44NSAxLjg5MSAxLjg5djQuNzM1YzAgMS4wNC0uODUgMS44OTEtMS44OSAxLjg5MS0xLjA0MSAwLTEuODkxLS44NS0xLjg5MS0xLjg5di00LjczNVpNOS42MjUgNi43ODJjLTEuMDQgMC0xLjg5LS44NS0xLjg5LTEuODkxIDAtMS4wNC44NS0xLjg5MSAxLjg5LTEuODkxIDEuMDQxIDAgMS44OTEuODUgMS44OTEgMS44OXYxLjg5MmgtMS44OVpNOS42MjUgNy43MzVjMS4wNDEgMCAxLjg5MS44NSAxLjg5MSAxLjg5IDAgMS4wNDEtLjg1IDEuODkxLTEuODkgMS44OTFINC44OWMtMS4wNCAwLTEuODkxLS44NS0xLjg5MS0xLjg5IDAtMS4wNDEuODUtMS44OTEgMS44OS0xLjg5MWg0LjczNVpNMTcuMjE4IDkuNjI1YzAtMS4wNC44NS0xLjg5IDEuODkxLTEuODkgMS4wNCAwIDEuODkxLjg1IDEuODkxIDEuODkgMCAxLjA0MS0uODUgMS44OTEtMS44OSAxLjg5MWgtMS44OTJ2LTEuODlaTTE2LjI2NSA5LjYyNWMwIDEuMDQxLS44NSAxLjg5MS0xLjg5IDEuODkxLTEuMDQxIDAtMS44OTEtLjg1LTEuODkxLTEuODlWNC44OWMwLTEuMDQuODUtMS44OTEgMS44OS0xLjg5MSAxLjA0MSAwIDEuODkxLjg1IDEuODkxIDEuODl2NC43MzVaTTE0LjM3NSAxNy4yMThjMS4wNCAwIDEuODkuODUgMS44OSAxLjg5MSAwIDEuMDQtLjg1IDEuODkxLTEuODkgMS44OTEtMS4wNDEgMC0xLjg5MS0uODUtMS44OTEtMS44OXYtMS44OTJoMS44OVpNMTQuMzc1IDE2LjI2NWMtMS4wNDEgMC0xLjg5MS0uODUtMS44OTEtMS44OSAwLTEuMDQxLjg1LTEuODkxIDEuODktMS44OTFoNC43MzVjMS4wNCAwIDEuODkxLjg1IDEuODkxIDEuODkgMCAxLjA0MS0uODUgMS44OTEtMS44OSAxLjg5MWgtNC43MzVaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtc2xhY2stc3F1YXJlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy41NjcgMS4zMzNoMTYuNzYyYTIuMjg2IDIuMjg2IDAgMCAxIDIuMjg2IDIuMjg2djE2Ljc2MmEyLjI4NiAyLjI4NiAwIDAgMS0yLjI4NiAyLjI4NkgzLjU2N2EyLjI4NiAyLjI4NiAwIDAgMS0yLjI4Ni0yLjI4NlYzLjYxOWEyLjI4NiAyLjI4NiAwIDAgMSAyLjI4Ni0yLjI4NlptNi4zMjIgNi4wMjljLS45MjUgMC0xLjY4LS43NTYtMS42OC0xLjY4MVM4Ljk2MyA0IDkuODg4IDRjLjkyNSAwIDEuNjgxLjc1NiAxLjY4MSAxLjY4djEuNjgySDkuODlabS00LjIwOCA4LjQzYy45MjUgMCAxLjY4LS43NTYgMS42OC0xLjY4MVYxMi40M2gtMS42OGMtLjkyNSAwLTEuNjgxLjc1Ni0xLjY4MSAxLjY4IDAgLjkyNi43NTYgMS42ODEgMS42OCAxLjY4MVptNC4yMDgtMy4zNjJjLS45MjUgMC0xLjY4Ljc1Ni0xLjY4IDEuNjh2NC4yMWMwIC45MjQuNzU1IDEuNjggMS42OCAxLjY4LjkyNSAwIDEuNjgxLS43NTYgMS42ODEtMS42OHYtNC4yMWMwLS45MjQtLjc1Ni0xLjY4LTEuNjgtMS42OFptMS42ODEtMi41NGMwLS45MjYtLjc1Ni0xLjY4Mi0xLjY4LTEuNjgySDUuNjhDNC43NTcgOC4yMDggNCA4Ljk2NCA0IDkuODlzLjc1NiAxLjY4MSAxLjY4IDEuNjgxaDQuMjFjLjkyNCAwIDEuNjgtLjc1NiAxLjY4LTEuNjhabTUuMDY5IDBjMC0uOTI2Ljc1NS0xLjY4MiAxLjY4LTEuNjgyLjkyNSAwIDEuNjgxLjc1NiAxLjY4MSAxLjY4MXMtLjc1NiAxLjY4MS0xLjY4IDEuNjgxaC0xLjY4MVY5Ljg5Wm0tMi41MjggMS42OGMuOTI1IDAgMS42OC0uNzU2IDEuNjgtMS42OFY1LjY4YzAtLjkyNC0uNzU1LTEuNjgtMS42OC0xLjY4LS45MjUgMC0xLjY4MS43NTYtMS42ODEgMS42OHY0LjIxYzAgLjkyNC43NTYgMS42OCAxLjY4IDEuNjhabTAgNS4wNjhjLjkyNSAwIDEuNjguNzU2IDEuNjggMS42ODFTMTUuMDM3IDIwIDE0LjExMiAyMGMtLjkyNSAwLTEuNjgxLS43NTYtMS42ODEtMS42OHYtMS42ODJoMS42OFptLTEuNjgxLTIuNTI3YzAgLjkyNS43NTYgMS42OCAxLjY4IDEuNjhoNC4yMWMuOTI0IDAgMS42OC0uNzU1IDEuNjgtMS42OCAwLS45MjUtLjc1Ni0xLjY4MS0xLjY4LTEuNjgxaC00LjIxYy0uOTI0IDAtMS42OC43NTYtMS42OCAxLjY4WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXNuYXBjaGF0IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xOS45NDMgMTUuNTI2Yy0uMTExLS4zMDMtLjMyMy0uNDY1LS41NjQtLjU5OWExLjQxNiAxLjQxNiAwIDAgMC0uMTIzLS4wNjRsLS4yMTktLjExMWMtLjc1Mi0uMzk5LTEuMzM4LS45MDItMS43NDYtMS40OThhMy4zOSAzLjM5IDAgMCAxLS4zLS41MzFjLS4wMzQtLjEtLjAzMi0uMTU2LS4wMDgtLjIwN2EuMzM5LjMzOSAwIDAgMSAuMDk3LS4xYy4xMjktLjA4Ni4yNjItLjE3My4zNTItLjIzMS4xNjItLjEwNC4yODktLjE4Ny4zNzEtLjI0NS4zMDktLjIxNi41MjUtLjQ0Ni42Ni0uNzAyYTEuMzk3IDEuMzk3IDAgMCAwIC4wNjktMS4xNmMtLjIwNS0uNTM4LS43MTMtLjg3Mi0xLjMyOS0uODcyYTEuODI5IDEuODI5IDAgMCAwLS40ODcuMDY1Yy4wMDYtLjM2OC0uMDAyLS43NTctLjAzNS0xLjEzOS0uMTE2LTEuMzQ0LS41ODctMi4wNDgtMS4wNzctMi42MWE0LjI5NCA0LjI5NCAwIDAgMC0xLjA5NS0uODgxQzEzLjc2NCA0LjIxNiAxMi45MiA0IDExLjk5OSA0Yy0uOTIgMC0xLjc2LjIxNi0yLjUwNS42NDEtLjQxMi4yMzItLjc4Mi41My0xLjA5Ny44ODMtLjQ5LjU2Mi0uOTYgMS4yNjctMS4wNzcgMi42MS0uMDMzLjM4Mi0uMDQuNzcyLS4wMzYgMS4xMzhhMS44MyAxLjgzIDAgMCAwLS40ODctLjA2NWMtLjYxNSAwLTEuMTI0LjMzNS0xLjMyOC44NzNhMS4zOTggMS4zOTggMCAwIDAgLjA2NyAxLjE2MWMuMTM2LjI1Ni4zNTIuNDg2LjY2LjcwMi4wODIuMDU3LjIxLjE0LjM3MS4yNDVsLjMzOS4yMjFjLjA0NC4wMjguMDguMDY2LjEwOS4xMS4wMjYuMDUzLjAyNy4xMS0uMDEyLjIxN2EzLjM1OSAzLjM1OSAwIDAgMS0uMjk1LjUyYy0uMzk4LjU4My0uOTY4IDEuMDc3LTEuNjk2IDEuNDcyLS4zODUuMjA0LS43ODYuMzQtLjk1NS44LS4xMjguMzQ4LS4wNDQuNzQzLjI4IDEuMDc1LjExOS4xMjUuMjU3LjIzLjQwOS4zMWE0LjQzIDQuNDMgMCAwIDAgMSAuNC42Ni42NiAwIDAgMSAuMjAyLjA5Yy4xMTguMTA0LjEwMi4yNi4yNTkuNDg4LjA3OS4xMTguMTguMjIuMjk2LjMuMzMuMjI5LjcwMS4yNDMgMS4wOTUuMjU4LjM1NS4wMTQuNzU4LjAzIDEuMjE3LjE4LjE5LjA2NC4zODkuMTg2LjYxOC4zMjguNTUuMzM4IDEuMzA1LjgwMiAyLjU2Ni44MDIgMS4yNjIgMCAyLjAyLS40NjYgMi41NzUtLjgwNi4yMjgtLjE0LjQyNS0uMjYuNjEtLjMyMS40Ni0uMTUyLjg2My0uMTY4IDEuMjE4LS4xODEuMzkzLS4wMTUuNzY0LS4wMyAxLjA5NS0uMjU4YTEuMTQgMS4xNCAwIDAgMCAuMzM2LS4zNjhjLjExNC0uMTkyLjExLS4zMjcuMjE3LS40MmEuNjI1LjYyNSAwIDAgMSAuMTktLjA4NyA0LjQ0NiA0LjQ0NiAwIDAgMCAxLjAxNC0uNDA0Yy4xNi0uMDg3LjMwNi0uMi40MjktLjMzNmwuMDA0LS4wMDVjLjMwNC0uMzI2LjM4LS43MDkuMjU2LTEuMDQ3Wm0tMS4xMjIuNjAyYy0uNjgzLjM3OC0xLjEzOC4zMzctMS40OTIuNTY1LS4zLjE5My0uMTIyLjYxLS4zNC43Ni0uMjY5LjE4Ni0xLjA2MS0uMDEyLTIuMDg1LjMyNi0uODQ1LjI3OS0xLjM4NCAxLjA4Mi0yLjkwMyAxLjA4Mi0xLjUxOSAwLTIuMDQ1LS44MDEtMi45MDQtMS4wODQtMS4wMjItLjMzOC0xLjgxNi0uMTQtMi4wODQtLjMyNS0uMjE4LS4xNS0uMDQxLS41NjgtLjM0MS0uNzYxLS4zNTQtLjIyOC0uODA5LS4xODctMS40OTItLjU2My0uNDM2LS4yNC0uMTg5LS4zOS0uMDQ0LS40NiAyLjQ3OC0xLjE5OSAyLjg3My0zLjA1IDIuODktMy4xODguMDIyLS4xNjYuMDQ1LS4yOTctLjEzOC0uNDY2LS4xNzctLjE2NC0uOTYyLS42NS0xLjE4LS44MDItLjM2LS4yNTItLjUyLS41MDMtLjQwMi0uODEyLjA4Mi0uMjE0LjI4MS0uMjk1LjQ5LS4yOTUuMDY3IDAgLjEzMi4wMDguMTk3LjAyMi4zOTYuMDg2Ljc4LjI4NCAxLjAwMi4zMzguMDI3LjAwNy4wNTQuMDEuMDgyLjAxMS4xMTggMCAuMTYtLjA2LjE1Mi0uMTk1LS4wMjYtLjQzMy0uMDg3LTEuMjc3LS4wMTktMi4wNjYuMDk0LTEuMDg0LjQ0NC0xLjYyMi44NTktMi4wOTcuMi0uMjI5IDEuMTM3LTEuMjIgMi45My0xLjIyIDEuNzkyIDAgMi43MzIuOTg3IDIuOTMxIDEuMjE1LjQxNi40NzUuNzY2IDEuMDEzLjg1OSAyLjA5OC4wNjguNzg4LjAwOSAxLjYzMi0uMDE5IDIuMDY1LS4wMS4xNDMuMDM0LjE5NS4xNTIuMTk1YS4zNDguMzQ4IDAgMCAwIC4wODItLjAxYy4yMjItLjA1NC42MDctLjI1MyAxLjAwMi0uMzM4YS45MS45MSAwIDAgMSAuMTk3LS4wMjNjLjIxIDAgLjQwOS4wODIuNDkuMjk1LjExNy4zMDktLjA0LjU2LS40MDEuODEyLS4yMTguMTUyLTEuMDAzLjYzOC0xLjE4LjgwMi0uMTg0LjE2OS0uMTYuMy0uMTM5LjQ2Ni4wMTguMTQuNDEzIDEuOTkxIDIuODkgMy4xODkuMTQ3LjA3My4zOTQuMjIyLS4wNDEuNDY0WiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXNuYXBjaGF0LXNxdWFyZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuNTY3IDEuMzMzaDE2Ljc2MmEyLjI4NiAyLjI4NiAwIDAgMSAyLjI4NiAyLjI4NnYxNi43NjJhMi4yODYgMi4yODYgMCAwIDEtMi4yODYgMi4yODZIMy41NjdhMi4yODYgMi4yODYgMCAwIDEtMi4yODYtMi4yODZWMy42MTlhMi4yODYgMi4yODYgMCAwIDEgMi4yODYtMi4yODZabTE1LjgxMiAxMy41OTRjLjI0LjEzNC40NTMuMjk2LjU2NC41OTkuMTI0LjMzOC4wNDguNzIxLS4yNTYgMS4wNDdsLS4wMDQuMDA1Yy0uMTIzLjEzNi0uMjY4LjI1LS40My4zMzYtLjMyLjE3Ni0uNjYuMzExLTEuMDEzLjQwNGEuNjI1LjYyNSAwIDAgMC0uMTkuMDg2Yy0uMDYuMDU0LS4wODUuMTItLjExNy4yMDQtLjAyNC4wNjItLjA1LjEzNC0uMS4yMTdhMS4xNCAxLjE0IDAgMCAxLS4zMzYuMzY4Yy0uMzMuMjI5LS43MDIuMjQzLTEuMDk1LjI1OEgxNi40Yy0uMzU0LjAxMy0uNzU3LjAyOS0xLjIxNi4xOC0uMTg1LjA2Mi0uMzgyLjE4My0uNjEuMzIybC0uMDAxLjAwMWMtLjU1NS4zNC0xLjMxNC44MDUtMi41NzQuODA1LTEuMjYxIDAtMi4wMTUtLjQ2My0yLjU2Ni0uODAyLS4yMy0uMTQyLS40MjctLjI2NC0uNjE4LS4zMjctLjQ2LS4xNTItLjg2Mi0uMTY3LTEuMjE3LS4xOC0uMzk0LS4wMTYtLjc2NS0uMDMtMS4wOTUtLjI1OGExLjEzNiAxLjEzNiAwIDAgMS0uMjk2LS4zMDFjLS4wNzctLjExMS0uMTEyLS4yMDUtLjE0Mi0uMjg0LS4wMzEtLjA4NC0uMDU2LS4xNS0uMTE3LS4yMDNhLjY2LjY2IDAgMCAwLS4yMDItLjA5IDQuNDMgNC40MyAwIDAgMS0xLS40MDEgMS42MiAxLjYyIDAgMCAxLS40MDktLjMxYy0uMzI0LS4zMzItLjQwNy0uNzI3LS4yOC0xLjA3NC4xNDQtLjM5My40NTctLjU1Ljc4Ni0uNzE0bC4xNy0uMDg3Yy43MjctLjM5NSAxLjI5Ny0uODkgMS42OTUtMS40NzIuMTE0LS4xNjQuMjEyLS4zMzguMjk1LS41Mi4wMzktLjEwNi4wMzgtLjE2NC4wMTItLjIxOGEuMzYzLjM2MyAwIDAgMC0uMTEtLjEwOSAxNTQuMjczIDE1NC4yNzMgMCAwIDEtLjcxLS40NjdjLS4zMDctLjIxNS0uNTIzLS40NDUtLjY1OS0uNzAxYTEuMzk5IDEuMzk5IDAgMCAxLS4wNjctMS4xNjFjLjIwNC0uNTM4LjcxMy0uODcyIDEuMzI5LS44NzJhMS44MyAxLjgzIDAgMCAxIC40ODYuMDY0Yy0uMDA1LS4zNjYuMDAzLS43NTYuMDM2LTEuMTM4LjExNi0xLjM0My41ODctMi4wNDggMS4wNzctMi42MWE0LjI3NyA0LjI3NyAwIDAgMSAxLjA5Ny0uODgzQzEwLjI0IDQuMjE2IDExLjA4IDQgMTIgNGMuOTIgMCAxLjc2NC4yMTYgMi41MDkuNjQxLjQxLjIzMi43OC41MyAxLjA5NS44ODEuNDkuNTYyLjk2IDEuMjY2IDEuMDc3IDIuNjEuMDMzLjM4Mi4wNC43Ny4wMzUgMS4xMzlhMS44MjkgMS44MjkgMCAwIDEgLjQ4Ny0uMDY1Yy42MTYgMCAxLjEyNC4zMzQgMS4zMjkuODcyYTEuMzk2IDEuMzk2IDAgMCAxLS4wNyAxLjE2Yy0uMTM0LjI1Ni0uMzUuNDg2LS42NTkuNzAyLS4wODIuMDU4LS4yMS4xNC0uMzcuMjQ1LS4wOTEuMDU4LS4yMjQuMTQ1LS4zNTMuMjNhLjMzOS4zMzkgMCAwIDAtLjA5Ni4xYy0uMDI1LjA1Mi0uMDI3LjEwOC4wMDguMjA4LjA4My4xODYuMTg0LjM2My4zLjUzMS40MDYuNTk2Ljk5MyAxLjEgMS43NDUgMS40OThsLjExNS4wNThhMTEuMTYyIDExLjE2MiAwIDAgMSAuMjI3LjExN1ptLTEuNDk2IDEuNTU4Yy4yNTgtLjA2OS41NjQtLjE1LjkzOS0uMzU3LjQzNS0uMjQyLjE4OC0uMzkxLjA0Mi0uNDY0LTIuNDc4LTEuMTk4LTIuODczLTMuMDUtMi44OS0zLjE4OWEuOTY1Ljk2NSAwIDAgMC0uMDAzLS4wMTdjLS4wMi0uMTU4LS4wMzctLjI4Ni4xNC0uNDUuMTIxLS4xMS41MjMtLjM3MS44MzYtLjU3NC4xNDctLjA5NS4yNzUtLjE3OC4zNDUtLjIyNy4zNi0uMjUyLjUxOC0uNTAzLjQwMi0uODEyLS4wODItLjIxMy0uMjgtLjI5NS0uNDktLjI5NWEuOTEuOTEgMCAwIDAtLjE5OC4wMjNjLS4yMzMuMDUtLjQ2Mi4xNC0uNjU3LjIxNi0uMTM1LjA1My0uMjU0LjEtLjM0NS4xMjFhLjM0OC4zNDggMCAwIDEtLjA4Mi4wMTFjLS4xMTggMC0uMTYxLS4wNTMtLjE1Mi0uMTk1bC4wMDMtLjA0N2MuMDI5LS40NDQuMDgyLTEuMjU3LjAxNi0yLjAxOC0uMDkzLTEuMDg1LS40NDMtMS42MjMtLjg1OS0yLjA5OC0uMi0uMjI4LTEuMTQtMS4yMTQtMi45MzItMS4yMTRzLTIuNzMuOTktMi45MyAxLjIxOWMtLjQxNC40NzUtLjc2NCAxLjAxMy0uODU4IDIuMDk3LS4wNjIuNzI1LS4wMTYgMS40OTcuMDEyIDEuOTUzbC4wMDcuMTEzYy4wMDguMTM1LS4wMzQuMTk1LS4xNTIuMTk1YS4zNTMuMzUzIDAgMCAxLS4wODItLjAxIDMuMDMyIDMuMDMyIDAgMCAxLS4zNDQtLjEyMmMtLjE5NS0uMDc2LS40MjUtLjE2Ni0uNjU4LS4yMTdhLjkxNi45MTYgMCAwIDAtLjE5Ny0uMDIyYy0uMjA5IDAtLjQwOC4wOC0uNDkuMjk1LS4xMTcuMzA5LjA0Mi41Ni40MDIuODEyLjA3LjA0OS4xOTguMTMyLjM0NS4yMjcuMzE0LjIwMy43MTUuNDYzLjgzNS41NzUuMTc4LjE2My4xNjEuMjkxLjE0LjQ1IDAgLjAwNSAwIC4wMS0uMDAyLjAxNi0uMDE3LjEzNy0uNDEyIDEuOTktMi44OSAzLjE4OS0uMTQ1LjA3LS4zOTIuMjE5LjA0NC40Ni4zNzMuMjA0LjY3OC4yODUuOTM2LjM1NC4yMTQuMDU3LjM5NS4xMDUuNTU2LjIwOC4xNjIuMTA1LjE4NS4yNzQuMjA2LjQzMi4wMTguMTM0LjAzNS4yNi4xMzUuMzI5LjExNi4wOC4zMzEuMDg4LjYyLjEuMzguMDE0Ljg4NS4wMzMgMS40NjQuMjI1LjI5MS4wOTYuNTQ0LjI1LjgxLjQxNC41Mi4zMiAxLjA5LjY3IDIuMDk0LjY3IDEuMDA4IDAgMS41ODUtLjM1NCAyLjEwNi0uNjczLjI2My0uMTYyLjUxMy0uMzE1Ljc5Ny0uNDEuNTgtLjE5IDEuMDg2LS4yMSAxLjQ2NC0uMjI1LjI5LS4wMS41MDQtLjAxOS42Mi0uMS4xLS4wNjguMTE3LS4xOTQuMTM1LS4zMjguMDIxLS4xNTcuMDQ0LS4zMjcuMjA2LS40MzIuMTYtLjEwMy4zNDEtLjE1MS41NTQtLjIwOFoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1zb2Z0d2FyZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48c3R5bGU+LnN0MHtmaWxsOm5vbmV9PC9zdHlsZT48cGF0aCBkPSJNMTguNSAwaC0xN0MuNyAwIDAgLjcgMCAxLjV2MTVjMCAuOC43IDEuNSAxLjUgMS41aDE3Yy44IDAgMS41LS43IDEuNS0xLjV2LTE1YzAtLjgtLjctMS41LTEuNS0xLjV6bS41IDE2LjVjMCAuMy0uMi41LS41LjVoLTE3Yy0uMyAwLS41LS4yLS41LS41VjVoMTh2MTEuNXpNMTkgNEgxVjEuNWMwLS4zLjItLjUuNS0uNWgxN2MuMyAwIC41LjIuNS41VjR6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDMpIi8+PHBhdGggZD0iTTEwIDEzaDV2MWgtNXpNMTAgMTEuMWwtNS4xIDMuN3YtMS4zbDMuNC0yLjQtMy40LTIuNVY3LjR6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDMpIi8+PHBhdGggY2xhc3M9InN0MCIgZD0ibTguMyAxMS4xLTMuNCAyLjRNOC4zIDExLjEgNC45IDguNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAzKSIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXN0YWNrZXhjaGFuZ2UiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTQuNDggMTEuNWgxNC45NnYzLjA4SDQuNDhWMTEuNVpNNC40OCA3LjUyaDE0Ljk2djMuMDhINC40OFY3LjUyWk0xNy4xIDMuNEg2Ljg4Yy0xLjMyIDAtMi40IDEuMS0yLjQgMi40NnYuOGgxNC45NnYtLjhjMC0xLjM2LTEuMDQtMi40Ni0yLjM0LTIuNDZaTTQuNDggMTUuNDZ2LjhjMCAxLjM2IDEuMDggMi40NiAyLjQgMi40Nmg2LjR2My4yNmwzLjE2LTMuMjZoLjdjMS4zMiAwIDIuNC0xLjEgMi40LTIuNDZ2LS44SDQuNDhaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtc3RhY2tleGNoYW5nZS1zcXVhcmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjU2NyAxLjMzM2gxNi43NjJhMi4yODYgMi4yODYgMCAwIDEgMi4yODYgMi4yODZ2MTYuNzYyYTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2IDIuMjg2SDMuNTY3YTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2LTIuMjg2VjMuNjE5YTIuMjg2IDIuMjg2IDAgMCAxIDIuMjg2LTIuMjg2Wk04LjAxMiA1aDguNTdjMS4wOSAwIDEuOTYyLjkyMiAxLjk2MiAyLjA2M3YuNjdINnYtLjY3QzYgNS45MjMgNi45MDYgNSA4LjAxMiA1Wk02IDguNDU1aDEyLjU0NHYyLjU4Mkg2VjguNDU2Wm0wIDMuMzM3aDEyLjU0NHYyLjU4M0g2di0yLjU4M1ptMCAzLjMydi42NzJjMCAxLjE0LjkwNiAyLjA2MiAyLjAxMiAyLjA2Mmg1LjM2N3YyLjczNGwyLjY1LTIuNzM0aC41ODdjMS4xMDcgMCAyLjAxMi0uOTIyIDIuMDEyLTIuMDYydi0uNjcxSDZaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtc3RhY2tvdmVyZmxvdyIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTYuNDEyIDE4LjU3MlYxNC4yOWgxLjQyOFYyMEg1di01LjcxaDEuNDI4djQuMjgyaDkuOTg0WiIvPjxwYXRoIGQ9Ik03Ljg1NyAxNy4xNDVoNy4xMzd2LTEuNDI4SDcuODU3djEuNDI4Wk0xNC4yNTQgNGwtMS4xNDYuODUyIDQuMjYgNS43MjcgMS4xNDYtLjg1MkwxNC4yNTQgNFptLTMuNTQgMy4zNzcgNS40ODQgNC41NjcuOTEzLTEuMDk3LTUuNDg0LTQuNTY3LS45MTQgMS4wOTdaTTguOTIyIDEwLjU1bDYuNDcgMy4wMTMuNjAzLTEuMjk0LTYuNDctMy4wMTMtLjYwMyAxLjI5NFptLS45MjUgMy4zNDQgNi45ODUgMS40NjkuMjk0LTEuMzk4LTYuOTg1LTEuNDY4LS4yOTQgMS4zOTdaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtc3RhY2tvdmVyZmxvdy1zcXVhcmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjU2NyAxLjMzM2gxNi43NjJhMi4yODYgMi4yODYgMCAwIDEgMi4yODYgMi4yODZ2MTYuNzYyYTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2IDIuMjg2SDMuNTY3YTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2LTIuMjg2VjMuNjE5YTIuMjg2IDIuMjg2IDAgMCAxIDIuMjg2LTIuMjg2Wm0xMS40MjcgMTUuODEySDcuODU3di0xLjQyOGg3LjEzN3YxLjQyOFpNMTMuMTA4IDQuODUyIDE0LjI1NCA0bDQuMjYgNS43MjctMS4xNDYuODUyLTQuMjYtNS43MjdabTMuMDkgNy4wOTItNS40ODUtNC41NjcuOTE0LTEuMDk3IDUuNDg0IDQuNTY3LS45MTMgMS4wOTdabS0uODA1IDEuNjItNi40Ny0zLjAxMy42MDItMS4yOTQgNi40NyAzLjAxMy0uNjAyIDEuMjk0Wm0tLjQxIDEuOC02Ljk4NS0xLjQ2OS4yOTQtMS4zOTcgNi45ODUgMS40NjktLjI5MyAxLjM5NlptMS40My0xLjA3NXY0LjI4M0g2LjQyN1YxNC4yOUg1VjIwaDEyLjg0di01LjcxaC0xLjQyOFoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1zdGFyLWZ1bGwiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyIDEuNyA5LjUgOS4ySDEuNkw4IDEzLjlsLTIuNCA3LjYgNi40LTQuNyA2LjQgNC43LTIuNC03LjYgNi40LTQuN2gtNy45TDEyIDEuN3oiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC1zdGFyLW91dGxpbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0ibTEyIDQuOSAxLjUgNC42LjIuN2g1LjdsLTQgMi45LS42LjQuMi43IDEuNSA0LjctMy45LTIuOS0uNi0uNC0uNi40LTMuOSAyLjlMOSAxNC4ybC4yLS43LS42LS40LTQtMi45aDUuN2wuMi0uN0wxMiA0LjltMC0zLjJMOS41IDkuMkgxLjZMOCAxMy45bC0yLjQgNy42IDYuNC00LjcgNi40IDQuNy0yLjQtNy42IDYuNC00LjdoLTcuOUwxMiAxLjd6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtdGVhbS1kaWdpdGFsZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjMuNiAyNEguNGMtLjIgMC0uNC0uMi0uNC0uNFYuNEMwIC4yLjIgMCAuNCAwaDIzLjNjLjEgMCAuMy4yLjMuNHYyMy4zYzAgLjEtLjIuMy0uNC4zek01LjggMTEuOGMuOSAwIDEuNi0uNyAxLjYtMS42cy0uNy0xLjYtMS42LTEuNi0xLjYuNy0xLjYgMS42LjcgMS42IDEuNiAxLjZ6TTEwIDE5aDQuNGM0LjcgMCA1LjYtMi4zIDUuNi02LjdTMTkgNiAxNC40IDZIMTB2MTN6bTQuNC0xMC43YzIuNiAwIDIuOCAxLjEgMi44IDRzLS4zIDQuNS0yLjggNC41aC0xLjhWOC4zaDEuOHoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC10ZWxlZ3JhbSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQiIGQ9Ik0xMCAwQTEwIDEwIDAgMSAxIDAgMTAgMTAgMTAgMCAwIDEgMTAgMFpNNC41MyA5Ljg5YzIuOTEtMS4yNyA0Ljg2LTIuMSA1LjgzLTIuNTFDMTMuMTQgNi4yMyAxMy43MSA2IDE0LjA5IDZhLjY3LjY3IDAgMCAxIC4zOS4xMi40LjQgMCAwIDEgLjE0LjI3IDIuMTIgMi4xMiAwIDAgMSAwIC4zOWMtLjE2IDEuNTgtLjgxIDUuNDItMS4xNCA3LjE5LS4xNC43NS0uNDEgMS0uNjggMS0uNTguMDUtMS0uMzktMS41OS0uNzYtLjg4LS41Ny0xLjM3LS45My0yLjIzLTEuNXMtLjM0LTEgLjIyLTEuNTljLjE3LS4xMiAyLjcyLTIuNDMgMi44LTIuNjRhLjE5LjE5IDAgMCAwIDAtLjE4LjI2LjI2IDAgMCAwLS4yMSAwYy0uMDkgMC0xLjQ5IDEtNC4yMiAyLjc5YTEuODMgMS44MyAwIDAgMS0xLjA4LjQgNyA3IDAgMCAxLTEuNTYtLjM3Yy0uNjItLjItMS4xMi0uMzEtMS4wOC0uNjUtLjA0LS4yLjItLjM5LjY4LS41OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC10ZWxlcGhvbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTUgM2guMk0yMCAxMS42QzIwIDcuNCAxNi42IDQgMTIuNSA0aC0uMWMtLjMgMC0uNS4yLS41LjVzLjIuNS41LjVDMTYgNSAxOSA4IDE5IDExLjZjMCAuMy4zLjUuNS41LjMgMCAuNS0uMi41LS41eiIvPjxwYXRoIGQ9Ik0xNi45IDExLjdjMC0yLjUtMi00LjUtNC41LTQuNS0uMy4xLS41LjMtLjQuNiAwIC4yLjIuNC40LjQgMS45IDAgMy41IDEuNiAzLjUgMy41IDAgLjMuMi41LjUuNXMuNS0uMi41LS41ek0xNS43IDIxLjJDOC42IDIwLjkgMyAxNS4yIDIuOSA4LjFjMC0uNC4yLS44LjYtLjkgMS43LS42IDQtMSA0LjcuMS41LjkuOCAxLjkuOSAyLjl2LjJjLjIuNy0uMSAxLjMtLjcgMS43LS4zLjEtLjUuNC0uNS43LjkgMS40IDIgMi42IDMuNCAzLjUuMi0uMS40LS4zLjUtLjYuMS0uNS42LTEgMS43LS45aC4yYzEgLjEgMiAuNCAyLjguOSAxIC43LjYgMyAuMSA0LjctLjEuNS0uNS44LS45Ljh6TTYuNiA3LjVjLS45IDAtMS45LjItMi44LjUuMSA2LjYgNS4zIDEyIDExLjkgMTIuMi43LTIuMy43LTMuNS4zLTMuOC0uOC0uNC0xLjYtLjYtMi41LS43aC0uMmMtLjMgMC0uNiAwLS43LjEtLjIuNi0uNiAxLjEtMS4zIDEuM2wtLjIuMUgxMWMtMS42LTEtMi45LTIuNC0zLjktNEw3IDEzYy0uMS0uNy4zLTEuNCAxLTEuNy4xLS4xLjMtLjIuMy0uOHYtLjJjLS4xLS45LS40LTEuNy0uNy0yLjUtLjMtLjItLjYtLjMtMS0uM3oiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC10aWt0b2siIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEzLjEyNSAzaDIuMjI4Yy4xNjEuODA0LjYwOCAxLjgyIDEuMzg5IDIuODI2Ljc2NS45ODYgMS43OCAxLjY3NCAzLjEzMyAxLjY3NHYyLjI1Yy0xLjk3MyAwLTMuNDU1LS45MTUtNC41LTIuMDU3djcuNjgyQTUuNjI1IDUuNjI1IDAgMSAxIDkuNzUgOS43NVYxMmEzLjM3NSAzLjM3NSAwIDEgMCAzLjM3NSAzLjM3NVYzWiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXRpa3Rvay1zcXVhcmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjU2NyAxLjMzM2gxNi43NjJhMi4yODYgMi4yODYgMCAwIDEgMi4yODYgMi4yODZ2MTYuNzYyYTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2IDIuMjg2SDMuNTY3YTIuMjg2IDIuMjg2IDAgMCAxLTIuMjg2LTIuMjg2VjMuNjE5YTIuMjg2IDIuMjg2IDAgMCAxIDIuMjg2LTIuMjg2Wk0xNC45ODEgNEgxM3YxMWEzIDMgMCAxIDEtMy0zdi0yYTUgNSAwIDEgMCA1IDVWOC4xNzFDMTUuOTMgOS4xODYgMTcuMjQ3IDEwIDE5IDEwVjhjLTEuMjAzIDAtMi4xMDUtLjYxMS0yLjc4NS0xLjQ4OC0uNjk0LS44OTUtMS4wOTEtMS43OTctMS4yMzQtMi41MTJaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtdG9vbCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNy43IDVjLjYgMCAxLjIuMiAxLjcuNSAxLjEuNiAxLjcgMS44IDEuNiAzLS4xLjkuMiAxLjguOCAyLjRsNi4zIDYuM2MuNC4zLjUuOS4yIDEuMy0uMi4zLS41LjUtLjguNS0uMyAwLS41LS4xLS43LS4zbC02LjQtNi40Yy0uNi0uNS0xLjMtLjgtMi4xLS44aC0uNmMtLjggMC0xLjctLjQtMi4yLTFoMi43VjYuNEg1LjFjLjMtLjQuNi0uOCAxLjEtMSAuNS0uMyAxLS40IDEuNS0uNG0wLTFjLS43IDAtMS40LjItMiAuNS0xLjEuNi0xLjkgMS43LTIuMSAyLjloMy42djIuMUgzLjdjLjIuNy42IDEuMyAxIDEuOC44LjggMS45IDEuMiAzIDEuMmguNmMuNSAwIDEgLjIgMS40LjVsNi40IDYuNGMuNC40LjkuNiAxLjQuNi43IDAgMS4zLS4zIDEuNi0uOS42LS44LjQtMS45LS4zLTIuNmwtNi4zLTYuM2MtLjQtLjQtLjYtMS0uNS0xLjYuMS0xLjYtLjctMy4xLTItNC0uNy0uNC0xLjUtLjYtMi4zLS42eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXR3aXR0ZXIiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEzLjkyNyAxMC40OTEgMTkuNTExIDRoLTEuMzIzbC00Ljg0OSA1LjYzNkw5LjQ2NyA0SDVsNS44NTYgOC41MjNMNSAxOS4zM2gxLjMyM2w1LjEyLTUuOTUyIDQuMDkgNS45NTJIMjBsLTYuMDczLTguODM5Wm0tMS44MTIgMi4xMDctLjU5NC0uODQ5LTQuNzItNi43NTNoMi4wMzJsMy44MSA1LjQ1LjU5My44NDkgNC45NTMgNy4wODRoLTIuMDMzbC00LjA0MS01Ljc4di0uMDAxWiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXR3aXR0ZXItc3F1YXJlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy41NjcgMS4zMzNoMTYuNzYyYTIuMjg2IDIuMjg2IDAgMCAxIDIuMjg2IDIuMjg2djE2Ljc2MmEyLjI4NiAyLjI4NiAwIDAgMS0yLjI4NiAyLjI4NkgzLjU2N2EyLjI4NiAyLjI4NiAwIDAgMS0yLjI4Ni0yLjI4NlYzLjYxOWEyLjI4NiAyLjI4NiAwIDAgMSAyLjI4Ni0yLjI4NlpNMTkuNTExIDRsLTUuNTg0IDYuNDkxTDIwIDE5LjMzaC00LjQ2N2wtNC4wOS01Ljk1Mi01LjEyIDUuOTUySDVsNS44NTYtNi44MDdMNSA0aDQuNDY3bDMuODcyIDUuNjM2TDE4LjE4OCA0aDEuMzIzWm0tNy45OSA3Ljc1LjU5NC44NDggNC4wNDEgNS43OGgyLjAzM2wtNC45NTMtNy4wODMtLjU5My0uODQ5LTMuODEtNS40NUg2LjhsNC43MjEgNi43NTNaIi8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtdW5sb2NrZWQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE2LjUgMTJIMTZWNmMwLTIuMi0xLjgtNC00LTRTOCAzLjggOCA2djNoMVY2YzAtMS43IDEuMy0zIDMtM3MzIDEuMyAzIDN2Nkg3LjVjLS42IDAtMS4xLjUtMS4xIDEuMXY2LjhjMCAuNi41IDEuMSAxLjEgMS4xaDljLjYgMCAxLjEtLjUgMS4xLTEuMXYtNi44YzAtLjYtLjUtMS4xLTEuMS0xLjF6bS4xIDcuOWMwIC4xIDAgLjEtLjEuMWgtOWMtLjEgMC0uMSAwLS4xLS4xdi02LjhoOS4ydjYuOHpNMTMgMTUuNWMwIC4zLS4yLjctLjUuOHYxLjVoLTF2LTEuNWMtLjMtLjEtLjUtLjUtLjUtLjggMC0uNi40LTEgMS0xczEgLjQgMSAxeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXVwbG9hZCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJtOC40IDcuMy0uNy0uN0wxMiAyLjNsNC4zIDQuMy0uNy43LTMuMS0zLjF2OS4zaC0xVjQuMkw4LjQgNy4zek0xOSAxMnY3LjVjMCAuMy0uMi41LS41LjVoLTEzYy0uMyAwLS41LS4yLS41LS41VjEySDR2Ny41YzAgLjguNyAxLjUgMS41IDEuNWgxM2MuOCAwIDEuNS0uNyAxLjUtMS41VjEyaC0xeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXVzZXIiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyIDEzYzIuMiAwIDQtMS44IDQtNFY2YzAtMi4yLTEuOC00LTQtNFM4IDMuOCA4IDZ2M2MwIDIuMiAxLjggNCA0IDR6TTkgNmMwLTEuNyAxLjMtMyAzLTNzMyAxLjMgMyAzdjNjMCAxLjctMS4zIDMtMyAzcy0zLTEuMy0zLTNWNnptMTEgMTZoLTFjMC0zLjktMy4xLTctNy03cy03IDMuMS03IDdINGMwLTQuNCAzLjYtOCA4LThzOCAzLjYgOCA4eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXZpZGVvIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xNy41IDcuM1Y2YzAtLjgtLjctMS41LTEuNS0xLjVINS41QzQuNyA0LjUgNCA1LjIgNCA2djhjMCAuOC43IDEuNSAxLjUgMS41aDMuNEw3LjQgMjFoMWwxLjYtNS41aDEuOGwxLjYgNS41aDFsLTEuNi01LjVIMTZjLjggMCAxLjUtLjcgMS41LTEuNXYtMS4zbDQgMS41VjUuOGwtNCAxLjV6bTMgNS41LTQtMS41VjE0YzAgLjMtLjIuNS0uNS41SDUuNWMtLjMgMC0uNS0uMi0uNS0uNVY2YzAtLjMuMi0uNS41LS41SDE2Yy4zIDAgLjUuMi41LjV2Mi43bDQtMS41djUuNnpNMiA4aDF2NEgyVjh6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtdmltZW8iIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIwLjk5MSA3LjczYy0uMDggMS43NS0xLjMwMyA0LjE0Ny0zLjY3IDcuMTkxLTIuNDQ3IDMuMTgzLTQuNTE4IDQuNzc0LTYuMjEyIDQuNzc0LTEuMDUgMC0xLjkzOC0uOTY5LTIuNjYzLTIuOTA2bC0xLjQ1My01LjMyNmMtLjU0LTEuOTM3LTEuMTE4LTIuOTA2LTEuNzM1LTIuOTA2LS4xMzMgMC0uNjA0LjI4NS0xLjQxMS44NUwzIDguMzE0Yy44ODgtLjc4IDEuNzY0LTEuNTYxIDIuNjI2LTIuMzQyQzYuODEgNC45NTEgNy43IDQuNDEyIDguMjk1IDQuMzU2YzEuMzk5LS4xMzggMi4yNi44MiAyLjU4NiAyLjg3My4zNDkgMi4yMTQuNTkgMy41ODkuNzI2IDQuMTI0LjQwNiAxLjgzNS44NSAyLjc1MiAxLjMzNSAyLjc1LjM3NSAwIC45NC0uNTk1IDEuNjk2LTEuNzg1Ljc1NS0xLjE5IDEuMTYtMi4wOTUgMS4yMTItMi43MTcuMTA4LTEuMDI2LS4yOTYtMS41NC0xLjIxMi0xLjU0MmEzLjQgMy40IDAgMCAwLTEuMzMzLjI5NWMuODg3LTIuODk1IDIuNTc4LTQuMzAzIDUuMDcxLTQuMjI2IDEuODUuMDU3IDIuNzIyIDEuMjU3IDIuNjE1IDMuNjAxWiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXZpbWVvLXNxdWFyZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuNTY3IDEuMzMzaDE2Ljc2MmEyLjI4NiAyLjI4NiAwIDAgMSAyLjI4NiAyLjI4NnYxNi43NjJhMi4yODYgMi4yODYgMCAwIDEtMi4yODYgMi4yODZIMy41NjdhMi4yODYgMi4yODYgMCAwIDEtMi4yODYtMi4yODZWMy42MTlhMi4yODYgMi4yODYgMCAwIDEgMi4yODYtMi4yODZaTTE2LjczIDE0LjU5N2MyLjEwNC0yLjcwNiAzLjE5LTQuODM3IDMuMjYyLTYuMzkzLjA5NS0yLjA4NC0uNjgtMy4xNS0yLjMyNC0zLjIwMS0yLjIxNy0uMDctMy43MiAxLjE4My00LjUwOCAzLjc1NmEzLjAyMiAzLjAyMiAwIDAgMSAxLjE4NS0uMjYyYy44MTQuMDAxIDEuMTczLjQ1OCAxLjA3NyAxLjM3LS4wNDYuNTUzLS40MDYgMS4zNTgtMS4wNzcgMi40MTYtLjY3MiAxLjA1OC0xLjE3NCAxLjU4Ny0xLjUwOCAxLjU4Ny0uNDMgMC0uODI1LS44MTQtMS4xODYtMi40NDUtLjEyLS40NzYtLjMzNi0xLjY5OC0uNjQ2LTMuNjY2LS4yODktMS44MjUtMS4wNTUtMi42NzYtMi4yOTgtMi41NTMtLjUyOC4wNDktMS4zMTkuNTI4LTIuMzczIDEuNDM3QTIwOS41NiAyMDkuNTYgMCAwIDEgNCA4LjcyNGwuNzUzLjk3Yy43MTctLjUwMSAxLjEzNi0uNzU0IDEuMjU0LS43NTQuNTQ5IDAgMS4wNjMuODYgMS41NDMgMi41ODNsMS4yOTEgNC43MzRjLjY0NSAxLjcyMiAxLjQzNCAyLjU4MyAyLjM2NyAyLjU4MyAxLjUwNiAwIDMuMzQ3LTEuNDE1IDUuNTIyLTQuMjQzWiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXdhcm5pbmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyLjUgMTdoLTFWMmgxdjE1em0wIDNoLTF2Mmgxdi0yeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXdhcm5pbmctY2lyY2xlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xMiAyQzYuNSAyIDIgNi41IDIgMTJzNC41IDEwIDEwIDEwIDEwLTQuNSAxMC0xMFMxNy41IDIgMTIgMnptMCAxOWMtNSAwLTktNC05LTlzNC05IDktOSA5IDQgOSA5LTQgOS05IDl6bS0uNS02LjhWNS43aDEuMnY4LjVoLTEuMnptLS4xIDIuM2gxLjJ2MS44aC0xLjJ2LTEuOHoiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC13aGF0c2FwcCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkuMSA0LjZDMTUuNSAxLjMgMTAgMSA2LjEgNFMxIDEyLjQgMy40IDE2LjdMMiAyMS44bDUuMy0xLjRjMS40LjggMy4xIDEuMiA0LjcgMS4yIDQgMCA3LjYtMi41IDkuMS02LjIgMS42LTMuNi44LTcuOS0yLTEwLjh6TTEyIDIwYy0xLjUgMC0yLjktLjQtNC4yLTEuMmwtLjMtLjItMy4xLjguOC0zLjEtLjItLjJDMyAxMi45IDMuNSA4LjcgNi4xIDZzNi43LTMuMyAxMC0xLjUgNC45IDUuNyA0IDkuM2MtMSAzLjctNC4zIDYuMi04LjEgNi4yem00LjUtNi4yYy0uMy0uMS0xLjUtLjctMS43LS44LS4yLS4xLS40LS4xLS42LjEtLjIuMy0uNS43LS44IDEtLjEuMi0uMy4yLS41LjEtLjctLjMtMS40LS43LTItMS4yLS41LS41LTEtMS4xLTEuNC0xLjctLjEtLjMgMC0uNC4xLS41bC40LS40Yy4xLS4xLjItLjMuMy0uNC4xLS4xLjEtLjMgMC0uNCAwLS4yLS41LTEuNC0uOC0xLjlzLS40LS42LS41LS42aC0uNWMtLjIgMC0uNS4xLS43LjMtLjUuNS0uOCAxLjMtLjggMiAuMS45LjQgMS44IDEgMi42IDEuMSAxLjYgMi41IDIuOSA0LjMgMy44LjUuMi45LjQgMS40LjUuNS4yIDEgLjIgMS42LjEuNy0uMSAxLjMtLjYgMS43LTEuMi4yLS40LjItLjguMi0xLjItLjItLjEtLjQtLjEtLjctLjJ6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtd2hhdHNhcHAtc3F1YXJlIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0xNiA4LjFjLTEuNS0xLjUtMy44LTItNS44LTEuMnMtMy4zIDIuOC0zLjMgNC45YzAgMSAuMyAyIC44IDIuOGwuMS4yLS41IDIgMi0uNS4yLjFjLjguNSAxLjguNyAyLjcuOCAyLjIgMCA0LjEtMS4zIDUtMy4zLjgtMiAuMy00LjMtMS4yLTUuOHptLS44IDUuOGMtLjIuNC0uNi43LTEuMS44LS4zLjEtLjcgMC0xLS4xLS4yLS4xLS41LS4yLS45LS4zLTEuMS0uNi0yLjEtMS40LTIuOC0yLjQtLjQtLjUtLjYtMS4xLS43LTEuNyAwLS41LjItMSAuNi0xLjMuMS0uMS4zLS4yLjQtLjJoLjNjLjEgMCAuMiAwIC40LjMuMS4zLjUgMS4xLjUgMS4ydi4zYzAgLjEtLjEuMi0uMi4zLS4xLjEtLjIuMi0uMi4zLS4xLjEtLjIuMi0uMS4zLjIuNC41LjguOSAxLjEuNC4zLjguNiAxLjMuOC4yLjEuMy4xLjMgMCAuMS0uMS40LS41LjUtLjYuMS0uMi4yLS4xLjQtLjEuMS4xLjkuNCAxLjEuNS4yLjEuMy4xLjMuMnYuNnoiLz48cGF0aCBkPSJNMjEgNy4xYzAtLjQgMC0uOC0uMS0xLjItLjItMS4xLS45LTItMS45LTIuNS0uMy0uMi0uNy0uMy0xLS4zLS4zLS4xLS43LS4xLTEuMS0uMUg3LjFjLS40IDAtLjggMC0xLjIuMS0xLjEuMi0yIC45LTIuNSAxLjktLjEuMy0uMi43LS4zIDEtLjEuNC0uMS43LS4xIDEuMVYxN2MwIC40IDAgLjguMSAxLjEuMiAxLjEuOSAyIDEuOSAyLjUuMy4yLjcuMyAxIC4zLjQuMS44LjEgMS4yLjFIMTdjLjQgMCAuOCAwIDEuMS0uMSAxLjEtLjIgMi0uOSAyLjUtMS45LjItLjMuMy0uNy4zLTEgLjEtLjQuMS0uOC4xLTEuMlY3LjF6bS04LjggMTEuMmMtMS4xIDAtMi4xLS4zLTMuMS0uOGwtMy40LjkuOS0zLjNjLS42LTEtLjktMi4xLS45LTMuMiAwLTIuNiAxLjUtNSA0LTZzNS4yLS40IDcgMS41YzEuMiAxLjIgMS45IDIuOCAxLjkgNC41IDAgMS43LS43IDMuMy0xLjkgNC42LTEuMSAxLjEtMi44IDEuOC00LjUgMS44eiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXdpZmkiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIyIDE5aC0xYzAtOC44LTcuMi0xNi0xNi0xNlYyYzkuNCAwIDE3IDcuNiAxNyAxN3oiLz48cGF0aCBkPSJNNSA3djFjNi4xIDAgMTEgNC45IDExIDExaDFjMC02LjYtNS40LTEyLTEyLTEyek01IDEydjFjMy4zIDAgNiAyLjcgNiA2aDFjMC0zLjktMy4xLTctNy03ek01IDE3Yy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMnptMCAzYy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xIDEgLjQgMSAxLS40IDEtMSAxeiIvPjwvc3ltYm9sPjxzeW1ib2wgaWQ9Iml0LXlvdXR1YmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIxLjYgNy4yYy0uMi0uOS0uOS0xLjUtMS44LTEuOEMxOC4yIDUgMTIgNSAxMiA1cy02LjIgMC03LjguNGMtLjkuMy0xLjUuOS0xLjggMS44QzIuMSA4LjggMiAxMC40IDIgMTJjMCAxLjYuMSAzLjIuNCA0LjguMi45LjkgMS41IDEuOCAxLjggMS42LjQgNy44LjQgNy44LjRzNi4yIDAgNy44LS40Yy45LS4yIDEuNS0uOSAxLjgtMS44LjMtMS42LjQtMy4yLjQtNC44IDAtMS42LS4xLTMuMi0uNC00Ljh6TTEwIDE1VjlsNS4yIDMtNS4yIDN6Ii8+PC9zeW1ib2w+PHN5bWJvbCBpZD0iaXQtem9vbS1pbiIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTAuNCA5LjVoMy4zdjFoLTMuM3YzLjJoLTF2LTMuMkg2LjJ2LTFoMy4yVjYuMmgxdjMuM3ptMTAuNyAxMi40TDE1LjMgMTZjLTEuNSAxLjMtMy40IDItNS4zIDItNC40IDAtOC0zLjYtOC04czMuNi04IDgtOCA4IDMuNiA4IDhjMCAxLjktLjcgMy44LTIgNS4zbDUuOSA1LjgtLjguOHpNMTcgMTBjMC0zLjktMy4xLTctNy03cy03IDMuMS03IDcgMy4xIDcgNyA3IDctMy4xIDctN3oiLz48L3N5bWJvbD48c3ltYm9sIGlkPSJpdC16b29tLW91dCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNi4yIDkuNWg3LjV2MUg2LjJ2LTF6bTE0LjkgMTIuNEwxNS4zIDE2Yy0xLjUgMS4zLTMuNCAyLTUuMyAyLTQuNCAwLTgtMy42LTgtOHMzLjYtOCA4LTggOCAzLjYgOCA4YzAgMS45LS43IDMuOC0yIDUuM2w1LjkgNS44LS44Ljh6TTE3IDEwYzAtMy45LTMuMS03LTctN3MtNyAzLjEtNyA3IDMuMSA3IDcgNyA3LTMuMSA3LTd6Ii8+PC9zeW1ib2w+PC9zdmc+", gT = { class: "select-wrapper" }, mT = ["for"], ET = ["disabled", "id"], MT = {
  key: 0,
  value: null
}, hT = ["selected", "value"], _T = /* @__PURE__ */ Ct({
  __name: "KSelect",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    labelText: { default: "" },
    class: { default: "" },
    readonly: { type: Boolean, default: !1 },
    formGroupClass: { default: "" },
    disabled: { type: Boolean, default: !1 },
    options: {},
    emptyOptionLabel: { default: "Seleziona un'opzione" },
    showEmptyOption: { type: Boolean, default: !1 },
    autocomplete: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change"],
  setup(j, { emit: f }) {
    const D = f, B = lt(), U = j;
    er(
      () => U.modelValue,
      (g) => {
        B.value = g;
      },
      { immediate: !0 }
    );
    const G = (g) => {
      const n = g.target.options[g.target.selectedIndex]._value;
      D("update:modelValue", n), D("change", n);
    }, R = (g) => g.value == B.value, m = `<svg class="icon autocomplete__dropdown-arrow-down" style="pointer-events: none; z-index:0"><use xlink:href="${dT}#it-expand"></use></svg>`;
    function e() {
      if (U.autocomplete === !0) {
        var g = document.getElementById(U.id);
        Kg.getOrCreateInstance(g, {
          showAllValues: !0,
          defaultValue: "",
          autoselect: !1,
          showNoOptionsFound: !1,
          confirmOnBlur: !1,
          dropdownArrow: () => m,
          onConfirm: (n) => {
            var i = U.options.find((r) => r.name == n);
            i ? B.value = i.value : B.value = null, D("update:modelValue", B.value), D("change", B.value);
          }
        });
      }
    }
    return tr(() => {
      e();
    }), (g, n) => (Ne(), We("div", {
      class: Ot(["form-group", g.formGroupClass])
    }, [
      he("div", gT, [
        he("label", {
          for: g.id,
          class: "k-select-label-text"
        }, ft(g.labelText), 9, mT),
        he("select", {
          disabled: U.disabled,
          onChange: G,
          class: Ot(["k-select-control-text", U.class]),
          id: g.id
        }, [
          U.showEmptyOption ? (Ne(), We("option", MT, ft(U.emptyOptionLabel), 1)) : mt("", !0),
          (Ne(!0), We(or, null, _r(U.options, (i) => (Ne(), We("option", {
            selected: R(i),
            value: i.value,
            key: i.value
          }, ft(i.name), 9, hT))), 128))
        ], 42, ET)
      ])
    ], 2));
  }
}), yT = { class: "steppers" }, vT = { class: "steppers-header mb-3" }, pT = { style: { "background-color": "#f8f8f8" } }, TT = { class: "steppers-number" }, LT = {
  key: 0,
  class: "visually-hidden"
}, IT = {
  key: 1,
  class: "visually-hidden"
}, AT = { key: 2 }, ST = {
  key: 4,
  class: "visually-hidden"
}, DT = {
  key: 1,
  class: "k-stepper-title-populated"
}, NT = {
  key: 0,
  class: "k-stepper-inner-title"
}, CT = /* @__PURE__ */ he("br", null, null, -1), jT = { key: 1 }, OT = {
  class: "steppers-index",
  "aria-hidden": "true"
}, PT = /* @__PURE__ */ Ct({
  __name: "KStepperHeader",
  props: {
    steps: {},
    currentIndex: { default: 1 }
  },
  setup(j) {
    const f = j, D = Vt(() => f.currentIndex + "/" + f.steps.length);
    return (B, U) => {
      const G = Pt("KIcon");
      return Ne(), We("div", yT, [
        he("div", vT, [
          he("ul", pT, [
            (Ne(!0), We(or, null, _r(B.steps, (R) => (Ne(), We("li", {
              key: R.index,
              class: Ot([
                { "active no-line": B.currentIndex === R.index },
                { confirmed: B.currentIndex > R.index },
                { "py-1": B.currentIndex > R.index },
                { "py-3": B.currentIndex <= R.index }
              ])
            }, [
              he("table", null, [
                he("tr", null, [
                  he("td", null, [
                    he("span", TT, [
                      B.currentIndex === R.index ? (Ne(), We("span", LT, "Step")) : mt("", !0),
                      B.currentIndex === R.index ? (Ne(), We("span", IT, "Attivo")) : mt("", !0),
                      B.currentIndex <= R.index ? (Ne(), We("span", AT, ft(R.index), 1)) : mt("", !0),
                      B.currentIndex > R.index ? (Ne(), Ft(G, {
                        key: 3,
                        class: "steppers-success",
                        icon: "it-check"
                      })) : mt("", !0),
                      B.currentIndex > R.index ? (Ne(), We("span", ST, "Confermato")) : mt("", !0)
                    ])
                  ]),
                  B.currentIndex <= R.index ? (Ne(), We("td", {
                    key: 0,
                    class: Ot([{ "k-stepper-title": B.currentIndex === R.index }, { "k-stepper-title-not-populated": B.currentIndex < R.index }])
                  }, ft(R.title), 3)) : (Ne(), We("td", DT, [
                    B.currentIndex > R.index ? (Ne(), We("span", NT, ft(R.shortTitle), 1)) : mt("", !0),
                    CT,
                    B.currentIndex > R.index ? (Ne(), We("span", jT, ft(R.description), 1)) : mt("", !0)
                  ]))
                ])
              ])
            ], 2))), 128))
          ]),
          he("span", OT, ft(D.value), 1)
        ])
      ]);
    };
  }
}), RT = ["aria-controls", "aria-selected", "href"], bT = {
  key: 0,
  class: "k-tab-counter-highlight bg-primary"
}, xT = /* @__PURE__ */ Ct({
  __name: "KTabs",
  props: {
    wrapperClass: {},
    navClass: {},
    noContentMargin: { type: Boolean, default: !1 }
  },
  emits: ["changed", "clicked", "to-link"],
  setup(j, { emit: f }) {
    Er();
    const D = Kr(), B = j, U = f, G = Vt(() => B && B.noContentMargin === !0 ? "k-tab-no-content-margin" : ""), R = wo({
      activeTabHash: "",
      lastActiveTabHash: "",
      tabs: []
    }), m = lt(null), e = lt([]);
    ln("tabsProvider", R), ln("addTab", (n) => {
      R.tabs.push(n);
    }), ln("updateTab", (n, i) => {
      let r = R.tabs.findIndex((l) => l.computedId === n);
      i.isActive = R.tabs[r].isActive, R.tabs[r] = i;
    }), ln("deleteTab", (n) => {
      let i = R.tabs.findIndex((r) => r.computedId === n);
      R.tabs.splice(i, 1);
    });
    const g = (n) => R.tabs.find((i) => i.hash === n);
    return tr(() => {
      var l;
      if (!R.tabs.length)
        return;
      var n = [].slice.call(m.value.querySelectorAll("a"));
      let i = (l = R.tabs.find((d) => D.matched.some((t) => t.path.includes(d.toLink)))) == null ? void 0 : l.hash, r = !1;
      n.forEach((d) => {
        let t = Zr.getOrCreateInstance(d);
        if (e.value.push(t), i)
          i == d.hash && t.show();
        else if (!r) {
          r = !0;
          let T = g(t._element.hash);
          T != null && T.toLink && U("to-link", T.toLink), t.show();
        }
        d.addEventListener("click", (T) => {
          U("clicked", T.currentTarget.hash);
          let S = g(T.currentTarget.hash);
          S != null && S.toLink && U("to-link", S.toLink), U("changed", S);
          var h = document.querySelector(`[href='${T.currentTarget.hash}']`);
          Zr.getInstance(h).show();
        });
      });
    }), (n, i) => (Ne(), We("div", {
      class: Ot(n.wrapperClass)
    }, [
      he("ul", {
        class: Ot(["nav nav-tabs", n.navClass]),
        role: "tablist",
        ref_key: "kTab",
        ref: m
      }, [
        (Ne(!0), We(or, null, _r(R.tabs, (r, l) => (Ne(), We("li", {
          key: l,
          class: "nav-item",
          style: { position: "relative" }
        }, [
          he("a", {
            "data-bs-toggle": "tab",
            role: "tab",
            class: Ot(["nav-link", "px-5", (r.isDisabled, ""), r.isActive ? "active" : ""]),
            "aria-controls": r.hash,
            "aria-selected": r.isActive,
            href: r.hash
          }, ft(r.header), 11, RT),
          r.higlightCounter && r.higlightCounter > 0 ? (Ne(), We("div", bT, ft(r.higlightCounter), 1)) : mt("", !0)
        ]))), 128))
      ], 2),
      he("div", {
        class: Ot(["tab-content", G.value])
      }, [
        nr(n.$slots, "default")
      ], 2)
    ], 2));
  }
}), wT = ["id", "aria-labelledby"], UT = /* @__PURE__ */ Ct({
  __name: "KTab",
  props: {
    id: {},
    name: {},
    prefix: { default: "" },
    suffix: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    higlightCounter: {},
    toLink: {},
    tabClass: {}
  },
  setup(j) {
    const f = j, D = lt(null), B = lt(!1), U = cn("tabsProvider"), G = cn("addTab"), R = cn("updateTab"), m = cn("deleteTab"), e = f.prefix + f.name + f.suffix, g = f.id ? f.id : f.name.toLowerCase().replace(/ /g, "-"), n = "#" + (f.isDisabled ? "" : g);
    return er(
      () => U.activeTabHash,
      () => {
        B.value = n === U.activeTabHash;
      }
    ), er(() => Object.assign({}, f), () => {
      R(g, {
        name: f.name,
        header: f.prefix + f.name + f.suffix,
        higlightCounter: f.higlightCounter,
        isDisabled: f.isDisabled,
        hash: n,
        toLink: f.toLink,
        index: U.tabs.length,
        computedId: g
      });
    }), bo(() => {
      G({
        name: f.name,
        header: e,
        higlightCounter: f.higlightCounter,
        isDisabled: f.isDisabled,
        hash: n,
        toLink: f.toLink,
        index: U.tabs.length,
        computedId: g
      });
    }), vi(() => {
      m(g);
    }), tr(() => {
    }), (i, r) => (Ne(), We("div", {
      class: Ot(["tab-pane p-4 fade", f.tabClass]),
      id: ot(g),
      ref_key: "tab",
      ref: D,
      "aria-labelledby": i.id + "-tab",
      role: "tabpanel"
    }, [
      nr(i.$slots, "default")
    ], 10, wT));
  }
}), FT = { class: "toggles" }, BT = /* @__PURE__ */ he("span", { class: "lever" }, null, -1), zT = /* @__PURE__ */ Ct({
  __name: "KToggle",
  props: {
    modelValue: { type: Boolean },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    group: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(j, { emit: f }) {
    lt(null);
    const D = j, B = f, U = Vt({
      get: () => D.modelValue,
      set: (R) => B("update:modelValue", R)
    }), G = "ktoggle_" + Math.floor(Math.random() * 65536).toString();
    return (R, m) => (Ne(), We("div", {
      class: Ot(["form-check", { "form-check-group": D.group }])
    }, [
      he("div", FT, [
        he("label", { for: G }, [
          Ht(ft(D.label) + " ", 1),
          Cn(he("input", {
            type: "checkbox",
            id: G,
            "onUpdate:modelValue": m[0] || (m[0] = (e) => U.value = e),
            "true-value": !0,
            "false-value": !1
          }, null, 512), [
            [Ro, U.value]
          ]),
          BT
        ])
      ])
    ], 2));
  }
}), Lu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  K2ColContainer: uf,
  K3ColContainer: lf,
  KAlert: Bo,
  KBackButton: mf,
  KCard: Pu,
  KCarousel: iE,
  KCheckbox: uE,
  KDataTableActions: UE,
  KDatePicker: zE,
  KGlobalCalendarCompact: tv,
  KGlobalSearchBar: nv,
  KIcon: Dr,
  KInputChips: sv,
  KInputDate: mv,
  KInputFile: Av,
  KInputNumber: Zv,
  KInputPassword: Zl,
  KInputSearch: Jl,
  KInputText: ql,
  KInputTextArea: ec,
  KLinkCarousel: sp,
  KModalCenter: Ep,
  KModalFullPage: Hl,
  KModalSlide: pp,
  KNavScroll: aT,
  KNavScrollItem: oT,
  KPaginator: kp,
  KRadioButton: cT,
  KSectionHeader: vs,
  KSelect: _T,
  KSpinner: _s,
  KStepperHeader: PT,
  KTab: UT,
  KTabs: xT,
  KToggle: zT
}, Symbol.toStringTag, { value: "Module" })), kT = { class: "col-12" }, YT = /* @__PURE__ */ Ct({
  __name: "KNotificationPreviewCard",
  props: {
    notification: { default: null },
    showTime: { type: Boolean, default: !1 }
  },
  setup(j) {
    const { toDateString: f, toDateTimeString: D } = qr(), B = Er(), { kToast: U } = xr(), G = j, { getCustomNotificationHandlerForModule: R } = ir(), m = lt(null);
    er(
      () => G.notification,
      (n, i) => {
        if (n != null) {
          const r = R(n.multichannelNotificationLite.module);
          r && r.previewCardhandler && (m.value = r.previewCardhandler.previewCardActionLabel(n));
        } else
          m.value = null;
      },
      { immediate: !0 }
    );
    const e = (n) => {
      if (!n)
        return;
      const i = R(n.multichannelNotificationLite.module);
      if (i && i.previewCardhandler && i.previewCardhandler.previewCardActionHandler)
        try {
          i.previewCardhandler.previewCardActionHandler(n, B);
        } catch (r) {
          U.showError((r == null ? void 0 : r.message) || "Unknown error.");
        }
    }, g = (n) => {
      B.push({ name: "notification-detail", params: { id: n } });
    };
    return (n, i) => {
      const r = Pt("KAlert");
      return Ne(), We("div", kT, [
        gt(r, {
          primaryButton: "APRI",
          secondaryButton: m.value,
          badge: n.showTime ? ot(D)(n.notification.dateTime) : ot(f)(n.notification.dateTime),
          title: n.notification.subject,
          body: n.notification.body,
          onOnPrimaryButtonClick: i[0] || (i[0] = (l) => g(n.notification.id)),
          onOnSecondaryButtonClick: i[1] || (i[1] = (l) => e(n.notification))
        }, null, 8, ["secondaryButton", "badge", "title", "body"])
      ]);
    };
  }
}), WT = /* @__PURE__ */ Ct({
  __name: "KLatestNotifications",
  props: {
    itemsToShow: { default: 3 },
    unreadOnly: { type: Boolean, default: !0 }
  },
  setup(j) {
    Er();
    const f = j, D = lt(!1), B = lt([]);
    tr(async () => {
      await U();
    });
    const U = async () => {
      D.value = !0;
      const G = await un.getLatestInAppNotifications(f.itemsToShow, f.unreadOnly);
      G && (B.value = G.items), D.value = !1;
    };
    return (G, R) => {
      const m = Pt("KCarousel");
      return Ne(), Ft(m, {
        items: B.value,
        class: "mb-4"
      }, {
        template: Rt((e) => [
          gt(YT, {
            notification: e.data,
            style: { "margin-bottom": "5px" }
          }, null, 8, ["notification"])
        ]),
        _: 1
      }, 8, ["items"]);
    };
  }
}), KT = {
  class: "card-wrapper",
  style: { width: "100%" }
}, VT = { class: "card card-img no-after" }, GT = { class: "img-responsive-wrapper" }, QT = { class: "img-responsive" }, HT = { class: "img-wrapper" }, XT = ["src"], $T = { class: "card-body" }, ZT = { class: "text" }, JT = { class: "visually-hidden" }, qT = /* @__PURE__ */ Ct({
  __name: "KWebTvLatest",
  setup(j) {
    const f = Ci();
    return tr(() => {
      f.getLatestVideos();
    }), (D, B) => {
      const U = Pt("router-link"), G = Pt("KCarousel");
      return Ne(), Ft(G, {
        items: ot(f).latestVideos
      }, {
        template: Rt((R) => [
          he("div", KT, [
            he("div", VT, [
              he("div", GT, [
                he("div", QT, [
                  he("div", HT, [
                    he("img", {
                      src: ot(f).getLargeThumbnailUrl(R.data),
                      title: "titolo immagine",
                      alt: "descrizione immagine"
                    }, null, 8, XT)
                  ])
                ])
              ]),
              he("div", $T, [
                gt(U, {
                  class: "read-more",
                  style: { position: "unset" },
                  to: "video/" + R.data.id
                }, {
                  default: Rt(() => [
                    he("span", ZT, ft(R.data.title), 1),
                    he("span", JT, ft(R.data.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["items"]);
    };
  }
});
var tc = { exports: {} };
(function(j, f) {
  (function(B, U) {
    j.exports = U();
  })(self, () => (
    /******/
    (() => {
      var D = {
        /***/
        "./externals/base64.js": (
          /*!*****************************!*\
            !*** ./externals/base64.js ***!
            \*****************************/
          /***/
          (R, m) => {
            var e = {};
            e.encode = function(n) {
              for (var i = [], r = 0; r < n.length; ++r) {
                var l = n.charCodeAt(r);
                l < 128 ? i.push(l) : l < 2048 ? (i.push(192 | l >> 6), i.push(128 | 63 & l)) : l < 65536 ? (i.push(224 | l >> 12), i.push(128 | 63 & l >> 6), i.push(128 | 63 & l)) : (i.push(240 | l >> 18), i.push(128 | 63 & l >> 12), i.push(128 | 63 & l >> 6), i.push(128 | 63 & l));
              }
              return i;
            }, e.decode = function(n) {
              for (var i = [], r = 0; r < n.length; ) {
                var l = n[r++];
                l < 128 || (l < 224 ? (l = (31 & l) << 6, l |= 63 & n[r++]) : l < 240 ? (l = (15 & l) << 12, l |= (63 & n[r++]) << 6, l |= 63 & n[r++]) : (l = (7 & l) << 18, l |= (63 & n[r++]) << 12, l |= (63 & n[r++]) << 6, l |= 63 & n[r++])), i.push(String.fromCharCode(l));
              }
              return i.join("");
            };
            var g = {};
            (function(n) {
              var i = function(T) {
                for (var S = 0, h = [], _ = 0 | T.length / 3; 0 < _--; ) {
                  var L = (T[S] << 16) + (T[S + 1] << 8) + T[S + 2];
                  S += 3, h.push(n.charAt(63 & L >> 18)), h.push(n.charAt(63 & L >> 12)), h.push(n.charAt(63 & L >> 6)), h.push(n.charAt(63 & L));
                }
                if (T.length - S == 2) {
                  var L = (T[S] << 16) + (T[S + 1] << 8);
                  h.push(n.charAt(63 & L >> 18)), h.push(n.charAt(63 & L >> 12)), h.push(n.charAt(63 & L >> 6)), h.push("=");
                } else if (T.length - S == 1) {
                  var L = T[S] << 16;
                  h.push(n.charAt(63 & L >> 18)), h.push(n.charAt(63 & L >> 12)), h.push("==");
                }
                return h.join("");
              }, r = function() {
                for (var t = [], T = 0; T < n.length; ++T)
                  t[n.charCodeAt(T)] = T;
                return t["=".charCodeAt(0)] = 0, t;
              }(), l = function(T) {
                for (var S = 0, h = [], _ = 0 | T.length / 4; 0 < _--; ) {
                  var L = (r[T.charCodeAt(S)] << 18) + (r[T.charCodeAt(S + 1)] << 12) + (r[T.charCodeAt(S + 2)] << 6) + r[T.charCodeAt(S + 3)];
                  h.push(255 & L >> 16), h.push(255 & L >> 8), h.push(255 & L), S += 4;
                }
                return h && (T.charAt(S - 2) == "=" ? (h.pop(), h.pop()) : T.charAt(S - 1) == "=" && h.pop()), h;
              }, d = {};
              d.encode = function(t) {
                for (var T = [], S = 0; S < t.length; ++S)
                  T.push(t.charCodeAt(S));
                return T;
              }, d.decode = function(t) {
                for (var T = 0; T < s.length; ++T)
                  a[T] = String.fromCharCode(a[T]);
                return a.join("");
              }, g.decodeArray = function(t) {
                var T = l(t);
                return new Uint8Array(T);
              }, g.encodeASCII = function(t) {
                var T = d.encode(t);
                return i(T);
              }, g.decodeASCII = function(t) {
                var T = l(t);
                return d.decode(T);
              }, g.encode = function(t) {
                var T = e.encode(t);
                return i(T);
              }, g.decode = function(t) {
                var T = l(t);
                return e.decode(T);
              };
            })("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), m.decode = g.decode, m.decodeArray = g.decodeArray, m.encode = g.encode, m.encodeASCII = g.encodeASCII;
          }
        ),
        /***/
        "./externals/cea608-parser.js": (
          /*!************************************!*\
            !*** ./externals/cea608-parser.js ***!
            \************************************/
          /***/
          (R, m) => {
            (function(e) {
              var g = {
                42: 225,
                // lowercase a, acute accent
                92: 233,
                // lowercase e, acute accent
                94: 237,
                // lowercase i, acute accent
                95: 243,
                // lowercase o, acute accent
                96: 250,
                // lowercase u, acute accent
                123: 231,
                // lowercase c with cedilla
                124: 247,
                // division symbol
                125: 209,
                // uppercase N tilde
                126: 241,
                // lowercase n tilde
                127: 9608,
                // Full block
                // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
                // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
                128: 174,
                // Registered symbol (R)
                129: 176,
                // degree sign
                130: 189,
                // 1/2 symbol
                131: 191,
                // Inverted (open) question mark
                132: 8482,
                // Trademark symbol (TM)
                133: 162,
                // Cents symbol
                134: 163,
                // Pounds sterling
                135: 9834,
                // Music 8'th note
                136: 224,
                // lowercase a, grave accent
                137: 32,
                // transparent space (regular)
                138: 232,
                // lowercase e, grave accent
                139: 226,
                // lowercase a, circumflex accent
                140: 234,
                // lowercase e, circumflex accent
                141: 238,
                // lowercase i, circumflex accent
                142: 244,
                // lowercase o, circumflex accent
                143: 251,
                // lowercase u, circumflex accent
                // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
                144: 193,
                // capital letter A with acute
                145: 201,
                // capital letter E with acute
                146: 211,
                // capital letter O with acute
                147: 218,
                // capital letter U with acute
                148: 220,
                // capital letter U with diaresis
                149: 252,
                // lowercase letter U with diaeresis
                150: 8216,
                // opening single quote
                151: 161,
                // inverted exclamation mark
                152: 42,
                // asterisk
                153: 8217,
                // closing single quote
                154: 9473,
                // box drawings heavy horizontal
                155: 169,
                // copyright sign
                156: 8480,
                // Service mark
                157: 8226,
                // (round) bullet
                158: 8220,
                // Left double quotation mark
                159: 8221,
                // Right double quotation mark
                160: 192,
                // uppercase A, grave accent
                161: 194,
                // uppercase A, circumflex
                162: 199,
                // uppercase C with cedilla
                163: 200,
                // uppercase E, grave accent
                164: 202,
                // uppercase E, circumflex
                165: 203,
                // capital letter E with diaresis
                166: 235,
                // lowercase letter e with diaresis
                167: 206,
                // uppercase I, circumflex
                168: 207,
                // uppercase I, with diaresis
                169: 239,
                // lowercase i, with diaresis
                170: 212,
                // uppercase O, circumflex
                171: 217,
                // uppercase U, grave accent
                172: 249,
                // lowercase u, grave accent
                173: 219,
                // uppercase U, circumflex
                174: 171,
                // left-pointing double angle quotation mark
                175: 187,
                // right-pointing double angle quotation mark
                // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
                176: 195,
                // Uppercase A, tilde
                177: 227,
                // Lowercase a, tilde
                178: 205,
                // Uppercase I, acute accent
                179: 204,
                // Uppercase I, grave accent
                180: 236,
                // Lowercase i, grave accent
                181: 210,
                // Uppercase O, grave accent
                182: 242,
                // Lowercase o, grave accent
                183: 213,
                // Uppercase O, tilde
                184: 245,
                // Lowercase o, tilde
                185: 123,
                // Open curly brace
                186: 125,
                // Closing curly brace
                187: 92,
                // Backslash
                188: 94,
                // Caret
                189: 95,
                // Underscore
                190: 124,
                // Pipe (vertical line)
                191: 8764,
                // Tilde operator
                192: 196,
                // Uppercase A, umlaut
                193: 228,
                // Lowercase A, umlaut
                194: 214,
                // Uppercase O, umlaut
                195: 246,
                // Lowercase o, umlaut
                196: 223,
                // Esszett (sharp S)
                197: 165,
                // Yen symbol
                198: 164,
                // Generic currency sign
                199: 9475,
                // Box drawings heavy vertical
                200: 197,
                // Uppercase A, ring
                201: 229,
                // Lowercase A, ring
                202: 216,
                // Uppercase O, stroke
                203: 248,
                // Lowercase o, strok
                204: 9487,
                // Box drawings heavy down and right
                205: 9491,
                // Box drawings heavy down and left
                206: 9495,
                // Box drawings heavy up and right
                207: 9499
                // Box drawings heavy up and left
              }, n = function(E) {
                var N = E;
                return g.hasOwnProperty(E) && (N = g[E]), String.fromCharCode(N);
              }, i = 15, r = 32, l = {
                17: 1,
                18: 3,
                21: 5,
                22: 7,
                23: 9,
                16: 11,
                19: 12,
                20: 14
              }, d = {
                17: 2,
                18: 4,
                21: 6,
                22: 8,
                23: 10,
                19: 13,
                20: 15
              }, t = {
                25: 1,
                26: 3,
                29: 5,
                30: 7,
                31: 9,
                24: 11,
                27: 12,
                28: 14
              }, T = {
                25: 2,
                26: 4,
                29: 6,
                30: 8,
                31: 10,
                27: 13,
                28: 15
              }, S = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"], h = {
                verboseFilter: {
                  DATA: 3,
                  DEBUG: 3,
                  INFO: 2,
                  WARNING: 2,
                  TEXT: 1,
                  ERROR: 0
                },
                time: null,
                verboseLevel: 0,
                // Only write errors
                setTime: function(E) {
                  this.time = E;
                },
                log: function(E, N) {
                  var C = this.verboseFilter[E];
                  this.verboseLevel >= C && console.log(this.time + " [" + E + "] " + N);
                }
              }, _ = function(E) {
                for (var N = [], C = 0; C < E.length; C++)
                  N.push(E[C].toString(16));
                return N;
              }, L = function(E, N, C, b, w) {
                this.foreground = E || "white", this.underline = N || !1, this.italics = C || !1, this.background = b || "black", this.flash = w || !1;
              };
              L.prototype = {
                reset: function() {
                  this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
                },
                setStyles: function(E) {
                  for (var N = ["foreground", "underline", "italics", "background", "flash"], C = 0; C < N.length; C++) {
                    var b = N[C];
                    E.hasOwnProperty(b) && (this[b] = E[b]);
                  }
                },
                isDefault: function() {
                  return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
                },
                equals: function(E) {
                  return this.foreground === E.foreground && this.underline === E.underline && this.italics === E.italics && this.background === E.background && this.flash === E.flash;
                },
                copy: function(E) {
                  this.foreground = E.foreground, this.underline = E.underline, this.italics = E.italics, this.background = E.background, this.flash = E.flash;
                },
                toString: function() {
                  return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
                }
              };
              var v = function(E, N, C, b, w, V) {
                this.uchar = E || " ", this.penState = new L(N, C, b, w, V);
              };
              v.prototype = {
                reset: function() {
                  this.uchar = " ", this.penState.reset();
                },
                setChar: function(E, N) {
                  this.uchar = E, this.penState.copy(N);
                },
                setPenState: function(E) {
                  this.penState.copy(E);
                },
                equals: function(E) {
                  return this.uchar === E.uchar && this.penState.equals(E.penState);
                },
                copy: function(E) {
                  this.uchar = E.uchar, this.penState.copy(E.penState);
                },
                isEmpty: function() {
                  return this.uchar === " " && this.penState.isDefault();
                }
              };
              var c = function() {
                this.chars = [];
                for (var E = 0; E < r; E++)
                  this.chars.push(new v());
                this.pos = 0, this.currPenState = new L();
              };
              c.prototype = {
                equals: function(E) {
                  for (var N = !0, C = 0; C < r; C++)
                    if (!this.chars[C].equals(E.chars[C])) {
                      N = !1;
                      break;
                    }
                  return N;
                },
                copy: function(E) {
                  for (var N = 0; N < r; N++)
                    this.chars[N].copy(E.chars[N]);
                },
                isEmpty: function() {
                  for (var E = !0, N = 0; N < r; N++)
                    if (!this.chars[N].isEmpty()) {
                      E = !1;
                      break;
                    }
                  return E;
                },
                /**
                 *  Set the cursor to a valid column.
                 */
                setCursor: function(E) {
                  this.pos !== E && (this.pos = E), this.pos < 0 ? (h.log("ERROR", "Negative cursor position " + this.pos), this.pos = 0) : this.pos > r && (h.log("ERROR", "Too large cursor position " + this.pos), this.pos = r);
                },
                /** 
                 * Move the cursor relative to current position.
                 */
                moveCursor: function(E) {
                  var N = this.pos + E;
                  if (E > 1)
                    for (var C = this.pos + 1; C < N + 1; C++)
                      this.chars[C].setPenState(this.currPenState);
                  this.setCursor(N);
                },
                /**
                 * Backspace, move one step back and clear character.
                 */
                backSpace: function() {
                  this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
                },
                insertChar: function(E) {
                  E >= 144 && this.backSpace();
                  var N = n(E);
                  if (this.pos >= r) {
                    h.log("ERROR", "Cannot insert " + E.toString(16) + " (" + N + ") at position " + this.pos + ". Skipping it!");
                    return;
                  }
                  this.chars[this.pos].setChar(N, this.currPenState), this.moveCursor(1);
                },
                clearFromPos: function(E) {
                  var N;
                  for (N = E; N < r; N++)
                    this.chars[N].reset();
                },
                clear: function() {
                  this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
                },
                clearToEndOfRow: function() {
                  this.clearFromPos(this.pos);
                },
                getTextString: function() {
                  for (var E = [], N = !0, C = 0; C < r; C++) {
                    var b = this.chars[C].uchar;
                    b !== " " && (N = !1), E.push(b);
                  }
                  return N ? "" : E.join("");
                },
                setPenStyles: function(E) {
                  this.currPenState.setStyles(E);
                  var N = this.chars[this.pos];
                  N.setPenState(this.currPenState);
                }
              };
              var o = function() {
                this.rows = [];
                for (var E = 0; E < i; E++)
                  this.rows.push(new c());
                this.currRow = i - 1, this.nrRollUpRows = null, this.reset();
              };
              o.prototype = {
                reset: function() {
                  for (var E = 0; E < i; E++)
                    this.rows[E].clear();
                  this.currRow = i - 1;
                },
                equals: function(E) {
                  for (var N = !0, C = 0; C < i; C++)
                    if (!this.rows[C].equals(E.rows[C])) {
                      N = !1;
                      break;
                    }
                  return N;
                },
                copy: function(E) {
                  for (var N = 0; N < i; N++)
                    this.rows[N].copy(E.rows[N]);
                },
                isEmpty: function() {
                  for (var E = !0, N = 0; N < i; N++)
                    if (!this.rows[N].isEmpty()) {
                      E = !1;
                      break;
                    }
                  return E;
                },
                backSpace: function() {
                  var E = this.rows[this.currRow];
                  E.backSpace();
                },
                clearToEndOfRow: function() {
                  var E = this.rows[this.currRow];
                  E.clearToEndOfRow();
                },
                /**
                 * Insert a character (without styling) in the current row.
                 */
                insertChar: function(E) {
                  var N = this.rows[this.currRow];
                  N.insertChar(E);
                },
                setPen: function(E) {
                  var N = this.rows[this.currRow];
                  N.setPenStyles(E);
                },
                moveCursor: function(E) {
                  var N = this.rows[this.currRow];
                  N.moveCursor(E);
                },
                setCursor: function(E) {
                  h.log("INFO", "setCursor: " + E);
                  var N = this.rows[this.currRow];
                  N.setCursor(E);
                },
                setPAC: function(E) {
                  h.log("INFO", "pacData = " + JSON.stringify(E));
                  var N = E.row - 1;
                  this.nrRollUpRows && N < this.nrRollUpRows - 1 && (N = this.nrRollUpRows - 1), this.currRow = N;
                  var C = this.rows[this.currRow];
                  if (E.indent !== null) {
                    var b = E.indent, w = Math.max(b - 1, 0);
                    C.setCursor(E.indent), E.color = C.chars[w].penState.foreground;
                  }
                  var V = {
                    foreground: E.color,
                    underline: E.underline,
                    italics: E.italics,
                    background: "black",
                    flash: !1
                  };
                  this.setPen(V);
                },
                /**
                 * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
                 */
                setBkgData: function(E) {
                  h.log("INFO", "bkgData = " + JSON.stringify(E)), this.backSpace(), this.setPen(E), this.insertChar(32);
                },
                setRollUpRows: function(E) {
                  this.nrRollUpRows = E;
                },
                rollUp: function() {
                  if (this.nrRollUpRows === null) {
                    h.log("DEBUG", "roll_up but nrRollUpRows not set yet");
                    return;
                  }
                  h.log("TEXT", this.getDisplayText());
                  var E = this.currRow + 1 - this.nrRollUpRows, N = this.rows.splice(E, 1)[0];
                  N.clear(), this.rows.splice(this.currRow, 0, N), h.log("INFO", "Rolling up");
                },
                /**
                 * Get all non-empty rows with as unicode text. 
                 */
                getDisplayText: function(E) {
                  E = E || !1;
                  for (var N = [], C = "", b = -1, w = 0; w < i; w++) {
                    var V = this.rows[w].getTextString();
                    V && (b = w + 1, E ? N.push("Row " + b + ': "' + V + '"') : N.push(V.trim()));
                  }
                  return N.length > 0 && (E ? C = "[" + N.join(" | ") + "]" : C = N.join(`
`)), C;
                },
                getTextAndFormat: function() {
                  return this.rows;
                }
              };
              var y = function(E, N) {
                this.chNr = E, this.outputFilter = N, this.mode = null, this.verbose = 0, this.displayedMemory = new o(), this.nonDisplayedMemory = new o(), this.lastOutputScreen = new o(), this.currRollUpRow = this.displayedMemory.rows[i - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
              };
              y.prototype = {
                modes: ["MODE_ROLL-UP", "MODE_POP-ON", "MODE_PAINT-ON", "MODE_TEXT"],
                reset: function() {
                  this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.currRollUpRow = this.displayedMemory.rows[i - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.lastCueEndTime = null;
                },
                getHandler: function() {
                  return this.outputFilter;
                },
                setHandler: function(E) {
                  this.outputFilter = E;
                },
                setPAC: function(E) {
                  this.writeScreen.setPAC(E);
                },
                setBkgData: function(E) {
                  this.writeScreen.setBkgData(E);
                },
                setMode: function(E) {
                  E !== this.mode && (this.mode = E, h.log("INFO", "MODE=" + E), this.mode == "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = E);
                },
                insertChars: function(E) {
                  for (var N = 0; N < E.length; N++)
                    this.writeScreen.insertChar(E[N]);
                  var C = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
                  h.log("INFO", C + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (h.log("TEXT", "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
                },
                cc_RCL: function() {
                  h.log("INFO", "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
                },
                cc_BS: function() {
                  h.log("INFO", "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
                },
                cc_AOF: function() {
                },
                cc_AON: function() {
                },
                cc_DER: function() {
                  h.log("INFO", "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
                },
                cc_RU: function(E) {
                  h.log("INFO", "RU(" + E + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(E);
                },
                cc_FON: function() {
                  h.log("INFO", "FON - Flash On"), this.writeScreen.setPen({
                    flash: !0
                  });
                },
                cc_RDC: function() {
                  h.log("INFO", "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
                },
                cc_TR: function() {
                  h.log("INFO", "TR"), this.setMode("MODE_TEXT");
                },
                cc_RTD: function() {
                  h.log("INFO", "RTD"), this.setMode("MODE_TEXT");
                },
                cc_EDM: function() {
                  h.log("INFO", "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate();
                },
                cc_CR: function() {
                  h.log("CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate();
                },
                cc_ENM: function() {
                  h.log("INFO", "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
                },
                cc_EOC: function() {
                  if (h.log("INFO", "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
                    var E = this.displayedMemory;
                    this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = E, this.writeScreen = this.nonDisplayedMemory, h.log("TEXT", "DISP: " + this.displayedMemory.getDisplayText());
                  }
                  this.outputDataUpdate();
                },
                cc_TO: function(E) {
                  h.log("INFO", "TO(" + E + ") - Tab Offset"), this.writeScreen.moveCursor(E);
                },
                cc_MIDROW: function(E) {
                  var N = {
                    flash: !1
                  };
                  if (N.underline = E % 2 === 1, N.italics = E >= 46, N.italics)
                    N.foreground = "white";
                  else {
                    var C = Math.floor(E / 2) - 16, b = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
                    N.foreground = b[C];
                  }
                  h.log("INFO", "MIDROW: " + JSON.stringify(N)), this.writeScreen.setPen(N);
                },
                outputDataUpdate: function() {
                  var E = h.time;
                  E !== null && this.outputFilter && (this.outputFilter.updateData && this.outputFilter.updateData(E, this.displayedMemory), this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = E : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, E, this.lastOutputScreen), this.cueStartTime = this.displayedMemory.isEmpty() ? null : E), this.lastOutputScreen.copy(this.displayedMemory));
                },
                cueSplitAtTime: function(E) {
                  this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, E, this.displayedMemory), this.cueStartTime = E));
                }
              };
              var u = function(E, N, C) {
                this.field = E || 1, this.outputs = [N, C], this.channels = [new y(1, N), new y(2, C)], this.currChNr = -1, this.lastCmdA = null, this.lastCmdB = null, this.bufferedData = [], this.startTime = null, this.lastTime = null, this.dataCounters = {
                  padding: 0,
                  char: 0,
                  cmd: 0,
                  other: 0
                };
              };
              u.prototype = {
                getHandler: function(E) {
                  return this.channels[E].getHandler();
                },
                setHandler: function(E, N) {
                  this.channels[E].setHandler(N);
                },
                /**
                 * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
                 */
                addData: function(E, N) {
                  var C, b, w, V = !1;
                  this.lastTime = E, h.setTime(E);
                  for (var J = 0; J < N.length; J += 2) {
                    if (b = N[J] & 127, w = N[J + 1] & 127, b >= 16 && b <= 31 && b === this.lastCmdA && w === this.lastCmdB) {
                      this.lastCmdA = null, this.lastCmdB = null, h.log("DEBUG", "Repeated command (" + _([b, w]) + ") is dropped");
                      continue;
                    }
                    if (b === 0 && w === 0) {
                      this.dataCounters.padding += 2;
                      continue;
                    } else
                      h.log("DATA", "[" + _([N[J], N[J + 1]]) + "] -> (" + _([b, w]) + ")");
                    if (C = this.parseCmd(b, w), C || (C = this.parseMidrow(b, w)), C || (C = this.parsePAC(b, w)), C || (C = this.parseBackgroundAttributes(b, w)), !C && (V = this.parseChars(b, w), V))
                      if (this.currChNr && this.currChNr >= 0) {
                        var H = this.channels[this.currChNr - 1];
                        H.insertChars(V);
                      } else
                        h.log("WARNING", "No channel found yet. TEXT-MODE?");
                    C ? this.dataCounters.cmd += 2 : V ? this.dataCounters.char += 2 : (this.dataCounters.other += 2, h.log("WARNING", "Couldn't parse cleaned data " + _([b, w]) + " orig: " + _([N[J], N[J + 1]])));
                  }
                },
                /**
                 * Parse Command.
                 * @returns {Boolean} Tells if a command was found
                 */
                parseCmd: function(E, N) {
                  var C = null, b = (E === 20 || E === 21 || E === 28 || E === 29) && 32 <= N && N <= 47, w = (E === 23 || E === 31) && 33 <= N && N <= 35;
                  if (!(b || w))
                    return !1;
                  E === 20 || E === 21 || E === 23 ? C = 1 : C = 2;
                  var V = this.channels[C - 1];
                  return E === 20 || E === 21 || E === 28 || E === 29 ? N === 32 ? V.cc_RCL() : N === 33 ? V.cc_BS() : N === 34 ? V.cc_AOF() : N === 35 ? V.cc_AON() : N === 36 ? V.cc_DER() : N === 37 ? V.cc_RU(2) : N === 38 ? V.cc_RU(3) : N === 39 ? V.cc_RU(4) : N === 40 ? V.cc_FON() : N === 41 ? V.cc_RDC() : N === 42 ? V.cc_TR() : N === 43 ? V.cc_RTD() : N === 44 ? V.cc_EDM() : N === 45 ? V.cc_CR() : N === 46 ? V.cc_ENM() : N === 47 && V.cc_EOC() : V.cc_TO(N - 32), this.lastCmdA = E, this.lastCmdB = N, this.currChNr = C, !0;
                },
                /**
                 * Parse midrow styling command
                 * @returns {Boolean}
                 */
                parseMidrow: function(E, N) {
                  var C = null;
                  if ((E === 17 || E === 25) && 32 <= N && N <= 47) {
                    if (E === 17 ? C = 1 : C = 2, C !== this.currChNr)
                      return h.log("ERROR", "Mismatch channel in midrow parsing"), !1;
                    var b = this.channels[C - 1];
                    return b.insertChars([32]), b.cc_MIDROW(N), h.log("DEBUG", "MIDROW (" + _([E, N]) + ")"), this.lastCmdA = E, this.lastCmdB = N, !0;
                  }
                  return !1;
                },
                /**
                 * Parse Preable Access Codes (Table 53).
                 * @returns {Boolean} Tells if PAC found
                 */
                parsePAC: function(E, N) {
                  var C = null, b = null, w = (17 <= E && E <= 23 || 25 <= E && E <= 31) && 64 <= N && N <= 127, V = (E === 16 || E === 24) && 64 <= N && N <= 95;
                  if (!(w || V))
                    return !1;
                  C = E <= 23 ? 1 : 2, 64 <= N && N <= 95 ? b = C === 1 ? l[E] : t[E] : b = C === 1 ? d[E] : T[E];
                  var J = this.interpretPAC(b, N), H = this.channels[C - 1];
                  return H.setPAC(J), this.lastCmdA = E, this.lastCmdB = N, this.currChNr = C, !0;
                },
                /**
                 * Interpret the second byte of the pac, and return the information.
                 * @returns {Object} pacData with style parameters.
                 */
                interpretPAC: function(E, N) {
                  var C = N, b = {
                    color: null,
                    italics: !1,
                    indent: null,
                    underline: !1,
                    row: E
                  };
                  return N > 95 ? C = N - 96 : C = N - 64, b.underline = (C & 1) === 1, C <= 13 ? b.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(C / 2)] : C <= 15 ? (b.italics = !0, b.color = "white") : b.indent = Math.floor((C - 16) / 2) * 4, b;
                },
                /**
                 * Parse characters.
                 * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
                 */
                parseChars: function(E, N) {
                  var C = null, b = null, w = null;
                  if (E >= 25 ? (C = 2, w = E - 8) : (C = 1, w = E), 17 <= w && w <= 19) {
                    var V = N;
                    w === 17 ? V = N + 80 : w === 18 ? V = N + 112 : V = N + 144, h.log("INFO", "Special char '" + n(V) + "' in channel " + C), b = [V], this.lastCmdA = E, this.lastCmdB = N;
                  } else
                    32 <= E && E <= 127 && (b = N === 0 ? [E] : [E, N], this.lastCmdA = null, this.lastCmdB = null);
                  if (b) {
                    var J = _(b);
                    h.log("DEBUG", "Char codes =  " + J.join(","));
                  }
                  return b;
                },
                /**
                * Parse extended background attributes as well as new foreground color black.
                * @returns{Boolean} Tells if background attributes are found
                */
                parseBackgroundAttributes: function(E, N) {
                  var C, b, w, V, J = (E === 16 || E === 24) && 32 <= N && N <= 47, H = (E === 23 || E === 31) && 45 <= N && N <= 47;
                  return J || H ? (C = {}, E === 16 || E === 24 ? (b = Math.floor((N - 32) / 2), C.background = S[b], N % 2 === 1 && (C.background = C.background + "_semi")) : N === 45 ? C.background = "transparent" : (C.foreground = "black", N === 47 && (C.underline = !0)), w = E < 24 ? 1 : 2, V = this.channels[w - 1], V.setBkgData(C), this.lastCmdA = E, this.lastCmdB = N, !0) : !1;
                },
                /**
                 * Reset state of parser and its channels.
                 */
                reset: function() {
                  for (var E = 0; E < this.channels.length; E++)
                    this.channels[E] && this.channels[E].reset();
                  this.lastCmdA = null, this.lastCmdB = null;
                },
                /**
                 * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
                 */
                cueSplitAtTime: function(E) {
                  for (var N = 0; N < this.channels.length; N++)
                    this.channels[N] && this.channels[N].cueSplitAtTime(E);
                }
              };
              var A = function(E, N, C) {
                for (var b = 0, w = N, V = 0, J = [], H = function(ne, ae, fe, Q) {
                  if (ne !== 4 || ae < 8)
                    return null;
                  var oe = fe.getUint8(Q), de = fe.getUint16(Q + 1), Me = fe.getUint32(Q + 3), ge = fe.getUint8(Q + 7);
                  return oe == 181 && de == 49 && Me == 1195456820 && ge == 3;
                }; w < N + C; ) {
                  if (b = E.getUint32(w), V = E.getUint8(w + 4) & 31, V === 6)
                    for (var z = w + 5, Z = -1; z < w + 4 + b - 1; ) {
                      Z = 0;
                      for (var ie = 255; ie === 255; )
                        ie = E.getUint8(z), Z += ie, z++;
                      var K = 0;
                      for (ie = 255; ie === 255; )
                        ie = E.getUint8(z), K += ie, z++;
                      H(Z, K, E, z) && J.push([z, K]), z += K;
                    }
                  w += b + 4;
                }
                return J;
              }, I = function(E, N) {
                var C = N[0], b = [[], []];
                C += 8;
                var w = E.getUint8(C) & 31;
                C += 2;
                for (var V = 0; V < w; V++) {
                  var J = E.getUint8(C), H = J & 4, z = J & 3;
                  C++;
                  var Z = E.getUint8(C);
                  C++;
                  var ie = E.getUint8(C);
                  C++, H && (Z & 127) + (ie & 127) !== 0 && (z === 0 ? (b[0].push(Z), b[0].push(ie)) : z === 1 && (b[1].push(Z), b[1].push(ie)));
                }
                return b;
              };
              e.logger = h, e.PenState = L, e.CaptionScreen = o, e.Cea608Parser = u, e.findCea608Nalus = A, e.extractCea608DataFromRange = I;
            })(m);
          }
        ),
        /***/
        "./externals/xml2json.js": (
          /*!*******************************!*\
            !*** ./externals/xml2json.js ***!
            \*******************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => n
              /* harmony export */
            });
            function g(i) {
              var r = "1.2.0";
              i = i || {}, l();
              function l() {
                i.escapeMode === void 0 && (i.escapeMode = !0), i.attributePrefix === void 0 && (i.attributePrefix = "_"), i.arrayAccessForm = i.arrayAccessForm || "none", i.emptyNodeForm = i.emptyNodeForm || "text", i.enableToStringFunc === void 0 && (i.enableToStringFunc = !0), i.arrayAccessFormPaths = i.arrayAccessFormPaths || [], i.skipEmptyTextNodesForObj === void 0 && (i.skipEmptyTextNodesForObj = !0), i.stripWhitespaces === void 0 && (i.stripWhitespaces = !0), i.datetimeAccessFormPaths = i.datetimeAccessFormPaths || [], i.useDoubleQuotes === void 0 && (i.useDoubleQuotes = !1), i.xmlElementsFilter = i.xmlElementsFilter || [], i.jsonPropertiesFilter = i.jsonPropertiesFilter || [], i.keepCData === void 0 && (i.keepCData = !1), i.ignoreRoot === void 0 && (i.ignoreRoot = !1);
              }
              var d = {
                ELEMENT_NODE: 1,
                TEXT_NODE: 3,
                CDATA_SECTION_NODE: 4,
                COMMENT_NODE: 8,
                DOCUMENT_NODE: 9
              };
              function t(H) {
                var z = H.localName;
                return z == null && (z = H.baseName), (z == null || z == "") && (z = H.nodeName), z;
              }
              function T(H) {
                return H.prefix;
              }
              function S(H) {
                return typeof H == "string" ? H.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;") : H;
              }
              function h(H, z, Z, ie) {
                for (var K = 0; K < H.length; K++) {
                  var Y = H[K];
                  if (typeof Y == "string") {
                    if (Y == ie)
                      break;
                  } else if (Y instanceof RegExp) {
                    if (Y.test(ie))
                      break;
                  } else if (typeof Y == "function" && Y(z, Z, ie))
                    break;
                }
                return K != H.length;
              }
              function _(H, z, Z) {
                switch (i.arrayAccessForm) {
                  case "property":
                    H[z] instanceof Array ? H[z + "_asArray"] = H[z] : H[z + "_asArray"] = [H[z]];
                    break;
                }
                !(H[z] instanceof Array) && i.arrayAccessFormPaths.length > 0 && h(i.arrayAccessFormPaths, H, z, Z) && (H[z] = [H[z]]);
              }
              function L(H) {
                var z = H.split(/[-T:+Z]/g), Z = new Date(z[0], z[1] - 1, z[2]), ie = z[5].split(".");
                if (Z.setHours(z[3], z[4], ie[0]), ie.length > 1 && Z.setMilliseconds(ie[1]), z[6] && z[7]) {
                  var K = z[6] * 60 + Number(z[7]), Y = /\d\d-\d\d:\d\d$/.test(H) ? "-" : "+";
                  K = 0 + (Y == "-" ? -1 * K : K), Z.setMinutes(Z.getMinutes() - K - Z.getTimezoneOffset());
                } else
                  H.indexOf("Z", H.length - 1) !== -1 && (Z = new Date(Date.UTC(Z.getFullYear(), Z.getMonth(), Z.getDate(), Z.getHours(), Z.getMinutes(), Z.getSeconds(), Z.getMilliseconds())));
                return Z;
              }
              function v(H, z, Z) {
                if (i.datetimeAccessFormPaths.length > 0) {
                  var ie = Z.split(".#")[0];
                  return h(i.datetimeAccessFormPaths, H, z, ie) ? L(H) : H;
                } else
                  return H;
              }
              function c(H, z, Z, ie) {
                return z == d.ELEMENT_NODE && i.xmlElementsFilter.length > 0 ? h(i.xmlElementsFilter, H, Z, ie) : !0;
              }
              function o(H, z) {
                if (H.nodeType == d.DOCUMENT_NODE) {
                  for (var Z = new Object(), ie = H.childNodes, K = 0; K < ie.length; K++) {
                    var Y = ie[K];
                    if (Y.nodeType == d.ELEMENT_NODE)
                      if (i.ignoreRoot)
                        Z = o(Y);
                      else {
                        Z = {};
                        var ne = t(Y);
                        Z[ne] = o(Y);
                      }
                  }
                  return Z;
                } else if (H.nodeType == d.ELEMENT_NODE) {
                  var Z = new Object();
                  Z.__cnt = 0;
                  for (var ae = [], ie = H.childNodes, K = 0; K < ie.length; K++) {
                    var Y = ie[K], ne = t(Y);
                    if (Y.nodeType != d.COMMENT_NODE) {
                      var fe = z + "." + ne;
                      if (c(Z, Y.nodeType, ne, fe))
                        if (Z.__cnt++, Z[ne] == null) {
                          var Q = o(Y, fe);
                          if (ne != "#text" || /[^\s]/.test(Q)) {
                            var oe = {};
                            oe[ne] = Q, ae.push(oe);
                          }
                          Z[ne] = Q, _(Z, ne, fe);
                        } else {
                          Z[ne] != null && (Z[ne] instanceof Array || (Z[ne] = [Z[ne]], _(Z, ne, fe)));
                          var Q = o(Y, fe);
                          if (ne != "#text" || /[^\s]/.test(Q)) {
                            var oe = {};
                            oe[ne] = Q, ae.push(oe);
                          }
                          Z[ne][Z[ne].length] = Q;
                        }
                    }
                  }
                  Z.__children = ae;
                  for (var de = t(H), Me = 0; Me < H.attributes.length; Me++) {
                    var ge = H.attributes[Me];
                    Z.__cnt++;
                    for (var se = ge.value, ee = 0, re = i.matchers.length; ee < re; ee++) {
                      var ue = i.matchers[ee];
                      ue.test(ge, de) && (se = ue.converter(ge.value));
                    }
                    Z[i.attributePrefix + ge.name] = se;
                  }
                  var te = T(H);
                  return te != null && te != "" && (Z.__cnt++, Z.__prefix = te), Z["#text"] != null && (Z.__text = Z["#text"], Z.__text instanceof Array && (Z.__text = Z.__text.join(`
`)), i.stripWhitespaces && (Z.__text = Z.__text.trim()), delete Z["#text"], i.arrayAccessForm == "property" && delete Z["#text_asArray"], Z.__text = v(Z.__text, ne, z + "." + ne)), Z["#cdata-section"] != null && (Z.__cdata = Z["#cdata-section"], delete Z["#cdata-section"], i.arrayAccessForm == "property" && delete Z["#cdata-section_asArray"]), Z.__cnt == 0 && i.emptyNodeForm == "text" ? Z = "" : Z.__cnt == 1 && Z.__text != null ? Z = Z.__text : Z.__cnt == 1 && Z.__cdata != null && !i.keepCData ? Z = Z.__cdata : Z.__cnt > 1 && Z.__text != null && i.skipEmptyTextNodesForObj && (i.stripWhitespaces && Z.__text == "" || Z.__text.trim() == "") && delete Z.__text, delete Z.__cnt, i.enableToStringFunc && (Z.__text != null || Z.__cdata != null) && (Z.toString = function() {
                    return (this.__text != null ? this.__text : "") + (this.__cdata != null ? this.__cdata : "");
                  }), Z;
                } else if (H.nodeType == d.TEXT_NODE || H.nodeType == d.CDATA_SECTION_NODE)
                  return H.nodeValue;
              }
              function y(H, z, Z, ie) {
                var K = "<" + (H != null && H.__prefix != null ? H.__prefix + ":" : "") + z;
                if (Z != null)
                  for (var Y = 0; Y < Z.length; Y++) {
                    var ne = Z[Y], ae = H[ne];
                    i.escapeMode && (ae = S(ae)), K += " " + ne.substr(i.attributePrefix.length) + "=", i.useDoubleQuotes ? K += '"' + ae + '"' : K += "'" + ae + "'";
                  }
                return ie ? K += "/>" : K += ">", K;
              }
              function u(H, z) {
                return "</" + (H.__prefix != null ? H.__prefix + ":" : "") + z + ">";
              }
              function A(H, z) {
                return H.indexOf(z, H.length - z.length) !== -1;
              }
              function I(H, z) {
                return !!(i.arrayAccessForm == "property" && A(z.toString(), "_asArray") || z.toString().indexOf(i.attributePrefix) == 0 || z.toString().indexOf("__") == 0 || H[z] instanceof Function);
              }
              function M(H) {
                var z = 0;
                if (H instanceof Object)
                  for (var Z in H)
                    I(H, Z) || z++;
                return z;
              }
              function E(H, z, Z) {
                return i.jsonPropertiesFilter.length == 0 || Z == "" || h(i.jsonPropertiesFilter, H, z, Z);
              }
              function N(H) {
                var z = [];
                if (H instanceof Object)
                  for (var Z in H)
                    Z.toString().indexOf("__") == -1 && Z.toString().indexOf(i.attributePrefix) == 0 && z.push(Z);
                return z;
              }
              function C(H) {
                var z = "";
                return H.__cdata != null && (z += "<![CDATA[" + H.__cdata + "]]>"), H.__text != null && (i.escapeMode ? z += S(H.__text) : z += H.__text), z;
              }
              function b(H) {
                var z = "";
                return H instanceof Object ? z += C(H) : H != null && (i.escapeMode ? z += S(H) : z += H), z;
              }
              function w(H, z) {
                return H === "" ? z : H + "." + z;
              }
              function V(H, z, Z, ie) {
                var K = "";
                if (H.length == 0)
                  K += y(H, z, Z, !0);
                else
                  for (var Y = 0; Y < H.length; Y++)
                    K += y(H[Y], z, N(H[Y]), !1), K += J(H[Y], w(ie, z)), K += u(H[Y], z);
                return K;
              }
              function J(H, z) {
                var Z = "", ie = M(H);
                if (ie > 0) {
                  for (var K in H)
                    if (!(I(H, K) || z != "" && !E(H, K, w(z, K)))) {
                      var Y = H[K], ne = N(Y);
                      if (Y == null || Y == null)
                        Z += y(Y, K, ne, !0);
                      else if (Y instanceof Object)
                        if (Y instanceof Array)
                          Z += V(Y, K, ne, z);
                        else if (Y instanceof Date)
                          Z += y(Y, K, ne, !1), Z += Y.toISOString(), Z += u(Y, K);
                        else {
                          var ae = M(Y);
                          ae > 0 || Y.__text != null || Y.__cdata != null ? (Z += y(Y, K, ne, !1), Z += J(Y, w(z, K)), Z += u(Y, K)) : Z += y(Y, K, ne, !0);
                        }
                      else
                        Z += y(Y, K, ne, !1), Z += b(Y), Z += u(Y, K);
                    }
                }
                return Z += b(H), Z;
              }
              this.parseXmlString = function(H) {
                if (H === void 0)
                  return null;
                var z;
                if (window.DOMParser) {
                  var Z = new window.DOMParser();
                  try {
                    z = Z.parseFromString(H, "text/xml"), z.getElementsByTagNameNS("*", "parsererror").length > 0 && (z = null);
                  } catch {
                    z = null;
                  }
                } else
                  H.indexOf("<?") == 0 && (H = H.substr(H.indexOf("?>") + 2)), z = new ActiveXObject("Microsoft.XMLDOM"), z.async = "false", z.loadXML(H);
                return z;
              }, this.asArray = function(H) {
                return H === void 0 || H == null ? [] : H instanceof Array ? H : [H];
              }, this.toXmlDateTime = function(H) {
                return H instanceof Date ? H.toISOString() : typeof H == "number" ? new Date(H).toISOString() : null;
              }, this.asDateTime = function(H) {
                return typeof H == "string" ? L(H) : H;
              }, this.xml2json = function(H) {
                return o(H);
              }, this.xml_str2json = function(H) {
                var z = this.parseXmlString(H);
                return z != null ? this.xml2json(z) : null;
              }, this.json2xml_str = function(H) {
                return J(H, "");
              }, this.json2xml = function(H) {
                var z = this.json2xml_str(H);
                return this.parseXmlString(z);
              }, this.getVersion = function() {
                return r;
              };
            }
            const n = g;
          }
        ),
        /***/
        "./index_mediaplayerOnly.js": (
          /*!**********************************!*\
            !*** ./index_mediaplayerOnly.js ***!
            \**********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              Debug: () => (
                /* reexport safe */
                i.default
              ),
              /* harmony export */
              FactoryMaker: () => (
                /* reexport safe */
                n.default
              ),
              /* harmony export */
              MediaPlayer: () => (
                /* reexport safe */
                g.default
              ),
              /* harmony export */
              default: () => t
              /* harmony export */
            });
            var g = e(
              /*! ./src/streaming/MediaPlayer */
              "./src/streaming/MediaPlayer.js"
            ), n = e(
              /*! ./src/core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), i = e(
              /*! ./src/core/Debug */
              "./src/core/Debug.js"
            ), r = e(
              /*! ./src/core/Version */
              "./src/core/Version.js"
            );
            e(
              /*! es6-promise/auto */
              "./node_modules/es6-promise/auto.js"
            );
            var l = typeof window < "u" && window || e.g, d = l.dashjs;
            d || (d = l.dashjs = {}), d.MediaPlayer = g.default, d.FactoryMaker = n.default, d.Debug = i.default, d.Version = (0, r.getVersionString)();
            const t = d;
          }
        ),
        /***/
        "./src/core/Debug.js": (
          /*!***************************!*\
            !*** ./src/core/Debug.js ***!
            \***************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var g = e(
              /*! ./EventBus */
              "./src/core/EventBus.js"
            ), n = e(
              /*! ./events/Events */
              "./src/core/events/Events.js"
            ), i = e(
              /*! ./FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = 0, l = 1, d = 2, t = 3, T = 4, S = 5;
            function h(v) {
              v = v || {};
              var c = this.context, o = (0, g.default)(c).getInstance(), y = v.settings, u = [], A, I, M, E;
              function N() {
                I = !0, M = !0, E = (/* @__PURE__ */ new Date()).getTime(), typeof window < "u" && window.console && (u[l] = C(window.console.error), u[d] = C(window.console.error), u[t] = C(window.console.warn), u[T] = C(window.console.info), u[S] = C(window.console.debug));
              }
              function C(Y) {
                return Y && Y.bind ? Y.bind(window.console) : window.console.log.bind(window.console);
              }
              function b(Y) {
                return {
                  fatal: J.bind(Y),
                  error: H.bind(Y),
                  warn: z.bind(Y),
                  info: Z.bind(Y),
                  debug: ie.bind(Y)
                };
              }
              function w(Y) {
                I = Y;
              }
              function V(Y) {
                M = Y;
              }
              function J() {
                for (var Y = arguments.length, ne = new Array(Y), ae = 0; ae < Y; ae++)
                  ne[ae] = arguments[ae];
                K.apply(void 0, [l, this].concat(ne));
              }
              function H() {
                for (var Y = arguments.length, ne = new Array(Y), ae = 0; ae < Y; ae++)
                  ne[ae] = arguments[ae];
                K.apply(void 0, [d, this].concat(ne));
              }
              function z() {
                for (var Y = arguments.length, ne = new Array(Y), ae = 0; ae < Y; ae++)
                  ne[ae] = arguments[ae];
                K.apply(void 0, [t, this].concat(ne));
              }
              function Z() {
                for (var Y = arguments.length, ne = new Array(Y), ae = 0; ae < Y; ae++)
                  ne[ae] = arguments[ae];
                K.apply(void 0, [T, this].concat(ne));
              }
              function ie() {
                for (var Y = arguments.length, ne = new Array(Y), ae = 0; ae < Y; ae++)
                  ne[ae] = arguments[ae];
                K.apply(void 0, [S, this].concat(ne));
              }
              function K(Y, ne) {
                var ae = "", fe = null;
                I && (fe = (/* @__PURE__ */ new Date()).getTime(), ae += "[" + (fe - E) + "]"), M && ne && ne.getClassName && (ae += "[" + ne.getClassName() + "]", ne.getType && (ae += "[" + ne.getType() + "]")), ae.length > 0 && (ae += " ");
                for (var Q = arguments.length, oe = new Array(Q > 2 ? Q - 2 : 0), de = 2; de < Q; de++)
                  oe[de - 2] = arguments[de];
                Array.apply(null, oe).forEach(function(Me) {
                  ae += Me + " ";
                }), u[Y] && y && y.get().debug.logLevel >= Y && u[Y](ae), y && y.get().debug.dispatchEvent && o.trigger(n.default.LOG, {
                  message: ae,
                  level: Y
                });
              }
              return A = {
                getLogger: b,
                setLogTimestampVisible: w,
                setCalleeNameVisible: V
              }, N(), A;
            }
            h.__dashjs_factory_name = "Debug";
            var _ = i.default.getSingletonFactory(h);
            _.LOG_LEVEL_NONE = r, _.LOG_LEVEL_FATAL = l, _.LOG_LEVEL_ERROR = d, _.LOG_LEVEL_WARNING = t, _.LOG_LEVEL_INFO = T, _.LOG_LEVEL_DEBUG = S, i.default.updateSingletonFactory(h.__dashjs_factory_name, _);
            const L = _;
          }
        ),
        /***/
        "./src/core/EventBus.js": (
          /*!******************************!*\
            !*** ./src/core/EventBus.js ***!
            \******************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => t
              /* harmony export */
            });
            var g = e(
              /*! ./FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), i = 0, r = 5e3;
            function l() {
              var T = {};
              function S(o, y, u) {
                var A = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                if (!o)
                  throw new Error("event type cannot be null or undefined");
                if (!y || typeof y != "function")
                  throw new Error("listener must be a function: " + y);
                var I = A.priority || i;
                if (!(L(o, y, u) >= 0)) {
                  T[o] = T[o] || [];
                  var M = {
                    callback: y,
                    scope: u,
                    priority: I
                  };
                  u && u.getStreamId && (M.streamId = u.getStreamId()), u && u.getType && (M.mediaType = u.getType()), A && A.mode && (M.mode = A.mode);
                  var E = T[o].some(function(N, C) {
                    if (N && I > N.priority)
                      return T[o].splice(C, 0, M), !0;
                  });
                  E || T[o].push(M);
                }
              }
              function h(o, y, u) {
                if (!(!o || !y || !T[o])) {
                  var A = L(o, y, u);
                  A < 0 || (T[o][A] = null);
                }
              }
              function _(o) {
                var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                if (!(!o || !T[o])) {
                  if (y = y || {}, y.hasOwnProperty("type"))
                    throw new Error("'type' is a reserved word for event dispatching");
                  y.type = o, u.streamId && (y.streamId = u.streamId), u.mediaType && (y.mediaType = u.mediaType), T[o].filter(function(A) {
                    return !(!A || u.streamId && A.streamId && A.streamId !== u.streamId || u.mediaType && A.mediaType && A.mediaType !== u.mediaType || u.mode && A.mode && A.mode !== u.mode || !A.mode && u.mode && u.mode === n.default.EVENT_MODE_ON_RECEIVE);
                  }).forEach(function(A) {
                    return A && A.callback.call(A.scope, y);
                  });
                }
              }
              function L(o, y, u) {
                var A = -1;
                return T[o] && T[o].some(function(I, M) {
                  if (I && I.callback === y && (!u || u === I.scope))
                    return A = M, !0;
                }), A;
              }
              function v() {
                T = {};
              }
              var c = {
                on: S,
                off: h,
                trigger: _,
                reset: v
              };
              return c;
            }
            l.__dashjs_factory_name = "EventBus";
            var d = g.default.getSingletonFactory(l);
            d.EVENT_PRIORITY_LOW = i, d.EVENT_PRIORITY_HIGH = r, g.default.updateSingletonFactory(l.__dashjs_factory_name, d);
            const t = d;
          }
        ),
        /***/
        "./src/core/FactoryMaker.js": (
          /*!**********************************!*\
            !*** ./src/core/FactoryMaker.js ***!
            \**********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => n
              /* harmony export */
            });
            var g = function() {
              var i, r = [], l = {}, d = {};
              function t(M, E, N, C) {
                !C[M] && E && (C[M] = {
                  instance: E,
                  override: N
                });
              }
              function T(M, E) {
                for (var N in r) {
                  var C = r[N];
                  if (C.context === M && C.name === E)
                    return C.instance;
                }
                return null;
              }
              function S(M, E, N) {
                for (var C in r) {
                  var b = r[C];
                  if (b.context === M && b.name === E) {
                    r[C].instance = N;
                    return;
                  }
                }
                r.push({
                  name: E,
                  context: M,
                  instance: N
                });
              }
              function h(M) {
                r = r.filter(function(E) {
                  return E.context !== M;
                });
              }
              function _(M, E) {
                return E[M];
              }
              function L(M, E, N) {
                M in N && (N[M] = E);
              }
              function v(M, E) {
                L(M, E, d);
              }
              function c(M) {
                return _(M, d);
              }
              function o(M) {
                var E = _(M.__dashjs_factory_name, d);
                return E || (E = function(C) {
                  return C === void 0 && (C = {}), {
                    create: function() {
                      return I(M, C, arguments);
                    }
                  };
                }, d[M.__dashjs_factory_name] = E), E;
              }
              function y(M, E) {
                L(M, E, l);
              }
              function u(M) {
                return _(M, l);
              }
              function A(M) {
                var E = _(M.__dashjs_factory_name, l);
                return E || (E = function(C) {
                  var b;
                  return C === void 0 && (C = {}), {
                    getInstance: function() {
                      return b || (b = T(C, M.__dashjs_factory_name)), b || (b = I(M, C, arguments), r.push({
                        name: M.__dashjs_factory_name,
                        context: C,
                        instance: b
                      })), b;
                    }
                  };
                }, l[M.__dashjs_factory_name] = E), E;
              }
              function I(M, E, N) {
                var C, b = M.__dashjs_factory_name, w = E[b];
                if (w) {
                  var V = w.instance;
                  if (w.override) {
                    C = M.apply({
                      context: E
                    }, N), V = V.apply({
                      context: E,
                      factory: i,
                      parent: C
                    }, N);
                    for (var J in V)
                      C.hasOwnProperty(J) && (C[J] = V[J]);
                  } else
                    return V.apply({
                      context: E,
                      factory: i
                    }, N);
                } else
                  C = M.apply({
                    context: E
                  }, N);
                return C.getClassName = function() {
                  return b;
                }, C;
              }
              return i = {
                extend: t,
                getSingletonInstance: T,
                setSingletonInstance: S,
                deleteSingletonInstances: h,
                getSingletonFactory: A,
                getSingletonFactoryByName: u,
                updateSingletonFactory: y,
                getClassFactory: o,
                getClassFactoryByName: c,
                updateClassFactory: v
              }, i;
            }();
            const n = g;
          }
        ),
        /***/
        "./src/core/Settings.js": (
          /*!******************************!*\
            !*** ./src/core/Settings.js ***!
            \******************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var g = e(
              /*! ./FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ./Utils.js */
              "./src/core/Utils.js"
            ), i = e(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), r = e(
              /*! ../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), l = e(
              /*! ../streaming/vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), d = e(
              /*! ./EventBus */
              "./src/core/EventBus.js"
            ), t = e(
              /*! ./events/Events */
              "./src/core/events/Events.js"
            );
            function T(v) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? T = function(o) {
                return typeof o;
              } : T = function(o) {
                return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
              }, T(v);
            }
            function S(v, c, o) {
              return c in v ? Object.defineProperty(v, c, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : v[c] = o, v;
            }
            function h() {
              var v, c, o, y = this.context, u = (0, d.default)(y).getInstance(), A = {
                "streaming.delay.liveDelay": t.default.SETTING_UPDATED_LIVE_DELAY,
                "streaming.delay.liveDelayFragmentCount": t.default.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT,
                "streaming.liveCatchup.enabled": t.default.SETTING_UPDATED_CATCHUP_ENABLED,
                "streaming.liveCatchup.playbackRate.min": t.default.SETTING_UPDATED_PLAYBACK_RATE_MIN,
                "streaming.liveCatchup.playbackRate.max": t.default.SETTING_UPDATED_PLAYBACK_RATE_MAX
              }, I = {
                debug: {
                  logLevel: i.default.LOG_LEVEL_WARNING,
                  dispatchEvent: !1
                },
                streaming: {
                  abandonLoadTimeout: 1e4,
                  wallclockTimeUpdateInterval: 100,
                  manifestUpdateRetryInterval: 100,
                  cacheInitSegments: !1,
                  applyServiceDescription: !0,
                  applyProducerReferenceTime: !0,
                  applyContentSteering: !0,
                  eventControllerRefreshDelay: 100,
                  enableManifestDurationMismatchFix: !0,
                  enableManifestTimescaleMismatchFix: !1,
                  capabilities: {
                    filterUnsupportedEssentialProperties: !0,
                    useMediaCapabilitiesApi: !1
                  },
                  timeShiftBuffer: {
                    calcFromSegmentTimeline: !1,
                    fallbackToSegmentTimeline: !0
                  },
                  metrics: {
                    maxListDepth: 100
                  },
                  delay: {
                    liveDelayFragmentCount: NaN,
                    liveDelay: NaN,
                    useSuggestedPresentationDelay: !0
                  },
                  protection: {
                    keepProtectionMediaKeys: !1,
                    ignoreEmeEncryptedEvent: !1,
                    detectPlayreadyMessageFormat: !0
                  },
                  buffer: {
                    enableSeekDecorrelationFix: !1,
                    fastSwitchEnabled: !0,
                    flushBufferAtTrackSwitch: !1,
                    reuseExistingSourceBuffers: !0,
                    bufferPruningInterval: 10,
                    bufferToKeep: 20,
                    bufferTimeAtTopQuality: 30,
                    bufferTimeAtTopQualityLongForm: 60,
                    initialBufferLevel: NaN,
                    stableBufferTime: 12,
                    longFormContentDurationThreshold: 600,
                    stallThreshold: 0.3,
                    useAppendWindow: !0,
                    setStallState: !0,
                    avoidCurrentTimeRangePruning: !1,
                    useChangeTypeForTrackSwitch: !0
                  },
                  gaps: {
                    jumpGaps: !0,
                    jumpLargeGaps: !0,
                    smallGapLimit: 1.5,
                    threshold: 0.3,
                    enableSeekFix: !0,
                    enableStallFix: !1,
                    stallSeek: 0.1
                  },
                  utcSynchronization: {
                    enabled: !0,
                    useManifestDateHeaderTimeSource: !0,
                    backgroundAttempts: 2,
                    timeBetweenSyncAttempts: 30,
                    maximumTimeBetweenSyncAttempts: 600,
                    minimumTimeBetweenSyncAttempts: 2,
                    timeBetweenSyncAttemptsAdjustmentFactor: 2,
                    maximumAllowedDrift: 100,
                    enableBackgroundSyncAfterSegmentDownloadError: !0,
                    defaultTimingSource: {
                      scheme: "urn:mpeg:dash:utc:http-xsdate:2014",
                      value: "https://time.akamai.com/?iso&ms"
                    }
                  },
                  scheduling: {
                    defaultTimeout: 500,
                    lowLatencyTimeout: 0,
                    scheduleWhilePaused: !0
                  },
                  text: {
                    defaultEnabled: !0,
                    extendSegmentedCues: !0,
                    webvtt: {
                      customRenderingEnabled: !1
                    }
                  },
                  liveCatchup: {
                    maxDrift: NaN,
                    playbackRate: {
                      min: NaN,
                      max: NaN
                    },
                    playbackBufferMin: 0.5,
                    enabled: null,
                    mode: r.default.LIVE_CATCHUP_MODE_DEFAULT
                  },
                  lastBitrateCachingInfo: {
                    enabled: !0,
                    ttl: 36e4
                  },
                  lastMediaSettingsCachingInfo: {
                    enabled: !0,
                    ttl: 36e4
                  },
                  cacheLoadThresholds: {
                    video: 50,
                    audio: 5
                  },
                  trackSwitchMode: {
                    audio: r.default.TRACK_SWITCH_MODE_ALWAYS_REPLACE,
                    video: r.default.TRACK_SWITCH_MODE_NEVER_REPLACE
                  },
                  selectionModeForInitialTrack: r.default.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY,
                  fragmentRequestTimeout: 2e4,
                  manifestRequestTimeout: 1e4,
                  retryIntervals: (v = {}, S(v, l.HTTPRequest.MPD_TYPE, 500), S(v, l.HTTPRequest.XLINK_EXPANSION_TYPE, 500), S(v, l.HTTPRequest.MEDIA_SEGMENT_TYPE, 1e3), S(v, l.HTTPRequest.INIT_SEGMENT_TYPE, 1e3), S(v, l.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, 1e3), S(v, l.HTTPRequest.INDEX_SEGMENT_TYPE, 1e3), S(v, l.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 1e3), S(v, l.HTTPRequest.LICENSE, 1e3), S(v, l.HTTPRequest.OTHER_TYPE, 1e3), S(v, "lowLatencyReductionFactor", 10), v),
                  retryAttempts: (c = {}, S(c, l.HTTPRequest.MPD_TYPE, 3), S(c, l.HTTPRequest.XLINK_EXPANSION_TYPE, 1), S(c, l.HTTPRequest.MEDIA_SEGMENT_TYPE, 3), S(c, l.HTTPRequest.INIT_SEGMENT_TYPE, 3), S(c, l.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, 3), S(c, l.HTTPRequest.INDEX_SEGMENT_TYPE, 3), S(c, l.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 3), S(c, l.HTTPRequest.LICENSE, 3), S(c, l.HTTPRequest.OTHER_TYPE, 3), S(c, "lowLatencyMultiplyFactor", 5), c),
                  abr: {
                    movingAverageMethod: r.default.MOVING_AVERAGE_SLIDING_WINDOW,
                    ABRStrategy: r.default.ABR_STRATEGY_DYNAMIC,
                    additionalAbrRules: {
                      insufficientBufferRule: !0,
                      switchHistoryRule: !0,
                      droppedFramesRule: !0,
                      abandonRequestsRule: !0
                    },
                    bandwidthSafetyFactor: 0.9,
                    useDefaultABRRules: !0,
                    useDeadTimeLatency: !0,
                    limitBitrateByPortal: !1,
                    usePixelRatioInLimitBitrateByPortal: !1,
                    maxBitrate: {
                      audio: -1,
                      video: -1
                    },
                    minBitrate: {
                      audio: -1,
                      video: -1
                    },
                    maxRepresentationRatio: {
                      audio: 1,
                      video: 1
                    },
                    initialBitrate: {
                      audio: -1,
                      video: -1
                    },
                    initialRepresentationRatio: {
                      audio: -1,
                      video: -1
                    },
                    autoSwitchBitrate: {
                      audio: !0,
                      video: !0
                    },
                    fetchThroughputCalculationMode: r.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING
                  },
                  cmcd: {
                    enabled: !1,
                    sid: null,
                    cid: null,
                    rtp: null,
                    rtpSafetyFactor: 5,
                    mode: r.default.CMCD_MODE_QUERY,
                    enabledKeys: ["br", "d", "ot", "tb", "bl", "dl", "mtp", "nor", "nrr", "su", "bs", "rtp", "cid", "pr", "sf", "sid", "st", "v"]
                  },
                  cmsd: {
                    enabled: !1,
                    abr: {
                      applyMb: !1,
                      etpWeightRatio: 0
                    }
                  }
                },
                errors: {
                  recoverAttempts: {
                    mediaErrorDecode: 5
                  }
                }
              }, M = n.default.clone(I);
              function E(w, V, J) {
                for (var H in w)
                  w.hasOwnProperty(H) && (V.hasOwnProperty(H) ? T(w[H]) === "object" && !(w[H] instanceof Array) && w[H] !== null ? E(w[H], V[H], J.slice() + H + ".") : (V[H] = n.default.clone(w[H]), A[J + H] && u.trigger(A[J + H])) : console.error("Settings parameter " + J + H + " is not supported"));
              }
              function N() {
                return M;
              }
              function C(w) {
                T(w) === "object" && E(w, M, "");
              }
              function b() {
                M = n.default.clone(I);
              }
              return o = {
                get: N,
                update: C,
                reset: b
              }, o;
            }
            h.__dashjs_factory_name = "Settings";
            var _ = g.default.getSingletonFactory(h);
            const L = _;
          }
        ),
        /***/
        "./src/core/Utils.js": (
          /*!***************************!*\
            !*** ./src/core/Utils.js ***!
            \***************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var g = e(
              /*! path-browserify */
              "./node_modules/path-browserify/index.js"
            ), n = /* @__PURE__ */ e.n(g), i = e(
              /*! ua-parser-js */
              "./node_modules/ua-parser-js/src/ua-parser.js"
            );
            function r(h) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(L) {
                return typeof L;
              } : r = function(L) {
                return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
              }, r(h);
            }
            function l(h, _) {
              if (!(h instanceof _))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(h, _) {
              for (var L = 0; L < _.length; L++) {
                var v = _[L];
                v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(h, v.key, v);
              }
            }
            function t(h, _, L) {
              return _ && d(h.prototype, _), L && d(h, L), h;
            }
            var T = /* @__PURE__ */ function() {
              function h() {
                l(this, h);
              }
              return t(h, null, [{
                key: "mixin",
                value: function(L, v, c) {
                  var o, y = {};
                  if (L)
                    for (var u in v)
                      v.hasOwnProperty(u) && (o = v[u], (!(u in L) || L[u] !== o && (!(u in y) || y[u] !== o)) && (r(L[u]) === "object" && L[u] !== null ? L[u] = h.mixin(L[u], o, c) : L[u] = c(o)));
                  return L;
                }
              }, {
                key: "clone",
                value: function(L) {
                  if (!L || r(L) !== "object")
                    return L;
                  var v;
                  if (L instanceof Array) {
                    v = [];
                    for (var c = 0, o = L.length; c < o; ++c)
                      c in L && v.push(h.clone(L[c]));
                  } else
                    v = {};
                  return h.mixin(v, L, h.clone);
                }
              }, {
                key: "addAditionalQueryParameterToUrl",
                value: function(L, v) {
                  try {
                    if (!v || v.length === 0)
                      return L;
                    var c = new URL(L);
                    return v.forEach(function(o) {
                      o.key && o.value && c.searchParams.set(o.key, o.value);
                    }), c.href;
                  } catch {
                    return L;
                  }
                }
              }, {
                key: "parseHttpHeaders",
                value: function(L) {
                  var v = {};
                  if (!L)
                    return v;
                  for (var c = L.trim().split(`\r
`), o = 0, y = c.length; o < y; o++) {
                    var u = c[o], A = u.indexOf(": ");
                    A > 0 && (v[u.substring(0, A)] = u.substring(A + 2));
                  }
                  return v;
                }
              }, {
                key: "generateUuid",
                value: function() {
                  var L = (/* @__PURE__ */ new Date()).getTime(), v = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                    var o = (L + Math.random() * 16) % 16 | 0;
                    return L = Math.floor(L / 16), (c == "x" ? o : o & 3 | 8).toString(16);
                  });
                  return v;
                }
              }, {
                key: "generateHashCode",
                value: function(L) {
                  var v = 0;
                  if (L.length === 0)
                    return v;
                  for (var c = 0; c < L.length; c++) {
                    var o = L.charCodeAt(c);
                    v = (v << 5) - v + o, v |= 0;
                  }
                  return v;
                }
                /**
                 * Compares both urls and returns a relative url (target relative to original)
                 * @param {string} original
                 * @param {string} target
                 * @return {string|*}
                 */
              }, {
                key: "getRelativeUrl",
                value: function(L, v) {
                  try {
                    var c = new URL(L), o = new URL(v);
                    if (c.protocol = o.protocol, c.origin !== o.origin)
                      return v;
                    var y = n().relative(c.pathname.substr(0, c.pathname.lastIndexOf("/")), o.pathname.substr(0, o.pathname.lastIndexOf("/"))), u = y.length === 0 ? 1 : 0;
                    return y += o.pathname.substr(o.pathname.lastIndexOf("/") + u, o.pathname.length - 1), o.pathname.length < y.length ? o.pathname : y;
                  } catch {
                    return v;
                  }
                }
              }, {
                key: "parseUserAgent",
                value: function() {
                  var L = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                  try {
                    var v = L === null && typeof navigator < "u" ? navigator.userAgent.toLowerCase() : "";
                    return (0, i.UAParser)(v);
                  } catch {
                    return {};
                  }
                }
              }]), h;
            }();
            const S = T;
          }
        ),
        /***/
        "./src/core/Version.js": (
          /*!*****************************!*\
            !*** ./src/core/Version.js ***!
            \*****************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              getVersionString: () => (
                /* binding */
                n
              )
              /* harmony export */
            });
            var g = "4.6.0";
            function n() {
              return g;
            }
          }
        ),
        /***/
        "./src/core/errors/Errors.js": (
          /*!***********************************!*\
            !*** ./src/core/errors/Errors.js ***!
            \***********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ./ErrorsBase */
              "./src/core/errors/ErrorsBase.js"
            );
            function n(c) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(y) {
                return typeof y;
              } : n = function(y) {
                return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
              }, n(c);
            }
            function i(c, o) {
              if (!(c instanceof o))
                throw new TypeError("Cannot call a class as a function");
            }
            function r(c, o) {
              if (typeof o != "function" && o !== null)
                throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(o && o.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), o && l(c, o);
            }
            function l(c, o) {
              return l = Object.setPrototypeOf || function(u, A) {
                return u.__proto__ = A, u;
              }, l(c, o);
            }
            function d(c) {
              var o = S();
              return function() {
                var u = h(c), A;
                if (o) {
                  var I = h(this).constructor;
                  A = Reflect.construct(u, arguments, I);
                } else
                  A = u.apply(this, arguments);
                return t(this, A);
              };
            }
            function t(c, o) {
              return o && (n(o) === "object" || typeof o == "function") ? o : T(c);
            }
            function T(c) {
              if (c === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return c;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function h(c) {
              return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, h(c);
            }
            var _ = /* @__PURE__ */ function(c) {
              r(y, c);
              var o = d(y);
              function y() {
                var u;
                return i(this, y), u = o.call(this), u.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE = 10, u.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE = 11, u.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE = 12, u.SEGMENT_BASE_LOADER_ERROR_CODE = 15, u.TIME_SYNC_FAILED_ERROR_CODE = 16, u.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE = 17, u.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE = 18, u.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE = 19, u.APPEND_ERROR_CODE = 20, u.REMOVE_ERROR_CODE = 21, u.DATA_UPDATE_FAILED_ERROR_CODE = 22, u.CAPABILITY_MEDIASOURCE_ERROR_CODE = 23, u.CAPABILITY_MEDIAKEYS_ERROR_CODE = 24, u.DOWNLOAD_ERROR_ID_MANIFEST_CODE = 25, u.DOWNLOAD_ERROR_ID_SIDX_CODE = 26, u.DOWNLOAD_ERROR_ID_CONTENT_CODE = 27, u.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE = 28, u.DOWNLOAD_ERROR_ID_XLINK_CODE = 29, u.MANIFEST_ERROR_ID_PARSE_CODE = 31, u.MANIFEST_ERROR_ID_NOSTREAMS_CODE = 32, u.TIMED_TEXT_ERROR_ID_PARSE_CODE = 33, u.MANIFEST_ERROR_ID_MULTIPLEXED_CODE = 34, u.MEDIASOURCE_TYPE_UNSUPPORTED_CODE = 35, u.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE = "parsing failed for ", u.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading manifest: ", u.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading Xlink element: ", u.SEGMENTS_UPDATE_FAILED_ERROR_MESSAGE = "Segments update failed", u.SEGMENTS_UNAVAILABLE_ERROR_MESSAGE = "no segments are available yet", u.SEGMENT_BASE_LOADER_ERROR_MESSAGE = "error loading segment ranges from sidx", u.TIME_SYNC_FAILED_ERROR_MESSAGE = "Failed to synchronize client and server time", u.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE = "request is null", u.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE = "Failed to resolve a valid URL", u.APPEND_ERROR_MESSAGE = "chunk is not defined", u.REMOVE_ERROR_MESSAGE = "Removing data from the SourceBuffer", u.DATA_UPDATE_FAILED_ERROR_MESSAGE = "Data update failed", u.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE = "mediasource is not supported", u.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE = "mediakeys is not supported", u.TIMED_TEXT_ERROR_MESSAGE_PARSE = "parsing error :", u.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE = "Error creating source buffer of type : ", u;
              }
              return y;
            }(g.default), L = new _();
            const v = L;
          }
        ),
        /***/
        "./src/core/errors/ErrorsBase.js": (
          /*!***************************************!*\
            !*** ./src/core/errors/ErrorsBase.js ***!
            \***************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            function g(d, t) {
              if (!(d instanceof t))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(d, t) {
              for (var T = 0; T < t.length; T++) {
                var S = t[T];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(d, S.key, S);
              }
            }
            function i(d, t, T) {
              return t && n(d.prototype, t), T && n(d, T), d;
            }
            var r = /* @__PURE__ */ function() {
              function d() {
                g(this, d);
              }
              return i(d, [{
                key: "extend",
                value: function(T, S) {
                  if (T) {
                    var h = S ? S.override : !1, _ = S ? S.publicOnly : !1;
                    for (var L in T)
                      !T.hasOwnProperty(L) || this[L] && !h || _ && T[L].indexOf("public_") === -1 || (this[L] = T[L]);
                  }
                }
              }]), d;
            }();
            const l = r;
          }
        ),
        /***/
        "./src/core/events/CoreEvents.js": (
          /*!***************************************!*\
            !*** ./src/core/events/CoreEvents.js ***!
            \***************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var g = e(
              /*! ./EventsBase */
              "./src/core/events/EventsBase.js"
            );
            function n(v) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(o) {
                return typeof o;
              } : n = function(o) {
                return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
              }, n(v);
            }
            function i(v, c) {
              if (!(v instanceof c))
                throw new TypeError("Cannot call a class as a function");
            }
            function r(v, c) {
              if (typeof c != "function" && c !== null)
                throw new TypeError("Super expression must either be null or a function");
              v.prototype = Object.create(c && c.prototype, { constructor: { value: v, writable: !0, configurable: !0 } }), c && l(v, c);
            }
            function l(v, c) {
              return l = Object.setPrototypeOf || function(y, u) {
                return y.__proto__ = u, y;
              }, l(v, c);
            }
            function d(v) {
              var c = S();
              return function() {
                var y = h(v), u;
                if (c) {
                  var A = h(this).constructor;
                  u = Reflect.construct(y, arguments, A);
                } else
                  u = y.apply(this, arguments);
                return t(this, u);
              };
            }
            function t(v, c) {
              return c && (n(c) === "object" || typeof c == "function") ? c : T(v);
            }
            function T(v) {
              if (v === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return v;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function h(v) {
              return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
              }, h(v);
            }
            var _ = /* @__PURE__ */ function(v) {
              r(o, v);
              var c = d(o);
              function o() {
                var y;
                return i(this, o), y = c.call(this), y.ATTEMPT_BACKGROUND_SYNC = "attemptBackgroundSync", y.BUFFERING_COMPLETED = "bufferingCompleted", y.BUFFER_CLEARED = "bufferCleared", y.BYTES_APPENDED_END_FRAGMENT = "bytesAppendedEndFragment", y.BUFFER_REPLACEMENT_STARTED = "bufferReplacementStarted", y.CHECK_FOR_EXISTENCE_COMPLETED = "checkForExistenceCompleted", y.CMSD_STATIC_HEADER = "cmsdStaticHeader", y.CURRENT_TRACK_CHANGED = "currentTrackChanged", y.DATA_UPDATE_COMPLETED = "dataUpdateCompleted", y.INBAND_EVENTS = "inbandEvents", y.INITIAL_STREAM_SWITCH = "initialStreamSwitch", y.INIT_FRAGMENT_LOADED = "initFragmentLoaded", y.INIT_FRAGMENT_NEEDED = "initFragmentNeeded", y.INTERNAL_MANIFEST_LOADED = "internalManifestLoaded", y.ORIGINAL_MANIFEST_LOADED = "originalManifestLoaded", y.LOADING_COMPLETED = "loadingCompleted", y.LOADING_PROGRESS = "loadingProgress", y.LOADING_DATA_PROGRESS = "loadingDataProgress", y.LOADING_ABANDONED = "loadingAborted", y.MANIFEST_UPDATED = "manifestUpdated", y.MEDIA_FRAGMENT_LOADED = "mediaFragmentLoaded", y.MEDIA_FRAGMENT_NEEDED = "mediaFragmentNeeded", y.QUOTA_EXCEEDED = "quotaExceeded", y.SEGMENT_LOCATION_BLACKLIST_ADD = "segmentLocationBlacklistAdd", y.SEGMENT_LOCATION_BLACKLIST_CHANGED = "segmentLocationBlacklistChanged", y.SERVICE_LOCATION_BLACKLIST_ADD = "serviceLocationBlacklistAdd", y.SERVICE_LOCATION_BLACKLIST_CHANGED = "serviceLocationBlacklistChanged", y.SET_FRAGMENTED_TEXT_AFTER_DISABLED = "setFragmentedTextAfterDisabled", y.SET_NON_FRAGMENTED_TEXT = "setNonFragmentedText", y.SOURCE_BUFFER_ERROR = "sourceBufferError", y.STREAMS_COMPOSED = "streamsComposed", y.STREAM_BUFFERING_COMPLETED = "streamBufferingCompleted", y.STREAM_REQUESTING_COMPLETED = "streamRequestingCompleted", y.TEXT_TRACKS_QUEUE_INITIALIZED = "textTracksQueueInitialized", y.TIME_SYNCHRONIZATION_COMPLETED = "timeSynchronizationComplete", y.UPDATE_TIME_SYNC_OFFSET = "updateTimeSyncOffset", y.URL_RESOLUTION_FAILED = "urlResolutionFailed", y.VIDEO_CHUNK_RECEIVED = "videoChunkReceived", y.WALLCLOCK_TIME_UPDATED = "wallclockTimeUpdated", y.XLINK_ELEMENT_LOADED = "xlinkElementLoaded", y.XLINK_READY = "xlinkReady", y.SEEK_TARGET = "seekTarget", y.SETTING_UPDATED_LIVE_DELAY = "settingUpdatedLiveDelay", y.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT = "settingUpdatedLiveDelayFragmentCount", y.SETTING_UPDATED_CATCHUP_ENABLED = "settingUpdatedCatchupEnabled", y.SETTING_UPDATED_PLAYBACK_RATE_MIN = "settingUpdatedPlaybackRateMin", y.SETTING_UPDATED_PLAYBACK_RATE_MAX = "settingUpdatedPlaybackRateMax", y;
              }
              return o;
            }(g.default);
            const L = _;
          }
        ),
        /***/
        "./src/core/events/Events.js": (
          /*!***********************************!*\
            !*** ./src/core/events/Events.js ***!
            \***********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ./CoreEvents */
              "./src/core/events/CoreEvents.js"
            );
            function n(c) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(y) {
                return typeof y;
              } : n = function(y) {
                return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
              }, n(c);
            }
            function i(c, o) {
              if (!(c instanceof o))
                throw new TypeError("Cannot call a class as a function");
            }
            function r(c, o) {
              if (typeof o != "function" && o !== null)
                throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(o && o.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), o && l(c, o);
            }
            function l(c, o) {
              return l = Object.setPrototypeOf || function(u, A) {
                return u.__proto__ = A, u;
              }, l(c, o);
            }
            function d(c) {
              var o = S();
              return function() {
                var u = h(c), A;
                if (o) {
                  var I = h(this).constructor;
                  A = Reflect.construct(u, arguments, I);
                } else
                  A = u.apply(this, arguments);
                return t(this, A);
              };
            }
            function t(c, o) {
              return o && (n(o) === "object" || typeof o == "function") ? o : T(c);
            }
            function T(c) {
              if (c === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return c;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function h(c) {
              return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, h(c);
            }
            var _ = /* @__PURE__ */ function(c) {
              r(y, c);
              var o = d(y);
              function y() {
                return i(this, y), o.apply(this, arguments);
              }
              return y;
            }(g.default), L = new _();
            const v = L;
          }
        ),
        /***/
        "./src/core/events/EventsBase.js": (
          /*!***************************************!*\
            !*** ./src/core/events/EventsBase.js ***!
            \***************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            function g(d, t) {
              if (!(d instanceof t))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(d, t) {
              for (var T = 0; T < t.length; T++) {
                var S = t[T];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(d, S.key, S);
              }
            }
            function i(d, t, T) {
              return t && n(d.prototype, t), T && n(d, T), d;
            }
            var r = /* @__PURE__ */ function() {
              function d() {
                g(this, d);
              }
              return i(d, [{
                key: "extend",
                value: function(T, S) {
                  if (T) {
                    var h = S ? S.override : !1, _ = S ? S.publicOnly : !1;
                    for (var L in T)
                      !T.hasOwnProperty(L) || this[L] && !h || _ && T[L].indexOf("public_") === -1 || (this[L] = T[L]);
                  }
                }
              }]), d;
            }();
            const l = r;
          }
        ),
        /***/
        "./src/dash/DashAdapter.js": (
          /*!*********************************!*\
            !*** ./src/dash/DashAdapter.js ***!
            \*********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ./constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), n = e(
              /*! ./vo/RepresentationInfo */
              "./src/dash/vo/RepresentationInfo.js"
            ), i = e(
              /*! ./vo/MediaInfo */
              "./src/dash/vo/MediaInfo.js"
            ), r = e(
              /*! ./vo/StreamInfo */
              "./src/dash/vo/StreamInfo.js"
            ), l = e(
              /*! ./vo/ManifestInfo */
              "./src/dash/vo/ManifestInfo.js"
            ), d = e(
              /*! ./vo/Event */
              "./src/dash/vo/Event.js"
            ), t = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), T = e(
              /*! ./models/DashManifestModel */
              "./src/dash/models/DashManifestModel.js"
            ), S = e(
              /*! ./models/PatchManifestModel */
              "./src/dash/models/PatchManifestModel.js"
            ), h = e(
              /*! bcp-47-normalize */
              "./node_modules/bcp-47-normalize/index.js"
            ), _ = /* @__PURE__ */ e.n(h);
            function L() {
              var c, o, y, u, A, I, M, E = this.context, N = "urn:dvb:dash:profile:dvb-dash:2014";
              function C() {
                o = (0, T.default)(E).getInstance(), y = (0, S.default)(E).getInstance(), Ge();
              }
              function b(ve) {
                ve && (ve.constants && (I = ve.constants), ve.cea608parser && (M = ve.cea608parser), ve.errHandler && o.setConfig({
                  errHandler: ve.errHandler
                }), ve.BASE64 && o.setConfig({
                  BASE64: ve.BASE64
                }));
              }
              function w(ve) {
                if (ve) {
                  var me = new n.default(), Ie = ve.adaptation.period.mpd.manifest.Period_asArray[ve.adaptation.period.index].AdaptationSet_asArray[ve.adaptation.index], we = o.getRepresentationFor(ve.index, Ie);
                  return me.id = ve.id, me.quality = ve.index, me.bandwidth = o.getBandwidth(we), me.fragmentDuration = ve.segmentDuration || (ve.segments && ve.segments.length > 0 ? ve.segments[0].duration : NaN), me.MSETimeOffset = ve.MSETimeOffset, me.mediaInfo = it(ve.adaptation), me;
                } else
                  return null;
              }
              function V(ve, me) {
                if (u.length === 0 || !ve)
                  return null;
                var Ie = nt(ve, u);
                if (!Ie)
                  return null;
                var we = o.getAdaptationsForPeriod(Ie), Ue = H(ve.index, me, ve);
                if (!Ue)
                  return null;
                var $e = o.getIndexForAdaptation(Ue, u[0].mpd.manifest, ve.index);
                return it(we[$e]);
              }
              function J(ve) {
                return o.getRolesForAdaptation(ve).filter(function(me) {
                  return me.value === g.default.MAIN;
                })[0];
              }
              function H(ve, me, Ie) {
                var we = o.getAdaptationsForType(u[0].mpd.manifest, ve, me);
                if (!we || we.length === 0)
                  return null;
                if (we.length > 1 && Ie) {
                  var Ue = ie(Ie, me);
                  if (A[Ie.id] && A[Ie.id][me]) {
                    for (var $e = 0, at = we.length; $e < at; $e++)
                      if (z(A[Ie.id][me], Ue[$e]))
                        return we[$e];
                  }
                  for (var et = 0, Mt = we.length; et < Mt; et++)
                    if (J(we[et]))
                      return we[et];
                }
                return we[0];
              }
              function z(ve, me) {
                if (!ve || !me)
                  return !1;
                var Ie = ve.id === me.id, we = ve.codec === me.codec, Ue = ve.viewpoint === me.viewpoint, $e = ve.lang === me.lang, at = ve.roles.toString() === me.roles.toString(), et = ve.accessibility.toString() === me.accessibility.toString(), Mt = ve.audioChannelConfiguration.toString() === me.audioChannelConfiguration.toString();
                return Ie && we && Ue && $e && at && et && Mt;
              }
              function Z(ve, me, Ie, we, Ue, $e) {
                var at = [], et, Mt, Lt, bt, Ae, ze;
                if (!we || we.length === 0)
                  return [];
                var qe = o.getAdaptationsForPeriod(me);
                for (bt = 0, ze = we.length; bt < ze; bt++)
                  if (et = we[bt], Lt = o.getIndexForAdaptation(et, ve, Ie.index), Mt = it(qe[Lt]), $e) {
                    var _t = Mt.accessibility.length;
                    for (Ae = 0; Ae < _t; Ae++)
                      if (Mt) {
                        var dt = Mt.accessibility[Ae];
                        if (dt.indexOf("cea-608:") === 0) {
                          var Tt = dt.substring(8), wt = Tt.split(";");
                          if (wt[0].substring(0, 2) === "CC")
                            for (Ae = 0; Ae < wt.length; Ae++)
                              Mt || (Mt = it.call(this, qe[Lt])), De(Mt, wt[Ae].substring(0, 3), wt[Ae].substring(4)), at.push(Mt), Mt = null;
                          else
                            for (Ae = 0; Ae < wt.length; Ae++)
                              Mt || (Mt = it.call(this, qe[Lt])), De(Mt, "CC" + (Ae + 1), wt[Ae]), at.push(Mt), Mt = null;
                        } else
                          dt.indexOf("cea-608") === 0 && (De(Mt, I.CC1, "eng"), at.push(Mt), Mt = null);
                      }
                  } else
                    Ue === I.IMAGE ? (Ye(Mt), at.push(Mt), Mt = null) : Mt && at.push(Mt);
                return at;
              }
              function ie(ve, me, Ie) {
                var we = u, Ue = Ie, $e = [];
                if (Ue)
                  st(), we = p(Ue);
                else if (u.length > 0)
                  Ue = u[0].mpd.manifest;
                else
                  return $e;
                var at = nt(ve, we), et = o.getAdaptationsForType(Ue, ve ? ve.index : null, me);
                return $e = Z(Ue, at, ve, et, me), me === I.TEXT && (et = o.getAdaptationsForType(Ue, ve ? ve.index : null, I.VIDEO), $e = $e.concat(Z(Ue, at, ve, et, me, !0))), $e;
              }
              function K(ve) {
                if (!ve)
                  return null;
                st(), u = p(ve);
              }
              function Y(ve, me) {
                var Ie = [], we = u;
                if (ve && (st(), we = p(ve)), we.length > 0) {
                  (!me || me > we.length) && (me = we.length);
                  for (var Ue = 0; Ue < me; Ue++)
                    Ie.push(Ke(we[Ue]));
                }
                return Ie;
              }
              function ne(ve, me) {
                var Ie, we, Ue = nt(ve, u);
                return Ie = me ? me.id : null, u.length > 0 && Ue && (we = Ie ? o.getAdaptationForId(Ie, u[0].mpd.manifest, Ue.index) : o.getAdaptationForIndex(me ? me.index : null, u[0].mpd.manifest, Ue.index)), we;
              }
              function ae(ve, me) {
                var Ie, we, Ue = nt(ve, u);
                return Ie = me ? me.id : null, u.length > 0 && Ue && (we = Ie ? o.getAdaptationForId(Ie, u[0].mpd.manifest, Ue.index) : o.getAdaptationForIndex(me ? me.index : null, u[0].mpd.manifest, Ue.index)), we ? o.getProducerReferenceTimesForAdaptation(we) : [];
              }
              function fe(ve) {
                try {
                  return o.getEssentialPropertiesForRepresentation(ve);
                } catch {
                  return [];
                }
              }
              function Q(ve) {
                return o.getRealPeriodForIndex(ve, u[0].mpd.manifest);
              }
              function oe(ve) {
                var me, Ie = Ze(ve);
                return me = o.getRepresentationsForAdaptation(Ie), me;
              }
              function de(ve, me, Ie, we) {
                try {
                  if (!ve || !me || isNaN(Ie) || !we)
                    return null;
                  var Ue = ve.scheme_id_uri, $e = ve.value;
                  if (!me[Ue + "/" + $e])
                    return null;
                  var at = new d.default(), et = ve.timescale || 1, Mt = we.adaptation.period.start, Lt = me[Ue + "/" + $e], bt = isNaN(we.presentationTimeOffset) ? isNaN(Lt.presentationTimeOffset) ? 0 : Lt.presentationTimeOffset : we.presentationTimeOffset, Ae = ve.presentation_time_delta / et, ze;
                  ve.version === 0 ? ze = Mt + Ie - bt + Ae : ze = Mt - bt + Ae;
                  var qe = ve.event_duration / et, _t = ve.id, dt = ve.message_data;
                  return at.eventStream = Lt, at.eventStream.value = $e, at.eventStream.timescale = et, at.duration = qe, at.id = _t, at.calculatedPresentationTime = ze, at.messageData = dt, at.presentationTimeDelta = Ae, at;
                } catch {
                  return null;
                }
              }
              function Me(ve, me, Ie) {
                var we = [];
                if (u.length > 0) {
                  var Ue = u[0].mpd.manifest;
                  if (ve instanceof r.default) {
                    var $e = nt(ve, u);
                    we = o.getEventsForPeriod($e);
                  } else if (ve instanceof i.default) {
                    var at = nt(Ie, u);
                    we = o.getEventStreamForAdaptationSet(Ue, Ze(ve), at);
                  } else if (ve instanceof n.default) {
                    var et = nt(Ie, u);
                    we = o.getEventStreamForRepresentation(Ue, me, et);
                  }
                }
                return we;
              }
              function ge(ve, me, Ie) {
                A[ve] = A[ve] || {}, A[ve][me] = A[ve][me] || {}, A[ve][me] = Ie;
              }
              function se(ve) {
                return o.getIsText(ve);
              }
              function ee() {
                var ve = je();
                return o.getUTCTimingSources(ve);
              }
              function re() {
                var ve = u.length > 0 ? u[0].mpd : null;
                return o.getSuggestedPresentationDelay(ve);
              }
              function ue(ve) {
                var me = P(ve);
                return o.getAvailabilityStartTime(me);
              }
              function te(ve) {
                var me = je(ve);
                return o.getIsDynamic(me);
              }
              function O(ve) {
                var me = je(ve);
                return o.getDuration(me);
              }
              function p(ve) {
                var me = P(ve);
                return o.getRegularPeriods(me);
              }
              function P(ve) {
                var me = je(ve);
                return o.getMpd(me);
              }
              function k(ve) {
                return o.getContentSteering(ve);
              }
              function X(ve) {
                return o.getLocation(ve);
              }
              function F(ve) {
                var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return o.getManifestUpdatePeriod(ve, me);
              }
              function x(ve) {
                return o.getPublishTime(ve);
              }
              function W(ve) {
                var me = o.getPatchLocation(ve), Ie = o.getPublishTime(ve);
                if (!me || !Ie)
                  return null;
                if (me.hasOwnProperty("ttl") && Ie) {
                  var we = parseFloat(me.ttl) * 1e3;
                  if (Ie.getTime() + we <= (/* @__PURE__ */ new Date()).getTime())
                    return null;
                }
                return me.__text;
              }
              function $(ve) {
                return o.hasProfile(ve, N);
              }
              function ce(ve) {
                return y.getIsPatch(ve);
              }
              function le(ve) {
                return o.getBaseURLsFromElement(ve);
              }
              function q() {
                return o.getRepresentationSortFunction();
              }
              function _e(ve, me, Ie) {
                return o.getCodec(ve, me, Ie);
              }
              function Ee(ve, me) {
                var Ie, we = Et(me);
                return Ie = xt(we, ve), Ie ? Ie.bandwidth : null;
              }
              function Te(ve, me) {
                var Ie = Et(me);
                return ht(Ie, ve);
              }
              function Ce(ve, me) {
                var Ie = Et(me);
                return Xe(Ie, ve);
              }
              function xe(ve) {
                if (!ve || u.length === 0)
                  return null;
                var me = u.filter(function(Ie) {
                  return Ie.id === ve;
                });
                return me && me.length > 0 ? me[0] : null;
              }
              function be(ve, me) {
                return o.getIsTypeOf(ve, me);
              }
              function Ge() {
                u = [], A = {};
              }
              function Pe(ve, me) {
                var Ie = o.getId(ve), we = y.getMpdId(me), Ue = o.getPublishTime(ve), $e = y.getPublishTime(me), at = y.getOriginalPublishTime(me);
                return !!(Ie && we && Ie == we && Ue && at && Ue.getTime() == at.getTime() && $e && Ue.getTime() < $e.getTime());
              }
              function Le(ve, me) {
                y.getPatchOperations(me).forEach(function(Ie) {
                  var we = Ie.getMpdTarget(ve);
                  if (we !== null) {
                    var Ue = we.name, $e = we.target, at = we.leaf;
                    if (Ie.xpath.findsAttribute()) {
                      switch (Ie.action) {
                        case "add":
                        case "replace":
                          $e[Ue] = Ie.value;
                          break;
                        case "remove":
                          delete $e[Ue];
                          break;
                      }
                      return;
                    }
                    var et = ($e[Ue + "_asArray"] || []).indexOf(at), Mt = Ie.position === "prepend" || Ie.position === "before";
                    if ((Ie.action === "remove" || Ie.action === "replace") && (delete $e[Ue], et != -1)) {
                      var Lt = $e[Ue + "_asArray"];
                      Lt.splice(et, 1), Lt.length > 1 ? $e[Ue] = Lt : Lt.length == 1 ? $e[Ue] = Lt[0] : delete $e[Ue + "_asArray"];
                    }
                    (Ie.action === "add" || Ie.action === "replace") && Object.keys(Ie.value).forEach(function(bt) {
                      var Ae = Ie.value[bt], ze = $e[bt + "_asArray"] || [];
                      if (ze.length === 0 && $e[bt] && ze.push($e[bt]), ze.length === 0)
                        ze = Ae;
                      else {
                        var qe = ze.length;
                        bt == Ue && et != -1 ? qe = et + (Mt ? 0 : 1) + (Ie.action == "replace" ? -1 : 0) : qe = Mt ? 0 : ze.length, ze.splice.apply(ze, [qe, 0].concat(Ae));
                      }
                      $e[bt + "_asArray"] = ze, $e[bt] = ze.length == 1 ? ze[0] : ze;
                    });
                  }
                });
              }
              function je(ve) {
                return ve || (u.length > 0 ? u[0].mpd.manifest : null);
              }
              function Ze(ve) {
                try {
                  var me = nt(ve.streamInfo, u), Ie = o.getAdaptationsForPeriod(me);
                  return !ve || !ve.streamInfo || ve.streamInfo.id === void 0 || !Ie ? null : Ie[ve.index];
                } catch {
                  return null;
                }
              }
              function nt(ve, me) {
                for (var Ie = me.length, we = 0; we < Ie; we++) {
                  var Ue = me[we];
                  if (ve && ve.id === Ue.id)
                    return Ue;
                }
                return null;
              }
              function it(ve) {
                if (!ve)
                  return null;
                var me = new i.default(), Ie = ve.period.mpd.manifest.Period_asArray[ve.period.index].AdaptationSet_asArray[ve.index], we;
                if (me.id = ve.id, me.index = ve.index, me.type = ve.type, me.streamInfo = Ke(ve.period), me.representationCount = o.getRepresentationCount(Ie), me.labels = o.getLabelsForAdaptation(Ie), me.lang = o.getLanguageForAdaptation(Ie), we = o.getViewpointForAdaptation(Ie), me.viewpoint = we ? we.value : void 0, me.accessibility = o.getAccessibilityForAdaptation(Ie).map(function(at) {
                  var et = at.value, Mt = et;
                  return at.schemeIdUri && at.schemeIdUri.search("cea-608") >= 0 && typeof M < "u" && (et ? Mt = "cea-608:" + et : Mt = "cea-608", me.embeddedCaptions = !0), Mt;
                }), me.audioChannelConfiguration = o.getAudioChannelConfigurationForAdaptation(Ie).map(function(at) {
                  return at.value;
                }), me.audioChannelConfiguration.length === 0 && Array.isArray(Ie.Representation_asArray) && Ie.Representation_asArray.length > 0 && (me.audioChannelConfiguration = o.getAudioChannelConfigurationForRepresentation(Ie.Representation_asArray[0]).map(function(at) {
                  return at.value;
                })), me.roles = o.getRolesForAdaptation(Ie).map(function(at) {
                  return at.value;
                }), me.codec = o.getCodec(Ie), me.mimeType = o.getMimeType(Ie), me.contentProtection = o.getContentProtectionData(Ie), me.bitrateList = o.getBitrateListForAdaptation(Ie), me.selectionPriority = o.getSelectionPriority(Ie), me.contentProtection) {
                  var Ue = me.contentProtection.map(function(at) {
                    return o.getKID(at);
                  }).filter(function(at) {
                    return at !== null;
                  });
                  if (Ue.length) {
                    var $e = Ue[0];
                    me.contentProtection.forEach(function(at) {
                      at.keyId = $e;
                    });
                  }
                }
                return me.isText = o.getIsText(Ie), me.supplementalProperties = o.getSupplementalProperties(Ie), me.isFragmented = o.getIsFragmented(Ie), me.isEmbedded = !1, me;
              }
              function De(ve, me, Ie) {
                ve.id = me, ve.index = 100 + parseInt(me.substring(2, 3)), ve.type = I.TEXT, ve.codec = "cea-608-in-SEI", ve.isEmbedded = !0, ve.isFragmented = !1, ve.lang = _()(Ie), ve.roles = ["caption"];
              }
              function Ye(ve) {
                ve.type = I.IMAGE;
              }
              function Ke(ve) {
                var me = new r.default(), Ie = 1;
                return me.id = ve.id, me.index = ve.index, me.start = ve.start, me.duration = ve.duration, me.manifestInfo = tt(ve.mpd), me.isLast = ve.mpd.manifest.Period_asArray.length === 1 || Math.abs(me.start + me.duration - me.manifestInfo.duration) < Ie, me;
              }
              function tt(ve) {
                var me = new l.default();
                return me.dvrWindowSize = ve.timeShiftBufferDepth, me.loadedTime = ve.manifest.loadedTime, me.availableFrom = ve.availabilityStartTime, me.minBufferTime = ve.manifest.minBufferTime, me.maxFragmentDuration = ve.maxSegmentDuration, me.duration = o.getDuration(ve.manifest), me.isDynamic = o.getIsDynamic(ve.manifest), me.serviceDescriptions = o.getServiceDescriptions(ve.manifest), me.protocol = ve.manifest.protocol, me;
              }
              function st() {
                if (!I)
                  throw new Error("setConfig function has to be called previously");
              }
              function Et(ve) {
                return u.length > 0 ? u[0].mpd.manifest.Period_asArray[ve] : null;
              }
              function ht(ve, me) {
                var Ie = xt(ve, me, !0);
                return Ie !== null ? Ie : -1;
              }
              function xt(ve, me, Ie) {
                var we, Ue, $e, at, et, Mt;
                if (ve) {
                  for (Ue = ve.AdaptationSet_asArray, et = 0; et < Ue.length; et = et + 1)
                    for (we = Ue[et], at = we.Representation_asArray, Mt = 0; Mt < at.length; Mt = Mt + 1)
                      if ($e = at[Mt], me === $e.id)
                        return Ie ? Mt : $e;
                }
                return null;
              }
              function Xe(ve, me) {
                var Ie, we, Ue, $e;
                if (!ve || !me)
                  return -1;
                for (we = ve.AdaptationSet_asArray, $e = 0; $e < we.length; $e = $e + 1)
                  if (Ie = we[$e], Ue = Ie.Representation_asArray, o.getIsTypeOf(Ie, me))
                    return Ue.length;
                return -1;
              }
              return c = {
                getBandwidthForRepresentation: Ee,
                getIndexForRepresentation: Te,
                getMaxIndexForBufferType: Ce,
                convertRepresentationToRepresentationInfo: w,
                getStreamsInfo: Y,
                getMediaInfoForType: V,
                getAllMediaInfoForType: ie,
                getAdaptationForType: H,
                getRealAdaptation: ne,
                getProducerReferenceTimes: ae,
                getRealPeriodByIndex: Q,
                getEssentialPropertiesForRepresentation: fe,
                getVoRepresentations: oe,
                getEventsFor: Me,
                getEvent: de,
                getMpd: P,
                setConfig: b,
                updatePeriods: K,
                getIsTextTrack: se,
                getUTCTimingSources: ee,
                getSuggestedPresentationDelay: re,
                getAvailabilityStartTime: ue,
                getIsTypeOf: be,
                getIsDynamic: te,
                getDuration: O,
                getRegularPeriods: p,
                getContentSteering: k,
                getLocation: X,
                getPatchLocation: W,
                getManifestUpdatePeriod: F,
                getPublishTime: x,
                getIsDVB: $,
                getIsPatch: ce,
                getBaseURLsFromElement: le,
                getRepresentationSortFunction: q,
                getCodec: _e,
                getPeriodById: xe,
                setCurrentMediaInfo: ge,
                isPatchValid: Pe,
                applyPatchToManifest: Le,
                areMediaInfosEqual: z,
                reset: Ge
              }, C(), c;
            }
            L.__dashjs_factory_name = "DashAdapter";
            const v = t.default.getSingletonFactory(L);
          }
        ),
        /***/
        "./src/dash/DashHandler.js": (
          /*!*********************************!*\
            !*** ./src/dash/DashHandler.js ***!
            \*********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            var g = e(
              /*! ../streaming/vo/FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            ), n = e(
              /*! ../streaming/vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), i = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! ../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), l = e(
              /*! ./utils/SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            ), d = e(
              /*! ./constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), t = 0.5, T = 1e-3;
            function S(_) {
              _ = _ || {};
              var L = _.eventBus, v = _.debug, c = _.urlUtils, o = _.type, y = _.streamInfo, u = _.segmentsController, A = _.timelineConverter, I = _.baseURLController, M, E, N, C, b;
              function w() {
                E = v.getLogger(M), Z(), L.on(r.default.DYNAMIC_TO_STATIC, se, M);
              }
              function V(ee) {
                C = ee, b = !1, u.initialize(ee);
              }
              function J() {
                return y.id;
              }
              function H() {
                return o;
              }
              function z() {
                return y;
              }
              function Z() {
                N = null;
              }
              function ie() {
                Z(), L.off(r.default.DYNAMIC_TO_STATIC, se, M);
              }
              function K(ee, re, ue) {
                var te = I.resolve(ue.path), O, p;
                return !te || re === te.url || !c.isRelative(re) ? O = re : (O = te.url, p = te.serviceLocation, re && (O = c.resolve(re, O))), c.isRelative(O) ? !1 : (ee.url = O, ee.serviceLocation = p, !0);
              }
              function Y(ee, re) {
                return re ? ne(ee, re, H()) : null;
              }
              function ne(ee, re, ue) {
                var te = new g.default(), O = re.adaptation.period, p = O.start;
                if (te.mediaType = ue, te.type = n.HTTPRequest.INIT_SEGMENT_TYPE, te.range = re.range, te.availabilityStartTime = A.calcAvailabilityStartTimeFromPresentationTime(p, re, C), te.availabilityEndTime = A.calcAvailabilityEndTimeFromPresentationTime(p + O.duration, re, C), te.quality = re.index, te.mediaInfo = ee, te.representationId = re.id, K(te, re.initialization, re))
                  return te.url = (0, l.replaceTokenForTemplate)(te.url, "Bandwidth", re.bandwidth), te;
              }
              function ae(ee, re) {
                if (re == null)
                  return null;
                var ue = new g.default(), te = re.representation, O = te.adaptation.period.mpd.manifest.Period_asArray[te.adaptation.period.index].AdaptationSet_asArray[te.adaptation.index].Representation_asArray[te.index].bandwidth, p = re.media;
                if (p = (0, l.replaceTokenForTemplate)(p, "Number", re.replacementNumber), p = (0, l.replaceTokenForTemplate)(p, "Time", re.replacementTime), p = (0, l.replaceTokenForTemplate)(p, "Bandwidth", O), p = (0, l.replaceIDForTemplate)(p, te.id), p = (0, l.unescapeDollarsInTemplate)(p), ue.mediaType = H(), ue.type = n.HTTPRequest.MEDIA_SEGMENT_TYPE, ue.range = re.mediaRange, ue.startTime = re.presentationStartTime, ue.mediaStartTime = re.mediaStartTime, ue.duration = re.duration, ue.timescale = te.timescale, ue.availabilityStartTime = re.availabilityStartTime, ue.availabilityEndTime = re.availabilityEndTime, ue.availabilityTimeComplete = te.availabilityTimeComplete, ue.wallStartTime = re.wallStartTime, ue.quality = te.index, ue.index = re.index, ue.mediaInfo = ee, ue.adaptationIndex = te.adaptation.index, ue.representationId = te.id, K(ue, p, te))
                  return ue;
              }
              function fe(ee, re) {
                if (!ee || !N)
                  return !1;
                if (b)
                  return !0;
                if (!isFinite(ee.adaptation.period.duration) || N.presentationStartTime + N.duration > re)
                  return !1;
                if (ee.mediaFinishedInformation && !isNaN(ee.mediaFinishedInformation.numberOfSegments) && !isNaN(N.index) && N.index >= ee.mediaFinishedInformation.numberOfSegments - 1) {
                  if (!C || ee.segmentInfoType === d.default.SEGMENT_TEMPLATE)
                    return !0;
                  if (C && ee.segmentInfoType === d.default.SEGMENT_LIST && ee.adaptation.period.nextPeriodId)
                    return !0;
                }
                return !!(C && ee.adaptation.period.nextPeriodId && ee.segmentInfoType === d.default.SEGMENT_TIMELINE && ee.mediaFinishedInformation && !isNaN(ee.mediaFinishedInformation.mediaTimeOfLastSignaledSegment) && N && !isNaN(N.mediaStartTime) && !isNaN(N.duration) && N.mediaStartTime + N.duration >= ee.mediaFinishedInformation.mediaTimeOfLastSignaledSegment - 0.05);
              }
              function Q(ee, re, ue) {
                var te = null;
                if (!re || !re.segmentInfoType)
                  return te;
                var O = u.getSegmentByTime(re, ue);
                return O && (N = O, E.debug("Index for time " + ue + " is " + O.index), te = ae(ee, O)), te;
              }
              function oe(ee, re) {
                var ue = null, te = N ? N.index + 1 : 0, O = u.getSegmentByIndex(re, te, N ? N.mediaStartTime : -1);
                return O ? (ue = ae(ee, O), ue) : null;
              }
              function de(ee, re) {
                var ue = null;
                if (!re || !re.segmentInfoType)
                  return null;
                var te = N ? N.index + 1 : 0, O = u.getSegmentByIndex(re, te, N ? N.mediaStartTime : -1);
                if (O)
                  ue = ae(ee, O), N = O;
                else {
                  if (C && !b)
                    return E.debug(H() + " No segment found at index: " + te + ". Wait for next loop"), null;
                  b = !0;
                }
                return ue;
              }
              function Me(ee, re, ue, te) {
                try {
                  if (isNaN(ee) || !re || !ue)
                    return NaN;
                  if (ee < 0 && (ee = 0), isNaN(te) && (te = t), Q(re, ue, ee))
                    return ee;
                  if (ue.adaptation.period.start + ue.adaptation.period.duration < ee)
                    return NaN;
                  for (var O = isFinite(ue.adaptation.period.duration) ? ue.adaptation.period.start + ue.adaptation.period.duration : ee + 30, p = Math.min(ee + te, O), P = NaN, k = null; p <= O; ) {
                    var X = null;
                    if (p <= O && (X = Q(re, ue, p)), X) {
                      P = p, k = X;
                      break;
                    }
                    p += te;
                  }
                  if (k) {
                    var F = k.startTime + k.duration;
                    return ee > k.startTime && F - ee > te ? ee : !isNaN(k.startTime) && ee < k.startTime && P > k.startTime ? k.startTime + T : Math.min(F - te, P);
                  }
                  return P;
                } catch {
                  return NaN;
                }
              }
              function ge() {
                return N ? N.index : -1;
              }
              function se() {
                E.debug("Dynamic stream complete"), b = !0;
              }
              return M = {
                initialize: V,
                getStreamId: J,
                getType: H,
                getStreamInfo: z,
                getInitRequest: Y,
                getSegmentRequestForTime: Q,
                getCurrentIndex: ge,
                getNextSegmentRequest: de,
                isLastSegmentRequested: fe,
                reset: ie,
                getNextSegmentRequestIdempotent: oe,
                getValidTimeAheadOfTargetTime: Me
              }, w(), M;
            }
            S.__dashjs_factory_name = "DashHandler";
            const h = i.default.getClassFactory(S);
          }
        ),
        /***/
        "./src/dash/DashMetrics.js": (
          /*!*********************************!*\
            !*** ./src/dash/DashMetrics.js ***!
            \*********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            var g = e(
              /*! ../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../streaming/vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), i = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! ../streaming/constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), l = e(
              /*! ./utils/Round10 */
              "./src/dash/utils/Round10.js"
            ), d = e(
              /*! ../streaming/models/MetricsModel */
              "./src/streaming/models/MetricsModel.js"
            ), t = e(
              /*! ../core/Utils */
              "./src/core/Utils.js"
            ), T = e(
              /*! ../streaming/vo/metrics/PlayList */
              "./src/streaming/vo/metrics/PlayList.js"
            );
            function S(_) {
              _ = _ || {};
              var L = this.context, v, c, o, y, u = _.metricsModel;
              function A() {
                u = u || (0, d.default)(L).getInstance({
                  settings: _.settings
                }), I();
              }
              function I() {
                c = !0, o = null, y = null;
              }
              function M(X) {
                var F = u.getMetricsFor(X, !0);
                return Z(F, r.default.TRACK_SWITCH);
              }
              function E(X, F, x, W, $) {
                u.addRepresentationSwitch(X, F, x, W, $);
              }
              function N(X) {
                var F = u.getMetricsFor(X, !0);
                return Z(F, r.default.BUFFER_STATE);
              }
              function C(X) {
                var F = u.getMetricsFor(X, !0), x = Z(F, r.default.BUFFER_LEVEL);
                return x ? l.default.round10(x.level / 1e3, -3) : 0;
              }
              function b(X, F, x) {
                u.addBufferLevel(X, F, x);
              }
              function w(X, F, x) {
                u.addBufferState(X, F, x);
              }
              function V() {
                u.clearAllCurrentMetrics();
              }
              function J(X) {
                var F = u.getMetricsFor(X, !0);
                if (!F)
                  return null;
                var x = F.HttpList, W = null, $;
                if (!x || x.length <= 0)
                  return null;
                for ($ = x.length - 1; $ >= 0; ) {
                  if (x[$].responsecode) {
                    W = x[$];
                    break;
                  }
                  $--;
                }
                return W;
              }
              function H(X) {
                var F = u.getMetricsFor(X, !0);
                return F ? F.HttpList ? F.HttpList : [] : [];
              }
              function z(X, F, x) {
                u.addRequestsQueue(X, F, x);
              }
              function Z(X, F) {
                if (!X)
                  return null;
                var x = X[F];
                return !x || x.length === 0 ? null : x[x.length - 1];
              }
              function ie() {
                var X = u.getMetricsFor(g.default.VIDEO, !0);
                return Z(X, r.default.DROPPED_FRAMES);
              }
              function K(X) {
                u.addDroppedFrames(g.default.VIDEO, X);
              }
              function Y(X) {
                var F = u.getMetricsFor(X, !0);
                return Z(F, r.default.SCHEDULING_INFO);
              }
              function ne(X, F) {
                u.addSchedulingInfo(X.mediaType, /* @__PURE__ */ new Date(), X.type, X.startTime, X.availabilityStartTime, X.duration, X.quality, X.range, F);
              }
              function ae() {
                var X = u.getMetricsFor(g.default.STREAM);
                return Z(X, r.default.MANIFEST_UPDATE);
              }
              function fe(X) {
                var F = this.getCurrentManifestUpdate();
                u.updateManifestUpdateInfo(F, X);
              }
              function Q(X) {
                if (X) {
                  var F = this.getCurrentManifestUpdate();
                  u.addManifestUpdateStreamInfo(F, X.id, X.index, X.start, X.duration);
                }
              }
              function oe(X) {
                u.addManifestUpdate(g.default.STREAM, X.type, X.requestStartDate, X.requestEndDate);
              }
              function de(X, F, x, W, $, ce) {
                u.addHttpRequest(X.mediaType, null, X.type, X.url, X.quality, F, X.serviceLocation || null, X.range || null, X.requestStartDate, X.firstByteDate, X.requestEndDate, x, X.duration, W, $, X.fileLoaderType, ce);
              }
              function Me(X, F) {
                if (X) {
                  var x = this.getCurrentManifestUpdate();
                  u.addManifestUpdateRepresentationInfo(x, X.id, X.index, X.streamIndex, F, X.presentationTimeOffset, X.startNumber, X.fragmentInfoType);
                }
              }
              function ge(X) {
                var F = X ? u.getMetricsFor(X, !0) : u.getMetricsFor(g.default.VIDEO, !0) || u.getMetricsFor(g.default.AUDIO, !0);
                return Z(F, r.default.DVR_INFO);
              }
              function se(X, F, x, W) {
                u.addDVRInfo(X, F, x, W);
              }
              function ee(X) {
                if (!X)
                  return null;
                var F = {}, x, W, $;
                for (x = H(g.default.STREAM), $ = x.length - 1; $ >= 0; $--)
                  if (W = x[$], W.type === n.HTTPRequest.MPD_TYPE) {
                    F = t.default.parseHttpHeaders(W._responseHeaders);
                    break;
                  }
                var ce = F[X.toLowerCase()];
                return ce === void 0 ? null : ce;
              }
              function re(X, F) {
                if (!F)
                  return null;
                var x = {}, W = J(X);
                W && (x = t.default.parseHttpHeaders(W._responseHeaders));
                var $ = x[F.toLowerCase()];
                return $ === void 0 ? null : $;
              }
              function ue() {
                y && (u.addPlayList(y), y = null);
              }
              function te(X, F) {
                y = new T.PlayList(), y.start = /* @__PURE__ */ new Date(), y.mstart = X, y.starttype = F;
              }
              function O(X, F, x) {
                c === !0 && (c = !1, o = new T.PlayListTrace(), o.representationid = X, o.start = /* @__PURE__ */ new Date(), o.mstart = F, o.playbackspeed = x !== null ? x.toString() : null);
              }
              function p(X) {
                if (o)
                  for (var F in o)
                    o[F] = X[F];
              }
              function P(X, F) {
                if (c === !1 && y && o && o.start) {
                  var x = o.start, W = X.getTime() - x.getTime();
                  o.duration = W, o.stopreason = F, y.trace.push(o), c = !0;
                }
              }
              function k(X) {
                u.addDVBErrors(X);
              }
              return v = {
                getCurrentRepresentationSwitch: M,
                getCurrentBufferState: N,
                getCurrentBufferLevel: C,
                getCurrentHttpRequest: J,
                getHttpRequests: H,
                getCurrentDroppedFrames: ie,
                getCurrentSchedulingInfo: Y,
                getCurrentDVRInfo: ge,
                getCurrentManifestUpdate: ae,
                getLatestFragmentRequestHeaderValueByID: re,
                getLatestMPDRequestHeaderValueByID: ee,
                addRepresentationSwitch: E,
                addDVRInfo: se,
                updateManifestUpdateInfo: fe,
                addManifestUpdateStreamInfo: Q,
                addManifestUpdateRepresentationInfo: Me,
                addManifestUpdate: oe,
                addHttpRequest: de,
                addSchedulingInfo: ne,
                addRequestsQueue: z,
                addBufferLevel: b,
                addBufferState: w,
                addDroppedFrames: K,
                addPlayList: ue,
                addDVBErrors: k,
                createPlaylistMetrics: te,
                createPlaylistTraceMetrics: O,
                updatePlayListTraceMetrics: p,
                pushPlayListTraceMetrics: P,
                clearAllCurrentMetrics: V
              }, A(), v;
            }
            S.__dashjs_factory_name = "DashMetrics";
            const h = i.default.getSingletonFactory(S);
          }
        ),
        /***/
        "./src/dash/SegmentBaseLoader.js": (
          /*!***************************************!*\
            !*** ./src/dash/SegmentBaseLoader.js ***!
            \***************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => t
              /* harmony export */
            });
            var g = e(
              /*! ./vo/Segment */
              "./src/dash/vo/Segment.js"
            ), n = e(
              /*! ../streaming/vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), i = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! ../streaming/vo/FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            ), l = e(
              /*! ../streaming/net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            );
            function d() {
              var T = this.context, S, h, _, L, v, c, o, y, u, A, I, M, E;
              function N() {
                y = (0, l.default)(T).create({
                  errHandler: _,
                  dashMetrics: c,
                  mediaPlayerModel: o,
                  requestModifier: v,
                  boxParser: L,
                  errors: u,
                  urlUtils: M,
                  constants: A,
                  dashConstants: I
                });
              }
              function C(K) {
                K.baseURLController && (E = K.baseURLController), K.dashMetrics && (c = K.dashMetrics), K.mediaPlayerModel && (o = K.mediaPlayerModel), K.errHandler && (_ = K.errHandler), K.boxParser && (L = K.boxParser), K.debug && (h = K.debug.getLogger(S)), K.requestModifier && (v = K.requestModifier), K.errors && (u = K.errors), K.urlUtils && (M = K.urlUtils), K.constants && (A = K.constants), K.dashConstants && (I = K.dashConstants);
              }
              function b(K, Y) {
                return new Promise(function(ne) {
                  w(K, Y, ne);
                });
              }
              function w(K, Y, ne, ae) {
                var fe = null, Q = K ? E.resolve(K.path) : null, oe = ae || {
                  init: !0,
                  url: Q ? Q.url : void 0,
                  range: {
                    start: 0,
                    end: 1500
                  },
                  searching: !1,
                  bytesLoaded: 0,
                  bytesToLoad: 1500,
                  mediaType: Y
                };
                h.debug("Start searching for initialization.");
                var de = ie(oe), Me = function(ee) {
                  if (oe.bytesLoaded = oe.range.end, fe = L.findInitRange(ee), fe)
                    K.range = fe, ne(K);
                  else
                    return oe.range.end = oe.bytesLoaded + oe.bytesToLoad, w(K, Y, ne, oe);
                }, ge = function() {
                  ne(K);
                };
                y.load({
                  request: de,
                  success: Me,
                  error: ge
                }), h.debug("Perform init search: " + oe.url);
              }
              function V(K, Y, ne) {
                return new Promise(function(ae) {
                  J(K, Y, ne, ae);
                });
              }
              function J(K, Y, ne, ae, fe, Q) {
                if (ne && (ne.start === void 0 || ne.end === void 0)) {
                  var oe = ne ? ne.toString().split("-") : null;
                  ne = oe ? {
                    start: parseFloat(oe[0]),
                    end: parseFloat(oe[1])
                  } : null;
                }
                fe = fe || H;
                var de = null, Me = null, ge = !!ne, se = K ? E.resolve(K.path) : null, ee = {
                  init: !1,
                  url: se ? se.url : void 0,
                  range: ge ? ne : {
                    start: 0,
                    end: 1500
                  },
                  searching: !ge,
                  bytesLoaded: Q ? Q.bytesLoaded : 0,
                  bytesToLoad: 1500,
                  mediaType: Y
                }, re = ie(ee), ue = function(p) {
                  var P = ee.bytesToLoad, k = p.byteLength;
                  if (ee.bytesLoaded = ee.range.end - ee.range.start, de = L.parse(p), Me = de.getBox("sidx"), !Me || !Me.isComplete) {
                    if (Me)
                      ee.range.start = Me.offset || ee.range.start, ee.range.end = ee.range.start + (Me.size || P);
                    else if (k < ee.bytesLoaded) {
                      fe(null, K, ae);
                      return;
                    } else {
                      var X = de.getLastBox();
                      X && X.size ? (ee.range.start = X.offset + X.size, ee.range.end = ee.range.start + P) : ee.range.end += P;
                    }
                    J(K, Y, ee.range, ae, null, ee);
                  } else {
                    var F = Me.references, x, W;
                    if (F != null && F.length > 0 && (x = F[0].reference_type === 1), x) {
                      h.debug("Initiate multiple SIDX load."), ee.range.end = ee.range.start + Me.size;
                      var $, ce, le, q, _e, Ee = [], Te = 0, Ce = (Me.offset || ee.range.start) + Me.size, xe = function(Ge) {
                        Ge ? (Ee = Ee.concat(Ge), Te++, Te >= ce && (Ee.sort(function(Pe, Le) {
                          return Pe.startTime - Le.startTime < 0 ? -1 : 0;
                        }), fe(Ee, K, ae))) : fe(null, K, ae);
                      };
                      for ($ = 0, ce = F.length; $ < ce; $++)
                        le = Ce, q = Ce + F[$].referenced_size - 1, Ce = Ce + F[$].referenced_size, _e = {
                          start: le,
                          end: q
                        }, J(K, Y, _e, ae, xe, ee);
                    } else
                      h.debug("Parsing segments from SIDX. representation " + Y + " - id: " + K.id + " for range : " + ee.range.start + " - " + ee.range.end), W = Z(Me, ee), fe(W, K, ae);
                  }
                }, te = function() {
                  fe(null, K, ae);
                };
                y.load({
                  request: re,
                  success: ue,
                  error: te
                }), h.debug("Perform SIDX load for type ".concat(Y, " : ").concat(ee.url, " with range ").concat(ee.range.start, " - ").concat(ee.range.end));
              }
              function H(K, Y, ne) {
                ne({
                  segments: K,
                  representation: Y,
                  error: K ? void 0 : new n.default(u.SEGMENT_BASE_LOADER_ERROR_CODE, u.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
                });
              }
              function z() {
                y && (y.abort(), y = null);
              }
              function Z(K, Y) {
                for (var ne = K.references, ae = ne.length, fe = K.timescale, Q = K.earliest_presentation_time, oe = Y.range.start + K.offset + K.first_offset + K.size, de = [], Me, ge, se, ee, re = 0; re < ae; re++)
                  se = ne[re].subsegment_duration, ee = ne[re].referenced_size, Me = new g.default(), Me.duration = se, Me.startTime = Q, Me.timescale = fe, ge = oe + ee - 1, Me.mediaRange = oe + "-" + ge, de.push(Me), Q += se, oe += ee;
                return de;
              }
              function ie(K) {
                if (K.url) {
                  var Y = new r.default();
                  return Y.setInfo(K), Y;
                }
              }
              return S = {
                setConfig: C,
                initialize: N,
                loadInitialization: b,
                loadSegments: V,
                reset: z
              }, S;
            }
            d.__dashjs_factory_name = "SegmentBaseLoader";
            const t = i.default.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/dash/WebmSegmentBaseLoader.js": (
          /*!*******************************************!*\
            !*** ./src/dash/WebmSegmentBaseLoader.js ***!
            \*******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var g = e(
              /*! ../streaming/utils/EBMLParser */
              "./src/streaming/utils/EBMLParser.js"
            ), n = e(
              /*! ../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), i = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! ./vo/Segment */
              "./src/dash/vo/Segment.js"
            ), l = e(
              /*! ../streaming/vo/FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            ), d = e(
              /*! ../streaming/net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            ), t = e(
              /*! ../streaming/vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            );
            function T() {
              var h = this.context, _, L, v, c, o, y, u, A, I, M;
              function E() {
                v = {
                  EBML: {
                    tag: 440786851,
                    required: !0
                  },
                  Segment: {
                    tag: 408125543,
                    required: !0,
                    SeekHead: {
                      tag: 290298740,
                      required: !0
                    },
                    Info: {
                      tag: 357149030,
                      required: !0,
                      TimecodeScale: {
                        tag: 2807729,
                        required: !0,
                        parse: "getMatroskaUint"
                      },
                      Duration: {
                        tag: 17545,
                        required: !0,
                        parse: "getMatroskaFloat"
                      }
                    },
                    Tracks: {
                      tag: 374648427,
                      required: !0
                    },
                    Cues: {
                      tag: 475249515,
                      required: !0,
                      CuePoint: {
                        tag: 187,
                        required: !0,
                        CueTime: {
                          tag: 179,
                          required: !0,
                          parse: "getMatroskaUint"
                        },
                        CueTrackPositions: {
                          tag: 183,
                          required: !0,
                          CueTrack: {
                            tag: 247,
                            required: !0,
                            parse: "getMatroskaUint"
                          },
                          CueClusterPosition: {
                            tag: 241,
                            required: !0,
                            parse: "getMatroskaUint"
                          }
                        }
                      }
                    }
                  },
                  Void: {
                    tag: 236,
                    required: !0
                  }
                };
              }
              function N() {
                A = (0, d.default)(h).create({
                  errHandler: c,
                  dashMetrics: y,
                  mediaPlayerModel: u,
                  requestModifier: o,
                  errors: I
                });
              }
              function C(ie) {
                if (!ie.baseURLController || !ie.dashMetrics || !ie.mediaPlayerModel || !ie.errHandler)
                  throw new Error(n.default.MISSING_CONFIG_ERROR);
                M = ie.baseURLController, y = ie.dashMetrics, u = ie.mediaPlayerModel, c = ie.errHandler, I = ie.errors, L = ie.debug.getLogger(_), o = ie.requestModifier;
              }
              function b(ie) {
                var K = [], Y = (0, g.default)(h).create({
                  data: ie
                }), ne, ae;
                for (Y.consumeTagAndSize(v.Segment.Cues); Y.moreData() && Y.consumeTagAndSize(v.Segment.Cues.CuePoint, !0); ) {
                  for (ne = {}, ne.CueTime = Y.parseTag(v.Segment.Cues.CuePoint.CueTime), ne.CueTracks = []; Y.moreData() && Y.consumeTag(v.Segment.Cues.CuePoint.CueTrackPositions, !0); ) {
                    var fe = Y.getMatroskaCodedNum(), Q = Y.getPos();
                    if (ae = {}, ae.Track = Y.parseTag(v.Segment.Cues.CuePoint.CueTrackPositions.CueTrack), ae.Track === 0)
                      throw new Error("Cue track cannot be 0");
                    ae.ClusterPosition = Y.parseTag(v.Segment.Cues.CuePoint.CueTrackPositions.CueClusterPosition), ne.CueTracks.push(ae), Y.setPos(Q + fe);
                  }
                  if (ne.CueTracks.length === 0)
                    throw new Error("Mandatory cuetrack not found");
                  K.push(ne);
                }
                if (K.length === 0)
                  throw new Error("mandatory cuepoint not found");
                return K;
              }
              function w(ie, K, Y, ne) {
                var ae, fe, Q, oe, de, Me, ge, se;
                for (fe = b(ie), Q = [], de = 0, Me = fe.length; de < Me; de += 1)
                  oe = new r.default(), ae = 0, de < fe.length - 1 ? ae = fe[de + 1].CueTime - fe[de].CueTime : ae = ne - fe[de].CueTime, oe.duration = ae, oe.startTime = fe[de].CueTime, oe.timescale = 1e3, ge = fe[de].CueTracks[0].ClusterPosition + K, de < fe.length - 1 ? se = fe[de + 1].CueTracks[0].ClusterPosition + K - 1 : se = Y - 1, oe.mediaRange = ge + "-" + se, Q.push(oe);
                return L.debug("Parsed cues: " + Q.length + " cues."), Q;
              }
              function V(ie, K, Y, ne) {
                if (!ie || ie.byteLength === 0) {
                  ne(null);
                  return;
                }
                var ae = (0, g.default)(h).create({
                  data: ie
                }), fe, Q, oe, de, Me = Y ? Y.split("-") : null, ge = null, se = {
                  url: K,
                  range: {
                    start: Me ? parseFloat(Me[0]) : null,
                    end: Me ? parseFloat(Me[1]) : null
                  },
                  request: ge
                };
                for (L.debug("Parse EBML header: " + se.url), ae.skipOverElement(v.EBML), ae.consumeTag(v.Segment), oe = ae.getMatroskaCodedNum(), oe += ae.getPos(), de = ae.getPos(); ae.moreData() && !ae.consumeTagAndSize(v.Segment.Info, !0); )
                  if (!(ae.skipOverElement(v.Segment.SeekHead, !0) || ae.skipOverElement(v.Segment.Tracks, !0) || ae.skipOverElement(v.Segment.Cues, !0) || ae.skipOverElement(v.Void, !0)))
                    throw new Error("no valid top level element found");
                for (; fe === void 0; ) {
                  var ee = ae.getMatroskaCodedNum(!0), re = ae.getMatroskaCodedNum();
                  switch (ee) {
                    case v.Segment.Info.Duration.tag:
                      fe = ae[v.Segment.Info.Duration.parse](re);
                      break;
                    default:
                      ae.setPos(ae.getPos() + re);
                      break;
                  }
                }
                ge = z(se);
                var ue = function(p) {
                  Q = w(p, de, oe, fe), ne(Q);
                }, te = function() {
                  L.error("Download Error: Cues " + se.url), ne(null);
                };
                A.load({
                  request: ge,
                  success: ue,
                  error: te
                }), L.debug("Perform cues load: " + se.url + " bytes=" + se.range.start + "-" + se.range.end);
              }
              function J(ie, K) {
                return new Promise(function(Y) {
                  var ne = null, ae = ie ? M.resolve(ie.path) : null, fe = ie ? ie.range.split("-") : null, Q = {
                    range: {
                      start: fe ? parseFloat(fe[0]) : null,
                      end: fe ? parseFloat(fe[1]) : null
                    },
                    request: ne,
                    url: ae ? ae.url : void 0,
                    init: !0,
                    mediaType: K
                  };
                  L.info("Start loading initialization."), ne = z(Q);
                  var oe = function() {
                    Y(ie);
                  }, de = function() {
                    Y(ie);
                  };
                  A.load({
                    request: ne,
                    success: oe,
                    error: de
                  }), L.debug("Perform init load: " + Q.url);
                });
              }
              function H(ie, K, Y) {
                return new Promise(function(ne) {
                  var ae = null, fe = ie ? M.resolve(ie.path) : null, Q = fe ? fe.url : void 0, oe = 8192, de = {
                    bytesLoaded: 0,
                    bytesToLoad: oe,
                    range: {
                      start: 0,
                      end: oe
                    },
                    request: ae,
                    url: Q,
                    init: !1,
                    mediaType: K
                  };
                  ae = z(de), L.debug("Parsing ebml header");
                  var Me = function(ee) {
                    V(ee, Q, Y, function(re) {
                      ne({
                        segments: re,
                        representation: ie,
                        error: re ? void 0 : new t.default(I.SEGMENT_BASE_LOADER_ERROR_CODE, I.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
                      });
                    });
                  }, ge = function() {
                    ne({
                      representation: ie,
                      error: new t.default(I.SEGMENT_BASE_LOADER_ERROR_CODE, I.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
                    });
                  };
                  A.load({
                    request: ae,
                    success: Me,
                    error: ge
                  });
                });
              }
              function z(ie) {
                var K = new l.default();
                return K.setInfo(ie), K;
              }
              function Z() {
                A && (A.abort(), A = null);
              }
              return _ = {
                setConfig: C,
                initialize: N,
                loadInitialization: J,
                loadSegments: H,
                reset: Z
              }, E(), _;
            }
            T.__dashjs_factory_name = "WebmSegmentBaseLoader";
            const S = i.default.getSingletonFactory(T);
          }
        ),
        /***/
        "./src/dash/constants/DashConstants.js": (
          /*!*********************************************!*\
            !*** ./src/dash/constants/DashConstants.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            function g(t, T) {
              if (!(t instanceof T))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(t, T) {
              for (var S = 0; S < T.length; S++) {
                var h = T[S];
                h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(t, h.key, h);
              }
            }
            function i(t, T, S) {
              return T && n(t.prototype, T), S && n(t, S), t;
            }
            var r = /* @__PURE__ */ function() {
              function t() {
                g(this, t), this.init();
              }
              return i(t, [{
                key: "init",
                value: function() {
                  this.BASE_URL = "BaseURL", this.SEGMENT_BASE = "SegmentBase", this.SEGMENT_TEMPLATE = "SegmentTemplate", this.SEGMENT_LIST = "SegmentList", this.SEGMENT_URL = "SegmentURL", this.SEGMENT_TIMELINE = "SegmentTimeline", this.SEGMENT_PROFILES = "segmentProfiles", this.ADAPTATION_SET = "AdaptationSet", this.REPRESENTATION = "Representation", this.REPRESENTATION_INDEX = "RepresentationIndex", this.SUB_REPRESENTATION = "SubRepresentation", this.INITIALIZATION = "Initialization", this.INITIALIZATION_MINUS = "initialization", this.MPD = "MPD", this.PERIOD = "Period", this.ASSET_IDENTIFIER = "AssetIdentifier", this.EVENT_STREAM = "EventStream", this.ID = "id", this.PROFILES = "profiles", this.SERVICE_LOCATION = "serviceLocation", this.RANGE = "range", this.INDEX = "index", this.MEDIA = "media", this.BYTE_RANGE = "byteRange", this.INDEX_RANGE = "indexRange", this.MEDIA_RANGE = "mediaRange", this.VALUE = "value", this.CONTENT_TYPE = "contentType", this.MIME_TYPE = "mimeType", this.BITSTREAM_SWITCHING = "BitstreamSwitching", this.BITSTREAM_SWITCHING_MINUS = "bitstreamSwitching", this.CODECS = "codecs", this.DEPENDENCY_ID = "dependencyId", this.MEDIA_STREAM_STRUCTURE_ID = "mediaStreamStructureId", this.METRICS = "Metrics", this.METRICS_MINUS = "metrics", this.REPORTING = "Reporting", this.WIDTH = "width", this.HEIGHT = "height", this.SAR = "sar", this.FRAMERATE = "frameRate", this.AUDIO_SAMPLING_RATE = "audioSamplingRate", this.MAXIMUM_SAP_PERIOD = "maximumSAPPeriod", this.START_WITH_SAP = "startWithSAP", this.MAX_PLAYOUT_RATE = "maxPlayoutRate", this.CODING_DEPENDENCY = "codingDependency", this.SCAN_TYPE = "scanType", this.FRAME_PACKING = "FramePacking", this.AUDIO_CHANNEL_CONFIGURATION = "AudioChannelConfiguration", this.CONTENT_PROTECTION = "ContentProtection", this.ESSENTIAL_PROPERTY = "EssentialProperty", this.SUPPLEMENTAL_PROPERTY = "SupplementalProperty", this.INBAND_EVENT_STREAM = "InbandEventStream", this.PRODUCER_REFERENCE_TIME = "ProducerReferenceTime", this.ACCESSIBILITY = "Accessibility", this.ROLE = "Role", this.RATING = "Rating", this.CONTENT_COMPONENT = "ContentComponent", this.SUBSET = "Subset", this.LANG = "lang", this.VIEWPOINT = "Viewpoint", this.ROLE_ASARRAY = "Role_asArray", this.REPRESENTATION_ASARRAY = "Representation_asArray", this.PRODUCERREFERENCETIME_ASARRAY = "ProducerReferenceTime_asArray", this.ACCESSIBILITY_ASARRAY = "Accessibility_asArray", this.AUDIOCHANNELCONFIGURATION_ASARRAY = "AudioChannelConfiguration_asArray", this.CONTENTPROTECTION_ASARRAY = "ContentProtection_asArray", this.MAIN = "main", this.DYNAMIC = "dynamic", this.STATIC = "static", this.MEDIA_PRESENTATION_DURATION = "mediaPresentationDuration", this.MINIMUM_UPDATE_PERIOD = "minimumUpdatePeriod", this.CODEC_PRIVATE_DATA = "codecPrivateData", this.BANDWITH = "bandwidth", this.SOURCE_URL = "sourceURL", this.TIMESCALE = "timescale", this.DURATION = "duration", this.START_NUMBER = "startNumber", this.PRESENTATION_TIME_OFFSET = "presentationTimeOffset", this.AVAILABILITY_START_TIME = "availabilityStartTime", this.AVAILABILITY_END_TIME = "availabilityEndTime", this.TIMESHIFT_BUFFER_DEPTH = "timeShiftBufferDepth", this.MAX_SEGMENT_DURATION = "maxSegmentDuration", this.PRESENTATION_TIME = "presentationTime", this.MIN_BUFFER_TIME = "minBufferTime", this.MAX_SUBSEGMENT_DURATION = "maxSubsegmentDuration", this.START = "start", this.AVAILABILITY_TIME_OFFSET = "availabilityTimeOffset", this.AVAILABILITY_TIME_COMPLETE = "availabilityTimeComplete", this.CENC_DEFAULT_KID = "cenc:default_KID", this.DVB_PRIORITY = "dvb:priority", this.DVB_WEIGHT = "dvb:weight", this.SUGGESTED_PRESENTATION_DELAY = "suggestedPresentationDelay", this.SERVICE_DESCRIPTION = "ServiceDescription", this.SERVICE_DESCRIPTION_SCOPE = "Scope", this.SERVICE_DESCRIPTION_LATENCY = "Latency", this.SERVICE_DESCRIPTION_PLAYBACK_RATE = "PlaybackRate", this.SERVICE_DESCRIPTION_OPERATING_QUALITY = "OperatingQuality", this.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH = "OperatingBandwidth", this.PATCH_LOCATION = "PatchLocation", this.PUBLISH_TIME = "publishTime", this.ORIGINAL_PUBLISH_TIME = "originalPublishTime", this.ORIGINAL_MPD_ID = "mpdId", this.WALL_CLOCK_TIME = "wallClockTime", this.PRESENTATION_TIME = "presentationTime", this.LABEL = "Label", this.GROUP_LABEL = "GroupLabel", this.CONTENT_STEERING = "ContentSteering", this.CONTENT_STEERING_AS_ARRAY = "ContentSteering_asArray", this.DEFAULT_SERVICE_LOCATION = "defaultServiceLocation", this.QUERY_BEFORE_START = "queryBeforeStart", this.PROXY_SERVER_URL = "proxyServerURL", this.CONTENT_STEERING_RESPONSE = {
                    VERSION: "VERSION",
                    TTL: "TTL",
                    RELOAD_URI: "RELOAD-URI",
                    SERVICE_LOCATION_PRIORITY: "SERVICE-LOCATION-PRIORITY"
                  };
                }
              }]), t;
            }(), l = new r();
            const d = l;
          }
        ),
        /***/
        "./src/dash/controllers/ContentSteeringController.js": (
          /*!***********************************************************!*\
            !*** ./src/dash/controllers/ContentSteeringController.js ***!
            \***********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => o
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), i = e(
              /*! ../../streaming/net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            ), r = e(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), l = e(
              /*! ../vo/ContentSteeringRequest */
              "./src/dash/vo/ContentSteeringRequest.js"
            ), d = e(
              /*! ../vo/ContentSteeringResponse */
              "./src/dash/vo/ContentSteeringResponse.js"
            ), t = e(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), T = e(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), S = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), h = e(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), _ = e(
              /*! ../../core/Utils */
              "./src/core/Utils.js"
            ), L = e(
              /*! ../../streaming/utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), v = {
              THROUGHPUT: "_DASH_throughput",
              PATHWAY: "_DASH_pathway",
              URL: "url"
            };
            function c() {
              var y = this.context, u = (0, L.default)(y).getInstance(), A, I, M, E, N, C, b, w, V, J, H, z, Z, ie, K;
              function Y() {
                I = (0, n.default)(y).getInstance().getLogger(A), p();
              }
              function ne(P) {
                P && (P.adapter && (K = P.adapter), P.errHandler && (w = P.errHandler), P.dashMetrics && (V = P.dashMetrics), P.mediaPlayerModel && (J = P.mediaPlayerModel), P.requestModifier && (z = P.requestModifier), P.manifestModel && (H = P.manifestModel), P.abrController && (Z = P.abrController), P.eventBus && (ie = P.eventBus));
              }
              function ae() {
                b = (0, i.default)(y).create({
                  errHandler: w,
                  dashMetrics: V,
                  mediaPlayerModel: J,
                  requestModifier: z,
                  errors: r.default
                }), ie.on(T.default.PERIOD_SWITCH_COMPLETED, fe, A), ie.on(S.default.FRAGMENT_LOADING_STARTED, Q, A);
              }
              function fe(P) {
                P && P.toStreamInfo && (E = P.toStreamInfo);
              }
              function Q(P) {
                P && P.request && P.request.serviceLocation && (N = P.request.serviceLocation);
              }
              function oe() {
                var P = H.getValue();
                return K.getContentSteering(P);
              }
              function de() {
                var P = oe();
                return P && P.queryBeforeStart;
              }
              function Me() {
                return new Promise(function(P) {
                  try {
                    var k = oe();
                    if (!k || !k.serverUrl) {
                      P();
                      return;
                    }
                    var X = ge(k), F = new l.default(X);
                    b.load({
                      request: F,
                      success: function(W) {
                        se(W), ie.trigger(T.default.CONTENT_STEERING_REQUEST_COMPLETED, {
                          currentSteeringResponseData: M,
                          url: X
                        }), P();
                      },
                      error: function(W) {
                        ue(W), P(W);
                      }
                    });
                  } catch (x) {
                    P(x);
                  }
                });
              }
              function ge(P) {
                var k = P.proxyServerUrl ? P.proxyServerUrl : P.serverUrl;
                M && M.reloadUri && (u.isRelative(M.reloadUri) ? k = u.resolve(M.reloadUri, P.serverUrl) : k = M.reloadUri);
                var X = [];
                if (E) {
                  var F = K.getIsDynamic(), x = K.getAllMediaInfoForType(E, h.default.VIDEO).length > 0 ? h.default.VIDEO : h.default.AUDIO, W = Z.getThroughputHistory(), $ = W ? W.getAverageThroughput(x, F) : NaN;
                  isNaN($) || X.push({
                    key: v.THROUGHPUT,
                    value: $ * 1e3
                  });
                }
                return N && X.push({
                  key: v.PATHWAY,
                  value: N
                }), P.proxyServerUrl && P.proxyServerUrl === k && P.serverUrl && X.push({
                  key: v.URL,
                  value: encodeURI(P.serverUrl)
                }), k = _.default.addAditionalQueryParameterToUrl(k, X), k;
              }
              function se(P) {
                !P || !P[t.default.CONTENT_STEERING_RESPONSE.VERSION] || parseInt(P[t.default.CONTENT_STEERING_RESPONSE.VERSION]) !== 1 || (M = new d.default(), M.version = P[t.default.CONTENT_STEERING_RESPONSE.VERSION], P[t.default.CONTENT_STEERING_RESPONSE.TTL] && !isNaN(P[t.default.CONTENT_STEERING_RESPONSE.TTL]) && (M.ttl = P[t.default.CONTENT_STEERING_RESPONSE.TTL]), P[t.default.CONTENT_STEERING_RESPONSE.RELOAD_URI] && (M.reloadUri = P[t.default.CONTENT_STEERING_RESPONSE.RELOAD_URI]), P[t.default.CONTENT_STEERING_RESPONSE.SERVICE_LOCATION_PRIORITY] && (M.serviceLocationPriority = P[t.default.CONTENT_STEERING_RESPONSE.SERVICE_LOCATION_PRIORITY]), ee());
              }
              function ee() {
                M && M.ttl && !isNaN(M.ttl) && (C && clearTimeout(C), C = setTimeout(function() {
                  Me();
                }, M.ttl * 1e3));
              }
              function re() {
                C && clearTimeout(C), C = null;
              }
              function ue(P) {
                I.warn("Error fetching data from content steering server", P), ee();
              }
              function te() {
                return M;
              }
              function O() {
                p(), ie.off(T.default.PERIOD_SWITCH_COMPLETED, fe, A), ie.off(S.default.FRAGMENT_LOADING_STARTED, Q, A);
              }
              function p() {
                M = null, E = null, N = null, re();
              }
              return A = {
                reset: O,
                setConfig: ne,
                loadSteeringData: Me,
                getCurrentSteeringResponseData: te,
                shouldQueryBeforeStart: de,
                getSteeringDataFromManifest: oe,
                stopSteeringRequestTimer: re,
                initialize: ae
              }, Y(), A;
            }
            c.__dashjs_factory_name = "ContentSteeringController";
            const o = g.default.getSingletonFactory(c);
          }
        ),
        /***/
        "./src/dash/controllers/RepresentationController.js": (
          /*!**********************************************************!*\
            !*** ./src/dash/controllers/RepresentationController.js ***!
            \**********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), i = e(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), r = e(
              /*! ../utils/SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            );
            function l(t) {
              t = t || {};
              var T = t.eventBus, S = t.events, h = t.abrController, _ = t.dashMetrics, L = t.playbackController, v = t.timelineConverter, c = t.type, o = t.streamInfo, y = t.dashConstants, u = t.segmentsController, A = t.isDynamic, I, M, E, N, C;
              function b() {
                ie(), T.on(i.default.MANIFEST_VALIDITY_CHANGED, te, I);
              }
              function w() {
                return o.id;
              }
              function V() {
                return c;
              }
              function J() {
                if (!h || !_ || !L || !v)
                  throw new Error(g.default.MISSING_CONFIG_ERROR);
              }
              function H() {
                return M;
              }
              function z() {
                return E;
              }
              function Z() {
                return C;
              }
              function ie() {
                M = null, E = !0, N = [];
              }
              function K() {
                T.off(i.default.MANIFEST_VALIDITY_CHANGED, te, I), ie();
              }
              function Y(O, p, P, k, X) {
                J(), E = !0, N = p;
                var F = de(X);
                if (ue(F), M = O, P !== g.default.VIDEO && P !== g.default.AUDIO && (P !== g.default.TEXT || !k))
                  return se(), Promise.resolve();
                for (var x = [], W = 0, $ = N.length; W < $; W++) {
                  var ce = N[W];
                  x.push(ne(ce));
                }
                return Promise.all(x);
              }
              function ne(O) {
                return new Promise(function(p, P) {
                  var k = O.hasInitialization(), X = O.hasSegments(), F = [];
                  F.push(u.updateInitData(O, k)), F.push(u.updateSegmentData(O, X)), Promise.all(F).then(function(x) {
                    x[0] && !x[0].error && (O = fe(O, x[0])), x[1] && !x[1].error && (O = Q(O, x[1])), ae(O), ee(O), p();
                  }).catch(function(x) {
                    P(x);
                  });
                });
              }
              function ae(O) {
                O.mediaFinishedInformation = u.getMediaFinishedInformation(O);
              }
              function fe(O, p) {
                return !p || p.error || !p.representation ? O : p.representation;
              }
              function Q(O, p) {
                if (!(!p || p.error)) {
                  var P = p.segments, k = [], X = 0, F, x, W, $;
                  for (F = 0, x = P ? P.length : 0; F < x; F++)
                    W = P[F], $ = (0, r.getTimeBasedSegment)(v, A, O, W.startTime, W.duration, W.timescale, W.media, W.mediaRange, X), $ && (k.push($), $ = null, X++);
                  return k.length > 0 && (O.segments = k), O;
                }
              }
              function oe() {
                J();
                var O = /* @__PURE__ */ new Date(), p = Z(), P = L.getTime() * 1e3;
                p && _.addRepresentationSwitch(p.adaptation.type, O, P, p.id), T.trigger(i.default.REPRESENTATION_SWITCH, {
                  mediaType: c,
                  streamId: o.id,
                  currentRepresentation: p,
                  numberOfRepresentations: N.length
                }, {
                  streamId: o.id,
                  mediaType: c
                });
              }
              function de(O) {
                return O == null || O >= N.length ? null : N[O];
              }
              function Me(O) {
                return N.indexOf(O);
              }
              function ge() {
                for (var O = 0, p = N.length; O < p; O++) {
                  var P = N[O].segmentInfoType;
                  if (!N[O].hasInitialization() || (P === y.SEGMENT_BASE || P === y.BASE_URL) && !N[O].segments)
                    return !1;
                }
                return !0;
              }
              function se(O) {
                E = !1, T.trigger(S.DATA_UPDATE_COMPLETED, {
                  data: M,
                  currentRepresentation: C,
                  error: O
                }, {
                  streamId: o.id,
                  mediaType: c
                });
              }
              function ee(O) {
                if (z()) {
                  var p = _.getCurrentManifestUpdate(), P = !1, k, X;
                  if (p) {
                    for (var F = 0; F < p.representationInfo.length; F++)
                      if (k = p.representationInfo[F], k.index === O.index && k.mediaType === V()) {
                        P = !0;
                        break;
                      }
                    P || _.addManifestUpdateRepresentationInfo(O, V());
                  }
                  if (ge()) {
                    h.setPlaybackQuality(c, o, Me(C));
                    var x = _.getCurrentDVRInfo(c);
                    x && _.updateManifestUpdateInfo({
                      latency: x.range.end - L.getTime()
                    }), X = _.getCurrentRepresentationSwitch(Z().adaptation.type), X || oe(), se();
                  }
                }
              }
              function re(O) {
                var p = de(O);
                ue(p), oe();
              }
              function ue(O) {
                C = O;
              }
              function te(O) {
                if (O.newDuration) {
                  var p = Z();
                  if (p && p.adaptation.period) {
                    var P = p.adaptation.period;
                    P.duration = O.newDuration;
                  }
                }
              }
              return I = {
                getStreamId: w,
                getType: V,
                getData: H,
                isUpdating: z,
                updateData: Y,
                getCurrentRepresentation: Z,
                getRepresentationForQuality: de,
                prepareQualityChange: re,
                reset: K
              }, b(), I;
            }
            l.__dashjs_factory_name = "RepresentationController";
            const d = n.default.getClassFactory(l);
          }
        ),
        /***/
        "./src/dash/controllers/SegmentBaseController.js": (
          /*!*******************************************************!*\
            !*** ./src/dash/controllers/SegmentBaseController.js ***!
            \*******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../SegmentBaseLoader */
              "./src/dash/SegmentBaseLoader.js"
            ), i = e(
              /*! ../WebmSegmentBaseLoader */
              "./src/dash/WebmSegmentBaseLoader.js"
            );
            function r(t) {
              t = t || {};
              var T = this.context, S = t.eventBus, h = t.events, _ = t.dashMetrics, L = t.mediaPlayerModel, v = t.errHandler, c = t.baseURLController, o = t.debug, y = t.boxParser, u = t.requestModifier, A = t.errors, I, M, E;
              function N() {
                M = (0, n.default)(T).getInstance(), E = (0, i.default)(T).getInstance(), M.setConfig({
                  baseURLController: c,
                  dashMetrics: _,
                  mediaPlayerModel: L,
                  errHandler: v,
                  eventBus: S,
                  events: h,
                  errors: A,
                  debug: o,
                  boxParser: y,
                  requestModifier: u
                }), E.setConfig({
                  baseURLController: c,
                  dashMetrics: _,
                  mediaPlayerModel: L,
                  errHandler: v,
                  eventBus: S,
                  events: h,
                  errors: A,
                  debug: o,
                  requestModifier: u
                });
              }
              function C(H) {
                var z = H ? H.split("/")[1] : "";
                return z.toLowerCase() === "webm";
              }
              function b() {
                M.initialize(), E.initialize();
              }
              function w(H) {
                return C(H.representation.mimeType) ? E.loadInitialization(H.representation, H.mediaType) : M.loadInitialization(H.representation, H.mediaType);
              }
              function V(H) {
                return C(H.mimeType) ? E.loadSegments(H.representation, H.mediaType, H.representation ? H.representation.indexRange : null) : M.loadSegments(H.representation, H.mediaType, H.representation ? H.representation.indexRange : null);
              }
              function J() {
                M.reset(), E.reset();
              }
              return I = {
                initialize: b,
                getSegmentBaseInitSegment: w,
                getSegmentList: V,
                reset: J
              }, N(), I;
            }
            r.__dashjs_factory_name = "SegmentBaseController";
            var l = g.default.getSingletonFactory(r);
            const d = l;
          }
        ),
        /***/
        "./src/dash/controllers/SegmentsController.js": (
          /*!****************************************************!*\
            !*** ./src/dash/controllers/SegmentsController.js ***!
            \****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../utils/TimelineSegmentsGetter */
              "./src/dash/utils/TimelineSegmentsGetter.js"
            ), i = e(
              /*! ../utils/TemplateSegmentsGetter */
              "./src/dash/utils/TemplateSegmentsGetter.js"
            ), r = e(
              /*! ../utils/ListSegmentsGetter */
              "./src/dash/utils/ListSegmentsGetter.js"
            ), l = e(
              /*! ../utils/SegmentBaseGetter */
              "./src/dash/utils/SegmentBaseGetter.js"
            );
            function d(S) {
              S = S || {};
              var h = this.context, _ = S.dashConstants, L = S.type, v = S.segmentBaseController, c, o;
              function y() {
                o = {};
              }
              function u(b) {
                o[_.SEGMENT_TIMELINE] = (0, n.default)(h).create(S, b), o[_.SEGMENT_TEMPLATE] = (0, i.default)(h).create(S, b), o[_.SEGMENT_LIST] = (0, r.default)(h).create(S, b), o[_.SEGMENT_BASE] = (0, l.default)(h).create(S, b);
              }
              function A(b, w) {
                return w ? Promise.resolve() : v.getSegmentBaseInitSegment({
                  representation: b,
                  mediaType: L
                });
              }
              function I(b, w) {
                return w ? Promise.resolve() : v.getSegmentList({
                  mimeType: b.mimeType,
                  representation: b,
                  mediaType: L
                });
              }
              function M(b) {
                return b ? b.segments ? o[_.SEGMENT_BASE] : o[b.segmentInfoType] : null;
              }
              function E(b, w, V) {
                var J = M(b);
                return J ? J.getSegmentByIndex(b, w, V) : null;
              }
              function N(b, w) {
                var V = M(b);
                return V ? V.getSegmentByTime(b, w) : null;
              }
              function C(b) {
                var w = M(b);
                return w ? w.getMediaFinishedInformation(b) : {
                  numberOfSegments: 0,
                  mediaTimeOfLastSignaledSegment: NaN
                };
              }
              return c = {
                initialize: u,
                updateInitData: A,
                updateSegmentData: I,
                getSegmentByIndex: E,
                getSegmentByTime: N,
                getMediaFinishedInformation: C
              }, y(), c;
            }
            d.__dashjs_factory_name = "SegmentsController";
            var t = g.default.getClassFactory(d);
            const T = t;
          }
        ),
        /***/
        "./src/dash/controllers/ServiceDescriptionController.js": (
          /*!**************************************************************!*\
            !*** ./src/dash/controllers/ServiceDescriptionController.js ***!
            \**************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), i = e(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), r = e(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), l = [i.default.SERVICE_DESCRIPTION_DVB_LL_SCHEME], d = {
              VIDEO: "video",
              AUDIO: "audio",
              ANY: "any",
              ALL: "all"
            };
            function t() {
              var S = this.context, h, _, L, v, c;
              function o() {
                v = (0, n.default)(S).getInstance().getLogger(h), A();
              }
              function y(Z) {
                Z && Z.adapter && (c = Z.adapter);
              }
              function u() {
                A();
              }
              function A() {
                _ = {
                  liveDelay: NaN,
                  liveCatchup: {
                    maxDrift: NaN,
                    playbackRate: {
                      min: NaN,
                      max: NaN
                    }
                  },
                  minBitrate: {},
                  maxBitrate: {},
                  initialBitrate: {}
                }, L = [];
              }
              function I() {
                return _;
              }
              function M(Z) {
                if (!(!Z || !Z.serviceDescriptions)) {
                  var ie = Z.serviceDescriptions.filter(function(ne) {
                    return l.includes(ne.schemeIdUri);
                  }), K = Z.serviceDescriptions.filter(function(ne) {
                    return ne.schemeIdUri == null;
                  }), Y = ie.length > 0 ? ie[ie.length - 1] : K[K.length - 1];
                  Y && (Y.latency && Y.latency.target > 0 && E(Y), Y.playbackRate && b(Y), Y.operatingQuality, Y.operatingBandwidth && w(Y));
                }
              }
              function E(Z) {
                var ie;
                if (Z.schemeIdUri === i.default.SERVICE_DESCRIPTION_DVB_LL_SCHEME ? ie = C(Z) : ie = N(Z), L.length > 0) {
                  var K = z(ie), Y = K.to, ne = K.id;
                  _.liveDelay = ie.liveDelay - Y, _.liveCatchup.maxDrift = ie.maxDrift, v.debug(`
                Found latency properties coming from service description. Applied time offset of `.concat(Y, " from ProducerReferenceTime element with id ").concat(ne, `.
                Live Delay: `).concat(ie.liveDelay - Y, ", Live catchup max drift: ").concat(ie.maxDrift, `
            `));
                } else
                  _.liveDelay = ie.liveDelay, _.liveCatchup.maxDrift = ie.maxDrift, v.debug("Found latency properties coming from service description: Live Delay: ".concat(ie.liveDelay, ", Live catchup max drift: ").concat(ie.maxDrift));
              }
              function N(Z) {
                var ie = Z.latency.target / 1e3, K = !isNaN(Z.latency.max) && Z.latency.max > Z.latency.target ? (Z.latency.max - Z.latency.target + 500) / 1e3 : NaN, Y = Z.latency.referenceId || NaN;
                return {
                  liveDelay: ie,
                  maxDrift: K,
                  referenceId: Y
                };
              }
              function C(Z) {
                var ie = Z.latency.target / 1e3, K = !isNaN(Z.latency.max) && Z.latency.max > Z.latency.target ? (Z.latency.max - Z.latency.target + 500) / 1e3 : NaN, Y = Z.latency.referenceId || NaN;
                return {
                  liveDelay: ie,
                  maxDrift: K,
                  referenceId: Y
                };
              }
              function b(Z) {
                var ie = Z.playbackRate.min ? Math.round((Z.playbackRate.min - 1) * 1e3) / 1e3 : NaN, K = Z.playbackRate.max ? Math.round((Z.playbackRate.max - 1) * 1e3) / 1e3 : NaN;
                _.liveCatchup.playbackRate.min = ie, _.liveCatchup.playbackRate.max = K, v.debug("Found latency properties coming from service description: Live catchup min playback rate: ".concat(ie)), v.debug("Found latency properties coming from service description: Live catchup max playback rate: ".concat(K));
              }
              function w(Z) {
                if (!(!Z || !Z.operatingBandwidth || !Z.operatingBandwidth.mediaType || Z.operatingBandwidth.mediaType === d.ALL)) {
                  var ie = {};
                  ie.minBandwidth = Z.operatingBandwidth.min, ie.maxBandwidth = Z.operatingBandwidth.max, ie.targetBandwidth = Z.operatingBandwidth.target;
                  var K = [];
                  Z.operatingBandwidth.mediaType === d.VIDEO || Z.operatingBandwidth.mediaType === d.AUDIO ? K.push(Z.operatingBandwidth.mediaType) : Z.operatingBandwidth.mediaType === d.ANY && (K.push(d.AUDIO), K.push(d.VIDEO)), K.forEach(function(Y) {
                    isNaN(ie.minBandwidth) || V("minBitrate", Y, ie.minBandwidth), isNaN(ie.maxBandwidth) || V("maxBitrate", Y, ie.maxBandwidth), isNaN(ie.targetBandwidth) || V("initialBitrate", Y, ie.targetBandwidth);
                  });
                }
              }
              function V(Z, ie, K) {
                try {
                  _[Z][ie] = K / 1e3;
                } catch (Y) {
                  v.error(Y);
                }
              }
              function J() {
                return L;
              }
              function H(Z) {
                try {
                  var ie = [];
                  if (Z && Z.length > 0) {
                    var K = [i.default.VIDEO, i.default.AUDIO, i.default.TEXT], Y = c.getAvailabilityStartTime() / 1e3;
                    Z.forEach(function(ne) {
                      var ae = K.reduce(function(fe, Q) {
                        return fe = fe.concat(c.getAllMediaInfoForType(ne, Q)), fe;
                      }, []).reduce(function(fe, Q) {
                        var oe = c.getProducerReferenceTimes(ne, Q);
                        return oe.forEach(function(de) {
                          var Me = c.getVoRepresentations(Q);
                          if (Me && Me.length > 0 && Me[0].adaptation && Me[0].segmentInfoType === r.default.SEGMENT_TEMPLATE) {
                            var ge = Me[0], se = new Date(de[r.default.WALL_CLOCK_TIME]), ee = se.getTime() / 1e3, re = ee - (de[r.default.PRESENTATION_TIME] / ge[r.default.TIMESCALE] - ge[r.default.PRESENTATION_TIME_OFFSET] + ne.start), ue = Y - re;
                            fe.push({
                              id: de[r.default.ID],
                              to: ue
                            });
                          }
                        }), fe;
                      }, []);
                      ie = ie.concat(ae);
                    });
                  }
                  L = ie;
                } catch (ne) {
                  v.error(ne), L = [];
                }
              }
              function z(Z) {
                var ie = 0, K, Y = L.filter(function(ne) {
                  return ne.id === Z.referenceId;
                });
                return Y.length === 0 ? (ie = L.length > 0 ? L[0].to : 0, K = L[0].id || NaN) : (ie = Y[0].to || 0, K = Y[0].id || NaN), {
                  to: ie,
                  id: K
                };
              }
              return h = {
                getServiceDescriptionSettings: I,
                getProducerReferenceTimeOffsets: J,
                calculateProducerReferenceTimeOffsets: H,
                applyServiceDescription: M,
                reset: u,
                setConfig: y
              }, o(), h;
            }
            t.__dashjs_factory_name = "ServiceDescriptionController";
            const T = g.default.getSingletonFactory(t);
          }
        ),
        /***/
        "./src/dash/models/DashManifestModel.js": (
          /*!**********************************************!*\
            !*** ./src/dash/models/DashManifestModel.js ***!
            \**********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => H
              /* harmony export */
            });
            var g = e(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), i = e(
              /*! ../vo/Representation */
              "./src/dash/vo/Representation.js"
            ), r = e(
              /*! ../vo/AdaptationSet */
              "./src/dash/vo/AdaptationSet.js"
            ), l = e(
              /*! ../vo/Period */
              "./src/dash/vo/Period.js"
            ), d = e(
              /*! ../vo/Mpd */
              "./src/dash/vo/Mpd.js"
            ), t = e(
              /*! ../vo/UTCTiming */
              "./src/dash/vo/UTCTiming.js"
            ), T = e(
              /*! ../vo/Event */
              "./src/dash/vo/Event.js"
            ), S = e(
              /*! ../vo/BaseURL */
              "./src/dash/vo/BaseURL.js"
            ), h = e(
              /*! ../vo/EventStream */
              "./src/dash/vo/EventStream.js"
            ), _ = e(
              /*! ../vo/ProducerReferenceTime */
              "./src/dash/vo/ProducerReferenceTime.js"
            ), L = e(
              /*! ../vo/ContentSteering */
              "./src/dash/vo/ContentSteering.js"
            ), v = e(
              /*! ../../streaming/utils/ObjectUtils */
              "./src/streaming/utils/ObjectUtils.js"
            ), c = e(
              /*! ../../streaming/utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), o = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), y = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), u = e(
              /*! ../../streaming/vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), A = e(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), I = e(
              /*! ../../streaming/thumbnail/ThumbnailTracks */
              "./src/streaming/thumbnail/ThumbnailTracks.js"
            );
            function M(z, Z) {
              var ie;
              if (typeof Symbol > "u" || z[Symbol.iterator] == null) {
                if (Array.isArray(z) || (ie = C(z)) || Z && z && typeof z.length == "number") {
                  ie && (z = ie);
                  var K = 0, Y = function() {
                  };
                  return { s: Y, n: function() {
                    return K >= z.length ? { done: !0 } : { done: !1, value: z[K++] };
                  }, e: function(oe) {
                    throw oe;
                  }, f: Y };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              var ne = !0, ae = !1, fe;
              return { s: function() {
                ie = z[Symbol.iterator]();
              }, n: function() {
                var oe = ie.next();
                return ne = oe.done, oe;
              }, e: function(oe) {
                ae = !0, fe = oe;
              }, f: function() {
                try {
                  !ne && ie.return != null && ie.return();
                } finally {
                  if (ae)
                    throw fe;
                }
              } };
            }
            function E(z) {
              return w(z) || b(z) || C(z) || N();
            }
            function N() {
              throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function C(z, Z) {
              if (z) {
                if (typeof z == "string")
                  return V(z, Z);
                var ie = Object.prototype.toString.call(z).slice(8, -1);
                if (ie === "Object" && z.constructor && (ie = z.constructor.name), ie === "Map" || ie === "Set")
                  return Array.from(z);
                if (ie === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ie))
                  return V(z, Z);
              }
            }
            function b(z) {
              if (typeof Symbol < "u" && Symbol.iterator in Object(z))
                return Array.from(z);
            }
            function w(z) {
              if (Array.isArray(z))
                return V(z);
            }
            function V(z, Z) {
              (Z == null || Z > z.length) && (Z = z.length);
              for (var ie = 0, K = new Array(Z); ie < Z; ie++)
                K[ie] = z[ie];
              return K;
            }
            function J() {
              var z, Z, ie, K, Y = this.context, ne = (0, c.default)(Y).getInstance(), ae = Number.isInteger || function(ye) {
                return typeof ye == "number" && isFinite(ye) && Math.floor(ye) === ye;
              };
              function fe() {
                Z = (0, y.default)(Y).getInstance().getLogger(z);
              }
              function Q(ye, Qe) {
                if (!ye)
                  throw new Error("adaptation is not defined");
                if (!Qe)
                  throw new Error("type is not defined");
                if (ye.Representation_asArray && ye.Representation_asArray.length) {
                  var ct = tt(ye.Representation_asArray[0]);
                  if (ct && ct.length > 0 && I.THUMBNAILS_SCHEME_ID_URIS.indexOf(ct[0].schemeIdUri) >= 0)
                    return Qe === g.default.IMAGE;
                }
                if (ye.ContentComponent_asArray && ye.ContentComponent_asArray.length > 0) {
                  if (ye.ContentComponent_asArray.length > 1)
                    return Qe === g.default.MUXED;
                  if (ye.ContentComponent_asArray[0].contentType === Qe)
                    return !0;
                }
                var Se = Qe === g.default.TEXT ? new RegExp("(ttml|vtt|wvtt|stpp)") : new RegExp(Qe);
                if (ye.Representation_asArray && ye.Representation_asArray.length) {
                  var Be = ye.Representation_asArray[0].codecs;
                  if (Se.test(Be))
                    return !0;
                }
                if (ye.hasOwnProperty(n.default.MIME_TYPE))
                  return Se.test(ye.mimeType);
                if (ye.Representation_asArray) {
                  for (var He, yt = 0; yt < ye.Representation_asArray.length; yt++)
                    if (He = ye.Representation_asArray[yt], He.hasOwnProperty(n.default.MIME_TYPE))
                      return Se.test(He.mimeType);
                }
                return !1;
              }
              function oe(ye) {
                if (!ye)
                  throw new Error("adaptation is not defined");
                if (ye.hasOwnProperty(n.default.SEGMENT_TEMPLATE) || ye.hasOwnProperty(n.default.SEGMENT_TIMELINE) || ye.hasOwnProperty(n.default.SEGMENT_LIST) || ye.hasOwnProperty(n.default.SEGMENT_BASE))
                  return !0;
                if (ye.Representation_asArray && ye.Representation_asArray.length > 0) {
                  var Qe = ye.Representation_asArray[0];
                  if (Qe.hasOwnProperty(n.default.SEGMENT_TEMPLATE) || Qe.hasOwnProperty(n.default.SEGMENT_TIMELINE) || Qe.hasOwnProperty(n.default.SEGMENT_LIST) || Qe.hasOwnProperty(n.default.SEGMENT_BASE))
                    return !0;
                }
                return !1;
              }
              function de(ye) {
                return Q(ye, g.default.AUDIO);
              }
              function Me(ye) {
                return Q(ye, g.default.VIDEO);
              }
              function ge(ye) {
                return Q(ye, g.default.TEXT);
              }
              function se(ye) {
                return Q(ye, g.default.MUXED);
              }
              function ee(ye) {
                return Q(ye, g.default.IMAGE);
              }
              function re(ye) {
                var Qe = ye && ye.hasOwnProperty(n.default.PRODUCERREFERENCETIME_ASARRAY) ? ye[n.default.PRODUCERREFERENCETIME_ASARRAY] : [], ct = ye && ye.hasOwnProperty(n.default.REPRESENTATION_ASARRAY) ? ye[n.default.REPRESENTATION_ASARRAY] : [];
                ct.forEach(function(Be) {
                  Be.hasOwnProperty(n.default.PRODUCERREFERENCETIME_ASARRAY) && Qe.push.apply(Qe, E(Be[n.default.PRODUCERREFERENCETIME_ASARRAY]));
                });
                var Se = [];
                return Qe.forEach(function(Be) {
                  var He = new _.default();
                  if (Be.hasOwnProperty(n.default.ID))
                    He[n.default.ID] = Be[n.default.ID];
                  else
                    return;
                  if (Be.hasOwnProperty(n.default.WALL_CLOCK_TIME))
                    He[n.default.WALL_CLOCK_TIME] = Be[n.default.WALL_CLOCK_TIME];
                  else
                    return;
                  if (Be.hasOwnProperty(n.default.PRESENTATION_TIME))
                    He[n.default.PRESENTATION_TIME] = Be[n.default.PRESENTATION_TIME];
                  else
                    return;
                  Se.push(He);
                }), Se;
              }
              function ue(ye) {
                var Qe = "";
                return ye && ye.hasOwnProperty(n.default.LANG) && (Qe = ye.lang), Qe;
              }
              function te(ye) {
                return ye && ye.hasOwnProperty(n.default.VIEWPOINT) ? ye.Viewpoint : null;
              }
              function O(ye) {
                return ye && ye.hasOwnProperty(n.default.ROLE_ASARRAY) ? ye.Role_asArray : [];
              }
              function p(ye) {
                return ye && ye.hasOwnProperty(n.default.ACCESSIBILITY_ASARRAY) ? ye.Accessibility_asArray : [];
              }
              function P(ye) {
                return ye && ye.hasOwnProperty(n.default.AUDIOCHANNELCONFIGURATION_ASARRAY) ? ye.AudioChannelConfiguration_asArray : [];
              }
              function k(ye) {
                return ye && ye.hasOwnProperty(n.default.AUDIOCHANNELCONFIGURATION_ASARRAY) ? ye.AudioChannelConfiguration_asArray : [];
              }
              function X() {
                return function(ye, Qe) {
                  return ye.bandwidth - Qe.bandwidth;
                };
              }
              function F(ye) {
                return ye && Array.isArray(ye.Representation_asArray) && ye.Representation_asArray.sort(X()), ye;
              }
              function x(ye, Qe) {
                return ye && ye.Period_asArray && ae(Qe) ? ye.Period_asArray[Qe] ? ye.Period_asArray[Qe].AdaptationSet_asArray : [] : [];
              }
              function W(ye) {
                return ye && ye.Period_asArray ? ye.Period_asArray : [];
              }
              function $(ye, Qe) {
                var ct = W(Qe);
                return ct.length > 0 && ae(ye) ? ct[ye] : null;
              }
              function ce(ye, Qe, ct) {
                var Se = x(Qe, ct), Be, He;
                for (Be = 0, He = Se.length; Be < He; Be++)
                  if (Se[Be].hasOwnProperty(n.default.ID) && Se[Be].id === ye)
                    return Se[Be];
                return null;
              }
              function le(ye, Qe, ct) {
                var Se = x(Qe, ct);
                return Se.length > 0 && ae(ye) ? Se[ye] : null;
              }
              function q(ye, Qe, ct) {
                if (!ye)
                  return -1;
                for (var Se = x(Qe, ct), Be = 0; Be < Se.length; Be++) {
                  var He = (0, v.default)(Y).getInstance();
                  if (He.areEqual(Se[Be], ye))
                    return Be;
                }
                return -1;
              }
              function _e(ye, Qe, ct) {
                var Se = x(ye, Qe), Be, He, yt = [];
                for (Be = 0, He = Se.length; Be < He; Be++)
                  Q(Se[Be], ct) && yt.push(F(Se[Be]));
                return yt;
              }
              function Ee(ye, Qe, ct) {
                var Se = null;
                if (ye && ye.Representation_asArray && ye.Representation_asArray.length > 0) {
                  var Be = ae(Qe) && Qe >= 0 && Qe < ye.Representation_asArray.length ? ye.Representation_asArray[Qe] : ye.Representation_asArray[0];
                  Be && (Se = Be.mimeType + ';codecs="' + Be.codecs + '"', ct && Be.width !== void 0 && (Se += ';width="' + Be.width + '";height="' + Be.height + '"'));
                }
                return Se && (Se = Se.replace(/\sprofiles=[^;]*/g, "")), Se;
              }
              function Te(ye) {
                return ye && ye.Representation_asArray && ye.Representation_asArray.length > 0 ? ye.Representation_asArray[0].mimeType : null;
              }
              function Ce(ye) {
                return !ye || !ye.hasOwnProperty(n.default.CENC_DEFAULT_KID) ? null : ye[n.default.CENC_DEFAULT_KID];
              }
              function xe(ye) {
                if (!ye || !Array.isArray(ye.Label_asArray))
                  return [];
                for (var Qe = [], ct = 0; ct < ye.Label_asArray.length; ct++)
                  Qe.push({
                    lang: ye.Label_asArray[ct].lang,
                    text: ye.Label_asArray[ct].__text || ye.Label_asArray[ct]
                  });
                return Qe;
              }
              function be(ye) {
                return !ye || !ye.hasOwnProperty(n.default.CONTENTPROTECTION_ASARRAY) || ye.ContentProtection_asArray.length === 0 ? null : ye.ContentProtection_asArray;
              }
              function Ge(ye) {
                var Qe = !1;
                return ye && ye.hasOwnProperty("type") && (Qe = ye.type === n.default.DYNAMIC), Qe;
              }
              function Pe(ye) {
                return ye && ye[n.default.ID] || null;
              }
              function Le(ye, Qe) {
                var ct = !1;
                return ye && ye.profiles && ye.profiles.length > 0 && (ct = ye.profiles.indexOf(Qe) !== -1), ct;
              }
              function je(ye) {
                var Qe;
                return ye && ye.hasOwnProperty(n.default.MEDIA_PRESENTATION_DURATION) ? Qe = ye.mediaPresentationDuration : ye && ye.type == "dynamic" ? Qe = Number.POSITIVE_INFINITY : Qe = Number.MAX_SAFE_INTEGER || Number.MAX_VALUE, Qe;
              }
              function Ze(ye) {
                return ye && ye.bandwidth ? ye.bandwidth : NaN;
              }
              function nt(ye) {
                var Qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, ct = NaN;
                return ye && ye.hasOwnProperty(n.default.MINIMUM_UPDATE_PERIOD) && (ct = ye.minimumUpdatePeriod), isNaN(ct) ? ct : Math.max(ct - Qe, 1);
              }
              function it(ye) {
                return ye && ye.hasOwnProperty(n.default.PUBLISH_TIME) ? new Date(ye[n.default.PUBLISH_TIME]) : null;
              }
              function De(ye) {
                return ye && Array.isArray(ye.Representation_asArray) ? ye.Representation_asArray.length : 0;
              }
              function Ye(ye) {
                var Qe = F(ye), ct = Qe && Array.isArray(Qe.Representation_asArray) ? Qe.Representation_asArray : [];
                return ct.map(function(Se) {
                  return {
                    bandwidth: Se.bandwidth,
                    width: Se.width || 0,
                    height: Se.height || 0,
                    scanType: Se.scanType || null,
                    id: Se.id || null
                  };
                });
              }
              function Ke(ye) {
                try {
                  var Qe = ye && typeof ye.selectionPriority < "u" ? parseInt(ye.selectionPriority) : 1;
                  return isNaN(Qe) ? 1 : Qe;
                } catch {
                  return 1;
                }
              }
              function tt(ye) {
                return !ye || !ye.EssentialProperty_asArray || !ye.EssentialProperty_asArray.length ? null : ye.EssentialProperty_asArray.map(function(Qe) {
                  return {
                    schemeIdUri: Qe.schemeIdUri,
                    value: Qe.value
                  };
                });
              }
              function st(ye, Qe) {
                return Qe && Qe.Representation_asArray && Qe.Representation_asArray.length > 0 && ae(ye) ? Qe.Representation_asArray[ye] : null;
              }
              function Et(ye) {
                if (ye && ye.period && ae(ye.period.index)) {
                  var Qe = ye.period.mpd.manifest.Period_asArray[ye.period.index];
                  if (Qe && Qe.AdaptationSet_asArray && ae(ye.index))
                    return F(Qe.AdaptationSet_asArray[ye.index]);
                }
              }
              function ht(ye) {
                var Qe = [], ct = Et(ye), Se, Be;
                if (ct && ct.Representation_asArray) {
                  if (ye && ye.period && ae(ye.period.index)) {
                    var He = Ae(ye.period.mpd.manifest);
                    He && (Be = He[0]);
                  }
                  for (var yt = 0, zt = ct.Representation_asArray.length; yt < zt; ++yt) {
                    var Nt = ct.Representation_asArray[yt], Dt = new i.default();
                    if (Dt.index = yt, Dt.adaptation = ye, Nt.hasOwnProperty(n.default.ID) && (Dt.id = Nt.id), Nt.hasOwnProperty(n.default.CODECS) && (Dt.codecs = Nt.codecs), Nt.hasOwnProperty(n.default.MIME_TYPE) && (Dt.mimeType = Nt[n.default.MIME_TYPE]), Nt.hasOwnProperty(n.default.CODEC_PRIVATE_DATA) && (Dt.codecPrivateData = Nt.codecPrivateData), Nt.hasOwnProperty(n.default.BANDWITH) && (Dt.bandwidth = Nt.bandwidth), Nt.hasOwnProperty(n.default.WIDTH) && (Dt.width = Nt.width), Nt.hasOwnProperty(n.default.HEIGHT) && (Dt.height = Nt.height), Nt.hasOwnProperty(n.default.SCAN_TYPE) && (Dt.scanType = Nt.scanType), Nt.hasOwnProperty(n.default.MAX_PLAYOUT_RATE) && (Dt.maxPlayoutRate = Nt.maxPlayoutRate), Nt.hasOwnProperty(n.default.SEGMENT_BASE) ? (Se = Nt.SegmentBase, Dt.segmentInfoType = n.default.SEGMENT_BASE) : Nt.hasOwnProperty(n.default.SEGMENT_LIST) ? (Se = Nt.SegmentList, Se.hasOwnProperty(n.default.SEGMENT_TIMELINE) ? Dt.segmentInfoType = n.default.SEGMENT_TIMELINE : Dt.segmentInfoType = n.default.SEGMENT_LIST) : Nt.hasOwnProperty(n.default.SEGMENT_TEMPLATE) ? (Se = Nt.SegmentTemplate, Se.hasOwnProperty(n.default.SEGMENT_TIMELINE) ? Dt.segmentInfoType = n.default.SEGMENT_TIMELINE : Dt.segmentInfoType = n.default.SEGMENT_TEMPLATE, Se.hasOwnProperty(n.default.INITIALIZATION_MINUS) && (Dt.initialization = Se.initialization.split("$Bandwidth$").join(Nt.bandwidth).split("$RepresentationID$").join(Nt.id))) : Dt.segmentInfoType = n.default.BASE_URL, Dt.essentialProperties = tt(Nt), Se) {
                      if (Se.hasOwnProperty(n.default.INITIALIZATION)) {
                        var ar = Se.Initialization;
                        ar.hasOwnProperty(n.default.SOURCE_URL) && (Dt.initialization = ar.sourceURL), ar.hasOwnProperty(n.default.RANGE) && (Dt.range = ar.range);
                      } else
                        ge(ct) && oe(ct) && ct.mimeType && ct.mimeType.indexOf("application/mp4") === -1 && (Dt.range = 0);
                      Se.hasOwnProperty(n.default.TIMESCALE) && (Dt.timescale = Se.timescale), Se.hasOwnProperty(n.default.DURATION) ? Dt.segmentDuration = Se.duration / Dt.timescale : Nt.hasOwnProperty(n.default.SEGMENT_TEMPLATE) && (Se = Nt.SegmentTemplate, Se.hasOwnProperty(n.default.SEGMENT_TIMELINE) && (Dt.segmentDuration = xt(Se.SegmentTimeline) / Dt.timescale)), Se.hasOwnProperty(n.default.MEDIA) && (Dt.media = Se.media), Se.hasOwnProperty(n.default.START_NUMBER) && (Dt.startNumber = Se.startNumber), Se.hasOwnProperty(n.default.INDEX_RANGE) && (Dt.indexRange = Se.indexRange), Se.hasOwnProperty(n.default.PRESENTATION_TIME_OFFSET) && (Dt.presentationTimeOffset = Se.presentationTimeOffset / Dt.timescale), Se.hasOwnProperty(n.default.AVAILABILITY_TIME_OFFSET) ? Dt.availabilityTimeOffset = Se.availabilityTimeOffset : Be && Be.availabilityTimeOffset !== void 0 && (Dt.availabilityTimeOffset = Be.availabilityTimeOffset), Se.hasOwnProperty(n.default.AVAILABILITY_TIME_COMPLETE) ? Dt.availabilityTimeComplete = Se.availabilityTimeComplete !== "false" : Be && Be.availabilityTimeComplete !== void 0 && (Dt.availabilityTimeComplete = Be.availabilityTimeComplete);
                    }
                    Dt.MSETimeOffset = Xe(Dt), Dt.path = [ye.period.index, ye.index, yt], Qe.push(Dt);
                  }
                }
                return Qe;
              }
              function xt(ye) {
                if (!ye || !ye.S_asArray)
                  return NaN;
                var Qe = ye.S_asArray[0], ct = ye.S_asArray[1];
                return Qe.hasOwnProperty("d") ? Qe.d : ct.t - Qe.t;
              }
              function Xe(ye) {
                var Qe = ye.presentationTimeOffset, ct = ye.adaptation.period.start;
                return ct - Qe;
              }
              function ve(ye) {
                var Qe = ye && ae(ye.index) ? ye.mpd.manifest.Period_asArray[ye.index] : null, ct = [], Se, Be, He;
                if (Qe && Qe.AdaptationSet_asArray)
                  for (He = 0; He < Qe.AdaptationSet_asArray.length; He++)
                    Be = Qe.AdaptationSet_asArray[He], Se = new r.default(), Be.hasOwnProperty(n.default.ID) && (Se.id = Be.id), Se.index = He, Se.period = ye, se(Be) ? Se.type = g.default.MUXED : de(Be) ? Se.type = g.default.AUDIO : Me(Be) ? Se.type = g.default.VIDEO : ge(Be) ? Se.type = g.default.TEXT : ee(Be) ? Se.type = g.default.IMAGE : Z.warn("Unknown Adaptation stream type"), ct.push(Se);
                return ct;
              }
              function me(ye) {
                var Qe = ye ? Ge(ye.manifest) : !1, ct = [], Se = null, Be = null, He = null, yt = null, zt, Nt;
                for (Nt = 0, zt = ye && ye.manifest && ye.manifest.Period_asArray ? ye.manifest.Period_asArray.length : 0; Nt < zt; Nt++)
                  Be = ye.manifest.Period_asArray[Nt], Be.hasOwnProperty(n.default.START) ? (yt = new l.default(), yt.start = Be.start) : Se !== null && Se.hasOwnProperty(n.default.DURATION) && He !== null ? (yt = new l.default(), yt.start = parseFloat((He.start + He.duration).toFixed(5))) : Nt === 0 && !Qe && (yt = new l.default(), yt.start = 0), He !== null && isNaN(He.duration) && (yt !== null ? He.duration = parseFloat((yt.start - He.start).toFixed(5)) : Z.warn("First period duration could not be calculated because lack of start and duration period properties. This will cause timing issues during playback")), yt !== null && (yt.id = Ie(Be, Nt), yt.index = Nt, yt.mpd = ye, Be.hasOwnProperty(n.default.DURATION) && (yt.duration = Be.duration), He && (He.nextPeriodId = yt.id), ct.push(yt), Se = Be, He = yt), Be = null, yt = null;
                return ct.length === 0 || He !== null && isNaN(He.duration) && (He.duration = parseFloat(($e(He) - He.start).toFixed(5))), ct;
              }
              function Ie(ye, Qe) {
                if (!ye)
                  throw new Error("Period cannot be null or undefined");
                var ct = l.default.DEFAULT_ID + "_" + Qe;
                return ye.hasOwnProperty(n.default.ID) && ye.id.length > 0 && ye.id !== "__proto__" && (ct = ye.id), ct;
              }
              function we(ye) {
                var Qe = new d.default();
                return ye && (Qe.manifest = ye, ye.hasOwnProperty(n.default.AVAILABILITY_START_TIME) ? Qe.availabilityStartTime = new Date(ye.availabilityStartTime.getTime()) : ye.loadedTime && (Qe.availabilityStartTime = new Date(ye.loadedTime.getTime())), ye.hasOwnProperty(n.default.AVAILABILITY_END_TIME) && (Qe.availabilityEndTime = new Date(ye.availabilityEndTime.getTime())), ye.hasOwnProperty(n.default.MINIMUM_UPDATE_PERIOD) && (Qe.minimumUpdatePeriod = ye.minimumUpdatePeriod), ye.hasOwnProperty(n.default.MEDIA_PRESENTATION_DURATION) && (Qe.mediaPresentationDuration = ye.mediaPresentationDuration), ye.hasOwnProperty(n.default.SUGGESTED_PRESENTATION_DELAY) && (Qe.suggestedPresentationDelay = ye.suggestedPresentationDelay), ye.hasOwnProperty(n.default.TIMESHIFT_BUFFER_DEPTH) && (Qe.timeShiftBufferDepth = ye.timeShiftBufferDepth), ye.hasOwnProperty(n.default.MAX_SEGMENT_DURATION) && (Qe.maxSegmentDuration = ye.maxSegmentDuration), ye.hasOwnProperty(n.default.PUBLISH_TIME) && (Qe.publishTime = new Date(ye.publishTime))), Qe;
              }
              function Ue() {
                if (!ie || !ie.hasOwnProperty("error"))
                  throw new Error(g.default.MISSING_CONFIG_ERROR);
              }
              function $e(ye) {
                Ue();
                var Qe = Ge(ye.mpd.manifest), ct;
                return ye.mpd.manifest.mediaPresentationDuration ? ct = ye.mpd.manifest.mediaPresentationDuration : ye.duration ? ct = ye.duration : Qe ? ct = Number.POSITIVE_INFINITY : ie.error(new u.default(A.default.MANIFEST_ERROR_ID_PARSE_CODE, "Must have @mediaPresentationDuration on MPD or an explicit @duration on the last period.", ye)), ct;
              }
              function at(ye) {
                var Qe = ye && ye.mpd && ye.mpd.manifest ? ye.mpd.manifest : null, ct = Qe ? Qe.Period_asArray : null, Se = ct && ye && ae(ye.index) ? ct[ye.index].EventStream_asArray : null, Be = [], He, yt;
                if (Se)
                  for (He = 0; He < Se.length; He++) {
                    var zt = new h.default();
                    if (zt.period = ye, zt.timescale = 1, Se[He].hasOwnProperty(g.default.SCHEME_ID_URI))
                      zt.schemeIdUri = Se[He][g.default.SCHEME_ID_URI];
                    else
                      throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                    for (Se[He].hasOwnProperty(n.default.TIMESCALE) && (zt.timescale = Se[He][n.default.TIMESCALE]), Se[He].hasOwnProperty(n.default.VALUE) && (zt.value = Se[He][n.default.VALUE]), Se[He].hasOwnProperty(n.default.PRESENTATION_TIME_OFFSET) && (zt.presentationTimeOffset = Se[He][n.default.PRESENTATION_TIME_OFFSET]), yt = 0; Se[He].Event_asArray && yt < Se[He].Event_asArray.length; yt++) {
                      var Nt = Se[He].Event_asArray[yt], Dt = new T.default();
                      Dt.presentationTime = 0, Dt.eventStream = zt, Nt.hasOwnProperty(n.default.PRESENTATION_TIME) && (Dt.presentationTime = Nt.presentationTime);
                      var ar = zt.presentationTimeOffset ? zt.presentationTimeOffset / zt.timescale : 0;
                      Dt.calculatedPresentationTime = Dt.presentationTime / zt.timescale + ye.start - ar, Nt.hasOwnProperty(n.default.DURATION) && (Dt.duration = Nt.duration / zt.timescale), Nt.hasOwnProperty(n.default.ID) ? Dt.id = Nt.id : Dt.id = null, Nt.Signal && Nt.Signal.Binary ? Dt.messageData = K.decodeArray(Nt.Signal.Binary.toString()) : Dt.messageData = Nt.messageData || Nt.__cdata || Nt.__text, Be.push(Dt);
                    }
                  }
                return Be;
              }
              function et(ye, Qe, ct) {
                var Se = [], Be;
                if (!ye)
                  return Se;
                for (Be = 0; Be < ye.length; Be++) {
                  var He = new h.default();
                  if (He.timescale = 1, He.representation = Qe, ye[Be].hasOwnProperty(g.default.SCHEME_ID_URI))
                    He.schemeIdUri = ye[Be].schemeIdUri;
                  else
                    throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                  ye[Be].hasOwnProperty(n.default.TIMESCALE) && (He.timescale = ye[Be].timescale), ye[Be].hasOwnProperty(n.default.VALUE) && (He.value = ye[Be].value), Se.push(He), He.period = ct;
                }
                return Se;
              }
              function Mt(ye, Qe, ct) {
                var Se, Be, He;
                return ye && ye.Period_asArray && Qe && Qe.period && ae(Qe.period.index) && (Be = ye.Period_asArray[Qe.period.index], Be && Be.AdaptationSet_asArray && ae(Qe.index) && (He = Be.AdaptationSet_asArray[Qe.index], He && (Se = He.InbandEventStream_asArray))), et(Se, null, ct);
              }
              function Lt(ye, Qe, ct) {
                var Se, Be, He, yt;
                return ye && ye.Period_asArray && Qe && Qe.adaptation && Qe.adaptation.period && ae(Qe.adaptation.period.index) && (Be = ye.Period_asArray[Qe.adaptation.period.index], Be && Be.AdaptationSet_asArray && ae(Qe.adaptation.index) && (He = Be.AdaptationSet_asArray[Qe.adaptation.index], He && He.Representation_asArray && ae(Qe.index) && (yt = He.Representation_asArray[Qe.index], yt && (Se = yt.InbandEventStream_asArray)))), et(Se, Qe, ct);
              }
              function bt(ye) {
                var Qe = Ge(ye), ct = ye ? ye.hasOwnProperty(n.default.AVAILABILITY_START_TIME) : !1, Se = ye ? ye.UTCTiming_asArray : null, Be = [];
                return (Qe || ct) && Se && Se.forEach(function(He) {
                  var yt = new t.default();
                  if (He.hasOwnProperty(g.default.SCHEME_ID_URI))
                    yt.schemeIdUri = He.schemeIdUri;
                  else
                    return;
                  if (He.hasOwnProperty(n.default.VALUE))
                    yt.value = He.value.toString();
                  else
                    return;
                  Be.push(yt);
                }), Be;
              }
              function Ae(ye) {
                var Qe = [], ct = ye.BaseURL_asArray || [ye.baseUri], Se = !1;
                return ct.some(function(Be) {
                  if (Be) {
                    var He = new S.default(), yt = Be.__text || Be;
                    return ne.isRelative(yt) && (Se = !0, ye.baseUri && (yt = ne.resolve(yt, ye.baseUri))), He.url = yt, Be.hasOwnProperty(n.default.SERVICE_LOCATION) && Be.serviceLocation.length ? He.serviceLocation = Be.serviceLocation : He.serviceLocation = yt, Be.hasOwnProperty(n.default.DVB_PRIORITY) && (He.dvb_priority = Be[n.default.DVB_PRIORITY]), Be.hasOwnProperty(n.default.DVB_WEIGHT) && (He.dvb_weight = Be[n.default.DVB_WEIGHT]), Be.hasOwnProperty(n.default.AVAILABILITY_TIME_OFFSET) && (He.availabilityTimeOffset = Be[n.default.AVAILABILITY_TIME_OFFSET]), Be.hasOwnProperty(n.default.AVAILABILITY_TIME_COMPLETE) && (He.availabilityTimeComplete = Be[n.default.AVAILABILITY_TIME_COMPLETE] !== "false"), Qe.push(He), Se;
                  }
                }), Qe;
              }
              function ze(ye) {
                if (ye && ye.hasOwnProperty(n.default.CONTENT_STEERING_AS_ARRAY)) {
                  var Qe = ye[n.default.CONTENT_STEERING_AS_ARRAY][0], ct = new L.default();
                  return ct.serverUrl = Qe.__text, Qe.hasOwnProperty(n.default.DEFAULT_SERVICE_LOCATION) && (ct.defaultServiceLocation = Qe[n.default.DEFAULT_SERVICE_LOCATION]), Qe.hasOwnProperty(n.default.QUERY_BEFORE_START) && (ct.queryBeforeStart = Qe[n.default.QUERY_BEFORE_START].toLowerCase() === "true"), Qe.hasOwnProperty(n.default.PROXY_SERVER_URL) && (ct.proxyServerUrl = Qe[n.default.PROXY_SERVER_URL]), ct;
                }
              }
              function qe(ye) {
                if (ye && ye.hasOwnProperty(g.default.LOCATION))
                  return ye.Location = ye.Location_asArray[0], ye.Location;
              }
              function _t(ye) {
                if (ye && ye.hasOwnProperty(n.default.PATCH_LOCATION))
                  return ye.PatchLocation = ye.PatchLocation_asArray[0], ye.PatchLocation;
              }
              function dt(ye) {
                return ye && ye.hasOwnProperty(n.default.SUGGESTED_PRESENTATION_DELAY) ? ye.suggestedPresentationDelay : null;
              }
              function Tt(ye) {
                return ye && ye.hasOwnProperty(n.default.AVAILABILITY_START_TIME) && ye.availabilityStartTime !== null ? ye.availabilityStartTime.getTime() : null;
              }
              function wt(ye) {
                var Qe = [];
                if (ye && ye.hasOwnProperty(n.default.SERVICE_DESCRIPTION)) {
                  var ct = M(ye.ServiceDescription_asArray), Se;
                  try {
                    for (ct.s(); !(Se = ct.n()).done; ) {
                      var Be = Se.value, He = null, yt = null, zt = null, Nt = null, Dt = null, ar = null;
                      for (var Qt in Be)
                        Be.hasOwnProperty(Qt) && (Qt === n.default.ID ? He = Be[Qt] : Qt === n.default.SERVICE_DESCRIPTION_SCOPE ? yt = Be[Qt].schemeIdUri : Qt === n.default.SERVICE_DESCRIPTION_LATENCY ? zt = {
                          target: parseInt(Be[Qt].target),
                          max: parseInt(Be[Qt].max),
                          min: parseInt(Be[Qt].min),
                          referenceId: parseInt(Be[Qt].referenceId)
                        } : Qt === n.default.SERVICE_DESCRIPTION_PLAYBACK_RATE ? Nt = {
                          max: parseFloat(Be[Qt].max),
                          min: parseFloat(Be[Qt].min)
                        } : Qt === n.default.SERVICE_DESCRIPTION_OPERATING_QUALITY ? Dt = {
                          mediaType: Be[Qt].mediaType,
                          max: parseInt(Be[Qt].max),
                          min: parseInt(Be[Qt].min),
                          target: parseInt(Be[Qt].target),
                          type: Be[Qt].type,
                          maxQualityDifference: parseInt(Be[Qt].maxQualityDifference)
                        } : Qt === n.default.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH && (ar = {
                          mediaType: Be[Qt].mediaType,
                          max: parseInt(Be[Qt].max),
                          min: parseInt(Be[Qt].min),
                          target: parseInt(Be[Qt].target)
                        }));
                      Qe.push({
                        id: He,
                        schemeIdUri: yt,
                        latency: zt,
                        playbackRate: Nt,
                        operatingQuality: Dt,
                        operatingBandwidth: ar
                      });
                    }
                  } catch (Je) {
                    ct.e(Je);
                  } finally {
                    ct.f();
                  }
                }
                return Qe;
              }
              function Gt(ye) {
                var Qe = {};
                if (ye && ye.hasOwnProperty(n.default.SUPPLEMENTAL_PROPERTY)) {
                  var ct = M(ye.SupplementalProperty_asArray), Se;
                  try {
                    for (ct.s(); !(Se = ct.n()).done; ) {
                      var Be = Se.value;
                      Be.hasOwnProperty(g.default.SCHEME_ID_URI) && Be.hasOwnProperty(n.default.VALUE) && (Qe[Be[g.default.SCHEME_ID_URI]] = Be[n.default.VALUE]);
                    }
                  } catch (He) {
                    ct.e(He);
                  } finally {
                    ct.f();
                  }
                }
                return Qe;
              }
              function Xt(ye) {
                ye && (ye.errHandler && (ie = ye.errHandler), ye.BASE64 && (K = ye.BASE64));
              }
              return z = {
                getIsTypeOf: Q,
                getIsText: ge,
                getIsFragmented: oe,
                getProducerReferenceTimesForAdaptation: re,
                getLanguageForAdaptation: ue,
                getViewpointForAdaptation: te,
                getRolesForAdaptation: O,
                getAccessibilityForAdaptation: p,
                getAudioChannelConfigurationForAdaptation: P,
                getAudioChannelConfigurationForRepresentation: k,
                getAdaptationForIndex: le,
                getIndexForAdaptation: q,
                getAdaptationForId: ce,
                getAdaptationsForType: _e,
                getRealPeriods: W,
                getRealPeriodForIndex: $,
                getCodec: Ee,
                getSelectionPriority: Ke,
                getMimeType: Te,
                getKID: Ce,
                getLabelsForAdaptation: xe,
                getContentProtectionData: be,
                getIsDynamic: Ge,
                getId: Pe,
                hasProfile: Le,
                getDuration: je,
                getBandwidth: Ze,
                getManifestUpdatePeriod: nt,
                getPublishTime: it,
                getRepresentationCount: De,
                getBitrateListForAdaptation: Ye,
                getRepresentationFor: st,
                getRepresentationsForAdaptation: ht,
                getAdaptationsForPeriod: ve,
                getRegularPeriods: me,
                getMpd: we,
                getEventsForPeriod: at,
                getEssentialPropertiesForRepresentation: tt,
                getEventStreamForAdaptationSet: Mt,
                getEventStreamForRepresentation: Lt,
                getUTCTimingSources: bt,
                getBaseURLsFromElement: Ae,
                getRepresentationSortFunction: X,
                getContentSteering: ze,
                getLocation: qe,
                getPatchLocation: _t,
                getSuggestedPresentationDelay: dt,
                getAvailabilityStartTime: Tt,
                getServiceDescriptions: wt,
                getSupplementalProperties: Gt,
                setConfig: Xt
              }, fe(), z;
            }
            J.__dashjs_factory_name = "DashManifestModel";
            const H = o.default.getSingletonFactory(J);
          }
        ),
        /***/
        "./src/dash/models/PatchManifestModel.js": (
          /*!***********************************************!*\
            !*** ./src/dash/models/PatchManifestModel.js ***!
            \***********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => t
              /* harmony export */
            });
            var g = e(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), n = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), i = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), r = e(
              /*! ../vo/SimpleXPath */
              "./src/dash/vo/SimpleXPath.js"
            ), l = e(
              /*! ../vo/PatchOperation */
              "./src/dash/vo/PatchOperation.js"
            );
            function d() {
              var T, S, h = this.context;
              function _() {
                S = (0, i.default)(h).getInstance().getLogger(T);
              }
              function L(u) {
                return u && u.hasOwnProperty(g.default.ORIGINAL_MPD_ID) || !1;
              }
              function v(u) {
                return u && u.hasOwnProperty(g.default.PUBLISH_TIME) ? new Date(u[g.default.PUBLISH_TIME]) : null;
              }
              function c(u) {
                return u && u.hasOwnProperty(g.default.ORIGINAL_PUBLISH_TIME) ? new Date(u[g.default.ORIGINAL_PUBLISH_TIME]) : null;
              }
              function o(u) {
                return u && u[g.default.ORIGINAL_MPD_ID] || null;
              }
              function y(u) {
                return u ? (u.__children || []).map(function(A) {
                  var I = Object.keys(A)[0];
                  if (I !== "add" && I !== "remove" && I !== "replace")
                    return S.warn("Ignoring node of invalid action: ".concat(I)), null;
                  var M = A[I], E = M.sel;
                  if (I === "add" && M.type) {
                    if (!M.type.startsWith("@"))
                      return S.warn("Ignoring add action for prefixed namespace declaration: ".concat(M.type, "=").concat(M.__text)), null;
                    E = "".concat(E, "/").concat(M.type);
                  }
                  var N = new r.default(E);
                  if (!N.isValid())
                    return S.warn("Ignoring action with invalid selector: ".concat(I, " - ").concat(E)), null;
                  var C = null;
                  N.findsAttribute() ? C = M.__text || "" : I !== "remove" && (C = M.__children.reduce(function(w, V) {
                    var J = Object.keys(V)[0];
                    return J !== "#text" && (w[J] = w[J] || [], w[J].push(V[J])), w;
                  }, {}));
                  var b = new l.default(I, N, C);
                  return I === "add" && (b.position = M.pos), b;
                }).filter(function(A) {
                  return !!A;
                }) : [];
              }
              return T = {
                getIsPatch: L,
                getPublishTime: v,
                getOriginalPublishTime: c,
                getMpdId: o,
                getPatchOperations: y
              }, _(), T;
            }
            d.__dashjs_factory_name = "PatchManifestModel";
            const t = n.default.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/dash/parser/DashParser.js": (
          /*!***************************************!*\
            !*** ./src/dash/parser/DashParser.js ***!
            \***************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ./objectiron */
              "./src/dash/parser/objectiron.js"
            ), i = e(
              /*! ../../../externals/xml2json */
              "./externals/xml2json.js"
            ), r = e(
              /*! ./matchers/StringMatcher */
              "./src/dash/parser/matchers/StringMatcher.js"
            ), l = e(
              /*! ./matchers/DurationMatcher */
              "./src/dash/parser/matchers/DurationMatcher.js"
            ), d = e(
              /*! ./matchers/DateTimeMatcher */
              "./src/dash/parser/matchers/DateTimeMatcher.js"
            ), t = e(
              /*! ./matchers/NumericMatcher */
              "./src/dash/parser/matchers/NumericMatcher.js"
            ), T = e(
              /*! ./matchers/LangMatcher */
              "./src/dash/parser/matchers/LangMatcher.js"
            ), S = e(
              /*! ./maps/RepresentationBaseValuesMap */
              "./src/dash/parser/maps/RepresentationBaseValuesMap.js"
            ), h = e(
              /*! ./maps/SegmentValuesMap */
              "./src/dash/parser/maps/SegmentValuesMap.js"
            );
            function _(v) {
              v = v || {};
              var c = this.context, o = v.debug, y, u, A, I, M;
              function E() {
                u = o.getLogger(y), A = [
                  new l.default(),
                  new d.default(),
                  new t.default(),
                  new T.default(),
                  new r.default()
                  // last in list to take precedence over NumericMatcher
                ], I = new i.default({
                  escapeMode: !1,
                  attributePrefix: "",
                  arrayAccessForm: "property",
                  emptyNodeForm: "object",
                  stripWhitespaces: !1,
                  enableToStringFunc: !0,
                  ignoreRoot: !1,
                  matchers: A
                }), M = (0, n.default)(c).create({
                  adaptationset: new S.default(),
                  period: new h.default()
                });
              }
              function N() {
                return A;
              }
              function C() {
                return M;
              }
              function b(w) {
                var V, J = window.performance.now();
                if (V = I.xml_str2json(w), !V)
                  throw new Error("parsing the manifest failed");
                var H = window.performance.now();
                V.Patch ? (V = V.Patch, V.add_asArray && V.add_asArray.forEach(function(Z) {
                  return M.run(Z);
                }), V.replace_asArray && V.replace_asArray.forEach(function(Z) {
                  return M.run(Z);
                })) : (V = V.MPD, M.run(V));
                var z = window.performance.now();
                return u.info("Parsing complete: ( xml2json: " + (H - J).toPrecision(3) + "ms, objectiron: " + (z - H).toPrecision(3) + "ms, total: " + ((z - J) / 1e3).toPrecision(3) + "s)"), V.protocol = "DASH", V;
              }
              return y = {
                parse: b,
                getMatchers: N,
                getIron: C
              }, E(), y;
            }
            _.__dashjs_factory_name = "DashParser";
            const L = g.default.getClassFactory(_);
          }
        ),
        /***/
        "./src/dash/parser/maps/CommonProperty.js": (
          /*!************************************************!*\
            !*** ./src/dash/parser/maps/CommonProperty.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            function g(d, t) {
              if (!(d instanceof t))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(d, t) {
              for (var T = 0; T < t.length; T++) {
                var S = t[T];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(d, S.key, S);
              }
            }
            function i(d, t, T) {
              return t && n(d.prototype, t), T && n(d, T), d;
            }
            var r = /* @__PURE__ */ function() {
              function d(t) {
                g(this, d);
                var T = function(h) {
                  return h && h.length && h.charAt(0) === h.charAt(0).toUpperCase();
                };
                this._name = t, this._merge = T(t);
              }
              return i(d, [{
                key: "name",
                get: function() {
                  return this._name;
                }
              }, {
                key: "merge",
                get: function() {
                  return this._merge;
                }
              }]), d;
            }();
            const l = r;
          }
        ),
        /***/
        "./src/dash/parser/maps/MapNode.js": (
          /*!*****************************************!*\
            !*** ./src/dash/parser/maps/MapNode.js ***!
            \*****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ./CommonProperty */
              "./src/dash/parser/maps/CommonProperty.js"
            );
            function n(t, T) {
              if (!(t instanceof T))
                throw new TypeError("Cannot call a class as a function");
            }
            function i(t, T) {
              for (var S = 0; S < T.length; S++) {
                var h = T[S];
                h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(t, h.key, h);
              }
            }
            function r(t, T, S) {
              return T && i(t.prototype, T), S && i(t, S), t;
            }
            var l = /* @__PURE__ */ function() {
              function t(T, S, h) {
                var _ = this;
                n(this, t), this._name = T || "", this._properties = [], this._children = h || [], Array.isArray(S) && S.forEach(function(L) {
                  _._properties.push(new g.default(L));
                });
              }
              return r(t, [{
                key: "name",
                get: function() {
                  return this._name;
                }
              }, {
                key: "children",
                get: function() {
                  return this._children;
                }
              }, {
                key: "properties",
                get: function() {
                  return this._properties;
                }
              }]), t;
            }();
            const d = l;
          }
        ),
        /***/
        "./src/dash/parser/maps/RepresentationBaseValuesMap.js": (
          /*!*************************************************************!*\
            !*** ./src/dash/parser/maps/RepresentationBaseValuesMap.js ***!
            \*************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ./MapNode */
              "./src/dash/parser/maps/MapNode.js"
            ), n = e(
              /*! ../../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            );
            function i(c) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(y) {
                return typeof y;
              } : i = function(y) {
                return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
              }, i(c);
            }
            function r(c, o) {
              if (!(c instanceof o))
                throw new TypeError("Cannot call a class as a function");
            }
            function l(c, o) {
              if (typeof o != "function" && o !== null)
                throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(o && o.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), o && d(c, o);
            }
            function d(c, o) {
              return d = Object.setPrototypeOf || function(u, A) {
                return u.__proto__ = A, u;
              }, d(c, o);
            }
            function t(c) {
              var o = h();
              return function() {
                var u = _(c), A;
                if (o) {
                  var I = _(this).constructor;
                  A = Reflect.construct(u, arguments, I);
                } else
                  A = u.apply(this, arguments);
                return T(this, A);
              };
            }
            function T(c, o) {
              return o && (i(o) === "object" || typeof o == "function") ? o : S(c);
            }
            function S(c) {
              if (c === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return c;
            }
            function h() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function _(c) {
              return _ = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, _(c);
            }
            var L = /* @__PURE__ */ function(c) {
              l(y, c);
              var o = t(y);
              function y() {
                r(this, y);
                var u = [n.default.PROFILES, n.default.WIDTH, n.default.HEIGHT, n.default.SAR, n.default.FRAMERATE, n.default.AUDIO_SAMPLING_RATE, n.default.MIME_TYPE, n.default.SEGMENT_PROFILES, n.default.CODECS, n.default.MAXIMUM_SAP_PERIOD, n.default.START_WITH_SAP, n.default.MAX_PLAYOUT_RATE, n.default.CODING_DEPENDENCY, n.default.SCAN_TYPE, n.default.FRAME_PACKING, n.default.AUDIO_CHANNEL_CONFIGURATION, n.default.CONTENT_PROTECTION, n.default.ESSENTIAL_PROPERTY, n.default.SUPPLEMENTAL_PROPERTY, n.default.INBAND_EVENT_STREAM];
                return o.call(this, n.default.ADAPTATION_SET, u, [new g.default(n.default.REPRESENTATION, u, [new g.default(n.default.SUB_REPRESENTATION, u)])]);
              }
              return y;
            }(g.default);
            const v = L;
          }
        ),
        /***/
        "./src/dash/parser/maps/SegmentValuesMap.js": (
          /*!**************************************************!*\
            !*** ./src/dash/parser/maps/SegmentValuesMap.js ***!
            \**************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ./MapNode */
              "./src/dash/parser/maps/MapNode.js"
            ), n = e(
              /*! ../../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            );
            function i(c) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(y) {
                return typeof y;
              } : i = function(y) {
                return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
              }, i(c);
            }
            function r(c, o) {
              if (!(c instanceof o))
                throw new TypeError("Cannot call a class as a function");
            }
            function l(c, o) {
              if (typeof o != "function" && o !== null)
                throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(o && o.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), o && d(c, o);
            }
            function d(c, o) {
              return d = Object.setPrototypeOf || function(u, A) {
                return u.__proto__ = A, u;
              }, d(c, o);
            }
            function t(c) {
              var o = h();
              return function() {
                var u = _(c), A;
                if (o) {
                  var I = _(this).constructor;
                  A = Reflect.construct(u, arguments, I);
                } else
                  A = u.apply(this, arguments);
                return T(this, A);
              };
            }
            function T(c, o) {
              return o && (i(o) === "object" || typeof o == "function") ? o : S(c);
            }
            function S(c) {
              if (c === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return c;
            }
            function h() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function _(c) {
              return _ = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, _(c);
            }
            var L = /* @__PURE__ */ function(c) {
              l(y, c);
              var o = t(y);
              function y() {
                r(this, y);
                var u = [n.default.SEGMENT_BASE, n.default.SEGMENT_TEMPLATE, n.default.SEGMENT_LIST];
                return o.call(this, n.default.PERIOD, u, [new g.default(n.default.ADAPTATION_SET, u, [new g.default(n.default.REPRESENTATION, u)])]);
              }
              return y;
            }(g.default);
            const v = L;
          }
        ),
        /***/
        "./src/dash/parser/matchers/BaseMatcher.js": (
          /*!*************************************************!*\
            !*** ./src/dash/parser/matchers/BaseMatcher.js ***!
            \*************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            function g(d, t) {
              if (!(d instanceof t))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(d, t) {
              for (var T = 0; T < t.length; T++) {
                var S = t[T];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(d, S.key, S);
              }
            }
            function i(d, t, T) {
              return t && n(d.prototype, t), T && n(d, T), d;
            }
            var r = /* @__PURE__ */ function() {
              function d(t, T) {
                g(this, d), this._test = t, this._converter = T;
              }
              return i(d, [{
                key: "test",
                get: function() {
                  return this._test;
                }
              }, {
                key: "converter",
                get: function() {
                  return this._converter;
                }
              }]), d;
            }();
            const l = r;
          }
        ),
        /***/
        "./src/dash/parser/matchers/DateTimeMatcher.js": (
          /*!*****************************************************!*\
            !*** ./src/dash/parser/matchers/DateTimeMatcher.js ***!
            \*****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => y
              /* harmony export */
            });
            var g = e(
              /*! ./BaseMatcher */
              "./src/dash/parser/matchers/BaseMatcher.js"
            );
            function n(u) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(I) {
                return typeof I;
              } : n = function(I) {
                return I && typeof Symbol == "function" && I.constructor === Symbol && I !== Symbol.prototype ? "symbol" : typeof I;
              }, n(u);
            }
            function i(u, A) {
              if (!(u instanceof A))
                throw new TypeError("Cannot call a class as a function");
            }
            function r(u, A) {
              if (typeof A != "function" && A !== null)
                throw new TypeError("Super expression must either be null or a function");
              u.prototype = Object.create(A && A.prototype, { constructor: { value: u, writable: !0, configurable: !0 } }), A && l(u, A);
            }
            function l(u, A) {
              return l = Object.setPrototypeOf || function(M, E) {
                return M.__proto__ = E, M;
              }, l(u, A);
            }
            function d(u) {
              var A = S();
              return function() {
                var M = h(u), E;
                if (A) {
                  var N = h(this).constructor;
                  E = Reflect.construct(M, arguments, N);
                } else
                  E = M.apply(this, arguments);
                return t(this, E);
              };
            }
            function t(u, A) {
              return A && (n(A) === "object" || typeof A == "function") ? A : T(u);
            }
            function T(u) {
              if (u === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function h(u) {
              return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(I) {
                return I.__proto__ || Object.getPrototypeOf(I);
              }, h(u);
            }
            var _ = 60, L = 60, v = 1e3, c = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})(?::?)([0-9]{2}))?/, o = /* @__PURE__ */ function(u) {
              r(I, u);
              var A = d(I);
              function I() {
                return i(this, I), A.call(this, function(M) {
                  return c.test(M.value);
                }, function(M) {
                  var E = c.exec(M), N;
                  if (N = Date.UTC(
                    parseInt(E[1], 10),
                    parseInt(E[2], 10) - 1,
                    // months start from zero
                    parseInt(E[3], 10),
                    parseInt(E[4], 10),
                    parseInt(E[5], 10),
                    E[6] && parseInt(E[6], 10) || 0,
                    E[7] && parseFloat(E[7]) * v || 0
                  ), E[9] && E[10]) {
                    var C = parseInt(E[9], 10) * L + parseInt(E[10], 10);
                    N += (E[8] === "+" ? -1 : 1) * C * _ * v;
                  }
                  return new Date(N);
                });
              }
              return I;
            }(g.default);
            const y = o;
          }
        ),
        /***/
        "./src/dash/parser/matchers/DurationMatcher.js": (
          /*!*****************************************************!*\
            !*** ./src/dash/parser/matchers/DurationMatcher.js ***!
            \*****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => M
              /* harmony export */
            });
            var g = e(
              /*! ./BaseMatcher */
              "./src/dash/parser/matchers/BaseMatcher.js"
            ), n = e(
              /*! ../../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), i = e(
              /*! ../../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            );
            function r(E) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(C) {
                return typeof C;
              } : r = function(C) {
                return C && typeof Symbol == "function" && C.constructor === Symbol && C !== Symbol.prototype ? "symbol" : typeof C;
              }, r(E);
            }
            function l(E, N) {
              if (!(E instanceof N))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(E, N) {
              if (typeof N != "function" && N !== null)
                throw new TypeError("Super expression must either be null or a function");
              E.prototype = Object.create(N && N.prototype, { constructor: { value: E, writable: !0, configurable: !0 } }), N && t(E, N);
            }
            function t(E, N) {
              return t = Object.setPrototypeOf || function(b, w) {
                return b.__proto__ = w, b;
              }, t(E, N);
            }
            function T(E) {
              var N = _();
              return function() {
                var b = L(E), w;
                if (N) {
                  var V = L(this).constructor;
                  w = Reflect.construct(b, arguments, V);
                } else
                  w = b.apply(this, arguments);
                return S(this, w);
              };
            }
            function S(E, N) {
              return N && (r(N) === "object" || typeof N == "function") ? N : h(E);
            }
            function h(E) {
              if (E === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return E;
            }
            function _() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function L(E) {
              return L = Object.setPrototypeOf ? Object.getPrototypeOf : function(C) {
                return C.__proto__ || Object.getPrototypeOf(C);
              }, L(E);
            }
            var v = /^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?T?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*)S)?/, c = 365 * 24 * 60 * 60, o = 30 * 24 * 60 * 60, y = 24 * 60 * 60, u = 60 * 60, A = 60, I = /* @__PURE__ */ function(E) {
              d(C, E);
              var N = T(C);
              function C() {
                return l(this, C), N.call(this, function(b) {
                  for (var w = [i.default.MIN_BUFFER_TIME, i.default.MEDIA_PRESENTATION_DURATION, i.default.MINIMUM_UPDATE_PERIOD, i.default.TIMESHIFT_BUFFER_DEPTH, i.default.MAX_SEGMENT_DURATION, i.default.MAX_SUBSEGMENT_DURATION, i.default.SUGGESTED_PRESENTATION_DELAY, i.default.START, n.default.START_TIME, i.default.DURATION], V = w.length, J = 0; J < V; J++)
                    if (b.nodeName === w[J])
                      return v.test(b.value);
                  return !1;
                }, function(b) {
                  var w = v.exec(b), V = parseFloat(w[3] || 0) * c + parseFloat(w[5] || 0) * o + parseFloat(w[7] || 0) * y + parseFloat(w[9] || 0) * u + parseFloat(w[11] || 0) * A + parseFloat(w[13] || 0);
                  return w[1] !== void 0 && (V = -V), V;
                });
              }
              return C;
            }(g.default);
            const M = I;
          }
        ),
        /***/
        "./src/dash/parser/matchers/LangMatcher.js": (
          /*!*************************************************!*\
            !*** ./src/dash/parser/matchers/LangMatcher.js ***!
            \*************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => y
              /* harmony export */
            });
            var g = e(
              /*! ./BaseMatcher */
              "./src/dash/parser/matchers/BaseMatcher.js"
            ), n = e(
              /*! ../../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), i = e(
              /*! bcp-47-normalize */
              "./node_modules/bcp-47-normalize/index.js"
            ), r = /* @__PURE__ */ e.n(i);
            function l(u) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? l = function(I) {
                return typeof I;
              } : l = function(I) {
                return I && typeof Symbol == "function" && I.constructor === Symbol && I !== Symbol.prototype ? "symbol" : typeof I;
              }, l(u);
            }
            function d(u, A, I) {
              return A in u ? Object.defineProperty(u, A, { value: I, enumerable: !0, configurable: !0, writable: !0 }) : u[A] = I, u;
            }
            function t(u, A) {
              if (!(u instanceof A))
                throw new TypeError("Cannot call a class as a function");
            }
            function T(u, A) {
              if (typeof A != "function" && A !== null)
                throw new TypeError("Super expression must either be null or a function");
              u.prototype = Object.create(A && A.prototype, { constructor: { value: u, writable: !0, configurable: !0 } }), A && S(u, A);
            }
            function S(u, A) {
              return S = Object.setPrototypeOf || function(M, E) {
                return M.__proto__ = E, M;
              }, S(u, A);
            }
            function h(u) {
              var A = v();
              return function() {
                var M = c(u), E;
                if (A) {
                  var N = c(this).constructor;
                  E = Reflect.construct(M, arguments, N);
                } else
                  E = M.apply(this, arguments);
                return _(this, E);
              };
            }
            function _(u, A) {
              return A && (l(A) === "object" || typeof A == "function") ? A : L(u);
            }
            function L(u) {
              if (u === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }
            function v() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function c(u) {
              return c = Object.setPrototypeOf ? Object.getPrototypeOf : function(I) {
                return I.__proto__ || Object.getPrototypeOf(I);
              }, c(u);
            }
            var o = /* @__PURE__ */ function(u) {
              T(I, u);
              var A = h(I);
              function I() {
                return t(this, I), A.call(this, function(M, E) {
                  var N, C = (N = {}, d(N, n.default.ADAPTATION_SET, [n.default.LANG]), d(N, n.default.REPRESENTATION, [n.default.LANG]), d(N, n.default.CONTENT_COMPONENT, [n.default.LANG]), d(N, n.default.LABEL, [n.default.LANG]), d(N, n.default.GROUP_LABEL, [n.default.LANG]), N);
                  if (C.hasOwnProperty(E)) {
                    var b = C[E];
                    return b !== void 0 ? b.indexOf(M.name) >= 0 : !1;
                  }
                  return !1;
                }, function(M) {
                  var E = r()(M);
                  return E !== void 0 ? E : String(M);
                });
              }
              return I;
            }(g.default);
            const y = o;
          }
        ),
        /***/
        "./src/dash/parser/matchers/NumericMatcher.js": (
          /*!****************************************************!*\
            !*** ./src/dash/parser/matchers/NumericMatcher.js ***!
            \****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ./BaseMatcher */
              "./src/dash/parser/matchers/BaseMatcher.js"
            );
            function n(c) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(y) {
                return typeof y;
              } : n = function(y) {
                return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
              }, n(c);
            }
            function i(c, o) {
              if (!(c instanceof o))
                throw new TypeError("Cannot call a class as a function");
            }
            function r(c, o) {
              if (typeof o != "function" && o !== null)
                throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(o && o.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), o && l(c, o);
            }
            function l(c, o) {
              return l = Object.setPrototypeOf || function(u, A) {
                return u.__proto__ = A, u;
              }, l(c, o);
            }
            function d(c) {
              var o = S();
              return function() {
                var u = h(c), A;
                if (o) {
                  var I = h(this).constructor;
                  A = Reflect.construct(u, arguments, I);
                } else
                  A = u.apply(this, arguments);
                return t(this, A);
              };
            }
            function t(c, o) {
              return o && (n(o) === "object" || typeof o == "function") ? o : T(c);
            }
            function T(c) {
              if (c === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return c;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function h(c) {
              return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, h(c);
            }
            var _ = /^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/, L = /* @__PURE__ */ function(c) {
              r(y, c);
              var o = d(y);
              function y() {
                return i(this, y), o.call(this, function(u) {
                  return _.test(u.value);
                }, function(u) {
                  return parseFloat(u);
                });
              }
              return y;
            }(g.default);
            const v = L;
          }
        ),
        /***/
        "./src/dash/parser/matchers/StringMatcher.js": (
          /*!***************************************************!*\
            !*** ./src/dash/parser/matchers/StringMatcher.js ***!
            \***************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => c
              /* harmony export */
            });
            var g = e(
              /*! ./BaseMatcher */
              "./src/dash/parser/matchers/BaseMatcher.js"
            ), n = e(
              /*! ../../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            );
            function i(o) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(u) {
                return typeof u;
              } : i = function(u) {
                return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
              }, i(o);
            }
            function r(o, y, u) {
              return y in o ? Object.defineProperty(o, y, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : o[y] = u, o;
            }
            function l(o, y) {
              if (!(o instanceof y))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(o, y) {
              if (typeof y != "function" && y !== null)
                throw new TypeError("Super expression must either be null or a function");
              o.prototype = Object.create(y && y.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), y && t(o, y);
            }
            function t(o, y) {
              return t = Object.setPrototypeOf || function(A, I) {
                return A.__proto__ = I, A;
              }, t(o, y);
            }
            function T(o) {
              var y = _();
              return function() {
                var A = L(o), I;
                if (y) {
                  var M = L(this).constructor;
                  I = Reflect.construct(A, arguments, M);
                } else
                  I = A.apply(this, arguments);
                return S(this, I);
              };
            }
            function S(o, y) {
              return y && (i(y) === "object" || typeof y == "function") ? y : h(o);
            }
            function h(o) {
              if (o === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return o;
            }
            function _() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function L(o) {
              return L = Object.setPrototypeOf ? Object.getPrototypeOf : function(u) {
                return u.__proto__ || Object.getPrototypeOf(u);
              }, L(o);
            }
            var v = /* @__PURE__ */ function(o) {
              d(u, o);
              var y = T(u);
              function u() {
                return l(this, u), y.call(this, function(A, I) {
                  var M, E = (M = {}, r(M, n.default.MPD, [n.default.ID, n.default.PROFILES]), r(M, n.default.PERIOD, [n.default.ID]), r(M, n.default.BASE_URL, [n.default.SERVICE_LOCATION, n.default.BYTE_RANGE]), r(M, n.default.SEGMENT_BASE, [n.default.INDEX_RANGE]), r(M, n.default.INITIALIZATION, [n.default.RANGE]), r(M, n.default.REPRESENTATION_INDEX, [n.default.RANGE]), r(M, n.default.SEGMENT_LIST, [n.default.INDEX_RANGE]), r(M, n.default.BITSTREAM_SWITCHING, [n.default.RANGE]), r(M, n.default.SEGMENT_URL, [n.default.MEDIA_RANGE, n.default.INDEX_RANGE]), r(M, n.default.SEGMENT_TEMPLATE, [n.default.INDEX_RANGE, n.default.MEDIA, n.default.INDEX, n.default.INITIALIZATION_MINUS, n.default.BITSTREAM_SWITCHING_MINUS]), r(M, n.default.ASSET_IDENTIFIER, [n.default.VALUE, n.default.ID]), r(M, n.default.EVENT_STREAM, [n.default.VALUE]), r(M, n.default.ADAPTATION_SET, [n.default.PROFILES, n.default.MIME_TYPE, n.default.SEGMENT_PROFILES, n.default.CODECS, n.default.CONTENT_TYPE]), r(M, n.default.FRAME_PACKING, [n.default.VALUE, n.default.ID]), r(M, n.default.AUDIO_CHANNEL_CONFIGURATION, [n.default.VALUE, n.default.ID]), r(M, n.default.CONTENT_PROTECTION, [n.default.VALUE, n.default.ID]), r(M, n.default.ESSENTIAL_PROPERTY, [n.default.VALUE, n.default.ID]), r(M, n.default.SUPPLEMENTAL_PROPERTY, [n.default.VALUE, n.default.ID]), r(M, n.default.INBAND_EVENT_STREAM, [n.default.VALUE, n.default.ID]), r(M, n.default.ACCESSIBILITY, [n.default.VALUE, n.default.ID]), r(M, n.default.ROLE, [n.default.VALUE, n.default.ID]), r(M, n.default.RATING, [n.default.VALUE, n.default.ID]), r(M, n.default.VIEWPOINT, [n.default.VALUE, n.default.ID]), r(M, n.default.CONTENT_COMPONENT, [n.default.CONTENT_TYPE]), r(M, n.default.REPRESENTATION, [n.default.ID, n.default.DEPENDENCY_ID, n.default.MEDIA_STREAM_STRUCTURE_ID]), r(M, n.default.SUBSET, [n.default.ID]), r(M, n.default.METRICS, [n.default.METRICS_MINUS]), r(M, n.default.REPORTING, [n.default.VALUE, n.default.ID]), M);
                  if (E.hasOwnProperty(I)) {
                    var N = E[I];
                    return N !== void 0 ? N.indexOf(A.name) >= 0 : !1;
                  }
                  return !1;
                }, function(A) {
                  return String(A);
                });
              }
              return u;
            }(g.default);
            const c = v;
          }
        ),
        /***/
        "./src/dash/parser/objectiron.js": (
          /*!***************************************!*\
            !*** ./src/dash/parser/objectiron.js ***!
            \***************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n(d) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(T) {
                return typeof T;
              } : n = function(T) {
                return T && typeof Symbol == "function" && T.constructor === Symbol && T !== Symbol.prototype ? "symbol" : typeof T;
              }, n(d);
            }
            function i(d) {
              function t(_, L) {
                for (var v in _)
                  L.hasOwnProperty(v) || (L[v] = _[v]);
              }
              function T(_, L, v) {
                for (var c = 0, o = _.length; c < o; ++c) {
                  var y = _[c];
                  if (L[y.name])
                    if (v[y.name]) {
                      if (y.merge) {
                        var u = L[y.name], A = v[y.name];
                        n(u) === "object" && n(A) === "object" ? t(u, A) : v[y.name] = u + A;
                      }
                    } else
                      v[y.name] = L[y.name];
                }
              }
              function S(_, L) {
                for (var v = 0, c = _.children.length; v < c; ++v) {
                  var o = _.children[v], y = L[o.name + "_asArray"];
                  if (y)
                    for (var u = 0, A = y.length; u < A; ++u) {
                      var I = y[u];
                      T(_.properties, L, I), S(o, I);
                    }
                }
              }
              function h(_) {
                if (_ === null || n(_) !== "object")
                  return _;
                if (_.Period_asArray && "period" in d)
                  for (var L = d.period, v = _.Period_asArray, c = 0, o = v.length; c < o; ++c) {
                    var y = v[c];
                    if (S(L, y), "adaptationset" in d) {
                      var u = y.AdaptationSet_asArray;
                      if (u)
                        for (var A = d.adaptationset, I = 0, M = u.length; I < M; ++I)
                          S(A, u[I]);
                    }
                  }
                return _;
              }
              return {
                run: h
              };
            }
            i.__dashjs_factory_name = "ObjectIron";
            var r = g.default.getClassFactory(i);
            const l = r;
          }
        ),
        /***/
        "./src/dash/utils/ListSegmentsGetter.js": (
          /*!**********************************************!*\
            !*** ./src/dash/utils/ListSegmentsGetter.js ***!
            \**********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), i = e(
              /*! ./SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            );
            function r(t, T) {
              t = t || {};
              var S = t.timelineConverter, h;
              function _() {
                if (!S || !S.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime"))
                  throw new Error(n.default.MISSING_CONFIG_ERROR);
              }
              function L(o) {
                var y = {
                  numberOfSegments: 0,
                  mediaTimeOfLastSignaledSegment: NaN
                };
                if (!o)
                  return y;
                var u = o.adaptation.period.mpd.manifest.Period_asArray[o.adaptation.period.index].AdaptationSet_asArray[o.adaptation.index].Representation_asArray[o.index].SegmentList, A = o && !isNaN(o.startNumber) ? o.startNumber : 1, I = Math.max(A - 1, 0);
                return y.numberOfSegments = I + u.SegmentURL_asArray.length, y;
              }
              function v(o, y) {
                if (_(), !o)
                  return null;
                var u = o.adaptation.period.mpd.manifest.Period_asArray[o.adaptation.period.index].AdaptationSet_asArray[o.adaptation.index].Representation_asArray[o.index].SegmentList, A = u.SegmentURL_asArray.length, I = o && !isNaN(o.startNumber) ? o.startNumber : 1, M = Math.max(I - 1, 0), E = Math.max(y - M, 0), N = null;
                if (E < A) {
                  var C = u.SegmentURL_asArray[E];
                  N = (0, i.getIndexBasedSegment)(S, T, o, y), N && (N.replacementTime = (I + y - 1) * o.segmentDuration, N.media = C.media ? C.media : "", N.mediaRange = C.mediaRange, N.indexRange = C.indexRange);
                }
                return N;
              }
              function c(o, y) {
                if (_(), !o)
                  return null;
                var u = o.segmentDuration;
                if (isNaN(u))
                  return null;
                var A = S.calcPeriodRelativeTimeFromMpdRelativeTime(o, y), I = Math.floor(A / u);
                return v(o, I);
              }
              return h = {
                getSegmentByIndex: v,
                getSegmentByTime: c,
                getMediaFinishedInformation: L
              }, h;
            }
            r.__dashjs_factory_name = "ListSegmentsGetter";
            var l = g.default.getClassFactory(r);
            const d = l;
          }
        ),
        /***/
        "./src/dash/utils/Round10.js": (
          /*!***********************************!*\
            !*** ./src/dash/utils/Round10.js ***!
            \***********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => (
                /* binding */
                r
              )
              /* harmony export */
            });
            function g(d, t) {
              if (!(d instanceof t))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(d, t) {
              for (var T = 0; T < t.length; T++) {
                var S = t[T];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(d, S.key, S);
              }
            }
            function i(d, t, T) {
              return t && n(d.prototype, t), T && n(d, T), d;
            }
            var r = /* @__PURE__ */ function() {
              function d() {
                g(this, d);
              }
              return i(d, null, [{
                key: "round10",
                value: (
                  /**
                  * Decimal round.
                  *
                  * @param {Number}  value The number.
                  * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
                  * @returns {Number} The adjusted value.
                  * @ignore
                  */
                  function(T, S) {
                    return l("round", T, S);
                  }
                )
              }]), d;
            }();
            function l(d, t, T) {
              return typeof T > "u" || +T == 0 ? Math[d](t) : (t = +t, T = +T, t === null || isNaN(t) || !(typeof T == "number" && T % 1 === 0) ? NaN : (t = t.toString().split("e"), t = Math[d](+(t[0] + "e" + (t[1] ? +t[1] - T : -T))), t = t.toString().split("e"), +(t[0] + "e" + (t[1] ? +t[1] + T : T))));
            }
          }
        ),
        /***/
        "./src/dash/utils/SegmentBaseGetter.js": (
          /*!*********************************************!*\
            !*** ./src/dash/utils/SegmentBaseGetter.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            );
            function i(d) {
              d = d || {};
              var t = d.timelineConverter, T;
              function S() {
                if (!t || !t.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime"))
                  throw new Error(n.default.MISSING_CONFIG_ERROR);
              }
              function h(c) {
                var o = {
                  numberOfSegments: 0,
                  mediaTimeOfLastSignaledSegment: NaN
                };
                return !c || !c.segments || (o.numberOfSegments = c.segments.length), o;
              }
              function _(c, o) {
                if (S(), !c)
                  return null;
                var y = c.segments ? c.segments.length : -1, u;
                if (o < y && (u = c.segments[o], u && u.index === o))
                  return u;
                for (var A = 0; A < y; A++)
                  if (u = c.segments[A], u && u.index === o)
                    return u;
                return null;
              }
              function L(c, o) {
                S();
                var y = v(c, o);
                return _(c, y);
              }
              function v(c, o) {
                if (!c)
                  return -1;
                var y = c.segments, u = y ? y.length : null, A = -1, I, M, E, N, C;
                if (y && u > 0) {
                  for (C = 0; C < u; C++)
                    if (M = y[C], E = M.presentationStartTime, N = M.duration, I = N / 2, o + I >= E && o - I < E + N) {
                      A = M.index;
                      break;
                    }
                }
                return A;
              }
              return T = {
                getSegmentByIndex: _,
                getSegmentByTime: L,
                getMediaFinishedInformation: h
              }, T;
            }
            i.__dashjs_factory_name = "SegmentBaseGetter";
            var r = g.default.getClassFactory(i);
            const l = r;
          }
        ),
        /***/
        "./src/dash/utils/SegmentsUtils.js": (
          /*!*****************************************!*\
            !*** ./src/dash/utils/SegmentsUtils.js ***!
            \*****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              getIndexBasedSegment: () => (
                /* binding */
                S
              ),
              /* harmony export */
              getTimeBasedSegment: () => (
                /* binding */
                h
              ),
              /* harmony export */
              replaceIDForTemplate: () => (
                /* binding */
                l
              ),
              /* harmony export */
              replaceTokenForTemplate: () => (
                /* binding */
                d
              ),
              /* harmony export */
              unescapeDollarsInTemplate: () => (
                /* binding */
                r
              )
              /* harmony export */
            });
            var g = e(
              /*! ./../vo/Segment */
              "./src/dash/vo/Segment.js"
            );
            function n(_, L) {
              for (; _.length < L; )
                _ = "0" + _;
              return _;
            }
            function i(_, L) {
              return _.representation.startNumber + L;
            }
            function r(_) {
              return _ && _.split("$$").join("$");
            }
            function l(_, L) {
              if (!L || !_ || _.indexOf("$RepresentationID$") === -1)
                return _;
              var v = L.toString();
              return _.split("$RepresentationID$").join(v);
            }
            function d(_, L, v) {
              var c = "%0", o, y, u, A, I, M, E = L.length, N = c.length;
              if (!_)
                return _;
              for (; ; ) {
                if (o = _.indexOf("$" + L), o < 0 || (y = _.indexOf("$", o + E), y < 0))
                  return _;
                if (u = _.indexOf(c, o + E), u > o && u < y)
                  switch (A = _.charAt(y - 1), I = parseInt(_.substring(u + N, y - 1), 10), A) {
                    case "d":
                    case "i":
                    case "u":
                      M = n(v.toString(), I);
                      break;
                    case "x":
                      M = n(v.toString(16), I);
                      break;
                    case "X":
                      M = n(v.toString(16), I).toUpperCase();
                      break;
                    case "o":
                      M = n(v.toString(8), I);
                      break;
                    default:
                      return _;
                  }
                else
                  M = v;
                _ = _.substring(0, o) + M + _.substring(y + 1);
              }
            }
            function t(_, L, v, c, o, y, u, A) {
              var I = new g.default();
              return I.representation = _, I.duration = L, I.presentationStartTime = v, I.mediaStartTime = c, I.availabilityStartTime = o.calcAvailabilityStartTimeFromPresentationTime(y, _, u), I.availabilityEndTime = o.calcAvailabilityEndTimeFromPresentationTime(y + L, _, u), I.wallStartTime = o.calcWallTimeForSegment(I, u), I.replacementNumber = i(I, A), I.index = A, I;
            }
            function T(_, L, v, c) {
              var o = L.adaptation.period;
              if (isFinite(o.duration) && o.start + o.duration <= v.presentationStartTime)
                return !1;
              if (c) {
                if (L.availabilityTimeOffset === "INF")
                  return !0;
                var y = _.getClientReferenceTime();
                return v.availabilityStartTime.getTime() <= y && (!isFinite(v.availabilityEndTime) || v.availabilityEndTime.getTime() >= y);
              }
              return !0;
            }
            function S(_, L, v, c) {
              var o, y, u;
              o = v.segmentDuration, isNaN(o) && (o = v.adaptation.period.duration), y = parseFloat((v.adaptation.period.start + c * o).toFixed(5)), u = parseFloat((y + o).toFixed(5));
              var A = _.calcMediaTimeFromPresentationTime(y, v), I = t(v, o, y, A, _, u, L, c);
              return T(_, v, I, L) ? I : null;
            }
            function h(_, L, v, c, o, y, u, A, I, M) {
              var E = c / y, N = o / y, C, b, w;
              return C = _.calcPresentationTimeFromMediaTime(E, v), b = C + N, w = t(v, N, C, E, _, b, L, I), T(_, v, w, L) ? (w.replacementTime = M || c, u = d(u, "Number", w.replacementNumber), u = d(u, "Time", w.replacementTime), w.media = u, w.mediaRange = A, w) : null;
            }
          }
        ),
        /***/
        "./src/dash/utils/TemplateSegmentsGetter.js": (
          /*!**************************************************!*\
            !*** ./src/dash/utils/TemplateSegmentsGetter.js ***!
            \**************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), i = e(
              /*! ./SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            );
            function r(t, T) {
              t = t || {};
              var S = t.timelineConverter, h;
              function _() {
                if (!S || !S.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime"))
                  throw new Error(n.default.MISSING_CONFIG_ERROR);
              }
              function L(o) {
                var y = {
                  numberOfSegments: 0,
                  mediaTimeOfLastSignaledSegment: NaN
                };
                if (!o)
                  return y;
                var u = o.segmentDuration;
                return isNaN(u) ? y.numberOfSegments = 1 : y.numberOfSegments = Math.ceil(o.adaptation.period.duration / u), y;
              }
              function v(o, y) {
                if (_(), !o)
                  return null;
                var u = o.adaptation.period.mpd.manifest.Period_asArray[o.adaptation.period.index].AdaptationSet_asArray[o.adaptation.index].Representation_asArray[o.index].SegmentTemplate;
                y = Math.max(y, 0);
                var A = (0, i.getIndexBasedSegment)(S, T, o, y);
                if (A) {
                  A.replacementTime = Math.round((y - 1) * o.segmentDuration * o.timescale, 10);
                  var I = u.media;
                  I = (0, i.replaceTokenForTemplate)(I, "Number", A.replacementNumber), I = (0, i.replaceTokenForTemplate)(I, "Time", A.replacementTime), A.media = I;
                }
                return A;
              }
              function c(o, y) {
                if (_(), !o)
                  return null;
                var u = o.segmentDuration;
                if (isNaN(u))
                  return null;
                var A = S.calcPeriodRelativeTimeFromMpdRelativeTime(o, y), I = Math.floor(A / u);
                return v(o, I);
              }
              return h = {
                getSegmentByIndex: v,
                getSegmentByTime: c,
                getMediaFinishedInformation: L
              }, h;
            }
            r.__dashjs_factory_name = "TemplateSegmentsGetter";
            var l = g.default.getClassFactory(r);
            const d = l;
          }
        ),
        /***/
        "./src/dash/utils/TimelineConverter.js": (
          /*!*********************************************!*\
            !*** ./src/dash/utils/TimelineConverter.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => _
              /* harmony export */
            });
            var g = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), n = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), i = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), l = e(
              /*! ../models/DashManifestModel */
              "./src/dash/models/DashManifestModel.js"
            ), d = e(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), t = e(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), T = e(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), S = e(
              /*! ../../streaming/constants/ConformanceViolationConstants */
              "./src/streaming/constants/ConformanceViolationConstants.js"
            );
            function h() {
              var L = this.context, v = (0, g.default)(L).getInstance(), c = (0, d.default)(L).getInstance(), o, y, u, A;
              function I() {
                y = (0, l.default)(L).getInstance(), ge();
              }
              function M() {
                Me(), v.on(n.default.UPDATE_TIME_SYNC_OFFSET, de, this);
              }
              function E() {
                return A;
              }
              function N(se) {
                A = se;
              }
              function C() {
                return Date.now() - u * 1e3 + A * 1e3;
              }
              function b(se, ee, re, ue) {
                var te, O = ee.adaptation.period.mpd, p = O.availabilityStartTime;
                if (ue)
                  re && O.timeShiftBufferDepth !== Number.POSITIVE_INFINITY ? te = new Date(p.getTime() + (se + O.timeShiftBufferDepth) * 1e3) : te = O.availabilityEndTime;
                else if (re) {
                  var P = ee.availabilityTimeOffset;
                  te = new Date(p.getTime() + (se - P) * 1e3);
                } else
                  te = p;
                return te;
              }
              function w(se, ee, re) {
                return b(se, ee, re);
              }
              function V(se, ee, re) {
                return b(se, ee, re, !0);
              }
              function J(se, ee) {
                return (se.getTime() - ee.mpd.availabilityStartTime.getTime() + A * 1e3) / 1e3;
              }
              function H(se, ee) {
                var re = ee.adaptation.period.start, ue = ee.presentationTimeOffset;
                return se + (re - ue);
              }
              function z(se, ee) {
                var re = ee.adaptation.period.start, ue = ee.presentationTimeOffset;
                return se - re + ue;
              }
              function Z(se, ee) {
                var re, ue, te;
                return ee && (re = se.representation.adaptation.period.mpd.suggestedPresentationDelay, ue = se.presentationStartTime + re, te = new Date(se.availabilityStartTime.getTime() + ue * 1e3)), te;
              }
              function ie(se, ee) {
                if (!ee)
                  return K(se);
                if (c.get().streaming.timeShiftBuffer.calcFromSegmentTimeline) {
                  var re = ne(se);
                  return ae(re.now, re.range), re.range;
                }
                return Y(se);
              }
              function K(se) {
                var ee = {
                  start: NaN,
                  end: NaN
                }, re = 0, ue = NaN;
                return se.forEach(function(te) {
                  var O = te.getStreamInfo();
                  re += O.duration, (isNaN(ue) || O.start < ue) && (ue = O.start);
                }), ee.start = ue, ee.end = ue + re, ee;
              }
              function Y(se) {
                var ee = {
                  start: NaN,
                  end: NaN
                };
                if (!se || se.length === 0)
                  return ee;
                var re = se[0].getAdapter().getRegularPeriods()[0], ue = J(/* @__PURE__ */ new Date(), re), te = re.mpd.timeShiftBufferDepth, O = isNaN(te) ? 0 : ue - te;
                if (ee.start = fe(se, O), ee.end = !isNaN(ee.start) && ue < ee.start ? ue : fe(se, ue, !0), !isNaN(te) && ee.end < ue - te && (ee.end = NaN), c.get().streaming.timeShiftBuffer.fallbackToSegmentTimeline) {
                  var p = ne(se);
                  if (p.range.end < ee.start)
                    return v.trigger(T.default.CONFORMANCE_VIOLATION, {
                      level: S.default.LEVELS.WARNING,
                      event: S.default.EVENTS.INVALID_DVR_WINDOW
                    }), ae(p.now, p.range), p.range;
                }
                return ee;
              }
              function ne(se) {
                var ee = {
                  start: NaN,
                  end: NaN
                }, re = se[0].getAdapter().getRegularPeriods()[0], ue = J(/* @__PURE__ */ new Date(), re);
                if (!se || se.length === 0)
                  return {
                    range: ee,
                    now: ue
                  };
                se.forEach(function(O) {
                  var p = O.getAdapter(), P = p.getMediaInfoForType(O.getStreamInfo(), t.default.VIDEO) || p.getMediaInfoForType(O.getStreamInfo(), t.default.AUDIO), k = p.getVoRepresentations(P), X = k[0], F = {
                    start: NaN,
                    end: NaN
                  };
                  if (X)
                    if (X.segmentInfoType === r.default.SEGMENT_TIMELINE)
                      F = Q(X);
                    else {
                      var x = X.adaptation.period;
                      F.start = x.start, F.end = Math.max(ue, x.start + x.duration);
                    }
                  !isNaN(F.start) && (isNaN(ee.start) || ee.start > F.start) && (ee.start = F.start), !isNaN(F.end) && (isNaN(ee.end) || ee.end < F.end) && (ee.end = F.end);
                }), ee.end = Math.min(ue, ee.end);
                var te = fe(se, ee.end, !0);
                return ee.end = isNaN(te) ? ee.end : te, ee.start = re && re.mpd && re.mpd.timeShiftBufferDepth && !isNaN(re.mpd.timeShiftBufferDepth) && !isNaN(ee.end) ? Math.max(ee.end - re.mpd.timeShiftBufferDepth, ee.start) : ee.start, ee.start = fe(se, ee.start), {
                  range: ee,
                  now: ue
                };
              }
              function ae(se, ee) {
                u = se - ee.end;
              }
              function fe(se, ee) {
                var re = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                try {
                  for (var ue = 0, te = !1, O = NaN; !te && ue < se.length; ) {
                    var p = se[ue].getStreamInfo();
                    p.start <= ee && (!isFinite(p.duration) || p.start + p.duration >= ee) ? (O = ee, te = !0) : !re && p.start > ee && (isNaN(O) || p.start < O) ? O = p.start : re && p.start + p.duration < ee && (isNaN(O) || p.start + p.duration > O) && (O = p.start + p.duration), ue += 1;
                  }
                  return O;
                } catch {
                  return ee;
                }
              }
              function Q(se) {
                var ee = se.adaptation.period.mpd.manifest.Period_asArray[se.adaptation.period.index].AdaptationSet_asArray[se.adaptation.index], re = y.getRepresentationFor(se.index, ee), ue = re.SegmentTemplate.SegmentTimeline, te = re.SegmentTemplate.timescale, O = ue.S_asArray, p = {
                  start: 0,
                  end: 0
                }, P = 0, k, X, F, x;
                for (p.start = H(O[0].t / te, se), F = 0, x = O.length; F < x; F++)
                  k = O[F], X = 0, k.hasOwnProperty("r") && (X = k.r), P += k.d * (1 + X);
                return p.end = H((O[0].t + P) / te, se), p;
              }
              function oe(se, ee) {
                var re = se.adaptation.period.start;
                return ee - re;
              }
              function de(se) {
                se.offset !== void 0 && !isNaN(se.offset) && N(se.offset / 1e3);
              }
              function Me() {
                A = 0, u = 0;
              }
              function ge() {
                v.off(n.default.UPDATE_TIME_SYNC_OFFSET, de, this), Me();
              }
              return o = {
                initialize: M,
                getClientTimeOffset: E,
                setClientTimeOffset: N,
                getClientReferenceTime: C,
                calcAvailabilityStartTimeFromPresentationTime: w,
                calcAvailabilityEndTimeFromPresentationTime: V,
                calcPresentationTimeFromWallTime: J,
                calcPresentationTimeFromMediaTime: H,
                calcPeriodRelativeTimeFromMpdRelativeTime: oe,
                calcMediaTimeFromPresentationTime: z,
                calcWallTimeForSegment: Z,
                calcTimeShiftBufferWindow: ie,
                reset: ge
              }, I(), o;
            }
            h.__dashjs_factory_name = "TimelineConverter";
            const _ = i.default.getSingletonFactory(h);
          }
        ),
        /***/
        "./src/dash/utils/TimelineSegmentsGetter.js": (
          /*!**************************************************!*\
            !*** ./src/dash/utils/TimelineSegmentsGetter.js ***!
            \**************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), i = e(
              /*! ./SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            );
            function r(t, T) {
              t = t || {};
              var S = t.timelineConverter, h = t.dashMetrics, _;
              function L() {
                if (!S)
                  throw new Error(n.default.MISSING_CONFIG_ERROR);
              }
              function v(I) {
                if (!I)
                  return 0;
                var M = I.adaptation.period.mpd.manifest.Period_asArray[I.adaptation.period.index].AdaptationSet_asArray[I.adaptation.index].Representation_asArray[I.index].SegmentTemplate || I.adaptation.period.mpd.manifest.Period_asArray[I.adaptation.period.index].AdaptationSet_asArray[I.adaptation.index].Representation_asArray[I.index].SegmentList, E = M.SegmentTimeline, N = 0, C = 0, b = 0, w, V, J, H, z, Z, ie;
                for (ie = I.timescale, w = E.S_asArray, H = w.length, J = 0; J < H; J++) {
                  if (V = w[J], Z = 0, V.hasOwnProperty("r") && (Z = V.r), V.hasOwnProperty("t") && (N = V.t, C = N / ie), Z < 0) {
                    var K = w[J + 1];
                    Z = o(I, K, V, ie, C);
                  }
                  for (z = 0; z <= Z; z++)
                    b++, N += V.d, C = N / ie;
                }
                return {
                  numberOfSegments: b,
                  mediaTimeOfLastSignaledSegment: C
                };
              }
              function c(I, M) {
                var E = I.adaptation.period.mpd.manifest.Period_asArray[I.adaptation.period.index].AdaptationSet_asArray[I.adaptation.index].Representation_asArray[I.index].SegmentTemplate || I.adaptation.period.mpd.manifest.Period_asArray[I.adaptation.period.index].AdaptationSet_asArray[I.adaptation.index].Representation_asArray[I.index].SegmentList, N = E.SegmentTimeline, C = E.SegmentURL_asArray, b = 0, w = -1, V, J, H, z, Z, ie, K;
                K = I.timescale, V = N.S_asArray;
                var Y = !1;
                for (H = 0, z = V.length; H < z && !Y; H++) {
                  if (J = V[H], ie = 0, J.hasOwnProperty("r") && (ie = J.r), J.hasOwnProperty("t") && (b = J.t), ie < 0) {
                    var ne = V[H + 1];
                    ie = o(I, ne, J, K, b / K);
                  }
                  for (Z = 0; Z <= ie && !Y; Z++)
                    w++, Y = M(b, E, C, J, K, w, H), Y && (I.segmentDuration = J.d / K), b += J.d;
                }
              }
              function o(I, M, E, N, C) {
                var b;
                if (M && M.hasOwnProperty("t"))
                  b = M.t / N;
                else
                  try {
                    var w = 0;
                    if (!isNaN(I.adaptation.period.start) && !isNaN(I.adaptation.period.duration) && isFinite(I.adaptation.period.duration))
                      w = I.adaptation.period.start + I.adaptation.period.duration;
                    else {
                      var V = h.getCurrentDVRInfo();
                      w = isNaN(V.end) ? 0 : V.end;
                    }
                    b = S.calcMediaTimeFromPresentationTime(w, I), I.segmentDuration = E.d / N;
                  } catch {
                    b = 0;
                  }
                return Math.max(Math.ceil((b - C) / (E.d / N)) - 1, 0);
              }
              function y(I, M, E) {
                if (L(), !I)
                  return null;
                var N = null, C = !1;
                return c(I, function(b, w, V, J, H, z, Z) {
                  if (C || E < 0) {
                    var ie = w.media, K = J.mediaRange;
                    return V && (ie = V[Z].media || "", K = V[Z].mediaRange), N = (0, i.getTimeBasedSegment)(S, T, I, b, J.d, H, ie, K, z, J.tManifest), !0;
                  } else
                    b >= E * H - J.d * 0.5 && (C = !0);
                  return !1;
                }), N;
              }
              function u(I, M) {
                if (L(), !I)
                  return null;
                M === void 0 && (M = null);
                var E = null, N = S.calcMediaTimeFromPresentationTime(M, I);
                return c(I, function(C, b, w, V, J, H, z) {
                  var Z = A(N * J);
                  if (Z < C + V.d && Z >= C) {
                    var ie = b.media, K = V.mediaRange;
                    return w && (ie = w[z].media || "", K = w[z].mediaRange), E = (0, i.getTimeBasedSegment)(S, T, I, C, V.d, J, ie, K, H, V.tManifest), !0;
                  }
                  return !1;
                }), E;
              }
              function A(I) {
                return parseFloat(I.toPrecision(15));
              }
              return _ = {
                getSegmentByIndex: y,
                getSegmentByTime: u,
                getMediaFinishedInformation: v
              }, _;
            }
            r.__dashjs_factory_name = "TimelineSegmentsGetter";
            var l = g.default.getClassFactory(r);
            const d = l;
          }
        ),
        /***/
        "./src/dash/vo/AdaptationSet.js": (
          /*!**************************************!*\
            !*** ./src/dash/vo/AdaptationSet.js ***!
            \**************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.period = null, this.index = -1, this.type = null;
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/BaseURL.js": (
          /*!********************************!*\
            !*** ./src/dash/vo/BaseURL.js ***!
            \********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            function g(d, t) {
              if (!(d instanceof t))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = 1, i = 1, r = function d(t, T, S, h) {
              g(this, d), this.url = t || "", this.serviceLocation = T || t || "", this.dvb_priority = S || n, this.dvb_weight = h || i, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0;
            };
            r.DEFAULT_DVB_PRIORITY = n, r.DEFAULT_DVB_WEIGHT = i;
            const l = r;
          }
        ),
        /***/
        "./src/dash/vo/ContentSteering.js": (
          /*!****************************************!*\
            !*** ./src/dash/vo/ContentSteering.js ***!
            \****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.defaultServiceLocation = null, this.queryBeforeStart = !1, this.proxyServerUrl = null, this.serverUrl = null;
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/ContentSteeringRequest.js": (
          /*!***********************************************!*\
            !*** ./src/dash/vo/ContentSteeringRequest.js ***!
            \***********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../../streaming/vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            );
            function n(l, d) {
              if (!(l instanceof d))
                throw new TypeError("Cannot call a class as a function");
            }
            var i = function l(d) {
              n(this, l), this.url = d || null, this.type = g.HTTPRequest.CONTENT_STEERING_TYPE, this.responseType = "json";
            };
            const r = i;
          }
        ),
        /***/
        "./src/dash/vo/ContentSteeringResponse.js": (
          /*!************************************************!*\
            !*** ./src/dash/vo/ContentSteeringResponse.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.version = null, this.ttl = 300, this.reloadUri = null, this.serviceLocationPriority = [];
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/Event.js": (
          /*!******************************!*\
            !*** ./src/dash/vo/Event.js ***!
            \******************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.duration = NaN, this.presentationTime = NaN, this.id = NaN, this.messageData = "", this.eventStream = null, this.presentationTimeDelta = NaN;
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/EventStream.js": (
          /*!************************************!*\
            !*** ./src/dash/vo/EventStream.js ***!
            \************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.adaptionSet = null, this.representation = null, this.period = null, this.timescale = 1, this.value = "", this.schemeIdUri = "", this.presentationTimeOffset = 0;
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/ManifestInfo.js": (
          /*!*************************************!*\
            !*** ./src/dash/vo/ManifestInfo.js ***!
            \*************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.dvrWindowSize = NaN, this.loadedTime = null, this.availableFrom = null, this.minBufferTime = NaN, this.duration = NaN, this.isDynamic = !1, this.maxFragmentDuration = null;
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/MediaInfo.js": (
          /*!**********************************!*\
            !*** ./src/dash/vo/MediaInfo.js ***!
            \**********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.id = null, this.index = null, this.type = null, this.streamInfo = null, this.representationCount = 0, this.labels = null, this.lang = null, this.viewpoint = null, this.accessibility = null, this.audioChannelConfiguration = null, this.roles = null, this.codec = null, this.mimeType = null, this.contentProtection = null, this.KID = null, this.bitrateList = null, this.isFragmented = null, this.isEmbedded = null, this.selectionPriority = 1, this.supplementalProperties = {};
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/Mpd.js": (
          /*!****************************!*\
            !*** ./src/dash/vo/Mpd.js ***!
            \****************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.manifest = null, this.suggestedPresentationDelay = 0, this.availabilityStartTime = null, this.availabilityEndTime = Number.POSITIVE_INFINITY, this.timeShiftBufferDepth = Number.POSITIVE_INFINITY, this.maxSegmentDuration = Number.POSITIVE_INFINITY, this.publishTime = null, this.minimumUpdatePeriod = NaN, this.mediaPresentationDuration = NaN;
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/PatchOperation.js": (
          /*!***************************************!*\
            !*** ./src/dash/vo/PatchOperation.js ***!
            \***************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            function g(d, t) {
              if (!(d instanceof t))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(d, t) {
              for (var T = 0; T < t.length; T++) {
                var S = t[T];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(d, S.key, S);
              }
            }
            function i(d, t, T) {
              return t && n(d.prototype, t), T && n(d, T), d;
            }
            var r = /* @__PURE__ */ function() {
              function d(t, T, S) {
                g(this, d), this.action = t, this.xpath = T, this.value = S, this.position = null;
              }
              return i(d, [{
                key: "getMpdTarget",
                value: function(T) {
                  var S = this.action === "remove" || this.action === "replace" || this.position === "before" || this.position === "after";
                  return this.xpath.getMpdTarget(T, S);
                }
              }]), d;
            }();
            const l = r;
          }
        ),
        /***/
        "./src/dash/vo/Period.js": (
          /*!*******************************!*\
            !*** ./src/dash/vo/Period.js ***!
            \*******************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.id = null, this.index = -1, this.duration = NaN, this.start = NaN, this.mpd = null, this.nextPeriodId = null;
            };
            n.DEFAULT_ID = "defaultId";
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/ProducerReferenceTime.js": (
          /*!**********************************************!*\
            !*** ./src/dash/vo/ProducerReferenceTime.js ***!
            \**********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.id = null, this.inband = !1, this.type = "encoder", this.applicationScheme = null, this.wallClockTime = null, this.presentationTime = NaN, this.UTCTiming = null;
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/Representation.js": (
          /*!***************************************!*\
            !*** ./src/dash/vo/Representation.js ***!
            \***************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            );
            function n(t, T) {
              if (!(t instanceof T))
                throw new TypeError("Cannot call a class as a function");
            }
            function i(t, T) {
              for (var S = 0; S < T.length; S++) {
                var h = T[S];
                h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(t, h.key, h);
              }
            }
            function r(t, T, S) {
              return T && i(t.prototype, T), S && i(t, S), t;
            }
            var l = /* @__PURE__ */ function() {
              function t() {
                n(this, t), this.id = null, this.index = -1, this.adaptation = null, this.segmentInfoType = null, this.initialization = null, this.codecs = null, this.mimeType = null, this.codecPrivateData = null, this.segmentDuration = NaN, this.timescale = 1, this.startNumber = 1, this.indexRange = null, this.range = null, this.presentationTimeOffset = 0, this.MSETimeOffset = NaN, this.mediaFinishedInformation = {
                  numberOfSegments: 0,
                  mediaTimeOfLastSignaledSegment: NaN
                }, this.bandwidth = NaN, this.width = NaN, this.height = NaN, this.scanType = null, this.maxPlayoutRate = NaN, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0;
              }
              return r(t, [{
                key: "hasInitialization",
                value: function() {
                  return this.initialization !== null || this.range !== null;
                }
              }, {
                key: "hasSegments",
                value: function() {
                  return this.segmentInfoType !== g.default.BASE_URL && this.segmentInfoType !== g.default.SEGMENT_BASE && !this.indexRange;
                }
              }]), t;
            }();
            const d = l;
          }
        ),
        /***/
        "./src/dash/vo/RepresentationInfo.js": (
          /*!*******************************************!*\
            !*** ./src/dash/vo/RepresentationInfo.js ***!
            \*******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.id = null, this.quality = null, this.fragmentDuration = null, this.mediaInfo = null, this.MSETimeOffset = null;
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/Segment.js": (
          /*!********************************!*\
            !*** ./src/dash/vo/Segment.js ***!
            \********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.indexRange = null, this.index = null, this.mediaRange = null, this.media = null, this.duration = NaN, this.replacementTime = null, this.replacementNumber = NaN, this.mediaStartTime = NaN, this.presentationStartTime = NaN, this.availabilityStartTime = NaN, this.availabilityEndTime = NaN, this.wallStartTime = NaN, this.representation = null;
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/SimpleXPath.js": (
          /*!************************************!*\
            !*** ./src/dash/vo/SimpleXPath.js ***!
            \************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            function g(d, t) {
              if (!(d instanceof t))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(d, t) {
              for (var T = 0; T < t.length; T++) {
                var S = t[T];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(d, S.key, S);
              }
            }
            function i(d, t, T) {
              return t && n(d.prototype, t), T && n(d, T), d;
            }
            var r = /* @__PURE__ */ function() {
              function d(t) {
                var T = this;
                g(this, d), this.valid = t[0] == "/", this.path = t.split("/").filter(function(S) {
                  return S.length !== 0;
                }).map(function(S) {
                  var h = {
                    name: S
                  }, _ = S.indexOf("[");
                  if (_ != -1) {
                    h.name = S.substring(0, _);
                    var L = S.substring(_ + 1, S.length - 1);
                    T.valid = T.valid && L.indexOf("[") == -1;
                    var v = L.indexOf("=");
                    v != -1 ? (h.attribute = {
                      name: L.substring(1, v),
                      // skip the @
                      value: L.substring(v + 1)
                    }, ["'", '"'].indexOf(h.attribute.value[0]) != -1 && (h.attribute.value = h.attribute.value.substring(1, h.attribute.value.length - 1))) : h.position = parseInt(L, 10) - 1;
                  }
                  return h;
                });
              }
              return i(d, [{
                key: "isValid",
                value: function() {
                  return this.valid;
                }
              }, {
                key: "findsElement",
                value: function() {
                  return !this.findsAttribute();
                }
              }, {
                key: "findsAttribute",
                value: function() {
                  return this.path[this.path.length - 1].name.startsWith("@");
                }
              }, {
                key: "getMpdTarget",
                value: function(T, S) {
                  for (var h = null, _ = T, L = 1, v = "MPD"; L < this.path.length && _ !== null; ) {
                    h = _;
                    var c = this.path[L];
                    if (v = c.name, L !== this.path.length - 1 || !v.startsWith("@")) {
                      var o = h[v + "_asArray"] || [];
                      o.length === 0 && h[v] && o.push(h[v]), c.position ? _ = o[c.position] || null : c.attribute ? function() {
                        var y = c.attribute;
                        _ = o.filter(function(u) {
                          return u[y.name] == y.value;
                        })[0] || null;
                      }() : _ = o[0] || null;
                    }
                    L++;
                  }
                  return _ === null ? null : v.startsWith("@") ? {
                    name: v.substring(1),
                    leaf: _,
                    target: _
                  } : {
                    name: v,
                    leaf: _,
                    target: S ? h : _
                  };
                }
              }]), d;
            }();
            const l = r;
          }
        ),
        /***/
        "./src/dash/vo/StreamInfo.js": (
          /*!***********************************!*\
            !*** ./src/dash/vo/StreamInfo.js ***!
            \***********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.id = null, this.index = null, this.start = NaN, this.duration = NaN, this.manifestInfo = null, this.isLast = !0;
            };
            const i = n;
          }
        ),
        /***/
        "./src/dash/vo/UTCTiming.js": (
          /*!**********************************!*\
            !*** ./src/dash/vo/UTCTiming.js ***!
            \**********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.schemeIdUri = "", this.value = "";
            };
            const i = n;
          }
        ),
        /***/
        "./src/streaming/FragmentLoader.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/FragmentLoader.js ***!
            \*****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => t
              /* harmony export */
            });
            var g = e(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ./net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            ), i = e(
              /*! ./vo/HeadRequest */
              "./src/streaming/vo/HeadRequest.js"
            ), r = e(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), l = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function d(T) {
              T = T || {};
              var S = this.context, h = T.eventBus, _ = T.events, L = T.urlUtils, v = T.errors, c = T.streamId, o, y;
              function u() {
                y = (0, n.default)(S).create({
                  errHandler: T.errHandler,
                  errors: v,
                  dashMetrics: T.dashMetrics,
                  mediaPlayerModel: T.mediaPlayerModel,
                  requestModifier: T.requestModifier,
                  urlUtils: L,
                  constants: g.default,
                  boxParser: T.boxParser,
                  dashConstants: T.dashConstants,
                  requestTimeout: T.settings.get().streaming.fragmentRequestTimeout
                });
              }
              function A(N) {
                var C = function(V) {
                  h.trigger(_.CHECK_FOR_EXISTENCE_COMPLETED, {
                    request: N,
                    exists: V
                  });
                };
                if (N) {
                  var b = new i.default(N.url);
                  y.load({
                    request: b,
                    success: function() {
                      C(!0);
                    },
                    error: function() {
                      C(!1);
                    }
                  });
                } else
                  C(!1);
              }
              function I(N) {
                var C = function(w, V) {
                  h.trigger(_.LOADING_COMPLETED, {
                    request: N,
                    response: w || null,
                    error: V || null,
                    sender: o
                  });
                };
                N ? y.load({
                  request: N,
                  progress: function(w) {
                    h.trigger(_.LOADING_PROGRESS, {
                      request: N,
                      stream: w.stream,
                      streamId: c
                    }), w.data && h.trigger(_.LOADING_DATA_PROGRESS, {
                      request: N,
                      response: w.data || null,
                      error: null,
                      sender: o
                    });
                  },
                  success: function(w) {
                    C(w);
                  },
                  error: function(w, V, J) {
                    C(void 0, new r.default(v.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE, J, V));
                  },
                  abort: function(w) {
                    w && h.trigger(_.LOADING_ABANDONED, {
                      mediaType: w.mediaType,
                      request: w,
                      sender: o
                    });
                  }
                }) : C(void 0, new r.default(v.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE, v.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE));
              }
              function M() {
                y && y.abort();
              }
              function E() {
                y && (y.abort(), y = null);
              }
              return o = {
                checkForExistence: A,
                load: I,
                abort: M,
                reset: E
              }, u(), o;
            }
            d.__dashjs_factory_name = "FragmentLoader";
            const t = l.default.getClassFactory(d);
          }
        ),
        /***/
        "./src/streaming/ManifestLoader.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/ManifestLoader.js ***!
            \*****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => y
              /* harmony export */
            });
            var g = e(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), i = e(
              /*! ./controllers/XlinkController */
              "./src/streaming/controllers/XlinkController.js"
            ), r = e(
              /*! ./net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            ), l = e(
              /*! ./utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), d = e(
              /*! ./vo/TextRequest */
              "./src/streaming/vo/TextRequest.js"
            ), t = e(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), T = e(
              /*! ./vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), S = e(
              /*! ../core/EventBus */
              "./src/core/EventBus.js"
            ), h = e(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), _ = e(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), L = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), v = e(
              /*! ../dash/parser/DashParser */
              "./src/dash/parser/DashParser.js"
            );
            function c(u) {
              u = u || {};
              var A = this.context, I = u.debug, M = u.settings, E = (0, S.default)(A).getInstance(), N = (0, l.default)(A).getInstance(), C, b, w, V, J, H = u.mssHandler, z = u.errHandler;
              function Z() {
                b = I.getLogger(C), E.on(h.default.XLINK_READY, ie, C), w = (0, r.default)(A).create({
                  errHandler: u.errHandler,
                  dashMetrics: u.dashMetrics,
                  mediaPlayerModel: u.mediaPlayerModel,
                  requestModifier: u.requestModifier,
                  urlUtils: N,
                  constants: g.default,
                  dashConstants: n.default,
                  errors: _.default,
                  requestTimeout: u.settings.get().streaming.manifestRequestTimeout
                }), V = (0, i.default)(A).create({
                  errHandler: z,
                  dashMetrics: u.dashMetrics,
                  mediaPlayerModel: u.mediaPlayerModel,
                  requestModifier: u.requestModifier,
                  settings: u.settings
                }), J = null;
              }
              function ie(ae) {
                E.trigger(h.default.INTERNAL_MANIFEST_LOADED, {
                  manifest: ae.manifest
                });
              }
              function K(ae) {
                var fe = null;
                return ae.indexOf("SmoothStreamingMedia") > -1 ? (H && (fe = H.createMssParser(), H.registerEvents()), fe) : ae.indexOf("MPD") > -1 || ae.indexOf("Patch") > -1 ? (0, v.default)(A).create({
                  debug: I
                }) : fe;
              }
              function Y(ae) {
                var fe = new d.default(ae, T.HTTPRequest.MPD_TYPE);
                w.load({
                  request: fe,
                  success: function(oe, de, Me) {
                    if (V) {
                      var ge, se, ee;
                      if (Me && Me !== ae ? (se = N.parseBaseUrl(Me), ge = Me) : (N.isRelative(ae) && (ae = N.resolve(ae, window.location.href)), se = N.parseBaseUrl(ae)), de == "No Content") {
                        E.trigger(h.default.INTERNAL_MANIFEST_LOADED, {
                          manifest: null
                        });
                        return;
                      }
                      if (J === null && (J = K(oe)), J === null) {
                        E.trigger(h.default.INTERNAL_MANIFEST_LOADED, {
                          manifest: null,
                          error: new t.default(_.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, _.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(ae))
                        });
                        return;
                      }
                      V.setMatchers(J.getMatchers()), V.setIron(J.getIron());
                      try {
                        ee = J.parse(oe);
                      } catch {
                        E.trigger(h.default.INTERNAL_MANIFEST_LOADED, {
                          manifest: null,
                          error: new t.default(_.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, _.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(ae))
                        });
                        return;
                      }
                      if (ee) {
                        if (ee.url = ge || ae, ee.originalUrl || (ee.originalUrl = ee.url), ee.hasOwnProperty(g.default.LOCATION) && (se = N.parseBaseUrl(ee.Location_asArray[0]), b.debug("BaseURI set by Location to: " + se)), M && M.get().streaming.enableManifestDurationMismatchFix && ee.mediaPresentationDuration && ee.Period_asArray.length > 1) {
                          var re = ee.Period_asArray.reduce(function(ue, te) {
                            return ue + te.duration;
                          }, 0);
                          !isNaN(re) && ee.mediaPresentationDuration > re && (b.warn("Media presentation duration greater than duration of all periods. Setting duration to total period duration"), ee.mediaPresentationDuration = re);
                        }
                        ee.baseUri = se, ee.loadedTime = /* @__PURE__ */ new Date(), V.resolveManifestOnLoad(ee), E.trigger(h.default.ORIGINAL_MANIFEST_LOADED, {
                          originalManifest: oe
                        });
                      } else
                        E.trigger(h.default.INTERNAL_MANIFEST_LOADED, {
                          manifest: null,
                          error: new t.default(_.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, _.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(ae))
                        });
                    }
                  },
                  error: function(oe, de, Me) {
                    E.trigger(h.default.INTERNAL_MANIFEST_LOADED, {
                      manifest: null,
                      error: new t.default(_.default.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE, _.default.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE + "".concat(ae, ", ").concat(Me))
                    });
                  }
                });
              }
              function ne() {
                E.off(h.default.XLINK_READY, ie, C), H && H.reset(), V && (V.reset(), V = null), w && (w.abort(), w = null);
              }
              return C = {
                load: Y,
                reset: ne
              }, Z(), C;
            }
            c.__dashjs_factory_name = "ManifestLoader";
            var o = L.default.getClassFactory(c);
            const y = o;
          }
        ),
        /***/
        "./src/streaming/ManifestUpdater.js": (
          /*!******************************************!*\
            !*** ./src/streaming/ManifestUpdater.js ***!
            \******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            var g = e(
              /*! ../core/EventBus */
              "./src/core/EventBus.js"
            ), n = e(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), i = e(
              /*! ../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), r = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), l = e(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), d = e(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), t = e(
              /*! ../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), T = e(
              /*! ./utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            );
            function S() {
              var _ = this.context, L = (0, g.default)(_).getInstance(), v = (0, T.default)(_).getInstance(), c, o, y, u, A, I, M, E, N, C, b, w;
              function V() {
                o = (0, l.default)(_).getInstance().getLogger(c);
              }
              function J(se) {
                se && (se.manifestModel && (N = se.manifestModel), se.adapter && (C = se.adapter), se.manifestLoader && (E = se.manifestLoader), se.errHandler && (b = se.errHandler), se.settings && (w = se.settings));
              }
              function H() {
                Z(), L.on(n.default.STREAMS_COMPOSED, Me, this), L.on(i.default.PLAYBACK_STARTED, oe, this), L.on(i.default.PLAYBACK_PAUSED, de, this), L.on(n.default.INTERNAL_MANIFEST_LOADED, Q, this);
              }
              function z(se) {
                ae(se);
              }
              function Z() {
                y = NaN, M = !1, A = !0, I = !1, K();
              }
              function ie() {
                L.off(i.default.PLAYBACK_STARTED, oe, this), L.off(i.default.PLAYBACK_PAUSED, de, this), L.off(n.default.STREAMS_COMPOSED, Me, this), L.off(n.default.INTERNAL_MANIFEST_LOADED, Q, this), Z();
              }
              function K() {
                u !== null && (clearTimeout(u), u = null);
              }
              function Y(se) {
                K(), !I && (isNaN(se) && !isNaN(y) && (se = y * 1e3), isNaN(se) || (o.debug("Refresh manifest in " + se + " milliseconds."), u = setTimeout(fe, se)));
              }
              function ne() {
                var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                M = !0;
                var ee = N.getValue(), re = ee.url, ue = C.getPatchLocation(ee), te = C.getLocation(ee);
                ue && !se ? re = ue : te && (re = te), v.isRelative(re) && (re = v.resolve(re, ee.url)), E.load(re);
              }
              function ae(se) {
                if (!se)
                  se = N.getValue(), se.loadedTime = /* @__PURE__ */ new Date();
                else if (C.getIsPatch(se)) {
                  var ee = se;
                  se = N.getValue();
                  var re = C.isPatchValid(se, ee), ue = re;
                  if (re) {
                    var te = C.getPublishTime(se);
                    ue = C.applyPatchToManifest(se, ee);
                    var O = C.getPublishTime(se);
                    ue = te.getTime() != O.getTime();
                  }
                  if (!ue) {
                    o.debug("Patch provided is invalid, performing full manifest refresh"), ne(!0);
                    return;
                  }
                  se.loadedTime = /* @__PURE__ */ new Date();
                }
                if (N.getValue() && N.getValue().type === t.default.DYNAMIC && se.type === t.default.STATIC) {
                  L.trigger(n.default.DYNAMIC_TO_STATIC), M = !1, I = !0;
                  return;
                }
                N.setValue(se);
                var p = /* @__PURE__ */ new Date(), P = (p.getTime() - se.loadedTime.getTime()) / 1e3;
                y = C.getManifestUpdatePeriod(se, P), y * 1e3 > 2147483647 && (y = 2147483647e-3), L.trigger(n.default.MANIFEST_UPDATED, {
                  manifest: se
                }), o.info("Manifest has been refreshed at " + p + "[" + p.getTime() / 1e3 + "] "), A || Y();
              }
              function fe() {
                if (!A) {
                  if (M) {
                    Y(w.get().streaming.manifestUpdateRetryInterval);
                    return;
                  }
                  ne();
                }
              }
              function Q(se) {
                se.error ? se.error.code === d.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE && b.error(se.error) : ae(se.manifest);
              }
              function oe() {
                A = !1, Y();
              }
              function de() {
                A = !w.get().streaming.scheduling.scheduleWhilePaused, A && K();
              }
              function Me() {
                M = !1;
              }
              function ge() {
                return M;
              }
              return c = {
                initialize: H,
                setManifest: z,
                refreshManifest: ne,
                getIsUpdating: ge,
                setConfig: J,
                reset: ie
              }, V(), c;
            }
            S.__dashjs_factory_name = "ManifestUpdater";
            const h = r.default.getClassFactory(S);
          }
        ),
        /***/
        "./src/streaming/MediaPlayer.js": (
          /*!**************************************!*\
            !*** ./src/streaming/MediaPlayer.js ***!
            \**************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => F
              /* harmony export */
            });
            var g = e(
              /*! ../../externals/cea608-parser */
              "./externals/cea608-parser.js"
            ), n = /* @__PURE__ */ e.n(g), i = e(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), r = e(
              /*! ../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), l = e(
              /*! ./constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), d = e(
              /*! ./controllers/PlaybackController */
              "./src/streaming/controllers/PlaybackController.js"
            ), t = e(
              /*! ./controllers/StreamController */
              "./src/streaming/controllers/StreamController.js"
            ), T = e(
              /*! ./controllers/GapController */
              "./src/streaming/controllers/GapController.js"
            ), S = e(
              /*! ./controllers/CatchupController */
              "./src/streaming/controllers/CatchupController.js"
            ), h = e(
              /*! ../dash/controllers/ServiceDescriptionController */
              "./src/dash/controllers/ServiceDescriptionController.js"
            ), _ = e(
              /*! ../dash/controllers/ContentSteeringController */
              "./src/dash/controllers/ContentSteeringController.js"
            ), L = e(
              /*! ./controllers/MediaController */
              "./src/streaming/controllers/MediaController.js"
            ), v = e(
              /*! ./controllers/BaseURLController */
              "./src/streaming/controllers/BaseURLController.js"
            ), c = e(
              /*! ./ManifestLoader */
              "./src/streaming/ManifestLoader.js"
            ), o = e(
              /*! ./utils/ErrorHandler */
              "./src/streaming/utils/ErrorHandler.js"
            ), y = e(
              /*! ./utils/Capabilities */
              "./src/streaming/utils/Capabilities.js"
            ), u = e(
              /*! ./utils/CapabilitiesFilter */
              "./src/streaming/utils/CapabilitiesFilter.js"
            ), A = e(
              /*! ./utils/RequestModifier */
              "./src/streaming/utils/RequestModifier.js"
            ), I = e(
              /*! ./models/URIFragmentModel */
              "./src/streaming/models/URIFragmentModel.js"
            ), M = e(
              /*! ./models/ManifestModel */
              "./src/streaming/models/ManifestModel.js"
            ), E = e(
              /*! ./models/MediaPlayerModel */
              "./src/streaming/models/MediaPlayerModel.js"
            ), N = e(
              /*! ./controllers/AbrController */
              "./src/streaming/controllers/AbrController.js"
            ), C = e(
              /*! ./net/SchemeLoaderFactory */
              "./src/streaming/net/SchemeLoaderFactory.js"
            ), b = e(
              /*! ./models/VideoModel */
              "./src/streaming/models/VideoModel.js"
            ), w = e(
              /*! ./models/CmcdModel */
              "./src/streaming/models/CmcdModel.js"
            ), V = e(
              /*! ./models/CmsdModel */
              "./src/streaming/models/CmsdModel.js"
            ), J = e(
              /*! ./utils/DOMStorage */
              "./src/streaming/utils/DOMStorage.js"
            ), H = e(
              /*! ./../core/Debug */
              "./src/core/Debug.js"
            ), z = e(
              /*! ./../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), Z = e(
              /*! ./../core/EventBus */
              "./src/core/EventBus.js"
            ), ie = e(
              /*! ./../core/events/Events */
              "./src/core/events/Events.js"
            ), K = e(
              /*! ./MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), Y = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), ne = e(
              /*! ../core/Settings */
              "./src/core/Settings.js"
            ), ae = e(
              /*! ../core/Version */
              "./src/core/Version.js"
            ), fe = e(
              /*! ../dash/controllers/SegmentBaseController */
              "./src/dash/controllers/SegmentBaseController.js"
            ), Q = e(
              /*! ../dash/DashAdapter */
              "./src/dash/DashAdapter.js"
            ), oe = e(
              /*! ../dash/DashMetrics */
              "./src/dash/DashMetrics.js"
            ), de = e(
              /*! ../dash/utils/TimelineConverter */
              "./src/dash/utils/TimelineConverter.js"
            ), Me = e(
              /*! ./vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), ge = e(
              /*! ../../externals/base64 */
              "./externals/base64.js"
            ), se = e(
              /*! codem-isoboxer */
              "./node_modules/codem-isoboxer/dist/iso_boxer.js"
            ), ee = e(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), re = e(
              /*! ./utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            ), ue = e(
              /*! ./ManifestUpdater */
              "./src/streaming/ManifestUpdater.js"
            ), te = e(
              /*! ../streaming/utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), O = e(
              /*! ./utils/BoxParser */
              "./src/streaming/utils/BoxParser.js"
            ), p = e(
              /*! ./text/TextController */
              "./src/streaming/text/TextController.js"
            ), P = e(
              /*! ./models/CustomParametersModel */
              "./src/streaming/models/CustomParametersModel.js"
            );
            function k() {
              var x = "You must first call initialize() and set a source before calling this method", W = "You must first call initialize() and set a valid source and view before calling this method", $ = "You must first call attachView() to set the video element before calling this method", ce = "You must first call attachSource() with a valid source before calling this method", le = "MediaPlayer not initialized!", q = this.context, _e = (0, Z.default)(q).getInstance(), Ee = (0, ne.default)(q).getInstance(), Te = (0, H.default)(q).getInstance({
                settings: Ee
              }), Ce, xe, be, Ge, Pe, Le, je, Ze, nt, it, De, Ye, Ke, tt, st, Et, ht, xt, Xe, ve, me, Ie, we, Ue, $e, at, et, Mt, Lt, bt, Ae, ze, qe, _t, dt, Tt, wt, Gt;
              function Xt() {
                xe = Te.getLogger(Ce), Pe = !1, je = !1, Le = !1, Ze = !0, Ke = null, Et = null, Ge = null, ht = null, Gt = null, ie.default.extend(K.default), xt = (0, E.default)(q).getInstance(), Xe = (0, P.default)(q).getInstance(), dt = (0, b.default)(q).getInstance(), Tt = (0, I.default)(q).getInstance();
              }
              function ye(Fe) {
                Fe && (Fe.capabilities && (Ie = Fe.capabilities), Fe.capabilitiesFilter && (we = Fe.capabilitiesFilter), Fe.streamController && (Ue = Fe.streamController), Fe.textController && ($e = Fe.textController), Fe.gapController && (at = Fe.gapController), Fe.playbackController && (et = Fe.playbackController), Fe.serviceDescriptionController && (Mt = Fe.serviceDescriptionController), Fe.contentSteeringController && (Lt = Fe.contentSteeringController), Fe.catchupController && (bt = Fe.catchupController), Fe.mediaPlayerModel && (xt = Fe.mediaPlayerModel), Fe.customParametersModel && (Xe = Fe.customParametersModel), Fe.abrController && (nt = Fe.abrController), Fe.schemeLoaderFactory && (it = Fe.schemeLoaderFactory), Fe.mediaController && (Ye = Fe.mediaController), Fe.settings && (Ee = Fe.settings));
              }
              function Qe(Fe, vt, Ut) {
                var rr = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : NaN;
                if (Ie || (Ie = (0, y.default)(q).getInstance(), Ie.setConfig({
                  settings: Ee
                })), ve || (ve = (0, o.default)(q).getInstance()), !Ie.supportsMediaSource()) {
                  ve.error(new ee.default(z.default.CAPABILITY_MEDIASOURCE_ERROR_CODE, z.default.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE));
                  return;
                }
                Pe || (Pe = !0, De = (0, de.default)(q).getInstance(), nt || (nt = (0, N.default)(q).getInstance(), nt.setConfig({
                  settings: Ee
                })), it || (it = (0, C.default)(q).getInstance()), et || (et = (0, d.default)(q).getInstance()), Ye || (Ye = (0, L.default)(q).getInstance()), Ue || (Ue = (0, t.default)(q).getInstance()), at || (at = (0, T.default)(q).getInstance()), bt || (bt = (0, S.default)(q).getInstance()), Mt || (Mt = (0, h.default)(q).getInstance()), Lt || (Lt = (0, _.default)(q).getInstance()), we || (we = (0, u.default)(q).getInstance()), ht = (0, Q.default)(q).getInstance(), ze = (0, M.default)(q).getInstance(), qe = (0, w.default)(q).getInstance(), _t = (0, V.default)(q).getInstance(), Ae = (0, oe.default)(q).getInstance({
                  settings: Ee
                }), wt = (0, J.default)(q).getInstance({
                  settings: Ee
                }), ht.setConfig({
                  constants: i.default,
                  cea608parser: n(),
                  errHandler: ve,
                  BASE64: ge
                }), me || (me = (0, v.default)(q).create()), me.setConfig({
                  adapter: ht
                }), Mt.setConfig({
                  adapter: ht
                }), Gt || (Gt = (0, fe.default)(q).getInstance({
                  dashMetrics: Ae,
                  mediaPlayerModel: xt,
                  errHandler: ve,
                  baseURLController: me,
                  events: ie.default,
                  eventBus: _e,
                  debug: Te,
                  boxParser: (0, O.default)(q).getInstance(),
                  requestModifier: (0, A.default)(q).getInstance(),
                  errors: z.default
                })), Ye.setConfig({
                  domStorage: wt,
                  settings: Ee,
                  customParametersModel: Xe
                }), xt.setConfig({
                  playbackController: et,
                  serviceDescriptionController: Mt
                }), Lt.setConfig({
                  adapter: ht,
                  errHandler: ve,
                  dashMetrics: Ae,
                  mediaPlayerModel: xt,
                  manifestModel: ze,
                  abrController: nt,
                  eventBus: _e,
                  requestModifier: (0, A.default)(q).getInstance()
                }), vn(), Gr(Ut !== void 0 ? Ut : !0), Ls()), Fe && pn(Fe), vt && bi(vt, rr), xe.info("[dash.js " + zt() + "] MediaPlayer has been initialized");
              }
              function ct() {
                bi(null), pn(null), Ge = null, Ke && (Ke.reset(), Ke = null), tt && (tt.reset(), tt = null), Xe && Xe.reset(), Ee.reset(), Et && (Et.reset(), Et = null);
              }
              function Se() {
                ct(), Y.default.deleteSingletonInstances(q);
              }
              function Be() {
                return !!be && !!dt.getElement();
              }
              function He(Fe, vt, Ut, rr) {
                _e.on(Fe, vt, Ut, rr);
              }
              function yt(Fe, vt, Ut) {
                _e.off(Fe, vt, Ut);
              }
              function zt() {
                return (0, ae.getVersionString)();
              }
              function Nt() {
                return Te;
              }
              function Dt() {
                if (dt.getElement() || Le)
                  return !1;
                if (be)
                  Ui();
                else
                  throw ce;
              }
              function ar() {
                if (!je)
                  throw W;
                (!Ze || Je() && je) && et.play(!0);
              }
              function Qt() {
                if (!je)
                  throw W;
                et.pause();
              }
              function Je() {
                if (!je)
                  throw W;
                return et.isPaused();
              }
              function At(Fe) {
                if (!je)
                  throw W;
                if ((0, re.checkParameterType)(Fe, "number"), isNaN(Fe))
                  throw i.default.BAD_ARGUMENT_ERROR;
                Fe < 0 && (Fe = 0);
                var vt = et.getIsDynamic() ? wr(Fe) : Fe, Ut = Tr();
                !et.getIsDynamic() && Ut.duration && (vt = Math.min(Ut.duration, vt)), et.seek(vt, !1, !1, !0);
              }
              function It() {
                !je || !ke() || et.seekToOriginalLive();
              }
              function Oe() {
                if (!je)
                  throw W;
                return et.isSeeking();
              }
              function ke() {
                if (!je)
                  throw W;
                return et.getIsDynamic();
              }
              function pe() {
                if (!je)
                  throw W;
                return et.getLowLatencyModeEnabled();
              }
              function Ve(Fe) {
                Tr().playbackRate = Fe;
              }
              function ut() {
                return Tr().playbackRate;
              }
              function St(Fe) {
                (0, re.checkParameterType)(Fe, "boolean"), Tr().muted = Fe;
              }
              function jt() {
                return Tr().muted;
              }
              function Kt(Fe) {
                if (typeof Fe != "number" || isNaN(Fe) || Fe < 0 || Fe > 1)
                  throw i.default.BAD_ARGUMENT_ERROR;
                Tr().volume = Fe;
              }
              function $t() {
                return Tr().volume;
              }
              function Yt(Fe) {
                var vt = [i.default.VIDEO, i.default.AUDIO, i.default.TEXT];
                if (Fe)
                  if (vt.indexOf(Fe) !== -1) {
                    var rr = kt().getCurrentBufferLevel(Fe);
                    return rr || NaN;
                  } else
                    return xe.warn("getBufferLength requested for invalid type"), NaN;
                else {
                  var Ut = vt.map(function(lr) {
                    return ps(lr).length > 0 ? kt().getCurrentBufferLevel(lr) : Number.MAX_VALUE;
                  }).reduce(function(lr, da) {
                    return Math.min(lr, da);
                  });
                  return Ut === Number.MAX_VALUE ? NaN : Ut;
                }
              }
              function gr() {
                var Fe = Ue && Ue.hasVideoTrack() ? i.default.VIDEO : i.default.AUDIO, vt = Ae.getCurrentDVRInfo(Fe);
                return vt ? vt.manifestInfo.dvrWindowSize : 0;
              }
              function wr(Fe) {
                var vt = Ue && Ue.hasVideoTrack() ? i.default.VIDEO : i.default.AUDIO, Ut = Ae.getCurrentDVRInfo(vt);
                if (!Ut)
                  return 0;
                var rr = et.getOriginalLiveDelay(), lr = Ut.range.start + Fe;
                return lr > Ut.range.end - rr && (lr = Ut.range.end - rr), lr;
              }
              function Vr() {
                if (!je)
                  throw W;
                return et.getOriginalLiveDelay();
              }
              function Nr(Fe) {
                if (!je)
                  throw W;
                var vt = Tr().currentTime;
                if (Fe !== void 0)
                  vt = Ue.getTimeRelativeToStreamId(vt, Fe);
                else if (et.getIsDynamic()) {
                  var Ut = Ue && Ue.hasVideoTrack() ? i.default.VIDEO : i.default.AUDIO, rr = Ae.getCurrentDVRInfo(Ut);
                  vt = rr === null || vt === 0 ? 0 : Math.max(0, vt - rr.range.start);
                }
                return vt;
              }
              function hn() {
                if (!je)
                  throw W;
                var Fe = Tr().duration;
                if (et.getIsDynamic()) {
                  var vt = Ue && Ue.hasVideoTrack() ? i.default.VIDEO : i.default.AUDIO, Ut = Ae.getCurrentDVRInfo(vt);
                  Fe = Ut ? Ut.range.end - Ut.range.start : 0;
                }
                return Fe;
              }
              function Pn() {
                if (!je)
                  throw W;
                return Nr() < 0 ? NaN : Is(Nr());
              }
              function ca() {
                if (!je)
                  throw W;
                return Is(hn());
              }
              function Ur(Fe) {
                if (!Le)
                  throw x;
                return nt.getTopBitrateInfoFor(Fe);
              }
              function _n(Fe) {
                if (!Le)
                  throw x;
                if (Fe === i.default.IMAGE) {
                  var vt = Xa();
                  if (!vt)
                    return -1;
                  var Ut = vt.getThumbnailController();
                  return Ut ? Ut.getCurrentTrackIndex() : -1;
                }
                return nt.getQualityFor(Fe);
              }
              function yn(Fe, vt) {
                var Ut = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                if (!Le)
                  throw x;
                if (Fe === i.default.IMAGE) {
                  var rr = Xa();
                  if (!rr)
                    return;
                  var lr = rr.getThumbnailController();
                  lr && lr.setTrackByIndex(vt);
                }
                nt.setPlaybackQuality(Fe, Ue.getActiveStreamInfo(), vt, {
                  forceReplace: Ut
                });
              }
              function Va() {
                nt.setElementSize(), nt.setWindowResizeEventCalled(!0);
              }
              function Gr(Fe) {
                (0, re.checkParameterType)(Fe, "boolean"), Ze = Fe;
              }
              function ji() {
                return Ze;
              }
              function Oi() {
                if (!Pe)
                  throw le;
                return je ? et.getCurrentLiveLatency() : NaN;
              }
              function fa(Fe, vt, Ut) {
                Xe.addAbrCustomRule(Fe, vt, Ut);
              }
              function Ga(Fe) {
                Xe.removeAbrCustomRule(Fe);
              }
              function Pi() {
                Xe.removeAllAbrCustomRule();
              }
              function Ri() {
                return Xe.getAbrCustomRules();
              }
              function Qa(Fe, vt) {
                Xe.addUTCTimingSource(Fe, vt);
              }
              function Rn(Fe, vt) {
                Xe.removeUTCTimingSource(Fe, vt);
              }
              function Ha() {
                Xe.clearDefaultUTCTimingSources();
              }
              function vn() {
                Xe.restoreDefaultUTCTimingSources();
              }
              function Re(Fe) {
                var vt = nt.getThroughputHistory(), Ut = et.getIsDynamic();
                return vt ? vt.getAverageThroughput(Fe, Ut) : 0;
              }
              function rt(Fe, vt) {
                Xe.setXHRWithCredentialsForType(Fe, vt);
              }
              function pt(Fe) {
                return Xe.getXHRWithCredentialsForType(Fe);
              }
              function Bt() {
                return Ls();
              }
              function kt() {
                return Ae;
              }
              function Zt(Fe) {
                var vt = Ue.getActiveStreamInfo();
                return !vt || !$e ? !1 : $e.enableText(vt.id, Fe);
              }
              function Jt(Fe) {
                var vt = Ue.getActiveStreamInfo();
                return !vt || !$e ? !1 : $e.enableForcedTextStreaming(Fe);
              }
              function Ir() {
                var Fe = Ue.getActiveStreamInfo();
                return !Fe || !$e ? !1 : $e.isTextEnabled(Fe);
              }
              function dr(Fe) {
                if (!je)
                  throw W;
                var vt = Ue.getActiveStreamInfo();
                !vt || !$e || $e.setTextTrack(vt.id, Fe);
              }
              function Fr() {
                var Fe = NaN, vt = Ue.getActiveStreamInfo();
                if (!(!vt || !$e))
                  return Fe = $e.getCurrentTrackIdx(vt.id), Fe;
              }
              function Tr() {
                if (!dt.getElement())
                  throw $;
                return dt.getElement();
              }
              function pn(Fe) {
                if (!Pe)
                  throw le;
                dt.setElement(Fe), Fe && (wi(), zc(), kc(), Ue && Ue.switchToVideoElement()), je && Ts(), Ui();
              }
              function ic() {
                return dt ? dt.getTTMLRenderingDiv() : null;
              }
              function oc(Fe) {
                if (!dt.getElement())
                  throw $;
                dt.setTTMLRenderingDiv(Fe);
              }
              function sc(Fe) {
                if (!dt.getElement())
                  throw $;
                dt.setVttRenderingDiv(Fe);
              }
              function uc(Fe) {
                if (!Le)
                  throw x;
                var vt = Xa();
                return vt ? vt.getBitrateListFor(Fe) : [];
              }
              function lc(Fe) {
                if (!Le)
                  throw x;
                return ht.getStreamsInfo(Fe);
              }
              function ps(Fe) {
                if (!Le)
                  throw x;
                var vt = Ue.getActiveStreamInfo();
                return vt ? Ye.getTracksFor(Fe, vt.id) : [];
              }
              function cc(Fe, vt, Ut) {
                if (!Le)
                  throw x;
                return Ut = Ut || ht.getStreamsInfo(vt, 1)[0], Ut ? ht.getAllMediaInfoForType(Ut, Fe, vt) : [];
              }
              function fc(Fe) {
                if (!Le)
                  throw x;
                var vt = Ue.getActiveStreamInfo();
                return Ye.getCurrentTrackFor(Fe, vt.id);
              }
              function dc(Fe, vt) {
                if (!Pe)
                  throw le;
                Ye.setInitialSettings(Fe, vt);
              }
              function gc(Fe) {
                if (!Pe)
                  throw le;
                return Ye.getInitialSettings(Fe);
              }
              function mc(Fe) {
                if (!Le)
                  throw x;
                Ye.setTrack(Fe);
              }
              function Ec(Fe) {
                Xe.registerCustomCapabilitiesFilter(Fe);
              }
              function Mc(Fe) {
                Xe.unregisterCustomCapabilitiesFilter(Fe);
              }
              function hc(Fe) {
                Xe.setCustomInitialTrackSelectionFunction(Fe);
              }
              function _c() {
                Xe.resetCustomInitialTrackSelectionFunction(null);
              }
              function yc(Fe) {
                Xe.registerLicenseRequestFilter(Fe);
              }
              function vc(Fe) {
                Xe.registerLicenseResponseFilter(Fe);
              }
              function pc(Fe) {
                Xe.unregisterLicenseRequestFilter(Fe);
              }
              function Tc(Fe) {
                Xe.unregisterLicenseResponseFilter(Fe);
              }
              function Lc() {
                return wi();
              }
              function Ic(Fe) {
                Ke = Fe;
              }
              function Ac(Fe) {
                Ge = Fe, Ue && Ue.setProtectionData(Ge);
              }
              function Sc(Fe, vt) {
                if (typeof vt == "function") {
                  if (Fe < 0) {
                    vt(null);
                    return;
                  }
                  var Ut = et.getIsDynamic() ? wr(Fe) : Fe, rr = Ue.getStreamForTime(Ut);
                  if (rr === null) {
                    vt(null);
                    return;
                  }
                  var lr = rr.getThumbnailController();
                  if (!lr) {
                    vt(null);
                    return;
                  }
                  return lr.provide(Ut, vt);
                }
              }
              function Dc(Fe, vt) {
                var Ut = xi(), rr = this, lr = function da(bn) {
                  bn.error ? vt(null, bn.error) : vt(bn.manifest), _e.off(ie.default.INTERNAL_MANIFEST_LOADED, da, rr), Ut.reset();
                };
                _e.on(ie.default.INTERNAL_MANIFEST_LOADED, lr, rr), Tt.initialize(Fe), Ut.load(Fe);
              }
              function Nc() {
                if (!be)
                  throw ce;
                return be;
              }
              function Cc(Fe) {
                be = Fe, Ue.load(be);
              }
              function bi(Fe) {
                var vt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
                if (!Pe)
                  throw le;
                typeof Fe == "string" && Tt.initialize(Fe), vt == null && (vt = NaN), isNaN(vt) || (vt = Math.max(0, vt)), be = Fe, (Le || je) && Ts(), Be() && Ui(vt);
              }
              function jc() {
                return Ee.get();
              }
              function Oc(Fe) {
                Ee.update(Fe);
              }
              function Pc() {
                Ee.reset();
              }
              function Rc(Fe, vt, Ut) {
                var rr = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, lr = new Date(Fe * 1e3), da = lr.toLocaleDateString(vt), bn = lr.toLocaleTimeString(vt, {
                  hour12: Ut
                });
                return rr ? bn + " " + da : bn;
              }
              function bc(Fe) {
                Fe = Math.max(Fe, 0);
                var vt = Math.floor(Fe / 3600), Ut = Math.floor(Fe % 3600 / 60), rr = Math.floor(Fe % 3600 % 60);
                return (vt === 0 ? "" : vt < 10 ? "0" + vt.toString() + ":" : vt.toString() + ":") + (Ut < 10 ? "0" + Ut.toString() : Ut.toString()) + ":" + (rr < 10 ? "0" + rr.toString() : rr.toString());
              }
              function xc(Fe, vt, Ut) {
                Y.default.extend(Fe, vt, Ut, q);
              }
              function Xa() {
                if (!Le)
                  throw x;
                var Fe = Ue.getActiveStreamInfo();
                return Fe ? Ue.getStreamById(Fe.id) : null;
              }
              function wc() {
                return ht;
              }
              function Uc() {
                if (Lt)
                  return Lt.loadSteeringData();
              }
              function Fc() {
                if (Lt)
                  return Lt.getCurrentSteeringResponseData();
              }
              function Ts() {
                je = !1, Le = !1, ht.reset(), Ue.reset(), at.reset(), bt.reset(), et.reset(), Mt.reset(), Lt.reset(), nt.reset(), Ye.reset(), Gt.reset(), Ke && (Ee.get().streaming.protection.keepProtectionMediaKeys ? Ke.stop() : (Ke.reset(), Ke = null, wi())), $e.reset(), qe.reset(), _t.reset();
              }
              function Bc() {
                var Fe = xi();
                Ue || (Ue = (0, t.default)(q).getInstance()), $e || ($e = (0, p.default)(q).create({
                  errHandler: ve,
                  manifestModel: ze,
                  adapter: ht,
                  mediaController: Ye,
                  videoModel: dt,
                  settings: Ee
                })), we.setConfig({
                  capabilities: Ie,
                  customParametersModel: Xe,
                  adapter: ht,
                  settings: Ee,
                  manifestModel: ze,
                  errHandler: ve
                }), Ue.setConfig({
                  capabilities: Ie,
                  capabilitiesFilter: we,
                  manifestLoader: Fe,
                  manifestModel: ze,
                  mediaPlayerModel: xt,
                  customParametersModel: Xe,
                  protectionController: Ke,
                  textController: $e,
                  adapter: ht,
                  dashMetrics: Ae,
                  errHandler: ve,
                  timelineConverter: De,
                  videoModel: dt,
                  playbackController: et,
                  serviceDescriptionController: Mt,
                  contentSteeringController: Lt,
                  abrController: nt,
                  mediaController: Ye,
                  settings: Ee,
                  baseURLController: me,
                  uriFragmentModel: Tt,
                  segmentBaseController: Gt
                }), at.setConfig({
                  settings: Ee,
                  playbackController: et,
                  streamController: Ue,
                  videoModel: dt,
                  timelineConverter: De,
                  adapter: ht
                }), et.setConfig({
                  streamController: Ue,
                  serviceDescriptionController: Mt,
                  dashMetrics: Ae,
                  adapter: ht,
                  videoModel: dt,
                  timelineConverter: De,
                  settings: Ee
                }), bt.setConfig({
                  streamController: Ue,
                  playbackController: et,
                  mediaPlayerModel: xt,
                  videoModel: dt,
                  settings: Ee
                }), nt.setConfig({
                  streamController: Ue,
                  domStorage: wt,
                  mediaPlayerModel: xt,
                  customParametersModel: Xe,
                  cmsdModel: _t,
                  dashMetrics: Ae,
                  adapter: ht,
                  videoModel: dt,
                  settings: Ee
                }), qe.setConfig({
                  abrController: nt,
                  dashMetrics: Ae,
                  playbackController: et
                }), _t.setConfig({}), nt.initialize(), Ue.initialize(Ze, Ge), $e.initialize(), at.initialize(), bt.initialize(), qe.initialize(), _t.initialize(), Lt.initialize(), Gt.initialize();
              }
              function xi() {
                return (0, c.default)(q).create({
                  debug: Te,
                  errHandler: ve,
                  dashMetrics: Ae,
                  mediaPlayerModel: xt,
                  requestModifier: (0, A.default)(q).getInstance(),
                  mssHandler: st,
                  settings: Ee
                });
              }
              function wi() {
                if (Ke)
                  return Ke;
                var Fe = dashjs.Protection;
                if (typeof Fe == "function") {
                  var vt = Fe(q).create();
                  return ie.default.extend(Fe.events), K.default.extend(Fe.events, {
                    publicOnly: !0
                  }), z.default.extend(Fe.errors), Ie || (Ie = (0, y.default)(q).getInstance()), Ke = vt.createProtectionSystem({
                    debug: Te,
                    errHandler: ve,
                    videoModel: dt,
                    customParametersModel: Xe,
                    capabilities: Ie,
                    eventBus: _e,
                    events: ie.default,
                    BASE64: ge,
                    constants: i.default,
                    cmcdModel: qe,
                    settings: Ee
                  }), Ke;
                }
                return null;
              }
              function zc() {
                if (!tt) {
                  var Fe = dashjs.MetricsReporting;
                  if (typeof Fe == "function") {
                    var vt = Fe(q).create();
                    tt = vt.createMetricsReporting({
                      debug: Te,
                      eventBus: _e,
                      mediaElement: Tr(),
                      adapter: ht,
                      dashMetrics: Ae,
                      mediaPlayerModel: xt,
                      events: ie.default,
                      constants: i.default,
                      metricsConstants: l.default
                    });
                  }
                }
              }
              function kc() {
                if (!st) {
                  var Fe = dashjs.MssHandler;
                  typeof Fe == "function" && (z.default.extend(Fe.errors), st = Fe(q).create({
                    eventBus: _e,
                    mediaPlayerModel: xt,
                    dashMetrics: Ae,
                    manifestModel: ze,
                    playbackController: et,
                    streamController: Ue,
                    protectionController: Ke,
                    baseURLController: me,
                    errHandler: ve,
                    events: ie.default,
                    constants: i.default,
                    debug: Te,
                    initSegmentType: Me.HTTPRequest.INIT_SEGMENT_TYPE,
                    BASE64: ge,
                    ISOBoxer: se,
                    settings: Ee
                  }));
                }
              }
              function Ls() {
                if (!Pe)
                  throw le;
                if (Et)
                  return Et;
                var Fe = dashjs.OfflineController;
                if (typeof Fe == "function") {
                  ie.default.extend(Fe.events), K.default.extend(Fe.events, {
                    publicOnly: !0
                  }), z.default.extend(Fe.errors);
                  var vt = xi(), Ut = (0, ue.default)(q).create();
                  return Ut.setConfig({
                    manifestModel: ze,
                    adapter: ht,
                    manifestLoader: vt,
                    errHandler: ve
                  }), Et = Fe(q).create({
                    debug: Te,
                    manifestUpdater: Ut,
                    baseURLController: me,
                    manifestLoader: vt,
                    manifestModel: ze,
                    mediaPlayerModel: xt,
                    abrController: nt,
                    playbackController: et,
                    adapter: ht,
                    errHandler: ve,
                    dashMetrics: Ae,
                    timelineConverter: De,
                    segmentBaseController: Gt,
                    schemeLoaderFactory: it,
                    eventBus: _e,
                    events: ie.default,
                    errors: z.default,
                    constants: i.default,
                    settings: Ee,
                    dashConstants: r.default,
                    urlUtils: (0, te.default)(q).getInstance()
                  }), Et;
                }
                return null;
              }
              function Is(Fe) {
                var vt = Ue && Ue.hasVideoTrack() ? i.default.VIDEO : i.default.AUDIO, Ut = Ae.getCurrentDVRInfo(vt), rr, lr;
                return Ut ? (rr = Ut.manifestInfo.availableFrom.getTime() / 1e3, lr = Fe + (rr + Ut.range.start), lr) : 0;
              }
              function Ui() {
                var Fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NaN;
                Et && Et.resetRecords(), !Le && be && (Le = !0, xe.info("Streaming Initialized"), Bc(), typeof be == "string" ? Ue.load(be, Fe) : Ue.loadWithManifest(be, Fe)), !je && Be() && (je = !0, xe.info("Playback Initialized"));
              }
              return Ce = {
                initialize: Qe,
                setConfig: ye,
                on: He,
                off: yt,
                extend: xc,
                attachView: pn,
                attachSource: bi,
                isReady: Be,
                preload: Dt,
                play: ar,
                isPaused: Je,
                pause: Qt,
                isSeeking: Oe,
                isDynamic: ke,
                getLowLatencyModeEnabled: pe,
                seek: At,
                seekToOriginalLive: It,
                setPlaybackRate: Ve,
                getPlaybackRate: ut,
                setMute: St,
                isMuted: jt,
                setVolume: Kt,
                getVolume: $t,
                time: Nr,
                duration: hn,
                timeAsUTC: Pn,
                durationAsUTC: ca,
                getActiveStream: Xa,
                getDVRWindowSize: gr,
                getDVRSeekOffset: wr,
                getTargetLiveDelay: Vr,
                convertToTimeCode: bc,
                formatUTC: Rc,
                getVersion: zt,
                getDebug: Nt,
                getBufferLength: Yt,
                getTTMLRenderingDiv: ic,
                getVideoElement: Tr,
                getSource: Nc,
                updateSource: Cc,
                getCurrentLiveLatency: Oi,
                getTopBitrateInfoFor: Ur,
                setAutoPlay: Gr,
                getAutoPlay: ji,
                getDashMetrics: kt,
                getQualityFor: _n,
                setQualityFor: yn,
                updatePortalSize: Va,
                enableText: Zt,
                enableForcedTextStreaming: Jt,
                isTextEnabled: Ir,
                setTextTrack: dr,
                getBitrateInfoListFor: uc,
                getStreamsFromManifest: lc,
                getTracksFor: ps,
                getTracksForTypeFromManifest: cc,
                getCurrentTrackFor: fc,
                setInitialMediaSettingsFor: dc,
                getInitialMediaSettingsFor: gc,
                setCurrentTrack: mc,
                addABRCustomRule: fa,
                removeABRCustomRule: Ga,
                removeAllABRCustomRule: Pi,
                getABRCustomRules: Ri,
                getAverageThroughput: Re,
                retrieveManifest: Dc,
                addUTCTimingSource: Qa,
                removeUTCTimingSource: Rn,
                clearDefaultUTCTimingSources: Ha,
                restoreDefaultUTCTimingSources: vn,
                setXHRWithCredentialsForType: rt,
                getXHRWithCredentialsForType: pt,
                getProtectionController: Lc,
                attachProtectionController: Ic,
                setProtectionData: Ac,
                registerLicenseRequestFilter: yc,
                registerLicenseResponseFilter: vc,
                unregisterLicenseRequestFilter: pc,
                unregisterLicenseResponseFilter: Tc,
                registerCustomCapabilitiesFilter: Ec,
                unregisterCustomCapabilitiesFilter: Mc,
                setCustomInitialTrackSelectionFunction: hc,
                resetCustomInitialTrackSelectionFunction: _c,
                attachTTMLRenderingDiv: oc,
                attachVttRenderingDiv: sc,
                getCurrentTextTrackIndex: Fr,
                provideThumbnail: Sc,
                getDashAdapter: wc,
                getOfflineController: Bt,
                triggerSteeringRequest: Uc,
                getCurrentSteeringResponseData: Fc,
                getSettings: jc,
                updateSettings: Oc,
                resetSettings: Pc,
                reset: ct,
                destroy: Se
              }, Xt(), Ce;
            }
            k.__dashjs_factory_name = "MediaPlayer";
            var X = Y.default.getClassFactory(k);
            X.events = K.default, X.errors = z.default, Y.default.updateClassFactory(k.__dashjs_factory_name, X);
            const F = X;
          }
        ),
        /***/
        "./src/streaming/MediaPlayerEvents.js": (
          /*!********************************************!*\
            !*** ./src/streaming/MediaPlayerEvents.js ***!
            \********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ../core/events/EventsBase */
              "./src/core/events/EventsBase.js"
            );
            function n(c) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(y) {
                return typeof y;
              } : n = function(y) {
                return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
              }, n(c);
            }
            function i(c, o) {
              if (!(c instanceof o))
                throw new TypeError("Cannot call a class as a function");
            }
            function r(c, o) {
              if (typeof o != "function" && o !== null)
                throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(o && o.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), o && l(c, o);
            }
            function l(c, o) {
              return l = Object.setPrototypeOf || function(u, A) {
                return u.__proto__ = A, u;
              }, l(c, o);
            }
            function d(c) {
              var o = S();
              return function() {
                var u = h(c), A;
                if (o) {
                  var I = h(this).constructor;
                  A = Reflect.construct(u, arguments, I);
                } else
                  A = u.apply(this, arguments);
                return t(this, A);
              };
            }
            function t(c, o) {
              return o && (n(o) === "object" || typeof o == "function") ? o : T(c);
            }
            function T(c) {
              if (c === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return c;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function h(c) {
              return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, h(c);
            }
            var _ = /* @__PURE__ */ function(c) {
              r(y, c);
              var o = d(y);
              function y() {
                var u;
                return i(this, y), u = o.call(this), u.AST_IN_FUTURE = "astInFuture", u.BUFFER_EMPTY = "bufferStalled", u.BUFFER_LOADED = "bufferLoaded", u.BUFFER_LEVEL_STATE_CHANGED = "bufferStateChanged", u.BUFFER_LEVEL_UPDATED = "bufferLevelUpdated", u.DYNAMIC_TO_STATIC = "dynamicToStatic", u.ERROR = "error", u.FRAGMENT_LOADING_COMPLETED = "fragmentLoadingCompleted", u.FRAGMENT_LOADING_PROGRESS = "fragmentLoadingProgress", u.FRAGMENT_LOADING_STARTED = "fragmentLoadingStarted", u.FRAGMENT_LOADING_ABANDONED = "fragmentLoadingAbandoned", u.LOG = "log", u.MANIFEST_LOADED = "manifestLoaded", u.METRICS_CHANGED = "metricsChanged", u.METRIC_CHANGED = "metricChanged", u.METRIC_ADDED = "metricAdded", u.METRIC_UPDATED = "metricUpdated", u.PERIOD_SWITCH_STARTED = "periodSwitchStarted", u.PERIOD_SWITCH_COMPLETED = "periodSwitchCompleted", u.QUALITY_CHANGE_REQUESTED = "qualityChangeRequested", u.QUALITY_CHANGE_RENDERED = "qualityChangeRendered", u.TRACK_CHANGE_RENDERED = "trackChangeRendered", u.STREAM_INITIALIZING = "streamInitializing", u.STREAM_UPDATED = "streamUpdated", u.STREAM_ACTIVATED = "streamActivated", u.STREAM_DEACTIVATED = "streamDeactivated", u.STREAM_INITIALIZED = "streamInitialized", u.STREAM_TEARDOWN_COMPLETE = "streamTeardownComplete", u.TEXT_TRACKS_ADDED = "allTextTracksAdded", u.TEXT_TRACK_ADDED = "textTrackAdded", u.TTML_PARSED = "ttmlParsed", u.TTML_TO_PARSE = "ttmlToParse", u.CAPTION_RENDERED = "captionRendered", u.CAPTION_CONTAINER_RESIZE = "captionContainerResize", u.CAN_PLAY = "canPlay", u.CAN_PLAY_THROUGH = "canPlayThrough", u.PLAYBACK_ENDED = "playbackEnded", u.PLAYBACK_ERROR = "playbackError", u.PLAYBACK_NOT_ALLOWED = "playbackNotAllowed", u.PLAYBACK_METADATA_LOADED = "playbackMetaDataLoaded", u.PLAYBACK_LOADED_DATA = "playbackLoadedData", u.PLAYBACK_PAUSED = "playbackPaused", u.PLAYBACK_PLAYING = "playbackPlaying", u.PLAYBACK_PROGRESS = "playbackProgress", u.PLAYBACK_RATE_CHANGED = "playbackRateChanged", u.PLAYBACK_SEEKED = "playbackSeeked", u.PLAYBACK_SEEKING = "playbackSeeking", u.PLAYBACK_STALLED = "playbackStalled", u.PLAYBACK_STARTED = "playbackStarted", u.PLAYBACK_TIME_UPDATED = "playbackTimeUpdated", u.PLAYBACK_VOLUME_CHANGED = "playbackVolumeChanged", u.PLAYBACK_WAITING = "playbackWaiting", u.MANIFEST_VALIDITY_CHANGED = "manifestValidityChanged", u.EVENT_MODE_ON_START = "eventModeOnStart", u.EVENT_MODE_ON_RECEIVE = "eventModeOnReceive", u.CONFORMANCE_VIOLATION = "conformanceViolation", u.REPRESENTATION_SWITCH = "representationSwitch", u.ADAPTATION_SET_REMOVED_NO_CAPABILITIES = "adaptationSetRemovedNoCapabilities", u.CONTENT_STEERING_REQUEST_COMPLETED = "contentSteeringRequestCompleted", u;
              }
              return y;
            }(g.default), L = new _();
            const v = L;
          }
        ),
        /***/
        "./src/streaming/MediaPlayerFactory.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/MediaPlayerFactory.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var g = e(
              /*! ./MediaPlayer */
              "./src/streaming/MediaPlayer.js"
            );
            function n() {
              var S = "application/dash+xml", h;
              function _(c, o, y) {
                if (!c || !/^VIDEO$/i.test(c.nodeName))
                  return null;
                if (c._dashjs_player)
                  return c._dashjs_player;
                var u, A = c.id || c.name || "video element";
                if (o = o || [].slice.call(c.querySelectorAll("source")).filter(function(I) {
                  return I.type == S;
                })[0], !o && c.src)
                  o = document.createElement("source"), o.src = c.src;
                else if (!o && !c.src)
                  return null;
                return y = y || {}, u = (0, g.default)(y).create(), u.initialize(c, o.src, c.autoplay), h || (h = u.getDebug().getLogger()), h.debug("Converted " + A + " to dash.js player and added content: " + o.src), c._dashjs_player = u, u;
              }
              function L(c, o) {
                var y = [];
                c = c || "[data-dashjs-player]", o = o || document;
                for (var u = o.querySelectorAll(c), A = 0; A < u.length; A++) {
                  var I = _(u[A], null);
                  y.push(I);
                }
                for (var M = o.querySelectorAll('source[type="' + S + '"]'), E = 0; E < M.length; E++) {
                  var N = v(M[E]), C = _(N, null);
                  y.push(C);
                }
                return y;
              }
              function v(c) {
                return /^VIDEO$/i.test(c.nodeName) ? c : v(c.parentNode);
              }
              return {
                create: _,
                createAll: L
              };
            }
            var i = n(), r;
            function l() {
              window.removeEventListener("load", l), i.createAll();
            }
            function d() {
              window.dashjs && (window.clearInterval(r), i.createAll());
            }
            var t = typeof window < "u" && window && window.dashjs && window.dashjs.skipAutoCreate;
            !t && typeof window < "u" && window && window.addEventListener && (window.document.readyState === "complete" ? window.dashjs ? i.createAll() : r = window.setInterval(d, 500) : window.addEventListener("load", l));
            const T = i;
          }
        ),
        /***/
        "./src/streaming/PreBufferSink.js": (
          /*!****************************************!*\
            !*** ./src/streaming/PreBufferSink.js ***!
            \****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), n = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function i(d) {
              var t = this.context, T, S, h, _ = [], L = d;
              function v() {
                S = (0, g.default)(t).getInstance().getLogger(T);
              }
              function c() {
                _ = [], h = null, L = null;
              }
              function o(b) {
                return b.segmentType !== "InitializationSegment" ? (_.push(b), _.sort(function(w, V) {
                  return w.start - V.start;
                }), h = null) : h = b, S.debug("PreBufferSink appended chunk s: " + b.start + "; e: " + b.end), L && L({
                  chunk: b
                }), Promise.resolve();
              }
              function y(b, w) {
                return _ = _.filter(function(V) {
                  return !((isNaN(w) || V.start < w) && (isNaN(b) || V.end > b));
                }), Promise.resolve();
              }
              function u() {
                return Promise.resolve();
              }
              function A() {
                for (var b = [], w = 0; w < _.length; w++) {
                  var V = _[w];
                  b.length === 0 || V.start > b[b.length - 1].end ? b.push({
                    start: V.start,
                    end: V.end
                  }) : b[b.length - 1].end = V.end;
                }
                var J = {
                  start: function(z) {
                    return b[z].start;
                  },
                  end: function(z) {
                    return b[z].end;
                  }
                };
                return Object.defineProperty(J, "length", {
                  get: function() {
                    return b.length;
                  }
                }), J;
              }
              function I() {
                return Promise.resolve();
              }
              function M() {
                return this;
              }
              function E(b, w) {
                var V = N(b, w);
                return h && (V.push(h), h = null), y(b, w), V;
              }
              function N(b, w) {
                return _.filter(function(V) {
                  return (isNaN(w) || V.start < w) && (isNaN(b) || V.end > b);
                });
              }
              function C(b) {
                b();
              }
              return T = {
                getAllBufferRanges: A,
                append: o,
                remove: y,
                abort: u,
                discharge: E,
                reset: c,
                updateTimestampOffset: I,
                waitForUpdateEnd: C,
                getBuffer: M
              }, v(), T;
            }
            i.__dashjs_factory_name = "PreBufferSink";
            var r = n.default.getClassFactory(i);
            const l = r;
          }
        ),
        /***/
        "./src/streaming/SourceBufferSink.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/SourceBufferSink.js ***!
            \*******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => c
              /* harmony export */
            });
            var g = e(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), n = e(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), i = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), l = e(
              /*! ../core/Settings */
              "./src/core/Settings.js"
            ), d = e(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), t = e(
              /*! ./vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), T = e(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), S = 0.1, h = 0.01, _ = 50;
            function L(o) {
              var y = this.context, u = (0, l.default)(y).getInstance(), A = o.textController, I = o.eventBus, M, E, N, C, b, w, V = [], J = [], H = !1, z = o.mediaSource, Z = null;
              function ie() {
                N = (0, g.default)(y).getInstance().getLogger(M);
              }
              function K($, ce, le) {
                b = $, E = b.type;
                var q = b.codec;
                ne(le), Q();
                var _e = [];
                return _e.push(te()), _e.push(Me(b.streamInfo)), _e.push(Y(q)), ce && ce.MSETimeOffset !== void 0 && _e.push(ge(ce.MSETimeOffset)), Promise.all(_e);
              }
              function Y($) {
                return new Promise(function(ce) {
                  W(function() {
                    C.changeType && C.changeType($), ce();
                  });
                });
              }
              function ne($) {
                C = $.getBuffer();
              }
              function ae($, ce, le) {
                b = ce, E = b.type;
                var q = b.codec;
                try {
                  if (q.match(/application\/mp4;\s*codecs="(stpp|wvtt).*"/i))
                    return fe($);
                  C = z.addSourceBuffer(q), Q();
                  var _e = [];
                  return _e.push(Me(b.streamInfo)), le && le.MSETimeOffset !== void 0 && _e.push(ge(le.MSETimeOffset)), Promise.all(_e);
                } catch (Ee) {
                  return b.type == d.default.TEXT && !b.isFragmented || q.indexOf('codecs="stpp') !== -1 || q.indexOf('codecs="vtt') !== -1 ? fe($) : Promise.reject(Ee);
                }
              }
              function fe($) {
                return C = A.getTextSourceBuffer($), Promise.resolve();
              }
              function Q() {
                if (typeof C.addEventListener == "function")
                  try {
                    C.addEventListener("updateend", X, !1), C.addEventListener("error", F, !1), C.addEventListener("abort", F, !1);
                  } catch {
                    w = setInterval(X, _);
                  }
                else
                  w = setInterval(X, _);
              }
              function oe() {
                return E;
              }
              function de() {
                try {
                  typeof C.removeEventListener == "function" && (C.removeEventListener("updateend", X, !1), C.removeEventListener("error", F, !1), C.removeEventListener("abort", F, !1)), clearInterval(w);
                } catch ($) {
                  N.error($);
                }
              }
              function Me($) {
                return new Promise(function(ce) {
                  if (!C || !u.get().streaming.buffer.useAppendWindow) {
                    ce();
                    return;
                  }
                  W(function() {
                    try {
                      if (!C) {
                        ce();
                        return;
                      }
                      var le = z.duration, q = 0;
                      $ && !isNaN($.start) && !isNaN($.duration) && isFinite($.duration) && (le = $.start + $.duration), $ && !isNaN($.start) && (q = $.start), (C.appendWindowEnd !== le || C.appendWindowStart !== q) && (C.appendWindowStart = 0, C.appendWindowEnd = le + h, C.appendWindowStart = Math.max(q - S, 0), N.debug("Updated append window for ".concat(b.type, ". Set start to ").concat(C.appendWindowStart, " and end to ").concat(C.appendWindowEnd))), ce();
                    } catch {
                      N.warn("Failed to set append window"), ce();
                    }
                  });
                });
              }
              function ge($) {
                return new Promise(function(ce) {
                  if (!C) {
                    ce();
                    return;
                  }
                  W(function() {
                    try {
                      C.timestampOffset !== $ && !isNaN($) && (C.timestampOffset = $, N.debug("Set MSE timestamp offset to ".concat($))), ce();
                    } catch {
                      ce();
                    }
                  });
                });
              }
              function se() {
                if (C) {
                  try {
                    V = [], de(), H = !1, J = [], (!C.getClassName || C.getClassName() !== "TextSourceBuffer") && (N.debug("Removing sourcebuffer from media source"), z.removeSourceBuffer(C));
                  } catch {
                  }
                  C = null;
                }
                Z = null;
              }
              function ee() {
                return C;
              }
              function re() {
                try {
                  return C.buffered;
                } catch ($) {
                  return N.error("getAllBufferRanges exception: " + $.message), null;
                }
              }
              function ue($) {
                var ce = this, le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return new Promise(function(q, _e) {
                  if (!$) {
                    _e({
                      chunk: $,
                      error: new n.default(r.default.APPEND_ERROR_CODE, r.default.APPEND_ERROR_MESSAGE)
                    });
                    return;
                  }
                  J.push({
                    data: $,
                    promise: {
                      resolve: q,
                      reject: _e
                    },
                    request: le
                  }), W(p.bind(ce));
                });
              }
              function te() {
                return new Promise(function($) {
                  W(function() {
                    var ce = C.appendWindowStart, le = C.appendWindowEnd;
                    C && (C.abort(), C.appendWindowStart = ce, C.appendWindowEnd = le), $();
                  });
                });
              }
              function O($) {
                return new Promise(function(ce, le) {
                  var q = $.start, _e = $.end;
                  if (!(q >= 0 && _e > q)) {
                    ce();
                    return;
                  }
                  W(function() {
                    try {
                      C.remove(q, _e), W(function() {
                        ce({
                          from: q,
                          to: _e,
                          unintended: !1
                        }), $.resolve && $.resolve();
                      });
                    } catch (Ee) {
                      le({
                        from: q,
                        to: _e,
                        unintended: !1,
                        error: new n.default(r.default.REMOVE_ERROR_CODE, r.default.REMOVE_ERROR_MESSAGE)
                      }), $.reject && $.reject(Ee);
                    }
                  });
                });
              }
              function p() {
                if (!H && J.length > 0) {
                  H = !0;
                  var $ = J[0];
                  J.splice(0, 1);
                  var ce = function() {
                    H = !1, J.length > 0 && p.call(this), $ && $.data && $.data.segmentType && $.data.segmentType !== t.HTTPRequest.INIT_SEGMENT_TYPE && delete $.data.bytes, $.promise.resolve({
                      chunk: $.data
                    });
                  };
                  try {
                    Z = $.request, $.data.bytes.byteLength === 0 ? ce.call(this) : (C.appendBuffer ? C.appendBuffer($.data.bytes) : C.append($.data.bytes, $.data), W(ce.bind(this)));
                  } catch (le) {
                    N.fatal('SourceBuffer append failed "' + le + '"'), J.length > 0 ? p() : H = !1, delete $.data.bytes, $.promise.reject({
                      chunk: $.data,
                      error: new n.default(le.code, le.message)
                    });
                  }
                }
              }
              function P() {
                return new Promise(function($) {
                  try {
                    J = [], z.readyState === "open" ? W(function() {
                      try {
                        C && C.abort(), $();
                      } catch {
                        $();
                      }
                    }) : (C && C.setTextTrack && z.readyState === "ended" && C.abort(), $());
                  } catch {
                    $();
                  }
                });
              }
              function k() {
                if (V.length > 0 && !C.updating) {
                  var $ = V.shift();
                  $(), k();
                }
              }
              function X() {
                C.updating || k();
              }
              function F($) {
                var ce = $.target || {};
                x(T.default.SOURCE_BUFFER_ERROR, {
                  error: ce,
                  lastRequestAppended: Z
                });
              }
              function x($, ce) {
                var le = ce || {};
                I.trigger($, le, {
                  streamId: b.streamInfo.id,
                  mediaType: E
                });
              }
              function W($) {
                V.push($), C.updating || k();
              }
              return M = {
                getType: oe,
                getAllBufferRanges: re,
                getBuffer: ee,
                append: ue,
                remove: O,
                abort: P,
                reset: se,
                updateTimestampOffset: ge,
                initializeForStreamSwitch: K,
                initializeForFirstUse: ae,
                updateAppendWindow: Me,
                changeType: Y
              }, ie(), M;
            }
            L.__dashjs_factory_name = "SourceBufferSink";
            var v = i.default.getClassFactory(L);
            const c = v;
          }
        ),
        /***/
        "./src/streaming/Stream.js": (
          /*!*********************************!*\
            !*** ./src/streaming/Stream.js ***!
            \*********************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => u
              /* harmony export */
            });
            var g = e(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), i = e(
              /*! ./StreamProcessor */
              "./src/streaming/StreamProcessor.js"
            ), r = e(
              /*! ./controllers/FragmentController */
              "./src/streaming/controllers/FragmentController.js"
            ), l = e(
              /*! ./thumbnail/ThumbnailController */
              "./src/streaming/thumbnail/ThumbnailController.js"
            ), d = e(
              /*! ../core/EventBus */
              "./src/core/EventBus.js"
            ), t = e(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), T = e(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), S = e(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), h = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), _ = e(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), L = e(
              /*! ./utils/BoxParser */
              "./src/streaming/utils/BoxParser.js"
            ), v = e(
              /*! ./utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), c = e(
              /*! ./controllers/BlacklistController */
              "./src/streaming/controllers/BlacklistController.js"
            ), o = [g.default.VIDEO, g.default.AUDIO, g.default.TEXT, g.default.MUXED, g.default.IMAGE];
            function y(A) {
              A = A || {};
              var I = this.context, M = (0, d.default)(I).getInstance(), E = (0, v.default)(I).getInstance(), N = A.manifestModel, C = A.mediaPlayerModel, b = A.dashMetrics, w = A.manifestUpdater, V = A.adapter, J = A.timelineConverter, H = A.capabilities, z = A.errHandler, Z = A.abrController, ie = A.playbackController, K = A.eventController, Y = A.mediaController, ne = A.protectionController, ae = A.textController, fe = A.videoModel, Q = A.streamInfo, oe = A.settings, de, Me, ge, se, ee, re, ue, te, O, p, P, k, X, F, x, W, $, ce;
              function le() {
                try {
                  W = (0, T.default)(I).getInstance(), Me = W.getLogger(de), Et(), x = (0, L.default)(I).getInstance(), X = (0, c.default)(I).create({
                    updateEventName: t.default.SEGMENT_LOCATION_BLACKLIST_CHANGED,
                    addBlacklistEventName: t.default.SEGMENT_LOCATION_BLACKLIST_ADD
                  }), P = (0, r.default)(I).create({
                    streamInfo: Q,
                    mediaPlayerModel: C,
                    dashMetrics: b,
                    errHandler: z,
                    settings: oe,
                    boxParser: x,
                    dashConstants: n.default,
                    urlUtils: E
                  });
                } catch (Je) {
                  throw Je;
                }
              }
              function q() {
                _e(), Te(), ae.initializeForStream(Q), M.trigger(t.default.STREAM_UPDATED, {
                  streamInfo: Q
                });
              }
              function _e() {
                M.on(t.default.BUFFERING_COMPLETED, dt, de), M.on(t.default.DATA_UPDATE_COMPLETED, Tt, de), M.on(t.default.INBAND_EVENTS, wt, de);
              }
              function Ee() {
                M.off(t.default.DATA_UPDATE_COMPLETED, Tt, de), M.off(t.default.BUFFERING_COMPLETED, dt, de), M.off(t.default.INBAND_EVENTS, wt, de);
              }
              function Te() {
                ne && (M.on(t.default.KEY_ERROR, Lt, de), M.on(t.default.SERVER_CERTIFICATE_UPDATED, Lt, de), M.on(t.default.LICENSE_REQUEST_COMPLETE, Lt, de), M.on(t.default.KEY_SYSTEM_SELECTED, Lt, de), M.on(t.default.KEY_SESSION_CREATED, Lt, de), M.on(t.default.KEY_STATUSES_CHANGED, Lt, de));
              }
              function Ce() {
                ne && (M.off(t.default.KEY_ERROR, Lt, de), M.off(t.default.SERVER_CERTIFICATE_UPDATED, Lt, de), M.off(t.default.LICENSE_REQUEST_COMPLETE, Lt, de), M.off(t.default.KEY_SYSTEM_SELECTED, Lt, de), M.off(t.default.KEY_SESSION_CREATED, Lt, de), M.off(t.default.KEY_STATUSES_CHANGED, Lt, de));
              }
              function xe() {
                return Q ? Q.id : null;
              }
              function be(Je, At) {
                return new Promise(function(It, Oe) {
                  if (ee) {
                    It(At);
                    return;
                  }
                  if (Dt()) {
                    ee = !0, M.trigger(t.default.STREAM_ACTIVATED, {
                      streamInfo: Q
                    }), It(At);
                    return;
                  }
                  Pe(Je, At).then(function(ke) {
                    ee = !0, M.trigger(t.default.STREAM_ACTIVATED, {
                      streamInfo: Q
                    }), It(ke);
                  }).catch(function(ke) {
                    Oe(ke);
                  });
                });
              }
              function Ge(Je, At) {
                return new Promise(function(It, Oe) {
                  if (Dt()) {
                    Oe();
                    return;
                  }
                  Me.info("[startPreloading] Preloading next stream with id ".concat(Ie())), Nt(!0), Le(Je, At).then(function() {
                    for (var ke = 0; ke < ge.length && ge[ke]; ke++)
                      ge[ke].setExplicitBufferingTime(me()), ge[ke].getScheduleController().startScheduleTimer();
                    It();
                  }).catch(function() {
                    Nt(!1), Oe();
                  });
                });
              }
              function Pe(Je, At) {
                return Le(Je, At);
              }
              function Le(Je, At) {
                return new Promise(function(It, Oe) {
                  et(), p = !0, ze();
                  var ke = fe.getElement();
                  o.forEach(function(pe) {
                    !(pe === g.default.TEXT && !Je) && (pe !== g.default.VIDEO || !ke || ke && /^VIDEO$/i.test(ke.nodeName)) && Ze(pe, Je);
                  }), De(At).then(function(pe) {
                    if (p = !1, ge.length === 0) {
                      var Ve = "No streams to play.";
                      z.error(new _.default(S.default.MANIFEST_ERROR_ID_NOSTREAMS_CODE, Ve, N.getValue())), Me.fatal(Ve);
                    } else
                      qe();
                    Je && ae.createTracks(Q), It(pe);
                  }).catch(function(pe) {
                    Oe(pe);
                  });
                });
              }
              function je(Je) {
                return new Promise(function(At, It) {
                  Ze(g.default.TEXT, Je), Ye().then(function() {
                    ae.createTracks(Q), At();
                  }).catch(function(Oe) {
                    It(Oe);
                  });
                });
              }
              function Ze(Je, At) {
                var It = V.getAllMediaInfoForType(Q, Je), Oe = [], ke = null, pe;
                if (!It || It.length === 0) {
                  Me.info("No " + Je + " data.");
                  return;
                }
                Je === g.default.VIDEO && (ue = !0), Je === g.default.AUDIO && (te = !0);
                for (var Ve = 0, ut = It.length; Ve < ut; Ve++)
                  ke = It[Ve], Je === g.default.TEXT && ke.isEmbedded && (ae.addEmbeddedTrack(Q, ke), Oe.push(ke)), nt(ke) && Y.addTrack(ke);
                if (Oe.length > 0 && (Y.setInitialMediaSettingsForType(Je, Q), ae.addMediaInfosToBuffer(Q, Je, Oe)), It = It.filter(function(jt) {
                  return !jt.isEmbedded;
                }), It.length !== 0) {
                  if (Je === g.default.IMAGE) {
                    k = (0, l.default)(I).create({
                      streamInfo: Q,
                      adapter: V,
                      baseURLController: A.baseURLController,
                      timelineConverter: A.timelineConverter,
                      debug: W,
                      eventBus: M,
                      events: t.default,
                      dashConstants: n.default,
                      dashMetrics: A.dashMetrics,
                      segmentBaseController: A.segmentBaseController
                    }), k.initialize();
                    return;
                  }
                  M.trigger(t.default.STREAM_INITIALIZING, {
                    streamInfo: Q,
                    mediaInfo: ke
                  }), Y.setInitialMediaSettingsForType(Je, Q);
                  var St = it(It, At);
                  pe = Y.getCurrentTrackFor(Je, Q.id), pe && (Z.updateTopQualityIndex(pe), St.selectMediaInfo(Je !== g.default.TEXT || !pe.isEmbedded ? pe : It[0]));
                }
              }
              function nt(Je) {
                var At = Je ? Je.type : null, It;
                return At === g.default.MUXED ? (It = "Multiplexed representations are intentionally not supported, as they are not compliant with the DASH-AVC/264 guidelines", Me.fatal(It), z.error(new _.default(S.default.MANIFEST_ERROR_ID_MULTIPLEXED_CODE, It, N.getValue())), !1) : At === g.default.TEXT || At === g.default.IMAGE ? !0 : Je.contentProtection && !H.supportsEncryptedMedia() ? (z.error(new _.default(S.default.CAPABILITY_MEDIAKEYS_ERROR_CODE, S.default.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE)), !1) : !0;
              }
              function it(Je, At) {
                var It = Je && Je.length > 0 ? Je[0] : null, Oe = P.getModel(It ? It.type : null), ke = It ? It.type : null, pe = It ? It.mimeType : null, Ve = It ? It.isFragmented : null, ut = (0, i.default)(I).create({
                  streamInfo: Q,
                  type: ke,
                  mimeType: pe,
                  timelineConverter: J,
                  adapter: V,
                  manifestModel: N,
                  mediaPlayerModel: C,
                  fragmentModel: Oe,
                  dashMetrics: A.dashMetrics,
                  baseURLController: A.baseURLController,
                  segmentBaseController: A.segmentBaseController,
                  abrController: Z,
                  playbackController: ie,
                  mediaController: Y,
                  textController: ae,
                  errHandler: z,
                  settings: oe,
                  boxParser: x,
                  segmentBlacklistController: X
                });
                ut.initialize(At, ue, Ve), ge.push(ut);
                for (var St = 0; St < Je.length; St++)
                  ut.addMediaInfo(Je[St]);
                return ke === g.default.TEXT && ae.addMediaInfosToBuffer(Q, ke, Je, Oe), ut;
              }
              function De(Je) {
                return new Promise(function(At) {
                  var It = {}, Oe = ge.map(function(ke) {
                    return ke.createBufferSinks(Je);
                  });
                  Promise.all(Oe).then(function(ke) {
                    ke.forEach(function(pe) {
                      pe && (It[pe.getType()] = pe);
                    }), At(It);
                  }).catch(function() {
                    At(It);
                  });
                });
              }
              function Ye() {
                var Je = Xt(g.default.TEXT);
                return Je ? Je.createBufferSinks() : Promise.resolve();
              }
              function Ke(Je) {
                for (var At = ge ? ge.length : 0, It = !1, Oe = 0; Oe < At; Oe++) {
                  var ke = ge[Oe].getFragmentModel();
                  ke.abortRequests(), ke.resetInitialSettings(), ge[Oe].reset(It, Je);
                }
                ae && ae.deactivateStream(Q), ge = [], ee = !1, re = !1, Nt(!1), ve(!1), M.trigger(t.default.STREAM_DEACTIVATED, {
                  streamInfo: Q
                });
              }
              function tt() {
                return ee;
              }
              function st(Je) {
                return new Promise(function(At, It) {
                  for (var Oe = [], ke = 0; ke < ge.length; )
                    nt(ge[ke].getMediaInfo()) ? (Oe.push(ge[ke].setMediaSource(Je)), ke++) : (ge[ke].reset(), ge.splice(ke, 1));
                  Promise.all(Oe).then(function() {
                    for (var pe = 0; pe < ge.length; pe++)
                      ge[pe].dischargePreBuffer();
                    if (ge.length === 0) {
                      var Ve = "No streams to play.";
                      z.error(new _.default(S.default.MANIFEST_ERROR_ID_NOSTREAMS_CODE, Ve + "nostreams", N.getValue())), Me.fatal(Ve);
                    }
                    At();
                  }).catch(function(pe) {
                    Me.error(pe), It(pe);
                  });
                });
              }
              function Et(Je) {
                Ke(Je), se = !1, ue = !1, te = !1, O = {}, p = !1, $ = !1, ce = [];
              }
              function ht(Je) {
                P && (P.reset(), P = null), Z && Q && Z.clearDataForStream(Q.id), X && (X.reset(), X = null), Et(Je), Q = null, Ee(), Ce();
              }
              function xt() {
                return Q ? Q.duration : NaN;
              }
              function Xe() {
                return $;
              }
              function ve(Je) {
                $ = Je;
              }
              function me() {
                return Q ? Q.start : NaN;
              }
              function Ie() {
                return Q ? Q.id : null;
              }
              function we() {
                return Q;
              }
              function Ue() {
                return te;
              }
              function $e() {
                return ue;
              }
              function at() {
                return k;
              }
              function et() {
                if (!fe || !Z)
                  throw new Error(g.default.MISSING_CONFIG_ERROR);
              }
              function Mt(Je) {
                if (et(), Je === g.default.IMAGE)
                  return k ? k.getBitrateList() : [];
                var At = _t(Je);
                return Z.getBitrateList(At);
              }
              function Lt(Je) {
                Je.error && (z.error(Je.error), Me.fatal(Je.error.message));
              }
              function bt(Je) {
                if (!(!ee || !Q)) {
                  re = !1;
                  var At = Je.newMediaInfo, It = N.getValue();
                  V.setCurrentMediaInfo(Q.id, At.type, At);
                  var Oe = Gt(At);
                  if (Oe) {
                    var ke = ie.getTime();
                    Me.info("Stream -  Process track changed at current time " + ke), It.refreshManifestOnSwitchTrack ? (ce.push(Je), w.getIsUpdating() || (Me.debug("Stream -  Refreshing manifest for switch track"), w.refreshManifest())) : Oe.selectMediaInfo(At).then(function() {
                      (At.type === g.default.VIDEO || At.type === g.default.AUDIO) && Z.updateTopQualityIndex(At), Oe.prepareTrackSwitch();
                    });
                  }
                }
              }
              function Ae(Je) {
                var At = Xt(Je.mediaType);
                At && At.prepareQualityChange(Je);
              }
              function ze() {
                if (K) {
                  var Je = V.getEventsFor(Q);
                  Je && Je.length > 0 && K.addInlineEvents(Je, Q.id);
                }
              }
              function qe() {
                for (var Je = ge.length, At = !!O.audio || !!O.video, It = At ? new _.default(S.default.DATA_UPDATE_FAILED_ERROR_CODE, S.default.DATA_UPDATE_FAILED_ERROR_MESSAGE) : null, Oe = 0; Oe < Je; Oe++)
                  if (ge[Oe].isUpdating() || p)
                    return;
                if (ne) {
                  ne.clearMediaInfoArray();
                  for (var ke = 0; ke < Je && ge[ke]; ke++) {
                    var pe = ge[ke].getType(), Ve = ge[ke].getMediaInfo();
                    if (pe === g.default.AUDIO || pe === g.default.VIDEO || pe === g.default.TEXT && Ve.isFragmented) {
                      var ut = ge[ke].getMediaInfo();
                      ut && ne.initializeForMedia(ut);
                    }
                  }
                  ne.handleKeySystemFromManifest();
                }
                It ? z.error(It) : se || (se = !0, fe.waitForReadyState(g.default.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                  M.trigger(t.default.STREAM_INITIALIZED, {
                    streamInfo: Q
                  });
                }));
              }
              function _t(Je) {
                for (var At = null, It = 0; It < ge.length; It++)
                  if (At = ge[It], At.getType() === Je)
                    return At.getMediaInfo();
                return null;
              }
              function dt() {
                var Je = ye(), At = Je.length;
                if (At === 0) {
                  Me.warn("onBufferingCompleted - can't trigger STREAM_BUFFERING_COMPLETED because no streamProcessor is defined");
                  return;
                }
                for (var It = 0; It < At; It++)
                  if (!Je[It].isBufferingCompleted() && (Je[It].getType() === g.default.AUDIO || Je[It].getType() === g.default.VIDEO)) {
                    Me.debug("onBufferingCompleted - One streamProcessor has finished but", Je[It].getType(), "one is not buffering completed");
                    return;
                  }
                Me.debug("onBufferingCompleted - trigger STREAM_BUFFERING_COMPLETED"), re = !0, M.trigger(t.default.STREAM_BUFFERING_COMPLETED, {
                  streamInfo: Q
                }, {
                  streamInfo: Q
                });
              }
              function Tt(Je) {
                O[Je.mediaType] = Je.error, qe();
              }
              function wt(Je) {
                K && K.addInbandEvents(Je.events, Q.id);
              }
              function Gt(Je) {
                return !Je || !Je.type ? null : Xt(Je.type);
              }
              function Xt(Je) {
                if (!Je)
                  return null;
                var At = ye();
                return At.filter(function(It) {
                  return It.getType() === Je;
                })[0];
              }
              function ye() {
                for (var Je = [], At, It, Oe = 0; Oe < ge.length; Oe++)
                  It = ge[Oe], At = It.getType(), (At === g.default.AUDIO || At === g.default.VIDEO || At === g.default.TEXT) && Je.push(It);
                return Je;
              }
              function Qe() {
                for (var Je = ge.length, At = 0; At < Je && ge[At]; At++)
                  ge[At].getScheduleController().startScheduleTimer();
              }
              function ct(Je) {
                return new Promise(function(At) {
                  p = !0, Q = Je, K && ze();
                  for (var It = [], Oe = 0, ke = ge.length; Oe < ke; Oe++) {
                    var pe = ge[Oe], Ve = pe.getMediaInfo();
                    It.push(pe.updateStreamInfo(Q));
                    var ut = V.getAllMediaInfoForType(Q, pe.getType());
                    if (ut = ut.filter(function(Kt) {
                      return !Kt.isEmbedded;
                    }), ut) {
                      pe.clearMediaInfoArray();
                      for (var St = 0; St < ut.length; St++) {
                        var jt = ut[St];
                        pe.addMediaInfo(ut[St]), V.areMediaInfosEqual(Ve, jt) && (Z.updateTopQualityIndex(jt), It.push(pe.selectMediaInfo(jt)));
                      }
                    }
                  }
                  Promise.all(It).then(function() {
                    for (It = []; ce.length > 0; ) {
                      var Kt = ce.pop(), $t = Kt.newMediaInfo, Yt = Gt(Kt.oldMediaInfo);
                      if (!Yt)
                        return;
                      It.push(Yt.prepareTrackSwitch()), Yt.selectMediaInfo($t);
                    }
                    return Promise.all(It);
                  }).then(function() {
                    p = !1, qe(), M.trigger(t.default.STREAM_UPDATED, {
                      streamInfo: Q
                    }), At();
                  });
                });
              }
              function Se(Je) {
                var At = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return zt(Je, g.default.VIDEO, At) && zt(Je, g.default.AUDIO, At);
              }
              function Be(Je) {
                return Je ? He(g.default.VIDEO, Je) && He(g.default.AUDIO, Je) : !0;
              }
              function He(Je, At) {
                var It = we(), Oe = At.getStreamInfo();
                if (!Oe || !It)
                  return !0;
                var ke = V.getAdaptationForType(Oe.index, Je, Oe), pe = V.getAdaptationForType(It.index, Je, It);
                return !ke || !pe ? !ke && !pe : !(!yt(pe) && yt(ke));
              }
              function yt(Je) {
                return Je ? !!(Je.ContentProtection || Je.Representation && Je.Representation.length > 0 && Je.Representation[0].ContentProtection) : !1;
              }
              function zt(Je, At) {
                var It = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                if (!Je || !Je.hasOwnProperty("getStreamInfo"))
                  return !1;
                var Oe = Je.getStreamInfo(), ke = It ? It.getStreamInfo() : we();
                if (!Oe || !ke)
                  return !1;
                var pe = V.getAdaptationForType(Oe.index, At, Oe), Ve = V.getAdaptationForType(ke.index, At, ke);
                if (!pe || !Ve)
                  return !pe && !Ve;
                var ut = pe && Ve && pe.mimeType === Ve.mimeType, St = Ve.Representation_asArray.map(function(Yt) {
                  return Yt.codecs;
                }), jt = pe.Representation_asArray.map(function(Yt) {
                  return Yt.codecs;
                }), Kt = jt.some(function(Yt) {
                  return St.indexOf(Yt) > -1;
                }), $t = jt.some(function(Yt) {
                  return St.some(function(gr) {
                    return H.codecRootCompatibleWithCodec(gr, Yt);
                  });
                });
                return Kt || $t && ut;
              }
              function Nt(Je) {
                F = Je;
              }
              function Dt() {
                return F;
              }
              function ar() {
                return re;
              }
              function Qt() {
                return V;
              }
              return de = {
                initialize: q,
                getStreamId: xe,
                activate: be,
                deactivate: Ke,
                getIsActive: tt,
                getDuration: xt,
                getStartTime: me,
                getId: Ie,
                getStreamInfo: we,
                getHasAudioTrack: Ue,
                getHasVideoTrack: $e,
                startPreloading: Ge,
                initializeForTextWithMediaSource: je,
                getThumbnailController: at,
                getBitrateListFor: Mt,
                updateData: ct,
                reset: ht,
                getProcessors: ye,
                setMediaSource: st,
                isMediaCodecCompatible: Se,
                isProtectionCompatible: Be,
                getPreloaded: Dt,
                getIsEndedEventSignaled: Xe,
                setIsEndedEventSignaled: ve,
                getAdapter: Qt,
                getHasFinishedBuffering: ar,
                setPreloaded: Nt,
                startScheduleControllers: Qe,
                prepareTrackChange: bt,
                prepareQualityChange: Ae
              }, le(), de;
            }
            y.__dashjs_factory_name = "Stream";
            const u = h.default.getClassFactory(y);
          }
        ),
        /***/
        "./src/streaming/StreamProcessor.js": (
          /*!******************************************!*\
            !*** ./src/streaming/StreamProcessor.js ***!
            \******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => b
              /* harmony export */
            });
            var g = e(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), i = e(
              /*! ./constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), r = e(
              /*! ./models/FragmentModel */
              "./src/streaming/models/FragmentModel.js"
            ), l = e(
              /*! ./controllers/BufferController */
              "./src/streaming/controllers/BufferController.js"
            ), d = e(
              /*! ./text/NotFragmentedTextBufferController */
              "./src/streaming/text/NotFragmentedTextBufferController.js"
            ), t = e(
              /*! ./controllers/ScheduleController */
              "./src/streaming/controllers/ScheduleController.js"
            ), T = e(
              /*! ../dash/controllers/RepresentationController */
              "./src/dash/controllers/RepresentationController.js"
            ), S = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), h = e(
              /*! ./utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            ), _ = e(
              /*! ../core/EventBus */
              "./src/core/EventBus.js"
            ), L = e(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), v = e(
              /*! ../dash/DashHandler */
              "./src/dash/DashHandler.js"
            ), c = e(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), o = e(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), y = e(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), u = e(
              /*! ./utils/RequestModifier */
              "./src/streaming/utils/RequestModifier.js"
            ), A = e(
              /*! ../streaming/utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), I = e(
              /*! ./utils/BoxParser */
              "./src/streaming/utils/BoxParser.js"
            ), M = e(
              /*! ./vo/metrics/PlayList */
              "./src/streaming/vo/metrics/PlayList.js"
            ), E = e(
              /*! ../dash/controllers/SegmentsController */
              "./src/dash/controllers/SegmentsController.js"
            ), N = e(
              /*! ./vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            );
            function C(w) {
              w = w || {};
              var V = this.context, J = (0, _.default)(V).getInstance(), H = w.streamInfo, z = w.type, Z = w.errHandler, ie = w.mimeType, K = w.timelineConverter, Y = w.adapter, ne = w.manifestModel, ae = w.mediaPlayerModel, fe = w.fragmentModel, Q = w.abrController, oe = w.playbackController, de = w.mediaController, Me = w.textController, ge = w.dashMetrics, se = w.settings, ee = w.boxParser, re = w.segmentBlacklistController, ue, te, O, p, P, k, X, F, x, W, $, ce, le;
              function q() {
                te = (0, y.default)(V).getInstance().getLogger(ue), xe(), J.on(L.default.DATA_UPDATE_COMPLETED, tt, ue, {
                  priority: _.default.EVENT_PRIORITY_HIGH
                }), J.on(L.default.INIT_FRAGMENT_NEEDED, je, ue), J.on(L.default.MEDIA_FRAGMENT_NEEDED, Ze, ue), J.on(L.default.INIT_FRAGMENT_LOADED, yt, ue), J.on(L.default.MEDIA_FRAGMENT_LOADED, zt, ue), J.on(L.default.BUFFER_LEVEL_STATE_CHANGED, st, ue), J.on(L.default.BUFFER_CLEARED, Et, ue), J.on(L.default.SEEK_TARGET, It, ue), J.on(L.default.FRAGMENT_LOADING_ABANDONED, Ie, ue), J.on(L.default.FRAGMENT_LOADING_COMPLETED, we, ue), J.on(L.default.QUOTA_EXCEEDED, et, ue), J.on(L.default.SET_FRAGMENTED_TEXT_AFTER_DISABLED, $e, ue), J.on(L.default.SET_NON_FRAGMENTED_TEXT, at, ue), J.on(L.default.SOURCE_BUFFER_ERROR, ht, ue);
              }
              function _e(pe, Ve, ut) {
                ce = (0, E.default)(V).create({
                  events: L.default,
                  eventBus: J,
                  streamInfo: H,
                  timelineConverter: K,
                  dashConstants: n.default,
                  segmentBaseController: w.segmentBaseController,
                  type: z
                }), $ = (0, v.default)(V).create({
                  streamInfo: H,
                  type: z,
                  timelineConverter: K,
                  dashMetrics: ge,
                  mediaPlayerModel: ae,
                  baseURLController: w.baseURLController,
                  errHandler: Z,
                  segmentsController: ce,
                  settings: se,
                  boxParser: ee,
                  events: L.default,
                  eventBus: J,
                  errors: c.default,
                  debug: (0, y.default)(V).getInstance(),
                  requestModifier: (0, u.default)(V).getInstance(),
                  dashConstants: n.default,
                  constants: g.default,
                  urlUtils: (0, A.default)(V).getInstance()
                }), O = H.manifestInfo.isDynamic, $.initialize(O), Q.registerStreamType(z, ue), F = (0, T.default)(V).create({
                  streamInfo: H,
                  type: z,
                  abrController: Q,
                  dashMetrics: ge,
                  playbackController: oe,
                  timelineConverter: K,
                  dashConstants: n.default,
                  events: L.default,
                  eventBus: J,
                  errors: c.default,
                  isDynamic: O,
                  segmentsController: ce
                }), k = At(z, ut), k && k.initialize(pe), X = (0, t.default)(V).create({
                  streamInfo: H,
                  type: z,
                  mimeType: ie,
                  adapter: Y,
                  dashMetrics: ge,
                  mediaPlayerModel: ae,
                  fragmentModel: fe,
                  abrController: Q,
                  playbackController: oe,
                  textController: Me,
                  mediaController: de,
                  bufferController: k,
                  settings: se
                }), X.initialize(Ve), le = 0, x = !1;
              }
              function Ee() {
                return H.id;
              }
              function Te() {
                return z;
              }
              function Ce() {
                return Y.getIsTextTrack(F.getData());
              }
              function xe() {
                P = [], p = null, le = 0, x = !1, W = !1;
              }
              function be(pe, Ve) {
                $ && $.reset(), k && (k.reset(pe, Ve), k = null), X && (X.reset(), X = null), F && (F.reset(), F = null), ce && (ce = null), Q && Q.unRegisterStreamType(Ee(), z), J.off(L.default.DATA_UPDATE_COMPLETED, tt, ue), J.off(L.default.INIT_FRAGMENT_NEEDED, je, ue), J.off(L.default.MEDIA_FRAGMENT_NEEDED, Ze, ue), J.off(L.default.INIT_FRAGMENT_LOADED, yt, ue), J.off(L.default.MEDIA_FRAGMENT_LOADED, zt, ue), J.off(L.default.BUFFER_LEVEL_STATE_CHANGED, st, ue), J.off(L.default.BUFFER_CLEARED, Et, ue), J.off(L.default.SEEK_TARGET, It, ue), J.off(L.default.FRAGMENT_LOADING_ABANDONED, Ie, ue), J.off(L.default.FRAGMENT_LOADING_COMPLETED, we, ue), J.off(L.default.SET_FRAGMENTED_TEXT_AFTER_DISABLED, $e, ue), J.off(L.default.SET_NON_FRAGMENTED_TEXT, at, ue), J.off(L.default.QUOTA_EXCEEDED, et, ue), J.off(L.default.SOURCE_BUFFER_ERROR, ht, ue), xe(), z = null, H = null;
              }
              function Ge() {
                return F ? F.isUpdating() : !1;
              }
              function Pe(pe) {
                return new Promise(function(Ve) {
                  var ut = k.hasBufferAtTime(pe.seekTime);
                  if (ut) {
                    k.pruneBuffer(), Ve();
                    return;
                  }
                  X.clearScheduleTimer(), fe.abortRequests(), k.prepareForPlaybackSeek().then(function() {
                    var St = k.getAllRangesWithSafetyFactor(pe.seekTime);
                    return k.clearBuffers(St);
                  }).then(function() {
                    var St = k.getContinuousBufferTimeForTargetTime(pe.seekTime);
                    if (!isNaN(St) && !isNaN(H.duration) && isFinite(H.duration) && St >= H.start + H.duration)
                      k.setIsBufferingCompleted(!0), Ve();
                    else {
                      var jt = isNaN(St) ? pe.seekTime : St;
                      Oe(jt), k.setSeekTarget(jt);
                      var Kt = [];
                      Kt.push(k.updateAppendWindow());
                      var $t = ct();
                      Kt.push(k.updateBufferTimestampOffset($t)), Promise.all(Kt).then(function() {
                        X.setInitSegmentRequired(!0), X.setCheckPlaybackQuality(!1), X.startScheduleTimer(), Ve();
                      });
                    }
                  }).catch(function(St) {
                    te.error(St);
                  });
                });
              }
              function Le() {
                return new Promise(function(pe, Ve) {
                  try {
                    X.clearScheduleTimer(), fe.abortRequests(), k.prepareForPlaybackSeek().then(function() {
                      return k.pruneAllSafely();
                    }).then(function() {
                      pe();
                    });
                  } catch (ut) {
                    Ve(ut);
                  }
                });
              }
              function je(pe) {
                var Ve = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                if (pe.sender) {
                  if (oe.getIsManifestUpdateInProgress()) {
                    Ke();
                    return;
                  }
                  if (!(Ce() && !Me.isTextEnabled()) && k && pe.representationId && !k.appendInitSegmentFromCache(pe.representationId)) {
                    var ut = F.getCurrentRepresentation();
                    if (ut.range === 0) {
                      Ze();
                      return;
                    }
                    var St = $ ? $.getInitRequest(p, ut) : null;
                    St ? fe.executeRequest(St) : Ve && (X.setInitSegmentRequired(!0), Ke());
                  }
                }
              }
              function Ze(pe) {
                var Ve = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                if (oe.getIsManifestUpdateInProgress() || k.getIsPruningInProgress()) {
                  Ke();
                  return;
                }
                var ut = Ye();
                ut ? (x = !1, nt(ut)) : it(Ve);
              }
              function nt(pe) {
                isNaN(pe.startTime + pe.duration) || (le = pe.startTime + pe.duration), pe.delayLoadingTime = (/* @__PURE__ */ new Date()).getTime() + X.getTimeToLoadDelay(), X.setTimeToLoadDelay(0), De(pe) ? (te.warn("Fragment request url ".concat(pe.url, " for stream id ").concat(H.id, " and media type ").concat(z, " is on the ignore list and will be skipped")), Ke()) : (te.debug("Next fragment request url for stream id ".concat(H.id, " and media type ").concat(z, " is ").concat(pe.url)), fe.executeRequest(pe));
              }
              function it(pe) {
                var Ve = F.getCurrentRepresentation();
                if (se.get().streaming.gaps.enableSeekFix && (x || oe.getTime() === 0)) {
                  var ut;
                  if (O ? O && Ve.segmentInfoType === n.default.SEGMENT_TIMELINE && (ut = $.getValidTimeAheadOfTargetTime(le, p, Ve, se.get().streaming.gaps.threshold)) : ut = $.getValidTimeAheadOfTargetTime(le, p, Ve, se.get().streaming.gaps.threshold), !isNaN(ut) && ut !== le) {
                    oe.isSeeking() || oe.getTime() === 0 ? (te.warn("Adjusting playback time ".concat(ut, " because of gap in the manifest. Seeking by ").concat(ut - le)), oe.seek(ut, !1, !1)) : (te.warn("Adjusting buffering time ".concat(ut, " because of gap in the manifest. Adjusting time by ").concat(ut - le)), Oe(ut), pe && Ke());
                    return;
                  }
                }
                var St = $.isLastSegmentRequested(Ve, le);
                if (St) {
                  var jt = $.getCurrentIndex();
                  te.debug("Segment requesting for stream ".concat(H.id, " has finished")), J.trigger(L.default.STREAM_REQUESTING_COMPLETED, {
                    segmentIndex: jt
                  }, {
                    streamId: H.id,
                    mediaType: z
                  }), k.segmentRequestingCompleted(jt), X.clearScheduleTimer();
                  return;
                }
                pe && Ke();
              }
              function De(pe) {
                var Ve = pe.url;
                return pe.range && (Ve = Ve.concat("_", pe.range)), re.contains(Ve);
              }
              function Ye() {
                var pe = ct(), Ve;
                if (isNaN(le) || Te() === g.default.TEXT && !Me.isTextEnabled())
                  return null;
                if ($) {
                  var ut = F && pe ? F.getRepresentationForQuality(pe.quality) : null;
                  x ? Ve = $.getSegmentRequestForTime(p, ut, le) : Ve = $.getNextSegmentRequest(p, ut);
                }
                return Ve;
              }
              function Ke() {
                X.startScheduleTimer(oe.getLowLatencyModeEnabled() ? se.get().streaming.scheduling.lowLatencyTimeout : se.get().streaming.scheduling.defaultTimeout);
              }
              function tt(pe) {
                pe.error || (X.setCurrentRepresentation(Y.convertRepresentationToRepresentationInfo(pe.currentRepresentation)), k.getIsBufferingCompleted() || k.updateBufferTimestampOffset(pe.currentRepresentation));
              }
              function st(pe) {
                ge.addBufferState(z, pe.state, X.getBufferTarget()), pe.state === i.default.BUFFER_EMPTY && !oe.isSeeking() && (te.info("Buffer is empty! Stalling!"), ge.pushPlayListTraceMetrics(/* @__PURE__ */ new Date(), M.PlayListTrace.REBUFFERING_REASON));
              }
              function Et(pe) {
                fe.syncExecutedRequestsWithBufferedRange(k.getBuffer().getAllBufferRanges(), H.duration), pe.quotaExceeded && pe.from > oe.getTime() && Oe(pe.from), pe.hasEnoughSpaceToAppend && pe.quotaExceeded && X.startScheduleTimer();
              }
              function ht(pe) {
                if (!(!pe || !pe.lastRequestAppended || !pe.lastRequestAppended.url)) {
                  var Ve = pe.lastRequestAppended.url;
                  pe.lastRequestAppended.range && (Ve = Ve.concat("_", pe.lastRequestAppended.range)), te.warn("Blacklisting segment with url ".concat(Ve)), re.add(Ve);
                }
              }
              function xt(pe) {
                te.debug("Preparing quality switch for type ".concat(z));
                var Ve = pe.newQuality;
                W = !0, X.clearScheduleTimer();
                var ut = ct(Ve);
                X.setCurrentRepresentation(ut), F.prepareQualityChange(Ve), fe.abortRequests(), k.updateBufferTimestampOffset(ut).then(function() {
                  pe.reason && pe.reason.forceReplace ? Xe() : se.get().streaming.buffer.fastSwitchEnabled ? ve(ut) : me(), ge.pushPlayListTraceMetrics(/* @__PURE__ */ new Date(), M.PlayListTrace.REPRESENTATION_SWITCH_STOP_REASON), ge.createPlaylistTraceMetrics(ut.id, oe.getTime() * 1e3, oe.getPlaybackRate());
                });
              }
              function Xe() {
                J.trigger(L.default.BUFFER_REPLACEMENT_STARTED, {
                  mediaType: z,
                  streamId: H.id
                }, {
                  mediaType: z,
                  streamId: H.id
                }), k.prepareForReplacementQualitySwitch().then(function() {
                  Qt(), W = !1;
                }).catch(function() {
                  Qt(), W = !1;
                });
              }
              function ve(pe) {
                var Ve = oe.getTime(), ut = 1.5 * (isNaN(pe.fragmentDuration) ? 1 : pe.fragmentDuration), St = fe.getRequests({
                  state: r.default.FRAGMENT_MODEL_EXECUTED,
                  time: Ve + ut,
                  threshold: 0
                })[0];
                if (St && !Ce()) {
                  var jt = k.getBufferLevel(), Kt = Q.getAbandonmentStateFor(H.id, z);
                  if (St.quality < pe.quality && jt >= ut && Kt !== i.default.ABANDON_LOAD) {
                    var $t = Ve + ut;
                    Oe($t), X.setCheckPlaybackQuality(!1), X.startScheduleTimer();
                  } else
                    me();
                } else
                  X.startScheduleTimer();
                W = !1;
              }
              function me() {
                Je(), W = !1;
              }
              function Ie(pe) {
                te.info("onFragmentLoadingAbandoned request: " + pe.request.url + " has been aborted"), !oe.isSeeking() && !X.getSwitchStrack() && !W && (te.info("onFragmentLoadingAbandoned request: " + pe.request.url + " has to be downloaded again, origin is not seeking process or switch track call"), pe.request && pe.request.isInitializationRequest() ? X.setInitSegmentRequired(!0) : Oe(pe.request.startTime + pe.request.duration / 2), X.startScheduleTimer(0));
              }
              function we(pe) {
                te.info("OnFragmentLoadingCompleted for stream id " + H.id + " and media type " + z + " - Url:", pe.request ? pe.request.url : "undefined", pe.request.range ? ", Range:" + pe.request.range : ""), Ce() && X.startScheduleTimer(0), pe.error && pe.request.serviceLocation && Ue(pe);
              }
              function Ue(pe) {
                te.info("Fragment loading completed with an error"), !(!pe || !pe.request || !pe.request.type) && (pe.request.type === N.HTTPRequest.INIT_SEGMENT_TYPE ? je({
                  representationId: pe.request.representationId,
                  sender: {}
                }, !1) : pe.request.type === N.HTTPRequest.MEDIA_SEGMENT_TYPE && (Oe(pe.request.startTime + pe.request.duration / 2), Ze({}, !1)));
              }
              function $e() {
                Oe(oe.getTime()), Qe().startScheduleTimer();
              }
              function at(pe) {
                var Ve = pe.currentTrackInfo;
                if (Ve) {
                  var ut = P.find(function(St) {
                    return St.index === Ve.index && St.lang === Ve.lang;
                  });
                  ut && dt(ut).then(function() {
                    k.setIsBufferingCompleted(!1), Oe(oe.getTime()), X.setInitSegmentRequired(!0), X.startScheduleTimer();
                  });
                }
              }
              function et(pe) {
                Oe(pe.quotaExceededTime), X.clearScheduleTimer();
              }
              function Mt() {
                return F;
              }
              function Lt() {
                return k ? k.getBuffer() : null;
              }
              function bt() {
                return k;
              }
              function Ae() {
                k.dischargePreBuffer();
              }
              function ze() {
                return fe;
              }
              function qe(pe) {
                return H = pe, Se() ? Promise.resolve() : k.updateAppendWindow();
              }
              function _t() {
                return H;
              }
              function dt(pe) {
                pe !== p && (!pe || !p || pe.type === p.type) && (p = pe);
                var Ve = Y.getRealAdaptation(H, p), ut = Y.getVoRepresentations(p);
                if (F) {
                  var St = F.getData(), jt = Q.getMaxAllowedIndexFor(z, H.id), Kt = Q.getMinAllowedIndexFor(z, H.id), $t, Yt, gr = null;
                  return (St === null || St.id !== Ve.id) && z !== g.default.TEXT ? (Yt = Q.getThroughputHistory().getAverageThroughput(z, O), gr = Yt || Q.getInitialBitrateFor(z, H.id), $t = Q.getQualityForBitrate(p, gr, H.id)) : $t = Q.getQualityFor(z, H.id), Kt !== void 0 && $t < Kt && ($t = Kt), $t > jt && ($t = jt), F.updateData(Ve, ut, z, p.isFragmented, $t);
                } else
                  return Promise.resolve();
              }
              function Tt(pe) {
                P.indexOf(pe) === -1 && P.push(pe);
              }
              function wt() {
                P = [];
              }
              function Gt() {
                return p;
              }
              function Xt() {
                return k.getMediaSource();
              }
              function ye(pe) {
                return k.setMediaSource(pe, p);
              }
              function Qe() {
                return X;
              }
              function ct(pe) {
                var Ve;
                return pe !== void 0 ? ((0, h.checkInteger)(pe), Ve = F ? F.getRepresentationForQuality(pe) : null) : Ve = F ? F.getCurrentRepresentation() : null, Y.convertRepresentationToRepresentationInfo(Ve);
              }
              function Se() {
                return k ? k.getIsBufferingCompleted() : !1;
              }
              function Be() {
                return k ? k.getBufferLevel() : 0;
              }
              function He() {
                var pe = ct(), Ve = F && pe ? F.getRepresentationForQuality(pe.quality) : null;
                return $.getNextSegmentRequestIdempotent(p, Ve);
              }
              function yt(pe) {
                if (se.get().streaming.enableManifestTimescaleMismatchFix) {
                  var Ve = pe.chunk, ut = Ve.bytes, St = Ve.quality, jt = ct(St), Kt = F && jt ? F.getRepresentationForQuality(jt.quality) : null;
                  if (jt && Kt) {
                    var $t = ee.getMediaTimescaleFromMoov(ut);
                    Kt.timescale = $t;
                  }
                }
              }
              function zt(pe) {
                var Ve = pe.chunk, ut = Ve.bytes, St = Ve.quality, jt = ct(St), Kt = F && jt ? F.getRepresentationForQuality(jt.quality) : null;
                if (jt && Kt) {
                  var $t = Y.getEventsFor(jt.mediaInfo, null, H), Yt = Y.getEventsFor(jt, Kt, H);
                  if ($t && $t.length > 0 || Yt && Yt.length > 0) {
                    var gr = fe.getRequests({
                      state: r.default.FRAGMENT_MODEL_EXECUTED,
                      quality: St,
                      index: Ve.index
                    })[0], wr = Nt(ut, gr, $t, Yt);
                    J.trigger(L.default.INBAND_EVENTS, {
                      events: wr
                    }, {
                      streamId: H.id
                    });
                  }
                }
              }
              function Nt(pe, Ve, ut, St) {
                try {
                  for (var jt = {}, Kt = [], $t = ut.concat(St), Yt = 0, gr = $t.length; Yt < gr; Yt++)
                    jt[$t[Yt].schemeIdUri + "/" + $t[Yt].value] = $t[Yt];
                  var wr = (0, I.default)(V).getInstance().parse(pe), Vr = wr.getBoxes("emsg");
                  if (!Vr || Vr.length === 0)
                    return Kt;
                  for (var Nr = wr.getBox("sidx"), hn = Nr && !isNaN(Nr.earliest_presentation_time) && !isNaN(Nr.timescale) ? Nr.earliest_presentation_time / Nr.timescale : Ve && !isNaN(Ve.mediaStartTime) ? Ve.mediaStartTime : 0, Pn = Math.max(hn, 0), ca = F.getCurrentRepresentation(), Ur = 0, _n = Vr.length; Ur < _n; Ur++) {
                    var yn = Y.getEvent(Vr[Ur], jt, Pn, ca);
                    yn && Kt.push(yn);
                  }
                  return Kt;
                } catch {
                  return [];
                }
              }
              function Dt(pe) {
                var Ve = Lt();
                return Ve ? Promise.resolve(Ve) : k ? k.createBufferSink(p, pe) : Promise.resolve(null);
              }
              function ar() {
                return new Promise(function(pe) {
                  te.debug("Preparing track switch for type ".concat(z));
                  var Ve = z === g.default.TEXT || se.get().streaming.trackSwitchMode[z] === g.default.TRACK_SWITCH_MODE_ALWAYS_REPLACE && oe.getTimeToStreamEnd(H) > se.get().streaming.buffer.stallThreshold;
                  if (k.getIsBufferingCompleted() && !Ve) {
                    k.prepareForNonReplacementTrackSwitch(p.codec).then(function() {
                      J.trigger(L.default.BUFFERING_COMPLETED, {}, {
                        streamId: H.id,
                        mediaType: z
                      });
                    }).catch(function() {
                      J.trigger(L.default.BUFFERING_COMPLETED, {}, {
                        streamId: H.id,
                        mediaType: z
                      });
                    }), pe();
                    return;
                  }
                  X.clearScheduleTimer(), X.setSwitchTrack(!0), Ve ? (J.trigger(L.default.BUFFER_REPLACEMENT_STARTED, {
                    mediaType: z,
                    streamId: H.id
                  }, {
                    mediaType: z,
                    streamId: H.id
                  }), fe.abortRequests(), k.prepareForReplacementTrackSwitch(p.codec).then(function() {
                    var ut = ct();
                    return k.updateBufferTimestampOffset(ut);
                  }).then(function() {
                    Qt(), pe();
                  }).catch(function() {
                    Qt(), pe();
                  })) : k.prepareForNonReplacementTrackSwitch(p.codec).then(function() {
                    Je(), pe();
                  }).catch(function() {
                    Je(), pe();
                  });
                });
              }
              function Qt() {
                var pe = oe.getTime();
                se.get().streaming.buffer.flushBufferAtTrackSwitch && oe.seek(pe + 1e-3, !1, !0), Oe(pe), k.setSeekTarget(pe), X.startScheduleTimer();
              }
              function Je() {
                var pe = oe.getTime(), Ve = k.getContinuousBufferTimeForTargetTime(pe), ut = isNaN(Ve) ? pe : Ve;
                Oe(ut), X.startScheduleTimer();
              }
              function At(pe, Ve) {
                var ut = null;
                return pe ? (pe === g.default.TEXT && !Ve ? ut = (0, d.default)(V).create({
                  streamInfo: H,
                  type: pe,
                  mimeType: ie,
                  fragmentModel: fe,
                  textController: Me,
                  errHandler: Z,
                  settings: se
                }) : ut = (0, l.default)(V).create({
                  streamInfo: H,
                  type: pe,
                  mediaPlayerModel: ae,
                  manifestModel: ne,
                  fragmentModel: fe,
                  errHandler: Z,
                  mediaController: de,
                  representationController: F,
                  adapter: Y,
                  textController: Me,
                  abrController: Q,
                  playbackController: oe,
                  settings: se
                }), ut) : (Z.error(new o.default(c.default.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, c.default.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + "not properly defined")), null);
              }
              function It(pe) {
                pe && !isNaN(pe.time) && (Oe(pe.time), k.setSeekTarget(pe.time));
              }
              function Oe(pe) {
                le = pe, x = !0;
              }
              function ke(pe, Ve) {
                ge.pushPlayListTraceMetrics(pe, Ve);
              }
              return ue = {
                initialize: _e,
                getStreamId: Ee,
                getType: Te,
                isUpdating: Ge,
                getBufferController: bt,
                dischargePreBuffer: Ae,
                getFragmentModel: ze,
                getScheduleController: Qe,
                getRepresentationController: Mt,
                getRepresentationInfo: ct,
                getBufferLevel: Be,
                isBufferingCompleted: Se,
                createBufferSinks: Dt,
                updateStreamInfo: qe,
                getStreamInfo: _t,
                selectMediaInfo: dt,
                clearMediaInfoArray: wt,
                addMediaInfo: Tt,
                prepareTrackSwitch: ar,
                prepareQualityChange: xt,
                getMediaInfo: Gt,
                getMediaSource: Xt,
                setMediaSource: ye,
                getBuffer: Lt,
                setExplicitBufferingTime: Oe,
                finalisePlayList: ke,
                probeNextRequest: He,
                prepareInnerPeriodPlaybackSeeking: Pe,
                prepareOuterPeriodPlaybackSeeking: Le,
                reset: be
              }, q(), ue;
            }
            C.__dashjs_factory_name = "StreamProcessor";
            const b = S.default.getClassFactory(C);
          }
        ),
        /***/
        "./src/streaming/XlinkLoader.js": (
          /*!**************************************!*\
            !*** ./src/streaming/XlinkLoader.js ***!
            \**************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            var g = e(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), n = e(
              /*! ./net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            ), i = e(
              /*! ./vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), r = e(
              /*! ./vo/TextRequest */
              "./src/streaming/vo/TextRequest.js"
            ), l = e(
              /*! ../core/EventBus */
              "./src/core/EventBus.js"
            ), d = e(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), t = e(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), T = e(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            );
            function S(_) {
              _ = _ || {};
              var L = "urn:mpeg:dash:resolve-to-zero:2013", v = this.context, c = (0, l.default)(v).getInstance(), o = (0, n.default)(v).create({
                errHandler: _.errHandler,
                dashMetrics: _.dashMetrics,
                mediaPlayerModel: _.mediaPlayerModel,
                requestModifier: _.requestModifier,
                errors: T.default
              }), y;
              function u(I, M, E) {
                var N = function(w, V) {
                  M.resolved = !0, M.resolvedContent = w || null, c.trigger(d.default.XLINK_ELEMENT_LOADED, {
                    element: M,
                    resolveObject: E,
                    error: w || V ? null : new g.default(T.default.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE, T.default.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE + I)
                  });
                };
                if (I === L)
                  N(null, !0);
                else {
                  var C = new r.default(I, i.HTTPRequest.XLINK_EXPANSION_TYPE);
                  o.load({
                    request: C,
                    success: function(w) {
                      N(w);
                    },
                    error: function() {
                      N(null);
                    }
                  });
                }
              }
              function A() {
                o && (o.abort(), o = null);
              }
              return y = {
                load: u,
                reset: A
              }, y;
            }
            S.__dashjs_factory_name = "XlinkLoader";
            const h = t.default.getClassFactory(S);
          }
        ),
        /***/
        "./src/streaming/constants/ConformanceViolationConstants.js": (
          /*!******************************************************************!*\
            !*** ./src/streaming/constants/ConformanceViolationConstants.js ***!
            \******************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            const g = {
              LEVELS: {
                SUGGESTION: "Suggestion",
                WARNING: "Warning",
                ERROR: "Error"
              },
              EVENTS: {
                NO_UTC_TIMING_ELEMENT: {
                  key: "NO_UTC_TIMING_ELEMENT",
                  message: "No UTCTiming element is present in the manifest. You may experience playback failures. For a detailed validation use https://conformance.dashif.org/"
                },
                NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE: {
                  key: "NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE",
                  message: 'SMPTE 2052-1:2013 defines the attribute name as "imageType" and does not define "imagetype"'
                },
                INVALID_DVR_WINDOW: {
                  key: "INVALID_DVR_WINDOW",
                  message: "No valid segment found when applying a specification compliant DVR window calculation. Using SegmentTimeline entries as a fallback."
                }
              }
            };
          }
        ),
        /***/
        "./src/streaming/constants/Constants.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/constants/Constants.js ***!
            \**********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            function g(t, T) {
              if (!(t instanceof T))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(t, T) {
              for (var S = 0; S < T.length; S++) {
                var h = T[S];
                h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(t, h.key, h);
              }
            }
            function i(t, T, S) {
              return T && n(t.prototype, T), S && n(t, S), t;
            }
            var r = /* @__PURE__ */ function() {
              function t() {
                g(this, t), this.init();
              }
              return i(t, [{
                key: "init",
                value: function() {
                  this.STREAM = "stream", this.VIDEO = "video", this.AUDIO = "audio", this.TEXT = "text", this.MUXED = "muxed", this.IMAGE = "image", this.STPP = "stpp", this.TTML = "ttml", this.VTT = "vtt", this.WVTT = "wvtt", this.CONTENT_STEERING = "contentSteering", this.ABR_STRATEGY_DYNAMIC = "abrDynamic", this.ABR_STRATEGY_BOLA = "abrBola", this.ABR_STRATEGY_L2A = "abrL2A", this.ABR_STRATEGY_LoLP = "abrLoLP", this.ABR_STRATEGY_THROUGHPUT = "abrThroughput", this.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA = "abrFetchThroughputCalculationDownloadedData", this.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING = "abrFetchThroughputCalculationMoofParsing", this.ABR_FETCH_THROUGHPUT_CALCULATION_AAST = "abrFetchThroughputCalculationAAST", this.LIVE_CATCHUP_MODE_DEFAULT = "liveCatchupModeDefault", this.LIVE_CATCHUP_MODE_LOLP = "liveCatchupModeLoLP", this.MOVING_AVERAGE_SLIDING_WINDOW = "slidingWindow", this.MOVING_AVERAGE_EWMA = "ewma", this.BAD_ARGUMENT_ERROR = "Invalid Arguments", this.MISSING_CONFIG_ERROR = "Missing config parameter(s)", this.TRACK_SWITCH_MODE_ALWAYS_REPLACE = "alwaysReplace", this.TRACK_SWITCH_MODE_NEVER_REPLACE = "neverReplace", this.TRACK_SELECTION_MODE_FIRST_TRACK = "firstTrack", this.TRACK_SELECTION_MODE_HIGHEST_BITRATE = "highestBitrate", this.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY = "highestEfficiency", this.TRACK_SELECTION_MODE_WIDEST_RANGE = "widestRange", this.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY = "highestSelectionPriority", this.CMCD_MODE_QUERY = "query", this.CMCD_MODE_HEADER = "header", this.LOCATION = "Location", this.INITIALIZE = "initialize", this.TEXT_SHOWING = "showing", this.TEXT_HIDDEN = "hidden", this.CC1 = "CC1", this.CC3 = "CC3", this.UTF8 = "utf-8", this.SCHEME_ID_URI = "schemeIdUri", this.START_TIME = "starttime", this.SERVICE_DESCRIPTION_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:scope:2019", this.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:critical:2019", this.XML = "XML", this.ARRAY_BUFFER = "ArrayBuffer", this.DVB_REPORTING_URL = "dvb:reportingUrl", this.DVB_PROBABILITY = "dvb:probability", this.VIDEO_ELEMENT_READY_STATES = {
                    HAVE_NOTHING: 0,
                    HAVE_METADATA: 1,
                    HAVE_CURRENT_DATA: 2,
                    HAVE_FUTURE_DATA: 3,
                    HAVE_ENOUGH_DATA: 4
                  }, this.FILE_LOADER_TYPES = {
                    FETCH: "fetch_loader",
                    XHR: "xhr_loader"
                  };
                }
              }]), t;
            }(), l = new r();
            const d = l;
          }
        ),
        /***/
        "./src/streaming/constants/MetricsConstants.js": (
          /*!*****************************************************!*\
            !*** ./src/streaming/constants/MetricsConstants.js ***!
            \*****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            function g(t, T) {
              if (!(t instanceof T))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(t, T) {
              for (var S = 0; S < T.length; S++) {
                var h = T[S];
                h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(t, h.key, h);
              }
            }
            function i(t, T, S) {
              return T && n(t.prototype, T), S && n(t, S), t;
            }
            var r = /* @__PURE__ */ function() {
              function t() {
                g(this, t), this.init();
              }
              return i(t, [{
                key: "init",
                value: function() {
                  this.TCP_CONNECTION = "TcpList", this.HTTP_REQUEST = "HttpList", this.TRACK_SWITCH = "RepSwitchList", this.BUFFER_LEVEL = "BufferLevel", this.BUFFER_LOADED = "bufferLoaded", this.ABANDON_LOAD = "abandonload", this.ALLOW_LOAD = "allowload", this.BUFFER_EMPTY = "bufferStalled", this.BUFFER_STATE = "BufferState", this.DVR_INFO = "DVRInfo", this.DROPPED_FRAMES = "DroppedFrames", this.SCHEDULING_INFO = "SchedulingInfo", this.REQUESTS_QUEUE = "RequestsQueue", this.MANIFEST_UPDATE = "ManifestUpdate", this.MANIFEST_UPDATE_STREAM_INFO = "ManifestUpdatePeriodInfo", this.MANIFEST_UPDATE_TRACK_INFO = "ManifestUpdateRepresentationInfo", this.PLAY_LIST = "PlayList", this.DVB_ERRORS = "DVBErrors", this.HTTP_REQUEST_DVB_REPORTING_TYPE = "DVBReporting";
                }
              }]), t;
            }(), l = new r();
            const d = l;
          }
        ),
        /***/
        "./src/streaming/constants/ProtectionConstants.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/constants/ProtectionConstants.js ***!
            \********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            function g(t, T) {
              if (!(t instanceof T))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(t, T) {
              for (var S = 0; S < T.length; S++) {
                var h = T[S];
                h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(t, h.key, h);
              }
            }
            function i(t, T, S) {
              return T && n(t.prototype, T), S && n(t, S), t;
            }
            var r = /* @__PURE__ */ function() {
              function t() {
                g(this, t), this.init();
              }
              return i(t, [{
                key: "init",
                value: function() {
                  this.CLEARKEY_KEYSTEM_STRING = "org.w3.clearkey", this.WIDEVINE_KEYSTEM_STRING = "com.widevine.alpha", this.PLAYREADY_KEYSTEM_STRING = "com.microsoft.playready", this.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING = "com.microsoft.playready.recommendation", this.INITIALIZATION_DATA_TYPE_CENC = "cenc", this.INITIALIZATION_DATA_TYPE_KEYIDS = "keyids", this.INITIALIZATION_DATA_TYPE_WEBM = "webm";
                }
              }]), t;
            }(), l = new r();
            const d = l;
          }
        ),
        /***/
        "./src/streaming/controllers/AbrController.js": (
          /*!****************************************************!*\
            !*** ./src/streaming/controllers/AbrController.js ***!
            \****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => C
              /* harmony export */
            });
            var g = e(
              /*! ../rules/abr/ABRRulesCollection */
              "./src/streaming/rules/abr/ABRRulesCollection.js"
            ), n = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), i = e(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), r = e(
              /*! ../vo/BitrateInfo */
              "./src/streaming/vo/BitrateInfo.js"
            ), l = e(
              /*! ../models/FragmentModel */
              "./src/streaming/models/FragmentModel.js"
            ), d = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), t = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), T = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), S = e(
              /*! ../rules/RulesContext */
              "./src/streaming/rules/RulesContext.js"
            ), h = e(
              /*! ../rules/SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), _ = e(
              /*! ../rules/SwitchRequestHistory */
              "./src/streaming/rules/SwitchRequestHistory.js"
            ), L = e(
              /*! ../rules/DroppedFramesHistory */
              "./src/streaming/rules/DroppedFramesHistory.js"
            ), v = e(
              /*! ../rules/ThroughputHistory */
              "./src/streaming/rules/ThroughputHistory.js"
            ), c = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), o = e(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), y = e(
              /*! ../utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            ), u = e(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), A = 1e3, I = 100, M = 0;
            function E() {
              var b = this.context, w = (0, c.default)(b).getInstance(), V = (0, d.default)(b).getInstance(), J, H, z, Z, ie, K, Y, ne, ae, fe, Q, oe, de, Me, ge, se, ee, re, ue, te, O, p, P, k, X, F, x;
              function W() {
                H = w.getLogger(J), _e();
              }
              function $() {
                O = (0, L.default)(b).create(), p = (0, v.default)(b).create({
                  settings: x
                }), z = (0, g.default)(b).create({
                  dashMetrics: F,
                  customParametersModel: se,
                  mediaPlayerModel: ge,
                  settings: x
                }), z.initialize(), V.on(u.default.QUALITY_CHANGE_RENDERED, be, J), V.on(u.default.METRIC_ADDED, Ge, J), V.on(t.default.LOADING_PROGRESS, xe, J);
              }
              function ce(Ae, ze) {
                var qe = ze.getStreamInfo().id;
                Y[qe] || (Y[qe] = {}), te[qe] || (te[qe] = {}), ne[qe] || (ne[qe] = {}), te[qe][Ae] = (0, _.default)(b).create(), Y[qe][Ae] = ze, ne[qe][Ae] = {}, ne[qe][Ae].state = i.default.ALLOW_LOAD, le(Ae), Ae === n.default.VIDEO && Lt();
              }
              function le(Ae) {
                var ze = x.get().streaming.abr.ABRStrategy;
                ze === n.default.ABR_STRATEGY_L2A ? (P[Ae] = !1, X[Ae] = !1, k[Ae] = !0) : ze === n.default.ABR_STRATEGY_LoLP ? (P[Ae] = !1, X[Ae] = !0, k[Ae] = !1) : ze === n.default.ABR_STRATEGY_BOLA ? (P[Ae] = !0, X[Ae] = !1, k[Ae] = !1) : ze === n.default.ABR_STRATEGY_THROUGHPUT ? (P[Ae] = !1, X[Ae] = !1, k[Ae] = !1) : ze === n.default.ABR_STRATEGY_DYNAMIC && (P[Ae] = P && P[Ae] ? P[Ae] : !1, X[Ae] = !1, k[Ae] = !1);
              }
              function q(Ae, ze) {
                try {
                  Y[Ae] && Y[Ae][ze] && delete Y[Ae][ze], te[Ae] && te[Ae][ze] && delete te[Ae][ze], ne[Ae] && ne[Ae][ze] && delete ne[Ae][ze];
                } catch {
                }
              }
              function _e() {
                ie = {}, K = {}, ne = {}, Y = {}, te = {}, P = {}, k = {}, X = {}, fe === void 0 && (fe = !1), O && O.reset(), ue = void 0, O = void 0, p = void 0, clearTimeout(ae), ae = null;
              }
              function Ee() {
                _e(), V.off(t.default.LOADING_PROGRESS, xe, J), V.off(u.default.QUALITY_CHANGE_RENDERED, be, J), V.off(u.default.METRIC_ADDED, Ge, J), z && z.reset();
              }
              function Te(Ae) {
                Ae && (Ae.streamController && (Z = Ae.streamController), Ae.domStorage && (re = Ae.domStorage), Ae.mediaPlayerModel && (ge = Ae.mediaPlayerModel), Ae.customParametersModel && (se = Ae.customParametersModel), Ae.cmsdModel && (ee = Ae.cmsdModel), Ae.dashMetrics && (F = Ae.dashMetrics), Ae.adapter && (de = Ae.adapter), Ae.videoModel && (Me = Ae.videoModel), Ae.settings && (x = Ae.settings));
              }
              function Ce() {
                if (!re || !re.hasOwnProperty("getSavedBitrateSettings"))
                  throw new Error(n.default.MISSING_CONFIG_ERROR);
              }
              function xe(Ae) {
                var ze = Ae.request.mediaType, qe = Ae.streamId;
                if (!(!ze || !qe || !Y[qe] || !x.get().streaming.abr.autoSwitchBitrate[ze])) {
                  var _t = Y[qe][ze];
                  if (_t) {
                    var dt = (0, S.default)(b).create({
                      abrController: J,
                      streamProcessor: _t,
                      currentRequest: Ae.request,
                      useBufferOccupancyABR: P[ze],
                      useL2AABR: k[ze],
                      useLoLPABR: X[ze],
                      videoModel: Me
                    }), Tt = z.shouldAbandonFragment(dt, qe);
                    if (Tt.quality > h.default.NO_CHANGE) {
                      var wt = _t.getFragmentModel(), Gt = wt.getRequests({
                        state: l.default.FRAGMENT_MODEL_LOADING,
                        index: Ae.request.index
                      })[0];
                      Gt && (ne[qe][ze].state = i.default.ABANDON_LOAD, te[qe][ze].reset(), te[qe][ze].push({
                        oldValue: Et(ze, qe),
                        newValue: Tt.quality,
                        confidence: 1,
                        reason: Tt.reason
                      }), ht(ze, Z.getActiveStreamInfo(), Tt.quality, Tt.reason), clearTimeout(ae), ae = setTimeout(function() {
                        ne[qe][ze].state = i.default.ALLOW_LOAD, ae = null;
                      }, x.get().streaming.abandonLoadTimeout));
                    }
                  }
                }
              }
              function be(Ae) {
                Ae.mediaType === n.default.VIDEO && (ue !== void 0 && O.push(Ae.streamId, ue, Me.getPlaybackQuality()), ue = Ae.newQuality);
              }
              function Ge(Ae) {
                Ae.metric === i.default.HTTP_REQUEST && Ae.value && Ae.value.type === o.HTTPRequest.MEDIA_SEGMENT_TYPE && (Ae.mediaType === n.default.AUDIO || Ae.mediaType === n.default.VIDEO) && p.push(Ae.mediaType, Ae.value, x.get().streaming.abr.useDeadTimeLatency), Ae.metric === i.default.BUFFER_LEVEL && (Ae.mediaType === n.default.AUDIO || Ae.mediaType === n.default.VIDEO) && we(Ae.mediaType, 1e-3 * Ae.value.level);
              }
              function Pe(Ae, ze) {
                try {
                  var qe;
                  return ie[ze] = ie[ze] || {}, ie[ze].hasOwnProperty(Ae) || (ie[ze][Ae] = 0), qe = nt(Ae, ze), qe = De(qe, Ae, ze), qe = Ye(qe, Ae, ze), x.get().streaming.cmsd.enabled && x.get().streaming.cmsd.abr.applyMb && (qe = it(qe, Ae, ze)), qe;
                } catch {
                  return;
                }
              }
              function Le(Ae, ze) {
                try {
                  return Ze(Ae, ze);
                } catch {
                  return;
                }
              }
              function je(Ae, ze) {
                try {
                  var qe = ge.getAbrBitrateParameter("maxBitrate", Ae);
                  return qe > -1 ? me(Y[ze][Ae].getMediaInfo(), qe, ze) : void 0;
                } catch {
                  return;
                }
              }
              function Ze(Ae, ze) {
                try {
                  var qe = ge.getAbrBitrateParameter("minBitrate", Ae);
                  if (qe > -1) {
                    var _t = Y[ze][Ae].getMediaInfo(), dt = Ie(_t), Tt = me(_t, qe, ze);
                    return dt[Tt] && Tt < dt.length - 1 && dt[Tt].bitrate < qe * 1e3 && Tt++, Tt;
                  } else
                    return;
                } catch {
                  return;
                }
              }
              function nt(Ae, ze) {
                var qe = ie[ze][Ae], _t = qe;
                if (!Y[ze] || !Y[ze][Ae])
                  return _t;
                var dt = Le(Ae, ze);
                dt !== void 0 && (_t = Math.max(qe, dt));
                var Tt = je(Ae, ze);
                return Tt !== void 0 && (_t = Math.min(_t, Tt)), _t;
              }
              function it(Ae, ze, qe) {
                if (ze !== "video")
                  return Ae;
                var _t = ee.getMaxBitrate(ze);
                if (_t < 0)
                  return Ae;
                var dt = ve(qe, "audio", Et("audio", qe));
                _t -= dt ? dt.bitrate / 1e3 : 0;
                var Tt = me(Y[qe][ze].getMediaInfo(), _t, qe);
                return H.debug("Stream ID: " + qe + " [" + ze + "] Apply max bit rate from CMSD: " + _t), Math.min(Ae, Tt);
              }
              function De(Ae, ze, qe) {
                var _t = ie[qe][ze], dt = x.get().streaming.abr.maxRepresentationRatio[ze];
                return isNaN(dt) || dt >= 1 || dt < 0 ? Ae : Math.min(Ae, Math.round(_t * dt));
              }
              function Ye(Ae, ze, qe) {
                if (ze !== n.default.VIDEO || !x.get().streaming.abr.limitBitrateByPortal || !Y[qe] || !Y[qe][ze])
                  return Ae;
                fe || Lt();
                var _t = Y[qe][ze].getStreamInfo(), dt = de.getAdaptationForType(_t.index, ze, _t).Representation_asArray, Tt = Ae;
                if (Q > 0 && oe > 0) {
                  for (; Tt > 0 && dt[Tt] && Q < dt[Tt].width && Q - dt[Tt - 1].width < dt[Tt].width - Q; )
                    Tt = Tt - 1;
                  for (; Tt < dt.length - 1 && dt[Tt].width === dt[Tt + 1].width; )
                    Tt = Tt + 1;
                }
                return Tt;
              }
              function Ke(Ae) {
                var ze = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (ze || (ze = Z.getActiveStreamInfo().id), Ae && Y && Y[ze] && Y[ze][Ae]) {
                  var qe = Pe(Ae, ze), _t = Ie(Y[ze][Ae].getMediaInfo());
                  return _t[qe] ? _t[qe] : null;
                }
                return null;
              }
              function tt(Ae, ze) {
                if (Ce(), Ae === n.default.TEXT)
                  return NaN;
                var qe = re.getSavedBitrateSettings(Ae), _t = ge.getAbrBitrateParameter("initialBitrate", Ae), dt = x.get().streaming.abr.initialRepresentationRatio[Ae];
                if (_t === -1)
                  if (dt > -1) {
                    var Tt = Y[ze][Ae].getStreamInfo(), wt = de.getAdaptationForType(Tt.index, Ae, Tt).Representation_asArray;
                    if (Array.isArray(wt)) {
                      var Gt = Math.max(Math.round(wt.length * dt) - 1, 0);
                      _t = wt[Gt].bandwidth / 1e3;
                    } else
                      _t = 0;
                  } else
                    isNaN(qe) ? _t = Ae === n.default.VIDEO ? A : I : _t = qe;
                return _t;
              }
              function st(Ae, ze) {
                try {
                  if (!Ae || !Y || !Y[ze] || !Y[ze][Ae])
                    return !1;
                  if (O) {
                    var qe = Me.getPlaybackQuality();
                    qe && O.push(ze, ue, qe);
                  }
                  if (!x.get().streaming.abr.autoSwitchBitrate[Ae])
                    return !1;
                  var _t = Et(Ae, ze), dt = (0, S.default)(b).create({
                    abrController: J,
                    switchHistory: te[ze][Ae],
                    droppedFramesHistory: O,
                    streamProcessor: Y[ze][Ae],
                    currentValue: _t,
                    useBufferOccupancyABR: P[Ae],
                    useL2AABR: k[Ae],
                    useLoLPABR: X[Ae],
                    videoModel: Me
                  }), Tt = Le(Ae, ze), wt = Pe(Ae, ze), Gt = z.getMaxQuality(dt), Xt = Gt.quality;
                  return Tt !== void 0 && (Xt > h.default.NO_CHANGE ? Xt : _t) < Tt && (Xt = Tt), Xt > wt && (Xt = wt), te[ze][Ae].push({
                    oldValue: _t,
                    newValue: Xt
                  }), Xt > h.default.NO_CHANGE && Xt !== _t && (ne[ze][Ae].state === i.default.ALLOW_LOAD || Xt < _t) ? (Xe(Ae, _t, Xt, wt, Gt.reason, ze), !0) : !1;
                } catch {
                  return !1;
                }
              }
              function Et(Ae) {
                var ze = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                try {
                  if (ze || (ze = Z.getActiveStreamInfo().id), Ae && Y[ze] && Y[ze][Ae]) {
                    var qe;
                    if (ze)
                      return K[ze] = K[ze] || {}, K[ze].hasOwnProperty(Ae) || (K[ze][Ae] = M), qe = K[ze][Ae], qe;
                  }
                  return M;
                } catch {
                  return M;
                }
              }
              function ht(Ae, ze, qe) {
                var _t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
                if (!(!ze || !ze.id || !Ae)) {
                  var dt = ze.id, Tt = Et(Ae, dt);
                  (0, y.checkInteger)(qe);
                  var wt = Pe(Ae, dt);
                  qe !== Tt && qe >= 0 && qe <= wt && Xe(Ae, Tt, qe, wt, _t, dt);
                }
              }
              function xt(Ae, ze) {
                return ne[Ae] && ne[Ae][ze] ? ne[Ae][ze].state : null;
              }
              function Xe(Ae, ze, qe, _t, dt, Tt) {
                if (Ae && Y[Tt] && Y[Tt][Ae]) {
                  var wt = Y[Tt][Ae].getStreamInfo(), Gt = wt && wt.manifestInfo && wt.manifestInfo.isDynamic, Xt = F.getCurrentBufferLevel(Ae);
                  H.info("Stream ID: " + Tt + " [" + Ae + "] switch from " + ze + " to " + qe + "/" + _t + " (buffer: " + Xt + ") " + (dt ? JSON.stringify(dt) : ".")), K[Tt] = K[Tt] || {}, K[Tt][Ae] = qe;
                  var ye = ve(Tt, Ae, qe);
                  V.trigger(t.default.QUALITY_CHANGE_REQUESTED, {
                    oldQuality: ze,
                    newQuality: qe,
                    reason: dt,
                    streamInfo: wt,
                    bitrateInfo: ye,
                    maxIdx: _t,
                    mediaType: Ae
                  }, {
                    streamId: wt.id,
                    mediaType: Ae
                  });
                  var Qe = p.getAverageThroughput(Ae, Gt);
                  isNaN(Qe) || re.setSavedBitrateSettings(Ae, Qe);
                }
              }
              function ve(Ae, ze, qe) {
                if (ze && Y && Y[Ae] && Y[Ae][ze]) {
                  var _t = Ie(Y[Ae][ze].getMediaInfo());
                  return _t[qe] ? _t[qe] : null;
                }
                return null;
              }
              function me(Ae, ze, qe) {
                var _t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, dt = Ae && Ae.type ? Y[qe][Ae.type].getRepresentationInfo() : null;
                if (x.get().streaming.abr.useDeadTimeLatency && _t && dt && dt.fragmentDuration) {
                  _t = _t / 1e3;
                  var Tt = dt.fragmentDuration;
                  if (_t > Tt)
                    return 0;
                  var wt = _t / Tt;
                  ze = ze * (1 - wt);
                }
                for (var Gt = Ie(Ae), Xt = Gt.length - 1; Xt >= 0; Xt--) {
                  var ye = Gt[Xt];
                  if (ze * 1e3 >= ye.bitrate)
                    return Xt;
                }
                return M;
              }
              function Ie(Ae) {
                var ze = [];
                if (!Ae || !Ae.bitrateList)
                  return ze;
                for (var qe = Ae.bitrateList, _t = Ae.type, dt, Tt = 0, wt = qe.length; Tt < wt; Tt++)
                  dt = new r.default(), dt.mediaType = _t, dt.qualityIndex = Tt, dt.bitrate = qe[Tt].bandwidth, dt.width = qe[Tt].width, dt.height = qe[Tt].height, dt.scanType = qe[Tt].scanType, ze.push(dt);
                return ze;
              }
              function we(Ae, ze) {
                var qe = x.get().streaming.abr.ABRStrategy;
                qe === n.default.ABR_STRATEGY_DYNAMIC && Ue(Ae, ze);
              }
              function Ue(Ae, ze) {
                try {
                  var qe = ge.getStableBufferTime(), _t = qe, dt = 0.5 * qe, Tt = P[Ae], wt = ze > (Tt ? dt : _t);
                  P[Ae] = wt, wt !== Tt && (wt ? H.info("[" + Ae + "] switching from throughput to buffer occupancy ABR rule (buffer: " + ze.toFixed(3) + ").") : H.info("[" + Ae + "] switching from buffer occupancy to throughput ABR rule (buffer: " + ze.toFixed(3) + ")."));
                } catch (Gt) {
                  H.error(Gt);
                }
              }
              function $e() {
                return p;
              }
              function at(Ae) {
                var ze = Ae.type, qe = Ae.streamInfo.id, _t = Ae.representationCount - 1;
                return ie[qe] = ie[qe] || {}, ie[qe][ze] = _t, _t;
              }
              function et(Ae) {
                var ze = Ae ? Ae.id : null, qe = Et(n.default.AUDIO, ze), _t = Et(n.default.VIDEO, ze), dt = qe === Pe(n.default.AUDIO, ze) && _t === Pe(n.default.VIDEO, ze);
                return dt;
              }
              function Mt(Ae) {
                fe = Ae;
              }
              function Lt() {
                if (Me) {
                  var Ae = x.get().streaming.abr.usePixelRatioInLimitBitrateByPortal && window.hasOwnProperty("devicePixelRatio"), ze = Ae ? window.devicePixelRatio : 1;
                  Q = Me.getClientWidth() * ze, oe = Me.getClientHeight() * ze;
                }
              }
              function bt(Ae) {
                O && O.clearForStream(Ae), Y[Ae] && delete Y[Ae], te[Ae] && delete te[Ae], ne[Ae] && delete ne[Ae];
              }
              return J = {
                initialize: $,
                isPlayingAtTopQuality: et,
                updateTopQualityIndex: at,
                clearDataForStream: bt,
                getThroughputHistory: $e,
                getBitrateList: Ie,
                getQualityForBitrate: me,
                getTopBitrateInfoFor: Ke,
                getMinAllowedIndexFor: Le,
                getMaxAllowedIndexFor: Pe,
                getInitialBitrateFor: tt,
                getQualityFor: Et,
                getAbandonmentStateFor: xt,
                setPlaybackQuality: ht,
                checkPlaybackQuality: st,
                setElementSize: Lt,
                setWindowResizeEventCalled: Mt,
                registerStreamType: ce,
                unRegisterStreamType: q,
                setConfig: Te,
                reset: Ee
              }, W(), J;
            }
            E.__dashjs_factory_name = "AbrController";
            var N = T.default.getSingletonFactory(E);
            N.QUALITY_DEFAULT = M, T.default.updateSingletonFactory(E.__dashjs_factory_name, N);
            const C = N;
          }
        ),
        /***/
        "./src/streaming/controllers/BaseURLController.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/controllers/BaseURLController.js ***!
            \********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var g = e(
              /*! ../models/BaseURLTreeModel */
              "./src/streaming/models/BaseURLTreeModel.js"
            ), n = e(
              /*! ../utils/BaseURLSelector */
              "./src/streaming/utils/BaseURLSelector.js"
            ), i = e(
              /*! ../utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), r = e(
              /*! ../../dash/vo/BaseURL */
              "./src/dash/vo/BaseURL.js"
            ), l = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), t = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            );
            function T() {
              var h, _, L = this.context, v = (0, d.default)(L).getInstance(), c = (0, i.default)(L).getInstance(), o, y;
              function u(b) {
                o.invalidateSelectedIndexes(b.entry);
              }
              function A() {
                o = (0, g.default)(L).create(), y = (0, n.default)(L).create(), v.on(t.default.SERVICE_LOCATION_BLACKLIST_CHANGED, u, h);
              }
              function I(b) {
                b.baseURLTreeModel && (o = b.baseURLTreeModel), b.baseURLSelector && (y = b.baseURLSelector), b.adapter && (_ = b.adapter);
              }
              function M(b) {
                o.update(b), y.chooseSelector(_.getIsDVB(b));
              }
              function E(b) {
                var w = o.getForPath(b), V = w.reduce(function(J, H) {
                  var z = y.select(H);
                  if (z)
                    c.isRelative(z.url) ? J.url = c.resolve(z.url, J.url) : (J.url = z.url, J.serviceLocation = z.serviceLocation), J.availabilityTimeOffset = z.availabilityTimeOffset, J.availabilityTimeComplete = z.availabilityTimeComplete;
                  else
                    return new r.default();
                  return J;
                }, new r.default());
                if (!c.isRelative(V.url))
                  return V;
              }
              function N() {
                o.reset(), y.reset();
              }
              function C(b) {
                o.setConfig({
                  adapter: _
                }), M(b);
              }
              return h = {
                reset: N,
                initialize: C,
                resolve: E,
                setConfig: I
              }, A(), h;
            }
            T.__dashjs_factory_name = "BaseURLController";
            const S = l.default.getClassFactory(T);
          }
        ),
        /***/
        "./src/streaming/controllers/BlacklistController.js": (
          /*!**********************************************************!*\
            !*** ./src/streaming/controllers/BlacklistController.js ***!
            \**********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            );
            function i(l) {
              l = l || {};
              var d, t = [], T = (0, n.default)(this.context).getInstance(), S = l.updateEventName, h = l.addBlacklistEventName;
              function _(y) {
                return !t.length || !y || !y.length ? !1 : t.indexOf(y) !== -1;
              }
              function L(y) {
                t.indexOf(y) === -1 && (t.push(y), T.trigger(S, {
                  entry: y
                }));
              }
              function v(y) {
                L(y.entry);
              }
              function c() {
                h && T.on(h, v, d);
              }
              function o() {
                t = [];
              }
              return d = {
                add: L,
                contains: _,
                reset: o
              }, c(), d;
            }
            i.__dashjs_factory_name = "BlackListController";
            const r = g.default.getClassFactory(i);
          }
        ),
        /***/
        "./src/streaming/controllers/BufferController.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/controllers/BufferController.js ***!
            \*******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => M
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), i = e(
              /*! ../models/FragmentModel */
              "./src/streaming/models/FragmentModel.js"
            ), r = e(
              /*! ../SourceBufferSink */
              "./src/streaming/SourceBufferSink.js"
            ), l = e(
              /*! ../PreBufferSink */
              "./src/streaming/PreBufferSink.js"
            ), d = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), t = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), T = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), S = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), h = e(
              /*! ../utils/InitCache */
              "./src/streaming/utils/InitCache.js"
            ), _ = e(
              /*! ../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), L = e(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), v = e(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), c = e(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), o = 0.5, y = 0.01, u = 22, A = "BufferController";
            function I(E) {
              E = E || {};
              var N = this.context, C = (0, d.default)(N).getInstance(), b = E.errHandler, w = E.fragmentModel, V = E.representationController, J = E.adapter, H = E.textController, z = E.abrController, Z = E.playbackController, ie = E.streamInfo, K = E.type, Y = E.settings, ne, ae, fe, Q, oe, de, Me, ge, se, ee, re, ue, te, O, p, P, k, X, F, x;
              function W() {
                ae = (0, S.default)(N).getInstance().getLogger(ne), k = (0, h.default)(N).getInstance(), At();
              }
              function $(Oe) {
                _e(Oe), C.on(t.default.INIT_FRAGMENT_LOADED, Pe, ne), C.on(t.default.MEDIA_FRAGMENT_LOADED, je, ne), C.on(t.default.WALLCLOCK_TIME_UPDATED, ye, ne), C.on(c.default.PLAYBACK_PLAYING, we, ne), C.on(c.default.PLAYBACK_PROGRESS, me, ne), C.on(c.default.PLAYBACK_TIME_UPDATED, me, ne), C.on(c.default.PLAYBACK_RATE_CHANGED, Qe, ne), C.on(c.default.PLAYBACK_STALLED, Ie, ne);
              }
              function ce() {
                return ie.id;
              }
              function le() {
                return K;
              }
              function q() {
                return A;
              }
              function _e(Oe) {
                var ke = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return new Promise(function(pe, Ve) {
                  de = Oe, se && ke && typeof se.discharge == "function" ? (ee = se, Te(ke).then(function() {
                    pe();
                  }).catch(function(ut) {
                    Ve(ut);
                  })) : pe();
                });
              }
              function Ee(Oe) {
                return J.convertRepresentationToRepresentationInfo(V.getRepresentationForQuality(Oe));
              }
              function Te(Oe) {
                var ke = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                return new Promise(function(pe, Ve) {
                  if (!k || !Oe) {
                    pe(null);
                    return;
                  }
                  de ? xe(Oe, ke).then(function(ut) {
                    pe(ut);
                  }).catch(function(ut) {
                    Ve(ut);
                  }) : Ce().then(function(ut) {
                    pe(ut);
                  }).catch(function(ut) {
                    Ve(ut);
                  });
                });
              }
              function Ce() {
                var Oe = this;
                return new Promise(function(ke, pe) {
                  var Ve = z.getQualityFor(K, ie.id);
                  se = (0, l.default)(N).create(it.bind(Oe)), wt(Ee(Ve)).then(function() {
                    ke(se);
                  }).catch(function() {
                    pe();
                  });
                });
              }
              function xe(Oe, ke) {
                return new Promise(function(pe, Ve) {
                  var ut = z.getQualityFor(K, ie.id);
                  se = (0, r.default)(N).create({
                    mediaSource: de,
                    textController: H,
                    eventBus: C
                  }), be(Oe, ke, ut).then(function() {
                    return wt(Ee(ut));
                  }).then(function() {
                    pe(se);
                  }).catch(function(St) {
                    ae.fatal("Caught error on create SourceBuffer: " + St), b.error(new _.default(L.default.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, L.default.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + K)), Ve(St);
                  });
                });
              }
              function be(Oe, ke, pe) {
                var Ve = Ee(pe);
                return ke && ke[K] && (K === g.default.VIDEO || K === g.default.AUDIO) ? se.initializeForStreamSwitch(Oe, Ve, ke[K]) : se.initializeForFirstUse(ie, Oe, Ve);
              }
              function Ge() {
                if (se && ee && typeof ee.discharge == "function") {
                  var Oe = ee.getAllBufferRanges();
                  if (Oe.length > 0) {
                    for (var ke = "Beginning " + K + "PreBuffer discharge, adding buffer for:", pe = 0; pe < Oe.length; pe++)
                      ke += " start: " + Oe.start(pe) + ", end: " + Oe.end(pe) + ";";
                    ae.debug(ke);
                  } else
                    ae.debug("PreBuffer discharge requested, but there were no media segments in the PreBuffer.");
                  re = [];
                  for (var Ve = ee.discharge(), ut = null, St = 0; St < Ve.length; St++) {
                    var jt = Ve[St];
                    if (jt.segmentType !== v.HTTPRequest.INIT_SEGMENT_TYPE) {
                      var Kt = k.extract(jt.streamId, jt.representationId);
                      Kt && ut !== Kt && (re.push(Kt), se.append(Kt), ut = Kt);
                    }
                    re.push(jt), se.append(jt);
                  }
                  ee.reset(), ee = null;
                }
              }
              function Pe(Oe) {
                Y.get().streaming.cacheInitSegments && (ae.info("Init fragment finished loading saving to", K + "'s init cache"), k.save(Oe.chunk)), ae.debug("Append Init fragment", K, " with representationId:", Oe.chunk.representationId, " and quality:", Oe.chunk.quality, ", data size:", Oe.chunk.bytes.byteLength), Ze(Oe.chunk);
              }
              function Le(Oe) {
                var ke = k.extract(ie.id, Oe);
                return ke ? (ae.info("Append Init fragment", K, " with representationId:", ke.representationId, " and quality:", ke.quality, ", data size:", ke.bytes.byteLength), Ze(ke), !0) : !1;
              }
              function je(Oe) {
                Ze(Oe.chunk, Oe.request);
              }
              function Ze(Oe) {
                var ke = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                se.append(Oe, ke).then(function(pe) {
                  it(pe);
                }).catch(function(pe) {
                  it(pe);
                }), Oe.mediaInfo.type === g.default.VIDEO && Je(t.default.VIDEO_CHUNK_RECEIVED, {
                  chunk: Oe
                });
              }
              function nt(Oe) {
                if (Oe && Oe.length > 0)
                  for (var ke = 0, pe = Oe.length; ke < pe; ke++)
                    ae.debug("Buffered range: " + Oe.start(ke) + " - " + Oe.end(ke) + ", currentTime = ", Z.getTime());
              }
              function it(Oe) {
                if (Oe.error) {
                  Oe.error.code === u && Ye(), (Oe.error.code === u || !ar()) && (ae.warn("Clearing playback buffer to overcome quota exceed situation"), Je(t.default.QUOTA_EXCEEDED, {
                    criticalBufferLevel: oe,
                    quotaExceededTime: Oe.chunk.start
                  }), qe(ze()));
                  return;
                }
                if (se && (et(), P = !1, te = Oe.chunk, !(!te || !te.endFragment))) {
                  te && !isNaN(te.index) && (Me = Math.max(te.index, Me), Mt());
                  var ke = se.getAllBufferRanges();
                  te.segmentType === v.HTTPRequest.MEDIA_SEGMENT_TYPE && (nt(ke), me(), De());
                  var pe = !1;
                  re && (re.indexOf(te) > 0 && (pe = !0), re = null), te && !pe && Je(t.default.BYTES_APPENDED_END_FRAGMENT, {
                    quality: te.quality,
                    startTime: te.start,
                    index: te.index,
                    bufferedRanges: ke,
                    segmentType: te.segmentType,
                    mediaType: K
                  });
                }
              }
              function De() {
                if (!isNaN(x)) {
                  if (K !== g.default.AUDIO && K !== g.default.VIDEO) {
                    x = NaN;
                    return;
                  }
                  var Oe = Z.getTime(), ke = $e(Oe, 0), pe = $e(x, 0);
                  if (ke && pe && ke.start === pe.start) {
                    x = NaN;
                    return;
                  }
                  var Ve = V.getCurrentRepresentation().segmentDuration, ut = $e(x, Ve);
                  ut && (Y.get().streaming.buffer.enableSeekDecorrelationFix && Math.abs(Oe - x) > Ve ? x <= ut.end && Z.seek(Math.max(x, ut.start), !1, !0) : Oe < ut.start && Z.seek(ut.start, !1, !0));
                }
              }
              function Ye() {
                if (P = !0, oe = Nt() * 0.8, ae.warn("Quota exceeded, Critical Buffer: " + oe), oe > 0) {
                  var Oe = Math.max(0.2 * oe, 1), ke = oe - Oe, pe = Math.min(Y.get().streaming.buffer.bufferTimeAtTopQuality, ke * 0.9), Ve = Math.min(Y.get().streaming.buffer.bufferTimeAtTopQualityLongForm, ke * 0.9), ut = {
                    streaming: {
                      buffer: {
                        bufferToKeep: parseFloat(Oe.toFixed(5)),
                        bufferTimeAtTopQuality: parseFloat(pe.toFixed(5)),
                        bufferTimeAtTopQualityLongForm: parseFloat(Ve.toFixed(5))
                      }
                    }
                  };
                  Y.update(ut);
                }
              }
              function Ke() {
                return fe && yt(!1), se.abort();
              }
              function tt(Oe) {
                return new Promise(function(ke, pe) {
                  se.abort().then(function() {
                    return Gt();
                  }).then(function() {
                    return Y.get().streaming.buffer.useChangeTypeForTrackSwitch ? se.changeType(Oe) : Promise.resolve();
                  }).then(function() {
                    return ht();
                  }).then(function() {
                    yt(!1), ke();
                  }).catch(function(Ve) {
                    pe(Ve);
                  });
                });
              }
              function st() {
                return new Promise(function(Oe, ke) {
                  se.abort().then(function() {
                    return Gt();
                  }).then(function() {
                    return ht();
                  }).then(function() {
                    yt(!1), Oe();
                  }).catch(function(pe) {
                    ke(pe);
                  });
                });
              }
              function Et(Oe) {
                return new Promise(function(ke, pe) {
                  Gt().then(function() {
                    return Y.get().streaming.buffer.useChangeTypeForTrackSwitch ? se.changeType(Oe) : Promise.resolve();
                  }).then(function() {
                    ke();
                  }).catch(function(Ve) {
                    pe(Ve);
                  });
                });
              }
              function ht() {
                return new Promise(function(Oe, ke) {
                  var pe = xt();
                  if (!pe || pe.length === 0) {
                    me(), Oe();
                    return;
                  }
                  qe(pe).then(function() {
                    Oe();
                  }).catch(function(Ve) {
                    ke(Ve);
                  });
                });
              }
              function xt(Oe) {
                var ke = [], pe = se.getAllBufferRanges();
                if (!pe || pe.length === 0)
                  return ke;
                if (!Oe && Oe !== 0 || isNaN(Oe))
                  ke.push({
                    start: pe.start(0),
                    end: pe.end(pe.length - 1) + o
                  });
                else {
                  var Ve = Xe(Oe, pe), ut = ve(Oe, pe);
                  Ve && ke.push(Ve), ut && ke.push(ut);
                }
                return ke;
              }
              function Xe(Oe, ke) {
                var pe = Y.get().streaming.buffer.bufferToKeep, Ve = ke.start(0), ut = Oe - Ve;
                if (ut > pe) {
                  var St = Math.max(0, Oe - pe), jt = w.getRequests({
                    state: i.default.FRAGMENT_MODEL_EXECUTED,
                    time: Oe,
                    threshold: y
                  })[0];
                  if (jt && (St = Math.min(jt.startTime, St)), St > 0)
                    return {
                      start: Ve,
                      end: St
                    };
                }
                return null;
              }
              function ve(Oe, ke) {
                var pe = ke.end(ke.length - 1) + o, Ve = Dt(Oe), ut = ie.manifestInfo.duration >= Y.get().streaming.buffer.longFormContentDurationThreshold, St = ut ? Y.get().streaming.buffer.bufferTimeAtTopQualityLongForm : Y.get().streaming.buffer.bufferTimeAtTopQuality, jt = isNaN(Ve) ? Oe : Math.min(Ve, Oe + St);
                if (jt >= ke.end(ke.length - 1))
                  return null;
                var Kt = w.getRequests({
                  state: i.default.FRAGMENT_MODEL_EXECUTED,
                  time: Oe,
                  threshold: y
                })[0];
                Kt && (jt = Math.max(Kt.startTime + Kt.duration, jt));
                var $t = Y.get().streaming.buffer.avoidCurrentTimeRangePruning;
                if ($t) {
                  for (var Yt = 0; Yt < ke.length; Yt++)
                    if (ke.start(Yt) <= Oe && Oe <= ke.end(Yt) && ke.start(Yt) <= jt && jt <= ke.end(Yt)) {
                      var gr = jt;
                      Yt + 1 < ke.length ? jt = ke.start(Yt + 1) : jt = ke.end(Yt) + 1, ae.debug("Buffered range [" + ke.start(Yt) + ", " + ke.end(Yt) + "] overlaps with targetTime " + Oe + " and range to be pruned [" + gr + ", " + pe + "], using [" + jt + ", " + pe + "] instead" + (jt < pe ? "" : " (no actual pruning)"));
                      break;
                    }
                }
                return jt < ke.end(ke.length - 1) ? {
                  start: jt,
                  end: pe
                } : null;
              }
              function me() {
                (!F || K === g.default.TEXT && H.isTextEnabled()) && et();
              }
              function Ie() {
                Lt();
              }
              function we() {
                Lt(), x = NaN;
              }
              function Ue(Oe) {
                try {
                  var ke = se.getAllBufferRanges();
                  if (!ke || ke.length === 0)
                    return !1;
                  for (var pe = 0; pe < ke.length; ) {
                    var Ve = ke.start(pe), ut = ke.end(pe);
                    if (Oe >= Ve && Oe <= ut)
                      return !0;
                    pe += 1;
                  }
                  return !1;
                } catch (St) {
                  return ae.error(St), !1;
                }
              }
              function $e(Oe, ke) {
                var pe = se.getAllBufferRanges(), Ve = 0, ut = 0, St = null, jt = null, Kt = 0, $t, Yt, gr = isNaN(ke) ? 0.15 : ke;
                if (pe != null) {
                  for (Yt = 0, $t = pe.length; Yt < $t; Yt++)
                    if (Ve = pe.start(Yt), ut = pe.end(Yt), St === null)
                      Kt = Math.abs(Ve - Oe), (Oe >= Ve && Oe < ut || Kt <= gr) && (St = Ve, jt = ut);
                    else if (Kt = Ve - jt, Kt <= gr)
                      jt = ut;
                    else
                      break;
                  if (St !== null)
                    return {
                      start: St,
                      end: jt
                    };
                }
                return null;
              }
              function at(Oe, ke) {
                var pe, Ve;
                return Y.get().streaming.gaps.jumpGaps && (ke = Y.get().streaming.gaps.smallGapLimit), pe = $e(Oe, ke), pe === null ? Ve = 0 : Ve = pe.end - Oe, Ve;
              }
              function et() {
                if (Z) {
                  var Oe = Y.get().streaming.gaps.jumpGaps && !isNaN(Y.get().streaming.gaps.smallGapLimit) ? Y.get().streaming.gaps.smallGapLimit : NaN;
                  Q = Math.max(at(Z.getTime() || 0, Oe), 0), Je(t.default.BUFFER_LEVEL_UPDATED, {
                    mediaType: K,
                    bufferLevel: Q
                  }), Lt();
                }
              }
              function Mt() {
                var Oe = Me >= ge - 1, ke = Z.getTimeToStreamEnd(ie) - Q < 1e-5;
                (Oe || ke) && !fe && (yt(!0), ae.debug("checkIfBufferingCompleted trigger BUFFERING_COMPLETED for stream id ".concat(ie.id, " and type ").concat(K)));
              }
              function Lt() {
                K !== g.default.AUDIO && K !== g.default.VIDEO || ((!Z.getLowLatencyModeEnabled() && Q < Y.get().streaming.buffer.stallThreshold || Q === 0) && !fe ? bt(n.default.BUFFER_EMPTY) : (fe || Q >= Y.get().streaming.buffer.stallThreshold || Z.getLowLatencyModeEnabled() && Q > 0) && bt(n.default.BUFFER_LOADED));
              }
              function bt(Oe) {
                ue === Oe || Oe === n.default.BUFFER_EMPTY && Z.getTime() === 0 || // Don't trigger BUFFER_EMPTY if it's initial loading
                K === g.default.TEXT && !H.isTextEnabled() || (ue = Oe, Je(t.default.BUFFER_LEVEL_STATE_CHANGED, {
                  state: Oe
                }), Je(Oe === n.default.BUFFER_LOADED ? t.default.BUFFER_LOADED : t.default.BUFFER_EMPTY), ae.debug(Oe === n.default.BUFFER_LOADED ? "Got enough buffer to start" : "Waiting for more buffer before starting playback"));
              }
              function Ae() {
                !se || K === g.default.TEXT || fe || qe(ze());
              }
              function ze() {
                var Oe = [], ke = se.getAllBufferRanges();
                if (!ke || ke.length === 0)
                  return Oe;
                var pe = Z.getTime(), Ve = Math.max(0, pe - Y.get().streaming.buffer.bufferToKeep), ut = w.getRequests({
                  state: i.default.FRAGMENT_MODEL_EXECUTED,
                  time: pe,
                  threshold: y
                })[0];
                if (ut)
                  Ve = Math.min(ut.startTime, Ve);
                else if (pe === 0 && Z.getIsDynamic())
                  return [];
                if (ke.start(0) <= Ve) {
                  for (var St = {
                    start: 0,
                    end: Ve
                  }, jt = 0; jt < ke.length && ke.end(jt) <= Ve; jt++)
                    St.end = ke.end(jt);
                  St.start < St.end && Oe.push(St);
                }
                return Oe;
              }
              function qe(Oe) {
                return new Promise(function(ke, pe) {
                  if (!Oe || !se || Oe.length === 0) {
                    ke();
                    return;
                  }
                  var Ve = [];
                  Oe.forEach(function(ut) {
                    Ve.push(_t(ut));
                  }), p || dt(), Promise.all(Ve).then(function() {
                    ke();
                  }).catch(function(ut) {
                    pe(ut);
                  });
                });
              }
              function _t(Oe) {
                return new Promise(function(ke, pe) {
                  Oe.resolve = ke, Oe.reject = pe, X.push(Oe);
                });
              }
              function dt() {
                try {
                  if (X.length === 0 || !se) {
                    ae.debug("Nothing to prune, halt pruning"), X = [], p = !1;
                    return;
                  }
                  var Oe = se.getBuffer();
                  if (!Oe || !Oe.buffered || Oe.buffered.length === 0) {
                    ae.debug("SourceBuffer is empty (or does not exist), halt pruning"), X = [], p = !1;
                    return;
                  }
                  var ke = X.shift();
                  ae.debug("".concat(K, ": Removing buffer from: ").concat(ke.start, " to ").concat(ke.end)), p = !0;
                  var pe = Z.getTime();
                  pe < ke.end && yt(!1), se.remove(ke).then(function(Ve) {
                    Tt(Ve);
                  }).catch(function(Ve) {
                    Tt(Ve);
                  });
                } catch {
                  p = !1;
                }
              }
              function Tt(Oe) {
                ae.debug("onRemoved buffer from:", Oe.from, "to", Oe.to);
                var ke = se.getAllBufferRanges();
                nt(ke), X.length === 0 && (p = !1, et()), Oe.unintended && (ae.warn("Detected unintended removal from:", Oe.from, "to", Oe.to, "setting streamprocessor time to", Oe.from), Je(t.default.SEEK_TARGET, {
                  time: Oe.from
                })), p ? dt() : (F ? F = !1 : et(), Je(t.default.BUFFER_CLEARED, {
                  from: Oe.from,
                  to: Oe.to,
                  unintended: Oe.unintended,
                  hasEnoughSpaceToAppend: ar(),
                  quotaExceeded: P
                }));
              }
              function wt(Oe) {
                return new Promise(function(ke) {
                  if (!Oe || Oe.MSETimeOffset === void 0 || !se || !se.updateTimestampOffset) {
                    ke();
                    return;
                  }
                  se.updateTimestampOffset(Oe.MSETimeOffset).then(function() {
                    ke();
                  }).catch(function() {
                    ke();
                  });
                });
              }
              function Gt() {
                return se && !fe ? se.updateAppendWindow(ie) : Promise.resolve();
              }
              function Xt(Oe) {
                isNaN(Oe) || (ge = Oe, Mt());
              }
              function ye() {
                O++;
                var Oe = O * (Y.get().streaming.wallclockTimeUpdateInterval / 1e3);
                Oe >= Y.get().streaming.buffer.bufferPruningInterval && (O = 0, Ae());
              }
              function Qe() {
                Lt();
              }
              function ct() {
                return se;
              }
              function Se() {
                return Q;
              }
              function Be() {
                return de;
              }
              function He() {
                return fe;
              }
              function yt(Oe) {
                fe !== Oe && (fe = Oe, fe ? Je(t.default.BUFFERING_COMPLETED) : ge = Number.POSITIVE_INFINITY);
              }
              function zt() {
                return p;
              }
              function Nt() {
                try {
                  var Oe = se.getAllBufferRanges(), ke = 0, pe, Ve;
                  if (!Oe)
                    return ke;
                  for (Ve = 0, pe = Oe.length; Ve < pe; Ve++)
                    ke += Oe.end(Ve) - Oe.start(Ve);
                  return ke;
                } catch {
                  return 0;
                }
              }
              function Dt(Oe) {
                try {
                  var ke = Oe, pe = se.getAllBufferRanges();
                  if (!pe || pe.length === 0)
                    return NaN;
                  for (var Ve = 0; ke === Oe && Ve < pe.length; ) {
                    var ut = pe.start(Ve), St = pe.end(Ve);
                    ke >= ut && ke <= St && (ke = St), Ve += 1;
                  }
                  return ke === Oe ? NaN : ke;
                } catch {
                }
              }
              function ar() {
                var Oe = Nt();
                return isNaN(Oe) || Oe < oe;
              }
              function Qt(Oe) {
                x = Oe;
              }
              function Je(Oe, ke) {
                var pe = ke || {};
                C.trigger(Oe, pe, {
                  streamId: ie.id,
                  mediaType: K
                });
              }
              function At(Oe, ke) {
                if (oe = Number.POSITIVE_INFINITY, ue = void 0, ge = Number.POSITIVE_INFINITY, Me = 0, te = null, fe = !1, p = !1, P = !1, Q = 0, O = 0, X = [], x = NaN, se) {
                  var pe = se;
                  se = null, !Oe && !ke && pe.abort().then(function() {
                    pe.reset(ke), pe = null;
                  });
                }
                F = !1;
              }
              function It(Oe, ke) {
                C.off(t.default.INIT_FRAGMENT_LOADED, Pe, this), C.off(t.default.MEDIA_FRAGMENT_LOADED, je, this), C.off(t.default.WALLCLOCK_TIME_UPDATED, ye, this), C.off(c.default.PLAYBACK_PLAYING, we, this), C.off(c.default.PLAYBACK_PROGRESS, me, this), C.off(c.default.PLAYBACK_TIME_UPDATED, me, this), C.off(c.default.PLAYBACK_RATE_CHANGED, Qe, this), C.off(c.default.PLAYBACK_STALLED, Ie, this), At(Oe, ke);
              }
              return ne = {
                initialize: $,
                getStreamId: ce,
                getType: le,
                getBufferControllerType: q,
                createBufferSink: Te,
                dischargePreBuffer: Ge,
                getBuffer: ct,
                getBufferLevel: Se,
                getRangeAt: $e,
                hasBufferAtTime: Ue,
                pruneBuffer: Ae,
                setMediaSource: _e,
                getMediaSource: Be,
                appendInitSegmentFromCache: Le,
                getIsBufferingCompleted: He,
                setIsBufferingCompleted: yt,
                getIsPruningInProgress: zt,
                reset: It,
                prepareForPlaybackSeek: Ke,
                prepareForReplacementTrackSwitch: tt,
                prepareForNonReplacementTrackSwitch: Et,
                prepareForReplacementQualitySwitch: st,
                updateAppendWindow: Gt,
                getAllRangesWithSafetyFactor: xt,
                getContinuousBufferTimeForTargetTime: Dt,
                clearBuffers: qe,
                pruneAllSafely: ht,
                updateBufferTimestampOffset: wt,
                setSeekTarget: Qt,
                segmentRequestingCompleted: Xt
              }, W(), ne;
            }
            I.__dashjs_factory_name = A;
            const M = T.default.getClassFactory(I);
          }
        ),
        /***/
        "./src/streaming/controllers/CatchupController.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/controllers/CatchupController.js ***!
            \********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), i = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), r = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), l = e(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), d = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), t = e(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), T = e(
              /*! ../../core/Utils */
              "./src/core/Utils.js"
            );
            function S() {
              var _ = this.context, L = (0, i.default)(_).getInstance(), v, c, o, y, u, A, I, M, E, N;
              function C() {
                w(), ee();
              }
              function b(re) {
                re && (re.settings && (u = re.settings), re.videoModel && (y = re.videoModel), re.streamController && (A = re.streamController), re.playbackController && (I = re.playbackController), re.mediaPlayerModel && (M = re.mediaPlayerModel));
              }
              function w() {
                L.on(l.default.BUFFER_LEVEL_UPDATED, ie, v), L.on(l.default.BUFFER_LEVEL_STATE_CHANGED, K, v), L.on(l.default.PLAYBACK_PROGRESS, ne, v), L.on(l.default.PLAYBACK_TIME_UPDATED, ne, v), L.on(l.default.PLAYBACK_SEEKED, Z, v), L.on(d.default.SETTING_UPDATED_CATCHUP_ENABLED, Y, v), L.on(d.default.SETTING_UPDATED_PLAYBACK_RATE_MIN, ee, v), L.on(d.default.SETTING_UPDATED_PLAYBACK_RATE_MAX, ee, v), L.on(l.default.STREAM_INITIALIZED, ee, v);
              }
              function V() {
                L.off(l.default.BUFFER_LEVEL_UPDATED, ie, v), L.off(l.default.BUFFER_LEVEL_STATE_CHANGED, K, v), L.off(l.default.PLAYBACK_PROGRESS, ne, v), L.off(l.default.PLAYBACK_TIME_UPDATED, ne, v), L.off(l.default.PLAYBACK_SEEKED, ne, v), L.off(d.default.SETTING_UPDATED_CATCHUP_ENABLED, Y, v), L.off(d.default.SETTING_UPDATED_PLAYBACK_RATE_MIN, ee, v), L.off(d.default.SETTING_UPDATED_PLAYBACK_RATE_MAX, ee, v), L.off(l.default.STREAM_INITIALIZED, ee, v);
              }
              function J() {
                N = (0, n.default)(_).getInstance().getLogger(v), z();
              }
              function H() {
                V(), z(), y.setPlaybackRate(1, !0);
              }
              function z() {
                c = !1;
                var re = T.default.parseUserAgent();
                o = re && re.browser && re.browser.name && re.browser.name.toLowerCase() === "safari";
              }
              function Z() {
                c = !1;
              }
              function ie(re) {
                if (!(re.streamId !== A.getActiveStreamInfo().id || !E)) {
                  var ue = I.getLiveDelay(), te = I.getBufferLevel();
                  te > ue / 2 && (E = !1);
                }
              }
              function K(re) {
                re.streamId === A.getActiveStreamInfo().id && (E = re.state === t.default.BUFFER_EMPTY);
              }
              function Y() {
                M.getCatchupModeEnabled() || y.setPlaybackRate(1);
              }
              function ne() {
                I.getIsDynamic() && M.getCatchupModeEnabled() && (M.getCatchupPlaybackRates().max > 0 || M.getCatchupPlaybackRates().min < 0) && !I.isPaused() && !I.isSeeking() && Q() && ae();
              }
              function ae() {
                if (!c && y) {
                  var re, ue = y.getPlaybackRate(), te = M.getCatchupPlaybackRates(), O = I.getBufferLevel(), p = fe(), P = M.getCatchupMaxDrift();
                  if (!isNaN(P) && P > 0 && p > P)
                    N.info("[CatchupController]: Low Latency catchup mechanism. Latency too high, doing a seek to live point"), c = !0, I.seekToCurrentLive(!0, !1);
                  else {
                    var k = I.getCurrentLiveLatency(), X = I.getLiveDelay();
                    if (oe() === r.default.LIVE_CATCHUP_MODE_LOLP) {
                      var F = u.get().streaming.liveCatchup.playbackBufferMin;
                      re = se(te, k, X, F, O);
                    } else
                      re = ge(te, k, X, O);
                    var x = o ? 0.25 : 0.02 / (0.5 / te.max);
                    re && Math.abs(ue - re) >= x && (N.debug("[CatchupController]: Setting playback rate to ".concat(re)), y.setPlaybackRate(re));
                  }
                }
              }
              function fe() {
                var re = I.getCurrentLiveLatency(), ue = I.getLiveDelay();
                return re - ue;
              }
              function Q() {
                try {
                  if (!I.getTime() > 0 || c)
                    return !1;
                  var re = oe();
                  if (re === r.default.LIVE_CATCHUP_MODE_LOLP) {
                    var ue = I.getBufferLevel(), te = u.get().streaming.liveCatchup.playbackBufferMin;
                    return Me(ue, te);
                  } else
                    return de();
                } catch {
                  return !1;
                }
              }
              function oe() {
                var re = u.get().streaming.liveCatchup.playbackBufferMin;
                return u.get().streaming.liveCatchup.mode === r.default.LIVE_CATCHUP_MODE_LOLP && re !== null && !isNaN(re) ? r.default.LIVE_CATCHUP_MODE_LOLP : r.default.LIVE_CATCHUP_MODE_DEFAULT;
              }
              function de() {
                try {
                  var re = Math.abs(fe());
                  return re > 0;
                } catch {
                  return !1;
                }
              }
              function Me(re, ue) {
                try {
                  var te = Math.abs(fe());
                  return te > 0 || re < ue;
                } catch {
                  return !1;
                }
              }
              function ge(re, ue, te, O) {
                if (E)
                  return 1;
                var p = ue - te, P = p < 0 ? Math.abs(re.min) : re.max, k = p * 5, X = P * 2 / (1 + Math.pow(Math.E, -k)), F = 1 - P + X;
                return I.getPlaybackStalled() && O <= te / 2 && p > 0 && (F = 1), F;
              }
              function se(re, ue, te, O, p) {
                var P;
                if (p < O) {
                  var k = Math.abs(re.min), X = p - O, F = X * 5, x = k * 2 / (1 + Math.pow(Math.E, -F));
                  P = 1 - k + x, N.debug("[LoL+ playback control_buffer-based] bufferLevel: " + p + ", newRate: " + P);
                } else {
                  var W = re.max, $ = 0.02;
                  if (Math.abs(ue - te) <= $ * te)
                    P = 1;
                  else {
                    var ce = ue - te, le = ce * 5, q = W * 2 / (1 + Math.pow(Math.E, -le));
                    P = 1 - W + q;
                  }
                  N.debug("[LoL+ playback control_latency-based] latency: " + ue + ", newRate: " + P);
                }
                return P;
              }
              function ee() {
                M.getCatchupPlaybackRates(!0);
              }
              return v = {
                reset: H,
                setConfig: b,
                initialize: C
              }, J(), v;
            }
            S.__dashjs_factory_name = "CatchupController";
            const h = g.default.getSingletonFactory(S);
          }
        ),
        /***/
        "./src/streaming/controllers/EventController.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/controllers/EventController.js ***!
            \******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => t
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), i = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), r = e(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), l = e(
              /*! ../net/XHRLoader */
              "./src/streaming/net/XHRLoader.js"
            );
            function d() {
              var T = "urn:mpeg:dash:event:2012", S = 1, h = "urn:mpeg:dash:event:callback:2015", _ = 1, L = 300, v = {
                DISCARDED: "discarded",
                UPDATED: "updated",
                ADDED: "added"
              }, c = this.context, o = (0, i.default)(c).getInstance(), y, u, A, I, M, E, N, C, b, w, V;
              function J() {
                u = (0, n.default)(c).getInstance().getLogger(y), z();
              }
              function H() {
                if (!N || !C)
                  throw new Error("setConfig function has to be called previously");
              }
              function z() {
                V = !1, A = {}, I = {}, M = null, w = !1, E = Date.now() / 1e3;
              }
              function Z() {
                try {
                  M !== null && V && (clearInterval(M), M = null, V = !1, de());
                } catch (F) {
                  throw F;
                }
              }
              function ie() {
                try {
                  H(), u.debug("Start Event Controller");
                  var F = b.get().streaming.eventControllerRefreshDelay;
                  !V && !isNaN(F) && (V = !0, M = setInterval(K, F));
                } catch (x) {
                  throw x;
                }
              }
              function K() {
                try {
                  if (!w) {
                    w = !0;
                    var F = C.getTime(), x = F - E;
                    x = E > 0 ? Math.max(0, x) : 0, Y(I, x, F), Y(A, x, F), ne(I), ne(A), E = F, w = !1;
                  }
                } catch (W) {
                  w = !1, u.error(W);
                }
              }
              function Y(F, x, W) {
                try {
                  var $ = function(le) {
                    if (le !== void 0) {
                      var q = isNaN(le.duration) ? 0 : le.duration;
                      le.calculatedPresentationTime <= W && le.calculatedPresentationTime + x + q >= W ? re(le, r.default.EVENT_MODE_ON_START) : (se(W, q + x, le.calculatedPresentationTime) || ee(le)) && (u.debug("Removing event ".concat(le.id, " from period ").concat(le.eventStream.period.id, " as it is expired or invalid")), ue(F, le));
                    }
                  };
                  ge(F, $);
                } catch (ce) {
                  u.error(ce);
                }
              }
              function ne(F) {
                try {
                  for (var x in F)
                    F.hasOwnProperty(x) && Object.keys(F[x]).length === 0 && delete F[x];
                } catch (W) {
                  u.error(W);
                }
              }
              function ae(F, x) {
                try {
                  if (H(), A[x] || (A[x] = {}), F)
                    for (var W = 0; W < F.length; W++) {
                      var $ = F[W], ce = C.getTime(), le = isNaN($.duration) ? 0 : $.duration;
                      if (!se(ce, le, $.calculatedPresentationTime)) {
                        var q = Q($, A[x], !0);
                        q === v.ADDED ? (u.debug("Added inline event with id ".concat($.id, " from period ").concat(x)), re($, r.default.EVENT_MODE_ON_RECEIVE)) : q === v.UPDATED && u.debug("Updated inline event with id ".concat($.id, " from period ").concat(x));
                      }
                    }
                } catch (_e) {
                  throw _e;
                }
              }
              function fe(F, x) {
                try {
                  H(), I[x] || (I[x] = {});
                  for (var W = 0; W < F.length; W++) {
                    var $ = F[W], ce = C.getTime(), le = isNaN($.duration) ? 0 : $.duration;
                    if (!se(ce, le, $.calculatedPresentationTime)) {
                      var q = Q($, I[x], !1);
                      q === v.ADDED ? ($.eventStream.schemeIdUri === T && oe($), u.debug("Added inband event with id ".concat($.id, " from period ").concat(x)), re($, r.default.EVENT_MODE_ON_RECEIVE)) : u.debug("Inband event with scheme_id_uri ".concat($.eventStream.schemeIdUri, ", value ").concat($.eventStream.value, ", period id ").concat(x, " and event id ").concat($.id, " was ignored because it has been added before."));
                    }
                  }
                  K();
                } catch (_e) {
                  throw _e;
                }
              }
              function Q(F, x) {
                var W = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, $ = F.eventStream.schemeIdUri, ce = F.eventStream.value, le = F.id, q = v.DISCARDED;
                x[$] || (x[$] = []);
                var _e = x[$].findIndex(function(Te) {
                  return (!ce || Te.eventStream.value && Te.eventStream.value === ce) && Te.id === le;
                });
                if (_e === -1)
                  x[$].push(F), F.triggeredReceivedEvent = !1, F.triggeredStartEvent = !1, q = v.ADDED;
                else if (W) {
                  var Ee = x[$][_e];
                  F.triggeredReceivedEvent = Ee.triggeredReceivedEvent, F.triggeredStartEvent = Ee.triggeredStartEvent, x[$][_e] = F, q = v.UPDATED;
                }
                return q;
              }
              function oe(F) {
                try {
                  if (F.eventStream.value == S) {
                    var x = F.calculatedPresentationTime, W;
                    F.calculatedPresentationTime == 4294967295 ? W = NaN : W = F.calculatedPresentationTime + F.duration, o.trigger(r.default.MANIFEST_VALIDITY_CHANGED, {
                      id: F.id,
                      validUntil: x,
                      newDuration: W,
                      newManifestValidAfter: NaN
                      //event.message_data - this is an arraybuffer with a timestring in it, but not used yet
                    }, {
                      mode: r.default.EVENT_MODE_ON_START
                    });
                  }
                } catch ($) {
                  u.error($);
                }
              }
              function de() {
                try {
                  Me(I), Me(A);
                } catch (F) {
                  u.error(F);
                }
              }
              function Me(F) {
                try {
                  var x = C.getTime(), W = function(ce) {
                    var le = ce.eventStream && ce.eventStream.period && !isNaN(ce.eventStream.period.duration) ? ce.eventStream.period.duration : NaN, q = ce.eventStream && ce.eventStream.period && !isNaN(ce.eventStream.period.start) ? ce.eventStream.period.start : NaN;
                    if (!(isNaN(le) || isNaN(q))) {
                      var _e = ce.calculatedPresentationTime;
                      Math.abs(_e - x) < L && re(ce, r.default.EVENT_MODE_ON_START);
                    }
                  };
                  ge(F, W);
                } catch ($) {
                  u.error($);
                }
              }
              function ge(F, x) {
                try {
                  if (F)
                    for (var W = Object.keys(F), $ = 0; $ < W.length; $++)
                      for (var ce = F[W[$]], le = Object.keys(ce), q = 0; q < le.length; q++) {
                        var _e = ce[le[q]];
                        _e.forEach(function(Ee) {
                          Ee !== void 0 && x(Ee);
                        });
                      }
                } catch (Ee) {
                  u.error(Ee);
                }
              }
              function se(F, x, W) {
                try {
                  return F - x > W;
                } catch ($) {
                  return u.error($), !1;
                }
              }
              function ee(F) {
                try {
                  var x = F.eventStream.period.start + F.eventStream.period.duration;
                  return F.calculatedPresentationTime > x;
                } catch (W) {
                  return u.error(W), !1;
                }
              }
              function re(F, x) {
                try {
                  var W = C.getTime(), $ = F.id;
                  if (x === r.default.EVENT_MODE_ON_RECEIVE && !F.triggeredReceivedEvent) {
                    u.debug("Received event ".concat($)), F.triggeredReceivedEvent = !0, o.trigger(F.eventStream.schemeIdUri, {
                      event: F
                    }, {
                      mode: x
                    });
                    return;
                  }
                  F.triggeredStartEvent || (F.eventStream.schemeIdUri === T && F.eventStream.value == S ? (F.duration !== 0 || F.presentationTimeDelta !== 0) && (u.debug("Starting manifest refresh event ".concat($, " at ").concat(W)), te()) : F.eventStream.schemeIdUri === h && F.eventStream.value == _ ? (u.debug("Starting callback event ".concat($, " at ").concat(W)), O(F.messageData)) : (u.debug("Starting event ".concat($, " from period ").concat(F.eventStream.period.id, " at ").concat(W)), o.trigger(F.eventStream.schemeIdUri, {
                    event: F
                  }, {
                    mode: x
                  })), F.triggeredStartEvent = !0);
                } catch (ce) {
                  u.error(ce);
                }
              }
              function ue(F, x) {
                try {
                  var W = x.eventStream.schemeIdUri, $ = x.eventStream.period.id, ce = x.eventStream.value, le = x.id;
                  F[$][W] = F[$][W].filter(function(q) {
                    return ce && q.eventStream.value && q.eventStream.value !== ce || q.id !== le;
                  }), F[$][W].length === 0 && delete F[$][W];
                } catch (q) {
                  u.error(q);
                }
              }
              function te() {
                try {
                  H(), N.refreshManifest();
                } catch (F) {
                  u.error(F);
                }
              }
              function O(F) {
                try {
                  var x = (0, l.default)(c).create({});
                  x.load({
                    method: "get",
                    url: F,
                    request: {
                      responseType: "arraybuffer"
                    }
                  });
                } catch (W) {
                  u.error(W);
                }
              }
              function p(F) {
                try {
                  if (!F)
                    return;
                  F.manifestUpdater && (N = F.manifestUpdater), F.playbackController && (C = F.playbackController), F.settings && (b = F.settings);
                } catch (x) {
                  throw x;
                }
              }
              function P() {
                return A;
              }
              function k() {
                return I;
              }
              function X() {
                Z(), z();
              }
              return y = {
                addInlineEvents: ae,
                addInbandEvents: fe,
                getInbandEvents: k,
                getInlineEvents: P,
                start: ie,
                setConfig: p,
                reset: X
              }, J(), y;
            }
            d.__dashjs_factory_name = "EventController";
            const t = g.default.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/streaming/controllers/FragmentController.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/controllers/FragmentController.js ***!
            \*********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => c
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../vo/DataChunk */
              "./src/streaming/vo/DataChunk.js"
            ), i = e(
              /*! ../models/FragmentModel */
              "./src/streaming/models/FragmentModel.js"
            ), r = e(
              /*! ../FragmentLoader */
              "./src/streaming/FragmentLoader.js"
            ), l = e(
              /*! ../utils/RequestModifier */
              "./src/streaming/utils/RequestModifier.js"
            ), d = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), t = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), T = e(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), S = e(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), h = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), _ = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), L = e(
              /*! ../utils/SegmentResponseModifier */
              "./src/streaming/utils/SegmentResponseModifier.js"
            );
            function v(o) {
              o = o || {};
              var y = this.context, u = (0, d.default)(y).getInstance(), A = o.errHandler, I = o.mediaPlayerModel, M = o.dashMetrics, E = (0, _.default)(y).getInstance(), N = (0, L.default)(y).getInstance(), C = o.streamInfo, b, w, V;
              function J() {
                w = E.getLogger(b), Z(), u.on(T.default.FRAGMENT_LOADING_COMPLETED, Y, b), u.on(T.default.FRAGMENT_LOADING_PROGRESS, Y, b);
              }
              function H() {
                return C.id;
              }
              function z(ne) {
                var ae = V[ne];
                return ae || (ae = (0, i.default)(y).create({
                  streamInfo: C,
                  type: ne,
                  dashMetrics: M,
                  fragmentLoader: (0, r.default)(y).create({
                    dashMetrics: M,
                    mediaPlayerModel: I,
                    errHandler: A,
                    requestModifier: (0, l.default)(y).getInstance(),
                    settings: o.settings,
                    boxParser: o.boxParser,
                    eventBus: u,
                    events: t.default,
                    errors: S.default,
                    dashConstants: o.dashConstants,
                    urlUtils: o.urlUtils,
                    streamId: H()
                  }),
                  debug: E,
                  eventBus: u,
                  events: t.default
                }), V[ne] = ae), ae;
              }
              function Z() {
                for (var ne in V)
                  V[ne].reset();
                V = {};
              }
              function ie() {
                u.off(T.default.FRAGMENT_LOADING_COMPLETED, Y, this), u.off(T.default.FRAGMENT_LOADING_PROGRESS, Y, this), Z();
              }
              function K(ne, ae, fe, Q) {
                var oe = new n.default();
                return oe.streamId = fe, oe.mediaInfo = ae.mediaInfo, oe.segmentType = ae.type, oe.start = ae.startTime, oe.duration = ae.duration, oe.end = oe.start + oe.duration, oe.bytes = ne, oe.index = ae.index, oe.quality = ae.quality, oe.representationId = ae.representationId, oe.endFragment = Q, oe;
              }
              function Y(ne) {
                if (ne.sender) {
                  var ae = ne.request, fe = ne.response, Q = ae.isInitializationRequest(), oe = ae.mediaInfo.streamInfo;
                  if (ne.error && (ae.mediaType === g.default.AUDIO || ae.mediaType === g.default.VIDEO || ae.mediaType === g.default.TEXT && ae.mediaInfo.isFragmented) && u.trigger(t.default.SERVICE_LOCATION_BLACKLIST_ADD, {
                    entry: ne.request.serviceLocation
                  }), !fe || !oe) {
                    w.warn("No " + ae.mediaType + " bytes to push or stream is inactive.");
                    return;
                  }
                  var de = K(fe, ae, C.id, ne.type !== t.default.FRAGMENT_LOADING_PROGRESS);
                  N.modifyResponseAsync(de).then(function(Me) {
                    u.trigger(Q ? t.default.INIT_FRAGMENT_LOADED : t.default.MEDIA_FRAGMENT_LOADED, {
                      chunk: Me,
                      request: ae
                    }, {
                      streamId: oe.id,
                      mediaType: ae.mediaType
                    });
                  }).catch(function(Me) {
                    w.error(Me), u.trigger(Q ? t.default.INIT_FRAGMENT_LOADED : t.default.MEDIA_FRAGMENT_LOADED, {
                      chunk: de,
                      request: ae
                    }, {
                      streamId: oe.id,
                      mediaType: ae.mediaType
                    });
                  });
                }
              }
              return b = {
                getStreamId: H,
                getModel: z,
                reset: ie
              }, J(), b;
            }
            v.__dashjs_factory_name = "FragmentController";
            const c = h.default.getClassFactory(v);
          }
        ),
        /***/
        "./src/streaming/controllers/GapController.js": (
          /*!****************************************************!*\
            !*** ./src/streaming/controllers/GapController.js ***!
            \****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), i = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), r = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), l = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), d = 100, t = 10, T = 0.1;
            function S() {
              var _ = this.context, L = (0, r.default)(_).getInstance(), v, c, o, y, u, A, I, M, E, N, C, b;
              function w() {
                Z();
              }
              function V() {
                b = (0, n.default)(_).getInstance().getLogger(v), J();
              }
              function J() {
                se(), ie(), H();
              }
              function H() {
                u = null, A = NaN, y = 0, N = null, C = {};
              }
              function z(re) {
                re && (re.settings && (o = re.settings), re.playbackController && (I = re.playbackController), re.streamController && (M = re.streamController), re.videoModel && (E = re.videoModel));
              }
              function Z() {
                L.on(i.default.WALLCLOCK_TIME_UPDATED, fe, this), L.on(i.default.INITIAL_STREAM_SWITCH, ae, this), L.on(i.default.PLAYBACK_SEEKING, K, this), L.on(i.default.BUFFER_REPLACEMENT_STARTED, Y, v), L.on(i.default.TRACK_CHANGE_RENDERED, ne, v);
              }
              function ie() {
                L.off(i.default.WALLCLOCK_TIME_UPDATED, fe, this), L.off(i.default.INITIAL_STREAM_SWITCH, ae, this), L.off(i.default.PLAYBACK_SEEKING, K, this), L.off(i.default.BUFFER_REPLACEMENT_STARTED, Y, v), L.off(i.default.TRACK_CHANGE_RENDERED, ne, v);
              }
              function K() {
                N && (clearTimeout(N), N = null);
              }
              function Y(re) {
                try {
                  if (re.streamId !== M.getActiveStreamInfo().id || re.mediaType !== l.default.VIDEO && re.mediaType !== l.default.AUDIO)
                    return;
                  re.streamId === M.getActiveStreamInfo().id && (C[re.mediaType] = !0);
                } catch (ue) {
                  b.error(ue);
                }
              }
              function ne(re) {
                !re || !re.mediaType || (C[re.mediaType] = !1);
              }
              function ae() {
                u || ge();
              }
              function fe() {
                if (Q(o.get().streaming.gaps.enableSeekFix) && (y++, y >= t)) {
                  var re = I.getTime();
                  c === re ? ee(re, !0) : (c = re, A = NaN), y = 0;
                }
              }
              function Q() {
                var re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                if (!M.getActiveStream())
                  return !1;
                var ue = Object.keys(C).some(function(O) {
                  return C[O];
                }), te = re ? oe() : !1;
                return !ue && o.get().streaming.gaps.jumpGaps && M.getActiveStreamProcessors().length > 0 && (!I.isSeeking() || te) && !I.isPaused() && !M.getIsStreamSwitchInProgress() && !M.getHasMediaOrInitialisationError();
              }
              function oe() {
                var re = M.getActiveStream(), ue = parseFloat((re.getStartTime() + re.getDuration()).toFixed(5));
                return I.getTime() + o.get().streaming.gaps.threshold >= ue;
              }
              function de(re, ue) {
                try {
                  if (!re || re.length <= 1 && ue > 0)
                    return NaN;
                  for (var te = NaN, O = 0; isNaN(te) && O < re.length; ) {
                    var p = O > 0 ? re.end(O - 1) : 0;
                    ue < re.start(O) && p - ue < o.get().streaming.gaps.threshold && (te = O), O += 1;
                  }
                  return te;
                } catch {
                  return null;
                }
              }
              function Me(re, ue) {
                for (var te = 0, O = re.length; te < O; te++)
                  if (ue >= re.start(te) && ue <= re.end(te))
                    return !0;
                return !1;
              }
              function ge() {
                try {
                  u || (b.debug("Starting the gap controller"), u = setInterval(function() {
                    if (Q()) {
                      var re = I.getTime();
                      ee(re);
                    }
                  }, d));
                } catch {
                }
              }
              function se() {
                b.debug("Stopping the gap controller"), u && (clearInterval(u), u = null);
              }
              function ee(re) {
                var ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, te = o.get().streaming.gaps.enableStallFix, O = o.get().streaming.gaps.stallSeek, p = o.get().streaming.gaps.smallGapLimit, P = o.get().streaming.gaps.jumpLargeGaps, k = E.getBufferRange(), X, F = NaN, x = !1;
                if (X = de(k, re), !isNaN(X)) {
                  var W = k.start(X), $ = W - re;
                  $ > 0 && ($ <= p || P) && (F = W);
                }
                var ce = I.getTimeToStreamEnd();
                if (isNaN(F) && ue && isFinite(ce) && !isNaN(ce) && ce < p && (F = parseFloat(I.getStreamEndTime().toFixed(5)), x = !0), te && isNaN(F) && ue && isNaN(X) && Me(k, re) && (O === 0 ? (b.warn("Toggle play pause to break stall"), E.pause(), E.play()) : (b.warn("Jumping ".concat(O, "s to break stall")), F = re + O)), F > 0 && A !== F && F > re && !N) {
                  var le = F - re;
                  if (x) {
                    var q = M.getStreamForTime(F), _e = q && !!q.getPreloaded();
                    b.warn("Jumping to end of stream because of gap from ".concat(re, " to ").concat(F, ". Gap duration: ").concat(le)), I.seek(F, !0, _e);
                  } else {
                    var Ee = I.getIsDynamic(), Te = X > 0 ? k.end(X - 1) : re, Ce = Ee ? Math.max(0, le - T) * 1e3 : 0;
                    N = window.setTimeout(function() {
                      I.seek(F, !0, !0), b.warn("Jumping gap occuring in period ".concat(M.getActiveStream().getStreamId(), " starting at ").concat(Te, " and ending at ").concat(F, ". Jumping by: ").concat(F - Te)), N = null;
                    }, Ce);
                  }
                  A = F;
                }
              }
              return v = {
                reset: J,
                setConfig: z,
                initialize: w
              }, V(), v;
            }
            S.__dashjs_factory_name = "GapController";
            const h = g.default.getSingletonFactory(S);
          }
        ),
        /***/
        "./src/streaming/controllers/MediaController.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/controllers/MediaController.js ***!
            \******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => _
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), i = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), r = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), l = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), d = e(
              /*! bcp-47-normalize */
              "./node_modules/bcp-47-normalize/index.js"
            ), t = /* @__PURE__ */ e.n(d), T = e(
              /*! bcp-47-match */
              "./node_modules/bcp-47-match/index.js"
            );
            function S() {
              var L = this.context, v = (0, i.default)(L).getInstance(), c, o, y, u, A, I, M, E;
              function N() {
                o = (0, l.default)(L).getInstance().getLogger(c), ae();
              }
              function C(le, q) {
                var _e = I[le] || Z(le), Ee = w(le, q.id), Te = [];
                _e || (_e = E.getSavedMediaSettings(le), z(le, _e)), !(!Ee || Ee.length === 0) && (_e && (Te = Array.from(Ee), Te = Q(Te, oe, _e), Te = Q(Te, de, _e), Te = Q(Te, Me, _e), le === g.default.AUDIO && I[le] || (Te = Q(Te, ge, _e)), Te = Q(Te, se, _e), Te = Q(Te, ee, _e)), Te.length === 0 ? H(k(le, Ee), !0) : Te.length > 1 ? H(k(le, Te, !!I[le])) : H(Te[0]));
              }
              function b(le) {
                if (le) {
                  var q = le.type;
                  if (K(q)) {
                    var _e = le.streamInfo.id;
                    y[_e] || (y[_e] = ce());
                    for (var Ee = y[_e][q].list, Te = 0, Ce = Ee.length; Te < Ce; ++Te)
                      if (Y(Ee[Te], le))
                        return;
                    Ee.push(le);
                  }
                }
              }
              function w(le, q) {
                return le ? !y[q] || !y[q][le] ? [] : y[q][le].list : [];
              }
              function V(le, q) {
                return !le || !y[q] || !y[q][le] ? null : y[q][le].current;
              }
              function J(le) {
                if (!le)
                  return !1;
                var q = le.type, _e = le.streamInfo.id;
                return y[_e] && y[_e][q] && Y(y[_e][q].current, le);
              }
              function H(le) {
                var q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                if (!(!le || !le.streamInfo)) {
                  var _e = le.type, Ee = le.streamInfo, Te = Ee.id, Ce = V(_e, Te);
                  if (!(!y[Te] || !y[Te][_e]) && (y[Te][_e].current = le, y[Te][_e].current && (_e !== g.default.TEXT && !Y(le, Ce) || _e === g.default.TEXT && le.isFragmented) && v.trigger(n.default.CURRENT_TRACK_CHANGED, {
                    oldMediaInfo: Ce,
                    newMediaInfo: le,
                    switchMode: u.get().streaming.trackSwitchMode[_e]
                  }, {
                    streamId: Te
                  }), !q)) {
                    var xe = fe(le);
                    if (!xe || !y[Te][_e].storeLastSettings)
                      return;
                    xe.roles && (xe.role = xe.roles[0], delete xe.roles), xe.accessibility && (xe.accessibility = xe.accessibility[0]), xe.audioChannelConfiguration && (xe.audioChannelConfiguration = xe.audioChannelConfiguration[0]), I[_e] = xe, E.setSavedMediaSettings(_e, xe);
                  }
                }
              }
              function z(le, q) {
                !le || !q || (A[le] = q);
              }
              function Z(le) {
                return le ? A[le] : null;
              }
              function ie() {
                E.setSavedMediaSettings(g.default.TEXT, null);
              }
              function K(le) {
                return le === g.default.AUDIO || le === g.default.VIDEO || le === g.default.TEXT || le === g.default.IMAGE;
              }
              function Y(le, q) {
                if (!le && !q)
                  return !0;
                if (!le || !q)
                  return !1;
                var _e = le.id === q.id, Ee = le.viewpoint === q.viewpoint, Te = le.lang === q.lang, Ce = le.codec === q.codec, xe = le.roles.toString() === q.roles.toString(), be = le.accessibility.toString() === q.accessibility.toString(), Ge = le.audioChannelConfiguration.toString() === q.audioChannelConfiguration.toString();
                return _e && Ce && Ee && Te && xe && be && Ge;
              }
              function ne(le) {
                le && (le.domStorage && (E = le.domStorage), le.settings && (u = le.settings), le.customParametersModel && (M = le.customParametersModel));
              }
              function ae() {
                y = {}, I = {}, ue();
              }
              function fe(le) {
                var q = {
                  lang: le.lang,
                  viewpoint: le.viewpoint,
                  roles: le.roles,
                  accessibility: le.accessibility,
                  audioChannelConfiguration: le.audioChannelConfiguration
                }, _e = q.lang || q.viewpoint || q.role && q.role.length > 0 || q.accessibility && q.accessibility.length > 0 || q.audioChannelConfiguration && q.audioChannelConfiguration.length > 0;
                return _e ? q : null;
              }
              function Q(le, q, _e) {
                var Ee = [];
                return le.forEach(function(Te) {
                  q(_e, Te) && Ee.push(Te);
                }), Ee.length !== 0 ? Ee : le;
              }
              function oe(le, q) {
                return !le.lang || le.lang instanceof RegExp ? q.lang.match(le.lang) : q.lang !== "" ? (0, T.extendedFilter)(q.lang, t()(le.lang)).length > 0 : !1;
              }
              function de(le, q) {
                return le.index === void 0 || le.index === null || q.index === le.index;
              }
              function Me(le, q) {
                return !le.viewpoint || le.viewpoint === q.viewpoint;
              }
              function ge(le, q) {
                var _e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Ee = !le.role || !!q.roles.filter(function(Te) {
                  return Te === le.role;
                })[0];
                return Ee || q.type === g.default.AUDIO && _e;
              }
              function se(le, q) {
                var _e;
                return le.accessibility ? _e = !!q.accessibility.filter(function(Ee) {
                  return Ee === le.accessibility;
                })[0] : _e = !q.accessibility.length, _e;
              }
              function ee(le, q) {
                var _e = !le.audioChannelConfiguration || !!q.audioChannelConfiguration.filter(function(Ee) {
                  return Ee === le.audioChannelConfiguration;
                })[0];
                return _e;
              }
              function re(le, q) {
                var _e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                try {
                  var Ee = !1;
                  if (!le.lang)
                    Ee = !0;
                  else if (le.lang instanceof RegExp)
                    Ee = q.lang.match(le.lang);
                  else if (q.lang !== "") {
                    var Te = t()(le.lang);
                    Te && (Ee = (0, T.extendedFilter)(q.lang, Te).length > 0);
                  }
                  var Ce = le.index === void 0 || le.index === null || q.index === le.index, xe = !le.viewpoint || le.viewpoint === q.viewpoint, be = !le.role || !!q.roles.filter(function(Le) {
                    return Le === le.role;
                  })[0], Ge = !le.accessibility || !!q.accessibility.filter(function(Le) {
                    return Le === le.accessibility;
                  })[0], Pe = !le.audioChannelConfiguration || !!q.audioChannelConfiguration.filter(function(Le) {
                    return Le === le.audioChannelConfiguration;
                  })[0];
                  return Ee && Ce && xe && (be || q.type === g.default.AUDIO && _e) && Ge && Pe;
                } catch {
                  return !1;
                }
              }
              function ue() {
                A = {
                  audio: null,
                  video: null,
                  text: null
                };
              }
              function te(le) {
                var q = 0, _e = [];
                return le.forEach(function(Ee) {
                  isNaN(Ee.selectionPriority) || (Ee.selectionPriority > q ? (q = Ee.selectionPriority, _e = [Ee]) : Ee.selectionPriority === q && _e.push(Ee));
                }), _e;
              }
              function O(le) {
                var q = 0, _e = [], Ee;
                return le.forEach(function(Te) {
                  Ee = Math.max.apply(Math, Te.bitrateList.map(function(Ce) {
                    return Ce.bandwidth;
                  })), Ee > q ? (q = Ee, _e = [Te]) : Ee === q && _e.push(Te);
                }), _e;
              }
              function p(le) {
                var q = 1 / 0, _e = [], Ee;
                return le.forEach(function(Te) {
                  var Ce = Te.bitrateList.reduce(function(xe, be) {
                    var Ge = Math.max(1, be.width * be.height), Pe = be.bandwidth / Ge;
                    return xe + Pe;
                  }, 0);
                  Ee = Ce / Te.bitrateList.length, Ee < q ? (q = Ee, _e = [Te]) : Ee === q && _e.push(Te);
                }), _e;
              }
              function P(le) {
                var q = 0, _e = [], Ee;
                return le.forEach(function(Te) {
                  Ee = Te.representationCount, Ee > q ? (q = Ee, _e = [Te]) : Ee === q && _e.push(Te);
                }), _e;
              }
              function k(le, q) {
                if (le === g.default.TEXT)
                  return q[0];
                var _e = u.get().streaming.selectionModeForInitialTrack, Ee, Te = M.getCustomInitialTrackSelectionFunction();
                if (Te && typeof Te == "function")
                  Ee = Te(q);
                else
                  switch (_e) {
                    case g.default.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY:
                      Ee = X(q);
                      break;
                    case g.default.TRACK_SELECTION_MODE_HIGHEST_BITRATE:
                      Ee = F(q);
                      break;
                    case g.default.TRACK_SELECTION_MODE_FIRST_TRACK:
                      Ee = x(q);
                      break;
                    case g.default.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY:
                      Ee = W(q);
                      break;
                    case g.default.TRACK_SELECTION_MODE_WIDEST_RANGE:
                      Ee = $(q);
                      break;
                    default:
                      o.warn("Track selection mode ".concat(_e, " is not supported. Falling back to TRACK_SELECTION_MODE_FIRST_TRACK")), Ee = x(q);
                      break;
                  }
                return Ee.length > 0 ? Ee[0] : q[0];
              }
              function X(le) {
                var q = te(le);
                return q.length > 1 && (q = O(q)), q.length > 1 && (q = P(q)), q;
              }
              function F(le) {
                var q = O(le);
                return q.length > 1 && (q = P(q)), q;
              }
              function x(le) {
                return le[0];
              }
              function W(le) {
                var q = p(le);
                return q.length > 1 && (q = O(q)), q;
              }
              function $(le) {
                var q = P(le);
                return q.length > 1 && (q = O(le)), q;
              }
              function ce() {
                return {
                  audio: {
                    list: [],
                    storeLastSettings: !0,
                    current: null
                  },
                  video: {
                    list: [],
                    storeLastSettings: !0,
                    current: null
                  },
                  text: {
                    list: [],
                    storeLastSettings: !0,
                    current: null
                  },
                  image: {
                    list: [],
                    storeLastSettings: !0,
                    current: null
                  }
                };
              }
              return c = {
                setInitialMediaSettingsForType: C,
                addTrack: b,
                getTracksFor: w,
                getCurrentTrackFor: V,
                isCurrentTrack: J,
                setTrack: H,
                selectInitialTrack: k,
                setInitialSettings: z,
                getInitialSettings: Z,
                getTracksWithHighestBitrate: O,
                getTracksWithHighestEfficiency: p,
                getTracksWithWidestRange: P,
                isTracksEqual: Y,
                matchSettings: re,
                matchSettingsLang: oe,
                matchSettingsIndex: de,
                matchSettingsViewPoint: Me,
                matchSettingsRole: ge,
                matchSettingsAccessibility: se,
                matchSettingsAudioChannelConfig: ee,
                saveTextSettingsDisabled: ie,
                setConfig: ne,
                reset: ae
              }, N(), c;
            }
            S.__dashjs_factory_name = "MediaController";
            var h = r.default.getSingletonFactory(S);
            r.default.updateSingletonFactory(S.__dashjs_factory_name, h);
            const _ = h;
          }
        ),
        /***/
        "./src/streaming/controllers/MediaSourceController.js": (
          /*!************************************************************!*\
            !*** ./src/streaming/controllers/MediaSourceController.js ***!
            \************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            );
            function i() {
              var l, d, t, T = this.context;
              function S() {
                t = (0, n.default)(T).getInstance().getLogger(l);
              }
              function h() {
                var u = "WebKitMediaSource" in window, A = "MediaSource" in window;
                return A ? d = new MediaSource() : u && (d = new WebKitMediaSource()), d;
              }
              function _(u) {
                var A = window.URL.createObjectURL(d);
                return u.setSource(A), A;
              }
              function L(u) {
                u.setSource(null);
              }
              function v(u) {
                !d || d.readyState !== "open" || u === null && isNaN(u) || d.duration !== u && (y(d) ? setTimeout(v.bind(null, u), 50) : (t.info("Set MediaSource duration:" + u), d.duration = u));
              }
              function c(u, A) {
                d && typeof d.setLiveSeekableRange == "function" && typeof d.clearLiveSeekableRange == "function" && d.readyState === "open" && u >= 0 && u < A && (d.clearLiveSeekableRange(), d.setLiveSeekableRange(u, A));
              }
              function o(u) {
                if (!(!u || u.readyState !== "open")) {
                  for (var A = u.sourceBuffers, I = 0; I < A.length; I++)
                    if (A[I].updating || A[I].buffered.length === 0)
                      return;
                  t.info("call to mediaSource endOfStream"), u.endOfStream();
                }
              }
              function y(u) {
                for (var A = u.sourceBuffers, I = 0; I < A.length; I++)
                  if (A[I].updating)
                    return !0;
                return !1;
              }
              return l = {
                createMediaSource: h,
                attachMediaSource: _,
                detachMediaSource: L,
                setDuration: v,
                setSeekable: c,
                signalEndOfStream: o
              }, S(), l;
            }
            i.__dashjs_factory_name = "MediaSourceController";
            const r = g.default.getSingletonFactory(i);
          }
        ),
        /***/
        "./src/streaming/controllers/PlaybackController.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/controllers/PlaybackController.js ***!
            \*********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), i = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), r = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), l = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), d = e(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), t = e(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), T = 500;
            function S() {
              var _ = this.context, L = (0, n.default)(_).getInstance(), v, c, o, y, u, A, I, M, E, N, C, b, w, V, J, H, z, Z, ie, K, Y, ne, ae, fe;
              function Q() {
                c = (0, l.default)(_).getInstance().getLogger(v), oe();
              }
              function oe() {
                ue(), V = !1, N = 0, C = 0, H = 0, ne = !1, z = !0, Z = !1, ae = !1, ie = NaN, I && (L.off(i.default.DATA_UPDATE_COMPLETED, it, v), L.off(i.default.LOADING_PROGRESS, qe, v), L.off(i.default.MANIFEST_UPDATED, Gt, v), L.off(i.default.STREAMS_COMPOSED, Xt, v), L.off(d.default.PLAYBACK_ENDED, et, v), L.off(d.default.STREAM_INITIALIZING, dt, v), L.off(d.default.REPRESENTATION_SWITCH, Tt, v), L.off(d.default.BUFFER_LEVEL_STATE_CHANGED, Ke, v), nt(), ct()), E = null, I = null, b = null, w = null;
              }
              function de(Se, Be) {
                b = Se, Be !== !0 && Me();
              }
              function Me() {
                Qe(), w = b.manifestInfo.isDynamic, Y = !1, K = !1, L.on(i.default.DATA_UPDATE_COMPLETED, it, v), L.on(i.default.LOADING_PROGRESS, qe, v), L.on(i.default.MANIFEST_UPDATED, Gt, v), L.on(i.default.STREAMS_COMPOSED, Xt, v), L.on(d.default.PLAYBACK_ENDED, et, v, {
                  priority: n.default.EVENT_PRIORITY_HIGH
                }), L.on(d.default.STREAM_INITIALIZING, dt, v), L.on(d.default.REPRESENTATION_SWITCH, Tt, v), L.on(d.default.BUFFER_LEVEL_STATE_CHANGED, Ke, v), V && (V = !1, re());
              }
              function ge() {
                return Y;
              }
              function se() {
                var Se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                return parseFloat((ee(Se) - X()).toFixed(5));
              }
              function ee(Se) {
                var Be = Se || b;
                return Be.start + Be.duration;
              }
              function re() {
                var Se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                b && I && I.getElement() ? (Se && w && k(X()), I.play()) : V = !0;
              }
              function ue() {
                b && I && I.pause();
              }
              function te(Se) {
                var Be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, He = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, yt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
                if (!(!b || !I)) {
                  var zt = isNaN(ie) ? I.getTime() : ie;
                  Se !== zt && (K = He === !0, K || (ie = Se), c.info("Requesting seek to time: " + Se + (K ? " (internal)" : "")), w && yt && k(Se), I.setCurrentTime(Se, Be));
                }
              }
              function O() {
                var Se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, Be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, He = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, yt = P();
                if (yt !== 0) {
                  N = C;
                  var zt = yt - N;
                  te(zt, Se, Be, He);
                }
              }
              function p() {
                var Se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, Be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, He = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, yt = P();
                if (yt !== 0) {
                  var zt = yt - N;
                  te(zt, Se, Be, He);
                }
              }
              function P() {
                if (!(!b || !I || !w)) {
                  var Se = o && o.hasVideoTrack() ? g.default.VIDEO : g.default.AUDIO, Be = u.getCurrentDVRInfo(Se);
                  return Be && Be.range ? Be.range.end : 0;
                }
              }
              function k(Se) {
                var Be = new Date(M.getClientReferenceTime()), He = A.getRegularPeriods()[0], yt = M.calcPresentationTimeFromWallTime(Be, He);
                N = yt - Se;
              }
              function X() {
                return b && I ? I.getTime() : null;
              }
              function F() {
                return b && I ? I.isPaused() : null;
              }
              function x() {
                return b && I ? I.isSeeking() : null;
              }
              function W() {
                return b && I ? I.isStalled() : null;
              }
              function $() {
                return b && I ? I.getPlaybackRate() : null;
              }
              function ce() {
                return b && I ? I.getPlayedRanges() : null;
              }
              function le() {
                return b && I ? I.getEnded() : null;
              }
              function q() {
                return w;
              }
              function _e() {
                return o;
              }
              function Ee() {
                return ne;
              }
              function Te() {
                return H;
              }
              function Ce() {
                return N;
              }
              function xe() {
                return C;
              }
              function be() {
                if (!w || isNaN(H))
                  return NaN;
                var Se = X();
                if (isNaN(Se) || Se === 0)
                  return 0;
                var Be = (/* @__PURE__ */ new Date()).getTime() + M.getClientTimeOffset() * 1e3;
                return Math.max(((Be - H - Se * 1e3) / 1e3).toFixed(3), 0);
              }
              function Ge(Se, Be) {
                var He, yt, zt, Nt = 4, Dt = 4, ar = !isNaN(Se) && isFinite(Se) ? Se : NaN, Qt = A.getSuggestedPresentationDelay(), Je = y.getServiceDescriptionSettings();
                return isNaN(fe.get().streaming.delay.liveDelay) ? fe.get().streaming.delay.liveDelayFragmentCount !== null && !isNaN(fe.get().streaming.delay.liveDelayFragmentCount) && !isNaN(ar) ? He = ar * fe.get().streaming.delay.liveDelayFragmentCount : Je && !isNaN(Je.liveDelay) && Je.liveDelay > 0 ? He = Je.liveDelay : fe.get().streaming.delay.useSuggestedPresentationDelay === !0 && Qt !== null && !isNaN(Qt) && Qt > 0 ? He = Qt : isNaN(ar) ? He = Be && !isNaN(Be.minBufferTime) ? Be.minBufferTime * Nt : b.manifestInfo.minBufferTime * Nt : He = ar * Dt : He = fe.get().streaming.delay.liveDelay, zt = A.getAvailabilityStartTime(), zt !== null && (H = zt), Be && Be.dvrWindowSize > 0 ? yt = Math.min(He, Be.dvrWindowSize) : yt = He, N = yt, C = yt, yt;
              }
              function Pe(Se) {
                Se && (Se.streamController && (o = Se.streamController), Se.serviceDescriptionController && (y = Se.serviceDescriptionController), Se.dashMetrics && (u = Se.dashMetrics), Se.adapter && (A = Se.adapter), Se.videoModel && (I = Se.videoModel), Se.timelineConverter && (M = Se.timelineConverter), Se.settings && (fe = Se.settings));
              }
              function Le() {
                var Se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                if (!(F() || !w || I.getReadyState() === 0 || x() || ne)) {
                  Se || (Se = o.hasVideoTrack() ? g.default.VIDEO : g.default.AUDIO);
                  var Be = X(), He = je(Be, Se), yt = !isNaN(He) && He !== Be;
                  yt && !x() && (W() || Y || I.getReadyState() === 1) && (c.debug("UpdateCurrentTime: Seek to actual time: ".concat(He, " from currentTime: ").concat(Be)), te(He, !1, !1));
                }
              }
              function je(Se, Be) {
                var He = u.getCurrentDVRInfo(Be), yt = He ? He.range : null, zt;
                return yt ? (Se > yt.end ? zt = Math.max(yt.end - N, yt.start) : Se > 0 && Se + 0.25 < yt.start && Math.abs(Se - yt.start) < 31536e4 ? Z ? zt = Math.max(yt.end - N, yt.start) : zt = yt.start : zt = Se, zt) : NaN;
              }
              function Ze() {
                E === null && (E = setInterval(function() {
                  Lt();
                }, fe.get().streaming.wallclockTimeUpdateInterval));
              }
              function nt() {
                clearInterval(E), E = null;
              }
              function it(Se) {
                var Be = A.convertRepresentationToRepresentationInfo(Se.currentRepresentation), He = Be ? Be.mediaInfo.streamInfo : null;
                He === null || b.id !== He.id || (b = He);
              }
              function De() {
                L.trigger(i.default.CAN_PLAY);
              }
              function Ye() {
                L.trigger(i.default.CAN_PLAY_THROUGH);
              }
              function Ke(Se) {
                Se.streamId === o.getActiveStreamInfo().id && (Y = Se.state === t.default.BUFFER_EMPTY, fe.get().streaming.buffer.setStallState && I.setStallState(Se.mediaType, Se.state === t.default.BUFFER_EMPTY));
              }
              function tt() {
                c.info("Native video element event: play"), Le(), Ze(), L.trigger(i.default.PLAYBACK_STARTED, {
                  startTime: X()
                });
              }
              function st() {
                c.info("Native video element event: waiting"), L.trigger(i.default.PLAYBACK_WAITING, {
                  playingTime: X()
                });
              }
              function Et() {
                c.info("Native video element event: playing"), K = !1, L.trigger(i.default.PLAYBACK_PLAYING, {
                  playingTime: X()
                });
              }
              function ht() {
                c.info("Native video element event: pause"), L.trigger(i.default.PLAYBACK_PAUSED, {
                  ended: le()
                });
              }
              function xt() {
                if (!K) {
                  var Se = X();
                  !isNaN(ie) && ie !== Se && (Se = ie), ie = NaN, c.info("Seeking to: " + Se), Ze(), L.trigger(i.default.PLAYBACK_SEEKING, {
                    seekTime: Se,
                    streamId: b.id
                  });
                }
              }
              function Xe() {
                c.info("Native video element event: seeked"), K = !1, L.trigger(i.default.PLAYBACK_SEEKED);
              }
              function ve() {
                b && L.trigger(i.default.PLAYBACK_TIME_UPDATED, {
                  timeToEnd: se(),
                  time: X(),
                  streamId: b.id
                });
              }
              function me() {
                L.trigger(i.default.PLAYBACK_PROGRESS, {
                  streamId: b.id
                });
              }
              function Ie() {
                var Se = $();
                c.info("Native video element event: ratechange: ", Se), L.trigger(i.default.PLAYBACK_RATE_CHANGED, {
                  playbackRate: Se
                });
              }
              function we() {
                c.info("Native video element event: loadedmetadata"), L.trigger(i.default.PLAYBACK_METADATA_LOADED), Ze();
              }
              function Ue() {
                c.info("Native video element event: loadeddata"), L.trigger(i.default.PLAYBACK_LOADED_DATA);
              }
              function $e() {
                c.info("Native video element event: ended"), ue(), nt();
                var Se = o ? o.getActiveStreamInfo() : null;
                Se && L.trigger(i.default.PLAYBACK_ENDED, {
                  isLast: Se.isLast
                });
              }
              function at() {
                L.trigger(i.default.PLAYBACK_VOLUME_CHANGED);
              }
              function et(Se) {
                if (E && Se.isLast) {
                  c.info("onPlaybackEnded -- PLAYBACK_ENDED but native video element didn't fire ended");
                  var Be = Se.seekTime ? Se.seekTime : ee();
                  I.setCurrentTime(Be), ue(), nt();
                }
              }
              function Mt(Se) {
                var Be = Se.target || Se.srcElement;
                L.trigger(i.default.PLAYBACK_ERROR, {
                  error: Be.error
                });
              }
              function Lt() {
                L.trigger(i.default.WALLCLOCK_TIME_UPDATED, {
                  isDynamic: w,
                  time: /* @__PURE__ */ new Date()
                }), q() && (o.addDVRMetric(), F() ? bt() : Le());
              }
              function bt() {
                var Se = Date.now();
                (!J || Se > J + T) && (J = Se, ve());
              }
              function Ae() {
                var Se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, Be = null;
                return o.getActiveStreamProcessors().forEach(function(He) {
                  if (!Se || Se.length === 0 || Se.indexOf(He.getType()) === -1) {
                    var yt = He.getBufferLevel();
                    Be === null ? Be = yt : Be = Math.min(Be, yt);
                  }
                }), Be;
              }
              function ze() {
                return Z;
              }
              function qe(Se) {
                if (Se.stream === !1 && Z && !isNaN(Se.request.duration)) {
                  var Be = 1.2 * Se.request.duration;
                  Be > N && (c.warn("Browser does not support fetch API with StreamReader. Increasing live delay to be 20% higher than segment duration:", Be.toFixed(2)), N = Be, C = Be);
                }
              }
              function _t(Se) {
                L.trigger(i.default.PLAYBACK_STALLED, {
                  e: Se
                });
              }
              function dt(Se) {
                ye(Se.mediaInfo);
              }
              function Tt(Se) {
                var Be = o.getActiveStreamInfo();
                !Se || !Be || !Se.currentRepresentation || !Se.streamId || Se.streamId !== Be.id || !Se.mediaType || Se.mediaType !== g.default.VIDEO && Se.mediaType !== g.default.AUDIO || (z = Se.currentRepresentation.availabilityTimeComplete, Z = !z, Z && !ae && (ae = !0));
              }
              function wt() {
                return ae;
              }
              function Gt() {
                ne = !0;
              }
              function Xt() {
                ne = !1;
              }
              function ye(Se) {
                Se && Se.supplementalProperties && Se.supplementalProperties[g.default.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME] === "true" && (c.debug("Low Latency critical SupplementalProperty set: Enabling low Latency"), Z = !0);
              }
              function Qe() {
                I.addEventListener("canplay", De), I.addEventListener("canplaythrough", Ye), I.addEventListener("play", tt), I.addEventListener("waiting", st), I.addEventListener("playing", Et), I.addEventListener("pause", ht), I.addEventListener("error", Mt), I.addEventListener("seeking", xt), I.addEventListener("seeked", Xe), I.addEventListener("timeupdate", ve), I.addEventListener("progress", me), I.addEventListener("ratechange", Ie), I.addEventListener("loadedmetadata", we), I.addEventListener("loadeddata", Ue), I.addEventListener("stalled", _t), I.addEventListener("ended", $e), I.addEventListener("volumechange", at);
              }
              function ct() {
                I.removeEventListener("canplay", De), I.removeEventListener("canplaythrough", Ye), I.removeEventListener("play", tt), I.removeEventListener("waiting", st), I.removeEventListener("playing", Et), I.removeEventListener("pause", ht), I.removeEventListener("error", Mt), I.removeEventListener("seeking", xt), I.removeEventListener("seeked", Xe), I.removeEventListener("timeupdate", ve), I.removeEventListener("progress", me), I.removeEventListener("ratechange", Ie), I.removeEventListener("loadedmetadata", we), I.removeEventListener("loadeddata", Ue), I.removeEventListener("stalled", _t), I.removeEventListener("ended", $e), I.removeEventListener("volumechange", at);
              }
              return v = {
                initialize: de,
                setConfig: Pe,
                getTimeToStreamEnd: se,
                getBufferLevel: Ae,
                getPlaybackStalled: ge,
                getTime: X,
                getLowLatencyModeEnabled: ze,
                getInitialCatchupModeActivated: wt,
                getIsManifestUpdateInProgress: Ee,
                getPlaybackRate: $,
                getPlayedRanges: ce,
                getEnded: le,
                getIsDynamic: q,
                getStreamController: _e,
                computeAndSetLiveDelay: Ge,
                getLiveDelay: Ce,
                getOriginalLiveDelay: xe,
                getCurrentLiveLatency: be,
                play: re,
                isPaused: F,
                isStalled: W,
                pause: ue,
                isSeeking: x,
                getStreamEndTime: ee,
                seek: te,
                seekToOriginalLive: O,
                seekToCurrentLive: p,
                reset: oe,
                updateCurrentTime: Le,
                getAvailabilityStartTime: Te
              }, Q(), v;
            }
            S.__dashjs_factory_name = "PlaybackController";
            const h = r.default.getSingletonFactory(S);
          }
        ),
        /***/
        "./src/streaming/controllers/ScheduleController.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/controllers/ScheduleController.js ***!
            \*********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../models/FragmentModel */
              "./src/streaming/models/FragmentModel.js"
            ), i = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), r = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), l = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), t = e(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), T = e(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            );
            function S(_) {
              _ = _ || {};
              var L = this.context, v = (0, i.default)(L).getInstance(), c = _.dashMetrics, o = _.mediaPlayerModel, y = _.fragmentModel, u = _.abrController, A = _.playbackController, I = _.textController, M = _.type, E = _.bufferController, N = _.settings, C, b, w, V, J, H, z, Z, ie, K, Y, ne, ae;
              function fe() {
                w = (0, d.default)(L).getInstance().getLogger(C), Ge(), b = _.streamInfo;
              }
              function Q(je) {
                z = je, v.on(r.default.BYTES_APPENDED_END_FRAGMENT, le, C), v.on(r.default.URL_RESOLUTION_FAILED, q, C), v.on(T.default.PLAYBACK_STARTED, _e, C), v.on(T.default.PLAYBACK_RATE_CHANGED, Ee, C), v.on(T.default.PLAYBACK_TIME_UPDATED, $, C);
              }
              function oe() {
                return M;
              }
              function de() {
                return b.id;
              }
              function Me(je) {
                V = je;
              }
              function ge(je) {
                if (!E.getIsBufferingCompleted()) {
                  se();
                  var Ze = isNaN(je) ? 0 : je;
                  H = setTimeout(re, Ze);
                }
              }
              function se() {
                H && (clearTimeout(H), H = null);
              }
              function ee() {
                var je = b.id, Ze = u.getMaxAllowedIndexFor(M, je);
                return isNaN(ie) || ie != Ze ? (w.info("Top quality " + M + " index has changed from " + ie + " to " + Ze), ie = Ze, !0) : !1;
              }
              function re() {
                try {
                  if (te()) {
                    se();
                    return;
                  }
                  if (O()) {
                    var je = !1;
                    ae && (je = u.checkPlaybackQuality(M, b.id)), je || ue();
                  } else
                    ge(A.getLowLatencyModeEnabled() ? N.get().streaming.scheduling.lowLatencyTimeout : N.get().streaming.scheduling.defaultTimeout);
                } catch {
                  ge(A.getLowLatencyModeEnabled() ? N.get().streaming.scheduling.lowLatencyTimeout : N.get().streaming.scheduling.defaultTimeout);
                }
              }
              function ue() {
                ne || V.quality !== K || Y ? (Y ? (w.debug("Switch track for " + M + ", representation id = " + V.id), Y = !1) : w.debug("Quality has changed, get init request for representationid = " + V.id), v.trigger(r.default.INIT_FRAGMENT_NEEDED, {
                  representationId: V.id,
                  sender: C
                }, {
                  streamId: b.id,
                  mediaType: M
                }), ae = !1, ne = !1) : (w.debug("Media segment needed for ".concat(M, " and stream id ").concat(b.id)), v.trigger(r.default.MEDIA_FRAGMENT_NEEDED, {}, {
                  streamId: b.id,
                  mediaType: M
                }), ae = !0);
              }
              function te() {
                try {
                  return M === g.default.TEXT && !I.isTextEnabled() || A.isPaused() && (!A.getStreamController().getInitialPlayback() || !A.getStreamController().getAutoPlay()) && !N.get().streaming.scheduling.scheduleWhilePaused;
                } catch {
                  return !1;
                }
              }
              function O() {
                try {
                  return V && (isNaN(K) || Y || ee() || p());
                } catch {
                  return !1;
                }
              }
              function p() {
                if (!M || !V)
                  return !0;
                var je = c.getCurrentBufferLevel(M);
                return je < P();
              }
              function P() {
                var je = NaN;
                return !M || !V || (M === g.default.TEXT ? je = k() : M === g.default.AUDIO && z ? je = X() : je = F()), je;
              }
              function k() {
                try {
                  if (I.isTextEnabled())
                    if (isNaN(V.fragmentDuration)) {
                      var je = c.getCurrentSchedulingInfo(t.default.SCHEDULING_INFO);
                      return je ? je.duration : 0;
                    } else
                      return V.fragmentDuration;
                  else
                    return 0;
                } catch {
                  return 0;
                }
              }
              function X() {
                try {
                  var je = c.getCurrentBufferLevel(g.default.VIDEO);
                  return isNaN(V.fragmentDuration) ? je + 1 : Math.max(je + 1, V.fragmentDuration);
                } catch {
                  return 0;
                }
              }
              function F() {
                try {
                  var je = V.mediaInfo.streamInfo;
                  if (u.isPlayingAtTopQuality(je)) {
                    var Ze = je.manifestInfo.duration >= N.get().streaming.buffer.longFormContentDurationThreshold;
                    return Ze ? N.get().streaming.buffer.bufferTimeAtTopQualityLongForm : N.get().streaming.buffer.bufferTimeAtTopQuality;
                  } else
                    return o.getStableBufferTime();
                } catch {
                  return o.getStableBufferTime();
                }
              }
              function x(je) {
                Y = je;
              }
              function W() {
                return Y;
              }
              function $() {
                ce(!0);
              }
              function ce(je) {
                if (A && y) {
                  var Ze = y.getRequests({
                    state: n.default.FRAGMENT_MODEL_EXECUTED,
                    time: A.getTime(),
                    threshold: 0
                  })[0];
                  Ze && A.getTime() >= Ze.startTime && ((!Z.mediaInfo || Ze.mediaInfo.type === Z.mediaInfo.type && Ze.mediaInfo.id !== Z.mediaInfo.id) && je && v.trigger(r.default.TRACK_CHANGE_RENDERED, {
                    mediaType: M,
                    oldMediaInfo: Z.mediaInfo,
                    newMediaInfo: Ze.mediaInfo,
                    streamId: b.id
                  }), (Ze.quality !== Z.quality || Ze.adaptationIndex !== Z.adaptationIndex) && je && (w.debug("Quality change rendered for streamId ".concat(b.id, " and type ").concat(M)), v.trigger(r.default.QUALITY_CHANGE_RENDERED, {
                    mediaType: M,
                    oldQuality: Z.quality,
                    newQuality: Ze.quality,
                    streamId: b.id
                  })), Z = {
                    mediaInfo: Ze.mediaInfo,
                    quality: Ze.quality,
                    adaptationIndex: Ze.adaptationIndex
                  });
                }
              }
              function le(je) {
                w.debug("Appended bytes for ".concat(je.mediaType, " and stream id ").concat(b.id)), (isNaN(je.index) || isNaN(K)) && (K = je.quality, w.info("[" + M + "] lastInitializedRepresentationInfo changed to " + je.quality)), ge(0);
              }
              function q() {
                y.abortRequests(), se();
              }
              function _e() {
                N.get().streaming.scheduling.scheduleWhilePaused || ge();
              }
              function Ee(je) {
                c.updatePlayListTraceMetrics({
                  playbackspeed: je.playbackRate.toString()
                });
              }
              function Te(je) {
                J = je;
              }
              function Ce() {
                return J;
              }
              function xe(je) {
                ae = je;
              }
              function be(je) {
                ne = je;
              }
              function Ge() {
                ae = !0, J = 0, K = NaN, Z = {
                  mediaInfo: void 0,
                  quality: NaN,
                  adaptationIndex: NaN
                }, ie = NaN, Y = !1, ne = !1;
              }
              function Pe() {
                v.off(r.default.BYTES_APPENDED_END_FRAGMENT, le, C), v.off(r.default.URL_RESOLUTION_FAILED, q, C), v.off(T.default.PLAYBACK_STARTED, _e, C), v.off(T.default.PLAYBACK_RATE_CHANGED, Ee, C), v.off(T.default.PLAYBACK_TIME_UPDATED, $, C), se(), ce(!1), Ge(), b = null;
              }
              function Le() {
                return A;
              }
              return C = {
                initialize: Q,
                getType: oe,
                getStreamId: de,
                setCurrentRepresentation: Me,
                setTimeToLoadDelay: Te,
                getTimeToLoadDelay: Ce,
                setSwitchTrack: x,
                getSwitchStrack: W,
                startScheduleTimer: ge,
                clearScheduleTimer: se,
                reset: Pe,
                getBufferTarget: P,
                getPlaybackController: Le,
                setCheckPlaybackQuality: xe,
                setInitSegmentRequired: be
              }, fe(), C;
            }
            S.__dashjs_factory_name = "ScheduleController";
            const h = l.default.getClassFactory(S);
          }
        ),
        /***/
        "./src/streaming/controllers/StreamController.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/controllers/StreamController.js ***!
            \*******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => J
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), i = e(
              /*! ../Stream */
              "./src/streaming/Stream.js"
            ), r = e(
              /*! ../ManifestUpdater */
              "./src/streaming/ManifestUpdater.js"
            ), l = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), d = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), t = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), T = e(
              /*! ../vo/metrics/PlayList */
              "./src/streaming/vo/metrics/PlayList.js"
            ), S = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), h = e(
              /*! ../utils/InitCache */
              "./src/streaming/utils/InitCache.js"
            ), _ = e(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), L = e(
              /*! ./TimeSyncController */
              "./src/streaming/controllers/TimeSyncController.js"
            ), v = e(
              /*! ./MediaSourceController */
              "./src/streaming/controllers/MediaSourceController.js"
            ), c = e(
              /*! ../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), o = e(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), y = e(
              /*! ./EventController */
              "./src/streaming/controllers/EventController.js"
            ), u = e(
              /*! ../constants/ConformanceViolationConstants */
              "./src/streaming/constants/ConformanceViolationConstants.js"
            );
            function A(H) {
              return N(H) || E(H) || M(H) || I();
            }
            function I() {
              throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function M(H, z) {
              if (H) {
                if (typeof H == "string")
                  return C(H, z);
                var Z = Object.prototype.toString.call(H).slice(8, -1);
                if (Z === "Object" && H.constructor && (Z = H.constructor.name), Z === "Map" || Z === "Set")
                  return Array.from(H);
                if (Z === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Z))
                  return C(H, z);
              }
            }
            function E(H) {
              if (typeof Symbol < "u" && Symbol.iterator in Object(H))
                return Array.from(H);
            }
            function N(H) {
              if (Array.isArray(H))
                return C(H);
            }
            function C(H, z) {
              (z == null || z > H.length) && (z = H.length);
              for (var Z = 0, ie = new Array(z); Z < z; Z++)
                ie[Z] = H[Z];
              return ie;
            }
            var b = 200, w = 2;
            function V() {
              var H = this.context, z = (0, l.default)(H).getInstance(), Z, ie, K, Y, ne, ae, fe, Q, oe, de, Me, ge, se, ee, re, ue, te, O, p, P, k, X, F, x, W, $, ce, le, q, _e, Ee, Te, Ce, xe, be, Ge, Pe, Le, je, Ze, nt, it, De, Ye, Ke, tt, st, Et;
              function ht() {
                ie = (0, S.default)(H).getInstance().getLogger(Z), Me = (0, L.default)(H).getInstance(), de = (0, v.default)(H).getInstance(), p = (0, h.default)(H).getInstance(), Qa();
              }
              function xt(Re, rt) {
                me(), ce = Re, $ = rt, k.initialize(), ne = (0, r.default)(H).create(), ne.setConfig({
                  manifestModel: fe,
                  adapter: Q,
                  manifestLoader: ae,
                  errHandler: P,
                  settings: Ye
                }), ne.initialize(), O = (0, y.default)(H).getInstance(), O.setConfig({
                  manifestUpdater: ne,
                  playbackController: Ce,
                  settings: Ye
                }), O.start(), Me.setConfig({
                  dashMetrics: oe,
                  baseURLController: se,
                  errHandler: P,
                  settings: Ye
                }), Me.initialize(), x && (z.trigger(d.default.PROTECTION_CREATED, {
                  controller: x
                }), x.setMediaElement(Te.getElement()), $ && x.setProtectionData($)), Xe();
              }
              function Xe() {
                z.on(_.default.PLAYBACK_TIME_UPDATED, yt, Z), z.on(_.default.PLAYBACK_SEEKING, qe, Z), z.on(_.default.PLAYBACK_ERROR, yn, Z), z.on(_.default.PLAYBACK_STARTED, zt, Z), z.on(_.default.PLAYBACK_PAUSED, Nt, Z), z.on(_.default.PLAYBACK_ENDED, Oe, Z), z.on(_.default.METRIC_ADDED, Ha, Z), z.on(_.default.MANIFEST_VALIDITY_CHANGED, Ga, Z), z.on(_.default.BUFFER_LEVEL_UPDATED, Se, Z), z.on(_.default.QUALITY_CHANGE_REQUESTED, Be, Z), d.default.KEY_SESSION_UPDATED && z.on(d.default.KEY_SESSION_UPDATED, at, Z), z.on(d.default.MANIFEST_UPDATED, Nr, Z), z.on(d.default.STREAM_BUFFERING_COMPLETED, Dt, Z), z.on(d.default.TIME_SYNCHRONIZATION_COMPLETED, $e, Z), z.on(d.default.CURRENT_TRACK_CHANGED, Gt, Z), z.on(d.default.SETTING_UPDATED_LIVE_DELAY, He, Z), z.on(d.default.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, He, Z);
              }
              function ve() {
                z.off(_.default.PLAYBACK_TIME_UPDATED, yt, Z), z.off(_.default.PLAYBACK_SEEKING, qe, Z), z.off(_.default.PLAYBACK_ERROR, yn, Z), z.off(_.default.PLAYBACK_STARTED, zt, Z), z.off(_.default.PLAYBACK_PAUSED, Nt, Z), z.off(_.default.PLAYBACK_ENDED, Oe, Z), z.off(_.default.METRIC_ADDED, Ha, Z), z.off(_.default.MANIFEST_VALIDITY_CHANGED, Ga, Z), z.off(_.default.BUFFER_LEVEL_UPDATED, Se, Z), z.off(_.default.QUALITY_CHANGE_REQUESTED, Be, Z), d.default.KEY_SESSION_UPDATED && z.off(d.default.KEY_SESSION_UPDATED, at, Z), z.off(d.default.MANIFEST_UPDATED, Nr, Z), z.off(d.default.STREAM_BUFFERING_COMPLETED, Dt, Z), z.off(d.default.TIME_SYNCHRONIZATION_COMPLETED, $e, Z), z.off(d.default.CURRENT_TRACK_CHANGED, Gt, Z), z.off(d.default.SETTING_UPDATED_LIVE_DELAY, He, Z), z.off(d.default.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, He, Z);
              }
              function me() {
                if (!ae || !ae.hasOwnProperty("load") || !k || !k.hasOwnProperty("initialize") || !k.hasOwnProperty("reset") || !k.hasOwnProperty("getClientTimeOffset") || !fe || !P || !oe || !Ce)
                  throw new Error(g.default.MISSING_CONFIG_ERROR);
              }
              function Ie() {
                if (!ne || !ne.hasOwnProperty("setManifest"))
                  throw new Error("initialize function has to be called previously");
              }
              function we(Re) {
                var rt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
                me(), st = rt, ae.load(Re);
              }
              function Ue(Re) {
                var rt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
                Ie(), st = rt, ne.setManifest(Re);
              }
              function $e() {
                et();
              }
              function at() {
                Ke = !0;
              }
              function et() {
                try {
                  var Re = Q.getStreamsInfo();
                  if (!F && Re.length === 0)
                    throw new Error("There are no periods in the MPD");
                  F && Re.length > 0 && oe.updateManifestUpdateInfo({
                    currentTime: Ce.getTime(),
                    buffered: Te.getBufferRange(),
                    presentationStartTime: Re[0].start,
                    clientTimeOffset: k.getClientTimeOffset()
                  }), X.length > 0 && wr(Re);
                  for (var rt = [], pt = 0, Bt = Re.length; pt < Bt; pt++) {
                    var kt = Re[pt];
                    rt.push(Mt(kt)), oe.addManifestUpdateStreamInfo(kt);
                  }
                  Promise.all(rt).then(function() {
                    return Ye.get().streaming.applyContentSteering && !F && ge.shouldQueryBeforeStart() ? ge.loadSteeringData() : Promise.resolve();
                  }).then(function() {
                    F || Lt(Re), z.trigger(d.default.STREAMS_COMPOSED), ar();
                  }).catch(function(Zt) {
                    throw Zt;
                  });
                } catch (Zt) {
                  P.error(new c.default(o.default.MANIFEST_ERROR_ID_NOSTREAMS_CODE, Zt.message + " nostreamscomposed", fe.getValue())), _e = !0, Rn();
                }
              }
              function Mt(Re) {
                var rt = fa(Re.id);
                return rt ? rt.updateData(Re) : (rt = (0, i.default)(H).create({
                  manifestModel: fe,
                  mediaPlayerModel: be,
                  dashMetrics: oe,
                  manifestUpdater: ne,
                  adapter: Q,
                  timelineConverter: k,
                  capabilities: K,
                  capabilitiesFilter: Y,
                  errHandler: P,
                  baseURLController: se,
                  segmentBaseController: ee,
                  textController: W,
                  abrController: ue,
                  playbackController: Ce,
                  eventController: O,
                  mediaController: te,
                  protectionController: x,
                  videoModel: Te,
                  streamInfo: Re,
                  settings: Ye
                }), X.push(rt), rt.initialize(), Promise.resolve());
              }
              function Lt(Re) {
                ct();
                var rt = oe.getCurrentDVRInfo().range;
                if (rt.end < rt.start) {
                  tt && clearTimeout(tt);
                  var pt = Math.min(((rt.end - rt.start) * -1 + w) * 1e3, 2147483647);
                  ie.debug("Waiting for ".concat(pt, " ms before playback can start")), z.trigger(d.default.AST_IN_FUTURE, {
                    delay: pt
                  }), tt = setTimeout(function() {
                    Lt(Re);
                  }, pt);
                  return;
                }
                Ye.get().streaming.applyProducerReferenceTime && xe.calculateProducerReferenceTimeOffsets(Re);
                var Bt = Re[0].manifestInfo;
                if (Ye.get().streaming.applyServiceDescription && xe.applyServiceDescription(Bt), Q.getIsDynamic()) {
                  var kt = Vr(Re, Bt);
                  Ce.computeAndSetLiveDelay(kt, Bt);
                }
                var Zt = Kt(), Jt = Qe(Zt), Ir = Jt !== null ? Jt : X[0];
                z.trigger(d.default.INITIAL_STREAM_SWITCH, {
                  startTime: Zt
                }), bt(Ir, null, Zt), Qt();
              }
              function bt(Re, rt, pt) {
                try {
                  if (le || !Re || rt === Re && Re.getIsActive())
                    return;
                  le = !0, z.trigger(d.default.PERIOD_SWITCH_STARTED, {
                    fromStreamInfo: rt ? rt.getStreamInfo() : null,
                    toStreamInfo: Re.getStreamInfo()
                  });
                  var Bt = !1;
                  F = Re, rt && (Bt = Xt(Re, rt), rt.deactivate(Bt)), pt = isNaN(pt) ? !Bt && rt ? Re.getStreamInfo().start : NaN : pt, ie.info("Switch to stream ".concat(Re.getId(), ". Seektime is ").concat(pt, ", current playback time is ").concat(Ce.getTime(), ". Seamless period switch is set to ").concat(Bt)), it = it.filter(function(kt) {
                    return kt.getId() !== F.getId();
                  }), Ce.initialize(Gr(), !!rt), Te.getElement() ? Ae(pt, Bt, !1) : ze(pt, Bt);
                } catch {
                  le = !1;
                }
              }
              function Ae(Re, rt) {
                var pt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Bt;
                function kt() {
                  if (!(!Ee || Ee.readyState !== "open")) {
                    ie.debug("MediaSource is open!"), window.URL.revokeObjectURL(Bt), Ee.removeEventListener("sourceopen", kt), Ee.removeEventListener("webkitsourceopen", kt), Ve();
                    var Jt = oe.getCurrentDVRInfo();
                    de.setSeekable(Jt.range.start, Jt.range.end), pt ? F.setMediaSource(Ee).then(function() {
                      F.initializeForTextWithMediaSource(Ee);
                    }) : ze(Re, rt);
                  }
                }
                function Zt() {
                  Ee.addEventListener("sourceopen", kt, !1), Ee.addEventListener("webkitsourceopen", kt, !1), Bt = de.attachMediaSource(Te), ie.debug("MediaSource attached to element.  Waiting on open...");
                }
                Ee ? rt ? ze(Re, rt) : (de.detachMediaSource(Te), Zt()) : (Ee = de.createMediaSource(), Zt());
              }
              function ze(Re, rt) {
                F.activate(Ee, rt ? nt : void 0, Re).then(function(pt) {
                  if (pt) {
                    var Bt = Object.keys(pt);
                    Bt.length > 0 && pt[Bt[0]].getBuffer().changeType && (De = !0), nt = pt;
                  }
                  isNaN(Re) || (z.trigger(d.default.SEEK_TARGET, {
                    time: Re
                  }, {
                    streamId: F.getId()
                  }), Ce.seek(Re, !1, !0), F.startScheduleControllers()), le = !1, z.trigger(d.default.PERIOD_SWITCH_COMPLETED, {
                    toStreamInfo: Gr()
                  });
                });
              }
              function qe(Re) {
                var rt = Re.seekTime, pt = Qe(rt);
                !pt || pt === F ? (_t(), Tt(Re)) : pt && pt !== F && (_t(pt), wt(Re, pt)), _n(T.PlayList.SEEK_START_REASON);
              }
              function _t() {
                var Re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                dt();
              }
              function dt() {
                it && it.length > 0 && (it.forEach(function(Re) {
                  Re.deactivate(!0);
                }), it = []);
              }
              function Tt(Re) {
                var rt = F.getProcessors();
                rt.forEach(function(pt) {
                  return pt.prepareInnerPeriodPlaybackSeeking(Re);
                }), Ur(T.PlayListTrace.USER_REQUEST_STOP_REASON);
              }
              function wt(Re, rt) {
                var pt = Re && !isNaN(Re.seekTime) ? Re.seekTime : NaN, Bt = F.getProcessors(), kt = Bt.map(function(Zt) {
                  return Zt.prepareOuterPeriodPlaybackSeeking(Re);
                });
                Promise.all(kt).then(function() {
                  bt(rt, F, pt);
                }).catch(function(Zt) {
                  P.error(Zt);
                });
              }
              function Gt(Re) {
                Re.newMediaInfo.streamInfo.id === F.getId() && (dt(), F.prepareTrackChange(Re));
              }
              function Xt(Re, rt) {
                try {
                  return Ye.get().streaming.buffer.reuseExistingSourceBuffers && (rt.isProtectionCompatible(Re) || Ke) && (De || rt.isMediaCodecCompatible(Re, rt));
                } catch {
                  return !1;
                }
              }
              function ye(Re) {
                var rt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (Ee && !Re.getPreloaded()) {
                  var pt = Xt(Re, rt);
                  pt && Re.startPreloading(Ee, nt).then(function() {
                    it.push(Re);
                  });
                }
              }
              function Qe(Re) {
                if (isNaN(Re))
                  return null;
                for (var rt = X.length, pt = 0; pt < rt; pt++) {
                  var Bt = X[pt], kt = parseFloat((Bt.getStartTime() + Bt.getDuration()).toFixed(5));
                  if (Re < kt)
                    return Bt;
                }
                return null;
              }
              function ct() {
                try {
                  var Re = Q.getIsDynamic(), rt = Q.getStreamsInfo(), pt = rt[0].manifestInfo, Bt = Ce.getTime(), kt = k.calcTimeShiftBufferWindow(X, Re), Zt = It();
                  if (typeof kt.start > "u" || typeof kt.end > "u")
                    return;
                  !Zt || Zt.length === 0 ? oe.addDVRInfo(g.default.VIDEO, Bt, pt, kt) : Zt.forEach(function(Jt) {
                    oe.addDVRInfo(Jt.getType(), Bt, pt, kt);
                  });
                } catch {
                }
              }
              function Se(Re) {
                if (Le && ce) {
                  var rt = be.getInitialBufferLevel(), pt = [g.default.TEXT];
                  (isNaN(rt) || rt <= Ce.getBufferLevel(pt) || Q.getIsDynamic() && rt > Ce.getLiveDelay()) && (Le = !1, _n(T.PlayList.INITIAL_PLAYOUT_START_REASON), Ce.play());
                }
                Re && Re.mediaType && oe.addBufferLevel(Re.mediaType, /* @__PURE__ */ new Date(), Re.bufferLevel * 1e3);
              }
              function Be(Re) {
                Re.streamInfo.id === F.getId() && Re.reason && Re.reason.forceReplace && dt();
                var rt = fa(Re.streamInfo.id);
                rt.prepareQualityChange(Re);
              }
              function He() {
                if (Q.getIsDynamic() && Ce.getOriginalLiveDelay() !== 0 && F) {
                  var Re = Q.getStreamsInfo();
                  if (Re.length > 0) {
                    var rt = Re[0].manifestInfo, pt = Vr(Re, rt);
                    Ce.computeAndSetLiveDelay(pt, rt);
                  }
                }
              }
              function yt() {
                if (hn()) {
                  var Re = Te.getPlaybackQuality();
                  Re && oe.addDroppedFrames(Re);
                }
              }
              function zt() {
                ie.debug("[onPlaybackStarted]"), !Le && Pe && _n(T.PlayList.RESUME_FROM_PAUSE_START_REASON), Le && (Le = !1), je && (je = !1, Ye.get().streaming.applyContentSteering && !ge.shouldQueryBeforeStart() && ge.loadSteeringData()), Pe = !1;
              }
              function Nt(Re) {
                ie.debug("[onPlaybackPaused]"), Re.ended || (Pe = !0, Ur(T.PlayListTrace.USER_REQUEST_STOP_REASON));
              }
              function Dt(Re) {
                ie.debug("Stream with id ".concat(Re.streamInfo.id, " finished buffering"));
                var rt = Re.streamInfo.isLast;
                Ee && rt ? (ie.info("[onStreamBufferingCompleted] calls signalEndOfStream of mediaSourceController."), de.signalEndOfStream(Ee)) : ar();
              }
              function ar() {
                if (!(!F || !F.getHasFinishedBuffering()))
                  for (var Re = pe(F), rt = 0; rt < Re.length; ) {
                    var pt = Re[rt], Bt = rt === 0 ? F : Re[rt - 1];
                    !pt.getPreloaded() && Bt.getHasFinishedBuffering() && Ee && ye(pt, Bt), rt += 1;
                  }
              }
              function Qt() {
                Ze || (Ze = setInterval(function() {
                  !le && Ce.getTimeToStreamEnd() <= 0 && !Ce.isSeeking() && z.trigger(d.default.PLAYBACK_ENDED, {
                    isLast: Gr().isLast
                  });
                }, b));
              }
              function Je() {
                Ze && (clearInterval(Ze), Ze = null);
              }
              function At(Re, rt) {
                for (var pt = null, Bt = 0, kt = 0, Zt = null, Jt = 0; Jt < X.length; Jt++) {
                  if (pt = X[Jt], kt = pt.getStartTime(), Zt = pt.getDuration(), Number.isFinite(kt) && (Bt = kt), pt.getId() === rt)
                    return Re - Bt;
                  Number.isFinite(Zt) && (Bt += Zt);
                }
                return null;
              }
              function It() {
                return F ? F.getProcessors() : [];
              }
              function Oe(Re) {
                if (F && !F.getIsEndedEventSignaled()) {
                  F.setIsEndedEventSignaled(!0);
                  var rt = ke();
                  rt ? (ie.debug("StreamController onEnded, found next stream with id ".concat(rt.getStreamInfo().id, ". Switching from ").concat(F.getStreamInfo().id, " to ").concat(rt.getStreamInfo().id)), bt(rt, F, NaN)) : (ie.debug("StreamController no next stream found"), F.setIsEndedEventSignaled(!1)), Ur(rt ? T.PlayListTrace.END_OF_PERIOD_STOP_REASON : T.PlayListTrace.END_OF_CONTENT_STOP_REASON);
                }
                Re && Re.isLast && (Je(), ge.stopSteeringRequestTimer());
              }
              function ke() {
                var Re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, rt = Re || F || null;
                if (!rt)
                  return null;
                for (var pt = rt.getStreamInfo(), Bt = pt.start, kt = 0, Zt = -1, Jt = NaN; kt < X.length; ) {
                  var Ir = X[kt], dr = Ir.getStreamInfo(), Fr = dr.start - Bt;
                  Fr > 0 && (isNaN(Jt) || Fr < Jt) && pt.id !== dr.id && (Jt = Fr, Zt = kt), kt += 1;
                }
                return Zt >= 0 ? X[Zt] : null;
              }
              function pe() {
                var Re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                try {
                  var rt = Re || F || null;
                  if (rt) {
                    var pt = rt.getStreamInfo();
                    return X.filter(function(Bt) {
                      var kt = Bt.getStreamInfo();
                      return kt.start > pt.start && pt.id !== kt.id;
                    });
                  }
                } catch {
                  return [];
                }
              }
              function Ve(Re) {
                var rt = Re || Gr().manifestInfo.duration;
                de.setDuration(rt);
              }
              function ut() {
                return F;
              }
              function St() {
                return Le;
              }
              function jt() {
                return ce;
              }
              function Kt() {
                var Re, rt = Q.getIsDynamic();
                if (rt) {
                  var pt = oe.getCurrentDVRInfo(), Bt = pt && pt.range ? pt.range.end : 0;
                  Re = Bt - Ce.getOriginalLiveDelay();
                  var kt = pt ? pt.range : null;
                  if (kt) {
                    if (!isNaN(st) || st.toString().indexOf("posix:") !== -1) {
                      ie.info("Start time provided by the app: ".concat(st));
                      var Zt = Yt(!0, st);
                      isNaN(Zt) || (Re = Math.min(Re, Zt));
                    } else {
                      var Jt = $t(!0);
                      isNaN(Jt) || (ie.info("Start time from URI parameters: ".concat(Jt)), Re = Math.min(Re, Jt));
                    }
                    var Ir = Ye.get().streaming.timeShiftBuffer.calcFromSegmentTimeline ? 0.1 : 0;
                    Re = Math.max(Re, kt.start + Ir);
                  }
                } else {
                  var dr = vn(), Fr = dr[0].getStreamInfo();
                  if (Re = Fr.start, isNaN(st)) {
                    var pn = $t(!1);
                    isNaN(pn) || (ie.info("Start time from URI parameters: ".concat(pn)), Re = Math.max(Re, pn));
                  } else {
                    ie.info("Start time provided by the app: ".concat(st));
                    var Tr = Yt(!1, st);
                    isNaN(Tr) || (Re = Math.max(Re, Tr));
                  }
                }
                return Re;
              }
              function $t(Re) {
                var rt = re.getURIFragmentData();
                if (!rt || !rt.t)
                  return NaN;
                var pt = vn()[0], Bt = pt.getStreamInfo().start;
                return rt.t = rt.t.split(",")[0], gr(Re, rt.t, Bt);
              }
              function Yt(Re, rt) {
                var pt = 0;
                if (!Re) {
                  var Bt = vn()[0];
                  pt = Bt.getStreamInfo().start;
                }
                return gr(Re, rt, pt);
              }
              function gr(Re, rt, pt) {
                var Bt = Q.getRegularPeriods()[0], kt = rt.toString(), Zt = kt.indexOf("posix:") !== -1 ? kt.substring(6) === "now" ? Date.now() / 1e3 : parseFloat(kt.substring(6)) : NaN, Jt = Re && !isNaN(Zt) ? k.calcPresentationTimeFromWallTime(new Date(Zt * 1e3), Bt) : parseFloat(kt) + pt;
                return Jt;
              }
              function wr(Re) {
                if (Re.length === 0) {
                  ie.warn("No periods included in the current manifest. Skipping the filtering of outdated stream objects.");
                  return;
                }
                X = X.filter(function(rt) {
                  var pt = Re.filter(function(kt) {
                    return kt.id === rt.getId();
                  }).length > 0, Bt = pt || rt.getId() === F.getId();
                  return Bt || (ie.debug("Removing stream ".concat(rt.getId())), rt.reset(!0)), Bt;
                });
              }
              function Vr(Re, rt) {
                try {
                  var pt = NaN;
                  if (rt && !isNaN(rt.maxFragmentDuration) && isFinite(rt.maxFragmentDuration))
                    return rt.maxFragmentDuration;
                  if (Re && Re.length === 1) {
                    var Bt = Re[0], kt = [g.default.VIDEO, g.default.AUDIO, g.default.TEXT], Zt = kt.reduce(function(Jt, Ir) {
                      var dr = Q.getMediaInfoForType(Bt, Ir);
                      return dr && dr.isFragmented !== !1 && Jt.push(dr), Jt;
                    }, []).reduce(function(Jt, Ir) {
                      var dr = Q.getVoRepresentations(Ir);
                      return dr && dr.length > 0 && dr.forEach(function(Fr) {
                        Fr && Jt.push(Fr);
                      }), Jt;
                    }, []).reduce(function(Jt, Ir) {
                      var dr = Q.convertRepresentationToRepresentationInfo(Ir);
                      return dr && dr.fragmentDuration && !isNaN(dr.fragmentDuration) && Jt.push(dr.fragmentDuration), Jt;
                    }, []);
                    pt = Math.max.apply(Math, A(Zt));
                  }
                  return isFinite(pt) ? pt : NaN;
                } catch {
                  return NaN;
                }
              }
              function Nr(Re) {
                if (Re.error)
                  _e = !0, Rn();
                else {
                  ie.info("Manifest updated... updating data system wide.");
                  var rt = Re.manifest;
                  Q.updatePeriods(rt);
                  var pt = Q.getUTCTimingSources();
                  Q.getIsDynamic() && (!pt || pt.length === 0) && z.trigger(_.default.CONFORMANCE_VIOLATION, {
                    level: u.default.LEVELS.WARNING,
                    event: u.default.EVENTS.NO_UTC_TIMING_ELEMENT
                  });
                  var Bt = Q.getIsDynamic() ? pt.concat(Ge.getUTCTimingSources()) : pt;
                  Y.filterUnsupportedFeatures(rt).then(function() {
                    se.initialize(rt), Me.attemptSync(Bt, Q.getIsDynamic());
                  });
                }
              }
              function hn() {
                return F ? F.getHasVideoTrack() : !1;
              }
              function Pn() {
                return F ? F.getHasAudioTrack() : !1;
              }
              function ca(Re) {
                F && (Ce.initialize(Gr()), Ae(Re, !1, !0));
              }
              function Ur(Re, rt) {
                rt = rt || /* @__PURE__ */ new Date(), It().forEach(function(pt) {
                  pt.finalisePlayList(rt, Re);
                }), oe.addPlayList();
              }
              function _n(Re) {
                oe.createPlaylistMetrics(Ce.getTime() * 1e3, Re);
              }
              function yn(Re) {
                if (Re.error) {
                  var rt = "";
                  switch (Re.error.code) {
                    case 1:
                      rt = "MEDIA_ERR_ABORTED";
                      break;
                    case 2:
                      rt = "MEDIA_ERR_NETWORK";
                      break;
                    case 3:
                      rt = "MEDIA_ERR_DECODE", Et.counts.mediaErrorDecode += 1;
                      break;
                    case 4:
                      rt = "MEDIA_ERR_SRC_NOT_SUPPORTED";
                      break;
                    case 5:
                      rt = "MEDIA_ERR_ENCRYPTED";
                      break;
                    default:
                      rt = "UNKNOWN";
                      break;
                  }
                  if (rt === "MEDIA_ERR_DECODE" && Ye.get().errors.recoverAttempts.mediaErrorDecode >= Et.counts.mediaErrorDecode) {
                    Va();
                    return;
                  }
                  q = !0, Re.error.message && (rt += " (" + Re.error.message + ")"), Re.error.msExtendedCode && (rt += " (0x" + (Re.error.msExtendedCode >>> 0).toString(16).toUpperCase() + ")"), ie.fatal("Video Element Error: " + rt), Re.error && ie.fatal(Re.error), P.error(new c.default(Re.error.code, rt)), Rn();
                }
              }
              function Va() {
                ie.warn("A MEDIA_ERR_DECODE occured: Resetting the MediaSource");
                var Re = Ce.getTime();
                F.deactivate(!1), ie.warn("MediaSource has been resetted. Resuming playback from time ".concat(Re)), Ae(Re, !1, !1);
              }
              function Gr() {
                return F ? F.getStreamInfo() : null;
              }
              function ji() {
                return le;
              }
              function Oi() {
                return q || _e;
              }
              function fa(Re) {
                for (var rt = 0, pt = X.length; rt < pt; rt++)
                  if (X[rt].getId() === Re)
                    return X[rt];
                return null;
              }
              function Ga(Re) {
                isNaN(Re.newDuration) || Ve(Re.newDuration);
              }
              function Pi(Re) {
                Re && (Re.capabilities && (K = Re.capabilities), Re.capabilitiesFilter && (Y = Re.capabilitiesFilter), Re.manifestLoader && (ae = Re.manifestLoader), Re.manifestModel && (fe = Re.manifestModel), Re.mediaPlayerModel && (be = Re.mediaPlayerModel), Re.customParametersModel && (Ge = Re.customParametersModel), Re.protectionController && (x = Re.protectionController), Re.adapter && (Q = Re.adapter), Re.dashMetrics && (oe = Re.dashMetrics), Re.errHandler && (P = Re.errHandler), Re.timelineConverter && (k = Re.timelineConverter), Re.videoModel && (Te = Re.videoModel), Re.playbackController && (Ce = Re.playbackController), Re.serviceDescriptionController && (xe = Re.serviceDescriptionController), Re.contentSteeringController && (ge = Re.contentSteeringController), Re.textController && (W = Re.textController), Re.abrController && (ue = Re.abrController), Re.mediaController && (te = Re.mediaController), Re.settings && (Ye = Re.settings), Re.baseURLController && (se = Re.baseURLController), Re.uriFragmentModel && (re = Re.uriFragmentModel), Re.segmentBaseController && (ee = Re.segmentBaseController));
              }
              function Ri(Re) {
                $ = Re, x && x.setProtectionData($);
              }
              function Qa() {
                X = [], st = NaN, x = null, le = !1, F = null, q = !1, _e = !1, Le = !0, je = !0, Pe = !1, ce = !0, Ze = null, Ke = !1, De = !1, it = [], tt = null, Et = {
                  counts: {
                    mediaErrorDecode: 0
                  }
                };
              }
              function Rn() {
                me(), Me.reset(), Ur(q || _e ? T.PlayListTrace.FAILURE_STOP_REASON : T.PlayListTrace.USER_REQUEST_STOP_REASON);
                for (var Re = 0, rt = X ? X.length : 0; Re < rt; Re++) {
                  var pt = X[Re];
                  pt.reset(q);
                }
                ve(), se.reset(), ne.reset(), O.reset(), oe.clearAllCurrentMetrics(), fe.setValue(null), ae.reset(), k.reset(), p.reset(), Ee && (de.detachMediaSource(Te), Ee = null), Te = null, x && (x = null, $ = null, fe.getValue() && z.trigger(d.default.PROTECTION_DESTROYED, {
                  data: fe.getValue().url
                })), Je(), z.trigger(d.default.STREAM_TEARDOWN_COMPLETE), Qa();
              }
              function Ha(Re) {
                if (Re.metric === n.default.DVR_INFO) {
                  var rt = Pn() ? g.default.AUDIO : g.default.VIDEO;
                  Re.mediaType === rt && de.setSeekable(Re.value.range.start, Re.value.range.end);
                }
              }
              function vn() {
                return X;
              }
              return Z = {
                initialize: xt,
                getActiveStreamInfo: Gr,
                addDVRMetric: ct,
                hasVideoTrack: hn,
                hasAudioTrack: Pn,
                getStreamById: fa,
                getStreamForTime: Qe,
                getTimeRelativeToStreamId: At,
                load: we,
                loadWithManifest: Ue,
                getActiveStreamProcessors: It,
                setConfig: Pi,
                setProtectionData: Ri,
                getIsStreamSwitchInProgress: ji,
                switchToVideoElement: ca,
                getHasMediaOrInitialisationError: Oi,
                getStreams: vn,
                getActiveStream: ut,
                getInitialPlayback: St,
                getAutoPlay: jt,
                reset: Rn
              }, ht(), Z;
            }
            V.__dashjs_factory_name = "StreamController";
            const J = t.default.getSingletonFactory(V);
          }
        ),
        /***/
        "./src/streaming/controllers/TimeSyncController.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/controllers/TimeSyncController.js ***!
            \*********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => I
              /* harmony export */
            });
            var g = e(
              /*! ./../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), n = e(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), i = e(
              /*! ./../../core/EventBus */
              "./src/core/EventBus.js"
            ), r = e(
              /*! ./../../core/events/Events */
              "./src/core/events/Events.js"
            ), l = e(
              /*! ./../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), d = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), t = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), T = e(
              /*! ../utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), S = 5e3, h = 100, _ = 2, L = 2, v = 30, c = 30, o = 600, y = 2;
            function u() {
              var M = this.context, E = (0, i.default)(M).getInstance(), N = (0, T.default)(M).getInstance(), C, b, w, V, J, H, z, Z, ie, K, Y, ne, ae, fe, Q, oe;
              function de() {
                b = (0, t.default)(M).getInstance().getLogger(C), E.on(r.default.ATTEMPT_BACKGROUND_SYNC, re, C);
              }
              function Me(be) {
                be && (be.dashMetrics && (z = be.dashMetrics), be.baseURLController && (oe = be.baseURLController), be.errHandler && (Q = be.errHandler), be.settings && (J = be.settings));
              }
              function ge() {
                Z = [], ie = [], K = null, Y = null, ae = null, ne = NaN, w = !1, V = !1, fe = J.get().streaming.utcSynchronization.timeBetweenSyncAttempts;
              }
              function se() {
                ge(), H = {
                  "urn:mpeg:dash:utc:http-head:2014": le,
                  "urn:mpeg:dash:utc:http-xsdate:2014": ce.bind(null, X),
                  "urn:mpeg:dash:utc:http-iso:2014": ce.bind(null, F),
                  "urn:mpeg:dash:utc:direct:2014": $,
                  // some specs referencing early ISO23009-1 drafts incorrectly use
                  // 2012 in the URI, rather than 2014. support these for now.
                  "urn:mpeg:dash:utc:http-head:2012": le,
                  "urn:mpeg:dash:utc:http-xsdate:2012": ce.bind(null, X),
                  "urn:mpeg:dash:utc:http-iso:2012": ce.bind(null, F),
                  "urn:mpeg:dash:utc:direct:2012": $,
                  // it isn't clear how the data returned would be formatted, and
                  // no public examples available so http-ntp not supported for now.
                  // presumably you would do an arraybuffer type xhr and decode the
                  // binary data returned but I would want to see a sample first.
                  "urn:mpeg:dash:utc:http-ntp:2014": W,
                  // not clear how this would be supported in javascript (in browser)
                  "urn:mpeg:dash:utc:ntp:2014": W,
                  "urn:mpeg:dash:utc:sntp:2014": W
                };
              }
              function ee(be, Ge) {
                if (ie = be, !w) {
                  if (!p(Ge)) {
                    E.trigger(r.default.TIME_SYNCHRONIZATION_COMPLETED);
                    return;
                  }
                  w = !0, te();
                }
              }
              function re() {
                if (!(!J.get().streaming.utcSynchronization.enabled || w || V || !ae || !ae.value || !ae.schemeIdUri || isNaN(ne) || isNaN(J.get().streaming.utcSynchronization.backgroundAttempts)) && !(Y && (Date.now() - Y) / 1e3 < c)) {
                  Z = [], V = !0;
                  var be = isNaN(J.get().streaming.utcSynchronization.backgroundAttempts) ? L : J.get().streaming.utcSynchronization.backgroundAttempts;
                  ue(be);
                }
              }
              function ue(be) {
                try {
                  if (be <= 0) {
                    Te();
                    return;
                  }
                  var Ge = Date.now();
                  H[ae.schemeIdUri](ae.value, function(Pe) {
                    var Le = Date.now(), je = O(Ge, Le, Pe);
                    Z.push(je), ue(be - 1);
                  }, function() {
                    Te();
                  });
                } catch {
                  Te();
                }
              }
              function te() {
                var be = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, Ge = be || 0;
                if (!ie || ie.length === 0 || Ge >= ie.length) {
                  P();
                  return;
                }
                var Pe = ie[Ge];
                if (Pe)
                  if (H.hasOwnProperty(Pe.schemeIdUri)) {
                    var Le = (/* @__PURE__ */ new Date()).getTime();
                    H[Pe.schemeIdUri](Pe.value, function(je) {
                      var Ze = (/* @__PURE__ */ new Date()).getTime(), nt = O(Le, Ze, je);
                      ae = Pe, P(nt);
                    }, function() {
                      te(Ge + 1);
                    });
                  } else
                    te(Ge + 1);
                else
                  P();
              }
              function O(be, Ge, Pe) {
                var Le = Ge - (Ge - be) / 2;
                return Pe - Le;
              }
              function p(be) {
                try {
                  if (!be || !J.get().streaming.utcSynchronization.enabled)
                    return !1;
                  var Ge = isNaN(fe) ? v : fe;
                  return !K || !Ge || isNaN(Ge) ? !0 : (Date.now() - K) / 1e3 >= Ge;
                } catch {
                  return !0;
                }
              }
              function P() {
                var be = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NaN, Ge = isNaN(be);
                Ge && J.get().streaming.utcSynchronization.useManifestDateHeaderTimeSource ? q() : _e(Ge, be);
              }
              function k(be) {
                var Ge = 60, Pe = 60, Le = 1e3, je = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+\-])([0-9]{2})([0-9]{2}))?/, Ze, nt, it = je.exec(be);
                return Ze = Date.UTC(
                  parseInt(it[1], 10),
                  parseInt(it[2], 10) - 1,
                  // months start from zero
                  parseInt(it[3], 10),
                  parseInt(it[4], 10),
                  parseInt(it[5], 10),
                  it[6] && (parseInt(it[6], 10) || 0),
                  it[7] && parseFloat(it[7]) * Le || 0
                ), it[9] && it[10] && (nt = parseInt(it[9], 10) * Pe + parseInt(it[10], 10), Ze += (it[8] === "+" ? -1 : 1) * nt * Ge * Le), new Date(Ze).getTime();
              }
              function X(be) {
                var Ge = Date.parse(be);
                return isNaN(Ge) && (Ge = k(be)), Ge;
              }
              function F(be) {
                return Date.parse(be);
              }
              function x(be) {
                return Date.parse(be);
              }
              function W(be, Ge, Pe) {
                Pe();
              }
              function $(be, Ge, Pe) {
                var Le = X(be);
                if (!isNaN(Le)) {
                  Ge(Le);
                  return;
                }
                Pe();
              }
              function ce(be, Ge, Pe, Le, je) {
                var Ze, nt, it = !1, De = new XMLHttpRequest(), Ye = je ? n.HTTPRequest.HEAD : n.HTTPRequest.GET, Ke = Ge.match(/\S+/g);
                if (Ge = Ke.shift(), Ze = function() {
                  it || (it = !0, Ke.length ? ce(be, Ke.join(" "), Pe, Le, je) : Le());
                }, nt = function() {
                  var Et, ht;
                  De.status === 200 && (Et = je ? De.getResponseHeader("Date") : De.response, ht = be(Et), isNaN(ht) || (Pe(ht), it = !0));
                }, N.isRelative(Ge)) {
                  var tt = oe.resolve();
                  tt && (Ge = N.resolve(Ge, tt.url));
                }
                De.open(Ye, Ge), De.timeout = S, De.onload = nt, De.onloadend = Ze, De.send();
              }
              function le(be, Ge, Pe) {
                ce(x, be, Ge, Pe, !0);
              }
              function q() {
                var be = z.getLatestMPDRequestHeaderValueByID("Date"), Ge = be !== null ? new Date(be).getTime() : Number.NaN;
                if (isNaN(Ge))
                  _e(!0);
                else {
                  var Pe = Ge - Date.now();
                  _e(!1, Pe);
                }
              }
              function _e(be, Ge) {
                if (!isNaN(ne) && !isNaN(Ge) && !be && Ee(Ge), !be && !isNaN(Ge)) {
                  K = Date.now(), w = !1;
                  var Pe = isNaN(ne);
                  ne = Ge, Pe && re(), b.debug("Completed UTC sync. Setting client - server offset to ".concat(Ge));
                }
                be && (ae = null, w = !1, Q.error(new g.default(l.default.TIME_SYNC_FAILED_ERROR_CODE, l.default.TIME_SYNC_FAILED_ERROR_MESSAGE))), E.trigger(r.default.UPDATE_TIME_SYNC_OFFSET, {
                  offset: Ge
                }), E.trigger(r.default.TIME_SYNCHRONIZATION_COMPLETED);
              }
              function Ee(be) {
                try {
                  var Ge = Ce(be), Pe = isNaN(fe) ? v : fe, Le = isNaN(J.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor) ? _ : J.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor, je = isNaN(J.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts) ? o : J.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts, Ze = isNaN(J.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts) ? y : J.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts, nt;
                  Ge ? (nt = Math.min(Pe * Le, je), b.debug("Increasing timeBetweenSyncAttempts to ".concat(nt))) : (nt = Math.max(Pe / Le, Ze), b.debug("Decreasing timeBetweenSyncAttempts to ".concat(nt))), fe = nt;
                } catch {
                }
              }
              function Te() {
                if (!(!Z || Z.length === 0)) {
                  var be = Z.reduce(function(Ge, Pe) {
                    return Ge + Pe;
                  }, 0) / Z.length;
                  Ce(be) ? b.debug("Completed background UTC sync. Offset is within allowed threshold and is not adjusted.") : (b.debug("Completed background UTC sync. Setting client - server offset to ".concat(be)), ne = be, E.trigger(r.default.UPDATE_TIME_SYNC_OFFSET, {
                    offset: ne
                  })), V = !1, Y = Date.now();
                }
              }
              function Ce(be) {
                try {
                  if (isNaN(ne))
                    return !0;
                  var Ge = J.get().streaming.utcSynchronization.maximumAllowedDrift && !isNaN(J.get().streaming.utcSynchronization.maximumAllowedDrift) ? J.get().streaming.utcSynchronization.maximumAllowedDrift : h, Pe = ne - Ge, Le = ne + Ge;
                  return be >= Pe && be <= Le;
                } catch {
                  return !0;
                }
              }
              function xe() {
                ge(), E.off(r.default.ATTEMPT_BACKGROUND_SYNC, re, C);
              }
              return C = {
                initialize: se,
                attemptSync: ee,
                setConfig: Me,
                reset: xe
              }, de(), C;
            }
            u.__dashjs_factory_name = "TimeSyncController";
            var A = d.default.getSingletonFactory(u);
            A.HTTP_TIMEOUT_MS = S, d.default.updateSingletonFactory(u.__dashjs_factory_name, A);
            const I = A;
          }
        ),
        /***/
        "./src/streaming/controllers/XlinkController.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/controllers/XlinkController.js ***!
            \******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var g = e(
              /*! ../XlinkLoader */
              "./src/streaming/XlinkLoader.js"
            ), n = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), i = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), r = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), l = e(
              /*! ../../../externals/xml2json */
              "./externals/xml2json.js"
            ), d = e(
              /*! ../utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), t = e(
              /*! ../../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), T = "onLoad", S = "onActuate", h = "urn:mpeg:dash:resolve-to-zero:2013";
            function _(v) {
              v = v || {};
              var c = this.context, o = (0, n.default)(c).getInstance(), y = (0, d.default)(c).getInstance(), u, A, I, M, E, N;
              function C() {
                o.on(i.default.XLINK_ELEMENT_LOADED, z, u), N = (0, g.default)(c).create({
                  errHandler: v.errHandler,
                  dashMetrics: v.dashMetrics,
                  mediaPlayerModel: v.mediaPlayerModel,
                  requestModifier: v.requestModifier,
                  settings: v.settings
                });
              }
              function b(fe) {
                fe && (A = fe);
              }
              function w(fe) {
                fe && (I = fe);
              }
              function V(fe) {
                var Q;
                E = new l.default({
                  escapeMode: !1,
                  attributePrefix: "",
                  arrayAccessForm: "property",
                  emptyNodeForm: "object",
                  stripWhitespaces: !1,
                  enableToStringFunc: !1,
                  ignoreRoot: !0,
                  matchers: A
                }), M = fe, M.Period_asArray ? (Q = ie(M.Period_asArray, M, t.default.PERIOD, T), H(Q, t.default.PERIOD, T)) : o.trigger(i.default.XLINK_READY, {
                  manifest: M
                });
              }
              function J() {
                o.off(i.default.XLINK_ELEMENT_LOADED, z, u), N && (N.reset(), N = null);
              }
              function H(fe, Q, oe) {
                var de = {}, Me, ge;
                de.elements = fe, de.type = Q, de.resolveType = oe, de.elements.length === 0 && Z(de);
                for (var se = 0; se < de.elements.length; se++)
                  Me = de.elements[se], y.isHTTPURL(Me.url) ? ge = Me.url : ge = Me.originalContent.BaseURL + Me.url, N.load(ge, Me, de);
              }
              function z(fe) {
                var Q, oe, de = "<response>", Me = "</response>", ge = "";
                if (Q = fe.element, oe = fe.resolveObject, Q.resolvedContent) {
                  var se = 0;
                  Q.resolvedContent.indexOf("<?xml") === 0 && (se = Q.resolvedContent.indexOf("?>") + 2), ge = Q.resolvedContent.substr(0, se) + de + Q.resolvedContent.substr(se) + Me, Q.resolvedContent = E.xml_str2json(ge);
                }
                ne(oe) && Z(oe);
              }
              function Z(fe) {
                var Q = [], oe, de;
                if (K(fe), fe.resolveType === S && o.trigger(i.default.XLINK_READY, {
                  manifest: M
                }), fe.resolveType === T)
                  switch (fe.type) {
                    case t.default.PERIOD:
                      for (oe = 0; oe < M[t.default.PERIOD + "_asArray"].length; oe++)
                        de = M[t.default.PERIOD + "_asArray"][oe], de.hasOwnProperty(t.default.ADAPTATION_SET + "_asArray") && (Q = Q.concat(ie(de[t.default.ADAPTATION_SET + "_asArray"], de, t.default.ADAPTATION_SET, T))), de.hasOwnProperty(t.default.EVENT_STREAM + "_asArray") && (Q = Q.concat(ie(de[t.default.EVENT_STREAM + "_asArray"], de, t.default.EVENT_STREAM, T)));
                      H(Q, t.default.ADAPTATION_SET, T);
                      break;
                    case t.default.ADAPTATION_SET:
                      o.trigger(i.default.XLINK_READY, {
                        manifest: M
                      });
                      break;
                  }
              }
              function ie(fe, Q, oe, de) {
                var Me = [], ge, se, ee;
                for (se = fe.length - 1; se >= 0; se--)
                  ge = fe[se], ge.hasOwnProperty("xlink:href") && ge["xlink:href"] === h && fe.splice(se, 1);
                for (se = 0; se < fe.length; se++)
                  ge = fe[se], ge.hasOwnProperty("xlink:href") && ge.hasOwnProperty("xlink:actuate") && ge["xlink:actuate"] === de && (ee = Y(ge["xlink:href"], Q, oe, se, de, ge), Me.push(ee));
                return Me;
              }
              function K(fe) {
                var Q = [], oe, de, Me, ge, se, ee;
                for (ge = fe.elements.length - 1; ge >= 0; ge--) {
                  if (oe = fe.elements[ge], de = oe.type + "_asArray", !oe.resolvedContent || ae())
                    delete oe.originalContent["xlink:actuate"], delete oe.originalContent["xlink:href"], Q.push(oe.originalContent);
                  else if (oe.resolvedContent)
                    for (se = 0; se < oe.resolvedContent[de].length; se++)
                      Me = oe.resolvedContent[de][se], Q.push(Me);
                  for (oe.parentElement[de].splice(oe.index, 1), ee = 0; ee < Q.length; ee++)
                    oe.parentElement[de].splice(oe.index + ee, 0, Q[ee]);
                  Q = [];
                }
                fe.elements.length > 0 && I.run(M);
              }
              function Y(fe, Q, oe, de, Me, ge) {
                return {
                  url: fe,
                  parentElement: Q,
                  type: oe,
                  index: de,
                  resolveType: Me,
                  originalContent: ge,
                  resolvedContent: null,
                  resolved: !1
                };
              }
              function ne(fe) {
                var Q, oe;
                for (Q = 0; Q < fe.elements.length; Q++)
                  if (oe = fe.elements[Q], oe.resolved === !1)
                    return !1;
                return !0;
              }
              function ae() {
                return !1;
              }
              return u = {
                resolveManifestOnLoad: V,
                setMatchers: b,
                setIron: w,
                reset: J
              }, C(), u;
            }
            _.__dashjs_factory_name = "XlinkController";
            const L = r.default.getClassFactory(_);
          }
        ),
        /***/
        "./src/streaming/metrics/MetricsReporting.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/metrics/MetricsReporting.js ***!
            \***************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var g = e(
              /*! ./utils/DVBErrorsTranslator */
              "./src/streaming/metrics/utils/DVBErrorsTranslator.js"
            ), n = e(
              /*! ./MetricsReportingEvents */
              "./src/streaming/metrics/MetricsReportingEvents.js"
            ), i = e(
              /*! ./controllers/MetricsCollectionController */
              "./src/streaming/metrics/controllers/MetricsCollectionController.js"
            ), r = e(
              /*! ./metrics/MetricsHandlerFactory */
              "./src/streaming/metrics/metrics/MetricsHandlerFactory.js"
            ), l = e(
              /*! ./reporting/ReportingFactory */
              "./src/streaming/metrics/reporting/ReportingFactory.js"
            );
            function d() {
              var S = this.context, h, _;
              function L(o) {
                return _ = (0, g.default)(S).getInstance({
                  eventBus: o.eventBus,
                  dashMetrics: o.dashMetrics,
                  metricsConstants: o.metricsConstants,
                  events: o.events
                }), _.initialise(), (0, i.default)(S).create(o);
              }
              function v() {
                return (0, l.default)(S).getInstance();
              }
              function c() {
                return (0, r.default)(S).getInstance();
              }
              return h = {
                createMetricsReporting: L,
                getReportingFactory: v,
                getMetricsHandlerFactory: c
              }, h;
            }
            d.__dashjs_factory_name = "MetricsReporting";
            var t = dashjs.FactoryMaker.getClassFactory(d);
            t.events = n.default, dashjs.FactoryMaker.updateClassFactory(d.__dashjs_factory_name, t);
            const T = t;
          }
        ),
        /***/
        "./src/streaming/metrics/MetricsReportingEvents.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/metrics/MetricsReportingEvents.js ***!
            \*********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ../../core/events/EventsBase */
              "./src/core/events/EventsBase.js"
            );
            function n(c) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(y) {
                return typeof y;
              } : n = function(y) {
                return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
              }, n(c);
            }
            function i(c, o) {
              if (!(c instanceof o))
                throw new TypeError("Cannot call a class as a function");
            }
            function r(c, o) {
              if (typeof o != "function" && o !== null)
                throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(o && o.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), o && l(c, o);
            }
            function l(c, o) {
              return l = Object.setPrototypeOf || function(u, A) {
                return u.__proto__ = A, u;
              }, l(c, o);
            }
            function d(c) {
              var o = S();
              return function() {
                var u = h(c), A;
                if (o) {
                  var I = h(this).constructor;
                  A = Reflect.construct(u, arguments, I);
                } else
                  A = u.apply(this, arguments);
                return t(this, A);
              };
            }
            function t(c, o) {
              return o && (n(o) === "object" || typeof o == "function") ? o : T(c);
            }
            function T(c) {
              if (c === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return c;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function h(c) {
              return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, h(c);
            }
            var _ = /* @__PURE__ */ function(c) {
              r(y, c);
              var o = d(y);
              function y() {
                var u;
                return i(this, y), u = o.call(this), u.METRICS_INITIALISATION_COMPLETE = "internal_metricsReportingInitialized", u.BECAME_REPORTING_PLAYER = "internal_becameReportingPlayer", u.CMCD_DATA_GENERATED = "cmcdDataGenerated", u;
              }
              return y;
            }(g.default), L = new _();
            const v = L;
          }
        ),
        /***/
        "./src/streaming/metrics/controllers/MetricsCollectionController.js": (
          /*!**************************************************************************!*\
            !*** ./src/streaming/metrics/controllers/MetricsCollectionController.js ***!
            \**************************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ./MetricsController */
              "./src/streaming/metrics/controllers/MetricsController.js"
            ), n = e(
              /*! ../utils/ManifestParsing */
              "./src/streaming/metrics/utils/ManifestParsing.js"
            ), i = e(
              /*! ../MetricsReportingEvents */
              "./src/streaming/metrics/MetricsReportingEvents.js"
            );
            function r(d) {
              d = d || {};
              var t, T = {}, S = this.context, h = d.eventBus, _ = d.events;
              function L(y) {
                if (!y.error) {
                  var u = Object.keys(T), A = (0, n.default)(S).getInstance({
                    adapter: d.adapter,
                    constants: d.constants
                  }).getMetrics(y.manifest);
                  A.forEach(function(I) {
                    var M = JSON.stringify(I);
                    if (T.hasOwnProperty(M))
                      u.splice(M, 1);
                    else
                      try {
                        var E = (0, g.default)(S).create(d);
                        E.initialize(I), T[M] = E;
                      } catch {
                      }
                  }), u.forEach(function(I) {
                    T[I].reset(), delete T[I];
                  }), h.trigger(i.default.METRICS_INITIALISATION_COMPLETE);
                }
              }
              function v() {
                Object.keys(T).forEach(function(y) {
                  T[y].reset();
                }), T = {};
              }
              function c() {
                h.on(_.MANIFEST_UPDATED, L, t), h.on(_.STREAM_TEARDOWN_COMPLETE, v, t);
              }
              function o() {
                h.off(_.MANIFEST_UPDATED, L, t), h.off(_.STREAM_TEARDOWN_COMPLETE, v, t);
              }
              return t = {
                reset: o
              }, c(), t;
            }
            r.__dashjs_factory_name = "MetricsCollectionController";
            const l = dashjs.FactoryMaker.getClassFactory(r);
          }
        ),
        /***/
        "./src/streaming/metrics/controllers/MetricsController.js": (
          /*!****************************************************************!*\
            !*** ./src/streaming/metrics/controllers/MetricsController.js ***!
            \****************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ./RangeController */
              "./src/streaming/metrics/controllers/RangeController.js"
            ), n = e(
              /*! ./ReportingController */
              "./src/streaming/metrics/controllers/ReportingController.js"
            ), i = e(
              /*! ./MetricsHandlersController */
              "./src/streaming/metrics/controllers/MetricsHandlersController.js"
            );
            function r(d) {
              d = d || {};
              var t, T, S, h, _ = this.context;
              function L(c) {
                try {
                  S = (0, g.default)(_).create({
                    mediaElement: d.mediaElement
                  }), S.initialize(c.Range), T = (0, n.default)(_).create({
                    debug: d.debug,
                    metricsConstants: d.metricsConstants,
                    mediaPlayerModel: d.mediaPlayerModel
                  }), T.initialize(c.Reporting, S), t = (0, i.default)(_).create({
                    debug: d.debug,
                    eventBus: d.eventBus,
                    metricsConstants: d.metricsConstants,
                    events: d.events
                  }), t.initialize(c.metrics, T);
                } catch (o) {
                  throw v(), o;
                }
              }
              function v() {
                t && t.reset(), T && T.reset(), S && S.reset();
              }
              return h = {
                initialize: L,
                reset: v
              }, h;
            }
            r.__dashjs_factory_name = "MetricsController";
            const l = dashjs.FactoryMaker.getClassFactory(r);
          }
        ),
        /***/
        "./src/streaming/metrics/controllers/MetricsHandlersController.js": (
          /*!************************************************************************!*\
            !*** ./src/streaming/metrics/controllers/MetricsHandlersController.js ***!
            \************************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../metrics/MetricsHandlerFactory */
              "./src/streaming/metrics/metrics/MetricsHandlerFactory.js"
            );
            function n(r) {
              r = r || {};
              var l = [], d, t = this.context, T = r.eventBus, S = r.events, h = (0, g.default)(t).getInstance({
                debug: r.debug,
                eventBus: r.eventBus,
                metricsConstants: r.metricsConstants
              });
              function _(c) {
                l.forEach(function(o) {
                  o.handleNewMetric(c.metric, c.value, c.mediaType);
                });
              }
              function L(c, o) {
                c.split(",").forEach(function(y, u, A) {
                  var I;
                  if (y.indexOf("(") !== -1 && y.indexOf(")") === -1) {
                    var M = A[u + 1];
                    M && M.indexOf("(") === -1 && M.indexOf(")") !== -1 && (y += "," + M, delete A[u + 1]);
                  }
                  I = h.create(y, o), I && l.push(I);
                }), T.on(S.METRIC_ADDED, _, d), T.on(S.METRIC_UPDATED, _, d);
              }
              function v() {
                T.off(S.METRIC_ADDED, _, d), T.off(S.METRIC_UPDATED, _, d), l.forEach(function(c) {
                  return c.reset();
                }), l = [];
              }
              return d = {
                initialize: L,
                reset: v
              }, d;
            }
            n.__dashjs_factory_name = "MetricsHandlersController";
            const i = dashjs.FactoryMaker.getClassFactory(n);
          }
        ),
        /***/
        "./src/streaming/metrics/controllers/RangeController.js": (
          /*!**************************************************************!*\
            !*** ./src/streaming/metrics/controllers/RangeController.js ***!
            \**************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../utils/CustomTimeRanges */
              "./src/streaming/utils/CustomTimeRanges.js"
            );
            function n(r) {
              r = r || {};
              var l = !1, d = this.context, t, T, S = r.mediaElement;
              function h(c) {
                c && c.length && (c.forEach(function(o) {
                  var y = o.starttime, u = y + o.duration;
                  T.add(y, u);
                }), l = !!c[0]._useWallClockTime);
              }
              function _() {
                T.clear();
              }
              function L() {
                T = (0, g.default)(d).create();
              }
              function v() {
                var c = T.length, o;
                if (!c)
                  return !0;
                o = l ? (/* @__PURE__ */ new Date()).getTime() / 1e3 : S.currentTime;
                for (var y = 0; y < c; y += 1) {
                  var u = T.start(y), A = T.end(y);
                  if (u <= o && o < A)
                    return !0;
                }
                return !1;
              }
              return t = {
                initialize: h,
                reset: _,
                isEnabled: v
              }, L(), t;
            }
            n.__dashjs_factory_name = "RangeController";
            const i = dashjs.FactoryMaker.getClassFactory(n);
          }
        ),
        /***/
        "./src/streaming/metrics/controllers/ReportingController.js": (
          /*!******************************************************************!*\
            !*** ./src/streaming/metrics/controllers/ReportingController.js ***!
            \******************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../reporting/ReportingFactory */
              "./src/streaming/metrics/reporting/ReportingFactory.js"
            );
            function n(r) {
              var l = [], d, t = (0, g.default)(this.context).getInstance(r);
              function T(_, L) {
                _.some(function(v) {
                  var c = t.create(v, L);
                  if (c)
                    return l.push(c), !0;
                });
              }
              function S() {
                l.forEach(function(_) {
                  return _.reset();
                }), l = [];
              }
              function h(_, L) {
                l.forEach(function(v) {
                  return v.report(_, L);
                });
              }
              return d = {
                initialize: T,
                reset: S,
                report: h
              }, d;
            }
            n.__dashjs_factory_name = "ReportingController";
            const i = dashjs.FactoryMaker.getClassFactory(n);
          }
        ),
        /***/
        "./src/streaming/metrics/metrics/MetricsHandlerFactory.js": (
          /*!****************************************************************!*\
            !*** ./src/streaming/metrics/metrics/MetricsHandlerFactory.js ***!
            \****************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ./handlers/BufferLevelHandler */
              "./src/streaming/metrics/metrics/handlers/BufferLevelHandler.js"
            ), n = e(
              /*! ./handlers/DVBErrorsHandler */
              "./src/streaming/metrics/metrics/handlers/DVBErrorsHandler.js"
            ), i = e(
              /*! ./handlers/HttpListHandler */
              "./src/streaming/metrics/metrics/handlers/HttpListHandler.js"
            ), r = e(
              /*! ./handlers/GenericMetricHandler */
              "./src/streaming/metrics/metrics/handlers/GenericMetricHandler.js"
            );
            function l(t) {
              t = t || {};
              var T, S = t.debug ? t.debug.getLogger(T) : {}, h = /([a-zA-Z]*)(\(([0-9]*)(\,\s*([a-zA-Z]*))?\))?/, _ = this.context, L = {
                BufferLevel: g.default,
                DVBErrors: n.default,
                HttpList: i.default,
                PlayList: r.default,
                RepSwitchList: r.default,
                TcpList: r.default
              };
              function v(y, u) {
                var A = y.match(h), I;
                if (A) {
                  try {
                    I = L[A[1]](_).create({
                      eventBus: t.eventBus,
                      metricsConstants: t.metricsConstants
                    }), I.initialize(A[1], u, A[3], A[5]);
                  } catch (M) {
                    I = null, S.error("MetricsHandlerFactory: Could not create handler for type ".concat(A[1], " with args ").concat(A[3], ", ").concat(A[5], " (").concat(M.message, ")"));
                  }
                  return I;
                }
              }
              function c(y, u) {
                L[y] = u;
              }
              function o(y) {
                delete L[y];
              }
              return T = {
                create: v,
                register: c,
                unregister: o
              }, T;
            }
            l.__dashjs_factory_name = "MetricsHandlerFactory";
            const d = dashjs.FactoryMaker.getSingletonFactory(l);
          }
        ),
        /***/
        "./src/streaming/metrics/metrics/handlers/BufferLevelHandler.js": (
          /*!**********************************************************************!*\
            !*** ./src/streaming/metrics/metrics/handlers/BufferLevelHandler.js ***!
            \**********************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../utils/HandlerHelpers */
              "./src/streaming/metrics/utils/HandlerHelpers.js"
            );
            function n(r) {
              r = r || {};
              var l, d, t, T, S, h, _ = this.context, L = (0, g.default)(_).getInstance(), v = [], c = r.metricsConstants;
              function o() {
                try {
                  return Object.keys(v).map(function(M) {
                    return v[M];
                  }).reduce(function(M, E) {
                    return M.level < E.level ? M : E;
                  });
                } catch {
                  return;
                }
              }
              function y() {
                var M = o();
                M && h !== M.t && (h = M.t, d.report(T, M));
              }
              function u(M, E, N) {
                E && (t = L.validateN(N), d = E, T = L.reconstructFullMetricName(M, N), S = setInterval(y, t));
              }
              function A() {
                clearInterval(S), S = null, t = 0, d = null, h = null;
              }
              function I(M, E, N) {
                M === c.BUFFER_LEVEL && (v[N] = E);
              }
              return l = {
                initialize: u,
                reset: A,
                handleNewMetric: I
              }, l;
            }
            n.__dashjs_factory_name = "BufferLevelHandler";
            const i = dashjs.FactoryMaker.getClassFactory(n);
          }
        ),
        /***/
        "./src/streaming/metrics/metrics/handlers/DVBErrorsHandler.js": (
          /*!********************************************************************!*\
            !*** ./src/streaming/metrics/metrics/handlers/DVBErrorsHandler.js ***!
            \********************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../MetricsReportingEvents */
              "./src/streaming/metrics/MetricsReportingEvents.js"
            );
            function n(r) {
              r = r || {};
              var l, d, t = r.eventBus, T = r.metricsConstants;
              function S() {
                t.off(g.default.METRICS_INITIALISATION_COMPLETE, S, this), t.trigger(g.default.BECAME_REPORTING_PLAYER);
              }
              function h(v, c) {
                c && (d = c, t.on(g.default.METRICS_INITIALISATION_COMPLETE, S, this));
              }
              function _() {
                d = null;
              }
              function L(v, c) {
                v === T.DVB_ERRORS && d && d.report(v, c);
              }
              return l = {
                initialize: h,
                reset: _,
                handleNewMetric: L
              }, l;
            }
            const i = dashjs.FactoryMaker.getClassFactory(n);
          }
        ),
        /***/
        "./src/streaming/metrics/metrics/handlers/GenericMetricHandler.js": (
          /*!************************************************************************!*\
            !*** ./src/streaming/metrics/metrics/handlers/GenericMetricHandler.js ***!
            \************************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => n
              /* harmony export */
            });
            function g() {
              var i, r, l;
              function d(S, h) {
                r = S, l = h;
              }
              function t() {
                l = null, r = void 0;
              }
              function T(S, h) {
                S === r && l && l.report(r, h);
              }
              return i = {
                initialize: d,
                reset: t,
                handleNewMetric: T
              }, i;
            }
            g.__dashjs_factory_name = "GenericMetricHandler";
            const n = dashjs.FactoryMaker.getClassFactory(g);
          }
        ),
        /***/
        "./src/streaming/metrics/metrics/handlers/HttpListHandler.js": (
          /*!*******************************************************************!*\
            !*** ./src/streaming/metrics/metrics/handlers/HttpListHandler.js ***!
            \*******************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../utils/HandlerHelpers */
              "./src/streaming/metrics/utils/HandlerHelpers.js"
            );
            function n(r) {
              r = r || {};
              var l, d, t, T, S, h, _ = [], L = (0, g.default)(this.context).getInstance(), v = r.metricsConstants;
              function c() {
                var A = _;
                A.length && d && d.report(S, A), _ = [];
              }
              function o(A, I, M, E) {
                I && (t = L.validateN(M), d = I, E && E.length && (T = E), S = L.reconstructFullMetricName(A, M, E), h = setInterval(c, t));
              }
              function y() {
                clearInterval(h), h = null, t = null, T = null, _ = [], d = null;
              }
              function u(A, I) {
                A === v.HTTP_REQUEST && (!T || T === I.type) && _.push(I);
              }
              return l = {
                initialize: o,
                reset: y,
                handleNewMetric: u
              }, l;
            }
            n.__dashjs_factory_name = "HttpListHandler";
            const i = dashjs.FactoryMaker.getClassFactory(n);
          }
        ),
        /***/
        "./src/streaming/metrics/reporting/ReportingFactory.js": (
          /*!*************************************************************!*\
            !*** ./src/streaming/metrics/reporting/ReportingFactory.js ***!
            \*************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ./reporters/DVBReporting */
              "./src/streaming/metrics/reporting/reporters/DVBReporting.js"
            );
            function n(r) {
              r = r || {};
              var l = {
                "urn:dvb:dash:reporting:2014": g.default
              }, d = this.context, t, T = r.debug ? r.debug.getLogger(t) : {}, S = r.metricsConstants, h = r.mediaPlayerModel || {};
              function _(c, o) {
                var y;
                try {
                  y = l[c.schemeIdUri](d).create({
                    metricsConstants: S,
                    mediaPlayerModel: h
                  }), y.initialize(c, o);
                } catch (u) {
                  y = null, T.error("ReportingFactory: could not create Reporting with schemeIdUri ".concat(c.schemeIdUri, " (").concat(u.message, ")"));
                }
                return y;
              }
              function L(c, o) {
                l[c] = o;
              }
              function v(c) {
                delete l[c];
              }
              return t = {
                create: _,
                register: L,
                unregister: v
              }, t;
            }
            n.__dashjs_factory_name = "ReportingFactory";
            const i = dashjs.FactoryMaker.getSingletonFactory(n);
          }
        ),
        /***/
        "./src/streaming/metrics/reporting/reporters/DVBReporting.js": (
          /*!*******************************************************************!*\
            !*** ./src/streaming/metrics/reporting/reporters/DVBReporting.js ***!
            \*******************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../utils/MetricSerialiser */
              "./src/streaming/metrics/utils/MetricSerialiser.js"
            ), n = e(
              /*! ../../utils/RNG */
              "./src/streaming/metrics/utils/RNG.js"
            ), i = e(
              /*! ../../../models/CustomParametersModel */
              "./src/streaming/models/CustomParametersModel.js"
            );
            function r(d) {
              d = d || {};
              var t, T = this.context, S, h, _, L, v, c, o, y = [], u = d.metricsConstants;
              function A() {
                S = (0, g.default)(T).getInstance(), _ = (0, n.default)(T).getInstance(), h = (0, i.default)(T).getInstance(), N();
              }
              function I(b, w, V) {
                var J = new XMLHttpRequest();
                J.withCredentials = h.getXHRWithCredentialsForType(u.HTTP_REQUEST_DVB_REPORTING_TYPE);
                var H = function() {
                  var Z = y.indexOf(J);
                  Z !== -1 && (y.splice(Z, 1), J.status >= 200 && J.status < 300 ? w && w() : V && V());
                };
                y.push(J);
                try {
                  J.open("GET", b), J.onloadend = H, J.onerror = H, J.send();
                } catch {
                  J.onerror();
                }
              }
              function M(b, w) {
                Array.isArray(w) || (w = [w]), v && o.isEnabled() && w.forEach(function(V) {
                  var J = S.serialise(V);
                  b !== u.DVB_ERRORS && (J = "metricname=".concat(b, "&").concat(J)), J = "".concat(c, "?").concat(J), I(J, null, function() {
                    v = !1;
                  });
                });
              }
              function E(b, w) {
                var V;
                if (o = w, c = b.dvb_reportingUrl, !c)
                  throw new Error("required parameter missing (dvb:reportingUrl)");
                L || (V = b.dvb_probability, V && (V === 1e3 || V / 1e3 >= _.random()) && (v = !0), L = !0);
              }
              function N() {
                L = !1, v = !1, c = null, o = null;
              }
              function C() {
                N();
              }
              return t = {
                report: M,
                initialize: E,
                reset: C
              }, A(), t;
            }
            r.__dashjs_factory_name = "DVBReporting";
            const l = dashjs.FactoryMaker.getClassFactory(r);
          }
        ),
        /***/
        "./src/streaming/metrics/utils/DVBErrorsTranslator.js": (
          /*!************************************************************!*\
            !*** ./src/streaming/metrics/utils/DVBErrorsTranslator.js ***!
            \************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../vo/DVBErrors */
              "./src/streaming/metrics/vo/DVBErrors.js"
            ), n = e(
              /*! ../MetricsReportingEvents */
              "./src/streaming/metrics/MetricsReportingEvents.js"
            );
            function i(l) {
              l = l || {};
              var d, t, T = l.eventBus, S = l.dashMetrics, h = l.metricsConstants, _ = l.events;
              function L(E) {
                var N = new g.default();
                if (t) {
                  for (var C in E)
                    E.hasOwnProperty(C) && (N[C] = E[C]);
                  N.mpdurl || (N.mpdurl = t.originalUrl || t.url), N.terror || (N.terror = /* @__PURE__ */ new Date()), S.addDVBErrors(N);
                }
              }
              function v(E) {
                E.error || (t = E.manifest);
              }
              function c(E) {
                L({
                  errorcode: g.default.BASE_URL_CHANGED,
                  servicelocation: E.entry
                });
              }
              function o() {
                L({
                  errorcode: g.default.BECAME_REPORTER
                });
              }
              function y(E) {
                (E.responsecode === 0 || // connection failure - unknown
                E.responsecode == null || // Generated on .catch() and when uninitialised
                E.responsecode >= 400 || // HTTP error status code
                E.responsecode < 100 || // unknown status codes
                E.responsecode >= 600) && L({
                  errorcode: E.responsecode || g.default.CONNECTION_ERROR,
                  url: E.url,
                  terror: E.tresponse,
                  servicelocation: E._serviceLocation
                });
              }
              function u(E) {
                switch (E.metric) {
                  case h.HTTP_REQUEST:
                    y(E.value);
                    break;
                }
              }
              function A(E) {
                var N = E.error ? E.error.code : 0, C;
                switch (N) {
                  case MediaError.MEDIA_ERR_NETWORK:
                    C = g.default.CONNECTION_ERROR;
                    break;
                  case MediaError.MEDIA_ERR_DECODE:
                    C = g.default.CORRUPT_MEDIA_OTHER;
                    break;
                  default:
                    return;
                }
                L({
                  errorcode: C
                });
              }
              function I() {
                T.on(_.MANIFEST_UPDATED, v, d), T.on(_.SERVICE_LOCATION_BLACKLIST_CHANGED, c, d), T.on(_.METRIC_ADDED, u, d), T.on(_.METRIC_UPDATED, u, d), T.on(_.PLAYBACK_ERROR, A, d), T.on(n.default.BECAME_REPORTING_PLAYER, o, d);
              }
              function M() {
                T.off(_.MANIFEST_UPDATED, v, d), T.off(_.SERVICE_LOCATION_BLACKLIST_CHANGED, c, d), T.off(_.METRIC_ADDED, u, d), T.off(_.METRIC_UPDATED, u, d), T.off(_.PLAYBACK_ERROR, A, d), T.off(n.default.BECAME_REPORTING_PLAYER, o, d);
              }
              return d = {
                initialise: I,
                reset: M
              }, d;
            }
            i.__dashjs_factory_name = "DVBErrorsTranslator";
            const r = dashjs.FactoryMaker.getSingletonFactory(i);
          }
        ),
        /***/
        "./src/streaming/metrics/utils/HandlerHelpers.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/metrics/utils/HandlerHelpers.js ***!
            \*******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => n
              /* harmony export */
            });
            function g() {
              return {
                reconstructFullMetricName: function(r, l, d) {
                  var t = r;
                  return l && (t += "(" + l, d && d.length && (t += "," + d), t += ")"), t;
                },
                validateN: function(r) {
                  if (!r)
                    throw new Error("missing n");
                  if (isNaN(r))
                    throw new Error("n is NaN");
                  if (r < 0)
                    throw new Error("n must be positive");
                  return r;
                }
              };
            }
            g.__dashjs_factory_name = "HandlerHelpers";
            const n = dashjs.FactoryMaker.getSingletonFactory(g);
          }
        ),
        /***/
        "./src/streaming/metrics/utils/ManifestParsing.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/metrics/utils/ManifestParsing.js ***!
            \********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../vo/Metrics */
              "./src/streaming/metrics/vo/Metrics.js"
            ), n = e(
              /*! ../vo/Range */
              "./src/streaming/metrics/vo/Range.js"
            ), i = e(
              /*! ../vo/Reporting */
              "./src/streaming/metrics/vo/Reporting.js"
            );
            function r(d) {
              d = d || {};
              var t, T = d.adapter, S = d.constants;
              function h(L, v, c) {
                var o, y, u = 0;
                return v ? u = T.getAvailabilityStartTime(L) / 1e3 : (o = T.getRegularPeriods(L), o.length && (u = o[0].start)), y = u, c && c.hasOwnProperty(S.START_TIME) && (y += c.starttime), y;
              }
              function _(L) {
                var v = [];
                return L && L.Metrics_asArray && L.Metrics_asArray.forEach(function(c) {
                  var o = new g.default(), y = T.getIsDynamic(L);
                  if (c.hasOwnProperty("metrics"))
                    o.metrics = c.metrics;
                  else
                    return;
                  if (c.Range_asArray && c.Range_asArray.forEach(function(u) {
                    var A = new n.default();
                    A.starttime = h(L, y, u), u.hasOwnProperty("duration") ? A.duration = u.duration : A.duration = T.getDuration(L), A._useWallClockTime = y, o.Range.push(A);
                  }), c.Reporting_asArray)
                    c.Reporting_asArray.forEach(function(u) {
                      var A = new i.default();
                      if (u.hasOwnProperty(S.SCHEME_ID_URI))
                        A.schemeIdUri = u.schemeIdUri;
                      else
                        return;
                      u.hasOwnProperty("value") && (A.value = u.value), u.hasOwnProperty(S.DVB_REPORTING_URL) && (A.dvb_reportingUrl = u[S.DVB_REPORTING_URL]), u.hasOwnProperty(S.DVB_PROBABILITY) && (A.dvb_probability = u[S.DVB_PROBABILITY]), o.Reporting.push(A);
                    });
                  else
                    return;
                  v.push(o);
                }), v;
              }
              return t = {
                getMetrics: _
              }, t;
            }
            r.__dashjs_factory_name = "ManifestParsing";
            const l = dashjs.FactoryMaker.getSingletonFactory(r);
          }
        ),
        /***/
        "./src/streaming/metrics/utils/MetricSerialiser.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/metrics/utils/MetricSerialiser.js ***!
            \*********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => n
              /* harmony export */
            });
            function g() {
              function i(r) {
                var l = [], d = [], t, T;
                for (t in r)
                  if (r.hasOwnProperty(t) && t.indexOf("_") !== 0) {
                    if (T = r[t], T == null && (T = ""), Array.isArray(T)) {
                      if (!T.length)
                        continue;
                      d = [], T.forEach(function(S) {
                        var h = Object.prototype.toString.call(S).slice(8, -1) !== "Object";
                        d.push(h ? S : i(S));
                      }), T = d.map(encodeURIComponent).join(",");
                    } else
                      typeof T == "string" ? T = encodeURIComponent(T) : T instanceof Date ? T = T.toISOString() : typeof T == "number" && (T = Math.round(T));
                    l.push(t + "=" + T);
                  }
                return l.join("&");
              }
              return {
                serialise: i
              };
            }
            g.__dashjs_factory_name = "MetricSerialiser";
            const n = dashjs.FactoryMaker.getSingletonFactory(g);
          }
        ),
        /***/
        "./src/streaming/metrics/utils/RNG.js": (
          /*!********************************************!*\
            !*** ./src/streaming/metrics/utils/RNG.js ***!
            \********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => n
              /* harmony export */
            });
            function g() {
              var i = window.crypto || window.msCrypto, r = Uint32Array, l = Math.pow(2, r.BYTES_PER_ELEMENT * 8) - 1, d = 10, t, T, S;
              function h() {
                i && (t || (t = new r(d)), i.getRandomValues(t), T = 0);
              }
              function _(L, v) {
                var c;
                return L || (L = 0), v || (v = 1), i ? (T === t.length && h(), c = t[T] / l, T += 1) : c = Math.random(), c * (v - L) + L;
              }
              return S = {
                random: _
              }, h(), S;
            }
            g.__dashjs_factory_name = "RNG";
            const n = dashjs.FactoryMaker.getSingletonFactory(g);
          }
        ),
        /***/
        "./src/streaming/metrics/vo/DVBErrors.js": (
          /*!***********************************************!*\
            !*** ./src/streaming/metrics/vo/DVBErrors.js ***!
            \***********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.mpdurl = null, this.errorcode = null, this.terror = null, this.url = null, this.ipaddress = null, this.servicelocation = null;
            };
            n.SSL_CONNECTION_FAILED_PREFIX = "SSL", n.DNS_RESOLUTION_FAILED = "C00", n.HOST_UNREACHABLE = "C01", n.CONNECTION_REFUSED = "C02", n.CONNECTION_ERROR = "C03", n.CORRUPT_MEDIA_ISOBMFF = "M00", n.CORRUPT_MEDIA_OTHER = "M01", n.BASE_URL_CHANGED = "F00", n.BECAME_REPORTER = "S00";
            const i = n;
          }
        ),
        /***/
        "./src/streaming/metrics/vo/Metrics.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/metrics/vo/Metrics.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.metrics = "", this.Range = [], this.Reporting = [];
            };
            const i = n;
          }
        ),
        /***/
        "./src/streaming/metrics/vo/Range.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/metrics/vo/Range.js ***!
            \*******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.starttime = 0, this.duration = 1 / 0, this._useWallClockTime = !1;
            };
            const i = n;
          }
        ),
        /***/
        "./src/streaming/metrics/vo/Reporting.js": (
          /*!***********************************************!*\
            !*** ./src/streaming/metrics/vo/Reporting.js ***!
            \***********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            function g(l, d) {
              if (!(l instanceof d))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = 1e3, i = function l() {
              g(this, l), this.schemeIdUri = "", this.value = "", this.dvb_reportingUrl = "", this.dvb_probability = n;
            };
            const r = i;
          }
        ),
        /***/
        "./src/streaming/models/BaseURLTreeModel.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/models/BaseURLTreeModel.js ***!
            \**************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => t
              /* harmony export */
            });
            var g = e(
              /*! ../utils/ObjectUtils */
              "./src/streaming/utils/ObjectUtils.js"
            ), n = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function i(T, S) {
              if (!(T instanceof S))
                throw new TypeError("Cannot call a class as a function");
            }
            var r = NaN, l = function T(S, h) {
              i(this, T), this.data = {
                baseUrls: S || null,
                selectedIdx: h || r
              }, this.children = [];
            };
            function d() {
              var T, S, h, _ = this.context, L = (0, g.default)(_).getInstance();
              function v() {
                E();
              }
              function c(C) {
                C.adapter && (h = C.adapter);
              }
              function o() {
                if (!h || !h.hasOwnProperty("getBaseURLsFromElement") || !h.hasOwnProperty("getRepresentationSortFunction"))
                  throw new Error("setConfig function has to be called previously");
              }
              function y(C, b, w) {
                var V = h.getBaseURLsFromElement(w);
                C[b] ? L.areEqual(V, C[b].data.baseUrls) || (C[b].data.baseUrls = V, C[b].data.selectedIdx = r) : C[b] = new l(V);
              }
              function u(C) {
                o();
                var b = h.getBaseURLsFromElement(C);
                L.areEqual(b, S.data.baseUrls) || (S.data.baseUrls = b, S.data.selectedIdx = r), C && C.Period_asArray && C.Period_asArray.forEach(function(w, V) {
                  y(S.children, V, w), w.AdaptationSet_asArray && w.AdaptationSet_asArray.forEach(function(J, H) {
                    y(S.children[V].children, H, J), J.Representation_asArray && J.Representation_asArray.sort(h.getRepresentationSortFunction()).forEach(function(z, Z) {
                      y(S.children[V].children[H].children, Z, z);
                    });
                  });
                });
              }
              function A(C, b) {
                var w = b || S;
                C(w.data), w.children && w.children.forEach(function(V) {
                  return A(C, V);
                });
              }
              function I(C) {
                A(function(b) {
                  isNaN(b.selectedIdx) || C === b.baseUrls[b.selectedIdx].serviceLocation && (b.selectedIdx = r);
                });
              }
              function M(C) {
                u(C);
              }
              function E() {
                S = new l();
              }
              function N(C) {
                var b = S, w = [b.data];
                return C && C.forEach(function(V) {
                  b = b.children[V], b && w.push(b.data);
                }), w.filter(function(V) {
                  return V.baseUrls.length;
                });
              }
              return T = {
                reset: E,
                update: M,
                getForPath: N,
                invalidateSelectedIndexes: I,
                setConfig: c
              }, v(), T;
            }
            d.__dashjs_factory_name = "BaseURLTreeModel";
            const t = n.default.getClassFactory(d);
          }
        ),
        /***/
        "./src/streaming/models/CmcdModel.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/models/CmcdModel.js ***!
            \*******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => M
              /* harmony export */
            });
            var g = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), n = e(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), i = e(
              /*! ../metrics/MetricsReportingEvents */
              "./src/streaming/metrics/MetricsReportingEvents.js"
            ), r = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), l = e(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), d = e(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), t = e(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), T = e(
              /*! ../../dash/models/DashManifestModel */
              "./src/dash/models/DashManifestModel.js"
            ), S = e(
              /*! ../../core/Utils */
              "./src/core/Utils.js"
            );
            function h(E, N) {
              var C;
              if (typeof Symbol > "u" || E[Symbol.iterator] == null) {
                if (Array.isArray(E) || (C = _(E)) || N && E && typeof E.length == "number") {
                  C && (E = C);
                  var b = 0, w = function() {
                  };
                  return { s: w, n: function() {
                    return b >= E.length ? { done: !0 } : { done: !1, value: E[b++] };
                  }, e: function(Z) {
                    throw Z;
                  }, f: w };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              var V = !0, J = !1, H;
              return { s: function() {
                C = E[Symbol.iterator]();
              }, n: function() {
                var Z = C.next();
                return V = Z.done, Z;
              }, e: function(Z) {
                J = !0, H = Z;
              }, f: function() {
                try {
                  !V && C.return != null && C.return();
                } finally {
                  if (J)
                    throw H;
                }
              } };
            }
            function _(E, N) {
              if (E) {
                if (typeof E == "string")
                  return L(E, N);
                var C = Object.prototype.toString.call(E).slice(8, -1);
                if (C === "Object" && E.constructor && (C = E.constructor.name), C === "Map" || C === "Set")
                  return Array.from(E);
                if (C === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(C))
                  return L(E, N);
              }
            }
            function L(E, N) {
              (N == null || N > E.length) && (N = E.length);
              for (var C = 0, b = new Array(N); C < N; C++)
                b[C] = E[C];
              return b;
            }
            var v = "CMCD", c = 1, o = {
              MANIFEST: "m",
              AUDIO: "a",
              VIDEO: "v",
              INIT: "i",
              CAPTION: "c",
              ISOBMFF_TEXT_TRACK: "tt",
              ENCRYPTION_KEY: "k",
              OTHER: "o"
            }, y = {
              DASH: "d",
              MSS: "s"
            }, u = {
              VOD: "v",
              LIVE: "l"
            }, A = 5;
            function I() {
              var E, N, C, b, w, V, J, H, z, Z, ie = this.context, K = (0, g.default)(ie).getInstance(), Y = (0, l.default)(ie).getInstance();
              function ne() {
                E = (0, T.default)(ie).getInstance(), Q();
              }
              function ae() {
                K.on(n.default.PLAYBACK_RATE_CHANGED, _e, N), K.on(n.default.MANIFEST_LOADED, Ee, N), K.on(n.default.BUFFER_LEVEL_STATE_CHANGED, Te, N), K.on(n.default.PLAYBACK_SEEKED, Ce, N), K.on(n.default.PERIOD_SWITCH_COMPLETED, oe, N);
              }
              function fe(Le) {
                Le && (Le.abrController && (b = Le.abrController), Le.dashMetrics && (w = Le.dashMetrics), Le.playbackController && (V = Le.playbackController));
              }
              function Q() {
                C = {
                  pr: 1,
                  nor: null,
                  st: null,
                  sf: null,
                  sid: "".concat(S.default.generateUuid()),
                  cid: null
                }, z = {}, H = {}, Z = {}, de();
              }
              function oe() {
                de();
              }
              function de() {
                if (V) {
                  var Le = V.getStreamController();
                  if (Le && typeof Le.getActiveStream == "function") {
                    var je = Le.getActiveStream();
                    je && (J = je.getProcessors());
                  }
                }
              }
              function Me(Le) {
                try {
                  if (Y.get().streaming.cmcd && Y.get().streaming.cmcd.enabled) {
                    var je = ue(Le), Ze = ge(je), nt = xe(Ze);
                    return K.trigger(i.default.CMCD_DATA_GENERATED, {
                      url: Le.url,
                      mediaType: Le.mediaType,
                      cmcdData: je,
                      cmcdString: nt
                    }), {
                      key: v,
                      value: nt
                    };
                  }
                  return null;
                } catch {
                  return null;
                }
              }
              function ge(Le) {
                try {
                  var je = Y.get().streaming.cmcd.enabledKeys;
                  return Object.keys(Le).filter(function(Ze) {
                    return je.includes(Ze);
                  }).reduce(function(Ze, nt) {
                    return Ze[nt] = Le[nt], Ze;
                  }, {});
                } catch {
                  return Le;
                }
              }
              function se(Le, je) {
                var Ze = {}, nt = h(je), it;
                try {
                  for (nt.s(); !(it = nt.n()).done; ) {
                    var De = it.value;
                    Le[De] && (Ze[De] = Le[De]);
                  }
                } catch (Ye) {
                  nt.e(Ye);
                } finally {
                  nt.f();
                }
                return Ze;
              }
              function ee(Le) {
                try {
                  if (Y.get().streaming.cmcd && Y.get().streaming.cmcd.enabled) {
                    var je = ue(Le), Ze = se(je, re(["br", "d", "ot", "tb"])), nt = se(je, re(["bl", "dl", "mtp", "nor", "nrr", "su"])), it = se(je, re(["bs", "rtp"])), De = se(je, re(["cid", "pr", "sf", "sid", "st", "v"])), Ye = {
                      "CMCD-Object": xe(Ze),
                      "CMCD-Request": xe(nt),
                      "CMCD-Status": xe(it),
                      "CMCD-Session": xe(De)
                    };
                    return K.trigger(i.default.CMCD_DATA_GENERATED, {
                      url: Le.url,
                      mediaType: Le.mediaType,
                      cmcdData: je,
                      headers: Ye
                    }), Ye;
                  }
                  return null;
                } catch {
                  return null;
                }
              }
              function re(Le) {
                var je = Y.get().streaming.cmcd.enabledKeys;
                return Le.filter(function(Ze) {
                  return je.includes(Ze);
                });
              }
              function ue(Le) {
                try {
                  var je = null;
                  return Le.type === t.HTTPRequest.MPD_TYPE ? O(Le) : Le.type === t.HTTPRequest.MEDIA_SEGMENT_TYPE ? (P(Le.mediaType), p(Le)) : Le.type === t.HTTPRequest.INIT_SEGMENT_TYPE ? k(Le) : Le.type === t.HTTPRequest.OTHER_TYPE || Le.type === t.HTTPRequest.XLINK_EXPANSION_TYPE ? X(Le) : Le.type === t.HTTPRequest.LICENSE ? te(Le) : je;
                } catch {
                  return null;
                }
              }
              function te(Le) {
                var je = F();
                return je.ot = o.ENCRYPTION_KEY, je;
              }
              function O() {
                var Le = F();
                return Le.ot = o.MANIFEST, Le;
              }
              function p(Le) {
                var je = F(), Ze = x(Le), nt = $(Le), it = ce(Le.mediaType), De = le(Le.mediaType), Ye = q(Le.mediaType), Ke = W(Le.mediaType), tt = C.pr, st = be(Le.mediaType), Et;
                Le.mediaType === d.default.VIDEO && (Et = o.VIDEO), Le.mediaType === d.default.AUDIO && (Et = o.AUDIO), Le.mediaType === d.default.TEXT && (Le.mediaInfo.mimeType === "application/mp4" ? Et = o.ISOBMFF_TEXT_TRACK : Et = o.CAPTION);
                var ht = Y.get().streaming.cmcd.rtp;
                return ht || (ht = Ge(Le)), je.rtp = ht, st && (Le.url !== st.url ? je.nor = encodeURIComponent(S.default.getRelativeUrl(Le.url, st.url)) : st.range && (je.nrr = st.range)), Ze && (je.br = Ze), Et && (je.ot = Et), isNaN(nt) || (je.d = nt), isNaN(it) || (je.mtp = it), isNaN(De) || (je.dl = De), isNaN(Ye) || (je.bl = Ye), isNaN(Ke) || (je.tb = Ke), !isNaN(tt) && tt !== 1 && (je.pr = tt), z[Le.mediaType] && (je.bs = !0, z[Le.mediaType] = !1), (H[Le.mediaType] || !Z[Le.mediaType]) && (je.su = !0, H[Le.mediaType] = !1, Z[Le.mediaType] = !0), je;
              }
              function P(Le) {
                Z.hasOwnProperty(Le) || (Z[Le] = !1), H.hasOwnProperty(Le) || (H[Le] = !1), z.hasOwnProperty(Le) || (z[Le] = !1);
              }
              function k() {
                var Le = F();
                return Le.ot = o.INIT, Le.su = !0, Le;
              }
              function X() {
                var Le = F();
                return Le.ot = o.OTHER, Le;
              }
              function F() {
                var Le = {}, je = Y.get().streaming.cmcd.cid ? Y.get().streaming.cmcd.cid : C.cid;
                return Le.v = c, Le.sid = Y.get().streaming.cmcd.sid ? Y.get().streaming.cmcd.sid : C.sid, Le.sid = "".concat(Le.sid), je && (Le.cid = "".concat(je)), !isNaN(C.pr) && C.pr !== 1 && C.pr !== null && (Le.pr = C.pr), C.st && (Le.st = C.st), C.sf && (Le.sf = C.sf), Le;
              }
              function x(Le) {
                try {
                  var je = Le.quality, Ze = Le.mediaInfo.bitrateList;
                  return parseInt(Ze[je].bandwidth / 1e3);
                } catch {
                  return null;
                }
              }
              function W(Le) {
                try {
                  var je = b.getTopBitrateInfoFor(Le);
                  return Math.round(je.bitrate / 1e3);
                } catch {
                  return null;
                }
              }
              function $(Le) {
                try {
                  return isNaN(Le.duration) ? null : Math.round(Le.duration * 1e3);
                } catch {
                  return null;
                }
              }
              function ce(Le) {
                try {
                  return parseInt(b.getThroughputHistory().getSafeAverageThroughput(Le) / 100) * 100;
                } catch {
                  return null;
                }
              }
              function le(Le) {
                try {
                  var je = C.pr, Ze = w.getCurrentBufferLevel(Le);
                  return !isNaN(je) && !isNaN(Ze) ? parseInt(Ze / je * 10) * 100 : null;
                } catch {
                  return null;
                }
              }
              function q(Le) {
                try {
                  var je = w.getCurrentBufferLevel(Le);
                  return isNaN(je) ? null : parseInt(je * 10) * 100;
                } catch {
                  return null;
                }
              }
              function _e(Le) {
                try {
                  C.pr = Le.playbackRate;
                } catch {
                }
              }
              function Ee(Le) {
                try {
                  var je = E.getIsDynamic(Le.data), Ze = je ? u.LIVE : u.VOD, nt = Le.protocol && Le.protocol === "MSS" ? y.MSS : y.DASH;
                  C.st = "".concat(Ze), C.sf = "".concat(nt);
                } catch {
                }
              }
              function Te(Le) {
                try {
                  Le.state && Le.mediaType && Le.state === n.default.BUFFER_EMPTY && (z[Le.mediaType] || (z[Le.mediaType] = !0), H[Le.mediaType] || (H[Le.mediaType] = !0));
                } catch {
                }
              }
              function Ce() {
                for (var Le in z)
                  z.hasOwnProperty(Le) && (z[Le] = !0);
                for (var je in H)
                  H.hasOwnProperty(je) && (H[je] = !0);
              }
              function xe(Le) {
                try {
                  if (!Le)
                    return null;
                  var je = Object.keys(Le).sort(function(it, De) {
                    return it.localeCompare(De);
                  }), Ze = je.length, nt = je.reduce(function(it, De, Ye) {
                    return De === "v" && Le[De] === 1 || (typeof Le[De] == "string" && De !== "ot" && De !== "sf" && De !== "st" ? it += "".concat(De, "=").concat(JSON.stringify(Le[De])) : it += "".concat(De, "=").concat(Le[De]), Ye < Ze - 1 && (it += ",")), it;
                  }, "");
                  return nt = nt.replace(/=true/g, ""), nt = nt.replace(/,\s*$/, ""), nt;
                } catch {
                  return null;
                }
              }
              function be(Le) {
                if (!(!J || J.length === 0)) {
                  var je = h(J), Ze;
                  try {
                    for (je.s(); !(Ze = je.n()).done; ) {
                      var nt = Ze.value;
                      if (nt.getType() === Le)
                        return nt.probeNextRequest();
                    }
                  } catch (it) {
                    je.e(it);
                  } finally {
                    je.f();
                  }
                }
              }
              function Ge(Le) {
                var je = V.getPlaybackRate();
                je || (je = 1);
                var Ze = Le.quality, nt = Le.mediaType, it = Le.mediaInfo, De = Le.duration, Ye = q(nt);
                Ye === 0 && (Ye = 500);
                var Ke = it.bitrateList[Ze].bandwidth, tt = Ke * De / 1e3, st = Ye / je / 1e3, Et = tt / st, ht = Y.get().streaming.cmcd.rtpSafetyFactor && !isNaN(Y.get().streaming.cmcd.rtpSafetyFactor) ? Y.get().streaming.cmcd.rtpSafetyFactor : A, xt = Et * ht, Xe = (parseInt(xt / 100) + 1) * 100;
                return Xe;
              }
              function Pe() {
                K.off(n.default.PLAYBACK_RATE_CHANGED, _e, this), K.off(n.default.MANIFEST_LOADED, Ee, this), K.off(n.default.BUFFER_LEVEL_STATE_CHANGED, Te, N), K.off(n.default.PLAYBACK_SEEKED, Ce, N), Q();
              }
              return N = {
                getQueryParameter: Me,
                getHeaderParameters: ee,
                setConfig: fe,
                reset: Pe,
                initialize: ae
              }, ne(), N;
            }
            I.__dashjs_factory_name = "CmcdModel";
            const M = r.default.getSingletonFactory(I);
          }
        ),
        /***/
        "./src/streaming/models/CmsdModel.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/models/CmsdModel.js ***!
            \*******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => w
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), i = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), r = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            );
            function l(V) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? l = function(H) {
                return typeof H;
              } : l = function(H) {
                return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
              }, l(V);
            }
            function d(V, J) {
              d = function(ne, ae) {
                return new ie(ne, void 0, ae);
              };
              var H = T(RegExp), z = RegExp.prototype, Z = /* @__PURE__ */ new WeakMap();
              function ie(Y, ne, ae) {
                var fe = H.call(this, Y, ne);
                return Z.set(fe, ae || Z.get(Y)), fe;
              }
              t(ie, H), ie.prototype.exec = function(Y) {
                var ne = z.exec.call(this, Y);
                return ne && (ne.groups = K(ne, this)), ne;
              }, ie.prototype[Symbol.replace] = function(Y, ne) {
                if (typeof ne == "string") {
                  var ae = Z.get(this);
                  return z[Symbol.replace].call(this, Y, ne.replace(/\$<([^>]+)>/g, function(Q, oe) {
                    return "$" + ae[oe];
                  }));
                } else if (typeof ne == "function") {
                  var fe = this;
                  return z[Symbol.replace].call(this, Y, function() {
                    var Q = [];
                    return Q.push.apply(Q, arguments), l(Q[Q.length - 1]) !== "object" && Q.push(K(Q, fe)), ne.apply(this, Q);
                  });
                } else
                  return z[Symbol.replace].call(this, Y, ne);
              };
              function K(Y, ne) {
                var ae = Z.get(ne);
                return Object.keys(ae).reduce(function(fe, Q) {
                  return fe[Q] = Y[ae[Q]], fe;
                }, /* @__PURE__ */ Object.create(null));
              }
              return d.apply(this, arguments);
            }
            function t(V, J) {
              if (typeof J != "function" && J !== null)
                throw new TypeError("Super expression must either be null or a function");
              V.prototype = Object.create(J && J.prototype, { constructor: { value: V, writable: !0, configurable: !0 } }), J && L(V, J);
            }
            function T(V) {
              var J = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
              return T = function(z) {
                if (z === null || !_(z))
                  return z;
                if (typeof z != "function")
                  throw new TypeError("Super expression must either be null or a function");
                if (typeof J < "u") {
                  if (J.has(z))
                    return J.get(z);
                  J.set(z, Z);
                }
                function Z() {
                  return S(z, arguments, v(this).constructor);
                }
                return Z.prototype = Object.create(z.prototype, { constructor: { value: Z, enumerable: !1, writable: !0, configurable: !0 } }), L(Z, z);
              }, T(V);
            }
            function S(V, J, H) {
              return h() ? S = Reflect.construct : S = function(Z, ie, K) {
                var Y = [null];
                Y.push.apply(Y, ie);
                var ne = Function.bind.apply(Z, Y), ae = new ne();
                return K && L(ae, K.prototype), ae;
              }, S.apply(null, arguments);
            }
            function h() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function _(V) {
              return Function.toString.call(V).indexOf("[native code]") !== -1;
            }
            function L(V, J) {
              return L = Object.setPrototypeOf || function(z, Z) {
                return z.__proto__ = Z, z;
              }, L(V, J);
            }
            function v(V) {
              return v = Object.setPrototypeOf ? Object.getPrototypeOf : function(H) {
                return H.__proto__ || Object.getPrototypeOf(H);
              }, v(V);
            }
            var c = "static", o = "dynamic", y = "cmsd-", u = y + c, A = y + o, I = {
              AVAILABILITY_TIME: "at",
              DURESS: "du",
              ENCODED_BITRATE: "br",
              ESTIMATED_THROUGHPUT: "etp",
              HELD_TIME: "ht",
              INTERMEDIARY_IDENTIFIER: "n",
              MAX_SUGGESTED_BITRATE: "mb",
              NEXT_OBJECT_RESPONSE: "nor",
              NEXT_RANGE_RESPONSE: "nrr",
              OBJECT_DURATION: "d",
              OBJECT_TYPE: "ot",
              RESPONSE_DELAY: "rd",
              ROUND_TRIP_TIME: "rtt",
              STARTUP: "su",
              STREAM_TYPE: "st",
              STREAMING_FORMAT: "sf",
              VERSION: "v"
            }, M = {
              MANIFEST: "m",
              AUDIO: "a",
              VIDEO: "v",
              INIT: "i",
              CAPTION: "c",
              ISOBMFF_TEXT_TRACK: "tt",
              ENCRYPTION_KEY: "k",
              OTHER: "o",
              STREAM: "stream"
              // Specific value for parameters without object type, which apply for all media/objects
            }, E = [I.MAX_SUGGESTED_BITRATE, I.STREAM_TYPE, I.STREAMING_FORMAT, I.VERSION], N = {
              video: M.VIDEO,
              audio: M.AUDIO,
              text: M.ISOBMFF_TEXT_TRACK,
              stream: M.STREAM
            }, C = /^[-0-9]/;
            function b() {
              var V = this.context, J = (0, n.default)(V).getInstance(), H, z, Z, ie;
              function K() {
                z = (0, r.default)(V).getInstance().getLogger(H), ae();
              }
              function Y() {
              }
              function ne() {
              }
              function ae() {
                Z = {}, ie = {};
              }
              function fe(p) {
                p && Object.keys(p).forEach(function(P) {
                  E.includes(P) || delete p[P];
                });
              }
              function Q(p) {
                return p ? p.toLowerCase() === "false" ? !1 : C.test(p) ? parseInt(p, 10) : p.replace(/["]+/g, "") : !0;
              }
              function oe(p) {
                try {
                  for (var P = {}, k = p.split(","), X = 0; X < k.length; X++) {
                    var F = k[X].split("="), x = F[0], W = Q(F[1]);
                    P[x] = W;
                  }
                  return P;
                } catch ($) {
                  z.error("Failed to parse CMSD-Static response header value:", $);
                }
              }
              function de(p) {
                try {
                  for (var P = {}, k = p.split(","), X = k[k.length - 1], F = X.split(";"), x = 1; x < F.length; x++) {
                    var W = F[x].split("="), $ = W[0], ce = Q(W[1]);
                    P[$] = ce;
                  }
                  return P;
                } catch (le) {
                  return z.error("Failed to parse CMSD-Dynamic response header value:", le), [];
                }
              }
              function Me(p) {
                return N[p] || M.OTHER;
              }
              function ge(p, P, k) {
                var X = p === c ? Z : ie, F = X[P] || {}, x = X[M.STREAM] || {}, W = F[k] || x[k];
                return W;
              }
              function se(p, P) {
                for (var k = null, X = null, F = p.split(`\r
`), x = F.length - 1; x >= 0; x--) {
                  var W = F[x], $ = W.match(/* @__PURE__ */ d(/^((?:(?!:)[\s\S])*):[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(.*)$/, {
                    key: 1,
                    value: 2
                  }));
                  if ($ && $.groups) {
                    var ce = $.groups.key.toLowerCase(), le = $.groups.value;
                    switch (ce) {
                      case u:
                        k = oe(le), J.trigger(i.default.CMSD_STATIC_HEADER, k);
                        break;
                      case A:
                        X || (X = de(le));
                        break;
                    }
                  }
                }
                var q = M.STREAM;
                return k && k[I.OBJECT_TYPE] ? q = k[I.OBJECT_TYPE] : P && (q = Me(P)), fe(Z[q]), fe(ie[q]), k && (Z[q] = Object.assign(Z[q] || {}, k)), X && (ie[q] = Object.assign(ie[q] || {}, X)), {
                  static: k,
                  dynamic: X
                };
              }
              function ee(p) {
                var P = Me(p), k = ge(o, P, I.MAX_SUGGESTED_BITRATE);
                return k || -1;
              }
              function re(p) {
                var P = Me(p), k = ge(o, P, I.ESTIMATED_THROUGHPUT);
                return k || null;
              }
              function ue(p) {
                var P = Me(p), k = ge(o, P, I.RESPONSE_DELAY);
                return k || null;
              }
              function te(p) {
                var P = Me(p), k = ge(o, P, I.ROUND_TRIP_TIME);
                return k || null;
              }
              function O() {
                ae();
              }
              return H = {
                setConfig: ne,
                initialize: Y,
                reset: O,
                parseResponseHeaders: se,
                getMaxBitrate: ee,
                getEstimatedThroughput: re,
                getResponseDelay: ue,
                getRoundTripTime: te
              }, K(), H;
            }
            b.__dashjs_factory_name = "CmsdModel";
            const w = g.default.getSingletonFactory(b);
          }
        ),
        /***/
        "./src/streaming/models/CustomParametersModel.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/models/CustomParametersModel.js ***!
            \*******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var g = e(
              /*! ../../dash/vo/UTCTiming */
              "./src/dash/vo/UTCTiming.js"
            ), n = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), i = e(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), r = e(
              /*! ../utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            ), l = e(
              /*! ../rules/abr/ABRRulesCollection */
              "./src/streaming/rules/abr/ABRRulesCollection.js"
            ), d = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), t = !1;
            function T() {
              var h, _, L, v, c, o, y, u, A = this.context, I = (0, i.default)(A).getInstance();
              function M() {
                L = {
                  default: t
                }, E();
              }
              function E() {
                v = [], c = [], o = [], u = [], y = null, _ = [];
              }
              function N() {
                E();
              }
              function C() {
              }
              function b(P) {
                y = P;
              }
              function w() {
                y = null;
              }
              function V() {
                return y;
              }
              function J() {
                return v;
              }
              function H() {
                return c;
              }
              function z(P) {
                v.push(P);
              }
              function Z(P) {
                c.push(P);
              }
              function ie(P) {
                fe(v, P);
              }
              function K(P) {
                fe(c, P);
              }
              function Y() {
                return o;
              }
              function ne(P) {
                o.push(P);
              }
              function ae(P) {
                fe(o, P);
              }
              function fe(P, k) {
                var X = -1;
                P.some(function(F, x) {
                  if (F === k)
                    return X = x, !0;
                }), !(X < 0) && P.splice(X, 1);
              }
              function Q(P) {
                var k;
                for (k = 0; k < u.length; k++)
                  if (u[k].rulename === P)
                    return k;
                return -1;
              }
              function oe(P, k, X) {
                if (typeof P != "string" || P !== l.default.ABANDON_FRAGMENT_RULES && P !== l.default.QUALITY_SWITCH_RULES || typeof k != "string")
                  throw d.default.BAD_ARGUMENT_ERROR;
                var F = Q(k);
                F === -1 ? u.push({
                  type: P,
                  rulename: k,
                  rule: X
                }) : (u[F].type = P, u[F].rule = X);
              }
              function de(P) {
                if (P) {
                  var k = Q(P);
                  k !== -1 && u.splice(k, 1);
                } else
                  u = [];
              }
              function Me() {
                u = [];
              }
              function ge() {
                return u;
              }
              function se(P, k) {
                re(P, k);
                var X = new g.default();
                X.schemeIdUri = P, X.value = k, _.push(X);
              }
              function ee() {
                return _;
              }
              function re(P, k) {
                (0, r.checkParameterType)(P, "string"), (0, r.checkParameterType)(k, "string"), _.forEach(function(X, F) {
                  X.schemeIdUri === P && X.value === k && _.splice(F, 1);
                });
              }
              function ue() {
                _ = [];
              }
              function te() {
                var P = I.get().streaming.utcSynchronization.defaultTimingSource;
                se(P.scheme, P.value);
              }
              function O(P, k) {
                P ? L[P] = !!k : Object.keys(L).forEach(function(X) {
                  O(X, k);
                });
              }
              function p(P) {
                var k = L[P];
                return k === void 0 ? L.default : k;
              }
              return h = {
                getCustomInitialTrackSelectionFunction: V,
                setCustomInitialTrackSelectionFunction: b,
                resetCustomInitialTrackSelectionFunction: w,
                getLicenseResponseFilters: H,
                getLicenseRequestFilters: J,
                getCustomCapabilitiesFilters: Y,
                registerCustomCapabilitiesFilter: ne,
                registerLicenseResponseFilter: Z,
                registerLicenseRequestFilter: z,
                unregisterCustomCapabilitiesFilter: ae,
                unregisterLicenseResponseFilter: K,
                unregisterLicenseRequestFilter: ie,
                addAbrCustomRule: oe,
                removeAllAbrCustomRule: Me,
                removeAbrCustomRule: de,
                getAbrCustomRules: ge,
                addUTCTimingSource: se,
                removeUTCTimingSource: re,
                getUTCTimingSources: ee,
                clearDefaultUTCTimingSources: ue,
                restoreDefaultUTCTimingSources: te,
                setXHRWithCredentialsForType: O,
                getXHRWithCredentialsForType: p,
                setConfig: C,
                reset: N
              }, M(), h;
            }
            T.__dashjs_factory_name = "CustomParametersModel";
            const S = n.default.getSingletonFactory(T);
          }
        ),
        /***/
        "./src/streaming/models/FragmentModel.js": (
          /*!***********************************************!*\
            !*** ./src/streaming/models/FragmentModel.js ***!
            \***********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../vo/FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            ), i = "loading", r = "executed", l = "canceled", d = "failed";
            function t(h) {
              h = h || {};
              var _ = h.eventBus, L = h.events, v = h.dashMetrics, c = h.fragmentLoader, o = h.debug, y = h.streamInfo, u = h.type, A, I, M, E;
              function N() {
                I = o.getLogger(A), ee(), _.on(L.LOADING_COMPLETED, Me, A), _.on(L.LOADING_DATA_PROGRESS, ge, A), _.on(L.LOADING_ABANDONED, se, A);
              }
              function C() {
                return y.id;
              }
              function b() {
                return u;
              }
              function w(te) {
                var O = function(F, x) {
                  return F.action === n.default.ACTION_COMPLETE && F.action === x.action;
                }, p = function(F, x) {
                  return !isNaN(F.index) && F.startTime === x.startTime && F.adaptationIndex === x.adaptationIndex && F.type === x.type;
                }, P = function(F, x) {
                  return isNaN(F.index) && isNaN(x.index) && F.quality === x.quality;
                }, k = function(F) {
                  var x = !1;
                  return F.some(function(W) {
                    if (p(te, W) || P(te, W) || O(te, W))
                      return x = !0, x;
                  }), x;
                };
                return te ? k(M) : !1;
              }
              function V(te) {
                var O = !1, p = 0, P;
                if (O = w(te), !O)
                  for (p = 0; p < E.length; p++)
                    P = E[p], te.url === P.url && te.startTime === P.startTime && (O = !0);
                return O;
              }
              function J(te) {
                var O = te ? te.state instanceof Array ? te.state : [te.state] : [], p = [];
                return O.forEach(function(P) {
                  var k = oe(P);
                  p = p.concat(Q(k, te));
                }), p;
              }
              function H(te) {
                return isNaN(te.duration) ? 0.25 : Math.min(te.duration / 8, 0.5);
              }
              function z(te) {
                M = M.filter(function(O) {
                  var p = H(O);
                  return isNaN(O.startTime) || (te !== void 0 ? O.startTime >= te - p : !1);
                });
              }
              function Z(te) {
                M = M.filter(function(O) {
                  return isNaN(O.startTime) || (te !== void 0 ? O.startTime < te : !1);
                });
              }
              function ie(te, O) {
                O <= te + 0.5 || (M = M.filter(function(p) {
                  var P = H(p);
                  return isNaN(p.startTime) || p.startTime >= O - P || isNaN(p.duration) || p.startTime + p.duration <= te + P;
                }));
              }
              function K(te, O) {
                if (!te || te.length === 0) {
                  z();
                  return;
                }
                for (var p = 0, P = 0, k = te.length; P < k; P++)
                  ie(p, te.start(P)), p = te.end(P);
                O > 0 && ie(p, O);
              }
              function Y() {
                I.debug("abort requests"), c.abort(), E = [];
              }
              function ne(te) {
                switch (te.action) {
                  case n.default.ACTION_DOWNLOAD:
                    de(te, i), E.push(te), ae(te);
                    break;
                  default:
                    I.warn("Unknown request action.");
                }
              }
              function ae(te) {
                _.trigger(L.FRAGMENT_LOADING_STARTED, {
                  request: te
                }, {
                  streamId: y.id,
                  mediaType: u
                }), c.load(te);
              }
              function fe(te, O, p) {
                for (var P = te.length - 1, k = P; k >= 0; k--) {
                  var X = te[k], F = X.startTime, x = F + X.duration;
                  if (p = isNaN(p) ? H(X) : p, !isNaN(F) && !isNaN(x) && O + p >= F && O - p < x || isNaN(F) && isNaN(O))
                    return X;
                }
                return null;
              }
              function Q(te, O) {
                return O.hasOwnProperty("time") ? [fe(te, O.time, O.threshold)] : te.filter(function(p) {
                  for (var P in O)
                    if (P !== "state" && O.hasOwnProperty(P) && p[P] != O[P])
                      return !1;
                  return !0;
                });
              }
              function oe(te) {
                var O;
                switch (te) {
                  case i:
                    O = E;
                    break;
                  case r:
                    O = M;
                    break;
                  default:
                    O = [];
                }
                return O;
              }
              function de(te, O) {
                v.addSchedulingInfo(te, O), v.addRequestsQueue(te.mediaType, E, M);
              }
              function Me(te) {
                te.sender === c && (E.splice(E.indexOf(te.request), 1), te.response && !te.error && M.push(te.request), de(te.request, te.error ? d : r), _.trigger(L.FRAGMENT_LOADING_COMPLETED, {
                  request: te.request,
                  response: te.response,
                  error: te.error,
                  sender: this
                }, {
                  streamId: y.id,
                  mediaType: u
                }));
              }
              function ge(te) {
                te.sender === c && _.trigger(L.FRAGMENT_LOADING_PROGRESS, {
                  request: te.request,
                  response: te.response,
                  error: te.error,
                  sender: this
                }, {
                  streamId: y.id,
                  mediaType: u
                });
              }
              function se(te) {
                te.sender === c && _.trigger(L.FRAGMENT_LOADING_ABANDONED, {
                  request: te.request
                }, {
                  streamId: y.id,
                  mediaType: u
                });
              }
              function ee() {
                M = [], E = [];
              }
              function re() {
                _.off(L.LOADING_COMPLETED, Me, this), _.off(L.LOADING_DATA_PROGRESS, ge, this), _.off(L.LOADING_ABANDONED, se, this), c && c.reset(), ee();
              }
              function ue(te) {
                M.push(te);
              }
              return A = {
                getStreamId: C,
                getType: b,
                getRequests: J,
                isFragmentLoaded: w,
                isFragmentLoadedOrPending: V,
                removeExecutedRequestsBeforeTime: z,
                removeExecutedRequestsAfterTime: Z,
                syncExecutedRequestsWithBufferedRange: K,
                abortRequests: Y,
                executeRequest: ne,
                reset: re,
                resetInitialSettings: ee,
                addExecutedRequest: ue
              }, N(), A;
            }
            t.__dashjs_factory_name = "FragmentModel";
            var T = g.default.getClassFactory(t);
            T.FRAGMENT_MODEL_LOADING = i, T.FRAGMENT_MODEL_EXECUTED = r, T.FRAGMENT_MODEL_CANCELED = l, T.FRAGMENT_MODEL_FAILED = d, g.default.updateClassFactory(t.__dashjs_factory_name, T);
            const S = T;
          }
        ),
        /***/
        "./src/streaming/models/LowLatencyThroughputModel.js": (
          /*!***********************************************************!*\
            !*** ./src/streaming/models/LowLatencyThroughputModel.js ***!
            \***********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), n = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function i() {
              var l = 10, d = 0.8, t = 0.6, T = 1.05, S = 250, h = this.context, _, L, v = {};
              function c() {
                L = (0, g.default)(h).getInstance().getLogger(_);
              }
              function o(M) {
                for (var E = {}, N = 0, C = 0, b = 0, w = 0, V = M.length, J = 0; J < V; ++J)
                  N += M[J].chunkDownloadTimeRelativeMS, C += M[J].bufferLevel, b += M[J].chunkDownloadTimeRelativeMS * M[J].bufferLevel, w += M[J].chunkDownloadTimeRelativeMS * M[J].chunkDownloadTimeRelativeMS;
                return E.m = (b - N * C / V) / (w - N * N / V), E.b = C / V - E.m * N / V, function(H) {
                  return E.m * H + E.b;
                };
              }
              function y(M) {
                var E = !0, N, C = M.reduce(function(b, w) {
                  return b + w.bufferLevelAtSegmentEnd;
                }, 0) / M.length;
                return M.forEach(function(b) {
                  Math.abs(b.bufferLevelAtSegmentEnd / b.bufferLevelAtSegmentStart) < 0.95 && (E = !1), b.bufferLevelAtSegmentEnd / C < 0.8 && (E = !1), N ? N > b.bitrate && (E = !1) : N = b.bitrate;
                }), E;
              }
              function u(M) {
                var E = v[M.mediaType].slice(-1).pop(), N = v[M.mediaType].slice(-3), C = E.chunkMeasurements.slice(-1).pop().chunkDownloadTimeRelativeMS;
                E.bufferLevelAtSegmentStart = E.getEstimatedBufferLevel(C / 2), E.bufferLevelAtSegmentEnd = E.getEstimatedBufferLevel(C);
                var b = y(N), w = b ? t : d;
                if (E.isBufferStable && E.segDurationMS * T < E.fetchDownloadDurationMS)
                  return E.fetchDownloadDurationMS;
                if (!b || E.segDurationMS < E.fetchDownloadDurationMS || E.adjustedAvailabilityStartTimeMS <= E.requestTimeMS + E.throughputCapacityDelayMS - E.segDurationMS)
                  return E.fetchDownloadDurationMS * d;
                for (var V = E.requestTimeMS + E.throughputCapacityDelayMS - E.adjustedAvailabilityStartTimeMS, J = 0, H = 0, z = 0, Z = 0; Z < E.chunkMeasurements.length; Z++) {
                  var ie = E.chunkMeasurements[Z];
                  if (V < H + ie.chunkDownloadDurationMS)
                    break;
                  H += ie.chunkDownloadDurationMS, J += ie.chunkBytes, z++;
                }
                if (V < 0 && L.warn("request time was before adjusted availibitly start time"), J && H && z > E.chunkMeasurements.length * 0.2) {
                  var K = J / H, Y = E.segmentBytes / K;
                  return E.fetchDownloadDurationMS < Y ? E.fetchDownloadDurationMS * w : Y * w;
                }
                var ne = E.bitrate;
                return E.bitrateList.some(function(ae) {
                  if (ae.bandwidth > E.bitrate)
                    return ne = ae.bandwidth, !0;
                }), ne === E.bitrate ? E.fetchDownloadDurationMS * w : w * E.segmentBytes * 8 * 1e3 / ne;
              }
              function A(M, E) {
                var N = v[M.mediaType] && v[M.mediaType].slice(-3);
                return !N || N.length < 3 || !y(N) ? 0 : E / 4 > S ? S : E / 4;
              }
              function I(M, E, N, C, b) {
                M && M.mediaType && !v[M.mediaType] && (v[M.mediaType] = []);
                var w = M.mediaInfo.bitrateList.find(function(V) {
                  return V.id === M.representationId;
                });
                v[M.mediaType].push({
                  index: M.index,
                  repId: M.representationId,
                  mediaType: M.mediaType,
                  requestTimeMS: C,
                  adjustedAvailabilityStartTimeMS: M.availabilityStartTime.getTime(),
                  segDurationMS: M.duration * 1e3,
                  chunksDurationMS: N.reduce(function(V, J) {
                    return V + J.chunkDownloadDurationMS;
                  }, 0),
                  segmentBytes: N.reduce(function(V, J) {
                    return V + J.chunkBytes;
                  }, 0),
                  bitrate: w && w.bandwidth,
                  bitrateList: M.mediaInfo.bitrateList,
                  chunkMeasurements: N,
                  fetchDownloadDurationMS: E,
                  throughputCapacityDelayMS: b,
                  getEstimatedBufferLevel: o(N.slice(1))
                  // don't use first chunk's buffer level
                }), v[M.mediaType].length > l && v[M.mediaType].shift();
              }
              return _ = {
                setup: c,
                addMeasurement: I,
                getThroughputCapacityDelayMS: A,
                getEstimatedDownloadDurationMS: u
              }, c(), _;
            }
            i.__dashjs_factory_name = "LowLatencyThroughputModel";
            const r = n.default.getSingletonFactory(i);
          }
        ),
        /***/
        "./src/streaming/models/ManifestModel.js": (
          /*!***********************************************!*\
            !*** ./src/streaming/models/ManifestModel.js ***!
            \***********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), n = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), i = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function r() {
              var d = this.context, t = (0, g.default)(d).getInstance(), T, S;
              function h() {
                return S;
              }
              function _(L) {
                S = L, L && t.trigger(n.default.MANIFEST_LOADED, {
                  data: L
                });
              }
              return T = {
                getValue: h,
                setValue: _
              }, T;
            }
            r.__dashjs_factory_name = "ManifestModel";
            const l = i.default.getSingletonFactory(r);
          }
        ),
        /***/
        "./src/streaming/models/MediaPlayerModel.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/models/MediaPlayerModel.js ***!
            \**************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => c
              /* harmony export */
            });
            var g = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), n = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), i = e(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), r = 12, l = 20, d = 10, t = 5, T = 12, S = -0.5, h = 0.5, _ = -0.5, L = 1;
            function v() {
              var o, y, u, A, I = this.context, M = (0, i.default)(I).getInstance();
              function E() {
                y = (0, g.default)(I).getInstance().getLogger(o);
              }
              function N(ne) {
                ne.playbackController && (u = ne.playbackController), ne.serviceDescriptionController && (A = ne.serviceDescriptionController);
              }
              function C(ne, ae) {
                return isNaN(ne) ? 0 : ne > 0 ? (ae && y.warn("Supplied minimum playback rate is a positive value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : ne < _ ? (ae && y.warn("Supplied minimum playback rate is out of range and will be limited to ".concat(_, ": ").concat(_ * 100, "% playback speed.")), _) : ne;
              }
              function b(ne, ae) {
                return isNaN(ne) ? 0 : ne < 0 ? (ae && y.warn("Supplied maximum playback rate is a negative value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : ne > L ? (ae && y.warn("Supplied maximum playback rate is out of range and will be limited to ".concat(L, ": ").concat((1 + L) * 100, "% playback speed.")), L) : ne;
              }
              function w() {
                if (!isNaN(M.get().streaming.liveCatchup.maxDrift) && M.get().streaming.liveCatchup.maxDrift > 0)
                  return M.get().streaming.liveCatchup.maxDrift;
                var ne = A.getServiceDescriptionSettings();
                return ne && ne.liveCatchup && !isNaN(ne.liveCatchup.maxDrift) && ne.liveCatchup.maxDrift > 0 ? ne.liveCatchup.maxDrift : T;
              }
              function V(ne) {
                var ae = M.get().streaming.liveCatchup.playbackRate;
                if (!isNaN(ae.min) || !isNaN(ae.max))
                  return {
                    min: C(ae.min, ne),
                    max: b(ae.max, ne)
                  };
                var fe = A.getServiceDescriptionSettings();
                if (fe && fe.liveCatchup && (!isNaN(fe.liveCatchup.playbackRate.min) || !isNaN(fe.liveCatchup.playbackRate.max))) {
                  var Q = fe.liveCatchup.playbackRate;
                  return {
                    min: C(Q.min, ne),
                    max: b(Q.max, ne)
                  };
                }
                return {
                  min: S,
                  max: h
                };
              }
              function J() {
                return M.get().streaming.liveCatchup.enabled !== null ? M.get().streaming.liveCatchup.enabled : u.getInitialCatchupModeActivated();
              }
              function H(ne, ae) {
                try {
                  var fe = M.get().streaming.abr[ne][ae];
                  if (!isNaN(fe) && fe !== -1)
                    return fe;
                  var Q = A.getServiceDescriptionSettings();
                  return Q && Q[ne] && !isNaN(Q[ne][ae]) ? Q[ne][ae] : -1;
                } catch {
                  return -1;
                }
              }
              function z() {
                var ne = M.get().streaming.buffer.initialBufferLevel;
                return isNaN(ne) || ne < 0 ? 0 : Math.min(Z(), ne);
              }
              function Z() {
                var ne = M.get().streaming.buffer.stableBufferTime > 0 ? M.get().streaming.buffer.stableBufferTime : M.get().streaming.buffer.fastSwitchEnabled ? l : r, ae = u.getLiveDelay();
                return !isNaN(ae) && ae > 0 ? Math.min(ne, ae) : ne;
              }
              function ie(ne) {
                var ae = isNaN(M.get().streaming.retryAttempts.lowLatencyMultiplyFactor) ? t : M.get().streaming.retryAttempts.lowLatencyMultiplyFactor;
                return u.getLowLatencyModeEnabled() ? M.get().streaming.retryAttempts[ne] * ae : M.get().streaming.retryAttempts[ne];
              }
              function K(ne) {
                var ae = isNaN(M.get().streaming.retryIntervals.lowLatencyReductionFactor) ? d : M.get().streaming.retryIntervals.lowLatencyReductionFactor;
                return u.getLowLatencyModeEnabled() ? M.get().streaming.retryIntervals[ne] / ae : M.get().streaming.retryIntervals[ne];
              }
              function Y() {
              }
              return o = {
                getCatchupMaxDrift: w,
                getCatchupModeEnabled: J,
                getStableBufferTime: Z,
                getInitialBufferLevel: z,
                getRetryAttemptsForType: ie,
                getRetryIntervalsForType: K,
                getCatchupPlaybackRates: V,
                getAbrBitrateParameter: H,
                setConfig: N,
                reset: Y
              }, E(), o;
            }
            v.__dashjs_factory_name = "MediaPlayerModel";
            const c = n.default.getSingletonFactory(v);
          }
        ),
        /***/
        "./src/streaming/models/MetricsModel.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/models/MetricsModel.js ***!
            \**********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => u
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), i = e(
              /*! ../vo/MetricsList */
              "./src/streaming/vo/MetricsList.js"
            ), r = e(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), l = e(
              /*! ../vo/metrics/RepresentationSwitch */
              "./src/streaming/vo/metrics/RepresentationSwitch.js"
            ), d = e(
              /*! ../vo/metrics/BufferLevel */
              "./src/streaming/vo/metrics/BufferLevel.js"
            ), t = e(
              /*! ../vo/metrics/BufferState */
              "./src/streaming/vo/metrics/BufferState.js"
            ), T = e(
              /*! ../vo/metrics/DVRInfo */
              "./src/streaming/vo/metrics/DVRInfo.js"
            ), S = e(
              /*! ../vo/metrics/DroppedFrames */
              "./src/streaming/vo/metrics/DroppedFrames.js"
            ), h = e(
              /*! ../vo/metrics/ManifestUpdate */
              "./src/streaming/vo/metrics/ManifestUpdate.js"
            ), _ = e(
              /*! ../vo/metrics/SchedulingInfo */
              "./src/streaming/vo/metrics/SchedulingInfo.js"
            ), L = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), v = e(
              /*! ../vo/metrics/RequestsQueue */
              "./src/streaming/vo/metrics/RequestsQueue.js"
            ), c = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), o = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function y(A) {
              A = A || {};
              var I = A.settings, M = this.context, E = (0, L.default)(M).getInstance(), N, C;
              function b() {
                C = {};
              }
              function w() {
                E.trigger(c.default.METRICS_CHANGED);
              }
              function V(P) {
                E.trigger(c.default.METRIC_CHANGED, {
                  mediaType: P
                }), w();
              }
              function J(P, k, X) {
                E.trigger(c.default.METRIC_UPDATED, {
                  mediaType: P,
                  metric: k,
                  value: X
                }), V(P);
              }
              function H(P, k, X) {
                E.trigger(c.default.METRIC_ADDED, {
                  mediaType: P,
                  metric: k,
                  value: X
                }), V(P);
              }
              function z(P) {
                delete C[P], V(P);
              }
              function Z() {
                C = {}, w();
              }
              function ie(P, k) {
                var X = null;
                return P && (C.hasOwnProperty(P) ? X = C[P] : k || (X = new i.default(), C[P] = X)), X;
              }
              function K(P, k, X) {
                var F = ie(P);
                F !== null && (F[k].push(X), F[k].length > I.get().streaming.metrics.maxListDepth && F[k].shift());
              }
              function Y(P, k, X, F) {
                var x = new r.HTTPRequestTrace();
                return x.s = k, x.d = X, x.b = F, P.trace.push(x), P.interval || (P.interval = 0), P.interval += X, x;
              }
              function ne(P, k, X, F, x, W, $, ce, le, q, _e, Ee, Te, Ce, xe, be, Ge) {
                var Pe = new r.HTTPRequest();
                W && W !== F && (ne(
                  P,
                  null,
                  X,
                  F,
                  x,
                  null,
                  null,
                  ce,
                  le,
                  null,
                  // unknown
                  null,
                  // unknown
                  null,
                  // unknown, probably a 302
                  Te,
                  null,
                  null,
                  be,
                  Ge
                ), Pe.actualurl = W), Pe.tcpid = k, Pe.type = X, Pe.url = F, Pe.range = ce, Pe.trequest = le, Pe.tresponse = q, Pe.responsecode = Ee, Pe.cmsd = Ge, Pe._tfinish = _e, Pe._stream = P, Pe._mediaduration = Te, Pe._quality = x, Pe._responseHeaders = Ce, Pe._serviceLocation = $, Pe._fileLoaderType = be, xe ? xe.forEach(function(Le) {
                  Y(Pe, Le.s, Le.d, Le.b);
                }) : (delete Pe.interval, delete Pe.trace), fe(P, n.default.HTTP_REQUEST, Pe);
              }
              function ae(P, k, X, F, x) {
                var W = new l.default();
                W.t = k, W.mt = X, W.to = F, x ? W.lto = x : delete W.lto, fe(P, n.default.TRACK_SWITCH, W);
              }
              function fe(P, k, X) {
                K(P, k, X), H(P, k, X);
              }
              function Q(P, k, X) {
                var F = new d.default();
                F.t = k, F.level = X, fe(P, n.default.BUFFER_LEVEL, F);
              }
              function oe(P, k, X) {
                var F = new t.default();
                F.target = X, F.state = k, fe(P, n.default.BUFFER_STATE, F);
              }
              function de(P, k, X, F) {
                var x = new T.default();
                x.time = k, x.range = F, x.manifestInfo = X, fe(P, n.default.DVR_INFO, x);
              }
              function Me(P, k) {
                var X = new S.default(), F = ie(P).DroppedFrames;
                k && (X.time = k.creationTime, X.droppedFrames = k.droppedVideoFrames, !(F.length > 0 && F[F.length - 1] == X) && fe(P, n.default.DROPPED_FRAMES, X));
              }
              function ge(P, k, X, F, x, W, $, ce, le) {
                var q = new _.default();
                q.mediaType = P, q.t = k, q.type = X, q.startTime = F, q.availabilityStartTime = x, q.duration = W, q.quality = $, q.range = ce, q.state = le, fe(P, n.default.SCHEDULING_INFO, q);
              }
              function se(P, k, X) {
                var F = new v.default();
                F.loadingRequests = k, F.executedRequests = X, ie(P).RequestsQueue = F, H(P, n.default.REQUESTS_QUEUE, F);
              }
              function ee(P, k, X, F, x, W, $, ce, le, q) {
                var _e = new h.ManifestUpdate();
                _e.mediaType = P, _e.type = k, _e.requestTime = X, _e.fetchTime = F, _e.availabilityStartTime = x, _e.presentationStartTime = W, _e.clientTimeOffset = $, _e.currentTime = ce, _e.buffered = le, _e.latency = q, K(g.default.STREAM, n.default.MANIFEST_UPDATE, _e), H(P, n.default.MANIFEST_UPDATE, _e);
              }
              function re(P, k) {
                if (P) {
                  for (var X in k)
                    P[X] = k[X];
                  J(P.mediaType, n.default.MANIFEST_UPDATE, P);
                }
              }
              function ue(P, k, X, F, x) {
                if (P) {
                  var W = new h.ManifestUpdateStreamInfo();
                  W.id = k, W.index = X, W.start = F, W.duration = x, P.streamInfo.push(W), J(P.mediaType, n.default.MANIFEST_UPDATE_STREAM_INFO, P);
                }
              }
              function te(P, k, X, F, x, W, $, ce) {
                if (P && P.representationInfo) {
                  var le = new h.ManifestUpdateRepresentationInfo();
                  le.id = k, le.index = X, le.streamIndex = F, le.mediaType = x, le.startNumber = $, le.fragmentInfoType = ce, le.presentationTimeOffset = W, P.representationInfo.push(le), J(P.mediaType, n.default.MANIFEST_UPDATE_TRACK_INFO, P);
                }
              }
              function O(P) {
                P.trace && Array.isArray(P.trace) ? P.trace.forEach(function(k) {
                  k.hasOwnProperty("subreplevel") && !k.subreplevel && delete k.subreplevel;
                }) : delete P.trace, fe(g.default.STREAM, n.default.PLAY_LIST, P);
              }
              function p(P) {
                fe(g.default.STREAM, n.default.DVB_ERRORS, P);
              }
              return N = {
                clearCurrentMetricsForType: z,
                clearAllCurrentMetrics: Z,
                getMetricsFor: ie,
                addHttpRequest: ne,
                addRepresentationSwitch: ae,
                addBufferLevel: Q,
                addBufferState: oe,
                addDVRInfo: de,
                addDroppedFrames: Me,
                addSchedulingInfo: ge,
                addRequestsQueue: se,
                addManifestUpdate: ee,
                updateManifestUpdateInfo: re,
                addManifestUpdateStreamInfo: ue,
                addManifestUpdateRepresentationInfo: te,
                addPlayList: O,
                addDVBErrors: p
              }, b(), N;
            }
            y.__dashjs_factory_name = "MetricsModel";
            const u = o.default.getSingletonFactory(y);
          }
        ),
        /***/
        "./src/streaming/models/URIFragmentModel.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/models/URIFragmentModel.js ***!
            \**************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../vo/URIFragmentData */
              "./src/streaming/vo/URIFragmentData.js"
            ), n = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function i() {
              var l, d;
              function t(S) {
                if (d = new g.default(), !S)
                  return null;
                var h = S.indexOf("#");
                if (h !== -1)
                  for (var _ = S.substr(h + 1).split("&"), L = 0, v = _.length; L < v; ++L) {
                    var c = _[L], o = c.indexOf("=");
                    if (o !== -1) {
                      var y = c.substring(0, o);
                      d.hasOwnProperty(y) && (d[y] = c.substr(o + 1));
                    }
                  }
              }
              function T() {
                return d;
              }
              return l = {
                initialize: t,
                getURIFragmentData: T
              }, l;
            }
            i.__dashjs_factory_name = "URIFragmentModel";
            const r = n.default.getSingletonFactory(i);
          }
        ),
        /***/
        "./src/streaming/models/VideoModel.js": (
          /*!********************************************!*\
            !*** ./src/streaming/models/VideoModel.js ***!
            \********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), i = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), r = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), l = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), d = /* @__PURE__ */ new Map([[l.default.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, "loadedmetadata"], [l.default.VIDEO_ELEMENT_READY_STATES.HAVE_CURRENT_DATA, "loadeddata"], [l.default.VIDEO_ELEMENT_READY_STATES.HAVE_FUTURE_DATA, "canplay"], [l.default.VIDEO_ELEMENT_READY_STATES.HAVE_ENOUGH_DATA, "canplaythrough"]]);
            function t() {
              var S, h, _, L, v, c, o = "element is not video or audio DOM type!", y = this.context, u = (0, n.default)(y).getInstance(), A = [];
              function I() {
                h = (0, r.default)(y).getInstance().getLogger(S), L = NaN;
              }
              function M() {
                u.on(i.default.PLAYBACK_PLAYING, de, this);
              }
              function E() {
                u.off(i.default.PLAYBACK_PLAYING, de, this);
              }
              function N() {
                _ && (_.playbackRate = 1, _.removeEventListener("canplay", N));
              }
              function C(Pe) {
                var Le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                _ && (!Le && _.readyState <= 2 && Pe > 0 ? _.addEventListener("canplay", N) : _.playbackRate = Pe);
              }
              function b(Pe, Le) {
                _ && (L = Pe, be(l.default.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                  if (_.currentTime === L) {
                    L = NaN;
                    return;
                  }
                  try {
                    L = Le ? w(L) : L, _.currentTime = L, L = NaN;
                  } catch (je) {
                    _.readyState === 0 && je.code === je.INVALID_STATE_ERR && setTimeout(function() {
                      _.currentTime = L, L = NaN;
                    }, 400);
                  }
                }));
              }
              function w(Pe) {
                var Le = F(), je = Pe, Ze = 9999999999;
                if (Le)
                  for (var nt = 0; nt < Le.length; nt++) {
                    var it = Le.start(nt), De = Le.end(nt), Ye = Math.abs(it - Pe), Ke = Math.abs(De - Pe);
                    if (Pe >= it && Pe <= De)
                      return Pe;
                    Ye < Ze && (Ze = Ye, je = it), Ke < Ze && (Ze = Ke, je = De);
                  }
                return je;
              }
              function V() {
                return _;
              }
              function J(Pe) {
                if (Pe == null || Pe && /^(VIDEO|AUDIO)$/i.test(Pe.nodeName))
                  _ = Pe, _ && (_.preload = "auto");
                else
                  throw o;
              }
              function H(Pe) {
                _ && (Pe ? _.src = Pe : (_.removeAttribute("src"), _.load()));
              }
              function z() {
                return _ ? _.src : null;
              }
              function Z() {
                return v;
              }
              function ie() {
                return c;
              }
              function K(Pe) {
                v = Pe, v.style.position = "absolute", v.style.display = "flex", v.style.overflow = "hidden", v.style.pointerEvents = "none", v.style.top = 0, v.style.left = 0;
              }
              function Y(Pe) {
                c = Pe;
              }
              function ne(Pe, Le) {
                oe(Pe, Le);
              }
              function ae() {
                return A.length > 0;
              }
              function fe(Pe) {
                Pe === null || !_ || _.seeking || A.indexOf(Pe) !== -1 || A.push(Pe);
              }
              function Q(Pe) {
                var Le = A.indexOf(Pe);
                Pe !== null && Le !== -1 && A.splice(Le, 1);
              }
              function oe(Pe, Le) {
                Le ? fe(Pe) : Q(Pe);
              }
              function de() {
                if (_ && ae() && _.playbackRate === 0) {
                  var Pe = document.createEvent("Event");
                  Pe.initEvent("waiting", !0, !1), _.dispatchEvent(Pe);
                }
              }
              function Me() {
                if (!_)
                  return null;
                var Pe = "webkitDroppedFrameCount" in _ && "webkitDecodedFrameCount" in _, Le = "getVideoPlaybackQuality" in _, je = null;
                return Le ? je = _.getVideoPlaybackQuality() : Pe && (je = {
                  droppedVideoFrames: _.webkitDroppedFrameCount,
                  totalVideoFrames: _.webkitDroppedFrameCount + _.webkitDecodedFrameCount,
                  creationTime: /* @__PURE__ */ new Date()
                }), je;
              }
              function ge() {
                if (_) {
                  _.autoplay = !0;
                  var Pe = _.play();
                  Pe && Pe.catch && typeof Promise < "u" && Pe.catch(function(Le) {
                    Le.name === "NotAllowedError" && u.trigger(i.default.PLAYBACK_NOT_ALLOWED), h.warn("Caught pending play exception - continuing (".concat(Le, ")"));
                  });
                }
              }
              function se() {
                return _ ? _.paused : null;
              }
              function ee() {
                _ && (_.pause(), _.autoplay = !1);
              }
              function re() {
                return _ ? _.seeking || !isNaN(L) : null;
              }
              function ue() {
                return _ ? isNaN(L) ? _.currentTime : L : null;
              }
              function te() {
                return _ ? _.playbackRate : null;
              }
              function O() {
                return _ ? _.played : null;
              }
              function p() {
                return _ ? _.ended : null;
              }
              function P(Pe, Le) {
                _ && _.addEventListener(Pe, Le);
              }
              function k(Pe, Le) {
                _ && _.removeEventListener(Pe, Le);
              }
              function X() {
                return _ ? _.readyState : NaN;
              }
              function F() {
                return _ ? _.buffered : null;
              }
              function x() {
                return _ ? _.clientWidth : NaN;
              }
              function W() {
                return _ ? _.clientHeight : NaN;
              }
              function $() {
                return _ ? _.videoWidth : NaN;
              }
              function ce() {
                return _ ? _.videoHeight : NaN;
              }
              function le() {
                var Pe = _.parentNode.host || _.parentNode;
                return Pe ? _.getBoundingClientRect().top - Pe.getBoundingClientRect().top : NaN;
              }
              function q() {
                var Pe = _.parentNode.host || _.parentNode;
                return Pe ? _.getBoundingClientRect().left - Pe.getBoundingClientRect().left : NaN;
              }
              function _e() {
                return _ ? _.textTracks : [];
              }
              function Ee(Pe, Le, je, Ze, nt) {
                if (_) {
                  for (var it = 0; it < _.textTracks.length; it++)
                    if (_.textTracks[it].kind === Pe && (!Le || _.textTracks[it].label == Le) && _.textTracks[it].language === je && _.textTracks[it].isTTML === Ze && _.textTracks[it].isEmbedded === nt)
                      return _.textTracks[it];
                }
                return null;
              }
              function Te(Pe, Le, je, Ze, nt) {
                if (!_)
                  return null;
                var it = Ee(Pe, Le, je, Ze, nt);
                return it || (it = _.addTextTrack(Pe, Le, je), it.isEmbedded = nt, it.isTTML = Ze), it;
              }
              function Ce(Pe) {
                _ && (_.appendChild(Pe), Pe.isTTML !== void 0 && (_.textTracks[_.textTracks.length - 1].isTTML = Pe.isTTML, _.textTracks[_.textTracks.length - 1].isEmbedded = Pe.isEmbedded));
              }
              function xe(Pe) {
                _ && _.removeChild(Pe);
              }
              function be(Pe, Le) {
                if (Pe === l.default.VIDEO_ELEMENT_READY_STATES.HAVE_NOTHING || X() >= Pe)
                  Le();
                else {
                  var je = d.get(Pe);
                  Ge(je, Le);
                }
              }
              function Ge(Pe, Le) {
                var je = function Ze() {
                  k(Pe, Ze), Le(Pe);
                };
                P(Pe, je);
              }
              return S = {
                initialize: M,
                setCurrentTime: b,
                play: ge,
                isPaused: se,
                pause: ee,
                isStalled: ae,
                isSeeking: re,
                getTime: ue,
                getPlaybackRate: te,
                setPlaybackRate: C,
                getPlayedRanges: O,
                getEnded: p,
                setStallState: ne,
                getElement: V,
                setElement: J,
                setSource: H,
                getSource: z,
                getTTMLRenderingDiv: Z,
                setTTMLRenderingDiv: K,
                getVttRenderingDiv: ie,
                setVttRenderingDiv: Y,
                getPlaybackQuality: Me,
                addEventListener: P,
                removeEventListener: k,
                getReadyState: X,
                getBufferRange: F,
                getClientWidth: x,
                getClientHeight: W,
                getTextTracks: _e,
                getTextTrack: Ee,
                addTextTrack: Te,
                appendChild: Ce,
                removeChild: xe,
                getVideoWidth: $,
                getVideoHeight: ce,
                getVideoRelativeOffsetTop: le,
                getVideoRelativeOffsetLeft: q,
                waitForReadyState: be,
                reset: E
              }, I(), S;
            }
            t.__dashjs_factory_name = "VideoModel";
            const T = g.default.getSingletonFactory(t);
          }
        ),
        /***/
        "./src/streaming/net/FetchLoader.js": (
          /*!******************************************!*\
            !*** ./src/streaming/net/FetchLoader.js ***!
            \******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => c
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), i = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), r = e(
              /*! ../utils/RequestModifier */
              "./src/streaming/utils/RequestModifier.js"
            );
            function l(o, y) {
              return T(o) || t(o, y) || h(o, y) || d();
            }
            function d() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function t(o, y) {
              if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(o)))) {
                var u = [], A = !0, I = !1, M = void 0;
                try {
                  for (var E = o[Symbol.iterator](), N; !(A = (N = E.next()).done) && (u.push(N.value), !(y && u.length === y)); A = !0)
                    ;
                } catch (C) {
                  I = !0, M = C;
                } finally {
                  try {
                    !A && E.return != null && E.return();
                  } finally {
                    if (I)
                      throw M;
                  }
                }
                return u;
              }
            }
            function T(o) {
              if (Array.isArray(o))
                return o;
            }
            function S(o, y) {
              var u;
              if (typeof Symbol > "u" || o[Symbol.iterator] == null) {
                if (Array.isArray(o) || (u = h(o)) || y && o && typeof o.length == "number") {
                  u && (o = u);
                  var A = 0, I = function() {
                  };
                  return { s: I, n: function() {
                    return A >= o.length ? { done: !0 } : { done: !1, value: o[A++] };
                  }, e: function(b) {
                    throw b;
                  }, f: I };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              var M = !0, E = !1, N;
              return { s: function() {
                u = o[Symbol.iterator]();
              }, n: function() {
                var b = u.next();
                return M = b.done, b;
              }, e: function(b) {
                E = !0, N = b;
              }, f: function() {
                try {
                  !M && u.return != null && u.return();
                } finally {
                  if (E)
                    throw N;
                }
              } };
            }
            function h(o, y) {
              if (o) {
                if (typeof o == "string")
                  return _(o, y);
                var u = Object.prototype.toString.call(o).slice(8, -1);
                if (u === "Object" && o.constructor && (u = o.constructor.name), u === "Map" || u === "Set")
                  return Array.from(o);
                if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u))
                  return _(o, y);
              }
            }
            function _(o, y) {
              (y == null || y > o.length) && (y = o.length);
              for (var u = 0, A = new Array(y); u < y; u++)
                A[u] = o[u];
              return A;
            }
            function L(o) {
              o = o || {};
              var y = this.context, u = o.requestModifier, A = o.lowLatencyThroughputModel, I = o.boxParser, M = (0, n.default)(y).getInstance(), E, N;
              function C(ie) {
                N = ie.dashMetrics;
              }
              function b(ie) {
                u && u.modifyRequest ? (0, r.modifyRequest)(ie, u).then(function() {
                  return w(ie);
                }) : w(ie);
              }
              function w(ie) {
                var K = /* @__PURE__ */ new Date(), Y = ie.request, ne = new Headers();
                if (Y.range && ne.append("Range", "bytes=" + Y.range), ie.headers)
                  for (var ae in ie.headers) {
                    var fe = ie.headers[ae];
                    fe && ne.append(ae, fe);
                  }
                Y.requestStartDate || (Y.requestStartDate = K), u && u.modifyRequestHeader && u.modifyRequestHeader({
                  setRequestHeader: function(ee, re) {
                    ne.append(ee, re);
                  }
                }, {
                  url: ie.url
                });
                var Q;
                typeof window.AbortController == "function" && (Q = new AbortController(), ie.abortController = Q, Q.signal.onabort = ie.onabort);
                var oe = {
                  method: ie.method,
                  headers: ne,
                  credentials: ie.withCredentials ? "include" : void 0,
                  signal: Q ? Q.signal : void 0
                }, de = M.get().streaming.abr.fetchThroughputCalculationMode, Me = Date.now(), ge = 0;
                new Promise(function(se) {
                  if (de === i.default.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && A && (ge = A.getThroughputCapacityDelayMS(Y, N.getCurrentBufferLevel(Y.mediaType) * 1e3), ge))
                    return setTimeout(se, ge);
                  se();
                }).then(function() {
                  var se = Date.now();
                  fetch(ie.url, oe).then(function(ee) {
                    ie.response || (ie.response = {}), ie.response.status = ee.status, ie.response.statusText = ee.statusText, ie.response.responseURL = ee.url, ee.ok || ie.onerror();
                    var re = "", ue = S(ee.headers.keys()), te;
                    try {
                      for (ue.s(); !(te = ue.n()).done; ) {
                        var O = te.value;
                        re += O + ": " + ee.headers.get(O) + `\r
`;
                      }
                    } catch (Ge) {
                      ue.e(Ge);
                    } finally {
                      ue.f();
                    }
                    if (ie.response.responseHeaders = re, !ee.body)
                      return ee.arrayBuffer().then(function(Ge) {
                        ie.response.response = Ge;
                        var Pe = {
                          loaded: Ge.byteLength,
                          total: Ge.byteLength,
                          stream: !1
                        };
                        ie.progress(Pe), ie.onload(), ie.onend();
                      });
                    var p = parseInt(ee.headers.get("Content-Length"), 10), P = 0, k = !1, X = new Uint8Array(), F = 0;
                    if (de === i.default.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && A) {
                      var x = function(Pe) {
                        var Le = Pe.getReader(), je = [];
                        Le.read().then(function Ze(nt) {
                          var it = nt.value, De = nt.done;
                          if ($ = Date.now(), it && it.length) {
                            var Ye = $ - W, Ke = it.length;
                            je.push({
                              chunkDownloadTimeRelativeMS: $ - se,
                              chunkDownloadDurationMS: Ye,
                              chunkBytes: Ke,
                              kbps: Math.round(8 * Ke / (Ye / 1e3)),
                              bufferLevel: N.getCurrentBufferLevel(Y.mediaType)
                            });
                          }
                          if (De) {
                            var tt = $ - se, st = je.reduce(function(Et, ht) {
                              return Et + ht.chunkBytes;
                            }, 0);
                            A.addMeasurement(Y, tt, je, Me, ge, re), ie.progress({
                              loaded: st,
                              total: st,
                              lengthComputable: !0,
                              time: A.getEstimatedDownloadDurationMS(Y),
                              stream: !0
                            });
                            return;
                          }
                          return W = Date.now(), Le.read().then(Ze);
                        });
                      }, W = se, $ = 0, ce = ee.body.tee(), le = l(ce, 2), q = le[0], _e = le[1];
                      x(q), ie.reader = _e.getReader();
                    } else
                      ie.reader = ee.body.getReader();
                    var Ee = [], Te = [], Ce = [], xe = !0, be = function Ge(Pe) {
                      var Le = Pe.value, je = Pe.done;
                      if (je) {
                        if (X) {
                          if (de !== i.default.ABR_FETCH_THROUGHPUT_CALCULATION_AAST) {
                            var Ze = null, nt = null;
                            de === i.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING ? (Ze = Z(Te, Ce), Ze && (nt = P * 8 / Ze)) : de === i.default.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA && (nt = z(Ee, P)), ie.progress({
                              loaded: P,
                              total: isNaN(p) ? P : p,
                              lengthComputable: !0,
                              time: nt,
                              stream: !0
                            });
                          }
                          ie.response.response = X.buffer;
                        }
                        ie.onload(), ie.onend();
                        return;
                      }
                      if (Le && Le.length > 0) {
                        if (X = J(X, Le), P += Le.length, Ee.push({
                          ts: Date.now(),
                          bytes: Le.length
                        }), de === i.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING && xe) {
                          var it = I.findLastTopIsoBoxCompleted(["moof"], X, F);
                          it.found && (xe = !1, Te.push({
                            ts: performance.now(),
                            /* jshint ignore:line */
                            bytes: Le.length
                          }));
                        }
                        var De = I.findLastTopIsoBoxCompleted(["moov", "mdat"], X, F);
                        if (De.found) {
                          var Ye = De.lastCompletedOffset + De.size;
                          de === i.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING && !xe && (xe = !0, Ce.push({
                            ts: performance.now(),
                            /* jshint ignore:line */
                            bytes: X.length
                          }));
                          var Ke;
                          Ye === X.length ? (Ke = X, X = new Uint8Array()) : (Ke = new Uint8Array(X.subarray(0, Ye)), X = X.subarray(Ye)), ie.progress({
                            data: Ke.buffer,
                            lengthComputable: !1,
                            noTrace: !0
                          }), F = 0;
                        } else
                          F = De.lastCompletedOffset, k || (ie.progress({
                            lengthComputable: !1,
                            noTrace: !0
                          }), k = !0);
                      }
                      V(ie, Ge);
                    };
                    V(ie, be);
                  }).catch(function(ee) {
                    ie.onerror && ie.onerror(ee);
                  });
                });
              }
              function V(ie, K) {
                ie.reader.read().then(K).catch(function(Y) {
                  ie.onerror && ie.response.status === 200 && ie.onerror(Y);
                });
              }
              function J(ie, K) {
                if (ie.length === 0)
                  return K;
                var Y = new Uint8Array(ie.length + K.length);
                return Y.set(ie), Y.set(K, ie.length), Y;
              }
              function H(ie) {
                if (ie.abortController)
                  ie.abortController.abort();
                else if (ie.reader)
                  try {
                    ie.reader.cancel(), ie.onabort();
                  } catch {
                  }
              }
              function z(ie, K) {
                try {
                  if (ie = ie.filter(function(ae) {
                    return ae.bytes > K / 4 / ie.length;
                  }), ie.length > 1) {
                    var Y = 0, ne = (ie[ie.length - 1].ts - ie[0].ts) / ie.length;
                    return ie.forEach(function(ae, fe) {
                      var Q = ie[fe + 1];
                      if (Q) {
                        var oe = Q.ts - ae.ts;
                        Y += oe < ne ? oe : 0;
                      }
                    }), Y;
                  }
                  return null;
                } catch {
                  return null;
                }
              }
              function Z(ie, K) {
                try {
                  var Y, ne;
                  Y = ie.filter(function(se, ee) {
                    return ee < ie.length - 1;
                  }), ne = K.filter(function(se, ee) {
                    return ee < K.length - 1;
                  });
                  var ae = [];
                  if (Y.length > 1) {
                    for (var fe = 0, Q = 0, oe = 0; oe < Y.length; oe++)
                      if (Y[oe] && ne[oe]) {
                        var de = ne[oe].ts - Y[oe].ts;
                        if (de > 1)
                          ae.push(8 * ne[oe].bytes / de);
                        else {
                          Q === 0 && (Q = Y[oe].ts);
                          var Me = ne[oe].ts - Q;
                          Me > 1 ? (ae.push(8 * fe / Me), fe = 0, Q = 0) : fe += ne[oe].bytes;
                        }
                      }
                    if (ae.length > 0) {
                      var ge = ae.reduce(function(se, ee) {
                        return se + ee;
                      }, 0);
                      return ge / ae.length;
                    }
                  }
                  return null;
                } catch {
                  return null;
                }
              }
              return E = {
                load: b,
                abort: H,
                calculateDownloadedTime: z,
                setup: C
              }, E;
            }
            L.__dashjs_factory_name = "FetchLoader";
            var v = g.default.getClassFactory(L);
            const c = v;
          }
        ),
        /***/
        "./src/streaming/net/HTTPLoader.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/net/HTTPLoader.js ***!
            \*****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => I
              /* harmony export */
            });
            var g = e(
              /*! ./XHRLoader */
              "./src/streaming/net/XHRLoader.js"
            ), n = e(
              /*! ./FetchLoader */
              "./src/streaming/net/FetchLoader.js"
            ), i = e(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), r = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), l = e(
              /*! ../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), d = e(
              /*! ../models/CmcdModel */
              "./src/streaming/models/CmcdModel.js"
            ), t = e(
              /*! ../models/CmsdModel */
              "./src/streaming/models/CmsdModel.js"
            ), T = e(
              /*! ../../core/Utils */
              "./src/core/Utils.js"
            ), S = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), h = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), _ = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), L = e(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), v = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), c = e(
              /*! ../models/LowLatencyThroughputModel */
              "./src/streaming/models/LowLatencyThroughputModel.js"
            ), o = e(
              /*! ../models/CustomParametersModel */
              "./src/streaming/models/CustomParametersModel.js"
            );
            function y(M, E, N) {
              return E in M ? Object.defineProperty(M, E, { value: N, enumerable: !0, configurable: !0, writable: !0 }) : M[E] = N, M;
            }
            function u(M) {
              M = M || {};
              var E = this.context, N = M.errHandler, C = M.dashMetrics, b = M.mediaPlayerModel, w = M.requestModifier, V = M.boxParser, J = M.errors, H = M.requestTimeout || 0, z = (0, h.default)(E).getInstance(), Z = (0, L.default)(E).getInstance(), ie, K, Y, ne, ae, fe, Q, oe, de, Me;
              function ge() {
                var te;
                Me = (0, S.default)(E).getInstance().getLogger(ie), K = [], Y = [], ne = [], fe = (0, d.default)(E).getInstance(), Q = (0, t.default)(E).getInstance(), de = (0, c.default)(E).getInstance(), oe = (0, o.default)(E).getInstance(), ae = (te = {}, y(te, i.HTTPRequest.MPD_TYPE, J.DOWNLOAD_ERROR_ID_MANIFEST_CODE), y(te, i.HTTPRequest.XLINK_EXPANSION_TYPE, J.DOWNLOAD_ERROR_ID_XLINK_CODE), y(te, i.HTTPRequest.INIT_SEGMENT_TYPE, J.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE), y(te, i.HTTPRequest.MEDIA_SEGMENT_TYPE, J.DOWNLOAD_ERROR_ID_CONTENT_CODE), y(te, i.HTTPRequest.INDEX_SEGMENT_TYPE, J.DOWNLOAD_ERROR_ID_CONTENT_CODE), y(te, i.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, J.DOWNLOAD_ERROR_ID_CONTENT_CODE), y(te, i.HTTPRequest.OTHER_TYPE, J.DOWNLOAD_ERROR_ID_CONTENT_CODE), te);
              }
              function se(te, O) {
                var p = te.request, P = [], k = !0, X = !0, F = /* @__PURE__ */ new Date(), x = F, W = 0, $ = null, ce;
                if (!w || !C || !N)
                  throw new Error("config object is not correct or missing");
                var le = function(Ye) {
                  if (X = !1, p.requestStartDate = F, p.requestEndDate = /* @__PURE__ */ new Date(), p.firstByteDate = p.firstByteDate || F, p.fileLoaderType = $, !p.checkExistenceOnly) {
                    var Ke = ce.response ? ce.response.responseURL : null, tt = ce.response ? ce.response.status : null, st = ce.response && ce.response.getAllResponseHeaders ? ce.response.getAllResponseHeaders() : ce.response ? ce.response.responseHeaders : null, Et = Z.get().streaming.cmsd && Z.get().streaming.cmsd.enabled ? Q.parseResponseHeaders(st, p.mediaType) : null;
                    C.addHttpRequest(p, Ke, tt, st, Ye ? P : null, Et), p.type === i.HTTPRequest.MPD_TYPE && C.addManifestUpdate(p);
                  }
                }, q = function() {
                  if (K.indexOf(ce) !== -1 && (K.splice(K.indexOf(ce), 1), X))
                    if (le(!1), O > 0) {
                      try {
                        if (Z.get().streaming.utcSynchronization.enableBackgroundSyncAfterSegmentDownloadError && p.type === i.HTTPRequest.MEDIA_SEGMENT_TYPE) {
                          var Ye = b.getRetryAttemptsForType(i.HTTPRequest.MEDIA_SEGMENT_TYPE);
                          Ye === O && z.trigger(_.default.ATTEMPT_BACKGROUND_SYNC);
                        }
                      } catch {
                      }
                      O--;
                      var Ke = {
                        config: te
                      };
                      ne.push(Ke), Ke.timeout = setTimeout(function() {
                        ne.indexOf(Ke) !== -1 && (ne.splice(ne.indexOf(Ke), 1), se(te, O));
                      }, b.getRetryIntervalsForType(p.type));
                    } else {
                      if (p.type === i.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE)
                        return;
                      N.error(new l.default(ae[p.type], p.url + " is not available", {
                        request: p,
                        response: ce.response
                      })), te.error && te.error(p, "error", ce.response.statusText), te.complete && te.complete(p, ce.response.statusText);
                    }
                }, _e = function(Ye) {
                  var Ke = /* @__PURE__ */ new Date();
                  k && (k = !1, (!Ye.lengthComputable || Ye.lengthComputable && Ye.total !== Ye.loaded) && (p.firstByteDate = Ke)), Ye.lengthComputable && (p.bytesLoaded = Ye.loaded, p.bytesTotal = Ye.total), Ye.noTrace || (P.push({
                    s: x,
                    d: Ye.time ? Ye.time : Ke.getTime() - x.getTime(),
                    b: [Ye.loaded ? Ye.loaded - W : 0]
                  }), x = Ke, W = Ye.loaded), te.progress && Ye && te.progress(Ye);
                }, Ee = function() {
                  ce.response.status >= 200 && ce.response.status <= 299 && (le(!0), te.success && te.success(ce.response.response, ce.response.statusText, ce.response.responseURL), te.complete && te.complete(p, ce.response.statusText));
                }, Te = function() {
                  te.abort && te.abort(p);
                }, Ce = function(Ye) {
                  var Ke;
                  if (Ye.lengthComputable) {
                    var tt = Ye.loaded / Ye.total * 100;
                    Ke = "Request timeout: loaded: " + Ye.loaded + ", out of: " + Ye.total + " : " + tt.toFixed(3) + "% Completed";
                  } else
                    Ke = "Request timeout: non-computable download size";
                  Me.warn(Ke);
                }, xe;
                p.hasOwnProperty("availabilityTimeComplete") && p.availabilityTimeComplete === !1 && window.fetch && p.responseType === "arraybuffer" && p.type === i.HTTPRequest.MEDIA_SEGMENT_TYPE ? (xe = (0, n.default)(E).create({
                  requestModifier: w,
                  lowLatencyThroughputModel: de,
                  boxParser: V
                }), xe.setup({
                  dashMetrics: C
                }), $ = v.default.FILE_LOADER_TYPES.FETCH) : (xe = (0, g.default)(E).create({
                  requestModifier: w
                }), $ = v.default.FILE_LOADER_TYPES.XHR);
                var be = null, Ge = w.modifyRequestURL ? w.modifyRequestURL(p.url) : p.url;
                if (Z.get().streaming.cmcd && Z.get().streaming.cmcd.enabled) {
                  var Pe = Z.get().streaming.cmcd.mode;
                  if (Pe === v.default.CMCD_MODE_QUERY) {
                    var Le = ee(p);
                    Ge = T.default.addAditionalQueryParameterToUrl(Ge, Le);
                  } else
                    Pe === v.default.CMCD_MODE_HEADER && (be = fe.getHeaderParameters(p));
                }
                p.url = Ge;
                var je = p.checkExistenceOnly ? i.HTTPRequest.HEAD : i.HTTPRequest.GET, Ze = oe.getXHRWithCredentialsForType(p.type);
                ce = {
                  url: Ge,
                  method: je,
                  withCredentials: Ze,
                  request: p,
                  onload: Ee,
                  onend: q,
                  onerror: q,
                  progress: _e,
                  onabort: Te,
                  ontimeout: Ce,
                  loader: xe,
                  timeout: H,
                  headers: be
                };
                var nt = (/* @__PURE__ */ new Date()).getTime();
                if (isNaN(p.delayLoadingTime) || nt >= p.delayLoadingTime)
                  K.push(ce), xe.load(ce);
                else {
                  var it = {
                    httpRequest: ce
                  };
                  Y.push(it), it.delayTimeout = setTimeout(function() {
                    if (Y.indexOf(it) !== -1) {
                      Y.splice(Y.indexOf(it), 1);
                      try {
                        F = /* @__PURE__ */ new Date(), x = F, K.push(it.httpRequest), xe.load(it.httpRequest);
                      } catch {
                        it.httpRequest.onerror();
                      }
                    }
                  }, p.delayLoadingTime - nt);
                }
              }
              function ee(te) {
                try {
                  var O = [], p = fe.getQueryParameter(te);
                  return p && O.push(p), O;
                } catch {
                  return [];
                }
              }
              function re(te) {
                te.request ? se(te, b.getRetryAttemptsForType(te.request.type)) : te.error && te.error(te.request, "error");
              }
              function ue() {
                ne.forEach(function(te) {
                  clearTimeout(te.timeout), te.config.request && te.config.abort && te.config.abort(te.config.request);
                }), ne = [], Y.forEach(function(te) {
                  return clearTimeout(te.delayTimeout);
                }), Y = [], K.forEach(function(te) {
                  te.request.type !== i.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE && (te.onloadend = te.onerror = te.onprogress = void 0, te.loader.abort(te));
                }), K = [];
              }
              return ie = {
                load: re,
                abort: ue
              }, ge(), ie;
            }
            u.__dashjs_factory_name = "HTTPLoader";
            var A = r.default.getClassFactory(u);
            const I = A;
          }
        ),
        /***/
        "./src/streaming/net/SchemeLoaderFactory.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/net/SchemeLoaderFactory.js ***!
            \**************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../streaming/net/HTTPLoader */
              "./src/streaming/net/HTTPLoader.js"
            );
            function i() {
              var d, t;
              function T(c, o) {
                t[c] = o;
              }
              function S(c) {
                t[c] && delete t[c];
              }
              function h() {
                t = {};
              }
              function _(c) {
                for (var o in t)
                  if (t.hasOwnProperty(o) && c.startsWith(o))
                    return t[o];
                return n.default;
              }
              function L() {
                h();
              }
              function v() {
                L();
              }
              return v(), d = {
                getLoader: _,
                registerLoader: T,
                unregisterLoader: S,
                unregisterAllLoader: h,
                reset: L
              }, d;
            }
            i.__dashjs_factory_name = "SchemeLoaderFactory";
            var r = g.default.getSingletonFactory(i);
            const l = r;
          }
        ),
        /***/
        "./src/streaming/net/URLLoader.js": (
          /*!****************************************!*\
            !*** ./src/streaming/net/URLLoader.js ***!
            \****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../streaming/net/SchemeLoaderFactory */
              "./src/streaming/net/SchemeLoaderFactory.js"
            );
            function i(d) {
              d = d || {};
              var t = this.context, T, S, h;
              S = (0, n.default)(t).getInstance();
              function _(v) {
                if (!h) {
                  var c = S.getLoader(v && v.request ? v.request.url : null);
                  h = c(t).create({
                    errHandler: d.errHandler,
                    mediaPlayerModel: d.mediaPlayerModel,
                    requestModifier: d.requestModifier,
                    dashMetrics: d.dashMetrics,
                    boxParser: d.boxParser ? d.boxParser : null,
                    constants: d.constants ? d.constants : null,
                    dashConstants: d.dashConstants ? d.dashConstants : null,
                    urlUtils: d.urlUtils ? d.urlUtils : null,
                    requestTimeout: isNaN(d.requestTimeout) ? 0 : d.requestTimeout,
                    errors: d.errors
                  });
                }
                h.load(v);
              }
              function L() {
                h && h.abort();
              }
              return T = {
                load: _,
                abort: L
              }, T;
            }
            i.__dashjs_factory_name = "URLLoader";
            var r = g.default.getClassFactory(i);
            const l = r;
          }
        ),
        /***/
        "./src/streaming/net/XHRLoader.js": (
          /*!****************************************!*\
            !*** ./src/streaming/net/XHRLoader.js ***!
            \****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../utils/RequestModifier */
              "./src/streaming/utils/RequestModifier.js"
            );
            function i(d) {
              d = d || {};
              var t = d.requestModifier, T;
              function S(L) {
                t && t.modifyRequest ? (0, n.modifyRequest)(L, t).then(function() {
                  return h(L);
                }) : h(L);
              }
              function h(L) {
                var v = /* @__PURE__ */ new Date(), c = L.request, o = new XMLHttpRequest();
                if (o.open(L.method, L.url, !0), c.responseType && (o.responseType = c.responseType), c.range && o.setRequestHeader("Range", "bytes=" + c.range), c.requestStartDate || (c.requestStartDate = v), t && t.modifyRequestHeader && (o = t.modifyRequestHeader(o, {
                  url: L.url
                })), L.headers)
                  for (var y in L.headers) {
                    var u = L.headers[y];
                    u && o.setRequestHeader(y, u);
                  }
                o.withCredentials = L.withCredentials, o.onload = L.onload, o.onloadend = L.onend, o.onerror = L.onerror, o.onprogress = L.progress, o.onabort = L.onabort, o.ontimeout = L.ontimeout, o.timeout = L.timeout, o.send(), L.response = o;
              }
              function _(L) {
                var v = L.response;
                v.onloadend = v.onerror = v.onprogress = void 0, v.abort();
              }
              return T = {
                load: S,
                abort: _
              }, T;
            }
            i.__dashjs_factory_name = "XHRLoader";
            var r = g.default.getClassFactory(i);
            const l = r;
          }
        ),
        /***/
        "./src/streaming/protection/CommonEncryption.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/protection/CommonEncryption.js ***!
            \******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            function g(t, T) {
              if (!(t instanceof T))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(t, T) {
              for (var S = 0; S < T.length; S++) {
                var h = T[S];
                h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(t, h.key, h);
              }
            }
            function i(t, T, S) {
              return T && n(t.prototype, T), S && n(t, S), t;
            }
            var r = {
              attributes: ["Laurl", "laurl"],
              prefixes: ["clearkey", "dashif"]
            }, l = /* @__PURE__ */ function() {
              function t() {
                g(this, t);
              }
              return i(t, null, [{
                key: "findCencContentProtection",
                value: (
                  /**
                   * Find and return the ContentProtection element in the given array
                   * that indicates support for MPEG Common Encryption
                   *
                   * @param {Array} cpArray array of content protection elements
                   * @returns {Object|null} the Common Encryption content protection element or
                   * null if one was not found
                   */
                  function(S) {
                    for (var h = null, _ = 0; _ < S.length; ++_) {
                      var L = S[_];
                      L.schemeIdUri.toLowerCase() === "urn:mpeg:dash:mp4protection:2011" && (L.value.toLowerCase() === "cenc" || L.value.toLowerCase() === "cbcs") && (h = L);
                    }
                    return h;
                  }
                )
                /**
                 * Returns just the data portion of a single PSSH
                 *
                 * @param {ArrayBuffer} pssh - the PSSH
                 * @return {ArrayBuffer} data portion of the PSSH
                 */
              }, {
                key: "getPSSHData",
                value: function(S) {
                  var h = 8, _ = new DataView(S), L = _.getUint8(h);
                  return h += 20, L > 0 && (h += 4 + 16 * _.getUint32(h)), h += 4, S.slice(h);
                }
                /**
                 * Returns the PSSH associated with the given key system from the concatenated
                 * list of PSSH boxes in the given initData
                 *
                 * @param {KeySystem} keySystem the desired
                 * key system
                 * @param {ArrayBuffer} initData 'cenc' initialization data.  Concatenated list of PSSH.
                 * @returns {ArrayBuffer|null} The PSSH box data corresponding to the given key system, null if not found
                 * or null if a valid association could not be found.
                 */
              }, {
                key: "getPSSHForKeySystem",
                value: function(S, h) {
                  var _ = t.parsePSSHList(h);
                  return S && _.hasOwnProperty(S.uuid.toLowerCase()) ? _[S.uuid.toLowerCase()] : null;
                }
                /**
                 * Parse a standard common encryption PSSH which contains a simple
                 * base64-encoding of the init data
                 *
                 * @param {Object} cpData the ContentProtection element
                 * @param {BASE64} BASE64 reference
                 * @returns {ArrayBuffer|null} the init data or null if not found
                 */
              }, {
                key: "parseInitDataFromContentProtection",
                value: function(S, h) {
                  return "pssh" in S ? (S.pssh.__text = S.pssh.__text.replace(/\r?\n|\r/g, "").replace(/\s+/g, ""), h.decodeArray(S.pssh.__text).buffer) : null;
                }
                /**
                 * Parses list of PSSH boxes into keysystem-specific PSSH data
                 *
                 * @param {ArrayBuffer} data - the concatenated list of PSSH boxes as provided by
                 * CDM as initialization data when CommonEncryption content is detected
                 * @returns {Object|Array} an object that has a property named according to each of
                 * the detected key system UUIDs (e.g. 00000000-0000-0000-0000-0000000000)
                 * and a ArrayBuffer (the entire PSSH box) as the property value
                 */
              }, {
                key: "parsePSSHList",
                value: function(S) {
                  if (S == null)
                    return [];
                  for (var h = new DataView(S.buffer || S), _ = !1, L = {}, v = 0; !_; ) {
                    var c = void 0, o = void 0, y = void 0, u = void 0, A = v;
                    if (v >= h.buffer.byteLength)
                      break;
                    if (c = h.getUint32(v), o = v + c, v += 4, h.getUint32(v) !== 1886614376) {
                      v = o;
                      continue;
                    }
                    if (v += 4, y = h.getUint8(v), y !== 0 && y !== 1) {
                      v = o;
                      continue;
                    }
                    v++, v += 3, u = "";
                    var I = void 0, M = void 0;
                    for (I = 0; I < 4; I++)
                      M = h.getUint8(v + I).toString(16), u += M.length === 1 ? "0" + M : M;
                    for (v += 4, u += "-", I = 0; I < 2; I++)
                      M = h.getUint8(v + I).toString(16), u += M.length === 1 ? "0" + M : M;
                    for (v += 2, u += "-", I = 0; I < 2; I++)
                      M = h.getUint8(v + I).toString(16), u += M.length === 1 ? "0" + M : M;
                    for (v += 2, u += "-", I = 0; I < 2; I++)
                      M = h.getUint8(v + I).toString(16), u += M.length === 1 ? "0" + M : M;
                    for (v += 2, u += "-", I = 0; I < 6; I++)
                      M = h.getUint8(v + I).toString(16), u += M.length === 1 ? "0" + M : M;
                    v += 6, u = u.toLowerCase(), v += 4, L[u] = h.buffer.slice(A, o), v = o;
                  }
                  return L;
                }
              }, {
                key: "getLicenseServerUrlFromMediaInfo",
                value: function(S, h) {
                  try {
                    if (!S || S.length === 0)
                      return null;
                    for (var _ = 0, L = null; _ < S.length && !L; ) {
                      var v = S[_];
                      if (v && v.contentProtection && v.contentProtection.length > 0) {
                        var c = v.contentProtection.filter(function(E) {
                          return E.schemeIdUri && E.schemeIdUri === h;
                        });
                        if (c && c.length > 0)
                          for (var o = 0; o < c.length && !L; ) {
                            for (var y = c[o], u = 0; u < r.attributes.length && !L; ) {
                              for (var A = 0, I = r.attributes[u]; A < r.prefixes.length && !L; ) {
                                var M = r.prefixes[A];
                                y[I] && y[I].__prefix && y[I].__prefix === M && y[I].__text && (L = y[I].__text), A += 1;
                              }
                              u += 1;
                            }
                            o += 1;
                          }
                      }
                      _ += 1;
                    }
                    return L;
                  } catch {
                    return null;
                  }
                }
              }]), t;
            }();
            const d = l;
          }
        ),
        /***/
        "./src/streaming/protection/Protection.js": (
          /*!************************************************!*\
            !*** ./src/streaming/protection/Protection.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var g = e(
              /*! ./controllers/ProtectionController */
              "./src/streaming/protection/controllers/ProtectionController.js"
            ), n = e(
              /*! ./controllers/ProtectionKeyController */
              "./src/streaming/protection/controllers/ProtectionKeyController.js"
            ), i = e(
              /*! ./ProtectionEvents */
              "./src/streaming/protection/ProtectionEvents.js"
            ), r = e(
              /*! ./errors/ProtectionErrors */
              "./src/streaming/protection/errors/ProtectionErrors.js"
            ), l = e(
              /*! ./models/ProtectionModel_21Jan2015 */
              "./src/streaming/protection/models/ProtectionModel_21Jan2015.js"
            ), d = e(
              /*! ./models/ProtectionModel_3Feb2014 */
              "./src/streaming/protection/models/ProtectionModel_3Feb2014.js"
            ), t = e(
              /*! ./models/ProtectionModel_01b */
              "./src/streaming/protection/models/ProtectionModel_01b.js"
            ), T = [
              // Un-prefixed as per spec
              {
                // Video Element
                generateKeyRequest: "generateKeyRequest",
                addKey: "addKey",
                cancelKeyRequest: "cancelKeyRequest",
                // Events
                needkey: "needkey",
                keyerror: "keyerror",
                keyadded: "keyadded",
                keymessage: "keymessage"
              },
              // Webkit-prefixed (early Chrome versions and Chrome with EME disabled in chrome://flags)
              {
                // Video Element
                generateKeyRequest: "webkitGenerateKeyRequest",
                addKey: "webkitAddKey",
                cancelKeyRequest: "webkitCancelKeyRequest",
                // Events
                needkey: "webkitneedkey",
                keyerror: "webkitkeyerror",
                keyadded: "webkitkeyadded",
                keymessage: "webkitkeymessage"
              }
            ], S = [
              // Un-prefixed as per spec
              // Chrome 38-39 (and some earlier versions) with chrome://flags -- Enable Encrypted Media Extensions
              {
                // Video Element
                setMediaKeys: "setMediaKeys",
                // MediaKeys
                MediaKeys: "MediaKeys",
                // MediaKeySession
                release: "close",
                // Events
                needkey: "needkey",
                error: "keyerror",
                message: "keymessage",
                ready: "keyadded",
                close: "keyclose"
              },
              // MS-prefixed (IE11, Windows 8.1)
              {
                // Video Element
                setMediaKeys: "msSetMediaKeys",
                // MediaKeys
                MediaKeys: "MSMediaKeys",
                // MediaKeySession
                release: "close",
                // Events
                needkey: "msneedkey",
                error: "mskeyerror",
                message: "mskeymessage",
                ready: "mskeyadded",
                close: "mskeyclose"
              }
            ];
            function h() {
              var v, c = this.context;
              function o(A) {
                var I = null, M = (0, n.default)(c).getInstance();
                M.setConfig({
                  debug: A.debug,
                  BASE64: A.BASE64,
                  settings: A.settings
                }), M.initialize();
                var E = y(A);
                return !I && E && (I = (0, g.default)(c).create({
                  protectionModel: E,
                  protectionKeyController: M,
                  eventBus: A.eventBus,
                  debug: A.debug,
                  events: A.events,
                  BASE64: A.BASE64,
                  constants: A.constants,
                  cmcdModel: A.cmcdModel,
                  customParametersModel: A.customParametersModel,
                  settings: A.settings
                }), A.capabilities.setEncryptedMediaSupported(!0)), I;
              }
              function y(A) {
                var I = A.debug, M = I.getLogger(v), E = A.eventBus, N = A.errHandler, C = A.videoModel ? A.videoModel.getElement() : null;
                return (!C || C.onencrypted !== void 0) && (!C || C.mediaKeys !== void 0) ? (M.info("EME detected on this user agent! (ProtectionModel_21Jan2015)"), (0, l.default)(c).create({
                  debug: I,
                  eventBus: E,
                  events: A.events
                })) : u(C, S) ? (M.info("EME detected on this user agent! (ProtectionModel_3Feb2014)"), (0, d.default)(c).create({
                  debug: I,
                  eventBus: E,
                  events: A.events,
                  api: u(C, S)
                })) : u(C, T) ? (M.info("EME detected on this user agent! (ProtectionModel_01b)"), (0, t.default)(c).create({
                  debug: I,
                  eventBus: E,
                  errHandler: N,
                  events: A.events,
                  api: u(C, T)
                })) : (M.warn("No supported version of EME detected on this user agent! - Attempts to play encrypted content will fail!"), null);
              }
              function u(A, I) {
                for (var M = 0; M < I.length; M++) {
                  var E = I[M];
                  if (typeof A[E[Object.keys(E)[0]]] == "function")
                    return E;
                }
                return null;
              }
              return v = {
                createProtectionSystem: o
              }, v;
            }
            h.__dashjs_factory_name = "Protection";
            var _ = dashjs.FactoryMaker.getClassFactory(h);
            _.events = i.default, _.errors = r.default, dashjs.FactoryMaker.updateClassFactory(h.__dashjs_factory_name, _);
            const L = _;
          }
        ),
        /***/
        "./src/streaming/protection/ProtectionEvents.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/protection/ProtectionEvents.js ***!
            \******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ../../core/events/EventsBase */
              "./src/core/events/EventsBase.js"
            );
            function n(c) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(y) {
                return typeof y;
              } : n = function(y) {
                return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
              }, n(c);
            }
            function i(c, o) {
              if (!(c instanceof o))
                throw new TypeError("Cannot call a class as a function");
            }
            function r(c, o) {
              if (typeof o != "function" && o !== null)
                throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(o && o.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), o && l(c, o);
            }
            function l(c, o) {
              return l = Object.setPrototypeOf || function(u, A) {
                return u.__proto__ = A, u;
              }, l(c, o);
            }
            function d(c) {
              var o = S();
              return function() {
                var u = h(c), A;
                if (o) {
                  var I = h(this).constructor;
                  A = Reflect.construct(u, arguments, I);
                } else
                  A = u.apply(this, arguments);
                return t(this, A);
              };
            }
            function t(c, o) {
              return o && (n(o) === "object" || typeof o == "function") ? o : T(c);
            }
            function T(c) {
              if (c === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return c;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function h(c) {
              return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, h(c);
            }
            var _ = /* @__PURE__ */ function(c) {
              r(y, c);
              var o = d(y);
              function y() {
                var u;
                return i(this, y), u = o.call(this), u.INTERNAL_KEY_MESSAGE = "internalKeyMessage", u.INTERNAL_KEY_STATUS_CHANGED = "internalkeyStatusChanged", u.KEY_ADDED = "public_keyAdded", u.KEY_ERROR = "public_keyError", u.KEY_MESSAGE = "public_keyMessage", u.KEY_SESSION_CLOSED = "public_keySessionClosed", u.KEY_SESSION_CREATED = "public_keySessionCreated", u.KEY_SESSION_REMOVED = "public_keySessionRemoved", u.KEY_STATUSES_CHANGED = "public_keyStatusesChanged", u.KEY_SYSTEM_ACCESS_COMPLETE = "public_keySystemAccessComplete", u.KEY_SYSTEM_SELECTED = "public_keySystemSelected", u.LICENSE_REQUEST_COMPLETE = "public_licenseRequestComplete", u.LICENSE_REQUEST_SENDING = "public_licenseRequestSending", u.NEED_KEY = "needkey", u.PROTECTION_CREATED = "public_protectioncreated", u.PROTECTION_DESTROYED = "public_protectiondestroyed", u.SERVER_CERTIFICATE_UPDATED = "serverCertificateUpdated", u.TEARDOWN_COMPLETE = "protectionTeardownComplete", u.VIDEO_ELEMENT_SELECTED = "videoElementSelected", u.KEY_SESSION_UPDATED = "public_keySessionUpdated", u;
              }
              return y;
            }(g.default), L = new _();
            const v = L;
          }
        ),
        /***/
        "./src/streaming/protection/controllers/ProtectionController.js": (
          /*!**********************************************************************!*\
            !*** ./src/streaming/protection/controllers/ProtectionController.js ***!
            \**********************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => I
              /* harmony export */
            });
            var g = e(
              /*! ../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), n = e(
              /*! ../vo/MediaCapability */
              "./src/streaming/protection/vo/MediaCapability.js"
            ), i = e(
              /*! ../vo/KeySystemConfiguration */
              "./src/streaming/protection/vo/KeySystemConfiguration.js"
            ), r = e(
              /*! ../errors/ProtectionErrors */
              "./src/streaming/protection/errors/ProtectionErrors.js"
            ), l = e(
              /*! ../../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), d = e(
              /*! ../vo/LicenseRequest */
              "./src/streaming/protection/vo/LicenseRequest.js"
            ), t = e(
              /*! ../vo/LicenseResponse */
              "./src/streaming/protection/vo/LicenseResponse.js"
            ), T = e(
              /*! ../../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), S = e(
              /*! ../../../core/Utils */
              "./src/core/Utils.js"
            ), h = e(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), _ = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function L(M) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? L = function(N) {
                return typeof N;
              } : L = function(N) {
                return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
              }, L(M);
            }
            var v = 5, c = 500, o = 3, y = 1e3, u = 8e3;
            function A(M) {
              M = M || {};
              var E = M.protectionKeyController, N = M.protectionModel, C = M.eventBus, b = M.events, w = M.debug, V = M.BASE64, J = M.constants, H = [], z = M.cmcdModel, Z = M.settings, ie = M.customParametersModel, K, Y, ne, ae, fe, Q, oe, de, Me, ge, se;
              function ee() {
                Y = w.getLogger(K), ne = [], ae = [], Q = "temporary", oe = "", ge = null, se = null, C.on(b.INTERNAL_KEY_MESSAGE, nt, K), C.on(b.INTERNAL_KEY_STATUS_CHANGED, Ze, K);
              }
              function re() {
                if (!C || !C.hasOwnProperty("on") || !E || !E.hasOwnProperty("getSupportedKeySystemsFromContentProtection"))
                  throw new Error("Missing config parameter(s)");
              }
              function ue(me) {
                if (!me)
                  throw new Error("mediaInfo can not be null or undefined");
                re(), ae.push(me);
              }
              function te() {
                if (!(!ae || ae.length === 0)) {
                  var me = [];
                  ae.forEach(function(Ie) {
                    var we = E.getSupportedKeySystemsFromContentProtection(Ie.contentProtection, fe, Q);
                    we.length > 0 && (me.length === 0 && (me = we), ne.push(we));
                  }), me && me.length > 0 && p(me, !0);
                }
              }
              function O(me) {
                ne.push(me), p(me, !1);
              }
              function p(me, Ie) {
                !de && !Me ? P(me, Ie) : de && k();
              }
              function P(me, Ie) {
                if (!Me) {
                  Me = !0;
                  var we = [];
                  me = me.sort(function(et, Mt) {
                    var Lt = fe && fe[et.ks.systemString] && fe[et.ks.systemString].priority >= 0 ? fe[et.ks.systemString].priority : me.length, bt = fe && fe[Mt.ks.systemString] && fe[Mt.ks.systemString].priority >= 0 ? fe[Mt.ks.systemString].priority : me.length;
                    return Lt - bt;
                  });
                  for (var Ue = 0; Ue < me.length; Ue++) {
                    var $e = je(me[Ue]);
                    we.push({
                      ks: me[Ue].ks,
                      configs: [$e],
                      protData: me[Ue].protData
                    });
                  }
                  var at;
                  N.requestKeySystemAccess(we).then(function(et) {
                    at = et.data;
                    var Mt = at.mksa && at.mksa.selectedSystemString ? at.mksa.selectedSystemString : at.keySystem.systemString;
                    return Y.info("DRM: KeySystem Access Granted for system string (" + Mt + ")!  Selecting key system..."), N.selectKeySystem(at);
                  }).then(function(et) {
                    if (de = et, Me = !1, !!N) {
                      C.trigger(b.KEY_SYSTEM_SELECTED, {
                        data: at
                      });
                      var Mt = W(de);
                      Mt && Mt.serverCertificate && Mt.serverCertificate.length > 0 && N.setServerCertificate(V.decodeArray(Mt.serverCertificate).buffer), k();
                    }
                  }).catch(function(et) {
                    de = null, Me = !1, Ie || C.trigger(b.KEY_SYSTEM_SELECTED, {
                      data: null,
                      error: new l.default(r.default.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE, r.default.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE + "Error selecting key system! -- " + et.error)
                    });
                  });
                }
              }
              function k() {
                for (var me, Ie = 0; Ie < ne.length; Ie++)
                  for (me = 0; me < ne[Ie].length; me++)
                    if (de === ne[Ie][me].ks) {
                      var we = ne[Ie][me];
                      X(we);
                      break;
                    }
                ne = [];
              }
              function X(me) {
                if (E.isClearKey(de) && me.protData && me.protData.hasOwnProperty("clearkeys") && Object.keys(me.protData.clearkeys).length !== 0) {
                  var Ie = {
                    kids: Object.keys(me.protData.clearkeys)
                  };
                  me.initData = new TextEncoder().encode(JSON.stringify(Ie));
                }
                me.sessionId ? F(me) : me.initData !== null && x(me);
              }
              function F(me) {
                re(), N.loadKeySession(me);
              }
              function x(me) {
                var Ie = g.default.getPSSHForKeySystem(de, me ? me.initData : null);
                if (Ie) {
                  if (le(me.keyId) || q(Ie))
                    return;
                  try {
                    me.initData = Ie, N.createKeySession(me);
                  } catch (we) {
                    C.trigger(b.KEY_SESSION_CREATED, {
                      data: null,
                      error: new l.default(r.default.KEY_SESSION_CREATED_ERROR_CODE, r.default.KEY_SESSION_CREATED_ERROR_MESSAGE + we.message)
                    });
                  }
                } else
                  me && me.initData ? N.createKeySession(me) : C.trigger(b.KEY_SESSION_CREATED, {
                    data: null,
                    error: new l.default(r.default.KEY_SESSION_CREATED_ERROR_CODE, r.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Selected key system is " + (de ? de.systemString : null) + ".  needkey/encrypted event contains no initData corresponding to that key system!")
                  });
              }
              function W(me) {
                if (me) {
                  var Ie = me.systemString;
                  if (fe)
                    return Ie in fe ? fe[Ie] : null;
                }
                return null;
              }
              function $() {
                ae = [];
              }
              function ce(me) {
                return re(), E.getSupportedKeySystemsFromContentProtection(me, fe, Q);
              }
              function le(me) {
                if (!me)
                  return !1;
                try {
                  for (var Ie = N.getSessions(), we = 0; we < Ie.length; we++)
                    if (Ie[we].getKeyId() === me)
                      return !0;
                  return !1;
                } catch {
                  return !1;
                }
              }
              function q(me) {
                if (!me)
                  return !1;
                try {
                  for (var Ie = N.getAllInitData(), we = 0; we < Ie.length; we++)
                    if (E.initDataEquals(me, Ie[we]))
                      return Y.debug("DRM: Ignoring initData because we have already seen it!"), !0;
                  return !1;
                } catch {
                  return !1;
                }
              }
              function _e(me) {
                re(), N.removeKeySession(me);
              }
              function Ee(me) {
                re(), N.closeKeySession(me);
              }
              function Te(me) {
                re(), N.setServerCertificate(me);
              }
              function Ce(me) {
                re(), me ? (N.setMediaElement(me), C.on(b.NEED_KEY, xt, K)) : me === null && (N.setMediaElement(me), C.off(b.NEED_KEY, xt, K));
              }
              function xe(me) {
                Q = me;
              }
              function be(me) {
                oe = me;
              }
              function Ge(me) {
                fe = me, E.setProtectionData(me);
              }
              function Pe() {
                Ke(), N && N.stop();
              }
              function Le() {
                C.off(b.INTERNAL_KEY_MESSAGE, nt, K), C.off(b.INTERNAL_KEY_STATUS_CHANGED, Ze, K), re(), Ke(), Ce(null), de = null, Me = !1, N && (N.reset(), N = null), H.forEach(function(me) {
                  return clearTimeout(me);
                }), H = [], ae = [], ne = [];
              }
              function je(me) {
                var Ie = me.protData, we = [], Ue = [], $e = Ie && Ie.audioRobustness && Ie.audioRobustness.length > 0 ? Ie.audioRobustness : oe, at = Ie && Ie.videoRobustness && Ie.videoRobustness.length > 0 ? Ie.videoRobustness : oe, et = me.sessionType, Mt = Ie && Ie.distinctiveIdentifier ? Ie.distinctiveIdentifier : "optional", Lt = Ie && Ie.persistentState ? Ie.persistentState : et === "temporary" ? "optional" : "required";
                return ae.forEach(function(bt) {
                  bt.type === J.AUDIO ? we.push(new n.default(bt.codec, $e)) : bt.type === J.VIDEO && Ue.push(new n.default(bt.codec, at));
                }), new i.default(we, Ue, Mt, Lt, [et]);
              }
              function Ze(me) {
                me.error ? C.trigger(b.KEY_STATUSES_CHANGED, {
                  data: null,
                  error: me.error
                }) : Y.debug("DRM: key status = " + me.status);
              }
              function nt(me) {
                Y.debug("DRM: onKeyMessage");
                var Ie = me.data;
                C.trigger(b.KEY_MESSAGE, {
                  data: Ie
                });
                var we = Ie.messageType ? Ie.messageType : "license-request", Ue = Ie.message, $e = Ie.sessionToken, at = W(de), et = E.getLicenseServerModelInstance(de, at, we), Mt = {
                  sessionToken: $e,
                  messageType: we
                };
                if (!Ue || Ue.byteLength === 0) {
                  it(Mt, new l.default(r.default.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE, r.default.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE));
                  return;
                }
                if (!et) {
                  Y.debug("DRM: License server request not required for this message (type = " + me.data.messageType + ").  Session ID = " + $e.getSessionId()), it(Mt);
                  return;
                }
                if (E.isClearKey(de)) {
                  var Lt = E.processClearKeyLicenseRequest(de, at, Ue);
                  if (Lt && Lt.keyPairs && Lt.keyPairs.length > 0) {
                    Y.debug("DRM: ClearKey license request handled by application!"), it(Mt), N.updateKeySession($e, Lt);
                    return;
                  }
                }
                De(Ie, et, at);
              }
              function it(me, Ie) {
                C.trigger(b.LICENSE_REQUEST_COMPLETE, {
                  data: me,
                  error: Ie
                });
              }
              function De(me, Ie, we) {
                var Ue = me.sessionToken, $e = me.messageType ? me.messageType : "license-request", at = {
                  sessionToken: Ue,
                  messageType: $e
                }, et = de ? de.systemString : null, Mt = tt(we, $e, Ue, me, Ie);
                if (!Mt) {
                  it(at, new l.default(r.default.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE, r.default.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE));
                  return;
                }
                var Lt = {}, bt = !1;
                we && st(Lt, we.httpRequestHeaders);
                var Ae = me.message, ze = de.getRequestHeadersFromMessage(Ae);
                st(Lt, ze), Object.keys(Lt).forEach(function(Be) {
                  Be.toLowerCase() === "authorization" && (bt = !0);
                }), we && typeof we.withCredentials == "boolean" && (bt = we.withCredentials);
                var qe = function(He) {
                  if (N)
                    if (He.status >= 200 && He.status <= 299) {
                      var yt = S.default.parseHttpHeaders(He.getAllResponseHeaders ? He.getAllResponseHeaders() : null), zt = new t.default(He.responseURL, yt, He.response), Nt = ie.getLicenseResponseFilters();
                      ht(Nt, zt).then(function() {
                        var Dt = Ie.getLicenseMessage(zt.data, et, $e);
                        Dt !== null ? (it(at), N.updateKeySession(Ue, Dt)) : Et(He, at, et, $e, Ie);
                      });
                    } else
                      Et(He, at, et, $e, Ie);
                }, _t = function(He) {
                  it(at, new l.default(r.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, r.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + et + ' update, XHR aborted. status is "' + He.statusText + '" (' + He.status + "), readyState is " + He.readyState));
                }, dt = function(He) {
                  it(at, new l.default(r.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, r.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + et + ' update, XHR error. status is "' + He.statusText + '" (' + He.status + "), readyState is " + He.readyState));
                }, Tt = de.getLicenseRequestFromMessage(Ae), wt = Ie.getHTTPMethod($e), Gt = Ie.getResponseType(et, $e), Xt = we && !isNaN(we.httpTimeout) ? we.httpTimeout : u, ye = Ue.getSessionId() || null, Qe = new d.default(Mt, wt, Gt, Lt, bt, $e, ye, Tt), ct = isNaN(Z.get().streaming.retryAttempts[T.HTTPRequest.LICENSE]) ? o : Z.get().streaming.retryAttempts[T.HTTPRequest.LICENSE], Se = ie.getLicenseRequestFilters();
                ht(Se, Qe).then(function() {
                  Ye(Qe, ct, Xt, qe, _t, dt);
                });
              }
              function Ye(me, Ie, we, Ue, $e, at) {
                var et = new XMLHttpRequest();
                if (Z.get().streaming.cmcd && Z.get().streaming.cmcd.enabled) {
                  var Mt = Z.get().streaming.cmcd.mode;
                  if (Mt === h.default.CMCD_MODE_QUERY) {
                    var Lt = z.getQueryParameter({
                      url: me.url,
                      type: T.HTTPRequest.LICENSE
                    });
                    Lt && (me.url = S.default.addAditionalQueryParameterToUrl(me.url, [Lt]));
                  }
                }
                et.open(me.method, me.url, !0), et.responseType = me.responseType, et.withCredentials = me.withCredentials, we > 0 && (et.timeout = we);
                for (var bt in me.headers)
                  et.setRequestHeader(bt, me.headers[bt]);
                if (Z.get().streaming.cmcd && Z.get().streaming.cmcd.enabled) {
                  var Ae = Z.get().streaming.cmcd.mode;
                  if (Ae === h.default.CMCD_MODE_HEADER) {
                    var ze = z.getHeaderParameters({
                      url: me.url,
                      type: T.HTTPRequest.LICENSE
                    });
                    if (ze)
                      for (var qe in ze) {
                        var _t = ze[qe];
                        _t && et.setRequestHeader(qe, _t);
                      }
                  }
                }
                var dt = function() {
                  Ie--;
                  var wt = isNaN(Z.get().streaming.retryIntervals[T.HTTPRequest.LICENSE]) ? y : Z.get().streaming.retryIntervals[T.HTTPRequest.LICENSE];
                  se = setTimeout(function() {
                    Ye(me, Ie, we, Ue, $e, at);
                  }, wt);
                };
                et.onload = function() {
                  ge = null, this.status >= 200 && this.status <= 299 || Ie <= 0 ? Ue(this) : (Y.warn("License request failed (" + this.status + "). Retrying it... Pending retries: " + Ie), dt());
                }, et.ontimeout = et.onerror = function() {
                  ge = null, Ie <= 0 ? at(this) : (Y.warn("License request network request failed . Retrying it... Pending retries: " + Ie), dt());
                }, et.onabort = function() {
                  $e(this);
                }, C.trigger(b.LICENSE_REQUEST_SENDING, {
                  url: me.url,
                  headers: me.headers,
                  payload: me.data,
                  sessionId: me.sessionId
                }), ge = et, et.send(me.data);
              }
              function Ke() {
                ge && (ge.onloadend = ge.onerror = ge.onprogress = void 0, ge.abort(), ge = null), se && (clearTimeout(se), se = null);
              }
              function tt(me, Ie, we, Ue, $e) {
                var at = null, et = Ue.message;
                if (me && me.serverURL) {
                  var Mt = me.serverURL;
                  typeof Mt == "string" && Mt !== "" ? at = Mt : L(Mt) === "object" && Mt.hasOwnProperty(Ie) && (at = Mt[Ie]);
                } else if (me && me.laURL && me.laURL !== "")
                  at = me.laURL;
                else if (at = g.default.getLicenseServerUrlFromMediaInfo(ae, de.schemeIdURI), !at && !E.isClearKey(de)) {
                  var Lt = g.default.getPSSHData(we.initData);
                  at = de.getLicenseServerURLFromInitData(Lt), at || (at = Ue.laURL);
                }
                return at = $e.getServerURLFromMessage(at, et, Ie), at;
              }
              function st(me, Ie) {
                if (Ie)
                  for (var we in Ie)
                    me[we] = Ie[we];
              }
              function Et(me, Ie, we, Ue, $e) {
                var at = "NONE", et = null;
                me.response && (at = $e.getErrorResponse(me.response, we, Ue), et = {
                  serverResponse: me.response || null,
                  responseCode: me.status || null,
                  responseText: me.statusText || null
                }), it(Ie, new l.default(r.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, r.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + we + ' update, XHR complete. status is "' + me.statusText + '" (' + me.status + "), readyState is " + me.readyState + ".  Response is " + at, et));
              }
              function ht(me, Ie) {
                return me ? me.reduce(function(we, Ue) {
                  return we.then(function() {
                    return Ue(Ie);
                  });
                }, Promise.resolve()) : Promise.resolve();
              }
              function xt(me, Ie) {
                if (!Z.get().streaming.protection.ignoreEmeEncryptedEvent) {
                  if (Y.debug("DRM: onNeedKey"), me.key.initDataType !== "cenc") {
                    Y.warn("DRM:  Only 'cenc' initData is supported!  Ignoring initData of type: " + me.key.initDataType);
                    return;
                  }
                  if (ae.length === 0 && (Y.warn("DRM: onNeedKey called before initializeForMedia, wait until initialized"), Ie = typeof Ie > "u" ? 1 : Ie + 1, Ie < v)) {
                    H.push(setTimeout(function() {
                      xt(me, Ie);
                    }, c));
                    return;
                  }
                  var we = me.key.initData;
                  if (ArrayBuffer.isView(we) && (we = we.buffer), de) {
                    var Ue = g.default.getPSSHForKeySystem(de, we);
                    if (Ue && q(Ue))
                      return;
                  }
                  Y.debug("DRM: initData:", String.fromCharCode.apply(null, new Uint8Array(we)));
                  var $e = E.getSupportedKeySystemsFromSegmentPssh(we, fe, Q);
                  if ($e.length === 0) {
                    Y.debug("DRM: Received needkey event with initData, but we don't support any of the key systems!");
                    return;
                  }
                  O($e);
                }
              }
              function Xe() {
                return E ? E.getKeySystems() : [];
              }
              function ve(me) {
                E && E.setKeySystems(me);
              }
              return K = {
                initializeForMedia: ue,
                clearMediaInfoArray: $,
                handleKeySystemFromManifest: te,
                createKeySession: x,
                loadKeySession: F,
                removeKeySession: _e,
                closeKeySession: Ee,
                setServerCertificate: Te,
                setMediaElement: Ce,
                setSessionType: xe,
                setRobustnessLevel: be,
                setProtectionData: Ge,
                getSupportedKeySystemsFromContentProtection: ce,
                getKeySystems: Xe,
                setKeySystems: ve,
                stop: Pe,
                reset: Le
              }, ee(), K;
            }
            A.__dashjs_factory_name = "ProtectionController";
            const I = _.default.getClassFactory(A);
          }
        ),
        /***/
        "./src/streaming/protection/controllers/ProtectionKeyController.js": (
          /*!*************************************************************************!*\
            !*** ./src/streaming/protection/controllers/ProtectionKeyController.js ***!
            \*************************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var g = e(
              /*! ./../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), n = e(
              /*! ./../drm/KeySystemClearKey */
              "./src/streaming/protection/drm/KeySystemClearKey.js"
            ), i = e(
              /*! ./../drm/KeySystemW3CClearKey */
              "./src/streaming/protection/drm/KeySystemW3CClearKey.js"
            ), r = e(
              /*! ./../drm/KeySystemWidevine */
              "./src/streaming/protection/drm/KeySystemWidevine.js"
            ), l = e(
              /*! ./../drm/KeySystemPlayReady */
              "./src/streaming/protection/drm/KeySystemPlayReady.js"
            ), d = e(
              /*! ./../servers/DRMToday */
              "./src/streaming/protection/servers/DRMToday.js"
            ), t = e(
              /*! ./../servers/PlayReady */
              "./src/streaming/protection/servers/PlayReady.js"
            ), T = e(
              /*! ./../servers/Widevine */
              "./src/streaming/protection/servers/Widevine.js"
            ), S = e(
              /*! ./../servers/ClearKey */
              "./src/streaming/protection/servers/ClearKey.js"
            ), h = e(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            );
            function _() {
              var v = this.context, c, o, y, u, A, I, M, E;
              function N(Q) {
                Q && (Q.debug && (o = Q.debug, y = o.getLogger(c)), Q.BASE64 && (A = Q.BASE64), Q.settings && (I = Q.settings));
              }
              function C() {
                u = [];
                var Q;
                Q = (0, l.default)(v).getInstance({
                  BASE64: A,
                  settings: I
                }), u.push(Q), Q = (0, r.default)(v).getInstance({
                  BASE64: A
                }), u.push(Q), Q = (0, n.default)(v).getInstance({
                  BASE64: A
                }), u.push(Q), M = Q, Q = (0, i.default)(v).getInstance({
                  BASE64: A,
                  debug: o
                }), u.push(Q), E = Q;
              }
              function b() {
                return u;
              }
              function w(Q) {
                u = Q;
              }
              function V(Q) {
                for (var oe = 0; oe < u.length; oe++)
                  if (u[oe].systemString === Q)
                    return u[oe];
                return null;
              }
              function J(Q) {
                return Q === M || Q === E;
              }
              function H(Q, oe) {
                if (Q.byteLength === oe.byteLength) {
                  for (var de = new Uint8Array(Q), Me = new Uint8Array(oe), ge = 0; ge < de.length; ge++)
                    if (de[ge] !== Me[ge])
                      return !1;
                  return !0;
                }
                return !1;
              }
              function z(Q, oe, de) {
                var Me, ge, se, ee, re = [];
                if (Q) {
                  var ue = g.default.findCencContentProtection(Q);
                  for (se = 0; se < u.length; ++se) {
                    ge = u[se];
                    var te = ne(ge.systemString, oe);
                    for (ee = 0; ee < Q.length; ++ee)
                      if (Me = Q[ee], Me.schemeIdUri.toLowerCase() === ge.schemeIdURI) {
                        var O = ge.getInitData(Me, ue);
                        re.push({
                          ks: u[se],
                          keyId: Me.keyId,
                          initData: O,
                          protData: te,
                          cdmData: ge.getCDMData(te ? te.cdmData : null),
                          sessionId: ae(te, Me),
                          sessionType: fe(te, de)
                        });
                      }
                  }
                }
                return re;
              }
              function Z(Q, oe, de) {
                for (var Me = [], ge = g.default.parsePSSHList(Q), se, ee, re = 0; re < u.length; ++re) {
                  se = u[re], ee = se.systemString;
                  var ue = ne(ee, oe);
                  se.uuid in ge && Me.push({
                    ks: se,
                    initData: ge[se.uuid],
                    protData: ue,
                    cdmData: se.getCDMData(ue ? ue.cdmData : null),
                    sessionId: ae(ue),
                    sessionType: fe(ue, de)
                  });
                }
                return Me;
              }
              function ie(Q, oe, de) {
                if (de === "license-release" || de === "individualization-request")
                  return null;
                var Me = null;
                return oe && oe.hasOwnProperty("drmtoday") ? Me = (0, d.default)(v).getInstance({
                  BASE64: A
                }) : Q.systemString === h.default.WIDEVINE_KEYSTEM_STRING ? Me = (0, T.default)(v).getInstance() : Q.systemString === h.default.PLAYREADY_KEYSTEM_STRING ? Me = (0, t.default)(v).getInstance() : Q.systemString === h.default.CLEARKEY_KEYSTEM_STRING && (Me = (0, S.default)(v).getInstance()), Me;
              }
              function K(Q, oe, de) {
                try {
                  return Q.getClearKeysFromProtectionData(oe, de);
                } catch {
                  return y.error("Failed to retrieve clearkeys from ProtectionData"), null;
                }
              }
              function Y(Q) {
                for (var oe = function(se) {
                  var ee = null;
                  return Q && (ee = se in Q ? Q[se] : null), ee;
                }, de = 0; de < u.length; de++) {
                  var Me = u[de];
                  Me.hasOwnProperty("init") && Me.init(oe(Me.systemString));
                }
              }
              function ne(Q, oe) {
                return oe && Q in oe ? oe[Q] : null;
              }
              function ae(Q, oe) {
                return Q && Q.sessionId ? Q.sessionId : oe && oe.sessionId ? oe.sessionId : null;
              }
              function fe(Q, oe) {
                return Q && Q.sessionType ? Q.sessionType : oe;
              }
              return c = {
                initialize: C,
                setProtectionData: Y,
                isClearKey: J,
                initDataEquals: H,
                getKeySystems: b,
                setKeySystems: w,
                getKeySystemBySystemString: V,
                getSupportedKeySystemsFromContentProtection: z,
                getSupportedKeySystemsFromSegmentPssh: Z,
                getLicenseServerModelInstance: ie,
                processClearKeyLicenseRequest: K,
                setConfig: N
              }, c;
            }
            _.__dashjs_factory_name = "ProtectionKeyController";
            const L = dashjs.FactoryMaker.getSingletonFactory(_);
          }
        ),
        /***/
        "./src/streaming/protection/drm/KeySystemClearKey.js": (
          /*!***********************************************************!*\
            !*** ./src/streaming/protection/drm/KeySystemClearKey.js ***!
            \***********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var g = e(
              /*! ../vo/KeyPair */
              "./src/streaming/protection/vo/KeyPair.js"
            ), n = e(
              /*! ../vo/ClearKeyKeySet */
              "./src/streaming/protection/vo/ClearKeyKeySet.js"
            ), i = e(
              /*! ../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), r = e(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            ), l = "e2719d58-a985-b3c9-781a-b030af78d30e", d = r.default.CLEARKEY_KEYSTEM_STRING, t = "urn:uuid:" + l;
            function T(h) {
              h = h || {};
              var _, L = h.BASE64;
              function v(M, E) {
                var N = null;
                if (M) {
                  for (var C = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(E))), b = [], w = 0; w < C.kids.length; w++) {
                    var V = C.kids[w], J = M.clearkeys && M.clearkeys.hasOwnProperty(V) ? M.clearkeys[V] : null;
                    if (!J)
                      throw new Error("DRM: ClearKey keyID (" + V + ") is not known!");
                    b.push(new g.default(V, J));
                  }
                  N = new n.default(b);
                }
                return N;
              }
              function c(M, E) {
                try {
                  var N = i.default.parseInitDataFromContentProtection(M, L);
                  if (!N && E) {
                    var C = o(E["cenc:default_KID"]), b = {
                      kids: [C]
                    };
                    N = new TextEncoder().encode(JSON.stringify(b));
                  }
                  return N;
                } catch {
                  return null;
                }
              }
              function o(M) {
                try {
                  var E = M.replace(/-/g, "");
                  return E = btoa(E.match(/\w{2}/g).map(function(N) {
                    return String.fromCharCode(parseInt(N, 16));
                  }).join("")), E.replace(/=/g, "").replace(/\//g, "_").replace(/\+/g, "-");
                } catch {
                  return null;
                }
              }
              function y() {
                return {
                  "Content-Type": "application/json"
                };
              }
              function u(M) {
                return JSON.stringify(JSON.parse(String.fromCharCode.apply(null, new Uint8Array(M))));
              }
              function A() {
                return null;
              }
              function I() {
                return null;
              }
              return _ = {
                uuid: l,
                schemeIdURI: t,
                systemString: d,
                getInitData: c,
                getRequestHeadersFromMessage: y,
                getLicenseRequestFromMessage: u,
                getLicenseServerURLFromInitData: A,
                getCDMData: I,
                getClearKeysFromProtectionData: v
              }, _;
            }
            T.__dashjs_factory_name = "KeySystemClearKey";
            const S = dashjs.FactoryMaker.getSingletonFactory(T);
          }
        ),
        /***/
        "./src/streaming/protection/drm/KeySystemPlayReady.js": (
          /*!************************************************************!*\
            !*** ./src/streaming/protection/drm/KeySystemPlayReady.js ***!
            \************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var g = e(
              /*! ../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), n = e(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            ), i = "9a04f079-9840-4286-ab92-e65be0885f95", r = n.default.PLAYREADY_KEYSTEM_STRING, l = "urn:uuid:" + i, d = '<PlayReadyCDMData type="LicenseAcquisition"><LicenseAcquisition version="1.0" Proactive="false"><CustomData encoding="base64encoded">%CUSTOMDATA%</CustomData></LicenseAcquisition></PlayReadyCDMData>';
            function t(S) {
              S = S || {};
              var h, _ = "utf-16", L = S.BASE64, v = S.settings;
              function c() {
                if (!L || !L.hasOwnProperty("decodeArray") || !L.hasOwnProperty("decodeArray"))
                  throw new Error("Missing config parameter(s)");
              }
              function o(E) {
                var N, C, b = {}, w = new DOMParser();
                if (v && v.get().streaming.protection.detectPlayreadyMessageFormat && _ === "utf-16" && E && E.byteLength % 2 === 1)
                  return b["Content-Type"] = "text/xml; charset=utf-8", b;
                var V = _ === "utf-16" ? new Uint16Array(E) : new Uint8Array(E);
                N = String.fromCharCode.apply(null, V), C = w.parseFromString(N, "application/xml");
                for (var J = C.getElementsByTagName("name"), H = C.getElementsByTagName("value"), z = 0; z < J.length; z++)
                  b[J[z].childNodes[0].nodeValue] = H[z].childNodes[0].nodeValue;
                return b.hasOwnProperty("Content") && (b["Content-Type"] = b.Content, delete b.Content), b.hasOwnProperty("Content-Type") || (b["Content-Type"] = "text/xml; charset=utf-8"), b;
              }
              function y(E) {
                var N = null, C = new DOMParser();
                if (v && v.get().streaming.protection.detectPlayreadyMessageFormat && _ === "utf-16" && E && E.byteLength % 2 === 1)
                  return E;
                var b = _ === "utf-16" ? new Uint16Array(E) : new Uint8Array(E);
                c();
                var w = String.fromCharCode.apply(null, b), V = C.parseFromString(w, "application/xml");
                if (V.getElementsByTagName("PlayReadyKeyMessage")[0]) {
                  var J = V.getElementsByTagName("Challenge")[0].childNodes[0].nodeValue;
                  J && (N = L.decode(J));
                } else
                  return E;
                return N;
              }
              function u(E) {
                if (E)
                  for (var N = new DataView(E), C = N.getUint16(4, !0), b = 6, w = new DOMParser(), V = 0; V < C; V++) {
                    var J = N.getUint16(b, !0);
                    b += 2;
                    var H = N.getUint16(b, !0);
                    if (b += 2, J !== 1) {
                      b += H;
                      continue;
                    }
                    var z = E.slice(b, b + H), Z = String.fromCharCode.apply(null, new Uint16Array(z)), ie = w.parseFromString(Z, "application/xml");
                    if (ie.getElementsByTagName("LA_URL")[0]) {
                      var K = ie.getElementsByTagName("LA_URL")[0].childNodes[0].nodeValue;
                      if (K)
                        return K;
                    }
                    if (ie.getElementsByTagName("LUI_URL")[0]) {
                      var Y = ie.getElementsByTagName("LUI_URL")[0].childNodes[0].nodeValue;
                      if (Y)
                        return Y;
                    }
                  }
                return null;
              }
              function A(E) {
                var N = new Uint8Array([112, 115, 115, 104, 0, 0, 0, 0]), C = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]), b = 0, w = null, V, J, H, z, Z;
                if (c(), !E)
                  return null;
                if ("pssh" in E)
                  return g.default.parseInitDataFromContentProtection(E, L);
                if ("pro" in E)
                  w = L.decodeArray(E.pro.__text);
                else if ("prheader" in E)
                  w = L.decodeArray(E.prheader.__text);
                else
                  return null;
                return V = w.length, J = 4 + N.length + C.length + 4 + V, H = new ArrayBuffer(J), z = new Uint8Array(H), Z = new DataView(H), Z.setUint32(b, J), b += 4, z.set(N, b), b += N.length, z.set(C, b), b += C.length, Z.setUint32(b, V), b += 4, z.set(w, b), b += V, z.buffer;
              }
              function I(E) {
                if (E !== "utf-8" && E !== "utf-16")
                  throw new Error('Specified message format is not one of "utf-8" or "utf-16"');
                _ = E;
              }
              function M(E) {
                var N, C, b, w;
                if (c(), !E)
                  return null;
                for (N = [], w = 0; w < E.length; ++w)
                  N.push(E.charCodeAt(w)), N.push(0);
                for (N = String.fromCharCode.apply(null, N), N = L.encode(N), C = d.replace("%CUSTOMDATA%", N), b = [], w = 0; w < C.length; ++w)
                  b.push(C.charCodeAt(w)), b.push(0);
                return new Uint8Array(b).buffer;
              }
              return h = {
                uuid: i,
                schemeIdURI: l,
                systemString: r,
                getInitData: A,
                getRequestHeadersFromMessage: o,
                getLicenseRequestFromMessage: y,
                getLicenseServerURLFromInitData: u,
                getCDMData: M,
                setPlayReadyMessageFormat: I
              }, h;
            }
            t.__dashjs_factory_name = "KeySystemPlayReady";
            const T = dashjs.FactoryMaker.getSingletonFactory(t);
          }
        ),
        /***/
        "./src/streaming/protection/drm/KeySystemW3CClearKey.js": (
          /*!**************************************************************!*\
            !*** ./src/streaming/protection/drm/KeySystemW3CClearKey.js ***!
            \**************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var g = e(
              /*! ../vo/KeyPair */
              "./src/streaming/protection/vo/KeyPair.js"
            ), n = e(
              /*! ../vo/ClearKeyKeySet */
              "./src/streaming/protection/vo/ClearKeyKeySet.js"
            ), i = e(
              /*! ../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), r = e(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            ), l = "1077efec-c0b2-4d02-ace3-3c1e52e2fb4b", d = r.default.CLEARKEY_KEYSTEM_STRING, t = "urn:uuid:" + l;
            function T(h) {
              var _, L = h.BASE64, v = h.debug.getLogger(_);
              function c(M, E) {
                var N = null;
                if (M) {
                  for (var C = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(E))), b = [], w = 0; w < C.kids.length; w++) {
                    var V = C.kids[w], J = M.clearkeys && M.clearkeys.hasOwnProperty(V) ? M.clearkeys[V] : null;
                    if (!J)
                      throw new Error("DRM: ClearKey keyID (" + V + ") is not known!");
                    b.push(new g.default(V, J));
                  }
                  N = new n.default(b), v.warn("ClearKey schemeIdURI is using W3C Common PSSH systemID (1077efec-c0b2-4d02-ace3-3c1e52e2fb4b) in Content Protection. See DASH-IF IOP v4.1 section 7.6.2.4");
                }
                return N;
              }
              function o(M) {
                return i.default.parseInitDataFromContentProtection(M, L);
              }
              function y() {
                return null;
              }
              function u(M) {
                return new Uint8Array(M);
              }
              function A() {
                return null;
              }
              function I() {
                return null;
              }
              return _ = {
                uuid: l,
                schemeIdURI: t,
                systemString: d,
                getInitData: o,
                getRequestHeadersFromMessage: y,
                getLicenseRequestFromMessage: u,
                getLicenseServerURLFromInitData: A,
                getCDMData: I,
                getClearKeysFromProtectionData: c
              }, _;
            }
            T.__dashjs_factory_name = "KeySystemW3CClearKey";
            const S = dashjs.FactoryMaker.getSingletonFactory(T);
          }
        ),
        /***/
        "./src/streaming/protection/drm/KeySystemWidevine.js": (
          /*!***********************************************************!*\
            !*** ./src/streaming/protection/drm/KeySystemWidevine.js ***!
            \***********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => t
              /* harmony export */
            });
            var g = e(
              /*! ../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), n = e(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            ), i = "edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", r = n.default.WIDEVINE_KEYSTEM_STRING, l = "urn:uuid:" + i;
            function d(T) {
              T = T || {};
              var S, h = T.BASE64;
              function _(y) {
                return g.default.parseInitDataFromContentProtection(y, h);
              }
              function L() {
                return null;
              }
              function v(y) {
                return new Uint8Array(y);
              }
              function c() {
                return null;
              }
              function o() {
                return null;
              }
              return S = {
                uuid: i,
                schemeIdURI: l,
                systemString: r,
                getInitData: _,
                getRequestHeadersFromMessage: L,
                getLicenseRequestFromMessage: v,
                getLicenseServerURLFromInitData: c,
                getCDMData: o
              }, S;
            }
            d.__dashjs_factory_name = "KeySystemWidevine";
            const t = dashjs.FactoryMaker.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/streaming/protection/errors/ProtectionErrors.js": (
          /*!*************************************************************!*\
            !*** ./src/streaming/protection/errors/ProtectionErrors.js ***!
            \*************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ../../../core/errors/ErrorsBase */
              "./src/core/errors/ErrorsBase.js"
            );
            function n(c) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(y) {
                return typeof y;
              } : n = function(y) {
                return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
              }, n(c);
            }
            function i(c, o) {
              if (!(c instanceof o))
                throw new TypeError("Cannot call a class as a function");
            }
            function r(c, o) {
              if (typeof o != "function" && o !== null)
                throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(o && o.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), o && l(c, o);
            }
            function l(c, o) {
              return l = Object.setPrototypeOf || function(u, A) {
                return u.__proto__ = A, u;
              }, l(c, o);
            }
            function d(c) {
              var o = S();
              return function() {
                var u = h(c), A;
                if (o) {
                  var I = h(this).constructor;
                  A = Reflect.construct(u, arguments, I);
                } else
                  A = u.apply(this, arguments);
                return t(this, A);
              };
            }
            function t(c, o) {
              return o && (n(o) === "object" || typeof o == "function") ? o : T(c);
            }
            function T(c) {
              if (c === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return c;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function h(c) {
              return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, h(c);
            }
            var _ = /* @__PURE__ */ function(c) {
              r(y, c);
              var o = d(y);
              function y() {
                var u;
                return i(this, y), u = o.call(this), u.MEDIA_KEYERR_CODE = 100, u.MEDIA_KEYERR_UNKNOWN_CODE = 101, u.MEDIA_KEYERR_CLIENT_CODE = 102, u.MEDIA_KEYERR_SERVICE_CODE = 103, u.MEDIA_KEYERR_OUTPUT_CODE = 104, u.MEDIA_KEYERR_HARDWARECHANGE_CODE = 105, u.MEDIA_KEYERR_DOMAIN_CODE = 106, u.MEDIA_KEY_MESSAGE_ERROR_CODE = 107, u.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE = 108, u.SERVER_CERTIFICATE_UPDATED_ERROR_CODE = 109, u.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE = 110, u.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE = 111, u.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE = 112, u.KEY_SESSION_CREATED_ERROR_CODE = 113, u.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE = 114, u.MEDIA_KEYERR_UNKNOWN_MESSAGE = "An unspecified error occurred. This value is used for errors that don't match any of the other codes.", u.MEDIA_KEYERR_CLIENT_MESSAGE = "The Key System could not be installed or updated.", u.MEDIA_KEYERR_SERVICE_MESSAGE = "The message passed into update indicated an error from the license service.", u.MEDIA_KEYERR_OUTPUT_MESSAGE = "There is no available output device with the required characteristics for the content protection system.", u.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE = "A hardware configuration change caused a content protection error.", u.MEDIA_KEYERR_DOMAIN_MESSAGE = "An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.", u.MEDIA_KEY_MESSAGE_ERROR_MESSAGE = "Multiple key sessions were creates with a user-agent that does not support sessionIDs!! Unpredictable behavior ahead!", u.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE = "DRM: Empty key message from CDM", u.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE = "Error updating server certificate -- ", u.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE = "DRM: KeyStatusChange error! -- License has expired", u.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE = "DRM: No license server URL specified!", u.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE = "DRM: KeySystem Access Denied! -- ", u.KEY_SESSION_CREATED_ERROR_MESSAGE = "DRM: unable to create session! --", u.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE = "DRM: licenser error! --", u;
              }
              return y;
            }(g.default), L = new _();
            const v = L;
          }
        ),
        /***/
        "./src/streaming/protection/models/ProtectionModel_01b.js": (
          /*!****************************************************************!*\
            !*** ./src/streaming/protection/models/ProtectionModel_01b.js ***!
            \****************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var g = e(
              /*! ../controllers/ProtectionKeyController */
              "./src/streaming/protection/controllers/ProtectionKeyController.js"
            ), n = e(
              /*! ../vo/NeedKey */
              "./src/streaming/protection/vo/NeedKey.js"
            ), i = e(
              /*! ../../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), r = e(
              /*! ../vo/KeyMessage */
              "./src/streaming/protection/vo/KeyMessage.js"
            ), l = e(
              /*! ../vo/KeySystemConfiguration */
              "./src/streaming/protection/vo/KeySystemConfiguration.js"
            ), d = e(
              /*! ../vo/KeySystemAccess */
              "./src/streaming/protection/vo/KeySystemAccess.js"
            ), t = e(
              /*! ../errors/ProtectionErrors */
              "./src/streaming/protection/errors/ProtectionErrors.js"
            );
            function T(h) {
              h = h || {};
              var _ = this.context, L = h.eventBus, v = h.events, c = h.debug, o = h.api, y = h.errHandler, u, A, I, M, E, N, C, b, w;
              function V() {
                A = c.getLogger(u), I = null, M = null, N = [], C = [], E = (0, g.default)(_).getInstance(), w = de();
              }
              function J() {
                I && ge();
                for (var se = 0; se < C.length; se++)
                  ae(C[se]);
                L.trigger(v.TEARDOWN_COMPLETE);
              }
              function H() {
                for (var se = [], ee = 0; ee < N.length; ee++)
                  se.push(N[ee].initData);
                for (var re = 0; re < C.length; re++)
                  se.push(C[re].initData);
                return se;
              }
              function z() {
                return C.concat(N);
              }
              function Z(se) {
                return new Promise(function(ee, re) {
                  var ue = I;
                  ue || (ue = document.createElement("video"));
                  for (var te = !1, O = 0; O < se.length; O++)
                    for (var p = se[O].ks.systemString, P = se[O].configs, k = null, X = null, F = 0; F < P.length; F++) {
                      var x = P[F].videoCapabilities;
                      if (x && x.length !== 0) {
                        X = [];
                        for (var W = 0; W < x.length; W++)
                          ue.canPlayType(x[W].contentType, p) !== "" && X.push(x[W]);
                      }
                      if (!(!k && !X || k && k.length === 0 || X && X.length === 0)) {
                        te = !0;
                        var $ = new l.default(k, X), ce = E.getKeySystemBySystemString(p), le = new d.default(ce, $);
                        L.trigger(v.KEY_SYSTEM_ACCESS_COMPLETE, {
                          data: le
                        }), ee({
                          data: le
                        });
                        break;
                      }
                    }
                  if (!te) {
                    var q = "Key system access denied! -- No valid audio/video content configurations detected!";
                    L.trigger(v.KEY_SYSTEM_ACCESS_COMPLETE, {
                      error: q
                    }), re({
                      error: q
                    });
                  }
                });
              }
              function ie(se) {
                return M = se.keySystem, Promise.resolve(M);
              }
              function K(se) {
                if (I !== se) {
                  if (I) {
                    ge();
                    for (var ee = 0; ee < C.length; ee++)
                      ae(C[ee]);
                    C = [];
                  }
                  I = se, I && (I.addEventListener(o.keyerror, w), I.addEventListener(o.needkey, w), I.addEventListener(o.keymessage, w), I.addEventListener(o.keyadded, w), L.trigger(v.VIDEO_ELEMENT_SELECTED));
                }
              }
              function Y(se) {
                if (!M)
                  throw new Error("Can not create sessions until you have selected a key system");
                if (b || C.length === 0) {
                  var ee = {
                    // Implements SessionToken
                    sessionId: null,
                    keyId: se.keyId,
                    initData: se.initData,
                    getKeyId: function() {
                      return this.keyId;
                    },
                    getSessionId: function() {
                      return this.sessionId;
                    },
                    getExpirationTime: function() {
                      return NaN;
                    },
                    getSessionType: function() {
                      return "temporary";
                    }
                  };
                  return N.push(ee), I[o.generateKeyRequest](M.systemString, new Uint8Array(se.initData)), ee;
                } else
                  throw new Error("Multiple sessions not allowed!");
              }
              function ne(se, ee) {
                var re = se.sessionId;
                if (!E.isClearKey(M))
                  I[o.addKey](M.systemString, new Uint8Array(ee), new Uint8Array(se.initData), re);
                else
                  for (var ue = 0; ue < ee.keyPairs.length; ue++)
                    I[o.addKey](M.systemString, ee.keyPairs[ue].key, ee.keyPairs[ue].keyID, re);
                L.trigger(v.KEY_SESSION_UPDATED);
              }
              function ae(se) {
                try {
                  I[o.cancelKeyRequest](M.systemString, se.sessionId);
                } catch (ee) {
                  L.trigger(v.KEY_SESSION_CLOSED, {
                    data: null,
                    error: "Error closing session (" + se.sessionId + ") " + ee.message
                  });
                }
              }
              function fe() {
              }
              function Q() {
              }
              function oe() {
              }
              function de() {
                return {
                  handleEvent: function(ee) {
                    var re = null;
                    switch (ee.type) {
                      case o.needkey:
                        var ue = ArrayBuffer.isView(ee.initData) ? ee.initData.buffer : ee.initData;
                        L.trigger(v.NEED_KEY, {
                          key: new n.default(ue, "cenc")
                        });
                        break;
                      case o.keyerror:
                        if (re = Me(C, ee.sessionId), re || (re = Me(N, ee.sessionId)), re) {
                          var te = t.default.MEDIA_KEYERR_CODE, O = "";
                          switch (ee.errorCode.code) {
                            case 1:
                              te = t.default.MEDIA_KEYERR_UNKNOWN_CODE, O += "MEDIA_KEYERR_UNKNOWN - " + t.default.MEDIA_KEYERR_UNKNOWN_MESSAGE;
                              break;
                            case 2:
                              te = t.default.MEDIA_KEYERR_CLIENT_CODE, O += "MEDIA_KEYERR_CLIENT - " + t.default.MEDIA_KEYERR_CLIENT_MESSAGE;
                              break;
                            case 3:
                              te = t.default.MEDIA_KEYERR_SERVICE_CODE, O += "MEDIA_KEYERR_SERVICE - " + t.default.MEDIA_KEYERR_SERVICE_MESSAGE;
                              break;
                            case 4:
                              te = t.default.MEDIA_KEYERR_OUTPUT_CODE, O += "MEDIA_KEYERR_OUTPUT - " + t.default.MEDIA_KEYERR_OUTPUT_MESSAGE;
                              break;
                            case 5:
                              te = t.default.MEDIA_KEYERR_HARDWARECHANGE_CODE, O += "MEDIA_KEYERR_HARDWARECHANGE - " + t.default.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE;
                              break;
                            case 6:
                              te = t.default.MEDIA_KEYERR_DOMAIN_CODE, O += "MEDIA_KEYERR_DOMAIN - " + t.default.MEDIA_KEYERR_DOMAIN_MESSAGE;
                              break;
                          }
                          O += "  System Code = " + ee.systemCode, L.trigger(v.KEY_ERROR, {
                            error: new i.default(te, O, re)
                          });
                        } else
                          A.error("No session token found for key error");
                        break;
                      case o.keyadded:
                        re = Me(C, ee.sessionId), re || (re = Me(N, ee.sessionId)), re ? (A.debug("DRM: Key added."), L.trigger(v.KEY_ADDED, {
                          data: re
                        })) : A.debug("No session token found for key added");
                        break;
                      case o.keymessage:
                        if (b = ee.sessionId !== null && ee.sessionId !== void 0, b ? (re = Me(C, ee.sessionId), !re && N.length > 0 && (re = N.shift(), C.push(re), re.sessionId = ee.sessionId, L.trigger(v.KEY_SESSION_CREATED, {
                          data: re
                        }))) : N.length > 0 && (re = N.shift(), C.push(re), N.length !== 0 && y.error(new i.default(t.default.MEDIA_KEY_MESSAGE_ERROR_CODE, t.default.MEDIA_KEY_MESSAGE_ERROR_MESSAGE))), re) {
                          var p = ArrayBuffer.isView(ee.message) ? ee.message.buffer : ee.message;
                          re.keyMessage = p, L.trigger(v.INTERNAL_KEY_MESSAGE, {
                            data: new r.default(re, p, ee.defaultURL)
                          });
                        } else
                          A.warn("No session token found for key message");
                        break;
                    }
                  }
                };
              }
              function Me(se, ee) {
                if (!ee || !se)
                  return null;
                for (var re = se.length, ue = 0; ue < re; ue++)
                  if (se[ue].sessionId == ee)
                    return se[ue];
                return null;
              }
              function ge() {
                I.removeEventListener(o.keyerror, w), I.removeEventListener(o.needkey, w), I.removeEventListener(o.keymessage, w), I.removeEventListener(o.keyadded, w);
              }
              return u = {
                getAllInitData: H,
                getSessions: z,
                requestKeySystemAccess: Z,
                selectKeySystem: ie,
                setMediaElement: K,
                createKeySession: Y,
                updateKeySession: ne,
                closeKeySession: ae,
                setServerCertificate: fe,
                loadKeySession: Q,
                removeKeySession: oe,
                stop: J,
                reset: J
              }, V(), u;
            }
            T.__dashjs_factory_name = "ProtectionModel_01b";
            const S = dashjs.FactoryMaker.getClassFactory(T);
          }
        ),
        /***/
        "./src/streaming/protection/models/ProtectionModel_21Jan2015.js": (
          /*!**********************************************************************!*\
            !*** ./src/streaming/protection/models/ProtectionModel_21Jan2015.js ***!
            \**********************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            var g = e(
              /*! ../controllers/ProtectionKeyController */
              "./src/streaming/protection/controllers/ProtectionKeyController.js"
            ), n = e(
              /*! ../vo/NeedKey */
              "./src/streaming/protection/vo/NeedKey.js"
            ), i = e(
              /*! ../errors/ProtectionErrors */
              "./src/streaming/protection/errors/ProtectionErrors.js"
            ), r = e(
              /*! ../../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), l = e(
              /*! ../vo/KeyMessage */
              "./src/streaming/protection/vo/KeyMessage.js"
            ), d = e(
              /*! ../vo/KeySystemAccess */
              "./src/streaming/protection/vo/KeySystemAccess.js"
            ), t = e(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            ), T = {};
            T[t.default.PLAYREADY_KEYSTEM_STRING] = [t.default.PLAYREADY_KEYSTEM_STRING, t.default.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING], T[t.default.WIDEVINE_KEYSTEM_STRING] = [t.default.WIDEVINE_KEYSTEM_STRING], T[t.default.CLEARKEY_KEYSTEM_STRING] = [t.default.CLEARKEY_KEYSTEM_STRING];
            function S(_) {
              _ = _ || {};
              var L = this.context, v = _.eventBus, c = _.events, o = _.debug, y, u, A, I, M, E, N, C;
              function b() {
                u = o.getLogger(y), A = null, I = null, M = null, E = [], C = (0, g.default)(L).getInstance(), N = se();
              }
              function w() {
                var te = E.length, O;
                te !== 0 ? function() {
                  for (var p = function(X) {
                    ee(X), E.length === 0 && (I ? (I.removeEventListener("encrypted", N), I.setMediaKeys(null).then(function() {
                      v.trigger(c.TEARDOWN_COMPLETE);
                    })) : v.trigger(c.TEARDOWN_COMPLETE));
                  }, P = 0; P < te; P++)
                    O = E[P], function(k) {
                      O.session.closed.then(function() {
                        p(k);
                      }), ge(O).catch(function() {
                        p(k);
                      });
                    }(O);
                }() : v.trigger(c.TEARDOWN_COMPLETE);
              }
              function V() {
                for (var te, O = 0; O < E.length; O++)
                  te = E[O], te.getUsable() || ge(te).catch(function() {
                    ee(te);
                  });
              }
              function J() {
                for (var te = [], O = 0; O < E.length; O++)
                  E[O].initData && te.push(E[O].initData);
                return te;
              }
              function H() {
                return E;
              }
              function z(te) {
                return new Promise(function(O, p) {
                  Z(te, 0, O, p);
                });
              }
              function Z(te, O, p, P) {
                if (navigator.requestMediaKeySystemAccess === void 0 || typeof navigator.requestMediaKeySystemAccess != "function") {
                  var k = "Insecure origins are not allowed";
                  v.trigger(c.KEY_SYSTEM_ACCESS_COMPLETE, {
                    error: k
                  }), P({
                    error: k
                  });
                  return;
                }
                var X = te[O].protData && te[O].protData.systemStringPriority ? te[O].protData.systemStringPriority : null, F = te[O].configs, x = te[O].ks, W = x.systemString, $ = X || (T[W] ? T[W] : [W]);
                ie($, F).then(function(ce) {
                  var le = typeof ce.getConfiguration == "function" ? ce.getConfiguration() : null, q = new d.default(x, le);
                  q.mksa = ce, v.trigger(c.KEY_SYSTEM_ACCESS_COMPLETE, {
                    data: q
                  }), p({
                    data: q
                  });
                }).catch(function(ce) {
                  if (O + 1 < te.length)
                    Z(te, O + 1, p, P);
                  else {
                    var le = "Key system access denied! ";
                    v.trigger(c.KEY_SYSTEM_ACCESS_COMPLETE, {
                      error: le + ce.message
                    }), P({
                      error: le + ce.message
                    });
                  }
                });
              }
              function ie(te, O) {
                return new Promise(function(p, P) {
                  K(te, O, 0, p, P);
                });
              }
              function K(te, O, p, P, k) {
                var X = te[p];
                u.debug("Requesting key system access for system string ".concat(X)), navigator.requestMediaKeySystemAccess(X, O).then(function(F) {
                  F.selectedSystemString = X, P(F);
                }).catch(function(F) {
                  p + 1 < te.length ? K(te, O, p + 1, P, k) : k(F);
                });
              }
              function Y(te) {
                return new Promise(function(O, p) {
                  te.mksa.createMediaKeys().then(function(P) {
                    return A = te.keySystem, M = P, I ? I.setMediaKeys(M) : Promise.resolve();
                  }).then(function() {
                    O(A);
                  }).catch(function() {
                    p({
                      error: "Error selecting keys system (" + te.keySystem.systemString + ")! Could not create MediaKeys -- TODO"
                    });
                  });
                });
              }
              function ne(te) {
                I !== te && (I && (I.removeEventListener("encrypted", N), I.setMediaKeys && I.setMediaKeys(null)), I = te, I && (I.addEventListener("encrypted", N), I.setMediaKeys && M && I.setMediaKeys(M)));
              }
              function ae(te) {
                if (!A || !M)
                  throw new Error("Can not set server certificate until you have selected a key system");
                M.setServerCertificate(te).then(function() {
                  u.info("DRM: License server certificate successfully updated."), v.trigger(c.SERVER_CERTIFICATE_UPDATED);
                }).catch(function(O) {
                  v.trigger(c.SERVER_CERTIFICATE_UPDATED, {
                    error: new r.default(i.default.SERVER_CERTIFICATE_UPDATED_ERROR_CODE, i.default.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE + O.name)
                  });
                });
              }
              function fe(te) {
                if (!A || !M)
                  throw new Error("Can not create sessions until you have selected a key system");
                var O = M.createSession(te.sessionType), p = ue(O, te), P = A.systemString === t.default.CLEARKEY_KEYSTEM_STRING && (te.initData || te.protData && te.protData.clearkeys) ? t.default.INITIALIZATION_DATA_TYPE_KEYIDS : t.default.INITIALIZATION_DATA_TYPE_CENC;
                O.generateRequest(P, te.initData).then(function() {
                  u.debug("DRM: Session created.  SessionID = " + p.getSessionId()), v.trigger(c.KEY_SESSION_CREATED, {
                    data: p
                  });
                }).catch(function(k) {
                  ee(p), v.trigger(c.KEY_SESSION_CREATED, {
                    data: null,
                    error: new r.default(i.default.KEY_SESSION_CREATED_ERROR_CODE, i.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Error generating key request -- " + k.name)
                  });
                });
              }
              function Q(te, O) {
                var p = te.session;
                C.isClearKey(A) && (O = O.toJWK()), p.update(O).then(function() {
                  v.trigger(c.KEY_SESSION_UPDATED);
                }).catch(function(P) {
                  v.trigger(c.KEY_ERROR, {
                    error: new r.default(i.default.MEDIA_KEYERR_CODE, "Error sending update() message! " + P.name, te)
                  });
                });
              }
              function oe(te) {
                if (!A || !M)
                  throw new Error("Can not load sessions until you have selected a key system");
                for (var O = te.sessionId, p = 0; p < E.length; p++)
                  if (O === E[p].sessionId) {
                    u.warn("DRM: Ignoring session ID because we have already seen it!");
                    return;
                  }
                var P = M.createSession(te.sessionType), k = ue(P, te);
                P.load(O).then(function(X) {
                  X ? (u.debug("DRM: Session loaded.  SessionID = " + k.getSessionId()), v.trigger(c.KEY_SESSION_CREATED, {
                    data: k
                  })) : (ee(k), v.trigger(c.KEY_SESSION_CREATED, {
                    data: null,
                    error: new r.default(i.default.KEY_SESSION_CREATED_ERROR_CODE, i.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session! Invalid Session ID (" + O + ")")
                  }));
                }).catch(function(X) {
                  ee(k), v.trigger(c.KEY_SESSION_CREATED, {
                    data: null,
                    error: new r.default(i.default.KEY_SESSION_CREATED_ERROR_CODE, i.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session (" + O + ")! " + X.name)
                  });
                });
              }
              function de(te) {
                var O = te.session;
                O.remove().then(function() {
                  u.debug("DRM: Session removed.  SessionID = " + te.getSessionId()), v.trigger(c.KEY_SESSION_REMOVED, {
                    data: te.getSessionId()
                  });
                }, function(p) {
                  v.trigger(c.KEY_SESSION_REMOVED, {
                    data: null,
                    error: "Error removing session (" + te.getSessionId() + "). " + p.name
                  });
                });
              }
              function Me(te) {
                ge(te).catch(function(O) {
                  ee(te), v.trigger(c.KEY_SESSION_CLOSED, {
                    data: null,
                    error: "Error closing session (" + te.getSessionId() + ") " + O.name
                  });
                });
              }
              function ge(te) {
                var O = te.session;
                return O.removeEventListener("keystatuseschange", te), O.removeEventListener("message", te), O.close();
              }
              function se() {
                return {
                  handleEvent: function(O) {
                    switch (O.type) {
                      case "encrypted":
                        if (O.initData) {
                          var p = ArrayBuffer.isView(O.initData) ? O.initData.buffer : O.initData;
                          v.trigger(c.NEED_KEY, {
                            key: new n.default(p, O.initDataType)
                          });
                        }
                        break;
                    }
                  }
                };
              }
              function ee(te) {
                for (var O = 0; O < E.length; O++)
                  if (E[O] === te) {
                    E.splice(O, 1);
                    break;
                  }
              }
              function re(te) {
                var O, p;
                return te && te.length > 0 && (te[0] && (typeof te[0] == "string" ? O = te[0] : p = te[0]), te[1] && (typeof te[1] == "string" ? O = te[1] : p = te[1])), {
                  status: O,
                  keyId: p
                };
              }
              function ue(te, O) {
                var p = {
                  // Implements SessionToken
                  session: te,
                  keyId: O.keyId,
                  initData: O.initData,
                  sessionId: O.sessionId,
                  sessionType: O.sessionType,
                  // This is our main event handler for all desired MediaKeySession events
                  // These events are translated into our API-independent versions of the
                  // same events
                  handleEvent: function(k) {
                    switch (k.type) {
                      case "keystatuseschange":
                        v.trigger(c.KEY_STATUSES_CHANGED, {
                          data: this
                        }), k.target.keyStatuses.forEach(function() {
                          var F = re(arguments);
                          switch (F.status) {
                            case "expired":
                              v.trigger(c.INTERNAL_KEY_STATUS_CHANGED, {
                                error: new r.default(i.default.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE, i.default.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE)
                              });
                              break;
                            default:
                              v.trigger(c.INTERNAL_KEY_STATUS_CHANGED, F);
                              break;
                          }
                        });
                        break;
                      case "message":
                        var X = ArrayBuffer.isView(k.message) ? k.message.buffer : k.message;
                        v.trigger(c.INTERNAL_KEY_MESSAGE, {
                          data: new l.default(this, X, void 0, k.messageType)
                        });
                        break;
                    }
                  },
                  getKeyId: function() {
                    return this.keyId;
                  },
                  getSessionId: function() {
                    return te.sessionId;
                  },
                  getSessionType: function() {
                    return this.sessionType;
                  },
                  getExpirationTime: function() {
                    return te.expiration;
                  },
                  getKeyStatuses: function() {
                    return te.keyStatuses;
                  },
                  getUsable: function() {
                    var k = !1;
                    return te.keyStatuses.forEach(function() {
                      var X = re(arguments);
                      X.status === "usable" && (k = !0);
                    }), k;
                  }
                };
                return te.addEventListener("keystatuseschange", p), te.addEventListener("message", p), te.closed.then(function() {
                  ee(p), u.debug("DRM: Session closed.  SessionID = " + p.getSessionId()), v.trigger(c.KEY_SESSION_CLOSED, {
                    data: p.getSessionId()
                  });
                }), E.push(p), p;
              }
              return y = {
                getAllInitData: J,
                getSessions: H,
                requestKeySystemAccess: z,
                selectKeySystem: Y,
                setMediaElement: ne,
                setServerCertificate: ae,
                createKeySession: fe,
                updateKeySession: Q,
                loadKeySession: oe,
                removeKeySession: de,
                closeKeySession: Me,
                stop: V,
                reset: w
              }, b(), y;
            }
            S.__dashjs_factory_name = "ProtectionModel_21Jan2015";
            const h = dashjs.FactoryMaker.getClassFactory(S);
          }
        ),
        /***/
        "./src/streaming/protection/models/ProtectionModel_3Feb2014.js": (
          /*!*********************************************************************!*\
            !*** ./src/streaming/protection/models/ProtectionModel_3Feb2014.js ***!
            \*********************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var g = e(
              /*! ../controllers/ProtectionKeyController */
              "./src/streaming/protection/controllers/ProtectionKeyController.js"
            ), n = e(
              /*! ../vo/NeedKey */
              "./src/streaming/protection/vo/NeedKey.js"
            ), i = e(
              /*! ../../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), r = e(
              /*! ../errors/ProtectionErrors */
              "./src/streaming/protection/errors/ProtectionErrors.js"
            ), l = e(
              /*! ../vo/KeyMessage */
              "./src/streaming/protection/vo/KeyMessage.js"
            ), d = e(
              /*! ../vo/KeySystemConfiguration */
              "./src/streaming/protection/vo/KeySystemConfiguration.js"
            ), t = e(
              /*! ../vo/KeySystemAccess */
              "./src/streaming/protection/vo/KeySystemAccess.js"
            );
            function T(h) {
              h = h || {};
              var _ = this.context, L = h.eventBus, v = h.events, c = h.debug, o = h.api, y, u, A, I, M, E, N, C, b;
              function w() {
                u = c.getLogger(y), A = null, I = null, M = null, E = null, N = [], b = (0, g.default)(_).getInstance(), C = oe();
              }
              function V() {
                try {
                  for (var ge = 0; ge < N.length; ge++)
                    ne(N[ge]);
                  A && A.removeEventListener(o.needkey, C), L.trigger(v.TEARDOWN_COMPLETE);
                } catch (se) {
                  L.trigger(v.TEARDOWN_COMPLETE, {
                    error: "Error tearing down key sessions and MediaKeys! -- " + se.message
                  });
                }
              }
              function J() {
                for (var ge = [], se = 0; se < N.length; se++)
                  ge.push(N[se].initData);
                return ge;
              }
              function H() {
                return N;
              }
              function z(ge) {
                return new Promise(function(se, ee) {
                  for (var re = !1, ue = 0; ue < ge.length; ue++)
                    for (var te = ge[ue].ks.systemString, O = ge[ue].configs, p = null, P = null, k = 0; k < O.length; k++) {
                      var X = O[k].audioCapabilities, F = O[k].videoCapabilities;
                      if (X && X.length !== 0) {
                        p = [];
                        for (var x = 0; x < X.length; x++)
                          window[o.MediaKeys].isTypeSupported(te, X[x].contentType) && p.push(X[x]);
                      }
                      if (F && F.length !== 0) {
                        P = [];
                        for (var W = 0; W < F.length; W++)
                          window[o.MediaKeys].isTypeSupported(te, F[W].contentType) && P.push(F[W]);
                      }
                      if (!(!p && !P || p && p.length === 0 || P && P.length === 0)) {
                        re = !0;
                        var $ = new d.default(p, P), ce = b.getKeySystemBySystemString(te), le = new t.default(ce, $);
                        L.trigger(v.KEY_SYSTEM_ACCESS_COMPLETE, {
                          data: le
                        }), se({
                          data: le
                        });
                        break;
                      }
                    }
                  if (!re) {
                    var q = "Key system access denied! -- No valid audio/video content configurations detected!";
                    L.trigger(v.KEY_SYSTEM_ACCESS_COMPLETE, {
                      error: q
                    }), ee({
                      error: q
                    });
                  }
                });
              }
              function Z(ge) {
                return new Promise(function(se, ee) {
                  try {
                    M = ge.mediaKeys = new window[o.MediaKeys](ge.keySystem.systemString), I = ge.keySystem, E = ge, A && de(), se(I);
                  } catch {
                    ee({
                      error: "Error selecting keys system (" + I.systemString + ")! Could not create MediaKeys -- TODO"
                    });
                  }
                });
              }
              function ie(ge) {
                A !== ge && (A && A.removeEventListener(o.needkey, C), A = ge, A && (A.addEventListener(o.needkey, C), M && de()));
              }
              function K(ge) {
                if (!I || !M || !E)
                  throw new Error("Can not create sessions until you have selected a key system");
                var se = null;
                if (E.ksConfiguration.videoCapabilities && E.ksConfiguration.videoCapabilities.length > 0 && (se = E.ksConfiguration.videoCapabilities[0]), se === null && E.ksConfiguration.audioCapabilities && E.ksConfiguration.audioCapabilities.length > 0 && (se = E.ksConfiguration.audioCapabilities[0]), se === null)
                  throw new Error("Can not create sessions for unknown content types.");
                var ee = se.contentType, re = M.createSession(ee, new Uint8Array(ge.initData), ge.cdmData ? new Uint8Array(ge.cdmData) : null), ue = Me(re, ge);
                re.addEventListener(o.error, ue), re.addEventListener(o.message, ue), re.addEventListener(o.ready, ue), re.addEventListener(o.close, ue), N.push(ue), u.debug("DRM: Session created.  SessionID = " + ue.getSessionId()), L.trigger(v.KEY_SESSION_CREATED, {
                  data: ue
                });
              }
              function Y(ge, se) {
                var ee = ge.session;
                b.isClearKey(I) ? ee.update(new Uint8Array(se.toJWK())) : ee.update(new Uint8Array(se)), L.trigger(v.KEY_SESSION_UPDATED);
              }
              function ne(ge) {
                var se = ge.session;
                se.removeEventListener(o.error, ge), se.removeEventListener(o.message, ge), se.removeEventListener(o.ready, ge), se.removeEventListener(o.close, ge);
                for (var ee = 0; ee < N.length; ee++)
                  if (N[ee] === ge) {
                    N.splice(ee, 1);
                    break;
                  }
                se[o.release]();
              }
              function ae() {
              }
              function fe() {
              }
              function Q() {
              }
              function oe() {
                return {
                  handleEvent: function(se) {
                    switch (se.type) {
                      case o.needkey:
                        if (se.initData) {
                          var ee = ArrayBuffer.isView(se.initData) ? se.initData.buffer : se.initData;
                          L.trigger(v.NEED_KEY, {
                            key: new n.default(ee, "cenc")
                          });
                        }
                        break;
                    }
                  }
                };
              }
              function de() {
                var ge = null, se = function() {
                  A.removeEventListener("loadedmetadata", ge), A[o.setMediaKeys](M), L.trigger(v.VIDEO_ELEMENT_SELECTED);
                };
                A.readyState >= 1 ? se() : (ge = se.bind(this), A.addEventListener("loadedmetadata", ge));
              }
              function Me(ge, se) {
                return {
                  // Implements SessionToken
                  session: ge,
                  keyId: se.keyId,
                  initData: se.initData,
                  getKeyId: function() {
                    return this.keyId;
                  },
                  getSessionId: function() {
                    return this.session.sessionId;
                  },
                  getExpirationTime: function() {
                    return NaN;
                  },
                  getSessionType: function() {
                    return "temporary";
                  },
                  // This is our main event handler for all desired MediaKeySession events
                  // These events are translated into our API-independent versions of the
                  // same events
                  handleEvent: function(re) {
                    switch (re.type) {
                      case o.error:
                        var ue = "KeyError";
                        L.trigger(v.KEY_ERROR, {
                          error: new i.default(r.default.MEDIA_KEYERR_CODE, ue, this)
                        });
                        break;
                      case o.message:
                        var te = ArrayBuffer.isView(re.message) ? re.message.buffer : re.message;
                        L.trigger(v.INTERNAL_KEY_MESSAGE, {
                          data: new l.default(this, te, re.destinationURL)
                        });
                        break;
                      case o.ready:
                        u.debug("DRM: Key added."), L.trigger(v.KEY_ADDED);
                        break;
                      case o.close:
                        u.debug("DRM: Session closed.  SessionID = " + this.getSessionId()), L.trigger(v.KEY_SESSION_CLOSED, {
                          data: this.getSessionId()
                        });
                        break;
                    }
                  }
                };
              }
              return y = {
                getAllInitData: J,
                getSessions: H,
                requestKeySystemAccess: z,
                selectKeySystem: Z,
                setMediaElement: ie,
                createKeySession: K,
                updateKeySession: Y,
                closeKeySession: ne,
                setServerCertificate: ae,
                loadKeySession: fe,
                removeKeySession: Q,
                stop: V,
                reset: V
              }, w(), y;
            }
            T.__dashjs_factory_name = "ProtectionModel_3Feb2014";
            const S = dashjs.FactoryMaker.getClassFactory(T);
          }
        ),
        /***/
        "./src/streaming/protection/servers/ClearKey.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/protection/servers/ClearKey.js ***!
            \******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../vo/KeyPair */
              "./src/streaming/protection/vo/KeyPair.js"
            ), n = e(
              /*! ../vo/ClearKeyKeySet */
              "./src/streaming/protection/vo/ClearKeyKeySet.js"
            );
            function i() {
              var l;
              function d(_) {
                return _;
              }
              function t() {
                return "POST";
              }
              function T() {
                return "json";
              }
              function S(_) {
                if (!_.hasOwnProperty("keys"))
                  return null;
                for (var L = [], v = 0; v < _.keys.length; v++) {
                  var c = _.keys[v], o = c.kid.replace(/=/g, ""), y = c.k.replace(/=/g, "");
                  L.push(new g.default(o, y));
                }
                return new n.default(L);
              }
              function h(_) {
                return String.fromCharCode.apply(null, new Uint8Array(_));
              }
              return l = {
                getServerURLFromMessage: d,
                getHTTPMethod: t,
                getResponseType: T,
                getLicenseMessage: S,
                getErrorResponse: h
              }, l;
            }
            i.__dashjs_factory_name = "ClearKey";
            const r = dashjs.FactoryMaker.getSingletonFactory(i);
          }
        ),
        /***/
        "./src/streaming/protection/servers/DRMToday.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/protection/servers/DRMToday.js ***!
            \******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            );
            function n(r) {
              r = r || {};
              var l = r.BASE64, d = {};
              d[g.default.WIDEVINE_KEYSTEM_STRING] = {
                responseType: "json",
                getLicenseMessage: function(o) {
                  return l.decodeArray(o.license);
                },
                getErrorResponse: function(o) {
                  return o;
                }
              }, d[g.default.PLAYREADY_KEYSTEM_STRING] = {
                responseType: "arraybuffer",
                getLicenseMessage: function(o) {
                  return o;
                },
                getErrorResponse: function(o) {
                  return String.fromCharCode.apply(null, new Uint8Array(o));
                }
              };
              var t;
              function T() {
                if (!l || !l.hasOwnProperty("decodeArray"))
                  throw new Error("Missing config parameter(s)");
              }
              function S(c) {
                return c;
              }
              function h() {
                return "POST";
              }
              function _(c) {
                return d[c].responseType;
              }
              function L(c, o) {
                return T(), d[o].getLicenseMessage(c);
              }
              function v(c, o) {
                return d[o].getErrorResponse(c);
              }
              return t = {
                getServerURLFromMessage: S,
                getHTTPMethod: h,
                getResponseType: _,
                getLicenseMessage: L,
                getErrorResponse: v
              }, t;
            }
            n.__dashjs_factory_name = "DRMToday";
            const i = dashjs.FactoryMaker.getSingletonFactory(n);
          }
        ),
        /***/
        "./src/streaming/protection/servers/PlayReady.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/protection/servers/PlayReady.js ***!
            \*******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n() {
              var r, l = "http://schemas.xmlsoap.org/soap/envelope/";
              function d(c) {
                var o = String.fromCharCode.apply(null, new Uint8Array(c)), y = decodeURIComponent(escape(o));
                return y;
              }
              function t(c) {
                if (window.DOMParser) {
                  var o = d(c), y = new window.DOMParser(), u = y.parseFromString(o, "text/xml"), A = u ? u.getElementsByTagNameNS(l, "Envelope")[0] : null, I = A ? A.getElementsByTagNameNS(l, "Body")[0] : null, M = I ? I.getElementsByTagNameNS(l, "Fault")[0] : null;
                  if (M)
                    return null;
                }
                return c;
              }
              function T(c) {
                var o = "", y = "", u = "", A = -1, I = -1;
                if (window.DOMParser) {
                  var M = d(c), E = new window.DOMParser(), N = E.parseFromString(M, "text/xml"), C = N ? N.getElementsByTagNameNS(l, "Envelope")[0] : null, b = C ? C.getElementsByTagNameNS(l, "Body")[0] : null, w = b ? b.getElementsByTagNameNS(l, "Fault")[0] : null, V = w ? w.getElementsByTagName("detail")[0] : null, J = V ? V.getElementsByTagName("Exception")[0] : null, H = null;
                  if (w === null)
                    return M;
                  H = w.getElementsByTagName("faultstring")[0].firstChild, o = H ? H.nodeValue : null, J !== null && (H = J.getElementsByTagName("StatusCode")[0], y = H ? H.firstChild.nodeValue : null, H = J.getElementsByTagName("Message")[0], u = H ? H.firstChild.nodeValue : null, A = u ? u.lastIndexOf("[") + 1 : -1, I = u ? u.indexOf("]") : -1, u = u ? u.substring(A, I) : "");
                }
                var z = "code: ".concat(y, ", name: ").concat(o);
                return u && (z += ", message: ".concat(u)), z;
              }
              function S(c) {
                return c;
              }
              function h() {
                return "POST";
              }
              function _() {
                return "arraybuffer";
              }
              function L(c) {
                return t.call(this, c);
              }
              function v(c) {
                return T.call(this, c);
              }
              return r = {
                getServerURLFromMessage: S,
                getHTTPMethod: h,
                getResponseType: _,
                getLicenseMessage: L,
                getErrorResponse: v
              }, r;
            }
            n.__dashjs_factory_name = "PlayReady";
            const i = g.default.getSingletonFactory(n);
          }
        ),
        /***/
        "./src/streaming/protection/servers/Widevine.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/protection/servers/Widevine.js ***!
            \******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => n
              /* harmony export */
            });
            function g() {
              var i;
              function r(S) {
                return S;
              }
              function l() {
                return "POST";
              }
              function d() {
                return "arraybuffer";
              }
              function t(S) {
                return S;
              }
              function T(S) {
                return String.fromCharCode.apply(null, new Uint8Array(S));
              }
              return i = {
                getServerURLFromMessage: r,
                getHTTPMethod: l,
                getResponseType: d,
                getLicenseMessage: t,
                getErrorResponse: T
              }, i;
            }
            g.__dashjs_factory_name = "Widevine";
            const n = dashjs.FactoryMaker.getSingletonFactory(g);
          }
        ),
        /***/
        "./src/streaming/protection/vo/ClearKeyKeySet.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/protection/vo/ClearKeyKeySet.js ***!
            \*******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            function g(d, t) {
              if (!(d instanceof t))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(d, t) {
              for (var T = 0; T < t.length; T++) {
                var S = t[T];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(d, S.key, S);
              }
            }
            function i(d, t, T) {
              return t && n(d.prototype, t), T && n(d, T), d;
            }
            var r = /* @__PURE__ */ function() {
              function d(t, T) {
                if (g(this, d), T && T !== "persistent" && T !== "temporary")
                  throw new Error("Invalid ClearKey key set type!  Must be one of 'persistent' or 'temporary'");
                this.keyPairs = t, this.type = T;
              }
              return i(d, [{
                key: "toJWK",
                value: function() {
                  var T, S = this.keyPairs.length, h = {
                    keys: []
                  };
                  for (T = 0; T < S; T++) {
                    var _ = {
                      kty: "oct",
                      alg: "A128KW",
                      kid: this.keyPairs[T].keyID,
                      k: this.keyPairs[T].key
                    };
                    h.keys.push(_);
                  }
                  this.type && (h.type = this.type);
                  var L = JSON.stringify(h), v = L.length, c = new ArrayBuffer(v), o = new Uint8Array(c);
                  for (T = 0; T < v; T++)
                    o[T] = L.charCodeAt(T);
                  return c;
                }
              }]), d;
            }();
            const l = r;
          }
        ),
        /***/
        "./src/streaming/protection/vo/KeyMessage.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/protection/vo/KeyMessage.js ***!
            \***************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @param {SessionToken} sessionToken the session
               * to which the key message is associated
               * @param {ArrayBuffer} message the key message
               * @param {string} defaultURL license acquisition URL provided by the CDM
               * @param {string} messageType Supported message types can be found
               * {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
               * @class
               */
              function r(l, d, t, T) {
                g(this, r), this.sessionToken = l, this.message = d, this.defaultURL = t, this.messageType = T || "license-request";
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/protection/vo/KeyPair.js": (
          /*!************************************************!*\
            !*** ./src/streaming/protection/vo/KeyPair.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @param {string} keyID 128-bit key ID, base64 encoded, with no padding
               * @param {string} key 128-bit encryption key, base64 encoded, with no padding
               * @class
               * @ignore
               */
              function r(l, d) {
                g(this, r), this.keyID = l, this.key = d;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/protection/vo/KeySystemAccess.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/protection/vo/KeySystemAccess.js ***!
            \********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @param {MediaPlayer.dependencies.protection.KeySystem} keySystem the key system
               * @param {KeySystemConfiguration} ksConfiguration the
               * subset of configurations passed to the key system access request that are supported
               * by this user agent
               * @class
               * @ignore
               */
              function r(l, d) {
                g(this, r), this.keySystem = l, this.ksConfiguration = d;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/protection/vo/KeySystemConfiguration.js": (
          /*!***************************************************************!*\
            !*** ./src/streaming/protection/vo/KeySystemConfiguration.js ***!
            \***************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @param {Array.<MediaCapability>} audioCapabilities array of
               * desired audio capabilities.  Higher preference capabilities should be placed earlier
               * in the array.
               * @param {Array.<MediaCapability>} videoCapabilities array of
               * desired video capabilities.  Higher preference capabilities should be placed earlier
               * in the array.
               * @param {string} distinctiveIdentifier desired use of distinctive identifiers.
               * One of "required", "optional", or "not-allowed"
               * @param {string} persistentState desired support for persistent storage of
               * key systems.  One of "required", "optional", or "not-allowed"
               * @param {Array.<string>} sessionTypes List of session types that must
               * be supported by the key system
               * @class
               */
              function r(l, d, t, T, S) {
                g(this, r), this.initDataTypes = ["cenc"], l && l.length && (this.audioCapabilities = l), d && d.length && (this.videoCapabilities = d), this.distinctiveIdentifier = t, this.persistentState = T, this.sessionTypes = S;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/protection/vo/LicenseRequest.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/protection/vo/LicenseRequest.js ***!
            \*******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * Defines a license request
               *
               * @class
               */
              function r(l, d, t, T, S, h, _, L) {
                g(this, r), this.url = l, this.method = d, this.responseType = t, this.headers = T, this.withCredentials = S, this.messageType = h, this.sessionId = _, this.data = L;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/protection/vo/LicenseResponse.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/protection/vo/LicenseResponse.js ***!
            \********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * Defines a license request
               *
               * @class
               * @ignore
               */
              function r(l, d, t) {
                g(this, r), this.url = l, this.headers = d, this.data = t;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/protection/vo/MediaCapability.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/protection/vo/MediaCapability.js ***!
            \********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @param {string} contentType MIME type and codecs (RFC6386)
               * @param {string} robustness
               * @class
               * @ignore
               */
              function r(l, d) {
                g(this, r), this.contentType = l, this.robustness = d;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/protection/vo/NeedKey.js": (
          /*!************************************************!*\
            !*** ./src/streaming/protection/vo/NeedKey.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @param {ArrayBuffer} initData the initialization data
               * @param {string} initDataType initialization data type
               * @class
               */
              function r(l, d) {
                g(this, r), this.initData = l, this.initDataType = d;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/rules/DroppedFramesHistory.js": (
          /*!*****************************************************!*\
            !*** ./src/streaming/rules/DroppedFramesHistory.js ***!
            \*****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n() {
              var l = {}, d = {}, t = {};
              function T(L, v, c) {
                if (v) {
                  l[L] || (l[L] = [], d[L] = 0, t[L] = 0);
                  var o = c && c.droppedVideoFrames ? c.droppedVideoFrames : 0, y = c && c.totalVideoFrames ? c.totalVideoFrames : 0, u = o - d[L];
                  d[L] = o;
                  var A = y - t[L];
                  t[L] = y;
                  var I = l[L];
                  isNaN(v) || (I[v] ? (I[v].droppedVideoFrames += u, I[v].totalVideoFrames += A) : I[v] = {
                    droppedVideoFrames: u,
                    totalVideoFrames: A
                  });
                }
              }
              function S(L) {
                return l[L];
              }
              function h(L) {
                try {
                  delete l[L], delete d[L], delete t[L];
                } catch {
                }
              }
              function _() {
                l = {}, d = {}, t = {};
              }
              return {
                push: T,
                getFrameHistory: S,
                clearForStream: h,
                reset: _
              };
            }
            n.__dashjs_factory_name = "DroppedFramesHistory";
            var i = g.default.getClassFactory(n);
            const r = i;
          }
        ),
        /***/
        "./src/streaming/rules/RulesContext.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/rules/RulesContext.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n(r) {
              r = r || {};
              var l, d = r.abrController, t = r.switchHistory, T = r.droppedFramesHistory, S = r.currentRequest, h = r.useBufferOccupancyABR, _ = r.useL2AABR, L = r.useLoLPABR, v = r.streamProcessor ? r.streamProcessor.getScheduleController() : null, c = r.streamProcessor ? r.streamProcessor.getRepresentationInfo() : null, o = r.videoModel ? r.videoModel : null;
              function y() {
                var z = A();
                return z ? z.type : null;
              }
              function u() {
                var z = A();
                return z ? z.streamInfo : null;
              }
              function A() {
                return c ? c.mediaInfo : null;
              }
              function I() {
                return c;
              }
              function M() {
                return v;
              }
              function E() {
                return d;
              }
              function N() {
                return t;
              }
              function C() {
                return o;
              }
              function b() {
                return T;
              }
              function w() {
                return S;
              }
              function V() {
                return h;
              }
              function J() {
                return _;
              }
              function H() {
                return L;
              }
              return l = {
                getMediaType: y,
                getMediaInfo: A,
                getDroppedFramesHistory: b,
                getCurrentRequest: w,
                getSwitchHistory: N,
                getStreamInfo: u,
                getScheduleController: M,
                getAbrController: E,
                getRepresentationInfo: I,
                useBufferOccupancyABR: V,
                useL2AABR: J,
                useLoLPABR: H,
                getVideoModel: C
              }, l;
            }
            n.__dashjs_factory_name = "RulesContext";
            const i = g.default.getClassFactory(n);
          }
        ),
        /***/
        "./src/streaming/rules/SwitchRequest.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/rules/SwitchRequest.js ***!
            \**********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = -1, i = {
              DEFAULT: 0.5,
              STRONG: 1,
              WEAK: 0
            };
            function r(t, T, S) {
              var h, _, L, v;
              function c(o) {
                var y = i.DEFAULT;
                return (o === i.DEFAULT || o === i.STRONG || o === i.WEAK) && (y = o), y;
              }
              return _ = t === void 0 ? n : t, L = c(S), v = T === void 0 ? null : T, h = {
                quality: _,
                reason: v,
                priority: L
              }, h;
            }
            r.__dashjs_factory_name = "SwitchRequest";
            var l = g.default.getClassFactory(r);
            l.NO_CHANGE = n, l.PRIORITY = i, g.default.updateClassFactory(r.__dashjs_factory_name, l);
            const d = l;
          }
        ),
        /***/
        "./src/streaming/rules/SwitchRequestHistory.js": (
          /*!*****************************************************!*\
            !*** ./src/streaming/rules/SwitchRequestHistory.js ***!
            \*****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ./SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), i = 8;
            function r() {
              var t = [], T = [];
              function S(L) {
                L.newValue === n.default.NO_CHANGE && (L.newValue = L.oldValue), t[L.oldValue] || (t[L.oldValue] = {
                  noDrops: 0,
                  drops: 0,
                  dropSize: 0
                });
                var v = L.newValue - L.oldValue, c = v < 0 ? 1 : 0, o = c ? -v : 0, y = c ? 0 : 1;
                if (t[L.oldValue].drops += c, t[L.oldValue].dropSize += o, t[L.oldValue].noDrops += y, T.push({
                  idx: L.oldValue,
                  noDrop: y,
                  drop: c,
                  dropSize: o
                }), T.length > i) {
                  var u = T.shift();
                  t[u.idx].drops -= u.drop, t[u.idx].dropSize -= u.dropSize, t[u.idx].noDrops -= u.noDrop;
                }
              }
              function h() {
                return t;
              }
              function _() {
                t = [], T = [];
              }
              return {
                push: S,
                getSwitchRequests: h,
                reset: _
              };
            }
            r.__dashjs_factory_name = "SwitchRequestHistory";
            var l = g.default.getClassFactory(r);
            const d = l;
          }
        ),
        /***/
        "./src/streaming/rules/ThroughputHistory.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/rules/ThroughputHistory.js ***!
            \**************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function i(l) {
              l = l || {};
              var d = 20, t = 3, T = 4, S = 4, h = 1.3, _ = 1.3, L = 8, v = 3, c = 2, o = 1, y = l.settings, u, A, I, M, E;
              function N() {
                E = {
                  throughputHalfLife: {
                    fast: v,
                    slow: L
                  },
                  latencyHalfLife: {
                    fast: o,
                    slow: c
                  }
                }, ae();
              }
              function C(Q, oe, de) {
                if (Q === g.default.VIDEO)
                  return de < y.get().streaming.cacheLoadThresholds[g.default.VIDEO];
                if (Q === g.default.AUDIO)
                  return de < y.get().streaming.cacheLoadThresholds[g.default.AUDIO];
              }
              function b(Q, oe, de) {
                if (!(!oe.trace || !oe.trace.length)) {
                  var Me = oe.tresponse.getTime() - oe.trequest.getTime() || 1, ge = oe._tfinish.getTime() - oe.tresponse.getTime() || 1, se = oe.trace.reduce(function(O, p) {
                    return O + p.b[0];
                  }, 0), ee = 0, re = 0;
                  if (oe._fileLoaderType && oe._fileLoaderType === g.default.FILE_LOADER_TYPES.FETCH ? ee = oe.trace.reduce(function(O, p) {
                    return O + p.d;
                  }, 0) : ee = de ? ge : Me + ge, ee !== 0 && (re = Math.round(8 * se / ee)), oe.cmsd) {
                    var ue = oe.cmsd.dynamic && oe.cmsd.dynamic.etp ? oe.cmsd.dynamic.etp : null;
                    if (ue) {
                      var te = y.get().streaming.cmsd.abr.etpWeightRatio;
                      te > 0 && te <= 1 && (re = re * (1 - te) + ue * te);
                    }
                  }
                  if (Y(Q), C(Q, Me, ge)) {
                    if (u[Q].length > 0 && !u[Q].hasCachedEntries)
                      return;
                    u[Q].hasCachedEntries = !0;
                  } else
                    u[Q] && u[Q].hasCachedEntries && ne(Q);
                  u[Q].push(re), u[Q].length > d && u[Q].shift(), A[Q].push(Me), A[Q].length > d && A[Q].shift(), w(I[Q], re, 1e-3 * ge, E.throughputHalfLife), w(M[Q], Me, 1, E.latencyHalfLife);
                }
              }
              function w(Q, oe, de, Me) {
                var ge = Math.pow(0.5, de / Me.fast);
                Q.fastEstimate = (1 - ge) * oe + ge * Q.fastEstimate;
                var se = Math.pow(0.5, de / Me.slow);
                Q.slowEstimate = (1 - se) * oe + se * Q.slowEstimate, Q.totalWeight += de;
              }
              function V(Q, oe, de) {
                var Me, ge;
                if (Q ? (Me = u[oe], ge = de ? t : T) : (Me = A[oe], ge = S), !Me)
                  ge = 0;
                else if (ge >= Me.length)
                  ge = Me.length;
                else if (Q)
                  for (var se = 1; se < ge; ++se) {
                    var ee = Me[Me.length - se] / Me[Me.length - se - 1];
                    if ((ee >= _ || ee <= 1 / h) && (ge += 1, ge === Me.length))
                      break;
                  }
                return ge;
              }
              function J(Q, oe, de) {
                return y.get().streaming.abr.movingAverageMethod !== g.default.MOVING_AVERAGE_SLIDING_WINDOW ? z(Q, oe) : H(Q, oe, de);
              }
              function H(Q, oe, de) {
                var Me = V(Q, oe, de), ge = Q ? u : A, se = ge[oe];
                return Me === 0 || !se || se.length === 0 ? NaN : (se = se.slice(-Me), se.reduce(function(ee, re) {
                  return ee + re;
                }) / se.length);
              }
              function z(Q, oe) {
                var de = Q ? E.throughputHalfLife : E.latencyHalfLife, Me = Q ? I[oe] : M[oe];
                if (!Me || Me.totalWeight <= 0)
                  return NaN;
                var ge = Me.fastEstimate / (1 - Math.pow(0.5, Me.totalWeight / de.fast)), se = Me.slowEstimate / (1 - Math.pow(0.5, Me.totalWeight / de.slow));
                return Q ? Math.min(ge, se) : Math.max(ge, se);
              }
              function Z(Q, oe) {
                return J(!0, Q, oe);
              }
              function ie(Q, oe) {
                var de = Z(Q, oe);
                return isNaN(de) || (de *= y.get().streaming.abr.bandwidthSafetyFactor), de;
              }
              function K(Q) {
                return J(!1, Q);
              }
              function Y(Q) {
                u[Q] = u[Q] || [], A[Q] = A[Q] || [], I[Q] = I[Q] || {
                  fastEstimate: 0,
                  slowEstimate: 0,
                  totalWeight: 0
                }, M[Q] = M[Q] || {
                  fastEstimate: 0,
                  slowEstimate: 0,
                  totalWeight: 0
                };
              }
              function ne(Q) {
                delete u[Q], delete A[Q], delete I[Q], delete M[Q], Y(Q);
              }
              function ae() {
                u = {}, A = {}, I = {}, M = {};
              }
              var fe = {
                push: b,
                getAverageThroughput: Z,
                getSafeAverageThroughput: ie,
                getAverageLatency: K,
                reset: ae
              };
              return N(), fe;
            }
            i.__dashjs_factory_name = "ThroughputHistory";
            const r = n.default.getClassFactory(i);
          }
        ),
        /***/
        "./src/streaming/rules/abr/ABRRulesCollection.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/rules/abr/ABRRulesCollection.js ***!
            \*******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => y
              /* harmony export */
            });
            var g = e(
              /*! ./ThroughputRule */
              "./src/streaming/rules/abr/ThroughputRule.js"
            ), n = e(
              /*! ./InsufficientBufferRule */
              "./src/streaming/rules/abr/InsufficientBufferRule.js"
            ), i = e(
              /*! ./AbandonRequestsRule */
              "./src/streaming/rules/abr/AbandonRequestsRule.js"
            ), r = e(
              /*! ./DroppedFramesRule */
              "./src/streaming/rules/abr/DroppedFramesRule.js"
            ), l = e(
              /*! ./SwitchHistoryRule */
              "./src/streaming/rules/abr/SwitchHistoryRule.js"
            ), d = e(
              /*! ./BolaRule */
              "./src/streaming/rules/abr/BolaRule.js"
            ), t = e(
              /*! ./L2ARule.js */
              "./src/streaming/rules/abr/L2ARule.js"
            ), T = e(
              /*! ./lolp/LoLpRule.js */
              "./src/streaming/rules/abr/lolp/LoLpRule.js"
            ), S = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), h = e(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), _ = e(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), L = "qualitySwitchRules", v = "abandonFragmentRules";
            function c(u) {
              u = u || {};
              var A = this.context, I = u.mediaPlayerModel, M = u.customParametersModel, E = u.dashMetrics, N = u.settings, C, b, w;
              function V() {
                b = [], w = [], N.get().streaming.abr.useDefaultABRRules && (N.get().streaming.abr.ABRStrategy === _.default.ABR_STRATEGY_L2A ? b.push((0, t.default)(A).create({
                  dashMetrics: E,
                  settings: N
                })) : N.get().streaming.abr.ABRStrategy === _.default.ABR_STRATEGY_LoLP ? b.push((0, T.default)(A).create({
                  dashMetrics: E
                })) : (b.push((0, d.default)(A).create({
                  dashMetrics: E,
                  mediaPlayerModel: I,
                  settings: N
                })), b.push((0, g.default)(A).create({
                  dashMetrics: E
                })), N.get().streaming.abr.additionalAbrRules.insufficientBufferRule && b.push((0, n.default)(A).create({
                  dashMetrics: E,
                  settings: N
                })), N.get().streaming.abr.additionalAbrRules.switchHistoryRule && b.push((0, l.default)(A).create()), N.get().streaming.abr.additionalAbrRules.droppedFramesRule && b.push((0, r.default)(A).create()), N.get().streaming.abr.additionalAbrRules.abandonRequestsRule && w.push((0, i.default)(A).create({
                  dashMetrics: E,
                  mediaPlayerModel: I,
                  settings: N
                }))));
                var Y = M.getAbrCustomRules();
                Y.forEach(function(ne) {
                  ne.type === L && b.push(ne.rule(A).create()), ne.type === v && w.push(ne.rule(A).create());
                });
              }
              function J(Y) {
                return Y.filter(function(ne) {
                  return ne.quality > h.default.NO_CHANGE;
                });
              }
              function H(Y) {
                var ne = {}, ae = null, fe, Q, oe, de, Me;
                if (Y.length !== 0) {
                  for (ne[h.default.PRIORITY.STRONG] = {
                    quality: h.default.NO_CHANGE,
                    reason: null
                  }, ne[h.default.PRIORITY.WEAK] = {
                    quality: h.default.NO_CHANGE,
                    reason: null
                  }, ne[h.default.PRIORITY.DEFAULT] = {
                    quality: h.default.NO_CHANGE,
                    reason: null
                  }, fe = 0, Q = Y.length; fe < Q; fe += 1)
                    oe = Y[fe], oe.quality !== h.default.NO_CHANGE && (ne[oe.priority].quality === h.default.NO_CHANGE || ne[oe.priority].quality > oe.quality) && (ne[oe.priority].quality = oe.quality, ne[oe.priority].reason = oe.reason || null);
                  return ne[h.default.PRIORITY.WEAK].quality !== h.default.NO_CHANGE && (ae = ne[h.default.PRIORITY.WEAK]), ne[h.default.PRIORITY.DEFAULT].quality !== h.default.NO_CHANGE && (ae = ne[h.default.PRIORITY.DEFAULT]), ne[h.default.PRIORITY.STRONG].quality !== h.default.NO_CHANGE && (ae = ne[h.default.PRIORITY.STRONG]), ae && (de = ae.quality, Me = ae.reason), (0, h.default)(A).create(de, Me);
                }
              }
              function z(Y) {
                var ne = b.map(function(Q) {
                  return Q.getMaxIndex(Y);
                }), ae = J(ne), fe = H(ae);
                return fe || (0, h.default)(A).create();
              }
              function Z(Y, ne) {
                var ae = w.map(function(oe) {
                  return oe.shouldAbandon(Y, ne);
                }), fe = J(ae), Q = H(fe);
                return Q || (0, h.default)(A).create();
              }
              function ie() {
                [b, w].forEach(function(Y) {
                  Y && Y.length && Y.forEach(function(ne) {
                    return ne.reset && ne.reset();
                  });
                }), b = [], w = [];
              }
              function K() {
                return b;
              }
              return C = {
                initialize: V,
                reset: ie,
                getMaxQuality: z,
                getMinSwitchRequest: H,
                shouldAbandonFragment: Z,
                getQualitySwitchRules: K
              }, C;
            }
            c.__dashjs_factory_name = "ABRRulesCollection";
            var o = S.default.getClassFactory(c);
            o.QUALITY_SWITCH_RULES = L, o.ABANDON_FRAGMENT_RULES = v, S.default.updateSingletonFactory(c.__dashjs_factory_name, o);
            const y = o;
          }
        ),
        /***/
        "./src/streaming/rules/abr/AbandonRequestsRule.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/rules/abr/AbandonRequestsRule.js ***!
            \********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), n = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), i = e(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            );
            function r(d) {
              d = d || {};
              var t = 1.8, T = 500, S = 5, h = this.context, _ = d.mediaPlayerModel, L = d.dashMetrics, v = d.settings, c, o, y, u, A;
              function I() {
                o = (0, i.default)(h).getInstance().getLogger(c), C();
              }
              function M(b, w) {
                y[b] = y[b] || {}, y[b][w] = y[b][w] || {};
              }
              function E(b, w) {
                A[b] = A[b] || [], A[b].push(w);
              }
              function N(b) {
                var w = (0, g.default)(h).create(g.default.NO_CHANGE, {
                  name: r.__dashjs_factory_name
                });
                if (!b || !b.hasOwnProperty("getMediaInfo") || !b.hasOwnProperty("getMediaType") || !b.hasOwnProperty("getCurrentRequest") || !b.hasOwnProperty("getRepresentationInfo") || !b.hasOwnProperty("getAbrController"))
                  return w;
                var V = b.getMediaInfo(), J = b.getMediaType(), H = b.getStreamInfo(), z = H ? H.id : null, Z = b.getCurrentRequest();
                if (!isNaN(Z.index)) {
                  M(J, Z.index);
                  var ie = _.getStableBufferTime(), K = L.getCurrentBufferLevel(J);
                  if (K > ie)
                    return w;
                  var Y = y[J][Z.index];
                  if (Y === null || Z.firstByteDate === null || u.hasOwnProperty(Y.id))
                    return w;
                  if (Y.firstByteTime === void 0 && (A[J] = [], Y.firstByteTime = Z.firstByteDate.getTime(), Y.segmentDuration = Z.duration, Y.bytesTotal = Z.bytesTotal, Y.id = Z.index), Y.bytesLoaded = Z.bytesLoaded, Y.elapsedTime = (/* @__PURE__ */ new Date()).getTime() - Y.firstByteTime, Y.bytesLoaded > 0 && Y.elapsedTime > 0 && E(J, Math.round(Y.bytesLoaded * 8 / Y.elapsedTime)), A[J].length >= S && Y.elapsedTime > T && Y.bytesLoaded < Y.bytesTotal) {
                    var ne = A[J].reduce(function(se, ee) {
                      return se + ee;
                    }, 0);
                    if (Y.measuredBandwidthInKbps = Math.round(ne / A[J].length), Y.estimatedTimeOfDownload = +(Y.bytesTotal * 8 / Y.measuredBandwidthInKbps / 1e3).toFixed(2), Y.estimatedTimeOfDownload < Y.segmentDuration * t || b.getRepresentationInfo().quality === 0)
                      return w;
                    if (!u.hasOwnProperty(Y.id)) {
                      var ae = b.getAbrController(), fe = Y.bytesTotal - Y.bytesLoaded, Q = ae.getBitrateList(V), oe = ae.getQualityForBitrate(V, Y.measuredBandwidthInKbps * v.get().streaming.abr.bandwidthSafetyFactor, z), de = ae.getMinAllowedIndexFor(J, z), Me = de !== void 0 ? Math.max(de, oe) : oe, ge = Y.bytesTotal * Q[Me].bitrate / Q[ae.getQualityFor(J, z)].bitrate;
                      fe > ge && (w.quality = Me, w.reason.throughput = Y.measuredBandwidthInKbps, w.reason.fragmentID = Y.id, u[Y.id] = Y, o.debug("[" + J + "] frag id", Y.id, " is asking to abandon and switch to quality to ", Me, " measured bandwidth was", Y.measuredBandwidthInKbps), delete y[J][Y.id]);
                    }
                  } else
                    Y.bytesLoaded === Y.bytesTotal && delete y[J][Y.id];
                }
                return w;
              }
              function C() {
                y = {}, u = {}, A = [];
              }
              return c = {
                shouldAbandon: N,
                reset: C
              }, I(), c;
            }
            r.__dashjs_factory_name = "AbandonRequestsRule";
            const l = n.default.getClassFactory(r);
          }
        ),
        /***/
        "./src/streaming/rules/abr/BolaRule.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/rules/abr/BolaRule.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => u
              /* harmony export */
            });
            var g = e(
              /*! ../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), n = e(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), i = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! ../../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), l = e(
              /*! ../../../core/EventBus */
              "./src/core/EventBus.js"
            ), d = e(
              /*! ../../../core/events/Events */
              "./src/core/events/Events.js"
            ), t = e(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            ), T = e(
              /*! ../../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), S = e(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), h = 0, _ = 1, L = 2, v = 10, c = 2, o = 0.99;
            function y(A) {
              A = A || {};
              var I = this.context, M = A.dashMetrics, E = A.mediaPlayerModel, N = (0, l.default)(I).getInstance(), C, b, w;
              function V() {
                b = (0, t.default)(I).getInstance().getLogger(C), ue(), N.on(T.default.BUFFER_EMPTY, Q, C), N.on(T.default.PLAYBACK_SEEKING, oe, C), N.on(T.default.METRIC_ADDED, Me, C), N.on(T.default.QUALITY_CHANGE_REQUESTED, se, C), N.on(T.default.FRAGMENT_LOADING_ABANDONED, ee, C), N.on(d.default.MEDIA_FRAGMENT_LOADED, de, C);
              }
              function J(O) {
                return O.map(function(p) {
                  return Math.log(p);
                });
              }
              function H(O, p, P) {
                var k = P.reduce(function(W, $, ce) {
                  return $ > P[W] ? ce : W;
                }, 0);
                if (k === 0)
                  return null;
                var X = Math.max(O, v + c * p.length), F = (P[k] - 1) / (X / v - 1), x = v / F;
                return {
                  gp: F,
                  Vp: x
                };
              }
              function z(O) {
                var p = {}, P = O.getMediaInfo(), k = P.bitrateList.map(function(W) {
                  return W.bandwidth;
                }), X = J(k);
                X = X.map(function(W) {
                  return W - X[0] + 1;
                });
                var F = E.getStableBufferTime(), x = H(F, k, X);
                return x ? (p.state = _, p.bitrates = k, p.utilities = X, p.stableBufferTime = F, p.Vp = x.Vp, p.gp = x.gp, p.lastQuality = 0, Z(p)) : p.state = h, p;
              }
              function Z(O) {
                O.placeholderBuffer = 0, O.mostAdvancedSegmentStart = NaN, O.lastSegmentWasReplacement = !1, O.lastSegmentStart = NaN, O.lastSegmentDurationS = NaN, O.lastSegmentRequestTimeMs = NaN, O.lastSegmentFinishTimeMs = NaN;
              }
              function ie(O, p) {
                var P = E.getStableBufferTime();
                if (O.stableBufferTime !== P) {
                  var k = H(P, O.bitrates, O.utilities);
                  if (k.Vp !== O.Vp || k.gp !== O.gp) {
                    var X = M.getCurrentBufferLevel(p), F = X + O.placeholderBuffer;
                    F -= v, F *= k.Vp / O.Vp, F += v, O.stableBufferTime = P, O.Vp = k.Vp, O.gp = k.gp, O.placeholderBuffer = Math.max(0, F - X);
                  }
                }
              }
              function K(O) {
                var p = O.getMediaType(), P = w[p];
                return P ? P.state !== h && ie(P, p) : (P = z(O), w[p] = P), P;
              }
              function Y(O, p) {
                for (var P = O.bitrates.length, k = NaN, X = NaN, F = 0; F < P; ++F) {
                  var x = (O.Vp * (O.utilities[F] + O.gp) - p) / O.bitrates[F];
                  (isNaN(X) || x >= X) && (X = x, k = F);
                }
                return k;
              }
              function ne(O, p) {
                return O.Vp * (O.utilities[p] + O.gp);
              }
              function ae(O, p) {
                for (var P = O.bitrates[p], k = O.utilities[p], X = 0, F = p - 1; F >= 0; --F)
                  if (O.utilities[F] < O.utilities[p]) {
                    var x = O.bitrates[F], W = O.utilities[F], $ = O.Vp * (O.gp + (P * W - x * k) / (P - x));
                    X = Math.max(X, $);
                  }
                return X;
              }
              function fe(O, p) {
                var P = Date.now();
                if (isNaN(O.lastSegmentFinishTimeMs)) {
                  if (!isNaN(O.lastCallTimeMs)) {
                    var X = 1e-3 * (P - O.lastCallTimeMs);
                    O.placeholderBuffer += Math.max(0, X);
                  }
                } else {
                  var k = 1e-3 * (P - O.lastSegmentFinishTimeMs);
                  O.placeholderBuffer += Math.max(0, k);
                }
                O.lastCallTimeMs = P, O.lastSegmentStart = NaN, O.lastSegmentRequestTimeMs = NaN, O.lastSegmentFinishTimeMs = NaN, ie(O, p);
              }
              function Q(O) {
                var p = O.mediaType, P = p === S.default.AUDIO ? [S.default.AUDIO] : w;
                for (var k in P)
                  w.hasOwnProperty(k) && w[k].state === L && (w[k].placeholderBuffer = 0);
              }
              function oe() {
                for (var O in w)
                  if (w.hasOwnProperty(O)) {
                    var p = w[O];
                    p.state !== h && (p.state = _, Z(p));
                  }
              }
              function de(O) {
                if (O && O.chunk && O.chunk.mediaInfo) {
                  var p = w[O.chunk.mediaInfo.type];
                  if (p && p.state !== h) {
                    var P = O.chunk.start;
                    isNaN(p.mostAdvancedSegmentStart) || P > p.mostAdvancedSegmentStart ? (p.mostAdvancedSegmentStart = P, p.lastSegmentWasReplacement = !1) : p.lastSegmentWasReplacement = !0, p.lastSegmentStart = P, p.lastSegmentDurationS = O.chunk.duration, p.lastQuality = O.chunk.quality, ge(p, O.chunk.mediaInfo.type);
                  }
                }
              }
              function Me(O) {
                if (O && O.metric === g.default.HTTP_REQUEST && O.value && O.value.type === r.HTTPRequest.MEDIA_SEGMENT_TYPE && O.value.trace && O.value.trace.length) {
                  var p = w[O.mediaType];
                  p && p.state !== h && (p.lastSegmentRequestTimeMs = O.value.trequest.getTime(), p.lastSegmentFinishTimeMs = O.value._tfinish.getTime(), ge(p, O.mediaType));
                }
              }
              function ge(O, p) {
                if (!isNaN(O.lastSegmentStart) && !isNaN(O.lastSegmentRequestTimeMs) && !isNaN(O.placeholderBuffer)) {
                  if (O.placeholderBuffer *= o, !isNaN(O.lastSegmentFinishTimeMs)) {
                    var P = M.getCurrentBufferLevel(p), k = P + 1e-3 * (O.lastSegmentFinishTimeMs - O.lastSegmentRequestTimeMs), X = ne(O, O.lastQuality), F = Math.max(0, X - k);
                    O.placeholderBuffer = Math.min(F, O.placeholderBuffer);
                  }
                  O.lastSegmentWasReplacement && !isNaN(O.lastSegmentDurationS) && (O.placeholderBuffer += O.lastSegmentDurationS), O.lastSegmentStart = NaN, O.lastSegmentRequestTimeMs = NaN;
                }
              }
              function se(O) {
                if (O) {
                  var p = w[O.mediaType];
                  p && p.state !== h && (p.abrQuality = O.newQuality);
                }
              }
              function ee(O) {
                if (O) {
                  var p = w[O.mediaType];
                  if (p && p.state !== h) {
                    var P = M.getCurrentBufferLevel(O.mediaType), k;
                    p.abrQuality > 0 ? k = ae(p, p.abrQuality) : k = v;
                    var X = Math.max(0, k - P);
                    p.placeholderBuffer = Math.min(p.placeholderBuffer, X);
                  }
                }
              }
              function re(O) {
                var p = (0, n.default)(I).create();
                if (!O || !O.hasOwnProperty("getMediaInfo") || !O.hasOwnProperty("getMediaType") || !O.hasOwnProperty("getScheduleController") || !O.hasOwnProperty("getStreamInfo") || !O.hasOwnProperty("getAbrController") || !O.hasOwnProperty("useBufferOccupancyABR"))
                  return p;
                var P = O.getMediaInfo(), k = O.getMediaType(), X = O.getScheduleController(), F = O.getStreamInfo(), x = O.getAbrController(), W = x.getThroughputHistory(), $ = F ? F.id : null, ce = F && F.manifestInfo && F.manifestInfo.isDynamic, le = O.useBufferOccupancyABR();
                if (p.reason = p.reason || {}, !le)
                  return p;
                X.setTimeToLoadDelay(0);
                var q = K(O);
                if (q.state === h)
                  return p;
                var _e = M.getCurrentBufferLevel(k), Ee = W.getAverageThroughput(k, ce), Te = W.getSafeAverageThroughput(k, ce), Ce = W.getAverageLatency(k), xe;
                if (p.reason.state = q.state, p.reason.throughput = Ee, p.reason.latency = Ce, isNaN(Ee))
                  return p;
                switch (q.state) {
                  case _:
                    xe = x.getQualityForBitrate(P, Te, $, Ce), p.quality = xe, p.reason.throughput = Te, q.placeholderBuffer = Math.max(0, ae(q, xe) - _e), q.lastQuality = xe, !isNaN(q.lastSegmentDurationS) && _e >= q.lastSegmentDurationS && (q.state = L);
                    break;
                  case L:
                    fe(q, k), xe = Y(q, _e + q.placeholderBuffer);
                    var be = x.getQualityForBitrate(P, Te, $, Ce);
                    xe > q.lastQuality && xe > be && (xe = Math.max(be, q.lastQuality));
                    var Ge = Math.max(0, _e + q.placeholderBuffer - ne(q, xe));
                    Ge <= q.placeholderBuffer ? (q.placeholderBuffer -= Ge, Ge = 0) : (Ge -= q.placeholderBuffer, q.placeholderBuffer = 0, xe < x.getMaxAllowedIndexFor(k, $) ? X.setTimeToLoadDelay(1e3 * Ge) : Ge = 0), p.quality = xe, p.reason.throughput = Ee, p.reason.latency = Ce, p.reason.bufferLevel = _e, p.reason.placeholderBuffer = q.placeholderBuffer, p.reason.delay = Ge, q.lastQuality = xe;
                    break;
                  default:
                    b.debug("BOLA ABR rule invoked in bad state."), p.quality = x.getQualityForBitrate(P, Te, $, Ce), p.reason.state = q.state, p.reason.throughput = Te, p.reason.latency = Ce, q.state = _, Z(q);
                }
                return p;
              }
              function ue() {
                w = {};
              }
              function te() {
                ue(), N.off(T.default.BUFFER_EMPTY, Q, C), N.off(T.default.PLAYBACK_SEEKING, oe, C), N.off(T.default.METRIC_ADDED, Me, C), N.off(T.default.QUALITY_CHANGE_REQUESTED, se, C), N.off(T.default.FRAGMENT_LOADING_ABANDONED, ee, C), N.off(d.default.MEDIA_FRAGMENT_LOADED, de, C);
              }
              return C = {
                getMaxIndex: re,
                reset: te
              }, V(), C;
            }
            y.__dashjs_factory_name = "BolaRule";
            const u = i.default.getClassFactory(y);
          }
        ),
        /***/
        "./src/streaming/rules/abr/DroppedFramesRule.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/rules/abr/DroppedFramesRule.js ***!
            \******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), i = e(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            );
            function r() {
              var d = this.context, t, T, S = 0.15, h = 375;
              function _() {
                T = (0, i.default)(d).getInstance().getLogger(t);
              }
              function L(v) {
                var c = (0, n.default)(d).create();
                if (!v || !v.hasOwnProperty("getDroppedFramesHistory"))
                  return c;
                var o = v.getDroppedFramesHistory(), y = v.getStreamInfo().id;
                if (o) {
                  var u = o.getFrameHistory(y);
                  if (!u || u.length === 0)
                    return c;
                  for (var A = 0, I = 0, M = n.default.NO_CHANGE, E = 1; E < u.length; E++)
                    if (u[E] && (A = u[E].droppedVideoFrames, I = u[E].totalVideoFrames, I > h && A / I > S)) {
                      M = E - 1, T.debug("index: " + M + " Dropped Frames: " + A + " Total Frames: " + I);
                      break;
                    }
                  return (0, n.default)(d).create(M, {
                    droppedFrames: A
                  });
                }
                return c;
              }
              return t = {
                getMaxIndex: L
              }, _(), t;
            }
            r.__dashjs_factory_name = "DroppedFramesRule";
            const l = g.default.getClassFactory(r);
          }
        ),
        /***/
        "./src/streaming/rules/abr/InsufficientBufferRule.js": (
          /*!***********************************************************!*\
            !*** ./src/streaming/rules/abr/InsufficientBufferRule.js ***!
            \***********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            var g = e(
              /*! ../../../core/EventBus */
              "./src/core/EventBus.js"
            ), n = e(
              /*! ../../../core/events/Events */
              "./src/core/events/Events.js"
            ), i = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            ), l = e(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), d = e(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), t = e(
              /*! ../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), T = e(
              /*! ../../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            );
            function S(_) {
              _ = _ || {};
              var L = 0.5, v = 2, c = this.context, o = (0, g.default)(c).getInstance(), y = _.dashMetrics, u, A, I;
              function M() {
                A = (0, r.default)(c).getInstance().getLogger(u), b(), o.on(T.default.PLAYBACK_SEEKING, w, u), o.on(n.default.BYTES_APPENDED_END_FRAGMENT, V, u);
              }
              function E() {
                if (!y || !y.hasOwnProperty("getCurrentBufferLevel") || !y.hasOwnProperty("getCurrentBufferState"))
                  throw new Error(d.default.MISSING_CONFIG_ERROR);
              }
              function N(H) {
                var z = (0, l.default)(c).create();
                if (!H || !H.hasOwnProperty("getMediaType"))
                  return z;
                E();
                var Z = H.getMediaType(), ie = y.getCurrentBufferState(Z), K = H.getRepresentationInfo(), Y = K.fragmentDuration, ne = H.getStreamInfo(), ae = ne ? ne.id : null, fe = H.getScheduleController(), Q = ne && ne.manifestInfo && ne.manifestInfo.isDynamic, oe = fe.getPlaybackController(), de = oe.getLowLatencyModeEnabled();
                if (C(de, Z) || !Y)
                  return z;
                if (ie && ie.state === t.default.BUFFER_EMPTY)
                  A.debug("[" + Z + "] Switch to index 0; buffer is empty."), z.quality = 0, z.reason = "InsufficientBufferRule: Buffer is empty";
                else {
                  var Me = H.getMediaInfo(), ge = H.getAbrController(), se = ge.getThroughputHistory(), ee = y.getCurrentBufferLevel(Z), re = se.getAverageThroughput(Z, Q), ue = se.getAverageLatency(Z), te = re * (ee / Y) * L;
                  z.quality = ge.getQualityForBitrate(Me, te, ae, ue), z.reason = "InsufficientBufferRule: being conservative to avoid immediate rebuffering";
                }
                return z;
              }
              function C(H, z) {
                return !H && I[z].ignoreCount > 0;
              }
              function b() {
                I = {}, I[d.default.VIDEO] = {
                  ignoreCount: v
                }, I[d.default.AUDIO] = {
                  ignoreCount: v
                };
              }
              function w() {
                b();
              }
              function V(H) {
                !isNaN(H.startTime) && (H.mediaType === d.default.AUDIO || H.mediaType === d.default.VIDEO) && I[H.mediaType].ignoreCount > 0 && I[H.mediaType].ignoreCount--;
              }
              function J() {
                b(), o.off(T.default.PLAYBACK_SEEKING, w, u), o.off(n.default.BYTES_APPENDED_END_FRAGMENT, V, u);
              }
              return u = {
                getMaxIndex: N,
                reset: J
              }, M(), u;
            }
            S.__dashjs_factory_name = "InsufficientBufferRule";
            const h = i.default.getClassFactory(S);
          }
        ),
        /***/
        "./src/streaming/rules/abr/L2ARule.js": (
          /*!********************************************!*\
            !*** ./src/streaming/rules/abr/L2ARule.js ***!
            \********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), n = e(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), i = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! ../../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), l = e(
              /*! ../../../core/EventBus */
              "./src/core/EventBus.js"
            ), d = e(
              /*! ../../../core/events/Events */
              "./src/core/events/Events.js"
            ), t = e(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            ), T = e(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), S = 0, h = 1, _ = 2;
            function L(c) {
              c = c || {};
              var o = this.context, y = c.dashMetrics, u = (0, l.default)(o).getInstance(), A, I, M, E;
              function N() {
                E = (0, t.default)(o).getInstance().getLogger(A), ae(), u.on(d.default.PLAYBACK_SEEKING, J, A), u.on(d.default.MEDIA_FRAGMENT_LOADED, H, A), u.on(d.default.METRIC_ADDED, z, A), u.on(d.default.QUALITY_CHANGE_REQUESTED, ie, A);
              }
              function C(Q) {
                var oe = {}, de = Q.getMediaInfo(), Me = de.bitrateList.map(function(ge) {
                  return ge.bandwidth / 1e3;
                });
                return oe.state = h, oe.bitrates = Me, oe.lastQuality = 0, b(de), w(oe), oe;
              }
              function b(Q) {
                !Q || !Q.type || (M[Q.type] = {}, M[Q.type].w = [], M[Q.type].prev_w = [], M[Q.type].Q = 0, M[Q.type].segment_request_start_s = 0, M[Q.type].segment_download_finish_s = 0, M[Q.type].B_target = 1.5);
              }
              function w(Q) {
                Q.placeholderBuffer = 0, Q.mostAdvancedSegmentStart = NaN, Q.lastSegmentWasReplacement = !1, Q.lastSegmentStart = NaN, Q.lastSegmentDurationS = NaN, Q.lastSegmentRequestTimeMs = NaN, Q.lastSegmentFinishTimeMs = NaN;
              }
              function V(Q) {
                var oe = Q.getMediaType(), de = I[oe];
                return de || (de = C(Q), I[oe] = de), de;
              }
              function J() {
                for (var Q in I)
                  if (I.hasOwnProperty(Q)) {
                    var oe = I[Q];
                    oe.state !== S && (oe.state = h, w(oe));
                  }
              }
              function H(Q) {
                if (Q && Q.chunk && Q.chunk.mediaInfo) {
                  var oe = I[Q.chunk.mediaInfo.type], de = M[Q.chunk.mediaInfo.type];
                  if (oe && oe.state !== S) {
                    var Me = Q.chunk.start;
                    isNaN(oe.mostAdvancedSegmentStart) || Me > oe.mostAdvancedSegmentStart ? (oe.mostAdvancedSegmentStart = Me, oe.lastSegmentWasReplacement = !1) : oe.lastSegmentWasReplacement = !0, oe.lastSegmentStart = Me, oe.lastSegmentDurationS = Q.chunk.duration, oe.lastQuality = Q.chunk.quality, Z(oe, de);
                  }
                }
              }
              function z(Q) {
                if (Q && Q.metric === g.default.HTTP_REQUEST && Q.value && Q.value.type === r.HTTPRequest.MEDIA_SEGMENT_TYPE && Q.value.trace && Q.value.trace.length) {
                  var oe = I[Q.mediaType], de = M[Q.mediaType];
                  oe && oe.state !== S && (oe.lastSegmentRequestTimeMs = Q.value.trequest.getTime(), oe.lastSegmentFinishTimeMs = Q.value._tfinish.getTime(), Z(oe, de));
                }
              }
              function Z(Q, oe) {
                !isNaN(Q.lastSegmentStart) && !isNaN(Q.lastSegmentRequestTimeMs) && (oe.segment_request_start_s = 1e-3 * Q.lastSegmentRequestTimeMs, oe.segment_download_finish_s = 1e-3 * Q.lastSegmentFinishTimeMs, Q.lastSegmentStart = NaN, Q.lastSegmentRequestTimeMs = NaN);
              }
              function ie(Q) {
                if (Q && Q.mediaType) {
                  var oe = I[Q.mediaType];
                  oe && oe.state !== S && (oe.abrQuality = Q.newQuality);
                }
              }
              function K(Q, oe) {
                if (Q.length !== oe.length)
                  return -1;
                for (var de = 0, Me = 0; Me < Q.length; Me++)
                  de = de + Q[Me] * oe[Me];
                return de;
              }
              function Y(Q) {
                for (var oe = Q.length, de = !1, Me = [], ge = 0; ge < oe; ++ge)
                  Me[ge] = Q[ge];
                for (var se = Q.sort(function(p, P) {
                  return P - p;
                }), ee = 0, re = 0, ue = [], te = 0; te < oe - 1; ++te)
                  if (ee = ee + se[te], re = (ee - 1) / (te + 1), re >= se[te + 1]) {
                    de = !0;
                    break;
                  }
                de || (re = (ee + se[oe - 1] - 1) / oe);
                for (var O = 0; O < oe; ++O)
                  ue[O] = Math.max(Me[O] - re, 0);
                return ue;
              }
              function ne(Q) {
                var oe = (0, n.default)(o).create(), de = 4, Me = Math.pow(de, 0.99), ge = Math.max(Math.pow(de, 1), Me * Math.sqrt(de)), se = Q.getMediaInfo(), ee = Q.getMediaType(), re = se.bitrateList.map(function(Ye) {
                  return Ye.bandwidth;
                }), ue = re.length, te = Q.getScheduleController(), O = Q.getStreamInfo(), p = Q.getAbrController(), P = p.getThroughputHistory(), k = O && O.manifestInfo && O.manifestInfo.isDynamic, X = Q.useL2AABR(), F = y.getCurrentBufferLevel(ee, !0), x = P.getSafeAverageThroughput(ee, k), W = P.getAverageThroughput(ee, k), $ = 2, ce = P.getAverageLatency(ee), le = Q.getVideoModel(), q, _e = le.getPlaybackRate();
                if (!Q || !Q.hasOwnProperty("getMediaInfo") || !Q.hasOwnProperty("getMediaType") || !Q.hasOwnProperty("getScheduleController") || !Q.hasOwnProperty("getStreamInfo") || !Q.hasOwnProperty("getAbrController") || !Q.hasOwnProperty("useL2AABR") || (oe.reason = oe.reason || {}, !X || ee === T.default.AUDIO))
                  return oe;
                te.setTimeToLoadDelay(0);
                var Ee = V(Q);
                if (Ee.state === S)
                  return oe;
                var Te = M[ee];
                if (!Te || (oe.reason.state = Ee.state, oe.reason.throughput = W, oe.reason.latency = ce, isNaN(W)))
                  return oe;
                switch (Ee.state) {
                  case h:
                    if (q = p.getQualityForBitrate(se, x, O.id, ce), oe.quality = q, oe.reason.throughput = x, Ee.lastQuality = q, !isNaN(Ee.lastSegmentDurationS) && F >= Te.B_target) {
                      Ee.state = _, Te.Q = Me;
                      for (var Ce = 0; Ce < ue; ++Ce)
                        Ce === Ee.lastQuality ? Te.prev_w[Ce] = 1 : Te.prev_w[Ce] = 0;
                    }
                    break;
                  case _:
                    var xe = [], be = y.getCurrentHttpRequest(ee).trace.reduce(function(Ye, Ke) {
                      return Ye + Ke.d;
                    }, 0), Ge = y.getCurrentHttpRequest(ee).trace.reduce(function(Ye, Ke) {
                      return Ye + Ke.b[0];
                    }, 0), Pe = Math.round(8 * Ge / be);
                    Pe < 1 && (Pe = 1);
                    for (var Le = Ee.lastSegmentDurationS, je = 1, Ze = 0; Ze < ue; ++Ze)
                      re[Ze] = re[Ze] / 1e3, _e * re[Ze] > Pe && (je = -1), Te.w[Ze] = Te.prev_w[Ze] + je * (Le / (2 * ge)) * ((Te.Q + Me) * (_e * re[Ze] / Pe));
                    Te.w = Y(Te.w);
                    for (var nt = 0; nt < ue; ++nt)
                      xe[nt] = Te.w[nt] - Te.prev_w[nt], Te.prev_w[nt] = Te.w[nt];
                    Te.Q = Math.max(0, Te.Q - Le + Le * _e * ((K(re, Te.prev_w) + K(re, xe)) / Pe));
                    for (var it = [], De = 0; De < ue; ++De)
                      it[De] = Math.abs(re[De] - K(Te.w, re));
                    q = it.indexOf(Math.min.apply(Math, it)), q > Ee.lastQuality && re[Ee.lastQuality + 1] <= Pe && (q = Ee.lastQuality + 1), re[q] >= Pe && (Te.Q = $ * Math.max(Me, Te.Q)), oe.quality = q, oe.reason.throughput = W, oe.reason.latency = ce, oe.reason.bufferLevel = F, Ee.lastQuality = oe.quality;
                    break;
                  default:
                    E.debug("L2A ABR rule invoked in bad state."), oe.quality = p.getQualityForBitrate(se, x, O.id, ce), oe.reason.state = Ee.state, oe.reason.throughput = x, oe.reason.latency = ce, Ee.state = h, w(Ee);
                }
                return oe;
              }
              function ae() {
                I = {}, M = {};
              }
              function fe() {
                ae(), u.off(d.default.PLAYBACK_SEEKING, J, A), u.off(d.default.MEDIA_FRAGMENT_LOADED, H, A), u.off(d.default.METRIC_ADDED, z, A), u.off(d.default.QUALITY_CHANGE_REQUESTED, ie, A);
              }
              return A = {
                getMaxIndex: ne,
                reset: fe
              }, N(), A;
            }
            L.__dashjs_factory_name = "L2ARule";
            const v = i.default.getClassFactory(L);
          }
        ),
        /***/
        "./src/streaming/rules/abr/SwitchHistoryRule.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/rules/abr/SwitchHistoryRule.js ***!
            \******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            ), i = e(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            );
            function r() {
              var d = this.context, t, T, S = 0.075, h = 6;
              function _() {
                T = (0, n.default)(d).getInstance().getLogger(t);
              }
              function L(v) {
                for (var c = v ? v.getSwitchHistory() : null, o = c ? c.getSwitchRequests() : [], y = 0, u = 0, A = 0, I = (0, i.default)(d).create(), M = 0; M < o.length; M++)
                  if (o[M] !== void 0 && (y += o[M].drops, u += o[M].noDrops, A += o[M].dropSize, y + u >= h && y / u > S)) {
                    I.quality = M > 0 && o[M].drops > 0 ? M - 1 : M, I.reason = {
                      index: I.quality,
                      drops: y,
                      noDrops: u,
                      dropSize: A
                    }, T.debug("Switch history rule index: " + I.quality + " samples: " + (y + u) + " drops: " + y);
                    break;
                  }
                return I;
              }
              return t = {
                getMaxIndex: L
              }, _(), t;
            }
            r.__dashjs_factory_name = "SwitchHistoryRule";
            const l = g.default.getClassFactory(r);
          }
        ),
        /***/
        "./src/streaming/rules/abr/ThroughputRule.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/rules/abr/ThroughputRule.js ***!
            \***************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), i = e(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), r = e(
              /*! ../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            );
            function l(t) {
              t = t || {};
              var T = this.context, S = t.dashMetrics, h;
              function _() {
                if (!S || !S.hasOwnProperty("getCurrentBufferState"))
                  throw new Error(i.default.MISSING_CONFIG_ERROR);
              }
              function L(c) {
                var o = (0, n.default)(T).create();
                if (!c || !c.hasOwnProperty("getMediaInfo") || !c.hasOwnProperty("getMediaType") || !c.hasOwnProperty("useBufferOccupancyABR") || !c.hasOwnProperty("getAbrController") || !c.hasOwnProperty("getScheduleController"))
                  return o;
                _();
                var y = c.getMediaInfo(), u = c.getMediaType(), A = S.getCurrentBufferState(u), I = c.getScheduleController(), M = c.getAbrController(), E = c.getStreamInfo(), N = E ? E.id : null, C = E && E.manifestInfo ? E.manifestInfo.isDynamic : null, b = M.getThroughputHistory(), w = b.getSafeAverageThroughput(u, C), V = b.getAverageLatency(u), J = c.useBufferOccupancyABR();
                return isNaN(w) || !A || J || M.getAbandonmentStateFor(N, u) !== r.default.ABANDON_LOAD && (A.state === r.default.BUFFER_LOADED || C) && (o.quality = M.getQualityForBitrate(y, w, N, V), I.setTimeToLoadDelay(0), o.reason = {
                  throughput: w,
                  latency: V
                }), o;
              }
              function v() {
              }
              return h = {
                getMaxIndex: L,
                reset: v
              }, h;
            }
            l.__dashjs_factory_name = "ThroughputRule";
            const d = g.default.getClassFactory(l);
          }
        ),
        /***/
        "./src/streaming/rules/abr/lolp/LearningAbrController.js": (
          /*!***************************************************************!*\
            !*** ./src/streaming/rules/abr/lolp/LearningAbrController.js ***!
            \***************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../../../core/Debug */
              "./src/core/Debug.js"
            ), i = {
              MANUAL: "manual_weight_selection",
              RANDOM: "random_weight_selection",
              DYNAMIC: "dynamic_weight_selection"
            };
            function r() {
              var d = this.context, t, T, S, h, _, L, v, c, o;
              function y() {
                T = (0, n.default)(d).getInstance().getLogger(t), A();
              }
              function u() {
                A();
              }
              function A() {
                S = null, h = 1, _ = 100, L = 0, v = null, c = null, o = i.DYNAMIC;
              }
              function I() {
                var ne = 0;
                if (S)
                  for (var ae = 0; ae < S.length; ae++) {
                    var fe = S[ae];
                    fe.state.throughput > ne && (ne = fe.state.throughput);
                  }
                return ne;
              }
              function M(ne) {
                var ae = ne.map(function(fe) {
                  return Math.pow(fe, 2);
                }).reduce(function(fe, Q) {
                  return fe + Q;
                });
                return Math.sqrt(ae);
              }
              function E(ne, ae, fe) {
                var Q = ne.map(function(de, Me) {
                  return fe[Me] * Math.pow(de - ae[Me], 2);
                }).reduce(function(de, Me) {
                  return de + Me;
                }), oe = Q < 0 ? -1 : 1;
                return oe * Math.sqrt(Math.abs(Q));
              }
              function N(ne, ae) {
                var fe = [ne.state.throughput, ne.state.latency, ne.state.rebuffer, ne.state.switch], Q = [ae.state.throughput, ae.state.latency, ae.state.rebuffer, ae.state.switch];
                return E(fe, Q, [1, 1, 1, 1]);
              }
              function C(ne, ae, fe) {
                for (var Q = 0; Q < ae.length; Q++) {
                  var oe = ae[Q], de = 0.1, Me = N(oe, ne), ge = Math.exp(-1 * Math.pow(Me, 2) / (2 * Math.pow(de, 2)));
                  b(oe, fe, ge);
                }
              }
              function b(ne, ae, fe) {
                var Q = ne.state, oe = [0.01, 0.01, 0.01, 0.01];
                Q.throughput = Q.throughput + (ae[0] - Q.throughput) * oe[0] * fe, Q.latency = Q.latency + (ae[1] - Q.latency) * oe[1] * fe, Q.rebuffer = Q.rebuffer + (ae[2] - Q.rebuffer) * oe[2] * fe, Q.switch = Q.switch + (ae[3] - Q.switch) * oe[3] * fe;
              }
              function w(ne, ae) {
                var fe = 0, Q = ne;
                if (S)
                  for (var oe = 0; oe < S.length; oe++) {
                    var de = S[oe];
                    de.bitrate < ne.bitrate && de.bitrate > fe && ae > de.bitrate && (fe = de.bitrate, Q = de);
                  }
                return Q;
              }
              function V(ne, ae, fe, Q, oe, de, Me) {
                var ge = fe, se = Q, ee = ae, re = ie(ne), ue = ae / h;
                ue > 1 && (ue = I()), fe = fe / _;
                var te = 0, O = 0, p = 0, P = 1e4;
                T.debug("getNextQuality called throughput:".concat(ue, " latency:").concat(fe, " bufferSize:").concat(Q, " currentQualityIndex:").concat(de, " playbackRate:").concat(oe));
                var k = re[de], X = k.bitrate * Me.getSegmentDuration() / ee, F = Math.max(0, X - se);
                if (se - X < Me.getMinBuffer())
                  return T.debug("Buffer is low for bitrate= ".concat(k.bitrate, " downloadTime=").concat(X, " currentBuffer=").concat(se, " rebuffer=").concat(F)), w(k, ee).qualityIndex;
                switch (o) {
                  case i.MANUAL:
                    J();
                    break;
                  case i.RANDOM:
                    H(re);
                    break;
                  case i.DYNAMIC:
                    z(Me, re, ge, se, F, ee, oe);
                    break;
                  default:
                    z(Me, re, ge, se, F, ee, oe);
                }
                for (var x = null, W = null, $ = null, ce = 0; ce < re.length; ce++) {
                  var le = re[ce], q = le.state, _e = [q.throughput, q.latency, q.rebuffer, q.switch], Ee = v.slice(), Te = Me.getNextBufferWithBitrate(le.bitrate, se, ee), Ce = Te < Me.getMinBuffer();
                  Ce && T.debug("Buffer is low for bitrate=".concat(le.bitrate, " downloadTime=").concat(X, " currentBuffer=").concat(se, " nextBuffer=").concat(Te)), (le.bitrate > ae - P || Ce) && le.bitrate !== L && (Ee[0] = 100);
                  var xe = E(_e, [ue, te, O, p], Ee);
                  (x === null || xe < x) && (x = xe, W = le.qualityIndex, $ = le);
                }
                var be = Math.abs(k.bitrate - $.bitrate) / h;
                return C(k, re, [ue, fe, F, be]), C($, re, [ue, te, O, be]), W;
              }
              function J() {
                var ne = 0.4, ae = 0.4, fe = 0.4, Q = 0.4;
                v = [ne, ae, fe, Q];
              }
              function H(ne) {
                v = Z(ne.length, 4);
              }
              function z(ne, ae, fe, Q, oe, de, Me) {
                v || (v = c[c.length - 1]);
                var ge = ne.findWeightVector(ae, fe, Q, oe, de, Me);
                ge !== null && ge !== -1 && (v = ge);
              }
              function Z(ne, ae) {
                for (var fe = [], Q = Math.sqrt(2 / ne), oe = 0; oe < ae; oe++)
                  fe.push(Math.random() * Q);
                return v = fe, v;
              }
              function ie(ne) {
                if (!S) {
                  S = [];
                  var ae = ne.bitrateList, fe = [];
                  L = ae[0].bandwidth, ae.forEach(function(de) {
                    fe.push(de.bandwidth), de.bandwidth < L && (L = de.bandwidth);
                  }), h = M(fe);
                  for (var Q = 0; Q < ae.length; Q++) {
                    var oe = {
                      qualityIndex: Q,
                      bitrate: ae[Q].bandwidth,
                      state: {
                        // normalize throughputs
                        throughput: ae[Q].bandwidth / h,
                        latency: 0,
                        rebuffer: 0,
                        switch: 0
                      }
                    };
                    S.push(oe);
                  }
                  c = Y(S);
                }
                return S;
              }
              function K(ne) {
                for (var ae = [], fe = 0; fe < ne; fe++) {
                  var Q = [
                    Math.random() * I(),
                    //throughput
                    Math.random(),
                    //latency
                    Math.random(),
                    //buffersize
                    Math.random()
                    //switch
                  ];
                  ae.push(Q);
                }
                return ae;
              }
              function Y(ne) {
                var ae = [], fe = K(Math.pow(ne.length, 2));
                ae.push(fe[0]);
                for (var Q = [1, 1, 1, 1], oe = 1; oe < ne.length; oe++) {
                  for (var de = null, Me = null, ge = 0; ge < fe.length; ge++) {
                    for (var se = fe[ge], ee = null, re = 0; re < ae.length; re++) {
                      var ue = E(se, ae[re], Q);
                      (ee === null || ue < ee) && (ee = ue);
                    }
                    (Me === null || ee > Me) && (de = se, Me = ee);
                  }
                  ae.push(de);
                }
                for (var te = null, O = null, p = 0; p < ae.length; p++) {
                  for (var P = 0, k = 0; k < ae.length; k++)
                    p !== k && (P += E(ae[p], ae[k], Q));
                  (te === null || P > te) && (te = P, O = p);
                }
                var X = [];
                for (X.push(ae[O]), ae.splice(O, 1); ae.length > 0; ) {
                  for (var F = null, x = null, W = 0; W < ae.length; W++) {
                    var $ = E(X[0], ae[W], Q);
                    (F === null || $ < F) && (F = $, x = W);
                  }
                  X.push(ae[x]), ae.splice(x, 1);
                }
                return X;
              }
              return t = {
                getNextQuality: V,
                reset: u
              }, y(), t;
            }
            r.__dashjs_factory_name = "LearningAbrController";
            const l = g.default.getClassFactory(r);
          }
        ),
        /***/
        "./src/streaming/rules/abr/lolp/LoLpQoEEvaluator.js": (
          /*!**********************************************************!*\
            !*** ./src/streaming/rules/abr/lolp/LoLpQoEEvaluator.js ***!
            \**********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ./QoeInfo */
              "./src/streaming/rules/abr/lolp/QoeInfo.js"
            );
            function i() {
              var l, d, t, T, S;
              function h() {
                _();
              }
              function _() {
                d = null, t = null, T = null, S = null;
              }
              function L(I, M, E) {
                d = v("segment", I, M, E), t = I, T = M, S = E;
              }
              function v(I, M, E, N) {
                var C = new n.default();
                return C.type = I, M ? C.weights.bitrateReward = M : C.weights.bitrateReward = 1, C.weights.bitrateSwitchPenalty = 1, E ? C.weights.rebufferPenalty = E : C.weights.rebufferPenalty = 1e3, C.weights.latencyPenalty = [], C.weights.latencyPenalty.push({
                  threshold: 1.1,
                  penalty: N * 0.05
                }), C.weights.latencyPenalty.push({
                  threshold: 1e8,
                  penalty: E * 0.1
                }), N ? C.weights.playbackSpeedPenalty = N : C.weights.playbackSpeedPenalty = 200, C;
              }
              function c(I, M, E, N) {
                d && o(I, M, E, N, d);
              }
              function o(I, M, E, N, C) {
                C.bitrateWSum += C.weights.bitrateReward * I, C.lastBitrate && (C.bitrateSwitchWSum += C.weights.bitrateSwitchPenalty * Math.abs(I - C.lastBitrate)), C.lastBitrate = I, C.rebufferWSum += C.weights.rebufferPenalty * M;
                for (var b = 0; b < C.weights.latencyPenalty.length; b++) {
                  var w = C.weights.latencyPenalty[b];
                  if (E <= w.threshold) {
                    C.latencyWSum += w.penalty * E;
                    break;
                  }
                }
                C.playbackSpeedWSum += C.weights.playbackSpeedPenalty * Math.abs(1 - N), C.totalQoe = C.bitrateWSum - C.bitrateSwitchWSum - C.rebufferWSum - C.latencyWSum - C.playbackSpeedWSum;
              }
              function y() {
                return d;
              }
              function u(I, M, E, N) {
                var C = null;
                return t && T && S && (C = v("segment", t, T, S)), C ? (o(I, M, E, N, C), C.totalQoe) : 0;
              }
              function A() {
                _();
              }
              return l = {
                setupPerSegmentQoe: L,
                logSegmentMetrics: c,
                getPerSegmentQoe: y,
                calculateSingleUseQoe: u,
                reset: A
              }, h(), l;
            }
            i.__dashjs_factory_name = "LoLpQoeEvaluator";
            const r = g.default.getClassFactory(i);
          }
        ),
        /***/
        "./src/streaming/rules/abr/lolp/LoLpRule.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/rules/abr/lolp/LoLpRule.js ***!
            \**************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var g = e(
              /*! ../../../../core/Debug */
              "./src/core/Debug.js"
            ), n = e(
              /*! ../../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), i = e(
              /*! ./LearningAbrController */
              "./src/streaming/rules/abr/lolp/LearningAbrController.js"
            ), r = e(
              /*! ./LoLpQoEEvaluator */
              "./src/streaming/rules/abr/lolp/LoLpQoEEvaluator.js"
            ), l = e(
              /*! ../../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), d = e(
              /*! ../../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), t = e(
              /*! ./LoLpWeightSelector */
              "./src/streaming/rules/abr/lolp/LoLpWeightSelector.js"
            ), T = e(
              /*! ../../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), S = 1.5, h = 0.3;
            function _(v) {
              v = v || {};
              var c = v.dashMetrics, o = this.context, y, u, A, I;
              function M() {
                y = (0, g.default)(o).getInstance().getLogger(u), A = (0, i.default)(o).create(), I = (0, r.default)(o).create();
              }
              function E(b) {
                try {
                  var w = (0, l.default)(o).create(), V = b.getMediaInfo().type, J = b.getAbrController(), H = b.getStreamInfo(), z = J.getQualityFor(V, H.id), Z = b.getMediaInfo(), ie = c.getCurrentBufferState(V), K = b.getScheduleController(), Y = c.getCurrentBufferLevel(V, !0), ne = H && H.manifestInfo ? H.manifestInfo.isDynamic : null, ae = K.getPlaybackController(), fe = ae.getCurrentLiveLatency();
                  if (!b.useLoLPABR() || V === T.default.AUDIO)
                    return w;
                  fe || (fe = 0);
                  var Q = ae.getPlaybackRate(), oe = J.getThroughputHistory(), de = oe.getSafeAverageThroughput(V, ne);
                  if (y.debug("Throughput ".concat(Math.round(de), " kbps")), isNaN(de) || !ie || J.getAbandonmentStateFor(H.id, V) === d.default.ABANDON_LOAD)
                    return w;
                  for (var Me = Z.bitrateList, ge = b.getRepresentationInfo().fragmentDuration, se = Me[0].bandwidth / 1e3, ee = Me[Me.length - 1].bandwidth / 1e3, re = 0; re < Me.length; re++) {
                    var ue = Me[re].bandwidth / 1e3;
                    ue > ee ? ee = ue : ue < se && (se = ue);
                  }
                  var te = Me[z].bandwidth, O = te / 1e3, p = c.getCurrentHttpRequest(V, !0), P = (p.tresponse.getTime() - p.trequest.getTime()) / 1e3, k = P > ge ? P - ge : 0;
                  I.setupPerSegmentQoe(ge, ee, se), I.logSegmentMetrics(O, k, fe, Q);
                  var X = (0, t.default)(o).create({
                    targetLatency: S,
                    bufferMin: h,
                    segmentDuration: ge,
                    qoeEvaluator: I
                  });
                  return w.quality = A.getNextQuality(Z, de * 1e3, fe, Y, Q, z, X), w.reason = {
                    throughput: de,
                    latency: fe
                  }, w.priority = l.default.PRIORITY.STRONG, K.setTimeToLoadDelay(0), w.quality !== z && console.log("[TgcLearningRule][" + V + "] requesting switch to index: ", w.quality, "Average throughput", Math.round(de), "kbps"), w;
                } catch (F) {
                  throw F;
                }
              }
              function N() {
                A.reset(), I.reset();
              }
              function C() {
                N();
              }
              return u = {
                getMaxIndex: E,
                reset: C
              }, M(), u;
            }
            _.__dashjs_factory_name = "LoLPRule";
            const L = n.default.getClassFactory(_);
          }
        ),
        /***/
        "./src/streaming/rules/abr/lolp/LoLpWeightSelector.js": (
          /*!************************************************************!*\
            !*** ./src/streaming/rules/abr/lolp/LoLpWeightSelector.js ***!
            \************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n(r) {
              var l = r.targetLatency, d = r.bufferMin, t = r.segmentDuration, T = r.qoeEvaluator, S, h, _, L, v;
              function c() {
                o();
              }
              function o() {
                h = [0.2, 0.4, 0.6, 0.8, 1], _ = 4, L = A(h, _), v = 0;
              }
              function y(C, b, w, V, J, H) {
                var z = null, Z = null, ie = null, K = Math.abs(b - v);
                return C.forEach(function(Y) {
                  L.forEach(function(ne) {
                    var ae = {
                      throughput: ne[0],
                      latency: ne[1],
                      buffer: ne[2],
                      switch: ne[3]
                    }, fe = Y.bitrate * t / J, Q = N(w, fe), oe = Math.max(1e-5, fe - Q), de;
                    ae.buffer === 0 ? de = 10 : de = 1 / ae.buffer;
                    var Me = de * oe;
                    ae.latency === 0 ? de = 10 : de = 1 / ae.latency;
                    var ge = de * Y.state.latency, se = T.calculateSingleUseQoe(Y.bitrate, Me, ge, H);
                    (z === null || se > z) && u(b, Q, K) && (z = se, Z = ne, ie = Y.bitrate);
                  });
                }), Z === null && ie === null && (Z = -1), v = b, Z;
              }
              function u(C, b, w) {
                return C > l + w ? !1 : b >= d;
              }
              function A(C, b) {
                var w = C.map(function(J) {
                  return [J];
                }), V = function J(H, z, Z) {
                  if (Z === z)
                    return H;
                  for (var ie = H.length, K = 0; K < ie; K++)
                    for (var Y = H.shift(), ne = 0; ne < C.length; ne++)
                      H.push(Y.concat(C[ne]));
                  return J(H, z, Z + 1);
                };
                return V(w, b, 1);
              }
              function I() {
                return d;
              }
              function M() {
                return t;
              }
              function E(C, b, w) {
                var V = C * t / w;
                return N(b, V);
              }
              function N(C, b) {
                var w = M(), V;
                return b > w ? V = C - w : V = C + w - b, V;
              }
              return S = {
                getMinBuffer: I,
                getSegmentDuration: M,
                getNextBufferWithBitrate: E,
                getNextBuffer: N,
                findWeightVector: y
              }, c(), S;
            }
            n.__dashjs_factory_name = "LoLpWeightSelector";
            const i = g.default.getClassFactory(n);
          }
        ),
        /***/
        "./src/streaming/rules/abr/lolp/QoeInfo.js": (
          /*!*************************************************!*\
            !*** ./src/streaming/rules/abr/lolp/QoeInfo.js ***!
            \*************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.type = null, this.lastBitrate = null, this.weights = {}, this.weights.bitrateReward = null, this.weights.bitrateSwitchPenalty = null, this.weights.rebufferPenalty = null, this.weights.latencyPenalty = null, this.weights.playbackSpeedPenalty = null, this.bitrateWSum = 0, this.bitrateSwitchWSum = 0, this.rebufferWSum = 0, this.latencyWSum = 0, this.playbackSpeedWSum = 0, this.totalQoe = 0;
            };
            const i = n;
          }
        ),
        /***/
        "./src/streaming/text/EmbeddedTextHtmlRender.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/text/EmbeddedTextHtmlRender.js ***!
            \******************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n() {
              var r = 0, l;
              function d(v) {
                for (var c = "", o = 0; o < v.length; ++o) {
                  var y = v[o];
                  c += y.uchar;
                }
                var u = c.length, A = c.replace(/^\s+/, "").length;
                return u - A;
              }
              function t(v) {
                return "left: " + v.x * 3.125 + "%; top: " + v.y1 * 6.66 + "%; width: " + (100 - v.x * 3.125) + "%; height: " + Math.max(v.y2 - 1 - v.y1, 1) * 6.66 + "%; align-items: flex-start; overflow: visible; -webkit-writing-mode: horizontal-tb;";
              }
              function T(v) {
                return v === "red" ? "rgb(255, 0, 0)" : v === "green" ? "rgb(0, 255, 0)" : v === "blue" ? "rgb(0, 0, 255)" : v === "cyan" ? "rgb(0, 255, 255)" : v === "magenta" ? "rgb(255, 0, 255)" : v === "yellow" ? "rgb(255, 255, 0)" : v === "white" ? "rgb(255, 255, 255)" : v === "black" ? "rgb(0, 0, 0)" : v;
              }
              function S(v, c) {
                var o = v.videoHeight / 15;
                return c ? "font-size: " + o + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; color: " + (c.foreground ? T(c.foreground) : "rgb(255, 255, 255)") + "; font-style: " + (c.italics ? "italic" : "normal") + "; text-decoration: " + (c.underline ? "underline" : "none") + "; white-space: pre; background-color: " + (c.background ? T(c.background) : "transparent") + ";" : "font-size: " + o + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; justify-content: flex-start; text-align: left; color: rgb(255, 255, 255); font-style: normal; white-space: pre; line-height: normal; font-weight: normal; text-decoration: none; width: 100%; display: flex;";
              }
              function h(v) {
                return v.replace(/^\s+/g, "");
              }
              function _(v) {
                return v.replace(/\s+$/g, "");
              }
              function L(v, c, o, y) {
                var u = null, A = null, I = !1, M = -1, E = {
                  start: c,
                  end: o,
                  spans: []
                }, N = "style_cea608_white_black", C = {}, b = {}, w = [], V, J;
                for (V = 0; V < 15; ++V) {
                  var H = y.rows[V], z = "", Z = null;
                  if (H.isEmpty() === !1) {
                    var ie = d(H.chars);
                    u === null && (u = {
                      x: ie,
                      y1: V,
                      y2: V + 1,
                      p: []
                    }), ie !== M && I && (u.p.push(E), E = {
                      start: c,
                      end: o,
                      spans: []
                    }, u.y2 = V, u.name = "region_" + u.x + "_" + u.y1 + "_" + u.y2, C.hasOwnProperty(u.name) === !1 ? (w.push(u), C[u.name] = u) : (A = C[u.name], A.p.contat(u.p)), u = {
                      x: ie,
                      y1: V,
                      y2: V + 1,
                      p: []
                    });
                    for (var K = 0; K < H.chars.length; ++K) {
                      var Y = H.chars[K], ne = Y.penState;
                      if (Z === null || !ne.equals(Z)) {
                        z.trim().length > 0 && (E.spans.push({
                          name: N,
                          line: z,
                          row: V
                        }), z = "");
                        var ae = "style_cea608_" + ne.foreground + "_" + ne.background;
                        ne.underline && (ae += "_underline"), ne.italics && (ae += "_italics"), b.hasOwnProperty(ae) || (b[ae] = JSON.parse(JSON.stringify(ne))), Z = ne, N = ae;
                      }
                      z += Y.uchar;
                    }
                    z.trim().length > 0 && E.spans.push({
                      name: N,
                      line: z,
                      row: V
                    }), I = !0, M = ie;
                  } else
                    I = !1, M = -1, u && (u.p.push(E), E = {
                      start: c,
                      end: o,
                      spans: []
                    }, u.y2 = V, u.name = "region_" + u.x + "_" + u.y1 + "_" + u.y2, C.hasOwnProperty(u.name) === !1 ? (w.push(u), C[u.name] = u) : (A = C[u.name], A.p.contat(u.p)), u = null);
                }
                u && (u.p.push(E), u.y2 = V + 1, u.name = "region_" + u.x + "_" + u.y1 + "_" + u.y2, C.hasOwnProperty(u.name) === !1 ? (w.push(u), C[u.name] = u) : (A = C[u.name], A.p.contat(u.p)), u = null);
                var fe = [];
                for (V = 0; V < w.length; ++V) {
                  var Q = w[V], oe = "sub_cea608_" + r++, de = document.createElement("div");
                  de.id = oe;
                  var Me = t(Q);
                  de.style.cssText = "position: absolute; margin: 0; display: flex; box-sizing: border-box; pointer-events: none;" + Me;
                  var ge = document.createElement("div");
                  ge.className = "paragraph bodyStyle", ge.style.cssText = S(v);
                  var se = document.createElement("div");
                  se.className = "cueUniWrapper", se.style.cssText = "unicode-bidi: normal; direction: ltr;";
                  for (var ee = 0; ee < Q.p.length; ++ee) {
                    var re = Q.p[ee], ue = 0;
                    for (J = 0; J < re.spans.length; ++J) {
                      var te = re.spans[J];
                      if (te.line.length > 0) {
                        if (J !== 0 && ue != te.row) {
                          var O = document.createElement("br");
                          O.className = "lineBreak", se.appendChild(O);
                        }
                        var p = !1;
                        ue === te.row && (p = !0), ue = te.row;
                        var P = b[te.name], k = document.createElement("span");
                        k.className = "spanPadding " + te.name + " customSpanColor", k.style.cssText = S(v, P), J !== 0 && p ? J === re.spans.length - 1 ? k.textContent = _(te.line) : k.textContent = te.line : re.spans.length > 1 && J < re.spans.length - 1 && te.row === re.spans[J + 1].row ? k.textContent = h(te.line) : k.textContent = te.line.trim(), se.appendChild(k);
                      }
                    }
                  }
                  ge.appendChild(se), de.appendChild(ge);
                  var X = {
                    bodyStyle: ["%", 90]
                  };
                  for (var F in b)
                    b.hasOwnProperty(F) && (X[F] = ["%", 90]);
                  fe.push({
                    type: "html",
                    start: c,
                    end: o,
                    cueHTMLElement: de,
                    cueID: oe,
                    cellResolution: [32, 15],
                    isFromCEA608: !0,
                    fontSize: X,
                    lineHeight: {},
                    linePadding: {}
                  });
                }
                return fe;
              }
              return l = {
                createHTMLCaptionsFromScreen: L
              }, l;
            }
            n.__dashjs_factory_name = "EmbeddedTextHtmlRender";
            const i = g.default.getSingletonFactory(n);
          }
        ),
        /***/
        "./src/streaming/text/NotFragmentedTextBufferController.js": (
          /*!*****************************************************************!*\
            !*** ./src/streaming/text/NotFragmentedTextBufferController.js ***!
            \*****************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            var g = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), n = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), i = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! ../utils/InitCache */
              "./src/streaming/utils/InitCache.js"
            ), l = e(
              /*! ../SourceBufferSink */
              "./src/streaming/SourceBufferSink.js"
            ), d = e(
              /*! ../../streaming/vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), t = e(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), T = "NotFragmentedTextBufferController";
            function S(_) {
              _ = _ || {};
              var L = this.context, v = (0, g.default)(L).getInstance(), c = _.textController, o = _.errHandler, y = _.streamInfo, u = _.type, A, I, M, E, N, C;
              function b() {
                M = !1, E = null, I = !1, C = (0, r.default)(L).getInstance(), v.on(n.default.INIT_FRAGMENT_LOADED, Me, A);
              }
              function w() {
                return T;
              }
              function V($) {
                ie($);
              }
              function J($) {
                return new Promise(function(ce, le) {
                  try {
                    N = (0, l.default)(L).create({
                      mediaSource: E,
                      textController: c,
                      eventBus: v
                    }), N.initializeForFirstUse(y, $), M || (N.getBuffer() && typeof N.getBuffer().initialize == "function" && N.getBuffer().initialize(), M = !0), ce(N);
                  } catch (q) {
                    o.error(new d.default(t.default.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, t.default.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + u)), le(q);
                  }
                });
              }
              function H() {
                return y.id;
              }
              function z() {
                return u;
              }
              function Z() {
                return N;
              }
              function ie($) {
                E = $;
              }
              function K() {
                return E;
              }
              function Y() {
                return !1;
              }
              function ne() {
              }
              function ae() {
                return 0;
              }
              function fe() {
                return I;
              }
              function Q($) {
                I !== $ && (I = $, I && W(n.default.BUFFERING_COMPLETED));
              }
              function oe($) {
                v.off(n.default.INIT_FRAGMENT_LOADED, Me, A), !$ && N && (N.abort(), N.reset(), N = null);
              }
              function de($) {
                return C.extract(y.id, $) !== null;
              }
              function Me($) {
                !$.chunk.bytes || I || (C.save($.chunk), N.append($.chunk), Q(!0));
              }
              function ge() {
                return null;
              }
              function se() {
                return !0;
              }
              function ee() {
                return [];
              }
              function re() {
                return Number.POSITIVE_INFINITY;
              }
              function ue() {
                return Promise.resolve();
              }
              function te() {
              }
              function O() {
                return Promise.resolve();
              }
              function p() {
                return Promise.resolve();
              }
              function P() {
                return I = !1, Promise.resolve();
              }
              function k() {
                return Promise.resolve();
              }
              function X() {
              }
              function F() {
              }
              function x() {
                return Promise.resolve();
              }
              function W($, ce) {
                var le = ce || {};
                v.trigger($, le, {
                  streamId: y.id,
                  mediaType: u
                });
              }
              return A = {
                initialize: V,
                getStreamId: H,
                getType: z,
                getBufferControllerType: w,
                createBufferSink: J,
                dischargePreBuffer: ne,
                getBuffer: Z,
                getBufferLevel: ae,
                getRangeAt: ge,
                pruneBuffer: te,
                hasBufferAtTime: se,
                getAllRangesWithSafetyFactor: ee,
                getContinuousBufferTimeForTargetTime: re,
                setMediaSource: ie,
                getMediaSource: K,
                appendInitSegmentFromCache: de,
                getIsBufferingCompleted: fe,
                setIsBufferingCompleted: Q,
                getIsPruningInProgress: Y,
                reset: oe,
                clearBuffers: ue,
                prepareForPlaybackSeek: p,
                prepareForReplacementTrackSwitch: P,
                setSeekTarget: X,
                updateAppendWindow: k,
                pruneAllSafely: x,
                updateBufferTimestampOffset: O,
                segmentRequestingCompleted: F
              }, b(), A;
            }
            S.__dashjs_factory_name = T;
            const h = i.default.getClassFactory(S);
          }
        ),
        /***/
        "./src/streaming/text/TextController.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/text/TextController.js ***!
            \**********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), i = e(
              /*! ./TextSourceBuffer */
              "./src/streaming/text/TextSourceBuffer.js"
            ), r = e(
              /*! ./TextTracks */
              "./src/streaming/text/TextTracks.js"
            ), l = e(
              /*! ../utils/VTTParser */
              "./src/streaming/utils/VTTParser.js"
            ), d = e(
              /*! ../utils/VttCustomRenderingParser */
              "./src/streaming/utils/VttCustomRenderingParser.js"
            ), t = e(
              /*! ../utils/TTMLParser */
              "./src/streaming/utils/TTMLParser.js"
            ), T = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), S = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), h = e(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), _ = e(
              /*! ../utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            );
            function L(c) {
              var o = this.context, y = c.adapter, u = c.errHandler, A = c.manifestModel, I = c.mediaController, M = c.videoModel, E = c.settings, N, C, b, w, V, J, H, z, Z, ie, K, Y;
              function ne() {
                ie = !1, K = !1, Y = !1, V = (0, l.default)(o).getInstance(), J = (0, d.default)(o).getInstance(), H = (0, t.default)(o).getInstance(), z = (0, T.default)(o).getInstance(), x();
              }
              function ae() {
                z.on(S.default.TEXT_TRACKS_QUEUE_INITIALIZED, se, N), E.get().streaming.text.webvtt.customRenderingEnabled && (z.on(S.default.PLAYBACK_TIME_UPDATED, ee, N), z.on(S.default.PLAYBACK_SEEKING, re, N));
              }
              function fe($) {
                var ce = $.id, le = (0, r.default)(o).create({
                  videoModel: M,
                  settings: E,
                  streamInfo: $
                });
                le.initialize(), w[ce] = le;
                var q = (0, i.default)(o).create({
                  errHandler: u,
                  adapter: y,
                  manifestModel: A,
                  mediaController: I,
                  videoModel: M,
                  textTracks: le,
                  vttParser: V,
                  vttCustomRenderingParser: J,
                  ttmlParser: H,
                  streamInfo: $,
                  settings: E
                });
                q.initialize(), b[ce] = q, C[ce] = {}, C[ce].lastEnabledIndex = -1;
              }
              function Q($) {
                var ce = $.id;
                w[ce] && w[ce].createTracks();
              }
              function oe($, ce, le) {
                var q = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, _e = $.id;
                b[_e] && b[_e].addMediaInfos(ce, le, q);
              }
              function de($) {
                var ce = $.id;
                if (b && b[ce])
                  return b[ce];
              }
              function Me() {
                return Z;
              }
              function ge($, ce) {
                var le = $.id;
                b[le] && b[le].addEmbeddedTrack(ce);
              }
              function se($) {
                var ce = $.tracks, le = $.index, q = $.streamId, _e = E.get().streaming.text.defaultEnabled;
                if (_e === !1 && !te() || Y)
                  p(q, -1);
                else {
                  var Ee = I.getCurrentTrackFor(g.default.TEXT, q);
                  if (Ee) {
                    var Te = {
                      lang: Ee.lang,
                      role: Ee.roles[0],
                      index: Ee.index,
                      codec: Ee.codec,
                      accessibility: Ee.accessibility[0]
                    };
                    ce.some(function(Ce, xe) {
                      if (I.matchSettings(Te, Ce))
                        return p(q, xe), le = xe, !0;
                    });
                  }
                  Z = !1;
                }
                C[q].lastEnabledIndex = le, z.trigger(h.default.TEXT_TRACKS_ADDED, {
                  enabled: te(),
                  index: le,
                  tracks: ce,
                  streamId: q
                }), K = !0;
              }
              function ee($) {
                try {
                  var ce = $.streamId;
                  if (!w[ce] || isNaN($.time))
                    return;
                  w[ce].manualCueProcessing($.time);
                } catch {
                }
              }
              function re($) {
                try {
                  var ce = $.streamId;
                  if (!w[ce])
                    return;
                  w[ce].disableManualTracks();
                } catch {
                }
              }
              function ue($, ce) {
                (0, _.checkParameterType)(ce, "boolean"), te() !== ce && (ce && p($, C[$].lastEnabledIndex), ce || (C[$].lastEnabledIndex = X($), K ? p($, -1) : Y = !0));
              }
              function te() {
                var $ = !0;
                return Z && !ie && ($ = !1), $;
              }
              function O($) {
                (0, _.checkParameterType)($, "boolean"), ie = $;
              }
              function p($, ce) {
                Z = ce === -1, Z && I && I.saveTextSettingsDisabled();
                var le = X($);
                if (!(le === ce || !w[$])) {
                  w[$].disableManualTracks(), w[$].setModeForTrackIdx(le, g.default.TEXT_HIDDEN), w[$].setCurrentTrackIdx(ce), w[$].setModeForTrackIdx(ce, g.default.TEXT_SHOWING);
                  var q = w[$].getCurrentTrackInfo();
                  q && q.isFragmented && !q.isEmbedded ? P($, q, le) : q && !q.isFragmented && k($, q), I.setTrack(q);
                }
              }
              function P($, ce, le) {
                if (b[$])
                  for (var q = b[$].getConfig(), _e = q.fragmentedTracks, Ee = 0; Ee < _e.length; Ee++) {
                    var Te = _e[Ee];
                    if (ce.lang === Te.lang && (Te.id ? ce.id === Te.id : ce.index === Te.index)) {
                      var Ce = I.getCurrentTrackFor(g.default.TEXT, $);
                      (Te.id ? Ce.id !== Te.id : Ce.index !== Te.index) ? (w[$].deleteCuesFromTrackIdx(le), b[$].setCurrentFragmentedTrackIdx(Ee)) : le === -1 && z.trigger(S.default.SET_FRAGMENTED_TEXT_AFTER_DISABLED, {}, {
                        streamId: $,
                        mediaType: g.default.TEXT
                      });
                    }
                  }
              }
              function k($, ce) {
                z.trigger(S.default.SET_NON_FRAGMENTED_TEXT, {
                  currentTrackInfo: ce
                }, {
                  streamId: $,
                  mediaType: g.default.TEXT
                });
              }
              function X($) {
                return w[$].getCurrentTrackIdx();
              }
              function F($) {
                if ($) {
                  var ce = $.id;
                  b[ce] && b[ce].resetMediaInfos(), w[ce] && w[ce].deleteAllTextTracks();
                }
              }
              function x() {
                b = {}, w = {}, C = {}, Z = !0, K = !1, Y = !1;
              }
              function W() {
                x(), z.off(S.default.TEXT_TRACKS_QUEUE_INITIALIZED, se, N), E.get().streaming.text.webvtt.customRenderingEnabled && (z.off(S.default.PLAYBACK_TIME_UPDATED, ee, N), z.off(S.default.PLAYBACK_SEEKING, re, N)), Object.keys(b).forEach(function($) {
                  b[$].resetEmbedded(), b[$].reset();
                });
              }
              return N = {
                deactivateStream: F,
                initialize: ae,
                initializeForStream: fe,
                createTracks: Q,
                getTextSourceBuffer: de,
                getAllTracksAreDisabled: Me,
                addEmbeddedTrack: ge,
                enableText: ue,
                isTextEnabled: te,
                setTextTrack: p,
                getCurrentTrackIdx: X,
                enableForcedTextStreaming: O,
                addMediaInfosToBuffer: oe,
                reset: W
              }, ne(), N;
            }
            L.__dashjs_factory_name = "TextController";
            const v = n.default.getClassFactory(L);
          }
        ),
        /***/
        "./src/streaming/text/TextSourceBuffer.js": (
          /*!************************************************!*\
            !*** ./src/streaming/text/TextSourceBuffer.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => u
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), i = e(
              /*! ../vo/TextTrackInfo */
              "./src/streaming/vo/TextTrackInfo.js"
            ), r = e(
              /*! ../utils/BoxParser */
              "./src/streaming/utils/BoxParser.js"
            ), l = e(
              /*! ../utils/CustomTimeRanges */
              "./src/streaming/utils/CustomTimeRanges.js"
            ), d = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), t = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), T = e(
              /*! ./EmbeddedTextHtmlRender */
              "./src/streaming/text/EmbeddedTextHtmlRender.js"
            ), S = e(
              /*! codem-isoboxer */
              "./node_modules/codem-isoboxer/dist/iso_boxer.js"
            ), h = e(
              /*! ../../../externals/cea608-parser */
              "./externals/cea608-parser.js"
            ), _ = /* @__PURE__ */ e.n(h), L = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), v = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), c = e(
              /*! ../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), o = e(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            );
            function y(A) {
              var I = A.errHandler, M = A.manifestModel, E = A.mediaController, N = A.videoModel, C = A.textTracks, b = A.vttParser, w = A.vttCustomRenderingParser, V = A.ttmlParser, J = A.streamInfo, H = A.settings, z = this.context, Z = (0, L.default)(z).getInstance(), ie = !1, K, Y, ne, ae, fe, Q, oe, de, Me, ge, se, ee, re, ue, te, O;
              function p() {
                Y = (0, t.default)(z).getInstance().getLogger(K), ne = (0, r.default)(z).getInstance(), X();
              }
              function P() {
                return J.id;
              }
              function k() {
                Q = null, de = NaN, Me = [], ge = null, oe = !1;
              }
              function X() {
                k(), fe = [], ae = null;
              }
              function F() {
                ie || q();
              }
              function x(Xe, ve, me) {
                if (fe = fe.concat(ve), Xe === g.default.TEXT && ve[0].isFragmented && !ve[0].isEmbedded) {
                  Q = me, K.buffered = (0, l.default)(z).create(), Me = E.getTracksFor(g.default.TEXT, J.id).filter(function($e) {
                    return $e.isFragmented;
                  });
                  for (var Ie = E.getCurrentTrackFor(g.default.TEXT, J.id), we = 0; we < Me.length; we++)
                    if (Me[we] === Ie) {
                      Ce(we);
                      break;
                    }
                }
                for (var Ue = 0; Ue < ve.length; Ue++)
                  W(ve[Ue]);
              }
              function W(Xe) {
                var ve = new i.default(), me = {
                  subtitle: "subtitles",
                  caption: "captions"
                };
                for (var Ie in Xe)
                  ve[Ie] = Xe[Ie];
                ve.labels = Xe.labels, ve.defaultTrack = tt(Xe), ve.isFragmented = Xe.isFragmented, ve.isEmbedded = !!Xe.isEmbedded, ve.isTTML = xe(Xe), ve.kind = be(Xe, me), C.addTextTrack(ve);
              }
              function $() {
              }
              function ce() {
                X(), fe = [], ne = null;
              }
              function le(Xe) {
                var ve = Xe.chunk;
                ve.mediaInfo.embeddedCaptions && Ge(ve.bytes, ve);
              }
              function q() {
                ee = [], se = null, re = 0, te = [], ue = null, ie = !0, O = (0, T.default)(z).getInstance(), Z.on(v.default.VIDEO_CHUNK_RECEIVED, le, K), Z.on(v.default.BUFFER_CLEARED, ht, K);
              }
              function _e() {
                Z.off(v.default.VIDEO_CHUNK_RECEIVED, le, K), Z.off(v.default.BUFFER_CLEARED, ht, K), C && C.deleteAllTextTracks(), ie = !1, ee = [], te = [null, null], ue = null;
              }
              function Ee(Xe) {
                if (ie && Xe)
                  if (Xe.id === g.default.CC1 || Xe.id === g.default.CC3) {
                    for (var ve = 0; ve < ee.length; ve++)
                      if (ee[ve].id === Xe.id)
                        return;
                    ee.push(Xe);
                  } else
                    Y.warn("Embedded track " + Xe.id + " not supported!");
              }
              function Te() {
                var Xe = {
                  fragmentModel: Q,
                  fragmentedTracks: Me,
                  videoModel: N
                };
                return Xe;
              }
              function Ce(Xe) {
                se = Xe;
              }
              function xe(Xe) {
                return Xe.codec && Xe.codec.search(g.default.STPP) >= 0 || Xe.mimeType && Xe.mimeType.search(g.default.TTML) >= 0;
              }
              function be(Xe, ve) {
                var me = Xe.roles && Xe.roles.length > 0 ? ve[Xe.roles[0]] : ve.caption;
                return me = me === ve.caption || me === ve.subtitle ? me : ve.caption, me;
              }
              function Ge(Xe, ve) {
                var me = ve.mediaInfo, Ie = me.type, we = me.mimeType, Ue = me.codec || we;
                if (!Ue) {
                  Y.error("No text type defined");
                  return;
                }
                me.codec.indexOf("application/mp4") !== -1 ? Pe(Xe, ve, Ue) : Ie === g.default.VIDEO ? nt(Xe, ve) : Ze(Xe, ve, Ue);
              }
              function Pe(Xe, ve, me) {
                var Ie, we;
                if (ve.segmentType === "InitializationSegment")
                  oe = !0, de = ne.getMediaTimescaleFromMoov(Xe);
                else {
                  if (!oe)
                    return;
                  we = ne.getSamplesInfo(Xe), Ie = we.sampleList, Ie.length > 0 && (ge = Ie[0].cts - ve.start * de), me.search(g.default.STPP) >= 0 ? Le(Xe, Ie, me) : je(Xe, Ie);
                }
              }
              function Le(Xe, ve, me) {
                var Ie, we;
                for (ae = ae !== null ? ae : st(me), Ie = 0; Ie < ve.length; Ie++) {
                  var Ue = ve[Ie], $e = Ue.cts, at = Ke(), et = at + $e / de, Mt = et + Ue.duration / de;
                  K.buffered.add(et, Mt);
                  var Lt = new DataView(Xe, Ue.offset, Ue.subSizes[0]), bt = S.Utils.dataViewToString(Lt, g.default.UTF8), Ae = [], ze = Ue.offset + Ue.subSizes[0];
                  for (we = 1; we < Ue.subSizes.length; we++) {
                    var qe = new Uint8Array(Xe, ze, Ue.subSizes[we]), _t = String.fromCharCode.apply(null, qe);
                    Ae.push(_t), ze += Ue.subSizes[we];
                  }
                  try {
                    var dt = M.getValue(), Tt = dt.ttmlTimeIsRelative ? $e / de : 0, wt = ae.parse(bt, Tt, $e / de, ($e + Ue.duration) / de, Ae);
                    C.addCaptions(se, at, wt);
                  } catch (Gt) {
                    Q.removeExecutedRequestsBeforeTime(), this.remove(), Y.error("TTML parser error: " + Gt.message);
                  }
                }
              }
              function je(Xe, ve) {
                var me, Ie, we, Ue = [];
                for (me = 0; me < ve.length; me++) {
                  var $e = ve[me];
                  $e.cts -= ge;
                  var at = Ke(), et = at + $e.cts / de, Mt = et + $e.duration / de;
                  K.buffered.add(et, Mt);
                  var Lt = Xe.slice($e.offset, $e.offset + $e.size), bt = S.parseBuffer(Lt);
                  for (Ie = 0; Ie < bt.boxes.length; Ie++) {
                    var Ae = bt.boxes[Ie];
                    if (Y.debug("VTT box1: " + Ae.type), Ae.type !== "vtte" && Ae.type === "vttc")
                      for (Y.debug("VTT vttc boxes.length = " + Ae.boxes.length), we = 0; we < Ae.boxes.length; we++) {
                        var ze = Ae.boxes[we];
                        if (Y.debug("VTT box2: " + ze.type), ze.type === "payl") {
                          var qe = ze.cue_text;
                          Y.debug("VTT cue_text = " + qe);
                          var _t = $e.cts / de, dt = ($e.cts + $e.duration) / de;
                          Ue.push({
                            start: _t,
                            end: dt,
                            data: qe,
                            styles: {}
                          }), Y.debug("VTT " + _t + "-" + dt + " : " + qe);
                        }
                      }
                  }
                }
                Ue.length > 0 && C.addCaptions(se, 0, Ue);
              }
              function Ze(Xe, ve, me) {
                var Ie, we, Ue = new DataView(Xe, 0, Xe.byteLength);
                we = S.Utils.dataViewToString(Ue, g.default.UTF8);
                try {
                  Ie = st(me).parse(we, 0), C.addCaptions(C.getCurrentTrackIdx(), 0, Ie), K.buffered && K.buffered.add(ve.start, ve.end);
                } catch ($e) {
                  I.error(new c.default(o.default.TIMED_TEXT_ERROR_ID_PARSE_CODE, o.default.TIMED_TEXT_ERROR_MESSAGE_PARSE + $e.message, we));
                }
              }
              function nt(Xe, ve) {
                var me, Ie;
                if (ve.segmentType === n.HTTPRequest.INIT_SEGMENT_TYPE)
                  re === 0 && (re = ne.getMediaTimescaleFromMoov(Xe));
                else if (ve.segmentType === n.HTTPRequest.MEDIA_SEGMENT_TYPE) {
                  if (re === 0) {
                    Y.warn("CEA-608: No timescale for embeddedTextTrack yet");
                    return;
                  }
                  Ie = ne.getSamplesInfo(Xe);
                  var we = Ie.lastSequenceNumber;
                  if (!te[0] && !te[1] && it(), re) {
                    if (ue !== null && we !== ue + Ie.numSequences)
                      for (me = 0; me < te.length; me++)
                        te[me] && te[me].reset();
                    for (var Ue = Ye(Xe, Ie.sampleList), $e = 0; $e < te.length; $e++) {
                      var at = Ue.fields[$e], et = te[$e];
                      if (et)
                        for (me = 0; me < at.length; me++)
                          et.addData(at[me][0] / re, at[me][1]);
                    }
                    ue = we;
                  }
                }
              }
              function it() {
                for (var Xe, ve = 0; ve < ee.length; ve++) {
                  if (Xe = C.getTrackIdxForId(ee[ve].id), Xe === -1) {
                    Y.warn("CEA-608: data before track is ready.");
                    return;
                  }
                  var me = De(Xe);
                  te[ve] = new (_()).Cea608Parser(ve + 1, {
                    newCue: me
                  }, null);
                }
              }
              function De(Xe) {
                function ve(me, Ie, we) {
                  var Ue;
                  if (N.getTTMLRenderingDiv())
                    Ue = O.createHTMLCaptionsFromScreen(N.getElement(), me, Ie, we);
                  else {
                    var $e = we.getDisplayText();
                    Ue = [{
                      start: me,
                      end: Ie,
                      data: $e,
                      styles: {}
                    }];
                  }
                  Ue && C.addCaptions(Xe, 0, Ue);
                }
                return ve;
              }
              function Ye(Xe, ve) {
                if (ve.length === 0)
                  return null;
                for (var me = {
                  splits: [],
                  fields: [[], []]
                }, Ie = new DataView(Xe), we = 0; we < ve.length; we++)
                  for (var Ue = ve[we], $e = _().findCea608Nalus(Ie, Ue.offset, Ue.size), at = null, et = 0, Mt = 0; Mt < $e.length; Mt++)
                    for (var Lt = _().extractCea608DataFromRange(Ie, $e[Mt]), bt = 0; bt < 2; bt++)
                      if (Lt[bt].length > 0) {
                        Ue.cts !== at ? et = 0 : et += 1;
                        var Ae = Ke();
                        me.fields[bt].push([Ue.cts + Ae * re, Lt[bt], et]), at = Ue.cts;
                      }
                return me.fields.forEach(function(qe) {
                  qe.sort(function(_t, dt) {
                    return _t[0] === dt[0] ? _t[2] - dt[2] : _t[0] - dt[0];
                  });
                }), me;
              }
              function Ke() {
                return isNaN(K.timestampOffset) ? 0 : K.timestampOffset;
              }
              function tt(Xe) {
                var ve = !1;
                return ee.length > 1 && Xe.isEmbedded ? ve = Xe.id && Xe.id === g.default.CC1 : ee.length === 1 ? Xe.id && typeof Xe.id == "string" && Xe.id.substring(0, 2) === "CC" && (ve = !0) : ee.length === 0 && (ve = Xe.index === fe[0].index), ve;
              }
              function st(Xe) {
                var ve;
                return Xe.search(g.default.VTT) >= 0 ? ve = H.get().streaming.text.webvtt.customRenderingEnabled && w ? w : b : (Xe.search(g.default.TTML) >= 0 || Xe.search(g.default.STPP) >= 0) && (ve = V), ve;
              }
              function Et(Xe, ve) {
                Xe === void 0 && Xe === ve && (Xe = K.buffered.start(0), ve = K.buffered.end(K.buffered.length - 1)), K.buffered.remove(Xe, ve), C.deleteCuesFromTrackIdx(se, Xe, ve);
              }
              function ht(Xe) {
                ee.forEach(function(ve) {
                  var me = C.getTrackIdxForId(ve.id);
                  me >= 0 && C.deleteCuesFromTrackIdx(me, Xe.from, Xe.to);
                });
              }
              function xt() {
                fe = [];
              }
              return K = {
                initialize: F,
                addMediaInfos: x,
                resetMediaInfos: xt,
                getStreamId: P,
                append: Ge,
                abort: $,
                addEmbeddedTrack: Ee,
                resetEmbedded: _e,
                getConfig: Te,
                setCurrentFragmentedTrackIdx: Ce,
                remove: Et,
                reset: ce
              }, p(), K;
            }
            y.__dashjs_factory_name = "TextSourceBuffer";
            const u = d.default.getClassFactory(y);
          }
        ),
        /***/
        "./src/streaming/text/TextTracks.js": (
          /*!******************************************!*\
            !*** ./src/streaming/text/TextTracks.js ***!
            \******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), i = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), r = e(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), l = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), t = e(
              /*! imsc */
              "./node_modules/imsc/src/main/js/main.js"
            );
            function T(c, o) {
              var y;
              if (typeof Symbol > "u" || c[Symbol.iterator] == null) {
                if (Array.isArray(c) || (y = S(c)) || o && c && typeof c.length == "number") {
                  y && (c = y);
                  var u = 0, A = function() {
                  };
                  return { s: A, n: function() {
                    return u >= c.length ? { done: !0 } : { done: !1, value: c[u++] };
                  }, e: function(C) {
                    throw C;
                  }, f: A };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              var I = !0, M = !1, E;
              return { s: function() {
                y = c[Symbol.iterator]();
              }, n: function() {
                var C = y.next();
                return I = C.done, C;
              }, e: function(C) {
                M = !0, E = C;
              }, f: function() {
                try {
                  !I && y.return != null && y.return();
                } finally {
                  if (M)
                    throw E;
                }
              } };
            }
            function S(c, o) {
              if (c) {
                if (typeof c == "string")
                  return h(c, o);
                var y = Object.prototype.toString.call(c).slice(8, -1);
                if (y === "Object" && c.constructor && (y = c.constructor.name), y === "Map" || y === "Set")
                  return Array.from(c);
                if (y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y))
                  return h(c, o);
              }
            }
            function h(c, o) {
              (o == null || o > c.length) && (o = c.length);
              for (var y = 0, u = new Array(o); y < o; y++)
                u[y] = c[y];
              return u;
            }
            var _ = ["text", "images", "embeddedImages", "align", "fontSize", "id", "isd", "line", "lineAlign", "lineHeight", "linePadding", "position", "positionAlign", "region", "size", "snapToLines", "vertical"];
            function L(c) {
              var o = this.context, y = (0, n.default)(o).getInstance(), u = c.videoModel, A = c.streamInfo, I = c.settings, M, E, N, C, b, w, V, J, H, z, Z, ie, K, Y, ne, ae, fe, Q;
              function oe() {
                E = (0, d.default)(o).getInstance().getLogger(M);
              }
              function de() {
                typeof window > "u" || typeof navigator > "u" || (N = window.VTTCue || window.TextTrackCue, C = [], b = [], w = -1, V = 0, J = 0, H = 0, z = 0, Z = null, ie = null, K = null, ne = !1, fe = 2147483647, ae = null, document.fullscreenElement !== void 0 ? Y = "fullscreenElement" : document.webkitIsFullScreen !== void 0 ? Y = "webkitIsFullScreen" : document.msFullscreenElement ? Y = "msFullscreenElement" : document.mozFullScreen && (Y = "mozFullScreen"));
              }
              function Me() {
                return A.id;
              }
              function ge(De) {
                var Ye = De.kind, Ke = De.id !== void 0 ? De.id : De.lang, tt = De.lang, st = De.isTTML, Et = De.isEmbedded, ht = u.addTextTrack(Ye, Ke, tt, st, Et);
                return ht;
              }
              function se(De) {
                C.push(De);
              }
              function ee() {
                C.sort(function(xt, Xe) {
                  return xt.index - Xe.index;
                }), Z = u.getTTMLRenderingDiv(), ie = u.getVttRenderingDiv();
                for (var De = -1, Ye = 0; Ye < C.length; Ye++) {
                  var Ke = ge(C[Ye]);
                  b.push(Ke), C[Ye].defaultTrack && (Ke.default = !0, De = Ye);
                  var tt = ce(Ye);
                  tt && (tt.mode = g.default.TEXT_SHOWING, Z && (C[Ye].isTTML || C[Ye].isEmbedded) ? tt.renderingType = "html" : tt.renderingType = "default"), k(Ye, 0, C[Ye].captionData), y.trigger(r.default.TEXT_TRACK_ADDED);
                }
                if (_e.call(this, De), De >= 0) {
                  var st = function xt() {
                    var Xe = ce(De);
                    Xe && Xe.renderingType === "html" && ue.call(this, Xe, !0), y.off(r.default.PLAYBACK_METADATA_LOADED, xt, this);
                  };
                  y.on(r.default.PLAYBACK_METADATA_LOADED, st, this);
                  for (var Et = 0; Et < C.length; Et++) {
                    var ht = ce(Et);
                    ht && (ht.mode = Et === De ? g.default.TEXT_SHOWING : g.default.TEXT_HIDDEN, ht.manualMode = Et === De ? g.default.TEXT_SHOWING : g.default.TEXT_HIDDEN);
                  }
                }
                y.trigger(i.default.TEXT_TRACKS_QUEUE_INITIALIZED, {
                  index: w,
                  tracks: C,
                  streamId: A.id
                });
              }
              function re(De, Ye, Ke, tt, st, Et) {
                var ht = De / Ye, xt = Ke / tt, Xe = 0, ve = 0;
                ht > xt ? (ve = Ye, Xe = ve / tt * Ke) : (Xe = De, ve = Xe / Ke * tt);
                var me = 0, Ie = 0, we = 0, Ue = 0, $e = Xe / ve;
                return $e > st ? (Ue = ve, we = ve * st) : (we = Xe, Ue = Xe / st), me = (De - we) / 2, Ie = (Ye - Ue) / 2, Et ? {
                  x: me + we * 0.1,
                  y: Ie + Ue * 0.1,
                  w: we * 0.8,
                  h: Ue * 0.8
                } : {
                  x: me,
                  y: Ie,
                  w: we,
                  h: Ue
                };
              }
              function ue(De, Ye) {
                var Ke = u.getClientWidth(), tt = u.getClientHeight(), st = u.getVideoWidth(), Et = u.getVideoHeight(), ht = u.getVideoRelativeOffsetTop(), xt = u.getVideoRelativeOffsetLeft();
                if (st !== 0 && Et !== 0) {
                  var Xe = st / Et, ve = !1;
                  De.isFromCEA608 && (Xe = 1.1666666666666667, ve = !0);
                  var me = re.call(this, Ke, tt, st, Et, Xe, ve), Ie = me.w, we = me.h, Ue = me.x, $e = me.y;
                  if (Ie != H || we != z || Ue != V || $e != J || Ye) {
                    if (V = Ue + xt, J = $e + ht, H = Ie, z = we, Z) {
                      var at = Z.style;
                      at && (at.left = V + "px", at.top = J + "px", at.width = H + "px", at.height = z + "px", at.zIndex = Y && document[Y] || ne ? fe : null, y.trigger(r.default.CAPTION_CONTAINER_RESIZE));
                    }
                    var et = De.activeCues;
                    if (et)
                      for (var Mt = et.length, Lt = 0; Lt < Mt; ++Lt) {
                        var bt = et[Lt];
                        bt.scaleCue(bt);
                      }
                  }
                }
              }
              function te(De) {
                var Ye = H, Ke = z, tt, st, Et, ht, xt;
                if (De.cellResolution) {
                  var Xe = [Ye / De.cellResolution[0], Ke / De.cellResolution[1]];
                  if (De.linePadding) {
                    for (tt in De.linePadding)
                      if (De.linePadding.hasOwnProperty(tt)) {
                        var ve = De.linePadding[tt];
                        st = (ve * Xe[0]).toString();
                        for (var me = document.getElementsByClassName("spanPadding"), Ie = 0; Ie < me.length; Ie++)
                          me[Ie].style.cssText = me[Ie].style.cssText.replace(/(padding-left\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + st), me[Ie].style.cssText = me[Ie].style.cssText.replace(/(padding-right\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + st);
                      }
                  }
                  if (De.fontSize) {
                    for (tt in De.fontSize)
                      if (De.fontSize.hasOwnProperty(tt)) {
                        De.fontSize[tt][0] === "%" ? Et = De.fontSize[tt][1] / 100 : De.fontSize[tt][0] === "c" && (Et = De.fontSize[tt][1]), st = (Et * Xe[1]).toString(), tt !== "defaultFontSize" ? xt = document.getElementsByClassName(tt) : xt = document.getElementsByClassName("paragraph");
                        for (var we = 0; we < xt.length; we++)
                          xt[we].style.cssText = xt[we].style.cssText.replace(/(font-size\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + st);
                      }
                    if (De.lineHeight) {
                      for (tt in De.lineHeight)
                        if (De.lineHeight.hasOwnProperty(tt)) {
                          De.lineHeight[tt][0] === "%" ? ht = De.lineHeight[tt][1] / 100 : De.fontSize[tt][0] === "c" && (ht = De.lineHeight[tt][1]), st = (ht * Xe[1]).toString(), xt = document.getElementsByClassName(tt);
                          for (var Ue = 0; Ue < xt.length; Ue++)
                            xt[Ue].style.cssText = xt[Ue].style.cssText.replace(/(line-height\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + st);
                        }
                    }
                  }
                }
                if (De.isd) {
                  var $e = document.getElementById(De.cueID);
                  $e && Z.removeChild($e), O(De);
                }
              }
              function O(De) {
                if (Z) {
                  var Ye = document.createElement("div");
                  Z.appendChild(Ye), ae = (0, t.renderHTML)(
                    De.isd,
                    Ye,
                    function(Ke) {
                      var tt = /^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/, st = /^#(.*)$/;
                      if (tt.test(Ke)) {
                        var Et = tt.exec(Ke), ht = parseInt(Et[4], 10) - 1, xt = btoa(De.images[ht]), Xe = "data:image/png;base64," + xt;
                        return Xe;
                      } else if (st.test(Ke)) {
                        var ve = st.exec(Ke), me = ve[1], Ie = "data:image/png;base64," + De.embeddedImages[me];
                        return Ie;
                      } else
                        return null;
                    },
                    Z.clientHeight,
                    Z.clientWidth,
                    !1,
                    function(Ke) {
                      E.info("renderCaption :", Ke);
                    },
                    ae,
                    !0
                    /*enableRollUp*/
                  ), Ye.id = De.cueID, y.trigger(r.default.CAPTION_RENDERED, {
                    captionDiv: Ye,
                    currentTrackIdx: w
                  });
                }
              }
              function p(De, Ye) {
                if (!I.get().streaming.text.extendSegmentedCues || !Ye.cues || Ye.cues.length === 0)
                  return !1;
                var Ke = Ye.cues[Ye.cues.length - 1];
                return Ke.endTime !== De.startTime || !P(Ke, De, _) ? !1 : (Ke.endTime = De.endTime, !0);
              }
              function P(De, Ye, Ke) {
                for (var tt = 0; tt < Ke.length; tt++) {
                  var st = Ke[tt];
                  if (JSON.stringify(De[st]) !== JSON.stringify(Ye[st]))
                    return !1;
                }
                return !0;
              }
              function k(De, Ye, Ke) {
                var tt = ce(De);
                if (tt && !(!Array.isArray(Ke) || Ke.length === 0))
                  for (var st = 0; st < Ke.length; st++) {
                    var Et = void 0, ht = Ke[st];
                    tt.cellResolution = ht.cellResolution, tt.isFromCEA608 = ht.isFromCEA608, !isNaN(ht.start) && !isNaN(ht.end) && (Et = ht.type === "html" && Z ? X(ht, Ye, tt) : ht.data ? F(ht, Ye, tt) : null);
                    try {
                      Et ? Te(tt, Et) || (I.get().streaming.text.webvtt.customRenderingEnabled ? (tt.manualCueList || (tt.manualCueList = []), tt.manualCueList.push(Et)) : p(Et, tt) || tt.addCue(Et)) : E.error("Impossible to display subtitles. You might have missed setting a TTML rendering div via player.attachTTMLRenderingDiv(TTMLRenderingDiv)");
                    } catch (xt) {
                      throw xe(tt), tt.addCue(Et), xt;
                    }
                  }
              }
              function X(De, Ye, Ke) {
                var tt = this, st = new N(De.start + Ye, De.end + Ye, "");
                return st.cueHTMLElement = De.cueHTMLElement, st.isd = De.isd, st.images = De.images, st.embeddedImages = De.embeddedImages, st.cueID = De.cueID, st.scaleCue = te.bind(tt), st.cellResolution = De.cellResolution, st.lineHeight = De.lineHeight, st.linePadding = De.linePadding, st.fontSize = De.fontSize, Z.style.left = V + "px", Z.style.top = J + "px", Z.style.width = H + "px", Z.style.height = z + "px", st.onenter = function() {
                  Ke.mode === g.default.TEXT_SHOWING && (this.isd ? (O(this), E.debug("Cue enter id:" + this.cueID)) : (Z.appendChild(this.cueHTMLElement), te.call(tt, this), y.trigger(r.default.CAPTION_RENDERED, {
                    captionDiv: this.cueHTMLElement,
                    currentTrackIdx: w
                  })));
                }, st.onexit = function() {
                  if (Z)
                    for (var Et = Z.childNodes, ht = 0; ht < Et.length; ++ht)
                      Et[ht].id === this.cueID && (E.debug("Cue exit id:" + Et[ht].id), Z.removeChild(Et[ht]), --ht);
                }, st;
              }
              function F(De, Ye, Ke) {
                var tt = new N(De.start - Ye, De.end - Ye, De.data);
                if (tt.cueID = "".concat(tt.startTime, "_").concat(tt.endTime), tt.isActive = !1, De.styles)
                  try {
                    De.styles.align !== void 0 && "align" in tt && (tt.align = De.styles.align), De.styles.line !== void 0 && "line" in tt && (tt.line = De.styles.line), De.styles.position !== void 0 && "position" in tt && (tt.position = De.styles.position), De.styles.size !== void 0 && "size" in tt && (tt.size = De.styles.size);
                  } catch (st) {
                    E.error(st);
                  }
                return tt.onenter = function() {
                  Ke.mode === g.default.TEXT_SHOWING && y.trigger(r.default.CAPTION_RENDERED, {
                    currentTrackIdx: w
                  });
                }, tt;
              }
              function x(De) {
                var Ye = $();
                if (Ye && Ye.length > 0) {
                  var Ke = Ye[0], tt = Ke.manualCueList;
                  tt && tt.length > 0 && tt.forEach(function(st) {
                    if (st.startTime <= De && st.endTime >= De && !st.isActive)
                      st.isActive = !0, WebVTT.processCues(window, [st], ie, st.cueID);
                    else if (st.isActive && (st.startTime > De || st.endTime < De) && (st.isActive = !1, ie))
                      for (var Et = ie.childNodes, ht = 0; ht < Et.length; ++ht)
                        Et[ht].id === st.cueID && (ie.removeChild(Et[ht]), --ht);
                  });
                }
              }
              function W() {
                var De = $();
                if (De && De.length > 0) {
                  var Ye = De[0], Ke = Ye.manualCueList;
                  Ke && Ke.length > 0 && Ke.forEach(function(tt) {
                    if (tt.isActive && (tt.isActive = !1, ie))
                      for (var st = ie.childNodes, Et = 0; Et < st.length; ++Et)
                        st[Et].id === tt.cueID && (ie.removeChild(st[Et]), --Et);
                  });
                }
              }
              function $() {
                var De = u.getTextTracks(), Ye = [], Ke = T(De), tt;
                try {
                  for (Ke.s(); !(tt = Ke.n()).done; ) {
                    var st = tt.value;
                    st.manualMode === g.default.TEXT_SHOWING && Ye.push(st);
                  }
                } catch (Et) {
                  Ke.e(Et);
                } finally {
                  Ke.f();
                }
                return Ye;
              }
              function ce(De) {
                return De >= 0 && C[De] ? u.getTextTrack(C[De].kind, C[De].id, C[De].lang, C[De].isTTML, C[De].isEmbedded) : null;
              }
              function le() {
                return w;
              }
              function q(De) {
                for (var Ye = -1, Ke = 0; Ke < C.length; Ke++)
                  if (C[Ke].id === De) {
                    Ye = Ke;
                    break;
                  }
                return Ye;
              }
              function _e(De) {
                var Ye = this;
                if (De !== w) {
                  w = De;
                  var Ke = ce(w);
                  Ee.call(this, Ke), K && (clearInterval(K), K = null), Ke && Ke.renderingType === "html" && (ue.call(this, Ke, !0), window.ResizeObserver ? (Q = new window.ResizeObserver(function() {
                    ue.call(Ye, Ke, !0);
                  }), Q.observe(u.getElement())) : K = setInterval(ue.bind(this, Ke), 500));
                }
              }
              function Ee(De) {
                Ze.call(this), De ? De.renderingType === "html" ? Le.call(this) : je.call(this) : je.call(this);
              }
              function Te(De, Ye) {
                if (!De.cues)
                  return !1;
                for (var Ke = 0; Ke < De.cues.length; Ke++)
                  if (De.cues[Ke].startTime === Ye.startTime && De.cues[Ke].endTime === Ye.endTime)
                    return !0;
                return !1;
              }
              function Ce(De, Ye, Ke) {
                var tt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
                return (isNaN(Ye) || (tt ? De.startTime : De.endTime) >= Ye) && (isNaN(Ke) || (tt ? De.endTime : De.startTime) <= Ke);
              }
              function xe(De, Ye, Ke) {
                var tt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
                if (De.cues)
                  for (var st = De.cues, Et = st.length - 1, ht = Et; ht >= 0; ht--)
                    Ce(st[ht], Ye, Ke, tt) && (st[ht].onexit && st[ht].onexit(), De.removeCue(st[ht]));
              }
              function be(De, Ye, Ke) {
                var tt = ce(De);
                tt && xe(tt, Ye, Ke);
              }
              function Ge() {
                for (var De = b ? b.length : 0, Ye = 0; Ye < De; Ye++) {
                  var Ke = ce(Ye);
                  Ke && xe.call(this, Ke, A.start, A.start + A.duration, !1);
                }
                b = [], C = [], K && (clearInterval(K), K = null), Q && u && (Q.unobserve(u.getElement()), Q = null), w = -1, Ze.call(this);
              }
              function Pe(De) {
                u.removeChild(b[De]), b.splice(De, 1);
              }
              function Le() {
                var De = document.getElementById("native-cue-style");
                if (!De) {
                  De = document.createElement("style"), De.id = "native-cue-style", document.head.appendChild(De);
                  var Ye = De.sheet, Ke = u.getElement();
                  try {
                    Ke && (Ke.id ? Ye.insertRule("#" + Ke.id + "::cue {background: transparent}", 0) : Ke.classList.length !== 0 ? Ye.insertRule("." + Ke.className + "::cue {background: transparent}", 0) : Ye.insertRule("video::cue {background: transparent}", 0));
                  } catch (tt) {
                    E.info("" + tt.message);
                  }
                }
              }
              function je() {
                var De = document.getElementById("native-cue-style");
                De && document.head.removeChild(De);
              }
              function Ze() {
                if (Z)
                  for (; Z.firstChild; )
                    Z.removeChild(Z.firstChild);
              }
              function nt(De, Ye) {
                var Ke = ce(De);
                Ke && Ke.mode !== Ye && (Ke.mode = Ye), Ke && Ke.manualMode !== Ye && (Ke.manualMode = Ye);
              }
              function it() {
                return C[w];
              }
              return M = {
                initialize: de,
                getStreamId: Me,
                addTextTrack: se,
                addCaptions: k,
                createTracks: ee,
                getCurrentTrackIdx: le,
                setCurrentTrackIdx: _e,
                getTrackIdxForId: q,
                getCurrentTrackInfo: it,
                setModeForTrackIdx: nt,
                deleteCuesFromTrackIdx: be,
                deleteAllTextTracks: Ge,
                deleteTextTrack: Pe,
                manualCueProcessing: x,
                disableManualTracks: W
              }, oe(), M;
            }
            L.__dashjs_factory_name = "TextTracks";
            const v = l.default.getClassFactory(L);
          }
        ),
        /***/
        "./src/streaming/thumbnail/ThumbnailController.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/thumbnail/ThumbnailController.js ***!
            \********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), i = e(
              /*! ../vo/Thumbnail */
              "./src/streaming/vo/Thumbnail.js"
            ), r = e(
              /*! ./ThumbnailTracks */
              "./src/streaming/thumbnail/ThumbnailTracks.js"
            ), l = e(
              /*! ../vo/BitrateInfo */
              "./src/streaming/vo/BitrateInfo.js"
            ), d = e(
              /*! ../../dash/utils/SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            );
            function t(S) {
              var h = this.context, _ = S.streamInfo, L, v;
              function c() {
                N(), v = (0, r.default)(h).create({
                  streamInfo: _,
                  adapter: S.adapter,
                  baseURLController: S.baseURLController,
                  timelineConverter: S.timelineConverter,
                  debug: S.debug,
                  eventBus: S.eventBus,
                  events: S.events,
                  dashConstants: S.dashConstants,
                  dashMetrics: S.dashMetrics,
                  segmentBaseController: S.segmentBaseController
                });
              }
              function o() {
                v.addTracks();
                var C = v.getTracks();
                C && C.length > 0 && I(0);
              }
              function y() {
                return _.id;
              }
              function u(C, b) {
                if (typeof b == "function") {
                  var w = v.getCurrentTrack(), V, J;
                  if (!w || w.segmentDuration <= 0 || C === void 0 || C === null) {
                    b(null);
                    return;
                  }
                  J = v.getThumbnailRequestForTime(C), J && (w.segmentDuration = J.duration), V = C % w.segmentDuration;
                  var H = Math.floor(V * w.tilesHor * w.tilesVert / w.segmentDuration), z = new i.default();
                  if (z.width = Math.floor(w.widthPerTile), z.height = Math.floor(w.heightPerTile), z.x = Math.floor(H % w.tilesHor) * w.widthPerTile, z.y = Math.floor(H / w.tilesHor) * w.heightPerTile, "readThumbnail" in w)
                    return w.readThumbnail(C, function(ie) {
                      z.url = ie, b(z);
                    });
                  if (J)
                    z.url = J.url, w.segmentDuration = NaN;
                  else {
                    var Z = Math.floor(C / w.segmentDuration);
                    z.url = A(w, Z);
                  }
                  b(z);
                }
              }
              function A(C, b) {
                var w = b + C.startNumber, V = (0, d.replaceTokenForTemplate)(C.templateUrl, "Number", w);
                return V = (0, d.replaceTokenForTemplate)(V, "Time", (w - 1) * C.segmentDuration * C.timescale), V = (0, d.replaceTokenForTemplate)(V, "Bandwidth", C.bandwidth), (0, d.unescapeDollarsInTemplate)(V);
              }
              function I(C) {
                v.setTrackByIndex(C);
              }
              function M() {
                return v.getCurrentTrackIndex();
              }
              function E() {
                var C = v.getTracks(), b = 0;
                return C.map(function(w) {
                  var V = new l.default();
                  return V.mediaType = n.default.IMAGE, V.qualityIndex = b++, V.bitrate = w.bitrate, V.width = w.width, V.height = w.height, V;
                });
              }
              function N() {
                v && v.reset();
              }
              return L = {
                getStreamId: y,
                initialize: o,
                provide: u,
                setTrackByIndex: I,
                getCurrentTrackIndex: M,
                getBitrateList: E,
                reset: N
              }, c(), L;
            }
            t.__dashjs_factory_name = "ThumbnailController";
            const T = g.default.getClassFactory(t);
          }
        ),
        /***/
        "./src/streaming/thumbnail/ThumbnailTracks.js": (
          /*!****************************************************!*\
            !*** ./src/streaming/thumbnail/ThumbnailTracks.js ***!
            \****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              THUMBNAILS_SCHEME_ID_URIS: () => (
                /* binding */
                _
              ),
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ../../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), i = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! ../vo/ThumbnailTrackInfo */
              "./src/streaming/vo/ThumbnailTrackInfo.js"
            ), l = e(
              /*! ../../streaming/utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), d = e(
              /*! ../../dash/utils/SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            ), t = e(
              /*! ../../streaming/utils/BoxParser */
              "./src/streaming/utils/BoxParser.js"
            ), T = e(
              /*! ../../streaming/net/XHRLoader */
              "./src/streaming/net/XHRLoader.js"
            ), S = e(
              /*! ../../dash/DashHandler */
              "./src/dash/DashHandler.js"
            ), h = e(
              /*! ../../dash/controllers/SegmentsController */
              "./src/dash/controllers/SegmentsController.js"
            ), _ = ["http://dashif.org/thumbnail_tile", "http://dashif.org/guidelines/thumbnail_tile"];
            function L(c) {
              var o = this.context, y = c.adapter, u = c.baseURLController, A = c.streamInfo, I = c.timelineConverter, M = c.debug, E = c.eventBus, N = c.events, C = c.dashConstants, b = (0, l.default)(o).getInstance(), w, V, J, H, z, Z, ie, K;
              function Y() {
                re(), ie = (0, T.default)(o).create({}), K = (0, t.default)(o).getInstance(), Z = (0, h.default)(o).create({
                  events: N,
                  eventBus: E,
                  streamInfo: A,
                  timelineConverter: I,
                  dashConstants: C,
                  dashMetrics: c.dashMetrics,
                  segmentBaseController: c.segmentBaseController,
                  type: g.default.IMAGE
                }), J = (0, S.default)(o).create({
                  streamInfo: A,
                  type: g.default.IMAGE,
                  timelineConverter: I,
                  segmentsController: Z,
                  baseURLController: u,
                  debug: M,
                  eventBus: E,
                  events: N,
                  dashConstants: C,
                  urlUtils: b
                }), J.initialize(y ? y.getIsDynamic() : !1);
              }
              function ne() {
                if (!(!A || !y) && (z = y.getMediaInfoForType(A, g.default.IMAGE), !!z)) {
                  var ue = y.getVoRepresentations(z);
                  ue && ue.length > 0 && ue.forEach(function(te) {
                    (te.segmentInfoType === n.default.SEGMENT_TEMPLATE && te.segmentDuration > 0 && te.media || te.segmentInfoType === n.default.SEGMENT_TIMELINE) && ae(te), te.segmentInfoType === n.default.SEGMENT_BASE && ae(te, !0);
                  }), V.length > 0 && V.sort(function(te, O) {
                    return te.bitrate - O.bitrate;
                  });
                }
              }
              function ae(ue, te) {
                var O = new r.default();
                O.id = ue.id, O.bitrate = ue.bandwidth, O.width = ue.width, O.height = ue.height, O.tilesHor = 1, O.tilesVert = 1, ue.essentialProperties && ue.essentialProperties.forEach(function(p) {
                  if (_.indexOf(p.schemeIdUri) >= 0 && p.value) {
                    var P = p.value.split("x");
                    P.length === 2 && !isNaN(P[0]) && !isNaN(P[1]) && (O.tilesHor = parseInt(P[0], 10), O.tilesVert = parseInt(P[1], 10));
                  }
                }), te ? Z.updateSegmentData(ue).then(function(p) {
                  fe(O, ue, p);
                }) : (O.startNumber = ue.startNumber, O.segmentDuration = ue.segmentDuration, O.timescale = ue.timescale, O.templateUrl = oe(ue)), O.tilesHor > 0 && O.tilesVert > 0 && (O.widthPerTile = O.width / O.tilesHor, O.heightPerTile = O.height / O.tilesVert, V.push(O));
              }
              function fe(ue, te, O) {
                var p = [], P = Q(O, te);
                te.segments = P, ue.segmentDuration = te.segments[0].duration, ue.readThumbnail = function(k, X) {
                  var F = null;
                  p.some(function(x) {
                    if (x.start <= k && x.end > k)
                      return F = x.url, !0;
                  }), F ? X(F) : te.segments.some(function(x) {
                    if (x.mediaStartTime <= k && x.mediaStartTime + x.duration > k) {
                      var W = u.resolve(te.path);
                      return ie.load({
                        method: "get",
                        url: W.url,
                        request: {
                          range: x.mediaRange,
                          responseType: "arraybuffer"
                        },
                        onload: function(ce) {
                          var le = K.getSamplesInfo(ce.target.response), q = new Blob([ce.target.response.slice(le.sampleList[0].offset, le.sampleList[0].offset + le.sampleList[0].size)], {
                            type: "image/jpeg"
                          }), _e = window.URL.createObjectURL(q);
                          p.push({
                            start: x.mediaStartTime,
                            end: x.mediaStartTime + x.duration,
                            url: _e
                          }), X && X(_e);
                        }
                      }), !0;
                    }
                  });
                };
              }
              function Q(ue, te) {
                var O = [], p = 0, P, k, X, F;
                for (P = 0, k = ue.segments.length; P < k; P++)
                  X = ue.segments[P], F = (0, d.getTimeBasedSegment)(I, y.getIsDynamic(), te, X.startTime, X.duration, X.timescale, X.media, X.mediaRange, p), F && (O.push(F), F = null, p++);
                return O;
              }
              function oe(ue) {
                var te = b.isRelative(ue.media) ? b.resolve(ue.media, u.resolve(ue.path).url) : ue.media;
                return te ? (0, d.replaceIDForTemplate)(te, ue.id) : "";
              }
              function de() {
                return V;
              }
              function Me() {
                return H;
              }
              function ge() {
                return H < 0 ? null : V[H];
              }
              function se(ue) {
                !V || V.length === 0 || (ue >= V.length && (ue = V.length - 1), H = ue);
              }
              function ee(ue) {
                for (var te, O = y.getVoRepresentations(z), p = 0; p < O.length; p++)
                  if (V[H].id === O[p].id) {
                    te = O[p];
                    break;
                  }
                return J.getSegmentRequestForTime(z, te, ue);
              }
              function re() {
                V = [], H = -1, z = null;
              }
              return w = {
                getTracks: de,
                addTracks: ne,
                reset: re,
                setTrackByIndex: se,
                getCurrentTrack: ge,
                getCurrentTrackIndex: Me,
                getThumbnailRequestForTime: ee
              }, Y(), w;
            }
            L.__dashjs_factory_name = "ThumbnailTracks";
            const v = i.default.getClassFactory(L);
          }
        ),
        /***/
        "./src/streaming/utils/BaseURLSelector.js": (
          /*!************************************************!*\
            !*** ./src/streaming/utils/BaseURLSelector.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), n = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), i = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), r = e(
              /*! ../controllers/BlacklistController */
              "./src/streaming/controllers/BlacklistController.js"
            ), l = e(
              /*! ./baseUrlResolution/DVBSelector */
              "./src/streaming/utils/baseUrlResolution/DVBSelector.js"
            ), d = e(
              /*! ./baseUrlResolution/BasicSelector */
              "./src/streaming/utils/baseUrlResolution/BasicSelector.js"
            ), t = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), T = e(
              /*! ../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), S = e(
              /*! ../utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            ), h = e(
              /*! ./baseUrlResolution/ContentSteeringSelector */
              "./src/streaming/utils/baseUrlResolution/ContentSteeringSelector.js"
            ), _ = e(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            );
            function L() {
              var c = this.context, o = (0, n.default)(c).getInstance(), y = (0, _.default)(c).getInstance(), u, A, I, M, E, N;
              function C() {
                A = (0, r.default)(c).create({
                  updateEventName: i.default.SERVICE_LOCATION_BLACKLIST_CHANGED,
                  addBlacklistEventName: i.default.SERVICE_LOCATION_BLACKLIST_ADD
                }), I = (0, d.default)(c).create({
                  blacklistController: A
                }), M = (0, l.default)(c).create({
                  blacklistController: A
                }), E = (0, h.default)(c).create(), E.setConfig({
                  blacklistController: A
                }), N = I;
              }
              function b(H) {
                H.selector && (N = H.selector), H.contentSteeringSelector && (E = H.contentSteeringSelector);
              }
              function w(H) {
                (0, S.checkParameterType)(H, "boolean"), N = H ? M : I;
              }
              function V(H) {
                if (H) {
                  if (y.get().streaming.applyContentSteering) {
                    var z = E.selectBaseUrlIndex(H);
                    !isNaN(z) && z !== -1 && (H.selectedIdx = z);
                  }
                  if (!isNaN(H.selectedIdx))
                    return H.baseUrls[H.selectedIdx];
                  var Z = N.select(H.baseUrls);
                  if (!Z) {
                    o.trigger(i.default.URL_RESOLUTION_FAILED, {
                      error: new T.default(g.default.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE, g.default.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE)
                    }), N === I && J();
                    return;
                  }
                  return H.selectedIdx = H.baseUrls.indexOf(Z), Z;
                }
              }
              function J() {
                A.reset();
              }
              return u = {
                chooseSelector: w,
                select: V,
                reset: J,
                setConfig: b
              }, C(), u;
            }
            L.__dashjs_factory_name = "BaseURLSelector";
            const v = t.default.getClassFactory(L);
          }
        ),
        /***/
        "./src/streaming/utils/BoxParser.js": (
          /*!******************************************!*\
            !*** ./src/streaming/utils/BoxParser.js ***!
            \******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => t
              /* harmony export */
            });
            var g = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), n = e(
              /*! ./IsoFile */
              "./src/streaming/utils/IsoFile.js"
            ), i = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), r = e(
              /*! codem-isoboxer */
              "./node_modules/codem-isoboxer/dist/iso_boxer.js"
            ), l = e(
              /*! ../vo/IsoBoxSearchInfo */
              "./src/streaming/vo/IsoBoxSearchInfo.js"
            );
            function d() {
              var T, S, h = this.context;
              function _() {
                T = (0, g.default)(h).getInstance().getLogger(S);
              }
              function L(M) {
                if (!M)
                  return null;
                M.fileStart === void 0 && (M.fileStart = 0);
                var E = r.parseBuffer(M), N = (0, n.default)(h).create();
                return N.setData(E), N;
              }
              function v(M, E, N) {
                if (N === void 0 && (N = 0), !E || N + 8 >= E.byteLength)
                  return new l.default(0, !1);
                for (var C = E instanceof ArrayBuffer ? new Uint8Array(E) : E, b, w = 0; N < C.byteLength; ) {
                  var V = y(C, N), J = u(C, N + 4);
                  if (V === 0)
                    break;
                  N + V <= C.byteLength && (M.indexOf(J) >= 0 ? b = new l.default(N, !0, V) : w = N + V), N += V;
                }
                return b || new l.default(w, !1);
              }
              function c(M) {
                if (!M || M.byteLength === 0)
                  return {
                    sampleList: [],
                    lastSequenceNumber: NaN,
                    totalDuration: NaN,
                    numSequences: NaN
                  };
                var E = L(M), N = E.getBoxes("moof"), C = E.getBoxes("mfhd"), b, w, V, J, H, z, Z, ie, K, Y, ne, ae, fe, Q, oe, de, Me;
                de = E.getBoxes("moof").length, oe = C[C.length - 1].sequence_number, V = 0, z = [];
                var ge = -1, se = -1;
                for (ne = 0; ne < N.length; ne++) {
                  var ee = N[ne], re = ee.getChildBoxes("traf");
                  for (K = 0; K < re.length; K++) {
                    var ue = re[K], te = ue.getChildBox("tfhd"), O = ue.getChildBox("tfdt");
                    H = O.baseMediaDecodeTime;
                    var p = ue.getChildBoxes("trun"), P = ue.getChildBoxes("subs");
                    for (Y = 0; Y < p.length; Y++) {
                      var k = p[Y];
                      for (V = k.sample_count, Q = (te.base_data_offset || 0) + (k.data_offset || 0), ie = 0; ie < V; ie++) {
                        Z = k.samples[ie], b = Z.sample_duration !== void 0 ? Z.sample_duration : te.default_sample_duration, J = Z.sample_size !== void 0 ? Z.sample_size : te.default_sample_size, w = Z.sample_composition_time_offset !== void 0 ? Z.sample_composition_time_offset : 0;
                        var X = {
                          dts: H,
                          cts: H + w,
                          duration: b,
                          offset: ee.offset + Q,
                          size: J,
                          subSizes: [J]
                        };
                        if (P)
                          for (ae = 0; ae < P.length; ae++) {
                            var F = P[ae];
                            if (ge < F.entry_count - 1 && ie > se && (ge++, se += F.entries[ge].sample_delta), ie == se) {
                              X.subSizes = [];
                              var x = F.entries[ge];
                              for (fe = 0; fe < x.subsample_count; fe++)
                                X.subSizes.push(x.subsamples[fe].subsample_size);
                            }
                          }
                        z.push(X), Q += J, H += b;
                      }
                    }
                    Me = H - O.baseMediaDecodeTime;
                  }
                }
                return {
                  sampleList: z,
                  lastSequenceNumber: oe,
                  totalDuration: Me,
                  numSequences: de
                };
              }
              function o(M) {
                var E = L(M), N = E ? E.getBox("mdhd") : void 0;
                return N ? N.timescale : NaN;
              }
              function y(M, E) {
                return M[E + 3] >>> 0 | M[E + 2] << 8 >>> 0 | M[E + 1] << 16 >>> 0 | M[E] << 24 >>> 0;
              }
              function u(M, E) {
                return String.fromCharCode(M[E++]) + String.fromCharCode(M[E++]) + String.fromCharCode(M[E++]) + String.fromCharCode(M[E]);
              }
              function A(M) {
                var E = null, N, C, b = L(M);
                if (!b)
                  return E;
                var w = b.getBox("ftyp"), V = b.getBox("moov");
                return T.debug("Searching for initialization."), V && V.isComplete && (N = w ? w.offset : V.offset, C = V.offset + V.size - 1, E = N + "-" + C, T.debug("Found the initialization.  Range: " + E)), E;
              }
              function I(M, E, N) {
                if (N === void 0 && (N = 0), !E || N + 8 >= E.byteLength)
                  return new l.default(0, !1);
                for (var C = E instanceof ArrayBuffer ? new Uint8Array(E) : E, b, w = 0; N < C.byteLength; ) {
                  var V = y(C, N), J = u(C, N + 4);
                  if (V === 0)
                    break;
                  N + V <= C.byteLength && (M.indexOf(J) >= 0 ? b = new l.default(N, !0, V, J) : w = N + V), N += V;
                }
                return b || new l.default(w, !1);
              }
              return S = {
                parse: L,
                findLastTopIsoBoxCompleted: v,
                getMediaTimescaleFromMoov: o,
                getSamplesInfo: c,
                findInitRange: A,
                parsePayload: I
              }, _(), S;
            }
            d.__dashjs_factory_name = "BoxParser";
            const t = i.default.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/streaming/utils/Capabilities.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/utils/Capabilities.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => t,
              /* harmony export */
              supportsMediaSource: () => (
                /* binding */
                l
              )
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../thumbnail/ThumbnailTracks */
              "./src/streaming/thumbnail/ThumbnailTracks.js"
            ), i = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), r = [{
              codec: "avc1",
              compatibleCodecs: ["avc3"]
            }, {
              codec: "avc3",
              compatibleCodecs: ["avc1"]
            }];
            function l() {
              var T = "WebKitMediaSource" in window, S = "MediaSource" in window;
              return T || S;
            }
            function d() {
              var T, S, h;
              function _() {
                h = !1;
              }
              function L(E) {
                E && E.settings && (S = E.settings);
              }
              function v() {
                return h;
              }
              function c(E) {
                h = E;
              }
              function o(E, N) {
                return N !== i.default.AUDIO && N !== i.default.VIDEO ? Promise.resolve(!0) : y(E, N) ? A(E, N) : u(E);
              }
              function y(E, N) {
                return S.get().streaming.capabilities.useMediaCapabilitiesApi && navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo && (E.codec && N === i.default.AUDIO || N === i.default.VIDEO && E.codec && E.width && E.height && E.bitrate && E.framerate);
              }
              function u(E) {
                return new Promise(function(N) {
                  if (!E || !E.codec) {
                    N(!1);
                    return;
                  }
                  var C = E.codec;
                  if (E.width && E.height && (C += ';width="' + E.width + '";height="' + E.height + '"'), "MediaSource" in window && MediaSource.isTypeSupported(C)) {
                    N(!0);
                    return;
                  } else if ("WebKitMediaSource" in window && WebKitMediaSource.isTypeSupported(C)) {
                    N(!0);
                    return;
                  }
                  N(!1);
                });
              }
              function A(E, N) {
                return new Promise(function(C) {
                  if (!E || !E.codec) {
                    C(!1);
                    return;
                  }
                  var b = {
                    type: "media-source"
                  };
                  b[N] = {}, b[N].contentType = E.codec, b[N].width = E.width, b[N].height = E.height, b[N].bitrate = parseInt(E.bitrate), b[N].framerate = parseFloat(E.framerate), navigator.mediaCapabilities.decodingInfo(b).then(function(w) {
                    C(w.supported);
                  }).catch(function() {
                    C(!1);
                  });
                });
              }
              function I(E) {
                try {
                  return n.THUMBNAILS_SCHEME_ID_URIS.indexOf(E.schemeIdUri) !== -1;
                } catch {
                  return !0;
                }
              }
              function M(E, N) {
                for (var C = E.split(".")[0], b = N.indexOf(C) === 0, w, V = 0; V < r.length; V++)
                  if (r[V].codec === C) {
                    w = r[V];
                    break;
                  }
                return w ? b || w.compatibleCodecs.some(function(J) {
                  return N.indexOf(J) === 0;
                }) : b;
              }
              return T = {
                setConfig: L,
                supportsMediaSource: l,
                supportsEncryptedMedia: v,
                supportsCodec: o,
                setEncryptedMediaSupported: c,
                supportsEssentialProperty: I,
                codecRootCompatibleWithCodec: M
              }, _(), T;
            }
            d.__dashjs_factory_name = "Capabilities";
            const t = g.default.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/streaming/utils/CapabilitiesFilter.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/utils/CapabilitiesFilter.js ***!
            \***************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => t
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), i = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), r = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), l = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            );
            function d() {
              var T = this.context, S = (0, r.default)(T).getInstance(), h, _, L, v, c, o;
              function y() {
                o = (0, n.default)(T).getInstance().getLogger(h);
              }
              function u(J) {
                J && (J.adapter && (_ = J.adapter), J.capabilities && (L = J.capabilities), J.settings && (v = J.settings), J.customParametersModel && (c = J.customParametersModel));
              }
              function A(J) {
                return new Promise(function(H) {
                  var z = [];
                  z.push(I(i.default.VIDEO, J)), z.push(I(i.default.AUDIO, J)), Promise.all(z).then(function() {
                    v.get().streaming.capabilities.filterUnsupportedEssentialProperties && w(J), V(J), H();
                  }).catch(function() {
                    H();
                  });
                });
              }
              function I(J, H) {
                if (!H || !H.Period_asArray || H.Period_asArray.length === 0)
                  return Promise.resolve();
                var z = [];
                return H.Period_asArray.forEach(function(Z) {
                  z.push(M(Z, J));
                }), Promise.all(z);
              }
              function M(J, H) {
                return new Promise(function(z) {
                  if (!J || !J.AdaptationSet_asArray || J.AdaptationSet_asArray.length === 0) {
                    z();
                    return;
                  }
                  var Z = [];
                  J.AdaptationSet_asArray.forEach(function(ie) {
                    _.getIsTypeOf(ie, H) && Z.push(E(ie, H));
                  }), Promise.all(Z).then(function() {
                    J.AdaptationSet_asArray = J.AdaptationSet_asArray.filter(function(ie) {
                      var K = ie.Representation_asArray && ie.Representation_asArray.length > 0;
                      return K || (S.trigger(l.default.ADAPTATION_SET_REMOVED_NO_CAPABILITIES, {
                        adaptationSet: ie
                      }), o.warn("AdaptationSet has been removed because of no supported Representation")), K;
                    }), z();
                  }).catch(function() {
                    z();
                  });
                });
              }
              function E(J, H) {
                return new Promise(function(z) {
                  if (!J.Representation_asArray || J.Representation_asArray.length === 0) {
                    z();
                    return;
                  }
                  var Z = [], ie = [];
                  J.Representation_asArray.forEach(function(K, Y) {
                    var ne = _.getCodec(J, Y, !1), ae = N(H, K, ne);
                    ie.push(ae), Z.push(L.supportsCodec(ae, H));
                  }), Promise.all(Z).then(function(K) {
                    J.Representation_asArray = J.Representation_asArray.filter(function(Y, ne) {
                      return K[ne] || o.debug("[Stream] Codec ".concat(ie[ne].codec, " not supported ")), K[ne];
                    }), z();
                  }).catch(function() {
                    z();
                  });
                });
              }
              function N(J, H, z) {
                switch (J) {
                  case i.default.VIDEO:
                    return C(H, z);
                  case i.default.AUDIO:
                    return b(H, z);
                  default:
                    return null;
                }
              }
              function C(J, H) {
                var z = J.width || null, Z = J.height || null, ie = J.frameRate || null, K = J.bandwidth || null;
                return {
                  codec: H,
                  width: z,
                  height: Z,
                  framerate: ie,
                  bitrate: K
                };
              }
              function b(J, H) {
                var z = J.audioSamplingRate || null, Z = J.bandwidth || null;
                return {
                  codec: H,
                  bitrate: Z,
                  samplerate: z
                };
              }
              function w(J) {
                !J || !J.Period_asArray || J.Period_asArray.length === 0 || J.Period_asArray.forEach(function(H) {
                  H.AdaptationSet_asArray = H.AdaptationSet_asArray.filter(function(z) {
                    return !z.Representation_asArray || z.Representation_asArray.length === 0 ? !0 : (z.Representation_asArray = z.Representation_asArray.filter(function(Z) {
                      var ie = _.getEssentialPropertiesForRepresentation(Z);
                      if (ie && ie.length > 0)
                        for (var K = 0; K < ie.length; ) {
                          if (!L.supportsEssentialProperty(ie[K]))
                            return o.debug("[Stream] EssentialProperty not supported: " + ie[K].schemeIdUri), !1;
                          K += 1;
                        }
                      return !0;
                    }), z.Representation_asArray && z.Representation_asArray.length > 0);
                  });
                });
              }
              function V(J) {
                var H = c.getCustomCapabilitiesFilters();
                !H || H.length === 0 || !J || !J.Period_asArray || J.Period_asArray.length === 0 || J.Period_asArray.forEach(function(z) {
                  z.AdaptationSet_asArray = z.AdaptationSet_asArray.filter(function(Z) {
                    return !Z.Representation_asArray || Z.Representation_asArray.length === 0 ? !0 : (Z.Representation_asArray = Z.Representation_asArray.filter(function(ie) {
                      return !H.some(function(K) {
                        return !K(ie);
                      });
                    }), Z.Representation_asArray && Z.Representation_asArray.length > 0);
                  });
                });
              }
              return h = {
                setConfig: u,
                filterUnsupportedFeatures: A
              }, y(), h;
            }
            d.__dashjs_factory_name = "CapabilitiesFilter";
            const t = g.default.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/streaming/utils/CustomTimeRanges.js": (
          /*!*************************************************!*\
            !*** ./src/streaming/utils/CustomTimeRanges.js ***!
            \*************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            );
            function i() {
              var l = [], d = 0;
              function t(v, c) {
                var o = 0;
                for (o = 0; o < this.customTimeRangeArray.length && v > this.customTimeRangeArray[o].start; o++)
                  ;
                for (this.customTimeRangeArray.splice(o, 0, {
                  start: v,
                  end: c
                }), o = 0; o < this.customTimeRangeArray.length - 1; o++)
                  this.mergeRanges(o, o + 1) && o--;
                this.length = this.customTimeRangeArray.length;
              }
              function T() {
                this.customTimeRangeArray = [], this.length = 0;
              }
              function S(v, c) {
                for (var o = 0; o < this.customTimeRangeArray.length; o++)
                  if (v <= this.customTimeRangeArray[o].start && c >= this.customTimeRangeArray[o].end)
                    this.customTimeRangeArray.splice(o, 1), o--;
                  else if (v > this.customTimeRangeArray[o].start && c < this.customTimeRangeArray[o].end) {
                    this.customTimeRangeArray.splice(o + 1, 0, {
                      start: c,
                      end: this.customTimeRangeArray[o].end
                    }), this.customTimeRangeArray[o].end = v;
                    break;
                  } else
                    v > this.customTimeRangeArray[o].start && v < this.customTimeRangeArray[o].end ? this.customTimeRangeArray[o].end = v : c > this.customTimeRangeArray[o].start && c < this.customTimeRangeArray[o].end && (this.customTimeRangeArray[o].start = c);
                this.length = this.customTimeRangeArray.length;
              }
              function h(v, c) {
                var o = this.customTimeRangeArray[v], y = this.customTimeRangeArray[c];
                return o.start <= y.start && y.start <= o.end && o.end <= y.end ? (o.end = y.end, this.customTimeRangeArray.splice(c, 1), !0) : y.start <= o.start && o.start <= y.end && y.end <= o.end ? (o.start = y.start, this.customTimeRangeArray.splice(c, 1), !0) : y.start <= o.start && o.start <= y.end && o.end <= y.end ? (this.customTimeRangeArray.splice(v, 1), !0) : o.start <= y.start && y.start <= o.end && y.end <= o.end ? (this.customTimeRangeArray.splice(c, 1), !0) : !1;
              }
              function _(v) {
                return (0, n.checkInteger)(v), v >= this.customTimeRangeArray.length || v < 0 ? NaN : this.customTimeRangeArray[v].start;
              }
              function L(v) {
                return (0, n.checkInteger)(v), v >= this.customTimeRangeArray.length || v < 0 ? NaN : this.customTimeRangeArray[v].end;
              }
              return {
                customTimeRangeArray: l,
                length: d,
                add: t,
                clear: T,
                remove: S,
                mergeRanges: h,
                start: _,
                end: L
              };
            }
            i.__dashjs_factory_name = "CustomTimeRanges";
            const r = g.default.getClassFactory(i);
          }
        ),
        /***/
        "./src/streaming/utils/DOMStorage.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/utils/DOMStorage.js ***!
            \*******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), i = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), r = [{
              oldKey: "dashjs_vbitrate",
              newKey: "dashjs_video_bitrate"
            }, {
              oldKey: "dashjs_abitrate",
              newKey: "dashjs_audio_bitrate"
            }, {
              oldKey: "dashjs_vsettings",
              newKey: "dashjs_video_settings"
            }, {
              oldKey: "dashjs_asettings",
              newKey: "dashjs_audio_settings"
            }], l = "dashjs_?_bitrate", d = "dashjs_?_settings", t = "localStorage", T = "sessionStorage", S = "lastBitrate", h = "lastMediaSettings";
            function _(c) {
              c = c || {};
              var o = this.context, y = c.settings, u, A, I;
              function M() {
                A = (0, n.default)(o).getInstance().getLogger(u), N();
              }
              function E(Z) {
                if (I !== void 0)
                  return I;
                I = !1;
                var ie = "1", K = "1", Y;
                try {
                  typeof window < "u" && (Y = window[Z]);
                } catch (ne) {
                  return A.warn("DOMStorage access denied: " + ne.message), I;
                }
                if (!Y || Z !== t && Z !== T)
                  return I;
                try {
                  Y.setItem(ie, K), Y.removeItem(ie), I = !0;
                } catch (ne) {
                  A.warn("DOMStorage is supported, but cannot be used: " + ne.message);
                }
                return I;
              }
              function N() {
                E(t) && r.forEach(function(Z) {
                  var ie = localStorage.getItem(Z.oldKey);
                  if (ie) {
                    localStorage.removeItem(Z.oldKey);
                    try {
                      localStorage.setItem(Z.newKey, ie);
                    } catch (K) {
                      A.error(K.message);
                    }
                  }
                });
              }
              function C() {
                var Z = 6e5;
                return Math.round((/* @__PURE__ */ new Date()).getTime() / Z) * Z;
              }
              function b(Z, ie) {
                return E(Z) && y.get().streaming[ie + "CachingInfo"].enabled;
              }
              function w() {
                if (!y)
                  throw new Error(i.default.MISSING_CONFIG_ERROR);
              }
              function V(Z) {
                if (w(), !y.get().streaming.lastMediaSettingsCachingInfo.enabled)
                  return null;
                var ie = null;
                if (b(t, h)) {
                  var K = d.replace(/\?/, Z);
                  try {
                    var Y = JSON.parse(localStorage.getItem(K)) || {}, ne = (/* @__PURE__ */ new Date()).getTime() - parseInt(Y.timestamp, 10) >= y.get().streaming.lastMediaSettingsCachingInfo.ttl || !1;
                    ie = Y.settings, ne && (localStorage.removeItem(K), ie = null);
                  } catch {
                    return null;
                  }
                }
                return ie;
              }
              function J(Z) {
                if (w(), !y.get().streaming.lastBitrateCachingInfo.enabled)
                  return NaN;
                var ie = NaN;
                if (b(t, S)) {
                  var K = l.replace(/\?/, Z);
                  try {
                    var Y = JSON.parse(localStorage.getItem(K)) || {}, ne = (/* @__PURE__ */ new Date()).getTime() - parseInt(Y.timestamp, 10) >= y.get().streaming.lastBitrateCachingInfo.ttl || !1, ae = parseFloat(Y.bitrate);
                    !isNaN(ae) && !ne ? (ie = ae, A.debug("Last saved bitrate for " + Z + " was " + ae)) : ne && localStorage.removeItem(K);
                  } catch {
                    return null;
                  }
                }
                return ie;
              }
              function H(Z, ie) {
                if (b(t, h)) {
                  var K = d.replace(/\?/, Z);
                  try {
                    localStorage.setItem(K, JSON.stringify({
                      settings: ie,
                      timestamp: C()
                    }));
                  } catch (Y) {
                    A.error(Y.message);
                  }
                }
              }
              function z(Z, ie) {
                if (b(t, S) && ie) {
                  var K = l.replace(/\?/, Z);
                  try {
                    localStorage.setItem(K, JSON.stringify({
                      bitrate: ie.toFixed(3),
                      timestamp: C()
                    }));
                  } catch (Y) {
                    A.error(Y.message);
                  }
                }
              }
              return u = {
                getSavedBitrateSettings: J,
                setSavedBitrateSettings: z,
                getSavedMediaSettings: V,
                setSavedMediaSettings: H
              }, M(), u;
            }
            _.__dashjs_factory_name = "DOMStorage";
            var L = g.default.getSingletonFactory(_);
            const v = L;
          }
        ),
        /***/
        "./src/streaming/utils/DefaultURLUtils.js": (
          /*!************************************************!*\
            !*** ./src/streaming/utils/DefaultURLUtils.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n() {
              var r, l = /^[a-z][a-z0-9+\-_.]*:/i, d = /^https?:\/\//i, t = /^https:\/\//i, T = /^([a-z][a-z0-9+\-_.]*:\/\/[^\/]+)\/?/i, S = function(b, w) {
                try {
                  return new window.URL(b, w).toString();
                } catch {
                  return b;
                }
              }, h = function(b, w) {
                var V = L;
                if (!w || !y(b))
                  return b;
                u(b) && (V = v), A(b) && (V = o);
                var J = V(w), H = J.charAt(J.length - 1) !== "/" && b.charAt(0) !== "/" ? "/" : "";
                return [J, b].join(H);
              };
              function _() {
                try {
                  var C = new window.URL("x", "http://y");
                  r = S;
                } catch {
                } finally {
                  r = r || h;
                }
              }
              function L(C) {
                var b = C.indexOf("/"), w = C.lastIndexOf("/");
                return b !== -1 ? w === b + 1 ? C : (C.indexOf("?") !== -1 && (C = C.substring(0, C.indexOf("?"))), C.substring(0, w + 1)) : "";
              }
              function v(C) {
                var b = C.match(T);
                return b ? b[1] : "";
              }
              function c(C) {
                var b = /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(C);
                return b[2].substring(1);
              }
              function o(C) {
                var b = C.match(l);
                return b ? b[0] : "";
              }
              function y(C) {
                return !l.test(C);
              }
              function u(C) {
                return y(C) && C.charAt(0) === "/";
              }
              function A(C) {
                return C.indexOf("//") === 0;
              }
              function I(C) {
                return d.test(C);
              }
              function M(C) {
                return t.test(C);
              }
              function E(C, b) {
                return r(C, b);
              }
              _();
              var N = {
                parseBaseUrl: L,
                parseOrigin: v,
                parseScheme: o,
                isRelative: y,
                isPathAbsolute: u,
                isSchemeRelative: A,
                isHTTPURL: I,
                isHTTPS: M,
                removeHostname: c,
                resolve: E
              };
              return N;
            }
            n.__dashjs_factory_name = "DefaultURLUtils";
            const i = g.default.getSingletonFactory(n);
          }
        ),
        /***/
        "./src/streaming/utils/EBMLParser.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/utils/EBMLParser.js ***!
            \*******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n(r) {
              r = r || {};
              var l, d = new DataView(r.data), t = 0;
              function T() {
                return t;
              }
              function S(A) {
                t = A;
              }
              function h(A, I) {
                var M = !0, E = 0, N, C;
                if (I === void 0 && (I = !1), A.tag > 16777215 ? (d.getUint32(t) !== A.tag && (M = !1), E = 4) : A.tag > 65535 ? (N = d.getUint16(t), C = d.getUint8(t + 2), N * 256 + C !== A.tag && (M = !1), E = 3) : A.tag > 255 ? (d.getUint16(t) !== A.tag && (M = !1), E = 2) : (d.getUint8(t) !== A.tag && (M = !1), E = 1), !M && A.required && !I)
                  throw new Error("required tag not found");
                return M && (t += E), M;
              }
              function _(A, I) {
                var M = h(A, I);
                return M && c(), M;
              }
              function L(A) {
                var I;
                return h(A), I = c(), l[A.parse](I);
              }
              function v(A, I) {
                var M = h(A, I), E;
                return M && (E = c(), t += E), M;
              }
              function c(A) {
                var I = 1, M = 128, E = 8, N = -1, C = 0, b = d.getUint8(t), w = 0;
                for (w = 0; w < E; w += 1) {
                  if ((b & M) === M) {
                    C = A === void 0 ? b & ~M : b, N = w;
                    break;
                  }
                  M >>= 1;
                }
                for (w = 0; w < N; w += 1, I += 1)
                  C = C << 8 | 255 & d.getUint8(t + I);
                return t += I, C;
              }
              function o(A) {
                var I;
                switch (A) {
                  case 4:
                    I = d.getFloat32(t), t += 4;
                    break;
                  case 8:
                    I = d.getFloat64(t), t += 8;
                    break;
                }
                return I;
              }
              function y(A) {
                for (var I = 0, M = 0; M < A; M += 1)
                  I <<= 8, I |= d.getUint8(t + M) & 255;
                return t += A, I;
              }
              function u() {
                return t < d.byteLength;
              }
              return l = {
                getPos: T,
                setPos: S,
                consumeTag: h,
                consumeTagAndSize: _,
                parseTag: L,
                skipOverElement: v,
                getMatroskaCodedNum: c,
                getMatroskaFloat: o,
                getMatroskaUint: y,
                moreData: u
              }, l;
            }
            n.__dashjs_factory_name = "EBMLParser";
            const i = g.default.getClassFactory(n);
          }
        ),
        /***/
        "./src/streaming/utils/ErrorHandler.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/utils/ErrorHandler.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), n = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), i = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function r() {
              var d, t = this.context, T = (0, g.default)(t).getInstance();
              function S(h) {
                T.trigger(n.default.ERROR, {
                  error: h
                });
              }
              return d = {
                error: S
              }, d;
            }
            r.__dashjs_factory_name = "ErrorHandler";
            const l = i.default.getSingletonFactory(r);
          }
        ),
        /***/
        "./src/streaming/utils/InitCache.js": (
          /*!******************************************!*\
            !*** ./src/streaming/utils/InitCache.js ***!
            \******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n() {
              var r = {};
              function l(S) {
                var h = S.streamId, _ = S.representationId;
                r[h] = r[h] || {}, r[h][_] = S;
              }
              function d(S, h) {
                return r && r[S] && r[S][h] ? r[S][h] : null;
              }
              function t() {
                r = {};
              }
              var T = {
                save: l,
                extract: d,
                reset: t
              };
              return T;
            }
            n.__dashjs_factory_name = "InitCache";
            const i = g.default.getSingletonFactory(n);
          }
        ),
        /***/
        "./src/streaming/utils/IsoFile.js": (
          /*!****************************************!*\
            !*** ./src/streaming/utils/IsoFile.js ***!
            \****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../vo/IsoBox */
              "./src/streaming/vo/IsoBox.js"
            ), n = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function i() {
              var l, d;
              function t(L) {
                return !L || !d || !d.boxes || d.boxes.length === 0 || typeof d.fetch != "function" ? null : _(d.fetch(L));
              }
              function T(L) {
                var v = [];
                if (!L || !d || typeof d.fetchAll != "function")
                  return v;
                for (var c = d.fetchAll(L), o, y = 0, u = c.length; y < u; y++)
                  o = _(c[y]), o && v.push(o);
                return v;
              }
              function S(L) {
                d = L;
              }
              function h() {
                if (!d || !d.boxes || !d.boxes.length)
                  return null;
                var L = d.boxes[d.boxes.length - 1].type, v = T(L);
                return v.length > 0 ? v[v.length - 1] : null;
              }
              function _(L) {
                if (!L)
                  return null;
                var v = new g.default(L);
                return L.hasOwnProperty("_incomplete") && (v.isComplete = !L._incomplete), v;
              }
              return l = {
                getBox: t,
                getBoxes: T,
                setData: S,
                getLastBox: h
              }, l;
            }
            i.__dashjs_factory_name = "IsoFile";
            const r = n.default.getClassFactory(i);
          }
        ),
        /***/
        "./src/streaming/utils/ObjectUtils.js": (
          /*!********************************************!*\
            !*** ./src/streaming/utils/ObjectUtils.js ***!
            \********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! fast-deep-equal */
              "./node_modules/fast-deep-equal/index.js"
            ), i = /* @__PURE__ */ e.n(n);
            function r() {
              var d;
              function t(T, S) {
                return i()(T, S);
              }
              return d = {
                areEqual: t
              }, d;
            }
            r.__dashjs_factory_name = "ObjectUtils";
            const l = g.default.getSingletonFactory(r);
          }
        ),
        /***/
        "./src/streaming/utils/RequestModifier.js": (
          /*!************************************************!*\
            !*** ./src/streaming/utils/RequestModifier.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r,
              /* harmony export */
              modifyRequest: () => (
                /* binding */
                n
              )
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n(l, d) {
              var t = {
                url: l.url,
                method: l.method,
                headers: Object.assign({}, l.headers),
                credentials: l.withCredentials ? "include" : void 0
              };
              return Promise.resolve(d.modifyRequest(t)).then(function() {
                return Object.assign(l, t, {
                  withCredentials: t.credentials === "include"
                });
              });
            }
            function i() {
              var l;
              function d(T) {
                return T;
              }
              function t(T, S) {
                return S.url, T;
              }
              return l = {
                modifyRequest: null,
                modifyRequestURL: d,
                modifyRequestHeader: t
              }, l;
            }
            i.__dashjs_factory_name = "RequestModifier";
            const r = g.default.getSingletonFactory(i);
          }
        ),
        /***/
        "./src/streaming/utils/SegmentResponseModifier.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/utils/SegmentResponseModifier.js ***!
            \********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n() {
              var r;
              function l(d) {
                return Promise.resolve(d);
              }
              return r = {
                modifyResponseAsync: l
              }, r;
            }
            n.__dashjs_factory_name = "SegmentResponseModifier";
            const i = g.default.getSingletonFactory(n);
          }
        ),
        /***/
        "./src/streaming/utils/SupervisorTools.js": (
          /*!************************************************!*\
            !*** ./src/streaming/utils/SupervisorTools.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              checkInteger: () => (
                /* binding */
                r
              ),
              /* harmony export */
              checkIsVideoOrAudioType: () => (
                /* binding */
                d
              ),
              /* harmony export */
              checkParameterType: () => (
                /* binding */
                i
              ),
              /* harmony export */
              checkRange: () => (
                /* binding */
                l
              )
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            );
            function n(t) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(S) {
                return typeof S;
              } : n = function(S) {
                return S && typeof Symbol == "function" && S.constructor === Symbol && S !== Symbol.prototype ? "symbol" : typeof S;
              }, n(t);
            }
            function i(t, T) {
              if (n(t) !== T)
                throw g.default.BAD_ARGUMENT_ERROR;
            }
            function r(t) {
              var T = t !== null && !isNaN(t) && t % 1 === 0;
              if (!T)
                throw g.default.BAD_ARGUMENT_ERROR + " : argument is not an integer";
            }
            function l(t, T, S) {
              if (t < T || t > S)
                throw g.default.BAD_ARGUMENT_ERROR + " : argument out of range";
            }
            function d(t) {
              if (typeof t != "string" || t !== g.default.AUDIO && t !== g.default.VIDEO)
                throw g.default.BAD_ARGUMENT_ERROR;
            }
          }
        ),
        /***/
        "./src/streaming/utils/TTMLParser.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/utils/TTMLParser.js ***!
            \*******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), i = e(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), r = e(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), l = e(
              /*! imsc */
              "./node_modules/imsc/src/main/js/main.js"
            ), d = e(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), t = e(
              /*! ../constants/ConformanceViolationConstants */
              "./src/streaming/constants/ConformanceViolationConstants.js"
            );
            function T() {
              var h = this.context, _ = (0, i.default)(h).getInstance(), L, v, c = 0;
              function o() {
                v = (0, n.default)(h).getInstance().getLogger(L);
              }
              function y() {
                var A = "cue_TTML_" + c;
                return c++, A;
              }
              function u(A, I, M, E, N) {
                var C = "", b = [], w, V, J, H = {}, z = {}, Z = "", ie = "", K = {
                  onOpenTag: function(Q, oe, de) {
                    if (de[" imagetype"] && !de[" imageType"] && (_.trigger(d.default.CONFORMANCE_VIOLATION, {
                      level: t.default.LEVELS.ERROR,
                      event: t.default.EVENTS.NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE
                    }), de[" imageType"] = de[" imagetype"]), oe === "image" && (Q === "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt" || Q === "http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt")) {
                      if (!de[" imageType"] || de[" imageType"].value !== "PNG") {
                        v.warn("smpte-tt imageType != PNG. Discarded");
                        return;
                      }
                      Z = de["http://www.w3.org/XML/1998/namespace id"].value;
                    }
                  },
                  onCloseTag: function() {
                    Z && (z[Z] = ie.trim()), ie = "", Z = "";
                  },
                  onText: function(Q) {
                    Z && (ie = ie + Q);
                  }
                };
                if (!A)
                  throw C = "no ttml data to parse", new Error(C);
                H.data = A, _.trigger(r.default.TTML_TO_PARSE, H);
                var Y = (0, l.fromXML)(H.data, function(fe) {
                  C = fe;
                }, K);
                _.trigger(r.default.TTML_PARSED, {
                  ttmlString: H.data,
                  ttmlDoc: Y
                });
                var ne = Y.getMediaTimeEvents();
                for (J = 0; J < ne.length; J++) {
                  var ae = (0, l.generateISD)(Y, ne[J], function(fe) {
                    C = fe;
                  });
                  ae.contents.some(function(fe) {
                    return fe.contents.length;
                  }) && (w = ne[J] + I < M ? M : ne[J] + I, V = ne[J + 1] + I > E ? E : ne[J + 1] + I, w < V && b.push({
                    start: w,
                    end: V,
                    type: "html",
                    cueID: y(),
                    isd: ae,
                    images: N,
                    embeddedImages: z
                  }));
                }
                if (C !== "")
                  throw v.error(C), new Error(C);
                return b;
              }
              return L = {
                parse: u
              }, o(), L;
            }
            T.__dashjs_factory_name = "TTMLParser";
            const S = g.default.getSingletonFactory(T);
          }
        ),
        /***/
        "./src/streaming/utils/URLUtils.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/utils/URLUtils.js ***!
            \*****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ./DefaultURLUtils */
              "./src/streaming/utils/DefaultURLUtils.js"
            );
            function i() {
              var d, t, T = [], S = this.context;
              function h(b) {
                var w;
                for (w = 0; w < T.length; w++) {
                  var V = T[w].regex;
                  if (V.test(b))
                    return T[w].utils;
                }
                return t;
              }
              function _() {
                t = (0, n.default)(S).getInstance();
              }
              function L(b, w) {
                T.push({
                  regex: b,
                  utils: w
                });
              }
              function v(b, w, V) {
                var J = h(V || w);
                return J && typeof J[b] == "function" ? J[b](w, V) : t[b](w, V);
              }
              function c(b) {
                return v("parseBaseUrl", b);
              }
              function o(b) {
                return v("parseOrigin", b);
              }
              function y(b) {
                return v("removeHostname", b);
              }
              function u(b) {
                return v("parseScheme", b);
              }
              function A(b) {
                return v("isRelative", b);
              }
              function I(b) {
                return v("isPathAbsolute", b);
              }
              function M(b) {
                return v("isSchemeRelative", b);
              }
              function E(b) {
                return v("isHTTPURL", b);
              }
              function N(b) {
                return v("isHTTPS", b);
              }
              function C(b, w) {
                return v("resolve", b, w);
              }
              return _(), d = {
                registerUrlRegex: L,
                parseBaseUrl: c,
                parseOrigin: o,
                parseScheme: u,
                isRelative: A,
                isPathAbsolute: I,
                isSchemeRelative: M,
                isHTTPURL: E,
                isHTTPS: N,
                removeHostname: y,
                resolve: C
              }, d;
            }
            i.__dashjs_factory_name = "URLUtils";
            var r = g.default.getSingletonFactory(i);
            const l = r;
          }
        ),
        /***/
        "./src/streaming/utils/VTTParser.js": (
          /*!******************************************!*\
            !*** ./src/streaming/utils/VTTParser.js ***!
            \******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), i = "WEBVTT";
            function r() {
              var d = this.context, t, T, S, h, _, L;
              function v() {
                T = (0, n.default)(d).getInstance().getLogger(t), S = /(?:\r\n|\r|\n)/gm, h = /-->/, _ = /(^[\s]+|[\s]+$)/g, L = /\s\b/g;
              }
              function c(I) {
                var M = [], E, N;
                if (!I)
                  return M;
                I = I.split(S), E = I.length, N = -1;
                for (var C = 0; C < E; C++) {
                  var b = I[C];
                  if (b.length > 0 && b !== i && b.match(h)) {
                    var w = y(b), V = w.cuePoints, J = w.styles, H = A(I, C + 1), z = o(V[0].replace(_, "")), Z = o(V[1].replace(_, ""));
                    !isNaN(z) && !isNaN(Z) && z >= N && Z > z ? H !== "" ? (N = z, M.push({
                      start: z,
                      end: Z,
                      data: H,
                      styles: J
                    })) : T.error("Skipping cue due to empty/malformed cue text") : T.error("Skipping cue due to incorrect cue timing");
                  }
                }
                return M;
              }
              function o(I) {
                var M = I.split(":"), E = M.length - 1;
                return I = parseInt(M[E - 1], 10) * 60 + parseFloat(M[E]), E === 2 && (I += parseInt(M[0], 10) * 3600), I;
              }
              function y(I) {
                var M = I.split(h), E = M[1].split(L);
                return E.shift(), M[1] = E[0], E.shift(), {
                  cuePoints: M,
                  styles: u(E)
                };
              }
              function u(I) {
                var M = {};
                return I.forEach(function(E) {
                  if (E.split(/:/).length > 1) {
                    var N = E.split(/:/)[1];
                    N && N.search(/%/) != -1 && (N = parseInt(N.replace(/%/, ""), 10)), (E.match(/align/) || E.match(/A/)) && (M.align = N), (E.match(/line/) || E.match(/L/)) && (M.line = N), (E.match(/position/) || E.match(/P/)) && (M.position = N), (E.match(/size/) || E.match(/S/)) && (M.size = N);
                  }
                }), M;
              }
              function A(I, M) {
                for (var E = M, N = "", C = "", b; I[E] !== "" && E < I.length; )
                  E++;
                if (b = E - M, b > 1)
                  for (var w = 0; w < b; w++)
                    if (C = I[M + w], !C.match(h))
                      N += C, w !== b - 1 && (N += `
`);
                    else {
                      N = "";
                      break;
                    }
                else
                  C = I[M], C.match(h) || (N = C);
                return N;
              }
              return t = {
                parse: c
              }, v(), t;
            }
            r.__dashjs_factory_name = "VTTParser";
            const l = g.default.getSingletonFactory(r);
          }
        ),
        /***/
        "./src/streaming/utils/VttCustomRenderingParser.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/utils/VttCustomRenderingParser.js ***!
            \*********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n() {
              var r, l;
              function d() {
                try {
                  window && window.WebVTT && window.WebVTT.Parser && (l = new window.WebVTT.Parser(window, window.vttjs, window.WebVTT.StringDecoder()));
                } catch {
                }
              }
              function t(T) {
                var S = [];
                return l.oncue = function(h) {
                  h.start = h.startTime, h.end = h.endTime, h.data = h.text, h.styles = {
                    align: h.align,
                    line: h.line,
                    position: h.position,
                    size: h.size
                  }, S.push(h);
                }, l.parse(T), S;
              }
              return r = {
                parse: t
              }, d(), r;
            }
            n.__dashjs_factory_name = "VttCustomRenderingParser";
            const i = g.default.getSingletonFactory(n);
          }
        ),
        /***/
        "./src/streaming/utils/baseUrlResolution/BasicSelector.js": (
          /*!****************************************************************!*\
            !*** ./src/streaming/utils/baseUrlResolution/BasicSelector.js ***!
            \****************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n(r) {
              r = r || {};
              var l, d = r.blacklistController;
              function t(T) {
                var S = 0, h;
                return T && T.some(function(_, L) {
                  return S = L, !d.contains(_.serviceLocation);
                }) && (h = T[S]), h;
              }
              return l = {
                select: t
              }, l;
            }
            n.__dashjs_factory_name = "BasicSelector";
            const i = g.default.getClassFactory(n);
          }
        ),
        /***/
        "./src/streaming/utils/baseUrlResolution/ContentSteeringSelector.js": (
          /*!**************************************************************************!*\
            !*** ./src/streaming/utils/baseUrlResolution/ContentSteeringSelector.js ***!
            \**************************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), n = e(
              /*! ../../../dash/controllers/ContentSteeringController */
              "./src/dash/controllers/ContentSteeringController.js"
            );
            function i() {
              var l = this.context, d, t, T;
              function S() {
                t = (0, n.default)(l).getInstance();
              }
              function h(v) {
                v.blacklistController && (T = v.blacklistController), v.contentSteeringController && (t = v.contentSteeringController);
              }
              function _(v) {
                var c = NaN;
                if (isNaN(v.selectedIdx)) {
                  var o = t.getSteeringDataFromManifest();
                  o && o.defaultServiceLocation && (c = L([o.defaultServiceLocation], v.baseUrls));
                }
                var y = t.getCurrentSteeringResponseData();
                return v.baseUrls && v.baseUrls.length && y && y.serviceLocationPriority && y.serviceLocationPriority.length && (c = L(y.serviceLocationPriority, v.baseUrls)), c;
              }
              function L() {
                for (var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], o = 0, y = NaN, u = function() {
                  var M = v[o], E = c.findIndex(function(N) {
                    return N.serviceLocation && N.serviceLocation === M;
                  });
                  if (E !== -1 && !T.contains(c[E].serviceLocation))
                    return y = E, "break";
                  o += 1;
                }; o < v.length; ) {
                  var A = u();
                  if (A === "break")
                    break;
                }
                return y;
              }
              return d = {
                selectBaseUrlIndex: _,
                setConfig: h
              }, S(), d;
            }
            i.__dashjs_factory_name = "ContentSteeringSelector";
            const r = g.default.getClassFactory(i);
          }
        ),
        /***/
        "./src/streaming/utils/baseUrlResolution/DVBSelector.js": (
          /*!**************************************************************!*\
            !*** ./src/streaming/utils/baseUrlResolution/DVBSelector.js ***!
            \**************************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            var g = e(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function n(r) {
              r = r || {};
              var l, d = r.blacklistController;
              function t(h) {
                var _ = [], L = function(o) {
                  return !(_.length && o.dvb_priority && _.indexOf(o.dvb_priority) !== -1);
                }, v = function(o) {
                  return d.contains(o.serviceLocation) ? (o.dvb_priority && _.push(o.dvb_priority), !1) : !0;
                };
                return h.filter(v).filter(L);
              }
              function T(h) {
                var _ = function(I, M) {
                  var E = I.dvb_priority - M.dvb_priority;
                  return isNaN(E) ? 0 : E;
                }, L = function(I, M, E) {
                  return !M || E[0].dvb_priority && I.dvb_priority && E[0].dvb_priority === I.dvb_priority;
                }, v = 0, c = [], o = 0, y, u;
                if (u = h.sort(_).filter(L), u.length)
                  return u.length > 1 && (u.forEach(function(A) {
                    v += A.dvb_weight, c.push(v);
                  }), y = Math.floor(Math.random() * (v - 1)), c.every(function(A, I) {
                    return o = I, !(y < A);
                  })), u[o];
              }
              function S(h) {
                return h && T(t(h));
              }
              return l = {
                select: S
              }, l;
            }
            n.__dashjs_factory_name = "DVBSelector";
            const i = g.default.getClassFactory(n);
          }
        ),
        /***/
        "./src/streaming/vo/BitrateInfo.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/vo/BitrateInfo.js ***!
            \*****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.mediaType = null, this.bitrate = null, this.width = null, this.height = null, this.scanType = null, this.qualityIndex = NaN;
            };
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/DashJSError.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/vo/DashJSError.js ***!
            \*****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r(l, d, t) {
              g(this, r), this.code = l || null, this.message = d || null, this.data = t || null;
            };
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/DataChunk.js": (
          /*!***************************************!*\
            !*** ./src/streaming/vo/DataChunk.js ***!
            \***************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              //Represents a data structure that keep all the necessary info about a single init/media segment
              function r() {
                g(this, r), this.streamId = null, this.mediaInfo = null, this.segmentType = null, this.quality = NaN, this.index = NaN, this.bytes = null, this.start = NaN, this.end = NaN, this.duration = NaN, this.representationId = null, this.endFragment = null;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/FragmentRequest.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/vo/FragmentRequest.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var g = e(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            );
            function n(t, T) {
              if (!(t instanceof T))
                throw new TypeError("Cannot call a class as a function");
            }
            function i(t, T) {
              for (var S = 0; S < T.length; S++) {
                var h = T[S];
                h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(t, h.key, h);
              }
            }
            function r(t, T, S) {
              return T && i(t.prototype, T), S && i(t, S), t;
            }
            var l = /* @__PURE__ */ function() {
              function t(T) {
                n(this, t), this.action = t.ACTION_DOWNLOAD, this.startTime = NaN, this.mediaStartTime = NaN, this.mediaType = null, this.mediaInfo = null, this.type = null, this.duration = NaN, this.timescale = NaN, this.range = null, this.url = T || null, this.serviceLocation = null, this.requestStartDate = null, this.firstByteDate = null, this.requestEndDate = null, this.quality = NaN, this.index = NaN, this.availabilityStartTime = null, this.availabilityEndTime = null, this.wallStartTime = null, this.bytesLoaded = NaN, this.bytesTotal = NaN, this.delayLoadingTime = NaN, this.responseType = "arraybuffer", this.representationId = null;
              }
              return r(t, [{
                key: "isInitializationRequest",
                value: function() {
                  return this.type && this.type === g.HTTPRequest.INIT_SEGMENT_TYPE;
                }
              }, {
                key: "setInfo",
                value: function(S) {
                  this.type = S && S.init ? g.HTTPRequest.INIT_SEGMENT_TYPE : g.HTTPRequest.MEDIA_SEGMENT_TYPE, this.url = S && S.url ? S.url : null, this.range = S && S.range ? S.range.start + "-" + S.range.end : null, this.mediaType = S && S.mediaType ? S.mediaType : null;
                }
              }]), t;
            }();
            l.ACTION_DOWNLOAD = "download", l.ACTION_COMPLETE = "complete";
            const d = l;
          }
        ),
        /***/
        "./src/streaming/vo/HeadRequest.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/vo/HeadRequest.js ***!
            \*****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var g = e(
              /*! ./FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            );
            function n(v) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(o) {
                return typeof o;
              } : n = function(o) {
                return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
              }, n(v);
            }
            function i(v, c) {
              if (!(v instanceof c))
                throw new TypeError("Cannot call a class as a function");
            }
            function r(v, c) {
              if (typeof c != "function" && c !== null)
                throw new TypeError("Super expression must either be null or a function");
              v.prototype = Object.create(c && c.prototype, { constructor: { value: v, writable: !0, configurable: !0 } }), c && l(v, c);
            }
            function l(v, c) {
              return l = Object.setPrototypeOf || function(y, u) {
                return y.__proto__ = u, y;
              }, l(v, c);
            }
            function d(v) {
              var c = S();
              return function() {
                var y = h(v), u;
                if (c) {
                  var A = h(this).constructor;
                  u = Reflect.construct(y, arguments, A);
                } else
                  u = y.apply(this, arguments);
                return t(this, u);
              };
            }
            function t(v, c) {
              return c && (n(c) === "object" || typeof c == "function") ? c : T(v);
            }
            function T(v) {
              if (v === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return v;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function h(v) {
              return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
              }, h(v);
            }
            var _ = /* @__PURE__ */ function(v) {
              r(o, v);
              var c = d(o);
              function o(y) {
                var u;
                return i(this, o), u = c.call(this, y), u.checkForExistenceOnly = !0, u;
              }
              return o;
            }(g.default);
            const L = _;
          }
        ),
        /***/
        "./src/streaming/vo/IsoBox.js": (
          /*!************************************!*\
            !*** ./src/streaming/vo/IsoBox.js ***!
            \************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => l
              /* harmony export */
            });
            function g(d, t) {
              if (!(d instanceof t))
                throw new TypeError("Cannot call a class as a function");
            }
            function n(d, t) {
              for (var T = 0; T < t.length; T++) {
                var S = t[T];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(d, S.key, S);
              }
            }
            function i(d, t, T) {
              return t && n(d.prototype, t), T && n(d, T), d;
            }
            var r = /* @__PURE__ */ function() {
              function d(t) {
                if (g(this, d), this.offset = t._offset, this.type = t.type, this.size = t.size, this.boxes = [], t.boxes)
                  for (var T = 0; T < t.boxes.length; T++)
                    this.boxes.push(new d(t.boxes[T]));
                switch (this.isComplete = !0, t.type) {
                  case "sidx":
                    if (this.timescale = t.timescale, this.earliest_presentation_time = t.earliest_presentation_time, this.first_offset = t.first_offset, this.references = t.references, t.references) {
                      this.references = [];
                      for (var S = 0; S < t.references.length; S++) {
                        var h = {
                          reference_type: t.references[S].reference_type,
                          referenced_size: t.references[S].referenced_size,
                          subsegment_duration: t.references[S].subsegment_duration
                        };
                        this.references.push(h);
                      }
                    }
                    break;
                  case "emsg":
                    this.id = t.id, this.version = t.version === 1 ? 1 : 0, this.value = t.value, this.timescale = t.timescale, this.scheme_id_uri = t.scheme_id_uri, this.presentation_time_delta = t.version === 1 ? t.presentation_time : t.presentation_time_delta, this.event_duration = t.event_duration, this.message_data = t.message_data;
                    break;
                  case "mdhd":
                    this.timescale = t.timescale;
                    break;
                  case "mfhd":
                    this.sequence_number = t.sequence_number;
                    break;
                  case "subs":
                    this.entry_count = t.entry_count, this.entries = t.entries;
                    break;
                  case "tfhd":
                    this.base_data_offset = t.base_data_offset, this.sample_description_index = t.sample_description_index, this.default_sample_duration = t.default_sample_duration, this.default_sample_size = t.default_sample_size, this.default_sample_flags = t.default_sample_flags, this.flags = t.flags;
                    break;
                  case "tfdt":
                    this.version = t.version, this.baseMediaDecodeTime = t.baseMediaDecodeTime, this.flags = t.flags;
                    break;
                  case "trun":
                    if (this.sample_count = t.sample_count, this.first_sample_flags = t.first_sample_flags, this.data_offset = t.data_offset, this.flags = t.flags, this.samples = t.samples, t.samples) {
                      this.samples = [];
                      for (var _ = 0, L = t.samples.length; _ < L; _++) {
                        var v = {
                          sample_size: t.samples[_].sample_size,
                          sample_duration: t.samples[_].sample_duration,
                          sample_composition_time_offset: t.samples[_].sample_composition_time_offset
                        };
                        this.samples.push(v);
                      }
                    }
                    break;
                }
              }
              return i(d, [{
                key: "getChildBox",
                value: function(T) {
                  for (var S = 0; S < this.boxes.length; S++)
                    if (this.boxes[S].type === T)
                      return this.boxes[S];
                }
              }, {
                key: "getChildBoxes",
                value: function(T) {
                  for (var S = [], h = 0; h < this.boxes.length; h++)
                    this.boxes[h].type === T && S.push(this.boxes[h]);
                  return S;
                }
              }]), d;
            }();
            const l = r;
          }
        ),
        /***/
        "./src/streaming/vo/IsoBoxSearchInfo.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/vo/IsoBoxSearchInfo.js ***!
            \**********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r(l, d, t) {
              g(this, r), this.lastCompletedOffset = l, this.found = d, this.size = t;
            };
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/MetricsList.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/vo/MetricsList.js ***!
            \*****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.TcpList = [], this.HttpList = [], this.RepSwitchList = [], this.BufferLevel = [], this.BufferState = [], this.PlayList = [], this.DroppedFrames = [], this.SchedulingInfo = [], this.DVRInfo = [], this.ManifestUpdate = [], this.RequestsQueue = null, this.DVBErrors = [];
            };
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/TextRequest.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/vo/TextRequest.js ***!
            \*****************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var g = e(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), n = e(
              /*! ./FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            );
            function i(c) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(y) {
                return typeof y;
              } : i = function(y) {
                return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
              }, i(c);
            }
            function r(c, o) {
              if (!(c instanceof o))
                throw new TypeError("Cannot call a class as a function");
            }
            function l(c, o) {
              if (typeof o != "function" && o !== null)
                throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(o && o.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), o && d(c, o);
            }
            function d(c, o) {
              return d = Object.setPrototypeOf || function(u, A) {
                return u.__proto__ = A, u;
              }, d(c, o);
            }
            function t(c) {
              var o = h();
              return function() {
                var u = _(c), A;
                if (o) {
                  var I = _(this).constructor;
                  A = Reflect.construct(u, arguments, I);
                } else
                  A = u.apply(this, arguments);
                return T(this, A);
              };
            }
            function T(c, o) {
              return o && (i(o) === "object" || typeof o == "function") ? o : S(c);
            }
            function S(c) {
              if (c === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return c;
            }
            function h() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function _(c) {
              return _ = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, _(c);
            }
            var L = /* @__PURE__ */ function(c) {
              l(y, c);
              var o = t(y);
              function y(u, A) {
                var I;
                return r(this, y), I = o.call(this), I.url = u || null, I.type = A || null, I.mediaType = g.default.STREAM, I.responseType = "", I;
              }
              return y;
            }(n.default);
            const v = L;
          }
        ),
        /***/
        "./src/streaming/vo/TextTrackInfo.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/vo/TextTrackInfo.js ***!
            \*******************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var g = e(
              /*! ./../../dash/vo/MediaInfo */
              "./src/dash/vo/MediaInfo.js"
            );
            function n(v) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(o) {
                return typeof o;
              } : n = function(o) {
                return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
              }, n(v);
            }
            function i(v, c) {
              if (!(v instanceof c))
                throw new TypeError("Cannot call a class as a function");
            }
            function r(v, c) {
              if (typeof c != "function" && c !== null)
                throw new TypeError("Super expression must either be null or a function");
              v.prototype = Object.create(c && c.prototype, { constructor: { value: v, writable: !0, configurable: !0 } }), c && l(v, c);
            }
            function l(v, c) {
              return l = Object.setPrototypeOf || function(y, u) {
                return y.__proto__ = u, y;
              }, l(v, c);
            }
            function d(v) {
              var c = S();
              return function() {
                var y = h(v), u;
                if (c) {
                  var A = h(this).constructor;
                  u = Reflect.construct(y, arguments, A);
                } else
                  u = y.apply(this, arguments);
                return t(this, u);
              };
            }
            function t(v, c) {
              return c && (n(c) === "object" || typeof c == "function") ? c : T(v);
            }
            function T(v) {
              if (v === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return v;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function h(v) {
              return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
              }, h(v);
            }
            var _ = /* @__PURE__ */ function(v) {
              r(o, v);
              var c = d(o);
              function o() {
                var y;
                return i(this, o), y = c.call(this), y.captionData = null, y.label = null, y.defaultTrack = !1, y.kind = null, y.isFragmented = !1, y.isEmbedded = !1, y.isTTML = null, y;
              }
              return o;
            }(g.default);
            const L = _;
          }
        ),
        /***/
        "./src/streaming/vo/Thumbnail.js": (
          /*!***************************************!*\
            !*** ./src/streaming/vo/Thumbnail.js ***!
            \***************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.url = null, this.width = null, this.height = null, this.x = null, this.y = null;
            };
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/ThumbnailTrackInfo.js": (
          /*!************************************************!*\
            !*** ./src/streaming/vo/ThumbnailTrackInfo.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.bitrate = 0, this.width = 0, this.height = 0, this.tilesHor = 0, this.tilesVert = 0, this.widthPerTile = 0, this.heightPerTile = 0, this.startNumber = 0, this.segmentDuration = 0, this.timescale = 0, this.templateUrl = "", this.id = "";
            };
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/URIFragmentData.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/vo/URIFragmentData.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = function r() {
              g(this, r), this.t = null, this.xywh = null, this.track = null, this.id = null, this.s = null, this.r = null;
            };
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/BufferLevel.js": (
          /*!*************************************************!*\
            !*** ./src/streaming/vo/metrics/BufferLevel.js ***!
            \*************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @description This Object holds reference to the current buffer level and the time it was recorded.
               */
              function r() {
                g(this, r), this.t = null, this.level = null;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/BufferState.js": (
          /*!*************************************************!*\
            !*** ./src/streaming/vo/metrics/BufferState.js ***!
            \*************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => r
              /* harmony export */
            });
            var g = e(
              /*! ../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            );
            function n(l, d) {
              if (!(l instanceof d))
                throw new TypeError("Cannot call a class as a function");
            }
            var i = (
              /**
               * @description This Object holds reference to the current buffer state of the video element.
               */
              function l() {
                n(this, l), this.target = null, this.state = g.default.BUFFER_EMPTY;
              }
            );
            const r = i;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/DVRInfo.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/vo/metrics/DVRInfo.js ***!
            \*********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @description This Object holds reference to DVR availability window information.
               */
              function r() {
                g(this, r), this.time = null, this.range = null, this.manifestInfo = null;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/DroppedFrames.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/vo/metrics/DroppedFrames.js ***!
            \***************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @description This Object holds reference to DroppedFrames count and the time it was recorded.
               */
              function r() {
                g(this, r), this.time = null, this.droppedFrames = null;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/HTTPRequest.js": (
          /*!*************************************************!*\
            !*** ./src/streaming/vo/metrics/HTTPRequest.js ***!
            \*************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              HTTPRequest: () => (
                /* binding */
                n
              ),
              /* harmony export */
              HTTPRequestTrace: () => (
                /* binding */
                i
              )
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @class
               */
              function r() {
                g(this, r), this.tcpid = null, this.type = null, this.url = null, this.actualurl = null, this.range = null, this.trequest = null, this.tresponse = null, this.responsecode = null, this.interval = null, this.trace = [], this.cmsd = null, this._stream = null, this._tfinish = null, this._mediaduration = null, this._quality = null, this._responseHeaders = null, this._serviceLocation = null, this._fileLoaderType = null;
              }
            ), i = (
              /**
               * @class
               */
              function r() {
                g(this, r), this.s = null, this.d = null, this.b = [];
              }
            );
            n.GET = "GET", n.HEAD = "HEAD", n.MPD_TYPE = "MPD", n.XLINK_EXPANSION_TYPE = "XLinkExpansion", n.INIT_SEGMENT_TYPE = "InitializationSegment", n.INDEX_SEGMENT_TYPE = "IndexSegment", n.MEDIA_SEGMENT_TYPE = "MediaSegment", n.BITSTREAM_SWITCHING_SEGMENT_TYPE = "BitstreamSwitchingSegment", n.MSS_FRAGMENT_INFO_SEGMENT_TYPE = "FragmentInfoSegment", n.DVB_REPORTING_TYPE = "DVBReporting", n.LICENSE = "license", n.CONTENT_STEERING_TYPE = "ContentSteering", n.OTHER_TYPE = "other";
          }
        ),
        /***/
        "./src/streaming/vo/metrics/ManifestUpdate.js": (
          /*!****************************************************!*\
            !*** ./src/streaming/vo/metrics/ManifestUpdate.js ***!
            \****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              ManifestUpdate: () => (
                /* binding */
                n
              ),
              /* harmony export */
              ManifestUpdateRepresentationInfo: () => (
                /* binding */
                r
              ),
              /* harmony export */
              ManifestUpdateStreamInfo: () => (
                /* binding */
                i
              )
              /* harmony export */
            });
            function g(l, d) {
              if (!(l instanceof d))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @class
               */
              function l() {
                g(this, l), this.mediaType = null, this.type = null, this.requestTime = null, this.fetchTime = null, this.availabilityStartTime = null, this.presentationStartTime = 0, this.clientTimeOffset = 0, this.currentTime = null, this.buffered = null, this.latency = 0, this.streamInfo = [], this.representationInfo = [];
              }
            ), i = (
              /**
               * @class
               */
              function l() {
                g(this, l), this.id = null, this.index = null, this.start = null, this.duration = null;
              }
            ), r = (
              /**
               * @class
               */
              function l() {
                g(this, l), this.id = null, this.index = null, this.mediaType = null, this.streamIndex = null, this.presentationTimeOffset = null, this.startNumber = null, this.fragmentInfoType = null;
              }
            );
          }
        ),
        /***/
        "./src/streaming/vo/metrics/PlayList.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/vo/metrics/PlayList.js ***!
            \**********************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              PlayList: () => (
                /* binding */
                n
              ),
              /* harmony export */
              PlayListTrace: () => (
                /* binding */
                i
              )
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @class
               */
              function r() {
                g(this, r), this.start = null, this.mstart = null, this.starttype = null, this.trace = [];
              }
            );
            n.INITIAL_PLAYOUT_START_REASON = "initial_playout", n.SEEK_START_REASON = "seek", n.RESUME_FROM_PAUSE_START_REASON = "resume", n.METRICS_COLLECTION_START_REASON = "metrics_collection_start";
            var i = (
              /**
               * @class
               */
              function r() {
                g(this, r), this.representationid = null, this.subreplevel = null, this.start = null, this.mstart = null, this.duration = null, this.playbackspeed = null, this.stopreason = null;
              }
            );
            i.REPRESENTATION_SWITCH_STOP_REASON = "representation_switch", i.REBUFFERING_REASON = "rebuffering", i.USER_REQUEST_STOP_REASON = "user_request", i.END_OF_PERIOD_STOP_REASON = "end_of_period", i.END_OF_CONTENT_STOP_REASON = "end_of_content", i.METRICS_COLLECTION_STOP_REASON = "metrics_collection_end", i.FAILURE_STOP_REASON = "failure";
          }
        ),
        /***/
        "./src/streaming/vo/metrics/RepresentationSwitch.js": (
          /*!**********************************************************!*\
            !*** ./src/streaming/vo/metrics/RepresentationSwitch.js ***!
            \**********************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @description This Object holds reference to the info at quality switch between two representations.
               */
              function r() {
                g(this, r), this.t = null, this.mt = null, this.to = null, this.lto = null;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/RequestsQueue.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/vo/metrics/RequestsQueue.js ***!
            \***************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @description This Object holds reference to Fragment Model's request queues
               */
              function r() {
                g(this, r), this.loadingRequests = [], this.executedRequests = [];
              }
            );
            const i = n;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/SchedulingInfo.js": (
          /*!****************************************************!*\
            !*** ./src/streaming/vo/metrics/SchedulingInfo.js ***!
            \****************************************************/
          /***/
          (R, m, e) => {
            e.r(m), e.d(m, {
              /* harmony export */
              default: () => i
              /* harmony export */
            });
            function g(r, l) {
              if (!(r instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            var n = (
              /**
               * @description This Object holds reference to the index handling of the current fragment being loaded or executed.
               */
              function r() {
                g(this, r), this.mediaType = null, this.t = null, this.type = null, this.startTime = null, this.availabilityStartTime = null, this.duration = null, this.quality = null, this.range = null, this.state = null;
              }
            );
            const i = n;
          }
        ),
        /***/
        "./node_modules/bcp-47-match/index.js": (
          /*!********************************************!*\
            !*** ./node_modules/bcp-47-match/index.js ***!
            \********************************************/
          /***/
          (R, m) => {
            m.basicFilter = i(e, !0), m.extendedFilter = i(g, !0), m.lookup = i(n);
            function e(l, d) {
              return d === "*" || l === d || l.indexOf(d + "-") > -1;
            }
            function g(l, d) {
              var t = l.split("-"), T = d.split("-"), S = 0, h = 0;
              if (T[h] !== "*" && t[S] !== T[h])
                return !1;
              for (S++, h++; h < T.length; ) {
                if (T[h] === "*") {
                  h++;
                  continue;
                }
                if (!t[S])
                  return !1;
                if (t[S] === T[h]) {
                  S++, h++;
                  continue;
                }
                if (t[S].length === 1)
                  return !1;
                S++;
              }
              return !0;
            }
            function n(l, d) {
              for (var t = d, T; ; ) {
                if (t === "*" || l === t)
                  return !0;
                if (T = t.lastIndexOf("-"), T < 0)
                  return !1;
                t.charAt(T - 2) === "-" && (T -= 2), t = t.slice(0, T);
              }
            }
            function i(l, d) {
              return t;
              function t(T, S) {
                for (var h = r(T, "tag"), _ = r(S ?? "*", "range"), L = [], v = -1, c, o, y; ++v < _.length; )
                  if (c = _[v].toLowerCase(), !(!d && c === "*")) {
                    for (o = -1, y = []; ++o < h.length; )
                      if (l(h[o].toLowerCase(), c)) {
                        if (!d)
                          return h[o];
                        L.push(h[o]);
                      } else
                        y.push(h[o]);
                    h = y;
                  }
                return d ? L : void 0;
              }
            }
            function r(l, d) {
              var t = l && typeof l == "string" ? [l] : l;
              if (!t || typeof t != "object" || !("length" in t))
                throw new Error(
                  "Invalid " + d + " `" + t + "`, expected non-empty string"
                );
              return t;
            }
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/index.js": (
          /*!************************************************!*\
            !*** ./node_modules/bcp-47-normalize/index.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            R.exports = e(
              /*! ./lib */
              "./node_modules/bcp-47-normalize/lib/index.js"
            );
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/lib/index.js": (
          /*!****************************************************!*\
            !*** ./node_modules/bcp-47-normalize/lib/index.js ***!
            \****************************************************/
          /***/
          (R, m, e) => {
            var g = e(
              /*! bcp-47 */
              "./node_modules/bcp-47/index.js"
            ), n = e(
              /*! bcp-47-match */
              "./node_modules/bcp-47-match/index.js"
            ), i = e(
              /*! ./matches.json */
              "./node_modules/bcp-47-normalize/lib/matches.json"
            ), r = e(
              /*! ./fields.json */
              "./node_modules/bcp-47-normalize/lib/fields.json"
            ), l = e(
              /*! ./defaults.json */
              "./node_modules/bcp-47-normalize/lib/defaults.json"
            ), d = e(
              /*! ./many.json */
              "./node_modules/bcp-47-normalize/lib/many.json"
            );
            R.exports = h;
            var t = {}.hasOwnProperty, T = new Intl.Collator(), S = {
              variants: [],
              extensions: [],
              privateuse: [],
              irregular: null,
              regular: null
            };
            function h(o, y) {
              var u = y || {}, A = g.parse(String(o || "").toLowerCase(), u), I = g.stringify(A), M = -1, E;
              if (!I)
                return I;
              for (; ++M < i.length; )
                n.extendedFilter(I, i[M].from).length && (_(A, i[M].from, i[M].to), I = g.stringify(A));
              for (M = -1; ++M < r.length; )
                L(A, r[M].from.field, r[M].from.value) && v(A, r[M].to.field, r[M].to.value);
              for (I = g.stringify(Object.assign({}, A, S)), M = -1; ++M < l.length; )
                I === l[M] && (_(
                  A,
                  l[M],
                  l[M].split("-").slice(0, -1).join("-")
                ), I = g.stringify(Object.assign({}, A, S)));
              if (A.extensions.sort(c), u.warning)
                for (E in d)
                  t.call(d[E], A[E]) && u.warning(
                    "Deprecated " + E + " `" + A[E] + "`, expected one of `" + d[E][A[E]].join("`, `") + "`",
                    null,
                    7
                  );
              return A.script && (A.script = A.script.charAt(0).toUpperCase() + A.script.slice(1)), A.region && (A.region = A.region.toUpperCase()), g.stringify(A);
            }
            function _(o, y, u) {
              var A = g.parse(y), I = g.parse(u), M = [], E;
              for (E in A)
                A[E] && A[E].length && L(o, E, A[E]) && M.push(E);
              for (E in I)
                I[E] && I[E].length && (M.indexOf(E) > -1 || !o[E] || !o[E].length) && v(o, E, I[E]);
            }
            function L(o, y, u) {
              var A = !1, I, M, E, N;
              if (u) {
                if (I = o[y], M = I, I && typeof I == "object")
                  for (M = [], E = -1; ++E < I.length; )
                    N = I[E], u.indexOf(N) < 0 ? M.push(N) : A = !0;
                else
                  I === u && (M = null, A = !0);
                o[y] = M;
              }
              return A;
            }
            function v(o, y, u) {
              var A = o[y], I, M, E;
              if (A && typeof A == "object")
                for (I = [].concat(u), M = -1; ++M < I.length; )
                  E = I[M], A.indexOf(E) < 0 && A.push(E);
              else
                o[y] = u;
            }
            function c(o, y) {
              return T.compare(o.singleton, y.singleton);
            }
          }
        ),
        /***/
        "./node_modules/bcp-47/index.js": (
          /*!**************************************!*\
            !*** ./node_modules/bcp-47/index.js ***!
            \**************************************/
          /***/
          (R, m, e) => {
            m.parse = e(
              /*! ./lib/parse */
              "./node_modules/bcp-47/lib/parse.js"
            ), m.stringify = e(
              /*! ./lib/stringify */
              "./node_modules/bcp-47/lib/stringify.js"
            );
          }
        ),
        /***/
        "./node_modules/bcp-47/lib/parse.js": (
          /*!******************************************!*\
            !*** ./node_modules/bcp-47/lib/parse.js ***!
            \******************************************/
          /***/
          (R, m, e) => {
            var g = e(
              /*! is-alphanumerical */
              "./node_modules/is-alphanumerical/index.js"
            ), n = e(
              /*! is-alphabetical */
              "./node_modules/is-alphabetical/index.js"
            ), i = e(
              /*! is-decimal */
              "./node_modules/is-decimal/index.js"
            ), r = e(
              /*! ./regular.json */
              "./node_modules/bcp-47/lib/regular.json"
            ), l = e(
              /*! ./normalize.json */
              "./node_modules/bcp-47/lib/normalize.json"
            );
            R.exports = t;
            var d = {}.hasOwnProperty;
            function t(S, h) {
              var _ = h || {}, L = T(), v = String(S), c = v.toLowerCase(), o = 0, y, u, A;
              if (S == null)
                throw new Error("Expected string, got `" + S + "`");
              if (d.call(l, c))
                return (_.normalize == null || _.normalize) && l[c] ? t(l[c]) : (L[r.indexOf(c) === -1 ? "irregular" : "regular"] = v, L);
              for (; n(c.charCodeAt(o)) && o < 9; )
                o++;
              if (o > 1 && o < 9) {
                if (L.language = v.slice(0, o), o < 4)
                  for (u = 0; c.charCodeAt(o) === 45 && n(c.charCodeAt(o + 1)) && n(c.charCodeAt(o + 2)) && n(c.charCodeAt(o + 3)) && !n(c.charCodeAt(o + 4)); ) {
                    if (u > 2)
                      return I(
                        o,
                        3,
                        "Too many extended language subtags, expected at most 3 subtags"
                      );
                    L.extendedLanguageSubtags.push(v.slice(o + 1, o + 4)), o += 4, u++;
                  }
                for (c.charCodeAt(o) === 45 && n(c.charCodeAt(o + 1)) && n(c.charCodeAt(o + 2)) && n(c.charCodeAt(o + 3)) && n(c.charCodeAt(o + 4)) && !n(c.charCodeAt(o + 5)) && (L.script = v.slice(o + 1, o + 5), o += 5), c.charCodeAt(o) === 45 && (n(c.charCodeAt(o + 1)) && n(c.charCodeAt(o + 2)) && !n(c.charCodeAt(o + 3)) ? (L.region = v.slice(o + 1, o + 3), o += 3) : i(c.charCodeAt(o + 1)) && i(c.charCodeAt(o + 2)) && i(c.charCodeAt(o + 3)) && !i(c.charCodeAt(o + 4)) && (L.region = v.slice(o + 1, o + 4), o += 4)); c.charCodeAt(o) === 45; ) {
                  for (A = y = o + 1; g(c.charCodeAt(A)); ) {
                    if (A - y > 7)
                      return I(
                        A,
                        1,
                        "Too long variant, expected at most 8 characters"
                      );
                    A++;
                  }
                  if (
                    // Long variant.
                    A - y > 4 || // Short variant.
                    A - y > 3 && i(c.charCodeAt(y))
                  )
                    L.variants.push(v.slice(y, A)), o = A;
                  else
                    break;
                }
                for (; c.charCodeAt(o) === 45 && !(c.charCodeAt(o + 1) === 120 || !g(c.charCodeAt(o + 1)) || c.charCodeAt(o + 2) !== 45 || !g(c.charCodeAt(o + 3))); ) {
                  for (A = o + 2, u = 0; c.charCodeAt(A) === 45 && g(c.charCodeAt(A + 1)) && g(c.charCodeAt(A + 2)); )
                    for (y = A + 1, A = y + 2, u++; g(c.charCodeAt(A)); ) {
                      if (A - y > 7)
                        return I(
                          A,
                          2,
                          "Too long extension, expected at most 8 characters"
                        );
                      A++;
                    }
                  if (!u)
                    return I(
                      A,
                      4,
                      "Empty extension, extensions must have at least 2 characters of content"
                    );
                  L.extensions.push({
                    singleton: v.charAt(o + 1),
                    extensions: v.slice(o + 3, A).split("-")
                  }), o = A;
                }
              } else
                o = 0;
              if (o === 0 && c.charCodeAt(o) === 120 || c.charCodeAt(o) === 45 && c.charCodeAt(o + 1) === 120)
                for (A = o = o ? o + 2 : 1; c.charCodeAt(A) === 45 && g(c.charCodeAt(A + 1)); ) {
                  for (A = y = o + 1; g(c.charCodeAt(A)); ) {
                    if (A - y > 7)
                      return I(
                        A,
                        5,
                        "Too long private-use area, expected at most 8 characters"
                      );
                    A++;
                  }
                  L.privateuse.push(v.slice(o + 1, A)), o = A;
                }
              if (o !== v.length)
                return I(o, 6, "Found superfluous content after tag");
              return L;
              function I(M, E, N) {
                return _.warning && _.warning(N, E, M), _.forgiving ? L : T();
              }
            }
            function T() {
              return {
                language: null,
                extendedLanguageSubtags: [],
                script: null,
                region: null,
                variants: [],
                extensions: [],
                privateuse: [],
                irregular: null,
                regular: null
              };
            }
          }
        ),
        /***/
        "./node_modules/bcp-47/lib/stringify.js": (
          /*!**********************************************!*\
            !*** ./node_modules/bcp-47/lib/stringify.js ***!
            \**********************************************/
          /***/
          (R) => {
            R.exports = m;
            function m(e) {
              var g = e || {}, n = [], i, r, l;
              if (g.irregular || g.regular)
                return g.irregular || g.regular;
              if (g.language)
                for (n = n.concat(
                  g.language,
                  g.extendedLanguageSubtags || [],
                  g.script || [],
                  g.region || [],
                  g.variants || []
                ), i = g.extensions || [], r = -1; ++r < i.length; )
                  l = i[r], l.singleton && l.extensions && l.extensions.length && (n = n.concat(l.singleton, l.extensions));
              return g.privateuse && g.privateuse.length && (n = n.concat("x", g.privateuse)), n.join("-");
            }
          }
        ),
        /***/
        "./node_modules/buffer/index.js": (
          /*!**************************************!*\
            !*** ./node_modules/buffer/index.js ***!
            \**************************************/
          /***/
          (R, m, e) => {
            /*!
             * The buffer module from node.js, for the browser.
             *
             * @author   Feross Aboukhadijeh <https://feross.org>
             * @license  MIT
             */
            var g = e(
              /*! base64-js */
              "./node_modules/buffer/node_modules/base64-js/index.js"
            ), n = e(
              /*! ieee754 */
              "./node_modules/buffer/node_modules/ieee754/index.js"
            ), i = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
            m.Buffer = t, m.SlowBuffer = A, m.INSPECT_MAX_BYTES = 50;
            var r = 2147483647;
            m.kMaxLength = r, t.TYPED_ARRAY_SUPPORT = l(), !t.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
              "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
            );
            function l() {
              try {
                var F = new Uint8Array(1), x = { foo: function() {
                  return 42;
                } };
                return Object.setPrototypeOf(x, Uint8Array.prototype), Object.setPrototypeOf(F, x), F.foo() === 42;
              } catch {
                return !1;
              }
            }
            Object.defineProperty(t.prototype, "parent", {
              enumerable: !0,
              get: function() {
                if (t.isBuffer(this))
                  return this.buffer;
              }
            }), Object.defineProperty(t.prototype, "offset", {
              enumerable: !0,
              get: function() {
                if (t.isBuffer(this))
                  return this.byteOffset;
              }
            });
            function d(F) {
              if (F > r)
                throw new RangeError('The value "' + F + '" is invalid for option "size"');
              var x = new Uint8Array(F);
              return Object.setPrototypeOf(x, t.prototype), x;
            }
            function t(F, x, W) {
              if (typeof F == "number") {
                if (typeof x == "string")
                  throw new TypeError(
                    'The "string" argument must be of type string. Received type number'
                  );
                return _(F);
              }
              return T(F, x, W);
            }
            t.poolSize = 8192;
            function T(F, x, W) {
              if (typeof F == "string")
                return L(F, x);
              if (ArrayBuffer.isView(F))
                return c(F);
              if (F == null)
                throw new TypeError(
                  "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof F
                );
              if (P(F, ArrayBuffer) || F && P(F.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (P(F, SharedArrayBuffer) || F && P(F.buffer, SharedArrayBuffer)))
                return o(F, x, W);
              if (typeof F == "number")
                throw new TypeError(
                  'The "value" argument must not be of type number. Received type number'
                );
              var $ = F.valueOf && F.valueOf();
              if ($ != null && $ !== F)
                return t.from($, x, W);
              var ce = y(F);
              if (ce)
                return ce;
              if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof F[Symbol.toPrimitive] == "function")
                return t.from(
                  F[Symbol.toPrimitive]("string"),
                  x,
                  W
                );
              throw new TypeError(
                "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof F
              );
            }
            t.from = function(F, x, W) {
              return T(F, x, W);
            }, Object.setPrototypeOf(t.prototype, Uint8Array.prototype), Object.setPrototypeOf(t, Uint8Array);
            function S(F) {
              if (typeof F != "number")
                throw new TypeError('"size" argument must be of type number');
              if (F < 0)
                throw new RangeError('The value "' + F + '" is invalid for option "size"');
            }
            function h(F, x, W) {
              return S(F), F <= 0 ? d(F) : x !== void 0 ? typeof W == "string" ? d(F).fill(x, W) : d(F).fill(x) : d(F);
            }
            t.alloc = function(F, x, W) {
              return h(F, x, W);
            };
            function _(F) {
              return S(F), d(F < 0 ? 0 : u(F) | 0);
            }
            t.allocUnsafe = function(F) {
              return _(F);
            }, t.allocUnsafeSlow = function(F) {
              return _(F);
            };
            function L(F, x) {
              if ((typeof x != "string" || x === "") && (x = "utf8"), !t.isEncoding(x))
                throw new TypeError("Unknown encoding: " + x);
              var W = I(F, x) | 0, $ = d(W), ce = $.write(F, x);
              return ce !== W && ($ = $.slice(0, ce)), $;
            }
            function v(F) {
              for (var x = F.length < 0 ? 0 : u(F.length) | 0, W = d(x), $ = 0; $ < x; $ += 1)
                W[$] = F[$] & 255;
              return W;
            }
            function c(F) {
              if (P(F, Uint8Array)) {
                var x = new Uint8Array(F);
                return o(x.buffer, x.byteOffset, x.byteLength);
              }
              return v(F);
            }
            function o(F, x, W) {
              if (x < 0 || F.byteLength < x)
                throw new RangeError('"offset" is outside of buffer bounds');
              if (F.byteLength < x + (W || 0))
                throw new RangeError('"length" is outside of buffer bounds');
              var $;
              return x === void 0 && W === void 0 ? $ = new Uint8Array(F) : W === void 0 ? $ = new Uint8Array(F, x) : $ = new Uint8Array(F, x, W), Object.setPrototypeOf($, t.prototype), $;
            }
            function y(F) {
              if (t.isBuffer(F)) {
                var x = u(F.length) | 0, W = d(x);
                return W.length === 0 || F.copy(W, 0, 0, x), W;
              }
              if (F.length !== void 0)
                return typeof F.length != "number" || k(F.length) ? d(0) : v(F);
              if (F.type === "Buffer" && Array.isArray(F.data))
                return v(F.data);
            }
            function u(F) {
              if (F >= r)
                throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + r.toString(16) + " bytes");
              return F | 0;
            }
            function A(F) {
              return +F != F && (F = 0), t.alloc(+F);
            }
            t.isBuffer = function(x) {
              return x != null && x._isBuffer === !0 && x !== t.prototype;
            }, t.compare = function(x, W) {
              if (P(x, Uint8Array) && (x = t.from(x, x.offset, x.byteLength)), P(W, Uint8Array) && (W = t.from(W, W.offset, W.byteLength)), !t.isBuffer(x) || !t.isBuffer(W))
                throw new TypeError(
                  'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
                );
              if (x === W)
                return 0;
              for (var $ = x.length, ce = W.length, le = 0, q = Math.min($, ce); le < q; ++le)
                if (x[le] !== W[le]) {
                  $ = x[le], ce = W[le];
                  break;
                }
              return $ < ce ? -1 : ce < $ ? 1 : 0;
            }, t.isEncoding = function(x) {
              switch (String(x).toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return !0;
                default:
                  return !1;
              }
            }, t.concat = function(x, W) {
              if (!Array.isArray(x))
                throw new TypeError('"list" argument must be an Array of Buffers');
              if (x.length === 0)
                return t.alloc(0);
              var $;
              if (W === void 0)
                for (W = 0, $ = 0; $ < x.length; ++$)
                  W += x[$].length;
              var ce = t.allocUnsafe(W), le = 0;
              for ($ = 0; $ < x.length; ++$) {
                var q = x[$];
                if (P(q, Uint8Array))
                  le + q.length > ce.length ? t.from(q).copy(ce, le) : Uint8Array.prototype.set.call(
                    ce,
                    q,
                    le
                  );
                else if (t.isBuffer(q))
                  q.copy(ce, le);
                else
                  throw new TypeError('"list" argument must be an Array of Buffers');
                le += q.length;
              }
              return ce;
            };
            function I(F, x) {
              if (t.isBuffer(F))
                return F.length;
              if (ArrayBuffer.isView(F) || P(F, ArrayBuffer))
                return F.byteLength;
              if (typeof F != "string")
                throw new TypeError(
                  'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof F
                );
              var W = F.length, $ = arguments.length > 2 && arguments[2] === !0;
              if (!$ && W === 0)
                return 0;
              for (var ce = !1; ; )
                switch (x) {
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return W;
                  case "utf8":
                  case "utf-8":
                    return re(F).length;
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return W * 2;
                  case "hex":
                    return W >>> 1;
                  case "base64":
                    return O(F).length;
                  default:
                    if (ce)
                      return $ ? -1 : re(F).length;
                    x = ("" + x).toLowerCase(), ce = !0;
                }
            }
            t.byteLength = I;
            function M(F, x, W) {
              var $ = !1;
              if ((x === void 0 || x < 0) && (x = 0), x > this.length || ((W === void 0 || W > this.length) && (W = this.length), W <= 0) || (W >>>= 0, x >>>= 0, W <= x))
                return "";
              for (F || (F = "utf8"); ; )
                switch (F) {
                  case "hex":
                    return ae(this, x, W);
                  case "utf8":
                  case "utf-8":
                    return Z(this, x, W);
                  case "ascii":
                    return Y(this, x, W);
                  case "latin1":
                  case "binary":
                    return ne(this, x, W);
                  case "base64":
                    return z(this, x, W);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return fe(this, x, W);
                  default:
                    if ($)
                      throw new TypeError("Unknown encoding: " + F);
                    F = (F + "").toLowerCase(), $ = !0;
                }
            }
            t.prototype._isBuffer = !0;
            function E(F, x, W) {
              var $ = F[x];
              F[x] = F[W], F[W] = $;
            }
            t.prototype.swap16 = function() {
              var x = this.length;
              if (x % 2 !== 0)
                throw new RangeError("Buffer size must be a multiple of 16-bits");
              for (var W = 0; W < x; W += 2)
                E(this, W, W + 1);
              return this;
            }, t.prototype.swap32 = function() {
              var x = this.length;
              if (x % 4 !== 0)
                throw new RangeError("Buffer size must be a multiple of 32-bits");
              for (var W = 0; W < x; W += 4)
                E(this, W, W + 3), E(this, W + 1, W + 2);
              return this;
            }, t.prototype.swap64 = function() {
              var x = this.length;
              if (x % 8 !== 0)
                throw new RangeError("Buffer size must be a multiple of 64-bits");
              for (var W = 0; W < x; W += 8)
                E(this, W, W + 7), E(this, W + 1, W + 6), E(this, W + 2, W + 5), E(this, W + 3, W + 4);
              return this;
            }, t.prototype.toString = function() {
              var x = this.length;
              return x === 0 ? "" : arguments.length === 0 ? Z(this, 0, x) : M.apply(this, arguments);
            }, t.prototype.toLocaleString = t.prototype.toString, t.prototype.equals = function(x) {
              if (!t.isBuffer(x))
                throw new TypeError("Argument must be a Buffer");
              return this === x ? !0 : t.compare(this, x) === 0;
            }, t.prototype.inspect = function() {
              var x = "", W = m.INSPECT_MAX_BYTES;
              return x = this.toString("hex", 0, W).replace(/(.{2})/g, "$1 ").trim(), this.length > W && (x += " ... "), "<Buffer " + x + ">";
            }, i && (t.prototype[i] = t.prototype.inspect), t.prototype.compare = function(x, W, $, ce, le) {
              if (P(x, Uint8Array) && (x = t.from(x, x.offset, x.byteLength)), !t.isBuffer(x))
                throw new TypeError(
                  'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof x
                );
              if (W === void 0 && (W = 0), $ === void 0 && ($ = x ? x.length : 0), ce === void 0 && (ce = 0), le === void 0 && (le = this.length), W < 0 || $ > x.length || ce < 0 || le > this.length)
                throw new RangeError("out of range index");
              if (ce >= le && W >= $)
                return 0;
              if (ce >= le)
                return -1;
              if (W >= $)
                return 1;
              if (W >>>= 0, $ >>>= 0, ce >>>= 0, le >>>= 0, this === x)
                return 0;
              for (var q = le - ce, _e = $ - W, Ee = Math.min(q, _e), Te = this.slice(ce, le), Ce = x.slice(W, $), xe = 0; xe < Ee; ++xe)
                if (Te[xe] !== Ce[xe]) {
                  q = Te[xe], _e = Ce[xe];
                  break;
                }
              return q < _e ? -1 : _e < q ? 1 : 0;
            };
            function N(F, x, W, $, ce) {
              if (F.length === 0)
                return -1;
              if (typeof W == "string" ? ($ = W, W = 0) : W > 2147483647 ? W = 2147483647 : W < -2147483648 && (W = -2147483648), W = +W, k(W) && (W = ce ? 0 : F.length - 1), W < 0 && (W = F.length + W), W >= F.length) {
                if (ce)
                  return -1;
                W = F.length - 1;
              } else if (W < 0)
                if (ce)
                  W = 0;
                else
                  return -1;
              if (typeof x == "string" && (x = t.from(x, $)), t.isBuffer(x))
                return x.length === 0 ? -1 : C(F, x, W, $, ce);
              if (typeof x == "number")
                return x = x & 255, typeof Uint8Array.prototype.indexOf == "function" ? ce ? Uint8Array.prototype.indexOf.call(F, x, W) : Uint8Array.prototype.lastIndexOf.call(F, x, W) : C(F, [x], W, $, ce);
              throw new TypeError("val must be string, number or Buffer");
            }
            function C(F, x, W, $, ce) {
              var le = 1, q = F.length, _e = x.length;
              if ($ !== void 0 && ($ = String($).toLowerCase(), $ === "ucs2" || $ === "ucs-2" || $ === "utf16le" || $ === "utf-16le")) {
                if (F.length < 2 || x.length < 2)
                  return -1;
                le = 2, q /= 2, _e /= 2, W /= 2;
              }
              function Ee(Ge, Pe) {
                return le === 1 ? Ge[Pe] : Ge.readUInt16BE(Pe * le);
              }
              var Te;
              if (ce) {
                var Ce = -1;
                for (Te = W; Te < q; Te++)
                  if (Ee(F, Te) === Ee(x, Ce === -1 ? 0 : Te - Ce)) {
                    if (Ce === -1 && (Ce = Te), Te - Ce + 1 === _e)
                      return Ce * le;
                  } else
                    Ce !== -1 && (Te -= Te - Ce), Ce = -1;
              } else
                for (W + _e > q && (W = q - _e), Te = W; Te >= 0; Te--) {
                  for (var xe = !0, be = 0; be < _e; be++)
                    if (Ee(F, Te + be) !== Ee(x, be)) {
                      xe = !1;
                      break;
                    }
                  if (xe)
                    return Te;
                }
              return -1;
            }
            t.prototype.includes = function(x, W, $) {
              return this.indexOf(x, W, $) !== -1;
            }, t.prototype.indexOf = function(x, W, $) {
              return N(this, x, W, $, !0);
            }, t.prototype.lastIndexOf = function(x, W, $) {
              return N(this, x, W, $, !1);
            };
            function b(F, x, W, $) {
              W = Number(W) || 0;
              var ce = F.length - W;
              $ ? ($ = Number($), $ > ce && ($ = ce)) : $ = ce;
              var le = x.length;
              $ > le / 2 && ($ = le / 2);
              for (var q = 0; q < $; ++q) {
                var _e = parseInt(x.substr(q * 2, 2), 16);
                if (k(_e))
                  return q;
                F[W + q] = _e;
              }
              return q;
            }
            function w(F, x, W, $) {
              return p(re(x, F.length - W), F, W, $);
            }
            function V(F, x, W, $) {
              return p(ue(x), F, W, $);
            }
            function J(F, x, W, $) {
              return p(O(x), F, W, $);
            }
            function H(F, x, W, $) {
              return p(te(x, F.length - W), F, W, $);
            }
            t.prototype.write = function(x, W, $, ce) {
              if (W === void 0)
                ce = "utf8", $ = this.length, W = 0;
              else if ($ === void 0 && typeof W == "string")
                ce = W, $ = this.length, W = 0;
              else if (isFinite(W))
                W = W >>> 0, isFinite($) ? ($ = $ >>> 0, ce === void 0 && (ce = "utf8")) : (ce = $, $ = void 0);
              else
                throw new Error(
                  "Buffer.write(string, encoding, offset[, length]) is no longer supported"
                );
              var le = this.length - W;
              if (($ === void 0 || $ > le) && ($ = le), x.length > 0 && ($ < 0 || W < 0) || W > this.length)
                throw new RangeError("Attempt to write outside buffer bounds");
              ce || (ce = "utf8");
              for (var q = !1; ; )
                switch (ce) {
                  case "hex":
                    return b(this, x, W, $);
                  case "utf8":
                  case "utf-8":
                    return w(this, x, W, $);
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return V(this, x, W, $);
                  case "base64":
                    return J(this, x, W, $);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return H(this, x, W, $);
                  default:
                    if (q)
                      throw new TypeError("Unknown encoding: " + ce);
                    ce = ("" + ce).toLowerCase(), q = !0;
                }
            }, t.prototype.toJSON = function() {
              return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
              };
            };
            function z(F, x, W) {
              return x === 0 && W === F.length ? g.fromByteArray(F) : g.fromByteArray(F.slice(x, W));
            }
            function Z(F, x, W) {
              W = Math.min(F.length, W);
              for (var $ = [], ce = x; ce < W; ) {
                var le = F[ce], q = null, _e = le > 239 ? 4 : le > 223 ? 3 : le > 191 ? 2 : 1;
                if (ce + _e <= W) {
                  var Ee, Te, Ce, xe;
                  switch (_e) {
                    case 1:
                      le < 128 && (q = le);
                      break;
                    case 2:
                      Ee = F[ce + 1], (Ee & 192) === 128 && (xe = (le & 31) << 6 | Ee & 63, xe > 127 && (q = xe));
                      break;
                    case 3:
                      Ee = F[ce + 1], Te = F[ce + 2], (Ee & 192) === 128 && (Te & 192) === 128 && (xe = (le & 15) << 12 | (Ee & 63) << 6 | Te & 63, xe > 2047 && (xe < 55296 || xe > 57343) && (q = xe));
                      break;
                    case 4:
                      Ee = F[ce + 1], Te = F[ce + 2], Ce = F[ce + 3], (Ee & 192) === 128 && (Te & 192) === 128 && (Ce & 192) === 128 && (xe = (le & 15) << 18 | (Ee & 63) << 12 | (Te & 63) << 6 | Ce & 63, xe > 65535 && xe < 1114112 && (q = xe));
                  }
                }
                q === null ? (q = 65533, _e = 1) : q > 65535 && (q -= 65536, $.push(q >>> 10 & 1023 | 55296), q = 56320 | q & 1023), $.push(q), ce += _e;
              }
              return K($);
            }
            var ie = 4096;
            function K(F) {
              var x = F.length;
              if (x <= ie)
                return String.fromCharCode.apply(String, F);
              for (var W = "", $ = 0; $ < x; )
                W += String.fromCharCode.apply(
                  String,
                  F.slice($, $ += ie)
                );
              return W;
            }
            function Y(F, x, W) {
              var $ = "";
              W = Math.min(F.length, W);
              for (var ce = x; ce < W; ++ce)
                $ += String.fromCharCode(F[ce] & 127);
              return $;
            }
            function ne(F, x, W) {
              var $ = "";
              W = Math.min(F.length, W);
              for (var ce = x; ce < W; ++ce)
                $ += String.fromCharCode(F[ce]);
              return $;
            }
            function ae(F, x, W) {
              var $ = F.length;
              (!x || x < 0) && (x = 0), (!W || W < 0 || W > $) && (W = $);
              for (var ce = "", le = x; le < W; ++le)
                ce += X[F[le]];
              return ce;
            }
            function fe(F, x, W) {
              for (var $ = F.slice(x, W), ce = "", le = 0; le < $.length - 1; le += 2)
                ce += String.fromCharCode($[le] + $[le + 1] * 256);
              return ce;
            }
            t.prototype.slice = function(x, W) {
              var $ = this.length;
              x = ~~x, W = W === void 0 ? $ : ~~W, x < 0 ? (x += $, x < 0 && (x = 0)) : x > $ && (x = $), W < 0 ? (W += $, W < 0 && (W = 0)) : W > $ && (W = $), W < x && (W = x);
              var ce = this.subarray(x, W);
              return Object.setPrototypeOf(ce, t.prototype), ce;
            };
            function Q(F, x, W) {
              if (F % 1 !== 0 || F < 0)
                throw new RangeError("offset is not uint");
              if (F + x > W)
                throw new RangeError("Trying to access beyond buffer length");
            }
            t.prototype.readUintLE = t.prototype.readUIntLE = function(x, W, $) {
              x = x >>> 0, W = W >>> 0, $ || Q(x, W, this.length);
              for (var ce = this[x], le = 1, q = 0; ++q < W && (le *= 256); )
                ce += this[x + q] * le;
              return ce;
            }, t.prototype.readUintBE = t.prototype.readUIntBE = function(x, W, $) {
              x = x >>> 0, W = W >>> 0, $ || Q(x, W, this.length);
              for (var ce = this[x + --W], le = 1; W > 0 && (le *= 256); )
                ce += this[x + --W] * le;
              return ce;
            }, t.prototype.readUint8 = t.prototype.readUInt8 = function(x, W) {
              return x = x >>> 0, W || Q(x, 1, this.length), this[x];
            }, t.prototype.readUint16LE = t.prototype.readUInt16LE = function(x, W) {
              return x = x >>> 0, W || Q(x, 2, this.length), this[x] | this[x + 1] << 8;
            }, t.prototype.readUint16BE = t.prototype.readUInt16BE = function(x, W) {
              return x = x >>> 0, W || Q(x, 2, this.length), this[x] << 8 | this[x + 1];
            }, t.prototype.readUint32LE = t.prototype.readUInt32LE = function(x, W) {
              return x = x >>> 0, W || Q(x, 4, this.length), (this[x] | this[x + 1] << 8 | this[x + 2] << 16) + this[x + 3] * 16777216;
            }, t.prototype.readUint32BE = t.prototype.readUInt32BE = function(x, W) {
              return x = x >>> 0, W || Q(x, 4, this.length), this[x] * 16777216 + (this[x + 1] << 16 | this[x + 2] << 8 | this[x + 3]);
            }, t.prototype.readIntLE = function(x, W, $) {
              x = x >>> 0, W = W >>> 0, $ || Q(x, W, this.length);
              for (var ce = this[x], le = 1, q = 0; ++q < W && (le *= 256); )
                ce += this[x + q] * le;
              return le *= 128, ce >= le && (ce -= Math.pow(2, 8 * W)), ce;
            }, t.prototype.readIntBE = function(x, W, $) {
              x = x >>> 0, W = W >>> 0, $ || Q(x, W, this.length);
              for (var ce = W, le = 1, q = this[x + --ce]; ce > 0 && (le *= 256); )
                q += this[x + --ce] * le;
              return le *= 128, q >= le && (q -= Math.pow(2, 8 * W)), q;
            }, t.prototype.readInt8 = function(x, W) {
              return x = x >>> 0, W || Q(x, 1, this.length), this[x] & 128 ? (255 - this[x] + 1) * -1 : this[x];
            }, t.prototype.readInt16LE = function(x, W) {
              x = x >>> 0, W || Q(x, 2, this.length);
              var $ = this[x] | this[x + 1] << 8;
              return $ & 32768 ? $ | 4294901760 : $;
            }, t.prototype.readInt16BE = function(x, W) {
              x = x >>> 0, W || Q(x, 2, this.length);
              var $ = this[x + 1] | this[x] << 8;
              return $ & 32768 ? $ | 4294901760 : $;
            }, t.prototype.readInt32LE = function(x, W) {
              return x = x >>> 0, W || Q(x, 4, this.length), this[x] | this[x + 1] << 8 | this[x + 2] << 16 | this[x + 3] << 24;
            }, t.prototype.readInt32BE = function(x, W) {
              return x = x >>> 0, W || Q(x, 4, this.length), this[x] << 24 | this[x + 1] << 16 | this[x + 2] << 8 | this[x + 3];
            }, t.prototype.readFloatLE = function(x, W) {
              return x = x >>> 0, W || Q(x, 4, this.length), n.read(this, x, !0, 23, 4);
            }, t.prototype.readFloatBE = function(x, W) {
              return x = x >>> 0, W || Q(x, 4, this.length), n.read(this, x, !1, 23, 4);
            }, t.prototype.readDoubleLE = function(x, W) {
              return x = x >>> 0, W || Q(x, 8, this.length), n.read(this, x, !0, 52, 8);
            }, t.prototype.readDoubleBE = function(x, W) {
              return x = x >>> 0, W || Q(x, 8, this.length), n.read(this, x, !1, 52, 8);
            };
            function oe(F, x, W, $, ce, le) {
              if (!t.isBuffer(F))
                throw new TypeError('"buffer" argument must be a Buffer instance');
              if (x > ce || x < le)
                throw new RangeError('"value" argument is out of bounds');
              if (W + $ > F.length)
                throw new RangeError("Index out of range");
            }
            t.prototype.writeUintLE = t.prototype.writeUIntLE = function(x, W, $, ce) {
              if (x = +x, W = W >>> 0, $ = $ >>> 0, !ce) {
                var le = Math.pow(2, 8 * $) - 1;
                oe(this, x, W, $, le, 0);
              }
              var q = 1, _e = 0;
              for (this[W] = x & 255; ++_e < $ && (q *= 256); )
                this[W + _e] = x / q & 255;
              return W + $;
            }, t.prototype.writeUintBE = t.prototype.writeUIntBE = function(x, W, $, ce) {
              if (x = +x, W = W >>> 0, $ = $ >>> 0, !ce) {
                var le = Math.pow(2, 8 * $) - 1;
                oe(this, x, W, $, le, 0);
              }
              var q = $ - 1, _e = 1;
              for (this[W + q] = x & 255; --q >= 0 && (_e *= 256); )
                this[W + q] = x / _e & 255;
              return W + $;
            }, t.prototype.writeUint8 = t.prototype.writeUInt8 = function(x, W, $) {
              return x = +x, W = W >>> 0, $ || oe(this, x, W, 1, 255, 0), this[W] = x & 255, W + 1;
            }, t.prototype.writeUint16LE = t.prototype.writeUInt16LE = function(x, W, $) {
              return x = +x, W = W >>> 0, $ || oe(this, x, W, 2, 65535, 0), this[W] = x & 255, this[W + 1] = x >>> 8, W + 2;
            }, t.prototype.writeUint16BE = t.prototype.writeUInt16BE = function(x, W, $) {
              return x = +x, W = W >>> 0, $ || oe(this, x, W, 2, 65535, 0), this[W] = x >>> 8, this[W + 1] = x & 255, W + 2;
            }, t.prototype.writeUint32LE = t.prototype.writeUInt32LE = function(x, W, $) {
              return x = +x, W = W >>> 0, $ || oe(this, x, W, 4, 4294967295, 0), this[W + 3] = x >>> 24, this[W + 2] = x >>> 16, this[W + 1] = x >>> 8, this[W] = x & 255, W + 4;
            }, t.prototype.writeUint32BE = t.prototype.writeUInt32BE = function(x, W, $) {
              return x = +x, W = W >>> 0, $ || oe(this, x, W, 4, 4294967295, 0), this[W] = x >>> 24, this[W + 1] = x >>> 16, this[W + 2] = x >>> 8, this[W + 3] = x & 255, W + 4;
            }, t.prototype.writeIntLE = function(x, W, $, ce) {
              if (x = +x, W = W >>> 0, !ce) {
                var le = Math.pow(2, 8 * $ - 1);
                oe(this, x, W, $, le - 1, -le);
              }
              var q = 0, _e = 1, Ee = 0;
              for (this[W] = x & 255; ++q < $ && (_e *= 256); )
                x < 0 && Ee === 0 && this[W + q - 1] !== 0 && (Ee = 1), this[W + q] = (x / _e >> 0) - Ee & 255;
              return W + $;
            }, t.prototype.writeIntBE = function(x, W, $, ce) {
              if (x = +x, W = W >>> 0, !ce) {
                var le = Math.pow(2, 8 * $ - 1);
                oe(this, x, W, $, le - 1, -le);
              }
              var q = $ - 1, _e = 1, Ee = 0;
              for (this[W + q] = x & 255; --q >= 0 && (_e *= 256); )
                x < 0 && Ee === 0 && this[W + q + 1] !== 0 && (Ee = 1), this[W + q] = (x / _e >> 0) - Ee & 255;
              return W + $;
            }, t.prototype.writeInt8 = function(x, W, $) {
              return x = +x, W = W >>> 0, $ || oe(this, x, W, 1, 127, -128), x < 0 && (x = 255 + x + 1), this[W] = x & 255, W + 1;
            }, t.prototype.writeInt16LE = function(x, W, $) {
              return x = +x, W = W >>> 0, $ || oe(this, x, W, 2, 32767, -32768), this[W] = x & 255, this[W + 1] = x >>> 8, W + 2;
            }, t.prototype.writeInt16BE = function(x, W, $) {
              return x = +x, W = W >>> 0, $ || oe(this, x, W, 2, 32767, -32768), this[W] = x >>> 8, this[W + 1] = x & 255, W + 2;
            }, t.prototype.writeInt32LE = function(x, W, $) {
              return x = +x, W = W >>> 0, $ || oe(this, x, W, 4, 2147483647, -2147483648), this[W] = x & 255, this[W + 1] = x >>> 8, this[W + 2] = x >>> 16, this[W + 3] = x >>> 24, W + 4;
            }, t.prototype.writeInt32BE = function(x, W, $) {
              return x = +x, W = W >>> 0, $ || oe(this, x, W, 4, 2147483647, -2147483648), x < 0 && (x = 4294967295 + x + 1), this[W] = x >>> 24, this[W + 1] = x >>> 16, this[W + 2] = x >>> 8, this[W + 3] = x & 255, W + 4;
            };
            function de(F, x, W, $, ce, le) {
              if (W + $ > F.length)
                throw new RangeError("Index out of range");
              if (W < 0)
                throw new RangeError("Index out of range");
            }
            function Me(F, x, W, $, ce) {
              return x = +x, W = W >>> 0, ce || de(F, x, W, 4), n.write(F, x, W, $, 23, 4), W + 4;
            }
            t.prototype.writeFloatLE = function(x, W, $) {
              return Me(this, x, W, !0, $);
            }, t.prototype.writeFloatBE = function(x, W, $) {
              return Me(this, x, W, !1, $);
            };
            function ge(F, x, W, $, ce) {
              return x = +x, W = W >>> 0, ce || de(F, x, W, 8), n.write(F, x, W, $, 52, 8), W + 8;
            }
            t.prototype.writeDoubleLE = function(x, W, $) {
              return ge(this, x, W, !0, $);
            }, t.prototype.writeDoubleBE = function(x, W, $) {
              return ge(this, x, W, !1, $);
            }, t.prototype.copy = function(x, W, $, ce) {
              if (!t.isBuffer(x))
                throw new TypeError("argument should be a Buffer");
              if ($ || ($ = 0), !ce && ce !== 0 && (ce = this.length), W >= x.length && (W = x.length), W || (W = 0), ce > 0 && ce < $ && (ce = $), ce === $ || x.length === 0 || this.length === 0)
                return 0;
              if (W < 0)
                throw new RangeError("targetStart out of bounds");
              if ($ < 0 || $ >= this.length)
                throw new RangeError("Index out of range");
              if (ce < 0)
                throw new RangeError("sourceEnd out of bounds");
              ce > this.length && (ce = this.length), x.length - W < ce - $ && (ce = x.length - W + $);
              var le = ce - $;
              return this === x && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(W, $, ce) : Uint8Array.prototype.set.call(
                x,
                this.subarray($, ce),
                W
              ), le;
            }, t.prototype.fill = function(x, W, $, ce) {
              if (typeof x == "string") {
                if (typeof W == "string" ? (ce = W, W = 0, $ = this.length) : typeof $ == "string" && (ce = $, $ = this.length), ce !== void 0 && typeof ce != "string")
                  throw new TypeError("encoding must be a string");
                if (typeof ce == "string" && !t.isEncoding(ce))
                  throw new TypeError("Unknown encoding: " + ce);
                if (x.length === 1) {
                  var le = x.charCodeAt(0);
                  (ce === "utf8" && le < 128 || ce === "latin1") && (x = le);
                }
              } else
                typeof x == "number" ? x = x & 255 : typeof x == "boolean" && (x = Number(x));
              if (W < 0 || this.length < W || this.length < $)
                throw new RangeError("Out of range index");
              if ($ <= W)
                return this;
              W = W >>> 0, $ = $ === void 0 ? this.length : $ >>> 0, x || (x = 0);
              var q;
              if (typeof x == "number")
                for (q = W; q < $; ++q)
                  this[q] = x;
              else {
                var _e = t.isBuffer(x) ? x : t.from(x, ce), Ee = _e.length;
                if (Ee === 0)
                  throw new TypeError('The value "' + x + '" is invalid for argument "value"');
                for (q = 0; q < $ - W; ++q)
                  this[q + W] = _e[q % Ee];
              }
              return this;
            };
            var se = /[^+/0-9A-Za-z-_]/g;
            function ee(F) {
              if (F = F.split("=")[0], F = F.trim().replace(se, ""), F.length < 2)
                return "";
              for (; F.length % 4 !== 0; )
                F = F + "=";
              return F;
            }
            function re(F, x) {
              x = x || 1 / 0;
              for (var W, $ = F.length, ce = null, le = [], q = 0; q < $; ++q) {
                if (W = F.charCodeAt(q), W > 55295 && W < 57344) {
                  if (!ce) {
                    if (W > 56319) {
                      (x -= 3) > -1 && le.push(239, 191, 189);
                      continue;
                    } else if (q + 1 === $) {
                      (x -= 3) > -1 && le.push(239, 191, 189);
                      continue;
                    }
                    ce = W;
                    continue;
                  }
                  if (W < 56320) {
                    (x -= 3) > -1 && le.push(239, 191, 189), ce = W;
                    continue;
                  }
                  W = (ce - 55296 << 10 | W - 56320) + 65536;
                } else
                  ce && (x -= 3) > -1 && le.push(239, 191, 189);
                if (ce = null, W < 128) {
                  if ((x -= 1) < 0)
                    break;
                  le.push(W);
                } else if (W < 2048) {
                  if ((x -= 2) < 0)
                    break;
                  le.push(
                    W >> 6 | 192,
                    W & 63 | 128
                  );
                } else if (W < 65536) {
                  if ((x -= 3) < 0)
                    break;
                  le.push(
                    W >> 12 | 224,
                    W >> 6 & 63 | 128,
                    W & 63 | 128
                  );
                } else if (W < 1114112) {
                  if ((x -= 4) < 0)
                    break;
                  le.push(
                    W >> 18 | 240,
                    W >> 12 & 63 | 128,
                    W >> 6 & 63 | 128,
                    W & 63 | 128
                  );
                } else
                  throw new Error("Invalid code point");
              }
              return le;
            }
            function ue(F) {
              for (var x = [], W = 0; W < F.length; ++W)
                x.push(F.charCodeAt(W) & 255);
              return x;
            }
            function te(F, x) {
              for (var W, $, ce, le = [], q = 0; q < F.length && !((x -= 2) < 0); ++q)
                W = F.charCodeAt(q), $ = W >> 8, ce = W % 256, le.push(ce), le.push($);
              return le;
            }
            function O(F) {
              return g.toByteArray(ee(F));
            }
            function p(F, x, W, $) {
              for (var ce = 0; ce < $ && !(ce + W >= x.length || ce >= F.length); ++ce)
                x[ce + W] = F[ce];
              return ce;
            }
            function P(F, x) {
              return F instanceof x || F != null && F.constructor != null && F.constructor.name != null && F.constructor.name === x.name;
            }
            function k(F) {
              return F !== F;
            }
            var X = function() {
              for (var F = "0123456789abcdef", x = new Array(256), W = 0; W < 16; ++W)
                for (var $ = W * 16, ce = 0; ce < 16; ++ce)
                  x[$ + ce] = F[W] + F[ce];
              return x;
            }();
          }
        ),
        /***/
        "./node_modules/buffer/node_modules/base64-js/index.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/buffer/node_modules/base64-js/index.js ***!
            \*************************************************************/
          /***/
          (R, m) => {
            m.byteLength = t, m.toByteArray = S, m.fromByteArray = L;
            for (var e = [], g = [], n = typeof Uint8Array < "u" ? Uint8Array : Array, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", r = 0, l = i.length; r < l; ++r)
              e[r] = i[r], g[i.charCodeAt(r)] = r;
            g["-".charCodeAt(0)] = 62, g["_".charCodeAt(0)] = 63;
            function d(v) {
              var c = v.length;
              if (c % 4 > 0)
                throw new Error("Invalid string. Length must be a multiple of 4");
              var o = v.indexOf("=");
              o === -1 && (o = c);
              var y = o === c ? 0 : 4 - o % 4;
              return [o, y];
            }
            function t(v) {
              var c = d(v), o = c[0], y = c[1];
              return (o + y) * 3 / 4 - y;
            }
            function T(v, c, o) {
              return (c + o) * 3 / 4 - o;
            }
            function S(v) {
              var c, o = d(v), y = o[0], u = o[1], A = new n(T(v, y, u)), I = 0, M = u > 0 ? y - 4 : y, E;
              for (E = 0; E < M; E += 4)
                c = g[v.charCodeAt(E)] << 18 | g[v.charCodeAt(E + 1)] << 12 | g[v.charCodeAt(E + 2)] << 6 | g[v.charCodeAt(E + 3)], A[I++] = c >> 16 & 255, A[I++] = c >> 8 & 255, A[I++] = c & 255;
              return u === 2 && (c = g[v.charCodeAt(E)] << 2 | g[v.charCodeAt(E + 1)] >> 4, A[I++] = c & 255), u === 1 && (c = g[v.charCodeAt(E)] << 10 | g[v.charCodeAt(E + 1)] << 4 | g[v.charCodeAt(E + 2)] >> 2, A[I++] = c >> 8 & 255, A[I++] = c & 255), A;
            }
            function h(v) {
              return e[v >> 18 & 63] + e[v >> 12 & 63] + e[v >> 6 & 63] + e[v & 63];
            }
            function _(v, c, o) {
              for (var y, u = [], A = c; A < o; A += 3)
                y = (v[A] << 16 & 16711680) + (v[A + 1] << 8 & 65280) + (v[A + 2] & 255), u.push(h(y));
              return u.join("");
            }
            function L(v) {
              for (var c, o = v.length, y = o % 3, u = [], A = 16383, I = 0, M = o - y; I < M; I += A)
                u.push(_(v, I, I + A > M ? M : I + A));
              return y === 1 ? (c = v[o - 1], u.push(
                e[c >> 2] + e[c << 4 & 63] + "=="
              )) : y === 2 && (c = (v[o - 2] << 8) + v[o - 1], u.push(
                e[c >> 10] + e[c >> 4 & 63] + e[c << 2 & 63] + "="
              )), u.join("");
            }
          }
        ),
        /***/
        "./node_modules/buffer/node_modules/ieee754/index.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/buffer/node_modules/ieee754/index.js ***!
            \***********************************************************/
          /***/
          (R, m) => {
            /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
            m.read = function(e, g, n, i, r) {
              var l, d, t = r * 8 - i - 1, T = (1 << t) - 1, S = T >> 1, h = -7, _ = n ? r - 1 : 0, L = n ? -1 : 1, v = e[g + _];
              for (_ += L, l = v & (1 << -h) - 1, v >>= -h, h += t; h > 0; l = l * 256 + e[g + _], _ += L, h -= 8)
                ;
              for (d = l & (1 << -h) - 1, l >>= -h, h += i; h > 0; d = d * 256 + e[g + _], _ += L, h -= 8)
                ;
              if (l === 0)
                l = 1 - S;
              else {
                if (l === T)
                  return d ? NaN : (v ? -1 : 1) * (1 / 0);
                d = d + Math.pow(2, i), l = l - S;
              }
              return (v ? -1 : 1) * d * Math.pow(2, l - i);
            }, m.write = function(e, g, n, i, r, l) {
              var d, t, T, S = l * 8 - r - 1, h = (1 << S) - 1, _ = h >> 1, L = r === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, v = i ? 0 : l - 1, c = i ? 1 : -1, o = g < 0 || g === 0 && 1 / g < 0 ? 1 : 0;
              for (g = Math.abs(g), isNaN(g) || g === 1 / 0 ? (t = isNaN(g) ? 1 : 0, d = h) : (d = Math.floor(Math.log(g) / Math.LN2), g * (T = Math.pow(2, -d)) < 1 && (d--, T *= 2), d + _ >= 1 ? g += L / T : g += L * Math.pow(2, 1 - _), g * T >= 2 && (d++, T /= 2), d + _ >= h ? (t = 0, d = h) : d + _ >= 1 ? (t = (g * T - 1) * Math.pow(2, r), d = d + _) : (t = g * Math.pow(2, _ - 1) * Math.pow(2, r), d = 0)); r >= 8; e[n + v] = t & 255, v += c, t /= 256, r -= 8)
                ;
              for (d = d << r | t, S += r; S > 0; e[n + v] = d & 255, v += c, d /= 256, S -= 8)
                ;
              e[n + v - c] |= o * 128;
            };
          }
        ),
        /***/
        "./node_modules/codem-isoboxer/dist/iso_boxer.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/codem-isoboxer/dist/iso_boxer.js ***!
            \*******************************************************/
          /***/
          (R, m) => {
            /*! codem-isoboxer v0.3.6 https://github.com/madebyhiro/codem-isoboxer/blob/master/LICENSE.txt */
            var e = {};
            e.parseBuffer = function(i) {
              return new g(i).parse();
            }, e.addBoxProcessor = function(i, r) {
              typeof i != "string" || typeof r != "function" || (n.prototype._boxProcessors[i] = r);
            }, e.createFile = function() {
              return new g();
            }, e.createBox = function(i, r, l) {
              var d = n.create(i);
              return r && r.append(d, l), d;
            }, e.createFullBox = function(i, r, l) {
              var d = e.createBox(i, r, l);
              return d.version = 0, d.flags = 0, d;
            }, e.Utils = {}, e.Utils.dataViewToString = function(i, r) {
              var l = r || "utf-8";
              if (typeof TextDecoder < "u")
                return new TextDecoder(l).decode(i);
              var d = [], t = 0;
              if (l === "utf-8")
                for (; t < i.byteLength; ) {
                  var T = i.getUint8(t++);
                  T < 128 || (T < 224 ? (T = (T & 31) << 6, T |= i.getUint8(t++) & 63) : T < 240 ? (T = (T & 15) << 12, T |= (i.getUint8(t++) & 63) << 6, T |= i.getUint8(t++) & 63) : (T = (T & 7) << 18, T |= (i.getUint8(t++) & 63) << 12, T |= (i.getUint8(t++) & 63) << 6, T |= i.getUint8(t++) & 63)), d.push(String.fromCharCode(T));
                }
              else
                for (; t < i.byteLength; )
                  d.push(String.fromCharCode(i.getUint8(t++)));
              return d.join("");
            }, e.Utils.utf8ToByteArray = function(i) {
              var r, l;
              if (typeof TextEncoder < "u")
                r = new TextEncoder().encode(i);
              else
                for (r = [], l = 0; l < i.length; ++l) {
                  var d = i.charCodeAt(l);
                  d < 128 ? r.push(d) : d < 2048 ? (r.push(192 | d >> 6), r.push(128 | 63 & d)) : d < 65536 ? (r.push(224 | d >> 12), r.push(128 | 63 & d >> 6), r.push(128 | 63 & d)) : (r.push(240 | d >> 18), r.push(128 | 63 & d >> 12), r.push(128 | 63 & d >> 6), r.push(128 | 63 & d));
                }
              return r;
            }, e.Utils.appendBox = function(i, r, l) {
              if (r._offset = i._cursor.offset, r._root = i._root ? i._root : i, r._raw = i._raw, r._parent = i, l !== -1) {
                if (l == null) {
                  i.boxes.push(r);
                  return;
                }
                var d = -1, t;
                if (typeof l == "number")
                  d = l;
                else {
                  if (typeof l == "string")
                    t = l;
                  else if (typeof l == "object" && l.type)
                    t = l.type;
                  else {
                    i.boxes.push(r);
                    return;
                  }
                  for (var T = 0; T < i.boxes.length; T++)
                    if (t === i.boxes[T].type) {
                      d = T + 1;
                      break;
                    }
                }
                i.boxes.splice(d, 0, r);
              }
            }, m.parseBuffer = e.parseBuffer, m.addBoxProcessor = e.addBoxProcessor, m.createFile = e.createFile, m.createBox = e.createBox, m.createFullBox = e.createFullBox, m.Utils = e.Utils, e.Cursor = function(i) {
              this.offset = typeof i > "u" ? 0 : i;
            };
            var g = function(i) {
              this._cursor = new e.Cursor(), this.boxes = [], i && (this._raw = new DataView(i));
            };
            g.prototype.fetch = function(i) {
              var r = this.fetchAll(i, !0);
              return r.length ? r[0] : null;
            }, g.prototype.fetchAll = function(i, r) {
              var l = [];
              return g._sweep.call(this, i, l, r), l;
            }, g.prototype.parse = function() {
              for (this._cursor.offset = 0, this.boxes = []; this._cursor.offset < this._raw.byteLength; ) {
                var i = n.parse(this);
                if (typeof i.type > "u")
                  break;
                this.boxes.push(i);
              }
              return this;
            }, g._sweep = function(i, r, l) {
              this.type && this.type == i && r.push(this);
              for (var d in this.boxes) {
                if (r.length && l)
                  return;
                g._sweep.call(this.boxes[d], i, r, l);
              }
            }, g.prototype.write = function() {
              var i = 0, r;
              for (r = 0; r < this.boxes.length; r++)
                i += this.boxes[r].getLength(!1);
              var l = new Uint8Array(i);
              for (this._rawo = new DataView(l.buffer), this.bytes = l, this._cursor.offset = 0, r = 0; r < this.boxes.length; r++)
                this.boxes[r].write();
              return l.buffer;
            }, g.prototype.append = function(i, r) {
              e.Utils.appendBox(this, i, r);
            };
            var n = function() {
              this._cursor = new e.Cursor();
            };
            n.parse = function(i) {
              var r = new n();
              return r._offset = i._cursor.offset, r._root = i._root ? i._root : i, r._raw = i._raw, r._parent = i, r._parseBox(), i._cursor.offset = r._raw.byteOffset + r._raw.byteLength, r;
            }, n.create = function(i) {
              var r = new n();
              return r.type = i, r.boxes = [], r;
            }, n.prototype._boxContainers = ["dinf", "edts", "mdia", "meco", "mfra", "minf", "moof", "moov", "mvex", "stbl", "strk", "traf", "trak", "tref", "udta", "vttc", "sinf", "schi", "encv", "enca"], n.prototype._boxProcessors = {}, n.prototype._procField = function(i, r, l) {
              this._parsing ? this[i] = this._readField(r, l) : this._writeField(r, l, this[i]);
            }, n.prototype._procFieldArray = function(i, r, l, d) {
              var t;
              if (this._parsing)
                for (this[i] = [], t = 0; t < r; t++)
                  this[i][t] = this._readField(l, d);
              else
                for (t = 0; t < this[i].length; t++)
                  this._writeField(l, d, this[i][t]);
            }, n.prototype._procFullBox = function() {
              this._procField("version", "uint", 8), this._procField("flags", "uint", 24);
            }, n.prototype._procEntries = function(i, r, l) {
              var d;
              if (this._parsing)
                for (this[i] = [], d = 0; d < r; d++)
                  this[i].push({}), l.call(this, this[i][d]);
              else
                for (d = 0; d < r; d++)
                  l.call(this, this[i][d]);
            }, n.prototype._procSubEntries = function(i, r, l, d) {
              var t;
              if (this._parsing)
                for (i[r] = [], t = 0; t < l; t++)
                  i[r].push({}), d.call(this, i[r][t]);
              else
                for (t = 0; t < l; t++)
                  d.call(this, i[r][t]);
            }, n.prototype._procEntryField = function(i, r, l, d) {
              this._parsing ? i[r] = this._readField(l, d) : this._writeField(l, d, i[r]);
            }, n.prototype._procSubBoxes = function(i, r) {
              var l;
              if (this._parsing)
                for (this[i] = [], l = 0; l < r; l++)
                  this[i].push(n.parse(this));
              else
                for (l = 0; l < r; l++)
                  this._rawo ? this[i][l].write() : this.size += this[i][l].getLength();
            }, n.prototype._readField = function(i, r) {
              switch (i) {
                case "uint":
                  return this._readUint(r);
                case "int":
                  return this._readInt(r);
                case "template":
                  return this._readTemplate(r);
                case "string":
                  return r === -1 ? this._readTerminatedString() : this._readString(r);
                case "data":
                  return this._readData(r);
                case "utf8":
                  return this._readUTF8String();
                default:
                  return -1;
              }
            }, n.prototype._readInt = function(i) {
              var r = null, l = this._cursor.offset - this._raw.byteOffset;
              switch (i) {
                case 8:
                  r = this._raw.getInt8(l);
                  break;
                case 16:
                  r = this._raw.getInt16(l);
                  break;
                case 32:
                  r = this._raw.getInt32(l);
                  break;
                case 64:
                  var d = this._raw.getInt32(l), t = this._raw.getInt32(l + 4);
                  r = d * Math.pow(2, 32) + t;
                  break;
              }
              return this._cursor.offset += i >> 3, r;
            }, n.prototype._readUint = function(i) {
              var r = null, l = this._cursor.offset - this._raw.byteOffset, d, t;
              switch (i) {
                case 8:
                  r = this._raw.getUint8(l);
                  break;
                case 16:
                  r = this._raw.getUint16(l);
                  break;
                case 24:
                  d = this._raw.getUint16(l), t = this._raw.getUint8(l + 2), r = (d << 8) + t;
                  break;
                case 32:
                  r = this._raw.getUint32(l);
                  break;
                case 64:
                  d = this._raw.getUint32(l), t = this._raw.getUint32(l + 4), r = d * Math.pow(2, 32) + t;
                  break;
              }
              return this._cursor.offset += i >> 3, r;
            }, n.prototype._readString = function(i) {
              for (var r = "", l = 0; l < i; l++) {
                var d = this._readUint(8);
                r += String.fromCharCode(d);
              }
              return r;
            }, n.prototype._readTemplate = function(i) {
              var r = this._readUint(i / 2), l = this._readUint(i / 2);
              return r + l / Math.pow(2, i / 2);
            }, n.prototype._readTerminatedString = function() {
              for (var i = ""; this._cursor.offset - this._offset < this._raw.byteLength; ) {
                var r = this._readUint(8);
                if (r === 0)
                  break;
                i += String.fromCharCode(r);
              }
              return i;
            }, n.prototype._readData = function(i) {
              var r = i > 0 ? i : this._raw.byteLength - (this._cursor.offset - this._offset);
              if (r > 0) {
                var l = new Uint8Array(this._raw.buffer, this._cursor.offset, r);
                return this._cursor.offset += r, l;
              } else
                return null;
            }, n.prototype._readUTF8String = function() {
              var i = this._raw.byteLength - (this._cursor.offset - this._offset), r = null;
              return i > 0 && (r = new DataView(this._raw.buffer, this._cursor.offset, i), this._cursor.offset += i), r && e.Utils.dataViewToString(r);
            }, n.prototype._parseBox = function() {
              if (this._parsing = !0, this._cursor.offset = this._offset, this._offset + 8 > this._raw.buffer.byteLength) {
                this._root._incomplete = !0;
                return;
              }
              switch (this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this.size) {
                case 0:
                  this._raw = new DataView(this._raw.buffer, this._offset, this._raw.byteLength - this._cursor.offset + 8);
                  break;
                case 1:
                  this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.largesize);
                  break;
                default:
                  this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.size);
              }
              this._incomplete || (this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1 ? this._parseContainerBox() : this._data = this._readData());
            }, n.prototype._parseFullBox = function() {
              this.version = this._readUint(8), this.flags = this._readUint(24);
            }, n.prototype._parseContainerBox = function() {
              for (this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
                this.boxes.push(n.parse(this));
            }, n.prototype.append = function(i, r) {
              e.Utils.appendBox(this, i, r);
            }, n.prototype.getLength = function() {
              if (this._parsing = !1, this._rawo = null, this.size = 0, this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1)
                for (var i = 0; i < this.boxes.length; i++)
                  this.size += this.boxes[i].getLength();
              return this._data && this._writeData(this._data), this.size;
            }, n.prototype.write = function() {
              switch (this._parsing = !1, this._cursor.offset = this._parent._cursor.offset, this.size) {
                case 0:
                  this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.parent._rawo.byteLength - this._cursor.offset);
                  break;
                case 1:
                  this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.largesize);
                  break;
                default:
                  this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.size);
              }
              if (this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1)
                for (var i = 0; i < this.boxes.length; i++)
                  this.boxes[i].write();
              return this._data && this._writeData(this._data), this._parent._cursor.offset += this.size, this.size;
            }, n.prototype._writeInt = function(i, r) {
              if (this._rawo) {
                var l = this._cursor.offset - this._rawo.byteOffset;
                switch (i) {
                  case 8:
                    this._rawo.setInt8(l, r);
                    break;
                  case 16:
                    this._rawo.setInt16(l, r);
                    break;
                  case 32:
                    this._rawo.setInt32(l, r);
                    break;
                  case 64:
                    var d = Math.floor(r / Math.pow(2, 32)), t = r - d * Math.pow(2, 32);
                    this._rawo.setUint32(l, d), this._rawo.setUint32(l + 4, t);
                    break;
                }
                this._cursor.offset += i >> 3;
              } else
                this.size += i >> 3;
            }, n.prototype._writeUint = function(i, r) {
              if (this._rawo) {
                var l = this._cursor.offset - this._rawo.byteOffset, d, t;
                switch (i) {
                  case 8:
                    this._rawo.setUint8(l, r);
                    break;
                  case 16:
                    this._rawo.setUint16(l, r);
                    break;
                  case 24:
                    d = (r & 16776960) >> 8, t = r & 255, this._rawo.setUint16(l, d), this._rawo.setUint8(l + 2, t);
                    break;
                  case 32:
                    this._rawo.setUint32(l, r);
                    break;
                  case 64:
                    d = Math.floor(r / Math.pow(2, 32)), t = r - d * Math.pow(2, 32), this._rawo.setUint32(l, d), this._rawo.setUint32(l + 4, t);
                    break;
                }
                this._cursor.offset += i >> 3;
              } else
                this.size += i >> 3;
            }, n.prototype._writeString = function(i, r) {
              for (var l = 0; l < i; l++)
                this._writeUint(8, r.charCodeAt(l));
            }, n.prototype._writeTerminatedString = function(i) {
              if (i.length !== 0) {
                for (var r = 0; r < i.length; r++)
                  this._writeUint(8, i.charCodeAt(r));
                this._writeUint(8, 0);
              }
            }, n.prototype._writeTemplate = function(i, r) {
              var l = Math.floor(r), d = (r - l) * Math.pow(2, i / 2);
              this._writeUint(i / 2, l), this._writeUint(i / 2, d);
            }, n.prototype._writeData = function(i) {
              var r;
              if (i)
                if (this._rawo) {
                  if (i instanceof Array) {
                    for (var l = this._cursor.offset - this._rawo.byteOffset, r = 0; r < i.length; r++)
                      this._rawo.setInt8(l + r, i[r]);
                    this._cursor.offset += i.length;
                  }
                  i instanceof Uint8Array && (this._root.bytes.set(i, this._cursor.offset), this._cursor.offset += i.length);
                } else
                  this.size += i.length;
            }, n.prototype._writeUTF8String = function(i) {
              var r = e.Utils.utf8ToByteArray(i);
              if (this._rawo)
                for (var l = new DataView(this._rawo.buffer, this._cursor.offset, r.length), d = 0; d < r.length; d++)
                  l.setUint8(d, r[d]);
              else
                this.size += r.length;
            }, n.prototype._writeField = function(i, r, l) {
              switch (i) {
                case "uint":
                  this._writeUint(r, l);
                  break;
                case "int":
                  this._writeInt(r, l);
                  break;
                case "template":
                  this._writeTemplate(r, l);
                  break;
                case "string":
                  r == -1 ? this._writeTerminatedString(l) : this._writeString(r, l);
                  break;
                case "data":
                  this._writeData(l);
                  break;
                case "utf8":
                  this._writeUTF8String(l);
                  break;
              }
            }, n.prototype._boxProcessors.avc1 = n.prototype._boxProcessors.encv = function() {
              this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procField("pre_defined1", "uint", 16), this._procField("reserved2", "uint", 16), this._procFieldArray("pre_defined2", 3, "uint", 32), this._procField("width", "uint", 16), this._procField("height", "uint", 16), this._procField("horizresolution", "template", 32), this._procField("vertresolution", "template", 32), this._procField("reserved3", "uint", 32), this._procField("frame_count", "uint", 16), this._procFieldArray("compressorname", 32, "uint", 8), this._procField("depth", "uint", 16), this._procField("pre_defined3", "int", 16), this._procField("config", "data", -1);
            }, n.prototype._boxProcessors.dref = function() {
              this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
            }, n.prototype._boxProcessors.elst = function() {
              this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(i) {
                this._procEntryField(i, "segment_duration", "uint", this.version === 1 ? 64 : 32), this._procEntryField(i, "media_time", "int", this.version === 1 ? 64 : 32), this._procEntryField(i, "media_rate_integer", "int", 16), this._procEntryField(i, "media_rate_fraction", "int", 16);
              });
            }, n.prototype._boxProcessors.emsg = function() {
              this._procFullBox(), this.version == 1 ? (this._procField("timescale", "uint", 32), this._procField("presentation_time", "uint", 64), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32), this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1)) : (this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1), this._procField("timescale", "uint", 32), this._procField("presentation_time_delta", "uint", 32), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32)), this._procField("message_data", "data", -1);
            }, n.prototype._boxProcessors.free = n.prototype._boxProcessors.skip = function() {
              this._procField("data", "data", -1);
            }, n.prototype._boxProcessors.frma = function() {
              this._procField("data_format", "uint", 32);
            }, n.prototype._boxProcessors.ftyp = n.prototype._boxProcessors.styp = function() {
              this._procField("major_brand", "string", 4), this._procField("minor_version", "uint", 32);
              var i = -1;
              this._parsing && (i = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)) / 4), this._procFieldArray("compatible_brands", i, "string", 4);
            }, n.prototype._boxProcessors.hdlr = function() {
              this._procFullBox(), this._procField("pre_defined", "uint", 32), this._procField("handler_type", "string", 4), this._procFieldArray("reserved", 3, "uint", 32), this._procField("name", "string", -1);
            }, n.prototype._boxProcessors.mdat = function() {
              this._procField("data", "data", -1);
            }, n.prototype._boxProcessors.mdhd = function() {
              this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), !this._parsing && typeof this.language == "string" && (this.language = this.language.charCodeAt(0) - 96 << 10 | this.language.charCodeAt(1) - 96 << 5 | this.language.charCodeAt(2) - 96), this._procField("language", "uint", 16), this._parsing && (this.language = String.fromCharCode(
                (this.language >> 10 & 31) + 96,
                (this.language >> 5 & 31) + 96,
                (this.language & 31) + 96
              )), this._procField("pre_defined", "uint", 16);
            }, n.prototype._boxProcessors.mehd = function() {
              this._procFullBox(), this._procField("fragment_duration", "uint", this.version == 1 ? 64 : 32);
            }, n.prototype._boxProcessors.mfhd = function() {
              this._procFullBox(), this._procField("sequence_number", "uint", 32);
            }, n.prototype._boxProcessors.mfro = function() {
              this._procFullBox(), this._procField("mfra_size", "uint", 32);
            }, n.prototype._boxProcessors.mp4a = n.prototype._boxProcessors.enca = function() {
              this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("channelcount", "uint", 16), this._procField("samplesize", "uint", 16), this._procField("pre_defined", "uint", 16), this._procField("reserved3", "uint", 16), this._procField("samplerate", "template", 32), this._procField("esds", "data", -1);
            }, n.prototype._boxProcessors.mvhd = function() {
              this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._procField("rate", "template", 32), this._procField("volume", "template", 16), this._procField("reserved1", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procFieldArray("matrix", 9, "template", 32), this._procFieldArray("pre_defined", 6, "uint", 32), this._procField("next_track_ID", "uint", 32);
            }, n.prototype._boxProcessors.payl = function() {
              this._procField("cue_text", "utf8");
            }, n.prototype._boxProcessors.pssh = function() {
              this._procFullBox(), this._procFieldArray("SystemID", 16, "uint", 8), this._procField("DataSize", "uint", 32), this._procFieldArray("Data", this.DataSize, "uint", 8);
            }, n.prototype._boxProcessors.schm = function() {
              this._procFullBox(), this._procField("scheme_type", "uint", 32), this._procField("scheme_version", "uint", 32), this.flags & 1 && this._procField("scheme_uri", "string", -1);
            }, n.prototype._boxProcessors.sdtp = function() {
              this._procFullBox();
              var i = -1;
              this._parsing && (i = this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)), this._procFieldArray("sample_dependency_table", i, "uint", 8);
            }, n.prototype._boxProcessors.sidx = function() {
              this._procFullBox(), this._procField("reference_ID", "uint", 32), this._procField("timescale", "uint", 32), this._procField("earliest_presentation_time", "uint", this.version == 1 ? 64 : 32), this._procField("first_offset", "uint", this.version == 1 ? 64 : 32), this._procField("reserved", "uint", 16), this._procField("reference_count", "uint", 16), this._procEntries("references", this.reference_count, function(i) {
                this._parsing || (i.reference = (i.reference_type & 1) << 31, i.reference |= i.referenced_size & 2147483647, i.sap = (i.starts_with_SAP & 1) << 31, i.sap |= (i.SAP_type & 3) << 28, i.sap |= i.SAP_delta_time & 268435455), this._procEntryField(i, "reference", "uint", 32), this._procEntryField(i, "subsegment_duration", "uint", 32), this._procEntryField(i, "sap", "uint", 32), this._parsing && (i.reference_type = i.reference >> 31 & 1, i.referenced_size = i.reference & 2147483647, i.starts_with_SAP = i.sap >> 31 & 1, i.SAP_type = i.sap >> 28 & 7, i.SAP_delta_time = i.sap & 268435455);
              });
            }, n.prototype._boxProcessors.smhd = function() {
              this._procFullBox(), this._procField("balance", "uint", 16), this._procField("reserved", "uint", 16);
            }, n.prototype._boxProcessors.ssix = function() {
              this._procFullBox(), this._procField("subsegment_count", "uint", 32), this._procEntries("subsegments", this.subsegment_count, function(i) {
                this._procEntryField(i, "ranges_count", "uint", 32), this._procSubEntries(i, "ranges", i.ranges_count, function(r) {
                  this._procEntryField(r, "level", "uint", 8), this._procEntryField(r, "range_size", "uint", 24);
                });
              });
            }, n.prototype._boxProcessors.stsd = function() {
              this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
            }, n.prototype._boxProcessors.subs = function() {
              this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(i) {
                this._procEntryField(i, "sample_delta", "uint", 32), this._procEntryField(i, "subsample_count", "uint", 16), this._procSubEntries(i, "subsamples", i.subsample_count, function(r) {
                  this._procEntryField(r, "subsample_size", "uint", this.version === 1 ? 32 : 16), this._procEntryField(r, "subsample_priority", "uint", 8), this._procEntryField(r, "discardable", "uint", 8), this._procEntryField(r, "codec_specific_parameters", "uint", 32);
                });
              });
            }, n.prototype._boxProcessors.tenc = function() {
              this._procFullBox(), this._procField("default_IsEncrypted", "uint", 24), this._procField("default_IV_size", "uint", 8), this._procFieldArray("default_KID", 16, "uint", 8);
            }, n.prototype._boxProcessors.tfdt = function() {
              this._procFullBox(), this._procField("baseMediaDecodeTime", "uint", this.version == 1 ? 64 : 32);
            }, n.prototype._boxProcessors.tfhd = function() {
              this._procFullBox(), this._procField("track_ID", "uint", 32), this.flags & 1 && this._procField("base_data_offset", "uint", 64), this.flags & 2 && this._procField("sample_description_offset", "uint", 32), this.flags & 8 && this._procField("default_sample_duration", "uint", 32), this.flags & 16 && this._procField("default_sample_size", "uint", 32), this.flags & 32 && this._procField("default_sample_flags", "uint", 32);
            }, n.prototype._boxProcessors.tfra = function() {
              this._procFullBox(), this._procField("track_ID", "uint", 32), this._parsing || (this.reserved = 0, this.reserved |= (this.length_size_of_traf_num & 48) << 4, this.reserved |= (this.length_size_of_trun_num & 12) << 2, this.reserved |= this.length_size_of_sample_num & 3), this._procField("reserved", "uint", 32), this._parsing && (this.length_size_of_traf_num = (this.reserved & 48) >> 4, this.length_size_of_trun_num = (this.reserved & 12) >> 2, this.length_size_of_sample_num = this.reserved & 3), this._procField("number_of_entry", "uint", 32), this._procEntries("entries", this.number_of_entry, function(i) {
                this._procEntryField(i, "time", "uint", this.version === 1 ? 64 : 32), this._procEntryField(i, "moof_offset", "uint", this.version === 1 ? 64 : 32), this._procEntryField(i, "traf_number", "uint", (this.length_size_of_traf_num + 1) * 8), this._procEntryField(i, "trun_number", "uint", (this.length_size_of_trun_num + 1) * 8), this._procEntryField(i, "sample_number", "uint", (this.length_size_of_sample_num + 1) * 8);
              });
            }, n.prototype._boxProcessors.tkhd = function() {
              this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("track_ID", "uint", 32), this._procField("reserved1", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("layer", "uint", 16), this._procField("alternate_group", "uint", 16), this._procField("volume", "template", 16), this._procField("reserved3", "uint", 16), this._procFieldArray("matrix", 9, "template", 32), this._procField("width", "template", 32), this._procField("height", "template", 32);
            }, n.prototype._boxProcessors.trex = function() {
              this._procFullBox(), this._procField("track_ID", "uint", 32), this._procField("default_sample_description_index", "uint", 32), this._procField("default_sample_duration", "uint", 32), this._procField("default_sample_size", "uint", 32), this._procField("default_sample_flags", "uint", 32);
            }, n.prototype._boxProcessors.trun = function() {
              this._procFullBox(), this._procField("sample_count", "uint", 32), this.flags & 1 && this._procField("data_offset", "int", 32), this.flags & 4 && this._procField("first_sample_flags", "uint", 32), this._procEntries("samples", this.sample_count, function(i) {
                this.flags & 256 && this._procEntryField(i, "sample_duration", "uint", 32), this.flags & 512 && this._procEntryField(i, "sample_size", "uint", 32), this.flags & 1024 && this._procEntryField(i, "sample_flags", "uint", 32), this.flags & 2048 && this._procEntryField(i, "sample_composition_time_offset", this.version === 1 ? "int" : "uint", 32);
              });
            }, n.prototype._boxProcessors["url "] = n.prototype._boxProcessors["urn "] = function() {
              this._procFullBox(), this.type === "urn " && this._procField("name", "string", -1), this._procField("location", "string", -1);
            }, n.prototype._boxProcessors.vlab = function() {
              this._procField("source_label", "utf8");
            }, n.prototype._boxProcessors.vmhd = function() {
              this._procFullBox(), this._procField("graphicsmode", "uint", 16), this._procFieldArray("opcolor", 3, "uint", 16);
            }, n.prototype._boxProcessors.vttC = function() {
              this._procField("config", "utf8");
            }, n.prototype._boxProcessors.vtte = function() {
            };
          }
        ),
        /***/
        "./node_modules/es6-promise/auto.js": (
          /*!******************************************!*\
            !*** ./node_modules/es6-promise/auto.js ***!
            \******************************************/
          /***/
          (R, m, e) => {
            R.exports = e(
              /*! ./ */
              "./node_modules/es6-promise/dist/es6-promise.js"
            ).polyfill();
          }
        ),
        /***/
        "./node_modules/es6-promise/dist/es6-promise.js": (
          /*!******************************************************!*\
            !*** ./node_modules/es6-promise/dist/es6-promise.js ***!
            \******************************************************/
          /***/
          function(R, m, e) {
            /*!
             * @overview es6-promise - a tiny implementation of Promises/A+.
             * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
             * @license   Licensed under MIT license
             *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
             * @version   v4.2.8+1e68dce6
             */
            (function(g, n) {
              R.exports = n();
            })(this, function() {
              function g(q) {
                var _e = typeof q;
                return q !== null && (_e === "object" || _e === "function");
              }
              function n(q) {
                return typeof q == "function";
              }
              var i = void 0;
              Array.isArray ? i = Array.isArray : i = function(q) {
                return Object.prototype.toString.call(q) === "[object Array]";
              };
              var r = i, l = 0, d = void 0, t = void 0, T = function(_e, Ee) {
                E[l] = _e, E[l + 1] = Ee, l += 2, l === 2 && (t ? t(N) : b());
              };
              function S(q) {
                t = q;
              }
              function h(q) {
                T = q;
              }
              var _ = typeof window < "u" ? window : void 0, L = _ || {}, v = L.MutationObserver || L.WebKitMutationObserver, c = typeof self > "u" && typeof process < "u" && {}.toString.call(process) === "[object process]", o = typeof Uint8ClampedArray < "u" && typeof importScripts < "u" && typeof MessageChannel < "u";
              function y() {
                return function() {
                  return process.nextTick(N);
                };
              }
              function u() {
                return typeof d < "u" ? function() {
                  d(N);
                } : M();
              }
              function A() {
                var q = 0, _e = new v(N), Ee = document.createTextNode("");
                return _e.observe(Ee, { characterData: !0 }), function() {
                  Ee.data = q = ++q % 2;
                };
              }
              function I() {
                var q = new MessageChannel();
                return q.port1.onmessage = N, function() {
                  return q.port2.postMessage(0);
                };
              }
              function M() {
                var q = setTimeout;
                return function() {
                  return q(N, 1);
                };
              }
              var E = new Array(1e3);
              function N() {
                for (var q = 0; q < l; q += 2) {
                  var _e = E[q], Ee = E[q + 1];
                  _e(Ee), E[q] = void 0, E[q + 1] = void 0;
                }
                l = 0;
              }
              function C() {
                try {
                  var q = Function("return this")().require("vertx");
                  return d = q.runOnLoop || q.runOnContext, u();
                } catch {
                  return M();
                }
              }
              var b = void 0;
              c ? b = y() : v ? b = A() : o ? b = I() : _ === void 0 ? b = C() : b = M();
              function w(q, _e) {
                var Ee = this, Te = new this.constructor(H);
                Te[J] === void 0 && p(Te);
                var Ce = Ee._state;
                if (Ce) {
                  var xe = arguments[Ce - 1];
                  T(function() {
                    return re(Ce, Te, xe, Ee._result);
                  });
                } else
                  se(Ee, Te, q, _e);
                return Te;
              }
              function V(q) {
                var _e = this;
                if (q && typeof q == "object" && q.constructor === _e)
                  return q;
                var Ee = new _e(H);
                return oe(Ee, q), Ee;
              }
              var J = Math.random().toString(36).substring(2);
              function H() {
              }
              var z = void 0, Z = 1, ie = 2;
              function K() {
                return new TypeError("You cannot resolve a promise with itself");
              }
              function Y() {
                return new TypeError("A promises callback cannot return that same promise.");
              }
              function ne(q, _e, Ee, Te) {
                try {
                  q.call(_e, Ee, Te);
                } catch (Ce) {
                  return Ce;
                }
              }
              function ae(q, _e, Ee) {
                T(function(Te) {
                  var Ce = !1, xe = ne(Ee, _e, function(be) {
                    Ce || (Ce = !0, _e !== be ? oe(Te, be) : Me(Te, be));
                  }, function(be) {
                    Ce || (Ce = !0, ge(Te, be));
                  }, "Settle: " + (Te._label || " unknown promise"));
                  !Ce && xe && (Ce = !0, ge(Te, xe));
                }, q);
              }
              function fe(q, _e) {
                _e._state === Z ? Me(q, _e._result) : _e._state === ie ? ge(q, _e._result) : se(_e, void 0, function(Ee) {
                  return oe(q, Ee);
                }, function(Ee) {
                  return ge(q, Ee);
                });
              }
              function Q(q, _e, Ee) {
                _e.constructor === q.constructor && Ee === w && _e.constructor.resolve === V ? fe(q, _e) : Ee === void 0 ? Me(q, _e) : n(Ee) ? ae(q, _e, Ee) : Me(q, _e);
              }
              function oe(q, _e) {
                if (q === _e)
                  ge(q, K());
                else if (g(_e)) {
                  var Ee = void 0;
                  try {
                    Ee = _e.then;
                  } catch (Te) {
                    ge(q, Te);
                    return;
                  }
                  Q(q, _e, Ee);
                } else
                  Me(q, _e);
              }
              function de(q) {
                q._onerror && q._onerror(q._result), ee(q);
              }
              function Me(q, _e) {
                q._state === z && (q._result = _e, q._state = Z, q._subscribers.length !== 0 && T(ee, q));
              }
              function ge(q, _e) {
                q._state === z && (q._state = ie, q._result = _e, T(de, q));
              }
              function se(q, _e, Ee, Te) {
                var Ce = q._subscribers, xe = Ce.length;
                q._onerror = null, Ce[xe] = _e, Ce[xe + Z] = Ee, Ce[xe + ie] = Te, xe === 0 && q._state && T(ee, q);
              }
              function ee(q) {
                var _e = q._subscribers, Ee = q._state;
                if (_e.length !== 0) {
                  for (var Te = void 0, Ce = void 0, xe = q._result, be = 0; be < _e.length; be += 3)
                    Te = _e[be], Ce = _e[be + Ee], Te ? re(Ee, Te, Ce, xe) : Ce(xe);
                  q._subscribers.length = 0;
                }
              }
              function re(q, _e, Ee, Te) {
                var Ce = n(Ee), xe = void 0, be = void 0, Ge = !0;
                if (Ce) {
                  try {
                    xe = Ee(Te);
                  } catch (Pe) {
                    Ge = !1, be = Pe;
                  }
                  if (_e === xe) {
                    ge(_e, Y());
                    return;
                  }
                } else
                  xe = Te;
                _e._state !== z || (Ce && Ge ? oe(_e, xe) : Ge === !1 ? ge(_e, be) : q === Z ? Me(_e, xe) : q === ie && ge(_e, xe));
              }
              function ue(q, _e) {
                try {
                  _e(function(Te) {
                    oe(q, Te);
                  }, function(Te) {
                    ge(q, Te);
                  });
                } catch (Ee) {
                  ge(q, Ee);
                }
              }
              var te = 0;
              function O() {
                return te++;
              }
              function p(q) {
                q[J] = te++, q._state = void 0, q._result = void 0, q._subscribers = [];
              }
              function P() {
                return new Error("Array Methods must be provided an Array");
              }
              var k = function() {
                function q(_e, Ee) {
                  this._instanceConstructor = _e, this.promise = new _e(H), this.promise[J] || p(this.promise), r(Ee) ? (this.length = Ee.length, this._remaining = Ee.length, this._result = new Array(this.length), this.length === 0 ? Me(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(Ee), this._remaining === 0 && Me(this.promise, this._result))) : ge(this.promise, P());
                }
                return q.prototype._enumerate = function(Ee) {
                  for (var Te = 0; this._state === z && Te < Ee.length; Te++)
                    this._eachEntry(Ee[Te], Te);
                }, q.prototype._eachEntry = function(Ee, Te) {
                  var Ce = this._instanceConstructor, xe = Ce.resolve;
                  if (xe === V) {
                    var be = void 0, Ge = void 0, Pe = !1;
                    try {
                      be = Ee.then;
                    } catch (je) {
                      Pe = !0, Ge = je;
                    }
                    if (be === w && Ee._state !== z)
                      this._settledAt(Ee._state, Te, Ee._result);
                    else if (typeof be != "function")
                      this._remaining--, this._result[Te] = Ee;
                    else if (Ce === ce) {
                      var Le = new Ce(H);
                      Pe ? ge(Le, Ge) : Q(Le, Ee, be), this._willSettleAt(Le, Te);
                    } else
                      this._willSettleAt(new Ce(function(je) {
                        return je(Ee);
                      }), Te);
                  } else
                    this._willSettleAt(xe(Ee), Te);
                }, q.prototype._settledAt = function(Ee, Te, Ce) {
                  var xe = this.promise;
                  xe._state === z && (this._remaining--, Ee === ie ? ge(xe, Ce) : this._result[Te] = Ce), this._remaining === 0 && Me(xe, this._result);
                }, q.prototype._willSettleAt = function(Ee, Te) {
                  var Ce = this;
                  se(Ee, void 0, function(xe) {
                    return Ce._settledAt(Z, Te, xe);
                  }, function(xe) {
                    return Ce._settledAt(ie, Te, xe);
                  });
                }, q;
              }();
              function X(q) {
                return new k(this, q).promise;
              }
              function F(q) {
                var _e = this;
                return r(q) ? new _e(function(Ee, Te) {
                  for (var Ce = q.length, xe = 0; xe < Ce; xe++)
                    _e.resolve(q[xe]).then(Ee, Te);
                }) : new _e(function(Ee, Te) {
                  return Te(new TypeError("You must pass an array to race."));
                });
              }
              function x(q) {
                var _e = this, Ee = new _e(H);
                return ge(Ee, q), Ee;
              }
              function W() {
                throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
              }
              function $() {
                throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
              }
              var ce = function() {
                function q(_e) {
                  this[J] = O(), this._result = this._state = void 0, this._subscribers = [], H !== _e && (typeof _e != "function" && W(), this instanceof q ? ue(this, _e) : $());
                }
                return q.prototype.catch = function(Ee) {
                  return this.then(null, Ee);
                }, q.prototype.finally = function(Ee) {
                  var Te = this, Ce = Te.constructor;
                  return n(Ee) ? Te.then(function(xe) {
                    return Ce.resolve(Ee()).then(function() {
                      return xe;
                    });
                  }, function(xe) {
                    return Ce.resolve(Ee()).then(function() {
                      throw xe;
                    });
                  }) : Te.then(Ee, Ee);
                }, q;
              }();
              ce.prototype.then = w, ce.all = X, ce.race = F, ce.resolve = V, ce.reject = x, ce._setScheduler = S, ce._setAsap = h, ce._asap = T;
              function le() {
                var q = void 0;
                if (typeof e.g < "u")
                  q = e.g;
                else if (typeof self < "u")
                  q = self;
                else
                  try {
                    q = Function("return this")();
                  } catch {
                    throw new Error("polyfill failed because global object is unavailable in this environment");
                  }
                var _e = q.Promise;
                if (_e) {
                  var Ee = null;
                  try {
                    Ee = Object.prototype.toString.call(_e.resolve());
                  } catch {
                  }
                  if (Ee === "[object Promise]" && !_e.cast)
                    return;
                }
                q.Promise = ce;
              }
              return ce.polyfill = le, ce.Promise = ce, ce;
            });
          }
        ),
        /***/
        "./node_modules/events/events.js": (
          /*!***************************************!*\
            !*** ./node_modules/events/events.js ***!
            \***************************************/
          /***/
          (R) => {
            var m = typeof Reflect == "object" ? Reflect : null, e = m && typeof m.apply == "function" ? m.apply : function(M, E, N) {
              return Function.prototype.apply.call(M, E, N);
            }, g;
            m && typeof m.ownKeys == "function" ? g = m.ownKeys : Object.getOwnPropertySymbols ? g = function(M) {
              return Object.getOwnPropertyNames(M).concat(Object.getOwnPropertySymbols(M));
            } : g = function(M) {
              return Object.getOwnPropertyNames(M);
            };
            function n(I) {
              console && console.warn && console.warn(I);
            }
            var i = Number.isNaN || function(M) {
              return M !== M;
            };
            function r() {
              r.init.call(this);
            }
            R.exports = r, R.exports.once = y, r.EventEmitter = r, r.prototype._events = void 0, r.prototype._eventsCount = 0, r.prototype._maxListeners = void 0;
            var l = 10;
            function d(I) {
              if (typeof I != "function")
                throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof I);
            }
            Object.defineProperty(r, "defaultMaxListeners", {
              enumerable: !0,
              get: function() {
                return l;
              },
              set: function(I) {
                if (typeof I != "number" || I < 0 || i(I))
                  throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + I + ".");
                l = I;
              }
            }), r.init = function() {
              (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
            }, r.prototype.setMaxListeners = function(M) {
              if (typeof M != "number" || M < 0 || i(M))
                throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + M + ".");
              return this._maxListeners = M, this;
            };
            function t(I) {
              return I._maxListeners === void 0 ? r.defaultMaxListeners : I._maxListeners;
            }
            r.prototype.getMaxListeners = function() {
              return t(this);
            }, r.prototype.emit = function(M) {
              for (var E = [], N = 1; N < arguments.length; N++)
                E.push(arguments[N]);
              var C = M === "error", b = this._events;
              if (b !== void 0)
                C = C && b.error === void 0;
              else if (!C)
                return !1;
              if (C) {
                var w;
                if (E.length > 0 && (w = E[0]), w instanceof Error)
                  throw w;
                var V = new Error("Unhandled error." + (w ? " (" + w.message + ")" : ""));
                throw V.context = w, V;
              }
              var J = b[M];
              if (J === void 0)
                return !1;
              if (typeof J == "function")
                e(J, this, E);
              else
                for (var H = J.length, z = v(J, H), N = 0; N < H; ++N)
                  e(z[N], this, E);
              return !0;
            };
            function T(I, M, E, N) {
              var C, b, w;
              if (d(E), b = I._events, b === void 0 ? (b = I._events = /* @__PURE__ */ Object.create(null), I._eventsCount = 0) : (b.newListener !== void 0 && (I.emit(
                "newListener",
                M,
                E.listener ? E.listener : E
              ), b = I._events), w = b[M]), w === void 0)
                w = b[M] = E, ++I._eventsCount;
              else if (typeof w == "function" ? w = b[M] = N ? [E, w] : [w, E] : N ? w.unshift(E) : w.push(E), C = t(I), C > 0 && w.length > C && !w.warned) {
                w.warned = !0;
                var V = new Error("Possible EventEmitter memory leak detected. " + w.length + " " + String(M) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                V.name = "MaxListenersExceededWarning", V.emitter = I, V.type = M, V.count = w.length, n(V);
              }
              return I;
            }
            r.prototype.addListener = function(M, E) {
              return T(this, M, E, !1);
            }, r.prototype.on = r.prototype.addListener, r.prototype.prependListener = function(M, E) {
              return T(this, M, E, !0);
            };
            function S() {
              if (!this.fired)
                return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
            }
            function h(I, M, E) {
              var N = { fired: !1, wrapFn: void 0, target: I, type: M, listener: E }, C = S.bind(N);
              return C.listener = E, N.wrapFn = C, C;
            }
            r.prototype.once = function(M, E) {
              return d(E), this.on(M, h(this, M, E)), this;
            }, r.prototype.prependOnceListener = function(M, E) {
              return d(E), this.prependListener(M, h(this, M, E)), this;
            }, r.prototype.removeListener = function(M, E) {
              var N, C, b, w, V;
              if (d(E), C = this._events, C === void 0)
                return this;
              if (N = C[M], N === void 0)
                return this;
              if (N === E || N.listener === E)
                --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete C[M], C.removeListener && this.emit("removeListener", M, N.listener || E));
              else if (typeof N != "function") {
                for (b = -1, w = N.length - 1; w >= 0; w--)
                  if (N[w] === E || N[w].listener === E) {
                    V = N[w].listener, b = w;
                    break;
                  }
                if (b < 0)
                  return this;
                b === 0 ? N.shift() : c(N, b), N.length === 1 && (C[M] = N[0]), C.removeListener !== void 0 && this.emit("removeListener", M, V || E);
              }
              return this;
            }, r.prototype.off = r.prototype.removeListener, r.prototype.removeAllListeners = function(M) {
              var E, N, C;
              if (N = this._events, N === void 0)
                return this;
              if (N.removeListener === void 0)
                return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : N[M] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete N[M]), this;
              if (arguments.length === 0) {
                var b = Object.keys(N), w;
                for (C = 0; C < b.length; ++C)
                  w = b[C], w !== "removeListener" && this.removeAllListeners(w);
                return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
              }
              if (E = N[M], typeof E == "function")
                this.removeListener(M, E);
              else if (E !== void 0)
                for (C = E.length - 1; C >= 0; C--)
                  this.removeListener(M, E[C]);
              return this;
            };
            function _(I, M, E) {
              var N = I._events;
              if (N === void 0)
                return [];
              var C = N[M];
              return C === void 0 ? [] : typeof C == "function" ? E ? [C.listener || C] : [C] : E ? o(C) : v(C, C.length);
            }
            r.prototype.listeners = function(M) {
              return _(this, M, !0);
            }, r.prototype.rawListeners = function(M) {
              return _(this, M, !1);
            }, r.listenerCount = function(I, M) {
              return typeof I.listenerCount == "function" ? I.listenerCount(M) : L.call(I, M);
            }, r.prototype.listenerCount = L;
            function L(I) {
              var M = this._events;
              if (M !== void 0) {
                var E = M[I];
                if (typeof E == "function")
                  return 1;
                if (E !== void 0)
                  return E.length;
              }
              return 0;
            }
            r.prototype.eventNames = function() {
              return this._eventsCount > 0 ? g(this._events) : [];
            };
            function v(I, M) {
              for (var E = new Array(M), N = 0; N < M; ++N)
                E[N] = I[N];
              return E;
            }
            function c(I, M) {
              for (; M + 1 < I.length; M++)
                I[M] = I[M + 1];
              I.pop();
            }
            function o(I) {
              for (var M = new Array(I.length), E = 0; E < M.length; ++E)
                M[E] = I[E].listener || I[E];
              return M;
            }
            function y(I, M) {
              return new Promise(function(E, N) {
                function C(w) {
                  I.removeListener(M, b), N(w);
                }
                function b() {
                  typeof I.removeListener == "function" && I.removeListener("error", C), E([].slice.call(arguments));
                }
                A(I, M, b, { once: !0 }), M !== "error" && u(I, C, { once: !0 });
              });
            }
            function u(I, M, E) {
              typeof I.on == "function" && A(I, "error", M, E);
            }
            function A(I, M, E, N) {
              if (typeof I.on == "function")
                N.once ? I.once(M, E) : I.on(M, E);
              else if (typeof I.addEventListener == "function")
                I.addEventListener(M, function C(b) {
                  N.once && I.removeEventListener(M, C), E(b);
                });
              else
                throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof I);
            }
          }
        ),
        /***/
        "./node_modules/fast-deep-equal/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/fast-deep-equal/index.js ***!
            \***********************************************/
          /***/
          (R) => {
            var m = Array.isArray, e = Object.keys, g = Object.prototype.hasOwnProperty;
            R.exports = function n(i, r) {
              if (i === r)
                return !0;
              if (i && r && typeof i == "object" && typeof r == "object") {
                var l = m(i), d = m(r), t, T, S;
                if (l && d) {
                  if (T = i.length, T != r.length)
                    return !1;
                  for (t = T; t-- !== 0; )
                    if (!n(i[t], r[t]))
                      return !1;
                  return !0;
                }
                if (l != d)
                  return !1;
                var h = i instanceof Date, _ = r instanceof Date;
                if (h != _)
                  return !1;
                if (h && _)
                  return i.getTime() == r.getTime();
                var L = i instanceof RegExp, v = r instanceof RegExp;
                if (L != v)
                  return !1;
                if (L && v)
                  return i.toString() == r.toString();
                var c = e(i);
                if (T = c.length, T !== e(r).length)
                  return !1;
                for (t = T; t-- !== 0; )
                  if (!g.call(r, c[t]))
                    return !1;
                for (t = T; t-- !== 0; )
                  if (S = c[t], !n(i[S], r[S]))
                    return !1;
                return !0;
              }
              return i !== i && r !== r;
            };
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/doc.js": (
          /*!**********************************************!*\
            !*** ./node_modules/imsc/src/main/js/doc.js ***!
            \**********************************************/
          /***/
          (R, m, e) => {
            (function(g, n, i, r, l) {
              g.fromXML = function(O, p, P) {
                var k = n.parser(!0, { xmlns: !0 }), X = [], F = [], x = [], W = 0, $ = null;
                k.onclosetag = function(Ee) {
                  if (X[0] instanceof h)
                    for (var Te in X[0].styles)
                      Me(X[0], X[0].styles[Te], p);
                  else if (X[0] instanceof N || X[0] instanceof C) {
                    if (X[0].contents.length > 1) {
                      var Ce = [X[0].contents[0]], xe;
                      for (xe = 1; xe < X[0].contents.length; xe++)
                        X[0].contents[xe] instanceof b && Ce[Ce.length - 1] instanceof b ? Ce[Ce.length - 1].text += X[0].contents[xe].text : Ce.push(X[0].contents[xe]);
                      X[0].contents = Ce;
                    }
                    X[0] instanceof C && X[0].contents.length === 1 && X[0].contents[0] instanceof b && (X[0].text = X[0].contents[0].text, delete X[0].contents);
                  } else
                    X[0] instanceof t && (X[0].node.uri === i.ns_tt && X[0].node.local === "metadata" ? W-- : W > 0 && P && "onCloseTag" in P && P.onCloseTag());
                  x.shift(), F.shift(), X.shift();
                }, k.ontext = function(Ee) {
                  if (X[0] !== void 0)
                    if (X[0] instanceof C || X[0] instanceof N) {
                      var Te = new b();
                      Te.initFromText($, X[0], Ee, x[0], p), X[0].contents.push(Te);
                    } else
                      X[0] instanceof t && W > 0 && P && "onText" in P && P.onText(Ee);
                }, k.onopentag = function(Ee) {
                  var Te = Ee.attributes["xml:space"];
                  Te ? x.unshift(Te.value) : x.length === 0 ? x.unshift("default") : x.unshift(x[0]);
                  var Ce = Ee.attributes["xml:lang"];
                  if (Ce ? F.unshift(Ce.value) : F.length === 0 ? F.unshift("") : F.unshift(F[0]), Ee.uri === i.ns_tt)
                    if (Ee.local === "tt")
                      $ !== null && ue(p, "Two <tt> elements at (" + this.line + "," + this.column + ")"), $ = new T(), $.initFromNode(Ee, p), X.unshift($);
                    else if (Ee.local === "head")
                      X[0] instanceof T || ue(p, "Parent of <head> element is not <tt> at (" + this.line + "," + this.column + ")"), $.head !== null && ue("Second <head> element at (" + this.line + "," + this.column + ")"), $.head = new S(), X.unshift($.head);
                    else if (Ee.local === "styling")
                      X[0] instanceof S || ue(p, "Parent of <styling> element is not <head> at (" + this.line + "," + this.column + ")"), $.head.styling !== null && ue("Second <styling> element at (" + this.line + "," + this.column + ")"), $.head.styling = new h(), X.unshift($.head.styling);
                    else if (Ee.local === "style") {
                      var xe;
                      X[0] instanceof h ? (xe = new _(), xe.initFromNode(Ee, p), xe.id ? $.head.styling.styles[xe.id] = xe : re(p, "<style> element missing @id attribute"), X.unshift(xe)) : X[0] instanceof V ? (xe = new _(), xe.initFromNode(Ee, p), se(xe.styleAttrs, X[0].styleAttrs), X.unshift(xe)) : ue(p, "Parent of <style> element is not <styling> or <region> at (" + this.line + "," + this.column + ")");
                    } else if (Ee.local === "layout")
                      X[0] instanceof S || ue(p, "Parent of <layout> element is not <head> at " + this.line + "," + this.column + ")"), $.head.layout !== null && ue(p, "Second <layout> element at " + this.line + "," + this.column + ")"), $.head.layout = new L(), X.unshift($.head.layout);
                    else if (Ee.local === "region") {
                      X[0] instanceof L || ue(p, "Parent of <region> element is not <layout> at " + this.line + "," + this.column + ")");
                      var be = new V();
                      be.initFromNode($, Ee, p), !be.id || be.id in $.head.layout.regions ? re(p, "Ignoring <region> with duplicate or missing @id at " + this.line + "," + this.column + ")") : $.head.layout.regions[be.id] = be, X.unshift(be);
                    } else if (Ee.local === "body") {
                      X[0] instanceof T || ue(p, "Parent of <body> element is not <tt> at " + this.line + "," + this.column + ")"), $.body !== null && ue(p, "Second <body> element at " + this.line + "," + this.column + ")");
                      var Ge = new M();
                      Ge.initFromNode($, Ee, p), $.body = Ge, X.unshift(Ge);
                    } else if (Ee.local === "div") {
                      X[0] instanceof E || X[0] instanceof M || ue(p, "Parent of <div> element is not <body> or <div> at " + this.line + "," + this.column + ")");
                      var Pe = new E();
                      Pe.initFromNode($, X[0], Ee, p), X[0].contents.push(Pe), X.unshift(Pe);
                    } else if (Ee.local === "p") {
                      X[0] instanceof E || ue(p, "Parent of <p> element is not <div> at " + this.line + "," + this.column + ")");
                      var Le = new N();
                      Le.initFromNode($, X[0], Ee, p), X[0].contents.push(Le), X.unshift(Le);
                    } else if (Ee.local === "span") {
                      X[0] instanceof C || X[0] instanceof N || ue(p, "Parent of <span> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                      var je = new C();
                      je.initFromNode($, X[0], Ee, x[0], p), X[0].contents.push(je), X.unshift(je);
                    } else if (Ee.local === "br") {
                      X[0] instanceof C || X[0] instanceof N || ue(p, "Parent of <br> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                      var Ze = new w();
                      Ze.initFromNode($, X[0], Ee, p), X[0].contents.push(Ze), X.unshift(Ze);
                    } else if (Ee.local === "set") {
                      X[0] instanceof C || X[0] instanceof N || X[0] instanceof E || X[0] instanceof M || X[0] instanceof V || X[0] instanceof w || ue(p, "Parent of <set> element is not a content element or a region at " + this.line + "," + this.column + ")");
                      var nt = new J();
                      nt.initFromNode($, X[0], Ee, p), X[0].sets.push(nt), X.unshift(nt);
                    } else
                      X.unshift(new t(Ee));
                  else
                    X.unshift(new t(Ee));
                  if (X[0] instanceof t) {
                    if (Ee.uri === i.ns_tt && Ee.local === "metadata")
                      W++;
                    else if (W > 0 && P && "onOpenTag" in P) {
                      var it = [];
                      for (var De in Ee.attributes)
                        it[Ee.attributes[De].uri + " " + Ee.attributes[De].local] = {
                          uri: Ee.attributes[De].uri,
                          local: Ee.attributes[De].local,
                          value: Ee.attributes[De].value
                        };
                      P.onOpenTag(Ee.uri, Ee.local, it);
                    }
                  }
                }, k.write(O).close(), $.head !== null ? delete $.head.styling : $.head = new S(), $.head.layout === null && ($.head.layout = new L());
                var ce = !1;
                for (var le in $.head.layout.regions) {
                  ce = !0;
                  break;
                }
                if (!ce) {
                  var q = V.prototype.createDefaultRegion();
                  $.head.layout.regions[q.id] = q;
                }
                for (var _e in $.head.layout.regions)
                  d($, $.head.layout.regions[_e], null, null);
                return $.body && d($, $.body, null, null), $;
              };
              function d(O, p, P, k) {
                var X = k && k.timeContainer === "seq", F = 0;
                k && (X && P ? F = P.end : F = k.begin), p.begin = p.explicit_begin ? p.explicit_begin + F : F;
                var x = p.begin, W = null;
                for (var $ in p.sets)
                  d(O, p.sets[$], W, p), p.timeContainer === "seq" ? x = p.sets[$].end : x = Math.max(x, p.sets[$].end), W = p.sets[$];
                if (!("contents" in p))
                  X ? x = p.begin : x = Number.POSITIVE_INFINITY;
                else
                  for (var ce in p.contents)
                    d(O, p.contents[ce], W, p), p.timeContainer === "seq" ? x = p.contents[ce].end : x = Math.max(x, p.contents[ce].end), W = p.contents[ce];
                p.explicit_end !== null && p.explicit_dur !== null ? p.end = Math.min(p.begin + p.explicit_dur, F + p.explicit_end) : p.explicit_end === null && p.explicit_dur !== null ? p.end = p.begin + p.explicit_dur : p.explicit_end !== null && p.explicit_dur === null ? p.end = F + p.explicit_end : p.end = x, delete p.explicit_begin, delete p.explicit_dur, delete p.explicit_end, O._registerEvent(p);
              }
              function t(O) {
                this.node = O;
              }
              function T() {
                this.events = [], this.head = null, this.body = null;
              }
              T.prototype.initFromNode = function(O, p) {
                this.cellResolution = ae(O, p);
                var P = fe(O, p);
                this.effectiveFrameRate = P.effectiveFrameRate, this.tickRate = P.tickRate, this.aspectRatio = ne(O, p);
                var k = Y(O, i.ns_ttp, "timeBase");
                k !== null && k !== "media" && ue(p, "Unsupported time base");
                var X = Q(O, p);
                X === null ? this.pxDimensions = { h: 480, w: 640 } : ((X.h.unit !== "px" || X.w.unit !== "px") && ue(p, "Extent on TT must be in px or absent"), this.pxDimensions = { h: X.h.value, w: X.w.value });
              }, T.prototype._registerEvent = function(O) {
                if (!(O.end <= O.begin)) {
                  var p = te(this.events, O.begin);
                  if (p.found || this.events.splice(p.index, 0, O.begin), O.end !== Number.POSITIVE_INFINITY) {
                    var P = te(this.events, O.end);
                    P.found || this.events.splice(P.index, 0, O.end);
                  }
                }
              }, T.prototype.getMediaTimeRange = function() {
                return [this.events[0], this.events[this.events.length - 1]];
              }, T.prototype.getMediaTimeEvents = function() {
                return this.events;
              };
              function S() {
                this.styling = null, this.layout = null;
              }
              function h() {
                this.styles = {};
              }
              function _() {
                this.id = null, this.styleAttrs = null, this.styleRefs = null;
              }
              _.prototype.initFromNode = function(O, p) {
                this.id = H(O), this.styleAttrs = K(O, p), this.styleRefs = ie(O);
              };
              function L() {
                this.regions = {};
              }
              function v(O) {
                this.kind = O;
              }
              function c(O) {
                this.id = O;
              }
              c.prototype.initFromNode = function(O, p, P, k) {
                this.id = H(P);
              };
              function o(O) {
                this.regionID = O;
              }
              o.prototype.initFromNode = function(O, p, P, k) {
                this.regionID = z(P);
              };
              function y(O) {
                this.styleAttrs = O;
              }
              y.prototype.initFromNode = function(O, p, P, k) {
                this.styleAttrs = K(P, k), O.head !== null && O.head.styling !== null && ge(O.head.styling, ie(P), this.styleAttrs, k);
              };
              function u(O) {
                this.sets = O;
              }
              u.prototype.initFromNode = function(O, p, P, k) {
                this.sets = [];
              };
              function A(O) {
                this.contents = O;
              }
              A.prototype.initFromNode = function(O, p, P, k) {
                this.contents = [];
              };
              function I(O, p, P) {
                this.explicit_begin = O, this.explicit_end = p, this.explicit_dur = P;
              }
              I.prototype.initFromNode = function(O, p, P, k) {
                var X = de(O, p, P, k);
                this.explicit_begin = X.explicit_begin, this.explicit_end = X.explicit_end, this.explicit_dur = X.explicit_dur, this.timeContainer = Z(P, k);
              };
              function M() {
                v.call(this, "body");
              }
              M.prototype.initFromNode = function(O, p, P) {
                y.prototype.initFromNode.call(this, O, null, p, P), I.prototype.initFromNode.call(this, O, null, p, P), u.prototype.initFromNode.call(this, O, null, p, P), o.prototype.initFromNode.call(this, O, null, p, P), A.prototype.initFromNode.call(this, O, null, p, P);
              };
              function E() {
                v.call(this, "div");
              }
              E.prototype.initFromNode = function(O, p, P, k) {
                y.prototype.initFromNode.call(this, O, p, P, k), I.prototype.initFromNode.call(this, O, p, P, k), u.prototype.initFromNode.call(this, O, p, P, k), o.prototype.initFromNode.call(this, O, p, P, k), A.prototype.initFromNode.call(this, O, p, P, k);
              };
              function N() {
                v.call(this, "p");
              }
              N.prototype.initFromNode = function(O, p, P, k) {
                y.prototype.initFromNode.call(this, O, p, P, k), I.prototype.initFromNode.call(this, O, p, P, k), u.prototype.initFromNode.call(this, O, p, P, k), o.prototype.initFromNode.call(this, O, p, P, k), A.prototype.initFromNode.call(this, O, p, P, k);
              };
              function C() {
                v.call(this, "span");
              }
              C.prototype.initFromNode = function(O, p, P, k, X) {
                y.prototype.initFromNode.call(this, O, p, P, X), I.prototype.initFromNode.call(this, O, p, P, X), u.prototype.initFromNode.call(this, O, p, P, X), o.prototype.initFromNode.call(this, O, p, P, X), A.prototype.initFromNode.call(this, O, p, P, X), this.space = k;
              };
              function b() {
                v.call(this, "span");
              }
              b.prototype.initFromText = function(O, p, P, k, X) {
                I.prototype.initFromNode.call(this, O, p, null, X), this.text = P, this.space = k;
              };
              function w() {
                v.call(this, "br");
              }
              w.prototype.initFromNode = function(O, p, P, k) {
                o.prototype.initFromNode.call(this, O, p, P, k), I.prototype.initFromNode.call(this, O, p, P, k);
              };
              function V() {
              }
              V.prototype.createDefaultRegion = function() {
                var O = new V();
                return c.call(O, ""), y.call(O, {}), u.call(O, []), I.call(O, 0, Number.POSITIVE_INFINITY, null), O;
              }, V.prototype.initFromNode = function(O, p, P) {
                c.prototype.initFromNode.call(this, O, null, p, P), y.prototype.initFromNode.call(this, O, null, p, P), I.prototype.initFromNode.call(this, O, null, p, P), u.prototype.initFromNode.call(this, O, null, p, P), O.head !== null && O.head.styling !== null && ge(O.head.styling, ie(p), this.styleAttrs, P);
              };
              function J() {
              }
              J.prototype.initFromNode = function(O, p, P, k) {
                I.prototype.initFromNode.call(this, O, p, P, k);
                var X = K(P, k);
                this.qname = null, this.value = null;
                for (var F in X) {
                  if (this.qname) {
                    re(k, "More than one style specified on set");
                    break;
                  }
                  this.qname = F, this.value = X[F];
                }
              };
              function H(O) {
                return O && "xml:id" in O.attributes && O.attributes["xml:id"].value || null;
              }
              function z(O) {
                return O && "region" in O.attributes ? O.attributes.region.value : "";
              }
              function Z(O, p) {
                var P = O && "timeContainer" in O.attributes ? O.attributes.timeContainer.value : null;
                return !P || P === "par" ? "par" : P === "seq" ? "seq" : (re(p, "Illegal value of timeContainer (assuming 'par')"), "par");
              }
              function ie(O) {
                return O && "style" in O.attributes ? O.attributes.style.value.split(" ") : [];
              }
              function K(O, p) {
                var P = {};
                if (O !== null)
                  for (var k in O.attributes) {
                    var X = O.attributes[k].uri + " " + O.attributes[k].local, F = r.byQName[X];
                    if (F !== void 0) {
                      var x = F.parse(O.attributes[k].value);
                      x !== null ? (P[X] = x, F === r.byName.zIndex && ee(p, "zIndex attribute present but not used by IMSC1 since regions do not overlap")) : re(p, "Cannot parse styling attribute " + X + " --> " + O.attributes[k].value);
                    }
                  }
                return P;
              }
              function Y(O, p, P) {
                for (var k in O.attributes)
                  if (O.attributes[k].uri === p && O.attributes[k].local === P)
                    return O.attributes[k].value;
                return null;
              }
              function ne(O, p) {
                var P = Y(O, i.ns_ittp, "aspectRatio"), k = null;
                if (P !== null) {
                  var X = /(\d+) (\d+)/, F = X.exec(P);
                  if (F !== null) {
                    var x = parseInt(F[1]), W = parseInt(F[2]);
                    x !== 0 && W !== 0 ? k = x / W : re(p, "Illegal aspectRatio values (ignoring)");
                  } else
                    re(p, "Malformed aspectRatio attribute (ignoring)");
                }
                return k;
              }
              function ae(O, p) {
                var P = Y(O, i.ns_ttp, "cellResolution"), k = 15, X = 32;
                if (P !== null) {
                  var F = /(\d+) (\d+)/, x = F.exec(P);
                  x !== null ? (X = parseInt(x[1]), k = parseInt(x[2])) : ee(p, "Malformed cellResolution value (using initial value instead)");
                }
                return { w: X, h: k };
              }
              function fe(O, p) {
                var P = Y(O, i.ns_ttp, "frameRate"), k = 30, X;
                if (P !== null) {
                  var F = /(\d+)/;
                  X = F.exec(P), X !== null ? k = parseInt(X[1]) : ee(p, "Malformed frame rate attribute (using initial value instead)");
                }
                var x = Y(O, i.ns_ttp, "frameRateMultiplier"), W = 1;
                if (x !== null) {
                  var $ = /(\d+) (\d+)/;
                  X = $.exec(x), X !== null ? W = parseInt(X[1]) / parseInt(X[2]) : ee(p, "Malformed frame rate multiplier attribute (using initial value instead)");
                }
                var ce = W * k, le = 1, q = Y(O, i.ns_ttp, "tickRate");
                if (q === null)
                  P !== null && (le = ce);
                else {
                  var _e = /(\d+)/;
                  X = _e.exec(q), X !== null ? le = parseInt(X[1]) : ee(p, "Malformed tick rate attribute (using initial value instead)");
                }
                return { effectiveFrameRate: ce, tickRate: le };
              }
              function Q(O, p) {
                var P = Y(O, i.ns_tts, "extent");
                if (P === null)
                  return null;
                var k = P.split(" ");
                if (k.length !== 2)
                  return ee(p, "Malformed extent (ignoring)"), null;
                var X = l.parseLength(k[0]), F = l.parseLength(k[1]);
                return !F || !X ? (ee(p, "Malformed extent values (ignoring)"), null) : { h: F, w: X };
              }
              function oe(O, p, P) {
                var k = /^(\d{2,}):(\d\d):(\d\d(?:\.\d+)?)$/, X = /^(\d{2,}):(\d\d):(\d\d)\:(\d{2,})$/, F = /^(\d+(?:\.\d+)?)f$/, x = /^(\d+(?:\.\d+)?)t$/, W = /^(\d+(?:\.\d+)?)ms$/, $ = /^(\d+(?:\.\d+)?)s$/, ce = /^(\d+(?:\.\d+)?)h$/, le = /^(\d+(?:\.\d+)?)m$/, q, _e = null;
                return (q = F.exec(P)) !== null ? p !== null && (_e = parseFloat(q[1]) / p) : (q = x.exec(P)) !== null ? O !== null && (_e = parseFloat(q[1]) / O) : (q = W.exec(P)) !== null ? _e = parseFloat(q[1]) / 1e3 : (q = $.exec(P)) !== null ? _e = parseFloat(q[1]) : (q = ce.exec(P)) !== null ? _e = parseFloat(q[1]) * 3600 : (q = le.exec(P)) !== null ? _e = parseFloat(q[1]) * 60 : (q = k.exec(P)) !== null ? _e = parseInt(q[1]) * 3600 + parseInt(q[2]) * 60 + parseFloat(q[3]) : (q = X.exec(P)) !== null && p !== null && (_e = parseInt(q[1]) * 3600 + parseInt(q[2]) * 60 + parseInt(q[3]) + (q[4] === null ? 0 : parseInt(q[4]) / p)), _e;
              }
              function de(O, p, P, k) {
                var X = null;
                P && "begin" in P.attributes && (X = oe(O.tickRate, O.effectiveFrameRate, P.attributes.begin.value), X === null && ee(k, "Malformed begin value " + P.attributes.begin.value + " (using 0)"));
                var F = null;
                P && "dur" in P.attributes && (F = oe(O.tickRate, O.effectiveFrameRate, P.attributes.dur.value), F === null && ee(k, "Malformed dur value " + P.attributes.dur.value + " (ignoring)"));
                var x = null;
                return P && "end" in P.attributes && (x = oe(O.tickRate, O.effectiveFrameRate, P.attributes.end.value), x === null && ee(k, "Malformed end value (ignoring)")), {
                  explicit_begin: X,
                  explicit_end: x,
                  explicit_dur: F
                };
              }
              function Me(O, p, P) {
                for (; p.styleRefs.length > 0; ) {
                  var k = p.styleRefs.pop();
                  if (!(k in O.styles)) {
                    re(P, "Non-existant style id referenced");
                    continue;
                  }
                  Me(O, O.styles[k], P), se(O.styles[k].styleAttrs, p.styleAttrs);
                }
              }
              function ge(O, p, P, k) {
                for (var X = p.length - 1; X >= 0; X--) {
                  var F = p[X];
                  if (!(F in O.styles)) {
                    re(k, "Non-existant style id referenced");
                    continue;
                  }
                  se(O.styles[F].styleAttrs, P);
                }
              }
              function se(O, p) {
                for (var P in O)
                  P in p || (p[P] = O[P]);
              }
              function ee(O, p) {
                if (O && O.warn && O.warn(p))
                  throw p;
              }
              function re(O, p) {
                if (O && O.error && O.error(p))
                  throw p;
              }
              function ue(O, p) {
                throw O && O.fatal && O.fatal(p), p;
              }
              function te(O, p) {
                for (var P = 0, k = O.length - 1, X; P <= k; ) {
                  X = Math.floor((P + k) / 2);
                  var F = O[X];
                  if (F < p)
                    P = X + 1;
                  else if (F > p)
                    k = X - 1;
                  else
                    return { found: !0, index: X };
                }
                return { found: !1, index: P };
              }
            })(
              m,
              typeof sax > "u" ? e(
                /*! sax */
                "./node_modules/sax/lib/sax.js"
              ) : sax,
              typeof imscNames > "u" ? e(
                /*! ./names */
                "./node_modules/imsc/src/main/js/names.js"
              ) : imscNames,
              typeof imscStyles > "u" ? e(
                /*! ./styles */
                "./node_modules/imsc/src/main/js/styles.js"
              ) : imscStyles,
              typeof imscUtils > "u" ? e(
                /*! ./utils */
                "./node_modules/imsc/src/main/js/utils.js"
              ) : imscUtils
            );
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/html.js": (
          /*!***********************************************!*\
            !*** ./node_modules/imsc/src/main/js/html.js ***!
            \***********************************************/
          /***/
          (R, m, e) => {
            (function(g, n, i) {
              g.render = function(u, A, I, M, E, N, C, b, w) {
                var V = M || A.clientHeight, J = E || A.clientWidth;
                if (u.aspectRatio !== null) {
                  var H = V * u.aspectRatio;
                  H > J ? V = Math.round(J / u.aspectRatio) : J = H;
                }
                var z = document.createElement("div");
                z.style.position = "relative", z.style.width = J + "px", z.style.height = V + "px", z.style.margin = "auto", z.style.top = 0, z.style.bottom = 0, z.style.left = 0, z.style.right = 0, z.style.zIndex = 0;
                var Z = {
                  h: V,
                  w: J,
                  regionH: null,
                  regionW: null,
                  imgResolver: I,
                  displayForcedOnlyMode: N || !1,
                  isd: u,
                  errorHandler: C,
                  previousISDState: b,
                  enableRollUp: w || !1,
                  currentISDState: {},
                  flg: null,
                  /* current fillLineGap value if active, null otherwise */
                  lp: null,
                  /* current linePadding value if active, null otherwise */
                  mra: null,
                  /* current multiRowAlign value if active, null otherwise */
                  ipd: null,
                  /* inline progression direction (lr, rl, tb) */
                  bpd: null
                  /* block progression direction (lr, rl, tb) */
                };
                A.appendChild(z);
                for (var ie in u.contents)
                  r(Z, z, u.contents[ie]);
                return Z.currentISDState;
              };
              function r(u, A, I) {
                var M;
                if (I.kind === "region" ? (M = document.createElement("div"), M.style.position = "absolute") : I.kind === "body" || I.kind === "div" ? M = document.createElement("div") : I.kind === "p" ? M = document.createElement("p") : I.kind === "span" ? M = document.createElement("span") : I.kind === "br" && (M = document.createElement("br")), !M) {
                  y(u.errorHandler, "Error processing ISD element kind: " + I.kind);
                  return;
                }
                M.style.margin = "0";
                for (var E in v) {
                  var N = v[E], C = I.styleAttrs[N.qname];
                  C !== void 0 && N.map !== null && N.map(u, M, I, C);
                }
                var b = M;
                if (I.kind === "region") {
                  var w = I.styleAttrs[i.byName.writingMode.qname];
                  w === "lrtb" || w === "lr" ? (u.ipd = "lr", u.bpd = "tb") : w === "rltb" || w === "rl" ? (u.ipd = "rl", u.bpd = "tb") : w === "tblr" ? (u.ipd = "tb", u.bpd = "lr") : (w === "tbrl" || w === "tb") && (u.ipd = "tb", u.bpd = "rl");
                }
                var V = I.styleAttrs[i.byName.linePadding.qname];
                if (V && V > 0) {
                  var J = Math.ceil(V * u.h) + "px";
                  u.bpd === "tb" ? (b.style.paddingLeft = J, b.style.paddingRight = J) : (b.style.paddingTop = J, b.style.paddingBottom = J), u.lp = V;
                }
                var H = I.styleAttrs[i.byName.multiRowAlign.qname];
                if (H && H !== "auto") {
                  var z = document.createElement("span");
                  z.style.display = "inline-block", z.style.textAlign = H, M.appendChild(z), b = z, u.mra = H;
                }
                if (I.styleAttrs[i.byName.fillLineGap.qname] && (u.flg = !0), I.kind === "span" && I.text)
                  if (u.lp || u.mra || u.flg)
                    for (var Z = "", ie = 0; ie < I.text.length; ie++) {
                      Z += I.text.charAt(ie);
                      var K = I.text.charCodeAt(ie);
                      if (K < 55296 || K > 56319 || ie === I.text.length) {
                        var Y = document.createElement("span");
                        Y.textContent = Z, M.appendChild(Y), Z = "";
                      }
                    }
                  else
                    M.textContent = I.text;
                A.appendChild(M);
                for (var ne in I.contents)
                  r(u, b, I.contents[ne]);
                var ae = [];
                if ((u.lp || u.mra || u.flg) && I.kind === "p" && (h(u, b, ae, null), u.mra && (d(ae), u.mra = null), u.lp && (l(ae, u.lp * u.h, u), u.lp = null), u.flg)) {
                  var fe = S(b.getBoundingClientRect(), u);
                  t(ae, fe.before, fe.after, u), u.flg = null;
                }
                if (I.kind === "region" && (h(u, b, ae), u.bpd === "tb" && u.enableRollUp && I.contents.length > 0 && I.styleAttrs[i.byName.displayAlign.qname] === "after")) {
                  var Q = I.id === "" ? "_" : I.id, oe = new T(Q, ae);
                  if (u.currentISDState[oe.id] = oe, u.previousISDState && oe.id in u.previousISDState && u.previousISDState[oe.id].plist.length > 0 && oe.plist.length > 1 && oe.plist[oe.plist.length - 2].text === u.previousISDState[oe.id].plist[u.previousISDState[oe.id].plist.length - 1].text) {
                    var de = M.firstElementChild, Me = oe.plist[oe.plist.length - 1].after - oe.plist[oe.plist.length - 1].before;
                    de.style.bottom = "-" + Me + "px", de.style.transition = "transform 0.4s", de.style.position = "relative", de.style.transform = "translateY(-" + Me + "px)";
                  }
                }
              }
              function l(u, A, I) {
                for (var M in u) {
                  var E = u[M].elements.length, N = u[M].elements[u[M].start_elem], C = u[M].elements[u[M].end_elem], b = Math.ceil(A) + "px", w = "-" + Math.ceil(A) + "px";
                  E !== 0 && (I.ipd === "lr" ? (N.node.style.borderLeftColor = N.bgcolor || "#00000000", N.node.style.borderLeftStyle = "solid", N.node.style.borderLeftWidth = b, N.node.style.marginLeft = w) : I.ipd === "rl" ? (N.node.style.borderRightColor = N.bgcolor || "#00000000", N.node.style.borderRightStyle = "solid", N.node.style.borderRightWidth = b, N.node.style.marginRight = w) : I.ipd === "tb" && (N.node.style.borderTopColor = N.bgcolor || "#00000000", N.node.style.borderTopStyle = "solid", N.node.style.borderTopWidth = b, N.node.style.marginTop = w), I.ipd === "lr" ? (C.node.style.borderRightColor = C.bgcolor || "#00000000", C.node.style.borderRightStyle = "solid", C.node.style.borderRightWidth = b, C.node.style.marginRight = w) : I.ipd === "rl" ? (C.node.style.borderLeftColor = C.bgcolor || "#00000000", C.node.style.borderLeftStyle = "solid", C.node.style.borderLeftWidth = b, C.node.style.marginLeft = w) : I.ipd === "tb" && (C.node.style.borderBottomColor = C.bgcolor || "#00000000", C.node.style.borderBottomStyle = "solid", C.node.style.borderBottomWidth = b, C.node.style.marginBottom = w));
                }
              }
              function d(u) {
                for (var A = 0; A < u.length - 1; A++) {
                  var I = u[A].elements.length;
                  if (I !== 0 && u[A].br === !1) {
                    var M = document.createElement("br"), E = u[A].elements[I - 1].node;
                    E.parentElement.insertBefore(M, E.nextSibling);
                  }
                }
              }
              function t(u, A, I, M) {
                for (var E = Math.sign(I - A), N = 0; N <= u.length; N++) {
                  var C;
                  N === 0 ? C = A : N === u.length ? C = I : C = (u[N].before + u[N - 1].after) / 2;
                  var b, w;
                  if (N > 0)
                    for (var V = 0; V < u[N - 1].elements.length; V++)
                      u[N - 1].elements[V].bgcolor !== null && (w = u[N - 1].elements[V], E * (w.after - C) < 0 && (b = Math.ceil(Math.abs(C - w.after)) + "px", w.node.style.backgroundColor = w.bgcolor, M.bpd === "lr" ? w.node.style.paddingRight = b : M.bpd === "rl" ? w.node.style.paddingLeft = b : M.bpd === "tb" && (w.node.style.paddingBottom = b)));
                  if (N < u.length)
                    for (var J = 0; J < u[N].elements.length; J++)
                      w = u[N].elements[J], w.bgcolor !== null && E * (w.before - C) > 0 && (b = Math.ceil(Math.abs(w.before - C)) + "px", w.node.style.backgroundColor = w.bgcolor, M.bpd === "lr" ? w.node.style.paddingLeft = b : M.bpd === "rl" ? w.node.style.paddingRight = b : M.bpd === "tb" && (w.node.style.paddingTop = b));
                }
              }
              function T(u, A) {
                this.id = u, this.plist = A;
              }
              function S(u, A) {
                var I = { before: null, after: null, start: null, end: null };
                return A.bpd === "tb" ? (I.before = u.top, I.after = u.bottom, A.ipd === "lr" ? (I.start = u.left, I.end = u.right) : (I.start = u.right, I.end = u.left)) : A.bpd === "lr" ? (I.before = u.left, I.after = u.right, I.start = u.top, I.end = u.bottom) : A.bpd === "rl" && (I.before = u.right, I.after = u.left, I.start = u.top, I.end = u.bottom), I;
              }
              function h(u, A, I, M) {
                var E = A.style.backgroundColor || M;
                if (A.childElementCount === 0)
                  if (A.localName === "span") {
                    var N = A.getBoundingClientRect();
                    if (N.height === 0 || N.width === 0)
                      return;
                    var C = S(N, u);
                    if (I.length === 0 || !_(C.before, C.after, I[I.length - 1].before, I[I.length - 1].after))
                      I.push({
                        before: C.before,
                        after: C.after,
                        start: C.start,
                        end: C.end,
                        start_elem: 0,
                        end_elem: 0,
                        elements: [],
                        text: "",
                        br: !1
                      });
                    else {
                      var b = Math.sign(C.after - C.before), w = Math.sign(C.end - C.start);
                      b * (C.before - I[I.length - 1].before) < 0 && (I[I.length - 1].before = C.before), b * (C.after - I[I.length - 1].after) > 0 && (I[I.length - 1].after = C.after), w * (C.start - I[I.length - 1].start) < 0 && (I[I.length - 1].start = C.start, I[I.length - 1].start_elem = I[I.length - 1].elements.length), w * (C.end - I[I.length - 1].end) > 0 && (I[I.length - 1].end = C.end, I[I.length - 1].end_elem = I[I.length - 1].elements.length);
                    }
                    I[I.length - 1].text += A.textContent, I[I.length - 1].elements.push(
                      {
                        node: A,
                        bgcolor: E,
                        before: C.before,
                        after: C.after
                      }
                    );
                  } else
                    A.localName === "br" && I.length !== 0 && (I[I.length - 1].br = !0);
                else
                  for (var V = A.firstChild; V; )
                    V.nodeType === Node.ELEMENT_NODE && h(u, V, I, E), V = V.nextSibling;
              }
              function _(u, A, I, M) {
                return A < M && u > I || M <= A && I >= u;
              }
              function L(u, A) {
                this.qname = u, this.map = A;
              }
              var v = [
                new L(
                  "http://www.w3.org/ns/ttml#styling backgroundColor",
                  function(u, A, I, M) {
                    M[3] !== 0 && (A.style.backgroundColor = "rgba(" + M[0].toString() + "," + M[1].toString() + "," + M[2].toString() + "," + (M[3] / 255).toString() + ")");
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling color",
                  function(u, A, I, M) {
                    A.style.color = "rgba(" + M[0].toString() + "," + M[1].toString() + "," + M[2].toString() + "," + (M[3] / 255).toString() + ")";
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling direction",
                  function(u, A, I, M) {
                    A.style.direction = M;
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling display",
                  function(u, A, I, M) {
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling displayAlign",
                  function(u, A, I, M) {
                    A.style.display = "flex", A.style.flexDirection = "column", M === "before" ? A.style.justifyContent = "flex-start" : M === "center" ? A.style.justifyContent = "center" : M === "after" && (A.style.justifyContent = "flex-end");
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling extent",
                  function(u, A, I, M) {
                    u.regionH = M.h * u.h, u.regionW = M.w * u.w;
                    var E = 0, N = 0, C = I.styleAttrs["http://www.w3.org/ns/ttml#styling padding"];
                    C && (E = (C[0] + C[2]) * u.h, N = (C[1] + C[3]) * u.w), A.style.height = u.regionH - E + "px", A.style.width = u.regionW - N + "px";
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling fontFamily",
                  function(u, A, I, M) {
                    var E = [];
                    for (var N in M)
                      M[N] === "monospaceSerif" ? (E.push("Courier New"), E.push('"Liberation Mono"'), E.push("Courier"), E.push("monospace")) : M[N] === "proportionalSansSerif" ? (E.push("Arial"), E.push("Helvetica"), E.push('"Liberation Sans"'), E.push("sans-serif")) : M[N] === "monospace" ? E.push("monospace") : M[N] === "sansSerif" ? E.push("sans-serif") : M[N] === "serif" ? E.push("serif") : M[N] === "monospaceSansSerif" ? (E.push("Consolas"), E.push("monospace")) : M[N] === "proportionalSerif" ? E.push("serif") : E.push(M[N]);
                    A.style.fontFamily = E.join(",");
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling fontSize",
                  function(u, A, I, M) {
                    A.style.fontSize = M * u.h + "px";
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling fontStyle",
                  function(u, A, I, M) {
                    A.style.fontStyle = M;
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling fontWeight",
                  function(u, A, I, M) {
                    A.style.fontWeight = M;
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling lineHeight",
                  function(u, A, I, M) {
                    M === "normal" ? A.style.lineHeight = "normal" : A.style.lineHeight = M * u.h + "px";
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling opacity",
                  function(u, A, I, M) {
                    A.style.opacity = M;
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling origin",
                  function(u, A, I, M) {
                    A.style.top = M.h * u.h + "px", A.style.left = M.w * u.w + "px";
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling overflow",
                  function(u, A, I, M) {
                    A.style.overflow = M;
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling padding",
                  function(u, A, I, M) {
                    var E = [];
                    E[0] = M[0] * u.h + "px", E[1] = M[3] * u.w + "px", E[2] = M[2] * u.h + "px", E[3] = M[1] * u.w + "px", A.style.padding = E.join(" ");
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling showBackground",
                  null
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling textAlign",
                  function(u, A, I, M) {
                    var E, N = I.styleAttrs[i.byName.direction.qname];
                    M === "start" ? E = N === "rtl" ? "right" : "left" : M === "end" ? E = N === "rtl" ? "left" : "right" : E = M, A.style.textAlign = E;
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling textDecoration",
                  function(u, A, I, M) {
                    A.style.textDecoration = M.join(" ").replace("lineThrough", "line-through");
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling textOutline",
                  function(u, A, I, M) {
                    M === "none" ? A.style.textShadow = "" : A.style.textShadow = "rgba(" + M.color[0].toString() + "," + M.color[1].toString() + "," + M.color[2].toString() + "," + (M.color[3] / 255).toString() + ") 0px 0px " + M.thickness * u.h + "px";
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling unicodeBidi",
                  function(u, A, I, M) {
                    var E;
                    M === "bidiOverride" ? E = "bidi-override" : E = M, A.style.unicodeBidi = E;
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling visibility",
                  function(u, A, I, M) {
                    A.style.visibility = M;
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling wrapOption",
                  function(u, A, I, M) {
                    M === "wrap" ? I.space === "preserve" ? A.style.whiteSpace = "pre-wrap" : A.style.whiteSpace = "normal" : I.space === "preserve" ? A.style.whiteSpace = "pre" : A.style.whiteSpace = "noWrap";
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling writingMode",
                  function(u, A, I, M) {
                    M === "lrtb" || M === "lr" || M === "rltb" || M === "rl" ? A.style.writingMode = "horizontal-tb" : M === "tblr" ? A.style.writingMode = "vertical-lr" : (M === "tbrl" || M === "tb") && (A.style.writingMode = "vertical-rl");
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml#styling zIndex",
                  function(u, A, I, M) {
                    A.style.zIndex = M;
                  }
                ),
                new L(
                  "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt backgroundImage",
                  function(u, A, I, M) {
                    if (u.imgResolver !== null && M !== null) {
                      var E = document.createElement("img"), N = u.imgResolver(M, E);
                      N && (E.src = N), E.height = u.regionH, E.width = u.regionW, A.appendChild(E);
                    }
                  }
                ),
                new L(
                  "http://www.w3.org/ns/ttml/profile/imsc1#styling forcedDisplay",
                  function(u, A, I, M) {
                    u.displayForcedOnlyMode && M === !1 && (A.style.visibility = "hidden");
                  }
                )
              ], c = {};
              for (var o in v)
                c[v[o].qname] = v[o];
              function y(u, A) {
                if (u && u.error && u.error(A))
                  throw A;
              }
            })(
              m,
              typeof imscNames > "u" ? e(
                /*! ./names */
                "./node_modules/imsc/src/main/js/names.js"
              ) : imscNames,
              typeof imscStyles > "u" ? e(
                /*! ./styles */
                "./node_modules/imsc/src/main/js/styles.js"
              ) : imscStyles
            );
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/isd.js": (
          /*!**********************************************!*\
            !*** ./node_modules/imsc/src/main/js/isd.js ***!
            \**********************************************/
          /***/
          (R, m, e) => {
            (function(g, n, i) {
              g.generateISD = function(h, _, L) {
                var v = new t(h), c = {
                  /* empty for now */
                };
                for (var o in h.head.layout.regions) {
                  var y = r(h, _, h.head.layout.regions[o], h.body, null, "", h.head.layout.regions[o], L, c);
                  y !== null && v.contents.push(y.element);
                }
                return v;
              };
              function r(h, _, L, v, c, o, y, u, A) {
                if (_ < y.begin || _ >= y.end)
                  return null;
                var I = "regionID" in y && y.regionID !== "" ? y.regionID : o;
                if (c !== null && I !== L.id && (!("contents" in y) || "contents" in y && y.contents.length === 0 || I !== ""))
                  return null;
                var M = new T(y);
                for (var E in y.sets)
                  _ < y.sets[E].begin || _ >= y.sets[E].end || (M.styleAttrs[y.sets[E].qname] = y.sets[E].value);
                var N = {};
                for (var C in M.styleAttrs)
                  if (N[C] = !0, C === i.byName.writingMode.qname && !(i.byName.direction.qname in M.styleAttrs)) {
                    var b = M.styleAttrs[C];
                    b === "lrtb" || b === "lr" ? M.styleAttrs[i.byName.direction.qname] = "ltr" : (b === "rltb" || b === "rl") && (M.styleAttrs[i.byName.direction.qname] = "rtl");
                  }
                if (c !== null)
                  for (var w in i.all) {
                    var V = i.all[w];
                    if (V.qname === i.byName.textDecoration.qname) {
                      var J = c.styleAttrs[V.qname], H = M.styleAttrs[V.qname], z = [];
                      H === void 0 ? z = J : H.indexOf("none") === -1 ? ((H.indexOf("noUnderline") === -1 && J.indexOf("underline") !== -1 || H.indexOf("underline") !== -1) && z.push("underline"), (H.indexOf("noLineThrough") === -1 && J.indexOf("lineThrough") !== -1 || H.indexOf("lineThrough") !== -1) && z.push("lineThrough"), (H.indexOf("noOverline") === -1 && J.indexOf("overline") !== -1 || H.indexOf("overline") !== -1) && z.push("overline")) : z.push("none"), M.styleAttrs[V.qname] = z;
                    } else
                      V.inherit && V.qname in c.styleAttrs && !(V.qname in M.styleAttrs) && (M.styleAttrs[V.qname] = c.styleAttrs[V.qname]);
                  }
                for (var Z in i.all) {
                  var ie = i.all[Z];
                  ie.qname in M.styleAttrs || (M.kind === "region" || ie.inherit === !1 && ie.initial !== null) && (M.styleAttrs[ie.qname] = ie.parse(ie.initial), N[ie.qname] = !0);
                }
                for (var K in i.all) {
                  var Y = i.all[K];
                  if (Y.qname in N && Y.compute !== null) {
                    var ne = Y.compute(
                      /*doc, parent, element, attr, context*/
                      h,
                      c,
                      M,
                      M.styleAttrs[Y.qname],
                      A
                    );
                    ne !== null ? M.styleAttrs[Y.qname] = ne : S(u, "Style '" + Y.qname + "' on element '" + M.kind + "' cannot be computed");
                  }
                }
                if (M.styleAttrs[i.byName.display.qname] === "none")
                  return null;
                var ae;
                c === null ? v === null ? ae = [] : ae = [v] : "contents" in y && (ae = y.contents);
                for (var fe in ae) {
                  var Q = r(h, _, L, v, M, I, ae[fe], u, A);
                  Q !== null && M.contents.push(Q.element);
                }
                for (var oe in M.styleAttrs) {
                  var de = i.byQName[oe];
                  de.applies.indexOf(M.kind) === -1 && delete M.styleAttrs[oe];
                }
                if (M.kind === "span" && M.text && M.space === "default") {
                  var Me = M.text.replace(/\s+/g, " ");
                  M.text = Me;
                }
                if (M.kind === "p") {
                  var ge = [];
                  l(M, ge);
                  for (var se = 0, ee = "after_br", re = 0; ; )
                    if (ee === "after_br")
                      se >= ge.length || ge[se].kind === "br" ? (ee = "before_br", re = se, se--) : (ge[se].space !== "preserve" && (ge[se].text = ge[se].text.replace(/^\s+/g, "")), ge[se].text.length > 0 ? (ee = "looking_br", se++) : ge.splice(se, 1));
                    else if (ee === "before_br")
                      if (se < 0 || ge[se].kind === "br") {
                        if (ee = "after_br", se = re + 1, se >= ge.length)
                          break;
                      } else if (ge[se].space !== "preserve" && (ge[se].text = ge[se].text.replace(/\s+$/g, "")), ge[se].text.length > 0) {
                        if (ee = "after_br", se = re + 1, se >= ge.length)
                          break;
                      } else
                        ge.splice(se, 1), se--;
                    else
                      se >= ge.length || ge[se].kind === "br" ? (ee = "before_br", re = se, se--) : se++;
                  d(M);
                }
                return M.kind === "div" && i.byName.backgroundImage.qname in M.styleAttrs || M.kind === "br" || "contents" in M && M.contents.length > 0 || M.kind === "span" && M.text !== null || M.kind === "region" && M.styleAttrs[i.byName.showBackground.qname] === "always" ? {
                  region_id: I,
                  element: M
                } : null;
              }
              function l(h, _) {
                if ("contents" in h)
                  for (var L in h.contents)
                    l(h.contents[L], _);
                else
                  _.push(h);
              }
              function d(h) {
                if (h.kind === "br")
                  return !1;
                if ("text" in h)
                  return h.text.length === 0;
                if ("contents" in h) {
                  for (var _ = h.contents.length; _--; )
                    d(h.contents[_]) && h.contents.splice(_, 1);
                  return h.contents.length === 0;
                }
              }
              function t(h) {
                this.contents = [], this.aspectRatio = h.aspectRatio;
              }
              function T(h) {
                this.kind = h.kind || "region", h.id && (this.id = h.id), this.styleAttrs = {};
                for (var _ in h.styleAttrs)
                  this.styleAttrs[_] = h.styleAttrs[_];
                "text" in h ? this.text = h.text : h.kind !== "br" && (this.contents = []), "space" in h && (this.space = h.space);
              }
              function S(h, _) {
                if (h && h.error && h.error(_))
                  throw _;
              }
            })(
              m,
              typeof imscNames > "u" ? e(
                /*! ./names */
                "./node_modules/imsc/src/main/js/names.js"
              ) : imscNames,
              typeof imscStyles > "u" ? e(
                /*! ./styles */
                "./node_modules/imsc/src/main/js/styles.js"
              ) : imscStyles
            );
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/main.js": (
          /*!***********************************************!*\
            !*** ./node_modules/imsc/src/main/js/main.js ***!
            \***********************************************/
          /***/
          (R, m, e) => {
            m.generateISD = e(
              /*! ./isd */
              "./node_modules/imsc/src/main/js/isd.js"
            ).generateISD, m.fromXML = e(
              /*! ./doc */
              "./node_modules/imsc/src/main/js/doc.js"
            ).fromXML, m.renderHTML = e(
              /*! ./html */
              "./node_modules/imsc/src/main/js/html.js"
            ).render;
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/names.js": (
          /*!************************************************!*\
            !*** ./node_modules/imsc/src/main/js/names.js ***!
            \************************************************/
          /***/
          (R, m) => {
            (function(e) {
              e.ns_tt = "http://www.w3.org/ns/ttml", e.ns_tts = "http://www.w3.org/ns/ttml#styling", e.ns_ttp = "http://www.w3.org/ns/ttml#parameter", e.ns_xml = "http://www.w3.org/XML/1998/namespace", e.ns_itts = "http://www.w3.org/ns/ttml/profile/imsc1#styling", e.ns_ittp = "http://www.w3.org/ns/ttml/profile/imsc1#parameter", e.ns_smpte = "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt", e.ns_ebutts = "urn:ebu:tt:style";
            })(m);
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/styles.js": (
          /*!*************************************************!*\
            !*** ./node_modules/imsc/src/main/js/styles.js ***!
            \*************************************************/
          /***/
          (R, m, e) => {
            (function(g, n, i) {
              function r(t, T, S, h, _, L, v, c) {
                this.name = T, this.ns = t, this.qname = t + " " + T, this.inherit = _, this.animatable = L, this.initial = S, this.applies = h, this.parse = v, this.compute = c;
              }
              g.all = [
                new r(
                  n.ns_tts,
                  "backgroundColor",
                  "transparent",
                  ["body", "div", "p", "region", "span"],
                  !1,
                  !0,
                  i.parseColor,
                  null
                ),
                new r(
                  n.ns_tts,
                  "color",
                  "white",
                  ["span"],
                  !0,
                  !0,
                  i.parseColor,
                  null
                ),
                new r(
                  n.ns_tts,
                  "direction",
                  "ltr",
                  ["p", "span"],
                  !0,
                  !0,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "display",
                  "auto",
                  ["body", "div", "p", "region", "span"],
                  !1,
                  !0,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "displayAlign",
                  "before",
                  ["region"],
                  !1,
                  !0,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "extent",
                  "auto",
                  ["tt", "region"],
                  !1,
                  !0,
                  function(t) {
                    if (t === "auto")
                      return t;
                    var T = t.split(" ");
                    if (T.length !== 2)
                      return null;
                    var S = i.parseLength(T[0]), h = i.parseLength(T[1]);
                    return !h || !S ? null : { h, w: S };
                  },
                  function(t, T, S, h, _) {
                    var L, v;
                    if (h === "auto")
                      L = 1;
                    else if (h.h.unit === "%")
                      L = h.h.value / 100;
                    else if (h.h.unit === "px")
                      L = h.h.value / t.pxDimensions.h;
                    else
                      return null;
                    if (h === "auto")
                      v = 1;
                    else if (h.w.unit === "%")
                      v = h.w.value / 100;
                    else if (h.w.unit === "px")
                      v = h.w.value / t.pxDimensions.w;
                    else
                      return null;
                    return { h: L, w: v };
                  }
                ),
                new r(
                  n.ns_tts,
                  "fontFamily",
                  "default",
                  ["span"],
                  !0,
                  !0,
                  function(t) {
                    var T = t.split(","), S = [];
                    for (var h in T)
                      T[h].charAt(0) !== "'" && T[h].charAt(0) !== '"' && T[h] === "default" ? S.push("monospaceSerif") : S.push(T[h]);
                    return S;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "fontSize",
                  "1c",
                  ["span"],
                  !0,
                  !0,
                  i.parseLength,
                  function(t, T, S, h, _) {
                    var L;
                    if (h.unit === "%")
                      T !== null ? L = T.styleAttrs[g.byName.fontSize.qname] * h.value / 100 : L = h.value / 100 / t.cellResolution.h;
                    else if (h.unit === "em")
                      T !== null ? L = T.styleAttrs[g.byName.fontSize.qname] * h.value : L = h.value / t.cellResolution.h;
                    else if (h.unit === "c")
                      L = h.value / t.cellResolution.h;
                    else if (h.unit === "px")
                      L = h.value / t.pxDimensions.h;
                    else
                      return null;
                    return L;
                  }
                ),
                new r(
                  n.ns_tts,
                  "fontStyle",
                  "normal",
                  ["span"],
                  !0,
                  !0,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "fontWeight",
                  "normal",
                  ["span"],
                  !0,
                  !0,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "lineHeight",
                  "normal",
                  ["p"],
                  !0,
                  !0,
                  function(t) {
                    return t === "normal" ? t : i.parseLength(t);
                  },
                  function(t, T, S, h, _) {
                    var L;
                    if (h === "normal")
                      L = h;
                    else if (h.unit === "%")
                      L = S.styleAttrs[g.byName.fontSize.qname] * h.value / 100;
                    else if (h.unit === "em")
                      L = S.styleAttrs[g.byName.fontSize.qname] * h.value;
                    else if (h.unit === "c")
                      L = h.value / t.cellResolution.h;
                    else if (h.unit === "px")
                      L = h.value / t.pxDimensions.h;
                    else
                      return null;
                    return L;
                  }
                ),
                new r(
                  n.ns_tts,
                  "opacity",
                  1,
                  ["region"],
                  !1,
                  !0,
                  parseFloat,
                  null
                ),
                new r(
                  n.ns_tts,
                  "origin",
                  "auto",
                  ["region"],
                  !1,
                  !0,
                  function(t) {
                    if (t === "auto")
                      return t;
                    var T = t.split(" ");
                    if (T.length !== 2)
                      return null;
                    var S = i.parseLength(T[0]), h = i.parseLength(T[1]);
                    return !h || !S ? null : { h, w: S };
                  },
                  function(t, T, S, h, _) {
                    var L, v;
                    if (h === "auto")
                      L = 0;
                    else if (h.h.unit === "%")
                      L = h.h.value / 100;
                    else if (h.h.unit === "px")
                      L = h.h.value / t.pxDimensions.h;
                    else
                      return null;
                    if (h === "auto")
                      v = 0;
                    else if (h.w.unit === "%")
                      v = h.w.value / 100;
                    else if (h.w.unit === "px")
                      v = h.w.value / t.pxDimensions.w;
                    else
                      return null;
                    return { h: L, w: v };
                  }
                ),
                new r(
                  n.ns_tts,
                  "overflow",
                  "hidden",
                  ["region"],
                  !1,
                  !0,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "padding",
                  "0px",
                  ["region"],
                  !1,
                  !0,
                  function(t) {
                    var T = t.split(" ");
                    if (T.length > 4)
                      return null;
                    var S = [];
                    for (var h in T) {
                      var _ = i.parseLength(T[h]);
                      if (!_)
                        return null;
                      S.push(_);
                    }
                    return S;
                  },
                  function(t, T, S, h, _) {
                    var L;
                    if (h.length === 1)
                      L = [h[0], h[0], h[0], h[0]];
                    else if (h.length === 2)
                      L = [h[0], h[1], h[0], h[1]];
                    else if (h.length === 3)
                      L = [h[0], h[1], h[2], h[1]];
                    else if (h.length === 4)
                      L = [h[0], h[1], h[2], h[3]];
                    else
                      return null;
                    var v = S.styleAttrs[g.byName.writingMode.qname];
                    if (v === "lrtb" || v === "lr")
                      L = [L[0], L[3], L[2], L[1]];
                    else if (v === "rltb" || v === "rl")
                      L = [L[0], L[1], L[2], L[3]];
                    else if (v === "tblr")
                      L = [L[3], L[0], L[1], L[2]];
                    else if (v === "tbrl" || v === "tb")
                      L = [L[3], L[2], L[1], L[0]];
                    else
                      return null;
                    var c = [];
                    for (var o in L)
                      if (L[o].value === 0)
                        c[o] = 0;
                      else if (L[o].unit === "%")
                        o === "0" || o === "2" ? c[o] = S.styleAttrs[g.byName.extent.qname].h * L[o].value / 100 : c[o] = S.styleAttrs[g.byName.extent.qname].w * L[o].value / 100;
                      else if (L[o].unit === "em")
                        c[o] = S.styleAttrs[g.byName.fontSize.qname] * L[o].value;
                      else if (L[o].unit === "c")
                        c[o] = L[o].value / t.cellResolution.h;
                      else if (L[o].unit === "px")
                        o === "0" || o === "2" ? c[o] = L[o].value / t.pxDimensions.h : c[o] = L[o].value / t.pxDimensions.w;
                      else
                        return null;
                    return c;
                  }
                ),
                new r(
                  n.ns_tts,
                  "showBackground",
                  "always",
                  ["region"],
                  !1,
                  !0,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "textAlign",
                  "start",
                  ["p"],
                  !0,
                  !0,
                  function(t) {
                    return t;
                  },
                  function(t, T, S, h, _) {
                    return h === "left" ? "start" : h === "right" ? "end" : h;
                  }
                ),
                new r(
                  n.ns_tts,
                  "textDecoration",
                  "none",
                  ["span"],
                  !0,
                  !0,
                  function(t) {
                    return t.split(" ");
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "textOutline",
                  "none",
                  ["span"],
                  !0,
                  !0,
                  function(t) {
                    if (t === "none")
                      return t;
                    var T = {}, S = t.split(" ");
                    if (S.length === 0 || S.length > 2)
                      return null;
                    var h = i.parseColor(S[0]);
                    if (T.color = h, h !== null && S.shift(), S.length !== 1)
                      return null;
                    var _ = i.parseLength(S[0]);
                    return _ ? (T.thickness = _, T) : null;
                  },
                  function(t, T, S, h, _) {
                    if (h === "none")
                      return h;
                    var L = {};
                    if (h.color === null ? L.color = S.styleAttrs[g.byName.color.qname] : L.color = h.color, h.thickness.unit === "%")
                      L.thickness = S.styleAttrs[g.byName.fontSize.qname] * h.thickness.value / 100;
                    else if (h.thickness.unit === "em")
                      L.thickness = S.styleAttrs[g.byName.fontSize.qname] * h.thickness.value;
                    else if (h.thickness.unit === "c")
                      L.thickness = h.thickness.value / t.cellResolution.h;
                    else if (h.thickness.unit === "px")
                      L.thickness = h.thickness.value / t.pxDimensions.h;
                    else
                      return null;
                    return L;
                  }
                ),
                new r(
                  n.ns_tts,
                  "unicodeBidi",
                  "normal",
                  ["span", "p"],
                  !1,
                  !0,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "visibility",
                  "visible",
                  ["body", "div", "p", "region", "span"],
                  !0,
                  !0,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "wrapOption",
                  "wrap",
                  ["span"],
                  !0,
                  !0,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "writingMode",
                  "lrtb",
                  ["region"],
                  !1,
                  !0,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_tts,
                  "zIndex",
                  "auto",
                  ["region"],
                  !1,
                  !0,
                  function(t) {
                    var T;
                    return t === "auto" ? T = t : (T = parseInt(t), isNaN(T) && (T = null)), T;
                  },
                  null
                ),
                new r(
                  n.ns_ebutts,
                  "linePadding",
                  "0c",
                  ["p"],
                  !0,
                  !1,
                  i.parseLength,
                  function(t, T, S, h, _) {
                    return h.unit === "c" ? h.value / t.cellResolution.h : null;
                  }
                ),
                new r(
                  n.ns_ebutts,
                  "multiRowAlign",
                  "auto",
                  ["p"],
                  !0,
                  !1,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_smpte,
                  "backgroundImage",
                  null,
                  ["div"],
                  !1,
                  !1,
                  function(t) {
                    return t;
                  },
                  null
                ),
                new r(
                  n.ns_itts,
                  "forcedDisplay",
                  "false",
                  ["body", "div", "p", "region", "span"],
                  !0,
                  !0,
                  function(t) {
                    return t === "true";
                  },
                  null
                ),
                new r(
                  n.ns_itts,
                  "fillLineGap",
                  "false",
                  ["p"],
                  !0,
                  !0,
                  function(t) {
                    return t === "true";
                  },
                  null
                )
              ], g.byQName = {};
              for (var l in g.all)
                g.byQName[g.all[l].qname] = g.all[l];
              g.byName = {};
              for (var d in g.all)
                g.byName[g.all[d].name] = g.all[d];
            })(
              m,
              typeof imscNames > "u" ? e(
                /*! ./names */
                "./node_modules/imsc/src/main/js/names.js"
              ) : imscNames,
              typeof imscUtils > "u" ? e(
                /*! ./utils */
                "./node_modules/imsc/src/main/js/utils.js"
              ) : imscUtils
            );
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/utils.js": (
          /*!************************************************!*\
            !*** ./node_modules/imsc/src/main/js/utils.js ***!
            \************************************************/
          /***/
          (R, m) => {
            (function(e) {
              var g = /#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?/, n = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, i = /rgba\(\s*(\d+),\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, r = {
                transparent: [0, 0, 0, 0],
                black: [0, 0, 0, 255],
                silver: [192, 192, 192, 255],
                gray: [128, 128, 128, 255],
                white: [255, 255, 255, 255],
                maroon: [128, 0, 0, 255],
                red: [255, 0, 0, 255],
                purple: [128, 0, 128, 255],
                fuchsia: [255, 0, 255, 255],
                magenta: [255, 0, 255, 255],
                green: [0, 128, 0, 255],
                lime: [0, 255, 0, 255],
                olive: [128, 128, 0, 255],
                yellow: [255, 255, 0, 255],
                navy: [0, 0, 128, 255],
                blue: [0, 0, 255, 255],
                teal: [0, 128, 128, 255],
                aqua: [0, 255, 255, 255],
                cyan: [0, 255, 255, 255]
              };
              e.parseColor = function(d) {
                var t, T = null, S = r[d.toLowerCase()];
                return S !== void 0 ? T = S : (t = g.exec(d)) !== null ? T = [
                  parseInt(t[1], 16),
                  parseInt(t[2], 16),
                  parseInt(t[3], 16),
                  t[4] !== void 0 ? parseInt(t[4], 16) : 255
                ] : (t = n.exec(d)) !== null ? T = [
                  parseInt(t[1]),
                  parseInt(t[2]),
                  parseInt(t[3]),
                  255
                ] : (t = i.exec(d)) !== null && (T = [
                  parseInt(t[1]),
                  parseInt(t[2]),
                  parseInt(t[3]),
                  parseInt(t[4])
                ]), T;
              };
              var l = /^((?:\+|\-)?\d*(?:\.\d+)?)(px|em|c|%)$/;
              e.parseLength = function(d) {
                var t, T = null;
                return (t = l.exec(d)) !== null && (T = { value: parseFloat(t[1]), unit: t[2] }), T;
              };
            })(m);
          }
        ),
        /***/
        "./node_modules/is-alphabetical/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/is-alphabetical/index.js ***!
            \***********************************************/
          /***/
          (R) => {
            R.exports = m;
            function m(e) {
              var g = typeof e == "string" ? e.charCodeAt(0) : e;
              return g >= 97 && g <= 122 || g >= 65 && g <= 90;
            }
          }
        ),
        /***/
        "./node_modules/is-alphanumerical/index.js": (
          /*!*************************************************!*\
            !*** ./node_modules/is-alphanumerical/index.js ***!
            \*************************************************/
          /***/
          (R, m, e) => {
            var g = e(
              /*! is-alphabetical */
              "./node_modules/is-alphabetical/index.js"
            ), n = e(
              /*! is-decimal */
              "./node_modules/is-decimal/index.js"
            );
            R.exports = i;
            function i(r) {
              return g(r) || n(r);
            }
          }
        ),
        /***/
        "./node_modules/is-decimal/index.js": (
          /*!******************************************!*\
            !*** ./node_modules/is-decimal/index.js ***!
            \******************************************/
          /***/
          (R) => {
            R.exports = m;
            function m(e) {
              var g = typeof e == "string" ? e.charCodeAt(0) : e;
              return g >= 48 && g <= 57;
            }
          }
        ),
        /***/
        "./node_modules/path-browserify/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/path-browserify/index.js ***!
            \***********************************************/
          /***/
          (R) => {
            function m(i) {
              if (typeof i != "string")
                throw new TypeError("Path must be a string. Received " + JSON.stringify(i));
            }
            function e(i, r) {
              for (var l = "", d = 0, t = -1, T = 0, S, h = 0; h <= i.length; ++h) {
                if (h < i.length)
                  S = i.charCodeAt(h);
                else {
                  if (S === 47)
                    break;
                  S = 47;
                }
                if (S === 47) {
                  if (!(t === h - 1 || T === 1))
                    if (t !== h - 1 && T === 2) {
                      if (l.length < 2 || d !== 2 || l.charCodeAt(l.length - 1) !== 46 || l.charCodeAt(l.length - 2) !== 46) {
                        if (l.length > 2) {
                          var _ = l.lastIndexOf("/");
                          if (_ !== l.length - 1) {
                            _ === -1 ? (l = "", d = 0) : (l = l.slice(0, _), d = l.length - 1 - l.lastIndexOf("/")), t = h, T = 0;
                            continue;
                          }
                        } else if (l.length === 2 || l.length === 1) {
                          l = "", d = 0, t = h, T = 0;
                          continue;
                        }
                      }
                      r && (l.length > 0 ? l += "/.." : l = "..", d = 2);
                    } else
                      l.length > 0 ? l += "/" + i.slice(t + 1, h) : l = i.slice(t + 1, h), d = h - t - 1;
                  t = h, T = 0;
                } else
                  S === 46 && T !== -1 ? ++T : T = -1;
              }
              return l;
            }
            function g(i, r) {
              var l = r.dir || r.root, d = r.base || (r.name || "") + (r.ext || "");
              return l ? l === r.root ? l + d : l + i + d : d;
            }
            var n = {
              // path.resolve([from ...], to)
              resolve: function() {
                for (var r = "", l = !1, d, t = arguments.length - 1; t >= -1 && !l; t--) {
                  var T;
                  t >= 0 ? T = arguments[t] : (d === void 0 && (d = process.cwd()), T = d), m(T), T.length !== 0 && (r = T + "/" + r, l = T.charCodeAt(0) === 47);
                }
                return r = e(r, !l), l ? r.length > 0 ? "/" + r : "/" : r.length > 0 ? r : ".";
              },
              normalize: function(r) {
                if (m(r), r.length === 0)
                  return ".";
                var l = r.charCodeAt(0) === 47, d = r.charCodeAt(r.length - 1) === 47;
                return r = e(r, !l), r.length === 0 && !l && (r = "."), r.length > 0 && d && (r += "/"), l ? "/" + r : r;
              },
              isAbsolute: function(r) {
                return m(r), r.length > 0 && r.charCodeAt(0) === 47;
              },
              join: function() {
                if (arguments.length === 0)
                  return ".";
                for (var r, l = 0; l < arguments.length; ++l) {
                  var d = arguments[l];
                  m(d), d.length > 0 && (r === void 0 ? r = d : r += "/" + d);
                }
                return r === void 0 ? "." : n.normalize(r);
              },
              relative: function(r, l) {
                if (m(r), m(l), r === l || (r = n.resolve(r), l = n.resolve(l), r === l))
                  return "";
                for (var d = 1; d < r.length && r.charCodeAt(d) === 47; ++d)
                  ;
                for (var t = r.length, T = t - d, S = 1; S < l.length && l.charCodeAt(S) === 47; ++S)
                  ;
                for (var h = l.length, _ = h - S, L = T < _ ? T : _, v = -1, c = 0; c <= L; ++c) {
                  if (c === L) {
                    if (_ > L) {
                      if (l.charCodeAt(S + c) === 47)
                        return l.slice(S + c + 1);
                      if (c === 0)
                        return l.slice(S + c);
                    } else
                      T > L && (r.charCodeAt(d + c) === 47 ? v = c : c === 0 && (v = 0));
                    break;
                  }
                  var o = r.charCodeAt(d + c), y = l.charCodeAt(S + c);
                  if (o !== y)
                    break;
                  o === 47 && (v = c);
                }
                var u = "";
                for (c = d + v + 1; c <= t; ++c)
                  (c === t || r.charCodeAt(c) === 47) && (u.length === 0 ? u += ".." : u += "/..");
                return u.length > 0 ? u + l.slice(S + v) : (S += v, l.charCodeAt(S) === 47 && ++S, l.slice(S));
              },
              _makeLong: function(r) {
                return r;
              },
              dirname: function(r) {
                if (m(r), r.length === 0)
                  return ".";
                for (var l = r.charCodeAt(0), d = l === 47, t = -1, T = !0, S = r.length - 1; S >= 1; --S)
                  if (l = r.charCodeAt(S), l === 47) {
                    if (!T) {
                      t = S;
                      break;
                    }
                  } else
                    T = !1;
                return t === -1 ? d ? "/" : "." : d && t === 1 ? "//" : r.slice(0, t);
              },
              basename: function(r, l) {
                if (l !== void 0 && typeof l != "string")
                  throw new TypeError('"ext" argument must be a string');
                m(r);
                var d = 0, t = -1, T = !0, S;
                if (l !== void 0 && l.length > 0 && l.length <= r.length) {
                  if (l.length === r.length && l === r)
                    return "";
                  var h = l.length - 1, _ = -1;
                  for (S = r.length - 1; S >= 0; --S) {
                    var L = r.charCodeAt(S);
                    if (L === 47) {
                      if (!T) {
                        d = S + 1;
                        break;
                      }
                    } else
                      _ === -1 && (T = !1, _ = S + 1), h >= 0 && (L === l.charCodeAt(h) ? --h === -1 && (t = S) : (h = -1, t = _));
                  }
                  return d === t ? t = _ : t === -1 && (t = r.length), r.slice(d, t);
                } else {
                  for (S = r.length - 1; S >= 0; --S)
                    if (r.charCodeAt(S) === 47) {
                      if (!T) {
                        d = S + 1;
                        break;
                      }
                    } else
                      t === -1 && (T = !1, t = S + 1);
                  return t === -1 ? "" : r.slice(d, t);
                }
              },
              extname: function(r) {
                m(r);
                for (var l = -1, d = 0, t = -1, T = !0, S = 0, h = r.length - 1; h >= 0; --h) {
                  var _ = r.charCodeAt(h);
                  if (_ === 47) {
                    if (!T) {
                      d = h + 1;
                      break;
                    }
                    continue;
                  }
                  t === -1 && (T = !1, t = h + 1), _ === 46 ? l === -1 ? l = h : S !== 1 && (S = 1) : l !== -1 && (S = -1);
                }
                return l === -1 || t === -1 || // We saw a non-dot character immediately before the dot
                S === 0 || // The (right-most) trimmed path component is exactly '..'
                S === 1 && l === t - 1 && l === d + 1 ? "" : r.slice(l, t);
              },
              format: function(r) {
                if (r === null || typeof r != "object")
                  throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof r);
                return g("/", r);
              },
              parse: function(r) {
                m(r);
                var l = { root: "", dir: "", base: "", ext: "", name: "" };
                if (r.length === 0)
                  return l;
                var d = r.charCodeAt(0), t = d === 47, T;
                t ? (l.root = "/", T = 1) : T = 0;
                for (var S = -1, h = 0, _ = -1, L = !0, v = r.length - 1, c = 0; v >= T; --v) {
                  if (d = r.charCodeAt(v), d === 47) {
                    if (!L) {
                      h = v + 1;
                      break;
                    }
                    continue;
                  }
                  _ === -1 && (L = !1, _ = v + 1), d === 46 ? S === -1 ? S = v : c !== 1 && (c = 1) : S !== -1 && (c = -1);
                }
                return S === -1 || _ === -1 || // We saw a non-dot character immediately before the dot
                c === 0 || // The (right-most) trimmed path component is exactly '..'
                c === 1 && S === _ - 1 && S === h + 1 ? _ !== -1 && (h === 0 && t ? l.base = l.name = r.slice(1, _) : l.base = l.name = r.slice(h, _)) : (h === 0 && t ? (l.name = r.slice(1, S), l.base = r.slice(1, _)) : (l.name = r.slice(h, S), l.base = r.slice(h, _)), l.ext = r.slice(S, _)), h > 0 ? l.dir = r.slice(0, h - 1) : t && (l.dir = "/"), l;
              },
              sep: "/",
              delimiter: ":",
              win32: null,
              posix: null
            };
            n.posix = n, R.exports = n;
          }
        ),
        /***/
        "./node_modules/safe-buffer/index.js": (
          /*!*******************************************!*\
            !*** ./node_modules/safe-buffer/index.js ***!
            \*******************************************/
          /***/
          (R, m, e) => {
            var g = e(
              /*! buffer */
              "./node_modules/buffer/index.js"
            ), n = g.Buffer;
            function i(l, d) {
              for (var t in l)
                d[t] = l[t];
            }
            n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? R.exports = g : (i(g, m), m.Buffer = r);
            function r(l, d, t) {
              return n(l, d, t);
            }
            i(n, r), r.from = function(l, d, t) {
              if (typeof l == "number")
                throw new TypeError("Argument must not be a number");
              return n(l, d, t);
            }, r.alloc = function(l, d, t) {
              if (typeof l != "number")
                throw new TypeError("Argument must be a number");
              var T = n(l);
              return d !== void 0 ? typeof t == "string" ? T.fill(d, t) : T.fill(d) : T.fill(0), T;
            }, r.allocUnsafe = function(l) {
              if (typeof l != "number")
                throw new TypeError("Argument must be a number");
              return n(l);
            }, r.allocUnsafeSlow = function(l) {
              if (typeof l != "number")
                throw new TypeError("Argument must be a number");
              return g.SlowBuffer(l);
            };
          }
        ),
        /***/
        "./node_modules/sax/lib/sax.js": (
          /*!*************************************!*\
            !*** ./node_modules/sax/lib/sax.js ***!
            \*************************************/
          /***/
          (R, m, e) => {
            (function(g) {
              g.parser = function(O, p) {
                return new i(O, p);
              }, g.SAXParser = i, g.SAXStream = h, g.createStream = S, g.MAX_BUFFER_LENGTH = 65536;
              var n = [
                "comment",
                "sgmlDecl",
                "textNode",
                "tagName",
                "doctype",
                "procInstName",
                "procInstBody",
                "entity",
                "attribName",
                "attribValue",
                "cdata",
                "script"
              ];
              g.EVENTS = [
                "text",
                "processinginstruction",
                "sgmldeclaration",
                "doctype",
                "comment",
                "opentagstart",
                "attribute",
                "opentag",
                "closetag",
                "opencdata",
                "cdata",
                "closecdata",
                "error",
                "end",
                "ready",
                "script",
                "opennamespace",
                "closenamespace"
              ];
              function i(O, p) {
                if (!(this instanceof i))
                  return new i(O, p);
                var P = this;
                l(P), P.q = P.c = "", P.bufferCheckPosition = g.MAX_BUFFER_LENGTH, P.opt = p || {}, P.opt.lowercase = P.opt.lowercase || P.opt.lowercasetags, P.looseCase = P.opt.lowercase ? "toLowerCase" : "toUpperCase", P.tags = [], P.closed = P.closedRoot = P.sawRoot = !1, P.tag = P.error = null, P.strict = !!O, P.noscript = !!(O || P.opt.noscript), P.state = z.BEGIN, P.strictEntities = P.opt.strictEntities, P.ENTITIES = P.strictEntities ? Object.create(g.XML_ENTITIES) : Object.create(g.ENTITIES), P.attribList = [], P.opt.xmlns && (P.ns = Object.create(M)), P.trackPosition = P.opt.position !== !1, P.trackPosition && (P.position = P.line = P.column = 0), ie(P, "onready");
              }
              Object.create || (Object.create = function(O) {
                function p() {
                }
                p.prototype = O;
                var P = new p();
                return P;
              }), Object.keys || (Object.keys = function(O) {
                var p = [];
                for (var P in O)
                  O.hasOwnProperty(P) && p.push(P);
                return p;
              });
              function r(O) {
                for (var p = Math.max(g.MAX_BUFFER_LENGTH, 10), P = 0, k = 0, X = n.length; k < X; k++) {
                  var F = O[n[k]].length;
                  if (F > p)
                    switch (n[k]) {
                      case "textNode":
                        Y(O);
                        break;
                      case "cdata":
                        K(O, "oncdata", O.cdata), O.cdata = "";
                        break;
                      case "script":
                        K(O, "onscript", O.script), O.script = "";
                        break;
                      default:
                        ae(O, "Max buffer length exceeded: " + n[k]);
                    }
                  P = Math.max(P, F);
                }
                var x = g.MAX_BUFFER_LENGTH - P;
                O.bufferCheckPosition = x + O.position;
              }
              function l(O) {
                for (var p = 0, P = n.length; p < P; p++)
                  O[n[p]] = "";
              }
              function d(O) {
                Y(O), O.cdata !== "" && (K(O, "oncdata", O.cdata), O.cdata = ""), O.script !== "" && (K(O, "onscript", O.script), O.script = "");
              }
              i.prototype = {
                end: function() {
                  fe(this);
                },
                write: te,
                resume: function() {
                  return this.error = null, this;
                },
                close: function() {
                  return this.write(null);
                },
                flush: function() {
                  d(this);
                }
              };
              var t;
              try {
                t = e(
                  /*! stream */
                  "./node_modules/stream-browserify/index.js"
                ).Stream;
              } catch {
                t = function() {
                };
              }
              var T = g.EVENTS.filter(function(O) {
                return O !== "error" && O !== "end";
              });
              function S(O, p) {
                return new h(O, p);
              }
              function h(O, p) {
                if (!(this instanceof h))
                  return new h(O, p);
                t.apply(this), this._parser = new i(O, p), this.writable = !0, this.readable = !0;
                var P = this;
                this._parser.onend = function() {
                  P.emit("end");
                }, this._parser.onerror = function(k) {
                  P.emit("error", k), P._parser.error = null;
                }, this._decoder = null, T.forEach(function(k) {
                  Object.defineProperty(P, "on" + k, {
                    get: function() {
                      return P._parser["on" + k];
                    },
                    set: function(X) {
                      if (!X)
                        return P.removeAllListeners(k), P._parser["on" + k] = X, X;
                      P.on(k, X);
                    },
                    enumerable: !0,
                    configurable: !1
                  });
                });
              }
              h.prototype = Object.create(t.prototype, {
                constructor: {
                  value: h
                }
              }), h.prototype.write = function(O) {
                if (typeof Buffer == "function" && typeof Buffer.isBuffer == "function" && Buffer.isBuffer(O)) {
                  if (!this._decoder) {
                    var p = e(
                      /*! string_decoder */
                      "./node_modules/string_decoder/lib/string_decoder.js"
                    ).StringDecoder;
                    this._decoder = new p("utf8");
                  }
                  O = this._decoder.write(O);
                }
                return this._parser.write(O.toString()), this.emit("data", O), !0;
              }, h.prototype.end = function(O) {
                return O && O.length && this.write(O), this._parser.end(), !0;
              }, h.prototype.on = function(O, p) {
                var P = this;
                return !P._parser["on" + O] && T.indexOf(O) !== -1 && (P._parser["on" + O] = function() {
                  var k = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
                  k.splice(0, 0, O), P.emit.apply(P, k);
                }), t.prototype.on.call(P, O, p);
              };
              var _ = `\r
	 `, L = "0124356789", v = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", c = `'"`, o = _ + ">", y = "[CDATA[", u = "DOCTYPE", A = "http://www.w3.org/XML/1998/namespace", I = "http://www.w3.org/2000/xmlns/", M = { xml: A, xmlns: I };
              _ = w(_), L = w(L), v = w(v);
              var E = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, N = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/, C = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, b = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/;
              c = w(c), o = w(o);
              function w(O) {
                return O.split("").reduce(function(p, P) {
                  return p[P] = !0, p;
                }, {});
              }
              function V(O) {
                return Object.prototype.toString.call(O) === "[object RegExp]";
              }
              function J(O, p) {
                return V(O) ? !!p.match(O) : O[p];
              }
              function H(O, p) {
                return !J(O, p);
              }
              var z = 0;
              g.STATE = {
                BEGIN: z++,
                // leading byte order mark or whitespace
                BEGIN_WHITESPACE: z++,
                // leading whitespace
                TEXT: z++,
                // general stuff
                TEXT_ENTITY: z++,
                // &amp and such.
                OPEN_WAKA: z++,
                // <
                SGML_DECL: z++,
                // <!BLARG
                SGML_DECL_QUOTED: z++,
                // <!BLARG foo "bar
                DOCTYPE: z++,
                // <!DOCTYPE
                DOCTYPE_QUOTED: z++,
                // <!DOCTYPE "//blah
                DOCTYPE_DTD: z++,
                // <!DOCTYPE "//blah" [ ...
                DOCTYPE_DTD_QUOTED: z++,
                // <!DOCTYPE "//blah" [ "foo
                COMMENT_STARTING: z++,
                // <!-
                COMMENT: z++,
                // <!--
                COMMENT_ENDING: z++,
                // <!-- blah -
                COMMENT_ENDED: z++,
                // <!-- blah --
                CDATA: z++,
                // <![CDATA[ something
                CDATA_ENDING: z++,
                // ]
                CDATA_ENDING_2: z++,
                // ]]
                PROC_INST: z++,
                // <?hi
                PROC_INST_BODY: z++,
                // <?hi there
                PROC_INST_ENDING: z++,
                // <?hi "there" ?
                OPEN_TAG: z++,
                // <strong
                OPEN_TAG_SLASH: z++,
                // <strong /
                ATTRIB: z++,
                // <a
                ATTRIB_NAME: z++,
                // <a foo
                ATTRIB_NAME_SAW_WHITE: z++,
                // <a foo _
                ATTRIB_VALUE: z++,
                // <a foo=
                ATTRIB_VALUE_QUOTED: z++,
                // <a foo="bar
                ATTRIB_VALUE_CLOSED: z++,
                // <a foo="bar"
                ATTRIB_VALUE_UNQUOTED: z++,
                // <a foo=bar
                ATTRIB_VALUE_ENTITY_Q: z++,
                // <foo bar="&quot;"
                ATTRIB_VALUE_ENTITY_U: z++,
                // <foo bar=&quot
                CLOSE_TAG: z++,
                // </a
                CLOSE_TAG_SAW_WHITE: z++,
                // </a   >
                SCRIPT: z++,
                // <script> ...
                SCRIPT_ENDING: z++
                // <script> ... <
              }, g.XML_ENTITIES = {
                amp: "&",
                gt: ">",
                lt: "<",
                quot: '"',
                apos: "'"
              }, g.ENTITIES = {
                amp: "&",
                gt: ">",
                lt: "<",
                quot: '"',
                apos: "'",
                AElig: 198,
                Aacute: 193,
                Acirc: 194,
                Agrave: 192,
                Aring: 197,
                Atilde: 195,
                Auml: 196,
                Ccedil: 199,
                ETH: 208,
                Eacute: 201,
                Ecirc: 202,
                Egrave: 200,
                Euml: 203,
                Iacute: 205,
                Icirc: 206,
                Igrave: 204,
                Iuml: 207,
                Ntilde: 209,
                Oacute: 211,
                Ocirc: 212,
                Ograve: 210,
                Oslash: 216,
                Otilde: 213,
                Ouml: 214,
                THORN: 222,
                Uacute: 218,
                Ucirc: 219,
                Ugrave: 217,
                Uuml: 220,
                Yacute: 221,
                aacute: 225,
                acirc: 226,
                aelig: 230,
                agrave: 224,
                aring: 229,
                atilde: 227,
                auml: 228,
                ccedil: 231,
                eacute: 233,
                ecirc: 234,
                egrave: 232,
                eth: 240,
                euml: 235,
                iacute: 237,
                icirc: 238,
                igrave: 236,
                iuml: 239,
                ntilde: 241,
                oacute: 243,
                ocirc: 244,
                ograve: 242,
                oslash: 248,
                otilde: 245,
                ouml: 246,
                szlig: 223,
                thorn: 254,
                uacute: 250,
                ucirc: 251,
                ugrave: 249,
                uuml: 252,
                yacute: 253,
                yuml: 255,
                copy: 169,
                reg: 174,
                nbsp: 160,
                iexcl: 161,
                cent: 162,
                pound: 163,
                curren: 164,
                yen: 165,
                brvbar: 166,
                sect: 167,
                uml: 168,
                ordf: 170,
                laquo: 171,
                not: 172,
                shy: 173,
                macr: 175,
                deg: 176,
                plusmn: 177,
                sup1: 185,
                sup2: 178,
                sup3: 179,
                acute: 180,
                micro: 181,
                para: 182,
                middot: 183,
                cedil: 184,
                ordm: 186,
                raquo: 187,
                frac14: 188,
                frac12: 189,
                frac34: 190,
                iquest: 191,
                times: 215,
                divide: 247,
                OElig: 338,
                oelig: 339,
                Scaron: 352,
                scaron: 353,
                Yuml: 376,
                fnof: 402,
                circ: 710,
                tilde: 732,
                Alpha: 913,
                Beta: 914,
                Gamma: 915,
                Delta: 916,
                Epsilon: 917,
                Zeta: 918,
                Eta: 919,
                Theta: 920,
                Iota: 921,
                Kappa: 922,
                Lambda: 923,
                Mu: 924,
                Nu: 925,
                Xi: 926,
                Omicron: 927,
                Pi: 928,
                Rho: 929,
                Sigma: 931,
                Tau: 932,
                Upsilon: 933,
                Phi: 934,
                Chi: 935,
                Psi: 936,
                Omega: 937,
                alpha: 945,
                beta: 946,
                gamma: 947,
                delta: 948,
                epsilon: 949,
                zeta: 950,
                eta: 951,
                theta: 952,
                iota: 953,
                kappa: 954,
                lambda: 955,
                mu: 956,
                nu: 957,
                xi: 958,
                omicron: 959,
                pi: 960,
                rho: 961,
                sigmaf: 962,
                sigma: 963,
                tau: 964,
                upsilon: 965,
                phi: 966,
                chi: 967,
                psi: 968,
                omega: 969,
                thetasym: 977,
                upsih: 978,
                piv: 982,
                ensp: 8194,
                emsp: 8195,
                thinsp: 8201,
                zwnj: 8204,
                zwj: 8205,
                lrm: 8206,
                rlm: 8207,
                ndash: 8211,
                mdash: 8212,
                lsquo: 8216,
                rsquo: 8217,
                sbquo: 8218,
                ldquo: 8220,
                rdquo: 8221,
                bdquo: 8222,
                dagger: 8224,
                Dagger: 8225,
                bull: 8226,
                hellip: 8230,
                permil: 8240,
                prime: 8242,
                Prime: 8243,
                lsaquo: 8249,
                rsaquo: 8250,
                oline: 8254,
                frasl: 8260,
                euro: 8364,
                image: 8465,
                weierp: 8472,
                real: 8476,
                trade: 8482,
                alefsym: 8501,
                larr: 8592,
                uarr: 8593,
                rarr: 8594,
                darr: 8595,
                harr: 8596,
                crarr: 8629,
                lArr: 8656,
                uArr: 8657,
                rArr: 8658,
                dArr: 8659,
                hArr: 8660,
                forall: 8704,
                part: 8706,
                exist: 8707,
                empty: 8709,
                nabla: 8711,
                isin: 8712,
                notin: 8713,
                ni: 8715,
                prod: 8719,
                sum: 8721,
                minus: 8722,
                lowast: 8727,
                radic: 8730,
                prop: 8733,
                infin: 8734,
                ang: 8736,
                and: 8743,
                or: 8744,
                cap: 8745,
                cup: 8746,
                int: 8747,
                there4: 8756,
                sim: 8764,
                cong: 8773,
                asymp: 8776,
                ne: 8800,
                equiv: 8801,
                le: 8804,
                ge: 8805,
                sub: 8834,
                sup: 8835,
                nsub: 8836,
                sube: 8838,
                supe: 8839,
                oplus: 8853,
                otimes: 8855,
                perp: 8869,
                sdot: 8901,
                lceil: 8968,
                rceil: 8969,
                lfloor: 8970,
                rfloor: 8971,
                lang: 9001,
                rang: 9002,
                loz: 9674,
                spades: 9824,
                clubs: 9827,
                hearts: 9829,
                diams: 9830
              }, Object.keys(g.ENTITIES).forEach(function(O) {
                var p = g.ENTITIES[O], P = typeof p == "number" ? String.fromCharCode(p) : p;
                g.ENTITIES[O] = P;
              });
              for (var Z in g.STATE)
                g.STATE[g.STATE[Z]] = Z;
              z = g.STATE;
              function ie(O, p, P) {
                O[p] && O[p](P);
              }
              function K(O, p, P) {
                O.textNode && Y(O), ie(O, p, P);
              }
              function Y(O) {
                O.textNode = ne(O.opt, O.textNode), O.textNode && ie(O, "ontext", O.textNode), O.textNode = "";
              }
              function ne(O, p) {
                return O.trim && (p = p.trim()), O.normalize && (p = p.replace(/\s+/g, " ")), p;
              }
              function ae(O, p) {
                return Y(O), O.trackPosition && (p += `
Line: ` + O.line + `
Column: ` + O.column + `
Char: ` + O.c), p = new Error(p), O.error = p, ie(O, "onerror", p), O;
              }
              function fe(O) {
                return O.sawRoot && !O.closedRoot && Q(O, "Unclosed root tag"), O.state !== z.BEGIN && O.state !== z.BEGIN_WHITESPACE && O.state !== z.TEXT && ae(O, "Unexpected end"), Y(O), O.c = "", O.closed = !0, ie(O, "onend"), i.call(O, O.strict, O.opt), O;
              }
              function Q(O, p) {
                if (typeof O != "object" || !(O instanceof i))
                  throw new Error("bad call to strictFail");
                O.strict && ae(O, p);
              }
              function oe(O) {
                O.strict || (O.tagName = O.tagName[O.looseCase]());
                var p = O.tags[O.tags.length - 1] || O, P = O.tag = { name: O.tagName, attributes: {} };
                O.opt.xmlns && (P.ns = p.ns), O.attribList.length = 0, K(O, "onopentagstart", P);
              }
              function de(O, p) {
                var P = O.indexOf(":"), k = P < 0 ? ["", O] : O.split(":"), X = k[0], F = k[1];
                return p && O === "xmlns" && (X = "xmlns", F = ""), { prefix: X, local: F };
              }
              function Me(O) {
                if (O.strict || (O.attribName = O.attribName[O.looseCase]()), O.attribList.indexOf(O.attribName) !== -1 || O.tag.attributes.hasOwnProperty(O.attribName)) {
                  O.attribName = O.attribValue = "";
                  return;
                }
                if (O.opt.xmlns) {
                  var p = de(O.attribName, !0), P = p.prefix, k = p.local;
                  if (P === "xmlns")
                    if (k === "xml" && O.attribValue !== A)
                      Q(
                        O,
                        "xml: prefix must be bound to " + A + `
Actual: ` + O.attribValue
                      );
                    else if (k === "xmlns" && O.attribValue !== I)
                      Q(
                        O,
                        "xmlns: prefix must be bound to " + I + `
Actual: ` + O.attribValue
                      );
                    else {
                      var X = O.tag, F = O.tags[O.tags.length - 1] || O;
                      X.ns === F.ns && (X.ns = Object.create(F.ns)), X.ns[k] = O.attribValue;
                    }
                  O.attribList.push([O.attribName, O.attribValue]);
                } else
                  O.tag.attributes[O.attribName] = O.attribValue, K(O, "onattribute", {
                    name: O.attribName,
                    value: O.attribValue
                  });
                O.attribName = O.attribValue = "";
              }
              function ge(O, p) {
                if (O.opt.xmlns) {
                  var P = O.tag, k = de(O.tagName);
                  P.prefix = k.prefix, P.local = k.local, P.uri = P.ns[k.prefix] || "", P.prefix && !P.uri && (Q(O, "Unbound namespace prefix: " + JSON.stringify(O.tagName)), P.uri = k.prefix);
                  var X = O.tags[O.tags.length - 1] || O;
                  P.ns && X.ns !== P.ns && Object.keys(P.ns).forEach(function(Ce) {
                    K(O, "onopennamespace", {
                      prefix: Ce,
                      uri: P.ns[Ce]
                    });
                  });
                  for (var F = 0, x = O.attribList.length; F < x; F++) {
                    var W = O.attribList[F], $ = W[0], ce = W[1], le = de($, !0), q = le.prefix, _e = le.local, Ee = q === "" ? "" : P.ns[q] || "", Te = {
                      name: $,
                      value: ce,
                      prefix: q,
                      local: _e,
                      uri: Ee
                    };
                    q && q !== "xmlns" && !Ee && (Q(O, "Unbound namespace prefix: " + JSON.stringify(q)), Te.uri = q), O.tag.attributes[$] = Te, K(O, "onattribute", Te);
                  }
                  O.attribList.length = 0;
                }
                O.tag.isSelfClosing = !!p, O.sawRoot = !0, O.tags.push(O.tag), K(O, "onopentag", O.tag), p || (!O.noscript && O.tagName.toLowerCase() === "script" ? O.state = z.SCRIPT : O.state = z.TEXT, O.tag = null, O.tagName = ""), O.attribName = O.attribValue = "", O.attribList.length = 0;
              }
              function se(O) {
                if (!O.tagName) {
                  Q(O, "Weird empty close tag."), O.textNode += "</>", O.state = z.TEXT;
                  return;
                }
                if (O.script) {
                  if (O.tagName !== "script") {
                    O.script += "</" + O.tagName + ">", O.tagName = "", O.state = z.SCRIPT;
                    return;
                  }
                  K(O, "onscript", O.script), O.script = "";
                }
                var p = O.tags.length, P = O.tagName;
                O.strict || (P = P[O.looseCase]());
                for (var k = P; p--; ) {
                  var X = O.tags[p];
                  if (X.name !== k)
                    Q(O, "Unexpected close tag");
                  else
                    break;
                }
                if (p < 0) {
                  Q(O, "Unmatched closing tag: " + O.tagName), O.textNode += "</" + O.tagName + ">", O.state = z.TEXT;
                  return;
                }
                O.tagName = P;
                for (var F = O.tags.length; F-- > p; ) {
                  var x = O.tag = O.tags.pop();
                  O.tagName = O.tag.name, K(O, "onclosetag", O.tagName);
                  var W = {};
                  for (var $ in x.ns)
                    W[$] = x.ns[$];
                  var ce = O.tags[O.tags.length - 1] || O;
                  O.opt.xmlns && x.ns !== ce.ns && Object.keys(x.ns).forEach(function(le) {
                    var q = x.ns[le];
                    K(O, "onclosenamespace", { prefix: le, uri: q });
                  });
                }
                p === 0 && (O.closedRoot = !0), O.tagName = O.attribValue = O.attribName = "", O.attribList.length = 0, O.state = z.TEXT;
              }
              function ee(O) {
                var p = O.entity, P = p.toLowerCase(), k, X = "";
                return O.ENTITIES[p] ? O.ENTITIES[p] : O.ENTITIES[P] ? O.ENTITIES[P] : (p = P, p.charAt(0) === "#" && (p.charAt(1) === "x" ? (p = p.slice(2), k = parseInt(p, 16), X = k.toString(16)) : (p = p.slice(1), k = parseInt(p, 10), X = k.toString(10))), p = p.replace(/^0+/, ""), X.toLowerCase() !== p ? (Q(O, "Invalid character entity"), "&" + O.entity + ";") : String.fromCodePoint(k));
              }
              function re(O, p) {
                p === "<" ? (O.state = z.OPEN_WAKA, O.startTagPosition = O.position) : H(_, p) && (Q(O, "Non-whitespace before first tag."), O.textNode = p, O.state = z.TEXT);
              }
              function ue(O, p) {
                var P = "";
                return p < O.length && (P = O.charAt(p)), P;
              }
              function te(O) {
                var p = this;
                if (this.error)
                  throw this.error;
                if (p.closed)
                  return ae(
                    p,
                    "Cannot write after close. Assign an onready handler."
                  );
                if (O === null)
                  return fe(p);
                typeof O == "object" && (O = O.toString());
                for (var P = 0, k = ""; k = ue(O, P++), p.c = k, !!k; )
                  switch (p.trackPosition && (p.position++, k === `
` ? (p.line++, p.column = 0) : p.column++), p.state) {
                    case z.BEGIN:
                      if (p.state = z.BEGIN_WHITESPACE, k === "\uFEFF")
                        continue;
                      re(p, k);
                      continue;
                    case z.BEGIN_WHITESPACE:
                      re(p, k);
                      continue;
                    case z.TEXT:
                      if (p.sawRoot && !p.closedRoot) {
                        for (var X = P - 1; k && k !== "<" && k !== "&"; )
                          k = ue(O, P++), k && p.trackPosition && (p.position++, k === `
` ? (p.line++, p.column = 0) : p.column++);
                        p.textNode += O.substring(X, P - 1);
                      }
                      k === "<" && !(p.sawRoot && p.closedRoot && !p.strict) ? (p.state = z.OPEN_WAKA, p.startTagPosition = p.position) : (H(_, k) && (!p.sawRoot || p.closedRoot) && Q(p, "Text data outside of root node."), k === "&" ? p.state = z.TEXT_ENTITY : p.textNode += k);
                      continue;
                    case z.SCRIPT:
                      k === "<" ? p.state = z.SCRIPT_ENDING : p.script += k;
                      continue;
                    case z.SCRIPT_ENDING:
                      k === "/" ? p.state = z.CLOSE_TAG : (p.script += "<" + k, p.state = z.SCRIPT);
                      continue;
                    case z.OPEN_WAKA:
                      if (k === "!")
                        p.state = z.SGML_DECL, p.sgmlDecl = "";
                      else if (!J(_, k))
                        if (J(E, k))
                          p.state = z.OPEN_TAG, p.tagName = k;
                        else if (k === "/")
                          p.state = z.CLOSE_TAG, p.tagName = "";
                        else if (k === "?")
                          p.state = z.PROC_INST, p.procInstName = p.procInstBody = "";
                        else {
                          if (Q(p, "Unencoded <"), p.startTagPosition + 1 < p.position) {
                            var F = p.position - p.startTagPosition;
                            k = new Array(F).join(" ") + k;
                          }
                          p.textNode += "<" + k, p.state = z.TEXT;
                        }
                      continue;
                    case z.SGML_DECL:
                      (p.sgmlDecl + k).toUpperCase() === y ? (K(p, "onopencdata"), p.state = z.CDATA, p.sgmlDecl = "", p.cdata = "") : p.sgmlDecl + k === "--" ? (p.state = z.COMMENT, p.comment = "", p.sgmlDecl = "") : (p.sgmlDecl + k).toUpperCase() === u ? (p.state = z.DOCTYPE, (p.doctype || p.sawRoot) && Q(
                        p,
                        "Inappropriately located doctype declaration"
                      ), p.doctype = "", p.sgmlDecl = "") : k === ">" ? (K(p, "onsgmldeclaration", p.sgmlDecl), p.sgmlDecl = "", p.state = z.TEXT) : (J(c, k) && (p.state = z.SGML_DECL_QUOTED), p.sgmlDecl += k);
                      continue;
                    case z.SGML_DECL_QUOTED:
                      k === p.q && (p.state = z.SGML_DECL, p.q = ""), p.sgmlDecl += k;
                      continue;
                    case z.DOCTYPE:
                      k === ">" ? (p.state = z.TEXT, K(p, "ondoctype", p.doctype), p.doctype = !0) : (p.doctype += k, k === "[" ? p.state = z.DOCTYPE_DTD : J(c, k) && (p.state = z.DOCTYPE_QUOTED, p.q = k));
                      continue;
                    case z.DOCTYPE_QUOTED:
                      p.doctype += k, k === p.q && (p.q = "", p.state = z.DOCTYPE);
                      continue;
                    case z.DOCTYPE_DTD:
                      p.doctype += k, k === "]" ? p.state = z.DOCTYPE : J(c, k) && (p.state = z.DOCTYPE_DTD_QUOTED, p.q = k);
                      continue;
                    case z.DOCTYPE_DTD_QUOTED:
                      p.doctype += k, k === p.q && (p.state = z.DOCTYPE_DTD, p.q = "");
                      continue;
                    case z.COMMENT:
                      k === "-" ? p.state = z.COMMENT_ENDING : p.comment += k;
                      continue;
                    case z.COMMENT_ENDING:
                      k === "-" ? (p.state = z.COMMENT_ENDED, p.comment = ne(p.opt, p.comment), p.comment && K(p, "oncomment", p.comment), p.comment = "") : (p.comment += "-" + k, p.state = z.COMMENT);
                      continue;
                    case z.COMMENT_ENDED:
                      k !== ">" ? (Q(p, "Malformed comment"), p.comment += "--" + k, p.state = z.COMMENT) : p.state = z.TEXT;
                      continue;
                    case z.CDATA:
                      k === "]" ? p.state = z.CDATA_ENDING : p.cdata += k;
                      continue;
                    case z.CDATA_ENDING:
                      k === "]" ? p.state = z.CDATA_ENDING_2 : (p.cdata += "]" + k, p.state = z.CDATA);
                      continue;
                    case z.CDATA_ENDING_2:
                      k === ">" ? (p.cdata && K(p, "oncdata", p.cdata), K(p, "onclosecdata"), p.cdata = "", p.state = z.TEXT) : k === "]" ? p.cdata += "]" : (p.cdata += "]]" + k, p.state = z.CDATA);
                      continue;
                    case z.PROC_INST:
                      k === "?" ? p.state = z.PROC_INST_ENDING : J(_, k) ? p.state = z.PROC_INST_BODY : p.procInstName += k;
                      continue;
                    case z.PROC_INST_BODY:
                      if (!p.procInstBody && J(_, k))
                        continue;
                      k === "?" ? p.state = z.PROC_INST_ENDING : p.procInstBody += k;
                      continue;
                    case z.PROC_INST_ENDING:
                      k === ">" ? (K(p, "onprocessinginstruction", {
                        name: p.procInstName,
                        body: p.procInstBody
                      }), p.procInstName = p.procInstBody = "", p.state = z.TEXT) : (p.procInstBody += "?" + k, p.state = z.PROC_INST_BODY);
                      continue;
                    case z.OPEN_TAG:
                      J(N, k) ? p.tagName += k : (oe(p), k === ">" ? ge(p) : k === "/" ? p.state = z.OPEN_TAG_SLASH : (H(_, k) && Q(p, "Invalid character in tag name"), p.state = z.ATTRIB));
                      continue;
                    case z.OPEN_TAG_SLASH:
                      k === ">" ? (ge(p, !0), se(p)) : (Q(p, "Forward-slash in opening tag not followed by >"), p.state = z.ATTRIB);
                      continue;
                    case z.ATTRIB:
                      if (J(_, k))
                        continue;
                      k === ">" ? ge(p) : k === "/" ? p.state = z.OPEN_TAG_SLASH : J(E, k) ? (p.attribName = k, p.attribValue = "", p.state = z.ATTRIB_NAME) : Q(p, "Invalid attribute name");
                      continue;
                    case z.ATTRIB_NAME:
                      k === "=" ? p.state = z.ATTRIB_VALUE : k === ">" ? (Q(p, "Attribute without value"), p.attribValue = p.attribName, Me(p), ge(p)) : J(_, k) ? p.state = z.ATTRIB_NAME_SAW_WHITE : J(N, k) ? p.attribName += k : Q(p, "Invalid attribute name");
                      continue;
                    case z.ATTRIB_NAME_SAW_WHITE:
                      if (k === "=")
                        p.state = z.ATTRIB_VALUE;
                      else {
                        if (J(_, k))
                          continue;
                        Q(p, "Attribute without value"), p.tag.attributes[p.attribName] = "", p.attribValue = "", K(p, "onattribute", {
                          name: p.attribName,
                          value: ""
                        }), p.attribName = "", k === ">" ? ge(p) : J(E, k) ? (p.attribName = k, p.state = z.ATTRIB_NAME) : (Q(p, "Invalid attribute name"), p.state = z.ATTRIB);
                      }
                      continue;
                    case z.ATTRIB_VALUE:
                      if (J(_, k))
                        continue;
                      J(c, k) ? (p.q = k, p.state = z.ATTRIB_VALUE_QUOTED) : (Q(p, "Unquoted attribute value"), p.state = z.ATTRIB_VALUE_UNQUOTED, p.attribValue = k);
                      continue;
                    case z.ATTRIB_VALUE_QUOTED:
                      if (k !== p.q) {
                        k === "&" ? p.state = z.ATTRIB_VALUE_ENTITY_Q : p.attribValue += k;
                        continue;
                      }
                      Me(p), p.q = "", p.state = z.ATTRIB_VALUE_CLOSED;
                      continue;
                    case z.ATTRIB_VALUE_CLOSED:
                      J(_, k) ? p.state = z.ATTRIB : k === ">" ? ge(p) : k === "/" ? p.state = z.OPEN_TAG_SLASH : J(E, k) ? (Q(p, "No whitespace between attributes"), p.attribName = k, p.attribValue = "", p.state = z.ATTRIB_NAME) : Q(p, "Invalid attribute name");
                      continue;
                    case z.ATTRIB_VALUE_UNQUOTED:
                      if (H(o, k)) {
                        k === "&" ? p.state = z.ATTRIB_VALUE_ENTITY_U : p.attribValue += k;
                        continue;
                      }
                      Me(p), k === ">" ? ge(p) : p.state = z.ATTRIB;
                      continue;
                    case z.CLOSE_TAG:
                      if (p.tagName)
                        k === ">" ? se(p) : J(N, k) ? p.tagName += k : p.script ? (p.script += "</" + p.tagName, p.tagName = "", p.state = z.SCRIPT) : (H(_, k) && Q(p, "Invalid tagname in closing tag"), p.state = z.CLOSE_TAG_SAW_WHITE);
                      else {
                        if (J(_, k))
                          continue;
                        H(E, k) ? p.script ? (p.script += "</" + k, p.state = z.SCRIPT) : Q(p, "Invalid tagname in closing tag.") : p.tagName = k;
                      }
                      continue;
                    case z.CLOSE_TAG_SAW_WHITE:
                      if (J(_, k))
                        continue;
                      k === ">" ? se(p) : Q(p, "Invalid characters in closing tag");
                      continue;
                    case z.TEXT_ENTITY:
                    case z.ATTRIB_VALUE_ENTITY_Q:
                    case z.ATTRIB_VALUE_ENTITY_U:
                      var x, W;
                      switch (p.state) {
                        case z.TEXT_ENTITY:
                          x = z.TEXT, W = "textNode";
                          break;
                        case z.ATTRIB_VALUE_ENTITY_Q:
                          x = z.ATTRIB_VALUE_QUOTED, W = "attribValue";
                          break;
                        case z.ATTRIB_VALUE_ENTITY_U:
                          x = z.ATTRIB_VALUE_UNQUOTED, W = "attribValue";
                          break;
                      }
                      k === ";" ? (p[W] += ee(p), p.entity = "", p.state = x) : J(p.entity.length ? b : C, k) ? p.entity += k : (Q(p, "Invalid character in entity name"), p[W] += "&" + p.entity + k, p.entity = "", p.state = x);
                      continue;
                    default:
                      throw new Error(p, "Unknown state: " + p.state);
                  }
                return p.position >= p.bufferCheckPosition && r(p), p;
              }
              /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
              String.fromCodePoint || function() {
                var O = String.fromCharCode, p = Math.floor, P = function() {
                  var k = 16384, X = [], F, x, W = -1, $ = arguments.length;
                  if (!$)
                    return "";
                  for (var ce = ""; ++W < $; ) {
                    var le = Number(arguments[W]);
                    if (!isFinite(le) || // `NaN`, `+Infinity`, or `-Infinity`
                    le < 0 || // not a valid Unicode code point
                    le > 1114111 || // not a valid Unicode code point
                    p(le) !== le)
                      throw RangeError("Invalid code point: " + le);
                    le <= 65535 ? X.push(le) : (le -= 65536, F = (le >> 10) + 55296, x = le % 1024 + 56320, X.push(F, x)), (W + 1 === $ || X.length > k) && (ce += O.apply(null, X), X.length = 0);
                  }
                  return ce;
                };
                Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", {
                  value: P,
                  configurable: !0,
                  writable: !0
                }) : String.fromCodePoint = P;
              }();
            })(m);
          }
        ),
        /***/
        "./node_modules/stream-browserify/index.js": (
          /*!*************************************************!*\
            !*** ./node_modules/stream-browserify/index.js ***!
            \*************************************************/
          /***/
          (R, m, e) => {
            R.exports = i;
            var g = e(
              /*! events */
              "./node_modules/events/events.js"
            ).EventEmitter, n = e(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            );
            n(i, g), i.Readable = e(
              /*! readable-stream/lib/_stream_readable.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_readable.js"
            ), i.Writable = e(
              /*! readable-stream/lib/_stream_writable.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_writable.js"
            ), i.Duplex = e(
              /*! readable-stream/lib/_stream_duplex.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
            ), i.Transform = e(
              /*! readable-stream/lib/_stream_transform.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_transform.js"
            ), i.PassThrough = e(
              /*! readable-stream/lib/_stream_passthrough.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_passthrough.js"
            ), i.finished = e(
              /*! readable-stream/lib/internal/streams/end-of-stream.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/end-of-stream.js"
            ), i.pipeline = e(
              /*! readable-stream/lib/internal/streams/pipeline.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/pipeline.js"
            ), i.Stream = i;
            function i() {
              g.call(this);
            }
            i.prototype.pipe = function(r, l) {
              var d = this;
              function t(c) {
                r.writable && r.write(c) === !1 && d.pause && d.pause();
              }
              d.on("data", t);
              function T() {
                d.readable && d.resume && d.resume();
              }
              r.on("drain", T), !r._isStdio && (!l || l.end !== !1) && (d.on("end", h), d.on("close", _));
              var S = !1;
              function h() {
                S || (S = !0, r.end());
              }
              function _() {
                S || (S = !0, typeof r.destroy == "function" && r.destroy());
              }
              function L(c) {
                if (v(), g.listenerCount(this, "error") === 0)
                  throw c;
              }
              d.on("error", L), r.on("error", L);
              function v() {
                d.removeListener("data", t), r.removeListener("drain", T), d.removeListener("end", h), d.removeListener("close", _), d.removeListener("error", L), r.removeListener("error", L), d.removeListener("end", v), d.removeListener("close", v), r.removeListener("close", v);
              }
              return d.on("end", v), d.on("close", v), r.on("close", v), r.emit("pipe", d), r;
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js": (
          /*!**********************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js ***!
            \**********************************************************************************/
          /***/
          (R) => {
            typeof Object.create == "function" ? R.exports = function(e, g) {
              g && (e.super_ = g, e.prototype = Object.create(g.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }));
            } : R.exports = function(e, g) {
              if (g) {
                e.super_ = g;
                var n = function() {
                };
                n.prototype = g.prototype, e.prototype = new n(), e.prototype.constructor = e;
              }
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js": (
          /*!***************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js ***!
            \***************************************************************************************/
          /***/
          (R) => {
            function m(d, t) {
              d.prototype = Object.create(t.prototype), d.prototype.constructor = d, d.__proto__ = t;
            }
            var e = {};
            function g(d, t, T) {
              T || (T = Error);
              function S(_, L, v) {
                return typeof t == "string" ? t : t(_, L, v);
              }
              var h = /* @__PURE__ */ function(_) {
                m(L, _);
                function L(v, c, o) {
                  return _.call(this, S(v, c, o)) || this;
                }
                return L;
              }(T);
              h.prototype.name = T.name, h.prototype.code = d, e[d] = h;
            }
            function n(d, t) {
              if (Array.isArray(d)) {
                var T = d.length;
                return d = d.map(function(S) {
                  return String(S);
                }), T > 2 ? "one of ".concat(t, " ").concat(d.slice(0, T - 1).join(", "), ", or ") + d[T - 1] : T === 2 ? "one of ".concat(t, " ").concat(d[0], " or ").concat(d[1]) : "of ".concat(t, " ").concat(d[0]);
              } else
                return "of ".concat(t, " ").concat(String(d));
            }
            function i(d, t, T) {
              return d.substr(!T || T < 0 ? 0 : +T, t.length) === t;
            }
            function r(d, t, T) {
              return (T === void 0 || T > d.length) && (T = d.length), d.substring(T - t.length, T) === t;
            }
            function l(d, t, T) {
              return typeof T != "number" && (T = 0), T + t.length > d.length ? !1 : d.indexOf(t, T) !== -1;
            }
            g("ERR_INVALID_OPT_VALUE", function(d, t) {
              return 'The value "' + t + '" is invalid for option "' + d + '"';
            }, TypeError), g("ERR_INVALID_ARG_TYPE", function(d, t, T) {
              var S;
              typeof t == "string" && i(t, "not ") ? (S = "must not be", t = t.replace(/^not /, "")) : S = "must be";
              var h;
              if (r(d, " argument"))
                h = "The ".concat(d, " ").concat(S, " ").concat(n(t, "type"));
              else {
                var _ = l(d, ".") ? "property" : "argument";
                h = 'The "'.concat(d, '" ').concat(_, " ").concat(S, " ").concat(n(t, "type"));
              }
              return h += ". Received type ".concat(typeof T), h;
            }, TypeError), g("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), g("ERR_METHOD_NOT_IMPLEMENTED", function(d) {
              return "The " + d + " method is not implemented";
            }), g("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), g("ERR_STREAM_DESTROYED", function(d) {
              return "Cannot call " + d + " after a stream was destroyed";
            }), g("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), g("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), g("ERR_STREAM_WRITE_AFTER_END", "write after end"), g("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), g("ERR_UNKNOWN_ENCODING", function(d) {
              return "Unknown encoding: " + d;
            }, TypeError), g("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), R.exports.codes = e;
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js": (
          /*!*******************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js ***!
            \*******************************************************************************************/
          /***/
          (R, m, e) => {
            var g = Object.keys || function(h) {
              var _ = [];
              for (var L in h)
                _.push(L);
              return _;
            };
            R.exports = t;
            var n = e(
              /*! ./_stream_readable */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_readable.js"
            ), i = e(
              /*! ./_stream_writable */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_writable.js"
            );
            e(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            )(t, n);
            for (var r = g(i.prototype), l = 0; l < r.length; l++) {
              var d = r[l];
              t.prototype[d] || (t.prototype[d] = i.prototype[d]);
            }
            function t(h) {
              if (!(this instanceof t))
                return new t(h);
              n.call(this, h), i.call(this, h), this.allowHalfOpen = !0, h && (h.readable === !1 && (this.readable = !1), h.writable === !1 && (this.writable = !1), h.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", T)));
            }
            Object.defineProperty(t.prototype, "writableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.highWaterMark;
              }
            }), Object.defineProperty(t.prototype, "writableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState && this._writableState.getBuffer();
              }
            }), Object.defineProperty(t.prototype, "writableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.length;
              }
            });
            function T() {
              this._writableState.ended || process.nextTick(S, this);
            }
            function S(h) {
              h.end();
            }
            Object.defineProperty(t.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
              },
              set: function(_) {
                this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = _, this._writableState.destroyed = _);
              }
            });
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_passthrough.js": (
          /*!************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_passthrough.js ***!
            \************************************************************************************************/
          /***/
          (R, m, e) => {
            R.exports = n;
            var g = e(
              /*! ./_stream_transform */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_transform.js"
            );
            e(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            )(n, g);
            function n(i) {
              if (!(this instanceof n))
                return new n(i);
              g.call(this, i);
            }
            n.prototype._transform = function(i, r, l) {
              l(null, i);
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_readable.js": (
          /*!*********************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_readable.js ***!
            \*********************************************************************************************/
          /***/
          (R, m, e) => {
            R.exports = V;
            var g;
            V.ReadableState = w, e(
              /*! events */
              "./node_modules/events/events.js"
            ).EventEmitter;
            var n = function(P, k) {
              return P.listeners(k).length;
            }, i = e(
              /*! ./internal/streams/stream */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/stream-browser.js"
            ), r = e(
              /*! buffer */
              "./node_modules/buffer/index.js"
            ).Buffer, l = e.g.Uint8Array || function() {
            };
            function d(p) {
              return r.from(p);
            }
            function t(p) {
              return r.isBuffer(p) || p instanceof l;
            }
            var T = e(
              /*! util */
              "?19e6"
            ), S;
            T && T.debuglog ? S = T.debuglog("stream") : S = function() {
            };
            var h = e(
              /*! ./internal/streams/buffer_list */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/buffer_list.js"
            ), _ = e(
              /*! ./internal/streams/destroy */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/destroy.js"
            ), L = e(
              /*! ./internal/streams/state */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/state.js"
            ), v = L.getHighWaterMark, c = e(
              /*! ../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes, o = c.ERR_INVALID_ARG_TYPE, y = c.ERR_STREAM_PUSH_AFTER_EOF, u = c.ERR_METHOD_NOT_IMPLEMENTED, A = c.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, I, M, E;
            e(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            )(V, i);
            var N = _.errorOrDestroy, C = ["error", "close", "destroy", "pause", "resume"];
            function b(p, P, k) {
              if (typeof p.prependListener == "function")
                return p.prependListener(P, k);
              !p._events || !p._events[P] ? p.on(P, k) : Array.isArray(p._events[P]) ? p._events[P].unshift(k) : p._events[P] = [k, p._events[P]];
            }
            function w(p, P, k) {
              g = g || e(
                /*! ./_stream_duplex */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
              ), p = p || {}, typeof k != "boolean" && (k = P instanceof g), this.objectMode = !!p.objectMode, k && (this.objectMode = this.objectMode || !!p.readableObjectMode), this.highWaterMark = v(this, p, "readableHighWaterMark", k), this.buffer = new h(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = p.emitClose !== !1, this.autoDestroy = !!p.autoDestroy, this.destroyed = !1, this.defaultEncoding = p.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, p.encoding && (I || (I = e(
                /*! string_decoder/ */
                "./node_modules/string_decoder/lib/string_decoder.js"
              ).StringDecoder), this.decoder = new I(p.encoding), this.encoding = p.encoding);
            }
            function V(p) {
              if (g = g || e(
                /*! ./_stream_duplex */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
              ), !(this instanceof V))
                return new V(p);
              var P = this instanceof g;
              this._readableState = new w(p, this, P), this.readable = !0, p && (typeof p.read == "function" && (this._read = p.read), typeof p.destroy == "function" && (this._destroy = p.destroy)), i.call(this);
            }
            Object.defineProperty(V.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState === void 0 ? !1 : this._readableState.destroyed;
              },
              set: function(P) {
                this._readableState && (this._readableState.destroyed = P);
              }
            }), V.prototype.destroy = _.destroy, V.prototype._undestroy = _.undestroy, V.prototype._destroy = function(p, P) {
              P(p);
            }, V.prototype.push = function(p, P) {
              var k = this._readableState, X;
              return k.objectMode ? X = !0 : typeof p == "string" && (P = P || k.defaultEncoding, P !== k.encoding && (p = r.from(p, P), P = ""), X = !0), J(this, p, P, !1, X);
            }, V.prototype.unshift = function(p) {
              return J(this, p, null, !0, !1);
            };
            function J(p, P, k, X, F) {
              S("readableAddChunk", P);
              var x = p._readableState;
              if (P === null)
                x.reading = !1, Y(p, x);
              else {
                var W;
                if (F || (W = z(x, P)), W)
                  N(p, W);
                else if (x.objectMode || P && P.length > 0)
                  if (typeof P != "string" && !x.objectMode && Object.getPrototypeOf(P) !== r.prototype && (P = d(P)), X)
                    x.endEmitted ? N(p, new A()) : H(p, x, P, !0);
                  else if (x.ended)
                    N(p, new y());
                  else {
                    if (x.destroyed)
                      return !1;
                    x.reading = !1, x.decoder && !k ? (P = x.decoder.write(P), x.objectMode || P.length !== 0 ? H(p, x, P, !1) : fe(p, x)) : H(p, x, P, !1);
                  }
                else
                  X || (x.reading = !1, fe(p, x));
              }
              return !x.ended && (x.length < x.highWaterMark || x.length === 0);
            }
            function H(p, P, k, X) {
              P.flowing && P.length === 0 && !P.sync ? (P.awaitDrain = 0, p.emit("data", k)) : (P.length += P.objectMode ? 1 : k.length, X ? P.buffer.unshift(k) : P.buffer.push(k), P.needReadable && ne(p)), fe(p, P);
            }
            function z(p, P) {
              var k;
              return !t(P) && typeof P != "string" && P !== void 0 && !p.objectMode && (k = new o("chunk", ["string", "Buffer", "Uint8Array"], P)), k;
            }
            V.prototype.isPaused = function() {
              return this._readableState.flowing === !1;
            }, V.prototype.setEncoding = function(p) {
              I || (I = e(
                /*! string_decoder/ */
                "./node_modules/string_decoder/lib/string_decoder.js"
              ).StringDecoder);
              var P = new I(p);
              this._readableState.decoder = P, this._readableState.encoding = this._readableState.decoder.encoding;
              for (var k = this._readableState.buffer.head, X = ""; k !== null; )
                X += P.write(k.data), k = k.next;
              return this._readableState.buffer.clear(), X !== "" && this._readableState.buffer.push(X), this._readableState.length = X.length, this;
            };
            var Z = 1073741824;
            function ie(p) {
              return p >= Z ? p = Z : (p--, p |= p >>> 1, p |= p >>> 2, p |= p >>> 4, p |= p >>> 8, p |= p >>> 16, p++), p;
            }
            function K(p, P) {
              return p <= 0 || P.length === 0 && P.ended ? 0 : P.objectMode ? 1 : p !== p ? P.flowing && P.length ? P.buffer.head.data.length : P.length : (p > P.highWaterMark && (P.highWaterMark = ie(p)), p <= P.length ? p : P.ended ? P.length : (P.needReadable = !0, 0));
            }
            V.prototype.read = function(p) {
              S("read", p), p = parseInt(p, 10);
              var P = this._readableState, k = p;
              if (p !== 0 && (P.emittedReadable = !1), p === 0 && P.needReadable && ((P.highWaterMark !== 0 ? P.length >= P.highWaterMark : P.length > 0) || P.ended))
                return S("read: emitReadable", P.length, P.ended), P.length === 0 && P.ended ? ue(this) : ne(this), null;
              if (p = K(p, P), p === 0 && P.ended)
                return P.length === 0 && ue(this), null;
              var X = P.needReadable;
              S("need readable", X), (P.length === 0 || P.length - p < P.highWaterMark) && (X = !0, S("length less than watermark", X)), P.ended || P.reading ? (X = !1, S("reading or ended", X)) : X && (S("do read"), P.reading = !0, P.sync = !0, P.length === 0 && (P.needReadable = !0), this._read(P.highWaterMark), P.sync = !1, P.reading || (p = K(k, P)));
              var F;
              return p > 0 ? F = re(p, P) : F = null, F === null ? (P.needReadable = P.length <= P.highWaterMark, p = 0) : (P.length -= p, P.awaitDrain = 0), P.length === 0 && (P.ended || (P.needReadable = !0), k !== p && P.ended && ue(this)), F !== null && this.emit("data", F), F;
            };
            function Y(p, P) {
              if (S("onEofChunk"), !P.ended) {
                if (P.decoder) {
                  var k = P.decoder.end();
                  k && k.length && (P.buffer.push(k), P.length += P.objectMode ? 1 : k.length);
                }
                P.ended = !0, P.sync ? ne(p) : (P.needReadable = !1, P.emittedReadable || (P.emittedReadable = !0, ae(p)));
              }
            }
            function ne(p) {
              var P = p._readableState;
              S("emitReadable", P.needReadable, P.emittedReadable), P.needReadable = !1, P.emittedReadable || (S("emitReadable", P.flowing), P.emittedReadable = !0, process.nextTick(ae, p));
            }
            function ae(p) {
              var P = p._readableState;
              S("emitReadable_", P.destroyed, P.length, P.ended), !P.destroyed && (P.length || P.ended) && (p.emit("readable"), P.emittedReadable = !1), P.needReadable = !P.flowing && !P.ended && P.length <= P.highWaterMark, ee(p);
            }
            function fe(p, P) {
              P.readingMore || (P.readingMore = !0, process.nextTick(Q, p, P));
            }
            function Q(p, P) {
              for (; !P.reading && !P.ended && (P.length < P.highWaterMark || P.flowing && P.length === 0); ) {
                var k = P.length;
                if (S("maybeReadMore read 0"), p.read(0), k === P.length)
                  break;
              }
              P.readingMore = !1;
            }
            V.prototype._read = function(p) {
              N(this, new u("_read()"));
            }, V.prototype.pipe = function(p, P) {
              var k = this, X = this._readableState;
              switch (X.pipesCount) {
                case 0:
                  X.pipes = p;
                  break;
                case 1:
                  X.pipes = [X.pipes, p];
                  break;
                default:
                  X.pipes.push(p);
                  break;
              }
              X.pipesCount += 1, S("pipe count=%d opts=%j", X.pipesCount, P);
              var F = (!P || P.end !== !1) && p !== process.stdout && p !== process.stderr, x = F ? $ : xe;
              X.endEmitted ? process.nextTick(x) : k.once("end", x), p.on("unpipe", W);
              function W(be, Ge) {
                S("onunpipe"), be === k && Ge && Ge.hasUnpiped === !1 && (Ge.hasUnpiped = !0, q());
              }
              function $() {
                S("onend"), p.end();
              }
              var ce = oe(k);
              p.on("drain", ce);
              var le = !1;
              function q() {
                S("cleanup"), p.removeListener("close", Te), p.removeListener("finish", Ce), p.removeListener("drain", ce), p.removeListener("error", Ee), p.removeListener("unpipe", W), k.removeListener("end", $), k.removeListener("end", xe), k.removeListener("data", _e), le = !0, X.awaitDrain && (!p._writableState || p._writableState.needDrain) && ce();
              }
              k.on("data", _e);
              function _e(be) {
                S("ondata");
                var Ge = p.write(be);
                S("dest.write", Ge), Ge === !1 && ((X.pipesCount === 1 && X.pipes === p || X.pipesCount > 1 && O(X.pipes, p) !== -1) && !le && (S("false write response, pause", X.awaitDrain), X.awaitDrain++), k.pause());
              }
              function Ee(be) {
                S("onerror", be), xe(), p.removeListener("error", Ee), n(p, "error") === 0 && N(p, be);
              }
              b(p, "error", Ee);
              function Te() {
                p.removeListener("finish", Ce), xe();
              }
              p.once("close", Te);
              function Ce() {
                S("onfinish"), p.removeListener("close", Te), xe();
              }
              p.once("finish", Ce);
              function xe() {
                S("unpipe"), k.unpipe(p);
              }
              return p.emit("pipe", k), X.flowing || (S("pipe resume"), k.resume()), p;
            };
            function oe(p) {
              return function() {
                var k = p._readableState;
                S("pipeOnDrain", k.awaitDrain), k.awaitDrain && k.awaitDrain--, k.awaitDrain === 0 && n(p, "data") && (k.flowing = !0, ee(p));
              };
            }
            V.prototype.unpipe = function(p) {
              var P = this._readableState, k = {
                hasUnpiped: !1
              };
              if (P.pipesCount === 0)
                return this;
              if (P.pipesCount === 1)
                return p && p !== P.pipes ? this : (p || (p = P.pipes), P.pipes = null, P.pipesCount = 0, P.flowing = !1, p && p.emit("unpipe", this, k), this);
              if (!p) {
                var X = P.pipes, F = P.pipesCount;
                P.pipes = null, P.pipesCount = 0, P.flowing = !1;
                for (var x = 0; x < F; x++)
                  X[x].emit("unpipe", this, {
                    hasUnpiped: !1
                  });
                return this;
              }
              var W = O(P.pipes, p);
              return W === -1 ? this : (P.pipes.splice(W, 1), P.pipesCount -= 1, P.pipesCount === 1 && (P.pipes = P.pipes[0]), p.emit("unpipe", this, k), this);
            }, V.prototype.on = function(p, P) {
              var k = i.prototype.on.call(this, p, P), X = this._readableState;
              return p === "data" ? (X.readableListening = this.listenerCount("readable") > 0, X.flowing !== !1 && this.resume()) : p === "readable" && !X.endEmitted && !X.readableListening && (X.readableListening = X.needReadable = !0, X.flowing = !1, X.emittedReadable = !1, S("on readable", X.length, X.reading), X.length ? ne(this) : X.reading || process.nextTick(Me, this)), k;
            }, V.prototype.addListener = V.prototype.on, V.prototype.removeListener = function(p, P) {
              var k = i.prototype.removeListener.call(this, p, P);
              return p === "readable" && process.nextTick(de, this), k;
            }, V.prototype.removeAllListeners = function(p) {
              var P = i.prototype.removeAllListeners.apply(this, arguments);
              return (p === "readable" || p === void 0) && process.nextTick(de, this), P;
            };
            function de(p) {
              var P = p._readableState;
              P.readableListening = p.listenerCount("readable") > 0, P.resumeScheduled && !P.paused ? P.flowing = !0 : p.listenerCount("data") > 0 && p.resume();
            }
            function Me(p) {
              S("readable nexttick read 0"), p.read(0);
            }
            V.prototype.resume = function() {
              var p = this._readableState;
              return p.flowing || (S("resume"), p.flowing = !p.readableListening, ge(this, p)), p.paused = !1, this;
            };
            function ge(p, P) {
              P.resumeScheduled || (P.resumeScheduled = !0, process.nextTick(se, p, P));
            }
            function se(p, P) {
              S("resume", P.reading), P.reading || p.read(0), P.resumeScheduled = !1, p.emit("resume"), ee(p), P.flowing && !P.reading && p.read(0);
            }
            V.prototype.pause = function() {
              return S("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (S("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
            };
            function ee(p) {
              var P = p._readableState;
              for (S("flow", P.flowing); P.flowing && p.read() !== null; )
                ;
            }
            V.prototype.wrap = function(p) {
              var P = this, k = this._readableState, X = !1;
              p.on("end", function() {
                if (S("wrapped end"), k.decoder && !k.ended) {
                  var W = k.decoder.end();
                  W && W.length && P.push(W);
                }
                P.push(null);
              }), p.on("data", function(W) {
                if (S("wrapped data"), k.decoder && (W = k.decoder.write(W)), !(k.objectMode && W == null) && !(!k.objectMode && (!W || !W.length))) {
                  var $ = P.push(W);
                  $ || (X = !0, p.pause());
                }
              });
              for (var F in p)
                this[F] === void 0 && typeof p[F] == "function" && (this[F] = function($) {
                  return function() {
                    return p[$].apply(p, arguments);
                  };
                }(F));
              for (var x = 0; x < C.length; x++)
                p.on(C[x], this.emit.bind(this, C[x]));
              return this._read = function(W) {
                S("wrapped _read", W), X && (X = !1, p.resume());
              }, this;
            }, typeof Symbol == "function" && (V.prototype[Symbol.asyncIterator] = function() {
              return M === void 0 && (M = e(
                /*! ./internal/streams/async_iterator */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/async_iterator.js"
              )), M(this);
            }), Object.defineProperty(V.prototype, "readableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.highWaterMark;
              }
            }), Object.defineProperty(V.prototype, "readableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState && this._readableState.buffer;
              }
            }), Object.defineProperty(V.prototype, "readableFlowing", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.flowing;
              },
              set: function(P) {
                this._readableState && (this._readableState.flowing = P);
              }
            }), V._fromList = re, Object.defineProperty(V.prototype, "readableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.length;
              }
            });
            function re(p, P) {
              if (P.length === 0)
                return null;
              var k;
              return P.objectMode ? k = P.buffer.shift() : !p || p >= P.length ? (P.decoder ? k = P.buffer.join("") : P.buffer.length === 1 ? k = P.buffer.first() : k = P.buffer.concat(P.length), P.buffer.clear()) : k = P.buffer.consume(p, P.decoder), k;
            }
            function ue(p) {
              var P = p._readableState;
              S("endReadable", P.endEmitted), P.endEmitted || (P.ended = !0, process.nextTick(te, P, p));
            }
            function te(p, P) {
              if (S("endReadableNT", p.endEmitted, p.length), !p.endEmitted && p.length === 0 && (p.endEmitted = !0, P.readable = !1, P.emit("end"), p.autoDestroy)) {
                var k = P._writableState;
                (!k || k.autoDestroy && k.finished) && P.destroy();
              }
            }
            typeof Symbol == "function" && (V.from = function(p, P) {
              return E === void 0 && (E = e(
                /*! ./internal/streams/from */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/from-browser.js"
              )), E(V, p, P);
            });
            function O(p, P) {
              for (var k = 0, X = p.length; k < X; k++)
                if (p[k] === P)
                  return k;
              return -1;
            }
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_transform.js": (
          /*!**********************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_transform.js ***!
            \**********************************************************************************************/
          /***/
          (R, m, e) => {
            R.exports = T;
            var g = e(
              /*! ../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes, n = g.ERR_METHOD_NOT_IMPLEMENTED, i = g.ERR_MULTIPLE_CALLBACK, r = g.ERR_TRANSFORM_ALREADY_TRANSFORMING, l = g.ERR_TRANSFORM_WITH_LENGTH_0, d = e(
              /*! ./_stream_duplex */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
            );
            e(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            )(T, d);
            function t(_, L) {
              var v = this._transformState;
              v.transforming = !1;
              var c = v.writecb;
              if (c === null)
                return this.emit("error", new i());
              v.writechunk = null, v.writecb = null, L != null && this.push(L), c(_);
              var o = this._readableState;
              o.reading = !1, (o.needReadable || o.length < o.highWaterMark) && this._read(o.highWaterMark);
            }
            function T(_) {
              if (!(this instanceof T))
                return new T(_);
              d.call(this, _), this._transformState = {
                afterTransform: t.bind(this),
                needTransform: !1,
                transforming: !1,
                writecb: null,
                writechunk: null,
                writeencoding: null
              }, this._readableState.needReadable = !0, this._readableState.sync = !1, _ && (typeof _.transform == "function" && (this._transform = _.transform), typeof _.flush == "function" && (this._flush = _.flush)), this.on("prefinish", S);
            }
            function S() {
              var _ = this;
              typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(L, v) {
                h(_, L, v);
              }) : h(this, null, null);
            }
            T.prototype.push = function(_, L) {
              return this._transformState.needTransform = !1, d.prototype.push.call(this, _, L);
            }, T.prototype._transform = function(_, L, v) {
              v(new n("_transform()"));
            }, T.prototype._write = function(_, L, v) {
              var c = this._transformState;
              if (c.writecb = v, c.writechunk = _, c.writeencoding = L, !c.transforming) {
                var o = this._readableState;
                (c.needTransform || o.needReadable || o.length < o.highWaterMark) && this._read(o.highWaterMark);
              }
            }, T.prototype._read = function(_) {
              var L = this._transformState;
              L.writechunk !== null && !L.transforming ? (L.transforming = !0, this._transform(L.writechunk, L.writeencoding, L.afterTransform)) : L.needTransform = !0;
            }, T.prototype._destroy = function(_, L) {
              d.prototype._destroy.call(this, _, function(v) {
                L(v);
              });
            };
            function h(_, L, v) {
              if (L)
                return _.emit("error", L);
              if (v != null && _.push(v), _._writableState.length)
                throw new l();
              if (_._transformState.transforming)
                throw new r();
              return _.push(null);
            }
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_writable.js": (
          /*!*********************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_writable.js ***!
            \*********************************************************************************************/
          /***/
          (R, m, e) => {
            R.exports = w;
            function g(ee) {
              var re = this;
              this.next = null, this.entry = null, this.finish = function() {
                se(re, ee);
              };
            }
            var n;
            w.WritableState = C;
            var i = {
              deprecate: e(
                /*! util-deprecate */
                "./node_modules/util-deprecate/browser.js"
              )
            }, r = e(
              /*! ./internal/streams/stream */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/stream-browser.js"
            ), l = e(
              /*! buffer */
              "./node_modules/buffer/index.js"
            ).Buffer, d = e.g.Uint8Array || function() {
            };
            function t(ee) {
              return l.from(ee);
            }
            function T(ee) {
              return l.isBuffer(ee) || ee instanceof d;
            }
            var S = e(
              /*! ./internal/streams/destroy */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/destroy.js"
            ), h = e(
              /*! ./internal/streams/state */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/state.js"
            ), _ = h.getHighWaterMark, L = e(
              /*! ../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes, v = L.ERR_INVALID_ARG_TYPE, c = L.ERR_METHOD_NOT_IMPLEMENTED, o = L.ERR_MULTIPLE_CALLBACK, y = L.ERR_STREAM_CANNOT_PIPE, u = L.ERR_STREAM_DESTROYED, A = L.ERR_STREAM_NULL_VALUES, I = L.ERR_STREAM_WRITE_AFTER_END, M = L.ERR_UNKNOWN_ENCODING, E = S.errorOrDestroy;
            e(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            )(w, r);
            function N() {
            }
            function C(ee, re, ue) {
              n = n || e(
                /*! ./_stream_duplex */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
              ), ee = ee || {}, typeof ue != "boolean" && (ue = re instanceof n), this.objectMode = !!ee.objectMode, ue && (this.objectMode = this.objectMode || !!ee.writableObjectMode), this.highWaterMark = _(this, ee, "writableHighWaterMark", ue), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
              var te = ee.decodeStrings === !1;
              this.decodeStrings = !te, this.defaultEncoding = ee.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(O) {
                Y(re, O);
              }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = ee.emitClose !== !1, this.autoDestroy = !!ee.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new g(this);
            }
            C.prototype.getBuffer = function() {
              for (var re = this.bufferedRequest, ue = []; re; )
                ue.push(re), re = re.next;
              return ue;
            }, function() {
              try {
                Object.defineProperty(C.prototype, "buffer", {
                  get: i.deprecate(function() {
                    return this.getBuffer();
                  }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                });
              } catch {
              }
            }();
            var b;
            typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (b = Function.prototype[Symbol.hasInstance], Object.defineProperty(w, Symbol.hasInstance, {
              value: function(re) {
                return b.call(this, re) ? !0 : this !== w ? !1 : re && re._writableState instanceof C;
              }
            })) : b = function(re) {
              return re instanceof this;
            };
            function w(ee) {
              n = n || e(
                /*! ./_stream_duplex */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
              );
              var re = this instanceof n;
              if (!re && !b.call(w, this))
                return new w(ee);
              this._writableState = new C(ee, this, re), this.writable = !0, ee && (typeof ee.write == "function" && (this._write = ee.write), typeof ee.writev == "function" && (this._writev = ee.writev), typeof ee.destroy == "function" && (this._destroy = ee.destroy), typeof ee.final == "function" && (this._final = ee.final)), r.call(this);
            }
            w.prototype.pipe = function() {
              E(this, new y());
            };
            function V(ee, re) {
              var ue = new I();
              E(ee, ue), process.nextTick(re, ue);
            }
            function J(ee, re, ue, te) {
              var O;
              return ue === null ? O = new A() : typeof ue != "string" && !re.objectMode && (O = new v("chunk", ["string", "Buffer"], ue)), O ? (E(ee, O), process.nextTick(te, O), !1) : !0;
            }
            w.prototype.write = function(ee, re, ue) {
              var te = this._writableState, O = !1, p = !te.objectMode && T(ee);
              return p && !l.isBuffer(ee) && (ee = t(ee)), typeof re == "function" && (ue = re, re = null), p ? re = "buffer" : re || (re = te.defaultEncoding), typeof ue != "function" && (ue = N), te.ending ? V(this, ue) : (p || J(this, te, ee, ue)) && (te.pendingcb++, O = z(this, te, p, ee, re, ue)), O;
            }, w.prototype.cork = function() {
              this._writableState.corked++;
            }, w.prototype.uncork = function() {
              var ee = this._writableState;
              ee.corked && (ee.corked--, !ee.writing && !ee.corked && !ee.bufferProcessing && ee.bufferedRequest && fe(this, ee));
            }, w.prototype.setDefaultEncoding = function(re) {
              if (typeof re == "string" && (re = re.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((re + "").toLowerCase()) > -1))
                throw new M(re);
              return this._writableState.defaultEncoding = re, this;
            }, Object.defineProperty(w.prototype, "writableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState && this._writableState.getBuffer();
              }
            });
            function H(ee, re, ue) {
              return !ee.objectMode && ee.decodeStrings !== !1 && typeof re == "string" && (re = l.from(re, ue)), re;
            }
            Object.defineProperty(w.prototype, "writableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.highWaterMark;
              }
            });
            function z(ee, re, ue, te, O, p) {
              if (!ue) {
                var P = H(re, te, O);
                te !== P && (ue = !0, O = "buffer", te = P);
              }
              var k = re.objectMode ? 1 : te.length;
              re.length += k;
              var X = re.length < re.highWaterMark;
              if (X || (re.needDrain = !0), re.writing || re.corked) {
                var F = re.lastBufferedRequest;
                re.lastBufferedRequest = {
                  chunk: te,
                  encoding: O,
                  isBuf: ue,
                  callback: p,
                  next: null
                }, F ? F.next = re.lastBufferedRequest : re.bufferedRequest = re.lastBufferedRequest, re.bufferedRequestCount += 1;
              } else
                Z(ee, re, !1, k, te, O, p);
              return X;
            }
            function Z(ee, re, ue, te, O, p, P) {
              re.writelen = te, re.writecb = P, re.writing = !0, re.sync = !0, re.destroyed ? re.onwrite(new u("write")) : ue ? ee._writev(O, re.onwrite) : ee._write(O, p, re.onwrite), re.sync = !1;
            }
            function ie(ee, re, ue, te, O) {
              --re.pendingcb, ue ? (process.nextTick(O, te), process.nextTick(Me, ee, re), ee._writableState.errorEmitted = !0, E(ee, te)) : (O(te), ee._writableState.errorEmitted = !0, E(ee, te), Me(ee, re));
            }
            function K(ee) {
              ee.writing = !1, ee.writecb = null, ee.length -= ee.writelen, ee.writelen = 0;
            }
            function Y(ee, re) {
              var ue = ee._writableState, te = ue.sync, O = ue.writecb;
              if (typeof O != "function")
                throw new o();
              if (K(ue), re)
                ie(ee, ue, te, re, O);
              else {
                var p = Q(ue) || ee.destroyed;
                !p && !ue.corked && !ue.bufferProcessing && ue.bufferedRequest && fe(ee, ue), te ? process.nextTick(ne, ee, ue, p, O) : ne(ee, ue, p, O);
              }
            }
            function ne(ee, re, ue, te) {
              ue || ae(ee, re), re.pendingcb--, te(), Me(ee, re);
            }
            function ae(ee, re) {
              re.length === 0 && re.needDrain && (re.needDrain = !1, ee.emit("drain"));
            }
            function fe(ee, re) {
              re.bufferProcessing = !0;
              var ue = re.bufferedRequest;
              if (ee._writev && ue && ue.next) {
                var te = re.bufferedRequestCount, O = new Array(te), p = re.corkedRequestsFree;
                p.entry = ue;
                for (var P = 0, k = !0; ue; )
                  O[P] = ue, ue.isBuf || (k = !1), ue = ue.next, P += 1;
                O.allBuffers = k, Z(ee, re, !0, re.length, O, "", p.finish), re.pendingcb++, re.lastBufferedRequest = null, p.next ? (re.corkedRequestsFree = p.next, p.next = null) : re.corkedRequestsFree = new g(re), re.bufferedRequestCount = 0;
              } else {
                for (; ue; ) {
                  var X = ue.chunk, F = ue.encoding, x = ue.callback, W = re.objectMode ? 1 : X.length;
                  if (Z(ee, re, !1, W, X, F, x), ue = ue.next, re.bufferedRequestCount--, re.writing)
                    break;
                }
                ue === null && (re.lastBufferedRequest = null);
              }
              re.bufferedRequest = ue, re.bufferProcessing = !1;
            }
            w.prototype._write = function(ee, re, ue) {
              ue(new c("_write()"));
            }, w.prototype._writev = null, w.prototype.end = function(ee, re, ue) {
              var te = this._writableState;
              return typeof ee == "function" ? (ue = ee, ee = null, re = null) : typeof re == "function" && (ue = re, re = null), ee != null && this.write(ee, re), te.corked && (te.corked = 1, this.uncork()), te.ending || ge(this, te, ue), this;
            }, Object.defineProperty(w.prototype, "writableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.length;
              }
            });
            function Q(ee) {
              return ee.ending && ee.length === 0 && ee.bufferedRequest === null && !ee.finished && !ee.writing;
            }
            function oe(ee, re) {
              ee._final(function(ue) {
                re.pendingcb--, ue && E(ee, ue), re.prefinished = !0, ee.emit("prefinish"), Me(ee, re);
              });
            }
            function de(ee, re) {
              !re.prefinished && !re.finalCalled && (typeof ee._final == "function" && !re.destroyed ? (re.pendingcb++, re.finalCalled = !0, process.nextTick(oe, ee, re)) : (re.prefinished = !0, ee.emit("prefinish")));
            }
            function Me(ee, re) {
              var ue = Q(re);
              if (ue && (de(ee, re), re.pendingcb === 0 && (re.finished = !0, ee.emit("finish"), re.autoDestroy))) {
                var te = ee._readableState;
                (!te || te.autoDestroy && te.endEmitted) && ee.destroy();
              }
              return ue;
            }
            function ge(ee, re, ue) {
              re.ending = !0, Me(ee, re), ue && (re.finished ? process.nextTick(ue) : ee.once("finish", ue)), re.ended = !0, ee.writable = !1;
            }
            function se(ee, re, ue) {
              var te = ee.entry;
              for (ee.entry = null; te; ) {
                var O = te.callback;
                re.pendingcb--, O(ue), te = te.next;
              }
              re.corkedRequestsFree.next = ee;
            }
            Object.defineProperty(w.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState === void 0 ? !1 : this._writableState.destroyed;
              },
              set: function(re) {
                this._writableState && (this._writableState.destroyed = re);
              }
            }), w.prototype.destroy = S.destroy, w.prototype._undestroy = S.undestroy, w.prototype._destroy = function(ee, re) {
              re(ee);
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/async_iterator.js": (
          /*!************************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/async_iterator.js ***!
            \************************************************************************************************************/
          /***/
          (R, m, e) => {
            var g;
            function n(A, I, M) {
              return I in A ? Object.defineProperty(A, I, { value: M, enumerable: !0, configurable: !0, writable: !0 }) : A[I] = M, A;
            }
            var i = e(
              /*! ./end-of-stream */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/end-of-stream.js"
            ), r = Symbol("lastResolve"), l = Symbol("lastReject"), d = Symbol("error"), t = Symbol("ended"), T = Symbol("lastPromise"), S = Symbol("handlePromise"), h = Symbol("stream");
            function _(A, I) {
              return {
                value: A,
                done: I
              };
            }
            function L(A) {
              var I = A[r];
              if (I !== null) {
                var M = A[h].read();
                M !== null && (A[T] = null, A[r] = null, A[l] = null, I(_(M, !1)));
              }
            }
            function v(A) {
              process.nextTick(L, A);
            }
            function c(A, I) {
              return function(M, E) {
                A.then(function() {
                  if (I[t]) {
                    M(_(void 0, !0));
                    return;
                  }
                  I[S](M, E);
                }, E);
              };
            }
            var o = Object.getPrototypeOf(function() {
            }), y = Object.setPrototypeOf((g = {
              get stream() {
                return this[h];
              },
              next: function() {
                var I = this, M = this[d];
                if (M !== null)
                  return Promise.reject(M);
                if (this[t])
                  return Promise.resolve(_(void 0, !0));
                if (this[h].destroyed)
                  return new Promise(function(b, w) {
                    process.nextTick(function() {
                      I[d] ? w(I[d]) : b(_(void 0, !0));
                    });
                  });
                var E = this[T], N;
                if (E)
                  N = new Promise(c(E, this));
                else {
                  var C = this[h].read();
                  if (C !== null)
                    return Promise.resolve(_(C, !1));
                  N = new Promise(this[S]);
                }
                return this[T] = N, N;
              }
            }, n(g, Symbol.asyncIterator, function() {
              return this;
            }), n(g, "return", function() {
              var I = this;
              return new Promise(function(M, E) {
                I[h].destroy(null, function(N) {
                  if (N) {
                    E(N);
                    return;
                  }
                  M(_(void 0, !0));
                });
              });
            }), g), o), u = function(I) {
              var M, E = Object.create(y, (M = {}, n(M, h, {
                value: I,
                writable: !0
              }), n(M, r, {
                value: null,
                writable: !0
              }), n(M, l, {
                value: null,
                writable: !0
              }), n(M, d, {
                value: null,
                writable: !0
              }), n(M, t, {
                value: I._readableState.endEmitted,
                writable: !0
              }), n(M, S, {
                value: function(C, b) {
                  var w = E[h].read();
                  w ? (E[T] = null, E[r] = null, E[l] = null, C(_(w, !1))) : (E[r] = C, E[l] = b);
                },
                writable: !0
              }), M));
              return E[T] = null, i(I, function(N) {
                if (N && N.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                  var C = E[l];
                  C !== null && (E[T] = null, E[r] = null, E[l] = null, C(N)), E[d] = N;
                  return;
                }
                var b = E[r];
                b !== null && (E[T] = null, E[r] = null, E[l] = null, b(_(void 0, !0))), E[t] = !0;
              }), I.on("readable", v.bind(null, E)), E;
            };
            R.exports = u;
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/buffer_list.js": (
          /*!*********************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/buffer_list.js ***!
            \*********************************************************************************************************/
          /***/
          (R, m, e) => {
            function g(v, c) {
              var o = Object.keys(v);
              if (Object.getOwnPropertySymbols) {
                var y = Object.getOwnPropertySymbols(v);
                c && (y = y.filter(function(u) {
                  return Object.getOwnPropertyDescriptor(v, u).enumerable;
                })), o.push.apply(o, y);
              }
              return o;
            }
            function n(v) {
              for (var c = 1; c < arguments.length; c++) {
                var o = arguments[c] != null ? arguments[c] : {};
                c % 2 ? g(Object(o), !0).forEach(function(y) {
                  i(v, y, o[y]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(o)) : g(Object(o)).forEach(function(y) {
                  Object.defineProperty(v, y, Object.getOwnPropertyDescriptor(o, y));
                });
              }
              return v;
            }
            function i(v, c, o) {
              return c in v ? Object.defineProperty(v, c, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : v[c] = o, v;
            }
            function r(v, c) {
              if (!(v instanceof c))
                throw new TypeError("Cannot call a class as a function");
            }
            function l(v, c) {
              for (var o = 0; o < c.length; o++) {
                var y = c[o];
                y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(v, y.key, y);
              }
            }
            function d(v, c, o) {
              return c && l(v.prototype, c), o && l(v, o), v;
            }
            var t = e(
              /*! buffer */
              "./node_modules/buffer/index.js"
            ), T = t.Buffer, S = e(
              /*! util */
              "?3e83"
            ), h = S.inspect, _ = h && h.custom || "inspect";
            function L(v, c, o) {
              T.prototype.copy.call(v, c, o);
            }
            R.exports = /* @__PURE__ */ function() {
              function v() {
                r(this, v), this.head = null, this.tail = null, this.length = 0;
              }
              return d(v, [{
                key: "push",
                value: function(o) {
                  var y = {
                    data: o,
                    next: null
                  };
                  this.length > 0 ? this.tail.next = y : this.head = y, this.tail = y, ++this.length;
                }
              }, {
                key: "unshift",
                value: function(o) {
                  var y = {
                    data: o,
                    next: this.head
                  };
                  this.length === 0 && (this.tail = y), this.head = y, ++this.length;
                }
              }, {
                key: "shift",
                value: function() {
                  if (this.length !== 0) {
                    var o = this.head.data;
                    return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, o;
                  }
                }
              }, {
                key: "clear",
                value: function() {
                  this.head = this.tail = null, this.length = 0;
                }
              }, {
                key: "join",
                value: function(o) {
                  if (this.length === 0)
                    return "";
                  for (var y = this.head, u = "" + y.data; y = y.next; )
                    u += o + y.data;
                  return u;
                }
              }, {
                key: "concat",
                value: function(o) {
                  if (this.length === 0)
                    return T.alloc(0);
                  for (var y = T.allocUnsafe(o >>> 0), u = this.head, A = 0; u; )
                    L(u.data, y, A), A += u.data.length, u = u.next;
                  return y;
                }
                // Consumes a specified amount of bytes or characters from the buffered data.
              }, {
                key: "consume",
                value: function(o, y) {
                  var u;
                  return o < this.head.data.length ? (u = this.head.data.slice(0, o), this.head.data = this.head.data.slice(o)) : o === this.head.data.length ? u = this.shift() : u = y ? this._getString(o) : this._getBuffer(o), u;
                }
              }, {
                key: "first",
                value: function() {
                  return this.head.data;
                }
                // Consumes a specified amount of characters from the buffered data.
              }, {
                key: "_getString",
                value: function(o) {
                  var y = this.head, u = 1, A = y.data;
                  for (o -= A.length; y = y.next; ) {
                    var I = y.data, M = o > I.length ? I.length : o;
                    if (M === I.length ? A += I : A += I.slice(0, o), o -= M, o === 0) {
                      M === I.length ? (++u, y.next ? this.head = y.next : this.head = this.tail = null) : (this.head = y, y.data = I.slice(M));
                      break;
                    }
                    ++u;
                  }
                  return this.length -= u, A;
                }
                // Consumes a specified amount of bytes from the buffered data.
              }, {
                key: "_getBuffer",
                value: function(o) {
                  var y = T.allocUnsafe(o), u = this.head, A = 1;
                  for (u.data.copy(y), o -= u.data.length; u = u.next; ) {
                    var I = u.data, M = o > I.length ? I.length : o;
                    if (I.copy(y, y.length - o, 0, M), o -= M, o === 0) {
                      M === I.length ? (++A, u.next ? this.head = u.next : this.head = this.tail = null) : (this.head = u, u.data = I.slice(M));
                      break;
                    }
                    ++A;
                  }
                  return this.length -= A, y;
                }
                // Make sure the linked list only shows the minimal necessary information.
              }, {
                key: _,
                value: function(o, y) {
                  return h(this, n({}, y, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: !1
                  }));
                }
              }]), v;
            }();
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/destroy.js": (
          /*!*****************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/destroy.js ***!
            \*****************************************************************************************************/
          /***/
          (R) => {
            function m(l, d) {
              var t = this, T = this._readableState && this._readableState.destroyed, S = this._writableState && this._writableState.destroyed;
              return T || S ? (d ? d(l) : l && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(i, this, l)) : process.nextTick(i, this, l)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(l || null, function(h) {
                !d && h ? t._writableState ? t._writableState.errorEmitted ? process.nextTick(g, t) : (t._writableState.errorEmitted = !0, process.nextTick(e, t, h)) : process.nextTick(e, t, h) : d ? (process.nextTick(g, t), d(h)) : process.nextTick(g, t);
              }), this);
            }
            function e(l, d) {
              i(l, d), g(l);
            }
            function g(l) {
              l._writableState && !l._writableState.emitClose || l._readableState && !l._readableState.emitClose || l.emit("close");
            }
            function n() {
              this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
            }
            function i(l, d) {
              l.emit("error", d);
            }
            function r(l, d) {
              var t = l._readableState, T = l._writableState;
              t && t.autoDestroy || T && T.autoDestroy ? l.destroy(d) : l.emit("error", d);
            }
            R.exports = {
              destroy: m,
              undestroy: n,
              errorOrDestroy: r
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/end-of-stream.js": (
          /*!***********************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/end-of-stream.js ***!
            \***********************************************************************************************************/
          /***/
          (R, m, e) => {
            var g = e(
              /*! ../../../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes.ERR_STREAM_PREMATURE_CLOSE;
            function n(d) {
              var t = !1;
              return function() {
                if (!t) {
                  t = !0;
                  for (var T = arguments.length, S = new Array(T), h = 0; h < T; h++)
                    S[h] = arguments[h];
                  d.apply(this, S);
                }
              };
            }
            function i() {
            }
            function r(d) {
              return d.setHeader && typeof d.abort == "function";
            }
            function l(d, t, T) {
              if (typeof t == "function")
                return l(d, null, t);
              t || (t = {}), T = n(T || i);
              var S = t.readable || t.readable !== !1 && d.readable, h = t.writable || t.writable !== !1 && d.writable, _ = function() {
                d.writable || v();
              }, L = d._writableState && d._writableState.finished, v = function() {
                h = !1, L = !0, S || T.call(d);
              }, c = d._readableState && d._readableState.endEmitted, o = function() {
                S = !1, c = !0, h || T.call(d);
              }, y = function(M) {
                T.call(d, M);
              }, u = function() {
                var M;
                if (S && !c)
                  return (!d._readableState || !d._readableState.ended) && (M = new g()), T.call(d, M);
                if (h && !L)
                  return (!d._writableState || !d._writableState.ended) && (M = new g()), T.call(d, M);
              }, A = function() {
                d.req.on("finish", v);
              };
              return r(d) ? (d.on("complete", v), d.on("abort", u), d.req ? A() : d.on("request", A)) : h && !d._writableState && (d.on("end", _), d.on("close", _)), d.on("end", o), d.on("finish", v), t.error !== !1 && d.on("error", y), d.on("close", u), function() {
                d.removeListener("complete", v), d.removeListener("abort", u), d.removeListener("request", A), d.req && d.req.removeListener("finish", v), d.removeListener("end", _), d.removeListener("close", _), d.removeListener("finish", v), d.removeListener("end", o), d.removeListener("error", y), d.removeListener("close", u);
              };
            }
            R.exports = l;
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/from-browser.js": (
          /*!**********************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/from-browser.js ***!
            \**********************************************************************************************************/
          /***/
          (R) => {
            R.exports = function() {
              throw new Error("Readable.from is not available in the browser");
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/pipeline.js": (
          /*!******************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/pipeline.js ***!
            \******************************************************************************************************/
          /***/
          (R, m, e) => {
            var g;
            function n(v) {
              var c = !1;
              return function() {
                c || (c = !0, v.apply(void 0, arguments));
              };
            }
            var i = e(
              /*! ../../../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes, r = i.ERR_MISSING_ARGS, l = i.ERR_STREAM_DESTROYED;
            function d(v) {
              if (v)
                throw v;
            }
            function t(v) {
              return v.setHeader && typeof v.abort == "function";
            }
            function T(v, c, o, y) {
              y = n(y);
              var u = !1;
              v.on("close", function() {
                u = !0;
              }), g === void 0 && (g = e(
                /*! ./end-of-stream */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/end-of-stream.js"
              )), g(v, {
                readable: c,
                writable: o
              }, function(I) {
                if (I)
                  return y(I);
                u = !0, y();
              });
              var A = !1;
              return function(I) {
                if (!u && !A) {
                  if (A = !0, t(v))
                    return v.abort();
                  if (typeof v.destroy == "function")
                    return v.destroy();
                  y(I || new l("pipe"));
                }
              };
            }
            function S(v) {
              v();
            }
            function h(v, c) {
              return v.pipe(c);
            }
            function _(v) {
              return !v.length || typeof v[v.length - 1] != "function" ? d : v.pop();
            }
            function L() {
              for (var v = arguments.length, c = new Array(v), o = 0; o < v; o++)
                c[o] = arguments[o];
              var y = _(c);
              if (Array.isArray(c[0]) && (c = c[0]), c.length < 2)
                throw new r("streams");
              var u, A = c.map(function(I, M) {
                var E = M < c.length - 1, N = M > 0;
                return T(I, E, N, function(C) {
                  u || (u = C), C && A.forEach(S), !E && (A.forEach(S), y(u));
                });
              });
              return c.reduce(h);
            }
            R.exports = L;
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/state.js": (
          /*!***************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/state.js ***!
            \***************************************************************************************************/
          /***/
          (R, m, e) => {
            var g = e(
              /*! ../../../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes.ERR_INVALID_OPT_VALUE;
            function n(r, l, d) {
              return r.highWaterMark != null ? r.highWaterMark : l ? r[d] : null;
            }
            function i(r, l, d, t) {
              var T = n(l, t, d);
              if (T != null) {
                if (!(isFinite(T) && Math.floor(T) === T) || T < 0) {
                  var S = t ? d : "highWaterMark";
                  throw new g(S, T);
                }
                return Math.floor(T);
              }
              return r.objectMode ? 16 : 16384;
            }
            R.exports = {
              getHighWaterMark: i
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/stream-browser.js": (
          /*!************************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/stream-browser.js ***!
            \************************************************************************************************************/
          /***/
          (R, m, e) => {
            R.exports = e(
              /*! events */
              "./node_modules/events/events.js"
            ).EventEmitter;
          }
        ),
        /***/
        "./node_modules/string_decoder/lib/string_decoder.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/string_decoder/lib/string_decoder.js ***!
            \***********************************************************/
          /***/
          (R, m, e) => {
            var g = e(
              /*! safe-buffer */
              "./node_modules/safe-buffer/index.js"
            ).Buffer, n = g.isEncoding || function(A) {
              switch (A = "" + A, A && A.toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                case "raw":
                  return !0;
                default:
                  return !1;
              }
            };
            function i(A) {
              if (!A)
                return "utf8";
              for (var I; ; )
                switch (A) {
                  case "utf8":
                  case "utf-8":
                    return "utf8";
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return "utf16le";
                  case "latin1":
                  case "binary":
                    return "latin1";
                  case "base64":
                  case "ascii":
                  case "hex":
                    return A;
                  default:
                    if (I)
                      return;
                    A = ("" + A).toLowerCase(), I = !0;
                }
            }
            function r(A) {
              var I = i(A);
              if (typeof I != "string" && (g.isEncoding === n || !n(A)))
                throw new Error("Unknown encoding: " + A);
              return I || A;
            }
            m.StringDecoder = l;
            function l(A) {
              this.encoding = r(A);
              var I;
              switch (this.encoding) {
                case "utf16le":
                  this.text = L, this.end = v, I = 4;
                  break;
                case "utf8":
                  this.fillLast = S, I = 4;
                  break;
                case "base64":
                  this.text = c, this.end = o, I = 3;
                  break;
                default:
                  this.write = y, this.end = u;
                  return;
              }
              this.lastNeed = 0, this.lastTotal = 0, this.lastChar = g.allocUnsafe(I);
            }
            l.prototype.write = function(A) {
              if (A.length === 0)
                return "";
              var I, M;
              if (this.lastNeed) {
                if (I = this.fillLast(A), I === void 0)
                  return "";
                M = this.lastNeed, this.lastNeed = 0;
              } else
                M = 0;
              return M < A.length ? I ? I + this.text(A, M) : this.text(A, M) : I || "";
            }, l.prototype.end = _, l.prototype.text = h, l.prototype.fillLast = function(A) {
              if (this.lastNeed <= A.length)
                return A.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
              A.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, A.length), this.lastNeed -= A.length;
            };
            function d(A) {
              return A <= 127 ? 0 : A >> 5 === 6 ? 2 : A >> 4 === 14 ? 3 : A >> 3 === 30 ? 4 : A >> 6 === 2 ? -1 : -2;
            }
            function t(A, I, M) {
              var E = I.length - 1;
              if (E < M)
                return 0;
              var N = d(I[E]);
              return N >= 0 ? (N > 0 && (A.lastNeed = N - 1), N) : --E < M || N === -2 ? 0 : (N = d(I[E]), N >= 0 ? (N > 0 && (A.lastNeed = N - 2), N) : --E < M || N === -2 ? 0 : (N = d(I[E]), N >= 0 ? (N > 0 && (N === 2 ? N = 0 : A.lastNeed = N - 3), N) : 0));
            }
            function T(A, I, M) {
              if ((I[0] & 192) !== 128)
                return A.lastNeed = 0, "�";
              if (A.lastNeed > 1 && I.length > 1) {
                if ((I[1] & 192) !== 128)
                  return A.lastNeed = 1, "�";
                if (A.lastNeed > 2 && I.length > 2 && (I[2] & 192) !== 128)
                  return A.lastNeed = 2, "�";
              }
            }
            function S(A) {
              var I = this.lastTotal - this.lastNeed, M = T(this, A);
              if (M !== void 0)
                return M;
              if (this.lastNeed <= A.length)
                return A.copy(this.lastChar, I, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
              A.copy(this.lastChar, I, 0, A.length), this.lastNeed -= A.length;
            }
            function h(A, I) {
              var M = t(this, A, I);
              if (!this.lastNeed)
                return A.toString("utf8", I);
              this.lastTotal = M;
              var E = A.length - (M - this.lastNeed);
              return A.copy(this.lastChar, 0, E), A.toString("utf8", I, E);
            }
            function _(A) {
              var I = A && A.length ? this.write(A) : "";
              return this.lastNeed ? I + "�" : I;
            }
            function L(A, I) {
              if ((A.length - I) % 2 === 0) {
                var M = A.toString("utf16le", I);
                if (M) {
                  var E = M.charCodeAt(M.length - 1);
                  if (E >= 55296 && E <= 56319)
                    return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = A[A.length - 2], this.lastChar[1] = A[A.length - 1], M.slice(0, -1);
                }
                return M;
              }
              return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = A[A.length - 1], A.toString("utf16le", I, A.length - 1);
            }
            function v(A) {
              var I = A && A.length ? this.write(A) : "";
              if (this.lastNeed) {
                var M = this.lastTotal - this.lastNeed;
                return I + this.lastChar.toString("utf16le", 0, M);
              }
              return I;
            }
            function c(A, I) {
              var M = (A.length - I) % 3;
              return M === 0 ? A.toString("base64", I) : (this.lastNeed = 3 - M, this.lastTotal = 3, M === 1 ? this.lastChar[0] = A[A.length - 1] : (this.lastChar[0] = A[A.length - 2], this.lastChar[1] = A[A.length - 1]), A.toString("base64", I, A.length - M));
            }
            function o(A) {
              var I = A && A.length ? this.write(A) : "";
              return this.lastNeed ? I + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : I;
            }
            function y(A) {
              return A.toString(this.encoding);
            }
            function u(A) {
              return A && A.length ? this.write(A) : "";
            }
          }
        ),
        /***/
        "./node_modules/ua-parser-js/src/ua-parser.js": (
          /*!****************************************************!*\
            !*** ./node_modules/ua-parser-js/src/ua-parser.js ***!
            \****************************************************/
          /***/
          function(R, m, e) {
            var g;
            (function(n, i) {
              var r = "1.0.2", l = "", d = "?", t = "function", T = "undefined", S = "object", h = "string", _ = "major", L = "model", v = "name", c = "type", o = "vendor", y = "version", u = "architecture", A = "console", I = "mobile", M = "tablet", E = "smarttv", N = "wearable", C = "embedded", b = 255, w = "Amazon", V = "Apple", J = "ASUS", H = "BlackBerry", z = "Browser", Z = "Chrome", ie = "Edge", K = "Firefox", Y = "Google", ne = "Huawei", ae = "LG", fe = "Microsoft", Q = "Motorola", oe = "Opera", de = "Samsung", Me = "Sony", ge = "Xiaomi", se = "Zebra", ee = "Facebook", re = function(q, _e) {
                var Ee = {};
                for (var Te in q)
                  _e[Te] && _e[Te].length % 2 === 0 ? Ee[Te] = _e[Te].concat(q[Te]) : Ee[Te] = q[Te];
                return Ee;
              }, ue = function(q) {
                for (var _e = {}, Ee = 0; Ee < q.length; Ee++)
                  _e[q[Ee].toUpperCase()] = q[Ee];
                return _e;
              }, te = function(q, _e) {
                return typeof q === h ? O(_e).indexOf(O(q)) !== -1 : !1;
              }, O = function(q) {
                return q.toLowerCase();
              }, p = function(q) {
                return typeof q === h ? q.replace(/[^\d\.]/g, l).split(".")[0] : i;
              }, P = function(q, _e) {
                if (typeof q === h)
                  return q = q.replace(/^\s\s*/, l).replace(/\s\s*$/, l), typeof _e === T ? q : q.substring(0, b);
              }, k = function(q, _e) {
                for (var Ee = 0, Te, Ce, xe, be, Ge, Pe; Ee < _e.length && !Ge; ) {
                  var Le = _e[Ee], je = _e[Ee + 1];
                  for (Te = Ce = 0; Te < Le.length && !Ge; )
                    if (Ge = Le[Te++].exec(q), Ge)
                      for (xe = 0; xe < je.length; xe++)
                        Pe = Ge[++Ce], be = je[xe], typeof be === S && be.length > 0 ? be.length === 2 ? typeof be[1] == t ? this[be[0]] = be[1].call(this, Pe) : this[be[0]] = be[1] : be.length === 3 ? typeof be[1] === t && !(be[1].exec && be[1].test) ? this[be[0]] = Pe ? be[1].call(this, Pe, be[2]) : i : this[be[0]] = Pe ? Pe.replace(be[1], be[2]) : i : be.length === 4 && (this[be[0]] = Pe ? be[3].call(this, Pe.replace(be[1], be[2])) : i) : this[be] = Pe || i;
                  Ee += 2;
                }
              }, X = function(q, _e) {
                for (var Ee in _e)
                  if (typeof _e[Ee] === S && _e[Ee].length > 0) {
                    for (var Te = 0; Te < _e[Ee].length; Te++)
                      if (te(_e[Ee][Te], q))
                        return Ee === d ? i : Ee;
                  } else if (te(_e[Ee], q))
                    return Ee === d ? i : Ee;
                return q;
              }, F = {
                "1.0": "/8",
                "1.2": "/1",
                "1.3": "/3",
                "2.0": "/412",
                "2.0.2": "/416",
                "2.0.3": "/417",
                "2.0.4": "/419",
                "?": "/"
              }, x = {
                ME: "4.90",
                "NT 3.11": "NT3.51",
                "NT 4.0": "NT4.0",
                2e3: "NT 5.0",
                XP: ["NT 5.1", "NT 5.2"],
                Vista: "NT 6.0",
                7: "NT 6.1",
                8: "NT 6.2",
                "8.1": "NT 6.3",
                10: ["NT 6.4", "NT 10.0"],
                RT: "ARM"
              }, W = {
                browser: [
                  [
                    /\b(?:crmo|crios)\/([\w\.]+)/i
                    // Chrome for Android/iOS
                  ],
                  [y, [v, "Chrome"]],
                  [
                    /edg(?:e|ios|a)?\/([\w\.]+)/i
                    // Microsoft Edge
                  ],
                  [y, [v, "Edge"]],
                  [
                    // Presto based
                    /(opera mini)\/([-\w\.]+)/i,
                    // Opera Mini
                    /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                    // Opera Mobi/Tablet
                    /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                    // Opera
                  ],
                  [v, y],
                  [
                    /opios[\/ ]+([\w\.]+)/i
                    // Opera mini on iphone >= 8.0
                  ],
                  [y, [v, oe + " Mini"]],
                  [
                    /\bopr\/([\w\.]+)/i
                    // Opera Webkit
                  ],
                  [y, [v, oe]],
                  [
                    // Mixed
                    /(kindle)\/([\w\.]+)/i,
                    // Kindle
                    /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                    // Lunascape/Maxthon/Netfront/Jasmine/Blazer
                    // Trident based
                    /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                    // Avant/IEMobile/SlimBrowser
                    /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                    // Baidu Browser
                    /(?:ms|\()(ie) ([\w\.]+)/i,
                    // Internet Explorer
                    // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                    /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                    // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                    /(weibo)__([\d\.]+)/i
                    // Weibo
                  ],
                  [v, y],
                  [
                    /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                    // UCBrowser
                  ],
                  [y, [v, "UC" + z]],
                  [
                    /\bqbcore\/([\w\.]+)/i
                    // WeChat Desktop for Windows Built-in Browser
                  ],
                  [y, [v, "WeChat(Win) Desktop"]],
                  [
                    /micromessenger\/([\w\.]+)/i
                    // WeChat
                  ],
                  [y, [v, "WeChat"]],
                  [
                    /konqueror\/([\w\.]+)/i
                    // Konqueror
                  ],
                  [y, [v, "Konqueror"]],
                  [
                    /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                    // IE11
                  ],
                  [y, [v, "IE"]],
                  [
                    /yabrowser\/([\w\.]+)/i
                    // Yandex
                  ],
                  [y, [v, "Yandex"]],
                  [
                    /(avast|avg)\/([\w\.]+)/i
                    // Avast/AVG Secure Browser
                  ],
                  [[v, /(.+)/, "$1 Secure " + z], y],
                  [
                    /\bfocus\/([\w\.]+)/i
                    // Firefox Focus
                  ],
                  [y, [v, K + " Focus"]],
                  [
                    /\bopt\/([\w\.]+)/i
                    // Opera Touch
                  ],
                  [y, [v, oe + " Touch"]],
                  [
                    /coc_coc\w+\/([\w\.]+)/i
                    // Coc Coc Browser
                  ],
                  [y, [v, "Coc Coc"]],
                  [
                    /dolfin\/([\w\.]+)/i
                    // Dolphin
                  ],
                  [y, [v, "Dolphin"]],
                  [
                    /coast\/([\w\.]+)/i
                    // Opera Coast
                  ],
                  [y, [v, oe + " Coast"]],
                  [
                    /miuibrowser\/([\w\.]+)/i
                    // MIUI Browser
                  ],
                  [y, [v, "MIUI " + z]],
                  [
                    /fxios\/([-\w\.]+)/i
                    // Firefox for iOS
                  ],
                  [y, [v, K]],
                  [
                    /\bqihu|(qi?ho?o?|360)browser/i
                    // 360
                  ],
                  [[v, "360 " + z]],
                  [
                    /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
                  ],
                  [[v, /(.+)/, "$1 " + z], y],
                  [
                    // Oculus/Samsung/Sailfish Browser
                    /(comodo_dragon)\/([\w\.]+)/i
                    // Comodo Dragon
                  ],
                  [[v, /_/g, " "], y],
                  [
                    /(electron)\/([\w\.]+) safari/i,
                    // Electron-based App
                    /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                    // Tesla
                    /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
                    // QQBrowser/Baidu App/2345 Browser
                  ],
                  [v, y],
                  [
                    /(metasr)[\/ ]?([\w\.]+)/i,
                    // SouGouBrowser
                    /(lbbrowser)/i
                    // LieBao Browser
                  ],
                  [v],
                  [
                    // WebView
                    /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                    // Facebook App for iOS & Android
                  ],
                  [[v, ee], y],
                  [
                    /safari (line)\/([\w\.]+)/i,
                    // Line App for iOS
                    /\b(line)\/([\w\.]+)\/iab/i,
                    // Line App for Android
                    /(chromium|instagram)[\/ ]([-\w\.]+)/i
                    // Chromium/Instagram
                  ],
                  [v, y],
                  [
                    /\bgsa\/([\w\.]+) .*safari\//i
                    // Google Search Appliance on iOS
                  ],
                  [y, [v, "GSA"]],
                  [
                    /headlesschrome(?:\/([\w\.]+)| )/i
                    // Chrome Headless
                  ],
                  [y, [v, Z + " Headless"]],
                  [
                    / wv\).+(chrome)\/([\w\.]+)/i
                    // Chrome WebView
                  ],
                  [[v, Z + " WebView"], y],
                  [
                    /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                    // Android Browser
                  ],
                  [y, [v, "Android " + z]],
                  [
                    /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                    // Chrome/OmniWeb/Arora/Tizen/Nokia
                  ],
                  [v, y],
                  [
                    /version\/([\w\.]+) .*mobile\/\w+ (safari)/i
                    // Mobile Safari
                  ],
                  [y, [v, "Mobile Safari"]],
                  [
                    /version\/([\w\.]+) .*(mobile ?safari|safari)/i
                    // Safari & Safari Mobile
                  ],
                  [y, v],
                  [
                    /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                    // Safari < 3.0
                  ],
                  [v, [y, X, F]],
                  [
                    /(webkit|khtml)\/([\w\.]+)/i
                  ],
                  [v, y],
                  [
                    // Gecko based
                    /(navigator|netscape\d?)\/([-\w\.]+)/i
                    // Netscape
                  ],
                  [[v, "Netscape"], y],
                  [
                    /mobile vr; rv:([\w\.]+)\).+firefox/i
                    // Firefox Reality
                  ],
                  [y, [v, K + " Reality"]],
                  [
                    /ekiohf.+(flow)\/([\w\.]+)/i,
                    // Flow
                    /(swiftfox)/i,
                    // Swiftfox
                    /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                    // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                    /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                    // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                    /(firefox)\/([\w\.]+)/i,
                    // Other Firefox-based
                    /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                    // Mozilla
                    // Other
                    /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                    // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                    /(links) \(([\w\.]+)/i
                    // Links
                  ],
                  [v, y]
                ],
                cpu: [
                  [
                    /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                    // AMD64 (x64)
                  ],
                  [[u, "amd64"]],
                  [
                    /(ia32(?=;))/i
                    // IA32 (quicktime)
                  ],
                  [[u, O]],
                  [
                    /((?:i[346]|x)86)[;\)]/i
                    // IA32 (x86)
                  ],
                  [[u, "ia32"]],
                  [
                    /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                    // ARM64
                  ],
                  [[u, "arm64"]],
                  [
                    /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                    // ARMHF
                  ],
                  [[u, "armhf"]],
                  [
                    // PocketPC mistakenly identified as PowerPC
                    /windows (ce|mobile); ppc;/i
                  ],
                  [[u, "arm"]],
                  [
                    /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                    // PowerPC
                  ],
                  [[u, /ower/, l, O]],
                  [
                    /(sun4\w)[;\)]/i
                    // SPARC
                  ],
                  [[u, "sparc"]],
                  [
                    /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                    // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
                  ],
                  [[u, O]]
                ],
                device: [
                  [
                    //////////////////////////
                    // MOBILES & TABLETS
                    // Ordered by popularity
                    /////////////////////////
                    // Samsung
                    /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                  ],
                  [L, [o, de], [c, M]],
                  [
                    /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
                    /samsung[- ]([-\w]+)/i,
                    /sec-(sgh\w+)/i
                  ],
                  [L, [o, de], [c, I]],
                  [
                    // Apple
                    /\((ip(?:hone|od)[\w ]*);/i
                    // iPod/iPhone
                  ],
                  [L, [o, V], [c, I]],
                  [
                    /\((ipad);[-\w\),; ]+apple/i,
                    // iPad
                    /applecoremedia\/[\w\.]+ \((ipad)/i,
                    /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                  ],
                  [L, [o, V], [c, M]],
                  [
                    // Huawei
                    /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                  ],
                  [L, [o, ne], [c, M]],
                  [
                    /(?:huawei|honor)([-\w ]+)[;\)]/i,
                    /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
                  ],
                  [L, [o, ne], [c, I]],
                  [
                    // Xiaomi
                    /\b(poco[\w ]+)(?: bui|\))/i,
                    // Xiaomi POCO
                    /\b; (\w+) build\/hm\1/i,
                    // Xiaomi Hongmi 'numeric' models
                    /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                    // Xiaomi Hongmi
                    /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                    // Xiaomi Redmi
                    /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                    // Xiaomi Mi
                  ],
                  [[L, /_/g, " "], [o, ge], [c, I]],
                  [
                    /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                    // Mi Pad tablets
                  ],
                  [[L, /_/g, " "], [o, ge], [c, M]],
                  [
                    // OPPO
                    /; (\w+) bui.+ oppo/i,
                    /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                  ],
                  [L, [o, "OPPO"], [c, I]],
                  [
                    // Vivo
                    /vivo (\w+)(?: bui|\))/i,
                    /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                  ],
                  [L, [o, "Vivo"], [c, I]],
                  [
                    // Realme
                    /\b(rmx[12]\d{3})(?: bui|;|\))/i
                  ],
                  [L, [o, "Realme"], [c, I]],
                  [
                    // Motorola
                    /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                    /\bmot(?:orola)?[- ](\w*)/i,
                    /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                  ],
                  [L, [o, Q], [c, I]],
                  [
                    /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                  ],
                  [L, [o, Q], [c, M]],
                  [
                    // LG
                    /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                  ],
                  [L, [o, ae], [c, M]],
                  [
                    /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                    /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                    /\blg-?([\d\w]+) bui/i
                  ],
                  [L, [o, ae], [c, I]],
                  [
                    // Lenovo
                    /(ideatab[-\w ]+)/i,
                    /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                  ],
                  [L, [o, "Lenovo"], [c, M]],
                  [
                    // Nokia
                    /(?:maemo|nokia).*(n900|lumia \d+)/i,
                    /nokia[-_ ]?([-\w\.]*)/i
                  ],
                  [[L, /_/g, " "], [o, "Nokia"], [c, I]],
                  [
                    // Google
                    /(pixel c)\b/i
                    // Google Pixel C
                  ],
                  [L, [o, Y], [c, M]],
                  [
                    /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                    // Google Pixel
                  ],
                  [L, [o, Y], [c, I]],
                  [
                    // Sony
                    /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                  ],
                  [L, [o, Me], [c, I]],
                  [
                    /sony tablet [ps]/i,
                    /\b(?:sony)?sgp\w+(?: bui|\))/i
                  ],
                  [[L, "Xperia Tablet"], [o, Me], [c, M]],
                  [
                    // OnePlus
                    / (kb2005|in20[12]5|be20[12][59])\b/i,
                    /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                  ],
                  [L, [o, "OnePlus"], [c, I]],
                  [
                    // Amazon
                    /(alexa)webm/i,
                    /(kf[a-z]{2}wi)( bui|\))/i,
                    // Kindle Fire without Silk
                    /(kf[a-z]+)( bui|\)).+silk\//i
                    // Kindle Fire HD
                  ],
                  [L, [o, w], [c, M]],
                  [
                    /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                    // Fire Phone
                  ],
                  [[L, /(.+)/g, "Fire Phone $1"], [o, w], [c, I]],
                  [
                    // BlackBerry
                    /(playbook);[-\w\),; ]+(rim)/i
                    // BlackBerry PlayBook
                  ],
                  [L, o, [c, M]],
                  [
                    /\b((?:bb[a-f]|st[hv])100-\d)/i,
                    /\(bb10; (\w+)/i
                    // BlackBerry 10
                  ],
                  [L, [o, H], [c, I]],
                  [
                    // Asus
                    /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                  ],
                  [L, [o, J], [c, M]],
                  [
                    / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                  ],
                  [L, [o, J], [c, I]],
                  [
                    // HTC
                    /(nexus 9)/i
                    // HTC Nexus 9
                  ],
                  [L, [o, "HTC"], [c, M]],
                  [
                    /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                    // HTC
                    // ZTE
                    /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                    /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i
                    // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
                  ],
                  [o, [L, /_/g, " "], [c, I]],
                  [
                    // Acer
                    /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                  ],
                  [L, [o, "Acer"], [c, M]],
                  [
                    // Meizu
                    /droid.+; (m[1-5] note) bui/i,
                    /\bmz-([-\w]{2,})/i
                  ],
                  [L, [o, "Meizu"], [c, I]],
                  [
                    // Sharp
                    /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                  ],
                  [L, [o, "Sharp"], [c, I]],
                  [
                    // MIXED
                    /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                    // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                    /(hp) ([\w ]+\w)/i,
                    // HP iPAQ
                    /(asus)-?(\w+)/i,
                    // Asus
                    /(microsoft); (lumia[\w ]+)/i,
                    // Microsoft Lumia
                    /(lenovo)[-_ ]?([-\w]+)/i,
                    // Lenovo
                    /(jolla)/i,
                    // Jolla
                    /(oppo) ?([\w ]+) bui/i
                    // OPPO
                  ],
                  [o, L, [c, I]],
                  [
                    /(archos) (gamepad2?)/i,
                    // Archos
                    /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                    // HP TouchPad
                    /(kindle)\/([\w\.]+)/i,
                    // Kindle
                    /(nook)[\w ]+build\/(\w+)/i,
                    // Nook
                    /(dell) (strea[kpr\d ]*[\dko])/i,
                    // Dell Streak
                    /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                    // Le Pan Tablets
                    /(trinity)[- ]*(t\d{3}) bui/i,
                    // Trinity Tablets
                    /(gigaset)[- ]+(q\w{1,9}) bui/i,
                    // Gigaset Tablets
                    /(vodafone) ([\w ]+)(?:\)| bui)/i
                    // Vodafone
                  ],
                  [o, L, [c, M]],
                  [
                    /(surface duo)/i
                    // Surface Duo
                  ],
                  [L, [o, fe], [c, M]],
                  [
                    /droid [\d\.]+; (fp\du?)(?: b|\))/i
                    // Fairphone
                  ],
                  [L, [o, "Fairphone"], [c, I]],
                  [
                    /(u304aa)/i
                    // AT&T
                  ],
                  [L, [o, "AT&T"], [c, I]],
                  [
                    /\bsie-(\w*)/i
                    // Siemens
                  ],
                  [L, [o, "Siemens"], [c, I]],
                  [
                    /\b(rct\w+) b/i
                    // RCA Tablets
                  ],
                  [L, [o, "RCA"], [c, M]],
                  [
                    /\b(venue[\d ]{2,7}) b/i
                    // Dell Venue Tablets
                  ],
                  [L, [o, "Dell"], [c, M]],
                  [
                    /\b(q(?:mv|ta)\w+) b/i
                    // Verizon Tablet
                  ],
                  [L, [o, "Verizon"], [c, M]],
                  [
                    /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                    // Barnes & Noble Tablet
                  ],
                  [L, [o, "Barnes & Noble"], [c, M]],
                  [
                    /\b(tm\d{3}\w+) b/i
                  ],
                  [L, [o, "NuVision"], [c, M]],
                  [
                    /\b(k88) b/i
                    // ZTE K Series Tablet
                  ],
                  [L, [o, "ZTE"], [c, M]],
                  [
                    /\b(nx\d{3}j) b/i
                    // ZTE Nubia
                  ],
                  [L, [o, "ZTE"], [c, I]],
                  [
                    /\b(gen\d{3}) b.+49h/i
                    // Swiss GEN Mobile
                  ],
                  [L, [o, "Swiss"], [c, I]],
                  [
                    /\b(zur\d{3}) b/i
                    // Swiss ZUR Tablet
                  ],
                  [L, [o, "Swiss"], [c, M]],
                  [
                    /\b((zeki)?tb.*\b) b/i
                    // Zeki Tablets
                  ],
                  [L, [o, "Zeki"], [c, M]],
                  [
                    /\b([yr]\d{2}) b/i,
                    /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                    // Dragon Touch Tablet
                  ],
                  [[o, "Dragon Touch"], L, [c, M]],
                  [
                    /\b(ns-?\w{0,9}) b/i
                    // Insignia Tablets
                  ],
                  [L, [o, "Insignia"], [c, M]],
                  [
                    /\b((nxa|next)-?\w{0,9}) b/i
                    // NextBook Tablets
                  ],
                  [L, [o, "NextBook"], [c, M]],
                  [
                    /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                    // Voice Xtreme Phones
                  ],
                  [[o, "Voice"], L, [c, I]],
                  [
                    /\b(lvtel\-)?(v1[12]) b/i
                    // LvTel Phones
                  ],
                  [[o, "LvTel"], L, [c, I]],
                  [
                    /\b(ph-1) /i
                    // Essential PH-1
                  ],
                  [L, [o, "Essential"], [c, I]],
                  [
                    /\b(v(100md|700na|7011|917g).*\b) b/i
                    // Envizen Tablets
                  ],
                  [L, [o, "Envizen"], [c, M]],
                  [
                    /\b(trio[-\w\. ]+) b/i
                    // MachSpeed Tablets
                  ],
                  [L, [o, "MachSpeed"], [c, M]],
                  [
                    /\btu_(1491) b/i
                    // Rotor Tablets
                  ],
                  [L, [o, "Rotor"], [c, M]],
                  [
                    /(shield[\w ]+) b/i
                    // Nvidia Shield Tablets
                  ],
                  [L, [o, "Nvidia"], [c, M]],
                  [
                    /(sprint) (\w+)/i
                    // Sprint Phones
                  ],
                  [o, L, [c, I]],
                  [
                    /(kin\.[onetw]{3})/i
                    // Microsoft Kin
                  ],
                  [[L, /\./g, " "], [o, fe], [c, I]],
                  [
                    /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                    // Zebra
                  ],
                  [L, [o, se], [c, M]],
                  [
                    /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                  ],
                  [L, [o, se], [c, I]],
                  [
                    ///////////////////
                    // CONSOLES
                    ///////////////////
                    /(ouya)/i,
                    // Ouya
                    /(nintendo) ([wids3utch]+)/i
                    // Nintendo
                  ],
                  [o, L, [c, A]],
                  [
                    /droid.+; (shield) bui/i
                    // Nvidia
                  ],
                  [L, [o, "Nvidia"], [c, A]],
                  [
                    /(playstation [345portablevi]+)/i
                    // Playstation
                  ],
                  [L, [o, Me], [c, A]],
                  [
                    /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                    // Microsoft Xbox
                  ],
                  [L, [o, fe], [c, A]],
                  [
                    ///////////////////
                    // SMARTTVS
                    ///////////////////
                    /smart-tv.+(samsung)/i
                    // Samsung
                  ],
                  [o, [c, E]],
                  [
                    /hbbtv.+maple;(\d+)/i
                  ],
                  [[L, /^/, "SmartTV"], [o, de], [c, E]],
                  [
                    /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                    // LG SmartTV
                  ],
                  [[o, ae], [c, E]],
                  [
                    /(apple) ?tv/i
                    // Apple TV
                  ],
                  [o, [L, V + " TV"], [c, E]],
                  [
                    /crkey/i
                    // Google Chromecast
                  ],
                  [[L, Z + "cast"], [o, Y], [c, E]],
                  [
                    /droid.+aft(\w)( bui|\))/i
                    // Fire TV
                  ],
                  [L, [o, w], [c, E]],
                  [
                    /\(dtv[\);].+(aquos)/i
                    // Sharp
                  ],
                  [L, [o, "Sharp"], [c, E]],
                  [
                    /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                    // Roku
                    /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
                    // HbbTV devices
                  ],
                  [[o, P], [L, P], [c, E]],
                  [
                    /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                    // SmartTV from Unidentified Vendors
                  ],
                  [[c, E]],
                  [
                    ///////////////////
                    // WEARABLES
                    ///////////////////
                    /((pebble))app/i
                    // Pebble
                  ],
                  [o, L, [c, N]],
                  [
                    /droid.+; (glass) \d/i
                    // Google Glass
                  ],
                  [L, [o, Y], [c, N]],
                  [
                    /droid.+; (wt63?0{2,3})\)/i
                  ],
                  [L, [o, se], [c, N]],
                  [
                    /(quest( 2)?)/i
                    // Oculus Quest
                  ],
                  [L, [o, ee], [c, N]],
                  [
                    ///////////////////
                    // EMBEDDED
                    ///////////////////
                    /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                    // Tesla
                  ],
                  [o, [c, C]],
                  [
                    ////////////////////
                    // MIXED (GENERIC)
                    ///////////////////
                    /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
                    // Android Phones from Unidentified Vendors
                  ],
                  [L, [c, I]],
                  [
                    /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                    // Android Tablets from Unidentified Vendors
                  ],
                  [L, [c, M]],
                  [
                    /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                    // Unidentifiable Tablet
                  ],
                  [[c, M]],
                  [
                    /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i
                    // Unidentifiable Mobile
                  ],
                  [[c, I]],
                  [
                    /(android[-\w\. ]{0,9});.+buil/i
                    // Generic Android Device
                  ],
                  [L, [o, "Generic"]]
                ],
                engine: [
                  [
                    /windows.+ edge\/([\w\.]+)/i
                    // EdgeHTML
                  ],
                  [y, [v, ie + "HTML"]],
                  [
                    /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                    // Blink
                  ],
                  [y, [v, "Blink"]],
                  [
                    /(presto)\/([\w\.]+)/i,
                    // Presto
                    /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                    // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
                    /ekioh(flow)\/([\w\.]+)/i,
                    // Flow
                    /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                    // KHTML/Tasman/Links
                    /(icab)[\/ ]([23]\.[\d\.]+)/i
                    // iCab
                  ],
                  [v, y],
                  [
                    /rv\:([\w\.]{1,9})\b.+(gecko)/i
                    // Gecko
                  ],
                  [y, v]
                ],
                os: [
                  [
                    // Windows
                    /microsoft (windows) (vista|xp)/i
                    // Windows (iTunes)
                  ],
                  [v, y],
                  [
                    /(windows) nt 6\.2; (arm)/i,
                    // Windows RT
                    /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                    // Windows Phone
                    /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
                  ],
                  [v, [y, X, x]],
                  [
                    /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                  ],
                  [[v, "Windows"], [y, X, x]],
                  [
                    // iOS/macOS
                    /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                    // iOS
                    /cfnetwork\/.+darwin/i
                  ],
                  [[y, /_/g, "."], [v, "iOS"]],
                  [
                    /(mac os x) ?([\w\. ]*)/i,
                    /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                    // Mac OS
                  ],
                  [[v, "Mac OS"], [y, /_/g, "."]],
                  [
                    // Mobile OSes
                    /droid ([\w\.]+)\b.+(android[- ]x86)/i
                    // Android-x86
                  ],
                  [y, v],
                  [
                    // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
                    /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                    /(blackberry)\w*\/([\w\.]*)/i,
                    // Blackberry
                    /(tizen|kaios)[\/ ]([\w\.]+)/i,
                    // Tizen/KaiOS
                    /\((series40);/i
                    // Series 40
                  ],
                  [v, y],
                  [
                    /\(bb(10);/i
                    // BlackBerry 10
                  ],
                  [y, [v, H]],
                  [
                    /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                    // Symbian
                  ],
                  [y, [v, "Symbian"]],
                  [
                    /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                    // Firefox OS
                  ],
                  [y, [v, K + " OS"]],
                  [
                    /web0s;.+rt(tv)/i,
                    /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                    // WebOS
                  ],
                  [y, [v, "webOS"]],
                  [
                    // Google Chromecast
                    /crkey\/([\d\.]+)/i
                    // Google Chromecast
                  ],
                  [y, [v, Z + "cast"]],
                  [
                    /(cros) [\w]+ ([\w\.]+\w)/i
                    // Chromium OS
                  ],
                  [[v, "Chromium OS"], y],
                  [
                    // Console
                    /(nintendo|playstation) ([wids345portablevuch]+)/i,
                    // Nintendo/Playstation
                    /(xbox); +xbox ([^\);]+)/i,
                    // Microsoft Xbox (360, One, X, S, Series X, Series S)
                    // Other
                    /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                    // Joli/Palm
                    /(mint)[\/\(\) ]?(\w*)/i,
                    // Mint
                    /(mageia|vectorlinux)[; ]/i,
                    // Mageia/VectorLinux
                    /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                    // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                    /(hurd|linux) ?([\w\.]*)/i,
                    // Hurd/Linux
                    /(gnu) ?([\w\.]*)/i,
                    // GNU
                    /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
                    /(haiku) (\w+)/i
                    // Haiku
                  ],
                  [v, y],
                  [
                    /(sunos) ?([\w\.\d]*)/i
                    // Solaris
                  ],
                  [[v, "Solaris"], y],
                  [
                    /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                    // Solaris
                    /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                    // AIX
                    /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
                    // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
                    /(unix) ?([\w\.]*)/i
                    // UNIX
                  ],
                  [v, y]
                ]
              }, $ = function(q, _e) {
                if (typeof q === S && (_e = q, q = i), !(this instanceof $))
                  return new $(q, _e).getResult();
                var Ee = q || (typeof n !== T && n.navigator && n.navigator.userAgent ? n.navigator.userAgent : l), Te = _e ? re(W, _e) : W;
                return this.getBrowser = function() {
                  var Ce = {};
                  return Ce[v] = i, Ce[y] = i, k.call(Ce, Ee, Te.browser), Ce.major = p(Ce.version), Ce;
                }, this.getCPU = function() {
                  var Ce = {};
                  return Ce[u] = i, k.call(Ce, Ee, Te.cpu), Ce;
                }, this.getDevice = function() {
                  var Ce = {};
                  return Ce[o] = i, Ce[L] = i, Ce[c] = i, k.call(Ce, Ee, Te.device), Ce;
                }, this.getEngine = function() {
                  var Ce = {};
                  return Ce[v] = i, Ce[y] = i, k.call(Ce, Ee, Te.engine), Ce;
                }, this.getOS = function() {
                  var Ce = {};
                  return Ce[v] = i, Ce[y] = i, k.call(Ce, Ee, Te.os), Ce;
                }, this.getResult = function() {
                  return {
                    ua: this.getUA(),
                    browser: this.getBrowser(),
                    engine: this.getEngine(),
                    os: this.getOS(),
                    device: this.getDevice(),
                    cpu: this.getCPU()
                  };
                }, this.getUA = function() {
                  return Ee;
                }, this.setUA = function(Ce) {
                  return Ee = typeof Ce === h && Ce.length > b ? P(Ce, b) : Ce, this;
                }, this.setUA(Ee), this;
              };
              $.VERSION = r, $.BROWSER = ue([v, y, _]), $.CPU = ue([u]), $.DEVICE = ue([L, o, c, A, I, E, M, N, C]), $.ENGINE = $.OS = ue([v, y]), typeof m !== T ? (R.exports && (m = R.exports = $), m.UAParser = $) : e.amdO ? (g = (function() {
                return $;
              }).call(m, e, m, R), g !== i && (R.exports = g)) : typeof n !== T && (n.UAParser = $);
              var ce = typeof n !== T && (n.jQuery || n.Zepto);
              if (ce && !ce.ua) {
                var le = new $();
                ce.ua = le.getResult(), ce.ua.get = function() {
                  return le.getUA();
                }, ce.ua.set = function(q) {
                  le.setUA(q);
                  var _e = le.getResult();
                  for (var Ee in _e)
                    ce.ua[Ee] = _e[Ee];
                };
              }
            })(typeof window == "object" ? window : this);
          }
        ),
        /***/
        "./node_modules/util-deprecate/browser.js": (
          /*!************************************************!*\
            !*** ./node_modules/util-deprecate/browser.js ***!
            \************************************************/
          /***/
          (R, m, e) => {
            R.exports = g;
            function g(i, r) {
              if (n("noDeprecation"))
                return i;
              var l = !1;
              function d() {
                if (!l) {
                  if (n("throwDeprecation"))
                    throw new Error(r);
                  n("traceDeprecation") ? console.trace(r) : console.warn(r), l = !0;
                }
                return i.apply(this, arguments);
              }
              return d;
            }
            function n(i) {
              try {
                if (!e.g.localStorage)
                  return !1;
              } catch {
                return !1;
              }
              var r = e.g.localStorage[i];
              return r == null ? !1 : String(r).toLowerCase() === "true";
            }
          }
        ),
        /***/
        "?3e83": (
          /*!**********************!*\
            !*** util (ignored) ***!
            \**********************/
          /***/
          () => {
          }
        ),
        /***/
        "?19e6": (
          /*!**********************!*\
            !*** util (ignored) ***!
            \**********************/
          /***/
          () => {
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/lib/defaults.json": (
          /*!*********************************************************!*\
            !*** ./node_modules/bcp-47-normalize/lib/defaults.json ***!
            \*********************************************************/
          /***/
          (R) => {
            R.exports = JSON.parse('["mni-beng-in","mni-mtei-in","sat-deva-in","sat-olck-in","shi-latn-ma","shi-tfng-ma","vai-latn-lr","vai-vaii-lr","yue-hans-cn","yue-hant-hk","az-arab-ir","az-cyrl-az","az-latn-az","bm-nkoo-ml","bs-cyrl-ba","bs-latn-ba","en-dsrt-us","ff-adlm-gn","ff-latn-sn","ha-arab-ng","hi-latn-in","iu-latn-ca","ks-arab-in","ks-deva-in","mn-mong-cn","ms-arab-my","pa-arab-pk","pa-guru-in","sd-arab-pk","sd-deva-in","sr-cyrl-rs","sr-latn-rs","su-latn-id","uz-arab-af","uz-cyrl-uz","uz-latn-uz","zh-hans-cn","zh-hant-tw","mni-beng","sat-olck","shi-tfng","vai-vaii","yue-hant","az-latn","bs-latn","ff-latn","jbo-001","ks-arab","pa-guru","prg-001","sd-arab","sr-cyrl","su-latn","uz-latn","zh-hans","agq-cm","ar-001","arn-cl","asa-tz","ast-es","bas-cm","bem-zm","bez-tz","bgn-pk","blt-vn","brx-in","bss-cm","byn-er","cad-us","cch-ng","ccp-bd","ceb-ph","cgg-ug","chr-us","cic-us","ckb-iq","dav-ke","dje-ne","doi-in","dsb-de","dua-cm","dyo-sn","ebu-ke","eo-001","ewo-cm","fil-ph","fur-it","gaa-gh","gez-et","gsw-ch","guz-ke","haw-us","hsb-de","ia-001","ife-tg","io-001","jgo-cm","jmc-tz","kab-dz","kaj-ng","kam-ke","kcg-ng","kde-tz","kea-cv","ken-cm","khq-ml","kkj-cm","kln-ke","kok-in","kpe-lr","ksb-tz","ksf-cm","ksh-de","lag-tz","lkt-us","lrc-ir","luo-ke","luy-ke","mai-in","mas-ke","mer-ke","mfe-mu","mgh-mz","mgo-cm","moh-ca","mua-cm","mus-us","myv-ru","mzn-ir","naq-na","nds-de","nmg-cm","nnh-cm","nqo-gn","nso-za","nus-ss","nyn-ug","osa-us","pcm-ng","quc-gt","rof-tz","rwk-tz","sah-ru","saq-ke","sbp-tz","scn-it","sdh-ir","seh-mz","ses-ml","sid-et","sma-se","smj-se","smn-fi","sms-fi","ssy-er","syr-iq","szl-pl","teo-ug","tig-er","trv-tw","trw-pk","twq-ne","tzm-ma","vo-001","vun-tz","wae-ch","wal-et","wbp-au","xog-ug","yav-cm","yi-001","zgh-ma","aa-et","af-za","ak-gh","am-et","an-es","as-in","ba-ru","be-by","bg-bg","bm-ml","bn-bd","bo-cn","br-fr","ca-es","ce-ru","co-fr","cs-cz","cu-ru","cv-ru","cy-gb","da-dk","de-de","dv-mv","dz-bt","ee-gh","el-gr","en-us","es-es","et-ee","eu-es","fa-ir","fi-fi","fo-fo","fr-fr","fy-nl","ga-ie","gd-gb","gl-es","gn-py","gu-in","gv-im","ha-ng","he-il","hi-in","hr-hr","hu-hu","hy-am","id-id","ig-ng","ii-cn","is-is","it-it","iu-ca","ja-jp","jv-id","ka-ge","ki-ke","kk-kz","kl-gl","km-kh","kn-in","ko-kr","ku-tr","kw-gb","ky-kg","lb-lu","lg-ug","ln-cd","lo-la","lt-lt","lu-cd","lv-lv","mg-mg","mi-nz","mk-mk","ml-in","mn-mn","mr-in","ms-my","mt-mt","my-mm","nb-no","nd-zw","ne-np","nl-nl","nn-no","nr-za","nv-us","ny-mw","oc-fr","om-et","or-in","os-ge","pl-pl","ps-af","pt-br","qu-pe","rm-ch","rn-bi","ro-ro","ru-ru","rw-rw","sa-in","sc-it","se-no","sg-cf","si-lk","sk-sk","sl-si","sn-zw","so-so","sq-al","ss-za","st-za","sv-se","sw-tz","ta-in","te-in","tg-tj","th-th","ti-et","tk-tm","tn-za","to-to","tr-tr","ts-za","tt-ru","ug-cn","uk-ua","ur-pk","ve-za","vi-vn","wa-be","wo-sn","xh-za","yo-ng","zu-za"]');
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/lib/fields.json": (
          /*!*******************************************************!*\
            !*** ./node_modules/bcp-47-normalize/lib/fields.json ***!
            \*******************************************************/
          /***/
          (R) => {
            R.exports = JSON.parse('[{"from":{"field":"script","value":"qaai"},"to":{"field":"script","value":"zinh"}},{"from":{"field":"region","value":"bu"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"ct"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"dd"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"dy"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"fx"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"hv"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"jt"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"mi"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"nh"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"nq"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"pu"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"pz"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"qu"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"rh"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"tp"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"uk"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"vd"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"wk"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"yd"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"zr"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"230"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"280"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"736"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"886"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"958"},"to":{"field":"region","value":"aa"}},{"from":{"field":"region","value":"020"},"to":{"field":"region","value":"ad"}},{"from":{"field":"region","value":"784"},"to":{"field":"region","value":"ae"}},{"from":{"field":"region","value":"004"},"to":{"field":"region","value":"af"}},{"from":{"field":"region","value":"028"},"to":{"field":"region","value":"ag"}},{"from":{"field":"region","value":"660"},"to":{"field":"region","value":"ai"}},{"from":{"field":"region","value":"008"},"to":{"field":"region","value":"al"}},{"from":{"field":"region","value":"051"},"to":{"field":"region","value":"am"}},{"from":{"field":"region","value":"024"},"to":{"field":"region","value":"ao"}},{"from":{"field":"region","value":"010"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"032"},"to":{"field":"region","value":"ar"}},{"from":{"field":"region","value":"016"},"to":{"field":"region","value":"as"}},{"from":{"field":"region","value":"040"},"to":{"field":"region","value":"at"}},{"from":{"field":"region","value":"036"},"to":{"field":"region","value":"au"}},{"from":{"field":"region","value":"533"},"to":{"field":"region","value":"aw"}},{"from":{"field":"region","value":"248"},"to":{"field":"region","value":"ax"}},{"from":{"field":"region","value":"031"},"to":{"field":"region","value":"az"}},{"from":{"field":"region","value":"070"},"to":{"field":"region","value":"ba"}},{"from":{"field":"region","value":"052"},"to":{"field":"region","value":"bb"}},{"from":{"field":"region","value":"050"},"to":{"field":"region","value":"bd"}},{"from":{"field":"region","value":"056"},"to":{"field":"region","value":"be"}},{"from":{"field":"region","value":"854"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"100"},"to":{"field":"region","value":"bg"}},{"from":{"field":"region","value":"048"},"to":{"field":"region","value":"bh"}},{"from":{"field":"region","value":"108"},"to":{"field":"region","value":"bi"}},{"from":{"field":"region","value":"204"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"652"},"to":{"field":"region","value":"bl"}},{"from":{"field":"region","value":"060"},"to":{"field":"region","value":"bm"}},{"from":{"field":"region","value":"096"},"to":{"field":"region","value":"bn"}},{"from":{"field":"region","value":"068"},"to":{"field":"region","value":"bo"}},{"from":{"field":"region","value":"535"},"to":{"field":"region","value":"bq"}},{"from":{"field":"region","value":"076"},"to":{"field":"region","value":"br"}},{"from":{"field":"region","value":"044"},"to":{"field":"region","value":"bs"}},{"from":{"field":"region","value":"064"},"to":{"field":"region","value":"bt"}},{"from":{"field":"region","value":"104"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"074"},"to":{"field":"region","value":"bv"}},{"from":{"field":"region","value":"072"},"to":{"field":"region","value":"bw"}},{"from":{"field":"region","value":"112"},"to":{"field":"region","value":"by"}},{"from":{"field":"region","value":"084"},"to":{"field":"region","value":"bz"}},{"from":{"field":"region","value":"124"},"to":{"field":"region","value":"ca"}},{"from":{"field":"region","value":"166"},"to":{"field":"region","value":"cc"}},{"from":{"field":"region","value":"180"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"140"},"to":{"field":"region","value":"cf"}},{"from":{"field":"region","value":"178"},"to":{"field":"region","value":"cg"}},{"from":{"field":"region","value":"756"},"to":{"field":"region","value":"ch"}},{"from":{"field":"region","value":"384"},"to":{"field":"region","value":"ci"}},{"from":{"field":"region","value":"184"},"to":{"field":"region","value":"ck"}},{"from":{"field":"region","value":"152"},"to":{"field":"region","value":"cl"}},{"from":{"field":"region","value":"120"},"to":{"field":"region","value":"cm"}},{"from":{"field":"region","value":"156"},"to":{"field":"region","value":"cn"}},{"from":{"field":"region","value":"170"},"to":{"field":"region","value":"co"}},{"from":{"field":"region","value":"188"},"to":{"field":"region","value":"cr"}},{"from":{"field":"region","value":"192"},"to":{"field":"region","value":"cu"}},{"from":{"field":"region","value":"132"},"to":{"field":"region","value":"cv"}},{"from":{"field":"region","value":"531"},"to":{"field":"region","value":"cw"}},{"from":{"field":"region","value":"162"},"to":{"field":"region","value":"cx"}},{"from":{"field":"region","value":"196"},"to":{"field":"region","value":"cy"}},{"from":{"field":"region","value":"203"},"to":{"field":"region","value":"cz"}},{"from":{"field":"region","value":"278"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"276"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"262"},"to":{"field":"region","value":"dj"}},{"from":{"field":"region","value":"208"},"to":{"field":"region","value":"dk"}},{"from":{"field":"region","value":"212"},"to":{"field":"region","value":"dm"}},{"from":{"field":"region","value":"214"},"to":{"field":"region","value":"do"}},{"from":{"field":"region","value":"012"},"to":{"field":"region","value":"dz"}},{"from":{"field":"region","value":"218"},"to":{"field":"region","value":"ec"}},{"from":{"field":"region","value":"233"},"to":{"field":"region","value":"ee"}},{"from":{"field":"region","value":"818"},"to":{"field":"region","value":"eg"}},{"from":{"field":"region","value":"732"},"to":{"field":"region","value":"eh"}},{"from":{"field":"region","value":"232"},"to":{"field":"region","value":"er"}},{"from":{"field":"region","value":"724"},"to":{"field":"region","value":"es"}},{"from":{"field":"region","value":"231"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"246"},"to":{"field":"region","value":"fi"}},{"from":{"field":"region","value":"242"},"to":{"field":"region","value":"fj"}},{"from":{"field":"region","value":"238"},"to":{"field":"region","value":"fk"}},{"from":{"field":"region","value":"583"},"to":{"field":"region","value":"fm"}},{"from":{"field":"region","value":"234"},"to":{"field":"region","value":"fo"}},{"from":{"field":"region","value":"250"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"249"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"266"},"to":{"field":"region","value":"ga"}},{"from":{"field":"region","value":"826"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"308"},"to":{"field":"region","value":"gd"}},{"from":{"field":"region","value":"268"},"to":{"field":"region","value":"ge"}},{"from":{"field":"region","value":"254"},"to":{"field":"region","value":"gf"}},{"from":{"field":"region","value":"831"},"to":{"field":"region","value":"gg"}},{"from":{"field":"region","value":"288"},"to":{"field":"region","value":"gh"}},{"from":{"field":"region","value":"292"},"to":{"field":"region","value":"gi"}},{"from":{"field":"region","value":"304"},"to":{"field":"region","value":"gl"}},{"from":{"field":"region","value":"270"},"to":{"field":"region","value":"gm"}},{"from":{"field":"region","value":"324"},"to":{"field":"region","value":"gn"}},{"from":{"field":"region","value":"312"},"to":{"field":"region","value":"gp"}},{"from":{"field":"region","value":"226"},"to":{"field":"region","value":"gq"}},{"from":{"field":"region","value":"300"},"to":{"field":"region","value":"gr"}},{"from":{"field":"region","value":"239"},"to":{"field":"region","value":"gs"}},{"from":{"field":"region","value":"320"},"to":{"field":"region","value":"gt"}},{"from":{"field":"region","value":"316"},"to":{"field":"region","value":"gu"}},{"from":{"field":"region","value":"624"},"to":{"field":"region","value":"gw"}},{"from":{"field":"region","value":"328"},"to":{"field":"region","value":"gy"}},{"from":{"field":"region","value":"344"},"to":{"field":"region","value":"hk"}},{"from":{"field":"region","value":"334"},"to":{"field":"region","value":"hm"}},{"from":{"field":"region","value":"340"},"to":{"field":"region","value":"hn"}},{"from":{"field":"region","value":"191"},"to":{"field":"region","value":"hr"}},{"from":{"field":"region","value":"332"},"to":{"field":"region","value":"ht"}},{"from":{"field":"region","value":"348"},"to":{"field":"region","value":"hu"}},{"from":{"field":"region","value":"360"},"to":{"field":"region","value":"id"}},{"from":{"field":"region","value":"372"},"to":{"field":"region","value":"ie"}},{"from":{"field":"region","value":"376"},"to":{"field":"region","value":"il"}},{"from":{"field":"region","value":"833"},"to":{"field":"region","value":"im"}},{"from":{"field":"region","value":"356"},"to":{"field":"region","value":"in"}},{"from":{"field":"region","value":"086"},"to":{"field":"region","value":"io"}},{"from":{"field":"region","value":"368"},"to":{"field":"region","value":"iq"}},{"from":{"field":"region","value":"364"},"to":{"field":"region","value":"ir"}},{"from":{"field":"region","value":"352"},"to":{"field":"region","value":"is"}},{"from":{"field":"region","value":"380"},"to":{"field":"region","value":"it"}},{"from":{"field":"region","value":"832"},"to":{"field":"region","value":"je"}},{"from":{"field":"region","value":"388"},"to":{"field":"region","value":"jm"}},{"from":{"field":"region","value":"400"},"to":{"field":"region","value":"jo"}},{"from":{"field":"region","value":"392"},"to":{"field":"region","value":"jp"}},{"from":{"field":"region","value":"404"},"to":{"field":"region","value":"ke"}},{"from":{"field":"region","value":"417"},"to":{"field":"region","value":"kg"}},{"from":{"field":"region","value":"116"},"to":{"field":"region","value":"kh"}},{"from":{"field":"region","value":"296"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"174"},"to":{"field":"region","value":"km"}},{"from":{"field":"region","value":"659"},"to":{"field":"region","value":"kn"}},{"from":{"field":"region","value":"408"},"to":{"field":"region","value":"kp"}},{"from":{"field":"region","value":"410"},"to":{"field":"region","value":"kr"}},{"from":{"field":"region","value":"414"},"to":{"field":"region","value":"kw"}},{"from":{"field":"region","value":"136"},"to":{"field":"region","value":"ky"}},{"from":{"field":"region","value":"398"},"to":{"field":"region","value":"kz"}},{"from":{"field":"region","value":"418"},"to":{"field":"region","value":"la"}},{"from":{"field":"region","value":"422"},"to":{"field":"region","value":"lb"}},{"from":{"field":"region","value":"662"},"to":{"field":"region","value":"lc"}},{"from":{"field":"region","value":"438"},"to":{"field":"region","value":"li"}},{"from":{"field":"region","value":"144"},"to":{"field":"region","value":"lk"}},{"from":{"field":"region","value":"430"},"to":{"field":"region","value":"lr"}},{"from":{"field":"region","value":"426"},"to":{"field":"region","value":"ls"}},{"from":{"field":"region","value":"440"},"to":{"field":"region","value":"lt"}},{"from":{"field":"region","value":"442"},"to":{"field":"region","value":"lu"}},{"from":{"field":"region","value":"428"},"to":{"field":"region","value":"lv"}},{"from":{"field":"region","value":"434"},"to":{"field":"region","value":"ly"}},{"from":{"field":"region","value":"504"},"to":{"field":"region","value":"ma"}},{"from":{"field":"region","value":"492"},"to":{"field":"region","value":"mc"}},{"from":{"field":"region","value":"498"},"to":{"field":"region","value":"md"}},{"from":{"field":"region","value":"499"},"to":{"field":"region","value":"me"}},{"from":{"field":"region","value":"663"},"to":{"field":"region","value":"mf"}},{"from":{"field":"region","value":"450"},"to":{"field":"region","value":"mg"}},{"from":{"field":"region","value":"584"},"to":{"field":"region","value":"mh"}},{"from":{"field":"region","value":"807"},"to":{"field":"region","value":"mk"}},{"from":{"field":"region","value":"466"},"to":{"field":"region","value":"ml"}},{"from":{"field":"region","value":"496"},"to":{"field":"region","value":"mn"}},{"from":{"field":"region","value":"446"},"to":{"field":"region","value":"mo"}},{"from":{"field":"region","value":"580"},"to":{"field":"region","value":"mp"}},{"from":{"field":"region","value":"474"},"to":{"field":"region","value":"mq"}},{"from":{"field":"region","value":"478"},"to":{"field":"region","value":"mr"}},{"from":{"field":"region","value":"500"},"to":{"field":"region","value":"ms"}},{"from":{"field":"region","value":"470"},"to":{"field":"region","value":"mt"}},{"from":{"field":"region","value":"480"},"to":{"field":"region","value":"mu"}},{"from":{"field":"region","value":"462"},"to":{"field":"region","value":"mv"}},{"from":{"field":"region","value":"454"},"to":{"field":"region","value":"mw"}},{"from":{"field":"region","value":"484"},"to":{"field":"region","value":"mx"}},{"from":{"field":"region","value":"458"},"to":{"field":"region","value":"my"}},{"from":{"field":"region","value":"508"},"to":{"field":"region","value":"mz"}},{"from":{"field":"region","value":"516"},"to":{"field":"region","value":"na"}},{"from":{"field":"region","value":"540"},"to":{"field":"region","value":"nc"}},{"from":{"field":"region","value":"562"},"to":{"field":"region","value":"ne"}},{"from":{"field":"region","value":"574"},"to":{"field":"region","value":"nf"}},{"from":{"field":"region","value":"566"},"to":{"field":"region","value":"ng"}},{"from":{"field":"region","value":"558"},"to":{"field":"region","value":"ni"}},{"from":{"field":"region","value":"528"},"to":{"field":"region","value":"nl"}},{"from":{"field":"region","value":"578"},"to":{"field":"region","value":"no"}},{"from":{"field":"region","value":"524"},"to":{"field":"region","value":"np"}},{"from":{"field":"region","value":"520"},"to":{"field":"region","value":"nr"}},{"from":{"field":"region","value":"570"},"to":{"field":"region","value":"nu"}},{"from":{"field":"region","value":"554"},"to":{"field":"region","value":"nz"}},{"from":{"field":"region","value":"512"},"to":{"field":"region","value":"om"}},{"from":{"field":"region","value":"591"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"604"},"to":{"field":"region","value":"pe"}},{"from":{"field":"region","value":"258"},"to":{"field":"region","value":"pf"}},{"from":{"field":"region","value":"598"},"to":{"field":"region","value":"pg"}},{"from":{"field":"region","value":"608"},"to":{"field":"region","value":"ph"}},{"from":{"field":"region","value":"586"},"to":{"field":"region","value":"pk"}},{"from":{"field":"region","value":"616"},"to":{"field":"region","value":"pl"}},{"from":{"field":"region","value":"666"},"to":{"field":"region","value":"pm"}},{"from":{"field":"region","value":"612"},"to":{"field":"region","value":"pn"}},{"from":{"field":"region","value":"630"},"to":{"field":"region","value":"pr"}},{"from":{"field":"region","value":"275"},"to":{"field":"region","value":"ps"}},{"from":{"field":"region","value":"620"},"to":{"field":"region","value":"pt"}},{"from":{"field":"region","value":"585"},"to":{"field":"region","value":"pw"}},{"from":{"field":"region","value":"600"},"to":{"field":"region","value":"py"}},{"from":{"field":"region","value":"634"},"to":{"field":"region","value":"qa"}},{"from":{"field":"region","value":"959"},"to":{"field":"region","value":"qm"}},{"from":{"field":"region","value":"960"},"to":{"field":"region","value":"qn"}},{"from":{"field":"region","value":"962"},"to":{"field":"region","value":"qp"}},{"from":{"field":"region","value":"963"},"to":{"field":"region","value":"qq"}},{"from":{"field":"region","value":"964"},"to":{"field":"region","value":"qr"}},{"from":{"field":"region","value":"965"},"to":{"field":"region","value":"qs"}},{"from":{"field":"region","value":"966"},"to":{"field":"region","value":"qt"}},{"from":{"field":"region","value":"967"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"968"},"to":{"field":"region","value":"qv"}},{"from":{"field":"region","value":"969"},"to":{"field":"region","value":"qw"}},{"from":{"field":"region","value":"970"},"to":{"field":"region","value":"qx"}},{"from":{"field":"region","value":"971"},"to":{"field":"region","value":"qy"}},{"from":{"field":"region","value":"972"},"to":{"field":"region","value":"qz"}},{"from":{"field":"region","value":"638"},"to":{"field":"region","value":"re"}},{"from":{"field":"region","value":"642"},"to":{"field":"region","value":"ro"}},{"from":{"field":"region","value":"688"},"to":{"field":"region","value":"rs"}},{"from":{"field":"region","value":"643"},"to":{"field":"region","value":"ru"}},{"from":{"field":"region","value":"646"},"to":{"field":"region","value":"rw"}},{"from":{"field":"region","value":"682"},"to":{"field":"region","value":"sa"}},{"from":{"field":"region","value":"090"},"to":{"field":"region","value":"sb"}},{"from":{"field":"region","value":"690"},"to":{"field":"region","value":"sc"}},{"from":{"field":"region","value":"729"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"752"},"to":{"field":"region","value":"se"}},{"from":{"field":"region","value":"702"},"to":{"field":"region","value":"sg"}},{"from":{"field":"region","value":"654"},"to":{"field":"region","value":"sh"}},{"from":{"field":"region","value":"705"},"to":{"field":"region","value":"si"}},{"from":{"field":"region","value":"744"},"to":{"field":"region","value":"sj"}},{"from":{"field":"region","value":"703"},"to":{"field":"region","value":"sk"}},{"from":{"field":"region","value":"694"},"to":{"field":"region","value":"sl"}},{"from":{"field":"region","value":"674"},"to":{"field":"region","value":"sm"}},{"from":{"field":"region","value":"686"},"to":{"field":"region","value":"sn"}},{"from":{"field":"region","value":"706"},"to":{"field":"region","value":"so"}},{"from":{"field":"region","value":"740"},"to":{"field":"region","value":"sr"}},{"from":{"field":"region","value":"728"},"to":{"field":"region","value":"ss"}},{"from":{"field":"region","value":"678"},"to":{"field":"region","value":"st"}},{"from":{"field":"region","value":"222"},"to":{"field":"region","value":"sv"}},{"from":{"field":"region","value":"534"},"to":{"field":"region","value":"sx"}},{"from":{"field":"region","value":"760"},"to":{"field":"region","value":"sy"}},{"from":{"field":"region","value":"748"},"to":{"field":"region","value":"sz"}},{"from":{"field":"region","value":"796"},"to":{"field":"region","value":"tc"}},{"from":{"field":"region","value":"148"},"to":{"field":"region","value":"td"}},{"from":{"field":"region","value":"260"},"to":{"field":"region","value":"tf"}},{"from":{"field":"region","value":"768"},"to":{"field":"region","value":"tg"}},{"from":{"field":"region","value":"764"},"to":{"field":"region","value":"th"}},{"from":{"field":"region","value":"762"},"to":{"field":"region","value":"tj"}},{"from":{"field":"region","value":"772"},"to":{"field":"region","value":"tk"}},{"from":{"field":"region","value":"626"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"795"},"to":{"field":"region","value":"tm"}},{"from":{"field":"region","value":"788"},"to":{"field":"region","value":"tn"}},{"from":{"field":"region","value":"776"},"to":{"field":"region","value":"to"}},{"from":{"field":"region","value":"792"},"to":{"field":"region","value":"tr"}},{"from":{"field":"region","value":"780"},"to":{"field":"region","value":"tt"}},{"from":{"field":"region","value":"798"},"to":{"field":"region","value":"tv"}},{"from":{"field":"region","value":"158"},"to":{"field":"region","value":"tw"}},{"from":{"field":"region","value":"834"},"to":{"field":"region","value":"tz"}},{"from":{"field":"region","value":"804"},"to":{"field":"region","value":"ua"}},{"from":{"field":"region","value":"800"},"to":{"field":"region","value":"ug"}},{"from":{"field":"region","value":"581"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"840"},"to":{"field":"region","value":"us"}},{"from":{"field":"region","value":"858"},"to":{"field":"region","value":"uy"}},{"from":{"field":"region","value":"860"},"to":{"field":"region","value":"uz"}},{"from":{"field":"region","value":"336"},"to":{"field":"region","value":"va"}},{"from":{"field":"region","value":"670"},"to":{"field":"region","value":"vc"}},{"from":{"field":"region","value":"862"},"to":{"field":"region","value":"ve"}},{"from":{"field":"region","value":"092"},"to":{"field":"region","value":"vg"}},{"from":{"field":"region","value":"850"},"to":{"field":"region","value":"vi"}},{"from":{"field":"region","value":"704"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"548"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"876"},"to":{"field":"region","value":"wf"}},{"from":{"field":"region","value":"882"},"to":{"field":"region","value":"ws"}},{"from":{"field":"region","value":"973"},"to":{"field":"region","value":"xa"}},{"from":{"field":"region","value":"974"},"to":{"field":"region","value":"xb"}},{"from":{"field":"region","value":"975"},"to":{"field":"region","value":"xc"}},{"from":{"field":"region","value":"976"},"to":{"field":"region","value":"xd"}},{"from":{"field":"region","value":"977"},"to":{"field":"region","value":"xe"}},{"from":{"field":"region","value":"978"},"to":{"field":"region","value":"xf"}},{"from":{"field":"region","value":"979"},"to":{"field":"region","value":"xg"}},{"from":{"field":"region","value":"980"},"to":{"field":"region","value":"xh"}},{"from":{"field":"region","value":"981"},"to":{"field":"region","value":"xi"}},{"from":{"field":"region","value":"982"},"to":{"field":"region","value":"xj"}},{"from":{"field":"region","value":"983"},"to":{"field":"region","value":"xk"}},{"from":{"field":"region","value":"984"},"to":{"field":"region","value":"xl"}},{"from":{"field":"region","value":"985"},"to":{"field":"region","value":"xm"}},{"from":{"field":"region","value":"986"},"to":{"field":"region","value":"xn"}},{"from":{"field":"region","value":"987"},"to":{"field":"region","value":"xo"}},{"from":{"field":"region","value":"988"},"to":{"field":"region","value":"xp"}},{"from":{"field":"region","value":"989"},"to":{"field":"region","value":"xq"}},{"from":{"field":"region","value":"990"},"to":{"field":"region","value":"xr"}},{"from":{"field":"region","value":"991"},"to":{"field":"region","value":"xs"}},{"from":{"field":"region","value":"992"},"to":{"field":"region","value":"xt"}},{"from":{"field":"region","value":"993"},"to":{"field":"region","value":"xu"}},{"from":{"field":"region","value":"994"},"to":{"field":"region","value":"xv"}},{"from":{"field":"region","value":"995"},"to":{"field":"region","value":"xw"}},{"from":{"field":"region","value":"996"},"to":{"field":"region","value":"xx"}},{"from":{"field":"region","value":"997"},"to":{"field":"region","value":"xy"}},{"from":{"field":"region","value":"998"},"to":{"field":"region","value":"xz"}},{"from":{"field":"region","value":"720"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"887"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"175"},"to":{"field":"region","value":"yt"}},{"from":{"field":"region","value":"710"},"to":{"field":"region","value":"za"}},{"from":{"field":"region","value":"894"},"to":{"field":"region","value":"zm"}},{"from":{"field":"region","value":"716"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"999"},"to":{"field":"region","value":"zz"}},{"from":{"field":"variants","value":"aaland"},"to":{"field":"region","value":"ax"}},{"from":{"field":"variants","value":"polytoni"},"to":{"field":"variants","value":"polyton"}},{"from":{"field":"variants","value":"heploc"},"to":{"field":"variants","value":"alalc97"}},{"from":{"field":"variants","value":"arevela"},"to":{"field":"language","value":"hy"}},{"from":{"field":"variants","value":"arevmda"},"to":{"field":"language","value":"hyw"}}]');
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/lib/many.json": (
          /*!*****************************************************!*\
            !*** ./node_modules/bcp-47-normalize/lib/many.json ***!
            \*****************************************************/
          /***/
          (R) => {
            R.exports = JSON.parse('{"region":{"172":["ru","am","az","by","ge","kg","kz","md","tj","tm","ua","uz"],"200":["cz","sk"],"530":["cw","sx","bq"],"532":["cw","sx","bq"],"536":["sa","iq"],"582":["fm","mh","mp","pw"],"810":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"830":["je","gg"],"890":["rs","me","si","hr","mk","ba"],"891":["rs","me"],"an":["cw","sx","bq"],"cs":["rs","me"],"fq":["aq","tf"],"nt":["sa","iq"],"pc":["fm","mh","mp","pw"],"su":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yu":["rs","me"],"062":["034","143"],"ant":["cw","sx","bq"],"scg":["rs","me"],"ntz":["sa","iq"],"sun":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yug":["rs","me"]}}');
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/lib/matches.json": (
          /*!********************************************************!*\
            !*** ./node_modules/bcp-47-normalize/lib/matches.json ***!
            \********************************************************/
          /***/
          (R) => {
            R.exports = JSON.parse('[{"from":"in","to":"id"},{"from":"iw","to":"he"},{"from":"ji","to":"yi"},{"from":"jw","to":"jv"},{"from":"mo","to":"ro"},{"from":"scc","to":"sr"},{"from":"scr","to":"hr"},{"from":"aam","to":"aas"},{"from":"adp","to":"dz"},{"from":"aue","to":"ktz"},{"from":"ayx","to":"nun"},{"from":"bgm","to":"bcg"},{"from":"bjd","to":"drl"},{"from":"ccq","to":"rki"},{"from":"cjr","to":"mom"},{"from":"cka","to":"cmr"},{"from":"cmk","to":"xch"},{"from":"coy","to":"pij"},{"from":"cqu","to":"quh"},{"from":"drh","to":"mn"},{"from":"drw","to":"fa-af"},{"from":"gav","to":"dev"},{"from":"gfx","to":"vaj"},{"from":"ggn","to":"gvr"},{"from":"gti","to":"nyc"},{"from":"guv","to":"duz"},{"from":"hrr","to":"jal"},{"from":"ibi","to":"opa"},{"from":"ilw","to":"gal"},{"from":"jeg","to":"oyb"},{"from":"kgc","to":"tdf"},{"from":"kgh","to":"kml"},{"from":"koj","to":"kwv"},{"from":"krm","to":"bmf"},{"from":"ktr","to":"dtp"},{"from":"kvs","to":"gdj"},{"from":"kwq","to":"yam"},{"from":"kxe","to":"tvd"},{"from":"kzj","to":"dtp"},{"from":"kzt","to":"dtp"},{"from":"lii","to":"raq"},{"from":"lmm","to":"rmx"},{"from":"meg","to":"cir"},{"from":"mst","to":"mry"},{"from":"mwj","to":"vaj"},{"from":"myt","to":"mry"},{"from":"nad","to":"xny"},{"from":"ncp","to":"kdz"},{"from":"nnx","to":"ngv"},{"from":"nts","to":"pij"},{"from":"oun","to":"vaj"},{"from":"pcr","to":"adx"},{"from":"pmc","to":"huw"},{"from":"pmu","to":"phr"},{"from":"ppa","to":"bfy"},{"from":"ppr","to":"lcq"},{"from":"pry","to":"prt"},{"from":"puz","to":"pub"},{"from":"sca","to":"hle"},{"from":"skk","to":"oyb"},{"from":"tdu","to":"dtp"},{"from":"thc","to":"tpo"},{"from":"thx","to":"oyb"},{"from":"tie","to":"ras"},{"from":"tkk","to":"twm"},{"from":"tlw","to":"weo"},{"from":"tmp","to":"tyj"},{"from":"tne","to":"kak"},{"from":"tnf","to":"fa-af"},{"from":"tsf","to":"taj"},{"from":"uok","to":"ema"},{"from":"xba","to":"cax"},{"from":"xia","to":"acn"},{"from":"xkh","to":"waw"},{"from":"xsj","to":"suj"},{"from":"ybd","to":"rki"},{"from":"yma","to":"lrr"},{"from":"ymt","to":"mtm"},{"from":"yos","to":"zom"},{"from":"yuu","to":"yug"},{"from":"asd","to":"snz"},{"from":"dit","to":"dif"},{"from":"llo","to":"ngt"},{"from":"myd","to":"aog"},{"from":"nns","to":"nbr"},{"from":"sgn-br","to":"bzs"},{"from":"sgn-co","to":"csn"},{"from":"sgn-de","to":"gsg"},{"from":"sgn-dk","to":"dsl"},{"from":"sgn-fr","to":"fsl"},{"from":"sgn-gb","to":"bfi"},{"from":"sgn-gr","to":"gss"},{"from":"sgn-ie","to":"isg"},{"from":"sgn-it","to":"ise"},{"from":"sgn-jp","to":"jsl"},{"from":"sgn-mx","to":"mfs"},{"from":"sgn-ni","to":"ncs"},{"from":"sgn-nl","to":"dse"},{"from":"sgn-no","to":"nsi"},{"from":"sgn-pt","to":"psr"},{"from":"sgn-se","to":"swl"},{"from":"sgn-us","to":"ase"},{"from":"sgn-za","to":"sfs"},{"from":"no-bokmal","to":"nb"},{"from":"no-nynorsk","to":"nn"},{"from":"aa-saaho","to":"ssy"},{"from":"sh","to":"sr-latn"},{"from":"cnr","to":"sr-me"},{"from":"no","to":"nb"},{"from":"tl","to":"fil"},{"from":"az-az","to":"az-latn-az"},{"from":"bs-ba","to":"bs-latn-ba"},{"from":"ha-latn-gh","to":"ha-gh"},{"from":"ha-latn-ne","to":"ha-ne"},{"from":"ha-latn-ng","to":"ha-ng"},{"from":"kk-cyrl-kz","to":"kk-kz"},{"from":"ky-cyrl-kg","to":"ky-kg"},{"from":"ks-arab-in","to":"ks-in"},{"from":"mn-cyrl-mn","to":"mn-mn"},{"from":"ms-latn-bn","to":"ms-bn"},{"from":"ms-latn-my","to":"ms-my"},{"from":"ms-latn-sg","to":"ms-sg"},{"from":"pa-in","to":"pa-guru-in"},{"from":"pa-pk","to":"pa-arab-pk"},{"from":"shi-ma","to":"shi-tfng-ma"},{"from":"sr-ba","to":"sr-cyrl-ba"},{"from":"sr-me","to":"sr-latn-me"},{"from":"sr-rs","to":"sr-cyrl-rs"},{"from":"sr-xk","to":"sr-cyrl-xk"},{"from":"tzm-latn-ma","to":"tzm-ma"},{"from":"ug-arab-cn","to":"ug-cn"},{"from":"uz-af","to":"uz-arab-af"},{"from":"uz-uz","to":"uz-latn-uz"},{"from":"vai-lr","to":"vai-vaii-lr"},{"from":"yue-cn","to":"yue-hans-cn"},{"from":"yue-hk","to":"yue-hant-hk"},{"from":"zh-cn","to":"zh-hans-cn"},{"from":"zh-hk","to":"zh-hant-hk"},{"from":"zh-mo","to":"zh-hant-mo"},{"from":"zh-sg","to":"zh-hans-sg"},{"from":"zh-tw","to":"zh-hant-tw"},{"from":"aju","to":"jrb"},{"from":"als","to":"sq"},{"from":"arb","to":"ar"},{"from":"ayr","to":"ay"},{"from":"azj","to":"az"},{"from":"bcc","to":"bal"},{"from":"bcl","to":"bik"},{"from":"bxk","to":"luy"},{"from":"bxr","to":"bua"},{"from":"cld","to":"syr"},{"from":"cmn","to":"zh"},{"from":"cwd","to":"cr"},{"from":"dgo","to":"doi"},{"from":"dhd","to":"mwr"},{"from":"dik","to":"din"},{"from":"diq","to":"zza"},{"from":"lbk","to":"bnc"},{"from":"ekk","to":"et"},{"from":"emk","to":"man"},{"from":"esk","to":"ik"},{"from":"fat","to":"ak"},{"from":"fuc","to":"ff"},{"from":"gaz","to":"om"},{"from":"gbo","to":"grb"},{"from":"gno","to":"gon"},{"from":"gug","to":"gn"},{"from":"gya","to":"gba"},{"from":"hdn","to":"hai"},{"from":"hea","to":"hmn"},{"from":"ike","to":"iu"},{"from":"kmr","to":"ku"},{"from":"knc","to":"kr"},{"from":"kng","to":"kg"},{"from":"knn","to":"kok"},{"from":"kpv","to":"kv"},{"from":"lvs","to":"lv"},{"from":"mhr","to":"chm"},{"from":"mup","to":"raj"},{"from":"khk","to":"mn"},{"from":"npi","to":"ne"},{"from":"ojg","to":"oj"},{"from":"ory","to":"or"},{"from":"pbu","to":"ps"},{"from":"pes","to":"fa"},{"from":"plt","to":"mg"},{"from":"pnb","to":"lah"},{"from":"quz","to":"qu"},{"from":"rmy","to":"rom"},{"from":"spy","to":"kln"},{"from":"src","to":"sc"},{"from":"swh","to":"sw"},{"from":"ttq","to":"tmh"},{"from":"tw","to":"ak"},{"from":"umu","to":"del"},{"from":"uzn","to":"uz"},{"from":"xpe","to":"kpe"},{"from":"xsl","to":"den"},{"from":"ydd","to":"yi"},{"from":"zai","to":"zap"},{"from":"zsm","to":"ms"},{"from":"zyb","to":"za"},{"from":"him","to":"srx"},{"from":"mnk","to":"man"},{"from":"bh","to":"bho"},{"from":"prs","to":"fa-af"},{"from":"swc","to":"sw-cd"},{"from":"aar","to":"aa"},{"from":"abk","to":"ab"},{"from":"ave","to":"ae"},{"from":"afr","to":"af"},{"from":"aka","to":"ak"},{"from":"amh","to":"am"},{"from":"arg","to":"an"},{"from":"ara","to":"ar"},{"from":"asm","to":"as"},{"from":"ava","to":"av"},{"from":"aym","to":"ay"},{"from":"aze","to":"az"},{"from":"bak","to":"ba"},{"from":"bel","to":"be"},{"from":"bul","to":"bg"},{"from":"bih","to":"bho"},{"from":"bis","to":"bi"},{"from":"bam","to":"bm"},{"from":"ben","to":"bn"},{"from":"bod","to":"bo"},{"from":"bre","to":"br"},{"from":"bos","to":"bs"},{"from":"cat","to":"ca"},{"from":"che","to":"ce"},{"from":"cha","to":"ch"},{"from":"cos","to":"co"},{"from":"cre","to":"cr"},{"from":"ces","to":"cs"},{"from":"chu","to":"cu"},{"from":"chv","to":"cv"},{"from":"cym","to":"cy"},{"from":"dan","to":"da"},{"from":"deu","to":"de"},{"from":"div","to":"dv"},{"from":"dzo","to":"dz"},{"from":"ewe","to":"ee"},{"from":"ell","to":"el"},{"from":"eng","to":"en"},{"from":"epo","to":"eo"},{"from":"spa","to":"es"},{"from":"est","to":"et"},{"from":"eus","to":"eu"},{"from":"fas","to":"fa"},{"from":"ful","to":"ff"},{"from":"fin","to":"fi"},{"from":"fij","to":"fj"},{"from":"fao","to":"fo"},{"from":"fra","to":"fr"},{"from":"fry","to":"fy"},{"from":"gle","to":"ga"},{"from":"gla","to":"gd"},{"from":"glg","to":"gl"},{"from":"grn","to":"gn"},{"from":"guj","to":"gu"},{"from":"glv","to":"gv"},{"from":"hau","to":"ha"},{"from":"heb","to":"he"},{"from":"hin","to":"hi"},{"from":"hmo","to":"ho"},{"from":"hrv","to":"hr"},{"from":"hat","to":"ht"},{"from":"hun","to":"hu"},{"from":"hye","to":"hy"},{"from":"her","to":"hz"},{"from":"ina","to":"ia"},{"from":"ind","to":"id"},{"from":"ile","to":"ie"},{"from":"ibo","to":"ig"},{"from":"iii","to":"ii"},{"from":"ipk","to":"ik"},{"from":"ido","to":"io"},{"from":"isl","to":"is"},{"from":"ita","to":"it"},{"from":"iku","to":"iu"},{"from":"jpn","to":"ja"},{"from":"jav","to":"jv"},{"from":"kat","to":"ka"},{"from":"kon","to":"kg"},{"from":"kik","to":"ki"},{"from":"kua","to":"kj"},{"from":"kaz","to":"kk"},{"from":"kal","to":"kl"},{"from":"khm","to":"km"},{"from":"kan","to":"kn"},{"from":"kor","to":"ko"},{"from":"kau","to":"kr"},{"from":"kas","to":"ks"},{"from":"kur","to":"ku"},{"from":"kom","to":"kv"},{"from":"cor","to":"kw"},{"from":"kir","to":"ky"},{"from":"lat","to":"la"},{"from":"ltz","to":"lb"},{"from":"lug","to":"lg"},{"from":"lim","to":"li"},{"from":"lin","to":"ln"},{"from":"lao","to":"lo"},{"from":"lit","to":"lt"},{"from":"lub","to":"lu"},{"from":"lav","to":"lv"},{"from":"mlg","to":"mg"},{"from":"mah","to":"mh"},{"from":"mri","to":"mi"},{"from":"mkd","to":"mk"},{"from":"mal","to":"ml"},{"from":"mon","to":"mn"},{"from":"mol","to":"ro"},{"from":"mar","to":"mr"},{"from":"msa","to":"ms"},{"from":"mlt","to":"mt"},{"from":"mya","to":"my"},{"from":"nau","to":"na"},{"from":"nob","to":"nb"},{"from":"nde","to":"nd"},{"from":"nep","to":"ne"},{"from":"ndo","to":"ng"},{"from":"nld","to":"nl"},{"from":"nno","to":"nn"},{"from":"nor","to":"nb"},{"from":"nbl","to":"nr"},{"from":"nav","to":"nv"},{"from":"nya","to":"ny"},{"from":"oci","to":"oc"},{"from":"oji","to":"oj"},{"from":"orm","to":"om"},{"from":"ori","to":"or"},{"from":"oss","to":"os"},{"from":"pan","to":"pa"},{"from":"pli","to":"pi"},{"from":"pol","to":"pl"},{"from":"pus","to":"ps"},{"from":"por","to":"pt"},{"from":"que","to":"qu"},{"from":"roh","to":"rm"},{"from":"run","to":"rn"},{"from":"ron","to":"ro"},{"from":"rus","to":"ru"},{"from":"kin","to":"rw"},{"from":"san","to":"sa"},{"from":"srd","to":"sc"},{"from":"snd","to":"sd"},{"from":"sme","to":"se"},{"from":"sag","to":"sg"},{"from":"hbs","to":"sr-latn"},{"from":"sin","to":"si"},{"from":"slk","to":"sk"},{"from":"slv","to":"sl"},{"from":"smo","to":"sm"},{"from":"sna","to":"sn"},{"from":"som","to":"so"},{"from":"sqi","to":"sq"},{"from":"srp","to":"sr"},{"from":"ssw","to":"ss"},{"from":"sot","to":"st"},{"from":"sun","to":"su"},{"from":"swe","to":"sv"},{"from":"swa","to":"sw"},{"from":"tam","to":"ta"},{"from":"tel","to":"te"},{"from":"tgk","to":"tg"},{"from":"tha","to":"th"},{"from":"tir","to":"ti"},{"from":"tuk","to":"tk"},{"from":"tgl","to":"fil"},{"from":"tsn","to":"tn"},{"from":"ton","to":"to"},{"from":"tur","to":"tr"},{"from":"tso","to":"ts"},{"from":"tat","to":"tt"},{"from":"twi","to":"ak"},{"from":"tah","to":"ty"},{"from":"uig","to":"ug"},{"from":"ukr","to":"uk"},{"from":"urd","to":"ur"},{"from":"uzb","to":"uz"},{"from":"ven","to":"ve"},{"from":"vie","to":"vi"},{"from":"vol","to":"vo"},{"from":"wln","to":"wa"},{"from":"wol","to":"wo"},{"from":"xho","to":"xh"},{"from":"yid","to":"yi"},{"from":"yor","to":"yo"},{"from":"zha","to":"za"},{"from":"zho","to":"zh"},{"from":"zul","to":"zu"},{"from":"alb","to":"sq"},{"from":"arm","to":"hy"},{"from":"baq","to":"eu"},{"from":"bur","to":"my"},{"from":"chi","to":"zh"},{"from":"cze","to":"cs"},{"from":"dut","to":"nl"},{"from":"fre","to":"fr"},{"from":"geo","to":"ka"},{"from":"ger","to":"de"},{"from":"gre","to":"el"},{"from":"ice","to":"is"},{"from":"mac","to":"mk"},{"from":"mao","to":"mi"},{"from":"may","to":"ms"},{"from":"per","to":"fa"},{"from":"rum","to":"ro"},{"from":"slo","to":"sk"},{"from":"tib","to":"bo"},{"from":"wel","to":"cy"}]');
          }
        ),
        /***/
        "./node_modules/bcp-47/lib/normalize.json": (
          /*!************************************************!*\
            !*** ./node_modules/bcp-47/lib/normalize.json ***!
            \************************************************/
          /***/
          (R) => {
            R.exports = JSON.parse('{"en-gb-oed":"en-GB-oxendict","i-ami":"ami","i-bnn":"bnn","i-default":null,"i-enochian":null,"i-hak":"hak","i-klingon":"tlh","i-lux":"lb","i-mingo":null,"i-navajo":"nv","i-pwn":"pwn","i-tao":"tao","i-tay":"tay","i-tsu":"tsu","sgn-be-fr":"sfb","sgn-be-nl":"vgt","sgn-ch-de":"sgg","art-lojban":"jbo","cel-gaulish":null,"no-bok":"nb","no-nyn":"nn","zh-guoyu":"cmn","zh-hakka":"hak","zh-min":null,"zh-min-nan":"nan","zh-xiang":"hsn"}');
          }
        ),
        /***/
        "./node_modules/bcp-47/lib/regular.json": (
          /*!**********************************************!*\
            !*** ./node_modules/bcp-47/lib/regular.json ***!
            \**********************************************/
          /***/
          (R) => {
            R.exports = JSON.parse('["art-lojban","cel-gaulish","no-bok","no-nyn","zh-guoyu","zh-hakka","zh-min","zh-min-nan","zh-xiang"]');
          }
        )
        /******/
      }, B = {};
      function U(R) {
        var m = B[R];
        if (m !== void 0)
          return m.exports;
        var e = B[R] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return D[R].call(e.exports, e, e.exports, U), e.exports;
      }
      U.amdO = {}, U.n = (R) => {
        var m = R && R.__esModule ? (
          /******/
          () => R.default
        ) : (
          /******/
          () => R
        );
        return U.d(m, { a: m }), m;
      }, U.d = (R, m) => {
        for (var e in m)
          U.o(m, e) && !U.o(R, e) && Object.defineProperty(R, e, { enumerable: !0, get: m[e] });
      }, U.g = function() {
        if (typeof globalThis == "object")
          return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object")
            return window;
        }
      }(), U.o = (R, m) => Object.prototype.hasOwnProperty.call(R, m), U.r = (R) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(R, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(R, "__esModule", { value: !0 });
      };
      var G = {};
      return (() => {
        /*!******************!*\
          !*** ./index.js ***!
          \******************/
        U.r(G), U.d(G, {
          /* harmony export */
          Debug: () => (
            /* reexport safe */
            i.default
          ),
          /* harmony export */
          MediaPlayer: () => (
            /* reexport safe */
            R.MediaPlayer
          ),
          /* harmony export */
          MediaPlayerFactory: () => (
            /* reexport safe */
            n.default
          ),
          /* harmony export */
          MetricsReporting: () => (
            /* reexport safe */
            e.default
          ),
          /* harmony export */
          Protection: () => (
            /* reexport safe */
            g.default
          ),
          /* harmony export */
          default: () => r,
          /* harmony export */
          supportsMediaSource: () => (
            /* reexport safe */
            m.supportsMediaSource
          )
          /* harmony export */
        });
        var R = U(
          /*! ./index_mediaplayerOnly */
          "./index_mediaplayerOnly.js"
        ), m = U(
          /*! ./src/streaming/utils/Capabilities */
          "./src/streaming/utils/Capabilities.js"
        ), e = U(
          /*! ./src/streaming/metrics/MetricsReporting */
          "./src/streaming/metrics/MetricsReporting.js"
        ), g = U(
          /*! ./src/streaming/protection/Protection */
          "./src/streaming/protection/Protection.js"
        ), n = U(
          /*! ./src/streaming/MediaPlayerFactory */
          "./src/streaming/MediaPlayerFactory.js"
        ), i = U(
          /*! ./src/core/Debug */
          "./src/core/Debug.js"
        );
        dashjs.Protection = g.default, dashjs.MetricsReporting = e.default, dashjs.MediaPlayerFactory = n.default, dashjs.Debug = i.default, dashjs.supportsMediaSource = m.supportsMediaSource;
        const r = dashjs;
      })(), G = G.default, G;
    })()
  ));
})(tc);
var eL = tc.exports;
const rc = /* @__PURE__ */ Ct({
  __name: "KWebTvVideoPlayer",
  props: {
    idVideo: {}
  },
  setup(j) {
    const f = lt(null), D = j, B = lt([]);
    let U = null;
    er(() => D.idVideo, async (R) => {
      if (R && R.length > 0) {
        const m = await Qr.getVideoSources(R);
        f.value.readyState && G(), U && U.reset(), B.value = m.map((e) => ({
          src: `${e}/manifest.mpd`,
          //?t=",
          type: "video/mp4"
        })), f.value.canPlayType("application/vnd.apple.mpegurl") ? (f.value.src = m[0], f.value.addEventListener("loadedmetadata", function() {
          f.value.play();
        })) : (U == null && (U = eL.MediaPlayer().create()), U.initialize(f.value, B.value[0].src, !0));
      }
    }, { immediate: !0 });
    const G = () => {
      f.value.pause(), f.value.currentTime = 0;
    };
    return (R, m) => (Ne(), We("video", {
      style: { width: "100%" },
      ref_key: "kVideoPlayer",
      ref: f,
      controls: "",
      oncontextmenu: "return false"
    }, " Sorry, your browser does not support the video tag. ", 512));
  }
}), tL = { class: "card-wrapper" }, rL = { class: "card" }, nL = { class: "card-body" }, aL = /* @__PURE__ */ he("br", null, null, -1), Oo = /* @__PURE__ */ Ct({
  __name: "CmsContentLoad",
  setup(j) {
    return (f, D) => (Ne(), We("div", tL, [
      he("div", rL, [
        he("div", nL, [
          gt(ot(ga), {
            height: "2rem",
            class: "mb-2"
          }),
          gt(ot(ga), {
            width: "75%",
            class: "mb-2"
          }),
          gt(ot(ga), {
            width: "50%",
            class: "mb-2"
          }),
          gt(ot(ga), { class: "mb-2" }),
          aL,
          gt(ot(ga), {
            width: "40%",
            class: "mb-2"
          })
        ])
      ])
    ]));
  }
}), iL = /* @__PURE__ */ Ct({
  __name: "KCmsLast",
  props: {
    cmsNodeCode: { default: null },
    cmsContentBaseUrl: { default: null }
  },
  setup(j) {
    const { toDateTimeLongString: f } = qr(), D = j;
    tr(async () => await G());
    const B = lt(!1), U = lt(null), G = async () => {
      var R;
      B.value = !0;
      try {
        if (U.value = null, D.cmsNodeCode) {
          const e = (await Vl.getTreeFromNode(D.cmsNodeCode, 1)).childNodes.sort((g, n) => new Date(n.publishedDate).getTime() - new Date(g.publishedDate).getTime());
          e.length > 0 && (U.value = {
            title: e[0].name,
            date: f(new Date(e[0].publishedDate)),
            description: (R = e[0].contents.find((g) => g.code == "text")) == null ? void 0 : R.value.value,
            url: D.cmsContentBaseUrl + e[0].url
          });
        }
      } finally {
        B.value = !1;
      }
    };
    return (R, m) => {
      var g, n, i, r;
      const e = Pt("KCard");
      return B.value ? (Ne(), Ft(Oo, { key: 0 })) : (Ne(), Ft(e, {
        key: 1,
        showFlagIcon: !0,
        "text-class": "pb-4",
        topTitle: (g = U.value) == null ? void 0 : g.date,
        title: (n = U.value) == null ? void 0 : n.title,
        text: (i = U.value) == null ? void 0 : i.description,
        labelDetailButton: "Dettagli",
        "show-detail-button": !0,
        detailButtonLinkUrl: (r = U.value) == null ? void 0 : r.url
      }, null, 8, ["topTitle", "title", "text", "detailButtonLinkUrl"]));
    };
  }
}), oL = { class: "card-title" }, sL = { class: "card-title" }, uL = /* @__PURE__ */ Ct({
  __name: "KCmsLatest2",
  props: {
    cmsNodeCode: { default: null },
    cmsContentBaseUrl: { default: null }
  },
  setup(j) {
    const { toDateString: f } = qr(), D = j;
    tr(async () => await R());
    const B = lt(!1), U = lt(null), G = lt(null), R = async () => {
      var m, e;
      B.value = !0;
      try {
        if (U.value = null, G.value = null, D.cmsNodeCode) {
          const n = (await Vl.getTreeFromNode(D.cmsNodeCode, 2)).childNodes.sort((i, r) => new Date(r.publishedDate).getTime() - new Date(i.publishedDate).getTime());
          n.length > 0 && (U.value = {
            title: n[0].name,
            date: f(new Date(n[0].publishedDate)),
            description: (m = n[0].contents.find((i) => i.code == "text")) == null ? void 0 : m.value.value,
            url: D.cmsContentBaseUrl + n[0].url
          }, n.length > 1 && (G.value = {
            title: n[1].name,
            date: f(new Date(n[1].publishedDate)),
            description: (e = n[1].contents.find((i) => i.code == "text")) == null ? void 0 : e.value.value,
            url: D.cmsContentBaseUrl + n[1].url
          }));
        }
      } finally {
        B.value = !1;
      }
    };
    return (m, e) => {
      const g = Pt("KCard"), n = Pt("K2ColContainer");
      return Ne(), Ft(n, {
        col1Class: "p-3",
        col2Class: "p-3"
      }, Cu({
        col1: Rt(() => [
          B.value ? (Ne(), Ft(Oo, { key: 0 })) : U.value ? (Ne(), Ft(g, {
            key: 1,
            flat: !0,
            topTitle: U.value.title,
            topTitleClass: "primary-color mb-1",
            topTitleDate: "",
            showDetailButton: !0,
            labelDetailButton: "scopri di più",
            detailButtonLinkUrl: U.value.url
          }, {
            "custom-content": Rt(() => [
              he("h5", oL, ft(U.value.description), 1)
            ]),
            _: 1
          }, 8, ["topTitle", "detailButtonLinkUrl"])) : mt("", !0)
        ]),
        _: 2
      }, [
        G.value ? {
          name: "col2",
          fn: Rt(() => [
            B.value ? (Ne(), Ft(Oo, { key: 0 })) : U.value ? (Ne(), Ft(g, {
              key: 1,
              flat: !0,
              topTitle: G.value.title,
              topTitleClass: "primary-color mb-1",
              topTitleDate: "",
              showDetailButton: !0,
              labelDetailButton: "scopri di più",
              detailButtonLinkUrl: G.value.url
            }, {
              "custom-content": Rt(() => [
                he("h5", sL, ft(G.value.description), 1)
              ]),
              _: 1
            }, 8, ["topTitle", "detailButtonLinkUrl"])) : mt("", !0)
          ]),
          key: "0"
        } : void 0
      ]), 1024);
    };
  }
}), Iu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  KCmsLast: iL,
  KCmsLatest2: uL,
  KLatestNotifications: WT,
  KWebTvLatest: qT,
  KWebTvVideoPlayer: rc
}, Symbol.toStringTag, { value: "Module" })), lL = { class: "login" }, cL = { class: "d-flex justify-content-end mb-3" }, fL = ["loading"], dL = {
  key: 0,
  class: "progress-spinner progress-spinner-active",
  style: { width: "24px", height: "24px", margin: "0 25%" }
}, gL = /* @__PURE__ */ he("span", { class: "visually-hidden" }, "Caricamento...", -1), mL = [
  gL
], EL = { key: 1 }, ML = { class: "mt-4 btn-links" }, hL = { key: 0 }, _L = /* @__PURE__ */ Ct({
  __name: "Login",
  setup(j) {
    const { getAppTitle: f, _customRegistrationPagePath: D } = ir(), { kToast: B } = xr(), U = f(), G = Er(), R = Pr(), m = lt(!1), e = lt(""), g = lt(""), n = async () => {
      if (l.value = "", e.value.length > 0 && g.value.length > 0)
        if (m.value = !0, await R.login(e.value, g.value), m.value = !1, !R.isLogged)
          R.userAuthData && R.userAuthData.passwordExpired === !0 ? (B.showInfo("Cambio password", "La password deve essere cambiata per il primo utilizzo."), G.push("/newpassword")) : R.userAuthData && R.userAuthData.requireVerificationCode === !0 ? (B.showInfo("Codice di verifia", "Inserire il codice di verifica inviato."), G.push("/codver")) : l.value = "Nome utente o password non validi.";
        else {
          let d = "/";
          if (G.currentRoute.value.query) {
            let t = G.currentRoute.value.query.returnUrl;
            t && t.length > 0 && (d = t.toString());
          }
          G.push(d);
        }
      else
        l.value = "Specificare nome utente e password per proseguire.";
    }, i = () => {
      R.logout();
    }, r = Vt(() => R.isLogged), l = lt("");
    return (d, t) => {
      const T = Pt("router-link"), S = Pt("KCard"), h = Pt("KAlert");
      return Ne(), We("div", lL, [
        gt(S, {
          shadow: !1,
          class: "login-card"
        }, Cu({ _: 2 }, [
          r.value ? {
            name: "custom-content",
            fn: Rt(() => [
              he("h5", null, [
                Ht(ft(ot(U)) + " ", 1),
                he("br"),
                Ht(" Accesso Eseguito")
              ]),
              gt(T, {
                to: "/",
                "active-class": "active"
              }, {
                default: Rt(() => [
                  Ht("TORNA ALLA HOME")
                ]),
                _: 1
              }),
              he("div", { class: "mt-4" }, [
                he("button", {
                  type: "button",
                  class: "btn btn-primary",
                  loading: m.value,
                  onClick: i
                }, "Esci", 8, ["loading"])
              ])
            ]),
            key: "1"
          } : {
            name: "custom-content",
            fn: Rt(() => [
              he("h5", null, ft(ot(U)) + " Login", 1),
              gt(ot(ql), {
                labelText: "Username",
                modelValue: e.value,
                "onUpdate:modelValue": t[0] || (t[0] = (_) => e.value = _),
                onKeyup: Yr(n, ["enter"])
              }, null, 8, ["modelValue", "onKeyup"]),
              gt(ot(Zl), {
                labelText: "Password",
                modelValue: g.value,
                "onUpdate:modelValue": t[1] || (t[1] = (_) => g.value = _),
                onKeyup: Yr(n, ["enter"])
              }, null, 8, ["modelValue", "onKeyup"]),
              he("div", cL, [
                he("button", {
                  type: "button",
                  class: Ot(["btn btn-primary", { disabled: m.value }]),
                  style: { "min-width": "100px" },
                  loading: m.value,
                  onClick: n
                }, [
                  m.value ? (Ne(), We("div", dL, mL)) : (Ne(), We("span", EL, "Accedi"))
                ], 10, fL)
              ]),
              he("div", ML, [
                he("button", {
                  type: "button",
                  class: "btn",
                  onClick: t[2] || (t[2] = (_) => {
                    ot(G).push("/resetpassword");
                  })
                }, "Non riesci ad accedere?"),
                (ot(D) || "") != "" ? (Ne(), We("div", hL, [
                  he("button", {
                    type: "button",
                    class: "btn",
                    onClick: t[3] || (t[3] = (_) => ot(G).push(ot(D)))
                  }, "Non sei ancora registrato? Registrati")
                ])) : mt("", !0)
              ])
            ]),
            key: "0"
          }
        ]), 1024),
        l.value && l.value.length > 0 ? (Ne(), Ft(h, {
          key: 0,
          level: "danger",
          body: l.value
        }, null, 8, ["body"])) : mt("", !0)
      ]);
    };
  }
});
const yL = /* @__PURE__ */ Ct({
  __name: "Sso",
  setup(j) {
    const f = Kr(), D = Er(), B = Pr();
    return tr(async () => {
      await D.isReady();
      const U = f.params.token;
      await B.loginSso(U) && D.replace("/");
    }), (U, G) => (Ne(), We("div", null, "Redirect..."));
  }
}), vL = /* @__PURE__ */ Ct({
  __name: "NotFound",
  setup(j) {
    const f = Er(), D = Kr(), B = Pr(), U = lt("");
    let G = 0, R = 0;
    return tr(() => {
      G = 0, U.value = ".", R = setInterval(() => {
        G++, U.value = U.value + ".", G > 5 && (clearInterval(R), U.value = "404"), B.user && f.getRoutes().findIndex((m) => {
          var n, i, r;
          let e = m.path == ((n = D.redirectedFrom) == null ? void 0 : n.path);
          if (!e) {
            if (m.children.length > 0 && ((i = D.redirectedFrom) != null && i.params) && Array.isArray(D.redirectedFrom.params.pathMatch) && D.redirectedFrom.params.pathMatch.length > 0) {
              const l = m.path.startsWith("/" + D.redirectedFrom.params.pathMatch[0]), d = m.children.find((t) => t.path == D.redirectedFrom.params.pathMatch[D.redirectedFrom.params.pathMatch.length - 1]);
              e = l && d != null;
            }
            if (m.path.includes("/:") && ((r = D.redirectedFrom) != null && r.params) && Array.isArray(D.redirectedFrom.params.pathMatch) && D.redirectedFrom.params.pathMatch.length > 0) {
              const l = m.path.slice(1).split("/");
              for (var g = 0; g < l.length && !l[g].includes(":"); g++)
                e = l[g] == D.redirectedFrom.params.pathMatch[g];
            }
          }
          return e;
        }) >= 0 && (clearInterval(R), Rr(() => {
          f.replace(D.redirectedFrom.path);
        }));
      }, 200);
    }), (m, e) => {
      const g = Pt("router-link");
      return Ne(), We(or, null, [
        he("h1", null, ft(U.value), 1),
        U.value == "404" ? (Ne(), Ft(g, {
          key: 0,
          to: "/"
        }, {
          default: Rt(() => [
            Ht("Home")
          ]),
          _: 1
        })) : mt("", !0)
      ], 64);
    };
  }
}), pL = {}, TL = /* @__PURE__ */ he("h1", null, "NOT AUTHORIZED", -1);
function LL(j, f) {
  const D = Pt("router-link");
  return Ne(), We(or, null, [
    TL,
    gt(D, {
      to: "/login",
      "active-class": "active"
    }, {
      default: Rt(() => [
        Ht("Please login")
      ]),
      _: 1
    })
  ], 64);
}
const IL = /* @__PURE__ */ hs(pL, [["render", LL]]), AL = { class: "card" }, SL = { class: "field" }, DL = /* @__PURE__ */ he("label", { for: "vecchiapassword" }, "Vecchia Password", -1), NL = { class: "field" }, CL = /* @__PURE__ */ he("label", { for: "nuovapassword" }, "Nuova Password", -1), jL = { class: "field" }, OL = /* @__PURE__ */ he("label", { for: "confermanuovapassword" }, "Conferma Nuova Password", -1), PL = { class: "msg-area" }, RL = /* @__PURE__ */ Ct({
  __name: "ChangePassword",
  setup(j) {
    const f = lt(""), D = lt(""), B = lt(""), U = lt(""), G = Pr(), R = Fo();
    Ou();
    const m = lt(!1), e = async () => {
      if (D.value != null && (D.value.trim().length < 8 || /^[a-zA-Z0-9~_&*%@$!.\-]+$/.test(D.value) == !1)) {
        U.value = "La password deve essere lunga almeno 8 caratteri. Può contenere lettere, numeri e i caratteri ~_&*%@$!.-";
        return;
      }
      if (D.value != B.value) {
        U.value = "La password e la sua conferma non coincidono.";
        return;
      }
      if (D.value == f.value) {
        U.value = "La nuova password deve essere diversa da quella attuale.";
        return;
      }
      if (f.value.length > 0 && D.value.length > 0 && B.value.length > 0) {
        m.value = !0;
        const g = await G.changePassword(f.value, D.value, B.value);
        m.value = !1, g ? g.success ? (R.add({ severity: "success", summary: "Completato", detail: "Operazione effettata correttamente.", life: 3e3 }), U.value = "", f.value = "", D.value = "", B.value = "") : (U.value = "Si è verificato un problema.", g.details.length > 0 && (U.value = g.details[0].message)) : U.value = "Si è verificato un problema.";
      } else
        U.value = "Specificare la vecchia password e la nuova password per proseguire.";
    };
    return tr(async () => {
    }), (g, n) => {
      const i = Pt("PageHeader"), r = Pt("Page");
      return Ne(), Ft(r, null, {
        default: Rt(() => [
          gt(i, { title: "Modifica Password" }),
          he("div", AL, [
            he("div", SL, [
              DL,
              gt(ot(Yn), {
                id: "vecchiapassword",
                modelValue: f.value,
                "onUpdate:modelValue": n[0] || (n[0] = (l) => f.value = l),
                toggleMask: "",
                promptLabel: "false",
                feedback: !1,
                class: "w-full"
              }, null, 8, ["modelValue"])
            ]),
            he("div", NL, [
              CL,
              gt(ot(Yn), {
                id: "nuovapassword",
                modelValue: D.value,
                "onUpdate:modelValue": n[1] || (n[1] = (l) => D.value = l),
                toggleMask: "",
                promptLabel: "false",
                feedback: !1,
                class: "w-full"
              }, null, 8, ["modelValue"])
            ]),
            he("div", jL, [
              OL,
              gt(ot(Yn), {
                id: "confermanuovapassword",
                modelValue: B.value,
                "onUpdate:modelValue": n[2] || (n[2] = (l) => B.value = l),
                toggleMask: "",
                promptLabel: "false",
                feedback: !1,
                class: "w-full"
              }, null, 8, ["modelValue"])
            ]),
            he("div", null, [
              gt(ot(si), {
                label: "Salva",
                loading: m.value,
                onClick: e
              }, null, 8, ["loading"])
            ])
          ]),
          he("div", PL, [
            U.value && U.value.length > 0 ? (Ne(), Ft(ot(ju), {
              key: 0,
              severity: "error",
              closable: !1
            }, {
              default: Rt(() => [
                Ht(ft(U.value), 1)
              ]),
              _: 1
            })) : mt("", !0)
          ])
        ]),
        _: 1
      });
    };
  }
});
const bL = { class: "code-verification" }, xL = /* @__PURE__ */ he("h5", { class: "mb-2" }, "Codice di verifica", -1), wL = /* @__PURE__ */ he("p", { class: "mb-6" }, " Ti è stato inviato un codice di verifica. Inserisci il codice e conferma per proseguire. ", -1), UL = { class: "d-flex justify-content-end" }, FL = ["loading"], BL = {
  key: 0,
  class: "progress-spinner progress-spinner-active",
  style: { width: "24px", height: "24px", margin: "0 25%" }
}, zL = /* @__PURE__ */ he("span", { class: "visually-hidden" }, "Caricamento...", -1), kL = [
  zL
], YL = { key: 1 }, WL = /* @__PURE__ */ Ct({
  __name: "CodeVerification2FA",
  setup(j) {
    const f = lt(""), D = lt(""), B = Er(), U = Pr(), { kToast: G } = xr(), R = lt(!1), m = async () => {
      await U.requestNewVerificationCode(), G.showInfo("Richiesta nuovo codice inviata.");
    }, e = async () => {
      if (f.value == null || f.value.trim().length == 0) {
        D.value = "Il codice di verifica inserito non è valido!";
        return;
      }
      D.value = null, R.value = !0;
      try {
        if (await U.loginWithVerificationCode(f.value), !U.isLogged)
          U.userAuthData && U.userAuthData.passwordExpired === !0 ? (G.showInfo("Cambio password", "La password deve essere cambiata per il primo utilizzo."), B.push("/newpassword")) : (G.showInfo("Codice di verifia", "Inserire il codice di verifica inviato."), D.value = "Il codice di verifica inserito non è valido!");
        else {
          let g = "/";
          B.push(g);
        }
      } finally {
        R.value = !1;
      }
    };
    return (g, n) => {
      const i = Pt("KInputText");
      return Ne(), We("div", bL, [
        gt(ot(Pu), {
          shadow: !1,
          class: "code-verification-card"
        }, {
          "custom-content": Rt(() => [
            xL,
            wL,
            gt(i, {
              labelText: "Codice verifica",
              modelValue: f.value,
              "onUpdate:modelValue": n[0] || (n[0] = (r) => f.value = r),
              onKeyup: Yr(e, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]),
            he("div", UL, [
              he("button", {
                type: "button",
                class: Ot(["btn btn-primary", { disabled: R.value }]),
                style: { "min-width": "100px" },
                loading: R.value,
                onClick: e
              }, [
                R.value ? (Ne(), We("div", BL, kL)) : (Ne(), We("span", YL, "CONFERMA"))
              ], 10, FL)
            ]),
            he("div", { class: "btn-links" }, [
              he("button", {
                type: "button",
                class: "btn",
                onClick: m
              }, "Invia un altro codice.")
            ])
          ]),
          _: 1
        }),
        D.value && D.value.length > 0 ? (Ne(), Ft(ot(Bo), {
          key: 0,
          level: ot(Wn).danger,
          body: D.value
        }, null, 8, ["level", "body"])) : mt("", !0)
      ]);
    };
  }
});
const KL = { class: "p-float-label" }, VL = /* @__PURE__ */ he("label", { for: "oldpassword" }, "Vecchia Password", -1), GL = {
  class: "p-float-label",
  style: { margin: "25px 0" }
}, QL = /* @__PURE__ */ he("label", { for: "newpassword" }, "Nuova Password", -1), HL = { class: "p-float-label" }, XL = /* @__PURE__ */ he("label", { for: "newpasswordconfirm" }, "Conferma Nuova Password", -1), $L = { class: "msg-area" }, ZL = /* @__PURE__ */ Ct({
  __name: "NewPassword",
  setup(j) {
    const f = lt(""), D = lt(""), B = lt(""), U = lt(""), G = Er(), R = Pr(), m = lt(!1), e = async () => {
      if (U.value = "", D.value != null && (D.value.trim().length < 8 || /^[a-zA-Z0-9~_&*%@$!.\-]+$/.test(D.value) == !1)) {
        U.value = "La password deve essere lunga almeno 8 caratteri. Può contenere lettere, numeri e i caratteri ~_&*%@$!.-";
        return;
      }
      if (D.value != B.value) {
        U.value = "La password e la sua conferma non coincidono.";
        return;
      }
      if (D.value == f.value) {
        U.value = "La nuova password deve essere diversa da quella attuale.";
        return;
      }
      if (f.value.length > 0 && D.value.length > 0 && B.value.length > 0) {
        m.value = !0;
        const g = await R.changeExpiredPassword(f.value, D.value, B.value);
        m.value = !1, g ? R.isLogged ? G.push("/") : R.userAuthData && R.userAuthData.requireVerificationCode === !0 ? G.push("/codver") : G.push({ name: "login" }) : U.value = "Si è verificato un problema.";
      } else
        U.value = "Specificare la vecchia password e la nuova password per proseguire.";
    };
    return (g, n) => (Ne(), Ft(ot(tf), { style: { padding: "10px" } }, {
      title: Rt(() => [
        Ht(" Cambio password per primo utilizzo ")
      ]),
      content: Rt(() => [
        he("p", null, [
          he("span", KL, [
            gt(ot(Yn), {
              id: "oldpassword",
              modelValue: f.value,
              "onUpdate:modelValue": n[0] || (n[0] = (i) => f.value = i),
              onKeyup: Yr(e, ["enter"]),
              toggleMask: "",
              promptLabel: "false",
              feedback: !1,
              class: "w-full"
            }, null, 8, ["modelValue", "onKeyup"]),
            VL
          ])
        ]),
        he("p", null, [
          he("span", GL, [
            gt(ot(Yn), {
              id: "newpassword",
              modelValue: D.value,
              "onUpdate:modelValue": n[1] || (n[1] = (i) => D.value = i),
              onKeyup: Yr(e, ["enter"]),
              toggleMask: "",
              promptLabel: "false",
              feedback: !1,
              class: "w-full"
            }, null, 8, ["modelValue", "onKeyup"]),
            QL
          ])
        ]),
        he("p", null, [
          he("span", HL, [
            gt(ot(Yn), {
              id: "newpasswordconfirm",
              modelValue: B.value,
              "onUpdate:modelValue": n[2] || (n[2] = (i) => B.value = i),
              onKeyup: Yr(e, ["enter"]),
              toggleMask: "",
              promptLabel: "false",
              feedback: !1,
              class: "w-full"
            }, null, 8, ["modelValue", "onKeyup"]),
            XL
          ])
        ]),
        he("div", $L, [
          U.value && U.value.length > 0 ? (Ne(), Ft(ot(ju), {
            key: 0,
            severity: "error",
            closable: !1
          }, {
            default: Rt(() => [
              Ht(ft(U.value), 1)
            ]),
            _: 1
          })) : mt("", !0)
        ])
      ]),
      footer: Rt(() => [
        gt(ot(si), {
          label: "Salva",
          loading: m.value,
          onClick: e
        }, null, 8, ["loading"])
      ]),
      _: 1
    }));
  }
}), JL = { class: "login" }, qL = /* @__PURE__ */ he("p", null, [
  /* @__PURE__ */ Ht(" Non ricordi la password?"),
  /* @__PURE__ */ he("br"),
  /* @__PURE__ */ Ht("Inserisci la tua mail, riceverai un codice di verifica all'indirizzo specificato e le istruzioni per poterla modificare. ")
], -1), eI = { class: "field" }, tI = /* @__PURE__ */ he("label", { for: "mail" }, "Indirizzo e-mail", -1), rI = {
  key: 0,
  class: "field"
}, nI = /* @__PURE__ */ he("label", { for: "verificationCode" }, "Inserice codice di verifica", -1), aI = { class: "msg-area" }, iI = /* @__PURE__ */ Ct({
  __name: "ResetPassword",
  setup(j) {
    const f = Er(), { getAppTitle: D } = ir(), B = D(), U = lt(""), G = lt(""), { kToast: R } = xr(), m = lt(!1), e = lt(!1), g = async () => {
      if (G.value = "", U.value.length > 0) {
        e.value = !0;
        try {
          await Ar.generateVerificationCode(U.value);
        } catch (r) {
          console.error(r);
        }
      } else
        G.value = "Specificare l'indirizzo e-mail.";
    }, n = lt(), i = async () => {
      if (G.value = "", n.value.length > 0 && U.value.length > 0) {
        m.value = !0;
        try {
          const l = await Ar.verifyVerificationCode(U.value, n.value);
          if (l.success)
            f.push({ name: "resetpwdtoken", params: { token: l.data.passwordResetToken } });
          else {
            var r = l.details[0];
            r && r.code == "USER_VERIFCATION_CODE_INVALID" ? G.value = "Codice di verifica non valido" : G.value = "E' avvenuto un errore";
          }
        } catch (l) {
          R.showError("Errore", l.toString());
        }
        m.value = !1;
      } else
        U.value.length == 0 ? G.value = "Specificare la mail." : n.value.length == 0 && (G.value = "Specificare il codice di conferma.");
    };
    return (r, l) => {
      const d = Pt("Button"), t = Pt("Card"), T = Pt("Message");
      return Ne(), We("div", JL, [
        gt(t, { class: "login-card" }, {
          title: Rt(() => [
            Ht(ft(ot(B)), 1)
          ]),
          content: Rt(() => [
            qL,
            he("p", null, [
              he("div", eI, [
                tI,
                Cn(he("input", {
                  type: "text",
                  id: "mail",
                  "onUpdate:modelValue": l[0] || (l[0] = (S) => U.value = S),
                  class: "text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                }, null, 512), [
                  [fo, U.value]
                ])
              ]),
              e.value ? (Ne(), We("div", rI, [
                nI,
                Cn(he("input", {
                  type: "text",
                  id: "verificationCode",
                  "onUpdate:modelValue": l[1] || (l[1] = (S) => n.value = S),
                  class: "text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                }, null, 512), [
                  [fo, n.value]
                ])
              ])) : mt("", !0)
            ])
          ]),
          footer: Rt(() => [
            e.value ? (Ne(), Ft(d, {
              key: 0,
              class: "mr-2",
              label: "Verifica codice",
              onClick: i
            })) : mt("", !0),
            gt(d, {
              label: e.value ? "Invia di nuovo" : "Invia la richiesta",
              onClick: g
            }, null, 8, ["label"])
          ]),
          _: 1
        }),
        he("div", aI, [
          G.value && G.value.length > 0 ? (Ne(), Ft(T, {
            key: 0,
            severity: "error",
            closable: !1
          }, {
            default: Rt(() => [
              Ht(ft(G.value), 1)
            ]),
            _: 1
          })) : mt("", !0)
        ])
      ]);
    };
  }
});
const oI = { class: "login" }, sI = /* @__PURE__ */ he("p", null, " Inserisci una nuova password per completare l'operazione di reset. ", -1), uI = { class: "field" }, lI = /* @__PURE__ */ he("label", { for: "nuovapassword" }, "Nuova Password", -1), cI = { class: "field" }, fI = /* @__PURE__ */ he("label", { for: "confermanuovapassword" }, "Conferma Nuova Password", -1), dI = { class: "msg-area" }, gI = /* @__PURE__ */ Ct({
  __name: "ResetPasswordWithToken",
  setup(j) {
    const f = Kr(), D = Er(), { getAppTitle: B } = ir(), U = B();
    lt("");
    const G = lt(""), R = lt(""), m = lt("");
    Pr();
    const e = Fo(), g = lt(!1), n = async () => {
      if (m.value = "", G.value != null && (G.value.trim().length < 8 || /^[a-zA-Z0-9~_&*%@$!]+$/.test(G.value) == !1)) {
        m.value = "La password deve essere lunga almeno 8 caratteri. Può contenere lettere, numeri e i caratteri ~_&*%@$!";
        return;
      }
      if (G.value != R.value) {
        m.value = "La password e la sua conferma non coincidono.";
        return;
      }
      if (G.value.length > 0 && R.value.length > 0) {
        g.value = !0;
        const i = f.params.token;
        console.log("token"), console.log(i);
        const r = await Ar.resetPasswordWithToken(i, G.value);
        g.value = !1, r ? r.success ? (e.add({ severity: "success", summary: "Completato", detail: "Operazione effettata correttamente.", life: 3e3 }), m.value = "", G.value = "", R.value = "", D.push({ name: "login" })) : (m.value = "Si è verificato un problema.", r.details.length > 0 && (m.value = r.details[0].message)) : m.value = "Si è verificato un problema.";
      }
    };
    return (i, r) => {
      const l = Pt("Password"), d = Pt("Button"), t = Pt("Card"), T = Pt("Message");
      return Ne(), We("div", oI, [
        gt(t, { class: "login-card" }, {
          title: Rt(() => [
            Ht(ft(ot(U)), 1)
          ]),
          content: Rt(() => [
            sI,
            he("p", null, [
              he("div", uI, [
                lI,
                gt(l, {
                  id: "nuovapassword",
                  modelValue: G.value,
                  "onUpdate:modelValue": r[0] || (r[0] = (S) => G.value = S),
                  toggleMask: "",
                  promptLabel: "false",
                  feedback: !1,
                  class: "w-full"
                }, null, 8, ["modelValue"])
              ]),
              he("div", cI, [
                fI,
                gt(l, {
                  id: "confermanuovapassword",
                  modelValue: R.value,
                  "onUpdate:modelValue": r[1] || (r[1] = (S) => R.value = S),
                  toggleMask: "",
                  promptLabel: "false",
                  feedback: !1,
                  class: "w-full"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          footer: Rt(() => [
            gt(d, {
              label: "Salva la nuova password",
              loading: g.value,
              onClick: n
            }, null, 8, ["loading"])
          ]),
          _: 1
        }),
        he("div", dI, [
          m.value && m.value.length > 0 ? (Ne(), Ft(T, {
            key: 0,
            severity: "error",
            closable: !1
          }, {
            default: Rt(() => [
              Ht(ft(m.value), 1)
            ]),
            _: 1
          })) : mt("", !0)
        ])
      ]);
    };
  }
});
const mI = { key: 0 }, EI = /* @__PURE__ */ he("hr", null, null, -1), MI = {
  key: 0,
  class: "k-notification-actions"
}, hI = { key: 0 }, _I = {
  key: 1,
  class: "k-notification-custom-panel"
}, yI = /* @__PURE__ */ Ct({
  __name: "KNotificationDetail",
  setup(j) {
    const { toDateString: f, toDateTimeString: D } = qr(), B = ys(), { getCustomNotificationHandlerForModule: U, _appOptionsNotification: G } = ir(), R = lt(null);
    er(
      () => B.selectedNotification,
      (d, t) => {
        if (d != null) {
          const T = U(d.multichannelNotificationLite.module);
          if (T && T.detailViewHandler) {
            R.value = T.detailViewHandler;
            return;
          }
        }
        R.value = null;
      },
      { immediate: !0 }
    );
    const m = lt(!1), e = lt(!1), g = lt(""), n = async () => {
      var d;
      if (g.value && g.value.length > 0) {
        const t = (d = B.selectedNotification.subject) != null && d.toUpperCase().startsWith("RE:") ? B.selectedNotification.subject : "RE: " + B.selectedNotification.subject;
        await un.sendInAppNotification(
          B.selectedNotification.multichannelNotificationLite.sender.id,
          t,
          g.value
        ), B.loadNotifications(), g.value = "", e.value = !0, setTimeout(() => {
          e.value = !1, m.value = !1;
        }, 2e3);
      }
    }, i = lt(!1), r = Vt({
      get: () => {
        var d;
        return ((d = B.selectedNotification) == null ? void 0 : d.isRead) == !0;
      },
      set: async (d) => {
        i.value = !0;
        try {
          if (B.selectedNotification) {
            const t = !B.selectedNotification.isRead;
            await B.setNotificationReadState(B.selectedNotification.id, t) && (B.selectedNotification.isRead = t);
          }
        } finally {
          i.value = !1;
        }
      }
    }), l = Vt(() => B.selectedNotification && B.selectedNotification.multichannelNotificationLite && B.selectedNotification.multichannelNotificationLite.sender ? B.selectedNotification.multichannelNotificationLite.sender.firstName + " " + B.selectedNotification.multichannelNotificationLite.sender.lastName : " -?- ");
    return (d, t) => {
      var h;
      const T = Pt("KToggle"), S = Pt("KSpinner");
      return ot(B).selectedNotification ? (Ne(), We("div", mI, [
        gt(ot(vs), {
          title: ot(B).selectedNotification.subject
        }, null, 8, ["title"]),
        he("div", null, "Data e ora: " + ft(ot(D)(ot(B).selectedNotification.dateTime)), 1),
        he("div", null, "Inviato da: " + ft(l.value), 1),
        EI,
        he("div", null, ft(ot(B).selectedNotification.body), 1),
        gt(S, { loading: i.value }, {
          default: Rt(() => [
            gt(T, {
              modelValue: r.value,
              "onUpdate:modelValue": t[0] || (t[0] = (_) => r.value = _),
              label: "Notifica letta"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["loading"]),
        (h = ot(G)) != null && h.disableNotificationReply ? mt("", !0) : (Ne(), We("div", MI, [
          m.value ? mt("", !0) : (Ne(), We("button", {
            key: 0,
            type: "button",
            class: "btn btn-outline-primary btn-xs px-5",
            onClick: t[1] || (t[1] = (_) => m.value = !m.value)
          }, " RISPONDI ")),
          gt(oi, {
            name: "fade",
            mode: "out-in"
          }, {
            default: Rt(() => [
              m.value ? (Ne(), We("div", hI, [
                e.value ? (Ne(), Ft(ot(Bo), {
                  key: 0,
                  level: ot(Wn).info,
                  title: "Messaggio di risposta inviato.."
                }, null, 8, ["level"])) : mt("", !0),
                e.value ? mt("", !0) : (Ne(), Ft(ot(ec), {
                  key: 1,
                  modelValue: g.value,
                  "onUpdate:modelValue": t[2] || (t[2] = (_) => g.value = _),
                  style: { "margin-bottom": "0" }
                }, null, 8, ["modelValue"])),
                e.value ? mt("", !0) : (Ne(), We("button", {
                  key: 2,
                  style: { "margin-left": "10px" },
                  type: "button",
                  class: "btn btn-primary btn-xs px-5",
                  onClick: t[3] || (t[3] = (_) => n())
                }, " INVIA RISPOSTA "))
              ])) : mt("", !0)
            ]),
            _: 1
          })
        ])),
        R.value ? (Ne(), We("div", _I, [
          (Ne(), Ft(Uo(R.value), {
            notification: ot(B).selectedNotification
          }, null, 8, ["notification"]))
        ])) : mt("", !0)
      ])) : mt("", !0);
    };
  }
});
const vI = {
  class: "d-inline-flex align-items-center",
  style: { "margin-left": "20px" }
}, Au = /* @__PURE__ */ Ct({
  __name: "Notifications",
  setup(j) {
    const { toDateTimeString: f } = qr(), D = ys(), B = Kr(), U = Er();
    lt(!1);
    const G = lt(!1), R = lt("");
    er(
      () => B.params.id,
      async () => await m()
    ), er(() => G.value, (r, l) => {
      l != r && r == !1 && U.push({ name: "notifications-list" });
    }), er(() => R.value, async (r, l) => {
      l != r && (r == "" ? D.filter.readState = null : r == "false" ? D.filter.readState = !1 : r == "true" && (D.filter.readState = !0), await i());
    }), tr(async () => {
      await D.loadNotifications(!0), await U.isReady(), await m();
    });
    const m = async () => {
      let l = B.params.id;
      l || (l = "0"), await e(parseInt(l));
    }, e = async (r) => {
      if (r > 0) {
        let l = D.notifications.find((d) => d.id == r);
        l == null && (await D.loadNotification(r), l = D.notifications.find((d) => d.id == r)), l.isRead === !1 && await D.setNotificationReadState(r, !0) && (l.isRead = !0), D.selectedNotification = l;
      } else
        D.selectedNotification = null;
      Rr(() => G.value = D.selectedNotification != null);
    }, g = (r) => {
      U.push({ name: "notification-detail", params: { id: r } });
    }, n = async (r) => {
      D.filter.page = r - 1, await D.loadNotifications();
    }, i = async () => {
      D.filter.page = 0, await D.loadNotifications();
    };
    return (r, l) => {
      const d = Pt("PageHeader"), t = Pt("KSelect"), T = Pt("KInputSearch"), S = Pt("Column"), h = Pt("DataTable"), _ = Pt("KPaginator"), L = Pt("KModalSlide"), v = Pt("Page");
      return Ne(), Ft(v, { title: "Lista notifiche" }, {
        default: Rt(() => [
          gt(d, { title: "Centro notifiche" }),
          gt(T, {
            onSearch: i,
            modelValue: ot(D).filter.search,
            "onUpdate:modelValue": l[1] || (l[1] = (c) => ot(D).filter.search = c),
            placeholder: "Cerca per mittente, titolo, corpo"
          }, {
            default: Rt(() => [
              he("div", vI, [
                Ht(" Filtro stato: "),
                gt(t, {
                  options: ot(D).optionsStates,
                  modelValue: R.value,
                  "onUpdate:modelValue": l[0] || (l[0] = (c) => R.value = c),
                  style: { "margin-bottom": "0" }
                }, null, 8, ["options", "modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          gt(h, {
            "table-class": "k-data-table k-row-clickable",
            onRowClick: l[2] || (l[2] = (c) => g(c.data.id)),
            value: ot(D).notifications,
            dataKey: "id",
            responsiveLayout: "scroll"
          }, {
            empty: Rt(() => [
              Ht(" Nessuna notifica presente. ")
            ]),
            default: Rt(() => [
              gt(S, {
                field: "dateTime",
                header: "Data"
              }, {
                body: Rt(({ data: c }) => [
                  he("div", {
                    style: Or({ "font-weight": c.isRead ? "normal" : "bold" })
                  }, ft(ot(f)(c.dateTime)), 5)
                ]),
                _: 1
              }),
              gt(S, {
                field: "sender",
                header: "Mittente"
              }, {
                body: Rt(({ data: c }) => [
                  he("div", {
                    style: Or({ "font-weight": c.isRead ? "normal" : "bold" })
                  }, ft(c.multichannelNotificationLite.sender.firstName + " " + c.multichannelNotificationLite.sender.lastName), 5)
                ]),
                _: 1
              }),
              gt(S, {
                field: "subject",
                header: "Titolo"
              }, {
                body: Rt(({ data: c }) => [
                  he("div", {
                    style: Or({ "font-weight": c.isRead ? "normal" : "bold" })
                  }, ft(c.subject), 5)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          gt(_, {
            "current-page": ot(D).currentPage,
            "total-count": ot(D).totalCount,
            "total-pages": ot(D).totalPages,
            "show-total-count": !0,
            onPageSelected: n
          }, null, 8, ["current-page", "total-count", "total-pages"]),
          gt(L, {
            modelValue: G.value,
            "onUpdate:modelValue": l[3] || (l[3] = (c) => G.value = c),
            title: "Dettaglio Notifica"
          }, {
            default: Rt(() => [
              gt(yI)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      });
    };
  }
}), pI = {
  key: "k-projects",
  name: "Progetti",
  routes: Gl,
  initModule: () => {
    console.log("Modulo DPR&DI inizializzato.");
  },
  notificationPlugins: null,
  searchPlugins: null
}, TI = { class: "card-wrapper" }, LI = { class: "card card-img no-after" }, II = { class: "img-responsive-wrapper" }, AI = { class: "img-responsive" }, SI = { class: "img-wrapper" }, DI = { class: "k-module-webtv-item-placeholder" }, NI = ["src", "title", "alt"], CI = { class: "k-module-webtv-item-play-overlay" }, jI = /* @__PURE__ */ he("div", null, [
  /* @__PURE__ */ he("span", { class: "visually-hidden" }, "Play video")
], -1), OI = {
  class: "card-body",
  style: { padding: "4px 0 24px 0" }
}, PI = {
  class: "card-title h5 mb-0",
  style: { overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
}, RI = { class: "badge bg-primary" }, bI = /* @__PURE__ */ he("span", { class: "text" }, "Vai al video", -1), xI = { class: "visually-hidden" }, wI = /* @__PURE__ */ Ct({
  __name: "KWebTvListItem",
  props: {
    video: {}
  },
  setup(j) {
    const f = Ci();
    return (D, B) => {
      const U = Pt("router-link");
      return Ne(), We("div", TI, [
        he("div", LI, [
          he("div", II, [
            he("div", AI, [
              he("figure", SI, [
                he("span", DI, [
                  he("p", null, ft(D.video.title), 1)
                ]),
                he("img", {
                  src: ot(f).getMediumThumbnailUrl(D.video),
                  style: { position: "absolute" },
                  title: D.video.title,
                  alt: D.video.title
                }, null, 8, NI),
                he("span", CI, [
                  gt(U, {
                    to: "video/" + D.video.id
                  }, {
                    default: Rt(() => [
                      jI
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ])
            ])
          ]),
          he("div", OI, [
            he("h3", PI, ft(D.video.title), 1),
            he("div", null, [
              he("span", RI, ft(D.video.categoryName), 1)
            ]),
            gt(U, {
              class: "read-more",
              style: { right: "0" },
              to: "video/" + D.video.id
            }, {
              default: Rt(() => [
                bI,
                he("span", xI, ft(D.video.title), 1),
                gt(ot(Dr), { icon: "it-arrow-right" })
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]);
    };
  }
});
const UI = { class: "row" }, FI = /* @__PURE__ */ Ct({
  __name: "KWebTvList",
  props: {
    items: {}
  },
  setup(j) {
    return (f, D) => (Ne(), We("div", UI, [
      (Ne(!0), We(or, null, _r(f.items, (B) => (Ne(), We("div", {
        class: "col-12 col-md-6 col-lg-4",
        key: B.id
      }, [
        gt(wI, { video: B }, null, 8, ["video"])
      ]))), 128))
    ]));
  }
}), BI = /* @__PURE__ */ Ct({
  __name: "Video",
  setup(j) {
    const f = Ci(), D = lt(!1);
    return tr(async () => {
      D.value = !0, await f.advancedSearch(), D.value = !1;
    }), (B, U) => {
      const G = Pt("PageHeader"), R = Pt("Page");
      return Ne(), Ft(R, { loading: D.value }, {
        default: Rt(() => [
          gt(G, { title: "Video" }),
          gt(ot(Jl), {
            modelValue: ot(f).advancedSearchTerm,
            "onUpdate:modelValue": U[0] || (U[0] = (m) => ot(f).advancedSearchTerm = m),
            onSearch: ot(f).advancedSearch
          }, null, 8, ["modelValue", "onSearch"]),
          gt(FI, {
            items: ot(f).advancedSearchResults
          }, null, 8, ["items"])
        ]),
        _: 1
      }, 8, ["loading"]);
    };
  }
}), zI = ["innerHTML"], kI = /* @__PURE__ */ Ct({
  __name: "VideoDetail",
  setup(j) {
    const f = Kr(), D = lt(f.params.id), B = lt();
    return tr(async () => {
      B.value = await Qr.getVideoDetails(D.value);
    }), (U, G) => {
      const R = Pt("PageHeader"), m = Pt("Page");
      return Ne(), Ft(m, null, {
        default: Rt(() => [
          gt(R, {
            title: B.value ? B.value.title : "Caricamento video.."
          }, null, 8, ["title"]),
          gt(rc, { idVideo: D.value }, null, 8, ["idVideo"]),
          he("div", {
            innerHTML: B.value && B.value.description
          }, null, 8, zI)
        ]),
        _: 1
      });
    };
  }
}), YI = [
  {
    name: "video-list",
    path: "/video",
    component: BI,
    meta: {
      requiresAuth: !0,
      menu: {
        order: 50,
        label: "Video",
        iconAsset: "icons/ico-webtv.svg"
      }
    }
  },
  {
    name: "video-detail",
    path: "/video/:id",
    component: kI,
    meta: {
      requiresAuth: !0
    }
  }
], WI = {
  key: "k-webtv",
  name: "WEB TV",
  routes: YI,
  initModule: () => {
    console.log("Modulo WebTV inizializzato.");
  },
  notificationPlugins: null,
  searchPlugins: [$l]
}, KI = [pI, WI], Su = [
  {
    name: "login",
    path: "/login",
    component: _L,
    meta: { layout: "anonymous" }
  },
  {
    path: "/sso/:token",
    component: yL,
    meta: { layout: "anonymous" }
  },
  {
    name: "forbidden",
    path: "/forbidden",
    component: IL,
    meta: { layout: "anonymous" }
  },
  {
    name: "notfound",
    path: "/404",
    component: vL,
    meta: { layout: "anonymous" }
  },
  {
    name: "changepwd",
    path: "/changepassword",
    component: RL,
    meta: {
      requiresAuth: !0
    }
  },
  {
    name: "code-verification",
    path: "/codver",
    component: WL,
    meta: { layout: "anonymous" }
  },
  {
    name: "newpwd",
    path: "/newpassword",
    component: ZL,
    meta: { layout: "anonymous" }
  },
  {
    name: "resetpwd",
    path: "/resetpassword",
    component: iI,
    meta: { layout: "anonymous" }
  },
  {
    name: "resetpwdtoken",
    path: "/resetpassword-with-token/:token",
    component: gI,
    meta: { layout: "anonymous" }
  },
  {
    name: "notifications-list",
    path: "/notifications",
    component: Au,
    meta: {
      requiresAuth: !0
    }
  },
  {
    name: "notification-detail",
    path: "/notifications/:id",
    component: Au,
    meta: {
      requiresAuth: !0
    }
  }
], VI = (j) => {
  const f = j.optionalModules, D = j.routingOptions.routeBasePath, B = j.routingOptions.routerBeforeNavigateGuard;
  if (j.routingOptions.customUserLoginComponent) {
    const e = Su.find((g) => g.name == "login");
    e.component = j.routingOptions.customUserLoginComponent;
  }
  const U = Su, { _config: G } = ir();
  G && G.modules && G.modules.forEach((e) => {
    const g = KI.find((n) => n.key == e.key);
    g && g.routes && U.push(...g.routes);
  }), Array.isArray(f) ? f.forEach((e) => {
    e && e.routes && U.push(...e.routes);
  }) : Object.keys(f).forEach((e) => {
    const g = f[e];
    U.push(...g);
  }), U.forEach((e) => {
    e.meta == null && (e.meta = {}), e.meta.static = !0, e.children && e.children.forEach((g) => {
      g.meta == null && (g.meta = {}), g.meta.static = !0;
    });
  }), U.push({ path: "/:pathMatch(.*)*", name: "not-found", redirect: "/404", meta: { static: !0 } });
  const R = Hc({
    history: Xc(D),
    routes: U
  }), m = (e, g, n) => {
    if (B) {
      const i = B(e, g);
      i && i.length > 0 ? n(i) : n();
    } else
      n();
  };
  return R.beforeResolve(async (e, g, n) => {
    const i = Pr();
    if (e.matched.some((r) => r.meta.requiresAuth === !0))
      if (i.isLogged)
        m(e.fullPath, g.fullPath, n);
      else if (await i.refreshToken(), i.isLogged)
        m(e.fullPath, g.fullPath, n);
      else {
        let r = "/login";
        e.fullPath && e.fullPath.length > 0 && (r += "?returnUrl=" + e.fullPath), n(r);
      }
    else
      n();
  }), R;
}, GI = {
  key: 0,
  class: "k-badge-beta"
}, QI = /* @__PURE__ */ he("div", null, "BETA", -1), HI = [
  QI
], XI = /* @__PURE__ */ Ct({
  __name: "AppContainer",
  setup(j) {
    const { _appBeta: f, _toastQueue: D, _confirmQueue: B } = ir(), U = Fo();
    er(
      D.value,
      () => {
        const r = D.value.pop();
        if (r) {
          let l = {
            severity: r.type,
            summary: r.message,
            detail: r.detail,
            life: r.life && r.life > 0 ? r.life : 3e3
          };
          U.add(l);
        }
      }
    );
    const G = Ou();
    er(
      B.value,
      () => {
        const r = B.value.pop();
        r && G.require({
          header: r.title,
          message: r.message,
          rejectClass: "p-button-outlined",
          acceptClass: "p-button-primary",
          accept: r.accept,
          reject: r.reject
        });
      }
    );
    const R = Kr(), m = Er(), { appStarting: e, layouts: g } = Gy(), n = Pr(), i = Vt(() => e.value === !0 ? g.splash : g[R.meta.layout || "default"]);
    return tr(async () => {
      e.value = !0;
      try {
        await n.initUser();
      } finally {
        e.value = !1;
      }
    }), er(
      () => n.isLogged,
      (r, l) => {
        l === !0 && r === !1 && m.push("/login");
      }
    ), (r, l) => (Ne(), We(or, null, [
      ot(f) ? (Ne(), We("div", GI, HI)) : mt("", !0),
      gt(ot(nf)),
      gt(ot(rf)),
      (Ne(), Ft(Uo(i.value)))
    ], 64));
  }
});
const $I = { class: "intranet-page container-fluid" }, ZI = {
  key: 0,
  class: "loading"
}, JI = /* @__PURE__ */ Ct({
  __name: "Page",
  props: {
    loading: { type: Boolean, default: !1 }
  },
  setup(j) {
    return (f, D) => (Ne(), We("div", $I, [
      nr(f.$slots, "default"),
      f.loading ? (Ne(), We("div", ZI)) : mt("", !0)
    ]));
  }
});
const qI = { class: "d-flex align-items-center mb-2" }, eA = { class: "ms-auto" }, tA = /* @__PURE__ */ Ct({
  __name: "PageHeader",
  props: {
    title: { default: "" },
    sticky: { type: Boolean, default: !1 },
    showBackButton: { type: Boolean, default: !1 }
  },
  setup(j) {
    const f = j;
    return (D, B) => {
      const U = Pt("KBackButton");
      return Ne(), We("div", {
        class: Ot({ sticky: D.sticky, "k-page-header-sticky": D.sticky })
      }, [
        f.showBackButton ? (Ne(), Ft(U, {
          key: 0,
          class: "pb-1"
        })) : mt("", !0),
        he("div", qI, [
          he("div", null, [
            he("h2", null, ft(D.title), 1)
          ]),
          he("div", eA, [
            nr(D.$slots, "primary-actions")
          ])
        ]),
        he("div", null, [
          nr(D.$slots, "secondary-actions")
        ])
      ], 2);
    };
  }
}), rA = { class: "c-line lightgrey-bg-c1 k-page-header-full" }, nA = { class: "d-flex align-items-center exit-menu" }, aA = { class: "top-text" }, iA = { class: "row" }, oA = { class: "title-text" }, sA = { class: "title-text-underline" }, uA = {
  key: 0,
  class: "row focus-text m-0"
}, lA = /* @__PURE__ */ Ct({
  __name: "PageHeaderFull",
  props: {
    title: { default: null },
    titleUnderline: { default: null }
  },
  setup(j) {
    const f = Nu(), D = Vt(() => {
      const m = f["secondary-actions"];
      if (m) {
        const e = m();
        if (e.length > 0)
          return e[0].children != "v-if";
      }
      return !1;
    }), { toDateTimeLongString: B, toTimeHMString: U } = qr(), G = lt(/* @__PURE__ */ new Date()), R = lt(0);
    return tr(() => {
      R.value = setInterval(() => {
        G.value = /* @__PURE__ */ new Date();
      }, 59e3);
    }), vi(() => clearInterval(R.value)), (m, e) => (Ne(), We("div", rA, [
      he("div", nA, [
        nr(m.$slots, "primary-actions")
      ]),
      he("div", aA, ft(ot(B)(G.value)) + " - " + ft(ot(U)(G.value)), 1),
      he("div", iA, [
        he("div", null, [
          he("h3", oA, [
            Ht(ft(m.title) + " ", 1),
            he("span", sA, ft(m.titleUnderline), 1)
          ])
        ])
      ]),
      D.value ? (Ne(), We("div", uA, [
        nr(m.$slots, "secondary-actions")
      ])) : mt("", !0)
    ]));
  }
});
var nc = { exports: {} };
(function(j, f) {
  (function(D, B) {
    j.exports = B();
  })(ss, function() {
    var D = "minute", B = /[+-]\d\d(?::?\d\d)?/g, U = /([+-]|\d\d)/g;
    return function(G, R, m) {
      var e = R.prototype;
      m.utc = function(t) {
        var T = { date: t, utc: !0, args: arguments };
        return new R(T);
      }, e.utc = function(t) {
        var T = m(this.toDate(), { locale: this.$L, utc: !0 });
        return t ? T.add(this.utcOffset(), D) : T;
      }, e.local = function() {
        return m(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var g = e.parse;
      e.parse = function(t) {
        t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), g.call(this, t);
      };
      var n = e.init;
      e.init = function() {
        if (this.$u) {
          var t = this.$d;
          this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
        } else
          n.call(this);
      };
      var i = e.utcOffset;
      e.utcOffset = function(t, T) {
        var S = this.$utils().u;
        if (S(t))
          return this.$u ? 0 : S(this.$offset) ? i.call(this) : this.$offset;
        if (typeof t == "string" && (t = function(v) {
          v === void 0 && (v = "");
          var c = v.match(B);
          if (!c)
            return null;
          var o = ("" + c[0]).match(U) || ["-", 0, 0], y = o[0], u = 60 * +o[1] + +o[2];
          return u === 0 ? 0 : y === "+" ? u : -u;
        }(t), t === null))
          return this;
        var h = Math.abs(t) <= 16 ? 60 * t : t, _ = this;
        if (T)
          return _.$offset = h, _.$u = t === 0, _;
        if (t !== 0) {
          var L = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (_ = this.local().add(h + L, D)).$offset = h, _.$x.$localOffset = L;
        } else
          _ = this.utc();
        return _;
      };
      var r = e.format;
      e.format = function(t) {
        var T = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return r.call(this, T);
      }, e.valueOf = function() {
        var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * t;
      }, e.isUTC = function() {
        return !!this.$u;
      }, e.toISOString = function() {
        return this.toDate().toISOString();
      }, e.toString = function() {
        return this.toDate().toUTCString();
      };
      var l = e.toDate;
      e.toDate = function(t) {
        return t === "s" && this.$offset ? m(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
      };
      var d = e.diff;
      e.diff = function(t, T, S) {
        if (t && this.$u === t.$u)
          return d.call(this, t, T, S);
        var h = this.local(), _ = m(t).local();
        return d.call(h, _, T, S);
      };
    };
  });
})(nc);
var cA = nc.exports;
const fA = /* @__PURE__ */ Di(cA), zn = {
  mounted(j, f, D, B) {
    const U = () => {
      f.value.validate(), zn.__renderValidation(j, f.value);
    }, G = zn.__getInputFromElement(j);
    G.removeEventListener("blur", U), G.addEventListener("blur", U), er(f.value, () => {
      zn.__renderValidation(j, f.value);
    });
  },
  updated(j, f, D, B) {
    zn.__renderValidation(j, f.value);
  },
  // metodi specifici
  __getInputFromElement(j) {
    if (j.tagName == "input" || j.tagName == "textarea" || j.tagName == "select")
      return j;
    let f = j.querySelector("input");
    return f || (f = j.querySelector("textarea")), f || (f = j.querySelector("select")), f;
  },
  __renderValidation(j, f) {
    if (!f)
      return;
    const D = "is-invalid", B = "is-valid", U = ["form-feedback", "just-validate-error-label"], G = f == null ? void 0 : f.success, R = j.querySelectorAll(`.${U.join(".")}`);
    for (let e = 0; e < R.length; e++)
      R.item(e).remove();
    const m = zn.__getInputFromElement(j);
    if (G === !0)
      m.classList.contains(D) && m.classList.remove(D), m.classList.contains(B) || m.classList.add(B);
    else if (G === !1) {
      m.classList.contains(D) || m.classList.add(D), m.classList.contains(B) && m.classList.remove(B);
      const e = (f == null ? void 0 : f.errors) || [], g = (f == null ? void 0 : f.messages) || [];
      if (g && g instanceof Array)
        for (let n = 0; n < g.length; n++) {
          const i = g[n], l = "fielderror_" + e[n];
          if (j.querySelectorAll(`.${l}`).length == 0) {
            const t = document.createElement("div");
            for (let T = 0; T < U.length; T++)
              t.classList.add(U[T]);
            t.classList.add(l), t.innerHTML = i, j.appendChild(t);
          }
        }
      if (f.scrollToFieldToken) {
        const n = j;
        n.dataset.lastScrollToken != f.scrollToFieldToken.toString() && (j.scrollIntoView({ behavior: "smooth" }), n.dataset.lastScrollToken = f.scrollToFieldToken.toString());
      }
    } else
      m.classList.contains(D) && m.classList.remove(D), m.classList.contains(B) && m.classList.remove(B);
  }
};
sr.extend(fA);
function ac(j) {
  for (const f in Lu)
    j.component(f, Lu[f]);
  for (const f in Iu)
    j.component(f, Iu[f]);
  j.component("Page", JI), j.component("PageHeader", tA), j.component("PageHeaderFull", lA);
}
const { storeAppOptions: dA, setCustomModuleResolver: gA, storePlugins: mA, storeConfig: EA } = ir(), { configureApiUrl: MA, initializePlatform: hA } = xr(), WA = async (j) => {
  console.log(`DP365+ kappa app startup: Start initialization for app '${j == null ? void 0 : j.appName}', type '${j == null ? void 0 : j.appType}'.`);
  try {
    dA(j), MA(j.appApiBaseUrl), gA(j.customModuleResolver);
    const f = await hA(j.appType);
    if (f == null)
      throw new Error("DP365+ kappa app initialization failed. Platform configuration loading failed!");
    EA(f);
    const D = Gc(XI);
    D.use(ac), D.directive("kvalidate", zn);
    let B = j.globalSearchPlugins || [], U = j.customNotificationPlugins || [];
    Array.isArray(j.optionalModules) && j.optionalModules.forEach((e) => {
      e && e.searchPlugins && B.push(...e.searchPlugins), e && e.notificationPlugins && U.push(...e.notificationPlugins);
    }), mA(B, U);
    const G = VI(j);
    D.use(G);
    const R = Zc();
    return R.use(({ store: e }) => {
      e.router = Qc(G);
    }), D.use(R), D.use(af, {
      locale: {
        accept: "Sì",
        reject: "No",
        monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dec"],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
        today: "Oggi",
        clear: "Cancella"
      }
    }), D.use(sf), D.use(of), await Pr().initUser(), Array.isArray(j.optionalModules) && j.optionalModules.forEach((e) => {
      e && e.initModule && e.initModule();
    }), D;
  } catch (f) {
    console.error("DP365+ client app initialization failed!", f);
  }
  return null;
}, KA = { install: ac };
export {
  Wn as AlertLevel,
  FA as ApiResponseMessage,
  BA as BaseFinder,
  la as BaseService,
  kA as ExternalPage,
  ha as InputChipsType,
  uf as K2ColContainer,
  lf as K3ColContainer,
  Bo as KAlert,
  mf as KBackButton,
  Pu as KCard,
  iE as KCarousel,
  uE as KCheckbox,
  iL as KCmsLast,
  uL as KCmsLatest2,
  UE as KDataTableActions,
  zE as KDatePicker,
  tv as KGlobalCalendarCompact,
  nv as KGlobalSearchBar,
  Dr as KIcon,
  sv as KInputChips,
  mv as KInputDate,
  Av as KInputFile,
  Zv as KInputNumber,
  Zl as KInputPassword,
  Jl as KInputSearch,
  ql as KInputText,
  ec as KInputTextArea,
  WT as KLatestNotifications,
  sp as KLinkCarousel,
  Ep as KModalCenter,
  Hl as KModalFullPage,
  pp as KModalSlide,
  aT as KNavScroll,
  oT as KNavScrollItem,
  kp as KPaginator,
  cT as KRadioButton,
  vs as KSectionHeader,
  _T as KSelect,
  _s as KSpinner,
  PT as KStepperHeader,
  UT as KTab,
  xT as KTabs,
  zT as KToggle,
  Xl as KValidationRules,
  qT as KWebTvLatest,
  rc as KWebTvVideoPlayer,
  _a as ModalDimension,
  xh as SortingOrder,
  rn as TwoColumnLayoutRatio,
  va as UserRouteModuleType,
  Vl as cmsService,
  WA as createKappaApp,
  KA as default,
  zA as platformService,
  kE as useCalendarEventsStore,
  qr as useFilters,
  Ka as useGlobalSearchStore,
  YA as useKValidation,
  Gy as useLayouts,
  ys as useNotificationStore,
  xr as usePlatformApi,
  Pr as useUserStore,
  Qr as webTvService
};
